// THIS IS A GENERATED FILE, DO NOT EDIT IT! (see codegen.yml)
/* eslint-disable */
import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '../state/graphql/apolloWithAbort';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Duration: { input: number; output: number; }
  Int64: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONString: { input: any; output: any; }
};

export type AccessToken = {
  __typename: 'AccessToken';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  emails: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastAccessedAt?: Maybe<Scalars['DateTime']['output']>;
  projects: Array<Project>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  token: Scalars['String']['output'];
  type: AccessTokenType;
  view: View;
};

export enum AccessTokenType {
  IndividualSharing = 'INDIVIDUAL_SHARING',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export type AckJobSetItemInput = {
  agentId: Scalars['ID']['input'];
  jobSetId: Scalars['ID']['input'];
  jobSetItemId: Scalars['ID']['input'];
  runName: Scalars['String']['input'];
};

export type AckJobSetItemPayload = {
  __typename: 'AckJobSetItemPayload';
  success: Scalars['Boolean']['output'];
};

export type AckRunQueueItemInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  runQueueItemId: Scalars['ID']['input'];
};

export type AckRunQueueItemPayload = {
  __typename: 'AckRunQueueItemPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActiveExperiment = Node & {
  __typename: 'ActiveExperiment';
  activeVariants: Array<ActiveVariant>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  experimentType: ExperimentType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ActiveVariant = {
  __typename: 'ActiveVariant';
  allocation: Scalars['Int']['output'];
  bucket: Scalars['Int']['output'];
};

export type ActivityDuration = {
  endAt: Scalars['DateTime']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type AddAliasesInput = {
  aliases: Array<ArtifactCollectionAliasInput>;
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AddAliasesPayload = {
  __typename: 'AddAliasesPayload';
  aliases: Array<ArtifactCollectionAlias>;
  artifact: Artifact;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddFilesInput = {
  bucketName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  modelName: Scalars['String']['input'];
  names: Array<InputMaybe<Scalars['String']['input']>>;
};

export type AddFilesPayload = {
  __typename: 'AddFilesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  files?: Maybe<FileConnection>;
};


export type AddFilesPayloadFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AddProjectProtectedAliasesInput = {
  aliases: Array<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type AddProjectProtectedAliasesPayload = {
  __typename: 'AddProjectProtectedAliasesPayload';
  aliases: Array<Scalars['String']['output']>;
  clientMutationID?: Maybe<Scalars['String']['output']>;
};

export type AddProtectedAliasesInput = {
  adminType: WorkflowsAdminType;
  aliases: Array<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
};

export type AddProtectedAliasesPayload = {
  __typename: 'AddProtectedAliasesPayload';
  aliases: Array<Scalars['String']['output']>;
  clientMutationID?: Maybe<Scalars['String']['output']>;
};

export type AddPublicQueueLaunchAgentTeamConfigInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AddPublicQueueLaunchAgentTeamConfigPayload = {
  __typename: 'AddPublicQueueLaunchAgentTeamConfigPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddRolePermissionsInput = {
  permissions: Array<Scalars['String']['input']>;
  roleID: Scalars['ID']['input'];
};

export type AddRolePermissionsPayload = {
  __typename: 'AddRolePermissionsPayload';
  success: Scalars['Boolean']['output'];
};

export type AddUserToOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  teams?: InputMaybe<Array<Scalars['String']['input']>>;
  userName: Scalars['String']['input'];
  userOrgRole: Scalars['String']['input'];
};

export type AddUserToOrganizationPayload = {
  __typename: 'AddUserToOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailSent: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddWorkflowsAdminInput = {
  adminType: WorkflowsAdminType;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AddWorkflowsAdminPayload = {
  __typename: 'AddWorkflowsAdminPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdvancedRegistryFeatures = {
  __typename: 'AdvancedRegistryFeatures';
  advancedSearch: Scalars['Boolean']['output'];
  advancedUI: Scalars['Boolean']['output'];
};

export type Agent = Node & {
  __typename: 'Agent';
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  heartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metrics: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  persistent?: Maybe<Scalars['Boolean']['output']>;
  runs: RunConnection;
  state?: Maybe<Scalars['String']['output']>;
  sweep: Sweep;
  totalRuns: Scalars['Int']['output'];
  user?: Maybe<User>;
};


export type AgentRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type AgentConnection = {
  __typename: 'AgentConnection';
  edges: Array<AgentEdge>;
  pageInfo: PageInfo;
};

export type AgentEdge = {
  __typename: 'AgentEdge';
  cursor: Scalars['String']['output'];
  node: Agent;
};

export type AgentHeartbeatInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metrics?: InputMaybe<Scalars['JSONString']['input']>;
  runState?: InputMaybe<Scalars['JSONString']['input']>;
};

export type AgentHeartbeatPayload = {
  __typename: 'AgentHeartbeatPayload';
  agent?: Maybe<Agent>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  commands?: Maybe<Scalars['JSONString']['output']>;
};

export enum Aggregation {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type AggregationKey = {
  aggregation: Aggregation;
  key: Scalars['String']['input'];
};

export type Alert = {
  __typename: 'Alert';
  condition: AlertCondition;
  events: AlertEventConnection;
  id: Scalars['ID']['output'];
  subscriptions: Array<AlertSubscription>;
};


export type AlertEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTime']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AlertCondition = FinishedRunCondition | ScriptableRunCondition | StoppedRunCondition;

export type AlertEvent = {
  __typename: 'AlertEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type AlertEventConnection = {
  __typename: 'AlertEventConnection';
  edges: Array<AlertEventEdge>;
  pageInfo: PageInfo;
};

export type AlertEventEdge = {
  __typename: 'AlertEventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AlertEvent>;
};

export enum AlertSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

export type AlertSubscription = {
  id: Scalars['ID']['output'];
};

export type AlertThreshold = {
  __typename: 'AlertThreshold';
  emailSent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  product: AlertThresholdProduct;
  type: AlertThresholdType;
  value: Scalars['Int']['output'];
};

export type AlertThresholdFilter = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  product?: InputMaybe<AlertThresholdProduct>;
  type?: InputMaybe<AlertThresholdType>;
};

export enum AlertThresholdProduct {
  Inference = 'INFERENCE',
  Storage = 'STORAGE',
  TrackingHour = 'TRACKING_HOUR',
  Training = 'TRAINING',
  Weave = 'WEAVE'
}

export enum AlertThresholdType {
  Spend = 'SPEND',
  Usage = 'USAGE'
}

export type ApiKey = {
  __typename: 'ApiKey';
  apiKeyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ips: Array<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  organizationID?: Maybe<Scalars['ID']['output']>;
  rateLimit?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ApiKeyConnection = {
  __typename: 'ApiKeyConnection';
  edges: Array<ApiKeyEdge>;
  pageInfo: PageInfo;
};

export type ApiKeyEdge = {
  __typename: 'ApiKeyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ApiKey>;
};

export type Artifact = {
  __typename: 'Artifact';
  aliases: Array<ArtifactAlias>;
  /** @deprecated Field no longer supported */
  artifactActions?: Maybe<ArtifactActionConnection>;
  artifactCollections: ArtifactCollectionConnection;
  artifactLineageDag?: Maybe<ArtifactLineageDag>;
  artifactMemberships: ArtifactCollectionMembershipConnection;
  artifactSequence: ArtifactSequence;
  artifactSequenceMembership: ArtifactCollectionMembership;
  artifactType: ArtifactType;
  commitHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Initiator>;
  currentManifest?: Maybe<ArtifactManifest>;
  dependencyOf: ArtifactConnection;
  dependsOn: ArtifactConnection;
  description?: Maybe<Scalars['String']['output']>;
  digest: Scalars['String']['output'];
  fileCount: Scalars['Int64']['output'];
  /** @deprecated Use artifactMembership.files instead. */
  files?: Maybe<FileConnection>;
  /** @deprecated Use artifactMembership.filesByManifestEntries instead. */
  filesByManifestEntries?: Maybe<FileConnection>;
  historyStep?: Maybe<Scalars['Int64']['output']>;
  id: Scalars['ID']['output'];
  isGenerated: Scalars['Boolean']['output'];
  isLinkedToGlobalRegistry: Scalars['Boolean']['output'];
  isProtected: Scalars['Boolean']['output'];
  /** @deprecated Field no longer supported */
  labels?: Maybe<Scalars['JSONString']['output']>;
  metadata?: Maybe<Scalars['JSONString']['output']>;
  runHistory: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
  state: ArtifactState;
  storageBytes: Scalars['Int64']['output'];
  storageRegion?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  ttlDurationSeconds: Scalars['Int64']['output'];
  ttlIsInherited: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedBy: RunConnection;
  usedCount: Scalars['Int']['output'];
  versionIndex?: Maybe<Scalars['Int']['output']>;
  /** Source info for artifacts backed by Weave objects. Null for regular artifacts. */
  weaveSource?: Maybe<ArtifactWeaveSource>;
};


export type ArtifactAliasesArgs = {
  artifactCollectionName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactArtifactLineageDagArgs = {
  baseGraphNodeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  directLineage?: InputMaybe<Scalars['Boolean']['input']>;
  filterGeneratedArtifacts: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  traversalDirection?: InputMaybe<TraversalDirection>;
};


export type ArtifactCommitHashArgs = {
  artifactCollectionName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactDependencyOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactDependsOnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ArtifactFilesByManifestEntriesArgs = {
  entries?: InputMaybe<Array<ArtifactManifestEntryInput>>;
  manifestVersion: Scalars['String']['input'];
  storageLayout: Scalars['String']['input'];
  storageRegion?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactRunHistoryArgs = {
  maxKeyLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactUsedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactVersionIndexArgs = {
  artifactCollectionName?: InputMaybe<Scalars['String']['input']>;
};

export type ArtifactAction = {
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator: Initiator;
};

export type ArtifactActionConnection = {
  __typename: 'ArtifactActionConnection';
  edges: Array<ArtifactActionEdge>;
  pageInfo: PageInfo;
};

export type ArtifactActionEdge = {
  __typename: 'ArtifactActionEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactAction;
};

export type ArtifactAlias = {
  __typename: 'ArtifactAlias';
  alias: Scalars['String']['output'];
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  artifactCollectionName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ArtifactAliasAction = {
  __typename: 'ArtifactAliasAction';
  actionType: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  artifactCollection: ArtifactCollection;
  createdAt: Scalars['DateTime']['output'];
  sourceArtifact?: Maybe<Artifact>;
  targetArtifact?: Maybe<Artifact>;
  user?: Maybe<User>;
};

export type ArtifactAliasActionConnection = {
  __typename: 'ArtifactAliasActionConnection';
  edges: Array<ArtifactAliasActionEdge>;
  pageInfo: PageInfo;
};

export type ArtifactAliasActionEdge = {
  __typename: 'ArtifactAliasActionEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactAliasAction;
};

export type ArtifactAliasConnection = {
  __typename: 'ArtifactAliasConnection';
  edges: Array<ArtifactAliasEdge>;
  pageInfo: PageInfo;
};

export type ArtifactAliasEdge = {
  __typename: 'ArtifactAliasEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactAlias>;
};

export type ArtifactAliasEventDetails = {
  __typename: 'ArtifactAliasEventDetails';
  alias?: Maybe<Scalars['String']['output']>;
  artifactCollectionName?: Maybe<Scalars['String']['output']>;
  artifactMetadata?: Maybe<Scalars['JSONString']['output']>;
  artifactVersionIndex?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

export type ArtifactAliasInput = {
  alias: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
};

export type ArtifactCollection = {
  aliasActionHistory: ArtifactAliasActionConnection;
  aliases: ArtifactAliasConnection;
  /** @deprecated Field no longer supported */
  artifactActions?: Maybe<ArtifactActionConnection>;
  artifactCollectionActions: ArtifactCollectionActionConnection;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  artifactMemberships: ArtifactCollectionMembershipConnection;
  artifacts?: Maybe<VersionedArtifactConnection>;
  createdAt: Scalars['DateTime']['output'];
  defaultArtifactType: ArtifactType;
  description?: Maybe<Scalars['String']['output']>;
  hasArtifactVersionLinkedToGlobalRegistry: Scalars['Boolean']['output'];
  hasProtectedArtifact: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isModelRegistryMigratedArtifactCollection: Scalars['Boolean']['output'];
  modelRegistryMigratedArtifactCollection?: Maybe<ArtifactCollection>;
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  state: ArtifactCollectionState;
  tags: TagConnection;
  triggerExecutions: TriggerExecutionConnection;
  triggers: TriggerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionIndexes: Array<Scalars['Int']['output']>;
};


export type ArtifactCollectionAliasActionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionAliasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactCollectionArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactCollectionArtifactCollectionActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionArtifactMembershipArgs = {
  aliasName: Scalars['String']['input'];
};


export type ArtifactCollectionArtifactMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type ArtifactCollectionTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactCollectionVersionIndexesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactCollectionAction = {
  __typename: 'ArtifactCollectionAction';
  actionType: Scalars['String']['output'];
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type ArtifactCollectionActionConnection = {
  __typename: 'ArtifactCollectionActionConnection';
  edges: Array<ArtifactCollectionActionEdge>;
  pageInfo: PageInfo;
};

export type ArtifactCollectionActionEdge = {
  __typename: 'ArtifactCollectionActionEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactCollectionAction;
};

export type ArtifactCollectionAlias = {
  __typename: 'ArtifactCollectionAlias';
  alias: Scalars['String']['output'];
  artifactCollectionName: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type ArtifactCollectionAliasInput = {
  alias: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type ArtifactCollectionConnection = {
  __typename: 'ArtifactCollectionConnection';
  edges: Array<ArtifactCollectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactCollectionEdge = {
  __typename: 'ArtifactCollectionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactCollection>;
};

export type ArtifactCollectionMembership = {
  __typename: 'ArtifactCollectionMembership';
  aliases: Array<ArtifactAlias>;
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  commitHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<FileConnection>;
  filesByManifestEntries?: Maybe<FileConnection>;
  id: Scalars['ID']['output'];
  versionIndex?: Maybe<Scalars['Int']['output']>;
};


export type ArtifactCollectionMembershipFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ArtifactCollectionMembershipFilesByManifestEntriesArgs = {
  entries?: InputMaybe<Array<ArtifactManifestEntryInput>>;
  manifestVersion: Scalars['String']['input'];
  storageLayout: Scalars['String']['input'];
  storageRegion?: InputMaybe<Scalars['String']['input']>;
};

export type ArtifactCollectionMembershipConnection = {
  __typename: 'ArtifactCollectionMembershipConnection';
  edges: Array<ArtifactCollectionMembershipEdge>;
  pageInfo: PageInfo;
};

export type ArtifactCollectionMembershipEdge = {
  __typename: 'ArtifactCollectionMembershipEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactCollectionMembership>;
};

export type ArtifactCollectionSearchConnection = {
  __typename: 'ArtifactCollectionSearchConnection';
  edges: Array<ArtifactCollectionSearchEdge>;
  pageInfo: PageInfo;
};

export type ArtifactCollectionSearchEdge = {
  __typename: 'ArtifactCollectionSearchEdge';
  artifactMatch: Scalars['Boolean']['output'];
  artifactMemberships: ArtifactCollectionMembershipConnection;
  cursor: Scalars['String']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  node: ArtifactCollection;
};

export enum ArtifactCollectionState {
  Deleted = 'DELETED',
  Ready = 'READY'
}

export enum ArtifactCollectionType {
  Portfolio = 'PORTFOLIO',
  Sequence = 'SEQUENCE'
}

export type ArtifactConnection = ArtifactConnectionType & {
  __typename: 'ArtifactConnection';
  edges: Array<ArtifactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactConnectionType = {
  edges: Array<ArtifactEdgeType>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ArtifactDigestAlgorithm {
  ManifestMd5 = 'MANIFEST_MD5'
}

export type ArtifactEdge = ArtifactEdgeType & {
  __typename: 'ArtifactEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Artifact>;
};

export type ArtifactEdgeType = {
  cursor: Scalars['String']['output'];
  node?: Maybe<Artifact>;
};

export type ArtifactEventDetails = {
  __typename: 'ArtifactEventDetails';
  artifactCollectionName?: Maybe<Scalars['String']['output']>;
  artifactMetadata?: Maybe<Scalars['JSONString']['output']>;
  artifactVersionIndex?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

export type ArtifactLineageDag = {
  __typename: 'ArtifactLineageDag';
  artifacts: Array<Maybe<ArtifactLineageDagArtifact>>;
  clusters: Array<Maybe<ArtifactLineageDagCluster>>;
  edges: Array<Maybe<ArtifactLineageDagEdge>>;
  hitLimit: Scalars['Boolean']['output'];
  runs: Array<Maybe<ArtifactLineageDagRun>>;
};

export type ArtifactLineageDagArtifact = {
  __typename: 'ArtifactLineageDagArtifact';
  artifactCommitHash: Scalars['String']['output'];
  artifactNodeID: Scalars['String']['output'];
  artifactSequenceName: Scalars['String']['output'];
  artifactTypeName: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  versionIndex: Scalars['Int']['output'];
};

export type ArtifactLineageDagCluster = {
  __typename: 'ArtifactLineageDagCluster';
  artifactNodes: Array<Maybe<ArtifactLineageDagArtifact>>;
  clusterEdges: Array<Maybe<ArtifactLineageDagEdge>>;
  id: Scalars['String']['output'];
  nodeType: DagNodeType;
  runNodes: Array<Maybe<ArtifactLineageDagRun>>;
};

export type ArtifactLineageDagEdge = {
  __typename: 'ArtifactLineageDagEdge';
  artifactNodeID: Scalars['String']['output'];
  clusterNodeID?: Maybe<Scalars['String']['output']>;
  direction: DagDirection;
  edgeID: Scalars['String']['output'];
  runNodeID: Scalars['String']['output'];
};

export type ArtifactLineageDagRun = {
  __typename: 'ArtifactLineageDagRun';
  displayName?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  jobType?: Maybe<Scalars['String']['output']>;
  projectName: Scalars['String']['output'];
  runName: Scalars['String']['output'];
  runNodeID: Scalars['String']['output'];
};

export type ArtifactManifest = {
  __typename: 'ArtifactManifest';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  digest: Scalars['String']['output'];
  file: File;
  id: Scalars['ID']['output'];
  type: ArtifactManifestType;
};

export type ArtifactManifestConnection = {
  __typename: 'ArtifactManifestConnection';
  edges: Array<ArtifactManifestEdge>;
  pageInfo: PageInfo;
};

export type ArtifactManifestEdge = {
  __typename: 'ArtifactManifestEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactManifest>;
};

export type ArtifactManifestEntryInput = {
  birthArtifactID?: InputMaybe<Scalars['ID']['input']>;
  digest: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ref?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int64']['input']>;
};

export enum ArtifactManifestType {
  Full = 'FULL',
  Incremental = 'INCREMENTAL',
  Patch = 'PATCH'
}

export type ArtifactPortfolio = ArtifactCollection & {
  __typename: 'ArtifactPortfolio';
  aliasActionHistory: ArtifactAliasActionConnection;
  aliases: ArtifactAliasConnection;
  /** @deprecated Field no longer supported */
  artifactActions: ArtifactActionConnection;
  artifactCollectionActions: ArtifactCollectionActionConnection;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  artifactMemberships: ArtifactCollectionMembershipConnection;
  artifacts: VersionedArtifactConnection;
  createdAt: Scalars['DateTime']['output'];
  defaultArtifactType: ArtifactType;
  description?: Maybe<Scalars['String']['output']>;
  hasArtifactVersionLinkedToGlobalRegistry: Scalars['Boolean']['output'];
  hasProtectedArtifact: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isModelRegistryMigratedArtifactCollection: Scalars['Boolean']['output'];
  modelRegistryMigratedArtifactCollection?: Maybe<ArtifactCollection>;
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  state: ArtifactCollectionState;
  tags: TagConnection;
  triggerExecutions: TriggerExecutionConnection;
  triggers: TriggerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionIndexes: Array<Scalars['Int']['output']>;
};


export type ArtifactPortfolioAliasActionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioAliasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactPortfolioArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactPortfolioArtifactCollectionActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioArtifactMembershipArgs = {
  aliasName: Scalars['String']['input'];
};


export type ArtifactPortfolioArtifactMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type ArtifactPortfolioTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactPortfolioVersionIndexesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactSequence = ArtifactCollection & {
  __typename: 'ArtifactSequence';
  aliasActionHistory: ArtifactAliasActionConnection;
  aliases: ArtifactAliasConnection;
  /** @deprecated Field no longer supported */
  artifactActions: ArtifactActionConnection;
  artifactCollectionActions: ArtifactCollectionActionConnection;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  artifactMemberships: ArtifactCollectionMembershipConnection;
  artifacts: VersionedArtifactConnection;
  createdAt: Scalars['DateTime']['output'];
  defaultArtifactType: ArtifactType;
  description?: Maybe<Scalars['String']['output']>;
  hasArtifactVersionLinkedToGlobalRegistry: Scalars['Boolean']['output'];
  hasProtectedArtifact: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isModelRegistryMigratedArtifactCollection: Scalars['Boolean']['output'];
  latestArtifact?: Maybe<Artifact>;
  modelRegistryMigratedArtifactCollection?: Maybe<ArtifactCollection>;
  name: Scalars['String']['output'];
  project?: Maybe<Project>;
  state: ArtifactCollectionState;
  tags: TagConnection;
  triggerExecutions: TriggerExecutionConnection;
  triggers: TriggerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionIndexes: Array<Scalars['Int']['output']>;
};


export type ArtifactSequenceAliasActionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceAliasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactSequenceArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactSequenceArtifactCollectionActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceArtifactMembershipArgs = {
  aliasName: Scalars['String']['input'];
};


export type ArtifactSequenceArtifactMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type ArtifactSequenceTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactSequenceVersionIndexesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactSequenceConnection = {
  __typename: 'ArtifactSequenceConnection';
  edges: Array<ArtifactSequenceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactSequenceEdge = {
  __typename: 'ArtifactSequenceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactSequence>;
};

export type ArtifactSequenceStorageNode = StorageTreeNode & {
  __typename: 'ArtifactSequenceStorageNode';
  artifactSequence: ArtifactSequence;
  artifactSequenceID: Scalars['ID']['output'];
  artifactType: ArtifactType;
  artifacts: ArtifactStorageNodeConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};


export type ArtifactSequenceStorageNodeArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactSequenceStorageNodeConnection = {
  __typename: 'ArtifactSequenceStorageNodeConnection';
  edges: Array<ArtifactSequenceStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type ArtifactSequenceStorageNodeEdge = {
  __typename: 'ArtifactSequenceStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactSequenceStorageNode;
};

export enum ArtifactState {
  Committed = 'COMMITTED',
  Deleted = 'DELETED',
  Pending = 'PENDING'
}

export enum ArtifactStorageLayout {
  V1 = 'V1',
  V2 = 'V2'
}

export type ArtifactStorageNode = StorageTreeNode & {
  __typename: 'ArtifactStorageNode';
  artifact: Artifact;
  artifactID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export type ArtifactStorageNodeConnection = {
  __typename: 'ArtifactStorageNodeConnection';
  edges: Array<ArtifactStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type ArtifactStorageNodeEdge = {
  __typename: 'ArtifactStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactStorageNode;
};

export type ArtifactTagEventDetails = {
  __typename: 'ArtifactTagEventDetails';
  artifactCollectionName?: Maybe<Scalars['String']['output']>;
  artifactMetadata?: Maybe<Scalars['JSONString']['output']>;
  artifactVersionIndex?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type ArtifactType = {
  __typename: 'ArtifactType';
  artifact?: Maybe<Artifact>;
  /** @deprecated Field no longer supported */
  artifactActions?: Maybe<ArtifactActionConnection>;
  artifactCollection?: Maybe<ArtifactCollection>;
  artifactCollections?: Maybe<ArtifactCollectionConnection>;
  artifactSequence?: Maybe<ArtifactSequence>;
  artifactSequences?: Maybe<ArtifactSequenceConnection>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
};


export type ArtifactTypeArtifactArgs = {
  name: Scalars['String']['input'];
};


export type ArtifactTypeArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactTypeArtifactCollectionArgs = {
  name: Scalars['String']['input'];
};


export type ArtifactTypeArtifactCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactTypeArtifactSequenceArgs = {
  name: Scalars['String']['input'];
};


export type ArtifactTypeArtifactSequencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type ArtifactTypeConnection = {
  __typename: 'ArtifactTypeConnection';
  edges: Array<ArtifactTypeEdge>;
  pageInfo: PageInfo;
};

export type ArtifactTypeEdge = {
  __typename: 'ArtifactTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactType>;
};

export type ArtifactTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ArtifactTypeNameConnection = {
  __typename: 'ArtifactTypeNameConnection';
  edges: Array<ArtifactTypeNameEdge>;
  pageInfo: PageInfo;
};

export type ArtifactTypeNameEdge = {
  __typename: 'ArtifactTypeNameEdge';
  cursor: Scalars['String']['output'];
  node: Scalars['String']['output'];
};

export type ArtifactTypeStorageNode = StorageTreeNode & {
  __typename: 'ArtifactTypeStorageNode';
  artifactType: ArtifactType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export type ArtifactWeaveSource = {
  __typename: 'ArtifactWeaveSource';
  sourceType: WeaveSourceType;
};

export type AttachCustomerPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type AttachCustomerPaymentMethodPayload = {
  __typename: 'AttachCustomerPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BenchmarkRun = {
  __typename: 'BenchmarkRun';
  benchmark: Project;
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  gitHubSubmissionPR?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCodeHidden: Scalars['Boolean']['output'];
  originalProject?: Maybe<Project>;
  originalRun?: Maybe<Run>;
  results?: Maybe<Scalars['String']['output']>;
  run: Run;
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type BenchmarkRunConnection = {
  __typename: 'BenchmarkRunConnection';
  edges: Array<BenchmarkRunEdge>;
  pageInfo: PageInfo;
};

export type BenchmarkRunEdge = {
  __typename: 'BenchmarkRunEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkRun>;
};

export type BucketDiff = {
  __typename: 'BucketDiff';
  op: DiffOperation;
  run?: Maybe<Run>;
};

export type BucketDiffs = {
  __typename: 'BucketDiffs';
  delta: Array<BucketDiff>;
  incomplete?: Maybe<Array<Scalars['ID']['output']>>;
  order: Array<Scalars['ID']['output']>;
};

export type BucketStoreConnectionError = Error & {
  __typename: 'BucketStoreConnectionError';
  message: Scalars['String']['output'];
  severity: ErrorSeverity;
};

export type BucketType = {
  commit?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['JSONString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  exampleTable?: Maybe<Scalars['JSONString']['output']>;
  exampleTableColumns?: Maybe<Scalars['JSONString']['output']>;
  exampleTableTypes?: Maybe<Scalars['JSONString']['output']>;
  fileCount?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<FileConnection>;
  framework?: Maybe<Scalars['String']['output']>;
  github?: Maybe<Scalars['String']['output']>;
  history: Array<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logLines?: Maybe<LogLineConnection>;
  name?: Maybe<Scalars['String']['output']>;
  shouldStop?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  summaryMetrics?: Maybe<Scalars['JSONString']['output']>;
  sweep?: Maybe<Sweep>;
};


export type BucketTypeConfigArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type BucketTypeFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type BucketTypeHistoryArgs = {
  maxStep?: InputMaybe<Scalars['Int64']['input']>;
  minStep?: InputMaybe<Scalars['Int64']['input']>;
  samples?: InputMaybe<Scalars['Int']['input']>;
};


export type BucketTypeLogLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  useImprovedPagination?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BucketTypeSummaryMetricsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelCustomerSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CancelCustomerSubscriptionPayload = {
  __typename: 'CancelCustomerSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CardBrand {
  Amex = 'AMEX',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Unionpay = 'UNIONPAY',
  Unknown = 'UNKNOWN',
  Visa = 'VISA'
}

export enum ChartAggOption {
  Last = 'last',
  Max = 'max',
  Mean = 'mean',
  Median = 'median',
  Min = 'min',
  Samples = 'samples',
  Sum = 'sum'
}

export type CheckoutPreview = {
  __typename: 'CheckoutPreview';
  lineItems: Array<Maybe<CheckoutPreviewLineItemsMetadata>>;
  renewalDate?: Maybe<Scalars['DateTime']['output']>;
  total: Scalars['Int']['output'];
};

export type CheckoutPreviewLineItemsMetadata = {
  __typename: 'CheckoutPreviewLineItemsMetadata';
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  product: Scalars['String']['output'];
  subLineItems: Array<Maybe<CheckoutPreviewSubLineItemsMetadata>>;
};

export type CheckoutPreviewSubLineItemsMetadata = {
  __typename: 'CheckoutPreviewSubLineItemsMetadata';
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  proration: Scalars['Boolean']['output'];
};

export type ClaimAnonymousEntityInput = {
  anonymousApiKey: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ClaimAnonymousEntityPayload = {
  __typename: 'ClaimAnonymousEntityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type ClientIdMapping = {
  __typename: 'ClientIDMapping';
  clientID: Scalars['ID']['output'];
  entry: ClientIdMappingEntry;
  serverID: Scalars['ID']['output'];
};

export type ClientIdMappingEntry = Artifact | ArtifactSequence;

export type CloneProjectsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationEntityName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerUsername: Scalars['String']['input'];
  projectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEntityName: Scalars['String']['input'];
};

export type CloneProjectsPayload = {
  __typename: 'CloneProjectsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
};

export enum CloudProvider {
  Aws = 'AWS',
  Azure = 'AZURE',
  Coreweave = 'COREWEAVE',
  Gcp = 'GCP',
  Minio = 'MINIO'
}

export type CloudRegion = {
  __typename: 'CloudRegion';
  id: Scalars['ID']['output'];
  provider: CloudProvider;
  region: Scalars['String']['output'];
};

export type Code = {
  __typename: 'Code';
  body?: Maybe<Scalars['String']['output']>;
  directUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CommitArtifactInput = {
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CommitArtifactPayload = {
  __typename: 'CommitArtifactPayload';
  artifact: Artifact;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum CompleteMultipartAction {
  Complete = 'Complete'
}

export type CompleteMultipartUploadArtifactInput = {
  artifactID: Scalars['ID']['input'];
  completeMultipartAction: CompleteMultipartAction;
  completedParts: Array<UploadPartsInput>;
  storagePath: Scalars['String']['input'];
  uploadID: Scalars['String']['input'];
};

export type CompleteMultipartUploadArtifactPayload = {
  __typename: 'CompleteMultipartUploadArtifactPayload';
  digest?: Maybe<Scalars['String']['output']>;
};

export type ContactUsForComputeHoursInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUsForComputeHoursPayload = {
  __typename: 'ContactUsForComputeHoursPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ContactUsForUserLedTrialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUsForUserLedTrialPayload = {
  __typename: 'ContactUsForUserLedTrialPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CoreweaveInfo = {
  __typename: 'CoreweaveInfo';
  clusterName: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type Coupon = {
  __typename: 'Coupon';
  amountOff: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  durationInMonths: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentOff: Scalars['Float']['output'];
};

export type CreateAwsExternalIdInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAcademicOrReverseTrialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isAcademic: Scalars['Boolean']['input'];
  newOrganizationName: Scalars['String']['input'];
  newTeamName: Scalars['String']['input'];
};

export type CreateAcademicOrReverseTrialPayload = {
  __typename: 'CreateAcademicOrReverseTrialPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orgID: Scalars['ID']['output'];
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
  projects: Array<ProjectSpecifier>;
  username?: InputMaybe<Scalars['String']['input']>;
  viewId: Scalars['ID']['input'];
};

export type CreateAccessTokenPayload = {
  __typename: 'CreateAccessTokenPayload';
  accessToken: AccessToken;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  recipientAlreadyOnTeam?: Maybe<Scalars['Boolean']['output']>;
  toNewUser?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAgentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  sweep: Scalars['String']['input'];
};

export type CreateAgentPayload = {
  __typename: 'CreateAgentPayload';
  agent?: Maybe<Agent>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateAlertPayload = {
  __typename: 'CreateAlertPayload';
  alert: Alert;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateAlertThresholdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
  product: AlertThresholdProduct;
  type: AlertThresholdType;
  value: Scalars['Int']['input'];
};

export type CreateAlertThresholdPayload = {
  __typename: 'CreateAlertThresholdPayload';
  alertThreshold?: Maybe<AlertThreshold>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateAndLinkWeaveAssetInput = {
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  artifactPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  /** The weave:// URI (e.g., weave:///entity/project/object/name:version) */
  ref: Scalars['String']['input'];
};

export type CreateAnonymousEntityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArtifactCollectionPayload = {
  __typename: 'CreateArtifactCollectionPayload';
  artifactCollection: ArtifactCollection;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateArtifactCollectionTagAssignmentsInput = {
  artifactCollectionName: Scalars['String']['input'];
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  tags: Array<TagInput>;
};

export type CreateArtifactFileSpecInput = {
  artifactID: Scalars['ID']['input'];
  artifactManifestID?: InputMaybe<Scalars['ID']['input']>;
  md5: Scalars['String']['input'];
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  uploadPartsInput?: InputMaybe<Array<UploadPartsInput>>;
};

export type CreateArtifactFilesInput = {
  artifactFiles: Array<CreateArtifactFileSpecInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use storageRegion in CreateArtifact instead */
  cloudRegionID?: InputMaybe<Scalars['ID']['input']>;
  storageLayout: ArtifactStorageLayout;
};

export type CreateArtifactFilesPayload = {
  __typename: 'CreateArtifactFilesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  files: FileConnection;
};


export type CreateArtifactFilesPayloadFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateArtifactInput = {
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  artifactCollectionName?: InputMaybe<Scalars['String']['input']>;
  artifactCollectionNames?: InputMaybe<Array<Scalars['String']['input']>>;
  artifactTypeName: Scalars['String']['input'];
  clientID?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  digest: Scalars['String']['input'];
  digestAlgorithm: ArtifactDigestAlgorithm;
  distributedID?: InputMaybe<Scalars['String']['input']>;
  enableDigestDeduplication?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  historyStep?: InputMaybe<Scalars['Int64']['input']>;
  /** @deprecated Field no longer supported */
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  projectName: Scalars['String']['input'];
  runName?: InputMaybe<Scalars['String']['input']>;
  sequenceClientID?: InputMaybe<Scalars['ID']['input']>;
  storageRegion?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<TagInput>>;
  ttlDurationSeconds?: InputMaybe<Scalars['Int64']['input']>;
};

export type CreateArtifactManifestInput = {
  artifactID: Scalars['ID']['input'];
  baseArtifactID?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digest: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  type: ArtifactManifestType;
};

export type CreateArtifactManifestPayload = {
  __typename: 'CreateArtifactManifestPayload';
  artifactManifest: ArtifactManifest;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateArtifactPayload = {
  __typename: 'CreateArtifactPayload';
  artifact: Artifact;
  /** @deprecated Field no longer supported */
  artifactActions: Array<ArtifactAction>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateArtifactPortfolioInput = {
  artifactTypeID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type CreateArtifactSequenceInput = {
  artifactTypeID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type CreateArtifactTagAssignmentsInput = {
  artifactID: Scalars['ID']['input'];
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  tags: Array<TagInput>;
};

export type CreateArtifactTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type CreateArtifactTypePayload = {
  __typename: 'CreateArtifactTypePayload';
  artifactType: ArtifactType;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateArtifactTypesInput = {
  artifactTypes: Array<ArtifactTypeInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type CreateArtifactTypesPayload = {
  __typename: 'CreateArtifactTypesPayload';
  artifactTypes: Array<ArtifactType>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateBenchmarkDiscussionCommentInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discussionThreadID: Scalars['ID']['input'];
  parentCommentID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBenchmarkDiscussionThreadInput = {
  benchmarkEntityName: Scalars['String']['input'];
  benchmarkProjectName: Scalars['String']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateClientIdMappingInput = {
  clientID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serverID: Scalars['ID']['input'];
};

export type CreateClientIdMappingPayload = {
  __typename: 'CreateClientIDMappingPayload';
  clientIDMapping: ClientIdMapping;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateClientInput = {
  entityName: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

export type CreateClientPayload = {
  __typename: 'CreateClientPayload';
  clientId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCustomChartInput = {
  access: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  spec: Scalars['JSONString']['input'];
  type: Scalars['String']['input'];
};

export type CreateCustomChartPayload = {
  __typename: 'CreateCustomChartPayload';
  chart: CustomChart;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newOrganizationName: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  trial: Scalars['Boolean']['input'];
};

export type CreateCustomerSubscriptionPayload = {
  __typename: 'CreateCustomerSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateCustomerTrialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newOrganizationName: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  trialDays: Scalars['Int']['input'];
  userName: Scalars['String']['input'];
};

export type CreateCustomerTrialPayload = {
  __typename: 'CreateCustomerTrialPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateDefaultResourceConfigInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSONString']['input'];
  entityName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  templateVariables?: InputMaybe<Scalars['JSONString']['input']>;
};

export type CreateDefaultResourceConfigPayload = {
  __typename: 'CreateDefaultResourceConfigPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  defaultResourceConfigID: Scalars['ID']['output'];
  schemaValidationErrors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type CreateDiscussionCommentPayload = {
  __typename: 'CreateDiscussionCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionComment: DiscussionComment;
};

export type CreateDiscussionThreadPayload = {
  __typename: 'CreateDiscussionThreadPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionThread: DiscussionThread;
};

export type CreateEmailSubscriptionInput = {
  alertID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmailSubscriptionPayload = {
  __typename: 'CreateEmailSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription: EmailSubscription;
};

export type CreateEntityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultAccess?: InputMaybe<Scalars['String']['input']>;
  defaultFramework?: InputMaybe<Scalars['String']['input']>;
  invited?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEntityPayload = {
  __typename: 'CreateEntityPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

export type CreateExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enrollmentPeriod: Scalars['Int']['input'];
  experimentType: ExperimentType;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  name: Scalars['String']['input'];
  observationalUnit: ObservationalUnit;
  sampleSize: Scalars['Int']['input'];
  variants: Array<VariantInput>;
};

export type CreateExperimentPayload = {
  __typename: 'CreateExperimentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateFilterTriggerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  eventFilter: Scalars['JSONString']['input'];
  name: Scalars['String']['input'];
  scopeID: Scalars['ID']['input'];
  scopeType: TriggerScopeType;
  triggeredActionConfig: TriggeredActionConfig;
  triggeredActionType: TriggeredActionType;
  triggeringEventType: EventTriggeringConditionType;
};

export type CreateFilterTriggerPayload = {
  __typename: 'CreateFilterTriggerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Trigger>;
};

export type CreateFinishedRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGenericWebhookIntegrationInput = {
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  secretRef?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint: Scalars['String']['input'];
};

export type CreateGitHubOAuthIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  redirectURI: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CreateGlueTaskInput = {
  arguments: Scalars['JSONString']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Scalars['String']['input'];
  strategyMetadata: Scalars['String']['input'];
  strategyType: Scalars['String']['input'];
  taskType: Scalars['String']['input'];
};

export type CreateGlueTaskPayload = {
  __typename: 'CreateGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateHourOverageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateHourOverageSubscriptionPayload = {
  __typename: 'CreateHourOverageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateInferenceSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInferenceSubscriptionPayload = {
  __typename: 'CreateInferenceSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateIntegrationPayload = {
  __typename: 'CreateIntegrationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integration: Integration;
};

export type CreateInviteInput = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `role` instead. */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  modelSeat?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvitePayload = {
  __typename: 'CreateInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailSent: Scalars['Boolean']['output'];
  entity?: Maybe<Entity>;
  invite?: Maybe<Invite>;
  remainingSeats?: Maybe<Scalars['Int']['output']>;
  remainingViewOnlySeats?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateLaunchAgentInput = {
  agentConfig?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runQueues: Array<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLaunchAgentPayload = {
  __typename: 'CreateLaunchAgentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  launchAgentId: Scalars['ID']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateLocalLicenseOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newOrganizationName: Scalars['String']['input'];
};

export type CreateLocalLicenseOrganizationPayload = {
  __typename: 'CreateLocalLicenseOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

export type CreateNewsletterSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNewsletterSubscriptionPayload = {
  __typename: 'CreateNewsletterSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newsletterSubscription: NewsletterSubscription;
};

export type CreateOAuthProviderInput = {
  issuerUrl: Scalars['String']['input'];
  jwk?: InputMaybe<Scalars['JSONString']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateOAuthProviderPayload = {
  __typename: 'CreateOAuthProviderPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateOrgServiceAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultEntityId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateOrgServiceAccountPayload = {
  __typename: 'CreateOrgServiceAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CreatePreviewableLinkInput = {
  author: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  redirectURL: Scalars['String']['input'];
  resourceID: Scalars['ID']['input'];
  resourceType: PreviewableLinkResourceType;
  title: Scalars['String']['input'];
  useDefaultImage: Scalars['Boolean']['input'];
};

export type CreatePreviewableLinkPayload = {
  __typename: 'CreatePreviewableLinkPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  previewImageUploadURL?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateProjectMembersInput = {
  projectId: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateProjectMembersPayload = {
  __typename: 'CreateProjectMembersPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  inheritedFrom: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type CreateRolePayload = {
  __typename: 'CreateRolePayload';
  success: Scalars['Boolean']['output'];
};

export type CreateRunFilesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  files: Array<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
};

export type CreateRunFilesPayload = {
  __typename: 'CreateRunFilesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  runID: Scalars['ID']['output'];
  uploadHeaders: Array<Scalars['String']['output']>;
};

export type CreateRunQueueInput = {
  access: RunQueueAccessType;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultResourceConfigID?: InputMaybe<Scalars['ID']['input']>;
  entityName: Scalars['String']['input'];
  prioritizationMode?: InputMaybe<RunQueuePrioritizationMode>;
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
};

export type CreateRunQueuePayload = {
  __typename: 'CreateRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  queueID?: Maybe<Scalars['ID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateScriptableRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSemanticLegendInput = {
  bucketUpperBounds: Array<InputMaybe<Scalars['Float']['input']>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRunColor: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  viewID: Scalars['ID']['input'];
  yValue: Scalars['String']['input'];
};

export type CreateSemanticLegendPayload = {
  __typename: 'CreateSemanticLegendPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateServiceAccountApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  serviceAccountId: Scalars['ID']['input'];
};

export type CreateServiceAccountApiKeyPayload = {
  __typename: 'CreateServiceAccountApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  secretApiKey?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateServiceAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateServiceAccountPayload = {
  __typename: 'CreateServiceAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CreateSlackChannelSubscriptionInput = {
  alertID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationID: Scalars['ID']['input'];
};

export type CreateSlackChannelSubscriptionPayload = {
  __typename: 'CreateSlackChannelSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription: SlackChannelSubscription;
};

export type CreateSlackIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  redirectURI: Scalars['String']['input'];
};

export type CreateStoppedRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  minimumRunDuration: Scalars['Duration']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStorageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated storagePlanID is fetched within backend.  */
  storagePlanId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated trackingPlanID is fetched within backend.  */
  trackingPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated trial is not relevant to storage subscription anymore. */
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateStorageSubscriptionPayload = {
  __typename: 'CreateStorageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateTagsPayload = {
  __typename: 'CreateTagsPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
};

export type CreateTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultAccess?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  storageBucketInfo?: InputMaybe<StorageBucketInfoInput>;
  teamAdminUserName?: InputMaybe<Scalars['String']['input']>;
  teamName: Scalars['String']['input'];
};

export type CreateTeamPayload = {
  __typename: 'CreateTeamPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

export type CreateUserEmailInput = {
  email: Scalars['String']['input'];
  type: EmailType;
};

export type CreateUserEmailPayload = {
  __typename: 'CreateUserEmailPayload';
  email?: Maybe<Email>;
  success: Scalars['Boolean']['output'];
};

export type CreateUserInput = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserPayload = {
  __typename: 'CreateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CreateViewCommentsAlertSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  viewID: Scalars['ID']['input'];
};

export type CreateViewDiscussionCommentInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discussionThreadID?: InputMaybe<Scalars['ID']['input']>;
  inlineCommentDetails?: InputMaybe<Scalars['JSONString']['input']>;
  notifyAllSubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  viewID: Scalars['ID']['input'];
};

export type CreateViewDiscussionCommentPayload = {
  __typename: 'CreateViewDiscussionCommentPayload';
  alertSubscription: AlertSubscription;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionComment: DiscussionComment;
  discussionThread: DiscussionThread;
};

export type CustomChart = {
  __typename: 'CustomChart';
  access: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  spec: Scalars['JSONString']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type CustomChartConnection = {
  __typename: 'CustomChartConnection';
  edges: Array<CustomChartEdge>;
  pageInfo: PageInfo;
};

export type CustomChartEdge = {
  __typename: 'CustomChartEdge';
  cursor: Scalars['String']['output'];
  node: CustomChart;
};

export type CustomColor = {
  __typename: 'CustomColor';
  bucketNumber: Scalars['Int64']['output'];
  colorHex: Scalars['String']['output'];
};

export enum DagDirection {
  AwayFromArtifact = 'AwayFromArtifact',
  TowardArtifact = 'TowardArtifact'
}

export enum DagNodeType {
  Artifact = 'Artifact',
  Run = 'Run'
}

export type DefaultResourceConfig = {
  __typename: 'DefaultResourceConfig';
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  resource: Scalars['String']['output'];
  scope: DefaultResourceConfigScope;
  templateVariables: Array<TemplateVariable>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DefaultResourceConfigConnection = {
  __typename: 'DefaultResourceConfigConnection';
  edges: Array<DefaultResourceConfigEdge>;
  pageInfo: PageInfo;
};

export type DefaultResourceConfigEdge = {
  __typename: 'DefaultResourceConfigEdge';
  cursor: Scalars['String']['output'];
  node: DefaultResourceConfig;
};

export type DefaultResourceConfigScope = {
  __typename: 'DefaultResourceConfigScope';
  ID: Scalars['Int']['output'];
  Type: DefaultResourceConfigScopeType;
};

export enum DefaultResourceConfigScopeType {
  Entity = 'ENTITY',
  Project = 'PROJECT'
}

export type DefaultTriggerResultDetails = {
  __typename: 'DefaultTriggerResultDetails';
  error?: Maybe<TriggerExecutionError>;
};

export type DeleteAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteAlertPayload = {
  __typename: 'DeleteAlertPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAlertSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteAlertSubscriptionPayload = {
  __typename: 'DeleteAlertSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAlertThresholdInput = {
  alertThresholdID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
};

export type DeleteAlertThresholdPayload = {
  __typename: 'DeleteAlertThresholdPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteAliasesInput = {
  aliases: Array<ArtifactCollectionAliasInput>;
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAliasesPayload = {
  __typename: 'DeleteAliasesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteApiKeyPayload = {
  __typename: 'DeleteApiKeyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteArtifactAction = ArtifactAction & {
  __typename: 'DeleteArtifactAction';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator: Initiator;
};

export type DeleteArtifactCollectionPayload = {
  __typename: 'DeleteArtifactCollectionPayload';
  artifactCollection: ArtifactCollection;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteArtifactCollectionTagAssignmentsInput = {
  artifactCollectionName: Scalars['String']['input'];
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  tags: Array<TagInput>;
};

export type DeleteArtifactEntityTtlInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
};

export type DeleteArtifactEntityTtlPayload = {
  __typename: 'DeleteArtifactEntityTTLPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteArtifactInput = {
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteAliases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteArtifactPayload = {
  __typename: 'DeleteArtifactPayload';
  artifact: Artifact;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteArtifactPortfolioInput = {
  artifactPortfolioID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteArtifactSequenceInput = {
  artifactSequenceID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteArtifactTagAssignmentsInput = {
  artifactID: Scalars['ID']['input'];
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  tags: Array<TagInput>;
};

export type DeleteCustomChartInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DeleteCustomChartPayload = {
  __typename: 'DeleteCustomChartPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteDefaultResourceConfigsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultResourceConfigIDs: Array<Scalars['ID']['input']>;
};

export type DeleteDefaultResourceConfigsPayload = {
  __typename: 'DeleteDefaultResourceConfigsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  numAffected: Scalars['Int64']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteDiscussionCommentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteThread?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteDiscussionCommentPayload = {
  __typename: 'DeleteDiscussionCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteExperimentPayload = {
  __typename: 'DeleteExperimentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteFilesByRunAndFolderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  folders: Array<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  runName: Scalars['String']['input'];
};

export type DeleteFilesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  files: Array<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteFilesPayload = {
  __typename: 'DeleteFilesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteFromRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  queueID: Scalars['ID']['input'];
  runQueueItemId: Scalars['ID']['input'];
};

export type DeleteFromRunQueuePayload = {
  __typename: 'DeleteFromRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGlueTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteGlueTaskPayload = {
  __typename: 'DeleteGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteIntegrationPayload = {
  __typename: 'DeleteIntegrationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteInvitePayload = {
  __typename: 'DeleteInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLaunchAgentsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  launchAgentIds: Array<Scalars['ID']['input']>;
};

export type DeleteLaunchAgentsPayload = {
  __typename: 'DeleteLaunchAgentsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteModelInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type DeleteModelPayload = {
  __typename: 'DeleteModelPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOAuthProviderInput = {
  providerId: Scalars['ID']['input'];
};

export type DeleteOAuthProviderPayload = {
  __typename: 'DeleteOAuthProviderPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type DeleteOrganizationPayload = {
  __typename: 'DeleteOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionID: Scalars['ID']['input'];
};

export type DeleteOrganizationSubscriptionPayload = {
  __typename: 'DeleteOrganizationSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteProjectMembersInput = {
  projectId: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteProjectMembersPayload = {
  __typename: 'DeleteProjectMembersPayload';
  success: Scalars['Boolean']['output'];
};

export type DeletePublicQueueLaunchAgentTeamConfigInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePublicQueueLaunchAgentTeamConfigPayload = {
  __typename: 'DeletePublicQueueLaunchAgentTeamConfigPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteRoleInput = {
  roleID: Scalars['ID']['input'];
};

export type DeleteRolePayload = {
  __typename: 'DeleteRolePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteRolePermissionsInput = {
  permissions: Array<Scalars['String']['input']>;
  roleID: Scalars['ID']['input'];
};

export type DeleteRolePermissionsPayload = {
  __typename: 'DeleteRolePermissionsPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteRunPayload = {
  __typename: 'DeleteRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteRunQueuesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  queueIDs: Array<Scalars['ID']['input']>;
};

export type DeleteRunQueuesPayload = {
  __typename: 'DeleteRunQueuesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRunsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  projectName: Scalars['String']['input'];
};

export type DeleteRunsPayload = {
  __typename: 'DeleteRunsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type DeleteSecretInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
};

export type DeleteSecretPayload = {
  __typename: 'DeleteSecretPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteServiceAccountApiKeyInput = {
  apiKeyId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceAccountId: Scalars['ID']['input'];
};

export type DeleteServiceAccountApiKeyPayload = {
  __typename: 'DeleteServiceAccountApiKeyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteServiceAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteServiceAccountPayload = {
  __typename: 'DeleteServiceAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type DeleteSweepInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteRuns: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteSweepsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteRuns: Scalars['Boolean']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteSweepsPayload = {
  __typename: 'DeleteSweepsPayload';
  affectedAgents: Scalars['Int']['output'];
  affectedRuns: Scalars['Int']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteTagAssignmentPayload = {
  __typename: 'DeleteTagAssignmentPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamName: Scalars['String']['input'];
};

export type DeleteTeamPayload = {
  __typename: 'DeleteTeamPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTriggerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  triggerID: Scalars['ID']['input'];
};

export type DeleteTriggerPayload = {
  __typename: 'DeleteTriggerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteUserEmailInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserEmailPayload = {
  __typename: 'DeleteUserEmailPayload';
  email?: Maybe<Email>;
  success: Scalars['Boolean']['output'];
};

export type DeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteUserPayload = {
  __typename: 'DeleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type DeleteViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteViewPayload = {
  __typename: 'DeleteViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pendingDrafts?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteViewsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteViewsPayload = {
  __typename: 'DeleteViewsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pendingDrafts?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteWorkflowsAdminInput = {
  adminType: WorkflowsAdminType;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteWorkflowsAdminPayload = {
  __typename: 'DeleteWorkflowsAdminPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteWorkspaceTemplateInput = {
  /** @deprecated Use linePlotTemplateId or workspaceLayoutTemplateId */
  id?: InputMaybe<Scalars['ID']['input']>;
  linePlotTemplateId?: InputMaybe<Scalars['ID']['input']>;
  workspaceLayoutTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteWorkspaceTemplatePayload = {
  __typename: 'DeleteWorkspaceTemplatePayload';
  success: Scalars['Boolean']['output'];
};

export type DetachCustomerPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type DetachCustomerPaymentMethodPayload = {
  __typename: 'DetachCustomerPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum DevicePlatform {
  Ios = 'IOS'
}

export enum DiffOperation {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

export type DisableGlueTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DisableGlueTaskPayload = {
  __typename: 'DisableGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DisableOldTrackingSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type DisableOldTrackingSubscriptionPayload = {
  __typename: 'DisableOldTrackingSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscriptionID?: Maybe<Scalars['String']['output']>;
};

export type Discount = {
  __typename: 'Discount';
  coupon: Coupon;
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type DiscussionComment = {
  __typename: 'DiscussionComment';
  body: Scalars['String']['output'];
  childComments: DiscussionCommentConnection;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isParent: Scalars['Boolean']['output'];
  parentComment?: Maybe<DiscussionComment>;
  poster: User;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotes: Scalars['Int']['output'];
};


export type DiscussionCommentChildCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscussionCommentConnection = {
  __typename: 'DiscussionCommentConnection';
  edges: Array<DiscussionCommentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DiscussionCommentEdge = {
  __typename: 'DiscussionCommentEdge';
  cursor: Scalars['String']['output'];
  node: DiscussionComment;
};

export type DiscussionThread = {
  __typename: 'DiscussionThread';
  body: Scalars['String']['output'];
  comments: DiscussionCommentConnection;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  poster: User;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotes: Scalars['Int']['output'];
};


export type DiscussionThreadCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscussionThreadConnection = {
  __typename: 'DiscussionThreadConnection';
  edges: Array<DiscussionThreadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DiscussionThreadEdge = {
  __typename: 'DiscussionThreadEdge';
  cursor: Scalars['String']['output'];
  node: DiscussionThread;
};

export type DismissedBanner = {
  __typename: 'DismissedBanner';
  dismissedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export enum DotBehavior {
  KeepAllDotValues = 'KEEP_ALL_DOT_VALUES',
  SkipFirstDotValue = 'SKIP_FIRST_DOT_VALUE'
}

export type DynamicConfig = {
  __typename: 'DynamicConfig';
  value: Scalars['JSON']['output'];
};

export type Email = {
  __typename: 'Email';
  createdAt: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identities: Array<Identity>;
  type: EmailType;
  verified: Scalars['Boolean']['output'];
};

export type EmailSubscription = AlertSubscription & {
  __typename: 'EmailSubscription';
  id: Scalars['ID']['output'];
};

export enum EmailType {
  Academic = 'ACADEMIC',
  Corporate = 'CORPORATE',
  Personal = 'PERSONAL'
}

export type EnableGlueTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type EnableGlueTaskPayload = {
  __typename: 'EnableGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EnsureInferenceOverageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type EnsureInferenceOverageSubscriptionPayload = {
  __typename: 'EnsureInferenceOverageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newSubscriptionID?: Maybe<Scalars['String']['output']>;
};

export type Entity = Node & {
  __typename: 'Entity';
  accessTokens: Array<AccessToken>;
  artifactCollectionStorageTree?: Maybe<ArtifactStorageNodeConnection>;
  artifactCollections?: Maybe<ArtifactCollectionConnection>;
  artifactCollectionsSearch?: Maybe<ArtifactCollectionSearchConnection>;
  artifactMemberships?: Maybe<ArtifactCollectionMembershipConnection>;
  artifactTTLDurationSeconds: Scalars['Int64']['output'];
  artifactTypeNames?: Maybe<ArtifactTypeNameConnection>;
  available?: Maybe<Scalars['Boolean']['output']>;
  claimedEntities?: Maybe<EntityConnection>;
  claimingEntity?: Maybe<Entity>;
  codeSavingEnabled: Scalars['Boolean']['output'];
  computeHours: Scalars['Duration']['output'];
  createdAt: Scalars['DateTime']['output'];
  dailyRunCount: Array<Scalars['Int']['output']>;
  defaultAccess: Scalars['String']['output'];
  defaultAlerts: Array<Alert>;
  defaultResourceConfig?: Maybe<DefaultResourceConfig>;
  defaultResourceConfigs?: Maybe<DefaultResourceConfigConnection>;
  dynamicConfig: DynamicConfig;
  entityType?: Maybe<Scalars['String']['output']>;
  featureFlags: Array<Maybe<FeatureFlag>>;
  id: Scalars['ID']['output'];
  integrations?: Maybe<IntegrationConnection>;
  invitedTeam?: Maybe<Scalars['String']['output']>;
  invites?: Maybe<InviteConnection>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  isTeam: Scalars['Boolean']['output'];
  latestRuns?: Maybe<RunConnection>;
  launchProject?: Maybe<Project>;
  limits?: Maybe<Scalars['JSONString']['output']>;
  member?: Maybe<Member>;
  memberCount: Scalars['Int']['output'];
  members: Array<Member>;
  modelRegistryMigrationConfig?: Maybe<ModelRegistryMigrationConfig>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  photoUploadUrl: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  privateOnly: Scalars['Boolean']['output'];
  profileView?: Maybe<View>;
  project?: Maybe<Project>;
  projectCount: Scalars['Int']['output'];
  projects?: Maybe<ProjectConnection>;
  protectedAliases: Array<Scalars['String']['output']>;
  publicQueueLaunchAgents: Array<User>;
  rateLimits?: Maybe<RateLimits>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  readOnlyAdmin: Scalars['Boolean']['output'];
  referenceBytes: Scalars['Int64']['output'];
  repos?: Maybe<RepoConnection>;
  secrets: Array<Secret>;
  settings: EntitySettings;
  storageBytes: Scalars['Int64']['output'];
  storageTree?: Maybe<EntityStorageNode>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  tagCategories: Array<TagCategory>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadHeaders: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
  userStats?: Maybe<EntityUserConnection>;
  views: ViewConnection;
  workflowsAdmins: Array<User>;
};


export type EntityArtifactCollectionStorageTreeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  artifactCollectionID: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  cached?: InputMaybe<Scalars['Boolean']['input']>;
  enableReferenceTracking?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityArtifactCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type EntityArtifactCollectionsSearchArgs = {
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type EntityArtifactMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionFilters?: InputMaybe<Scalars['JSONString']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type EntityArtifactTypeNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityClaimedEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityComputeHoursArgs = {
  minDaysOld?: InputMaybe<Scalars['Int']['input']>;
  timeWindow?: InputMaybe<TimeWindow>;
};


export type EntityDailyRunCountArgs = {
  limit: Scalars['Int']['input'];
};


export type EntityDefaultResourceConfigArgs = {
  id: Scalars['ID']['input'];
};


export type EntityDefaultResourceConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityDynamicConfigArgs = {
  configId: Scalars['String']['input'];
};


export type EntityFeatureFlagsArgs = {
  featureKey?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
};


export type EntityIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keysOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityMemberArgs = {
  id: Scalars['ID']['input'];
};


export type EntityProjectArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type EntityProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type EntityProtectedAliasesArgs = {
  adminType: WorkflowsAdminType;
};


export type EntityReferenceBytesArgs = {
  cached?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EntityReposArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityStorageBytesArgs = {
  cached?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EntityStorageTreeArgs = {
  cached?: InputMaybe<Scalars['Boolean']['input']>;
  enableReferenceTracking?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EntityUserStatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTime']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type EntityViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type EntityWorkflowsAdminsArgs = {
  adminType: WorkflowsAdminType;
};

export type EntityConnection = {
  __typename: 'EntityConnection';
  edges: Array<EntityEdge>;
};

export type EntityEdge = {
  __typename: 'EntityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Entity>;
};

export type EntitySettings = {
  __typename: 'EntitySettings';
  defaultCloudRegion: CloudRegion;
  disableMagicLinkSharing?: Maybe<Scalars['Boolean']['output']>;
  disableMembersEditArtifactTTL: Scalars['Boolean']['output'];
  entityProfileEnabled: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  hideActivityCalendar: Scalars['Boolean']['output'];
  membersCanInvite?: Maybe<Scalars['Boolean']['output']>;
  openToMatchingOrgEmailDomainUsers?: Maybe<Scalars['Boolean']['output']>;
  storageBucketInfo?: Maybe<StorageBucketInfo>;
};

export type EntitySettingsInput = {
  defaultCloudRegionID?: InputMaybe<Scalars['String']['input']>;
  disableMagicLinkSharing?: InputMaybe<Scalars['Boolean']['input']>;
  disableMembersEditArtifactTTL?: InputMaybe<Scalars['Boolean']['input']>;
  entityProfileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hideActivityCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  membersCanInvite?: InputMaybe<Scalars['Boolean']['input']>;
  openToMatchingOrgEmailDomainUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntityStorageNode = StorageTreeNode & {
  __typename: 'EntityStorageNode';
  entity: Entity;
  entityID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  projects: ProjectStorageNodeConnection;
  size: Scalars['Int64']['output'];
};


export type EntityStorageNodeProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type EntityUser = Node & {
  __typename: 'EntityUser';
  id: Scalars['ID']['output'];
  runCount: Scalars['Int']['output'];
  user: User;
};

export type EntityUserConnection = {
  __typename: 'EntityUserConnection';
  edges: Array<EntityUserEdge>;
};

export type EntityUserEdge = {
  __typename: 'EntityUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<EntityUser>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export enum ErrorSeverity {
  Error = 'ERROR',
  Warn = 'WARN'
}

export type Event = {
  __typename: 'Event';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type EventEdge = {
  __typename: 'EventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Event>;
};

export enum EventTriggeringConditionType {
  AddArtifactAlias = 'ADD_ARTIFACT_ALIAS',
  AddArtifactTag = 'ADD_ARTIFACT_TAG',
  CreateArtifact = 'CREATE_ARTIFACT',
  LinkModel = 'LINK_MODEL',
  RunMetric = 'RUN_METRIC',
  RunMetricChange = 'RUN_METRIC_CHANGE',
  RunMetricZscore = 'RUN_METRIC_ZSCORE',
  RunState = 'RUN_STATE',
  UpdateArtifactAlias = 'UPDATE_ARTIFACT_ALIAS'
}

export type ExpansionPack = Node & {
  __typename: 'ExpansionPack';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  secondsLimit: Scalars['Duration']['output'];
  secondsRemaining: Scalars['Duration']['output'];
};

export type ExpansionPackConnection = {
  __typename: 'ExpansionPackConnection';
  edges: Array<ExpansionPackEdge>;
};

export type ExpansionPackEdge = {
  __typename: 'ExpansionPackEdge';
  cursor: Scalars['String']['output'];
  node: ExpansionPack;
};

export type Experiment = Node & {
  __typename: 'Experiment';
  endAt?: Maybe<Scalars['DateTime']['output']>;
  enrollmentPeriod: Scalars['Int']['output'];
  experimentType: ExperimentType;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  observationalUnit: ObservationalUnit;
  sampleSize: Scalars['Int']['output'];
  startAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variants: Array<Variant>;
};

export enum ExperimentType {
  AbTest = 'AB_TEST',
  FeatureFlag = 'FEATURE_FLAG'
}

export type FailRunQueueItemInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use message, stage and filePaths instead */
  info?: InputMaybe<Scalars['JSONString']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  runQueueItemId: Scalars['ID']['input'];
  stage?: InputMaybe<Scalars['String']['input']>;
};

export type FailRunQueueItemPayload = {
  __typename: 'FailRunQueueItemPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FailedPaymentBanners = {
  __typename: 'FailedPaymentBanners';
  orgsWithFailedPayments: Array<Maybe<OrganizationDataForFailedPaymentBanner>>;
  userID: Scalars['Int']['output'];
};

export type FeatureFlag = {
  __typename: 'FeatureFlag';
  isEnabled: Scalars['Boolean']['output'];
  rampKey: Scalars['String']['output'];
};

export type File = Node & {
  __typename: 'File';
  archived?: Maybe<Scalars['Boolean']['output']>;
  artifact?: Maybe<Artifact>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dashSrc?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digest?: Maybe<Scalars['String']['output']>;
  directUrl: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  exists: Scalars['Boolean']['output'];
  hlsSrc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReference: Scalars['Boolean']['output'];
  md5?: Maybe<Scalars['String']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use id instead */
  ndbId?: Maybe<Scalars['ID']['output']>;
  sizeBytes: Scalars['Int64']['output'];
  special?: Maybe<Scalars['Boolean']['output']>;
  storageBucket?: Maybe<Scalars['String']['output']>;
  storagePath?: Maybe<Scalars['String']['output']>;
  thumbnails: Array<Thumbnail>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadHeaders: Array<Scalars['String']['output']>;
  uploadMultipartUrls?: Maybe<UploadMultipartUrls>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type FileUrlArgs = {
  upload?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileConnection = {
  __typename: 'FileConnection';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  uploadHeaders: Array<Scalars['String']['output']>;
};

export type FileEdge = {
  __typename: 'FileEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<File>;
};

export type FileStorageNode = StorageTreeNode & {
  __typename: 'FileStorageNode';
  file: File;
  fileID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export type FileStorageNodeConnection = {
  __typename: 'FileStorageNodeConnection';
  edges: Array<FileStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type FileStorageNodeEdge = {
  __typename: 'FileStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: FileStorageNode;
};

export type FilterEventTriggeringCondition = {
  __typename: 'FilterEventTriggeringCondition';
  eventType: EventTriggeringConditionType;
  filter: Scalars['String']['output'];
};

export type FinishedRunCondition = {
  __typename: 'FinishedRunCondition';
  success: Scalars['Boolean']['output'];
};

export type FolderMetadata = {
  __typename: 'FolderMetadata';
  name: Scalars['String']['output'];
  numberOfFiles: Scalars['Int64']['output'];
  size: Scalars['Int64']['output'];
};

export type Folders = {
  __typename: 'Folders';
  folderList: Array<Maybe<FolderMetadata>>;
};

export type ForceCleanArtifactStorageStatsInput = {
  artifactCollectionIDs: Array<Scalars['ID']['input']>;
};

export type ForceCleanArtifactStorageStatsPayload = {
  __typename: 'ForceCleanArtifactStorageStatsPayload';
  cleanedArtifactCollectionIDs: Array<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ForceCleanRunStorageStatsInput = {
  projectIDs: Array<Scalars['Int']['input']>;
};

export type ForceCleanRunStorageStatsPayload = {
  __typename: 'ForceCleanRunStorageStatsPayload';
  cleanedProjectIDs: Array<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerateApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateApiKeyPayload = {
  __typename: 'GenerateApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  secretApiKey?: Maybe<Scalars['String']['output']>;
};

export type GenerateLocalLicenseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  expDuration: Scalars['Int']['input'];
  flags: Array<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  seats: Scalars['Int']['input'];
  storageGigs: Scalars['Int']['input'];
  teams: Scalars['Int']['input'];
};

export type GenerateLocalLicensePayload = {
  __typename: 'GenerateLocalLicensePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  localLicense: LocalLicense;
};

export type GenericWebhookActionArgs = {
  __typename: 'GenericWebhookActionArgs';
  integration?: Maybe<GenericWebhookIntegration>;
  requestPayload?: Maybe<Scalars['JSONString']['output']>;
};

export type GenericWebhookActionInput = {
  integrationID: Scalars['ID']['input'];
  requestPayload?: InputMaybe<Scalars['JSONString']['input']>;
};

export type GenericWebhookIntegration = Integration & {
  __typename: 'GenericWebhookIntegration';
  accessTokenRef?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  secretRef?: Maybe<Scalars['String']['output']>;
  urlEndpoint: Scalars['String']['output'];
};

export type GenericWebhookTriggeredAction = {
  __typename: 'GenericWebhookTriggeredAction';
  entityName: Scalars['String']['output'];
  integration: Integration;
  requestPayload?: Maybe<Scalars['JSONString']['output']>;
};

export type GitHubOAuthIntegration = Integration & {
  __typename: 'GitHubOAuthIntegration';
  id: Scalars['ID']['output'];
};

export type GitInfo = {
  __typename: 'GitInfo';
  commit?: Maybe<Scalars['String']['output']>;
  remote?: Maybe<Scalars['String']['output']>;
};

export type GlueManager = {
  __typename: 'GlueManager';
  registeredTasks: GlueTaskConnection;
  taskConfig?: Maybe<GlueTaskConfig>;
  taskTypes: Array<Scalars['String']['output']>;
};


export type GlueManagerRegisteredTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type GlueManagerTaskConfigArgs = {
  taskType: Scalars['String']['input'];
};

export type GlueRun = {
  __typename: 'GlueRun';
  arguments?: Maybe<Scalars['JSONString']['output']>;
  checkpoint?: Maybe<Scalars['JSONString']['output']>;
  errors?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  retries: Scalars['Int']['output'];
  runAt: Scalars['DateTime']['output'];
  runtimeMS: Scalars['Int64']['output'];
  succeeded: Scalars['Boolean']['output'];
  task: GlueTask;
};

export type GlueRunConnection = {
  __typename: 'GlueRunConnection';
  edges: Array<GlueRunEdge>;
  pageInfo: PageInfo;
};

export type GlueRunEdge = {
  __typename: 'GlueRunEdge';
  cursor: Scalars['String']['output'];
  node: GlueRun;
};

export type GlueTask = {
  __typename: 'GlueTask';
  arguments?: Maybe<Scalars['JSONString']['output']>;
  checkpoint?: Maybe<Scalars['JSONString']['output']>;
  glueRuns: GlueRunConnection;
  id: Scalars['ID']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  strategyMetadata: Scalars['String']['output'];
  strategyType: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
};


export type GlueTaskGlueRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};

export type GlueTaskConfig = {
  __typename: 'GlueTaskConfig';
  defaultArguments: Scalars['JSONString']['output'];
};

export type GlueTaskConnection = {
  __typename: 'GlueTaskConnection';
  edges: Array<GlueTaskEdge>;
  pageInfo: PageInfo;
};

export type GlueTaskEdge = {
  __typename: 'GlueTaskEdge';
  cursor: Scalars['String']['output'];
  node: GlueTask;
};

export type GroupAggregation = {
  custom: Array<AggregationKey>;
  default: Aggregation;
};

export type GroupBucketDiff = {
  __typename: 'GroupBucketDiff';
  groupedRun?: Maybe<GroupedRun>;
  op: DiffOperation;
};

export type GroupBucketDiffs = {
  __typename: 'GroupBucketDiffs';
  delta: Array<GroupBucketDiff>;
  incomplete?: Maybe<Array<Scalars['ID']['output']>>;
  order: Array<Scalars['ID']['output']>;
};

export type GroupedRun = Node & {
  __typename: 'GroupedRun';
  bucketedHistory: Array<Scalars['JSON']['output']>;
  config?: Maybe<Scalars['JSONString']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultColorIndex?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Number of runs whose history was actually fetched and aggregated into
   * this group's metrics. May be less than totalRuns due to maxTotalRuns
   * budget distribution across groups via CalculateGroupSizes.
   */
  includedRuns: Scalars['Int']['output'];
  jobType?: Maybe<Scalars['String']['output']>;
  lines: Array<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  summaryMetrics?: Maybe<Scalars['JSONString']['output']>;
  sweep?: Maybe<Sweep>;
  /**
   * Total number of runs in this group before any capping or truncation.
   * Bounded by the initial fetch limit in NewSummarizeRunGroups, so it
   * may undercount on very large run sets.
   */
  totalRuns: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};


export type GroupedRunBucketedHistoryArgs = {
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type GroupedRunConfigArgs = {
  dotBehavior?: InputMaybe<DotBehavior>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GroupedRunLinesArgs = {
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type GroupedRunSummaryMetricsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupedRunConnection = {
  __typename: 'GroupedRunConnection';
  deltas?: Maybe<GroupBucketDiffs>;
  edges: Array<GroupedRunEdge>;
};


export type GroupedRunConnectionDeltasArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupedRunEdge = {
  __typename: 'GroupedRunEdge';
  cursor: Scalars['String']['output'];
  node: GroupedRun;
};

export enum HistoryKeysFormat {
  Bitmap = 'BITMAP',
  Plaintext = 'PLAINTEXT'
}

export type HttpTriggerResultDetails = {
  __typename: 'HttpTriggerResultDetails';
  body?: Maybe<Scalars['String']['output']>;
  error?: Maybe<TriggerExecutionError>;
  status?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type HubSettingsInput = {
  disk?: InputMaybe<Scalars['String']['input']>;
  dockerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  redisEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  repo?: InputMaybe<Scalars['String']['input']>;
};

export type Identity = {
  __typename: 'Identity';
  emailIdentityVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
};

export type ImageUrl = {
  __typename: 'ImageUrl';
  path?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InferenceCostUsageAggregation = UsageAggregationInterface & {
  __typename: 'InferenceCostUsageAggregation';
  end: Scalars['DateTime']['output'];
  endpointName: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  inputCost: Scalars['Int64']['output'];
  inputCount: Scalars['Int64']['output'];
  outputCost: Scalars['Int64']['output'];
  outputCount: Scalars['Int64']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  value: Scalars['Int64']['output'];
};

export type InferenceEnterpriseSubscription = {
  __typename: 'InferenceEnterpriseSubscription';
  billingPeriodEnd: Scalars['DateTime']['output'];
  billingPeriodStart: Scalars['DateTime']['output'];
  inferenceLimit: Scalars['Int64']['output'];
};

export type Initiator = Run | User;

export type InputArtifactConnection = ArtifactConnectionType & {
  __typename: 'InputArtifactConnection';
  edges: Array<InputArtifactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InputArtifactEdge = ArtifactEdgeType & {
  __typename: 'InputArtifactEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Artifact>;
  usedAs: Array<Scalars['String']['output']>;
};

export type InsertGalleryDiscussionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportID: Scalars['ID']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  spec: Scalars['String']['input'];
};

export type InsertGalleryDiscussionPayload = {
  __typename: 'InsertGalleryDiscussionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InsertSecretInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
  secretValue: Scalars['String']['input'];
};

export type InsertSecretPayload = {
  __typename: 'InsertSecretPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Integration = {
  id: Scalars['ID']['output'];
};

export type IntegrationConnection = {
  __typename: 'IntegrationConnection';
  edges: Array<IntegrationEdge>;
  pageInfo: PageInfo;
};

export type IntegrationEdge = {
  __typename: 'IntegrationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Integration>;
};

export type Invite = {
  __typename: 'Invite';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fromUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  role: Scalars['String']['output'];
  toUser?: Maybe<User>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InviteConnection = {
  __typename: 'InviteConnection';
  edges: Array<InviteEdge>;
  pageInfo: PageInfo;
};

export type InviteEdge = {
  __typename: 'InviteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Invite>;
};

export type JobSetDiff = {
  __typename: 'JobSetDiff';
  complete: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  removeJobs: Array<Scalars['ID']['output']>;
  upsertJobs: Array<RunQueueItem>;
  version: Scalars['Int']['output'];
};

export type JobSetSelectorInput = {
  entityName: Scalars['String']['input'];
  jobSetName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type LaunchAgent = {
  __typename: 'LaunchAgent';
  agentConfig?: Maybe<Scalars['JSONString']['output']>;
  agentStatus: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  heartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  hostname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  runQueues: Array<Scalars['ID']['output']>;
  stopPolling: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type LeaseJobSetItemInput = {
  agentId: Scalars['ID']['input'];
  jobSetId: Scalars['ID']['input'];
  jobSetItemId: Scalars['ID']['input'];
};

export type LeaseJobSetItemPayload = {
  __typename: 'LeaseJobSetItemPayload';
  success: Scalars['Boolean']['output'];
};

export type LicenseClaims = {
  __typename: 'LicenseClaims';
  expiresAt: Scalars['Int64']['output'];
  flags: Array<Scalars['String']['output']>;
  seats: Scalars['Int']['output'];
  storageGigs: Scalars['Int']['output'];
  teams: Scalars['Int']['output'];
};

export type LicenseExpirationUi = {
  __typename: 'LicenseExpirationUI';
  bannerDaysRemaining: Scalars['Int']['output'];
  bannerTotalDays: Scalars['Int']['output'];
  renewUrl?: Maybe<Scalars['String']['output']>;
};

export type LinkArtifactInput = {
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  artifactID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioName?: InputMaybe<Scalars['String']['input']>;
  clientID?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type LinkArtifactPayload = {
  __typename: 'LinkArtifactPayload';
  aliases: Array<ArtifactCollectionAlias>;
  artifactCollectionID: Scalars['ID']['output'];
  artifactID: Scalars['ID']['output'];
  artifactMembership: ArtifactCollectionMembership;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  versionIndex?: Maybe<Scalars['Int']['output']>;
};

export type LinkTeamToOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
};

export type LinkTeamToOrganizationPayload = {
  __typename: 'LinkTeamToOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LocalLicense = Node & {
  __typename: 'LocalLicense';
  claims: LicenseClaims;
  contactEmail: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerName: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  generatedBy: User;
  id: Scalars['ID']['output'];
  license: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocalVersionInfo = {
  __typename: 'LocalVersionInfo';
  latestVersionString: Scalars['String']['output'];
  outOfDate: Scalars['Boolean']['output'];
  versionOnThisInstanceString: Scalars['String']['output'];
};

export type LogLine = {
  __typename: 'LogLine';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  line?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type LogLineConnection = {
  __typename: 'LogLineConnection';
  edges: Array<LogLineEdge>;
  pageInfo: PageInfo;
};

export type LogLineEdge = {
  __typename: 'LogLineEdge';
  cursor: Scalars['String']['output'];
  node: LogLine;
};

export type MakeOrgMembersNoAccessModelsSeatInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MakeOrgMembersNoAccessModelsSeatPayload = {
  __typename: 'MakeOrgMembersNoAccessModelsSeatPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MaybeGroupedRunConnection = GroupedRunConnection | RunConnection;

export type Member = {
  __typename: 'Member';
  OAuthClients: Array<OAuthClient>;
  accountType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `role` instead. */
  admin?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiKeyCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  memberRole?: Maybe<Role>;
  name: Scalars['String']['output'];
  pending?: Maybe<Scalars['Boolean']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  serviceAccountAuthMethod?: Maybe<ServiceAccountAuthMethod>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum MetricColumn {
  SummaryMetrics = 'SUMMARY_METRICS',
  SystemMetrics = 'SYSTEM_METRICS'
}

export type MetricInfo = {
  __typename: 'MetricInfo';
  column: MetricColumn;
  key: Scalars['String']['output'];
  types: Array<Scalars['String']['output']>;
};

export type MetricSearchResults = {
  __typename: 'MetricSearchResults';
  cursor: Scalars['String']['output'];
  hasMore: Scalars['Boolean']['output'];
  results: Array<MetricInfo>;
};

export type MigrateOldHourOverageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MigrateOldHourOverageSubscriptionPayload = {
  __typename: 'MigrateOldHourOverageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newSubscriptionID?: Maybe<Scalars['String']['output']>;
  oldSubscriptionID?: Maybe<Scalars['String']['output']>;
};

export type MigrateOldStorageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MigrateOldStorageSubscriptionPayload = {
  __typename: 'MigrateOldStorageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newSubscriptionID?: Maybe<Scalars['String']['output']>;
  oldSubscriptionID?: Maybe<Scalars['String']['output']>;
};

export type MigrateOrPurgePersonalEntityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['ID']['input'];
};

export type MigrateOrPurgePersonalEntityPayload = {
  __typename: 'MigrateOrPurgePersonalEntityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationID?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ModelRegistryMigrationConfig = {
  __typename: 'ModelRegistryMigrationConfig';
  blockWritesLegacyModelRegistry: Scalars['Boolean']['output'];
  blockWritesMigratedModelRegistry: Scalars['Boolean']['output'];
  migrationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  orgRegistryProject?: Maybe<Project>;
};

export type ModifyRunsInput = {
  addTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  removeTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModifyRunsPayload = {
  __typename: 'ModifyRunsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  runs: Array<Maybe<Run>>;
  runsSQL: Array<Maybe<Run>>;
};

export type MoveArtifactAliasAction = ArtifactAction & {
  __typename: 'MoveArtifactAliasAction';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  destinationArtifact?: Maybe<Artifact>;
  id: Scalars['ID']['output'];
  initiator: Initiator;
};

export type MoveArtifactCollectionPayload = {
  __typename: 'MoveArtifactCollectionPayload';
  artifactCollection?: Maybe<ArtifactCollection>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type MoveArtifactSequenceInput = {
  artifactSequenceID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationArtifactTypeName: Scalars['String']['input'];
};

export type MoveHistoryForRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationEntityName: Scalars['String']['input'];
  destinationProjectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  sourceEntityName: Scalars['String']['input'];
  sourceProjectName: Scalars['String']['input'];
};

export type MoveHistoryForRunPayload = {
  __typename: 'MoveHistoryForRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task?: Maybe<Task>;
};

export type MoveProjectsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationEntityName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerUsername: Scalars['String']['input'];
  projectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEntityName: Scalars['String']['input'];
};

export type MoveProjectsPayload = {
  __typename: 'MoveProjectsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
};

export type MoveRunsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationEntityName: Scalars['String']['input'];
  destinationProjectName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  sourceEntityName: Scalars['String']['input'];
  sourceProjectName: Scalars['String']['input'];
};

export type MoveRunsPayload = {
  __typename: 'MoveRunsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type MoveTagCategoryInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  newEntityName: Scalars['String']['input'];
  oldEntityName: Scalars['String']['input'];
  tagCategoryName: Scalars['String']['input'];
};

export type MoveTagInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  newTagCategoryName: Scalars['String']['input'];
  oldTagCategoryName: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type MoveViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  projectName: Scalars['String']['input'];
};

export type MoveViewPayload = {
  __typename: 'MoveViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename: 'Mutation';
  ackJobSetItem?: Maybe<AckJobSetItemPayload>;
  ackRunQueueItem?: Maybe<AckRunQueueItemPayload>;
  addAliases?: Maybe<AddAliasesPayload>;
  addFiles?: Maybe<AddFilesPayload>;
  addProjectProtectedAliases?: Maybe<AddProjectProtectedAliasesPayload>;
  addProtectedAliases?: Maybe<AddProtectedAliasesPayload>;
  addPublicQueueLaunchAgentTeamConfig?: Maybe<AddPublicQueueLaunchAgentTeamConfigPayload>;
  addRolePermissions?: Maybe<AddRolePermissionsPayload>;
  addUserToOrganization?: Maybe<AddUserToOrganizationPayload>;
  addWorkflowsAdmin?: Maybe<AddWorkflowsAdminPayload>;
  agentHeartbeat?: Maybe<AgentHeartbeatPayload>;
  attachCustomerPaymentMethod?: Maybe<AttachCustomerPaymentMethodPayload>;
  cancelCustomerSubscription?: Maybe<CancelCustomerSubscriptionPayload>;
  claimAnonymousEntity?: Maybe<ClaimAnonymousEntityPayload>;
  cloneProjects?: Maybe<CloneProjectsPayload>;
  commitArtifact?: Maybe<CommitArtifactPayload>;
  completeMultipartUploadArtifact?: Maybe<CompleteMultipartUploadArtifactPayload>;
  contactUsForComputeHours?: Maybe<ContactUsForComputeHoursPayload>;
  contactUsForUserLedTrial?: Maybe<ContactUsForUserLedTrialPayload>;
  createAWSExternalID: Scalars['String']['output'];
  createAcademicOrReverseTrial?: Maybe<CreateAcademicOrReverseTrialPayload>;
  createAccessToken?: Maybe<CreateAccessTokenPayload>;
  createAgent?: Maybe<CreateAgentPayload>;
  createAlertThreshold?: Maybe<CreateAlertThresholdPayload>;
  createAndLinkWeaveAsset?: Maybe<LinkArtifactPayload>;
  createAnonymousEntity?: Maybe<CreateEntityPayload>;
  createArtifact?: Maybe<CreateArtifactPayload>;
  createArtifactCollectionTagAssignments?: Maybe<CreateTagsPayload>;
  createArtifactFiles?: Maybe<CreateArtifactFilesPayload>;
  createArtifactManifest?: Maybe<CreateArtifactManifestPayload>;
  createArtifactPortfolio?: Maybe<CreateArtifactCollectionPayload>;
  createArtifactSequence?: Maybe<CreateArtifactCollectionPayload>;
  createArtifactTagAssignments?: Maybe<CreateTagsPayload>;
  /** @deprecated Use createArtifactTypes instead */
  createArtifactType?: Maybe<CreateArtifactTypePayload>;
  createArtifactTypes?: Maybe<CreateArtifactTypesPayload>;
  createBenchmarkDiscussionComment?: Maybe<CreateDiscussionCommentPayload>;
  createBenchmarkDiscussionThread?: Maybe<CreateDiscussionThreadPayload>;
  createClient?: Maybe<CreateClientPayload>;
  createClientIDMapping?: Maybe<CreateClientIdMappingPayload>;
  createCustomChart?: Maybe<CreateCustomChartPayload>;
  createCustomerSubscription?: Maybe<CreateCustomerSubscriptionPayload>;
  createCustomerTrial?: Maybe<CreateCustomerTrialPayload>;
  createDefaultResourceConfig?: Maybe<CreateDefaultResourceConfigPayload>;
  createEmailSubscription?: Maybe<CreateEmailSubscriptionPayload>;
  createEntity?: Maybe<CreateEntityPayload>;
  createExperiment?: Maybe<CreateExperimentPayload>;
  createFilterTrigger?: Maybe<CreateFilterTriggerPayload>;
  createFinishedRunAlert?: Maybe<CreateAlertPayload>;
  createGenericWebhookIntegration?: Maybe<CreateIntegrationPayload>;
  createGitHubOAuthIntegration?: Maybe<CreateIntegrationPayload>;
  createGlueTask?: Maybe<CreateGlueTaskPayload>;
  createHourOverageSubscription?: Maybe<CreateHourOverageSubscriptionPayload>;
  createInferenceSubscription?: Maybe<CreateInferenceSubscriptionPayload>;
  createInvite?: Maybe<CreateInvitePayload>;
  createLaunchAgent?: Maybe<CreateLaunchAgentPayload>;
  createLocalLicenseOrganization?: Maybe<CreateLocalLicenseOrganizationPayload>;
  createNewsletterSubscription?: Maybe<CreateNewsletterSubscriptionPayload>;
  createOAuthProvider?: Maybe<CreateOAuthProviderPayload>;
  createOrgServiceAccount?: Maybe<CreateOrgServiceAccountPayload>;
  createPreviewableLink?: Maybe<CreatePreviewableLinkPayload>;
  createProjectMembers?: Maybe<CreateProjectMembersPayload>;
  createRole?: Maybe<CreateRolePayload>;
  createRunFiles?: Maybe<CreateRunFilesPayload>;
  createRunQueue?: Maybe<CreateRunQueuePayload>;
  createScriptableRunAlert?: Maybe<CreateAlertPayload>;
  createSemanticLegend?: Maybe<CreateSemanticLegendPayload>;
  createServiceAccount?: Maybe<CreateServiceAccountPayload>;
  createServiceAccountApiKey?: Maybe<CreateServiceAccountApiKeyPayload>;
  createSlackChannelSubscription?: Maybe<CreateSlackChannelSubscriptionPayload>;
  createSlackIntegration?: Maybe<CreateIntegrationPayload>;
  createStoppedRunAlert?: Maybe<CreateAlertPayload>;
  createStorageSubscription?: Maybe<CreateStorageSubscriptionPayload>;
  createTeam?: Maybe<CreateTeamPayload>;
  createUser?: Maybe<CreateUserPayload>;
  createViewCommentsAlertSubscription?: Maybe<CreateEmailSubscriptionPayload>;
  createViewDiscussionComment?: Maybe<CreateViewDiscussionCommentPayload>;
  deleteAlert?: Maybe<DeleteAlertPayload>;
  deleteAlertSubscription?: Maybe<DeleteAlertSubscriptionPayload>;
  deleteAlertThreshold?: Maybe<DeleteAlertThresholdPayload>;
  deleteAliases?: Maybe<DeleteAliasesPayload>;
  deleteApiKey?: Maybe<DeleteApiKeyPayload>;
  deleteArtifact?: Maybe<DeleteArtifactPayload>;
  deleteArtifactCollectionTagAssignments?: Maybe<DeleteTagAssignmentPayload>;
  deleteArtifactEntityTTL?: Maybe<DeleteArtifactEntityTtlPayload>;
  deleteArtifactPortfolio?: Maybe<DeleteArtifactCollectionPayload>;
  deleteArtifactSequence?: Maybe<DeleteArtifactCollectionPayload>;
  deleteArtifactTagAssignments?: Maybe<DeleteTagAssignmentPayload>;
  deleteCustomChart?: Maybe<DeleteCustomChartPayload>;
  deleteDefaultResourceConfigs?: Maybe<DeleteDefaultResourceConfigsPayload>;
  deleteDiscussionComment?: Maybe<DeleteDiscussionCommentPayload>;
  deleteExperiment?: Maybe<DeleteExperimentPayload>;
  deleteFiles?: Maybe<DeleteFilesPayload>;
  deleteFilesByRunAndFolder?: Maybe<DeleteFilesPayload>;
  deleteFromRunQueue?: Maybe<DeleteFromRunQueuePayload>;
  deleteGlueTask?: Maybe<DeleteGlueTaskPayload>;
  deleteIntegration?: Maybe<DeleteIntegrationPayload>;
  deleteInvite?: Maybe<DeleteInvitePayload>;
  deleteLaunchAgents?: Maybe<DeleteLaunchAgentsPayload>;
  deleteModel?: Maybe<DeleteModelPayload>;
  deleteOAuthProvider?: Maybe<DeleteOAuthProviderPayload>;
  deleteOrganization?: Maybe<DeleteOrganizationPayload>;
  deleteOrganizationSubscription?: Maybe<DeleteOrganizationSubscriptionPayload>;
  deleteProjectMembers?: Maybe<DeleteProjectMembersPayload>;
  deletePublicQueueLaunchAgentTeamConfig?: Maybe<DeletePublicQueueLaunchAgentTeamConfigPayload>;
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteRolePermissions?: Maybe<DeleteRolePermissionsPayload>;
  deleteRun?: Maybe<DeleteRunPayload>;
  deleteRunQueues?: Maybe<DeleteRunQueuesPayload>;
  deleteRuns?: Maybe<DeleteRunsPayload>;
  deleteSecret?: Maybe<DeleteSecretPayload>;
  deleteServiceAccount?: Maybe<DeleteServiceAccountPayload>;
  deleteServiceAccountApiKey?: Maybe<DeleteServiceAccountApiKeyPayload>;
  deleteSweep?: Maybe<DeleteSweepsPayload>;
  deleteSweeps?: Maybe<DeleteSweepsPayload>;
  deleteTeam?: Maybe<DeleteTeamPayload>;
  deleteTrigger: DeleteTriggerPayload;
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteUserEmail?: Maybe<DeleteUserEmailPayload>;
  deleteView?: Maybe<DeleteViewPayload>;
  deleteViews?: Maybe<DeleteViewsPayload>;
  deleteWorkflowsAdmin?: Maybe<DeleteWorkflowsAdminPayload>;
  deleteWorkspaceTemplate?: Maybe<DeleteWorkspaceTemplatePayload>;
  detachCustomerPaymentMethod?: Maybe<DetachCustomerPaymentMethodPayload>;
  disableGlueTask?: Maybe<DisableGlueTaskPayload>;
  disableOldTrackingSubscription?: Maybe<DisableOldTrackingSubscriptionPayload>;
  enableGlueTask?: Maybe<EnableGlueTaskPayload>;
  ensureInferenceOverageSubscription?: Maybe<EnsureInferenceOverageSubscriptionPayload>;
  failRunQueueItem?: Maybe<FailRunQueueItemPayload>;
  forceCleanArtifactStorageStats?: Maybe<ForceCleanArtifactStorageStatsPayload>;
  forceCleanRunStorageStats?: Maybe<ForceCleanRunStorageStatsPayload>;
  generateApiKey?: Maybe<GenerateApiKeyPayload>;
  generateLocalLicense?: Maybe<GenerateLocalLicensePayload>;
  insertGalleryDiscussion?: Maybe<InsertGalleryDiscussionPayload>;
  insertSecret?: Maybe<InsertSecretPayload>;
  leaseJobSetItem?: Maybe<LeaseJobSetItemPayload>;
  linkArtifact?: Maybe<LinkArtifactPayload>;
  linkTeamToOrganization?: Maybe<LinkTeamToOrganizationPayload>;
  makeOrgMembersNoAccessModelsSeat?: Maybe<MakeOrgMembersNoAccessModelsSeatPayload>;
  migrateOldHourOverageSubscription?: Maybe<MigrateOldHourOverageSubscriptionPayload>;
  migrateOldStorageSubscription?: Maybe<MigrateOldStorageSubscriptionPayload>;
  migrateOrPurgePersonalEntity?: Maybe<MigrateOrPurgePersonalEntityPayload>;
  modifyRuns?: Maybe<ModifyRunsPayload>;
  moveArtifactSequence?: Maybe<MoveArtifactCollectionPayload>;
  moveHistoryForRun?: Maybe<MoveHistoryForRunPayload>;
  moveProjects?: Maybe<MoveProjectsPayload>;
  moveRuns?: Maybe<MoveRunsPayload>;
  moveTag?: Maybe<UpdateTagPayload>;
  moveTagCategory?: Maybe<UpdateTagCategoryPayload>;
  moveView?: Maybe<MoveViewPayload>;
  notifyScriptableRunAlert?: Maybe<NotifyScriptableRunAlertPayload>;
  popFromRunQueue?: Maybe<PopFromRunQueuePayload>;
  publishBenchmarkRun?: Maybe<PublishBenchmarkRunPayload>;
  purgeUser?: Maybe<PurgeUserPayload>;
  pushToRunQueue?: Maybe<PushToRunQueuePayload>;
  pushToRunQueueByName?: Maybe<PushToRunQueueByNamePayload>;
  registerUserDevice?: Maybe<RegisterUserDevicePayload>;
  removeProjectProtectedAliases?: Maybe<RemoveProjectProtectedAliasesPayload>;
  removeProtectedAliases?: Maybe<RemoveProtectedAliasesPayload>;
  removeUserFromOrganization?: Maybe<RemoveUserFromOrganizationPayload>;
  removeUserFromOrganizationById?: Maybe<RemoveUserFromOrganizationByIdPayload>;
  renameProject?: Maybe<UpsertModelPayload>;
  resendEmailVerification?: Maybe<ResendEmailVerificationPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  retryStripeOpenInvoicesByOrganization?: Maybe<RetryStripeOpenInvoicesByOrganizationPayload>;
  revokeAccessToken?: Maybe<RevokeAccessTokenPayload>;
  revokeAccessTokenEmail?: Maybe<RevokeAccessTokenEmailPayload>;
  revokeClient?: Maybe<RevokeClientPayload>;
  rewindRun?: Maybe<RewindRunPayload>;
  sendRequestOrgEmailDomainVerification?: Maybe<SendRequestOrgEmailDomainVerificationPayload>;
  setDismissedBanner?: Maybe<SetDismissedBannerPayload>;
  setTagColor?: Maybe<SetTagColorPayload>;
  starProject?: Maybe<StarProjectPayload>;
  starRegistry?: Maybe<StarRegistryPayload>;
  starView?: Maybe<StarViewPayload>;
  startExperiment?: Maybe<UpdateExperimentPayload>;
  stopExperiment?: Maybe<UpdateExperimentPayload>;
  stopRun?: Maybe<StopRunPayload>;
  submitBenchmarkRun?: Maybe<SubmitBenchmarkRunPayload>;
  submitFCNews?: Maybe<SubmitFcNewsPayload>;
  testBucketStoreConnection: Array<BucketStoreConnectionError>;
  testGenericWebhookIntegration?: Maybe<TestGenericWebhookIntegrationPayload>;
  triggerEventsExport?: Maybe<TriggerEventsExportPayload>;
  triggerFlatRunsMigrator?: Maybe<TriggerFlatRunsMigratorPayload>;
  triggerParquetExport?: Maybe<TriggerParquetExportPayload>;
  triggerRecomputeKeysInfo?: Maybe<TriggerRecomputeKeysInfoPayload>;
  undeleteRuns?: Maybe<UndeleteRunsPayload>;
  undeleteUser?: Maybe<UndeleteUserPayload>;
  unlinkArtifact?: Maybe<UnlinkArtifactPayload>;
  unregisterUserDevice?: Maybe<UnregisterUserDevicePayload>;
  unstarProject?: Maybe<UnstarProjectPayload>;
  unstarRegistry?: Maybe<UnstarRegistryPayload>;
  unstarView?: Maybe<UnstarViewPayload>;
  updateAccessToken?: Maybe<UpdateAccessTokenPayload>;
  updateAccessTokenProjects?: Maybe<UpdateAccessTokenProjectsPayload>;
  updateAlertThreshold?: Maybe<UpdateAlertThresholdPayload>;
  updateApiKey?: Maybe<UpdateApiKeyPayload>;
  updateArtifact?: Maybe<UpdateArtifactPayload>;
  updateArtifactEntityTTL?: Maybe<UpdateArtifactEntityTtlPayload>;
  updateArtifactManifest?: Maybe<UpdateArtifactManifestPayload>;
  updateArtifactPortfolio?: Maybe<UpdateArtifactCollectionPayload>;
  updateArtifactSequence?: Maybe<UpdateArtifactCollectionPayload>;
  updateArtifactType?: Maybe<UpdateArtifactTypePayload>;
  updateBenchmarkRun?: Maybe<UpdateBenchmarkRunPayload>;
  updateCustomChart?: Maybe<UpdateCustomChartPayload>;
  updateCustomerDefaultPaymentMethod?: Maybe<UpdateCustomerDefaultPaymentMethodPayload>;
  updateCustomerPaymentMethod?: Maybe<UpdateCustomerPaymentMethodPayload>;
  updateDefaultResourceConfig?: Maybe<UpdateDefaultResourceConfigPayload>;
  updateDiscussionComment?: Maybe<UpdateDiscussionCommentPayload>;
  updateDiscussionThread?: Maybe<UpdateDiscussionThreadPayload>;
  updateEntity?: Maybe<UpdateEntityPayload>;
  updateExperiment?: Maybe<UpdateExperimentPayload>;
  updateFilterTrigger?: Maybe<UpdateFilterTriggerPayload>;
  updateGenericWebhookIntegration?: Maybe<CreateIntegrationPayload>;
  updateGlueTask?: Maybe<UpdateGlueTaskPayload>;
  updateLaunchAgent?: Maybe<UpdateLaunchAgentPayload>;
  updateLocalLicense?: Maybe<UpdateLocalLicensePayload>;
  updateMember?: Maybe<UpdateMemberPayload>;
  updateModelsSeat?: Maybe<UpdateModelsSeatPayload>;
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  updateOrganizationBillingUser?: Maybe<UpdateOrganizationBillingUserPayload>;
  updateOrganizationPrivacySettings?: Maybe<UpdateOrganizationPrivacySettingsPayload>;
  updateOrganizationSubscription?: Maybe<UpdateOrganizationSubscriptionPayload>;
  updateOrganizationSubscriptionSeats?: Maybe<UpdateOrganizationSubscriptionSeatsPayload>;
  updateOrganizationUser?: Maybe<UpdateOrganizationUserPayload>;
  updateOrganizationUserV2?: Maybe<UpdateOrganizationUserV2Payload>;
  updateProjectMember?: Maybe<UpdateProjectMemberPayload>;
  updateProjectTeamMember?: Maybe<UpdateProjectTeamMemberPayload>;
  updateRampThreshold?: Maybe<UpdateRampThresholdPayload>;
  updateRole?: Maybe<UpdateRolePayload>;
  updateRunQueue?: Maybe<UpdateRunQueuePayload>;
  updateRunQueueItemWarning?: Maybe<UpdateRunQueueItemWarningPayload>;
  updateRunState?: Maybe<UpdateRunStatePayload>;
  updateSemanticLegend?: Maybe<UpdateSemanticLegendPayload>;
  updateServiceAccountApiKey?: Maybe<UpdateServiceAccountApiKeyPayload>;
  updateStoppedRunAlert?: Maybe<UpdateAlertPayload>;
  updateSubscription?: Maybe<UpdateSubscriptionPayload>;
  updateTag?: Maybe<UpdateTagPayload>;
  updateTagCategory?: Maybe<UpdateTagCategoryPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserEmail?: Maybe<UpdateUserEmailPayload>;
  updateUserRole?: Maybe<UpdateUserRolePayload>;
  updateUserRoleV2?: Maybe<UpdateUserRoleV2Payload>;
  updateWeaveRole?: Maybe<UpdateWeaveRolePayload>;
  upgradeCustomerSubscription?: Maybe<UpgradeCustomerSubscriptionPayload>;
  upgradeCustomerToProPlan?: Maybe<UpgradeCustomerToProPlanPayload>;
  upgradeProCustomer?: Maybe<UpgradeProCustomerPayload>;
  upgradeTrialSubscription?: Maybe<UpgradeTrialSubscriptionPayload>;
  /** @deprecated Use createPreviewableLink instead */
  uploadPanel?: Maybe<UploadPanelPayload>;
  upsertBucket?: Maybe<UpsertBucketPayload>;
  upsertModel?: Maybe<UpsertModelPayload>;
  upsertRunGroup?: Maybe<UpsertRunGroupPayload>;
  upsertRunQueue?: Maybe<UpsertRunQueuePayload>;
  upsertSharedView?: Maybe<UpsertSharedViewPayload>;
  upsertSweep?: Maybe<UpsertSweepPayload>;
  upsertUserProfileView?: Maybe<UpsertUserProfileViewPayload>;
  upsertView?: Maybe<UpsertViewPayload>;
  upsertWorkspaceTemplate?: Maybe<UpsertWorkspaceTemplatePayload>;
  useArtifact?: Maybe<UseArtifactPayload>;
  viewView?: Maybe<ViewViewPayload>;
};


export type MutationAckJobSetItemArgs = {
  input: AckJobSetItemInput;
};


export type MutationAckRunQueueItemArgs = {
  input: AckRunQueueItemInput;
};


export type MutationAddAliasesArgs = {
  input: AddAliasesInput;
};


export type MutationAddFilesArgs = {
  input: AddFilesInput;
};


export type MutationAddProjectProtectedAliasesArgs = {
  input: AddProjectProtectedAliasesInput;
};


export type MutationAddProtectedAliasesArgs = {
  input: AddProtectedAliasesInput;
};


export type MutationAddPublicQueueLaunchAgentTeamConfigArgs = {
  input: AddPublicQueueLaunchAgentTeamConfigInput;
};


export type MutationAddRolePermissionsArgs = {
  input: AddRolePermissionsInput;
};


export type MutationAddUserToOrganizationArgs = {
  input: AddUserToOrganizationInput;
};


export type MutationAddWorkflowsAdminArgs = {
  input: AddWorkflowsAdminInput;
};


export type MutationAgentHeartbeatArgs = {
  input: AgentHeartbeatInput;
};


export type MutationAttachCustomerPaymentMethodArgs = {
  input: AttachCustomerPaymentMethodInput;
};


export type MutationCancelCustomerSubscriptionArgs = {
  input: CancelCustomerSubscriptionInput;
};


export type MutationClaimAnonymousEntityArgs = {
  input: ClaimAnonymousEntityInput;
};


export type MutationCloneProjectsArgs = {
  input: CloneProjectsInput;
};


export type MutationCommitArtifactArgs = {
  input: CommitArtifactInput;
};


export type MutationCompleteMultipartUploadArtifactArgs = {
  input: CompleteMultipartUploadArtifactInput;
};


export type MutationContactUsForComputeHoursArgs = {
  input: ContactUsForComputeHoursInput;
};


export type MutationContactUsForUserLedTrialArgs = {
  input: ContactUsForUserLedTrialInput;
};


export type MutationCreateAwsExternalIdArgs = {
  input: CreateAwsExternalIdInput;
};


export type MutationCreateAcademicOrReverseTrialArgs = {
  input: CreateAcademicOrReverseTrialInput;
};


export type MutationCreateAccessTokenArgs = {
  input: CreateAccessTokenInput;
};


export type MutationCreateAgentArgs = {
  input: CreateAgentInput;
};


export type MutationCreateAlertThresholdArgs = {
  input: CreateAlertThresholdInput;
};


export type MutationCreateAndLinkWeaveAssetArgs = {
  input: CreateAndLinkWeaveAssetInput;
};


export type MutationCreateAnonymousEntityArgs = {
  input: CreateAnonymousEntityInput;
};


export type MutationCreateArtifactArgs = {
  input: CreateArtifactInput;
};


export type MutationCreateArtifactCollectionTagAssignmentsArgs = {
  input: CreateArtifactCollectionTagAssignmentsInput;
};


export type MutationCreateArtifactFilesArgs = {
  input: CreateArtifactFilesInput;
};


export type MutationCreateArtifactManifestArgs = {
  input: CreateArtifactManifestInput;
};


export type MutationCreateArtifactPortfolioArgs = {
  input: CreateArtifactPortfolioInput;
};


export type MutationCreateArtifactSequenceArgs = {
  input: CreateArtifactSequenceInput;
};


export type MutationCreateArtifactTagAssignmentsArgs = {
  input: CreateArtifactTagAssignmentsInput;
};


export type MutationCreateArtifactTypeArgs = {
  input: CreateArtifactTypeInput;
};


export type MutationCreateArtifactTypesArgs = {
  input: CreateArtifactTypesInput;
};


export type MutationCreateBenchmarkDiscussionCommentArgs = {
  input: CreateBenchmarkDiscussionCommentInput;
};


export type MutationCreateBenchmarkDiscussionThreadArgs = {
  input: CreateBenchmarkDiscussionThreadInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateClientIdMappingArgs = {
  input: CreateClientIdMappingInput;
};


export type MutationCreateCustomChartArgs = {
  input: CreateCustomChartInput;
};


export type MutationCreateCustomerSubscriptionArgs = {
  input: CreateCustomerSubscriptionInput;
};


export type MutationCreateCustomerTrialArgs = {
  input: CreateCustomerTrialInput;
};


export type MutationCreateDefaultResourceConfigArgs = {
  input: CreateDefaultResourceConfigInput;
};


export type MutationCreateEmailSubscriptionArgs = {
  input: CreateEmailSubscriptionInput;
};


export type MutationCreateEntityArgs = {
  input: CreateEntityInput;
};


export type MutationCreateExperimentArgs = {
  input: CreateExperimentInput;
};


export type MutationCreateFilterTriggerArgs = {
  input: CreateFilterTriggerInput;
};


export type MutationCreateFinishedRunAlertArgs = {
  input: CreateFinishedRunAlertInput;
};


export type MutationCreateGenericWebhookIntegrationArgs = {
  input: CreateGenericWebhookIntegrationInput;
};


export type MutationCreateGitHubOAuthIntegrationArgs = {
  input: CreateGitHubOAuthIntegrationInput;
};


export type MutationCreateGlueTaskArgs = {
  input: CreateGlueTaskInput;
};


export type MutationCreateHourOverageSubscriptionArgs = {
  input: CreateHourOverageSubscriptionInput;
};


export type MutationCreateInferenceSubscriptionArgs = {
  input: CreateInferenceSubscriptionInput;
};


export type MutationCreateInviteArgs = {
  input: CreateInviteInput;
};


export type MutationCreateLaunchAgentArgs = {
  input: CreateLaunchAgentInput;
};


export type MutationCreateLocalLicenseOrganizationArgs = {
  input: CreateLocalLicenseOrganizationInput;
};


export type MutationCreateNewsletterSubscriptionArgs = {
  input: CreateNewsletterSubscriptionInput;
};


export type MutationCreateOAuthProviderArgs = {
  input: CreateOAuthProviderInput;
};


export type MutationCreateOrgServiceAccountArgs = {
  input: CreateOrgServiceAccountInput;
};


export type MutationCreatePreviewableLinkArgs = {
  input: CreatePreviewableLinkInput;
};


export type MutationCreateProjectMembersArgs = {
  input: CreateProjectMembersInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateRunFilesArgs = {
  input: CreateRunFilesInput;
};


export type MutationCreateRunQueueArgs = {
  input: CreateRunQueueInput;
};


export type MutationCreateScriptableRunAlertArgs = {
  input: CreateScriptableRunAlertInput;
};


export type MutationCreateSemanticLegendArgs = {
  input: CreateSemanticLegendInput;
};


export type MutationCreateServiceAccountArgs = {
  input: CreateServiceAccountInput;
};


export type MutationCreateServiceAccountApiKeyArgs = {
  input: CreateServiceAccountApiKeyInput;
};


export type MutationCreateSlackChannelSubscriptionArgs = {
  input: CreateSlackChannelSubscriptionInput;
};


export type MutationCreateSlackIntegrationArgs = {
  input: CreateSlackIntegrationInput;
};


export type MutationCreateStoppedRunAlertArgs = {
  input: CreateStoppedRunAlertInput;
};


export type MutationCreateStorageSubscriptionArgs = {
  input: CreateStorageSubscriptionInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateViewCommentsAlertSubscriptionArgs = {
  input: CreateViewCommentsAlertSubscriptionInput;
};


export type MutationCreateViewDiscussionCommentArgs = {
  input: CreateViewDiscussionCommentInput;
};


export type MutationDeleteAlertArgs = {
  input: DeleteAlertInput;
};


export type MutationDeleteAlertSubscriptionArgs = {
  input: DeleteAlertSubscriptionInput;
};


export type MutationDeleteAlertThresholdArgs = {
  input: DeleteAlertThresholdInput;
};


export type MutationDeleteAliasesArgs = {
  input: DeleteAliasesInput;
};


export type MutationDeleteApiKeyArgs = {
  input: DeleteApiKeyInput;
};


export type MutationDeleteArtifactArgs = {
  input: DeleteArtifactInput;
};


export type MutationDeleteArtifactCollectionTagAssignmentsArgs = {
  input: DeleteArtifactCollectionTagAssignmentsInput;
};


export type MutationDeleteArtifactEntityTtlArgs = {
  input: DeleteArtifactEntityTtlInput;
};


export type MutationDeleteArtifactPortfolioArgs = {
  input: DeleteArtifactPortfolioInput;
};


export type MutationDeleteArtifactSequenceArgs = {
  input: DeleteArtifactSequenceInput;
};


export type MutationDeleteArtifactTagAssignmentsArgs = {
  input: DeleteArtifactTagAssignmentsInput;
};


export type MutationDeleteCustomChartArgs = {
  input: DeleteCustomChartInput;
};


export type MutationDeleteDefaultResourceConfigsArgs = {
  input: DeleteDefaultResourceConfigsInput;
};


export type MutationDeleteDiscussionCommentArgs = {
  input: DeleteDiscussionCommentInput;
};


export type MutationDeleteExperimentArgs = {
  input: DeleteExperimentInput;
};


export type MutationDeleteFilesArgs = {
  input: DeleteFilesInput;
};


export type MutationDeleteFilesByRunAndFolderArgs = {
  input: DeleteFilesByRunAndFolderInput;
};


export type MutationDeleteFromRunQueueArgs = {
  input: DeleteFromRunQueueInput;
};


export type MutationDeleteGlueTaskArgs = {
  input: DeleteGlueTaskInput;
};


export type MutationDeleteIntegrationArgs = {
  input: DeleteIntegrationInput;
};


export type MutationDeleteInviteArgs = {
  input: DeleteInviteInput;
};


export type MutationDeleteLaunchAgentsArgs = {
  input: DeleteLaunchAgentsInput;
};


export type MutationDeleteModelArgs = {
  input: DeleteModelInput;
};


export type MutationDeleteOAuthProviderArgs = {
  input: DeleteOAuthProviderInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeleteOrganizationSubscriptionArgs = {
  input: DeleteOrganizationSubscriptionInput;
};


export type MutationDeleteProjectMembersArgs = {
  input: DeleteProjectMembersInput;
};


export type MutationDeletePublicQueueLaunchAgentTeamConfigArgs = {
  input: DeletePublicQueueLaunchAgentTeamConfigInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationDeleteRolePermissionsArgs = {
  input: DeleteRolePermissionsInput;
};


export type MutationDeleteRunArgs = {
  input: DeleteRunInput;
};


export type MutationDeleteRunQueuesArgs = {
  input: DeleteRunQueuesInput;
};


export type MutationDeleteRunsArgs = {
  input: DeleteRunsInput;
};


export type MutationDeleteSecretArgs = {
  input: DeleteSecretInput;
};


export type MutationDeleteServiceAccountArgs = {
  input: DeleteServiceAccountInput;
};


export type MutationDeleteServiceAccountApiKeyArgs = {
  input: DeleteServiceAccountApiKeyInput;
};


export type MutationDeleteSweepArgs = {
  input: DeleteSweepInput;
};


export type MutationDeleteSweepsArgs = {
  input: DeleteSweepsInput;
};


export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationDeleteTriggerArgs = {
  input: DeleteTriggerInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteUserEmailArgs = {
  input: DeleteUserEmailInput;
};


export type MutationDeleteViewArgs = {
  input: DeleteViewInput;
};


export type MutationDeleteViewsArgs = {
  input: DeleteViewsInput;
};


export type MutationDeleteWorkflowsAdminArgs = {
  input: DeleteWorkflowsAdminInput;
};


export type MutationDeleteWorkspaceTemplateArgs = {
  input: DeleteWorkspaceTemplateInput;
};


export type MutationDetachCustomerPaymentMethodArgs = {
  input: DetachCustomerPaymentMethodInput;
};


export type MutationDisableGlueTaskArgs = {
  input: DisableGlueTaskInput;
};


export type MutationDisableOldTrackingSubscriptionArgs = {
  input: DisableOldTrackingSubscriptionInput;
};


export type MutationEnableGlueTaskArgs = {
  input: EnableGlueTaskInput;
};


export type MutationEnsureInferenceOverageSubscriptionArgs = {
  input: EnsureInferenceOverageSubscriptionInput;
};


export type MutationFailRunQueueItemArgs = {
  input: FailRunQueueItemInput;
};


export type MutationForceCleanArtifactStorageStatsArgs = {
  input: ForceCleanArtifactStorageStatsInput;
};


export type MutationForceCleanRunStorageStatsArgs = {
  input: ForceCleanRunStorageStatsInput;
};


export type MutationGenerateApiKeyArgs = {
  input: GenerateApiKeyInput;
};


export type MutationGenerateLocalLicenseArgs = {
  input: GenerateLocalLicenseInput;
};


export type MutationInsertGalleryDiscussionArgs = {
  input: InsertGalleryDiscussionInput;
};


export type MutationInsertSecretArgs = {
  input: InsertSecretInput;
};


export type MutationLeaseJobSetItemArgs = {
  input: LeaseJobSetItemInput;
};


export type MutationLinkArtifactArgs = {
  input: LinkArtifactInput;
};


export type MutationLinkTeamToOrganizationArgs = {
  input: LinkTeamToOrganizationInput;
};


export type MutationMakeOrgMembersNoAccessModelsSeatArgs = {
  input: MakeOrgMembersNoAccessModelsSeatInput;
};


export type MutationMigrateOldHourOverageSubscriptionArgs = {
  input: MigrateOldHourOverageSubscriptionInput;
};


export type MutationMigrateOldStorageSubscriptionArgs = {
  input: MigrateOldStorageSubscriptionInput;
};


export type MutationMigrateOrPurgePersonalEntityArgs = {
  input: MigrateOrPurgePersonalEntityInput;
};


export type MutationModifyRunsArgs = {
  input: ModifyRunsInput;
};


export type MutationMoveArtifactSequenceArgs = {
  input: MoveArtifactSequenceInput;
};


export type MutationMoveHistoryForRunArgs = {
  input: MoveHistoryForRunInput;
};


export type MutationMoveProjectsArgs = {
  input: MoveProjectsInput;
};


export type MutationMoveRunsArgs = {
  input: MoveRunsInput;
};


export type MutationMoveTagArgs = {
  input: MoveTagInput;
};


export type MutationMoveTagCategoryArgs = {
  input: MoveTagCategoryInput;
};


export type MutationMoveViewArgs = {
  input: MoveViewInput;
};


export type MutationNotifyScriptableRunAlertArgs = {
  input: NotifyScriptableRunAlertInput;
};


export type MutationPopFromRunQueueArgs = {
  input: PopFromRunQueueInput;
};


export type MutationPublishBenchmarkRunArgs = {
  input: PublishBenchmarkRunInput;
};


export type MutationPurgeUserArgs = {
  input: PurgeUserInput;
};


export type MutationPushToRunQueueArgs = {
  input: PushToRunQueueInput;
};


export type MutationPushToRunQueueByNameArgs = {
  input: PushToRunQueueByNameInput;
};


export type MutationRegisterUserDeviceArgs = {
  input: RegisterUserDeviceInput;
};


export type MutationRemoveProjectProtectedAliasesArgs = {
  input: RemoveProjectProtectedAliasesInput;
};


export type MutationRemoveProtectedAliasesArgs = {
  input: RemoveProtectedAliasesInput;
};


export type MutationRemoveUserFromOrganizationArgs = {
  input: RemoveUserFromOrganizationInput;
};


export type MutationRemoveUserFromOrganizationByIdArgs = {
  input: RemoveUserFromOrganizationByIdInput;
};


export type MutationRenameProjectArgs = {
  input: RenameProjectInput;
};


export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRetryStripeOpenInvoicesByOrganizationArgs = {
  input: RetryStripeOpenInvoicesByOrganizationInput;
};


export type MutationRevokeAccessTokenArgs = {
  input: RevokeAccessTokenInput;
};


export type MutationRevokeAccessTokenEmailArgs = {
  input: RevokeAccessTokenEmailInput;
};


export type MutationRevokeClientArgs = {
  input: RevokeClientInput;
};


export type MutationRewindRunArgs = {
  input: RewindRunInput;
};


export type MutationSendRequestOrgEmailDomainVerificationArgs = {
  input: SendRequestOrgEmailDomainVerificationInput;
};


export type MutationSetDismissedBannerArgs = {
  input: SetDismissedBannerInput;
};


export type MutationSetTagColorArgs = {
  input: SetTagColorInput;
};


export type MutationStarProjectArgs = {
  input: StarProjectInput;
};


export type MutationStarRegistryArgs = {
  input: StarRegistryInput;
};


export type MutationStarViewArgs = {
  input: StarViewInput;
};


export type MutationStartExperimentArgs = {
  input: StartExperimentInput;
};


export type MutationStopExperimentArgs = {
  input: StopExperimentInput;
};


export type MutationStopRunArgs = {
  input: StopRunInput;
};


export type MutationSubmitBenchmarkRunArgs = {
  input: SubmitBenchmarkRunInput;
};


export type MutationSubmitFcNewsArgs = {
  input: SubmitFcNewsInput;
};


export type MutationTestBucketStoreConnectionArgs = {
  input: StorageBucketInfoInput;
};


export type MutationTestGenericWebhookIntegrationArgs = {
  input: TestGenericWebhookIntegrationInput;
};


export type MutationTriggerEventsExportArgs = {
  input: TriggerEventsExportInput;
};


export type MutationTriggerFlatRunsMigratorArgs = {
  input: TriggerFlatRunsMigratorInput;
};


export type MutationTriggerParquetExportArgs = {
  input: TriggerParquetExportInput;
};


export type MutationTriggerRecomputeKeysInfoArgs = {
  input: TriggerRecomputeKeysInfoInput;
};


export type MutationUndeleteRunsArgs = {
  input: UndeleteRunsInput;
};


export type MutationUndeleteUserArgs = {
  input: UndeleteUserInput;
};


export type MutationUnlinkArtifactArgs = {
  input: UnlinkArtifactInput;
};


export type MutationUnregisterUserDeviceArgs = {
  input: UnregisterUserDeviceInput;
};


export type MutationUnstarProjectArgs = {
  input: UnstarProjectInput;
};


export type MutationUnstarRegistryArgs = {
  input: UnstarRegistryInput;
};


export type MutationUnstarViewArgs = {
  input: UnstarViewInput;
};


export type MutationUpdateAccessTokenArgs = {
  input: UpdateAccessTokenInput;
};


export type MutationUpdateAccessTokenProjectsArgs = {
  input: UpdateAccessTokenProjectsInput;
};


export type MutationUpdateAlertThresholdArgs = {
  input: UpdateAlertThresholdInput;
};


export type MutationUpdateApiKeyArgs = {
  input: UpdateApiKeyInput;
};


export type MutationUpdateArtifactArgs = {
  input: UpdateArtifactInput;
};


export type MutationUpdateArtifactEntityTtlArgs = {
  input: UpdateArtifactEntityTtlInput;
};


export type MutationUpdateArtifactManifestArgs = {
  input: UpdateArtifactManifestInput;
};


export type MutationUpdateArtifactPortfolioArgs = {
  input: UpdateArtifactPortfolioInput;
};


export type MutationUpdateArtifactSequenceArgs = {
  input: UpdateArtifactSequenceInput;
};


export type MutationUpdateArtifactTypeArgs = {
  input: UpdateArtifactTypeInput;
};


export type MutationUpdateBenchmarkRunArgs = {
  input: UpdateBenchmarkRunInput;
};


export type MutationUpdateCustomChartArgs = {
  input: UpdateCustomChartInput;
};


export type MutationUpdateCustomerDefaultPaymentMethodArgs = {
  input: UpdateCustomerDefaultPaymentMethodInput;
};


export type MutationUpdateCustomerPaymentMethodArgs = {
  input: UpdateCustomerPaymentMethodInput;
};


export type MutationUpdateDefaultResourceConfigArgs = {
  input: UpdateDefaultResourceConfigInput;
};


export type MutationUpdateDiscussionCommentArgs = {
  input: UpdateDiscussionCommentInput;
};


export type MutationUpdateDiscussionThreadArgs = {
  input: UpdateDiscussionThreadInput;
};


export type MutationUpdateEntityArgs = {
  input: UpdateEntityInput;
};


export type MutationUpdateExperimentArgs = {
  input: UpdateExperimentInput;
};


export type MutationUpdateFilterTriggerArgs = {
  input: UpdateFilterTriggerInput;
};


export type MutationUpdateGenericWebhookIntegrationArgs = {
  input: UpdateGenericWebhookIntegrationInput;
};


export type MutationUpdateGlueTaskArgs = {
  input: UpdateGlueTaskInput;
};


export type MutationUpdateLaunchAgentArgs = {
  input: UpdateLaunchAgentInput;
};


export type MutationUpdateLocalLicenseArgs = {
  input: UpdateLocalLicenseInput;
};


export type MutationUpdateMemberArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateModelsSeatArgs = {
  input: UpdateModelsSeatInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationBillingUserArgs = {
  input: UpdateOrganizationBillingUserInput;
};


export type MutationUpdateOrganizationPrivacySettingsArgs = {
  input: UpdateOrganizationPrivacySettingsInput;
};


export type MutationUpdateOrganizationSubscriptionArgs = {
  input: UpdateOrganizationSubscriptionInput;
};


export type MutationUpdateOrganizationSubscriptionSeatsArgs = {
  input: UpdateOrganizationSubscriptionSeatsInput;
};


export type MutationUpdateOrganizationUserArgs = {
  input: UpdateOrganizationUserInput;
};


export type MutationUpdateOrganizationUserV2Args = {
  input: UpdateOrganizationUserV2Input;
};


export type MutationUpdateProjectMemberArgs = {
  input: UpdateProjectMemberInput;
};


export type MutationUpdateProjectTeamMemberArgs = {
  input: UpdateProjectTeamMemberInput;
};


export type MutationUpdateRampThresholdArgs = {
  input: UpdateRampThresholdInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateRunQueueArgs = {
  input: UpdateRunQueueInput;
};


export type MutationUpdateRunQueueItemWarningArgs = {
  input: UpdateRunQueueItemWarningInput;
};


export type MutationUpdateRunStateArgs = {
  input: UpdateRunStateInput;
};


export type MutationUpdateSemanticLegendArgs = {
  input: UpdateSemanticLegendInput;
};


export type MutationUpdateServiceAccountApiKeyArgs = {
  input: UpdateServiceAccountApiKeyInput;
};


export type MutationUpdateStoppedRunAlertArgs = {
  input: UpdateStoppedRunAlertInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTagCategoryArgs = {
  input: UpdateTagCategoryInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};


export type MutationUpdateUserRoleV2Args = {
  input: UpdateUserRoleV2Input;
};


export type MutationUpdateWeaveRoleArgs = {
  input: UpdateWeaveRoleInput;
};


export type MutationUpgradeCustomerSubscriptionArgs = {
  input: UpgradeCustomerSubscriptionInput;
};


export type MutationUpgradeCustomerToProPlanArgs = {
  input: UpgradeCustomerToProPlanInput;
};


export type MutationUpgradeProCustomerArgs = {
  input: UpgradeProCustomerInput;
};


export type MutationUpgradeTrialSubscriptionArgs = {
  input: UpgradeTrialSubscriptionInput;
};


export type MutationUploadPanelArgs = {
  input: UploadPanelInput;
};


export type MutationUpsertBucketArgs = {
  input: UpsertBucketInput;
};


export type MutationUpsertModelArgs = {
  input: UpsertModelInput;
};


export type MutationUpsertRunGroupArgs = {
  input: UpsertRunGroupInput;
};


export type MutationUpsertRunQueueArgs = {
  input: UpsertRunQueueInput;
};


export type MutationUpsertSharedViewArgs = {
  input: UpsertSharedViewInput;
};


export type MutationUpsertSweepArgs = {
  input: UpsertSweepInput;
};


export type MutationUpsertUserProfileViewArgs = {
  input: UpsertUserProfileViewInput;
};


export type MutationUpsertViewArgs = {
  input: UpsertViewInput;
};


export type MutationUpsertWorkspaceTemplateArgs = {
  input: UpsertWorkspaceTemplateInput;
};


export type MutationUseArtifactArgs = {
  input: UseArtifactInput;
};


export type MutationViewViewArgs = {
  input: ViewViewInput;
};

export type NewsletterSubscription = {
  __typename: 'NewsletterSubscription';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type NewsletterSubscriptionConnection = {
  __typename: 'NewsletterSubscriptionConnection';
  edges: Array<NewsletterSubscriptionEdge>;
};

export type NewsletterSubscriptionEdge = {
  __typename: 'NewsletterSubscriptionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<NewsletterSubscription>;
};

export type NoOpActionArgs = {
  __typename: 'NoOpActionArgs';
  noOp?: Maybe<Scalars['Boolean']['output']>;
};

export type NoOpTriggeredAction = {
  __typename: 'NoOpTriggeredAction';
  noOp?: Maybe<Scalars['Boolean']['output']>;
};

export type NoOpTriggeredActionInput = {
  noOp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NodeAlert = {
  __typename: 'NodeAlert';
  alertName: Scalars['String']['output'];
  alertStatus: Scalars['String']['output'];
  cluster: Scalars['String']['output'];
  clusterOrg: Scalars['String']['output'];
  description: Scalars['String']['output'];
  grafanaDashboard: Scalars['String']['output'];
  labels: Scalars['JSON']['output'];
  node: Scalars['String']['output'];
  occurrences: Scalars['JSON']['output'];
  pod: Scalars['String']['output'];
};

export type NotificationActionInput = {
  integrationID: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<AlertSeverity>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationTriggeredAction = {
  __typename: 'NotificationTriggeredAction';
  entityName: Scalars['String']['output'];
  integration: Integration;
  message?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<AlertSeverity>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NotifyScriptableRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  severity?: InputMaybe<AlertSeverity>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  waitDuration?: InputMaybe<Scalars['Duration']['input']>;
};

export type NotifyScriptableRunAlertPayload = {
  __typename: 'NotifyScriptableRunAlertPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OAuthClient = {
  __typename: 'OAuthClient';
  id: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type OAuthProvider = {
  __typename: 'OAuthProvider';
  id: Scalars['ID']['output'];
  issuerUrl: Scalars['String']['output'];
};

export enum ObservationalUnit {
  AnonymousUser = 'ANONYMOUS_USER',
  Organization = 'ORGANIZATION',
  Team = 'TEAM',
  User = 'USER'
}

export type OrgActivityTimeline = ActivityDuration & {
  __typename: 'OrgActivityTimeline';
  endAt: Scalars['DateTime']['output'];
  numActiveUsers: Scalars['Int']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type OrgDashboardActiveUsersForRangeStats = {
  __typename: 'OrgDashboardActiveUsersForRangeStats';
  allTime: Scalars['Int64']['output'];
  last3Months: Scalars['Int64']['output'];
  last6Months: Scalars['Int64']['output'];
  last7Days: Scalars['Int64']['output'];
  last12Months: Scalars['Int64']['output'];
  last30Days: Scalars['Int64']['output'];
  last90Days: Scalars['Int64']['output'];
};

export enum OrgType {
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL'
}

export type Organization = Node & {
  __typename: 'Organization';
  OAuthProviders: Array<OAuthProvider>;
  activeUsersForRange?: Maybe<OrgDashboardActiveUsersForRangeStats>;
  activity: Array<OrgActivityTimeline>;
  advancedRegistryFeatures?: Maybe<AdvancedRegistryFeatures>;
  alertThresholds: Array<AlertThreshold>;
  apiKeysConnection: OrganizationApiKeyConnection;
  artifactCollections?: Maybe<ArtifactCollectionConnection>;
  artifactSequences?: Maybe<ArtifactSequenceConnection>;
  available: Scalars['Boolean']['output'];
  billingUser?: Maybe<User>;
  coreWeaveOrganizationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dynamicConfig: DynamicConfig;
  featureFlags: Array<Maybe<FeatureFlag>>;
  firstActivity?: Maybe<Scalars['DateTime']['output']>;
  flags?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  inferenceEnterpriseSubscription?: Maybe<InferenceEnterpriseSubscription>;
  isLaunchActive: Scalars['Boolean']['output'];
  latestRuns?: Maybe<RunConnection>;
  member?: Maybe<OrganizationMember>;
  memberCount: Scalars['Int']['output'];
  members: Array<OrganizationMember>;
  name: Scalars['String']['output'];
  orgEntity?: Maybe<Entity>;
  orgType: OrgType;
  pendingInvites: Array<Invite>;
  projects?: Maybe<ProjectConnection>;
  registries?: Maybe<ProjectConnection>;
  roles: Array<Role>;
  seatAvailability: OrganizationSeatAvailability;
  serviceAccounts: Array<ServiceAccount>;
  stripeBillingInfo?: Maybe<StripeBillingInfo>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeInvoices: Array<StripeInvoice>;
  stripePaymentMethods: Array<StripePaymentMethod>;
  subscriptions: Array<OrganizationSubscription>;
  teams: Array<Entity>;
  usage: Array<UsageAggregationInterface>;
  usageTotal: Array<Scalars['Int64']['output']>;
  usedSeats: Scalars['Int']['output'];
  usedViewOnlySeats: Scalars['Int']['output'];
  views: ViewConnection;
  weaveEnterpriseSubscription?: Maybe<WeaveEnterpriseSubscription>;
};


export type OrganizationActivityArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationAlertThresholdsArgs = {
  filters?: InputMaybe<AlertThresholdFilter>;
};


export type OrganizationApiKeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationArtifactCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationArtifactSequencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationDynamicConfigArgs = {
  configId: Scalars['String']['input'];
};


export type OrganizationFeatureFlagsArgs = {
  featureKey?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
};


export type OrganizationLatestRunsArgs = {
  userID: Scalars['ID']['input'];
};


export type OrganizationMemberArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type OrganizationRegistriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationUsageArgs = {
  intervalMarkers: Array<Scalars['DateTime']['input']>;
  usageType: UsageType;
};


export type OrganizationUsageTotalArgs = {
  intervalMarkers: Array<Scalars['DateTime']['input']>;
  usageType: UsageType;
};


export type OrganizationViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationApiKeyConnection = {
  __typename: 'OrganizationApiKeyConnection';
  edges: Array<OrganizationApiKeyEdge>;
  pageInfo: PageInfo;
};

export type OrganizationApiKeyEdge = {
  __typename: 'OrganizationApiKeyEdge';
  cursor: Scalars['String']['output'];
  node: ApiKey;
};

export type OrganizationConnection = {
  __typename: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
};

export type OrganizationDataForFailedPaymentBanner = {
  __typename: 'OrganizationDataForFailedPaymentBanner';
  billingEmail: Scalars['String']['output'];
  daysUntilCancellation: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isBillingUser: Scalars['Boolean']['output'];
  isCollectionMethodACH: Scalars['Boolean']['output'];
  orgId: Scalars['Int']['output'];
  orgName: Scalars['String']['output'];
};

export type OrganizationEdge = {
  __typename: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationMember = {
  __typename: 'OrganizationMember';
  admin: Scalars['Boolean']['output'];
  daysActive?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  modelsSeat: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgID: Scalars['ID']['output'];
  photoUrl: Scalars['String']['output'];
  role: Scalars['String']['output'];
  teams?: Maybe<EntityConnection>;
  user: User;
  username: Scalars['String']['output'];
  weaveRole: Scalars['String']['output'];
};


export type OrganizationMemberDaysActiveArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationMemberTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationSeatAvailability = {
  __typename: 'OrganizationSeatAvailability';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  seats: Scalars['Int']['output'];
  viewOnlySeats: Scalars['Int']['output'];
};

export type OrganizationSubscription = {
  __typename: 'OrganizationSubscription';
  availableSeatsToPurchase: Scalars['Int']['output'];
  billingPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  billingPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Discount>;
  expansionPacks: ExpansionPackConnection;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAutomaticUpgrade: Scalars['Boolean']['output'];
  nextPlans: Array<Plan>;
  plan: Plan;
  privileges: Scalars['JSON']['output'];
  seats: Scalars['Int']['output'];
  status: OrganizationSubscriptionStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionType: OrganizationSubscriptionType;
  thresholdCrossedAt?: Maybe<Scalars['DateTime']['output']>;
  upgradedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type OrganizationSubscriptionExpansionPacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum OrganizationSubscriptionStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum OrganizationSubscriptionType {
  Academic = 'ACADEMIC',
  AcademicTrial = 'ACADEMIC_TRIAL',
  Enterprise = 'ENTERPRISE',
  FreePlan = 'FREE_PLAN',
  Local = 'LOCAL',
  ManualTrial = 'MANUAL_TRIAL',
  Stripe = 'STRIPE',
  UserLedTrial = 'USER_LED_TRIAL'
}

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParquetHistory = {
  __typename: 'ParquetHistory';
  liveData: Array<Scalars['JSON']['output']>;
  parquetUrls: Array<Scalars['String']['output']>;
};

export type PaymentMetadata = {
  __typename: 'PaymentMetadata';
  orgName?: Maybe<Scalars['String']['output']>;
  shouldUpgradeToTeams?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename: 'PaymentMethod';
  cardType?: Maybe<Scalars['String']['output']>;
  endingIn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type Plan = {
  __typename: 'Plan';
  billingInterval?: Maybe<Scalars['String']['output']>;
  defaultPrivileges: Scalars['JSON']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxSeats: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  planType: PlanType;
  planVisibility: PlanVisibility;
  stripePlanId?: Maybe<Scalars['String']['output']>;
  stripePrice?: Maybe<StripePrice>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export enum PlanType {
  HourOverage = 'HOUR_OVERAGE',
  HourUsage = 'HOUR_USAGE',
  InferenceUsage = 'INFERENCE_USAGE',
  ModelsSeats = 'MODELS_SEATS',
  Primary = 'PRIMARY',
  Reference = 'REFERENCE',
  Storage = 'STORAGE',
  WeaveIngestionCommit = 'WEAVE_INGESTION_COMMIT',
  WeaveIngestionUsage = 'WEAVE_INGESTION_USAGE'
}

export enum PlanVisibility {
  Deprecated = 'DEPRECATED',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type PopFromRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  launchAgentId?: InputMaybe<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
};

export type PopFromRunQueuePayload = {
  __typename: 'PopFromRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  runQueueItemId?: Maybe<Scalars['ID']['output']>;
  runSpec?: Maybe<Scalars['JSON']['output']>;
};

export type PreviewFriendlyUrl = {
  __typename: 'PreviewFriendlyURL';
  URL: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewID: Scalars['ID']['output'];
};

export type PreviewableLink = {
  __typename: 'PreviewableLink';
  URL: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  resourceID: Scalars['ID']['output'];
  resourceType: PreviewableLinkResourceType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PreviewableLinkResourceType {
  Entity = 'Entity',
  User = 'User',
  View = 'View'
}

export type Project = Node & {
  __typename: 'Project';
  access?: Maybe<Scalars['String']['output']>;
  allViews?: Maybe<ViewConnection>;
  allowAllArtifactTypesInRegistry: Scalars['Boolean']['output'];
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  artifactCollectionMembership?: Maybe<ArtifactCollectionMembership>;
  artifactCollections?: Maybe<ArtifactCollectionConnection>;
  artifactCollectionsSearch?: Maybe<ArtifactCollectionSearchConnection>;
  artifactMembershipsWithAliasCount: Scalars['Int']['output'];
  artifactType?: Maybe<ArtifactType>;
  artifactTypes: ArtifactTypeConnection;
  artifacts: Array<Artifact>;
  benchmarkDiscussionThreads: DiscussionThreadConnection;
  benchmarkRuns?: Maybe<BenchmarkRunConnection>;
  benchmarkSubmissions?: Maybe<BenchmarkRunConnection>;
  bucket?: Maybe<Run>;
  bucketCount?: Maybe<Scalars['Int']['output']>;
  buckets?: Maybe<RunConnection>;
  computeHours: Scalars['Duration']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultResourceConfigs?: Maybe<DefaultResourceConfigConnection>;
  description?: Maybe<Scalars['String']['output']>;
  dockerImage?: Maybe<Scalars['String']['output']>;
  entity: Entity;
  entityId?: Maybe<Scalars['Int']['output']>;
  entityName: Scalars['String']['output'];
  featured?: Maybe<Scalars['Int']['output']>;
  fields: ProjectFieldConnection;
  fromV2?: Maybe<Scalars['Boolean']['output']>;
  gitHubSubmissionRepo?: Maybe<Scalars['String']['output']>;
  groupPath?: Maybe<Scalars['String']['output']>;
  groupedRuns?: Maybe<MaybeGroupedRunConnection>;
  hasProtectedArtifact: Scalars['Boolean']['output'];
  hasRun: Scalars['Boolean']['output'];
  icon?: Maybe<ProjectIcon>;
  id: Scalars['ID']['output'];
  internalId: Scalars['ID']['output'];
  isBenchmark: Scalars['Boolean']['output'];
  isMigratedRegistryProject: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  launchAgents: Array<LaunchAgent>;
  legacyModelRegistryProject?: Maybe<Project>;
  linkedBenchmark?: Maybe<Project>;
  media?: Maybe<Scalars['String']['output']>;
  member?: Maybe<ProjectMember>;
  members: Array<ProjectMember>;
  name: Scalars['String']['output'];
  ndbId?: Maybe<Scalars['ID']['output']>;
  parameterImportance: Scalars['JSON']['output'];
  pathCounts?: Maybe<Scalars['JSONString']['output']>;
  protectedArtifactAliases: Array<ProtectedArtifactAlias>;
  public?: Maybe<Scalars['Boolean']['output']>;
  rateLimits?: Maybe<RateLimits>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  repo?: Maybe<Scalars['String']['output']>;
  requestSubscribe?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<Run>;
  runActiveCount: Scalars['Int']['output'];
  runCount: Scalars['Int']['output'];
  runFieldValues?: Maybe<RunFieldValueConnection>;
  runGroup?: Maybe<RunGroup>;
  runKeySuggestions: Array<RunKeySuggestion>;
  runOutputArtifactsCount: Scalars['Int']['output'];
  runQueue?: Maybe<RunQueue>;
  runQueues: Array<RunQueue>;
  runTags?: Maybe<RunTagConnection>;
  runs?: Maybe<RunConnection>;
  runsHaveProtectedOutputArtifacts: Scalars['Boolean']['output'];
  starred: Scalars['Boolean']['output'];
  storageBytes: Scalars['Int64']['output'];
  subGroupPath?: Maybe<Scalars['String']['output']>;
  summaryMetrics?: Maybe<Scalars['JSONString']['output']>;
  sweep?: Maybe<Sweep>;
  sweeps?: Maybe<SweepConnection>;
  tagCounts: Array<RunTagCount>;
  /** @deprecated Use runTags instead */
  tags: Array<RunTag>;
  teamMembers: Array<ProjectTeamMember>;
  totalArtifactCollections: Scalars['Int']['output'];
  /** @deprecated Use computeHours instead */
  totalRunTime?: Maybe<Scalars['Float']['output']>;
  totalRuns?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  totalRunsWithGroup: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  totalRunsWithJobType: Scalars['Int']['output'];
  totalSweeps: Scalars['Int']['output'];
  totalUsers?: Maybe<Scalars['Int']['output']>;
  triggerExecutions: TriggerExecutionConnection;
  triggers: Array<Trigger>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  valueCounts?: Maybe<Scalars['JSONString']['output']>;
  views?: Maybe<Scalars['JSONString']['output']>;
  weavePermissions: ProjectPermissions;
};


export type ProjectAllViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  viewName?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectArtifactArgs = {
  enableTracking?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type ProjectArtifactCollectionArgs = {
  name: Scalars['String']['input'];
};


export type ProjectArtifactCollectionMembershipArgs = {
  name: Scalars['String']['input'];
};


export type ProjectArtifactCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectArtifactCollectionsSearchArgs = {
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectArtifactMembershipsWithAliasCountArgs = {
  alias: Scalars['String']['input'];
};


export type ProjectArtifactTypeArgs = {
  name: Scalars['String']['input'];
};


export type ProjectArtifactTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectArtifactsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectBenchmarkDiscussionThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectBenchmarkRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  state: Scalars['String']['input'];
};


export type ProjectBenchmarkSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectBucketArgs = {
  desc?: InputMaybe<Scalars['String']['input']>;
  missingOk?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type ProjectBucketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectDefaultResourceConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ProjectGroupedRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupAggregation?: InputMaybe<GroupAggregation>;
  groupKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupLevel?: InputMaybe<Scalars['Int']['input']>;
  historyFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectMemberArgs = {
  id: Scalars['ID']['input'];
};


export type ProjectParameterImportanceArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
  runParameters?: InputMaybe<Array<Scalars['String']['input']>>;
  target: Scalars['String']['input'];
};


export type ProjectPathCountsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectRunArgs = {
  desc?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type ProjectRunActiveCountArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectRunCountArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectRunFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyPath: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  valuePattern?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectRunGroupArgs = {
  name: Scalars['String']['input'];
};


export type ProjectRunKeySuggestionsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  keyPath: Scalars['String']['input'];
};


export type ProjectRunOutputArtifactsCountArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectRunQueueArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectRunTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupAggregation?: InputMaybe<GroupAggregation>;
  groupKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupLevel?: InputMaybe<Scalars['Int']['input']>;
  historyFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectRunsHaveProtectedOutputArtifactsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectStarredArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type ProjectSweepArgs = {
  sweepName: Scalars['String']['input'];
};


export type ProjectSweepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectTagCountsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectTotalArtifactCollectionsArgs = {
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
};


export type ProjectTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectOnly?: InputMaybe<Scalars['Boolean']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type ProjectTriggersArgs = {
  projectOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectValueCountsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  keyPath?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectConnection = {
  __typename: 'ProjectConnection';
  edges: Array<ProjectEdge>;
  pageInfo: PageInfo;
};

export type ProjectEdge = {
  __typename: 'ProjectEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Project>;
};

export type ProjectField = {
  __typename: 'ProjectField';
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectFieldConnection = {
  __typename: 'ProjectFieldConnection';
  edges: Array<ProjectFieldEdge>;
  pageInfo: PageInfo;
};

export type ProjectFieldEdge = {
  __typename: 'ProjectFieldEdge';
  cursor: Scalars['String']['output'];
  node: ProjectField;
};

export type ProjectIcon = {
  __typename: 'ProjectIcon';
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProjectIconInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ProjectIdentifierInput = {
  EntityName?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectMember = {
  __typename: 'ProjectMember';
  accountType: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  projectRoleIsInherited: Scalars['Boolean']['output'];
  role: Role;
  username?: Maybe<Scalars['String']['output']>;
};

export type ProjectPermissions = {
  __typename: 'ProjectPermissions';
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  hasProjectReadPermission: Scalars['Boolean']['output'];
};

export type ProjectSpecifier = {
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type ProjectStorageNode = StorageTreeNode & {
  __typename: 'ProjectStorageNode';
  artifactSequences: ArtifactSequenceStorageNodeConnection;
  artifactTypes: Array<ArtifactTypeStorageNode>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  projectID: Scalars['ID']['output'];
  runs: RunStorageNodeConnection;
  size: Scalars['Int64']['output'];
};


export type ProjectStorageNodeArtifactSequencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectStorageNodeArtifactTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectStorageNodeRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectStorageNodeConnection = {
  __typename: 'ProjectStorageNodeConnection';
  edges: Array<ProjectStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type ProjectStorageNodeEdge = {
  __typename: 'ProjectStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: ProjectStorageNode;
};

export type ProjectTeamMember = {
  __typename: 'ProjectTeamMember';
  role: Role;
  team: Entity;
};

export type ProtectedArtifactAlias = {
  __typename: 'ProtectedArtifactAlias';
  alias: Scalars['String']['output'];
  projectID: Scalars['ID']['output'];
};

export type PublicImageUploadInfo = {
  __typename: 'PublicImageUploadInfo';
  imageUrl: Scalars['String']['output'];
  uploadHeaders: Array<Scalars['String']['output']>;
  uploadUrl: Scalars['String']['output'];
};

export type PublishBenchmarkRunInput = {
  benchmarkEntityName?: InputMaybe<Scalars['String']['input']>;
  benchmarkName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCodeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublishBenchmarkRunPayload = {
  __typename: 'PublishBenchmarkRunPayload';
  benchmarkRun: BenchmarkRun;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type PurgeUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type PurgeUserPayload = {
  __typename: 'PurgeUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type PushNotificationActionArgs = {
  __typename: 'PushNotificationActionArgs';
  body?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type PushNotificationActionInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['ID']['input'];
};

export type PushNotificationTriggeredAction = {
  __typename: 'PushNotificationTriggeredAction';
  body?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type PushToRunQueueByNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
  runSpec: Scalars['JSONString']['input'];
  templateVariableValues?: InputMaybe<Scalars['JSONString']['input']>;
};

export type PushToRunQueueByNamePayload = {
  __typename: 'PushToRunQueueByNamePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  runQueueItemId: Scalars['ID']['output'];
  runSpec: Scalars['JSONString']['output'];
};

export type PushToRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  queueID: Scalars['ID']['input'];
  runSpec: Scalars['JSONString']['input'];
  templateVariableValues?: InputMaybe<Scalars['JSONString']['input']>;
};

export type PushToRunQueuePayload = {
  __typename: 'PushToRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  runQueueItemId: Scalars['ID']['output'];
  runSpec: Scalars['JSONString']['output'];
};

export type Query = {
  __typename: 'Query';
  activeExperiments: Array<ActiveExperiment>;
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  artifactSequence?: Maybe<ArtifactSequence>;
  benchmarks?: Maybe<ProjectConnection>;
  checkoutPreview?: Maybe<CheckoutPreview>;
  clientIDMapping?: Maybe<ClientIdMapping>;
  coupon?: Maybe<Coupon>;
  customChart?: Maybe<CustomChart>;
  customCharts?: Maybe<CustomChartConnection>;
  dataFrame?: Maybe<RowConnection>;
  dataFrameSchema: Array<Scalars['JSON']['output']>;
  discussionComment?: Maybe<DiscussionComment>;
  discussionThread?: Maybe<DiscussionThread>;
  dismissedBanner?: Maybe<DismissedBanner>;
  entities?: Maybe<EntityConnection>;
  entity?: Maybe<Entity>;
  experiments: Array<Experiment>;
  failedPaymentBanners?: Maybe<FailedPaymentBanners>;
  featuredReports?: Maybe<View>;
  galleryTagSections: Scalars['JSONString']['output'];
  glueManager?: Maybe<GlueManager>;
  glueRuns?: Maybe<GlueRunConnection>;
  highQualityUserProfiles?: Maybe<View>;
  invite?: Maybe<Invite>;
  jobSetDiff?: Maybe<JobSetDiff>;
  launchAgent?: Maybe<LaunchAgent>;
  localLicenses: Array<Maybe<LocalLicense>>;
  /** @deprecated use project */
  model?: Maybe<Project>;
  models?: Maybe<ProjectConnection>;
  newsletterSubscriptions?: Maybe<NewsletterSubscriptionConnection>;
  numPendingInvites: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizations: OrganizationConnection;
  plans: Array<Maybe<Plan>>;
  /** @deprecated Use previewableLink instead */
  previewFriendlyURL?: Maybe<PreviewFriendlyUrl>;
  previewableLink?: Maybe<PreviewableLink>;
  project?: Maybe<Project>;
  projects?: Maybe<ProjectConnection>;
  publicImageUploadUrl?: Maybe<PublicImageUploadInfo>;
  publicViews?: Maybe<ViewConnection>;
  publishedProjects?: Maybe<ProjectConnection>;
  rampManager?: Maybe<RampManager>;
  repo?: Maybe<Repo>;
  repoInsightsPlotData?: Maybe<RepoInsightsRowConnection>;
  reportSearch?: Maybe<ViewConnection>;
  runs: RunsResult;
  serverInfo?: Maybe<ServerInfo>;
  singletonView?: Maybe<View>;
  tag?: Maybe<Tag>;
  task?: Maybe<Task>;
  trendingRepos?: Maybe<RowConnection>;
  triggerExecutions: TriggerExecutionConnection;
  /**
   * Returns available template variables for automations.
   *
   * Template variables are placeholders like "${artifact_version}" that are replaced
   * with actual values when the automation action is executed.
   *
   * If no event type is provided, all available template variables are returned.
   */
  triggerTemplateVariables: Array<TriggerTemplateVariable>;
  usage: Array<UsageAggregationInterface>;
  user?: Maybe<User>;
  users?: Maybe<UserConnection>;
  view?: Maybe<View>;
  viewParent?: Maybe<View>;
  viewer?: Maybe<User>;
  views?: Maybe<ViewConnection>;
  weaveSavingsCalculator?: Maybe<WeaveSavingsCalculator>;
  workspaceTemplates: Array<WorkspaceTemplate>;
};


export type QueryArtifactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtifactCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtifactSequenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBenchmarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckoutPreviewArgs = {
  couponID?: InputMaybe<Scalars['String']['input']>;
  isMonthly?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfModelsSeat: Scalars['Int']['input'];
  organizationID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
};


export type QueryClientIdMappingArgs = {
  clientID: Scalars['ID']['input'];
};


export type QueryCouponArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomChartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomChartsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDataFrameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  dataFrameKeys: Array<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
};


export type QueryDataFrameSchemaArgs = {
  dataFrameKeys: Array<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};


export type QueryDiscussionCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiscussionThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDismissedBannerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEntityArgs = {
  login?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFailedPaymentBannersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlueRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  taskID: Scalars['ID']['input'];
};


export type QueryInviteArgs = {
  key: Scalars['String']['input'];
};


export type QueryJobSetDiffArgs = {
  agentID: Scalars['ID']['input'];
  fromVersion?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  selector?: InputMaybe<JobSetSelectorInput>;
};


export type QueryLaunchAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocalLicensesArgs = {
  expired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryModelArgs = {
  entityName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keysOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewsletterSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryOrg?: InputMaybe<Scalars['String']['input']>;
  querySubId?: InputMaybe<Scalars['String']['input']>;
  queryTeam?: InputMaybe<Scalars['String']['input']>;
  queryUser?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewFriendlyUrlArgs = {
  viewID: Scalars['ID']['input'];
};


export type QueryPreviewableLinkArgs = {
  resourceID: Scalars['ID']['input'];
  resourceType: PreviewableLinkResourceType;
};


export type QueryProjectArgs = {
  entityName?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  internalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  projectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPublicViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublishedProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRepoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRepoInsightsPlotDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  plotName: Scalars['String']['input'];
  repoName: Scalars['String']['input'];
};


export type QueryReportSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryRunsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySingletonViewArgs = {
  type: Scalars['String']['input'];
};


export type QueryTagArgs = {
  entityName?: InputMaybe<Scalars['String']['input']>;
  tag: QueryTagInput;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrendingReposArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID: Scalars['ID']['input'];
};


export type QueryTriggerTemplateVariablesArgs = {
  eventType?: InputMaybe<EventTriggeringConditionType>;
};


export type QueryUsageArgs = {
  intervalMarkers: Array<Scalars['DateTime']['input']>;
  usageType: UsageType;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryEmail?: InputMaybe<Scalars['String']['input']>;
  usernames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryViewArgs = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryViewParentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryViewerArgs = {
  entityName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryViewsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryWeaveSavingsCalculatorArgs = {
  organizationID: Scalars['ID']['input'];
};


export type QueryWorkspaceTemplatesArgs = {
  entityId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTagInput = {
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
  tagName: Scalars['String']['input'];
};

export type QueueJobActionArgs = {
  __typename: 'QueueJobActionArgs';
  priority?: Maybe<Scalars['Int']['output']>;
  runSpec?: Maybe<Scalars['JSON']['output']>;
};

export type QueueJobActionInput = {
  queueID: Scalars['ID']['input'];
  template: Scalars['JSONString']['input'];
};

export type QueueJobTriggeredAction = {
  __typename: 'QueueJobTriggeredAction';
  queue?: Maybe<RunQueue>;
  template: Scalars['JSONString']['output'];
};

export type QueuedJobTriggerResultDetails = {
  __typename: 'QueuedJobTriggerResultDetails';
  error?: Maybe<TriggerExecutionError>;
  runQueueItemID?: Maybe<Scalars['ID']['output']>;
};

export enum RampIdType {
  ApiKey = 'ApiKey',
  CustomId = 'CustomID',
  EntityId = 'EntityID',
  EntityName = 'EntityName',
  None = 'None',
  OrgId = 'OrgID',
  OrgName = 'OrgName',
  ProjectId = 'ProjectID',
  UserId = 'UserID',
  UserName = 'UserName'
}

export type RampManager = {
  __typename: 'RampManager';
  setting?: Maybe<RampSettingEdge>;
  settings: RampSettingConnection;
};


export type RampManagerSettingArgs = {
  name: Scalars['String']['input'];
};

export type RampSettingConnection = {
  __typename: 'RampSettingConnection';
  edges: Array<RampSettingEdge>;
};

export type RampSettingEdge = {
  __typename: 'RampSettingEdge';
  description: Scalars['String']['output'];
  group: Scalars['String']['output'];
  idIsRamped: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rampIDType: RampIdType;
  rampType: RampType;
  stores: Array<RampThresholdStore>;
};


export type RampSettingEdgeIdIsRampedArgs = {
  id: Scalars['String']['input'];
};

export type RampSettingThreshold = {
  __typename: 'RampSettingThreshold';
  checkId: Scalars['String']['output'];
  displayCheckID: Scalars['String']['output'];
  threshold: Scalars['Float']['output'];
};

export type RampThresholdStore = {
  __typename: 'RampThresholdStore';
  name: Scalars['String']['output'];
  thresholds: Array<RampSettingThreshold>;
};

export enum RampType {
  Backend = 'Backend',
  FrontendBetaFlag = 'FrontendBetaFlag',
  FrontendFeatureFlag = 'FrontendFeatureFlag',
  Statsig = 'Statsig'
}

export type RateLimits = {
  __typename: 'RateLimits';
  createArtifacts: Scalars['Int']['output'];
  createArtifactsTimeWindow: Scalars['Int']['output'];
  filestreamCount: Scalars['Float']['output'];
  filestreamPerRunCount: Scalars['Float']['output'];
  filestreamSize: Scalars['Int']['output'];
  graphql: Scalars['Int']['output'];
  runUpdateCount: Scalars['Float']['output'];
  sdkGraphql: Scalars['Int']['output'];
  sdkGraphqlQuerySeconds: Scalars['Float']['output'];
};

export type RateLimitsInput = {
  createArtifacts?: InputMaybe<Scalars['Int']['input']>;
  createArtifactsTimeWindow?: InputMaybe<Scalars['Int']['input']>;
  filestreamCount?: InputMaybe<Scalars['Float']['input']>;
  filestreamPerRunCount?: InputMaybe<Scalars['Float']['input']>;
  filestreamSize?: InputMaybe<Scalars['Int']['input']>;
  graphql?: InputMaybe<Scalars['Int']['input']>;
  runUpdateCount?: InputMaybe<Scalars['Float']['input']>;
  sdkGraphql?: InputMaybe<Scalars['Int']['input']>;
  sdkGraphqlQuerySeconds?: InputMaybe<Scalars['Float']['input']>;
};

/** Input payload for registering a device for push notifications. */
export type RegisterUserDeviceInput = {
  /** The device's human-readable name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The device platform. */
  platform: DevicePlatform;
  /** The device token to register. */
  token: Scalars['String']['input'];
};

/** Response payload from registering a device for push notifications. */
export type RegisterUserDevicePayload = {
  __typename: 'RegisterUserDevicePayload';
  /** The registered device. */
  device: UserDevice;
};

export type RemoveProjectProtectedAliasesInput = {
  aliases: Array<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type RemoveProjectProtectedAliasesPayload = {
  __typename: 'RemoveProjectProtectedAliasesPayload';
  aliases: Array<Scalars['String']['output']>;
};

export type RemoveProtectedAliasesInput = {
  adminType: WorkflowsAdminType;
  aliases: Array<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
};

export type RemoveProtectedAliasesPayload = {
  __typename: 'RemoveProtectedAliasesPayload';
  aliases: Array<Scalars['String']['output']>;
};

export type RemoveUserFromOrganizationByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveUserFromOrganizationByIdPayload = {
  __typename: 'RemoveUserFromOrganizationByIdPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveUserFromOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
};

export type RemoveUserFromOrganizationPayload = {
  __typename: 'RemoveUserFromOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RenameProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  newProjectName: Scalars['String']['input'];
  oldProjectName: Scalars['String']['input'];
};

export type Repo = Node & {
  __typename: 'Repo';
  displayName: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
};

export type RepoConnection = {
  __typename: 'RepoConnection';
  edges: Array<RepoEdge>;
};

export type RepoEdge = {
  __typename: 'RepoEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Repo>;
};

export type RepoInsightsRowConnection = {
  __typename: 'RepoInsightsRowConnection';
  edges: Array<RowEdge>;
  isNormalizedUserCount: Scalars['Boolean']['output'];
  pageInfo: PageInfo;
  schema: Scalars['JSON']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ResendEmailVerificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type ResendEmailVerificationPayload = {
  __typename: 'ResendEmailVerificationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type ResetPasswordPayload = {
  __typename: 'ResetPasswordPayload';
  success: Scalars['Boolean']['output'];
};

export type RetryStripeOpenInvoicesByOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type RetryStripeOpenInvoicesByOrganizationPayload = {
  __typename: 'RetryStripeOpenInvoicesByOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RevokeAccessTokenEmailInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RevokeAccessTokenEmailPayload = {
  __typename: 'RevokeAccessTokenEmailPayload';
  accessToken: AccessToken;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RevokeAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type RevokeAccessTokenPayload = {
  __typename: 'RevokeAccessTokenPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RevokeClientInput = {
  clientId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
};

export type RevokeClientPayload = {
  __typename: 'RevokeClientPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RewindRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  metricName: Scalars['String']['input'];
  metricValue: Scalars['Float']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
};

export type RewindRunPayload = {
  __typename: 'RewindRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rewoundRun?: Maybe<Run>;
};

export type Role = {
  __typename: 'Role';
  ID: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  inheritedFrom?: Maybe<Role>;
  name: Scalars['String']['output'];
  permissions: Array<RolePermission>;
};

export type RolePermission = {
  __typename: 'RolePermission';
  displayName: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RowConnection = {
  __typename: 'RowConnection';
  edges: Array<RowEdge>;
  pageInfo: PageInfo;
  schema: Scalars['JSON']['output'];
  totalCount: Scalars['Int']['output'];
};

export type RowEdge = {
  __typename: 'RowEdge';
  node?: Maybe<RowType>;
};

export type RowType = {
  __typename: 'RowType';
  row: Scalars['JSON']['output'];
};

export type Run = BucketType & Node & {
  __typename: 'Run';
  agent?: Maybe<Agent>;
  aggregations?: Maybe<Scalars['JSON']['output']>;
  artifactLineageDag?: Maybe<ArtifactLineageDag>;
  benchmarkRun?: Maybe<BenchmarkRun>;
  branchPoint?: Maybe<RunBranchPoint>;
  bucketedHistory: Array<Scalars['JSON']['output']>;
  codeArtifact?: Maybe<Artifact>;
  commit?: Maybe<Scalars['String']['output']>;
  computeSeconds: Scalars['Duration']['output'];
  config?: Maybe<Scalars['JSONString']['output']>;
  coreweaveGrafanaDashboard: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  debug?: Maybe<Scalars['Boolean']['output']>;
  defaultColorIndex?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  events: Array<Scalars['String']['output']>;
  eventsLineCount?: Maybe<Scalars['Int']['output']>;
  eventsTail?: Maybe<Scalars['JSONString']['output']>;
  exampleTable?: Maybe<Scalars['JSONString']['output']>;
  exampleTableColumns?: Maybe<Scalars['JSONString']['output']>;
  exampleTableTypes?: Maybe<Scalars['JSONString']['output']>;
  exitcode?: Maybe<Scalars['Float']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  fileCount?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<FileConnection>;
  folders?: Maybe<Folders>;
  framework?: Maybe<Scalars['String']['output']>;
  github?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  groupCounts?: Maybe<Array<Scalars['Int']['output']>>;
  hasProtectedOutputArtifact: Scalars['Boolean']['output'];
  heartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  history: Array<Scalars['String']['output']>;
  historyKeys?: Maybe<Scalars['JSON']['output']>;
  historyLineCount?: Maybe<Scalars['Int']['output']>;
  historyMaterializationTask?: Maybe<Task>;
  historyTail?: Maybe<Scalars['JSONString']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputArtifacts?: Maybe<InputArtifactConnection>;
  internalID?: Maybe<Scalars['ID']['output']>;
  job?: Maybe<Artifact>;
  jobId?: Maybe<Scalars['Int']['output']>;
  jobType?: Maybe<Scalars['String']['output']>;
  lines: Array<Scalars['JSON']['output']>;
  logLineCount?: Maybe<Scalars['Int']['output']>;
  logLines?: Maybe<LogLineConnection>;
  metricSearch?: Maybe<MetricSearchResults>;
  metricStatistics?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Project>;
  name: Scalars['String']['output'];
  ndbId?: Maybe<Scalars['ID']['output']>;
  nodeAlertsHistory: Array<NodeAlert>;
  notes?: Maybe<Scalars['String']['output']>;
  outputArtifacts?: Maybe<ArtifactConnection>;
  parquetHistory: ParquetHistory;
  patch?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  requestSubscribe?: Maybe<Scalars['Boolean']['output']>;
  runInfo?: Maybe<RunInfo>;
  running?: Maybe<Scalars['Boolean']['output']>;
  sampledHistory: Array<Scalars['JSON']['output']>;
  servicesAvailable?: Maybe<RunServicesAvailable>;
  shouldStop?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stepsForMetricValues: Array<Maybe<Scalars['Int']['output']>>;
  stopped?: Maybe<Scalars['Boolean']['output']>;
  storageBytes: Scalars['Int64']['output'];
  summaryMetrics?: Maybe<Scalars['JSONString']['output']>;
  sweep?: Maybe<Sweep>;
  sweepName?: Maybe<Scalars['String']['output']>;
  systemMetrics?: Maybe<Scalars['JSONString']['output']>;
  tagColors: Array<RunTag>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  wandbConfig?: Maybe<Scalars['JSONString']['output']>;
};


export type RunAggregationsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RunArtifactLineageDagArgs = {
  baseGraphNodeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  directLineage?: InputMaybe<Scalars['Boolean']['input']>;
  filterGeneratedArtifacts: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  traversalDirection?: InputMaybe<TraversalDirection>;
};


export type RunBucketedHistoryArgs = {
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type RunConfigArgs = {
  dotBehavior?: InputMaybe<DotBehavior>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RunEventsArgs = {
  samples?: InputMaybe<Scalars['Int']['input']>;
};


export type RunFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type RunFoldersArgs = {
  folderPath?: InputMaybe<Scalars['String']['input']>;
};


export type RunHistoryArgs = {
  maxKeyLimit?: InputMaybe<Scalars['Int']['input']>;
  maxStep?: InputMaybe<Scalars['Int64']['input']>;
  minStep?: InputMaybe<Scalars['Int64']['input']>;
  samples?: InputMaybe<Scalars['Int']['input']>;
};


export type RunHistoryKeysArgs = {
  format?: InputMaybe<HistoryKeysFormat>;
};


export type RunInputArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type RunLinesArgs = {
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type RunLogLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  useImprovedPagination?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RunMetricSearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RunMetricStatisticsArgs = {
  metricName?: InputMaybe<Scalars['String']['input']>;
};


export type RunNodeAlertsHistoryArgs = {
  start: Scalars['DateTime']['input'];
};


export type RunOutputArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type RunParquetHistoryArgs = {
  liveKeys: Array<Scalars['String']['input']>;
};


export type RunSampledHistoryArgs = {
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type RunStepsForMetricValuesArgs = {
  metric: Scalars['String']['input'];
  values: Array<Scalars['Float']['input']>;
};


export type RunSummaryMetricsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type RunWandbConfigArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RunBranchPoint = {
  __typename: 'RunBranchPoint';
  run: Run;
  step: Scalars['Int64']['output'];
};

export type RunConnection = {
  __typename: 'RunConnection';
  configValues?: Maybe<Scalars['JSON']['output']>;
  configValuesCategories?: Maybe<Scalars['JSON']['output']>;
  configValuesNumberAggregation?: Maybe<Scalars['JSON']['output']>;
  delta: Array<RunDiff>;
  deltaOrder: Array<Scalars['ID']['output']>;
  deltas?: Maybe<BucketDiffs>;
  edges: Array<RunEdge>;
  historyKeys?: Maybe<Scalars['JSON']['output']>;
  metricSearch?: Maybe<MetricSearchResults>;
  metricStatistics?: Maybe<Scalars['JSON']['output']>;
  metricStatisticsAggregation?: Maybe<Scalars['JSON']['output']>;
  pageInfo: PageInfo;
  paths?: Maybe<Scalars['JSONString']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type RunConnectionConfigValuesArgs = {
  configKey?: InputMaybe<Scalars['String']['input']>;
  configType?: InputMaybe<Scalars['String']['input']>;
};


export type RunConnectionConfigValuesCategoriesArgs = {
  configKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RunConnectionConfigValuesNumberAggregationArgs = {
  configKey?: InputMaybe<Scalars['String']['input']>;
};


export type RunConnectionDeltaArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
};


export type RunConnectionDeltaOrderArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
};


export type RunConnectionDeltasArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};


export type RunConnectionHistoryKeysArgs = {
  format?: InputMaybe<HistoryKeysFormat>;
  includeHash?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RunConnectionMetricSearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RunConnectionMetricStatisticsArgs = {
  metricName?: InputMaybe<Scalars['String']['input']>;
};


export type RunConnectionMetricStatisticsAggregationArgs = {
  metricName?: InputMaybe<Scalars['String']['input']>;
};

export type RunDiff = {
  __typename: 'RunDiff';
  index: Scalars['Int']['output'];
  op: DiffOperation;
  run?: Maybe<Run>;
};

export type RunEdge = {
  __typename: 'RunEdge';
  cursor: Scalars['String']['output'];
  node: Run;
};

export type RunFieldValue = {
  __typename: 'RunFieldValue';
  value?: Maybe<Scalars['JSONString']['output']>;
};

export type RunFieldValueConnection = {
  __typename: 'RunFieldValueConnection';
  edges: Array<RunFieldValueEdge>;
  pageInfo: PageInfo;
};

export type RunFieldValueEdge = {
  __typename: 'RunFieldValueEdge';
  cursor: Scalars['String']['output'];
  node: RunFieldValue;
};

export type RunGroup = {
  __typename: 'RunGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  project: Project;
  tags: Array<RunTag>;
};

export type RunInfo = {
  __typename: 'RunInfo';
  args: Array<Scalars['String']['output']>;
  codePath?: Maybe<Scalars['String']['output']>;
  codePathLocal?: Maybe<Scalars['String']['output']>;
  codeSaved?: Maybe<Scalars['Boolean']['output']>;
  colab?: Maybe<Scalars['String']['output']>;
  coreweave?: Maybe<CoreweaveInfo>;
  cpuCount?: Maybe<Scalars['Int']['output']>;
  cpuCountLogical?: Maybe<Scalars['Int']['output']>;
  executable?: Maybe<Scalars['String']['output']>;
  git?: Maybe<GitInfo>;
  gpu?: Maybe<Scalars['String']['output']>;
  gpuCount?: Maybe<Scalars['Int']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  python?: Maybe<Scalars['String']['output']>;
  slurm?: Maybe<SlurmInfo>;
};

export type RunKeySuggestion = {
  __typename: 'RunKeySuggestion';
  count: Scalars['Int']['output'];
  displayValue?: Maybe<Scalars['JSONString']['output']>;
  value?: Maybe<Scalars['JSONString']['output']>;
};

export type RunMetricEventDetails = {
  __typename: 'RunMetricEventDetails';
  entityName?: Maybe<Scalars['String']['output']>;
  metricName?: Maybe<Scalars['String']['output']>;
  metricValues?: Maybe<Array<Scalars['Float']['output']>>;
  projectName?: Maybe<Scalars['String']['output']>;
  runName?: Maybe<Scalars['String']['output']>;
};

export type RunQueue = {
  __typename: 'RunQueue';
  access: RunQueueAccessType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  defaultResourceConfig?: Maybe<DefaultResourceConfig>;
  defaultResourceConfigID?: Maybe<Scalars['ID']['output']>;
  entityName: Scalars['String']['output'];
  /** @deprecated Executor state tracked in LaunchAgent.AgentStatus */
  executorInfo: Scalars['String']['output'];
  externalLinks?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  prioritizationMode: RunQueuePrioritizationMode;
  runQueueItem?: Maybe<RunQueueItem>;
  runQueueItems: RunQueueItemConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type RunQueueRunQueueItemArgs = {
  id: Scalars['ID']['input'];
};


export type RunQueueRunQueueItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum RunQueueAccessType {
  Project = 'PROJECT',
  User = 'USER'
}

export type RunQueueItem = {
  __typename: 'RunQueueItem';
  associatedRunId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<RunQueueItemInfoDetails>;
  id: Scalars['ID']['output'];
  launchAgentId?: Maybe<Scalars['ID']['output']>;
  priority: Scalars['Int']['output'];
  runSpec: Scalars['JSON']['output'];
  state: RunQueueItemState;
  templateVariableValues?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  warnings: Array<Maybe<RunQueueItemInfoDetails>>;
};

export type RunQueueItemConnection = {
  __typename: 'RunQueueItemConnection';
  edges: Array<RunQueueItemEdge>;
  pageInfo: PageInfo;
};

export type RunQueueItemEdge = {
  __typename: 'RunQueueItemEdge';
  cursor: Scalars['String']['output'];
  node: RunQueueItem;
};

export type RunQueueItemInfoDetails = Error & {
  __typename: 'RunQueueItemInfoDetails';
  filePaths: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export enum RunQueueItemState {
  Claimed = 'CLAIMED',
  Failed = 'FAILED',
  Leased = 'LEASED',
  Pending = 'PENDING'
}

export enum RunQueuePrioritizationMode {
  Disabled = 'DISABLED',
  V0 = 'V0'
}

export type RunServicesAvailable = {
  __typename: 'RunServicesAvailable';
  tensorboard?: Maybe<Scalars['Boolean']['output']>;
};

export type RunStateEventDetails = {
  __typename: 'RunStateEventDetails';
  entityName?: Maybe<Scalars['String']['output']>;
  newRunState?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  runName?: Maybe<Scalars['String']['output']>;
};

export type RunStorageNode = StorageTreeNode & {
  __typename: 'RunStorageNode';
  files: FileStorageNodeConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  run: Run;
  runID: Scalars['ID']['output'];
  size: Scalars['Int64']['output'];
};


export type RunStorageNodeFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RunStorageNodeConnection = {
  __typename: 'RunStorageNodeConnection';
  edges: Array<RunStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type RunStorageNodeEdge = {
  __typename: 'RunStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: RunStorageNode;
};

export type RunTag = {
  __typename: 'RunTag';
  colorIndex: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RunTagConnection = {
  __typename: 'RunTagConnection';
  edges: Array<RunTagEdge>;
  pageInfo: PageInfo;
};

export type RunTagCount = {
  __typename: 'RunTagCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RunTagEdge = {
  __typename: 'RunTagEdge';
  cursor: Scalars['String']['output'];
  node: RunTag;
};

export type RunsResult = {
  __typename: 'RunsResult';
  runs: Array<Run>;
};

export type ScriptableRunCondition = {
  __typename: 'ScriptableRunCondition';
  success: Scalars['Boolean']['output'];
};

export type Secret = {
  __typename: 'Secret';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SemanticLegend = {
  __typename: 'SemanticLegend';
  currentMetric: Scalars['String']['output'];
  semanticLegendsByMetric: Array<Maybe<SemanticLegendByMetric>>;
  viewID: Scalars['ID']['output'];
};

export type SemanticLegendByMetric = {
  __typename: 'SemanticLegendByMetric';
  bucketUpperBounds?: Maybe<Array<Scalars['Float']['output']>>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  customColors: Array<CustomColor>;
  excludedRunColor?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  metricName?: Maybe<Scalars['String']['output']>;
  yValue?: Maybe<Scalars['String']['output']>;
};

export type SendRequestOrgEmailDomainVerificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
};

export type SendRequestOrgEmailDomainVerificationPayload = {
  __typename: 'SendRequestOrgEmailDomainVerificationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ServerFeature = {
  __typename: 'ServerFeature';
  description: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ServerInfo = {
  __typename: 'ServerInfo';
  actionHistoryLimit: Scalars['Int']['output'];
  availableBucketProviders: Array<CloudProvider>;
  availableCloudRegions: Array<CloudRegion>;
  cliVersionInfo: Scalars['JSON']['output'];
  contractStartDate?: Maybe<Scalars['DateTime']['output']>;
  dataRetentionDuration: Scalars['Duration']['output'];
  defaultCloudRegion: CloudRegion;
  deploymentId?: Maybe<Scalars['String']['output']>;
  exposesExplicitRunQueueAckPath: Scalars['Boolean']['output'];
  features: Array<Maybe<ServerFeature>>;
  frontendHost: Scalars['String']['output'];
  hasLocalLicense: Scalars['Boolean']['output'];
  isGoogleIap: Scalars['Boolean']['output'];
  latestLocalVersionInfo?: Maybe<LocalVersionInfo>;
  licenseExpirationUI?: Maybe<LicenseExpirationUi>;
  licenseFlags: Array<Scalars['String']['output']>;
  messageOfTheDay?: Maybe<Scalars['String']['output']>;
  pollingOK: Scalars['Boolean']['output'];
  registeredModelLimitReached: Scalars['Boolean']['output'];
  secureStorageConnectorEnabled: Scalars['Boolean']['output'];
  slackClientID: Scalars['String']['output'];
  streamTableEnabled: Scalars['Boolean']['output'];
  userLimitReached: Scalars['Boolean']['output'];
  viewOnlyUserLimitReached: Scalars['Boolean']['output'];
  weaveLimits?: Maybe<WeaveLimits>;
};


export type ServerInfoActionHistoryLimitArgs = {
  artifactCollectionID?: InputMaybe<Scalars['ID']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
};


export type ServerInfoRegisteredModelLimitReachedArgs = {
  entityName: Scalars['String']['input'];
};

export type ServiceAccount = {
  __typename: 'ServiceAccount';
  accountType: UserAccountType;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiKeyCount: Scalars['Int']['output'];
  authMethod?: Maybe<ServiceAccountAuthMethod>;
  createdAt: Scalars['DateTime']['output'];
  defaultEntity?: Maybe<Entity>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  teams?: Maybe<EntityConnection>;
};


export type ServiceAccountTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ServiceAccountAuthMethod {
  ApiKey = 'API_KEY',
  Federated = 'FEDERATED'
}

export type SetDismissedBannerInput = {
  bannerID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SetDismissedBannerPayload = {
  __typename: 'SetDismissedBannerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetTagColorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  colorIndex?: InputMaybe<Scalars['Int']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type SetTagColorPayload = {
  __typename: 'SetTagColorPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tags: Array<RunTag>;
};

export type SlackChannelSubscription = AlertSubscription & {
  __typename: 'SlackChannelSubscription';
  id: Scalars['ID']['output'];
  slackIntegration: SlackIntegration;
};

export type SlackIntegration = Integration & {
  __typename: 'SlackIntegration';
  channelName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  teamName: Scalars['String']['output'];
};

export type SlackNotificationActionArgs = {
  __typename: 'SlackNotificationActionArgs';
  integration?: Maybe<SlackIntegration>;
  severity?: Maybe<AlertSeverity>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleURL?: Maybe<Scalars['String']['output']>;
};

export type SlurmInfo = {
  __typename: 'SlurmInfo';
  jobId: Scalars['String']['output'];
};

export enum SmoothingType {
  Average = 'average',
  Exponential = 'exponential',
  ExponentialTimeWeighted = 'exponentialTimeWeighted',
  Gaussian = 'gaussian',
  None = 'none'
}

export type StarProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
};

export type StarProjectPayload = {
  __typename: 'StarProjectPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

export type StarRegistryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
};

export type StarRegistryPayload = {
  __typename: 'StarRegistryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  registryProject?: Maybe<Project>;
};

export type StarViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StarViewPayload = {
  __typename: 'StarViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  view?: Maybe<View>;
};

export type StargazerConnection = {
  __typename: 'StargazerConnection';
  edges: Array<StargazerEdge>;
  pageInfo: PageInfo;
};

export type StargazerEdge = {
  __typename: 'StargazerEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<User>;
};

export type StartExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StopExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StopRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StopRunPayload = {
  __typename: 'StopRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StoppedRunCondition = {
  __typename: 'StoppedRunCondition';
  minimumRunDuration: Scalars['Duration']['output'];
};

export type StorageBucketInfo = {
  __typename: 'StorageBucketInfo';
  ID: Scalars['ID']['output'];
  awsExternalID?: Maybe<Scalars['String']['output']>;
  azureClientID?: Maybe<Scalars['String']['output']>;
  azureTenantID?: Maybe<Scalars['String']['output']>;
  kmsKeyID?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  provider: CloudProvider;
};

export type StorageBucketInfoInput = {
  awsExternalID?: InputMaybe<Scalars['String']['input']>;
  azureClientID?: InputMaybe<Scalars['String']['input']>;
  azureTenantID?: InputMaybe<Scalars['String']['input']>;
  kmsKeyID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  provider: CloudProvider;
};

export type StorageTreeNode = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export enum StorageUnit {
  B = 'B',
  Gb = 'GB',
  Kb = 'KB',
  Mb = 'MB',
  Pb = 'PB',
  Tb = 'TB'
}

export type StripeBillingInfo = {
  __typename: 'StripeBillingInfo';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  invoiceLink?: Maybe<Scalars['String']['output']>;
  paymentMetadata?: Maybe<PaymentMetadata>;
  paymentMethod?: Maybe<PaymentMethod>;
  status: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
};

export type StripeInvoice = {
  __typename: 'StripeInvoice';
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  hostedInvoiceURL: Scalars['String']['output'];
  invoicePDF: Scalars['String']['output'];
  number: Scalars['String']['output'];
  status: StripeInvoiceStatus;
  subscription?: Maybe<StripeSubscription>;
  total: Scalars['Int64']['output'];
};

export enum StripeInvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type StripePaymentMethod = {
  __typename: 'StripePaymentMethod';
  card: StripePaymentMethodCard;
  isDefault: Scalars['Boolean']['output'];
  isFailed: Scalars['Boolean']['output'];
  stripePaymentMethodID: Scalars['String']['output'];
  type: StripePaymentMethodType;
};

export type StripePaymentMethodCard = {
  __typename: 'StripePaymentMethodCard';
  brand: CardBrand;
  last4: Scalars['String']['output'];
};

export enum StripePaymentMethodType {
  Card = 'CARD'
}

export type StripePrice = {
  __typename: 'StripePrice';
  amount: Scalars['Int64']['output'];
  currency: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
};

export type StripeSubscription = {
  __typename: 'StripeSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  organizationSubscriptions: Array<OrganizationSubscription>;
  status: Scalars['String']['output'];
};

export type SubmitBenchmarkRunInput = {
  benchmarkEntityName?: InputMaybe<Scalars['String']['input']>;
  benchmarkName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCodeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitBenchmarkRunPayload = {
  __typename: 'SubmitBenchmarkRunPayload';
  benchmarkRun: BenchmarkRun;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SubmitFcNewsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SubmitFcNewsPayload = {
  __typename: 'SubmitFCNewsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Sweep = Node & {
  __typename: 'Sweep';
  agent?: Maybe<Agent>;
  agents: AgentConnection;
  bestLoss?: Maybe<Scalars['Float']['output']>;
  config: Scalars['String']['output'];
  controller?: Maybe<Scalars['JSONString']['output']>;
  controllerRunName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  earlyStopJobRunning: Scalars['Boolean']['output'];
  heartbeatAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priorRuns: RunConnection;
  project?: Maybe<Project>;
  runCount: Scalars['Int']['output'];
  runCountExpected?: Maybe<Scalars['Int']['output']>;
  runTime: Scalars['Float']['output'];
  runs: RunConnection;
  scheduler?: Maybe<Scalars['JSONString']['output']>;
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};


export type SweepAgentArgs = {
  agentName: Scalars['String']['input'];
};


export type SweepRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type SweepConnection = {
  __typename: 'SweepConnection';
  edges: Array<SweepEdge>;
  pageInfo: PageInfo;
};

export type SweepEdge = {
  __typename: 'SweepEdge';
  cursor: Scalars['String']['output'];
  node: Sweep;
};

export type Tag = {
  __typename: 'Tag';
  attributes: Scalars['JSONString']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objects?: Maybe<TaggedObjectConnection>;
  tagCategory?: Maybe<TagCategory>;
  tagCategoryName: Scalars['String']['output'];
};


export type TagObjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  objectType?: InputMaybe<TaggedObjectType>;
};

export type TagCategory = {
  __typename: 'TagCategory';
  group: TagGroup;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: TagConnection;
};


export type TagCategoryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TagConnection = {
  __typename: 'TagConnection';
  edges: Array<TagEdge>;
  pageInfo: PageInfo;
};

export type TagEdge = {
  __typename: 'TagEdge';
  cursor: Scalars['String']['output'];
  node: Tag;
};

export type TagGroup = Entity;

export type TagInput = {
  attributes?: InputMaybe<Scalars['JSONString']['input']>;
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
  tagName: Scalars['String']['input'];
};

export type TaggedObject = Artifact | ArtifactPortfolio | ArtifactSequence;

export type TaggedObjectConnection = {
  __typename: 'TaggedObjectConnection';
  edges: Array<TaggedObjectEdge>;
  pageInfo: PageInfo;
};

export type TaggedObjectEdge = {
  __typename: 'TaggedObjectEdge';
  cursor: Scalars['String']['output'];
  node: TaggedObject;
};

export enum TaggedObjectType {
  Artifact = 'ARTIFACT',
  ArtifactCollection = 'ARTIFACT_COLLECTION'
}

export type Task = {
  __typename: 'Task';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  result?: Maybe<Scalars['String']['output']>;
  state: TaskState;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TaskState {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type TemplateVariable = {
  __typename: 'TemplateVariable';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  schema: Scalars['JSONString']['output'];
};

export type TestGenericWebhookIntegrationInput = {
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  requestPayload?: InputMaybe<Scalars['JSONString']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint: Scalars['String']['input'];
};

export type TestGenericWebhookIntegrationPayload = {
  __typename: 'TestGenericWebhookIntegrationPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  response: Scalars['JSONString']['output'];
};

export type Thumbnail = {
  __typename: 'Thumbnail';
  directUrl: Scalars['String']['output'];
  originalImageHeight: Scalars['Int']['output'];
  originalImageWidth: Scalars['Int']['output'];
  size: Scalars['Int64']['output'];
};

export type TimeWindow = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type TrainingCostUsageAggregation = UsageAggregationInterface & {
  __typename: 'TrainingCostUsageAggregation';
  end: Scalars['DateTime']['output'];
  entityName: Scalars['String']['output'];
  gpuDurationMs: Scalars['Int64']['output'];
  gpuModelID: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  value: Scalars['Int64']['output'];
};

export enum TraversalDirection {
  Downstream = 'DOWNSTREAM',
  Upstream = 'UPSTREAM'
}

export type Trigger = {
  __typename: 'Trigger';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scope: TriggerScope;
  triggerExecutions: TriggerExecutionConnection;
  triggeredAction: TriggeredAction;
  triggeringCondition: TriggeringCondition;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TriggerTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerActionDetails = GenericWebhookActionArgs | NoOpActionArgs | PushNotificationActionArgs | QueueJobActionArgs | SlackNotificationActionArgs;

export type TriggerConnection = {
  __typename: 'TriggerConnection';
  edges: Array<TriggerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TriggerEdge = {
  __typename: 'TriggerEdge';
  cursor: Scalars['String']['output'];
  node: Trigger;
};

export type TriggerEventDetails = ArtifactAliasEventDetails | ArtifactEventDetails | ArtifactTagEventDetails | RunMetricEventDetails | RunStateEventDetails;

export type TriggerEventsExportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};

export type TriggerEventsExportPayload = {
  __typename: 'TriggerEventsExportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type TriggerExecution = {
  __typename: 'TriggerExecution';
  action?: Maybe<TriggerExecutionAction>;
  actionDuration?: Maybe<Scalars['Duration']['output']>;
  actionStartedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<TriggerExecutionEvent>;
  id: Scalars['ID']['output'];
  result?: Maybe<TriggerExecutionResult>;
  scope?: Maybe<TriggerScope>;
  state: TriggerExecutionState;
  triggerID?: Maybe<Scalars['ID']['output']>;
  triggerName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TriggerExecutionAction = {
  __typename: 'TriggerExecutionAction';
  actionType: TriggeredActionType;
  data?: Maybe<TriggerActionDetails>;
};

export type TriggerExecutionConnection = {
  __typename: 'TriggerExecutionConnection';
  edges: Array<TriggerExecutionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int64']['output'];
};

export type TriggerExecutionEdge = {
  __typename: 'TriggerExecutionEdge';
  cursor: Scalars['String']['output'];
  node: TriggerExecution;
};

export type TriggerExecutionError = Error & {
  __typename: 'TriggerExecutionError';
  message: Scalars['String']['output'];
};

export type TriggerExecutionEvent = {
  __typename: 'TriggerExecutionEvent';
  data?: Maybe<TriggerEventDetails>;
  eventType: EventTriggeringConditionType;
};

export type TriggerExecutionResult = {
  __typename: 'TriggerExecutionResult';
  data?: Maybe<TriggerResultDetails>;
  resultType: TriggerResultType;
};

export enum TriggerExecutionState {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Pending = 'PENDING'
}

export type TriggerFlatRunsMigratorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerFlatRunsMigratorPayload = {
  __typename: 'TriggerFlatRunsMigratorPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  glueTaskName?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerParquetExportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};

export type TriggerParquetExportPayload = {
  __typename: 'TriggerParquetExportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type TriggerRecomputeKeysInfoInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};

export type TriggerRecomputeKeysInfoPayload = {
  __typename: 'TriggerRecomputeKeysInfoPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type TriggerResultDetails = DefaultTriggerResultDetails | HttpTriggerResultDetails | QueuedJobTriggerResultDetails;

export enum TriggerResultType {
  Default = 'DEFAULT',
  HttpResponse = 'HTTP_RESPONSE',
  QueueJob = 'QUEUE_JOB'
}

export type TriggerScope = ArtifactPortfolio | ArtifactSequence | Project;

export enum TriggerScopeType {
  ArtifactCollection = 'ARTIFACT_COLLECTION',
  Project = 'PROJECT'
}

/** Represents a template variable that can be used in automation action payloads. */
export type TriggerTemplateVariable = {
  __typename: 'TriggerTemplateVariable';
  /** User-facing help text explaining what this variable resolves to. */
  description: Scalars['String']['output'];
  /** A user-facing representation of the variable syntax, e.g. "${artifact_version}" or "${artifact_metadata.KEY}" */
  name: Scalars['String']['output'];
};

export type TriggeredAction = GenericWebhookTriggeredAction | NoOpTriggeredAction | NotificationTriggeredAction | PushNotificationTriggeredAction | QueueJobTriggeredAction;

export type TriggeredActionConfig =
  { genericWebhookActionInput: GenericWebhookActionInput; noOpActionInput?: never; notificationActionInput?: never; pushNotificationActionInput?: never; queueJobActionInput?: never; }
  |  { genericWebhookActionInput?: never; noOpActionInput: NoOpTriggeredActionInput; notificationActionInput?: never; pushNotificationActionInput?: never; queueJobActionInput?: never; }
  |  { genericWebhookActionInput?: never; noOpActionInput?: never; notificationActionInput: NotificationActionInput; pushNotificationActionInput?: never; queueJobActionInput?: never; }
  |  { genericWebhookActionInput?: never; noOpActionInput?: never; notificationActionInput?: never; pushNotificationActionInput: PushNotificationActionInput; queueJobActionInput?: never; }
  |  { genericWebhookActionInput?: never; noOpActionInput?: never; notificationActionInput?: never; pushNotificationActionInput?: never; queueJobActionInput: QueueJobActionInput; };

export enum TriggeredActionType {
  GenericWebhook = 'GENERIC_WEBHOOK',
  Notification = 'NOTIFICATION',
  NoOp = 'NO_OP',
  PushNotification = 'PUSH_NOTIFICATION',
  QueueJob = 'QUEUE_JOB'
}

export type TriggeringCondition = FilterEventTriggeringCondition;

export type UndeleteRunsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  projectName: Scalars['String']['input'];
};

export type UndeleteRunsPayload = {
  __typename: 'UndeleteRunsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UndeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UndeleteUserPayload = {
  __typename: 'UndeleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UnlinkArtifactInput = {
  artifactID: Scalars['ID']['input'];
  artifactPortfolioID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkArtifactPayload = {
  __typename: 'UnlinkArtifactPayload';
  artifactID: Scalars['ID']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input payload for unregistering a device for push notifications. */
export type UnregisterUserDeviceInput = {
  /** The device token to unregister. */
  token: Scalars['String']['input'];
};

/** Response payload from unregistering a device for push notifications. */
export type UnregisterUserDevicePayload = {
  __typename: 'UnregisterUserDevicePayload';
  /** Whether the device was successfully unregistered. */
  success: Scalars['Boolean']['output'];
};

export type UnstarProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
};

export type UnstarProjectPayload = {
  __typename: 'UnstarProjectPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

export type UnstarRegistryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
};

export type UnstarRegistryPayload = {
  __typename: 'UnstarRegistryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  registryProject?: Maybe<Project>;
};

export type UnstarViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UnstarViewPayload = {
  __typename: 'UnstarViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  view?: Maybe<View>;
};

export type UpdateAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccessTokenPayload = {
  __typename: 'UpdateAccessTokenPayload';
  accessToken: AccessToken;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  recipientAlreadyOnTeam?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
  toNewUser?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAccessTokenProjectsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projects: Array<ProjectSpecifier>;
  token: Scalars['String']['input'];
};

export type UpdateAccessTokenProjectsPayload = {
  __typename: 'UpdateAccessTokenProjectsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAlertPayload = {
  __typename: 'UpdateAlertPayload';
  alert: Alert;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateAlertThresholdInput = {
  alertThresholdID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAlertThresholdPayload = {
  __typename: 'UpdateAlertThresholdPayload';
  alertThreshold?: Maybe<AlertThreshold>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UpdateApiKeyPayload = {
  __typename: 'UpdateApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateArtifactAction = ArtifactAction & {
  __typename: 'UpdateArtifactAction';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator: Initiator;
  newAliases?: Maybe<Array<ArtifactAlias>>;
  newDescription?: Maybe<Scalars['String']['output']>;
  newMetadata?: Maybe<Scalars['JSONString']['output']>;
  /** @deprecated Field no longer supported */
  newTags?: Maybe<Scalars['JSONString']['output']>;
  oldAliases?: Maybe<Array<ArtifactAlias>>;
  oldDescription?: Maybe<Scalars['String']['output']>;
  oldMetadata?: Maybe<Scalars['JSONString']['output']>;
  /** @deprecated Field no longer supported */
  oldTags?: Maybe<Scalars['JSONString']['output']>;
};

export type UpdateArtifactCollectionPayload = {
  __typename: 'UpdateArtifactCollectionPayload';
  artifactCollection: ArtifactCollection;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateArtifactEntityTtlInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  ttlDurationSeconds: Scalars['Int64']['input'];
};

export type UpdateArtifactEntityTtlPayload = {
  __typename: 'UpdateArtifactEntityTTLPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateArtifactInput = {
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  tagsToAdd?: InputMaybe<Array<TagInput>>;
  tagsToDelete?: InputMaybe<Array<TagInput>>;
  ttlDurationSeconds?: InputMaybe<Scalars['Int64']['input']>;
};

export type UpdateArtifactManifestInput = {
  artifactManifestID: Scalars['ID']['input'];
  baseArtifactID?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digest?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactManifestPayload = {
  __typename: 'UpdateArtifactManifestPayload';
  artifactManifest: ArtifactManifest;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateArtifactPayload = {
  __typename: 'UpdateArtifactPayload';
  artifact: Artifact;
  /** @deprecated Field no longer supported */
  artifactActions: Array<ArtifactAction>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateArtifactPortfolioInput = {
  artifactPortfolioID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactSequenceInput = {
  artifactSequenceID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactTypeInput = {
  artifactTypeID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactTypePayload = {
  __typename: 'UpdateArtifactTypePayload';
  artifactType: ArtifactType;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateBenchmarkRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBenchmarkRunPayload = {
  __typename: 'UpdateBenchmarkRunPayload';
  benchmarkRun: BenchmarkRun;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCustomChartInput = {
  access?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  spec?: InputMaybe<Scalars['JSONString']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomChartPayload = {
  __typename: 'UpdateCustomChartPayload';
  chart: CustomChart;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCustomerDefaultPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type UpdateCustomerDefaultPaymentMethodPayload = {
  __typename: 'UpdateCustomerDefaultPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCustomerPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type UpdateCustomerPaymentMethodPayload = {
  __typename: 'UpdateCustomerPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateDefaultResourceConfigInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSONString']['input'];
  defaultResourceConfigID: Scalars['ID']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  templateVariables?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpdateDefaultResourceConfigPayload = {
  __typename: 'UpdateDefaultResourceConfigPayload';
  defaultResourceConfigID: Scalars['ID']['output'];
  schemaValidationErrors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDiscussionCommentInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discussionCommentID: Scalars['ID']['input'];
  inlineCommentDetails?: InputMaybe<Scalars['JSONString']['input']>;
  viewID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDiscussionCommentPayload = {
  __typename: 'UpdateDiscussionCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionComment: DiscussionComment;
};

export type UpdateDiscussionThreadInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discussionThreadID: Scalars['ID']['input'];
};

export type UpdateDiscussionThreadPayload = {
  __typename: 'UpdateDiscussionThreadPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionThread: DiscussionThread;
};

export type UpdateEntityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  codeSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAccess?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  privateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rateLimits?: InputMaybe<RateLimitsInput>;
  settings?: InputMaybe<EntitySettingsInput>;
};

export type UpdateEntityPayload = {
  __typename: 'UpdateEntityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

export type UpdateExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enrollmentPeriod: Scalars['Int']['input'];
  experimentType: ExperimentType;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  name: Scalars['String']['input'];
  observationalUnit: ObservationalUnit;
  sampleSize: Scalars['Int']['input'];
  variants: Array<VariantInput>;
};

export type UpdateExperimentPayload = {
  __typename: 'UpdateExperimentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateFilterTriggerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventFilter?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scopeID?: InputMaybe<Scalars['ID']['input']>;
  scopeType?: InputMaybe<TriggerScopeType>;
  triggeredActionConfig?: InputMaybe<TriggeredActionConfig>;
  triggeredActionType?: InputMaybe<TriggeredActionType>;
  triggeringEventType?: InputMaybe<EventTriggeringConditionType>;
};

export type UpdateFilterTriggerPayload = {
  __typename: 'UpdateFilterTriggerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Trigger>;
};

export type UpdateGenericWebhookIntegrationInput = {
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGlueTaskInput = {
  arguments?: InputMaybe<Scalars['JSONString']['input']>;
  checkpoint?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategyMetadata?: InputMaybe<Scalars['String']['input']>;
  strategyType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGlueTaskPayload = {
  __typename: 'UpdateGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateLaunchAgentInput = {
  agentStatus?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  heartbeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  launchAgentId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  runQueues?: InputMaybe<Array<Scalars['ID']['input']>>;
  stopPolling?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLaunchAgentPayload = {
  __typename: 'UpdateLaunchAgentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLocalLicenseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocalLicensePayload = {
  __typename: 'UpdateLocalLicensePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  localLicense: LocalLicense;
};

export type UpdateMemberInput = {
  /** @deprecated Use `role` instead */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['ID']['input'];
};

export type UpdateMemberPayload = {
  __typename: 'UpdateMemberPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member: Member;
};

export type UpdateModelsSeatInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modelsSeat: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateModelsSeatPayload = {
  __typename: 'UpdateModelsSeatPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationBillingUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newBillingUser: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateOrganizationBillingUserPayload = {
  __typename: 'UpdateOrganizationBillingUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
};

export type UpdateOrganizationPayload = {
  __typename: 'UpdateOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationPrivacySettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  codeSavingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  disableMagicLinkSharing?: InputMaybe<Scalars['Boolean']['input']>;
  enableLLMPoweredFeatures?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  onlyAdminsCanInvite?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  privateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  requireOrgScopedAPIKeys?: InputMaybe<Scalars['Boolean']['input']>;
  restrictMatchingOrgEmailDomainUsers?: InputMaybe<Scalars['Boolean']['input']>;
  shareAITracesWithWB?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationPrivacySettingsPayload = {
  __typename: 'UpdateOrganizationPrivacySettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createStripeSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationSubscriptionID: Scalars['ID']['input'];
  planID?: InputMaybe<Scalars['ID']['input']>;
  privileges?: InputMaybe<Scalars['JSONString']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrganizationSubscriptionStatus>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrganizationSubscriptionType>;
};

export type UpdateOrganizationSubscriptionPayload = {
  __typename: 'UpdateOrganizationSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationSubscriptionSeatsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
  seats: Scalars['Int']['input'];
};

export type UpdateOrganizationSubscriptionSeatsPayload = {
  __typename: 'UpdateOrganizationSubscriptionSeatsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
  userOrgRole: Scalars['String']['input'];
};

export type UpdateOrganizationUserPayload = {
  __typename: 'UpdateOrganizationUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationUserV2Input = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
  userOrgRole: Scalars['String']['input'];
};

export type UpdateOrganizationUserV2Payload = {
  __typename: 'UpdateOrganizationUserV2Payload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProjectMemberInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  userProjectRole: Scalars['String']['input'];
};

export type UpdateProjectMemberPayload = {
  __typename: 'UpdateProjectMemberPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProjectTeamMemberInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  teamProjectRole: Scalars['String']['input'];
};

export type UpdateProjectTeamMemberPayload = {
  __typename: 'UpdateProjectTeamMemberPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRampThresholdInput = {
  checkId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  setting: Scalars['String']['input'];
  store: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
};

export type UpdateRampThresholdPayload = {
  __typename: 'UpdateRampThresholdPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  inheritedFrom?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleID: Scalars['ID']['input'];
};

export type UpdateRolePayload = {
  __typename: 'UpdateRolePayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultResourceConfigID?: InputMaybe<Scalars['ID']['input']>;
  externalLinks?: InputMaybe<Scalars['JSONString']['input']>;
  prioritizationMode?: InputMaybe<RunQueuePrioritizationMode>;
  queueID: Scalars['ID']['input'];
};

export type UpdateRunQueueItemWarningInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
  runQueueItemId: Scalars['ID']['input'];
  stage: Scalars['String']['input'];
};

export type UpdateRunQueueItemWarningPayload = {
  __typename: 'UpdateRunQueueItemWarningPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateRunQueuePayload = {
  __typename: 'UpdateRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  queueID?: Maybe<Scalars['ID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateRunStateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};

export type UpdateRunStatePayload = {
  __typename: 'UpdateRunStatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Run>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSemanticLegendInput = {
  bucketUpperBounds?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentMetric?: InputMaybe<Scalars['String']['input']>;
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRunColor?: InputMaybe<Scalars['String']['input']>;
  metricName?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  viewID?: InputMaybe<Scalars['ID']['input']>;
  yValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSemanticLegendPayload = {
  __typename: 'UpdateSemanticLegendPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateServiceAccountApiKeyInput = {
  apiKeyId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  serviceAccountId: Scalars['ID']['input'];
};

export type UpdateServiceAccountApiKeyPayload = {
  __typename: 'UpdateServiceAccountApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateStoppedRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  minimumRunDuration?: InputMaybe<Scalars['Duration']['input']>;
};

export type UpdateSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  gpuEnabled?: InputMaybe<Scalars['DateTime']['input']>;
  hubPreset?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsInput>;
  privateProjects?: InputMaybe<Scalars['Boolean']['input']>;
  teamsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSubscriptionPayload = {
  __typename: 'UpdateSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

export type UpdateTagCategoryInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  newTagCategoryName?: InputMaybe<Scalars['String']['input']>;
  oldTagCategoryName: Scalars['String']['input'];
};

export type UpdateTagCategoryPayload = {
  __typename: 'UpdateTagCategoryPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  tagCategory: TagCategory;
};

export type UpdateTagInput = {
  attributes?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  newTagName?: InputMaybe<Scalars['String']['input']>;
  oldTagName: Scalars['String']['input'];
  tagCategoryName: Scalars['String']['input'];
};

export type UpdateTagPayload = {
  __typename: 'UpdateTagPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  tag: Tag;
};

export type UpdateUserEmailInput = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<EmailType>;
};

export type UpdateUserEmailPayload = {
  __typename: 'UpdateUserEmailPayload';
  email?: Maybe<Email>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  defaultEntity?: InputMaybe<Scalars['String']['input']>;
  defaultFramework?: InputMaybe<Scalars['String']['input']>;
  galleryVisited?: InputMaybe<Scalars['Boolean']['input']>;
  hideTeamsFromPublic?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingHidden?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  settingsVisited?: InputMaybe<Scalars['Boolean']['input']>;
  userInfo?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpdateUserPayload = {
  __typename: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UpdateUserRoleInput = {
  accountType: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateUserRolePayload = {
  __typename: 'UpdateUserRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UpdateUserRoleV2Input = {
  accountType: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateUserRoleV2Payload = {
  __typename: 'UpdateUserRoleV2Payload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UpdateWeaveRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  weaveRole: Scalars['String']['input'];
};

export type UpdateWeaveRolePayload = {
  __typename: 'UpdateWeaveRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpgradeCustomerSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  planID: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpgradeCustomerSubscriptionPayload = {
  __typename: 'UpgradeCustomerSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationID: Scalars['ID']['output'];
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type UpgradeTrialSubscriptionPayload = {
  __typename: 'UpgradeTrialSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UploadMultipartUrls = {
  __typename: 'UploadMultipartUrls';
  uploadID: Scalars['String']['output'];
  uploadUrlParts: Array<UploadUrlPart>;
};

export type UploadPanelInput = {
  author: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  panelID: Scalars['String']['input'];
  redirectURL: Scalars['String']['input'];
  title: Scalars['String']['input'];
  viewID: Scalars['ID']['input'];
};

export type UploadPanelPayload = {
  __typename: 'UploadPanelPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  panelImageUploadUrl: Scalars['String']['output'];
  panelLink: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UploadPartsInput = {
  hexMD5: Scalars['String']['input'];
  partNumber: Scalars['Int64']['input'];
};

export type UploadUrlPart = {
  __typename: 'UploadUrlPart';
  partNumber: Scalars['Int64']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UpsertBucketInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSONString']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobProgram?: InputMaybe<Scalars['String']['input']>;
  jobRepo?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  runQueueItemId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Run state can only be managed internally. */
  state?: InputMaybe<Scalars['String']['input']>;
  summaryMetrics?: InputMaybe<Scalars['JSONString']['input']>;
  sweep?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpsertBucketPayload = {
  __typename: 'UpsertBucketPayload';
  bucket?: Maybe<Run>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  updateAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertModelInput = {
  access?: InputMaybe<Scalars['String']['input']>;
  allowAllArtifactTypesInRegistry?: InputMaybe<Scalars['Boolean']['input']>;
  artifactTypes?: InputMaybe<Array<ArtifactTypeInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<ProjectIconInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  linkedBenchmark?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  rateLimits?: InputMaybe<RateLimitsInput>;
  repo?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpsertModelPayload = {
  __typename: 'UpsertModelPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  model?: Maybe<Project>;
  project?: Maybe<Project>;
};

export type UpsertRunGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpsertRunGroupPayload = {
  __typename: 'UpsertRunGroupPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<RunGroup>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  externalLinks?: InputMaybe<Scalars['JSONString']['input']>;
  prioritizationMode?: InputMaybe<RunQueuePrioritizationMode>;
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
  resourceConfig: Scalars['JSONString']['input'];
  resourceType: Scalars['String']['input'];
  templateVariables?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpsertRunQueuePayload = {
  __typename: 'UpsertRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  configSchemaValidationErrors?: Maybe<Array<Scalars['String']['output']>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertSharedViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  spec: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpsertSharedViewPayload = {
  __typename: 'UpsertSharedViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  view?: Maybe<View>;
};

export type UpsertSweepInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  controller?: InputMaybe<Scalars['JSONString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  launchScheduler?: InputMaybe<Scalars['JSONString']['input']>;
  priorRunsFilters?: InputMaybe<Scalars['JSONString']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  scheduler?: InputMaybe<Scalars['JSONString']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  templateVariableValues?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpsertSweepPayload = {
  __typename: 'UpsertSweepPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  configValidationWarnings: Array<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  insertedPriorRuns?: Maybe<Scalars['Int']['output']>;
  sweep?: Maybe<Sweep>;
};

export type UpsertUserProfileViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertUserProfileViewPayload = {
  __typename: 'UpsertUserProfileViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  view?: Maybe<View>;
};

export type UpsertViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  createdUsing?: InputMaybe<ViewSource>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  showcasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertViewPayload = {
  __typename: 'UpsertViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  view?: Maybe<View>;
};

export type UpsertWorkspaceTemplateInput = {
  entityId: Scalars['ID']['input'];
  /** @deprecated Use linePlotTemplateId or workspaceLayoutTemplateId */
  id?: InputMaybe<Scalars['ID']['input']>;
  linePlotSettings?: InputMaybe<Scalars['JSONString']['input']>;
  linePlotTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use linePlotSettings or workspaceLayoutSettings */
  settings?: InputMaybe<Scalars['JSONString']['input']>;
  /** @deprecated Use linePlotSettings or workspaceLayoutSettings */
  type?: InputMaybe<WorkspaceTemplateType>;
  workspaceLayoutSettings?: InputMaybe<Scalars['JSONString']['input']>;
  workspaceLayoutTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertWorkspaceTemplatePayload = {
  __typename: 'UpsertWorkspaceTemplatePayload';
  /** @deprecated Use linePlotTemplateId or workspaceLayoutTemplateId */
  id?: Maybe<Scalars['ID']['output']>;
  linePlotTemplateId?: Maybe<Scalars['ID']['output']>;
  workspaceLayoutTemplateId?: Maybe<Scalars['ID']['output']>;
};

export type UsageAggregation = UsageAggregationInterface & {
  __typename: 'UsageAggregation';
  end: Scalars['DateTime']['output'];
  entityName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  value: Scalars['Int64']['output'];
};

export type UsageAggregationInterface = {
  end: Scalars['DateTime']['output'];
  entityName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  value: Scalars['Int64']['output'];
};

export type UsageStat = {
  __typename: 'UsageStat';
  date?: Maybe<Scalars['DateTime']['output']>;
  stat?: Maybe<Scalars['Float']['output']>;
};

export type UsageStatConnection = {
  __typename: 'UsageStatConnection';
  edges: Array<UsageStatEdge>;
  pageInfo: PageInfo;
};

export type UsageStatEdge = {
  __typename: 'UsageStatEdge';
  cursor: Scalars['String']['output'];
  node: UsageStat;
};

export enum UsageType {
  InferenceCost = 'INFERENCE_COST',
  Storage = 'STORAGE',
  TrackedHours = 'TRACKED_HOURS',
  TrainingCost = 'TRAINING_COST',
  TrainingDuration = 'TRAINING_DURATION',
  UserSeats = 'USER_SEATS',
  Weave = 'WEAVE'
}

export type UseArtifactAction = ArtifactAction & {
  __typename: 'UseArtifactAction';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator: Initiator;
};

export type UseArtifactInput = {
  artifactEntityName?: InputMaybe<Scalars['String']['input']>;
  artifactID: Scalars['ID']['input'];
  artifactProjectName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  usedAs?: InputMaybe<Scalars['String']['input']>;
};

export type UseArtifactPayload = {
  __typename: 'UseArtifactPayload';
  artifact: Artifact;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  run: Run;
};

export type User = Node & {
  __typename: 'User';
  accountType?: Maybe<UserAccountType>;
  activity?: Maybe<UserActivityDetails>;
  admin?: Maybe<Scalars['Boolean']['output']>;
  analyticsId?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiKeys?: Maybe<ApiKeyConnection>;
  /** @deprecated Field no longer supported */
  authId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dailyRunCount: Array<Scalars['Int']['output']>;
  defaultEntity?: Maybe<Entity>;
  defaultEntityId?: Maybe<Scalars['Int']['output']>;
  defaultFramework?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  devices: Array<UserDevice>;
  domainClaimBlockingReason?: Maybe<Scalars['String']['output']>;
  dynamicConfig: DynamicConfig;
  email?: Maybe<Scalars['String']['output']>;
  emails: Array<Email>;
  entity?: Maybe<Scalars['String']['output']>;
  featureFlags: Array<Maybe<FeatureFlag>>;
  flags?: Maybe<Scalars['JSONString']['output']>;
  hasRun: Scalars['Boolean']['output'];
  hideTeamsFromPublic: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instanceAdminTeamAccessDisabled: Scalars['Boolean']['output'];
  isEmailDomainClaimedAndShouldRedirectToSSO: Scalars['Boolean']['output'];
  limits?: Maybe<Scalars['JSON']['output']>;
  loggedInAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  ndbId?: Maybe<Scalars['ID']['output']>;
  newsletterSubscription?: Maybe<NewsletterSubscription>;
  onboardingSteps?: Maybe<Scalars['JSON']['output']>;
  organizations: Array<Organization>;
  personalEntityDisabled: Scalars['Boolean']['output'];
  photoUploadUrl: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  private: Scalars['Boolean']['output'];
  profileView?: Maybe<View>;
  projects?: Maybe<ProjectConnection>;
  runs?: Maybe<RunConnection>;
  signupRequired: Scalars['Boolean']['output'];
  starredProjects?: Maybe<ProjectConnection>;
  starredRegistries?: Maybe<ProjectConnection>;
  starredViews?: Maybe<ViewConnection>;
  teams?: Maybe<EntityConnection>;
  totalRuns: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadHeaders: Array<Scalars['String']['output']>;
  userEntity?: Maybe<Entity>;
  userInfo?: Maybe<Scalars['JSON']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  views?: Maybe<ViewConnection>;
};


export type UserApiKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keysOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type UserDailyRunCountArgs = {
  limit: Scalars['Int']['input'];
};


export type UserDomainClaimBlockingReasonArgs = {
  orgId: Scalars['ID']['input'];
};


export type UserDynamicConfigArgs = {
  configId: Scalars['String']['input'];
};


export type UserFeatureFlagsArgs = {
  featureKey?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
};


export type UserOrganizationsArgs = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
};


export type UserProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  linkedBenchmark?: InputMaybe<ProjectIdentifierInput>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  restrictTo?: InputMaybe<UserProjectRestriction>;
};


export type UserRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type UserStarredProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};


export type UserStarredRegistriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};


export type UserStarredViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};

export enum UserAccountType {
  Anonymous = 'ANONYMOUS',
  OrgService = 'ORG_SERVICE',
  Service = 'SERVICE',
  User = 'USER',
  Viewer = 'VIEWER'
}

export type UserActivityDetails = ActivityDuration & {
  __typename: 'UserActivityDetails';
  daysActive: Scalars['Int']['output'];
  endAt: Scalars['DateTime']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  numReports: Scalars['Int']['output'];
  numRuns: Scalars['Int']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type UserConnection = {
  __typename: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserDevice = {
  __typename: 'UserDevice';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  platform: DevicePlatform;
};

export type UserEdge = {
  __typename: 'UserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<User>;
};

export enum UserProjectRestriction {
  Contributed = 'CONTRIBUTED',
  Owned = 'OWNED'
}

export type Variant = {
  __typename: 'Variant';
  allocation: Scalars['Int']['output'];
  bucket: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type VariantInput = {
  allocation: Scalars['Int']['input'];
  bucket: Scalars['Int']['input'];
  description: Scalars['String']['input'];
};

export type VersionedArtifactConnection = ArtifactConnectionType & {
  __typename: 'VersionedArtifactConnection';
  edges: Array<VersionedArtifactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VersionedArtifactEdge = ArtifactEdgeType & {
  __typename: 'VersionedArtifactEdge';
  cursor: Scalars['String']['output'];
  node: Artifact;
  version: Scalars['String']['output'];
};

export type View = Node & {
  __typename: 'View';
  accessTokens: Array<AccessToken>;
  alertSubscription?: Maybe<AlertSubscription>;
  children?: Maybe<ViewConnection>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdUsing: ViewSource;
  description?: Maybe<Scalars['String']['output']>;
  discussionThreads: DiscussionThreadConnection;
  displayName?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
  entityName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUploadUrl: ImageUrl;
  locked: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectName: Scalars['String']['output'];
  semanticLegend: SemanticLegend;
  showcasedAt?: Maybe<Scalars['DateTime']['output']>;
  spec?: Maybe<Scalars['JSONString']['output']>;
  specObject?: Maybe<Scalars['JSON']['output']>;
  starCount: Scalars['Int']['output'];
  stargazers: StargazerConnection;
  starred?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  uploadHeaders: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  viewCount: Scalars['Int']['output'];
};


export type ViewDiscussionThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ViewImageUploadUrlArgs = {
  name: Scalars['String']['input'];
};


export type ViewStarCountArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ViewStargazersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ViewConnection = {
  __typename: 'ViewConnection';
  edges: Array<ViewEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ViewEdge = {
  __typename: 'ViewEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<View>;
};

export enum ViewSource {
  WandbSdk = 'WANDB_SDK',
  WandbUi = 'WANDB_UI',
  WandbUiSharePanel = 'WANDB_UI_SHARE_PANEL',
  WeaveUi = 'WEAVE_UI'
}

export type ViewViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type ViewViewPayload = {
  __typename: 'ViewViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type WeaveEnterpriseSubscription = {
  __typename: 'WeaveEnterpriseSubscription';
  billingPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  billingPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  weaveLimit?: Maybe<WeaveLimits>;
};

export enum WeaveIngestionLimitInMb {
  Limit_1500 = 'LIMIT_1500',
  Limit_2000 = 'LIMIT_2000',
  Limit_3500 = 'LIMIT_3500',
  Limit_5000 = 'LIMIT_5000',
  Limit_6500 = 'LIMIT_6500',
  Limit_8000 = 'LIMIT_8000',
  Limit_10000 = 'LIMIT_10000',
  Limit_12500 = 'LIMIT_12500',
  Limit_15000 = 'LIMIT_15000',
  Limit_20000 = 'LIMIT_20000',
  Limit_25000 = 'LIMIT_25000',
  Limit_30000 = 'LIMIT_30000',
  Limit_35000 = 'LIMIT_35000'
}

export type WeaveLimits = {
  __typename: 'WeaveLimits';
  weaveLimitBytes?: Maybe<Scalars['Int64']['output']>;
  weaveOverageCostCents?: Maybe<Scalars['Int']['output']>;
  weaveOverageUnit?: Maybe<StorageUnit>;
};

export type WeaveSavingsCalculator = {
  __typename: 'WeaveSavingsCalculator';
  recommendationString: Scalars['String']['output'];
  recommendedWeaveTier: Scalars['String']['output'];
  totalPossibleSavings: Scalars['Int']['output'];
};

export enum WeaveSourceType {
  Prompt = 'PROMPT'
}

export enum WorkflowsAdminType {
  Model = 'MODEL'
}

export type WorkspaceTemplate = Node & {
  __typename: 'WorkspaceTemplate';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  settings?: Maybe<Scalars['JSON']['output']>;
  settingsVersion?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<WorkspaceTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum WorkspaceTemplateType {
  LinePlot = 'line_plot',
  WorkspaceLayout = 'workspace_layout'
}

export enum XAxisFormatValues {
  Datetime = 'datetime',
  Number = 'number'
}

export type UpgradeCustomerToProPlanInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modelsSeats: Scalars['Int']['input'];
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationID: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  planID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
};

export type UpgradeCustomerToProPlanPayload = {
  __typename: 'upgradeCustomerToProPlanPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationID: Scalars['ID']['output'];
  subscriptionCommit?: Maybe<Scalars['JSON']['output']>;
  subscriptionUsage?: Maybe<Scalars['JSON']['output']>;
};

export type UpgradeProCustomerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modelsSeats: Scalars['Int']['input'];
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
};

export type UpgradeProCustomerPayload = {
  __typename: 'upgradeProCustomerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationID: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpgradeTrialSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
  planID: Scalars['ID']['input'];
};

export type GraphDataFragmentFragment = { __typename: 'ArtifactLineageDag', hitLimit: boolean, artifacts: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, runs: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, clusters: Array<{ __typename: 'ArtifactLineageDagCluster', id: string, nodeType: DagNodeType, runNodes: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, artifactNodes: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, clusterEdges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null>, edges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> };

export type ArtifactDagQueryVariables = Exact<{
  artifactVersionID: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  filterGeneratedArtifacts: Scalars['Boolean']['input'];
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  directLineage?: InputMaybe<Scalars['Boolean']['input']>;
  traversalDirection?: InputMaybe<TraversalDirection>;
  baseGraphNodeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type ArtifactDagQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, artifactLineageDag?: { __typename: 'ArtifactLineageDag', hitLimit: boolean, artifacts: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, runs: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, clusters: Array<{ __typename: 'ArtifactLineageDagCluster', id: string, nodeType: DagNodeType, runNodes: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, artifactNodes: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, clusterEdges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null>, edges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null } | null };

export type ArtifactOverviewQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  artifactVersionIndex: Scalars['String']['input'];
}>;


export type ArtifactOverviewQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, digest: string, description?: string | null, size: any, fileCount: any, createdAt: string, usedCount: number, ttlDurationSeconds: any, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } | null }, createdBy?:
      | { __typename: 'Run', id: string, displayName?: string | null, runName: string, runProjectQuery?: { __typename: 'Project', id: string, runProject: string, runEntity: string } | null }
      | { __typename: 'User', id: string, username?: string | null }
     | null, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, artifactCollection?:
            | { __typename: 'ArtifactPortfolio', id: string, linkPortfolioName: string, linkProjectQuery?: { __typename: 'Project', id: string, linkProjectName: string, linkEntityName: string } | null }
            | { __typename: 'ArtifactSequence', id: string }
           | null } | null }> } } | null };

export type RunArtifactDagQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  filterGeneratedArtifacts: Scalars['Boolean']['input'];
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  directLineage?: InputMaybe<Scalars['Boolean']['input']>;
  traversalDirection?: InputMaybe<TraversalDirection>;
  baseGraphNodeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunArtifactDagQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, artifactLineageDag?: { __typename: 'ArtifactLineageDag', hitLimit: boolean, artifacts: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, runs: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, clusters: Array<{ __typename: 'ArtifactLineageDagCluster', id: string, nodeType: DagNodeType, runNodes: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, artifactNodes: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, clusterEdges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null>, edges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null } | null } | null };

export type RunOverviewLineageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunOverviewLineageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, createdAt: string, group?: string | null, state?: string | null, notes?: string | null, config?: any | null, tags?: Array<string> | null, host?: string | null, computeSeconds: number, project?: { __typename: 'Project', id: string, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null } | null, runInfo?: { __typename: 'RunInfo', os?: string | null, python?: string | null } | null } | null } | null };

export type ArtifactVersionAliasesQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
  versionAlias: Scalars['String']['input'];
  adminType: WorkflowsAdminType;
}>;


export type ArtifactVersionAliasesQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, artifactType: { __typename: 'ArtifactType', id: string, name: string } } | null } | null, project?: { __typename: 'Project', id: string, name: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, entity: { __typename: 'Entity', id: string, name: string, protectedAliases: Array<string>, workflowsAdmins: Array<{ __typename: 'User', id: string, name: string, username?: string | null }> } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, artifactType: { __typename: 'ArtifactType', id: string, name: string } } | null } | null, project?: { __typename: 'Project', id: string, name: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, entity: { __typename: 'Entity', id: string, name: string, protectedAliases: Array<string>, workflowsAdmins: Array<{ __typename: 'User', id: string, name: string, username?: string | null }> } } | null }
   | null };

export type ArtifactVersionTagsQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
  versionAlias: Scalars['String']['input'];
}>;


export type ArtifactVersionTagsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
   | null };

export type ArtifactIsProtectedQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactIsProtectedQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, isProtected: boolean, artifactSequence: { __typename: 'ArtifactSequence', id: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null } } | null };

export type ArtifactTagsQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactTagsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, attributes: any, tagCategoryName: string } }> }, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, attributes: any, tagCategoryName: string } }> }, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
   | null };

export type ArtifactVersionsTableDataQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactVersionsTableDataQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, ttlDurationSeconds: any, usedCount: number, size: any, isGenerated: boolean, createdAt: string, runHistory: string, createdBy?:
                | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
                | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
               | null, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } | null }> } }
    | { __typename: 'ArtifactSequence', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, ttlDurationSeconds: any, usedCount: number, size: any, isGenerated: boolean, createdAt: string, runHistory: string, createdBy?:
                | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
                | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
               | null, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } | null }> } }
   | null };

export type ArtifactVersionsTableAliasesQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactVersionsTableAliasesQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, project?: { __typename: 'Project', id: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }> } | null }
    | { __typename: 'ArtifactSequence', id: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, project?: { __typename: 'Project', id: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }> } | null }
   | null };

export type ArtifactCollectionOverviewQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactCollectionOverviewQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, versionIndexes: Array<number>, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, versionIndexes: Array<number>, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
   | null };

export type ArtifactCollectionWithRegistryVersionQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
}>;


export type ArtifactCollectionWithRegistryVersionQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, name: string, hasArtifactVersionLinkedToGlobalRegistry: boolean }
        | { __typename: 'ArtifactSequence', id: string, name: string, hasArtifactVersionLinkedToGlobalRegistry: boolean }
       | null } | null } | null };

export type ArtifactCollectionHasProtectedArtifactQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactCollectionHasProtectedArtifactQuery = { __typename: 'Query', artifactSequence?: { __typename: 'ArtifactSequence', id: string, hasProtectedArtifact: boolean } | null };

export type ArtifactProjectMetadataSearchQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type ArtifactProjectMetadataSearchQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifacts: Array<{ __typename: 'Artifact', id: string, digest: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string }, artifactType: { __typename: 'ArtifactType', id: string, name: string } }> } | null };

export type DiscussionThreadPageQueryVariables = Exact<{
  threadID: Scalars['ID']['input'];
}>;


export type DiscussionThreadPageQuery = { __typename: 'Query', discussionThread?: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, deletedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string }, comments: { __typename: 'DiscussionCommentConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'DiscussionCommentEdge', node: { __typename: 'DiscussionComment', id: string, createdAt: string, updatedAt?: string | null, deletedAt?: string | null, body: string, isParent: boolean, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string } } }> } } | null, viewer?: { __typename: 'User', id: string } | null };

export type EotfOrganizationSubscriptionsBasicInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type EotfOrganizationSubscriptionsBasicInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, expiresAt?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type ProjectFromNameQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectFromNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type EntityArtifactTypeQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  artifactType: Scalars['String']['input'];
}>;


export type EntityArtifactTypeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string } | null } | null }> } | null } | null };

export type FetchProjectJobsForTriggersPartialQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchProjectJobsForTriggersPartialQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, createdAt: string, project?: { __typename: 'Project', id: string, name: string, access?: string | null, entity: { __typename: 'Entity', id: string, name: string } } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, createdAt: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
                      | { __typename: 'Run', id: string, name: string, config?: any | null }
                      | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
                     | null, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null } }> } } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, createdAt: string, project?: { __typename: 'Project', id: string, name: string, access?: string | null, entity: { __typename: 'Entity', id: string, name: string } } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, createdAt: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
                      | { __typename: 'Run', id: string, name: string, config?: any | null }
                      | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
                     | null, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null } }> } } }> } }
           | null }> } | null } | null } | null };

export type FetchProjectTriggerExecutionsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  triggerID?: InputMaybe<Scalars['ID']['input']>;
  projectOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchProjectTriggerExecutionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, triggerExecutions: { __typename: 'TriggerExecutionConnection', totalCount: any, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'TriggerExecutionEdge', node: { __typename: 'TriggerExecution', id: string, state: TriggerExecutionState, createdAt: string, updatedAt?: string | null, triggerID?: string | null, triggerName: string, actionStartedAt?: string | null, actionDuration?: number | null, scope?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
            | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
            | { __typename: 'Project', id: string, name: string }
           | null, event?: { __typename: 'TriggerExecutionEvent', eventType: EventTriggeringConditionType, data?:
              | { __typename: 'ArtifactAliasEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, alias?: string | null }
              | { __typename: 'ArtifactEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null }
              | { __typename: 'ArtifactTagEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null }
              | { __typename: 'RunMetricEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, metricName?: string | null, metricValues?: Array<number> | null }
              | { __typename: 'RunStateEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, newRunState?: string | null }
             | null } | null, action?: { __typename: 'TriggerExecutionAction', actionType: TriggeredActionType, data?:
              | { __typename: 'GenericWebhookActionArgs', requestPayload?: any | null, integration?: { __typename: 'GenericWebhookIntegration', name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string, id: string } | null }
              | { __typename: 'NoOpActionArgs' }
              | { __typename: 'PushNotificationActionArgs' }
              | { __typename: 'QueueJobActionArgs', runSpec?: any | null, priority?: number | null }
              | { __typename: 'SlackNotificationActionArgs', title?: string | null, text?: string | null, titleURL?: string | null, severity?: AlertSeverity | null, integration?: { __typename: 'SlackIntegration', channelName: string, id: string } | null }
             | null } | null, result?: { __typename: 'TriggerExecutionResult', resultType: TriggerResultType, data?:
              | { __typename: 'DefaultTriggerResultDetails', error?: { __typename: 'TriggerExecutionError', message: string } | null }
              | { __typename: 'HttpTriggerResultDetails', status?: string | null, statusCode?: number | null, body?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null }
              | { __typename: 'QueuedJobTriggerResultDetails', runQueueItemID?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null }
             | null } | null } }> } } | null };

export type CreateFilterTriggerMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  triggeringEventType: EventTriggeringConditionType;
  scopeType: TriggerScopeType;
  scopeID: Scalars['ID']['input'];
  eventFilter: Scalars['JSONString']['input'];
  triggeredActionType: TriggeredActionType;
  triggeredActionConfig: TriggeredActionConfig;
  enabled: Scalars['Boolean']['input'];
}>;


export type CreateFilterTriggerMutation = { __typename: 'Mutation', createFilterTrigger?: { __typename: 'CreateFilterTriggerPayload', trigger?: { __typename: 'Trigger', id: string } | null } | null };

export type UpdateFilterTriggerMutationVariables = Exact<{
  triggerID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  triggeringEventType: EventTriggeringConditionType;
  scopeType: TriggerScopeType;
  scopeID: Scalars['ID']['input'];
  eventFilter: Scalars['JSONString']['input'];
  triggeredActionType: TriggeredActionType;
  triggeredActionConfig: TriggeredActionConfig;
  enabled: Scalars['Boolean']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFilterTriggerMutation = { __typename: 'Mutation', updateFilterTrigger?: { __typename: 'UpdateFilterTriggerPayload', clientMutationId?: string | null, trigger?: { __typename: 'Trigger', id: string } | null } | null };

type TriggerScopeFragment_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null };

type TriggerScopeFragment_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null };

type TriggerScopeFragment_Project_Fragment = { __typename: 'Project', id: string, name: string };

export type TriggerScopeFragmentFragment =
  | TriggerScopeFragment_ArtifactPortfolio_Fragment
  | TriggerScopeFragment_ArtifactSequence_Fragment
  | TriggerScopeFragment_Project_Fragment
;

export type TriggeringConditionFragmentFragment = { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string };

type TriggeredActionFragment_GenericWebhookTriggeredAction_Fragment = { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, integration:
    | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
    | { __typename: 'GitHubOAuthIntegration' }
    | { __typename: 'SlackIntegration' }
   };

type TriggeredActionFragment_NoOpTriggeredAction_Fragment = { __typename: 'NoOpTriggeredAction' };

type TriggeredActionFragment_NotificationTriggeredAction_Fragment = { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, integration:
    | { __typename: 'GenericWebhookIntegration', id: string }
    | { __typename: 'GitHubOAuthIntegration', id: string }
    | { __typename: 'SlackIntegration', channelName: string, id: string }
   };

type TriggeredActionFragment_PushNotificationTriggeredAction_Fragment = { __typename: 'PushNotificationTriggeredAction' };

type TriggeredActionFragment_QueueJobTriggeredAction_Fragment = { __typename: 'QueueJobTriggeredAction', template: any, queue?: { __typename: 'RunQueue', id: string, name: string } | null };

export type TriggeredActionFragmentFragment =
  | TriggeredActionFragment_GenericWebhookTriggeredAction_Fragment
  | TriggeredActionFragment_NoOpTriggeredAction_Fragment
  | TriggeredActionFragment_NotificationTriggeredAction_Fragment
  | TriggeredActionFragment_PushNotificationTriggeredAction_Fragment
  | TriggeredActionFragment_QueueJobTriggeredAction_Fragment
;

export type TriggerFragmentFragment = { __typename: 'Trigger', id: string, name: string, createdAt: string, enabled: boolean, description?: string | null, createdBy: { __typename: 'User', id: string, name: string }, triggerExecutions: { __typename: 'TriggerExecutionConnection', edges: Array<{ __typename: 'TriggerExecutionEdge', node: { __typename: 'TriggerExecution', id: string, createdAt: string, state: TriggerExecutionState } }> }, scope:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
    | { __typename: 'Project', id: string, name: string }
  , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
    | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, integration:
        | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
        | { __typename: 'GitHubOAuthIntegration' }
        | { __typename: 'SlackIntegration' }
       }
    | { __typename: 'NoOpTriggeredAction' }
    | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, integration:
        | { __typename: 'GenericWebhookIntegration', id: string }
        | { __typename: 'GitHubOAuthIntegration', id: string }
        | { __typename: 'SlackIntegration', channelName: string, id: string }
       }
    | { __typename: 'PushNotificationTriggeredAction' }
    | { __typename: 'QueueJobTriggeredAction', template: any, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
   };

export type FetchProjectTriggersQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  projectOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchProjectTriggersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, triggers: Array<{ __typename: 'Trigger', id: string, name: string, createdAt: string, enabled: boolean, description?: string | null, createdBy: { __typename: 'User', id: string, name: string }, triggerExecutions: { __typename: 'TriggerExecutionConnection', edges: Array<{ __typename: 'TriggerExecutionEdge', node: { __typename: 'TriggerExecution', id: string, createdAt: string, state: TriggerExecutionState } }> }, scope:
        | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
        | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
        | { __typename: 'Project', id: string, name: string }
      , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
        | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, integration:
            | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
            | { __typename: 'GitHubOAuthIntegration' }
            | { __typename: 'SlackIntegration' }
           }
        | { __typename: 'NoOpTriggeredAction' }
        | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, integration:
            | { __typename: 'GenericWebhookIntegration', id: string }
            | { __typename: 'GitHubOAuthIntegration', id: string }
            | { __typename: 'SlackIntegration', channelName: string, id: string }
           }
        | { __typename: 'PushNotificationTriggeredAction' }
        | { __typename: 'QueueJobTriggeredAction', template: any, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
       }> } | null };

export type FetchArtifactCollectionTriggersQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type FetchArtifactCollectionTriggersQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, triggers: { __typename: 'TriggerConnection', edges: Array<{ __typename: 'TriggerEdge', node: { __typename: 'Trigger', id: string, name: string, createdAt: string, enabled: boolean, description?: string | null, createdBy: { __typename: 'User', id: string, name: string }, triggerExecutions: { __typename: 'TriggerExecutionConnection', edges: Array<{ __typename: 'TriggerExecutionEdge', node: { __typename: 'TriggerExecution', id: string, createdAt: string, state: TriggerExecutionState } }> }, scope:
              | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
              | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
              | { __typename: 'Project', id: string, name: string }
            , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
              | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, integration:
                  | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
                  | { __typename: 'GitHubOAuthIntegration' }
                  | { __typename: 'SlackIntegration' }
                 }
              | { __typename: 'NoOpTriggeredAction' }
              | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, integration:
                  | { __typename: 'GenericWebhookIntegration', id: string }
                  | { __typename: 'GitHubOAuthIntegration', id: string }
                  | { __typename: 'SlackIntegration', channelName: string, id: string }
                 }
              | { __typename: 'PushNotificationTriggeredAction' }
              | { __typename: 'QueueJobTriggeredAction', template: any, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
             } }> } }
    | { __typename: 'ArtifactSequence', id: string, name: string, triggers: { __typename: 'TriggerConnection', edges: Array<{ __typename: 'TriggerEdge', node: { __typename: 'Trigger', id: string, name: string, createdAt: string, enabled: boolean, description?: string | null, createdBy: { __typename: 'User', id: string, name: string }, triggerExecutions: { __typename: 'TriggerExecutionConnection', edges: Array<{ __typename: 'TriggerExecutionEdge', node: { __typename: 'TriggerExecution', id: string, createdAt: string, state: TriggerExecutionState } }> }, scope:
              | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
              | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
              | { __typename: 'Project', id: string, name: string }
            , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
              | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, integration:
                  | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
                  | { __typename: 'GitHubOAuthIntegration' }
                  | { __typename: 'SlackIntegration' }
                 }
              | { __typename: 'NoOpTriggeredAction' }
              | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, integration:
                  | { __typename: 'GenericWebhookIntegration', id: string }
                  | { __typename: 'GitHubOAuthIntegration', id: string }
                  | { __typename: 'SlackIntegration', channelName: string, id: string }
                 }
              | { __typename: 'PushNotificationTriggeredAction' }
              | { __typename: 'QueueJobTriggeredAction', template: any, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
             } }> } }
   | null };

export type DeleteTriggerMutationVariables = Exact<{
  triggerID: Scalars['ID']['input'];
}>;


export type DeleteTriggerMutation = { __typename: 'Mutation', deleteTrigger: { __typename: 'DeleteTriggerPayload', success: boolean } };

export type FetchTriggerTemplateVariablesQueryVariables = Exact<{
  eventType: EventTriggeringConditionType;
}>;


export type FetchTriggerTemplateVariablesQuery = { __typename: 'Query', triggerTemplateVariables: Array<{ __typename: 'TriggerTemplateVariable', value: string, help: string }> };

export type RunLogLinesQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  useImprovedPagination?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RunLogLinesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, state?: string | null, logLines?: { __typename: 'LogLineConnection', edges: Array<{ __typename: 'LogLineEdge', node: { __typename: 'LogLine', id?: string | null, label?: string | null, level?: string | null, line?: string | null, timestamp?: string | null } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null } | null };

export type OrganizationMembersTableQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationMembersTableQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, members: Array<{ __typename: 'OrganizationMember', id: string, name: string, username: string, email: string, photoUrl: string, lastActiveAt?: string | null, role: string, modelsSeat: string, weaveRole: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }>, seatAvailability: { __typename: 'OrganizationSeatAvailability', viewOnlySeats: number, seats: number }, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, availableSeatsToPurchase: number, privileges: any, plan: { __typename: 'Plan', id: string, planType: PlanType, unitPrice?: number | null } }>, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null, createdAt?: string | null, role: string, toUser?: { __typename: 'User', id: string, username?: string | null } | null, entity?: { __typename: 'Entity', id: string, name: string } | null }> } | null };

export type WorkspaceSingleRunQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type WorkspaceSingleRunQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, name: string, config?: any | null, createdAt: string, displayName?: string | null, defaultColorIndex?: number | null, state?: string | null } | null } | null };

export type ProjectListFragment = { __typename: 'Project', name: string, access?: string | null, entityName: string, createdAt: string, lastActive?: string | null, totalRuns: number };

export type ProjectsByTeamQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectsByTeamQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, access?: string | null, entityName: string, createdAt: string, lastActive?: string | null, totalRuns: number } | null }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ProjectsByAccountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectsByAccountQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, access?: string | null, entityName: string, createdAt: string, lastActive?: string | null, totalRuns: number } | null }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null } | null };

export type ProjectsByUserQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectsByUserQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, username?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, access?: string | null, entityName: string, createdAt: string, lastActive?: string | null, totalRuns: number } | null }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null } | null };

export type RunComparerQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runNames: Array<Scalars['String']['input']>;
}>;


export type RunComparerQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, codeSaved?: boolean | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, codePath?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null, slurm?: { __typename: 'SlurmInfo', jobId: string } | null } | null } }> } | null } | null };

export type ProjectDetailsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectDetailsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, fromV2?: boolean | null } | null };

export type BackendLinesRunDeltasFragmentFragment = { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null };

export type BackendLinesDeltaQueryFragmentFragment = { __typename: 'Project', entityName: string, name: string, baselineRun?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null };

export type BackendLinesDeltaQueryQueryVariables = Exact<{
  baselineRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  includeBaselineRun?: InputMaybe<Scalars['Boolean']['input']>;
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  pinnedRunsLimit: Scalars['Int']['input'];
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BackendLinesDeltaQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, baselineRun?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null } | null };

export type BackendLinesDeltaQueryInternalIdQueryVariables = Exact<{
  baselineRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  includeBaselineRun?: InputMaybe<Scalars['Boolean']['input']>;
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
  internalId: Scalars['ID']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  pinnedRunsLimit: Scalars['Int']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BackendLinesDeltaQueryInternalIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, baselineRun?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null } | null };

export type RunsInfoQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type RunsInfoQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } }> } | null } | null };

export type RunDeltasFragmentFragment = { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null };

export type DeltaQueryFragmentWithoutRunInfoFragment = { __typename: 'Project', entityName: string, name: string, baselineRun?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null };

export type BucketedRunsDeltaQueryWithoutRunInfoQueryVariables = Exact<{
  baselineRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  includeBaselineRun?: InputMaybe<Scalars['Boolean']['input']>;
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  pinnedRunsLimit: Scalars['Int']['input'];
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BucketedRunsDeltaQueryWithoutRunInfoQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, baselineRun?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null } | null };

export type BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables = Exact<{
  baselineRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  includeBaselineRun?: InputMaybe<Scalars['Boolean']['input']>;
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
  internalId: Scalars['ID']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  pinnedRunsLimit: Scalars['Int']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, baselineRun?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null } | null };

export type GroupedBackendLinesDeltaQueryFragmentFragment = { __typename: 'Project', entityName: string, name: string, groupedRuns?:
    | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', lines: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
    | { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
   | null };

export type GroupedBackendLinesDeltaQueryQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GroupedBackendLinesDeltaQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, groupedRuns?:
      | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', lines: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
      | { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
     | null } | null };

export type GroupedBackendLinesDeltaQueryInternalIdQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  internalId: Scalars['ID']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GroupedBackendLinesDeltaQueryInternalIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, groupedRuns?:
      | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', lines: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
      | { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
     | null } | null };

export type GroupedDeltaQueryFragmentWithoutRunInfoFragment = { __typename: 'Project', groupedRuns?:
    | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', bucketedHistory: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
    | { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
   | null };

export type GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, groupedRuns?:
      | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', bucketedHistory: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
      | { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
     | null } | null };

export type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  internalId: Scalars['ID']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, groupedRuns?:
      | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', bucketedHistory: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
      | { __typename: 'RunConnection', totalCount: number, deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, computeSeconds: number, createdAt: string, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
     | null } | null };

export type ProjectHasProtectedArtifactQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type ProjectHasProtectedArtifactQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, hasProtectedArtifact: boolean } | null };

export type StarProjectMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StarProjectMutation = { __typename: 'Mutation', starProject?: { __typename: 'StarProjectPayload', clientMutationId?: string | null, project?: { __typename: 'Project', id: string, starred: boolean } | null } | null };

export type UnstarProjectMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnstarProjectMutation = { __typename: 'Mutation', unstarProject?: { __typename: 'UnstarProjectPayload', clientMutationId?: string | null, project?: { __typename: 'Project', id: string, starred: boolean } | null } | null };

export type TeamMemberRolesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamMemberRolesQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string } | null }> } | null };

export type UpdateUserProjectRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userProjectRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserProjectRoleMutation = { __typename: 'Mutation', updateProjectMember?: { __typename: 'UpdateProjectMemberPayload', success: boolean, clientMutationId?: string | null } | null };

export type FilteredProjectPickerQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilteredProjectPickerQueryQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null, viewer?: { __typename: 'User', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null, user?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null }> } | null } | null };

export type LegacyMrProjectQueryVariables = Exact<{
  orgEntityName: Scalars['String']['input'];
  registryProjectName: Scalars['String']['input'];
}>;


export type LegacyMrProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, isMigratedRegistryProject: boolean, entity: { __typename: 'Entity', id: string, name: string, modelRegistryMigrationConfig?: { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }, legacyModelRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null };

export type MigratedArtifactCollectionQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
}>;


export type MigratedArtifactCollectionQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, modelRegistryMigratedArtifactCollection?:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
          | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
         | null }
      | { __typename: 'ArtifactSequence', id: string, name: string, modelRegistryMigratedArtifactCollection?:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
          | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
         | null }
     | null } | null };

export type ModelRegistryMigrationConfigFragmentFragment = { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type OrgMrConfigQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrgMrConfigQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, orgEntity?: { __typename: 'Entity', id: string, modelRegistryMigrationConfig?: { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null } | null } | null };

export type EntityMrConfigQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityMrConfigQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, modelRegistryMigrationConfig?: { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null } | null };

export type OrgTeamsMrConfigQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrgTeamsMrConfigQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, teams: Array<{ __typename: 'Entity', id: string, name: string, modelRegistryMigrationConfig?: { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null };

export type FetchArtifactTypeNamesQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchArtifactTypeNamesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactTypeNames?: { __typename: 'ArtifactTypeNameConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactTypeNameEdge', node: string, cursor: string }> } | null } | null } | null };

export type OrganizationMemberFragmentFragment = { __typename: 'OrganizationMember', orgID: string, admin: boolean, username: string, name: string, id: string, email: string, photoUrl: string, role: string, modelsSeat: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null, admin?: boolean | null } };

export type RegistryOrganizationQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type RegistryOrganizationQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', orgID: string, admin: boolean, username: string, name: string, id: string, email: string, photoUrl: string, role: string, modelsSeat: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null, admin?: boolean | null } }>, teams: Array<{ __typename: 'Entity', id: string, name: string, photoUrl?: string | null, memberCount: number }>, serviceAccounts: Array<{ __typename: 'ServiceAccount', id: string, name: string, accountType: UserAccountType }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type OrganizationReadOnlyQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationReadOnlyQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null } | null } | null };

export type ProjectReadOnlyQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type ProjectReadOnlyQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, project?: { __typename: 'Project', id: string, readOnly?: boolean | null } | null } | null };

export type RegistrySearchArtifactMembershipsFragmentFragment = { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null };

type RegistrySearchCollectionFragment_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } };

type RegistrySearchCollectionFragment_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } };

export type RegistrySearchCollectionFragmentFragment =
  | RegistrySearchCollectionFragment_ArtifactPortfolio_Fragment
  | RegistrySearchCollectionFragment_ArtifactSequence_Fragment
;

export type RegistrySearchResultFragmentFragment = { __typename: 'ArtifactCollectionSearchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', artifactMatch: boolean, lastUpdatedAt: string, cursor: string, node:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
      | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
    , artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }> };

export type FetchArtifactCollectionsPartialQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchArtifactCollectionsPartialQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactCollectionsSearch?: { __typename: 'ArtifactCollectionSearchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', artifactMatch: boolean, lastUpdatedAt: string, cursor: string, node:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
          , artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }> } | null } | null } | null };

export type FetchArtifactMembershipsPartialQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchArtifactMembershipsPartialQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }
    | { __typename: 'ArtifactSequence', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }
   | null };

export type FetchArtifactCollectionSupplementalQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type FetchArtifactCollectionSupplementalQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, project?: { __typename: 'Project', id: string, name: string } | null, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number, edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, usedBy: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, user?: { __typename: 'User', id: string, name: string } | null } }> } } }> } }
    | { __typename: 'ArtifactSequence', id: string, project?: { __typename: 'Project', id: string, name: string } | null, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number, edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, usedBy: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, user?: { __typename: 'User', id: string, name: string } | null } }> } } }> } }
   | null };

type RegistryCollectionFragment_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string } };

type RegistryCollectionFragment_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string } };

export type RegistryCollectionFragmentFragment =
  | RegistryCollectionFragment_ArtifactPortfolio_Fragment
  | RegistryCollectionFragment_ArtifactSequence_Fragment
;

type RegistryCollectionWithDetailsFragment_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } };

type RegistryCollectionWithDetailsFragment_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } };

export type RegistryCollectionWithDetailsFragmentFragment =
  | RegistryCollectionWithDetailsFragment_ArtifactPortfolio_Fragment
  | RegistryCollectionWithDetailsFragment_ArtifactSequence_Fragment
;

export type PageInfoFragmentFragment = { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean };

export type ProjectInfoFragmentFragment = { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } };

export type RegistryCollectionsQueryVariables = Exact<{
  organization: Scalars['String']['input'];
  registryFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistryCollectionsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string } }
           | null }> } | null } | null } | null };

export type RegistryCollectionsWithDetailsQueryVariables = Exact<{
  organization: Scalars['String']['input'];
  registryFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistryCollectionsWithDetailsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
           | null }> } | null } | null } | null };

export type CreateRegistryMembersMutationVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
}>;


export type CreateRegistryMembersMutation = { __typename: 'Mutation', createProjectMembers?: { __typename: 'CreateProjectMembersPayload', success: boolean } | null };

export type DeleteRegistryMembersMutationVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
}>;


export type DeleteRegistryMembersMutation = { __typename: 'Mutation', deleteProjectMembers?: { __typename: 'DeleteProjectMembersPayload', success: boolean } | null };

export type UpdateUserRegistryRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userProjectRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserRegistryRoleMutation = { __typename: 'Mutation', updateProjectMember?: { __typename: 'UpdateProjectMemberPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateTeamRegistryRoleMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  teamProjectRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTeamRegistryRoleMutation = { __typename: 'Mutation', updateProjectTeamMember?: { __typename: 'UpdateProjectTeamMemberPayload', success: boolean, clientMutationId?: string | null } | null };

export type ArtifactMembershipFragmentFragment = { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, usedCount: number, artifactCreatedAt: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }
   | null };

export type ArtifactMembershipsQueryVariables = Exact<{
  organization: Scalars['String']['input'];
  registryFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionFilter?: InputMaybe<Scalars['JSONString']['input']>;
  artifactFilter?: InputMaybe<Scalars['JSONString']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactMembershipsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactMemberships?: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, usedCount: number, artifactCreatedAt: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, artifactCollection?:
              | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }
              | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }
             | null } | null }> } | null } | null } | null };

export type RegistryProjectArtifactTypesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RegistryProjectArtifactTypesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> } } | null };

export type RegistryProjectMembersQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RegistryProjectMembersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null, email?: string | null, accountType?: UserAccountType | null } | null, members: Array<{ __typename: 'ProjectMember', id: string, username?: string | null, name?: string | null, photoUrl?: string | null, email?: string | null, accountType: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string } }>, teamMembers: Array<{ __typename: 'ProjectTeamMember', role: { __typename: 'Role', ID: string, name: string }, team: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, memberCount: number, members: Array<{ __typename: 'Member', id?: string | null, name: string, photoUrl?: string | null, accountType?: string | null }> } }> } | null };

export type RegistryProjectMemberQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  memberID: Scalars['ID']['input'];
}>;


export type RegistryProjectMemberQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, member?: { __typename: 'ProjectMember', id: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string } } | null, teamMembers: Array<{ __typename: 'ProjectTeamMember', role: { __typename: 'Role', ID: string, name: string }, team: { __typename: 'Entity', id: string, member?: { __typename: 'Member', id?: string | null } | null } }> } | null };

export type BatchRegistryViewerMembershipQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  viewerID: Scalars['ID']['input'];
  projectIDs: Array<Scalars['ID']['input']>;
}>;


export type BatchRegistryViewerMembershipQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, member?: { __typename: 'ProjectMember', id: string, name?: string | null } | null, teamMembers: Array<{ __typename: 'ProjectTeamMember', team: { __typename: 'Entity', id: string, member?: { __typename: 'Member', id?: string | null, name: string } | null } }> } | null }> } | null };

export type ProjectFragmentFragment = { __typename: 'Project', internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null };

export type RegistryProjectsSearchFragmentFragment = { __typename: 'ProjectConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }> };

export type FetchRegistryProjectsPartialQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchRegistryProjectsPartialQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, registries?: { __typename: 'ProjectConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }> } | null } | null };

export type LegacyRegistryProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type LegacyRegistryProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }> } | null };

export type RegistryProjectsWithTypeQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
}>;


export type RegistryProjectsWithTypeQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, registries?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, allowAllArtifactTypesInRegistry: boolean, entityName: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string } | null } | null }> } | null } | null };

export type UpsertRegistryProjectMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  access?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  allowAllArtifactTypesInRegistry?: InputMaybe<Scalars['Boolean']['input']>;
  artifactTypes?: InputMaybe<Array<ArtifactTypeInput>>;
  icon?: InputMaybe<ProjectIconInput>;
}>;


export type UpsertRegistryProjectMutation = { __typename: 'Mutation', upsertModel?: { __typename: 'UpsertModelPayload', inserted?: boolean | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string } | null, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null } | null };

export type RegistryProjectQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RegistryProjectQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, project?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null } | null } | null };

export type StarredRegistriesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StarredRegistriesQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, starredRegistries?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }> } | null } | null };

export type AddProjectProtectedAliasesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  aliases: Array<Scalars['String']['input']>;
}>;


export type AddProjectProtectedAliasesMutation = { __typename: 'Mutation', addProjectProtectedAliases?: { __typename: 'AddProjectProtectedAliasesPayload', aliases: Array<string> } | null };

export type RemoveProjectProtectedAliasesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  aliases: Array<Scalars['String']['input']>;
}>;


export type RemoveProjectProtectedAliasesMutation = { __typename: 'Mutation', removeProjectProtectedAliases?: { __typename: 'RemoveProjectProtectedAliasesPayload', aliases: Array<string> } | null };

export type ProjectProtectedAliasesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type ProjectProtectedAliasesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }> } | null };

export type ArtifactMembershipsWithAliasCountQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  alias: Scalars['String']['input'];
}>;


export type ArtifactMembershipsWithAliasCountQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactMembershipsWithAliasCount: number } | null };

export type FetchRegistryArtifactCollectionsPartialQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchRegistryArtifactCollectionsPartialQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactCollectionsSearch?: { __typename: 'ArtifactCollectionSearchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', artifactMatch: boolean, lastUpdatedAt: string, cursor: string, node:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
          | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
        , artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }> } | null } | null };

export type FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchEntityModelRegistryArtifactCollectionsPartialQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, artifactCollectionsSearch?: { __typename: 'ArtifactCollectionSearchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', artifactMatch: boolean, lastUpdatedAt: string, cursor: string, node:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
          | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
        , artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }> } | null } | null };

export type StarRegistryMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StarRegistryMutation = { __typename: 'Mutation', starRegistry?: { __typename: 'StarRegistryPayload', clientMutationId?: string | null } | null };

export type UnstarRegistryMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnstarRegistryMutation = { __typename: 'Mutation', unstarRegistry?: { __typename: 'UnstarRegistryPayload', clientMutationId?: string | null } | null };

export type LinkArtifactMutationVariables = Exact<{
  artifactID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
}>;


export type LinkArtifactMutation = { __typename: 'Mutation', linkArtifact?: { __typename: 'LinkArtifactPayload', artifactCollectionID: string, artifactID: string, createdAt: string, versionIndex?: number | null, clientMutationId?: string | null } | null };

export type CreateAndLinkWeaveAssetMutationVariables = Exact<{
  ref: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  artifactPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioName?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
}>;


export type CreateAndLinkWeaveAssetMutation = { __typename: 'Mutation', createAndLinkWeaveAsset?: { __typename: 'LinkArtifactPayload', artifactCollectionID: string, artifactID: string, createdAt: string, versionIndex?: number | null, clientMutationId?: string | null } | null };

export type ImportPanelMenuProjectsQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  selectedEntityName?: InputMaybe<Scalars['String']['input']>;
  projectSearchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportPanelMenuProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null, user?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null }> } | null } | null };

export type ImportPanelMenuEntityFragmentFragment = { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null };

export type ImportPanelMenuViewsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportPanelMenuViewsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, name?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type ImportPanelProjectViewsFragmentFragment = { __typename: 'View', id: string, name?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null };

export type ImportPanelMenuViewSpecQueryVariables = Exact<{
  viewId: Scalars['ID']['input'];
}>;


export type ImportPanelMenuViewSpecQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, spec?: any | null } | null };

export type ReportsTableFragmentFragment = { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null };

export type RunDetailsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunDetailsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, access?: string | null, readOnly?: boolean | null, entity: { __typename: 'Entity', id: string, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null }, run?: { __typename: 'Run', id: string, group?: string | null, displayName?: string | null, name: string, summaryMetrics?: any | null, config?: any | null, createdAt: string, historyMaterializationTask?: { __typename: 'Task', id: string, state: TaskState, progress: number, updatedAt?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, servicesAvailable?: { __typename: 'RunServicesAvailable', tensorboard?: boolean | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string } | null } | null } | null };

export type RunsDetailsUserQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunsDetailsUserQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, user?: { __typename: 'User', id: string, username?: string | null, apiKey?: string | null, accountType?: UserAccountType | null } | null } | null };

export type RunPageLogsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunPageLogsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, group?: string | null, state?: string | null, historyKeys?: any | null, createdAt: string, logLineCount?: number | null, sweep?: { __typename: 'Sweep', id: string } | null, outputLogFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, sizeBytes: any, url?: string | null } | null }> } | null } | null } | null };

export type AllRunGroupsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type AllRunGroupsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, group?: string | null } }> } | null } | null };

export type GetRunsForMoveGroupsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type GetRunsForMoveGroupsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, group?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } }> } | null } | null };

export type MoveRunToGroupMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runId: Scalars['String']['input'];
}>;


export type MoveRunToGroupMutation = { __typename: 'Mutation', upsertBucket?: { __typename: 'UpsertBucketPayload', bucket?: { __typename: 'Run', id: string, group?: string | null } | null } | null };

export type RunValueSuggestionsPaginatedQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  keyPath: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  valuePattern?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunValueSuggestionsPaginatedQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runFieldValues?: { __typename: 'RunFieldValueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'RunFieldValueEdge', node: { __typename: 'RunFieldValue', value?: any | null } }> } | null } | null };

export type RunsTableFragmentFragment = { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type AccountSelectorContextProviderEntityQueryVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type AccountSelectorContextProviderEntityQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, organization?: { __typename: 'Organization', id: string, name: string } | null, members: Array<{ __typename: 'Member', id?: string | null }> } | null };

export type ProfileMenuOrgRoleInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type ProfileMenuOrgRoleInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, role: string, username: string }> } | null };

export type QuickAddMetricSearchQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  runLimit?: InputMaybe<Scalars['Int']['input']>;
  runOrder?: InputMaybe<Scalars['String']['input']>;
  keysPageSize?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type QuickAddMetricSearchQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', metricSearch?: { __typename: 'MetricSearchResults', cursor: string, hasMore: boolean, results: Array<{ __typename: 'MetricInfo', key: string, types: Array<string>, column: MetricColumn }> } | null } | null } | null };

export type ConfigValuesAggregationQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  configKey: Scalars['String']['input'];
  configType: Scalars['String']['input'];
}>;


export type ConfigValuesAggregationQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', configValues?: any | null, configValuesNumberAggregation?: any | null } | null } | null };

export type ConfigValuesCategoriesQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  configKey: Scalars['String']['input'];
  configType: Scalars['String']['input'];
}>;


export type ConfigValuesCategoriesQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', configValues?: any | null, configValuesCategories?: any | null } | null } | null };

export type MetricStatisticsAggregationQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
}>;


export type MetricStatisticsAggregationQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', metricStatisticsAggregation?: any | null } | null } | null };

export type MetricStatisticsQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
}>;


export type MetricStatisticsQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', metricStatistics?: any | null } | null } | null };

export type CreateSemanticLegendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  metricName: Scalars['String']['input'];
  yValue: Scalars['String']['input'];
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bucketUpperBounds: Array<Scalars['Float']['input']>;
  excludedRunColor: Scalars['String']['input'];
}>;


export type CreateSemanticLegendMutation = { __typename: 'Mutation', createSemanticLegend?: { __typename: 'CreateSemanticLegendPayload', success: boolean } | null };

export type UpdateSemanticLegendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  currentMetric: Scalars['String']['input'];
  metricName?: InputMaybe<Scalars['String']['input']>;
  yValue?: InputMaybe<Scalars['String']['input']>;
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bucketUpperBounds?: InputMaybe<Array<Scalars['Float']['input']>>;
  excludedRunColor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSemanticLegendMutation = { __typename: 'Mutation', updateSemanticLegend?: { __typename: 'UpdateSemanticLegendPayload', success: boolean } | null };

export type SemanticLegendsQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SemanticLegendsQueryQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, semanticLegend: { __typename: 'SemanticLegend', currentMetric: string, semanticLegendsByMetric: Array<{ __typename: 'SemanticLegendByMetric', metricName?: string | null, yValue?: string | null, bucketUpperBounds?: Array<number> | null, excludedRunColor?: string | null, lastUpdatedAt?: string | null, customColors: Array<{ __typename: 'CustomColor', bucketNumber: any, colorHex: string }> } | null> } } | null };

export type CreateSemanticLegendWithCategoricalConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  metricName: Scalars['String']['input'];
  yValue: Scalars['String']['input'];
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bucketUpperBounds: Array<Scalars['Float']['input']>;
  excludedRunColor: Scalars['String']['input'];
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type CreateSemanticLegendWithCategoricalConfigMutation = { __typename: 'Mutation', createSemanticLegend?: { __typename: 'CreateSemanticLegendPayload', success: boolean } | null };

export type UpdateSemanticLegendWithCategoricalConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  currentMetric: Scalars['String']['input'];
  metricName?: InputMaybe<Scalars['String']['input']>;
  yValue?: InputMaybe<Scalars['String']['input']>;
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bucketUpperBounds?: InputMaybe<Array<Scalars['Float']['input']>>;
  excludedRunColor?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type UpdateSemanticLegendWithCategoricalConfigMutation = { __typename: 'Mutation', updateSemanticLegend?: { __typename: 'UpdateSemanticLegendPayload', success: boolean } | null };

export type SemanticLegendsQueryWithCategoricalConfigQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SemanticLegendsQueryWithCategoricalConfigQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, semanticLegend: { __typename: 'SemanticLegend', currentMetric: string, semanticLegendsByMetric: Array<{ __typename: 'SemanticLegendByMetric', metricName?: string | null, yValue?: string | null, bucketUpperBounds?: Array<number> | null, excludedRunColor?: string | null, lastUpdatedAt?: string | null, categories?: Array<string> | null, customColors: Array<{ __typename: 'CustomColor', bucketNumber: any, colorHex: string }> } | null> } } | null };

export type UpsertWorkspaceTemplateMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  linePlotTemplateId?: InputMaybe<Scalars['ID']['input']>;
  linePlotSettings?: InputMaybe<Scalars['JSONString']['input']>;
  workspaceLayoutTemplateId?: InputMaybe<Scalars['ID']['input']>;
  workspaceLayoutSettings?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpsertWorkspaceTemplateMutation = { __typename: 'Mutation', upsertWorkspaceTemplate?: { __typename: 'UpsertWorkspaceTemplatePayload', linePlotTemplateId?: string | null, workspaceLayoutTemplateId?: string | null } | null };

export type DeleteWorkspaceTemplateMutationVariables = Exact<{
  linePlotTemplateId?: InputMaybe<Scalars['ID']['input']>;
  workspaceLayoutTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteWorkspaceTemplateMutation = { __typename: 'Mutation', deleteWorkspaceTemplate?: { __typename: 'DeleteWorkspaceTemplatePayload', success: boolean } | null };

export type WorkspaceTemplatesQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkspaceTemplatesQuery = { __typename: 'Query', workspaceTemplates: Array<{ __typename: 'WorkspaceTemplate', id: string, createdAt: string, updatedAt?: string | null, settings?: any | null, settingsVersion?: number | null, type?: WorkspaceTemplateType | null, createdBy: { __typename: 'User', id: string, name: string, email?: string | null, username?: string | null } }> };

export type TeamsForInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamsForInvitesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number }> } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  teamsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  privateProjects?: InputMaybe<Scalars['Boolean']['input']>;
  gpuEnabled?: InputMaybe<Scalars['DateTime']['input']>;
  hubPreset?: InputMaybe<Scalars['String']['input']>;
  repo?: InputMaybe<Scalars['String']['input']>;
  disk?: InputMaybe<Scalars['String']['input']>;
  redisEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dockerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSubscriptionMutation = { __typename: 'Mutation', updateSubscription?: { __typename: 'UpdateSubscriptionPayload', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, limits?: any | null } | null } | null };

export type UpdateEntityPhotoMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  photoUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEntityPhotoMutation = { __typename: 'Mutation', updateEntity?: { __typename: 'UpdateEntityPayload', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, limits?: any | null } | null } | null };

export type TeamQueryQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamQueryQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, limits?: any | null, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } } | null };

export type UserQueryQueryVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type UserQueryQuery = { __typename: 'Query', user?: { __typename: 'User', id: string } | null };

export type AllEntitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllEntitiesQuery = { __typename: 'Query', entities?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, createdAt: string, name: string, memberCount: number, isTeam: boolean, members: Array<{ __typename: 'Member', admin?: boolean | null, pending?: boolean | null, username?: string | null, email?: string | null, name: string, id?: string | null }> } | null }> } | null };

export type UpdateEntityAdminMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  rateLimits?: InputMaybe<RateLimitsInput>;
}>;


export type UpdateEntityAdminMutation = { __typename: 'Mutation', updateEntity?: { __typename: 'UpdateEntityPayload', entity?: { __typename: 'Entity', id: string, isPaid?: boolean | null, rateLimits?: { __typename: 'RateLimits', graphql: number, sdkGraphql: number, filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number } | null } | null } | null };

export type UpdateProjectAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
  rateLimits?: InputMaybe<RateLimitsInput>;
}>;


export type UpdateProjectAdminMutation = { __typename: 'Mutation', upsertModel?: { __typename: 'UpsertModelPayload', project?: { __typename: 'Project', id: string, rateLimits?: { __typename: 'RateLimits', filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number } | null } | null } | null };

export type ProjectRateLimitsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectRateLimitsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, rateLimits?: { __typename: 'RateLimits', filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number } | null } | null };

export type TriggerParquetExportMutationVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type TriggerParquetExportMutation = { __typename: 'Mutation', triggerParquetExport?: { __typename: 'TriggerParquetExportPayload', task: { __typename: 'Task', id: string } } | null };

export type TriggerRecomputeKeysInfoMutationVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type TriggerRecomputeKeysInfoMutation = { __typename: 'Mutation', triggerRecomputeKeysInfo?: { __typename: 'TriggerRecomputeKeysInfoPayload', task: { __typename: 'Task', id: string } } | null };

export type TriggerEventsExportMutationVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type TriggerEventsExportMutation = { __typename: 'Mutation', triggerEventsExport?: { __typename: 'TriggerEventsExportPayload', task: { __typename: 'Task', id: string } } | null };

export type TriggerFlatRunsMigratorMutationVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggerFlatRunsMigratorMutation = { __typename: 'Mutation', triggerFlatRunsMigrator?: { __typename: 'TriggerFlatRunsMigratorPayload', glueTaskName?: string | null } | null };

export type CreateFinishedRunAlertMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type CreateFinishedRunAlertMutation = { __typename: 'Mutation', createFinishedRunAlert?: { __typename: 'CreateAlertPayload', alert: { __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition', success: boolean }
        | { __typename: 'ScriptableRunCondition' }
        | { __typename: 'StoppedRunCondition' }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > } } | null };

export type CreateStoppedRunAlertMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  minimumRunDuration: Scalars['Duration']['input'];
}>;


export type CreateStoppedRunAlertMutation = { __typename: 'Mutation', createStoppedRunAlert?: { __typename: 'CreateAlertPayload', alert: { __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition' }
        | { __typename: 'ScriptableRunCondition' }
        | { __typename: 'StoppedRunCondition', minimumRunDuration: number }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > } } | null };

export type UpdateStoppedRunAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  minimumRunDuration?: InputMaybe<Scalars['Duration']['input']>;
}>;


export type UpdateStoppedRunAlertMutation = { __typename: 'Mutation', updateStoppedRunAlert?: { __typename: 'UpdateAlertPayload', alert: { __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition' }
        | { __typename: 'ScriptableRunCondition' }
        | { __typename: 'StoppedRunCondition', minimumRunDuration: number }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > } } | null };

export type CreateScriptableRunAlertMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type CreateScriptableRunAlertMutation = { __typename: 'Mutation', createScriptableRunAlert?: { __typename: 'CreateAlertPayload', alert: { __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition' }
        | { __typename: 'ScriptableRunCondition', success: boolean }
        | { __typename: 'StoppedRunCondition' }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > } } | null };

export type DeleteAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAlertMutation = { __typename: 'Mutation', deleteAlert?: { __typename: 'DeleteAlertPayload', success?: boolean | null } | null };

export type CreateSlackChannelSubscriptionMutationVariables = Exact<{
  alertID: Scalars['ID']['input'];
  integrationID: Scalars['ID']['input'];
}>;


export type CreateSlackChannelSubscriptionMutation = { __typename: 'Mutation', createSlackChannelSubscription?: { __typename: 'CreateSlackChannelSubscriptionPayload', subscription: { __typename: 'SlackChannelSubscription', id: string } } | null };

export type CreateEmailSubscriptionMutationVariables = Exact<{
  alertID: Scalars['ID']['input'];
}>;


export type CreateEmailSubscriptionMutation = { __typename: 'Mutation', createEmailSubscription?: { __typename: 'CreateEmailSubscriptionPayload', subscription: { __typename: 'EmailSubscription', id: string } } | null };

export type CreateViewCommentsAlertSubscriptionMutationVariables = Exact<{
  viewID: Scalars['ID']['input'];
}>;


export type CreateViewCommentsAlertSubscriptionMutation = { __typename: 'Mutation', createViewCommentsAlertSubscription?: { __typename: 'CreateEmailSubscriptionPayload', subscription: { __typename: 'EmailSubscription', id: string } } | null };

export type DeleteAlertSubscriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAlertSubscriptionMutation = { __typename: 'Mutation', deleteAlertSubscription?: { __typename: 'DeleteAlertSubscriptionPayload', success?: boolean | null } | null };

export type BenchmarkProjectQueryVariables = Exact<{
  name: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type BenchmarkProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, name: string, description?: string | null, readOnly?: boolean | null, entityName: string, views?: any | null, gitHubSubmissionRepo?: string | null, acceptedBenchmarkRuns?: { __typename: 'BenchmarkRunConnection', edges: Array<{ __typename: 'BenchmarkRunEdge', node?: { __typename: 'BenchmarkRun', id: string, gitHubSubmissionPR?: string | null, createdAt: string, details?: any | null, results?: string | null, state: string, user: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null }, originalRun?: { __typename: 'Run', id: string, name: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null, originalProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null, run: { __typename: 'Run', github?: string | null, commit?: string | null, id: string, name: string, displayName?: string | null, notes?: string | null, summaryMetrics?: any | null, user?: { __typename: 'User', id: string, username?: string | null } | null, diffPatchFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any } | null }> } | null }, benchmark: { __typename: 'Project', id: string, name: string, entityName: string } } | null }> } | null, rejectedBenchmarkRuns?: { __typename: 'BenchmarkRunConnection', edges: Array<{ __typename: 'BenchmarkRunEdge', node?: { __typename: 'BenchmarkRun', id: string, gitHubSubmissionPR?: string | null, createdAt: string, details?: any | null, results?: string | null, state: string, user: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null }, originalRun?: { __typename: 'Run', id: string, name: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null, originalProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null, run: { __typename: 'Run', github?: string | null, commit?: string | null, id: string, name: string, displayName?: string | null, notes?: string | null, summaryMetrics?: any | null, user?: { __typename: 'User', id: string, username?: string | null } | null, diffPatchFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any } | null }> } | null }, benchmark: { __typename: 'Project', id: string, name: string, entityName: string } } | null }> } | null, submittedBenchmarkRuns?: { __typename: 'BenchmarkRunConnection', edges: Array<{ __typename: 'BenchmarkRunEdge', node?: { __typename: 'BenchmarkRun', id: string, gitHubSubmissionPR?: string | null, createdAt: string, details?: any | null, results?: string | null, state: string, user: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null }, originalRun?: { __typename: 'Run', id: string, name: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null, originalProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null, run: { __typename: 'Run', github?: string | null, commit?: string | null, id: string, name: string, displayName?: string | null, notes?: string | null, summaryMetrics?: any | null, user?: { __typename: 'User', id: string, username?: string | null } | null, diffPatchFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any } | null }> } | null }, benchmark: { __typename: 'Project', id: string, name: string, entityName: string } } | null }> } | null, entity: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean } } | null };

export type BenchmarkRunsFragmentFragment = { __typename: 'BenchmarkRunConnection', edges: Array<{ __typename: 'BenchmarkRunEdge', node?: { __typename: 'BenchmarkRun', id: string, gitHubSubmissionPR?: string | null, createdAt: string, details?: any | null, results?: string | null, state: string, user: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null }, originalRun?: { __typename: 'Run', id: string, name: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null, originalProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null, run: { __typename: 'Run', github?: string | null, commit?: string | null, id: string, name: string, displayName?: string | null, notes?: string | null, summaryMetrics?: any | null, user?: { __typename: 'User', id: string, username?: string | null } | null, diffPatchFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any } | null }> } | null }, benchmark: { __typename: 'Project', id: string, name: string, entityName: string } } | null }> };

export type SubmitBenchmarkRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isCodeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  benchmarkEntityName?: InputMaybe<Scalars['String']['input']>;
  benchmarkName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitBenchmarkRunMutation = { __typename: 'Mutation', submitBenchmarkRun?: { __typename: 'SubmitBenchmarkRunPayload', benchmarkRun: { __typename: 'BenchmarkRun', id: string, results?: string | null } } | null };

export type PublishBenchmarkRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isCodeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  benchmarkEntityName?: InputMaybe<Scalars['String']['input']>;
  benchmarkName?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublishBenchmarkRunMutation = { __typename: 'Mutation', publishBenchmarkRun?: { __typename: 'PublishBenchmarkRunPayload', benchmarkRun: { __typename: 'BenchmarkRun', id: string, gitHubSubmissionPR?: string | null } } | null };

export type UpdateBenchmarkRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpdateBenchmarkRunMutation = { __typename: 'Mutation', updateBenchmarkRun?: { __typename: 'UpdateBenchmarkRunPayload', benchmarkRun: { __typename: 'BenchmarkRun', id: string, state: string, details?: any | null } } | null };

export type CreateReportsPromptQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateReportsPromptQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } }> } | null } | null };

export type CustomChartFragmentFragment = { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } };

export type CreateCustomChartMutationVariables = Exact<{
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  type: Scalars['String']['input'];
  access: Scalars['String']['input'];
  spec: Scalars['JSONString']['input'];
}>;


export type CreateCustomChartMutation = { __typename: 'Mutation', createCustomChart?: { __typename: 'CreateCustomChartPayload', chart: { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } } } | null };

export type UpdateCustomChartMutationVariables = Exact<{
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  access?: InputMaybe<Scalars['String']['input']>;
  spec?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpdateCustomChartMutation = { __typename: 'Mutation', updateCustomChart?: { __typename: 'UpdateCustomChartPayload', chart: { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } } } | null };

export type DeleteCustomChartMutationVariables = Exact<{
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type DeleteCustomChartMutation = { __typename: 'Mutation', deleteCustomChart?: { __typename: 'DeleteCustomChartPayload', success: boolean } | null };

export type CustomChartsQueryVariables = Exact<{
  entity: Scalars['String']['input'];
}>;


export type CustomChartsQuery = { __typename: 'Query', customCharts?: { __typename: 'CustomChartConnection', edges: Array<{ __typename: 'CustomChartEdge', node: { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } } }> } | null };

export type CustomChartQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CustomChartQuery = { __typename: 'Query', customChart?: { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } } | null };

export type CreateCustomerSubscriptionMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  newOrganizationName: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  trial: Scalars['Boolean']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerSubscriptionMutation = { __typename: 'Mutation', createCustomerSubscription?: { __typename: 'CreateCustomerSubscriptionPayload', subscription?: any | null, organizationId: string, clientMutationId?: string | null } | null };

export type CreateAcademicOrReverseTrialMutationVariables = Exact<{
  newOrganizationName: Scalars['String']['input'];
  newTeamName: Scalars['String']['input'];
  isAcademic: Scalars['Boolean']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAcademicOrReverseTrialMutation = { __typename: 'Mutation', createAcademicOrReverseTrial?: { __typename: 'CreateAcademicOrReverseTrialPayload', clientMutationId?: string | null, orgID: string } | null };

export type CreateCustomerTrialMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
  newOrganizationName: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  trialDays: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerTrialMutation = { __typename: 'Mutation', createCustomerTrial?: { __typename: 'CreateCustomerTrialPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type CancelCustomerSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelCustomerSubscriptionMutation = { __typename: 'Mutation', cancelCustomerSubscription?: { __typename: 'CancelCustomerSubscriptionPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type UpdateCustomerPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerPaymentMethodMutation = { __typename: 'Mutation', updateCustomerPaymentMethod?: { __typename: 'UpdateCustomerPaymentMethodPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type AttachCustomerPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AttachCustomerPaymentMethodMutation = { __typename: 'Mutation', attachCustomerPaymentMethod?: { __typename: 'AttachCustomerPaymentMethodPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type UpdateCustomerDefaultPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerDefaultPaymentMethodMutation = { __typename: 'Mutation', updateCustomerDefaultPaymentMethod?: { __typename: 'UpdateCustomerDefaultPaymentMethodPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type DetachCustomerPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DetachCustomerPaymentMethodMutation = { __typename: 'Mutation', detachCustomerPaymentMethod?: { __typename: 'DetachCustomerPaymentMethodPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type RetryStripeOpenInvoicesByOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type RetryStripeOpenInvoicesByOrganizationMutation = { __typename: 'Mutation', retryStripeOpenInvoicesByOrganization?: { __typename: 'RetryStripeOpenInvoicesByOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type CustomerSubscriptionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerSubscriptionInfoQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, usedSeats: number, stripeBillingInfo?: { __typename: 'StripeBillingInfo', status: string, cancelAtPeriodEnd: boolean, currentPeriodEnd: string, invoiceLink?: string | null, paymentMethod?: { __typename: 'PaymentMethod', id: string, type: string, cardType?: string | null, endingIn?: string | null } | null } | null, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, seats: number, expiresAt?: string | null, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, displayName: string, unitPrice?: number | null, billingInterval?: string | null, planType: PlanType } }>, teams: Array<{ __typename: 'Entity', id: string, name: string, storageBytes: any, referenceBytes: any, computeHours: number }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, name: string, photoUrl: string, admin: boolean, role: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }>, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null }> }> } | null };

export type OrganizationSubscriptionInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSubscriptionInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, orgType: OrgType, flags?: any | null, usedSeats: number, usedViewOnlySeats: number, createdAt: string, stripeCustomerId?: string | null, seatAvailability: { __typename: 'OrganizationSeatAvailability', seats: number, viewOnlySeats: number }, stripeBillingInfo?: { __typename: 'StripeBillingInfo', status: string, cancelAtPeriodEnd: boolean, currentPeriodEnd: string, invoiceLink?: string | null, paymentMethod?: { __typename: 'PaymentMethod', id: string, type: string, cardType?: string | null, endingIn?: string | null } | null, paymentMetadata?: { __typename: 'PaymentMetadata', shouldUpgradeToTeams?: boolean | null } | null } | null, stripePaymentMethods: Array<{ __typename: 'StripePaymentMethod', stripePaymentMethodID: string, type: StripePaymentMethodType, isDefault: boolean, isFailed: boolean, card: { __typename: 'StripePaymentMethodCard', last4: string, brand: CardBrand } }>, stripeInvoices: Array<{ __typename: 'StripeInvoice', number: string, created: string, total: any, status: StripeInvoiceStatus, currency: string, hostedInvoiceURL: string, invoicePDF: string, subscription?: { __typename: 'StripeSubscription', status: string, organizationSubscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, plan: { __typename: 'Plan', id: string, displayName: string } }> } | null }>, billingUser?: { __typename: 'User', id: string, username?: string | null, name: string, email?: string | null, photoUrl?: string | null } | null, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number, photoUrl?: string | null }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, seats: number, expiresAt?: string | null, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, availableSeatsToPurchase: number, isAutomaticUpgrade: boolean, thresholdCrossedAt?: string | null, upgradedAt?: string | null, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, unitPrice?: number | null, billingInterval?: string | null, planType: PlanType, maxSeats: number, displayName: string, defaultPrivileges: any, stripePrice?: { __typename: 'StripePrice', amount: any } | null }, nextPlans: Array<{ __typename: 'Plan', id: string, name: string, displayName: string, billingInterval?: string | null, defaultPrivileges: any, stripePrice?: { __typename: 'StripePrice', amount: any } | null }> }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, name: string, photoUrl: string, admin: boolean, email: string, role: string, modelsSeat: string, weaveRole: string, user: { __typename: 'User', id: string, loggedInAt?: string | null }, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }>, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null, role: string, createdAt?: string | null, entity?: { __typename: 'Entity', id: string, name: string } | null }> } | null };

export type UpgradeCustomerSubscriptionMutationVariables = Exact<{
  planID: Scalars['ID']['input'];
  organizationID: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpgradeCustomerSubscriptionMutation = { __typename: 'Mutation', upgradeCustomerSubscription?: { __typename: 'UpgradeCustomerSubscriptionPayload', subscription?: any | null, organizationID: string, clientMutationId?: string | null } | null };

export type UpgradeCustomerToProPlanMutationVariables = Exact<{
  planID: Scalars['ID']['input'];
  organizationID: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  modelsSeats: Scalars['Int']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpgradeCustomerToProPlanMutation = { __typename: 'Mutation', upgradeCustomerToProPlan?: { __typename: 'upgradeCustomerToProPlanPayload', subscriptionUsage?: any | null, subscriptionCommit?: any | null, organizationID: string, clientMutationId?: string | null } | null };

export type CreateHourOverageSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateHourOverageSubscriptionMutation = { __typename: 'Mutation', createHourOverageSubscription?: { __typename: 'CreateHourOverageSubscriptionPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type UpgradeTrialSubscriptionMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  planID: Scalars['ID']['input'];
}>;


export type UpgradeTrialSubscriptionMutation = { __typename: 'Mutation', upgradeTrialSubscription?: { __typename: 'UpgradeTrialSubscriptionPayload', success: boolean, clientMutationId?: string | null } | null };

export type BenchmarkDiscussionThreadsQueryVariables = Exact<{
  benchmarkEntityName: Scalars['String']['input'];
  benchmarkProjectName: Scalars['String']['input'];
}>;


export type BenchmarkDiscussionThreadsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, benchmarkDiscussionThreads: { __typename: 'DiscussionThreadConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'DiscussionThreadEdge', node: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string }, comments: { __typename: 'DiscussionCommentConnection', totalCount: number } } }> } } | null };

export type CreateBenchmarkDiscussionThreadMutationVariables = Exact<{
  benchmarkEntityName: Scalars['String']['input'];
  benchmarkProjectName: Scalars['String']['input'];
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
}>;


export type CreateBenchmarkDiscussionThreadMutation = { __typename: 'Mutation', createBenchmarkDiscussionThread?: { __typename: 'CreateDiscussionThreadPayload', discussionThread: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string } } } | null };

export type UpdateDiscussionThreadMutationVariables = Exact<{
  discussionThreadID: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;


export type UpdateDiscussionThreadMutation = { __typename: 'Mutation', updateDiscussionThread?: { __typename: 'UpdateDiscussionThreadPayload', discussionThread: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string } } } | null };

export type CreateBenchmarkDiscussionCommentMutationVariables = Exact<{
  discussionThreadID: Scalars['ID']['input'];
  parentCommentID?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
}>;


export type CreateBenchmarkDiscussionCommentMutation = { __typename: 'Mutation', createBenchmarkDiscussionComment?: { __typename: 'CreateDiscussionCommentPayload', discussionComment: { __typename: 'DiscussionComment', id: string, createdAt: string, updatedAt?: string | null, deletedAt?: string | null, body: string, isParent: boolean, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string } } } | null };

export type UpdateDiscussionCommentMutationVariables = Exact<{
  viewID?: InputMaybe<Scalars['ID']['input']>;
  discussionCommentID: Scalars['ID']['input'];
  body: Scalars['String']['input'];
  inlineCommentDetails?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpdateDiscussionCommentMutation = { __typename: 'Mutation', updateDiscussionComment?: { __typename: 'UpdateDiscussionCommentPayload', discussionComment: { __typename: 'DiscussionComment', id: string, createdAt: string, updatedAt?: string | null, deletedAt?: string | null, body: string, isParent: boolean, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null } } } | null };

export type DeleteDiscussionCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  deleteThread?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDiscussionCommentMutation = { __typename: 'Mutation', deleteDiscussionComment?: { __typename: 'DeleteDiscussionCommentPayload', success?: boolean | null } | null };

export type ViewDiscussionThreadsQueryVariables = Exact<{
  viewID: Scalars['ID']['input'];
}>;


export type ViewDiscussionThreadsQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, discussionThreads: { __typename: 'DiscussionThreadConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'DiscussionThreadEdge', node: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null }, comments: { __typename: 'DiscussionCommentConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'DiscussionCommentEdge', node: { __typename: 'DiscussionComment', id: string, createdAt: string, updatedAt?: string | null, body: string, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null } } }> } } }> } } | null };

export type CreateViewDiscussionCommentMutationVariables = Exact<{
  viewID: Scalars['ID']['input'];
  discussionThreadID?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  notifyAllSubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  inlineCommentDetails?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type CreateViewDiscussionCommentMutation = { __typename: 'Mutation', createViewDiscussionComment?: { __typename: 'CreateViewDiscussionCommentPayload', discussionThread: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null } }, discussionComment: { __typename: 'DiscussionComment', id: string, createdAt: string, updatedAt?: string | null, body: string, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null } }, alertSubscription:
      | { __typename: 'EmailSubscription', id: string }
      | { __typename: 'SlackChannelSubscription', id: string }
     } | null };

export type DismissedBannerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DismissedBannerQuery = { __typename: 'Query', dismissedBanner?: { __typename: 'DismissedBanner', id: string, dismissedAt: string } | null };

export type SetDismissedBannerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDismissedBannerMutation = { __typename: 'Mutation', setDismissedBanner?: { __typename: 'SetDismissedBannerPayload', success: boolean } | null };

export type ResendEmailVerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendEmailVerificationMutation = { __typename: 'Mutation', resendEmailVerification?: { __typename: 'ResendEmailVerificationPayload', success: boolean, clientMutationId?: string | null } | null };

export type SelectedAccountEntityOrgQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectedAccountEntityOrgQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string } | null } | null };

export type EntityPageQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityPageQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, entityType?: string | null, available?: boolean | null, name: string, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null, members: Array<{ __typename: 'Member', id?: string | null, name: string, username?: string | null, email?: string | null, photoUrl?: string | null, pending?: boolean | null, accountType?: string | null, role?: string | null }> } | null };

export type EntityTypeQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityTypeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, entityType?: string | null } | null };

export type EntityPageUserStatsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  userStatsStartDate: Scalars['DateTime']['input'];
}>;


export type EntityPageUserStatsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, userStats?: { __typename: 'EntityUserConnection', edges: Array<{ __typename: 'EntityUserEdge', node?: { __typename: 'EntityUser', id: string, runCount: number, user: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null, accountType?: UserAccountType | null } } | null }> } | null } | null };

export type EntityRunsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityRunsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, latestRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } }> } | null } | null };

export type EntitySettingsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EntitySettingsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null, entityProfileEnabled: boolean, hideActivityCalendar: boolean, membersCanInvite?: boolean | null, disableMagicLinkSharing?: boolean | null, disableMembersEditArtifactTTL: boolean, hidden: boolean, defaultCloudRegion: { __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string } } } | null };

export type EntityStorageQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  enableReferenceTracking?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EntityStorageQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, storageBytes: any, referenceBytes: any, computeHours: number, storage?: { __typename: 'EntityStorageNode', id: string, size: any } | null } | null };

export type CachedEntityStorageInfoQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CachedEntityStorageInfoQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, storageBytes: any } | null };

export type ArtifactNodeFragment = { __typename: 'ArtifactSequenceStorageNode', id: string, name: string, size: any, artifactSequenceID: string, artifactType: { __typename: 'ArtifactType', id: string, name: string } };

export type RunNodeFragment = { __typename: 'RunStorageNode', id: string, name: string, size: any, runID: string };

export type ArtifactCollectionStorageTreeQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  enableReferenceTracking: Scalars['Boolean']['input'];
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactCollectionStorageTreeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, artifactCollectionStorageTree?: { __typename: 'ArtifactStorageNodeConnection', edges: Array<{ __typename: 'ArtifactStorageNodeEdge', node: { __typename: 'ArtifactStorageNode', id: string, name: string, size: any, artifactID: string } }> } | null } | null };

export type EntityStorageTreeQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  enableReferenceTracking: Scalars['Boolean']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  cached?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EntityStorageTreeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, storageTree?: { __typename: 'EntityStorageNode', id: string, name: string, size: any, lastUpdatedAt?: string | null, projects: { __typename: 'ProjectStorageNodeConnection', totalSize: any, edges: Array<{ __typename: 'ProjectStorageNodeEdge', node: { __typename: 'ProjectStorageNode', id: string, name: string, size: any, projectID: string, runs?: { __typename: 'RunStorageNodeConnection', totalSize: any, edges: Array<{ __typename: 'RunStorageNodeEdge', node: { __typename: 'RunStorageNode', id: string, name: string, size: any, runID: string } }> }, artifactSequences: { __typename: 'ArtifactSequenceStorageNodeConnection', totalSize: any, edges: Array<{ __typename: 'ArtifactSequenceStorageNodeEdge', node: { __typename: 'ArtifactSequenceStorageNode', id: string, name: string, size: any, artifactSequenceID: string, artifactType: { __typename: 'ArtifactType', id: string, name: string } } }> }, artifactTypes: Array<{ __typename: 'ArtifactTypeStorageNode', id: string, name: string, size: any }> } }> } } | null } | null };

export type GetEmails_UserFragment = { __typename: 'User', id: string, emails: Array<{ __typename: 'Email', id: string, emailAddress: string, type: EmailType, createdAt: string, verified: boolean, identities: Array<{ __typename: 'Identity', id: string, emailIdentityVerified: boolean, provider?: string | null }> }> };

export type UserEmailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEmailsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, emails: Array<{ __typename: 'Email', id: string, emailAddress: string, type: EmailType, createdAt: string, verified: boolean, identities: Array<{ __typename: 'Identity', id: string, emailIdentityVerified: boolean, provider?: string | null }> }> } | null };

export type GlueTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GlueTasksQuery = { __typename: 'Query', glueManager?: { __typename: 'GlueManager', taskTypes: Array<string>, registeredTasks: { __typename: 'GlueTaskConnection', edges: Array<{ __typename: 'GlueTaskEdge', node: { __typename: 'GlueTask', id: string, name: string, taskType: string, arguments?: any | null, checkpoint?: any | null, lastRunAt?: string | null, status: string, strategyType: string, strategyMetadata: string } }> } } | null };

export type GlueTaskConfigQueryVariables = Exact<{
  taskType: Scalars['String']['input'];
}>;


export type GlueTaskConfigQuery = { __typename: 'Query', glueManager?: { __typename: 'GlueManager', taskConfig?: { __typename: 'GlueTaskConfig', defaultArguments: any } | null } | null };

export type GlueRunsQueryVariables = Exact<{
  taskID: Scalars['ID']['input'];
}>;


export type GlueRunsQuery = { __typename: 'Query', glueRuns?: { __typename: 'GlueRunConnection', edges: Array<{ __typename: 'GlueRunEdge', node: { __typename: 'GlueRun', id: string, runAt: string, runtimeMS: any, arguments?: any | null, errors?: any | null, retries: number, succeeded: boolean } }> } | null };

export type CreateGlueTaskMutationVariables = Exact<{
  name: Scalars['String']['input'];
  taskType: Scalars['String']['input'];
  arguments: Scalars['JSONString']['input'];
  status: Scalars['String']['input'];
  strategyType: Scalars['String']['input'];
  strategyMetadata: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateGlueTaskMutation = { __typename: 'Mutation', createGlueTask?: { __typename: 'CreateGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateGlueTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  arguments?: InputMaybe<Scalars['JSONString']['input']>;
  checkpoint?: InputMaybe<Scalars['JSONString']['input']>;
  strategyType?: InputMaybe<Scalars['String']['input']>;
  strategyMetadata?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGlueTaskMutation = { __typename: 'Mutation', updateGlueTask?: { __typename: 'UpdateGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type EnableGlueTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableGlueTaskMutation = { __typename: 'Mutation', enableGlueTask?: { __typename: 'EnableGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type DisableGlueTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableGlueTaskMutation = { __typename: 'Mutation', disableGlueTask?: { __typename: 'DisableGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type DeleteGlueTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGlueTaskMutation = { __typename: 'Mutation', deleteGlueTask?: { __typename: 'DeleteGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type HomePageViewerDetailsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomePageViewerDetailsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, username?: string | null, name: string, photoUrl?: string | null, organizations: Array<{ __typename: 'Organization', id: string, name: string }>, defaultEntity?: { __typename: 'Entity', id: string, name: string } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null } | null }> } | null } | null };

export type HomePageViewerProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomePageViewerProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, createdAt: string } | null }> } | null };

export type ViewerReportsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewerReportsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null } | null };

export type ViewerRunsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ViewerRunsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } }> } | null } | null };

export type EntityProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EntityProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type EntityReportsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityReportsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, views: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } } | null };

export type OrganizationReportsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OrganizationReportsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, views: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } } | null };

export type AccountTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountTeamsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, name: string, username?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, isTeam: boolean, organizationId?: string | null, name: string, defaultAccess: string, privateOnly: boolean, members: Array<{ __typename: 'Member', id?: string | null, name: string, username?: string | null, email?: string | null, pending?: boolean | null, photoUrl?: string | null, accountType?: string | null, role?: string | null, memberRole?: { __typename: 'Role', name: string } | null }> } | null }> } | null } | null };

export type CreateSlackIntegrationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  redirectURI: Scalars['String']['input'];
}>;


export type CreateSlackIntegrationMutation = { __typename: 'Mutation', createSlackIntegration?: { __typename: 'CreateIntegrationPayload', integration:
      | { __typename: 'GenericWebhookIntegration', id: string }
      | { __typename: 'GitHubOAuthIntegration', id: string }
      | { __typename: 'SlackIntegration', id: string }
     } | null };

export type CreateGenericWebhookIntegrationMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  webhookName: Scalars['String']['input'];
  urlEndpoint: Scalars['String']['input'];
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateGenericWebhookIntegrationMutation = { __typename: 'Mutation', createGenericWebhookIntegration?: { __typename: 'CreateIntegrationPayload', integration:
      | { __typename: 'GenericWebhookIntegration', id: string, urlEndpoint: string, name: string }
      | { __typename: 'GitHubOAuthIntegration' }
      | { __typename: 'SlackIntegration' }
     } | null };

export type UpdateGenericWebhookIntegrationMutationVariables = Exact<{
  integrationID: Scalars['ID']['input'];
  webhookName?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint?: InputMaybe<Scalars['String']['input']>;
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGenericWebhookIntegrationMutation = { __typename: 'Mutation', updateGenericWebhookIntegration?: { __typename: 'CreateIntegrationPayload', integration:
      | { __typename: 'GenericWebhookIntegration', id: string, urlEndpoint: string, name: string }
      | { __typename: 'GitHubOAuthIntegration' }
      | { __typename: 'SlackIntegration' }
     } | null };

export type TestGenericWebhookIntegrationMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  urlEndpoint: Scalars['String']['input'];
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
  requestPayload?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type TestGenericWebhookIntegrationMutation = { __typename: 'Mutation', testGenericWebhookIntegration?: { __typename: 'TestGenericWebhookIntegrationPayload', ok: boolean, response: any } | null };

export type DeleteIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIntegrationMutation = { __typename: 'Mutation', deleteIntegration?: { __typename: 'DeleteIntegrationPayload', success?: boolean | null } | null };

export type FetchLaunchAgentsFromProjectQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchLaunchAgentsFromProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string, agentConfig?: any | null, version?: string | null }> } | null };

export type StopLaunchAgentMutationVariables = Exact<{
  agentId: Scalars['ID']['input'];
  stopPolling?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StopLaunchAgentMutation = { __typename: 'Mutation', updateLaunchAgent?: { __typename: 'UpdateLaunchAgentPayload', success?: boolean | null } | null };

export type DeleteLaunchAgentsMutationVariables = Exact<{
  agentIds: Array<Scalars['ID']['input']>;
}>;


export type DeleteLaunchAgentsMutation = { __typename: 'Mutation', deleteLaunchAgents?: { __typename: 'DeleteLaunchAgentsPayload', success?: boolean | null } | null };

export type HasLocalLicenseQueryVariables = Exact<{ [key: string]: never; }>;


export type HasLocalLicenseQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', hasLocalLicense: boolean } | null };

export type LatestLocalVersionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestLocalVersionInfoQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', latestLocalVersionInfo?: { __typename: 'LocalVersionInfo', outOfDate: boolean, latestVersionString: string, versionOnThisInstanceString: string } | null } | null };

export type AvailableFilesQueryQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  filenames: Array<Scalars['String']['input']>;
  includeDirectUrl: Scalars['Boolean']['input'];
}>;


export type AvailableFilesQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl?: string, url?: string | null, md5?: string | null, sizeBytes: any } | null }> } | null } | null } | null };

export type DirectUrlQueryQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  filenames: Array<Scalars['String']['input']>;
}>;


export type DirectUrlQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, url?: string | null, hlsSrc?: string | null, thumbnails: Array<{ __typename: 'Thumbnail', size: any, directUrl: string, originalImageWidth: number, originalImageHeight: number }> } | null }> } | null } | null } | null };

export type ArtifactCodeFileQueryQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  filenames: Array<Scalars['String']['input']>;
}>;


export type ArtifactCodeFileQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, outputArtifacts?: { __typename: 'ArtifactConnection', edges: Array<{ __typename: 'ArtifactEdge', node?: { __typename: 'Artifact', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null, directUrl: string, sizeBytes: any } | null }> } | null } | null }> } | null } | null } | null };

export type AddWorkflowsAdminMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  adminType: WorkflowsAdminType;
}>;


export type AddWorkflowsAdminMutation = { __typename: 'Mutation', addWorkflowsAdmin?: { __typename: 'AddWorkflowsAdminPayload', success: boolean } | null };

export type DeleteWorkflowsAdminMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  adminType: WorkflowsAdminType;
}>;


export type DeleteWorkflowsAdminMutation = { __typename: 'Mutation', deleteWorkflowsAdmin?: { __typename: 'DeleteWorkflowsAdminPayload', success: boolean } | null };

export type AddProtectedAliasesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  aliases: Array<Scalars['String']['input']>;
  adminType: WorkflowsAdminType;
}>;


export type AddProtectedAliasesMutation = { __typename: 'Mutation', addProtectedAliases?: { __typename: 'AddProtectedAliasesPayload', aliases: Array<string> } | null };

export type RemoveProtectedAliasesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  aliases: Array<Scalars['String']['input']>;
  adminType: WorkflowsAdminType;
}>;


export type RemoveProtectedAliasesMutation = { __typename: 'Mutation', removeProtectedAliases?: { __typename: 'RemoveProtectedAliasesPayload', aliases: Array<string> } | null };

export type EntityProtectedAliasesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  workflowsAdminType: WorkflowsAdminType;
}>;


export type EntityProtectedAliasesQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, protectedAliases: Array<string>, workflowsAdmins: Array<{ __typename: 'User', id: string, username?: string | null, name: string, email?: string | null }> } | null };

export type ModelQueryVariables = Exact<{
  name: Scalars['String']['input'];
  logCursor?: InputMaybe<Scalars['String']['input']>;
  fileCursor?: InputMaybe<Scalars['String']['input']>;
  fileLimit?: InputMaybe<Scalars['Int']['input']>;
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  bucketName: Scalars['String']['input'];
  upload?: InputMaybe<Scalars['Boolean']['input']>;
  detailed: Scalars['Boolean']['input'];
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ModelQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null, name: string, entityName: string, description?: string | null, createdAt: string, bucketCount?: number | null, access?: string | null, summaryMetrics?: any | null, views?: any | null, run?: { __typename: 'Run', id: string, name: string, config?: any | null, summaryMetrics?: any | null, systemMetrics?: any | null, readOnly?: boolean | null, framework?: string | null, displayName?: string | null, notes?: string | null, github?: string | null, group?: string | null, jobType?: string | null, createdAt: string, heartbeatAt?: string | null, commit?: string | null, host?: string | null, state?: string | null, shouldStop?: boolean | null, groupCounts?: Array<number> | null, stopped?: boolean | null, defaultColorIndex?: number | null, history: Array<string>, events: Array<string>, fileCount?: number | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpuCount?: number | null, gpu?: string | null } | null, logLines?: { __typename: 'LogLineConnection', edges: Array<{ __typename: 'LogLineEdge', node: { __typename: 'LogLine', id?: string | null, line?: string | null, level?: string | null } }> } | null, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, url?: string | null, sizeBytes: any, updatedAt?: string | null } | null }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null } | null, viewer?: { __typename: 'User', id: string, email?: string | null, photoUrl?: string | null, admin?: boolean | null, defaultFramework?: string | null } | null };

export type UpsertModelMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  access?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['JSONString']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpsertModelMutation = { __typename: 'Mutation', upsertModel?: { __typename: 'UpsertModelPayload', inserted?: boolean | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null, user?: { __typename: 'User', id: string } | null } | null, model?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null, user?: { __typename: 'User', id: string } | null } | null } | null };

export type RenameProjectMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  oldProjectName: Scalars['String']['input'];
  newProjectName: Scalars['String']['input'];
}>;


export type RenameProjectMutation = { __typename: 'Mutation', renameProject?: { __typename: 'UpsertModelPayload', inserted?: boolean | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null } | null, model?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null } | null } | null };

export type DeleteModelMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteModelMutation = { __typename: 'Mutation', deleteModel?: { __typename: 'DeleteModelPayload', success?: boolean | null } | null };

export type ModelsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ModelsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, totalRuns?: number | null, totalUsers?: number | null, lastActive?: string | null } | null }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, viewer?: { __typename: 'User', id: string, email?: string | null, photoUrl?: string | null } | null };

export type NumPendingInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type NumPendingInvitesQuery = { __typename: 'Query', numPendingInvites: number };

export type CreateOAuthProviderMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  issuerUrl: Scalars['String']['input'];
}>;


export type CreateOAuthProviderMutation = { __typename: 'Mutation', createOAuthProvider?: { __typename: 'CreateOAuthProviderPayload', success: boolean } | null };

export type OauthProvidersQueryVariables = Exact<{
  organizationName: Scalars['String']['input'];
}>;


export type OauthProvidersQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, OAuthProviders: Array<{ __typename: 'OAuthProvider', id: string, issuerUrl: string }> } | null };

export type DeleteOAuthProviderMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type DeleteOAuthProviderMutation = { __typename: 'Mutation', deleteOAuthProvider?: { __typename: 'DeleteOAuthProviderPayload', success: boolean } | null };

export type OauthClientsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type OauthClientsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, role?: string | null, OAuthClients: Array<{ __typename: 'OAuthClient', id: string, subject: string }> }> } | null };

export type CreateOAuthClientMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type CreateOAuthClientMutation = { __typename: 'Mutation', createClient?: { __typename: 'CreateClientPayload', success: boolean } | null };

export type DeleteOAuthClientMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type DeleteOAuthClientMutation = { __typename: 'Mutation', revokeClient?: { __typename: 'RevokeClientPayload', success: boolean } | null };

export type ActivityTimelineQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  orgName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ActivityTimelineQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, firstActivity?: string | null, activity: Array<{ __typename: 'OrgActivityTimeline', numActiveUsers: number, startAt: string, endAt: string }> } | null };

export type OrgFlagsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrgFlagsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null } | null };

export type OrgDashboardEnablementQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgDashboardEnablementQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, activity: Array<{ __typename: 'OrgActivityTimeline', numActiveUsers: number }> } | null };

export type OrgDashboardContextQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrgDashboardContextQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, role: string, username: string, modelsSeat: string, weaveRole: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null, activity?: { __typename: 'UserActivityDetails', lastActiveAt?: string | null, startAt: string, endAt: string, daysActive: number, numReports: number, numRuns: number } | null } }>, activeUsersForRange?: { __typename: 'OrgDashboardActiveUsersForRangeStats', last30Days: any, last3Months: any, last6Months: any, last12Months: any, allTime: any } | null } | null };

export type OrgActivityTimelineQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type OrgActivityTimelineQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, activity: Array<{ __typename: 'OrgActivityTimeline', numActiveUsers: number, startAt: string, endAt: string }> } | null };

export type OrgSeatsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgSeatsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, seatAvailability: { __typename: 'OrganizationSeatAvailability', seats: number, viewOnlySeats: number, expiresAt?: string | null } } | null };

export type UserActivityTableQueryVariables = Exact<{ [key: string]: never; }>;


export type UserActivityTableQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, role: string, modelsSeat: string, weaveRole: string, user: { __typename: 'User', id: string, name: string, photoUrl?: string | null, createdAt: string, accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null, activity?: { __typename: 'UserActivityDetails', lastActiveAt?: string | null, daysActive: number, numReports: number, numRuns: number } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null } }> } | null };

export type AddUserToOrganizationMutationVariables = Exact<{
  userName: Scalars['String']['input'];
  teams?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userOrgRole: Scalars['String']['input'];
}>;


export type AddUserToOrganizationMutation = { __typename: 'Mutation', addUserToOrganization?: { __typename: 'AddUserToOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type RemoveUserFromOrganizationMutationVariables = Exact<{
  userName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveUserFromOrganizationMutation = { __typename: 'Mutation', removeUserFromOrganization?: { __typename: 'RemoveUserFromOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type RemoveUserFromOrganizationByIdMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveUserFromOrganizationByIdMutation = { __typename: 'Mutation', removeUserFromOrganizationById?: { __typename: 'RemoveUserFromOrganizationByIdPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  flags?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationMutation = { __typename: 'Mutation', updateOrganization?: { __typename: 'UpdateOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteOrganizationMutation = { __typename: 'Mutation', deleteOrganization?: { __typename: 'DeleteOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateOrganizationUserV2MutationVariables = Exact<{
  userName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userOrgRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationUserV2Mutation = { __typename: 'Mutation', updateOrganizationUserV2?: { __typename: 'UpdateOrganizationUserV2Payload', success: boolean, clientMutationId?: string | null } | null };

export type MakeOrgMembersNoAccessModelsSeatMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MakeOrgMembersNoAccessModelsSeatMutation = { __typename: 'Mutation', makeOrgMembersNoAccessModelsSeat?: { __typename: 'MakeOrgMembersNoAccessModelsSeatPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateModelsSeatMutationVariables = Exact<{
  userID: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  modelsSeat: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateModelsSeatMutation = { __typename: 'Mutation', updateModelsSeat?: { __typename: 'UpdateModelsSeatPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateWeaveRoleMutationVariables = Exact<{
  userID: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  weaveRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateWeaveRoleMutation = { __typename: 'Mutation', updateWeaveRole?: { __typename: 'UpdateWeaveRolePayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateOrganizationBillingUserMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  newBillingUser: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationBillingUserMutation = { __typename: 'Mutation', updateOrganizationBillingUser?: { __typename: 'UpdateOrganizationBillingUserPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpgradeProCustomerMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
  modelsSeats: Scalars['Int']['input'];
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpgradeProCustomerMutation = { __typename: 'Mutation', upgradeProCustomer?: { __typename: 'upgradeProCustomerPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateOrganizationSubscriptionMutationVariables = Exact<{
  organizationSubscriptionID: Scalars['ID']['input'];
  createStripeSubscription: Scalars['Boolean']['input'];
  planID?: InputMaybe<Scalars['ID']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  privileges?: InputMaybe<Scalars['JSONString']['input']>;
  type?: InputMaybe<OrganizationSubscriptionType>;
  status?: InputMaybe<OrganizationSubscriptionStatus>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateOrganizationSubscriptionMutation = { __typename: 'Mutation', updateOrganizationSubscription?: { __typename: 'UpdateOrganizationSubscriptionPayload', success: boolean, clientMutationId?: string | null } | null };

export type DeleteOrganizationSubscriptionMutationVariables = Exact<{
  subscriptionID: Scalars['ID']['input'];
}>;


export type DeleteOrganizationSubscriptionMutation = { __typename: 'Mutation', deleteOrganizationSubscription?: { __typename: 'DeleteOrganizationSubscriptionPayload', success: boolean, clientMutationId?: string | null } | null };

export type LinkTeamToOrganizationMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkTeamToOrganizationMutation = { __typename: 'Mutation', linkTeamToOrganization?: { __typename: 'LinkTeamToOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type WeaveSavingsCalculatorQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type WeaveSavingsCalculatorQuery = { __typename: 'Query', weaveSavingsCalculator?: { __typename: 'WeaveSavingsCalculator', recommendationString: string, totalPossibleSavings: number, recommendedWeaveTier: string } | null };

export type CheckoutPreviewQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
  numberOfModelsSeat: Scalars['Int']['input'];
  couponID?: InputMaybe<Scalars['String']['input']>;
  isMonthly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CheckoutPreviewQuery = { __typename: 'Query', checkoutPreview?: { __typename: 'CheckoutPreview', total: number, renewalDate?: string | null, lineItems: Array<{ __typename: 'CheckoutPreviewLineItemsMetadata', description: string, amount: number, product: string, position: number, discountAmount?: number | null, subLineItems: Array<{ __typename: 'CheckoutPreviewSubLineItemsMetadata', description: string, amount: number, proration: boolean } | null> } | null> } | null };

export type AllOrganizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  queryOrg?: InputMaybe<Scalars['String']['input']>;
  querySubId?: InputMaybe<Scalars['String']['input']>;
  queryUser?: InputMaybe<Scalars['String']['input']>;
  queryTeam?: InputMaybe<Scalars['String']['input']>;
  emailDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllOrganizationsQuery = { __typename: 'Query', organizations: { __typename: 'OrganizationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'OrganizationEdge', node: { __typename: 'Organization', id: string, name: string, orgType: OrgType, flags?: any | null, usedSeats: number, usedViewOnlySeats: number, billingUser?: { __typename: 'User', id: string, username?: string | null, email?: string | null } | null, teams: Array<{ __typename: 'Entity', id: string, name: string }>, stripeBillingInfo?: { __typename: 'StripeBillingInfo', stripeSubscriptionId: string, status: string, currentPeriodEnd: string, cancelAtPeriodEnd: boolean, paymentMethod?: { __typename: 'PaymentMethod', id: string, cardType?: string | null, endingIn?: string | null } | null } | null, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, admin: boolean, name: string, username: string, photoUrl: string, role: string, modelsSeat: string, weaveRole: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', seats: number, id: string, subscriptionType: OrganizationSubscriptionType, stripeSubscriptionId?: string | null, status: OrganizationSubscriptionStatus, expiresAt?: string | null, privileges: any, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType, displayName: string } }> } }> } };

export type OrganizationSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSubscriptionsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, createdAt: string, name: string, flags?: any | null, usedSeats: number, billingUser?: { __typename: 'User', id: string, username?: string | null, email?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, expiresAt?: string | null, privileges: any, seats: number, isAutomaticUpgrade: boolean, createdAt: string, thresholdCrossedAt?: string | null, upgradedAt?: string | null, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType, billingInterval?: string | null }, expansionPacks: { __typename: 'ExpansionPackConnection', edges: Array<{ __typename: 'ExpansionPackEdge', node: { __typename: 'ExpansionPack', id: string, secondsLimit: number, secondsRemaining: number, expiresAt?: string | null } }> } }>, teams: Array<{ __typename: 'Entity', id: string, name: string, computeHours: number, oldComputeHours: number }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, role: string }>, pendingInvites: Array<{ __typename: 'Invite', id: string }> }> } | null };

export type OrganizationStorageInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type OrganizationStorageInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, storageBytes: any, referenceBytes: any }> } | null };

export type OrganizationSubscriptionBasicInfoFragment = { __typename: 'Organization', name: string, orgType: OrgType, memberCount: number, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> };

export type OrganizationSubscriptionsBasicInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSubscriptionsBasicInfoQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, username?: string | null, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, memberCount: number, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> }> } | null };

export type OrganizationSubscriptionBasicInfoByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type OrganizationSubscriptionBasicInfoByNameQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, orgType: OrgType, memberCount: number, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type OrganizationSubscriptionsBasicDetailsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSubscriptionsBasicDetailsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type UpdateOrganizationSubscriptionSeatsMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  seats: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationSubscriptionSeatsMutation = { __typename: 'Mutation', updateOrganizationSubscriptionSeats?: { __typename: 'UpdateOrganizationSubscriptionSeatsPayload', success: boolean, clientMutationId?: string | null } | null };

export type SendRequestOrgEmailDomainVerificationMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendRequestOrgEmailDomainVerificationMutation = { __typename: 'Mutation', sendRequestOrgEmailDomainVerification?: { __typename: 'SendRequestOrgEmailDomainVerificationPayload', success: boolean, clientMutationId?: string | null } | null };

export type OrganizationRunsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
}>;


export type OrganizationRunsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, latestRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } }> } | null } | null };

export type OrganizationServiceAccountsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationServiceAccountsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, serviceAccounts: Array<{ __typename: 'ServiceAccount', id: string, name: string, createdAt: string, apiKey?: string | null, apiKeyCount: number, accountType: UserAccountType, defaultEntity?: { __typename: 'Entity', name: string, id: string } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }> } | null };

export type AccountProjectFragmentFragment = { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null };

export type OrganizationProjectsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationProjectsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type ViewerOrganizationFeatureFlagsQueryVariables = Exact<{
  rampIDType: RampIdType;
}>;


export type ViewerOrganizationFeatureFlagsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, name: string, featureFlags: Array<{ __typename: 'FeatureFlag', rampKey: string, isEnabled: boolean } | null> }> } | null };

export type OrganizationFeatureFlagsQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
}>;


export type OrganizationFeatureFlagsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgType: OrgType, featureFlags: Array<{ __typename: 'FeatureFlag', rampKey: string, isEnabled: boolean } | null> } | null };

export type UpdateOrganizationPrivacySettingsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  privateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  onlyAdminsCanInvite?: InputMaybe<Scalars['Boolean']['input']>;
  disableMagicLinkSharing?: InputMaybe<Scalars['Boolean']['input']>;
  restrictMatchingOrgEmailDomainUsers?: InputMaybe<Scalars['Boolean']['input']>;
  codeSavingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationPrivacySettingsMutation = { __typename: 'Mutation', updateOrganizationPrivacySettings?: { __typename: 'UpdateOrganizationPrivacySettingsPayload', success: boolean, clientMutationId?: string | null } | null };

export type OrganizationMemberRoleQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationMemberRoleQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, member?: { __typename: 'OrganizationMember', id: string, role: string } | null } | null };

export type OrganizationMemberModelsSeatQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationMemberModelsSeatQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, member?: { __typename: 'OrganizationMember', id: string, role: string, modelsSeat: string } | null } | null };

export type OrganizationMemberWeaveRoleQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationMemberWeaveRoleQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, member?: { __typename: 'OrganizationMember', id: string, weaveRole: string } | null } | null };

export type OrganizationMembersQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationMembersQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, name: string, username: string, email: string, photoUrl: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null }, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }> } | null };

export type OrganizationApiKeysQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationApiKeysQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, apiKeysConnection: { __typename: 'OrganizationApiKeyConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null }, edges: Array<{ __typename: 'OrganizationApiKeyEdge', node: { __typename: 'ApiKey', id: string, apiKeyId?: string | null, description?: string | null, createdAt?: string | null, expiresAt?: string | null, lastUsedAt?: string | null, user?: { __typename: 'User', id: string, name: string, accountType?: UserAccountType | null, username?: string | null } | null } }> } } | null };

export type FetchPreviewableLinkQueryVariables = Exact<{
  resourceID: Scalars['ID']['input'];
  resourceType: PreviewableLinkResourceType;
}>;


export type FetchPreviewableLinkQuery = { __typename: 'Query', previewableLink?: { __typename: 'PreviewableLink', id: string, URL: string, createdAt: string, updatedAt?: string | null, resourceID: string, resourceType: PreviewableLinkResourceType } | null };

export type ProfilePageQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ProfilePageQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, photoUrl?: string | null, userInfo?: any | null, hideTeamsFromPublic: boolean, accountType?: UserAccountType | null, defaultEntity?: { __typename: 'Entity', id: string, name: string } | null, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null, starredViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, isTeam: boolean } | null }> } | null } | null };

export type ProfileUserCheckQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ProfileUserCheckQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, name: string, username?: string | null } | null };

export type ProfilePageProjectsQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ProfilePageProjectsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, description?: string | null, totalRuns?: number | null, lastActive?: string | null, runCount: number, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type UserRunsActivityQueryVariables = Exact<{
  username: Scalars['String']['input'];
  dailyRunCountLimit: Scalars['Int']['input'];
}>;


export type UserRunsActivityQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, dailyRunCount: Array<number> } | null };

export type UserRunsQueryVariables = Exact<{
  username: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserRunsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } }> } | null } | null };

export type ProjectNameFromInternalIdQueryVariables = Exact<{
  internalId: Scalars['ID']['input'];
}>;


export type ProjectNameFromInternalIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string } | null };

export type ProjectInternalIdFromNameQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type ProjectInternalIdFromNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, internalId: string } | null };

export type ProjectInfosFromInternalIdsQueryVariables = Exact<{
  internalIds: Array<Scalars['ID']['input']>;
}>;


export type ProjectInfosFromInternalIdsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string } | null }> } | null };

export type AllProjectNamesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllProjectNamesQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null };

export type AllProjectNamesWithPatternQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllProjectNamesWithPatternQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null };

export type MoveProjectsMutationVariables = Exact<{
  projectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEntityName: Scalars['String']['input'];
  destinationEntityName: Scalars['String']['input'];
  ownerUsername: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveProjectsMutation = { __typename: 'Mutation', moveProjects?: { __typename: 'MoveProjectsPayload', tasks: Array<{ __typename: 'Task', id: string, type: string, state: TaskState, progress: number, name: string }> } | null };

export type CloneProjectsMutationVariables = Exact<{
  projectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEntityName: Scalars['String']['input'];
  destinationEntityName: Scalars['String']['input'];
  ownerUsername: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloneProjectsMutation = { __typename: 'Mutation', cloneProjects?: { __typename: 'CloneProjectsPayload', tasks: Array<{ __typename: 'Task', id: string, type: string, state: TaskState, progress: number, name: string }> } | null };

export type MoveHistoryForRunMutationVariables = Exact<{
  sourceEntityName: Scalars['String']['input'];
  sourceProjectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  destinationEntityName: Scalars['String']['input'];
  destinationProjectName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveHistoryForRunMutation = { __typename: 'Mutation', moveHistoryForRun?: { __typename: 'MoveHistoryForRunPayload', task?: { __typename: 'Task', id: string, type: string, state: TaskState, progress: number, name: string } | null } | null };

export type ProjectMemberFieldsFragment = { __typename: 'ProjectMember', id: string, name?: string | null, username?: string | null, email?: string | null, photoUrl?: string | null, accountType: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string, inheritedFrom?: { __typename: 'Role', permissions: Array<{ __typename: 'RolePermission', name: string }> } | null, permissions: Array<{ __typename: 'RolePermission', name: string }> } };

export type ProjectMembersQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type ProjectMembersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, members: Array<{ __typename: 'ProjectMember', id: string, name?: string | null, username?: string | null, email?: string | null, photoUrl?: string | null, accountType: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string, inheritedFrom?: { __typename: 'Role', permissions: Array<{ __typename: 'RolePermission', name: string }> } | null, permissions: Array<{ __typename: 'RolePermission', name: string }> } }> } | null };

export type ProjectMemberQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type ProjectMemberQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, member?: { __typename: 'ProjectMember', id: string, name?: string | null, username?: string | null, email?: string | null, photoUrl?: string | null, accountType: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string, inheritedFrom?: { __typename: 'Role', permissions: Array<{ __typename: 'RolePermission', name: string }> } | null, permissions: Array<{ __typename: 'RolePermission', name: string }> } } | null } | null };

export type CreateProjectMembersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
}>;


export type CreateProjectMembersMutation = { __typename: 'Mutation', createProjectMembers?: { __typename: 'CreateProjectMembersPayload', success: boolean } | null };

export type DeleteProjectMembersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
}>;


export type DeleteProjectMembersMutation = { __typename: 'Mutation', deleteProjectMembers?: { __typename: 'DeleteProjectMembersPayload', success: boolean } | null };

export type ProjectMembersEntityMembersQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectMembersEntityMembersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, members: Array<{ __typename: 'ProjectMember', id: string, role: { __typename: 'Role', ID: string, name: string } }>, entity: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, admin?: boolean | null, pending?: boolean | null, email?: string | null, username?: string | null, name: string, photoUrl?: string | null, accountType?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string, groupName: string, displayName: string }> } | null }> } } | null };

export type RampSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type RampSettingsQuery = { __typename: 'Query', rampManager?: { __typename: 'RampManager', settings: { __typename: 'RampSettingConnection', edges: Array<{ __typename: 'RampSettingEdge', name: string, group: string, description: string, rampType: RampType, rampIDType: RampIdType, stores: Array<{ __typename: 'RampThresholdStore', name: string, thresholds: Array<{ __typename: 'RampSettingThreshold', checkId: string, displayCheckID: string, threshold: number }> }> }> } } | null };

export type IdIsRampedForSettingQueryVariables = Exact<{
  setting: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type IdIsRampedForSettingQuery = { __typename: 'Query', rampManager?: { __typename: 'RampManager', setting?: { __typename: 'RampSettingEdge', idIsRamped: boolean } | null } | null };

export type UpdateRampThresholdMutationVariables = Exact<{
  store: Scalars['String']['input'];
  setting: Scalars['String']['input'];
  checkId: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRampThresholdMutation = { __typename: 'Mutation', updateRampThreshold?: { __typename: 'UpdateRampThresholdPayload', success: boolean, clientMutationId?: string | null } | null };

export type FetchRepoDisplayNameByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchRepoDisplayNameByIdQuery = { __typename: 'Query', repo?: { __typename: 'Repo', id: string, displayName: string } | null };

export type ReportSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type ReportSearchQuery = { __typename: 'Query', reportSearch?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', entityName: string, displayName?: string | null, id: string, projectName: string } | null }> } | null };

export type OrganizationRolesQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationRolesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, roles: Array<{ __typename: 'Role', ID: string, name: string, description?: string | null, inheritedFrom?: { __typename: 'Role', name: string } | null }> } | null };

export type OrganizationRolePermissionsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationRolePermissionsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, roles: Array<{ __typename: 'Role', ID: string, name: string, description?: string | null, inheritedFrom?: { __typename: 'Role', ID: string, name: string } | null, permissions: Array<{ __typename: 'RolePermission', name: string, displayName: string, groupName: string }> }> } | null };

export type CreateRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  inheritedFrom: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
}>;


export type CreateRoleMutation = { __typename: 'Mutation', createRole?: { __typename: 'CreateRolePayload', success: boolean } | null };

export type UpdateRoleMutationVariables = Exact<{
  roleID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inheritedFrom?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRoleMutation = { __typename: 'Mutation', updateRole?: { __typename: 'UpdateRolePayload', success: boolean } | null };

export type DeleteRoleMutationVariables = Exact<{
  roleID: Scalars['ID']['input'];
}>;


export type DeleteRoleMutation = { __typename: 'Mutation', deleteRole?: { __typename: 'DeleteRolePayload', success: boolean } | null };

export type AddRolePermissionsMutationVariables = Exact<{
  roleID: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
}>;


export type AddRolePermissionsMutation = { __typename: 'Mutation', addRolePermissions?: { __typename: 'AddRolePermissionsPayload', success: boolean } | null };

export type DeleteRolePermissionsMutationVariables = Exact<{
  roleID: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
}>;


export type DeleteRolePermissionsMutation = { __typename: 'Mutation', deleteRolePermissions?: { __typename: 'DeleteRolePermissionsPayload', success: boolean } | null };

export type EntityMemberRoleQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type EntityMemberRoleQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, member?: { __typename: 'Member', id?: string | null, role?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string, inheritedFrom?: { __typename: 'Role', permissions: Array<{ __typename: 'RolePermission', name: string, groupName: string, displayName: string }> } | null, permissions: Array<{ __typename: 'RolePermission', name: string, groupName: string, displayName: string }> } | null } | null } | null };

export type RunQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RunQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, internalId: string, name: string, readOnly?: boolean | null, createdAt: string, access?: string | null, views?: any | null, entityName: string, isBenchmark: boolean, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, linkedBenchmark?: { __typename: 'Project', id: string, entityName: string, name: string, gitHubSubmissionRepo?: string | null, views?: any | null } | null, run?: { __typename: 'Run', id: string, name: string, displayName?: string | null, notes?: string | null, config?: any | null, summaryMetrics?: any | null, historyKeys?: any | null, github?: string | null, fileCount?: number | null, createdAt: string, heartbeatAt?: string | null, computeSeconds: number, commit?: string | null, jobType?: string | null, group?: string | null, host?: string | null, state?: string | null, stopped?: boolean | null, logLineCount?: number | null, internalID?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, codeSaved?: boolean | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null, diffPatchFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any } | null }> } | null, outputLogFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any, directUrl: string, url?: string | null } | null }> } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string, details?: any | null, results?: string | null, gitHubSubmissionPR?: string | null, isCodeHidden: boolean, state: string, benchmark: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null, views?: any | null }, run: { __typename: 'Run', id: string, name: string, github?: string | null, summaryMetrics?: any | null, user?: { __typename: 'User', id: string, username?: string | null } | null }, originalProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null, originalRun?: { __typename: 'Run', id: string, name: string } | null } | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, photoUrl?: string | null, accountType?: UserAccountType | null } | null, servicesAvailable?: { __typename: 'RunServicesAvailable', tensorboard?: boolean | null } | null, branchPoint?: { __typename: 'RunBranchPoint', step: any, run: { __typename: 'Run', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null } } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } | null, entity: { __typename: 'Entity', id: string, name: string, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean, codeSavingEnabled: boolean, user?: { __typename: 'User', id: string, username?: string | null, accountType?: UserAccountType | null } | null, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null } } | null };

export type RunQueueItemFragmentFragment = { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null };

export type CreateRunQueueMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
  access: RunQueueAccessType;
  defaultResourceConfigID?: InputMaybe<Scalars['ID']['input']>;
  prioritizationMode: RunQueuePrioritizationMode;
}>;


export type CreateRunQueueMutation = { __typename: 'Mutation', createRunQueue?: { __typename: 'CreateRunQueuePayload', success?: boolean | null, queueID?: string | null } | null };

export type UpdateRunQueueMutationVariables = Exact<{
  queueID: Scalars['ID']['input'];
  defaultResourceConfigID?: InputMaybe<Scalars['ID']['input']>;
  externalLinks?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpdateRunQueueMutation = { __typename: 'Mutation', updateRunQueue?: { __typename: 'UpdateRunQueuePayload', success?: boolean | null } | null };

export type EnableRunQueuePrioritizationMutationVariables = Exact<{
  queueID: Scalars['ID']['input'];
}>;


export type EnableRunQueuePrioritizationMutation = { __typename: 'Mutation', updateRunQueue?: { __typename: 'UpdateRunQueuePayload', success?: boolean | null } | null };

export type DeleteRunQueuesMutationVariables = Exact<{
  queueIDs: Array<Scalars['ID']['input']>;
}>;


export type DeleteRunQueuesMutation = { __typename: 'Mutation', deleteRunQueues?: { __typename: 'DeleteRunQueuesPayload', success?: boolean | null } | null };

export type PushToRunQueueMutationVariables = Exact<{
  queueID: Scalars['ID']['input'];
  runSpec: Scalars['JSONString']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  templateVariableValues?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type PushToRunQueueMutation = { __typename: 'Mutation', pushToRunQueue?: { __typename: 'PushToRunQueuePayload', runQueueItemId: string } | null };

export type DeleteFromRunQueueMutationVariables = Exact<{
  queueID: Scalars['ID']['input'];
  runQueueItemId: Scalars['ID']['input'];
}>;


export type DeleteFromRunQueueMutation = { __typename: 'Mutation', deleteFromRunQueue?: { __typename: 'DeleteFromRunQueuePayload', success?: boolean | null } | null };

export type FetchRunQueuesFromProjectQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchRunQueuesFromProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runQueues: Array<{ __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, access: RunQueueAccessType, updatedAt?: string | null, name: string, defaultResourceConfigID?: string | null, executorInfo: string, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } }> } | null };

export type FetchRunQueueByNameQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runQueueName: Scalars['String']['input'];
}>;


export type FetchRunQueueByNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, access: RunQueueAccessType, updatedAt?: string | null, name: string, defaultResourceConfigID?: string | null, executorInfo: string, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } } | null } | null };

export type FetchRunQueueItemFromProjectQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runQueueName: Scalars['String']['input'];
  runQueueItemID: Scalars['ID']['input'];
}>;


export type FetchRunQueueItemFromProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runQueue?: { __typename: 'RunQueue', id: string, runQueueItem?: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } | null } | null } | null };

export type TeamInfoQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamInfoQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, name: string, admin?: boolean | null }> } | null };

export type RunDisplayNameQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunDisplayNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, displayName?: string | null } | null } | null };

export type RunsStateQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type RunsStateQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null } }> } | null } | null };

export type RunTensorboardQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunTensorboardQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, servicesAvailable?: { __typename: 'RunServicesAvailable', tensorboard?: boolean | null } | null } | null } | null };

export type BasicRunFragmentFragment = { __typename: 'Run', id: string, readOnly?: boolean | null, framework?: string | null, displayName?: string | null, notes?: string | null, github?: string | null, group?: string | null, jobType?: string | null, createdAt: string, heartbeatAt?: string | null, commit?: string | null, host?: string | null, state?: string | null, shouldStop?: boolean | null, groupCounts?: Array<number> | null, stopped?: boolean | null, defaultColorIndex?: number | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpuCount?: number | null, gpu?: string | null } | null };

export type DetailedRunFragmentFragment = { __typename: 'Run', history: Array<string>, events: Array<string>, fileCount?: number | null, logLines?: { __typename: 'LogLineConnection', edges: Array<{ __typename: 'LogLineEdge', node: { __typename: 'LogLine', id?: string | null, line?: string | null, level?: string | null } }> } | null };

export type RunFilesFragmentFragment = { __typename: 'Run', files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, url?: string | null, sizeBytes: any, updatedAt?: string | null } | null }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type SelectRunFragmentFragment = { __typename: 'Run', config?: any | null, summaryMetrics?: any | null, systemMetrics?: any | null };

export type HistoryRunFragmentFragment = { __typename: 'Run', history: Array<string> };

export type SampledHistoryRunFragmentFragment = { __typename: 'Run', sampledHistory: Array<any> };

export type RunsModelQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  bucketIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestSubscribe: Scalars['Boolean']['input'];
  selectEnable?: InputMaybe<Scalars['Boolean']['input']>;
  basicEnable?: InputMaybe<Scalars['Boolean']['input']>;
  history?: InputMaybe<Scalars['Boolean']['input']>;
  historyKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  historySamples?: InputMaybe<Scalars['Int']['input']>;
  sampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  historyFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  groupKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupLevel?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunsModelQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, createdAt: string, entityName: string, description?: string | null, summaryMetrics?: any | null, views?: any | null, requestSubscribe?: boolean | null, runCount: number, runs?: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, historyKeys?: any | null, config?: any | null, summaryMetrics?: any | null, systemMetrics?: any | null, readOnly?: boolean | null, framework?: string | null, notes?: string | null, github?: string | null, group?: string | null, jobType?: string | null, createdAt: string, heartbeatAt?: string | null, commit?: string | null, host?: string | null, state?: string | null, shouldStop?: boolean | null, groupCounts?: Array<number> | null, stopped?: boolean | null, defaultColorIndex?: number | null, history: Array<string>, sampledHistory: Array<any>, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpuCount?: number | null, gpu?: string | null } | null } }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean, endCursor?: string | null, hasNextPage: boolean } } | null } | null, viewer?: { __typename: 'User', id: string, email?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, serverInfo?: { __typename: 'ServerInfo', pollingOK: boolean } | null };

export type UpsertRunMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type UpsertRunMutation = { __typename: 'Mutation', upsertBucket?: { __typename: 'UpsertBucketPayload', inserted?: boolean | null, bucket?: { __typename: 'Run', id: string, name: string, displayName?: string | null, notes?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, project?: { __typename: 'Project', id: string, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } | null } | null } | null };

export type UpsertRunGroupMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type UpsertRunGroupMutation = { __typename: 'Mutation', upsertRunGroup?: { __typename: 'UpsertRunGroupPayload', group?: { __typename: 'RunGroup', id: string, name: string, notes?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, project: { __typename: 'Project', id: string, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } } | null } | null };

export type ModifyRunsMutationVariables = Exact<{
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  addTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type ModifyRunsMutation = { __typename: 'Mutation', modifyRuns?: { __typename: 'ModifyRunsPayload', runsSQL: Array<{ __typename: 'Run', id: string, name: string, config?: any | null, summaryMetrics?: any | null, systemMetrics?: any | null, readOnly?: boolean | null, framework?: string | null, displayName?: string | null, notes?: string | null, github?: string | null, group?: string | null, jobType?: string | null, createdAt: string, heartbeatAt?: string | null, commit?: string | null, host?: string | null, state?: string | null, shouldStop?: boolean | null, groupCounts?: Array<number> | null, stopped?: boolean | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpuCount?: number | null, gpu?: string | null } | null } | null> } | null };

export type MoveRunsMutationVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  sourceEntityName: Scalars['String']['input'];
  sourceProjectName: Scalars['String']['input'];
  destinationEntityName: Scalars['String']['input'];
  destinationProjectName: Scalars['String']['input'];
}>;


export type MoveRunsMutation = { __typename: 'Mutation', moveRuns?: { __typename: 'MoveRunsPayload', task: { __typename: 'Task', id: string } } | null };

export type DeleteRunsMutationVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  deleteArtifacts: Scalars['Boolean']['input'];
}>;


export type DeleteRunsMutation = { __typename: 'Mutation', deleteRuns?: { __typename: 'DeleteRunsPayload', clientMutationId?: string | null, errors?: string | null } | null };

export type UndeleteRunsMutationVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type UndeleteRunsMutation = { __typename: 'Mutation', undeleteRuns?: { __typename: 'UndeleteRunsPayload', clientMutationId?: string | null } | null };

export type DeleteRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  deleteArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteRunMutation = { __typename: 'Mutation', deleteRun?: { __typename: 'DeleteRunPayload', clientMutationId?: string | null } | null };

export type StopRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StopRunMutation = { __typename: 'Mutation', stopRun?: { __typename: 'StopRunPayload', clientMutationId?: string | null } | null };

export type RunStopMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RunStopMutation = { __typename: 'Mutation', stopRun?: { __typename: 'StopRunPayload', success: boolean } | null };

export type DeleteFilesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  projectId: Scalars['Int']['input'];
}>;


export type DeleteFilesMutation = { __typename: 'Mutation', deleteFiles?: { __typename: 'DeleteFilesPayload', clientMutationId?: string | null, success: boolean } | null };

export type DeleteFilesByRunAndFolderMutationVariables = Exact<{
  runName: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  folders: Array<Scalars['String']['input']>;
}>;


export type DeleteFilesByRunAndFolderMutation = { __typename: 'Mutation', deleteFilesByRunAndFolder?: { __typename: 'DeleteFilesPayload', clientMutationId?: string | null, success: boolean } | null };

export type RunHasProtectedOutputArtifactQueryVariables = Exact<{
  runName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type RunHasProtectedOutputArtifactQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, hasProtectedOutputArtifact: boolean } | null } | null };

export type RunsHaveProtectedOutputArtifactsQueryVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type RunsHaveProtectedOutputArtifactsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runsHaveProtectedOutputArtifacts: boolean } | null };

export type InsertSecretMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
  secretValue: Scalars['String']['input'];
}>;


export type InsertSecretMutation = { __typename: 'Mutation', insertSecret?: { __typename: 'InsertSecretPayload', success: boolean } | null };

export type DeleteSecretMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
}>;


export type DeleteSecretMutation = { __typename: 'Mutation', deleteSecret?: { __typename: 'DeleteSecretPayload', success: boolean } | null };

export type SecretsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type SecretsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, secrets: Array<{ __typename: 'Secret', entityId: number, name: string, createdAt: string }> } | null };

export type ServerInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerInfoQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', isGoogleIap: boolean, slackClientID: string, availableCloudRegions: Array<{ __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string }> } | null };

export type LicenseExpirationUiQueryVariables = Exact<{ [key: string]: never; }>;


export type LicenseExpirationUiQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', licenseExpirationUI?: { __typename: 'LicenseExpirationUI', bannerTotalDays: number, bannerDaysRemaining: number, renewUrl?: string | null } | null } | null };

export type UserLimitReachedQueryVariables = Exact<{ [key: string]: never; }>;


export type UserLimitReachedQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', userLimitReached: boolean, viewOnlyUserLimitReached: boolean, licenseFlags: Array<string> } | null };

export type ViewOnlyUserLimitReachedQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewOnlyUserLimitReachedQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', viewOnlyUserLimitReached: boolean } | null };

export type RegisteredModelLimitReachedQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type RegisteredModelLimitReachedQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', registeredModelLimitReached: boolean } | null };

export type ActionHistoryLimitQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactCollectionID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ActionHistoryLimitQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', actionHistoryLimit: number } | null };

export type FrontendHostQueryVariables = Exact<{ [key: string]: never; }>;


export type FrontendHostQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', frontendHost: string } | null };

export type DeploymentIdQueryVariables = Exact<{ [key: string]: never; }>;


export type DeploymentIdQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', deploymentId?: string | null } | null };

export type SecureStorageConnectorEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type SecureStorageConnectorEnabledQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', secureStorageConnectorEnabled: boolean } | null };

export type AvailableBucketProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableBucketProvidersQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', availableBucketProviders: Array<CloudProvider> } | null };

export type DataRetentionDurationQueryVariables = Exact<{ [key: string]: never; }>;


export type DataRetentionDurationQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', dataRetentionDuration: number } | null };

export type FailedPaymentBannersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FailedPaymentBannersQuery = { __typename: 'Query', failedPaymentBanners?: { __typename: 'FailedPaymentBanners', userID: number, orgsWithFailedPayments: Array<{ __typename: 'OrganizationDataForFailedPaymentBanner', id: string, orgId: number, orgName: string, isBillingUser: boolean, billingEmail: string, daysUntilCancellation: number, isCollectionMethodACH: boolean } | null> } | null };

export type StarredProjectsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StarredProjectsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, starredProjects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type CreateStorageSubscriptionMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateStorageSubscriptionMutation = { __typename: 'Mutation', createStorageSubscription?: { __typename: 'CreateStorageSubscriptionPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type CreateInferenceSubscriptionMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateInferenceSubscriptionMutation = { __typename: 'Mutation', createInferenceSubscription?: { __typename: 'CreateInferenceSubscriptionPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type SubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename: 'Query', plans: Array<{ __typename: 'Plan', id: string, name: string, displayName: string, stripePlanId?: string | null, maxSeats: number, defaultPrivileges: any, planType: PlanType, planVisibility: PlanVisibility, unitPrice?: number | null, billingInterval?: string | null } | null> };

export type UpsertSweepMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  priorRunsFilters?: InputMaybe<Scalars['JSONString']['input']>;
  launchScheduler?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpsertSweepMutation = { __typename: 'Mutation', upsertSweep?: { __typename: 'UpsertSweepPayload', inserted?: boolean | null, insertedPriorRuns?: number | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, description?: string | null, state: string } | null } | null };

export type DeleteSweepsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  deleteRuns: Scalars['Boolean']['input'];
}>;


export type DeleteSweepsMutation = { __typename: 'Mutation', deleteSweeps?: { __typename: 'DeleteSweepsPayload', affectedAgents: number, affectedRuns: number } | null };

export type GetTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskQuery = { __typename: 'Query', task?: { __typename: 'Task', id: string, name: string, state: TaskState, progress: number, createdAt: string, updatedAt?: string | null, type: string, result?: string | null } | null };

export type EntityIsTeamQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntityIsTeamQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean } | null };

export type BasicTeamOrganizationQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type BasicTeamOrganizationQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, available?: boolean | null, organization?: { __typename: 'Organization', id: string, name: string } | null } | null };

export type TeamOrganizationQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamOrganizationQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, computeHours: number, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null, membersCanInvite?: boolean | null, disableMagicLinkSharing?: boolean | null }, organization?: { __typename: 'Organization', id: string, name: string, flags?: any | null, usedSeats: number, orgType: OrgType, roles: Array<{ __typename: 'Role', ID: string, name: string, description?: string | null, inheritedFrom?: { __typename: 'Role', name: string } | null }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, role: string, modelsSeat: string, weaveRole: string }>, seatAvailability: { __typename: 'OrganizationSeatAvailability', seats: number, viewOnlySeats: number }, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, subscriptionType: OrganizationSubscriptionType, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, availableSeatsToPurchase: number, seats: number, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType, unitPrice?: number | null, billingInterval?: string | null, defaultPrivileges: any, maxSeats: number } }> } | null } | null };

export type TeamOrganizationRolesQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamOrganizationRolesQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', membersCanInvite?: boolean | null }, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, role?: string | null }>, organization?: { __typename: 'Organization', id: string, seatAvailability: { __typename: 'OrganizationSeatAvailability', viewOnlySeats: number }, roles: Array<{ __typename: 'Role', ID: string, name: string, description?: string | null, inheritedFrom?: { __typename: 'Role', name: string } | null }>, members: Array<{ __typename: 'OrganizationMember', id: string, username: string, role: string }> } | null } | null };

export type TeamOrganizationMembersQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamOrganizationMembersQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, organizationId?: string | null } | null };

export type TeamPageProjectsTwoQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeamPageProjectsTwoQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organizationId?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, totalRuns?: number | null, lastActive?: string | null } | null }> } | null } | null };

export type TeamPageProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamPageProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organizationId?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null } | null }> } | null } | null };

export type FetchTeamProfilePageProjectsByIDsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectIDs: Array<Scalars['ID']['input']>;
}>;


export type FetchTeamProfilePageProjectsByIDsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, lastActive?: string | null, runCount: number, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null };

export type TeamPageQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  workflowsAdminType: WorkflowsAdminType;
}>;


export type TeamPageQuery = { __typename: 'Query', entity?: { __typename: 'Entity', available?: boolean | null, id: string, isTeam: boolean, memberCount: number, name: string, organizationId?: string | null, photoUrl?: string | null, projectCount: number, readOnly?: boolean | null, protectedAliases: Array<string>, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null, members: Array<{ __typename: 'Member', id?: string | null, admin?: boolean | null, pending?: boolean | null, email?: string | null, username?: string | null, name: string, photoUrl?: string | null, accountType?: string | null, apiKey?: string | null, apiKeyCount?: number | null, role?: string | null, serviceAccountAuthMethod?: ServiceAccountAuthMethod | null, memberRole?: { __typename: 'Role', ID: string, name: string } | null }>, invites?: { __typename: 'InviteConnection', edges: Array<{ __typename: 'InviteEdge', node?: { __typename: 'Invite', id: string, email?: string | null, fromUser?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string } | null }> } | null, workflowsAdmins: Array<{ __typename: 'User', id: string, username?: string | null, name: string, email?: string | null }>, publicQueueLaunchAgents: Array<{ __typename: 'User', id: string, username?: string | null, name: string, email?: string | null }> } | null };

export type AvailableTeamQueryVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type AvailableTeamQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, available?: boolean | null } | null };

export type AvailableOrgQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type AvailableOrgQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, available: boolean } | null };

export type OrganizationStorageBucketInfosQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationStorageBucketInfosQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', storageBucketInfo?: { __typename: 'StorageBucketInfo', ID: string, provider: CloudProvider, name: string, kmsKeyID?: string | null, awsExternalID?: string | null, path?: string | null } | null } }> } | null };

export type StorageBucketInfosQueryVariables = Exact<{ [key: string]: never; }>;


export type StorageBucketInfosQuery = { __typename: 'Query', entities?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', storageBucketInfo?: { __typename: 'StorageBucketInfo', ID: string, provider: CloudProvider, name: string, kmsKeyID?: string | null, awsExternalID?: string | null, path?: string | null } | null } } | null }> } | null };

export type CreateTeamMutationVariables = Exact<{
  teamName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  teamAdminUserName?: InputMaybe<Scalars['String']['input']>;
  storageBucketInfo?: InputMaybe<StorageBucketInfoInput>;
}>;


export type CreateTeamMutation = { __typename: 'Mutation', createTeam?: { __typename: 'CreateTeamPayload', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, limits?: any | null } | null } | null };

export type TestBucketStoreConnectionMutationVariables = Exact<{
  input: StorageBucketInfoInput;
}>;


export type TestBucketStoreConnectionMutation = { __typename: 'Mutation', testBucketStoreConnection: Array<{ __typename: 'BucketStoreConnectionError', message: string, severity: ErrorSeverity }> };

export type DeleteTeamMutationVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type DeleteTeamMutation = { __typename: 'Mutation', deleteTeam?: { __typename: 'DeleteTeamPayload', success: boolean } | null };

export type EntityFeatureFlagsQueryVariables = Exact<{
  teamName?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
}>;


export type EntityFeatureFlagsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, featureFlags: Array<{ __typename: 'FeatureFlag', rampKey: string, isEnabled: boolean } | null> } | null };

export type OrganizationTeamsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationTeamsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number, computeHours: number }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, role: string, user: { __typename: 'User', id: string, name: string, accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null } }> } | null };

export type EntityOrganizationQueryVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type EntityOrganizationQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organization?: { __typename: 'Organization', id: string, name: string } | null } | null };

export type UserContextQueryVariables = Exact<{ [key: string]: never; }>;


export type UserContextQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, spec?: any | null } | null }> } | null } | null };

export type ViewerUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerUserInfoQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, userInfo?: any | null } | null };

export type UserOrganizationsQueryVariables = Exact<{
  emailDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserOrganizationsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, members: Array<{ __typename: 'OrganizationMember', id: string, admin: boolean }>, teams: Array<{ __typename: 'Entity', id: string, name: string }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, privileges: any, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType, displayName: string } }> }>, openMatchingOrganizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, flags?: any | null, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, admin: boolean }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, status: OrganizationSubscriptionStatus }>, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> }> } | null };

export type EntityStorageBytesQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EntityStorageBytesQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, storageBytes: any } | null };

export type EntityQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EntityQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, readOnly?: boolean | null, readOnlyAdmin: boolean, isTeam: boolean, privateOnly: boolean, codeSavingEnabled: boolean, artifactTTLDurationSeconds: any, defaultAccess: string, isPaid?: boolean | null, computeHours: number, settings: { __typename: 'EntitySettings', hidden: boolean, openToMatchingOrgEmailDomainUsers?: boolean | null, membersCanInvite?: boolean | null, disableMagicLinkSharing?: boolean | null, disableMembersEditArtifactTTL: boolean, defaultCloudRegion: { __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string }, storageBucketInfo?: { __typename: 'StorageBucketInfo', provider: CloudProvider, name: string, kmsKeyID?: string | null, awsExternalID?: string | null, path?: string | null } | null }, rateLimits?: { __typename: 'RateLimits', graphql: number, sdkGraphql: number, filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number } | null, members: Array<{ __typename: 'Member', id?: string | null, admin?: boolean | null, role?: string | null, pending?: boolean | null, email?: string | null, username?: string | null, name: string, photoUrl?: string | null, accountType?: string | null, apiKey?: string | null }>, defaultAlerts: Array<{ __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition', success: boolean }
        | { __typename: 'ScriptableRunCondition' }
        | { __typename: 'StoppedRunCondition', minimumRunDuration: number }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > }>, integrations?: { __typename: 'IntegrationConnection', edges: Array<{ __typename: 'IntegrationEdge', node?:
          | { __typename: 'GenericWebhookIntegration', id: string, urlEndpoint: string, name: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
          | { __typename: 'GitHubOAuthIntegration', id: string }
          | { __typename: 'SlackIntegration', teamName: string, channelName: string, id: string }
         | null }> } | null, organization?: { __typename: 'Organization', id: string, name: string, orgType: OrgType, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, seats: number, expiresAt?: string | null, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, name: string, photoUrl: string, admin: boolean, role: string }>, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null }> } | null, invites?: { __typename: 'InviteConnection', edges: Array<{ __typename: 'InviteEdge', node?: { __typename: 'Invite', id: string, createdAt?: string | null, name: string, toUser?: { __typename: 'User', id: string, email?: string | null, username?: string | null } | null } | null }> } | null } | null, user?: { __typename: 'User', id: string, username?: string | null, accountType?: UserAccountType | null } | null };

export type EntityIntegrationsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EntityIntegrationsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, integrations?: { __typename: 'IntegrationConnection', edges: Array<{ __typename: 'IntegrationEdge', node?:
          | { __typename: 'GenericWebhookIntegration', id: string, urlEndpoint: string, name: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
          | { __typename: 'GitHubOAuthIntegration', id: string }
          | { __typename: 'SlackIntegration', teamName: string, channelName: string, id: string }
         | null }> } | null } | null };

export type UserRoleFragmentFragment = { __typename: 'User', accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null };

export type EmailBasicFragment = { __typename: 'Email', id: string, emailAddress: string, createdAt: string, type: EmailType };

export type SearchUsersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  queryEmail?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  usernames?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type SearchUsersQuery = { __typename: 'Query', users?: { __typename: 'UserConnection', edges: Array<{ __typename: 'UserEdge', node?: { __typename: 'User', id: string, name: string, loggedInAt?: string | null, userInfo?: any | null, accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null, emails: Array<{ __typename: 'Email', id: string, emailAddress: string, createdAt: string, type: EmailType }> } | null }> } | null };

export type UserFragmentFragment = { __typename: 'User', name: string, email?: string | null, username?: string | null, deletedAt?: string | null, photoUrl?: string | null };

export type FindUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindUsersQuery = { __typename: 'Query', users?: { __typename: 'UserConnection', edges: Array<{ __typename: 'UserEdge', node?: { __typename: 'User', id: string, name: string, email?: string | null, username?: string | null, deletedAt?: string | null, photoUrl?: string | null } | null }> } | null };

export type FindUsersByUsernameQueryVariables = Exact<{
  usernames: Array<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type FindUsersByUsernameQuery = { __typename: 'Query', users?: { __typename: 'UserConnection', edges: Array<{ __typename: 'UserEdge', node?: { __typename: 'User', id: string, name: string, email?: string | null, username?: string | null, deletedAt?: string | null, photoUrl?: string | null } | null }> } | null };

export type UpdateUserRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateUserRoleMutation = { __typename: 'Mutation', updateUserRole?: { __typename: 'UpdateUserRolePayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null, accountType?: UserAccountType | null } | null } | null };

export type UpdateUserRoleV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateUserRoleV2Mutation = { __typename: 'Mutation', updateUserRoleV2?: { __typename: 'UpdateUserRoleV2Payload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null, accountType?: UserAccountType | null } | null } | null };

export type SetUserAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  admin: Scalars['Boolean']['input'];
}>;


export type SetUserAdminMutation = { __typename: 'Mutation', updateUser?: { __typename: 'UpdateUserPayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null } | null } | null };

export type PurgeUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type PurgeUserMutation = { __typename: 'Mutation', purgeUser?: { __typename: 'PurgeUserPayload', user?: { __typename: 'User', id: string, deletedAt?: string | null } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename: 'Mutation', deleteUser?: { __typename: 'DeleteUserPayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null } | null } | null };

export type UndeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UndeleteUserMutation = { __typename: 'Mutation', undeleteUser?: { __typename: 'UndeleteUserPayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null } | null } | null };

export type CreateInviteMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  modelSeat?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateInviteMutation = { __typename: 'Mutation', createInvite?: { __typename: 'CreateInvitePayload', success: boolean, remainingSeats?: number | null, remainingViewOnlySeats?: number | null, invite?: { __typename: 'Invite', id: string, name: string, email?: string | null, createdAt?: string | null, toUser?: { __typename: 'User', id: string, name: string } | null } | null } | null };

export type DeleteInviteMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteInviteMutation = { __typename: 'Mutation', deleteInvite?: { __typename: 'DeleteInvitePayload', success?: boolean | null } | null };

export type UpdateMemberMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  user: Scalars['ID']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateMemberMutation = { __typename: 'Mutation', updateMember?: { __typename: 'UpdateMemberPayload', member: { __typename: 'Member', id?: string | null, role?: string | null } } | null };

export type CreateServiceAccountMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateServiceAccountMutation = { __typename: 'Mutation', createServiceAccount?: { __typename: 'CreateServiceAccountPayload', user?: { __typename: 'User', id: string, name: string, apiKeys?: { __typename: 'ApiKeyConnection', edges: Array<{ __typename: 'ApiKeyEdge', node?: { __typename: 'ApiKey', id: string, name: string } | null }> } | null } | null } | null };

export type CreateOrgServiceAccountMutationVariables = Exact<{
  description: Scalars['String']['input'];
  defaultEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type CreateOrgServiceAccountMutation = { __typename: 'Mutation', createOrgServiceAccount?: { __typename: 'CreateOrgServiceAccountPayload', user?: { __typename: 'User', id: string, name: string, apiKeys?: { __typename: 'ApiKeyConnection', edges: Array<{ __typename: 'ApiKeyEdge', node?: { __typename: 'ApiKey', id: string, name: string } | null }> } | null } | null } | null };

export type DeleteServiceAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteServiceAccountMutation = { __typename: 'Mutation', deleteServiceAccount?: { __typename: 'DeleteServiceAccountPayload', user?: { __typename: 'User', id: string } | null } | null };

export type CreateEntityMutationVariables = Exact<{
  name: Scalars['String']['input'];
  invited?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEntityMutation = { __typename: 'Mutation', createEntity?: { __typename: 'CreateEntityPayload', entity?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, invitedTeam?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null, apiKey?: { __typename: 'ApiKey', id: string, name: string } | null } | null };

export type CreateUserFromAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateUserFromAdminMutation = { __typename: 'Mutation', createUser?: { __typename: 'CreateUserPayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null } | null } | null };

export type CreateEntityOnboardingFlowMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateEntityOnboardingFlowMutation = { __typename: 'Mutation', createEntity?: { __typename: 'CreateEntityPayload', entity?: { __typename: 'Entity', id: string } | null } | null };

export type CheckAvailabilityQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckAvailabilityQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, available?: boolean | null } | null };

export type UpdateUserMutationVariables = Exact<{
  defaultEntity?: InputMaybe<Scalars['String']['input']>;
  defaultFramework?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  settingsVisited?: InputMaybe<Scalars['Boolean']['input']>;
  galleryVisited?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingHidden?: InputMaybe<Scalars['Boolean']['input']>;
  hideTeamsFromPublic?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateUser?: { __typename: 'UpdateUserPayload', user?: { __typename: 'User', id: string, flags?: any | null, entity?: string | null, hideTeamsFromPublic: boolean, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, isTeam: boolean } | null }> } | null } | null } | null };

export type UpdateUserInfoMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  userInfo?: InputMaybe<Scalars['JSONString']['input']>;
  defaultEntity?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserInfoMutation = { __typename: 'Mutation', updateUser?: { __typename: 'UpdateUserPayload', user?: { __typename: 'User', id: string, name: string, userInfo?: any | null, photoUrl?: string | null, entity?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, isTeam: boolean } | null }> } | null } | null } | null };

export type UpdateUserEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  type?: InputMaybe<EmailType>;
}>;


export type UpdateUserEmailMutation = { __typename: 'Mutation', updateUserEmail?: { __typename: 'UpdateUserEmailPayload', success: boolean, email?: { __typename: 'Email', id: string, emailAddress: string } | null } | null };

export type DeleteUserEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserEmailMutation = { __typename: 'Mutation', deleteUserEmail?: { __typename: 'DeleteUserEmailPayload', success: boolean } | null };

export type GenerateApiKeyMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateApiKeyMutation = { __typename: 'Mutation', generateApiKey?: { __typename: 'GenerateApiKeyPayload', secretApiKey?: string | null, apiKey?: { __typename: 'ApiKey', id: string, name: string, description?: string | null, apiKeyId?: string | null, createdAt?: string | null, expiresAt?: string | null, user?: { __typename: 'User', id: string, name: string } | null } | null } | null };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename: 'Mutation', deleteApiKey?: { __typename: 'DeleteApiKeyPayload', success?: boolean | null } | null };

export type CreateServiceAccountApiKeyMutationVariables = Exact<{
  serviceAccountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateServiceAccountApiKeyMutation = { __typename: 'Mutation', createServiceAccountApiKey?: { __typename: 'CreateServiceAccountApiKeyPayload', secretApiKey?: string | null, success?: boolean | null, apiKey?: { __typename: 'ApiKey', id: string, name: string, description?: string | null, apiKeyId?: string | null, createdAt?: string | null, expiresAt?: string | null, user?: { __typename: 'User', id: string, name: string } | null } | null } | null };

export type DeleteServiceAccountApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
  serviceAccountId: Scalars['ID']['input'];
}>;


export type DeleteServiceAccountApiKeyMutation = { __typename: 'Mutation', deleteServiceAccountApiKey?: { __typename: 'DeleteServiceAccountApiKeyPayload', success?: boolean | null } | null };

export type UpdateServiceAccountApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
  serviceAccountId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
}>;


export type UpdateServiceAccountApiKeyMutation = { __typename: 'Mutation', updateServiceAccountApiKey?: { __typename: 'UpdateServiceAccountApiKeyPayload', success?: boolean | null, apiKey?: { __typename: 'ApiKey', id: string, description?: string | null } | null } | null };

export type UpdateApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type UpdateApiKeyMutation = { __typename: 'Mutation', updateApiKey?: { __typename: 'UpdateApiKeyPayload', success?: boolean | null, apiKey?: { __typename: 'ApiKey', id: string, description?: string | null } | null } | null };

export type OrganizationTeamsWithViewerRoleQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationTeamsWithViewerRoleQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, teams: Array<{ __typename: 'Entity', id: string, name: string, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, role?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string, groupName: string, displayName: string }> } | null }> }> } | null, viewer?: { __typename: 'User', id: string, username?: string | null } | null };

export type UpdateEntityMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  defaultAccess?: InputMaybe<Scalars['String']['input']>;
  privateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  codeSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<EntitySettingsInput>;
}>;


export type UpdateEntityMutation = { __typename: 'Mutation', updateEntity?: { __typename: 'UpdateEntityPayload', entity?: { __typename: 'Entity', id: string, defaultAccess: string, privateOnly: boolean, limits?: any | null, settings: { __typename: 'EntitySettings', hidden: boolean, defaultCloudRegion: { __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string } } } | null } | null };

export type ClaimAnonymousEntityMutationVariables = Exact<{
  anonymousApiKey: Scalars['String']['input'];
}>;


export type ClaimAnonymousEntityMutation = { __typename: 'Mutation', claimAnonymousEntity?: { __typename: 'ClaimAnonymousEntityPayload', task: { __typename: 'Task', id: string, type: string, state: TaskState, progress: number, name: string } } | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', resetPassword?: { __typename: 'ResetPasswordPayload', success: boolean } | null };

export type ViewerAllProjectsWithPatternQueryVariables = Exact<{
  pattern?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ViewerAllProjectsWithPatternQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, entity?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null };

export type ViewerQueryVariables = Exact<{
  includeStorage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ViewerQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, analyticsId?: string | null, admin?: boolean | null, email?: string | null, entity?: string | null, defaultFramework?: string | null, photoUrl?: string | null, flags?: any | null, code?: string | null, username?: string | null, createdAt: string, name: string, accountType?: UserAccountType | null, userInfo?: any | null, hideTeamsFromPublic: boolean, limits?: any | null, signupRequired: boolean, personalEntityDisabled: boolean, instanceAdminTeamAccessDisabled: boolean, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean, organizationId?: string | null } | null }> } | null, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType }> }>, defaultEntity?: { __typename: 'Entity', id: string, name: string } | null, userEntity?: { __typename: 'Entity', id: string, name: string, defaultAccess: string, codeSavingEnabled: boolean, storageBytes?: any, isTeam: boolean, settings: { __typename: 'EntitySettings', defaultCloudRegion: { __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string } }, defaultAlerts: Array<{ __typename: 'Alert', id: string, condition:
          | { __typename: 'FinishedRunCondition', success: boolean }
          | { __typename: 'ScriptableRunCondition' }
          | { __typename: 'StoppedRunCondition', minimumRunDuration: number }
        , subscriptions: Array<
          | { __typename: 'EmailSubscription', id: string }
          | { __typename: 'SlackChannelSubscription', id: string }
        > }>, integrations?: { __typename: 'IntegrationConnection', edges: Array<{ __typename: 'IntegrationEdge', node?:
            | { __typename: 'GenericWebhookIntegration', id: string }
            | { __typename: 'GitHubOAuthIntegration', id: string }
            | { __typename: 'SlackIntegration', teamName: string, channelName: string, id: string }
           | null }> } | null, claimedEntities?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null } | null } | null };

export type ViewerPhotoUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerPhotoUrlQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, photoUrl?: string | null } | null };

export type ViewerProjectsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewerProjectsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, entity?: string | null, photoUrl?: string | null, username?: string | null, createdAt: string, linkedProjects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, notes?: string | null, summaryMetrics?: any | null, displayName?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string, results?: string | null, originalRun?: { __typename: 'Run', id: string, name: string } | null } | null } }> } | null } | null }> } | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null };

export type ViewerFeatureFlagsQueryVariables = Exact<{
  rampIDType: RampIdType;
}>;


export type ViewerFeatureFlagsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, featureFlags: Array<{ __typename: 'FeatureFlag', rampKey: string, isEnabled: boolean } | null> } | null };

export type ViewFragmentFragment = { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type ViewFragmentMetadataFragment = { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
    | { __typename: 'EmailSubscription', id: string }
    | { __typename: 'SlackChannelSubscription', id: string }
   | null };

export type UpsertViewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  spec: Scalars['String']['input'];
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpsertViewMutation = { __typename: 'Mutation', upsertView?: { __typename: 'UpsertViewPayload', inserted?: boolean | null, view?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null } | null };

export type DeleteViewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteViewMutation = { __typename: 'Mutation', deleteView?: { __typename: 'DeleteViewPayload', success?: boolean | null } | null };

export type CreateSharedViewMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  spec: Scalars['String']['input'];
}>;


export type CreateSharedViewMutation = { __typename: 'Mutation', upsertSharedView?: { __typename: 'UpsertSharedViewPayload', view?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null } | null };

export type ViewParentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewParentQuery = { __typename: 'Query', viewParent?: { __typename: 'View', id: string, displayName?: string | null } | null };

export type ViewChildrenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewChildrenQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, children?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, user?: { __typename: 'User', id: string } | null } | null }> } | null } | null };

export type AcademicApplicationOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type AcademicApplicationOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type UpsertLinkedBenchmarkMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  access?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['JSONString']['input']>;
  linkedBenchmark?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpsertLinkedBenchmarkMutation = { __typename: 'Mutation', upsertModel?: { __typename: 'UpsertModelPayload', inserted?: boolean | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null, isBenchmark: boolean, linkedBenchmark?: { __typename: 'Project', id: string, name: string } | null } | null } | null };

export type MostActiveMembersQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type MostActiveMembersQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, name: string, username: string, photoUrl: string, daysActive?: number | null, lastActiveAt?: string | null }> } | null };

export type OrganizationMemberActivityQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationMemberActivityQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, lastActiveAt?: string | null }>, activeUsersForRange?: { __typename: 'OrgDashboardActiveUsersForRangeStats', last7Days: any, last30Days: any, last90Days: any, last6Months: any, last12Months: any } | null } | null };

export type CreateAlertThresholdMutationVariables = Exact<{
  input: CreateAlertThresholdInput;
}>;


export type CreateAlertThresholdMutation = { __typename: 'Mutation', createAlertThreshold?: { __typename: 'CreateAlertThresholdPayload', success: boolean, alertThreshold?: { __typename: 'AlertThreshold', id: string, type: AlertThresholdType, value: number, emailSent: boolean, isEnabled: boolean, product: AlertThresholdProduct } | null } | null };

export type DeleteAlertThresholdMutationVariables = Exact<{
  input: DeleteAlertThresholdInput;
}>;


export type DeleteAlertThresholdMutation = { __typename: 'Mutation', deleteAlertThreshold?: { __typename: 'DeleteAlertThresholdPayload', success: boolean } | null };

export type UpdateAlertThresholdMutationVariables = Exact<{
  input: UpdateAlertThresholdInput;
}>;


export type UpdateAlertThresholdMutation = { __typename: 'Mutation', updateAlertThreshold?: { __typename: 'UpdateAlertThresholdPayload', success: boolean, alertThreshold?: { __typename: 'AlertThreshold', id: string, isEnabled: boolean } | null } | null };

export type AlertsTabOrgInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type AlertsTabOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, alertThresholds: Array<{ __typename: 'AlertThreshold', id: string, type: AlertThresholdType, value: number, emailSent: boolean, isEnabled: boolean, product: AlertThresholdProduct }> } | null };

export type CurrentBillingPeriodUsageSectionOrgInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type CurrentBillingPeriodUsageSectionOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, createdAt: string, usedSeats: number, teams: Array<{ __typename: 'Entity', id: string, name: string }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, subscriptionType: OrganizationSubscriptionType, seats: number, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type EnterpriseBillingPeriodOrgInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type EnterpriseBillingPeriodOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, weaveEnterpriseSubscription?: { __typename: 'WeaveEnterpriseSubscription', billingPeriodStart?: string | null, billingPeriodEnd?: string | null } | null } | null };

export type UsageTotalInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  usageType: UsageType;
  intervalMarkers: Array<Scalars['DateTime']['input']>;
}>;


export type UsageTotalInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, createdAt: string, usageTotal: Array<any> } | null };

export type CurrentPlanPageOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type CurrentPlanPageOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, usedSeats: number, createdAt: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, status: OrganizationSubscriptionStatus, seats: number, plan: { __typename: 'Plan', id: string, planType: PlanType, name: string } }>, teams: Array<{ __typename: 'Entity', id: string, name: string }>, stripeBillingInfo?: { __typename: 'StripeBillingInfo', currentPeriodEnd: string } | null } | null };

export type PrimaryPlanCardV3OrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type PrimaryPlanCardV3OrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, usedSeats: number, createdAt: string, teams: Array<{ __typename: 'Entity', id: string, name: string, computeHours: number }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, expiresAt?: string | null, seats: number, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, discount?: { __typename: 'Discount', start: string, end: string, coupon: { __typename: 'Coupon', id: string, amountOff: number, percentOff: number, duration: string, currency: string, name: string } } | null, plan: { __typename: 'Plan', id: string, displayName: string, planType: PlanType, name: string, billingInterval?: string | null, unitPrice?: number | null, stripePrice?: { __typename: 'StripePrice', amount: any } | null } }> } | null };

export type StoragePlanCardV2OrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type StoragePlanCardV2OrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, createdAt: string, teams: Array<{ __typename: 'Entity', id: string, storageBytes: any, referenceBytes: any }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type ServerCurrentBillingPeriodUsageSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerCurrentBillingPeriodUsageSectionQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', contractStartDate?: string | null, weaveLimits?: { __typename: 'WeaveLimits', weaveLimitBytes?: any | null, weaveOverageCostCents?: number | null, weaveOverageUnit?: StorageUnit | null } | null } | null };

export type TotalUsageSectionOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type TotalUsageSectionOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, usedSeats: number, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, seats: number, subscriptionType: OrganizationSubscriptionType, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }>, teams: Array<{ __typename: 'Entity', id: string, computeHours: number, storageBytes: any, referenceBytes: any }> } | null };

export type StorageTableQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type StorageTableQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, teams: Array<{ __typename: 'Entity', id: string, name: string, storageBytes: any, storageTree?: { __typename: 'EntityStorageNode', id: string } | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, storageBytes: any } | null }> } | null }> } | null };

export type DefaultEntityForDomainCaptureDropdownQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type DefaultEntityForDomainCaptureDropdownQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, name: string, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> } | null };

export type OrganizationDefaultModelsSeatQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationDefaultModelsSeatQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, plan: { __typename: 'Plan', id: string, planType: PlanType } }> } | null };

export type OrganizationDomainCaptureSettingQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationDomainCaptureSettingQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> } | null };

export type ViewerDomainClaimBlockingReasonQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type ViewerDomainClaimBlockingReasonQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, domainClaimBlockingReason?: string | null } | null };

export type OrganizationTeamsWithDomainCaptureEnabledQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationTeamsWithDomainCaptureEnabledQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> } | null };

export type EditOrgMembersModalQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type EditOrgMembersModalQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, name: string, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }>, seatAvailability: { __typename: 'OrganizationSeatAvailability', seats: number }, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null }>, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, seats: number, plan: { __typename: 'Plan', id: string, unitPrice?: number | null, planType: PlanType, billingInterval?: string | null } }>, members: Array<{ __typename: 'OrganizationMember', id: string, username: string, role: string, modelsSeat: string, name: string, user: { __typename: 'User', id: string, loggedInAt?: string | null }, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }> } | null };

export type IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables = Exact<{ [key: string]: never; }>;


export type IsEmailDomainClaimedAndShouldRedirectToSsoQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, isEmailDomainClaimedAndShouldRedirectToSSO: boolean } | null };

export type TeamPageShowcasedProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamPageShowcasedProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, lastActive?: string | null, runCount: number, access?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ProfilePageShowcasedProjectsQueryVariables = Exact<{
  username: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfilePageShowcasedProjectsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, description?: string | null, totalRuns?: number | null, lastActive?: string | null, runCount: number, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type SimpleTestQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SimpleTestQueryQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', pollingOK: boolean } | null };

export type HistoricUsageOrganizationInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type HistoricUsageOrganizationInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, username: string, role: string }> } | null };

export type UsageTabInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  usageType: UsageType;
  intervalMarkers: Array<Scalars['DateTime']['input']>;
}>;


export type UsageTabInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, createdAt: string, usage: Array<
      | { __typename: 'InferenceCostUsageAggregation', endpointName: string, inputCount: any, outputCount: any, inputCost: any, outputCost: any, start: string, end: string, value: any, projectName: string, entityName: string }
      | { __typename: 'TrainingCostUsageAggregation', gpuModelID: string, gpuDurationMs: any, start: string, end: string, value: any, projectName: string, entityName: string }
      | { __typename: 'UsageAggregation', start: string, end: string, value: any, projectName: string, entityName: string }
    > } | null };

export type GlobalUsageTabInfoQueryVariables = Exact<{
  usageType: UsageType;
  intervalMarkers: Array<Scalars['DateTime']['input']>;
}>;


export type GlobalUsageTabInfoQuery = { __typename: 'Query', usage: Array<
    | { __typename: 'InferenceCostUsageAggregation', endpointName: string, inputCount: any, outputCount: any, inputCost: any, outputCost: any, start: string, end: string, value: any, projectName: string, entityName: string }
    | { __typename: 'TrainingCostUsageAggregation', gpuModelID: string, gpuDurationMs: any, start: string, end: string, value: any, projectName: string, entityName: string }
    | { __typename: 'UsageAggregation', start: string, end: string, value: any, projectName: string, entityName: string }
  > };

export type WeaveUsageInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  usageType: UsageType;
  intervalMarkers: Array<Scalars['DateTime']['input']>;
}>;


export type WeaveUsageInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, createdAt: string, usageTotal: Array<any> } | null };

export type TrialCardAccountExpirationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type TrialCardAccountExpirationQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, expiresAt?: string | null, status: OrganizationSubscriptionStatus, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type UpsertBenchmarkMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  access?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpsertBenchmarkMutation = { __typename: 'Mutation', upsertModel?: { __typename: 'UpsertModelPayload', inserted?: boolean | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null, isBenchmark: boolean } | null } | null };

export type PredefinedRoleOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type PredefinedRoleOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type OrganizationFlagsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationFlagsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null } | null };

export type FetchProfilePageProjectsByIDsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectIDs: Array<Scalars['ID']['input']>;
}>;


export type FetchProfilePageProjectsByIDsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, lastActive?: string | null, runCount: number, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null };

export type RunOverflowMenuQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunOverflowMenuQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, readOnly?: boolean | null, run?: { __typename: 'Run', id: string, state?: string | null, displayName?: string | null, name: string, commit?: string | null, github?: string | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, runInfo?: { __typename: 'RunInfo', git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null, diffPatchFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, sizeBytes: any } | null }> } | null } | null } | null };

export type RunOverviewQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunOverviewQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, internalId: string, name: string, readOnly?: boolean | null, entityName: string, isBenchmark: boolean, entity: { __typename: 'Entity', id: string, isTeam: boolean }, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, linkedBenchmark?: { __typename: 'Project', id: string, entityName: string, name: string } | null, run?: { __typename: 'Run', id: string, state?: string | null, stopped?: boolean | null, heartbeatAt?: string | null, computeSeconds: number, name: string, displayName?: string | null, notes?: string | null, config?: any | null, createdAt: string, jobType?: string | null, group?: string | null, host?: string | null, internalID?: string | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string, details?: any | null, results?: string | null, gitHubSubmissionPR?: string | null, state: string, benchmark: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null, views?: any | null }, run: { __typename: 'Run', id: string, summaryMetrics?: any | null }, originalProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null, originalRun?: { __typename: 'Run', id: string, name: string } | null } | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, photoUrl?: string | null, accountType?: UserAccountType | null } | null, branchPoint?: { __typename: 'RunBranchPoint', step: any, run: { __typename: 'Run', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null } } | null } | null } | null };

export type RunPageHeaderQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunPageHeaderQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, name: string, notes?: string | null, displayName?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string }> } | null } | null };

export type StartupProgramQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type StartupProgramQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type StartupProgramCouponInfoQueryVariables = Exact<{
  couponID: Scalars['String']['input'];
}>;


export type StartupProgramCouponInfoQuery = { __typename: 'Query', coupon?: { __typename: 'Coupon', id: string } | null };

export type TrialEndOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type TrialEndOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, usedSeats: number, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, name: string }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, expiresAt?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type TrialEndCouponInfoQueryVariables = Exact<{
  couponID: Scalars['String']['input'];
}>;


export type TrialEndCouponInfoQuery = { __typename: 'Query', coupon?: { __typename: 'Coupon', id: string, amountOff: number, percentOff: number, duration: string, currency: string, name: string, durationInMonths: number } | null };

export type CreateAccessTokenMutationVariables = Exact<{
  projects: Array<ProjectSpecifier>;
  viewId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAccessTokenMutation = { __typename: 'Mutation', createAccessToken?: { __typename: 'CreateAccessTokenPayload', toNewUser?: boolean | null, recipientAlreadyOnTeam?: boolean | null, clientMutationId?: string | null, accessToken: { __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> } } | null };

export type RevokeAccessTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevokeAccessTokenMutation = { __typename: 'Mutation', revokeAccessToken?: { __typename: 'RevokeAccessTokenPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateAccessTokenProjectsMutationVariables = Exact<{
  token: Scalars['String']['input'];
  projects: Array<ProjectSpecifier>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAccessTokenProjectsMutation = { __typename: 'Mutation', updateAccessTokenProjects?: { __typename: 'UpdateAccessTokenProjectsPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateAccessTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAccessTokenMutation = { __typename: 'Mutation', updateAccessToken?: { __typename: 'UpdateAccessTokenPayload', toNewUser?: boolean | null, recipientAlreadyOnTeam?: boolean | null, clientMutationId?: string | null, accessToken: { __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> } } | null };

export type RevokeAccessTokenEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevokeAccessTokenEmailMutation = { __typename: 'Mutation', revokeAccessTokenEmail?: { __typename: 'RevokeAccessTokenEmailPayload', clientMutationId?: string | null, accessToken: { __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, view: { __typename: 'View', id: string } } } | null };

export type ArtifactCollectionAliasActionHistoryQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  actionCursor?: InputMaybe<Scalars['String']['input']>;
  actionFirst?: InputMaybe<Scalars['Int']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactCollectionAliasActionHistoryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, isModelRegistryMigratedArtifactCollection: boolean, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, aliasActionHistory: { __typename: 'ArtifactAliasActionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactAliasActionEdge', node: { __typename: 'ArtifactAliasAction', createdAt: string, alias: string, actionType: string, targetArtifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null, sourceArtifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, name: string, accountType?: UserAccountType | null } | null } }> } }
        | { __typename: 'ArtifactSequence', id: string, isModelRegistryMigratedArtifactCollection: boolean, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, aliasActionHistory: { __typename: 'ArtifactAliasActionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactAliasActionEdge', node: { __typename: 'ArtifactAliasAction', createdAt: string, alias: string, actionType: string, targetArtifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null, sourceArtifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, name: string, accountType?: UserAccountType | null } | null } }> } }
       | null } | null } | null };

export type ArtifactCollectionActionHistoryQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  actionCursor?: InputMaybe<Scalars['String']['input']>;
  actionFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArtifactCollectionActionHistoryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, artifactCollectionActions: { __typename: 'ArtifactCollectionActionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionActionEdge', node: { __typename: 'ArtifactCollectionAction', id: string, createdAt: string, actionType: string, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, artifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null } }> } }
        | { __typename: 'ArtifactSequence', id: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, artifactCollectionActions: { __typename: 'ArtifactCollectionActionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionActionEdge', node: { __typename: 'ArtifactCollectionAction', id: string, createdAt: string, actionType: string, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, artifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null } }> } }
       | null } | null } | null };

export type ArtifactCollectionQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  artifactCursor?: InputMaybe<Scalars['String']['input']>;
  artifactFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArtifactCollectionQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string, description?: string | null, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number }, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, createdAt: string, commitHash?: string | null, versionIndex?: number | null, artifact?: { __typename: 'Artifact', id: string, digest: string, state: ArtifactState, createdAt: string } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string, artifactCollection?:
                    | { __typename: 'ArtifactPortfolio', id: string, name: string }
                    | { __typename: 'ArtifactSequence', id: string, name: string }
                   | null }> } | null }> }, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string, artifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null } | null } | null }> }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
        | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number }, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, createdAt: string, commitHash?: string | null, versionIndex?: number | null, artifact?: { __typename: 'Artifact', id: string, digest: string, state: ArtifactState, createdAt: string } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string, artifactCollection?:
                    | { __typename: 'ArtifactPortfolio', id: string, name: string }
                    | { __typename: 'ArtifactSequence', id: string, name: string }
                   | null }> } | null }> }, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string, artifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null } | null } | null }> }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
       | null } | null } | null };

export type EntityPortfoliosQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
}>;


export type EntityPortfoliosQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                  | { __typename: 'ArtifactPortfolio', id: string, name: string }
                  | { __typename: 'ArtifactSequence', id: string, name: string }
                 | null }> } | null } | null } | null }> } | null } | null };

export type ArtifactCollectionNameFromIdQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactCollectionNameFromIdQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
   | null };

export type ArtifactFilesQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  artifactFileNames: Array<Scalars['String']['input']>;
}>;


export type ArtifactFilesQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, createdAt: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, displayName: string, digest?: string | null, url?: string | null, directUrl: string, isReference: boolean, sizeBytes: any, updatedAt?: string | null } | null }> } | null } | null };

export type ArtifactIdQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
  artifactID: Scalars['String']['input'];
}>;


export type ArtifactIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifact?: { __typename: 'Artifact', id: string } | null } | null } | null };

export type ArtifactPathInfoQueryVariables = Exact<{
  artifactId: Scalars['ID']['input'];
}>;


export type ArtifactPathInfoQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, createdAt: string, commitHash?: string | null, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string }, artifactType: { __typename: 'ArtifactType', id: string, name: string, project: { __typename: 'Project', id: string, name: string, entityName: string } } } | null };

export type ArtifactManifestQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactID: Scalars['String']['input'];
}>;


export type ArtifactManifestQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifact?: { __typename: 'Artifact', id: string, createdAt: string, currentManifest?: { __typename: 'ArtifactManifest', id: string, file: { __typename: 'File', id: string, directUrl: string } } | null } | null } | null } | null, serverInfo?: { __typename: 'ServerInfo', defaultCloudRegion: { __typename: 'CloudRegion', id: string } } | null };

export type ArtifactManifestFromIdQueryVariables = Exact<{
  artifactId: Scalars['ID']['input'];
}>;


export type ArtifactManifestFromIdQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, createdAt: string, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }, artifactType: { __typename: 'ArtifactType', id: string, name: string }, currentManifest?: { __typename: 'ArtifactManifest', id: string, file: { __typename: 'File', id: string, directUrl: string } } | null } | null, serverInfo?: { __typename: 'ServerInfo', defaultCloudRegion: { __typename: 'CloudRegion', id: string } } | null };

export type ResolveLatestSequenceAliasToArtifactIdQueryVariables = Exact<{
  sequenceId: Scalars['ID']['input'];
}>;


export type ResolveLatestSequenceAliasToArtifactIdQuery = { __typename: 'Query', artifactSequence?: { __typename: 'ArtifactSequence', id: string, latestArtifact?: { __typename: 'Artifact', id: string } | null } | null };

export type ArtifactCommitHashQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  artifactCollectionName: Scalars['String']['input'];
}>;


export type ArtifactCommitHashQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, commitHash?: string | null } | null };

export type ArtifactManifestFromMembershipQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactName: Scalars['String']['input'];
  versionIndex: Scalars['String']['input'];
}>;


export type ArtifactManifestFromMembershipQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, createdAt: string, currentManifest?: { __typename: 'ArtifactManifest', id: string, file: { __typename: 'File', id: string, directUrl: string } } | null } | null } | null }
      | { __typename: 'ArtifactSequence', id: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, createdAt: string, currentManifest?: { __typename: 'ArtifactManifest', id: string, file: { __typename: 'File', id: string, directUrl: string } } | null } | null } | null }
     | null } | null, serverInfo?: { __typename: 'ServerInfo', defaultCloudRegion: { __typename: 'CloudRegion', id: string } } | null };

export type CreateArtifactTypesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactTypes: Array<ArtifactTypeInput>;
}>;


export type CreateArtifactTypesMutation = { __typename: 'Mutation', createArtifactTypes?: { __typename: 'CreateArtifactTypesPayload', artifactTypes: Array<{ __typename: 'ArtifactType', id: string, name: string }> } | null };

export type UpdateArtifactMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  ttlDurationSeconds?: InputMaybe<Scalars['Int64']['input']>;
}>;


export type UpdateArtifactMutation = { __typename: 'Mutation', updateArtifact?: { __typename: 'UpdateArtifactPayload', artifact: { __typename: 'Artifact', id: string, digest: string, description?: string | null, labels?: any | null, ttlDurationSeconds: any, aliases: Array<{ __typename: 'ArtifactAlias', id: string, artifactCollectionName: string, alias: string }> } } | null };

export type DeleteArtifactMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  deleteAliases?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteArtifactMutation = { __typename: 'Mutation', deleteArtifact?: { __typename: 'DeleteArtifactPayload', artifact: { __typename: 'Artifact', id: string, state: ArtifactState } } | null };

export type DeleteArtifactSequenceMutationVariables = Exact<{
  artifactSequenceID: Scalars['ID']['input'];
}>;


export type DeleteArtifactSequenceMutation = { __typename: 'Mutation', deleteArtifactSequence?: { __typename: 'DeleteArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, state: ArtifactCollectionState }
      | { __typename: 'ArtifactSequence', id: string, state: ArtifactCollectionState }
     } | null };

export type UpdateArtifactTypeMutationVariables = Exact<{
  artifactTypeID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateArtifactTypeMutation = { __typename: 'Mutation', updateArtifactType?: { __typename: 'UpdateArtifactTypePayload', artifactType: { __typename: 'ArtifactType', id: string, description?: string | null } } | null };

export type UpdateArtifactPortfolioMutationVariables = Exact<{
  artifactPortfolioID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateArtifactPortfolioMutation = { __typename: 'Mutation', updateArtifactPortfolio?: { __typename: 'UpdateArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null }
      | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null }
     } | null };

export type UpdateArtifactCollectionMutationVariables = Exact<{
  artifactSequenceID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateArtifactCollectionMutation = { __typename: 'Mutation', updateArtifactSequence?: { __typename: 'UpdateArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null }
      | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null }
     } | null };

export type MoveArtifactCollectionMutationVariables = Exact<{
  artifactSequenceID: Scalars['ID']['input'];
  destinationArtifactTypeName: Scalars['String']['input'];
}>;


export type MoveArtifactCollectionMutation = { __typename: 'Mutation', moveArtifactSequence?: { __typename: 'MoveArtifactCollectionPayload', artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null }
      | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null }
     | null } | null };

export type DeleteArtifactCollectionMutationVariables = Exact<{
  artifactSequenceID: Scalars['ID']['input'];
}>;


export type DeleteArtifactCollectionMutation = { __typename: 'Mutation', deleteArtifactSequence?: { __typename: 'DeleteArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string }
      | { __typename: 'ArtifactSequence', id: string }
     } | null };

export type DeleteArtifactPortfolioMutationVariables = Exact<{
  artifactPortfolioID: Scalars['ID']['input'];
}>;


export type DeleteArtifactPortfolioMutation = { __typename: 'Mutation', deleteArtifactPortfolio?: { __typename: 'DeleteArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string }
      | { __typename: 'ArtifactSequence', id: string }
     } | null };

export type CreateArtifactFilesMutationVariables = Exact<{
  artifactFiles: Array<CreateArtifactFileSpecInput>;
  layout?: InputMaybe<ArtifactStorageLayout>;
}>;


export type CreateArtifactFilesMutation = { __typename: 'Mutation', createArtifactFiles?: { __typename: 'CreateArtifactFilesPayload', files: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, displayName: string, directUrl: string, isReference: boolean, sizeBytes: any, updatedAt?: string | null, uploadUrl?: string | null } | null }> } } | null };

export type CreateArtifactPortfolioMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactTypeID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateArtifactPortfolioMutation = { __typename: 'Mutation', createArtifactPortfolio?: { __typename: 'CreateArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, name: string }
      | { __typename: 'ArtifactSequence', id: string, name: string }
     } | null };

export type CreateArtifactSequenceMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactTypeID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateArtifactSequenceMutation = { __typename: 'Mutation', createArtifactSequence?: { __typename: 'CreateArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, name: string }
      | { __typename: 'ArtifactSequence', id: string, name: string }
     } | null };

export type UnlinkArtifactMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  artifactPortfolioID: Scalars['ID']['input'];
}>;


export type UnlinkArtifactMutation = { __typename: 'Mutation', unlinkArtifact?: { __typename: 'UnlinkArtifactPayload', artifactID: string, success: boolean, clientMutationId?: string | null } | null };

export type AddAliasesMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  aliases: Array<ArtifactCollectionAliasInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddAliasesMutation = { __typename: 'Mutation', addAliases?: { __typename: 'AddAliasesPayload', success: boolean } | null };

export type DeleteAliasesMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  aliases: Array<ArtifactCollectionAliasInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteAliasesMutation = { __typename: 'Mutation', deleteAliases?: { __typename: 'DeleteAliasesPayload', success: boolean } | null };

export type UpdateArtifactEntityTtlMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  ttlDurationSeconds: Scalars['Int64']['input'];
}>;


export type UpdateArtifactEntityTtlMutation = { __typename: 'Mutation', updateArtifactEntityTTL?: { __typename: 'UpdateArtifactEntityTTLPayload', clientMutationId?: string | null } | null };

export type DeleteArtifactEntityTtlMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type DeleteArtifactEntityTtlMutation = { __typename: 'Mutation', deleteArtifactEntityTTL?: { __typename: 'DeleteArtifactEntityTTLPayload', clientMutationId?: string | null } | null };

export type ArtifactRedirectQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  membershipIdentifier: Scalars['String']['input'];
}>;


export type ArtifactRedirectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                | { __typename: 'ArtifactPortfolio', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> } }
                | { __typename: 'ArtifactSequence', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> } }
               | null }> } | null } | null }> }, artifactType?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> } }
           | null }> } | null, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> }, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }
        | { __typename: 'ArtifactSequence', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> }, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }
       | null } | null } | null };

export type ArtifactTypeQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
}>;


export type ArtifactTypeQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string, description?: string | null, artifactSequences?: { __typename: 'ArtifactSequenceConnection', edges: Array<{ __typename: 'ArtifactSequenceEdge', node?: { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number } } | null }> } | null } | null } | null };

export type ArtifactTypesQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactTypesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> } } | null };

export type ViewerDefaultResourceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerDefaultResourceConfigsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, defaultResourceConfigs?: { __typename: 'DefaultResourceConfigConnection', edges: Array<{ __typename: 'DefaultResourceConfigEdge', node: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } }> } | null } | null }> } | null } | null };

export type EntityDefaultResourceConfigsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityDefaultResourceConfigsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, defaultResourceConfigs?: { __typename: 'DefaultResourceConfigConnection', edges: Array<{ __typename: 'DefaultResourceConfigEdge', node: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } }> } | null } | null };

export type ProjectDefaultResourceConfigsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
}>;


export type ProjectDefaultResourceConfigsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, defaultResourceConfigs?: { __typename: 'DefaultResourceConfigConnection', edges: Array<{ __typename: 'DefaultResourceConfigEdge', node: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } }> } | null } | null };

export type CreateDefaultResourceConfigMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  config: Scalars['JSONString']['input'];
  templateVariables: Scalars['JSONString']['input'];
}>;


export type CreateDefaultResourceConfigMutation = { __typename: 'Mutation', createDefaultResourceConfig?: { __typename: 'CreateDefaultResourceConfigPayload', defaultResourceConfigID: string, schemaValidationErrors?: Array<string> | null, success: boolean } | null };

export type DeleteDefaultResourceConfigMutationVariables = Exact<{
  defaultResourceConfigIDs: Array<Scalars['ID']['input']>;
}>;


export type DeleteDefaultResourceConfigMutation = { __typename: 'Mutation', deleteDefaultResourceConfigs?: { __typename: 'DeleteDefaultResourceConfigsPayload', numAffected: any, success: boolean } | null };

export type UpdateDefaultResourceConfigMutationVariables = Exact<{
  defaultResourceConfigID: Scalars['ID']['input'];
  resource?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSONString']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  templateVariables: Scalars['JSONString']['input'];
}>;


export type UpdateDefaultResourceConfigMutation = { __typename: 'Mutation', updateDefaultResourceConfig?: { __typename: 'UpdateDefaultResourceConfigPayload', schemaValidationErrors?: Array<string> | null, success: boolean } | null };

export type DefaultResourceConfigQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  defaultResourceConfigID: Scalars['ID']['input'];
}>;


export type DefaultResourceConfigQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, config?: any | null, resource: string, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null } | null };

export type EntityArtifactsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityArtifactsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string, artifactSequences?: { __typename: 'ArtifactSequenceConnection', edges: Array<{ __typename: 'ArtifactSequenceEdge', node?: { __typename: 'ArtifactSequence', id: string, name: string, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } } | null }> } | null } | null }> } } | null }> } | null } | null };

export type PaidEntityQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type PaidEntityQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, isPaid?: boolean | null } | null };

export type EntityProfileQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityProfileQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, profileView?: { __typename: 'View', id: string, spec?: any | null, updatedAt?: string | null, updatedBy?: { __typename: 'User', id: string, username?: string | null } | null } | null } | null };

export type EntityProjectsReportsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EntityProjectsReportsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, reports?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
                  | { __typename: 'EmailSubscription', id: string }
                  | { __typename: 'SlackChannelSubscription', id: string }
                 | null } | null }> } | null } | null }> } | null } | null };

export type ProjectReportsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectReportsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string, reports?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
            | { __typename: 'EmailSubscription', id: string }
            | { __typename: 'SlackChannelSubscription', id: string }
           | null } | null }> } | null } | null };

export type EntityTagsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityTagsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, tagCategories: Array<{ __typename: 'TagCategory', id: string, name: string, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }> } | null };

export type GalleryQueryVariables = Exact<{ [key: string]: never; }>;


export type GalleryQuery = { __typename: 'Query', singletonView?: { __typename: 'View', id: string, spec?: any | null } | null };

export type UpdateGalleryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  spec: Scalars['String']['input'];
}>;


export type UpdateGalleryMutation = { __typename: 'Mutation', upsertView?: { __typename: 'UpsertViewPayload', inserted?: boolean | null, view?: { __typename: 'View', id: string, updatedAt?: string | null, createdAt: string, spec?: any | null } | null } | null };

export type FeaturedReportsMetadataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  recentStarCountFrom?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type FeaturedReportsMetadataQuery = { __typename: 'Query', views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, createdAt: string, updatedAt?: string | null, entityName: string, displayName?: string | null, description?: string | null, viewCount: number, starCount: number, starred?: boolean | null, recentStarCount: number, project?: { __typename: 'Project', id: string, entityName: string, name: string, access?: string | null } | null } | null }> } | null };

export type FeaturedReportsAuthorsQueryVariables = Exact<{
  usernames: Array<Scalars['String']['input']>;
}>;


export type FeaturedReportsAuthorsQuery = { __typename: 'Query', users?: { __typename: 'UserConnection', edges: Array<{ __typename: 'UserEdge', node?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null, userInfo?: any | null } | null }> } | null };

export type InsertGalleryDiscussionMutationVariables = Exact<{
  spec: Scalars['String']['input'];
  reportID: Scalars['ID']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertGalleryDiscussionMutation = { __typename: 'Mutation', insertGalleryDiscussion?: { __typename: 'InsertGalleryDiscussionPayload', success: boolean } | null };

export type SubmitFcNewsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitFcNewsMutation = { __typename: 'Mutation', submitFCNews?: { __typename: 'SubmitFCNewsPayload', success: boolean } | null };

export type GalleryTagSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GalleryTagSectionsQuery = { __typename: 'Query', galleryTagSections: any };

export type ProjectAccessQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectAccessQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null } | null };

export type NewsletterSubscriptionQueryVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type NewsletterSubscriptionQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, newsletterSubscription?: { __typename: 'NewsletterSubscription', id: string } | null } | null };

export type CreateNewsletterSubscriptionMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateNewsletterSubscriptionMutation = { __typename: 'Mutation', createNewsletterSubscription?: { __typename: 'CreateNewsletterSubscriptionPayload', newsletterSubscription: { __typename: 'NewsletterSubscription', id: string } } | null };

export type AllNewsletterSubscriptionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllNewsletterSubscriptionsQuery = { __typename: 'Query', newsletterSubscriptions?: { __typename: 'NewsletterSubscriptionConnection', edges: Array<{ __typename: 'NewsletterSubscriptionEdge', node?: { __typename: 'NewsletterSubscription', id: string, email?: string | null, createdAt: string, user?: { __typename: 'User', id: string, username?: string | null, email?: string | null } | null } | null }> } | null };

export type ViewPreviewUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewPreviewUrlQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, previewUrl?: string | null } | null };

export type GroupPageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  groupName: Scalars['String']['input'];
}>;


export type GroupPageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runGroup?: { __typename: 'RunGroup', id: string, name: string, notes?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } | null } | null };

export type HistoryKeysFieldsFragment = { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, wandbConfig?: any | null } }> } | null };

export type HistoryKeysQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type HistoryKeysQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', historyKeys?: any | null, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, wandbConfig?: any | null } }> } | null } | null };

export type HistoryKeysWithHashQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type HistoryKeysWithHashQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', historyKeys?: any | null, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, wandbConfig?: any | null } }> } | null } | null };

export type HistoryKeysByProjectIdQueryVariables = Exact<{
  internalId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type HistoryKeysByProjectIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', historyKeys?: any | null, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, wandbConfig?: any | null } }> } | null } | null };

export type InviteQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type InviteQuery = { __typename: 'Query', invite?: { __typename: 'Invite', id: string, toUser?: { __typename: 'User', id: string, username?: string | null } | null } | null };

type JobInfo_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } };

type JobInfo_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } };

export type JobInfoFragment =
  | JobInfo_ArtifactPortfolio_Fragment
  | JobInfo_ArtifactSequence_Fragment
;

export type DefaultResourceConfigFragmentFragment = { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> };

export type FetchEntityJobsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchEntityJobsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                  | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
                  | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
                 | null }> } | null } | null } | null }> } | null } | null };

export type FetchProjectJobsPartialQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchProjectJobsPartialQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, internalId: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
           | null }> } | null } | null } | null };

export type FetchProjectInternalIdQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchProjectInternalIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, internalId: string } | null };

export type FetchProjectJobsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchProjectJobsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
           | null }> } | null } | null } | null };

export type FetchRecentlyUsedJobsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchRecentlyUsedJobsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, createdAt: string, job?: { __typename: 'Artifact', id: string, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, state: ArtifactCollectionState, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } } | null } }> } | null } | null };

export type FetchJobVersionsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  jobName: Scalars['String']['input'];
}>;


export type FetchJobVersionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, createdAt: string, createdBy?:
                | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
                | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
               | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
      | { __typename: 'ArtifactSequence', id: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, createdAt: string, createdBy?:
                | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
                | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
               | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
     | null } | null };

export type FetchRecentlyUsedJobDetailQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  artifactCollectionFilters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchRecentlyUsedJobDetailQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, internalId: string, entityName: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
           | null }> } | null } | null } | null };

export type FetchJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type FetchJobQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string }
    | { __typename: 'ArtifactSequence', id: string, name: string }
   | null };

export type FetchJobDetailsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  usedByFilters?: InputMaybe<Scalars['JSONString']['input']>;
  usedByFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchJobDetailsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, access?: string | null, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
              | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
              | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
             | null, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, stopped?: boolean | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, runInfo?: { __typename: 'RunInfo', args: Array<string> } | null } }> } } }> } }
    | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, access?: string | null, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
              | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
              | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
             | null, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, stopped?: boolean | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, runInfo?: { __typename: 'RunInfo', args: Array<string> } | null } }> } } }> } }
   | null };

export type FetchProjectRunsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchProjectRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, runInfo?: { __typename: 'RunInfo', git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null } }> } | null } | null };

export type FetchProjectLaunchQueuesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchProjectLaunchQueuesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, isTeam: boolean, name: string }, runQueues: Array<{ __typename: 'RunQueue', id: string, name: string, access: RunQueueAccessType, defaultResourceConfigID?: string | null, prioritizationMode: RunQueuePrioritizationMode }> } | null };

export type FetchEntityProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type FetchEntityProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null };

export type EntityPhotoQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityPhotoQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, photoUrl?: string | null } | null };

export type UserEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEntitiesQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, role?: string | null }> } | null }> } | null } | null };

export type ViewerDestinationProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerDestinationProjectsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null }> } | null } | null };

export type QueueNamesQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type QueueNamesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runQueues: Array<{ __typename: 'RunQueue', id: string, name: string }> } | null };

export type AllQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllQueuesQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, entity?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, organizationId?: string | null, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueues: Array<{ __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } }> } | null } | null }> } | null } | null };

export type PublicQueueQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  publicQueueName?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicQueueQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null, error?: { __typename: 'RunQueueItemInfoDetails', message: string, stage: string, filePaths: Array<string> } | null, warnings: Array<{ __typename: 'RunQueueItemInfoDetails', message: string, stage: string, filePaths: Array<string> } | null> } }> } } | null } | null } | null };

export type QueueByIdLiteQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  queueId: Scalars['ID']['input'];
}>;


export type QueueByIdLiteQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, name: string, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, resource: string, config?: any | null, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } } | null } | null };

export type PublicQueueLiteQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  publicQueueName?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicQueueLiteQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } } | null } | null } | null };

export type EntityQueuesLiteQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntityQueuesLiteQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueues: Array<{ __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null }> } | null } | null };

export type EntityQueueByQueueNameLiteQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  queueName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntityQueueByQueueNameLiteQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null } | null } | null } | null };

export type AllQueuesLiteQueryVariables = Exact<{ [key: string]: never; }>;


export type AllQueuesLiteQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, entity?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, organizationId?: string | null, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueues: Array<{ __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null }> } | null } | null }> } | null } | null };

export type RunsInformationQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type RunsInformationQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null } }> } | null } | null };

export type FetchCodeArtifactFilesQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type FetchCodeArtifactFilesQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, displayName: string, mimetype?: string | null, sizeBytes: any, url?: string | null } | null }> } | null } | null };

export type FetchAgentDetailsQueryVariables = Exact<{
  agentId: Scalars['ID']['input'];
}>;


export type FetchAgentDetailsQuery = { __typename: 'Query', launchAgent?: { __typename: 'LaunchAgent', id: string, name: string, createdAt: string, updatedAt?: string | null, heartbeatAt?: string | null, runQueues: Array<string>, hostname: string, agentStatus: string, stopPolling: boolean, agentConfig?: any | null, version?: string | null } | null };

export type EntityAgentsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityAgentsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }> } | null } | null };

export type FetchRunOutputLogQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type FetchRunOutputLogQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, logLineCount?: number | null, outputLogFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any, directUrl: string, url?: string | null } | null }> } | null } | null } | null };

export type QueueByIdQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  queueId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type QueueByIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, name: string, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, resource: string, config?: any | null, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null, error?: { __typename: 'RunQueueItemInfoDetails', message: string, stage: string, filePaths: Array<string> } | null, warnings: Array<{ __typename: 'RunQueueItemInfoDetails', message: string, stage: string, filePaths: Array<string> } | null> } }> } } | null } | null };

export type RunJobQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunJobQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, job?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string } } | null } | null } | null };

export type RunFilesAndFolderWithDirectUrLsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  maxNumFiles: Scalars['Int']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunFilesAndFolderWithDirectUrLsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, run?: { __typename: 'Run', id: string, name: string, projectId: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, sizeBytes: any, updatedAt?: string | null, artifact?: { __typename: 'Artifact', id: string, digest: string } | null } | null }> } | null } | null } | null };

export type AccountUsingLaunchQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type AccountUsingLaunchQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, isLaunchActive: boolean } | null };

export type ArtifactPathEntityProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactPathEntityProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null };

export type ArtifactPathSearchArtifactsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArtifactPathSearchArtifactsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, project?: { __typename: 'Project', id: string, artifactCollectionsSearch?: { __typename: 'ArtifactCollectionSearchConnection', edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', node:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
           }> } | null } | null } | null };

export type AddPublicQueueLaunchAgentTeamConfigMutationVariables = Exact<{
  input: AddPublicQueueLaunchAgentTeamConfigInput;
}>;


export type AddPublicQueueLaunchAgentTeamConfigMutation = { __typename: 'Mutation', addPublicQueueLaunchAgentTeamConfig?: { __typename: 'AddPublicQueueLaunchAgentTeamConfigPayload', success: boolean, clientMutationID?: string | null } | null };

export type DeletePublicQueueLaunchAgentTeamConfigMutationVariables = Exact<{
  input: DeletePublicQueueLaunchAgentTeamConfigInput;
}>;


export type DeletePublicQueueLaunchAgentTeamConfigMutation = { __typename: 'Mutation', deletePublicQueueLaunchAgentTeamConfig?: { __typename: 'DeletePublicQueueLaunchAgentTeamConfigPayload', success: boolean, clientMutationID?: string | null } | null };

export type ViewerTeamsProjectsQueryVariables = Exact<{
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewerTeamsProjectsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null }> } | null } | null };

export type FetchProjectRunsForConfigQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchProjectRunsForConfigQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, createdAt: string, state?: string | null, defaultColorIndex?: number | null, config?: any | null, runInfo?: { __typename: 'RunInfo', args: Array<string> } | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null, job?: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string } } | null } }> } | null } | null };

export type MessageOfTheDayQueryVariables = Exact<{ [key: string]: never; }>;


export type MessageOfTheDayQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', messageOfTheDay?: string | null } | null };

export type MoveViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveViewMutation = { __typename: 'Mutation', moveView?: { __typename: 'MoveViewPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type MultiRunWorkspaceQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type MultiRunWorkspaceQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null, isBenchmark: boolean, linkedBenchmark?: { __typename: 'Project', id: string, entityName: string, name: string, gitHubSubmissionRepo?: string | null, views?: any | null } | null, runQueues: Array<{ __typename: 'RunQueue', id: string, name: string, createdBy?: number | null, access: RunQueueAccessType }> } | null };

export type NwEntityPermissionQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type NwEntityPermissionQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, settings: { __typename: 'EntitySettings', hidden: boolean } } | null };

export type NwProjectPermissionQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type NwProjectPermissionQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null, members: Array<{ __typename: 'ProjectMember', id: string, username?: string | null }> } | null };

export type OrgAdminsQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrgAdminsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, members: Array<{ __typename: 'OrganizationMember', id: string, admin: boolean, user: { __typename: 'User', id: string, username?: string | null } }> } | null };

export type ParameterImportanceQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  targetName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
  runParameters?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type ParameterImportanceQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, parameterImportance: any } | null };

export type ProjectArtifactCollectionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
}>;


export type ProjectArtifactCollectionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                | { __typename: 'ArtifactPortfolio', id: string, name: string }
                | { __typename: 'ArtifactSequence', id: string, name: string }
               | null }> } | null } | null }> } } | null };

export type ProjectArtifactsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type ProjectArtifactsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', totalCount: number, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                | { __typename: 'ArtifactPortfolio', id: string, name: string, updatedAt?: string | null }
                | { __typename: 'ArtifactSequence', id: string, name: string, updatedAt?: string | null }
               | null }> } | null } | null }> } } | null };

export type ProjectFieldsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  types: Array<Scalars['String']['input']>;
  columns: Array<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectFieldsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, fields: { __typename: 'ProjectFieldConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ProjectFieldEdge', node: { __typename: 'ProjectField', path: string, type: string } }> } } | null };

export type WeaveflowCheckFragmentFragment = { __typename: 'Project', weaveRun?: { __typename: 'Run', id: string } | null };

export type ProjectPageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectPageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string, lastActive?: string | null, access?: string | null, description?: string | null, readOnly?: boolean | null, fromV2?: boolean | null, computeHours: number, totalSweeps: number, totalUsers?: number | null, isBenchmark: boolean, views?: any | null, totalRuns: number, reports?: { __typename: 'ViewConnection', totalCount: number } | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null, accountType?: UserAccountType | null } | null, linkedBenchmark?: { __typename: 'Project', id: string, entityName: string, name: string, gitHubSubmissionRepo?: string | null, views?: any | null } | null, entity: { __typename: 'Entity', id: string, name: string, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null, organization?: { __typename: 'Organization', id: string, name: string } | null }, weaveRun?: { __typename: 'Run', id: string } | null } | null };

export type ProjectTags2QueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectTags2Query = { __typename: 'Query', project?: { __typename: 'Project', id: string, runTags?: { __typename: 'RunTagConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'RunTagEdge', node: { __typename: 'RunTag', name: string, id: string } }> } | null } | null };

export type ProjectTagsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type ProjectTagsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, tagCounts: Array<{ __typename: 'RunTagCount', name: string, count: number }> } | null };

export type ReportPageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type ReportPageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, readOnly?: boolean | null, entity: { __typename: 'Entity', id: string, name: string, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean } } | null };

export type ReportTableQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  draftsOffset?: InputMaybe<Scalars['Int']['input']>;
  draftsPageSize?: InputMaybe<Scalars['Int']['input']>;
  publishedOffset?: InputMaybe<Scalars['Int']['input']>;
  publishedPageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReportTableQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, readOnly?: boolean | null, reportDrafts?: { __typename: 'ViewConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
            | { __typename: 'EmailSubscription', id: string }
            | { __typename: 'SlackChannelSubscription', id: string }
           | null } | null }> } | null, reports?: { __typename: 'ViewConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
            | { __typename: 'EmailSubscription', id: string }
            | { __typename: 'SlackChannelSubscription', id: string }
           | null } | null }> } | null } | null };

export type RunArtifactVersionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  includeOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeInput?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunArtifactVersionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, state?: string | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactEdge', node?: { __typename: 'Artifact', id: string, versionIndex?: number | null, isLinkedToGlobalRegistry: boolean, artifactType: { __typename: 'ArtifactType', id: string, name: string, project: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } }, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string }, usedBy: { __typename: 'RunConnection', totalCount: number } } | null }> } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'InputArtifactEdge', node?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactType: { __typename: 'ArtifactType', id: string, name: string, project: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } }, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }, usedBy: { __typename: 'RunConnection', totalCount: number } } | null }> } | null } | null } | null };

export type CodeFilesQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type CodeFilesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, config?: any | null, group?: string | null, codeArtifact?: { __typename: 'Artifact', id: string, commitHash?: string | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string } } | null, sweep?: { __typename: 'Sweep', id: string, name: string } | null } | null } | null };

export type RunCodePollingQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunCodePollingQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, state?: string | null, historyKeys?: any | null } | null } | null };

export type RunsOutputArtifactsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runNames: Array<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  filenames: Array<Scalars['String']['input']>;
}>;


export type RunsOutputArtifactsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, outputArtifacts?: { __typename: 'ArtifactConnection', edges: Array<{ __typename: 'ArtifactEdge', node?: { __typename: 'Artifact', id: string, artifactType: { __typename: 'ArtifactType', id: string, name: string }, artifactSequenceMembership: { __typename: 'ArtifactCollectionMembership', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string } | null }> } | null } } | null }> } | null } }> } | null } | null };

export type RunByDisplayNameQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type RunByDisplayNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, createdAt: string } }> } | null } | null };

export type RunFilesQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  maxNumFiles: Scalars['Int']['input'];
}>;


export type RunFilesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, run?: { __typename: 'Run', id: string, name: string, fileCount?: number | null, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null, sizeBytes: any, updatedAt?: string | null, artifact?: { __typename: 'Artifact', id: string, digest: string } | null } | null }> } | null } | null } | null };

export type RunFilesAndFoldersQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  maxNumFiles: Scalars['Int']['input'];
  folderPath?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunFilesAndFoldersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, run?: { __typename: 'Run', id: string, name: string, projectId: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null, sizeBytes: any, updatedAt?: string | null, artifact?: { __typename: 'Artifact', id: string, digest: string } | null } | null }> } | null, folders?: { __typename: 'Folders', folderList: Array<{ __typename: 'FolderMetadata', name: string, size: any, numberOfFiles: any } | null> } | null } | null } | null };

export type RunHistoryQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
}>;


export type RunHistoryQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, sampledHistory: Array<any> } | null } | null };

export type RunInfoAndConfigQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunInfoAndConfigQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, config?: any | null, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, codeSaved?: boolean | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null } | null } | null };

export type RunInfoQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunInfoQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, codeSaved?: boolean | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null } | null } | null };

export type RunKeysQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunKeysQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, fields: { __typename: 'ProjectFieldConnection', edges: Array<{ __typename: 'ProjectFieldEdge', node: { __typename: 'ProjectField', path: string } }> } } | null };

export type RunSelectorQueryVariables = Exact<{
  projectInternalId: Scalars['ID']['input'];
}>;


export type RunSelectorQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runCount: number, fields: { __typename: 'ProjectFieldConnection', edges: Array<{ __typename: 'ProjectFieldEdge', node: { __typename: 'ProjectField', path: string } }> }, entity: { __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', storageBucketInfo?: { __typename: 'StorageBucketInfo', ID: string } | null } } } | null };

export type RunFieldsFragment = { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null };

export type RunsSelectorRunsProjectFragmentFragment = { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, deltaOrder: Array<string>, delta: Array<{ __typename: 'RunDiff', index: number, op: DiffOperation, run?: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } | null }> } | null, pinnedRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } }> } | null };

export type RunSelectorRunsQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunsFilter: Scalars['JSONString']['input'];
  projectInternalId: Scalars['ID']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunSelectorRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, deltaOrder: Array<string>, delta: Array<{ __typename: 'RunDiff', index: number, op: DiffOperation, run?: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } | null }> } | null, pinnedRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } }> } | null } | null };

export type RunSelectorCsvExportRunsQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunSelectorCsvExportRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, config?: any | null, createdAt: string, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, tags?: Array<string> | null, updatedAt?: string | null, wandbConfig?: any | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, user?: { __typename: 'User', id: string, username?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } }> } | null } | null };

export type RunSelectorAutoColsRunsQueryVariables = Exact<{
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RunSelectorAutoColsRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, config?: any | null, createdAt: string, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, user?: { __typename: 'User', id: string, username?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } }> } | null } | null };

export type BulkEditorProjectTagsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  tempFilters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type BulkEditorProjectTagsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, tagCounts: Array<{ __typename: 'RunTagCount', name: string, count: number }> } | null };

export type RunSetSummaryQueryVariables = Exact<{
  projectInternalId: Scalars['ID']['input'];
  selections: Scalars['JSONString']['input'];
}>;


export type RunSetSummaryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, selectedCount: number } | null };

export type RunValueSuggestionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  keyPath: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type RunValueSuggestionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, runKeySuggestions: Array<{ __typename: 'RunKeySuggestion', value?: any | null, displayValue?: any | null, count: number }> } | null };

export type ViewSpecQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewSpecQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, type?: string | null, spec?: any | null } | null };

export type SearchEntityProjectsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityProjectsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchEntityProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null } | null }> } | null };

export type SearchViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchViewerQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, admin?: boolean | null, photoUrl?: string | null, username?: string | null, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType }>, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null }> } | null } | null };

export type SearchNavQueryQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  sweepName: Scalars['String']['input'];
}>;


export type SearchNavQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, access?: string | null, readOnly?: boolean | null, isBenchmark: boolean, entity: { __typename: 'Entity', id: string, name: string, readOnlyAdmin: boolean, defaultAccess: string, privateOnly: boolean, isTeam: boolean }, user?: { __typename: 'User', id: string } | null, run?: { __typename: 'Run', id: string, displayName?: string | null, state?: string | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null } | null };

export type SelectedCountQueryVariables = Exact<{
  projectInternalId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  tempFilters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type SelectedCountQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, selectedCount: number, tempSelectedCount: number, tempSelectedActiveCount: number, tempOutputArtifactsCount: number } | null };

export type SingleFileQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type SingleFileQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, sizeBytes: any, updatedAt?: string | null } | null }> } | null } | null } | null };

export type SweepPageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  sweepName: Scalars['String']['input'];
}>;


export type SweepPageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, readOnly?: boolean | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, runCount: number, runCountExpected?: number | null, runTime: number, method: string, state: string, description?: string | null, config: string, createdAt: string, heartbeatAt: string, updatedAt?: string | null, controllerRunName: string, scheduler?: any | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, priorRuns: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string } }> }, agents: { __typename: 'AgentConnection', edges: Array<{ __typename: 'AgentEdge', node: { __typename: 'Agent', id: string, name: string, state?: string | null, host: string, persistent?: boolean | null, metrics: any, createdAt: string, heartbeatAt?: string | null, totalRuns: number, user?: { __typename: 'User', id: string } | null } }> } } | null, entity: { __typename: 'Entity', id: string, name: string, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean } } | null };

export type SweepsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SweepsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null, sweeps?: { __typename: 'SweepConnection', edges: Array<{ __typename: 'SweepEdge', node: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, state: string, runCount: number, runCountExpected?: number | null, runTime: number, createdAt: string, config: string, scheduler?: any | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } }> } | null } | null };

export type CreateArtifactCollectionTagAssignmentsMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  tags: Array<TagInput>;
}>;


export type CreateArtifactCollectionTagAssignmentsMutation = { __typename: 'Mutation', createArtifactCollectionTagAssignments?: { __typename: 'CreateTagsPayload', tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string }> } | null };

export type DeleteArtifactCollectionTagAssignmentsMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  tags: Array<TagInput>;
}>;


export type DeleteArtifactCollectionTagAssignmentsMutation = { __typename: 'Mutation', deleteArtifactCollectionTagAssignments?: { __typename: 'DeleteTagAssignmentPayload', success: boolean } | null };

export type CreateArtifactTagAssignmentsMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  tags: Array<TagInput>;
}>;


export type CreateArtifactTagAssignmentsMutation = { __typename: 'Mutation', createArtifactTagAssignments?: { __typename: 'CreateTagsPayload', tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string }> } | null };

export type DeleteArtifactTagAssignmentsMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  tags: Array<TagInput>;
}>;


export type DeleteArtifactTagAssignmentsMutation = { __typename: 'Mutation', deleteArtifactTagAssignments?: { __typename: 'DeleteTagAssignmentPayload', success: boolean } | null };

export type TeamMemberFieldsFragment = { __typename: 'Member', id?: string | null, username?: string | null, name: string, photoUrl?: string | null, role?: string | null };

export type TeamMemberDetailedRoleFragment = { __typename: 'Member', memberRole?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string }>, inheritedFrom?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string }> } | null } | null };

export type TeamMembersQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamMembersQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, name: string, photoUrl?: string | null, role?: string | null }> } | null };

export type TeamMemberQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type TeamMemberQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, member?: { __typename: 'Member', id?: string | null, username?: string | null, name: string, photoUrl?: string | null, role?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string }>, inheritedFrom?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string }> } | null } | null } | null } | null };

export type ContactUsForUserLedTrialMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactUsForUserLedTrialMutation = { __typename: 'Mutation', contactUsForUserLedTrial?: { __typename: 'ContactUsForUserLedTrialPayload', clientMutationId?: string | null } | null };

export type ContactUsForComputeHoursMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactUsForComputeHoursMutation = { __typename: 'Mutation', contactUsForComputeHours?: { __typename: 'ContactUsForComputeHoursPayload', clientMutationId?: string | null } | null };

export type UserProfileQueryVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type UserProfileQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, profileView?: { __typename: 'View', id: string, spec?: any | null, updatedAt?: string | null, updatedBy?: { __typename: 'User', id: string, username?: string | null } | null } | null } | null };

export type UserProjectsQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  includeReports: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProjectsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, reports?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
                        | { __typename: 'EmailSubscription', id: string }
                        | { __typename: 'SlackChannelSubscription', id: string }
                       | null } | null }> } | null } | null }> } | null } | null }> } | null } | null };

export type AllTeamProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllTeamProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, totalRuns?: number | null, lastActive?: string | null, computeHours: number } | null }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type UserReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserReportsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, username?: string | null, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, createdAt: string, updatedAt?: string | null, name?: string | null, displayName?: string | null, description?: string | null, previewUrl?: string | null, spec?: any | null, viewCount: number, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null } | null };

export type Vega2PanelQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  fetchSingle: Scalars['Boolean']['input'];
}>;


export type Vega2PanelQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null } | null, view?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null };

export type VegaPanelQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  fetchSingle: Scalars['Boolean']['input'];
}>;


export type VegaPanelQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null } | null, view?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null };

export type ViewerApiKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerApiKeyQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, apiKey?: string | null } | null };

export type ViewerApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerApiKeysQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, apiKeys?: { __typename: 'ApiKeyConnection', edges: Array<{ __typename: 'ApiKeyEdge', node?: { __typename: 'ApiKey', id: string, name: string, createdAt?: string | null, expiresAt?: string | null, description?: string | null, apiKeyId?: string | null } | null }> } | null } | null };

export type WandbConfigQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type WandbConfigQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, wandbConfig?: any | null } }> } | null } | null };

export type CoreweaveIdQueryVariables = Exact<{
  entity?: InputMaybe<Scalars['String']['input']>;
}>;


export type CoreweaveIdQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organization?: { __typename: 'Organization', id: string, coreWeaveOrganizationId?: string | null } | null } | null };

export type CoreweaveIdByRunNameQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type CoreweaveIdByRunNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, runInfo?: { __typename: 'RunInfo', coreweave?: { __typename: 'CoreweaveInfo', orgId: string, clusterName: string, region: string } | null } | null } | null } | null };

export type NodeAlertFragmentFragment = { __typename: 'NodeAlert', alertName: string, alertStatus: string, cluster: string, clusterOrg: string, description: string, grafanaDashboard: string, labels: any, node: string, pod: string, occurrences: any };

export type RunIssueQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
}>;


export type RunIssueQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, nodeAlertsHistory: Array<{ __typename: 'NodeAlert', alertName: string, alertStatus: string, cluster: string, clusterOrg: string, description: string, grafanaDashboard: string, labels: any, node: string, pod: string, occurrences: any }> } | null } | null };

export type IssuesTimestampsByMetricQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
}>;


export type IssuesTimestampsByMetricQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, bucketedHistory: Array<any> } | null } | null };

export type RunGrafanaDashboardQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunGrafanaDashboardQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, coreweaveGrafanaDashboard: string } | null } | null };

export type ServerPollingOkQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerPollingOkQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', pollingOK: boolean } | null };

export type RunWithoutRunInfoStateBasicFragmentFragment = { __typename: 'Run', commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null };

export type RunInfoFragmentFragment = { __typename: 'Run', runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null };

export type RunStateBasicFragmentFragment = { __typename: 'Run', commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null };

export type ArtifactCountsFragmentFragment = { __typename: 'Run', inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null };

export type RunsStateQueryQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableHistoryKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableSystemMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableWandb?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunsStateQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, projectId: string, displayName?: string | null, updatedAt?: string | null, aggregations?: any | null, config?: any | null, historyKeys?: any | null, sampledHistory?: Array<any>, summaryMetrics?: any | null, systemMetrics?: any | null, wandbConfig?: any | null, commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } }> } | null } | null };

export type RunsStateQueryWithProjectIdQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableHistoryKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableSystemMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableWandb?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  internalId: Scalars['ID']['input'];
}>;


export type RunsStateQueryWithProjectIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, projectId: string, displayName?: string | null, updatedAt?: string | null, aggregations?: any | null, config?: any | null, historyKeys?: any | null, sampledHistory?: Array<any>, summaryMetrics?: any | null, systemMetrics?: any | null, wandbConfig?: any | null, commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } }> } | null } | null };

export type RunsStateDeltaQueryQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableHistoryKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableSystemMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableWandb?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunsStateDeltaQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, delta: Array<{ __typename: 'RunDiff', index: number, op: DiffOperation, run?: { __typename: 'Run', id: string, name: string, projectId: string, displayName?: string | null, updatedAt?: string | null, aggregations?: any | null, config?: any | null, historyKeys?: any | null, sampledHistory?: Array<any>, summaryMetrics?: any | null, systemMetrics?: any | null, wandbConfig?: any | null, commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } | null }> } | null } | null };

export type RunsStateDeltaQueryWithProjectIdQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableHistoryKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableSystemMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableWandb?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  internalId: Scalars['ID']['input'];
}>;


export type RunsStateDeltaQueryWithProjectIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, delta: Array<{ __typename: 'RunDiff', index: number, op: DiffOperation, run?: { __typename: 'Run', id: string, name: string, projectId: string, displayName?: string | null, updatedAt?: string | null, aggregations?: any | null, config?: any | null, historyKeys?: any | null, sampledHistory?: Array<any>, summaryMetrics?: any | null, systemMetrics?: any | null, wandbConfig?: any | null, commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, benchmarkRun?: { __typename: 'BenchmarkRun', id: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } | null }> } | null } | null };

export type ViewFragmentMetadata2Fragment = { __typename: 'View', id: string, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
    | { __typename: 'EmailSubscription', id: string }
    | { __typename: 'SlackChannelSubscription', id: string }
   | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> };

export type Views2MetadataQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  viewName?: InputMaybe<Scalars['String']['input']>;
}>;


export type Views2MetadataQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
            | { __typename: 'EmailSubscription', id: string }
            | { __typename: 'SlackChannelSubscription', id: string }
           | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null }> } | null } | null };

export type Views2ViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type Views2ViewQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, spec?: any | null, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
      | { __typename: 'EmailSubscription', id: string }
      | { __typename: 'SlackChannelSubscription', id: string }
     | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null };

export type Views2RawViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type Views2RawViewQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, specObject?: any | null, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
      | { __typename: 'EmailSubscription', id: string }
      | { __typename: 'SlackChannelSubscription', id: string }
     | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null };

export type ViewUpdatedAtQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewUpdatedAtQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, updatedAt?: string | null } | null };

export type NamedWorkspaceUpdateViewFieldsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NamedWorkspaceUpdateViewFieldsQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, createdAt: string, updatedAt?: string | null, user?: { __typename: 'User', id: string, name: string, username?: string | null } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null } | null };

export type UpsertView2MutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  showcasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdUsing?: InputMaybe<ViewSource>;
}>;


export type UpsertView2Mutation = { __typename: 'Mutation', upsertView?: { __typename: 'UpsertViewPayload', inserted?: boolean | null, view?: { __typename: 'View', id: string, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
       | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null } | null };

export type UpsertUserProfileViewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpsertUserProfileViewMutation = { __typename: 'Mutation', upsertUserProfileView?: { __typename: 'UpsertUserProfileViewPayload', inserted?: boolean | null, view?: { __typename: 'View', id: string, spec?: any | null, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
       | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null } | null };

export type DeleteView2MutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  deleteDrafts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteView2Mutation = { __typename: 'Mutation', deleteView?: { __typename: 'DeleteViewPayload', success?: boolean | null, pendingDrafts?: boolean | null } | null };

export type DeleteViewsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  deleteDrafts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteViewsMutation = { __typename: 'Mutation', deleteViews?: { __typename: 'DeleteViewsPayload', success?: boolean | null, pendingDrafts?: boolean | null } | null };

export type StarViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StarViewMutation = { __typename: 'Mutation', starView?: { __typename: 'StarViewPayload', view?: { __typename: 'View', id: string, starCount: number, starred?: boolean | null } | null } | null };

export type UnstarViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnstarViewMutation = { __typename: 'Mutation', unstarView?: { __typename: 'UnstarViewPayload', view?: { __typename: 'View', id: string, starCount: number, starred?: boolean | null } | null } | null };

export type StargazersQueryQueryVariables = Exact<{
  viewID: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type StargazersQueryQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, stargazers: { __typename: 'StargazerConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'StargazerEdge', node?: { __typename: 'User', id: string, name: string, username?: string | null, userInfo?: any | null, photoUrl?: string | null } | null }> } } | null };

export type PublicViewsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicViewsQuery = { __typename: 'Query', publicViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, name?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null, name: string } | null } | null }> } | null };

export type ViewDraftsQueryVariables = Exact<{
  viewID: Scalars['ID']['input'];
}>;


export type ViewDraftsQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, children?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, entityName: string, user?: { __typename: 'User', id: string } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null } | null };

export type ViewPermissionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type ViewPermissionsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, settings: { __typename: 'EntitySettings', disableMagicLinkSharing?: boolean | null, hidden: boolean } } | null, project?: { __typename: 'Project', id: string, access?: string | null } | null };

export type ViewViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewViewMutation = { __typename: 'Mutation', viewView?: { __typename: 'ViewViewPayload', success?: boolean | null } | null };

export type AccountPrivilegesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AccountPrivilegesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, plan: { __typename: 'Plan', id: string, planType: PlanType } }> } | null };

export type AccountEnterpriseWeaveLimitsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AccountEnterpriseWeaveLimitsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, weaveEnterpriseSubscription?: { __typename: 'WeaveEnterpriseSubscription', billingPeriodStart?: string | null, billingPeriodEnd?: string | null, weaveLimit?: { __typename: 'WeaveLimits', weaveLimitBytes?: any | null, weaveOverageCostCents?: number | null, weaveOverageUnit?: StorageUnit | null } | null } | null } | null };

export type AccountSubscriptionPlansQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AccountSubscriptionPlansQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, plan: { __typename: 'Plan', id: string, planType: PlanType, name: string } }> } | null };

export type UserDynamicConfigQueryVariables = Exact<{
  configId: Scalars['String']['input'];
}>;


export type UserDynamicConfigQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, dynamicConfig: { __typename: 'DynamicConfig', value: any } } | null };

export type EntityDynamicConfigQueryVariables = Exact<{
  configId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type EntityDynamicConfigQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, dynamicConfig: { __typename: 'DynamicConfig', value: any } } | null };

export type OrganizationDyamicConfigQueryVariables = Exact<{
  configId: Scalars['String']['input'];
  orgName: Scalars['String']['input'];
}>;


export type OrganizationDyamicConfigQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgType: OrgType, dynamicConfig: { __typename: 'DynamicConfig', value: any } } | null };

export type TeamOrgQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamOrgQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, organization?: { __typename: 'Organization', id: string, name: string } | null } | null };

export type BillingPeriodSubscriptionsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type BillingPeriodSubscriptionsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, createdAt: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }>, inferenceEnterpriseSubscription?: { __typename: 'InferenceEnterpriseSubscription', billingPeriodStart: string, billingPeriodEnd: string, inferenceLimit: any } | null } | null };

export type OrganizationSubscriptionUpdateAdditionalInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationSubscriptionUpdateAdditionalInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, weaveEnterpriseSubscription?: { __typename: 'WeaveEnterpriseSubscription', billingPeriodStart?: string | null, billingPeriodEnd?: string | null } | null, inferenceEnterpriseSubscription?: { __typename: 'InferenceEnterpriseSubscription', billingPeriodStart: string, billingPeriodEnd: string, inferenceLimit: any } | null } | null };

export const GraphDataFragmentFragmentDoc = gql`
    fragment GraphDataFragment on ArtifactLineageDag {
  artifacts {
    id
    artifactNodeID
    entityName
    projectName
    artifactTypeName
    artifactSequenceName
    artifactCommitHash
    versionIndex
  }
  runs {
    runNodeID
    entityName
    projectName
    runName
    displayName
    jobType
  }
  clusters {
    id
    nodeType
    runNodes {
      runNodeID
      entityName
      projectName
      runName
      displayName
      jobType
    }
    artifactNodes {
      id
      artifactNodeID
      entityName
      projectName
      artifactTypeName
      artifactSequenceName
      artifactCommitHash
      versionIndex
    }
    clusterEdges {
      edgeID
      artifactNodeID
      runNodeID
      clusterNodeID
      direction
    }
  }
  edges {
    edgeID
    artifactNodeID
    runNodeID
    clusterNodeID
    direction
  }
  hitLimit
}
    `;
export const TriggerScopeFragmentFragmentDoc = gql`
    fragment TriggerScopeFragment on TriggerScope {
  __typename
  ... on Project {
    id
    name
  }
  ... on ArtifactSequence {
    id
    name
    project {
      id
      name
    }
  }
  ... on ArtifactPortfolio {
    id
    name
    project {
      id
      name
    }
  }
}
    `;
export const TriggeringConditionFragmentFragmentDoc = gql`
    fragment TriggeringConditionFragment on TriggeringCondition {
  __typename
  ... on FilterEventTriggeringCondition {
    eventType
    filter
  }
}
    `;
export const TriggeredActionFragmentFragmentDoc = gql`
    fragment TriggeredActionFragment on TriggeredAction {
  __typename
  ... on QueueJobTriggeredAction {
    queue {
      id
      name
    }
    template
  }
  ... on NotificationTriggeredAction {
    integration {
      id
      ... on SlackIntegration {
        channelName
      }
    }
    title
    message
    severity
    entityName
  }
  ... on GenericWebhookTriggeredAction {
    integration {
      __typename
      ... on GenericWebhookIntegration {
        id
        name
        urlEndpoint
        accessTokenRef
        secretRef
        createdAt
      }
    }
    entityName
    requestPayload
  }
}
    `;
export const TriggerFragmentFragmentDoc = gql`
    fragment TriggerFragment on Trigger {
  id
  name
  createdAt
  enabled
  createdBy {
    id
    name
  }
  description
  triggerExecutions(first: 1, order: "-created_at") {
    edges {
      node {
        id
        createdAt
        state
      }
    }
  }
  scope {
    ...TriggerScopeFragment
  }
  triggeringCondition {
    ...TriggeringConditionFragment
  }
  triggeredAction {
    ...TriggeredActionFragment
  }
}
    ${TriggerScopeFragmentFragmentDoc}
${TriggeringConditionFragmentFragmentDoc}
${TriggeredActionFragmentFragmentDoc}`;
export const ProjectListFragmentDoc = gql`
    fragment ProjectList on Project {
  name
  access
  entityName
  totalRuns: runCount
  createdAt
  lastActive
}
    `;
export const RunWithoutRunInfoStateBasicFragmentFragmentDoc = gql`
    fragment RunWithoutRunInfoStateBasicFragment on Run {
  agent {
    id
    name
  }
  benchmarkRun {
    id
  }
  commit
  computeSeconds
  createdAt
  defaultColorIndex
  displayName
  framework
  github
  group
  groupCounts
  heartbeatAt
  host
  jobType
  logLineCount
  notes
  projectId
  readOnly
  shouldStop
  state
  stopped
  sweep {
    id
    name
    displayName
    config
  }
  user {
    id
    username
    photoUrl
  }
}
    `;
export const BackendLinesRunDeltasFragmentFragmentDoc = gql`
    fragment BackendLinesRunDeltasFragment on RunConnection {
  deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
    order
    incomplete
    delta {
      op
      run {
        ...RunWithoutRunInfoStateBasicFragment @include(if: $enableBasic)
        config(keys: $configKeys) @include(if: $enableConfig)
        defaultColorIndex
        displayName
        id
        lines(specs: $bucketedHistorySpecs)
        name
        projectId
        summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
        updatedAt
      }
    }
  }
}
    ${RunWithoutRunInfoStateBasicFragmentFragmentDoc}`;
export const BackendLinesDeltaQueryFragmentFragmentDoc = gql`
    fragment BackendLinesDeltaQueryFragment on Project {
  entityName
  name
  baselineRun: runs(filters: $baselineRunFilters, first: 1) @include(if: $includeBaselineRun) {
    ...BackendLinesRunDeltasFragment
  }
  pinnedRuns: runs(filters: $pinnedRunFilters, first: $pinnedRunsLimit) @include(if: $includePinnedRuns) {
    ...BackendLinesRunDeltasFragment
  }
  runs(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
  ) {
    totalCount
    ...BackendLinesRunDeltasFragment
  }
}
    ${BackendLinesRunDeltasFragmentFragmentDoc}`;
export const RunDeltasFragmentFragmentDoc = gql`
    fragment RunDeltasFragment on RunConnection {
  deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
    order
    incomplete
    delta {
      op
      run {
        ...RunWithoutRunInfoStateBasicFragment @include(if: $enableBasic)
        bucketedHistory(specs: $bucketedHistorySpecs, packVersion: 1)
        config(keys: $configKeys) @include(if: $enableConfig)
        defaultColorIndex
        displayName
        id
        name
        projectId
        summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
        updatedAt
      }
    }
  }
}
    ${RunWithoutRunInfoStateBasicFragmentFragmentDoc}`;
export const DeltaQueryFragmentWithoutRunInfoFragmentDoc = gql`
    fragment DeltaQueryFragmentWithoutRunInfo on Project {
  entityName
  name
  baselineRun: runs(filters: $baselineRunFilters, first: 1) @include(if: $includeBaselineRun) {
    ...RunDeltasFragment
  }
  pinnedRuns: runs(filters: $pinnedRunFilters, first: $pinnedRunsLimit) @include(if: $includePinnedRuns) {
    ...RunDeltasFragment
  }
  runs(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
  ) {
    totalCount
    ...RunDeltasFragment
  }
}
    ${RunDeltasFragmentFragmentDoc}`;
export const GroupedBackendLinesDeltaQueryFragmentFragmentDoc = gql`
    fragment GroupedBackendLinesDeltaQueryFragment on Project {
  entityName
  name
  groupedRuns(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
    expressions: $expressions
    maxGroups: $maxGroups
  ) {
    ... on GroupedRunConnection {
      deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
        order
        incomplete
        delta {
          op
          groupedRun {
            lines(specs: $bucketedHistorySpecs)
            createdAt
            config(keys: $configKeys) @include(if: $enableConfig)
            defaultColorIndex
            displayName
            id
            name
            projectId
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            updatedAt
            group
            jobType
            state
            host
            sweep {
              id
              name
              displayName
              config
            }
            user {
              id
              username
              photoUrl
            }
          }
        }
      }
    }
    ... on RunConnection {
      totalCount
      deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
        order
        incomplete
        delta {
          op
          run {
            ...RunWithoutRunInfoStateBasicFragment @include(if: $enableBasic)
            config(keys: $configKeys) @include(if: $enableConfig)
            defaultColorIndex
            displayName
            id
            lines(specs: $bucketedHistorySpecs)
            name
            projectId
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            updatedAt
          }
        }
      }
    }
  }
}
    ${RunWithoutRunInfoStateBasicFragmentFragmentDoc}`;
export const GroupedDeltaQueryFragmentWithoutRunInfoFragmentDoc = gql`
    fragment GroupedDeltaQueryFragmentWithoutRunInfo on Project {
  groupedRuns(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
    expressions: $expressions
    maxGroups: $maxGroups
  ) {
    __typename
    ... on GroupedRunConnection {
      deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
        order
        incomplete
        delta {
          op
          groupedRun {
            bucketedHistory(specs: $bucketedHistorySpecs, packVersion: 1)
            createdAt
            config(keys: $configKeys) @include(if: $enableConfig)
            defaultColorIndex
            displayName
            id
            name
            projectId
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            updatedAt
            group
            jobType
            state
            host
            sweep {
              id
              name
              displayName
              config
            }
            user {
              id
              username
              photoUrl
            }
          }
        }
      }
    }
    ... on RunConnection {
      totalCount
      deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
        order
        incomplete
        delta {
          op
          run {
            ...RunWithoutRunInfoStateBasicFragment @include(if: $enableBasic)
            bucketedHistory(specs: $bucketedHistorySpecs, packVersion: 1)
            config(keys: $configKeys) @include(if: $enableConfig)
            defaultColorIndex
            displayName
            id
            name
            projectId
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            updatedAt
          }
        }
      }
    }
  }
}
    ${RunWithoutRunInfoStateBasicFragmentFragmentDoc}`;
export const ModelRegistryMigrationConfigFragmentFragmentDoc = gql`
    fragment ModelRegistryMigrationConfigFragment on ModelRegistryMigrationConfig {
  blockWritesLegacyModelRegistry
  blockWritesMigratedModelRegistry
  migrationCompletedAt
  orgRegistryProject {
    id
    name
    entityName
  }
}
    `;
export const OrganizationMemberFragmentFragmentDoc = gql`
    fragment OrganizationMemberFragment on OrganizationMember {
  orgID
  user {
    id
    accountType
    admin
  }
  admin
  username
  name
  id
  email
  photoUrl
  role
  modelsSeat
}
    `;
export const RegistrySearchCollectionFragmentFragmentDoc = gql`
    fragment registrySearchCollectionFragment on ArtifactCollection {
  __typename
  ... on ArtifactPortfolio {
    id
    name
    description
    createdAt
    updatedAt
    defaultArtifactType {
      id
      name
    }
    project {
      id
      name
      entityName
      protectedArtifactAliases {
        alias
      }
      icon {
        name
        color
      }
    }
    tags {
      edges {
        node {
          id
          name
          tagCategoryName
          attributes
        }
      }
    }
  }
  __typename
  ... on ArtifactSequence {
    id
    name
    description
    createdAt
    updatedAt
    defaultArtifactType {
      id
      name
    }
    project {
      id
      name
      entityName
      protectedArtifactAliases {
        alias
      }
      icon {
        name
        color
      }
    }
    tags {
      edges {
        node {
          id
          name
          tagCategoryName
          attributes
        }
      }
    }
  }
}
    `;
export const RegistrySearchArtifactMembershipsFragmentFragmentDoc = gql`
    fragment registrySearchArtifactMembershipsFragment on ArtifactCollectionMembership {
  ... on ArtifactCollectionMembership {
    id
    versionIndex
    createdAt
    aliases {
      id
      alias
    }
    artifact {
      id
      tags {
        id
        name
        tagCategoryName
        attributes
      }
      metadata
      size
      usedCount
    }
  }
}
    `;
export const RegistrySearchResultFragmentFragmentDoc = gql`
    fragment registrySearchResultFragment on ArtifactCollectionSearchConnection {
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
  edges {
    artifactMatch
    lastUpdatedAt
    cursor
    node {
      ...registrySearchCollectionFragment
    }
    artifactMemberships {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...registrySearchArtifactMembershipsFragment
        }
      }
    }
  }
}
    ${RegistrySearchCollectionFragmentFragmentDoc}
${RegistrySearchArtifactMembershipsFragmentFragmentDoc}`;
export const ProjectInfoFragmentFragmentDoc = gql`
    fragment ProjectInfoFragment on Project {
  id
  name
  entity {
    id
    name
  }
}
    `;
export const RegistryCollectionFragmentFragmentDoc = gql`
    fragment RegistryCollectionFragment on ArtifactCollection {
  __typename
  id
  name
  description
  createdAt
  project {
    ...ProjectInfoFragment
  }
  artifactType: defaultArtifactType {
    id
    name
  }
}
    ${ProjectInfoFragmentFragmentDoc}`;
export const RegistryCollectionWithDetailsFragmentFragmentDoc = gql`
    fragment RegistryCollectionWithDetailsFragment on ArtifactCollection {
  __typename
  id
  name
  description
  createdAt
  updatedAt
  project {
    id
    name
    entity {
      id
      name
    }
    protectedArtifactAliases {
      alias
    }
    icon {
      name
      color
    }
  }
  artifactType: defaultArtifactType {
    id
    name
  }
  tags {
    edges {
      node {
        id
        name
        tagCategoryName
        attributes
      }
    }
  }
}
    `;
export const PageInfoFragmentFragmentDoc = gql`
    fragment PageInfoFragment on PageInfo {
  __typename
  endCursor
  hasNextPage
}
    `;
export const ArtifactMembershipFragmentFragmentDoc = gql`
    fragment ArtifactMembershipFragment on ArtifactCollectionMembership {
  id
  versionIndex
  createdAt
  aliases {
    id
    alias
  }
  artifact {
    id
    artifactCreatedAt: createdAt
    tags {
      id
      name
      tagCategoryName
      attributes
    }
    usedCount
  }
  artifactCollection {
    id
    name
    defaultArtifactType {
      id
      name
    }
    project {
      id
      name
      entityName
      icon {
        name
        color
      }
    }
  }
}
    `;
export const ProjectFragmentFragmentDoc = gql`
    fragment ProjectFragment on Project {
  internalId
  name
  user {
    id
    name
    photoUrl
  }
  entityName
  access
  createdAt
  lastActive
  updatedAt
  description
  totalArtifactCollections(collectionTypes: [PORTFOLIO])
  artifactTypes(includeAll: true) {
    edges {
      node {
        id
        name
      }
    }
  }
  allowAllArtifactTypesInRegistry
  protectedArtifactAliases {
    alias
  }
  icon {
    name
    color
  }
}
    `;
export const RegistryProjectsSearchFragmentFragmentDoc = gql`
    fragment RegistryProjectsSearchFragment on ProjectConnection {
  pageInfo {
    hasNextPage
    startCursor
    endCursor
  }
  edges {
    node {
      id
      ...ProjectFragment
    }
  }
}
    ${ProjectFragmentFragmentDoc}`;
export const ImportPanelMenuEntityFragmentFragmentDoc = gql`
    fragment ImportPanelMenuEntityFragment on Entity {
  id
  name
  projects(order: "-created_at", first: 10000, pattern: $projectSearchQuery) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export const ImportPanelProjectViewsFragmentFragmentDoc = gql`
    fragment ImportPanelProjectViewsFragment on View {
  id
  name
  user {
    id
    username
  }
}
    `;
export const ReportsTableFragmentFragmentDoc = gql`
    fragment ReportsTableFragment on View {
  id
  displayName
  description
  user {
    id
    username
    photoUrl
    admin
  }
  project {
    id
    name
    entityName
    access
  }
  starCount
  createdAt
  updatedAt
  starred
  showcasedAt
  previewUrl
  viewCount
}
    `;
export const RunsTableFragmentFragmentDoc = gql`
    fragment RunsTableFragment on Run {
  id
  name
  displayName
  state
  createdAt
  heartbeatAt
  updatedAt
  user {
    id
    username
  }
  project {
    id
    name
    entityName
  }
  groupCounts
}
    `;
export const BenchmarkRunsFragmentFragmentDoc = gql`
    fragment benchmarkRunsFragment on BenchmarkRunConnection {
  edges {
    node {
      id
      gitHubSubmissionPR
      createdAt
      details
      results
      state
      user {
        id
        username
        photoUrl
        admin
      }
      originalRun {
        id
        name
        displayName
        project {
          id
          name
          entityName
        }
      }
      originalProject {
        id
        name
        entityName
      }
      run {
        github
        commit
        id
        name
        displayName
        notes
        user {
          id
          username
        }
        diffPatchFile: files(first: 1, names: ["diff.patch"]) {
          edges {
            node {
              id
              name
              md5
              sizeBytes
            }
          }
        }
        summaryMetrics
      }
      benchmark {
        id
        name
        entityName
      }
    }
  }
}
    `;
export const CustomChartFragmentFragmentDoc = gql`
    fragment CustomChartFragment on CustomChart {
  id
  name
  displayName
  entity {
    id
    name
    readOnly
  }
  user {
    id
    username
  }
  spec
  access
}
    `;
export const ArtifactNodeFragmentDoc = gql`
    fragment ArtifactNode on ArtifactSequenceStorageNode {
  id
  name
  size
  artifactType {
    id
    name
  }
  artifactSequenceID
}
    `;
export const RunNodeFragmentDoc = gql`
    fragment RunNode on RunStorageNode {
  id
  name
  size
  runID
}
    `;
export const GetEmails_UserFragmentDoc = gql`
    fragment GetEmails_User on User {
  id
  emails {
    id
    emailAddress
    type
    createdAt
    verified
    identities {
      id
      emailIdentityVerified
      provider
    }
  }
}
    `;
export const OrganizationSubscriptionBasicInfoFragmentDoc = gql`
    fragment OrganizationSubscriptionBasicInfo on Organization {
  name
  orgType
  memberCount
  subscriptions {
    id
    subscriptionType
    plan {
      id
      name
      planType
    }
  }
}
    `;
export const AccountProjectFragmentFragmentDoc = gql`
    fragment AccountProjectFragment on Project {
  id
  name
  entityName
  access
  totalRuns
  createdAt
  lastActive
  description
  user {
    id
    username
  }
}
    `;
export const ProjectMemberFieldsFragmentDoc = gql`
    fragment ProjectMemberFields on ProjectMember {
  id
  name
  username
  email
  photoUrl
  accountType
  projectRoleIsInherited
  role {
    ID
    name
    inheritedFrom {
      permissions {
        name
      }
    }
    permissions {
      name
    }
  }
}
    `;
export const RunQueueItemFragmentFragmentDoc = gql`
    fragment RunQueueItemFragment on RunQueueItem {
  id
  createdAt
  updatedAt
  runSpec
  state
  associatedRunId
  launchAgentId
  priority
  templateVariableValues
}
    `;
export const BasicRunFragmentFragmentDoc = gql`
    fragment BasicRunFragment on Run {
  id
  readOnly
  framework
  displayName
  notes
  github
  group
  jobType
  createdAt
  heartbeatAt
  commit
  host
  state
  shouldStop
  groupCounts
  stopped
  defaultColorIndex
  sweep {
    id
    name
    displayName
  }
  agent {
    id
    name
  }
  user {
    id
    username
    photoUrl
  }
  tags: tagColors {
    id
    name
    colorIndex
  }
  benchmarkRun {
    id
  }
  runInfo {
    gpuCount
    gpu
  }
}
    `;
export const DetailedRunFragmentFragmentDoc = gql`
    fragment DetailedRunFragment on Run {
  history
  events
  fileCount
  logLines(after: $logCursor, last: 1000) {
    edges {
      node {
        id
        line
        level
      }
    }
  }
}
    `;
export const RunFilesFragmentFragmentDoc = gql`
    fragment RunFilesFragment on Run {
  files(after: $fileCursor, first: $fileLimit, names: $fileNames) {
    edges {
      node {
        id
        name
        directUrl
        url(upload: $upload)
        sizeBytes
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const SelectRunFragmentFragmentDoc = gql`
    fragment SelectRunFragment on Run {
  config
  summaryMetrics(packVersion: 1)
  systemMetrics
}
    `;
export const HistoryRunFragmentFragmentDoc = gql`
    fragment HistoryRunFragment on Run {
  history(samples: $historySamples)
}
    `;
export const SampledHistoryRunFragmentFragmentDoc = gql`
    fragment SampledHistoryRunFragment on Run {
  sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
}
    `;
export const UserRoleFragmentFragmentDoc = gql`
    fragment UserRoleFragment on User {
  accountType
  admin
  deletedAt
  email
  username
}
    `;
export const EmailBasicFragmentDoc = gql`
    fragment EmailBasic on Email {
  id
  emailAddress
  createdAt
  type
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  name
  email
  username
  deletedAt
  photoUrl
}
    `;
export const ViewFragmentFragmentDoc = gql`
    fragment ViewFragment on View {
  id
  type
  name
  displayName
  description
  user {
    id
    username
    photoUrl
    admin
  }
  project {
    id
    name
    entityName
  }
  spec
  updatedAt
}
    `;
export const ViewFragmentMetadataFragmentDoc = gql`
    fragment ViewFragmentMetadata on View {
  id
  type
  name
  displayName
  description
  updatedBy {
    id
    username
    name
  }
  user {
    id
    username
    photoUrl
    admin
  }
  project {
    id
    name
    entityName
  }
  updatedAt
  createdAt
  starred
  starCount
  parentId
  locked
  viewCount
  alertSubscription {
    id
  }
}
    `;
export const HistoryKeysFieldsFragmentDoc = gql`
    fragment HistoryKeysFields on Project {
  id
  runs(filters: $filters, first: $limit, order: $order) {
    edges {
      node {
        id
        wandbConfig(keys: ["viz", "visualize"])
      }
    }
  }
}
    `;
export const JobInfoFragmentDoc = gql`
    fragment JobInfo on ArtifactCollection {
  id
  name
  description
  createdAt
  artifacts {
    edges {
      node {
        id
        description
        labels
        versionIndex
        aliases {
          id
          alias
        }
        usedBy(first: 1, order: "-createdAt", filters: $filters) {
          totalCount
          edges {
            node {
              id
              name
              displayName
              state
              createdAt
            }
          }
        }
      }
    }
  }
}
    `;
export const DefaultResourceConfigFragmentFragmentDoc = gql`
    fragment DefaultResourceConfigFragment on DefaultResourceConfig {
  id
  createdAt
  updatedAt
  scope {
    __typename
    Type
    ID
  }
  resource
  config
  templateVariables {
    name
    description
    schema
  }
}
    `;
export const WeaveflowCheckFragmentFragmentDoc = gql`
    fragment WeaveflowCheckFragment on Project {
  weaveRun: run(name: "__weave_trace_server__") {
    id
  }
}
    `;
export const ArtifactCountsFragmentFragmentDoc = gql`
    fragment ArtifactCountsFragment on Run {
  inputArtifacts {
    totalCount
  }
  outputArtifacts {
    totalCount
  }
}
    `;
export const RunFieldsFragmentDoc = gql`
    fragment RunFields on Run {
  id
  agent {
    id
    name
  }
  aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
  benchmarkRun {
    id
  }
  commit
  computeSeconds
  config(keys: $configKeys) @include(if: $enableConfig)
  createdAt
  defaultColorIndex
  displayName
  framework
  github
  group
  groupCounts
  heartbeatAt
  host
  jobType
  logLineCount
  name
  notes
  projectId
  readOnly
  runInfo {
    gpu
    gpuCount
  }
  shouldStop
  state
  stopped
  summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
  sweep {
    id
    name
    displayName
    config
  }
  tags: tagColors @include(if: $enableTags) {
    id
    name
    colorIndex
  }
  updatedAt
  user {
    id
    username
    photoUrl
  }
  wandbConfig(keys: $wandbKeys)
  ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
}
    ${ArtifactCountsFragmentFragmentDoc}`;
export const RunsSelectorRunsProjectFragmentFragmentDoc = gql`
    fragment RunsSelectorRunsProjectFragment on Project {
  id
  runs(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
  ) {
    totalCount
    deltaOrder(currentRuns: $currentRuns, lastUpdated: $lastUpdated)
    delta(currentRuns: $currentRuns, lastUpdated: $lastUpdated) {
      index
      op
      run {
        ...RunFields
      }
    }
  }
  pinnedRuns: runs(filters: $pinnedRunsFilter, order: $order) {
    edges {
      node {
        ...RunFields
      }
    }
  }
}
    ${RunFieldsFragmentDoc}`;
export const TeamMemberFieldsFragmentDoc = gql`
    fragment TeamMemberFields on Member {
  id
  username
  name
  photoUrl
  role
}
    `;
export const TeamMemberDetailedRoleFragmentDoc = gql`
    fragment TeamMemberDetailedRole on Member {
  memberRole {
    ID
    name
    permissions {
      name
    }
    inheritedFrom {
      ID
      name
      permissions {
        name
      }
    }
  }
}
    `;
export const NodeAlertFragmentFragmentDoc = gql`
    fragment NodeAlertFragment on NodeAlert {
  alertName
  alertStatus
  cluster
  clusterOrg
  description
  grafanaDashboard
  labels
  node
  pod
  occurrences
}
    `;
export const RunInfoFragmentFragmentDoc = gql`
    fragment RunInfoFragment on Run {
  runInfo {
    gpu
    gpuCount
    codePath
    codePathLocal
  }
}
    `;
export const RunStateBasicFragmentFragmentDoc = gql`
    fragment RunStateBasicFragment on Run {
  ...RunWithoutRunInfoStateBasicFragment
  ...RunInfoFragment
}
    ${RunWithoutRunInfoStateBasicFragmentFragmentDoc}
${RunInfoFragmentFragmentDoc}`;
export const ViewFragmentMetadata2FragmentDoc = gql`
    fragment ViewFragmentMetadata2 on View {
  id
  name
  displayName
  type
  description
  user {
    id
    username
    photoUrl
    admin
    name
  }
  updatedBy {
    id
    name
    username
  }
  entityName
  project {
    id
    name
    entityName
    readOnly
  }
  previewUrl
  coverUrl
  updatedAt
  createdAt
  starCount
  starred
  parentId
  locked
  viewCount
  showcasedAt
  alertSubscription {
    id
  }
  accessTokens {
    id
    token
    view {
      id
    }
    type
    emails
    createdBy {
      id
      username
      email
      name
    }
    createdAt
    lastAccessedAt
    revokedAt
    projects {
      id
      name
      entityName
    }
  }
}
    `;
export const ArtifactDagDocument = gql`
    query ArtifactDAG($artifactVersionID: ID!, $limit: Int!, $filterGeneratedArtifacts: Boolean!, $clusterSize: Int, $directLineage: Boolean, $traversalDirection: TraversalDirection, $baseGraphNodeIDs: [String!]) {
  artifact(id: $artifactVersionID) {
    id
    artifactLineageDag(
      limit: $limit
      filterGeneratedArtifacts: $filterGeneratedArtifacts
      clusterSize: $clusterSize
      directLineage: $directLineage
      traversalDirection: $traversalDirection
      baseGraphNodeIDs: $baseGraphNodeIDs
    ) {
      ...GraphDataFragment
    }
  }
}
    ${GraphDataFragmentFragmentDoc}`;
export type ArtifactDagComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactDagQuery, ArtifactDagQueryVariables>, 'query'> & ({ variables: ArtifactDagQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactDagComponent = (props: ArtifactDagComponentProps) => (
      <ApolloReactComponents.Query<ArtifactDagQuery, ArtifactDagQueryVariables> query={ArtifactDagDocument} {...props} />
    );
    
export type ArtifactDagProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactDagQuery, ArtifactDagQueryVariables>
    } & TChildProps;
export function withArtifactDag<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactDagQuery,
  ArtifactDagQueryVariables,
  ArtifactDagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactDagQuery, ArtifactDagQueryVariables, ArtifactDagProps<TChildProps, TDataName>>(ArtifactDagDocument, {
      alias: 'artifactDag',
      ...operationOptions
    });
};

/**
 * __useArtifactDagQuery__
 *
 * To run a query within a React component, call `useArtifactDagQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactDagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactDagQuery({
 *   variables: {
 *      artifactVersionID: // value for 'artifactVersionID'
 *      limit: // value for 'limit'
 *      filterGeneratedArtifacts: // value for 'filterGeneratedArtifacts'
 *      clusterSize: // value for 'clusterSize'
 *      directLineage: // value for 'directLineage'
 *      traversalDirection: // value for 'traversalDirection'
 *      baseGraphNodeIDs: // value for 'baseGraphNodeIDs'
 *   },
 * });
 */
export function useArtifactDagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables> & ({ variables: ArtifactDagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactDagQuery, ArtifactDagQueryVariables>(ArtifactDagDocument, options);
      }
export function useArtifactDagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactDagQuery, ArtifactDagQueryVariables>(ArtifactDagDocument, options);
        }
// @ts-ignore
export function useArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactDagQuery, ArtifactDagQueryVariables>;
export function useArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactDagQuery | undefined, ArtifactDagQueryVariables>;
export function useArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactDagQuery, ArtifactDagQueryVariables>(ArtifactDagDocument, options);
        }
export type ArtifactDagQueryHookResult = ReturnType<typeof useArtifactDagQuery>;
export type ArtifactDagLazyQueryHookResult = ReturnType<typeof useArtifactDagLazyQuery>;
export type ArtifactDagSuspenseQueryHookResult = ReturnType<typeof useArtifactDagSuspenseQuery>;
export type ArtifactDagQueryResult = ApolloReactCommon.QueryResult<ArtifactDagQuery, ArtifactDagQueryVariables>;
export const ArtifactOverviewDocument = gql`
    query ArtifactOverview($artifactID: ID!, $artifactVersionIndex: String!) {
  artifact(id: $artifactID) {
    id
    artifactSequence {
      id
      name
      project {
        id
        name
        entityName
      }
      artifactMembership(aliasName: $artifactVersionIndex) {
        id
        aliases {
          id
          alias
        }
      }
    }
    digest
    description
    size
    fileCount
    createdAt
    createdBy {
      __typename
      ... on Run {
        id
        runName: name
        displayName
        runProjectQuery: project {
          id
          runProject: name
          runEntity: entityName
        }
      }
      ... on User {
        id
        username
      }
    }
    artifactMemberships {
      edges {
        node {
          id
          versionIndex
          artifactCollection {
            __typename
            id
            ... on ArtifactPortfolio {
              linkPortfolioName: name
              linkProjectQuery: project {
                id
                linkProjectName: name
                linkEntityName: entityName
              }
            }
          }
        }
      }
    }
    usedCount
    ttlDurationSeconds
  }
}
    `;
export type ArtifactOverviewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>, 'query'> & ({ variables: ArtifactOverviewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactOverviewComponent = (props: ArtifactOverviewComponentProps) => (
      <ApolloReactComponents.Query<ArtifactOverviewQuery, ArtifactOverviewQueryVariables> query={ArtifactOverviewDocument} {...props} />
    );
    
export type ArtifactOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>
    } & TChildProps;
export function withArtifactOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactOverviewQuery,
  ArtifactOverviewQueryVariables,
  ArtifactOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactOverviewQuery, ArtifactOverviewQueryVariables, ArtifactOverviewProps<TChildProps, TDataName>>(ArtifactOverviewDocument, {
      alias: 'artifactOverview',
      ...operationOptions
    });
};

/**
 * __useArtifactOverviewQuery__
 *
 * To run a query within a React component, call `useArtifactOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactOverviewQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      artifactVersionIndex: // value for 'artifactVersionIndex'
 *   },
 * });
 */
export function useArtifactOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables> & ({ variables: ArtifactOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>(ArtifactOverviewDocument, options);
      }
export function useArtifactOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>(ArtifactOverviewDocument, options);
        }
// @ts-ignore
export function useArtifactOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>;
export function useArtifactOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactOverviewQuery | undefined, ArtifactOverviewQueryVariables>;
export function useArtifactOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>(ArtifactOverviewDocument, options);
        }
export type ArtifactOverviewQueryHookResult = ReturnType<typeof useArtifactOverviewQuery>;
export type ArtifactOverviewLazyQueryHookResult = ReturnType<typeof useArtifactOverviewLazyQuery>;
export type ArtifactOverviewSuspenseQueryHookResult = ReturnType<typeof useArtifactOverviewSuspenseQuery>;
export type ArtifactOverviewQueryResult = ApolloReactCommon.QueryResult<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>;
export const RunArtifactDagDocument = gql`
    query RunArtifactDAG($projectName: String!, $entityName: String!, $runName: String!, $limit: Int!, $filterGeneratedArtifacts: Boolean!, $clusterSize: Int, $directLineage: Boolean, $traversalDirection: TraversalDirection, $baseGraphNodeIDs: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      artifactLineageDag(
        limit: $limit
        filterGeneratedArtifacts: $filterGeneratedArtifacts
        clusterSize: $clusterSize
        directLineage: $directLineage
        traversalDirection: $traversalDirection
        baseGraphNodeIDs: $baseGraphNodeIDs
      ) {
        ...GraphDataFragment
      }
    }
  }
}
    ${GraphDataFragmentFragmentDoc}`;
export type RunArtifactDagComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>, 'query'> & ({ variables: RunArtifactDagQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunArtifactDagComponent = (props: RunArtifactDagComponentProps) => (
      <ApolloReactComponents.Query<RunArtifactDagQuery, RunArtifactDagQueryVariables> query={RunArtifactDagDocument} {...props} />
    );
    
export type RunArtifactDagProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunArtifactDagQuery, RunArtifactDagQueryVariables>
    } & TChildProps;
export function withRunArtifactDag<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunArtifactDagQuery,
  RunArtifactDagQueryVariables,
  RunArtifactDagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunArtifactDagQuery, RunArtifactDagQueryVariables, RunArtifactDagProps<TChildProps, TDataName>>(RunArtifactDagDocument, {
      alias: 'runArtifactDag',
      ...operationOptions
    });
};

/**
 * __useRunArtifactDagQuery__
 *
 * To run a query within a React component, call `useRunArtifactDagQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunArtifactDagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunArtifactDagQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      limit: // value for 'limit'
 *      filterGeneratedArtifacts: // value for 'filterGeneratedArtifacts'
 *      clusterSize: // value for 'clusterSize'
 *      directLineage: // value for 'directLineage'
 *      traversalDirection: // value for 'traversalDirection'
 *      baseGraphNodeIDs: // value for 'baseGraphNodeIDs'
 *   },
 * });
 */
export function useRunArtifactDagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables> & ({ variables: RunArtifactDagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunArtifactDagQuery, RunArtifactDagQueryVariables>(RunArtifactDagDocument, options);
      }
export function useRunArtifactDagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunArtifactDagQuery, RunArtifactDagQueryVariables>(RunArtifactDagDocument, options);
        }
// @ts-ignore
export function useRunArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunArtifactDagQuery, RunArtifactDagQueryVariables>;
export function useRunArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunArtifactDagQuery | undefined, RunArtifactDagQueryVariables>;
export function useRunArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunArtifactDagQuery, RunArtifactDagQueryVariables>(RunArtifactDagDocument, options);
        }
export type RunArtifactDagQueryHookResult = ReturnType<typeof useRunArtifactDagQuery>;
export type RunArtifactDagLazyQueryHookResult = ReturnType<typeof useRunArtifactDagLazyQuery>;
export type RunArtifactDagSuspenseQueryHookResult = ReturnType<typeof useRunArtifactDagSuspenseQuery>;
export type RunArtifactDagQueryResult = ApolloReactCommon.QueryResult<RunArtifactDagQuery, RunArtifactDagQueryVariables>;
export const RunOverviewLineageDocument = gql`
    query RunOverviewLineage($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      project {
        id
        name
      }
      createdAt
      group
      state
      notes
      config
      tags
      host
      computeSeconds
      user {
        id
        username
      }
      runInfo {
        os
        python
      }
    }
  }
}
    `;
export type RunOverviewLineageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>, 'query'> & ({ variables: RunOverviewLineageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunOverviewLineageComponent = (props: RunOverviewLineageComponentProps) => (
      <ApolloReactComponents.Query<RunOverviewLineageQuery, RunOverviewLineageQueryVariables> query={RunOverviewLineageDocument} {...props} />
    );
    
export type RunOverviewLineageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>
    } & TChildProps;
export function withRunOverviewLineage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunOverviewLineageQuery,
  RunOverviewLineageQueryVariables,
  RunOverviewLineageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunOverviewLineageQuery, RunOverviewLineageQueryVariables, RunOverviewLineageProps<TChildProps, TDataName>>(RunOverviewLineageDocument, {
      alias: 'runOverviewLineage',
      ...operationOptions
    });
};

/**
 * __useRunOverviewLineageQuery__
 *
 * To run a query within a React component, call `useRunOverviewLineageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunOverviewLineageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunOverviewLineageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunOverviewLineageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables> & ({ variables: RunOverviewLineageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>(RunOverviewLineageDocument, options);
      }
export function useRunOverviewLineageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>(RunOverviewLineageDocument, options);
        }
// @ts-ignore
export function useRunOverviewLineageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>;
export function useRunOverviewLineageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewLineageQuery | undefined, RunOverviewLineageQueryVariables>;
export function useRunOverviewLineageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>(RunOverviewLineageDocument, options);
        }
export type RunOverviewLineageQueryHookResult = ReturnType<typeof useRunOverviewLineageQuery>;
export type RunOverviewLineageLazyQueryHookResult = ReturnType<typeof useRunOverviewLineageLazyQuery>;
export type RunOverviewLineageSuspenseQueryHookResult = ReturnType<typeof useRunOverviewLineageSuspenseQuery>;
export type RunOverviewLineageQueryResult = ApolloReactCommon.QueryResult<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>;
export const ArtifactVersionAliasesDocument = gql`
    query ArtifactVersionAliases($artifactCollectionID: ID!, $versionAlias: String!, $adminType: WorkflowsAdminType!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    name
    __typename
    aliases {
      edges {
        node {
          id
          alias
        }
      }
    }
    artifactMembership(aliasName: $versionAlias) {
      id
      aliases {
        id
        alias
      }
      artifact {
        id
        artifactType {
          id
          name
        }
      }
    }
    project {
      id
      name
      protectedArtifactAliases {
        alias
      }
      entity {
        id
        name
        protectedAliases(adminType: $adminType)
        workflowsAdmins(adminType: $adminType) {
          id
          name
          username
        }
      }
    }
  }
}
    `;
export type ArtifactVersionAliasesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>, 'query'> & ({ variables: ArtifactVersionAliasesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactVersionAliasesComponent = (props: ArtifactVersionAliasesComponentProps) => (
      <ApolloReactComponents.Query<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables> query={ArtifactVersionAliasesDocument} {...props} />
    );
    
export type ArtifactVersionAliasesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>
    } & TChildProps;
export function withArtifactVersionAliases<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactVersionAliasesQuery,
  ArtifactVersionAliasesQueryVariables,
  ArtifactVersionAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables, ArtifactVersionAliasesProps<TChildProps, TDataName>>(ArtifactVersionAliasesDocument, {
      alias: 'artifactVersionAliases',
      ...operationOptions
    });
};

/**
 * __useArtifactVersionAliasesQuery__
 *
 * To run a query within a React component, call `useArtifactVersionAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionAliasesQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *      versionAlias: // value for 'versionAlias'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useArtifactVersionAliasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables> & ({ variables: ArtifactVersionAliasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>(ArtifactVersionAliasesDocument, options);
      }
export function useArtifactVersionAliasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>(ArtifactVersionAliasesDocument, options);
        }
// @ts-ignore
export function useArtifactVersionAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>;
export function useArtifactVersionAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionAliasesQuery | undefined, ArtifactVersionAliasesQueryVariables>;
export function useArtifactVersionAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>(ArtifactVersionAliasesDocument, options);
        }
export type ArtifactVersionAliasesQueryHookResult = ReturnType<typeof useArtifactVersionAliasesQuery>;
export type ArtifactVersionAliasesLazyQueryHookResult = ReturnType<typeof useArtifactVersionAliasesLazyQuery>;
export type ArtifactVersionAliasesSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionAliasesSuspenseQuery>;
export type ArtifactVersionAliasesQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>;
export const ArtifactVersionTagsDocument = gql`
    query ArtifactVersionTags($artifactCollectionID: ID!, $versionAlias: String!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    name
    artifactMembership(aliasName: $versionAlias) {
      id
      artifact {
        id
        tags {
          id
          name
          tagCategoryName
          attributes
        }
      }
    }
    project {
      id
      name
      entity {
        id
        name
      }
    }
  }
}
    `;
export type ArtifactVersionTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>, 'query'> & ({ variables: ArtifactVersionTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactVersionTagsComponent = (props: ArtifactVersionTagsComponentProps) => (
      <ApolloReactComponents.Query<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables> query={ArtifactVersionTagsDocument} {...props} />
    );
    
export type ArtifactVersionTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>
    } & TChildProps;
export function withArtifactVersionTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactVersionTagsQuery,
  ArtifactVersionTagsQueryVariables,
  ArtifactVersionTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables, ArtifactVersionTagsProps<TChildProps, TDataName>>(ArtifactVersionTagsDocument, {
      alias: 'artifactVersionTags',
      ...operationOptions
    });
};

/**
 * __useArtifactVersionTagsQuery__
 *
 * To run a query within a React component, call `useArtifactVersionTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionTagsQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *      versionAlias: // value for 'versionAlias'
 *   },
 * });
 */
export function useArtifactVersionTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables> & ({ variables: ArtifactVersionTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>(ArtifactVersionTagsDocument, options);
      }
export function useArtifactVersionTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>(ArtifactVersionTagsDocument, options);
        }
// @ts-ignore
export function useArtifactVersionTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>;
export function useArtifactVersionTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionTagsQuery | undefined, ArtifactVersionTagsQueryVariables>;
export function useArtifactVersionTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>(ArtifactVersionTagsDocument, options);
        }
export type ArtifactVersionTagsQueryHookResult = ReturnType<typeof useArtifactVersionTagsQuery>;
export type ArtifactVersionTagsLazyQueryHookResult = ReturnType<typeof useArtifactVersionTagsLazyQuery>;
export type ArtifactVersionTagsSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionTagsSuspenseQuery>;
export type ArtifactVersionTagsQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>;
export const ArtifactIsProtectedDocument = gql`
    query ArtifactIsProtected($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    isProtected
    artifactSequence {
      id
      project {
        id
        name
        entity {
          id
          name
        }
      }
    }
  }
}
    `;
export type ArtifactIsProtectedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>, 'query'> & ({ variables: ArtifactIsProtectedQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactIsProtectedComponent = (props: ArtifactIsProtectedComponentProps) => (
      <ApolloReactComponents.Query<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables> query={ArtifactIsProtectedDocument} {...props} />
    );
    
export type ArtifactIsProtectedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>
    } & TChildProps;
export function withArtifactIsProtected<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactIsProtectedQuery,
  ArtifactIsProtectedQueryVariables,
  ArtifactIsProtectedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables, ArtifactIsProtectedProps<TChildProps, TDataName>>(ArtifactIsProtectedDocument, {
      alias: 'artifactIsProtected',
      ...operationOptions
    });
};

/**
 * __useArtifactIsProtectedQuery__
 *
 * To run a query within a React component, call `useArtifactIsProtectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactIsProtectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactIsProtectedQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactIsProtectedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables> & ({ variables: ArtifactIsProtectedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>(ArtifactIsProtectedDocument, options);
      }
export function useArtifactIsProtectedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>(ArtifactIsProtectedDocument, options);
        }
// @ts-ignore
export function useArtifactIsProtectedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>;
export function useArtifactIsProtectedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactIsProtectedQuery | undefined, ArtifactIsProtectedQueryVariables>;
export function useArtifactIsProtectedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>(ArtifactIsProtectedDocument, options);
        }
export type ArtifactIsProtectedQueryHookResult = ReturnType<typeof useArtifactIsProtectedQuery>;
export type ArtifactIsProtectedLazyQueryHookResult = ReturnType<typeof useArtifactIsProtectedLazyQuery>;
export type ArtifactIsProtectedSuspenseQueryHookResult = ReturnType<typeof useArtifactIsProtectedSuspenseQuery>;
export type ArtifactIsProtectedQueryResult = ApolloReactCommon.QueryResult<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>;
export const ArtifactTagsDocument = gql`
    query ArtifactTags($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    name
    tags {
      edges {
        node {
          id
          name
          attributes
          tagCategoryName
        }
      }
    }
    project {
      id
      name
      entity {
        id
        name
      }
    }
  }
}
    `;
export type ArtifactTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>, 'query'> & ({ variables: ArtifactTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactTagsComponent = (props: ArtifactTagsComponentProps) => (
      <ApolloReactComponents.Query<ArtifactTagsQuery, ArtifactTagsQueryVariables> query={ArtifactTagsDocument} {...props} />
    );
    
export type ArtifactTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactTagsQuery, ArtifactTagsQueryVariables>
    } & TChildProps;
export function withArtifactTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactTagsQuery,
  ArtifactTagsQueryVariables,
  ArtifactTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactTagsQuery, ArtifactTagsQueryVariables, ArtifactTagsProps<TChildProps, TDataName>>(ArtifactTagsDocument, {
      alias: 'artifactTags',
      ...operationOptions
    });
};

/**
 * __useArtifactTagsQuery__
 *
 * To run a query within a React component, call `useArtifactTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactTagsQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables> & ({ variables: ArtifactTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactTagsQuery, ArtifactTagsQueryVariables>(ArtifactTagsDocument, options);
      }
export function useArtifactTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactTagsQuery, ArtifactTagsQueryVariables>(ArtifactTagsDocument, options);
        }
// @ts-ignore
export function useArtifactTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTagsQuery, ArtifactTagsQueryVariables>;
export function useArtifactTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTagsQuery | undefined, ArtifactTagsQueryVariables>;
export function useArtifactTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactTagsQuery, ArtifactTagsQueryVariables>(ArtifactTagsDocument, options);
        }
export type ArtifactTagsQueryHookResult = ReturnType<typeof useArtifactTagsQuery>;
export type ArtifactTagsLazyQueryHookResult = ReturnType<typeof useArtifactTagsLazyQuery>;
export type ArtifactTagsSuspenseQueryHookResult = ReturnType<typeof useArtifactTagsSuspenseQuery>;
export type ArtifactTagsQueryResult = ApolloReactCommon.QueryResult<ArtifactTagsQuery, ArtifactTagsQueryVariables>;
export const ArtifactVersionsTableDataDocument = gql`
    query ArtifactVersionsTableData($artifactCollectionID: ID!, $limit: Int!, $after: String) {
  artifactCollection(id: $artifactCollectionID) {
    id
    artifactMemberships(first: $limit, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          versionIndex
          createdAt
          artifact {
            id
            createdBy {
              __typename
              ... on User {
                id
                name
                username
                photoUrl
              }
              ... on Run {
                id
                name
                displayName
                defaultColorIndex
                project {
                  id
                  name
                  entityName
                }
              }
            }
            tags {
              id
              name
              tagCategoryName
              attributes
            }
            metadata
            ttlDurationSeconds
            usedCount
            size
            isGenerated
            createdAt
            runHistory
          }
          aliases {
            id
            alias
          }
        }
      }
    }
  }
}
    `;
export type ArtifactVersionsTableDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>, 'query'> & ({ variables: ArtifactVersionsTableDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactVersionsTableDataComponent = (props: ArtifactVersionsTableDataComponentProps) => (
      <ApolloReactComponents.Query<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables> query={ArtifactVersionsTableDataDocument} {...props} />
    );
    
export type ArtifactVersionsTableDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>
    } & TChildProps;
export function withArtifactVersionsTableData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactVersionsTableDataQuery,
  ArtifactVersionsTableDataQueryVariables,
  ArtifactVersionsTableDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables, ArtifactVersionsTableDataProps<TChildProps, TDataName>>(ArtifactVersionsTableDataDocument, {
      alias: 'artifactVersionsTableData',
      ...operationOptions
    });
};

/**
 * __useArtifactVersionsTableDataQuery__
 *
 * To run a query within a React component, call `useArtifactVersionsTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionsTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionsTableDataQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useArtifactVersionsTableDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables> & ({ variables: ArtifactVersionsTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>(ArtifactVersionsTableDataDocument, options);
      }
export function useArtifactVersionsTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>(ArtifactVersionsTableDataDocument, options);
        }
// @ts-ignore
export function useArtifactVersionsTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>;
export function useArtifactVersionsTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionsTableDataQuery | undefined, ArtifactVersionsTableDataQueryVariables>;
export function useArtifactVersionsTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>(ArtifactVersionsTableDataDocument, options);
        }
export type ArtifactVersionsTableDataQueryHookResult = ReturnType<typeof useArtifactVersionsTableDataQuery>;
export type ArtifactVersionsTableDataLazyQueryHookResult = ReturnType<typeof useArtifactVersionsTableDataLazyQuery>;
export type ArtifactVersionsTableDataSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionsTableDataSuspenseQuery>;
export type ArtifactVersionsTableDataQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>;
export const ArtifactVersionsTableAliasesDocument = gql`
    query ArtifactVersionsTableAliases($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    aliases {
      edges {
        node {
          id
          alias
        }
      }
    }
    project {
      id
      protectedArtifactAliases {
        alias
      }
    }
  }
}
    `;
export type ArtifactVersionsTableAliasesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>, 'query'> & ({ variables: ArtifactVersionsTableAliasesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactVersionsTableAliasesComponent = (props: ArtifactVersionsTableAliasesComponentProps) => (
      <ApolloReactComponents.Query<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables> query={ArtifactVersionsTableAliasesDocument} {...props} />
    );
    
export type ArtifactVersionsTableAliasesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>
    } & TChildProps;
export function withArtifactVersionsTableAliases<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactVersionsTableAliasesQuery,
  ArtifactVersionsTableAliasesQueryVariables,
  ArtifactVersionsTableAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables, ArtifactVersionsTableAliasesProps<TChildProps, TDataName>>(ArtifactVersionsTableAliasesDocument, {
      alias: 'artifactVersionsTableAliases',
      ...operationOptions
    });
};

/**
 * __useArtifactVersionsTableAliasesQuery__
 *
 * To run a query within a React component, call `useArtifactVersionsTableAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionsTableAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionsTableAliasesQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactVersionsTableAliasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables> & ({ variables: ArtifactVersionsTableAliasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>(ArtifactVersionsTableAliasesDocument, options);
      }
export function useArtifactVersionsTableAliasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>(ArtifactVersionsTableAliasesDocument, options);
        }
// @ts-ignore
export function useArtifactVersionsTableAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>;
export function useArtifactVersionsTableAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionsTableAliasesQuery | undefined, ArtifactVersionsTableAliasesQueryVariables>;
export function useArtifactVersionsTableAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>(ArtifactVersionsTableAliasesDocument, options);
        }
export type ArtifactVersionsTableAliasesQueryHookResult = ReturnType<typeof useArtifactVersionsTableAliasesQuery>;
export type ArtifactVersionsTableAliasesLazyQueryHookResult = ReturnType<typeof useArtifactVersionsTableAliasesLazyQuery>;
export type ArtifactVersionsTableAliasesSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionsTableAliasesSuspenseQuery>;
export type ArtifactVersionsTableAliasesQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>;
export const ArtifactCollectionOverviewDocument = gql`
    query ArtifactCollectionOverview($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    __typename
    name
    defaultArtifactType {
      id
      name
    }
    versionIndexes
    aliases {
      edges {
        node {
          id
          alias
        }
      }
    }
    project {
      id
      name
      entity {
        id
        name
      }
    }
  }
}
    `;
export type ArtifactCollectionOverviewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>, 'query'> & ({ variables: ArtifactCollectionOverviewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCollectionOverviewComponent = (props: ArtifactCollectionOverviewComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables> query={ArtifactCollectionOverviewDocument} {...props} />
    );
    
export type ArtifactCollectionOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>
    } & TChildProps;
export function withArtifactCollectionOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCollectionOverviewQuery,
  ArtifactCollectionOverviewQueryVariables,
  ArtifactCollectionOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables, ArtifactCollectionOverviewProps<TChildProps, TDataName>>(ArtifactCollectionOverviewDocument, {
      alias: 'artifactCollectionOverview',
      ...operationOptions
    });
};

/**
 * __useArtifactCollectionOverviewQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionOverviewQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactCollectionOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables> & ({ variables: ArtifactCollectionOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>(ArtifactCollectionOverviewDocument, options);
      }
export function useArtifactCollectionOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>(ArtifactCollectionOverviewDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>;
export function useArtifactCollectionOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionOverviewQuery | undefined, ArtifactCollectionOverviewQueryVariables>;
export function useArtifactCollectionOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>(ArtifactCollectionOverviewDocument, options);
        }
export type ArtifactCollectionOverviewQueryHookResult = ReturnType<typeof useArtifactCollectionOverviewQuery>;
export type ArtifactCollectionOverviewLazyQueryHookResult = ReturnType<typeof useArtifactCollectionOverviewLazyQuery>;
export type ArtifactCollectionOverviewSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionOverviewSuspenseQuery>;
export type ArtifactCollectionOverviewQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>;
export const ArtifactCollectionWithRegistryVersionDocument = gql`
    query ArtifactCollectionWithRegistryVersion($projectName: String!, $entityName: String!, $artifactTypeName: String!, $artifactCollectionName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifactCollection(name: $artifactCollectionName) {
        id
        name
        hasArtifactVersionLinkedToGlobalRegistry
      }
    }
  }
}
    `;
export type ArtifactCollectionWithRegistryVersionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>, 'query'> & ({ variables: ArtifactCollectionWithRegistryVersionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCollectionWithRegistryVersionComponent = (props: ArtifactCollectionWithRegistryVersionComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables> query={ArtifactCollectionWithRegistryVersionDocument} {...props} />
    );
    
export type ArtifactCollectionWithRegistryVersionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>
    } & TChildProps;
export function withArtifactCollectionWithRegistryVersion<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCollectionWithRegistryVersionQuery,
  ArtifactCollectionWithRegistryVersionQueryVariables,
  ArtifactCollectionWithRegistryVersionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables, ArtifactCollectionWithRegistryVersionProps<TChildProps, TDataName>>(ArtifactCollectionWithRegistryVersionDocument, {
      alias: 'artifactCollectionWithRegistryVersion',
      ...operationOptions
    });
};

/**
 * __useArtifactCollectionWithRegistryVersionQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionWithRegistryVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionWithRegistryVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionWithRegistryVersionQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *   },
 * });
 */
export function useArtifactCollectionWithRegistryVersionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables> & ({ variables: ArtifactCollectionWithRegistryVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>(ArtifactCollectionWithRegistryVersionDocument, options);
      }
export function useArtifactCollectionWithRegistryVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>(ArtifactCollectionWithRegistryVersionDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionWithRegistryVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>;
export function useArtifactCollectionWithRegistryVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionWithRegistryVersionQuery | undefined, ArtifactCollectionWithRegistryVersionQueryVariables>;
export function useArtifactCollectionWithRegistryVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>(ArtifactCollectionWithRegistryVersionDocument, options);
        }
export type ArtifactCollectionWithRegistryVersionQueryHookResult = ReturnType<typeof useArtifactCollectionWithRegistryVersionQuery>;
export type ArtifactCollectionWithRegistryVersionLazyQueryHookResult = ReturnType<typeof useArtifactCollectionWithRegistryVersionLazyQuery>;
export type ArtifactCollectionWithRegistryVersionSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionWithRegistryVersionSuspenseQuery>;
export type ArtifactCollectionWithRegistryVersionQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>;
export const ArtifactCollectionHasProtectedArtifactDocument = gql`
    query ArtifactCollectionHasProtectedArtifact($artifactCollectionID: ID!) {
  artifactSequence(id: $artifactCollectionID) {
    id
    hasProtectedArtifact
  }
}
    `;
export type ArtifactCollectionHasProtectedArtifactComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>, 'query'> & ({ variables: ArtifactCollectionHasProtectedArtifactQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCollectionHasProtectedArtifactComponent = (props: ArtifactCollectionHasProtectedArtifactComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables> query={ArtifactCollectionHasProtectedArtifactDocument} {...props} />
    );
    
export type ArtifactCollectionHasProtectedArtifactProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>
    } & TChildProps;
export function withArtifactCollectionHasProtectedArtifact<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCollectionHasProtectedArtifactQuery,
  ArtifactCollectionHasProtectedArtifactQueryVariables,
  ArtifactCollectionHasProtectedArtifactProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables, ArtifactCollectionHasProtectedArtifactProps<TChildProps, TDataName>>(ArtifactCollectionHasProtectedArtifactDocument, {
      alias: 'artifactCollectionHasProtectedArtifact',
      ...operationOptions
    });
};

/**
 * __useArtifactCollectionHasProtectedArtifactQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionHasProtectedArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionHasProtectedArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionHasProtectedArtifactQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactCollectionHasProtectedArtifactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables> & ({ variables: ArtifactCollectionHasProtectedArtifactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>(ArtifactCollectionHasProtectedArtifactDocument, options);
      }
export function useArtifactCollectionHasProtectedArtifactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>(ArtifactCollectionHasProtectedArtifactDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>;
export function useArtifactCollectionHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionHasProtectedArtifactQuery | undefined, ArtifactCollectionHasProtectedArtifactQueryVariables>;
export function useArtifactCollectionHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>(ArtifactCollectionHasProtectedArtifactDocument, options);
        }
export type ArtifactCollectionHasProtectedArtifactQueryHookResult = ReturnType<typeof useArtifactCollectionHasProtectedArtifactQuery>;
export type ArtifactCollectionHasProtectedArtifactLazyQueryHookResult = ReturnType<typeof useArtifactCollectionHasProtectedArtifactLazyQuery>;
export type ArtifactCollectionHasProtectedArtifactSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionHasProtectedArtifactSuspenseQuery>;
export type ArtifactCollectionHasProtectedArtifactQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>;
export const ArtifactProjectMetadataSearchDocument = gql`
    query ArtifactProjectMetadataSearch($projectName: String!, $entityName: String!, $filters: JSONString!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifacts(filters: $filters) {
      id
      digest
      aliases {
        id
        alias
      }
      versionIndex
      artifactSequence {
        id
        name
      }
      artifactType {
        id
        name
      }
      createdAt
    }
  }
}
    `;
export type ArtifactProjectMetadataSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>, 'query'> & ({ variables: ArtifactProjectMetadataSearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactProjectMetadataSearchComponent = (props: ArtifactProjectMetadataSearchComponentProps) => (
      <ApolloReactComponents.Query<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables> query={ArtifactProjectMetadataSearchDocument} {...props} />
    );
    
export type ArtifactProjectMetadataSearchProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>
    } & TChildProps;
export function withArtifactProjectMetadataSearch<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactProjectMetadataSearchQuery,
  ArtifactProjectMetadataSearchQueryVariables,
  ArtifactProjectMetadataSearchProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables, ArtifactProjectMetadataSearchProps<TChildProps, TDataName>>(ArtifactProjectMetadataSearchDocument, {
      alias: 'artifactProjectMetadataSearch',
      ...operationOptions
    });
};

/**
 * __useArtifactProjectMetadataSearchQuery__
 *
 * To run a query within a React component, call `useArtifactProjectMetadataSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactProjectMetadataSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactProjectMetadataSearchQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useArtifactProjectMetadataSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables> & ({ variables: ArtifactProjectMetadataSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>(ArtifactProjectMetadataSearchDocument, options);
      }
export function useArtifactProjectMetadataSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>(ArtifactProjectMetadataSearchDocument, options);
        }
// @ts-ignore
export function useArtifactProjectMetadataSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>;
export function useArtifactProjectMetadataSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactProjectMetadataSearchQuery | undefined, ArtifactProjectMetadataSearchQueryVariables>;
export function useArtifactProjectMetadataSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>(ArtifactProjectMetadataSearchDocument, options);
        }
export type ArtifactProjectMetadataSearchQueryHookResult = ReturnType<typeof useArtifactProjectMetadataSearchQuery>;
export type ArtifactProjectMetadataSearchLazyQueryHookResult = ReturnType<typeof useArtifactProjectMetadataSearchLazyQuery>;
export type ArtifactProjectMetadataSearchSuspenseQueryHookResult = ReturnType<typeof useArtifactProjectMetadataSearchSuspenseQuery>;
export type ArtifactProjectMetadataSearchQueryResult = ApolloReactCommon.QueryResult<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>;
export const DiscussionThreadPageDocument = gql`
    query DiscussionThreadPage($threadID: ID!) {
  discussionThread(id: $threadID) {
    id
    createdAt
    updatedAt
    deletedAt
    title
    body
    upvotes
    poster {
      id
      photoUrl
      name
    }
    comments {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          createdAt
          updatedAt
          deletedAt
          body
          isParent
          upvotes
          poster {
            id
            photoUrl
            name
          }
        }
      }
    }
  }
  viewer {
    id
  }
}
    `;
export type DiscussionThreadPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>, 'query'> & ({ variables: DiscussionThreadPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DiscussionThreadPageComponent = (props: DiscussionThreadPageComponentProps) => (
      <ApolloReactComponents.Query<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables> query={DiscussionThreadPageDocument} {...props} />
    );
    
export type DiscussionThreadPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>
    } & TChildProps;
export function withDiscussionThreadPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DiscussionThreadPageQuery,
  DiscussionThreadPageQueryVariables,
  DiscussionThreadPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables, DiscussionThreadPageProps<TChildProps, TDataName>>(DiscussionThreadPageDocument, {
      alias: 'discussionThreadPage',
      ...operationOptions
    });
};

/**
 * __useDiscussionThreadPageQuery__
 *
 * To run a query within a React component, call `useDiscussionThreadPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionThreadPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionThreadPageQuery({
 *   variables: {
 *      threadID: // value for 'threadID'
 *   },
 * });
 */
export function useDiscussionThreadPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables> & ({ variables: DiscussionThreadPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>(DiscussionThreadPageDocument, options);
      }
export function useDiscussionThreadPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>(DiscussionThreadPageDocument, options);
        }
// @ts-ignore
export function useDiscussionThreadPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>;
export function useDiscussionThreadPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DiscussionThreadPageQuery | undefined, DiscussionThreadPageQueryVariables>;
export function useDiscussionThreadPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>(DiscussionThreadPageDocument, options);
        }
export type DiscussionThreadPageQueryHookResult = ReturnType<typeof useDiscussionThreadPageQuery>;
export type DiscussionThreadPageLazyQueryHookResult = ReturnType<typeof useDiscussionThreadPageLazyQuery>;
export type DiscussionThreadPageSuspenseQueryHookResult = ReturnType<typeof useDiscussionThreadPageSuspenseQuery>;
export type DiscussionThreadPageQueryResult = ApolloReactCommon.QueryResult<DiscussionThreadPageQuery, DiscussionThreadPageQueryVariables>;
export const EotfOrganizationSubscriptionsBasicInfoDocument = gql`
    query EOTFOrganizationSubscriptionsBasicInfo($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    subscriptions {
      id
      expiresAt
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;
export type EotfOrganizationSubscriptionsBasicInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>, 'query'> & ({ variables: EotfOrganizationSubscriptionsBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EotfOrganizationSubscriptionsBasicInfoComponent = (props: EotfOrganizationSubscriptionsBasicInfoComponentProps) => (
      <ApolloReactComponents.Query<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables> query={EotfOrganizationSubscriptionsBasicInfoDocument} {...props} />
    );
    
export type EotfOrganizationSubscriptionsBasicInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>
    } & TChildProps;
export function withEotfOrganizationSubscriptionsBasicInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EotfOrganizationSubscriptionsBasicInfoQuery,
  EotfOrganizationSubscriptionsBasicInfoQueryVariables,
  EotfOrganizationSubscriptionsBasicInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables, EotfOrganizationSubscriptionsBasicInfoProps<TChildProps, TDataName>>(EotfOrganizationSubscriptionsBasicInfoDocument, {
      alias: 'eotfOrganizationSubscriptionsBasicInfo',
      ...operationOptions
    });
};

/**
 * __useEotfOrganizationSubscriptionsBasicInfoQuery__
 *
 * To run a query within a React component, call `useEotfOrganizationSubscriptionsBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEotfOrganizationSubscriptionsBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEotfOrganizationSubscriptionsBasicInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEotfOrganizationSubscriptionsBasicInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables> & ({ variables: EotfOrganizationSubscriptionsBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>(EotfOrganizationSubscriptionsBasicInfoDocument, options);
      }
export function useEotfOrganizationSubscriptionsBasicInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>(EotfOrganizationSubscriptionsBasicInfoDocument, options);
        }
// @ts-ignore
export function useEotfOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>;
export function useEotfOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EotfOrganizationSubscriptionsBasicInfoQuery | undefined, EotfOrganizationSubscriptionsBasicInfoQueryVariables>;
export function useEotfOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>(EotfOrganizationSubscriptionsBasicInfoDocument, options);
        }
export type EotfOrganizationSubscriptionsBasicInfoQueryHookResult = ReturnType<typeof useEotfOrganizationSubscriptionsBasicInfoQuery>;
export type EotfOrganizationSubscriptionsBasicInfoLazyQueryHookResult = ReturnType<typeof useEotfOrganizationSubscriptionsBasicInfoLazyQuery>;
export type EotfOrganizationSubscriptionsBasicInfoSuspenseQueryHookResult = ReturnType<typeof useEotfOrganizationSubscriptionsBasicInfoSuspenseQuery>;
export type EotfOrganizationSubscriptionsBasicInfoQueryResult = ApolloReactCommon.QueryResult<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>;
export const ProjectFromNameDocument = gql`
    query ProjectFromName($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
  }
}
    `;
export type ProjectFromNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>, 'query'> & ({ variables: ProjectFromNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectFromNameComponent = (props: ProjectFromNameComponentProps) => (
      <ApolloReactComponents.Query<ProjectFromNameQuery, ProjectFromNameQueryVariables> query={ProjectFromNameDocument} {...props} />
    );
    
export type ProjectFromNameProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectFromNameQuery, ProjectFromNameQueryVariables>
    } & TChildProps;
export function withProjectFromName<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectFromNameQuery,
  ProjectFromNameQueryVariables,
  ProjectFromNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectFromNameQuery, ProjectFromNameQueryVariables, ProjectFromNameProps<TChildProps, TDataName>>(ProjectFromNameDocument, {
      alias: 'projectFromName',
      ...operationOptions
    });
};

/**
 * __useProjectFromNameQuery__
 *
 * To run a query within a React component, call `useProjectFromNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFromNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFromNameQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectFromNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables> & ({ variables: ProjectFromNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectFromNameQuery, ProjectFromNameQueryVariables>(ProjectFromNameDocument, options);
      }
export function useProjectFromNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectFromNameQuery, ProjectFromNameQueryVariables>(ProjectFromNameDocument, options);
        }
// @ts-ignore
export function useProjectFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFromNameQuery, ProjectFromNameQueryVariables>;
export function useProjectFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFromNameQuery | undefined, ProjectFromNameQueryVariables>;
export function useProjectFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectFromNameQuery, ProjectFromNameQueryVariables>(ProjectFromNameDocument, options);
        }
export type ProjectFromNameQueryHookResult = ReturnType<typeof useProjectFromNameQuery>;
export type ProjectFromNameLazyQueryHookResult = ReturnType<typeof useProjectFromNameLazyQuery>;
export type ProjectFromNameSuspenseQueryHookResult = ReturnType<typeof useProjectFromNameSuspenseQuery>;
export type ProjectFromNameQueryResult = ApolloReactCommon.QueryResult<ProjectFromNameQuery, ProjectFromNameQueryVariables>;
export const EntityArtifactTypeDocument = gql`
    query EntityArtifactType($entityName: String!, $artifactType: String!) {
  entity(name: $entityName) {
    id
    projects {
      edges {
        node {
          id
          name
          artifactType(name: $artifactType) {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type EntityArtifactTypeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>, 'query'> & ({ variables: EntityArtifactTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityArtifactTypeComponent = (props: EntityArtifactTypeComponentProps) => (
      <ApolloReactComponents.Query<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables> query={EntityArtifactTypeDocument} {...props} />
    );
    
export type EntityArtifactTypeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>
    } & TChildProps;
export function withEntityArtifactType<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityArtifactTypeQuery,
  EntityArtifactTypeQueryVariables,
  EntityArtifactTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables, EntityArtifactTypeProps<TChildProps, TDataName>>(EntityArtifactTypeDocument, {
      alias: 'entityArtifactType',
      ...operationOptions
    });
};

/**
 * __useEntityArtifactTypeQuery__
 *
 * To run a query within a React component, call `useEntityArtifactTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityArtifactTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityArtifactTypeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      artifactType: // value for 'artifactType'
 *   },
 * });
 */
export function useEntityArtifactTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables> & ({ variables: EntityArtifactTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>(EntityArtifactTypeDocument, options);
      }
export function useEntityArtifactTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>(EntityArtifactTypeDocument, options);
        }
// @ts-ignore
export function useEntityArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>;
export function useEntityArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityArtifactTypeQuery | undefined, EntityArtifactTypeQueryVariables>;
export function useEntityArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>(EntityArtifactTypeDocument, options);
        }
export type EntityArtifactTypeQueryHookResult = ReturnType<typeof useEntityArtifactTypeQuery>;
export type EntityArtifactTypeLazyQueryHookResult = ReturnType<typeof useEntityArtifactTypeLazyQuery>;
export type EntityArtifactTypeSuspenseQueryHookResult = ReturnType<typeof useEntityArtifactTypeSuspenseQuery>;
export type EntityArtifactTypeQueryResult = ApolloReactCommon.QueryResult<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>;
export const FetchProjectJobsForTriggersPartialDocument = gql`
    query FetchProjectJobsForTriggersPartial($entityName: String!, $projectName: String!, $limit: Int!, $after: String) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactType(name: "job") {
      id
      artifactCollections(first: $limit, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            createdAt
            project {
              id
              name
              access
              entity {
                id
                name
              }
            }
            artifacts {
              edges {
                node {
                  id
                  createdAt
                  description
                  labels
                  versionIndex
                  aliases {
                    id
                    alias
                  }
                  createdBy {
                    __typename
                    ... on User {
                      id
                      name
                      username
                      photoUrl
                    }
                    ... on Run {
                      id
                      name
                      config
                    }
                  }
                  usedBy(order: "-createdAt") {
                    totalCount
                    edges {
                      node {
                        id
                        name
                        displayName
                        state
                        createdAt
                        user {
                          id
                          name
                          username
                          photoUrl
                        }
                        config
                        defaultColorIndex
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type FetchProjectJobsForTriggersPartialComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>, 'query'> & ({ variables: FetchProjectJobsForTriggersPartialQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectJobsForTriggersPartialComponent = (props: FetchProjectJobsForTriggersPartialComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables> query={FetchProjectJobsForTriggersPartialDocument} {...props} />
    );
    
export type FetchProjectJobsForTriggersPartialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>
    } & TChildProps;
export function withFetchProjectJobsForTriggersPartial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectJobsForTriggersPartialQuery,
  FetchProjectJobsForTriggersPartialQueryVariables,
  FetchProjectJobsForTriggersPartialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables, FetchProjectJobsForTriggersPartialProps<TChildProps, TDataName>>(FetchProjectJobsForTriggersPartialDocument, {
      alias: 'fetchProjectJobsForTriggersPartial',
      ...operationOptions
    });
};

/**
 * __useFetchProjectJobsForTriggersPartialQuery__
 *
 * To run a query within a React component, call `useFetchProjectJobsForTriggersPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectJobsForTriggersPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectJobsForTriggersPartialQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchProjectJobsForTriggersPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables> & ({ variables: FetchProjectJobsForTriggersPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>(FetchProjectJobsForTriggersPartialDocument, options);
      }
export function useFetchProjectJobsForTriggersPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>(FetchProjectJobsForTriggersPartialDocument, options);
        }
// @ts-ignore
export function useFetchProjectJobsForTriggersPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>;
export function useFetchProjectJobsForTriggersPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsForTriggersPartialQuery | undefined, FetchProjectJobsForTriggersPartialQueryVariables>;
export function useFetchProjectJobsForTriggersPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>(FetchProjectJobsForTriggersPartialDocument, options);
        }
export type FetchProjectJobsForTriggersPartialQueryHookResult = ReturnType<typeof useFetchProjectJobsForTriggersPartialQuery>;
export type FetchProjectJobsForTriggersPartialLazyQueryHookResult = ReturnType<typeof useFetchProjectJobsForTriggersPartialLazyQuery>;
export type FetchProjectJobsForTriggersPartialSuspenseQueryHookResult = ReturnType<typeof useFetchProjectJobsForTriggersPartialSuspenseQuery>;
export type FetchProjectJobsForTriggersPartialQueryResult = ApolloReactCommon.QueryResult<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>;
export const FetchProjectTriggerExecutionsDocument = gql`
    query FetchProjectTriggerExecutions($entityName: String!, $projectName: String!, $triggerID: ID, $projectOnly: Boolean = false, $first: Int, $after: String, $order: String = "-created_at", $filters: JSONString) {
  project(entityName: $entityName, name: $projectName) {
    id
    triggerExecutions(
      triggerID: $triggerID
      projectOnly: $projectOnly
      first: $first
      after: $after
      order: $order
      filters: $filters
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          state
          createdAt
          updatedAt
          triggerID
          triggerName
          scope {
            ...TriggerScopeFragment
          }
          event {
            eventType
            data {
              ... on ArtifactEventDetails {
                artifactMetadata
                artifactVersionIndex
                artifactCollectionName
                projectName
                entityName
              }
              ... on ArtifactAliasEventDetails {
                artifactMetadata
                artifactVersionIndex
                artifactCollectionName
                projectName
                entityName
                alias
              }
              ... on ArtifactTagEventDetails {
                artifactMetadata
                artifactVersionIndex
                artifactCollectionName
                projectName
                entityName
                tag
              }
              ... on RunMetricEventDetails {
                runName
                projectName
                entityName
                metricName
                metricValues
              }
              ... on RunStateEventDetails {
                runName
                projectName
                entityName
                newRunState
              }
            }
          }
          action {
            actionType
            data {
              ... on QueueJobActionArgs {
                runSpec
                priority
              }
              ... on SlackNotificationActionArgs {
                integration {
                  id
                  ... on SlackIntegration {
                    channelName
                  }
                }
                title
                text
                titleURL
                severity
              }
              ... on GenericWebhookActionArgs {
                integration {
                  id
                  ... on GenericWebhookIntegration {
                    name
                    urlEndpoint
                    accessTokenRef
                    secretRef
                    createdAt
                  }
                }
                requestPayload
              }
            }
          }
          result {
            resultType
            data {
              ... on DefaultTriggerResultDetails {
                error {
                  message
                }
              }
              ... on QueuedJobTriggerResultDetails {
                error {
                  message
                }
                runQueueItemID
              }
              ... on HttpTriggerResultDetails {
                error {
                  message
                }
                status
                statusCode
                body
              }
            }
          }
          actionStartedAt
          actionDuration
        }
      }
    }
  }
}
    ${TriggerScopeFragmentFragmentDoc}`;
export type FetchProjectTriggerExecutionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>, 'query'> & ({ variables: FetchProjectTriggerExecutionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectTriggerExecutionsComponent = (props: FetchProjectTriggerExecutionsComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables> query={FetchProjectTriggerExecutionsDocument} {...props} />
    );
    
export type FetchProjectTriggerExecutionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>
    } & TChildProps;
export function withFetchProjectTriggerExecutions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectTriggerExecutionsQuery,
  FetchProjectTriggerExecutionsQueryVariables,
  FetchProjectTriggerExecutionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables, FetchProjectTriggerExecutionsProps<TChildProps, TDataName>>(FetchProjectTriggerExecutionsDocument, {
      alias: 'fetchProjectTriggerExecutions',
      ...operationOptions
    });
};

/**
 * __useFetchProjectTriggerExecutionsQuery__
 *
 * To run a query within a React component, call `useFetchProjectTriggerExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectTriggerExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectTriggerExecutionsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      triggerID: // value for 'triggerID'
 *      projectOnly: // value for 'projectOnly'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchProjectTriggerExecutionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables> & ({ variables: FetchProjectTriggerExecutionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>(FetchProjectTriggerExecutionsDocument, options);
      }
export function useFetchProjectTriggerExecutionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>(FetchProjectTriggerExecutionsDocument, options);
        }
// @ts-ignore
export function useFetchProjectTriggerExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>;
export function useFetchProjectTriggerExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectTriggerExecutionsQuery | undefined, FetchProjectTriggerExecutionsQueryVariables>;
export function useFetchProjectTriggerExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>(FetchProjectTriggerExecutionsDocument, options);
        }
export type FetchProjectTriggerExecutionsQueryHookResult = ReturnType<typeof useFetchProjectTriggerExecutionsQuery>;
export type FetchProjectTriggerExecutionsLazyQueryHookResult = ReturnType<typeof useFetchProjectTriggerExecutionsLazyQuery>;
export type FetchProjectTriggerExecutionsSuspenseQueryHookResult = ReturnType<typeof useFetchProjectTriggerExecutionsSuspenseQuery>;
export type FetchProjectTriggerExecutionsQueryResult = ApolloReactCommon.QueryResult<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>;
export const CreateFilterTriggerDocument = gql`
    mutation createFilterTrigger($name: String!, $description: String, $triggeringEventType: EventTriggeringConditionType!, $scopeType: TriggerScopeType!, $scopeID: ID!, $eventFilter: JSONString!, $triggeredActionType: TriggeredActionType!, $triggeredActionConfig: TriggeredActionConfig!, $enabled: Boolean!) {
  createFilterTrigger(
    input: {name: $name, description: $description, triggeringEventType: $triggeringEventType, scopeType: $scopeType, scopeID: $scopeID, eventFilter: $eventFilter, triggeredActionType: $triggeredActionType, triggeredActionConfig: $triggeredActionConfig, enabled: $enabled}
  ) {
    trigger {
      id
    }
  }
}
    `;
export type CreateFilterTriggerMutationFn = ApolloReactCommon.MutationFunction<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>;
export type CreateFilterTriggerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>, 'mutation'>;

    export const CreateFilterTriggerComponent = (props: CreateFilterTriggerComponentProps) => (
      <ApolloReactComponents.Mutation<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables> mutation={CreateFilterTriggerDocument} {...props} />
    );
    
export type CreateFilterTriggerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>
    } & TChildProps;
export function withCreateFilterTrigger<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateFilterTriggerMutation,
  CreateFilterTriggerMutationVariables,
  CreateFilterTriggerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables, CreateFilterTriggerProps<TChildProps, TDataName>>(CreateFilterTriggerDocument, {
      alias: 'createFilterTrigger',
      ...operationOptions
    });
};

/**
 * __useCreateFilterTriggerMutation__
 *
 * To run a mutation, you first call `useCreateFilterTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFilterTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFilterTriggerMutation, { data, loading, error }] = useCreateFilterTriggerMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      triggeringEventType: // value for 'triggeringEventType'
 *      scopeType: // value for 'scopeType'
 *      scopeID: // value for 'scopeID'
 *      eventFilter: // value for 'eventFilter'
 *      triggeredActionType: // value for 'triggeredActionType'
 *      triggeredActionConfig: // value for 'triggeredActionConfig'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useCreateFilterTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>(CreateFilterTriggerDocument, options);
      }
export type CreateFilterTriggerMutationHookResult = ReturnType<typeof useCreateFilterTriggerMutation>;
export type CreateFilterTriggerMutationResult = ApolloReactCommon.MutationResult<CreateFilterTriggerMutation>;
export type CreateFilterTriggerMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>;
export const UpdateFilterTriggerDocument = gql`
    mutation updateFilterTrigger($triggerID: ID!, $name: String!, $description: String, $triggeringEventType: EventTriggeringConditionType!, $scopeType: TriggerScopeType!, $scopeID: ID!, $eventFilter: JSONString!, $triggeredActionType: TriggeredActionType!, $triggeredActionConfig: TriggeredActionConfig!, $enabled: Boolean!, $clientMutationId: String) {
  updateFilterTrigger(
    input: {id: $triggerID, name: $name, description: $description, triggeringEventType: $triggeringEventType, scopeType: $scopeType, scopeID: $scopeID, eventFilter: $eventFilter, triggeredActionType: $triggeredActionType, triggeredActionConfig: $triggeredActionConfig, enabled: $enabled, clientMutationId: $clientMutationId}
  ) {
    trigger {
      id
    }
    clientMutationId
  }
}
    `;
export type UpdateFilterTriggerMutationFn = ApolloReactCommon.MutationFunction<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>;
export type UpdateFilterTriggerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>, 'mutation'>;

    export const UpdateFilterTriggerComponent = (props: UpdateFilterTriggerComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables> mutation={UpdateFilterTriggerDocument} {...props} />
    );
    
export type UpdateFilterTriggerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>
    } & TChildProps;
export function withUpdateFilterTrigger<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateFilterTriggerMutation,
  UpdateFilterTriggerMutationVariables,
  UpdateFilterTriggerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables, UpdateFilterTriggerProps<TChildProps, TDataName>>(UpdateFilterTriggerDocument, {
      alias: 'updateFilterTrigger',
      ...operationOptions
    });
};

/**
 * __useUpdateFilterTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateFilterTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFilterTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFilterTriggerMutation, { data, loading, error }] = useUpdateFilterTriggerMutation({
 *   variables: {
 *      triggerID: // value for 'triggerID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      triggeringEventType: // value for 'triggeringEventType'
 *      scopeType: // value for 'scopeType'
 *      scopeID: // value for 'scopeID'
 *      eventFilter: // value for 'eventFilter'
 *      triggeredActionType: // value for 'triggeredActionType'
 *      triggeredActionConfig: // value for 'triggeredActionConfig'
 *      enabled: // value for 'enabled'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateFilterTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>(UpdateFilterTriggerDocument, options);
      }
export type UpdateFilterTriggerMutationHookResult = ReturnType<typeof useUpdateFilterTriggerMutation>;
export type UpdateFilterTriggerMutationResult = ApolloReactCommon.MutationResult<UpdateFilterTriggerMutation>;
export type UpdateFilterTriggerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>;
export const FetchProjectTriggersDocument = gql`
    query FetchProjectTriggers($entityName: String!, $projectName: String!, $projectOnly: Boolean) {
  project(name: $projectName, entityName: $entityName) {
    id
    triggers(projectOnly: $projectOnly) {
      ...TriggerFragment
    }
  }
}
    ${TriggerFragmentFragmentDoc}`;
export type FetchProjectTriggersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>, 'query'> & ({ variables: FetchProjectTriggersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectTriggersComponent = (props: FetchProjectTriggersComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables> query={FetchProjectTriggersDocument} {...props} />
    );
    
export type FetchProjectTriggersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>
    } & TChildProps;
export function withFetchProjectTriggers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectTriggersQuery,
  FetchProjectTriggersQueryVariables,
  FetchProjectTriggersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables, FetchProjectTriggersProps<TChildProps, TDataName>>(FetchProjectTriggersDocument, {
      alias: 'fetchProjectTriggers',
      ...operationOptions
    });
};

/**
 * __useFetchProjectTriggersQuery__
 *
 * To run a query within a React component, call `useFetchProjectTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectTriggersQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      projectOnly: // value for 'projectOnly'
 *   },
 * });
 */
export function useFetchProjectTriggersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables> & ({ variables: FetchProjectTriggersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>(FetchProjectTriggersDocument, options);
      }
export function useFetchProjectTriggersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>(FetchProjectTriggersDocument, options);
        }
// @ts-ignore
export function useFetchProjectTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>;
export function useFetchProjectTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectTriggersQuery | undefined, FetchProjectTriggersQueryVariables>;
export function useFetchProjectTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>(FetchProjectTriggersDocument, options);
        }
export type FetchProjectTriggersQueryHookResult = ReturnType<typeof useFetchProjectTriggersQuery>;
export type FetchProjectTriggersLazyQueryHookResult = ReturnType<typeof useFetchProjectTriggersLazyQuery>;
export type FetchProjectTriggersSuspenseQueryHookResult = ReturnType<typeof useFetchProjectTriggersSuspenseQuery>;
export type FetchProjectTriggersQueryResult = ApolloReactCommon.QueryResult<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>;
export const FetchArtifactCollectionTriggersDocument = gql`
    query FetchArtifactCollectionTriggers($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    name
    triggers {
      edges {
        node {
          ...TriggerFragment
        }
      }
    }
  }
}
    ${TriggerFragmentFragmentDoc}`;
export type FetchArtifactCollectionTriggersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>, 'query'> & ({ variables: FetchArtifactCollectionTriggersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchArtifactCollectionTriggersComponent = (props: FetchArtifactCollectionTriggersComponentProps) => (
      <ApolloReactComponents.Query<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables> query={FetchArtifactCollectionTriggersDocument} {...props} />
    );
    
export type FetchArtifactCollectionTriggersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>
    } & TChildProps;
export function withFetchArtifactCollectionTriggers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchArtifactCollectionTriggersQuery,
  FetchArtifactCollectionTriggersQueryVariables,
  FetchArtifactCollectionTriggersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables, FetchArtifactCollectionTriggersProps<TChildProps, TDataName>>(FetchArtifactCollectionTriggersDocument, {
      alias: 'fetchArtifactCollectionTriggers',
      ...operationOptions
    });
};

/**
 * __useFetchArtifactCollectionTriggersQuery__
 *
 * To run a query within a React component, call `useFetchArtifactCollectionTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactCollectionTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactCollectionTriggersQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useFetchArtifactCollectionTriggersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables> & ({ variables: FetchArtifactCollectionTriggersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>(FetchArtifactCollectionTriggersDocument, options);
      }
export function useFetchArtifactCollectionTriggersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>(FetchArtifactCollectionTriggersDocument, options);
        }
// @ts-ignore
export function useFetchArtifactCollectionTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>;
export function useFetchArtifactCollectionTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionTriggersQuery | undefined, FetchArtifactCollectionTriggersQueryVariables>;
export function useFetchArtifactCollectionTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>(FetchArtifactCollectionTriggersDocument, options);
        }
export type FetchArtifactCollectionTriggersQueryHookResult = ReturnType<typeof useFetchArtifactCollectionTriggersQuery>;
export type FetchArtifactCollectionTriggersLazyQueryHookResult = ReturnType<typeof useFetchArtifactCollectionTriggersLazyQuery>;
export type FetchArtifactCollectionTriggersSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactCollectionTriggersSuspenseQuery>;
export type FetchArtifactCollectionTriggersQueryResult = ApolloReactCommon.QueryResult<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>;
export const DeleteTriggerDocument = gql`
    mutation DeleteTrigger($triggerID: ID!) {
  deleteTrigger(input: {triggerID: $triggerID}) {
    success
  }
}
    `;
export type DeleteTriggerMutationFn = ApolloReactCommon.MutationFunction<DeleteTriggerMutation, DeleteTriggerMutationVariables>;
export type DeleteTriggerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>, 'mutation'>;

    export const DeleteTriggerComponent = (props: DeleteTriggerComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteTriggerMutation, DeleteTriggerMutationVariables> mutation={DeleteTriggerDocument} {...props} />
    );
    
export type DeleteTriggerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteTriggerMutation, DeleteTriggerMutationVariables>
    } & TChildProps;
export function withDeleteTrigger<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteTriggerMutation,
  DeleteTriggerMutationVariables,
  DeleteTriggerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteTriggerMutation, DeleteTriggerMutationVariables, DeleteTriggerProps<TChildProps, TDataName>>(DeleteTriggerDocument, {
      alias: 'deleteTrigger',
      ...operationOptions
    });
};

/**
 * __useDeleteTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTriggerMutation, { data, loading, error }] = useDeleteTriggerMutation({
 *   variables: {
 *      triggerID: // value for 'triggerID'
 *   },
 * });
 */
export function useDeleteTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTriggerMutation, DeleteTriggerMutationVariables>(DeleteTriggerDocument, options);
      }
export type DeleteTriggerMutationHookResult = ReturnType<typeof useDeleteTriggerMutation>;
export type DeleteTriggerMutationResult = ApolloReactCommon.MutationResult<DeleteTriggerMutation>;
export type DeleteTriggerMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>;
export const FetchTriggerTemplateVariablesDocument = gql`
    query FetchTriggerTemplateVariables($eventType: EventTriggeringConditionType!) {
  triggerTemplateVariables(eventType: $eventType) {
    value: name
    help: description
  }
}
    `;
export type FetchTriggerTemplateVariablesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>, 'query'> & ({ variables: FetchTriggerTemplateVariablesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchTriggerTemplateVariablesComponent = (props: FetchTriggerTemplateVariablesComponentProps) => (
      <ApolloReactComponents.Query<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables> query={FetchTriggerTemplateVariablesDocument} {...props} />
    );
    
export type FetchTriggerTemplateVariablesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>
    } & TChildProps;
export function withFetchTriggerTemplateVariables<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchTriggerTemplateVariablesQuery,
  FetchTriggerTemplateVariablesQueryVariables,
  FetchTriggerTemplateVariablesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables, FetchTriggerTemplateVariablesProps<TChildProps, TDataName>>(FetchTriggerTemplateVariablesDocument, {
      alias: 'fetchTriggerTemplateVariables',
      ...operationOptions
    });
};

/**
 * __useFetchTriggerTemplateVariablesQuery__
 *
 * To run a query within a React component, call `useFetchTriggerTemplateVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTriggerTemplateVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTriggerTemplateVariablesQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function useFetchTriggerTemplateVariablesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables> & ({ variables: FetchTriggerTemplateVariablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>(FetchTriggerTemplateVariablesDocument, options);
      }
export function useFetchTriggerTemplateVariablesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>(FetchTriggerTemplateVariablesDocument, options);
        }
// @ts-ignore
export function useFetchTriggerTemplateVariablesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>;
export function useFetchTriggerTemplateVariablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchTriggerTemplateVariablesQuery | undefined, FetchTriggerTemplateVariablesQueryVariables>;
export function useFetchTriggerTemplateVariablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>(FetchTriggerTemplateVariablesDocument, options);
        }
export type FetchTriggerTemplateVariablesQueryHookResult = ReturnType<typeof useFetchTriggerTemplateVariablesQuery>;
export type FetchTriggerTemplateVariablesLazyQueryHookResult = ReturnType<typeof useFetchTriggerTemplateVariablesLazyQuery>;
export type FetchTriggerTemplateVariablesSuspenseQueryHookResult = ReturnType<typeof useFetchTriggerTemplateVariablesSuspenseQuery>;
export type FetchTriggerTemplateVariablesQueryResult = ApolloReactCommon.QueryResult<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>;
export const RunLogLinesDocument = gql`
    query RunLogLines($projectName: String!, $entityName: String, $runName: String!, $last: Int, $before: String, $first: Int, $after: String, $useImprovedPagination: Boolean = false) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      state @include(if: $useImprovedPagination)
      logLines(
        after: $after
        before: $before
        first: $first
        last: $last
        useImprovedPagination: $useImprovedPagination
      ) {
        edges {
          node {
            id
            label
            level
            line
            timestamp
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
}
    `;
export type RunLogLinesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunLogLinesQuery, RunLogLinesQueryVariables>, 'query'> & ({ variables: RunLogLinesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunLogLinesComponent = (props: RunLogLinesComponentProps) => (
      <ApolloReactComponents.Query<RunLogLinesQuery, RunLogLinesQueryVariables> query={RunLogLinesDocument} {...props} />
    );
    
export type RunLogLinesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunLogLinesQuery, RunLogLinesQueryVariables>
    } & TChildProps;
export function withRunLogLines<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunLogLinesQuery,
  RunLogLinesQueryVariables,
  RunLogLinesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunLogLinesQuery, RunLogLinesQueryVariables, RunLogLinesProps<TChildProps, TDataName>>(RunLogLinesDocument, {
      alias: 'runLogLines',
      ...operationOptions
    });
};

/**
 * __useRunLogLinesQuery__
 *
 * To run a query within a React component, call `useRunLogLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunLogLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunLogLinesQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      useImprovedPagination: // value for 'useImprovedPagination'
 *   },
 * });
 */
export function useRunLogLinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables> & ({ variables: RunLogLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunLogLinesQuery, RunLogLinesQueryVariables>(RunLogLinesDocument, options);
      }
export function useRunLogLinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunLogLinesQuery, RunLogLinesQueryVariables>(RunLogLinesDocument, options);
        }
// @ts-ignore
export function useRunLogLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunLogLinesQuery, RunLogLinesQueryVariables>;
export function useRunLogLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunLogLinesQuery | undefined, RunLogLinesQueryVariables>;
export function useRunLogLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunLogLinesQuery, RunLogLinesQueryVariables>(RunLogLinesDocument, options);
        }
export type RunLogLinesQueryHookResult = ReturnType<typeof useRunLogLinesQuery>;
export type RunLogLinesLazyQueryHookResult = ReturnType<typeof useRunLogLinesLazyQuery>;
export type RunLogLinesSuspenseQueryHookResult = ReturnType<typeof useRunLogLinesSuspenseQuery>;
export type RunLogLinesQueryResult = ApolloReactCommon.QueryResult<RunLogLinesQuery, RunLogLinesQueryVariables>;
export const OrganizationMembersTableDocument = gql`
    query OrganizationMembersTable($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    billingUser {
      id
      username
    }
    members {
      id
      name
      username
      email
      photoUrl
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
      lastActiveAt
      role
      modelsSeat
      weaveRole
    }
    seatAvailability {
      viewOnlySeats
      seats
    }
    teams {
      id
      name
      memberCount
    }
    subscriptions {
      id
      availableSeatsToPurchase
      plan {
        id
        planType
        unitPrice
      }
      privileges
    }
    pendingInvites {
      id
      email
      createdAt
      toUser {
        id
        username
      }
      entity {
        id
        name
      }
      role
    }
  }
}
    `;
export type OrganizationMembersTableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>, 'query'> & ({ variables: OrganizationMembersTableQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationMembersTableComponent = (props: OrganizationMembersTableComponentProps) => (
      <ApolloReactComponents.Query<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables> query={OrganizationMembersTableDocument} {...props} />
    );
    
export type OrganizationMembersTableProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>
    } & TChildProps;
export function withOrganizationMembersTable<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationMembersTableQuery,
  OrganizationMembersTableQueryVariables,
  OrganizationMembersTableProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables, OrganizationMembersTableProps<TChildProps, TDataName>>(OrganizationMembersTableDocument, {
      alias: 'organizationMembersTable',
      ...operationOptions
    });
};

/**
 * __useOrganizationMembersTableQuery__
 *
 * To run a query within a React component, call `useOrganizationMembersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMembersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMembersTableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationMembersTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables> & ({ variables: OrganizationMembersTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>(OrganizationMembersTableDocument, options);
      }
export function useOrganizationMembersTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>(OrganizationMembersTableDocument, options);
        }
// @ts-ignore
export function useOrganizationMembersTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>;
export function useOrganizationMembersTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMembersTableQuery | undefined, OrganizationMembersTableQueryVariables>;
export function useOrganizationMembersTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>(OrganizationMembersTableDocument, options);
        }
export type OrganizationMembersTableQueryHookResult = ReturnType<typeof useOrganizationMembersTableQuery>;
export type OrganizationMembersTableLazyQueryHookResult = ReturnType<typeof useOrganizationMembersTableLazyQuery>;
export type OrganizationMembersTableSuspenseQueryHookResult = ReturnType<typeof useOrganizationMembersTableSuspenseQuery>;
export type OrganizationMembersTableQueryResult = ApolloReactCommon.QueryResult<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>;
export const WorkspaceSingleRunDocument = gql`
    query WorkspaceSingleRun($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      name
      config
      createdAt
      displayName
      defaultColorIndex
      state
    }
  }
}
    `;
export type WorkspaceSingleRunComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>, 'query'> & ({ variables: WorkspaceSingleRunQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WorkspaceSingleRunComponent = (props: WorkspaceSingleRunComponentProps) => (
      <ApolloReactComponents.Query<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables> query={WorkspaceSingleRunDocument} {...props} />
    );
    
export type WorkspaceSingleRunProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>
    } & TChildProps;
export function withWorkspaceSingleRun<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  WorkspaceSingleRunQuery,
  WorkspaceSingleRunQueryVariables,
  WorkspaceSingleRunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables, WorkspaceSingleRunProps<TChildProps, TDataName>>(WorkspaceSingleRunDocument, {
      alias: 'workspaceSingleRun',
      ...operationOptions
    });
};

/**
 * __useWorkspaceSingleRunQuery__
 *
 * To run a query within a React component, call `useWorkspaceSingleRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSingleRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSingleRunQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useWorkspaceSingleRunQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables> & ({ variables: WorkspaceSingleRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>(WorkspaceSingleRunDocument, options);
      }
export function useWorkspaceSingleRunLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>(WorkspaceSingleRunDocument, options);
        }
// @ts-ignore
export function useWorkspaceSingleRunSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>;
export function useWorkspaceSingleRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceSingleRunQuery | undefined, WorkspaceSingleRunQueryVariables>;
export function useWorkspaceSingleRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>(WorkspaceSingleRunDocument, options);
        }
export type WorkspaceSingleRunQueryHookResult = ReturnType<typeof useWorkspaceSingleRunQuery>;
export type WorkspaceSingleRunLazyQueryHookResult = ReturnType<typeof useWorkspaceSingleRunLazyQuery>;
export type WorkspaceSingleRunSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSingleRunSuspenseQuery>;
export type WorkspaceSingleRunQueryResult = ApolloReactCommon.QueryResult<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>;
export const ProjectsByTeamDocument = gql`
    query ProjectsByTeam($entityName: String!, $pattern: String, $order: String, $first: Int = 500, $before: String, $after: String) {
  projects(
    first: $first
    entityName: $entityName
    order: $order
    before: $before
    after: $after
    pattern: $pattern
  ) {
    edges {
      node {
        id
        ...ProjectList
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ProjectListFragmentDoc}`;
export type ProjectsByTeamComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>, 'query'> & ({ variables: ProjectsByTeamQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectsByTeamComponent = (props: ProjectsByTeamComponentProps) => (
      <ApolloReactComponents.Query<ProjectsByTeamQuery, ProjectsByTeamQueryVariables> query={ProjectsByTeamDocument} {...props} />
    );
    
export type ProjectsByTeamProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>
    } & TChildProps;
export function withProjectsByTeam<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectsByTeamQuery,
  ProjectsByTeamQueryVariables,
  ProjectsByTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectsByTeamQuery, ProjectsByTeamQueryVariables, ProjectsByTeamProps<TChildProps, TDataName>>(ProjectsByTeamDocument, {
      alias: 'projectsByTeam',
      ...operationOptions
    });
};

/**
 * __useProjectsByTeamQuery__
 *
 * To run a query within a React component, call `useProjectsByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByTeamQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProjectsByTeamQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables> & ({ variables: ProjectsByTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>(ProjectsByTeamDocument, options);
      }
export function useProjectsByTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>(ProjectsByTeamDocument, options);
        }
// @ts-ignore
export function useProjectsByTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>;
export function useProjectsByTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByTeamQuery | undefined, ProjectsByTeamQueryVariables>;
export function useProjectsByTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>(ProjectsByTeamDocument, options);
        }
export type ProjectsByTeamQueryHookResult = ReturnType<typeof useProjectsByTeamQuery>;
export type ProjectsByTeamLazyQueryHookResult = ReturnType<typeof useProjectsByTeamLazyQuery>;
export type ProjectsByTeamSuspenseQueryHookResult = ReturnType<typeof useProjectsByTeamSuspenseQuery>;
export type ProjectsByTeamQueryResult = ApolloReactCommon.QueryResult<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>;
export const ProjectsByAccountDocument = gql`
    query ProjectsByAccount($orgID: ID!, $userID: ID!, $order: String, $first: Int = 500, $before: String, $after: String, $pattern: String) {
  organization(id: $orgID) {
    id
    projects(
      first: $first
      userID: $userID
      order: $order
      before: $before
      after: $after
      pattern: $pattern
    ) {
      edges {
        node {
          id
          ...ProjectList
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ProjectListFragmentDoc}`;
export type ProjectsByAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>, 'query'> & ({ variables: ProjectsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectsByAccountComponent = (props: ProjectsByAccountComponentProps) => (
      <ApolloReactComponents.Query<ProjectsByAccountQuery, ProjectsByAccountQueryVariables> query={ProjectsByAccountDocument} {...props} />
    );
    
export type ProjectsByAccountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>
    } & TChildProps;
export function withProjectsByAccount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectsByAccountQuery,
  ProjectsByAccountQueryVariables,
  ProjectsByAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectsByAccountQuery, ProjectsByAccountQueryVariables, ProjectsByAccountProps<TChildProps, TDataName>>(ProjectsByAccountDocument, {
      alias: 'projectsByAccount',
      ...operationOptions
    });
};

/**
 * __useProjectsByAccountQuery__
 *
 * To run a query within a React component, call `useProjectsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByAccountQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      userID: // value for 'userID'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useProjectsByAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables> & ({ variables: ProjectsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>(ProjectsByAccountDocument, options);
      }
export function useProjectsByAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>(ProjectsByAccountDocument, options);
        }
// @ts-ignore
export function useProjectsByAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>;
export function useProjectsByAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByAccountQuery | undefined, ProjectsByAccountQueryVariables>;
export function useProjectsByAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>(ProjectsByAccountDocument, options);
        }
export type ProjectsByAccountQueryHookResult = ReturnType<typeof useProjectsByAccountQuery>;
export type ProjectsByAccountLazyQueryHookResult = ReturnType<typeof useProjectsByAccountLazyQuery>;
export type ProjectsByAccountSuspenseQueryHookResult = ReturnType<typeof useProjectsByAccountSuspenseQuery>;
export type ProjectsByAccountQueryResult = ApolloReactCommon.QueryResult<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>;
export const ProjectsByUserDocument = gql`
    query ProjectsByUser($userName: String!, $pattern: String, $order: String, $first: Int = 500, $before: String, $after: String) {
  user(userName: $userName) {
    id
    username
    projects(
      first: $first
      order: $order
      before: $before
      after: $after
      pattern: $pattern
    ) {
      edges {
        node {
          id
          ...ProjectList
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ProjectListFragmentDoc}`;
export type ProjectsByUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>, 'query'> & ({ variables: ProjectsByUserQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectsByUserComponent = (props: ProjectsByUserComponentProps) => (
      <ApolloReactComponents.Query<ProjectsByUserQuery, ProjectsByUserQueryVariables> query={ProjectsByUserDocument} {...props} />
    );
    
export type ProjectsByUserProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectsByUserQuery, ProjectsByUserQueryVariables>
    } & TChildProps;
export function withProjectsByUser<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectsByUserQuery,
  ProjectsByUserQueryVariables,
  ProjectsByUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectsByUserQuery, ProjectsByUserQueryVariables, ProjectsByUserProps<TChildProps, TDataName>>(ProjectsByUserDocument, {
      alias: 'projectsByUser',
      ...operationOptions
    });
};

/**
 * __useProjectsByUserQuery__
 *
 * To run a query within a React component, call `useProjectsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByUserQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      pattern: // value for 'pattern'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProjectsByUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables> & ({ variables: ProjectsByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsByUserQuery, ProjectsByUserQueryVariables>(ProjectsByUserDocument, options);
      }
export function useProjectsByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsByUserQuery, ProjectsByUserQueryVariables>(ProjectsByUserDocument, options);
        }
// @ts-ignore
export function useProjectsByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByUserQuery, ProjectsByUserQueryVariables>;
export function useProjectsByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByUserQuery | undefined, ProjectsByUserQueryVariables>;
export function useProjectsByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsByUserQuery, ProjectsByUserQueryVariables>(ProjectsByUserDocument, options);
        }
export type ProjectsByUserQueryHookResult = ReturnType<typeof useProjectsByUserQuery>;
export type ProjectsByUserLazyQueryHookResult = ReturnType<typeof useProjectsByUserLazyQuery>;
export type ProjectsByUserSuspenseQueryHookResult = ReturnType<typeof useProjectsByUserSuspenseQuery>;
export type ProjectsByUserQueryResult = ApolloReactCommon.QueryResult<ProjectsByUserQuery, ProjectsByUserQueryVariables>;
export const RunComparerDocument = gql`
    query RunComparer($projectName: String!, $entityName: String!, $runNames: [String!]!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(names: $runNames) {
      edges {
        node {
          id
          name
          runInfo {
            program
            args
            os
            python
            colab
            executable
            codeSaved
            cpuCount
            cpuCountLogical
            gpuCount
            gpu
            git {
              remote
              commit
            }
            codePath
            slurm {
              jobId
            }
          }
        }
      }
    }
  }
}
    `;
export type RunComparerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunComparerQuery, RunComparerQueryVariables>, 'query'> & ({ variables: RunComparerQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunComparerComponent = (props: RunComparerComponentProps) => (
      <ApolloReactComponents.Query<RunComparerQuery, RunComparerQueryVariables> query={RunComparerDocument} {...props} />
    );
    
export type RunComparerProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunComparerQuery, RunComparerQueryVariables>
    } & TChildProps;
export function withRunComparer<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunComparerQuery,
  RunComparerQueryVariables,
  RunComparerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunComparerQuery, RunComparerQueryVariables, RunComparerProps<TChildProps, TDataName>>(RunComparerDocument, {
      alias: 'runComparer',
      ...operationOptions
    });
};

/**
 * __useRunComparerQuery__
 *
 * To run a query within a React component, call `useRunComparerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunComparerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunComparerQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runNames: // value for 'runNames'
 *   },
 * });
 */
export function useRunComparerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunComparerQuery, RunComparerQueryVariables> & ({ variables: RunComparerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunComparerQuery, RunComparerQueryVariables>(RunComparerDocument, options);
      }
export function useRunComparerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunComparerQuery, RunComparerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunComparerQuery, RunComparerQueryVariables>(RunComparerDocument, options);
        }
// @ts-ignore
export function useRunComparerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunComparerQuery, RunComparerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunComparerQuery, RunComparerQueryVariables>;
export function useRunComparerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunComparerQuery, RunComparerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunComparerQuery | undefined, RunComparerQueryVariables>;
export function useRunComparerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunComparerQuery, RunComparerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunComparerQuery, RunComparerQueryVariables>(RunComparerDocument, options);
        }
export type RunComparerQueryHookResult = ReturnType<typeof useRunComparerQuery>;
export type RunComparerLazyQueryHookResult = ReturnType<typeof useRunComparerLazyQuery>;
export type RunComparerSuspenseQueryHookResult = ReturnType<typeof useRunComparerSuspenseQuery>;
export type RunComparerQueryResult = ApolloReactCommon.QueryResult<RunComparerQuery, RunComparerQueryVariables>;
export const ProjectDetailsDocument = gql`
    query ProjectDetails($entityName: String, $projectName: String) {
  project(entityName: $entityName, name: $projectName) {
    id
    fromV2
  }
}
    `;
export type ProjectDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>, 'query'>;

    export const ProjectDetailsComponent = (props: ProjectDetailsComponentProps) => (
      <ApolloReactComponents.Query<ProjectDetailsQuery, ProjectDetailsQueryVariables> query={ProjectDetailsDocument} {...props} />
    );
    
export type ProjectDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectDetailsQuery, ProjectDetailsQueryVariables>
    } & TChildProps;
export function withProjectDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectDetailsQuery,
  ProjectDetailsQueryVariables,
  ProjectDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectDetailsQuery, ProjectDetailsQueryVariables, ProjectDetailsProps<TChildProps, TDataName>>(ProjectDetailsDocument, {
      alias: 'projectDetails',
      ...operationOptions
    });
};

/**
 * __useProjectDetailsQuery__
 *
 * To run a query within a React component, call `useProjectDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDetailsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDetailsQuery, ProjectDetailsQueryVariables>(ProjectDetailsDocument, options);
      }
export function useProjectDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDetailsQuery, ProjectDetailsQueryVariables>(ProjectDetailsDocument, options);
        }
// @ts-ignore
export function useProjectDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectDetailsQuery, ProjectDetailsQueryVariables>;
export function useProjectDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectDetailsQuery | undefined, ProjectDetailsQueryVariables>;
export function useProjectDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDetailsQuery, ProjectDetailsQueryVariables>(ProjectDetailsDocument, options);
        }
export type ProjectDetailsQueryHookResult = ReturnType<typeof useProjectDetailsQuery>;
export type ProjectDetailsLazyQueryHookResult = ReturnType<typeof useProjectDetailsLazyQuery>;
export type ProjectDetailsSuspenseQueryHookResult = ReturnType<typeof useProjectDetailsSuspenseQuery>;
export type ProjectDetailsQueryResult = ApolloReactCommon.QueryResult<ProjectDetailsQuery, ProjectDetailsQueryVariables>;
export const BackendLinesDeltaQueryDocument = gql`
    query BackendLinesDeltaQuery($baselineRunFilters: JSONString, $bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $includeBaselineRun: Boolean = false, $includePinnedRuns: Boolean = false, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunFilters: JSONString, $pinnedRunsLimit: Int!, $projectName: String!, $summaryKeys: [String!], $timeout: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    ...BackendLinesDeltaQueryFragment
  }
}
    ${BackendLinesDeltaQueryFragmentFragmentDoc}`;
export type BackendLinesDeltaQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>, 'query'> & ({ variables: BackendLinesDeltaQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BackendLinesDeltaQueryComponent = (props: BackendLinesDeltaQueryComponentProps) => (
      <ApolloReactComponents.Query<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables> query={BackendLinesDeltaQueryDocument} {...props} />
    );
    
export type BackendLinesDeltaQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>
    } & TChildProps;
export function withBackendLinesDeltaQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BackendLinesDeltaQueryQuery,
  BackendLinesDeltaQueryQueryVariables,
  BackendLinesDeltaQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables, BackendLinesDeltaQueryProps<TChildProps, TDataName>>(BackendLinesDeltaQueryDocument, {
      alias: 'backendLinesDeltaQuery',
      ...operationOptions
    });
};

/**
 * __useBackendLinesDeltaQueryQuery__
 *
 * To run a query within a React component, call `useBackendLinesDeltaQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackendLinesDeltaQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackendLinesDeltaQueryQuery({
 *   variables: {
 *      baselineRunFilters: // value for 'baselineRunFilters'
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      includeBaselineRun: // value for 'includeBaselineRun'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunFilters: // value for 'pinnedRunFilters'
 *      pinnedRunsLimit: // value for 'pinnedRunsLimit'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useBackendLinesDeltaQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables> & ({ variables: BackendLinesDeltaQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>(BackendLinesDeltaQueryDocument, options);
      }
export function useBackendLinesDeltaQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>(BackendLinesDeltaQueryDocument, options);
        }
// @ts-ignore
export function useBackendLinesDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>;
export function useBackendLinesDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackendLinesDeltaQueryQuery | undefined, BackendLinesDeltaQueryQueryVariables>;
export function useBackendLinesDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>(BackendLinesDeltaQueryDocument, options);
        }
export type BackendLinesDeltaQueryQueryHookResult = ReturnType<typeof useBackendLinesDeltaQueryQuery>;
export type BackendLinesDeltaQueryLazyQueryHookResult = ReturnType<typeof useBackendLinesDeltaQueryLazyQuery>;
export type BackendLinesDeltaQuerySuspenseQueryHookResult = ReturnType<typeof useBackendLinesDeltaQuerySuspenseQuery>;
export type BackendLinesDeltaQueryQueryResult = ApolloReactCommon.QueryResult<BackendLinesDeltaQueryQuery, BackendLinesDeltaQueryQueryVariables>;
export const BackendLinesDeltaQueryInternalIdDocument = gql`
    query BackendLinesDeltaQueryInternalID($baselineRunFilters: JSONString, $bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $includeBaselineRun: Boolean = false, $includePinnedRuns: Boolean = false, $internalId: ID!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunFilters: JSONString, $pinnedRunsLimit: Int!, $summaryKeys: [String!], $timeout: Int) {
  project(internalId: $internalId) {
    id
    ...BackendLinesDeltaQueryFragment
  }
}
    ${BackendLinesDeltaQueryFragmentFragmentDoc}`;
export type BackendLinesDeltaQueryInternalIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>, 'query'> & ({ variables: BackendLinesDeltaQueryInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BackendLinesDeltaQueryInternalIdComponent = (props: BackendLinesDeltaQueryInternalIdComponentProps) => (
      <ApolloReactComponents.Query<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables> query={BackendLinesDeltaQueryInternalIdDocument} {...props} />
    );
    
export type BackendLinesDeltaQueryInternalIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>
    } & TChildProps;
export function withBackendLinesDeltaQueryInternalId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BackendLinesDeltaQueryInternalIdQuery,
  BackendLinesDeltaQueryInternalIdQueryVariables,
  BackendLinesDeltaQueryInternalIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables, BackendLinesDeltaQueryInternalIdProps<TChildProps, TDataName>>(BackendLinesDeltaQueryInternalIdDocument, {
      alias: 'backendLinesDeltaQueryInternalId',
      ...operationOptions
    });
};

/**
 * __useBackendLinesDeltaQueryInternalIdQuery__
 *
 * To run a query within a React component, call `useBackendLinesDeltaQueryInternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackendLinesDeltaQueryInternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackendLinesDeltaQueryInternalIdQuery({
 *   variables: {
 *      baselineRunFilters: // value for 'baselineRunFilters'
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      includeBaselineRun: // value for 'includeBaselineRun'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *      internalId: // value for 'internalId'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunFilters: // value for 'pinnedRunFilters'
 *      pinnedRunsLimit: // value for 'pinnedRunsLimit'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useBackendLinesDeltaQueryInternalIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables> & ({ variables: BackendLinesDeltaQueryInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>(BackendLinesDeltaQueryInternalIdDocument, options);
      }
export function useBackendLinesDeltaQueryInternalIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>(BackendLinesDeltaQueryInternalIdDocument, options);
        }
// @ts-ignore
export function useBackendLinesDeltaQueryInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>;
export function useBackendLinesDeltaQueryInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackendLinesDeltaQueryInternalIdQuery | undefined, BackendLinesDeltaQueryInternalIdQueryVariables>;
export function useBackendLinesDeltaQueryInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>(BackendLinesDeltaQueryInternalIdDocument, options);
        }
export type BackendLinesDeltaQueryInternalIdQueryHookResult = ReturnType<typeof useBackendLinesDeltaQueryInternalIdQuery>;
export type BackendLinesDeltaQueryInternalIdLazyQueryHookResult = ReturnType<typeof useBackendLinesDeltaQueryInternalIdLazyQuery>;
export type BackendLinesDeltaQueryInternalIdSuspenseQueryHookResult = ReturnType<typeof useBackendLinesDeltaQueryInternalIdSuspenseQuery>;
export type BackendLinesDeltaQueryInternalIdQueryResult = ApolloReactCommon.QueryResult<BackendLinesDeltaQueryInternalIdQuery, BackendLinesDeltaQueryInternalIdQueryVariables>;
export const RunsInfoDocument = gql`
    query RunsInfo($projectName: String!, $entityName: String!, $filters: JSONString!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters) {
      edges {
        node {
          id
          ...RunInfoFragment
        }
      }
    }
  }
}
    ${RunInfoFragmentFragmentDoc}`;
export type RunsInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsInfoQuery, RunsInfoQueryVariables>, 'query'> & ({ variables: RunsInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsInfoComponent = (props: RunsInfoComponentProps) => (
      <ApolloReactComponents.Query<RunsInfoQuery, RunsInfoQueryVariables> query={RunsInfoDocument} {...props} />
    );
    
export type RunsInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsInfoQuery, RunsInfoQueryVariables>
    } & TChildProps;
export function withRunsInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsInfoQuery,
  RunsInfoQueryVariables,
  RunsInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsInfoQuery, RunsInfoQueryVariables, RunsInfoProps<TChildProps, TDataName>>(RunsInfoDocument, {
      alias: 'runsInfo',
      ...operationOptions
    });
};

/**
 * __useRunsInfoQuery__
 *
 * To run a query within a React component, call `useRunsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsInfoQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunsInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables> & ({ variables: RunsInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsInfoQuery, RunsInfoQueryVariables>(RunsInfoDocument, options);
      }
export function useRunsInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsInfoQuery, RunsInfoQueryVariables>(RunsInfoDocument, options);
        }
// @ts-ignore
export function useRunsInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsInfoQuery, RunsInfoQueryVariables>;
export function useRunsInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsInfoQuery | undefined, RunsInfoQueryVariables>;
export function useRunsInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsInfoQuery, RunsInfoQueryVariables>(RunsInfoDocument, options);
        }
export type RunsInfoQueryHookResult = ReturnType<typeof useRunsInfoQuery>;
export type RunsInfoLazyQueryHookResult = ReturnType<typeof useRunsInfoLazyQuery>;
export type RunsInfoSuspenseQueryHookResult = ReturnType<typeof useRunsInfoSuspenseQuery>;
export type RunsInfoQueryResult = ApolloReactCommon.QueryResult<RunsInfoQuery, RunsInfoQueryVariables>;
export const BucketedRunsDeltaQueryWithoutRunInfoDocument = gql`
    query BucketedRunsDeltaQueryWithoutRunInfo($baselineRunFilters: JSONString, $bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $includeBaselineRun: Boolean = false, $includePinnedRuns: Boolean = false, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunFilters: JSONString, $pinnedRunsLimit: Int!, $projectName: String!, $summaryKeys: [String!], $timeout: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    ...DeltaQueryFragmentWithoutRunInfo
  }
}
    ${DeltaQueryFragmentWithoutRunInfoFragmentDoc}`;
export type BucketedRunsDeltaQueryWithoutRunInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>, 'query'> & ({ variables: BucketedRunsDeltaQueryWithoutRunInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BucketedRunsDeltaQueryWithoutRunInfoComponent = (props: BucketedRunsDeltaQueryWithoutRunInfoComponentProps) => (
      <ApolloReactComponents.Query<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables> query={BucketedRunsDeltaQueryWithoutRunInfoDocument} {...props} />
    );
    
export type BucketedRunsDeltaQueryWithoutRunInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>
    } & TChildProps;
export function withBucketedRunsDeltaQueryWithoutRunInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BucketedRunsDeltaQueryWithoutRunInfoQuery,
  BucketedRunsDeltaQueryWithoutRunInfoQueryVariables,
  BucketedRunsDeltaQueryWithoutRunInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables, BucketedRunsDeltaQueryWithoutRunInfoProps<TChildProps, TDataName>>(BucketedRunsDeltaQueryWithoutRunInfoDocument, {
      alias: 'bucketedRunsDeltaQueryWithoutRunInfo',
      ...operationOptions
    });
};

/**
 * __useBucketedRunsDeltaQueryWithoutRunInfoQuery__
 *
 * To run a query within a React component, call `useBucketedRunsDeltaQueryWithoutRunInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBucketedRunsDeltaQueryWithoutRunInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBucketedRunsDeltaQueryWithoutRunInfoQuery({
 *   variables: {
 *      baselineRunFilters: // value for 'baselineRunFilters'
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      includeBaselineRun: // value for 'includeBaselineRun'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunFilters: // value for 'pinnedRunFilters'
 *      pinnedRunsLimit: // value for 'pinnedRunsLimit'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useBucketedRunsDeltaQueryWithoutRunInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables> & ({ variables: BucketedRunsDeltaQueryWithoutRunInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>(BucketedRunsDeltaQueryWithoutRunInfoDocument, options);
      }
export function useBucketedRunsDeltaQueryWithoutRunInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>(BucketedRunsDeltaQueryWithoutRunInfoDocument, options);
        }
// @ts-ignore
export function useBucketedRunsDeltaQueryWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>;
export function useBucketedRunsDeltaQueryWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BucketedRunsDeltaQueryWithoutRunInfoQuery | undefined, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>;
export function useBucketedRunsDeltaQueryWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>(BucketedRunsDeltaQueryWithoutRunInfoDocument, options);
        }
export type BucketedRunsDeltaQueryWithoutRunInfoQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQueryWithoutRunInfoQuery>;
export type BucketedRunsDeltaQueryWithoutRunInfoLazyQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQueryWithoutRunInfoLazyQuery>;
export type BucketedRunsDeltaQueryWithoutRunInfoSuspenseQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQueryWithoutRunInfoSuspenseQuery>;
export type BucketedRunsDeltaQueryWithoutRunInfoQueryResult = ApolloReactCommon.QueryResult<BucketedRunsDeltaQueryWithoutRunInfoQuery, BucketedRunsDeltaQueryWithoutRunInfoQueryVariables>;
export const BucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument = gql`
    query BucketedRunsDeltaQueryInternalIDWithoutRunInfo($baselineRunFilters: JSONString, $bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $includeBaselineRun: Boolean = false, $includePinnedRuns: Boolean = false, $internalId: ID!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunFilters: JSONString, $pinnedRunsLimit: Int!, $summaryKeys: [String!], $timeout: Int) {
  project(internalId: $internalId) {
    id
    ...DeltaQueryFragmentWithoutRunInfo
  }
}
    ${DeltaQueryFragmentWithoutRunInfoFragmentDoc}`;
export type BucketedRunsDeltaQueryInternalIdWithoutRunInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>, 'query'> & ({ variables: BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BucketedRunsDeltaQueryInternalIdWithoutRunInfoComponent = (props: BucketedRunsDeltaQueryInternalIdWithoutRunInfoComponentProps) => (
      <ApolloReactComponents.Query<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables> query={BucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument} {...props} />
    );
    
export type BucketedRunsDeltaQueryInternalIdWithoutRunInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>
    } & TChildProps;
export function withBucketedRunsDeltaQueryInternalIdWithoutRunInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
  BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables,
  BucketedRunsDeltaQueryInternalIdWithoutRunInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables, BucketedRunsDeltaQueryInternalIdWithoutRunInfoProps<TChildProps, TDataName>>(BucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument, {
      alias: 'bucketedRunsDeltaQueryInternalIdWithoutRunInfo',
      ...operationOptions
    });
};

/**
 * __useBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery__
 *
 * To run a query within a React component, call `useBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery({
 *   variables: {
 *      baselineRunFilters: // value for 'baselineRunFilters'
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      includeBaselineRun: // value for 'includeBaselineRun'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *      internalId: // value for 'internalId'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunFilters: // value for 'pinnedRunFilters'
 *      pinnedRunsLimit: // value for 'pinnedRunsLimit'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables> & ({ variables: BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>(BucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument, options);
      }
export function useBucketedRunsDeltaQueryInternalIdWithoutRunInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>(BucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument, options);
        }
// @ts-ignore
export function useBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>;
export function useBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery | undefined, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>;
export function useBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>(BucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument, options);
        }
export type BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery>;
export type BucketedRunsDeltaQueryInternalIdWithoutRunInfoLazyQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQueryInternalIdWithoutRunInfoLazyQuery>;
export type BucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQuery>;
export type BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryResult = ApolloReactCommon.QueryResult<BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>;
export const GroupedBackendLinesDeltaQueryDocument = gql`
    query GroupedBackendLinesDeltaQuery($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $projectName: String!, $summaryKeys: [String!], $expressions: [JSONString!], $maxGroups: Int, $timeout: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    ...GroupedBackendLinesDeltaQueryFragment
  }
}
    ${GroupedBackendLinesDeltaQueryFragmentFragmentDoc}`;
export type GroupedBackendLinesDeltaQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>, 'query'> & ({ variables: GroupedBackendLinesDeltaQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupedBackendLinesDeltaQueryComponent = (props: GroupedBackendLinesDeltaQueryComponentProps) => (
      <ApolloReactComponents.Query<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables> query={GroupedBackendLinesDeltaQueryDocument} {...props} />
    );
    
export type GroupedBackendLinesDeltaQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>
    } & TChildProps;
export function withGroupedBackendLinesDeltaQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GroupedBackendLinesDeltaQueryQuery,
  GroupedBackendLinesDeltaQueryQueryVariables,
  GroupedBackendLinesDeltaQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables, GroupedBackendLinesDeltaQueryProps<TChildProps, TDataName>>(GroupedBackendLinesDeltaQueryDocument, {
      alias: 'groupedBackendLinesDeltaQuery',
      ...operationOptions
    });
};

/**
 * __useGroupedBackendLinesDeltaQueryQuery__
 *
 * To run a query within a React component, call `useGroupedBackendLinesDeltaQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedBackendLinesDeltaQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedBackendLinesDeltaQueryQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      expressions: // value for 'expressions'
 *      maxGroups: // value for 'maxGroups'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useGroupedBackendLinesDeltaQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables> & ({ variables: GroupedBackendLinesDeltaQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>(GroupedBackendLinesDeltaQueryDocument, options);
      }
export function useGroupedBackendLinesDeltaQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>(GroupedBackendLinesDeltaQueryDocument, options);
        }
// @ts-ignore
export function useGroupedBackendLinesDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>;
export function useGroupedBackendLinesDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBackendLinesDeltaQueryQuery | undefined, GroupedBackendLinesDeltaQueryQueryVariables>;
export function useGroupedBackendLinesDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>(GroupedBackendLinesDeltaQueryDocument, options);
        }
export type GroupedBackendLinesDeltaQueryQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQueryQuery>;
export type GroupedBackendLinesDeltaQueryLazyQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQueryLazyQuery>;
export type GroupedBackendLinesDeltaQuerySuspenseQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQuerySuspenseQuery>;
export type GroupedBackendLinesDeltaQueryQueryResult = ApolloReactCommon.QueryResult<GroupedBackendLinesDeltaQueryQuery, GroupedBackendLinesDeltaQueryQueryVariables>;
export const GroupedBackendLinesDeltaQueryInternalIdDocument = gql`
    query GroupedBackendLinesDeltaQueryInternalID($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $internalId: ID!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $summaryKeys: [String!], $expressions: [JSONString!], $maxGroups: Int, $timeout: Int) {
  project(internalId: $internalId) {
    id
    ...GroupedBackendLinesDeltaQueryFragment
  }
}
    ${GroupedBackendLinesDeltaQueryFragmentFragmentDoc}`;
export type GroupedBackendLinesDeltaQueryInternalIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>, 'query'> & ({ variables: GroupedBackendLinesDeltaQueryInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupedBackendLinesDeltaQueryInternalIdComponent = (props: GroupedBackendLinesDeltaQueryInternalIdComponentProps) => (
      <ApolloReactComponents.Query<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables> query={GroupedBackendLinesDeltaQueryInternalIdDocument} {...props} />
    );
    
export type GroupedBackendLinesDeltaQueryInternalIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>
    } & TChildProps;
export function withGroupedBackendLinesDeltaQueryInternalId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GroupedBackendLinesDeltaQueryInternalIdQuery,
  GroupedBackendLinesDeltaQueryInternalIdQueryVariables,
  GroupedBackendLinesDeltaQueryInternalIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables, GroupedBackendLinesDeltaQueryInternalIdProps<TChildProps, TDataName>>(GroupedBackendLinesDeltaQueryInternalIdDocument, {
      alias: 'groupedBackendLinesDeltaQueryInternalId',
      ...operationOptions
    });
};

/**
 * __useGroupedBackendLinesDeltaQueryInternalIdQuery__
 *
 * To run a query within a React component, call `useGroupedBackendLinesDeltaQueryInternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedBackendLinesDeltaQueryInternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedBackendLinesDeltaQueryInternalIdQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      internalId: // value for 'internalId'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      summaryKeys: // value for 'summaryKeys'
 *      expressions: // value for 'expressions'
 *      maxGroups: // value for 'maxGroups'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useGroupedBackendLinesDeltaQueryInternalIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables> & ({ variables: GroupedBackendLinesDeltaQueryInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>(GroupedBackendLinesDeltaQueryInternalIdDocument, options);
      }
export function useGroupedBackendLinesDeltaQueryInternalIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>(GroupedBackendLinesDeltaQueryInternalIdDocument, options);
        }
// @ts-ignore
export function useGroupedBackendLinesDeltaQueryInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>;
export function useGroupedBackendLinesDeltaQueryInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBackendLinesDeltaQueryInternalIdQuery | undefined, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>;
export function useGroupedBackendLinesDeltaQueryInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>(GroupedBackendLinesDeltaQueryInternalIdDocument, options);
        }
export type GroupedBackendLinesDeltaQueryInternalIdQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQueryInternalIdQuery>;
export type GroupedBackendLinesDeltaQueryInternalIdLazyQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQueryInternalIdLazyQuery>;
export type GroupedBackendLinesDeltaQueryInternalIdSuspenseQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQueryInternalIdSuspenseQuery>;
export type GroupedBackendLinesDeltaQueryInternalIdQueryResult = ApolloReactCommon.QueryResult<GroupedBackendLinesDeltaQueryInternalIdQuery, GroupedBackendLinesDeltaQueryInternalIdQueryVariables>;
export const GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument = gql`
    query GroupedBucketedRunsDeltaQueryWithoutRunInfo($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableBasic: Boolean = true, $enableConfig: Boolean = true, $enableSummary: Boolean = true, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $projectName: String!, $summaryKeys: [String!], $expressions: [JSONString!], $maxGroups: Int, $timeout: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    ...GroupedDeltaQueryFragmentWithoutRunInfo
  }
}
    ${GroupedDeltaQueryFragmentWithoutRunInfoFragmentDoc}`;
export type GroupedBucketedRunsDeltaQueryWithoutRunInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>, 'query'> & ({ variables: GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupedBucketedRunsDeltaQueryWithoutRunInfoComponent = (props: GroupedBucketedRunsDeltaQueryWithoutRunInfoComponentProps) => (
      <ApolloReactComponents.Query<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables> query={GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument} {...props} />
    );
    
export type GroupedBucketedRunsDeltaQueryWithoutRunInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>
    } & TChildProps;
export function withGroupedBucketedRunsDeltaQueryWithoutRunInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery,
  GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables,
  GroupedBucketedRunsDeltaQueryWithoutRunInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables, GroupedBucketedRunsDeltaQueryWithoutRunInfoProps<TChildProps, TDataName>>(GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument, {
      alias: 'groupedBucketedRunsDeltaQueryWithoutRunInfo',
      ...operationOptions
    });
};

/**
 * __useGroupedBucketedRunsDeltaQueryWithoutRunInfoQuery__
 *
 * To run a query within a React component, call `useGroupedBucketedRunsDeltaQueryWithoutRunInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedBucketedRunsDeltaQueryWithoutRunInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedBucketedRunsDeltaQueryWithoutRunInfoQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      expressions: // value for 'expressions'
 *      maxGroups: // value for 'maxGroups'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useGroupedBucketedRunsDeltaQueryWithoutRunInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables> & ({ variables: GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>(GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument, options);
      }
export function useGroupedBucketedRunsDeltaQueryWithoutRunInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>(GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument, options);
        }
// @ts-ignore
export function useGroupedBucketedRunsDeltaQueryWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>;
export function useGroupedBucketedRunsDeltaQueryWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery | undefined, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>;
export function useGroupedBucketedRunsDeltaQueryWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>(GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument, options);
        }
export type GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQueryWithoutRunInfoQuery>;
export type GroupedBucketedRunsDeltaQueryWithoutRunInfoLazyQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQueryWithoutRunInfoLazyQuery>;
export type GroupedBucketedRunsDeltaQueryWithoutRunInfoSuspenseQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQueryWithoutRunInfoSuspenseQuery>;
export type GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryResult = ApolloReactCommon.QueryResult<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables>;
export const GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument = gql`
    query GroupedBucketedRunsDeltaQueryInternalIDWithoutRunInfo($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableBasic: Boolean = true, $enableConfig: Boolean = true, $enableSummary: Boolean = true, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $internalId: ID!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $summaryKeys: [String!], $expressions: [JSONString!], $maxGroups: Int, $timeout: Int) {
  project(internalId: $internalId) {
    id
    ...GroupedDeltaQueryFragmentWithoutRunInfo
  }
}
    ${GroupedDeltaQueryFragmentWithoutRunInfoFragmentDoc}`;
export type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>, 'query'> & ({ variables: GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoComponent = (props: GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoComponentProps) => (
      <ApolloReactComponents.Query<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables> query={GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument} {...props} />
    );
    
export type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>
    } & TChildProps;
export function withGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
  GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables,
  GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoProps<TChildProps, TDataName>>(GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument, {
      alias: 'groupedBucketedRunsDeltaQueryInternalIdWithoutRunInfo',
      ...operationOptions
    });
};

/**
 * __useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery__
 *
 * To run a query within a React component, call `useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      internalId: // value for 'internalId'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      summaryKeys: // value for 'summaryKeys'
 *      expressions: // value for 'expressions'
 *      maxGroups: // value for 'maxGroups'
 *      timeout: // value for 'timeout'
 *   },
 * });
 */
export function useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables> & ({ variables: GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>(GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument, options);
      }
export function useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>(GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument, options);
        }
// @ts-ignore
export function useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>;
export function useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery | undefined, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>;
export function useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>(GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument, options);
        }
export type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery>;
export type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoLazyQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoLazyQuery>;
export type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoSuspenseQuery>;
export type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryResult = ApolloReactCommon.QueryResult<GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery, GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables>;
export const ProjectHasProtectedArtifactDocument = gql`
    query ProjectHasProtectedArtifact($entityName: String!, $name: String!) {
  project(entityName: $entityName, name: $name) {
    id
    hasProtectedArtifact
  }
}
    `;
export type ProjectHasProtectedArtifactComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>, 'query'> & ({ variables: ProjectHasProtectedArtifactQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectHasProtectedArtifactComponent = (props: ProjectHasProtectedArtifactComponentProps) => (
      <ApolloReactComponents.Query<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables> query={ProjectHasProtectedArtifactDocument} {...props} />
    );
    
export type ProjectHasProtectedArtifactProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>
    } & TChildProps;
export function withProjectHasProtectedArtifact<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectHasProtectedArtifactQuery,
  ProjectHasProtectedArtifactQueryVariables,
  ProjectHasProtectedArtifactProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables, ProjectHasProtectedArtifactProps<TChildProps, TDataName>>(ProjectHasProtectedArtifactDocument, {
      alias: 'projectHasProtectedArtifact',
      ...operationOptions
    });
};

/**
 * __useProjectHasProtectedArtifactQuery__
 *
 * To run a query within a React component, call `useProjectHasProtectedArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectHasProtectedArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectHasProtectedArtifactQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProjectHasProtectedArtifactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables> & ({ variables: ProjectHasProtectedArtifactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>(ProjectHasProtectedArtifactDocument, options);
      }
export function useProjectHasProtectedArtifactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>(ProjectHasProtectedArtifactDocument, options);
        }
// @ts-ignore
export function useProjectHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>;
export function useProjectHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectHasProtectedArtifactQuery | undefined, ProjectHasProtectedArtifactQueryVariables>;
export function useProjectHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>(ProjectHasProtectedArtifactDocument, options);
        }
export type ProjectHasProtectedArtifactQueryHookResult = ReturnType<typeof useProjectHasProtectedArtifactQuery>;
export type ProjectHasProtectedArtifactLazyQueryHookResult = ReturnType<typeof useProjectHasProtectedArtifactLazyQuery>;
export type ProjectHasProtectedArtifactSuspenseQueryHookResult = ReturnType<typeof useProjectHasProtectedArtifactSuspenseQuery>;
export type ProjectHasProtectedArtifactQueryResult = ApolloReactCommon.QueryResult<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>;
export const StarProjectDocument = gql`
    mutation starProject($entityName: String!, $projectName: String!, $organizationId: ID, $clientMutationId: String) {
  starProject(
    input: {entityName: $entityName, projectName: $projectName, organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    project {
      id
      starred(organizationId: $organizationId)
    }
    clientMutationId
  }
}
    `;
export type StarProjectMutationFn = ApolloReactCommon.MutationFunction<StarProjectMutation, StarProjectMutationVariables>;
export type StarProjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StarProjectMutation, StarProjectMutationVariables>, 'mutation'>;

    export const StarProjectComponent = (props: StarProjectComponentProps) => (
      <ApolloReactComponents.Mutation<StarProjectMutation, StarProjectMutationVariables> mutation={StarProjectDocument} {...props} />
    );
    
export type StarProjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<StarProjectMutation, StarProjectMutationVariables>
    } & TChildProps;
export function withStarProject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StarProjectMutation,
  StarProjectMutationVariables,
  StarProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, StarProjectMutation, StarProjectMutationVariables, StarProjectProps<TChildProps, TDataName>>(StarProjectDocument, {
      alias: 'starProject',
      ...operationOptions
    });
};

/**
 * __useStarProjectMutation__
 *
 * To run a mutation, you first call `useStarProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starProjectMutation, { data, loading, error }] = useStarProjectMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useStarProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StarProjectMutation, StarProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StarProjectMutation, StarProjectMutationVariables>(StarProjectDocument, options);
      }
export type StarProjectMutationHookResult = ReturnType<typeof useStarProjectMutation>;
export type StarProjectMutationResult = ApolloReactCommon.MutationResult<StarProjectMutation>;
export type StarProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<StarProjectMutation, StarProjectMutationVariables>;
export const UnstarProjectDocument = gql`
    mutation unstarProject($entityName: String!, $projectName: String!, $organizationId: ID, $clientMutationId: String) {
  unstarProject(
    input: {entityName: $entityName, projectName: $projectName, organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    project {
      id
      starred(organizationId: $organizationId)
    }
    clientMutationId
  }
}
    `;
export type UnstarProjectMutationFn = ApolloReactCommon.MutationFunction<UnstarProjectMutation, UnstarProjectMutationVariables>;
export type UnstarProjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnstarProjectMutation, UnstarProjectMutationVariables>, 'mutation'>;

    export const UnstarProjectComponent = (props: UnstarProjectComponentProps) => (
      <ApolloReactComponents.Mutation<UnstarProjectMutation, UnstarProjectMutationVariables> mutation={UnstarProjectDocument} {...props} />
    );
    
export type UnstarProjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnstarProjectMutation, UnstarProjectMutationVariables>
    } & TChildProps;
export function withUnstarProject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnstarProjectMutation,
  UnstarProjectMutationVariables,
  UnstarProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnstarProjectMutation, UnstarProjectMutationVariables, UnstarProjectProps<TChildProps, TDataName>>(UnstarProjectDocument, {
      alias: 'unstarProject',
      ...operationOptions
    });
};

/**
 * __useUnstarProjectMutation__
 *
 * To run a mutation, you first call `useUnstarProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarProjectMutation, { data, loading, error }] = useUnstarProjectMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUnstarProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnstarProjectMutation, UnstarProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnstarProjectMutation, UnstarProjectMutationVariables>(UnstarProjectDocument, options);
      }
export type UnstarProjectMutationHookResult = ReturnType<typeof useUnstarProjectMutation>;
export type UnstarProjectMutationResult = ApolloReactCommon.MutationResult<UnstarProjectMutation>;
export type UnstarProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UnstarProjectMutation, UnstarProjectMutationVariables>;
export const TeamMemberRolesDocument = gql`
    query TeamMemberRoles($entityName: String!) {
  entity(name: $entityName) {
    id
    members {
      id
      username
      memberRole {
        ID
        name
      }
    }
  }
}
    `;
export type TeamMemberRolesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>, 'query'> & ({ variables: TeamMemberRolesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamMemberRolesComponent = (props: TeamMemberRolesComponentProps) => (
      <ApolloReactComponents.Query<TeamMemberRolesQuery, TeamMemberRolesQueryVariables> query={TeamMemberRolesDocument} {...props} />
    );
    
export type TeamMemberRolesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>
    } & TChildProps;
export function withTeamMemberRoles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamMemberRolesQuery,
  TeamMemberRolesQueryVariables,
  TeamMemberRolesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamMemberRolesQuery, TeamMemberRolesQueryVariables, TeamMemberRolesProps<TChildProps, TDataName>>(TeamMemberRolesDocument, {
      alias: 'teamMemberRoles',
      ...operationOptions
    });
};

/**
 * __useTeamMemberRolesQuery__
 *
 * To run a query within a React component, call `useTeamMemberRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberRolesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamMemberRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables> & ({ variables: TeamMemberRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>(TeamMemberRolesDocument, options);
      }
export function useTeamMemberRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>(TeamMemberRolesDocument, options);
        }
// @ts-ignore
export function useTeamMemberRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>;
export function useTeamMemberRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMemberRolesQuery | undefined, TeamMemberRolesQueryVariables>;
export function useTeamMemberRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>(TeamMemberRolesDocument, options);
        }
export type TeamMemberRolesQueryHookResult = ReturnType<typeof useTeamMemberRolesQuery>;
export type TeamMemberRolesLazyQueryHookResult = ReturnType<typeof useTeamMemberRolesLazyQuery>;
export type TeamMemberRolesSuspenseQueryHookResult = ReturnType<typeof useTeamMemberRolesSuspenseQuery>;
export type TeamMemberRolesQueryResult = ApolloReactCommon.QueryResult<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>;
export const UpdateUserProjectRoleDocument = gql`
    mutation updateUserProjectRole($userId: ID!, $projectId: ID!, $userProjectRole: String!, $clientMutationId: String) {
  updateProjectMember(
    input: {userId: $userId, projectId: $projectId, userProjectRole: $userProjectRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateUserProjectRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>;
export type UpdateUserProjectRoleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>, 'mutation'>;

    export const UpdateUserProjectRoleComponent = (props: UpdateUserProjectRoleComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables> mutation={UpdateUserProjectRoleDocument} {...props} />
    );
    
export type UpdateUserProjectRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>
    } & TChildProps;
export function withUpdateUserProjectRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserProjectRoleMutation,
  UpdateUserProjectRoleMutationVariables,
  UpdateUserProjectRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables, UpdateUserProjectRoleProps<TChildProps, TDataName>>(UpdateUserProjectRoleDocument, {
      alias: 'updateUserProjectRole',
      ...operationOptions
    });
};

/**
 * __useUpdateUserProjectRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserProjectRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProjectRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProjectRoleMutation, { data, loading, error }] = useUpdateUserProjectRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *      userProjectRole: // value for 'userProjectRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateUserProjectRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>(UpdateUserProjectRoleDocument, options);
      }
export type UpdateUserProjectRoleMutationHookResult = ReturnType<typeof useUpdateUserProjectRoleMutation>;
export type UpdateUserProjectRoleMutationResult = ApolloReactCommon.MutationResult<UpdateUserProjectRoleMutation>;
export type UpdateUserProjectRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>;
export const FilteredProjectPickerQueryDocument = gql`
    query FilteredProjectPickerQuery($entityName: String!, $userName: String!, $pattern: String) {
  entity(name: $entityName) {
    id
    projects(order: "-created_at", first: 50, pattern: $pattern) {
      edges {
        node {
          id
          internalId
          name
          entityName
          createdAt
        }
      }
    }
  }
  viewer {
    id
    projects(first: 500) {
      edges {
        node {
          id
          internalId
          name
          entityName
          createdAt
        }
      }
    }
  }
  user(userName: $userName) {
    id
    teams {
      edges {
        node {
          id
          name
          projects(order: "-created_at", first: 50, pattern: $pattern) {
            edges {
              node {
                id
                internalId
                name
                entityName
                createdAt
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type FilteredProjectPickerQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>, 'query'> & ({ variables: FilteredProjectPickerQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FilteredProjectPickerQueryComponent = (props: FilteredProjectPickerQueryComponentProps) => (
      <ApolloReactComponents.Query<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables> query={FilteredProjectPickerQueryDocument} {...props} />
    );
    
export type FilteredProjectPickerQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>
    } & TChildProps;
export function withFilteredProjectPickerQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FilteredProjectPickerQueryQuery,
  FilteredProjectPickerQueryQueryVariables,
  FilteredProjectPickerQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables, FilteredProjectPickerQueryProps<TChildProps, TDataName>>(FilteredProjectPickerQueryDocument, {
      alias: 'filteredProjectPickerQuery',
      ...operationOptions
    });
};

/**
 * __useFilteredProjectPickerQueryQuery__
 *
 * To run a query within a React component, call `useFilteredProjectPickerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredProjectPickerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredProjectPickerQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      userName: // value for 'userName'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useFilteredProjectPickerQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables> & ({ variables: FilteredProjectPickerQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>(FilteredProjectPickerQueryDocument, options);
      }
export function useFilteredProjectPickerQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>(FilteredProjectPickerQueryDocument, options);
        }
// @ts-ignore
export function useFilteredProjectPickerQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>;
export function useFilteredProjectPickerQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FilteredProjectPickerQueryQuery | undefined, FilteredProjectPickerQueryQueryVariables>;
export function useFilteredProjectPickerQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>(FilteredProjectPickerQueryDocument, options);
        }
export type FilteredProjectPickerQueryQueryHookResult = ReturnType<typeof useFilteredProjectPickerQueryQuery>;
export type FilteredProjectPickerQueryLazyQueryHookResult = ReturnType<typeof useFilteredProjectPickerQueryLazyQuery>;
export type FilteredProjectPickerQuerySuspenseQueryHookResult = ReturnType<typeof useFilteredProjectPickerQuerySuspenseQuery>;
export type FilteredProjectPickerQueryQueryResult = ApolloReactCommon.QueryResult<FilteredProjectPickerQueryQuery, FilteredProjectPickerQueryQueryVariables>;
export const LegacyMrProjectDocument = gql`
    query LegacyMRProject($orgEntityName: String!, $registryProjectName: String!) {
  project(entityName: $orgEntityName, name: $registryProjectName) {
    id
    name
    entity {
      id
      name
      modelRegistryMigrationConfig {
        ...ModelRegistryMigrationConfigFragment
      }
    }
    isMigratedRegistryProject
    legacyModelRegistryProject {
      id
      name
      entityName
    }
  }
}
    ${ModelRegistryMigrationConfigFragmentFragmentDoc}`;
export type LegacyMrProjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>, 'query'> & ({ variables: LegacyMrProjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LegacyMrProjectComponent = (props: LegacyMrProjectComponentProps) => (
      <ApolloReactComponents.Query<LegacyMrProjectQuery, LegacyMrProjectQueryVariables> query={LegacyMrProjectDocument} {...props} />
    );
    
export type LegacyMrProjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>
    } & TChildProps;
export function withLegacyMrProject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LegacyMrProjectQuery,
  LegacyMrProjectQueryVariables,
  LegacyMrProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, LegacyMrProjectQuery, LegacyMrProjectQueryVariables, LegacyMrProjectProps<TChildProps, TDataName>>(LegacyMrProjectDocument, {
      alias: 'legacyMrProject',
      ...operationOptions
    });
};

/**
 * __useLegacyMrProjectQuery__
 *
 * To run a query within a React component, call `useLegacyMrProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyMrProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyMrProjectQuery({
 *   variables: {
 *      orgEntityName: // value for 'orgEntityName'
 *      registryProjectName: // value for 'registryProjectName'
 *   },
 * });
 */
export function useLegacyMrProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables> & ({ variables: LegacyMrProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>(LegacyMrProjectDocument, options);
      }
export function useLegacyMrProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>(LegacyMrProjectDocument, options);
        }
// @ts-ignore
export function useLegacyMrProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>;
export function useLegacyMrProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LegacyMrProjectQuery | undefined, LegacyMrProjectQueryVariables>;
export function useLegacyMrProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>(LegacyMrProjectDocument, options);
        }
export type LegacyMrProjectQueryHookResult = ReturnType<typeof useLegacyMrProjectQuery>;
export type LegacyMrProjectLazyQueryHookResult = ReturnType<typeof useLegacyMrProjectLazyQuery>;
export type LegacyMrProjectSuspenseQueryHookResult = ReturnType<typeof useLegacyMrProjectSuspenseQuery>;
export type LegacyMrProjectQueryResult = ApolloReactCommon.QueryResult<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>;
export const MigratedArtifactCollectionDocument = gql`
    query MigratedArtifactCollection($entityName: String!, $projectName: String!, $artifactCollectionName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactCollection(name: $artifactCollectionName) {
      id
      name
      modelRegistryMigratedArtifactCollection {
        id
        name
        project {
          id
          name
          entityName
        }
      }
    }
  }
}
    `;
export type MigratedArtifactCollectionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>, 'query'> & ({ variables: MigratedArtifactCollectionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MigratedArtifactCollectionComponent = (props: MigratedArtifactCollectionComponentProps) => (
      <ApolloReactComponents.Query<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables> query={MigratedArtifactCollectionDocument} {...props} />
    );
    
export type MigratedArtifactCollectionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>
    } & TChildProps;
export function withMigratedArtifactCollection<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MigratedArtifactCollectionQuery,
  MigratedArtifactCollectionQueryVariables,
  MigratedArtifactCollectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables, MigratedArtifactCollectionProps<TChildProps, TDataName>>(MigratedArtifactCollectionDocument, {
      alias: 'migratedArtifactCollection',
      ...operationOptions
    });
};

/**
 * __useMigratedArtifactCollectionQuery__
 *
 * To run a query within a React component, call `useMigratedArtifactCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMigratedArtifactCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMigratedArtifactCollectionQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *   },
 * });
 */
export function useMigratedArtifactCollectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables> & ({ variables: MigratedArtifactCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>(MigratedArtifactCollectionDocument, options);
      }
export function useMigratedArtifactCollectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>(MigratedArtifactCollectionDocument, options);
        }
// @ts-ignore
export function useMigratedArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>;
export function useMigratedArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MigratedArtifactCollectionQuery | undefined, MigratedArtifactCollectionQueryVariables>;
export function useMigratedArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>(MigratedArtifactCollectionDocument, options);
        }
export type MigratedArtifactCollectionQueryHookResult = ReturnType<typeof useMigratedArtifactCollectionQuery>;
export type MigratedArtifactCollectionLazyQueryHookResult = ReturnType<typeof useMigratedArtifactCollectionLazyQuery>;
export type MigratedArtifactCollectionSuspenseQueryHookResult = ReturnType<typeof useMigratedArtifactCollectionSuspenseQuery>;
export type MigratedArtifactCollectionQueryResult = ApolloReactCommon.QueryResult<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>;
export const OrgMrConfigDocument = gql`
    query OrgMRConfig($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    orgEntity {
      id
      modelRegistryMigrationConfig {
        ...ModelRegistryMigrationConfigFragment
      }
    }
  }
}
    ${ModelRegistryMigrationConfigFragmentFragmentDoc}`;
export type OrgMrConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>, 'query'> & ({ variables: OrgMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrgMrConfigComponent = (props: OrgMrConfigComponentProps) => (
      <ApolloReactComponents.Query<OrgMrConfigQuery, OrgMrConfigQueryVariables> query={OrgMrConfigDocument} {...props} />
    );
    
export type OrgMrConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrgMrConfigQuery, OrgMrConfigQueryVariables>
    } & TChildProps;
export function withOrgMrConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrgMrConfigQuery,
  OrgMrConfigQueryVariables,
  OrgMrConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrgMrConfigQuery, OrgMrConfigQueryVariables, OrgMrConfigProps<TChildProps, TDataName>>(OrgMrConfigDocument, {
      alias: 'orgMrConfig',
      ...operationOptions
    });
};

/**
 * __useOrgMrConfigQuery__
 *
 * To run a query within a React component, call `useOrgMrConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgMrConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgMrConfigQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrgMrConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables> & ({ variables: OrgMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgMrConfigQuery, OrgMrConfigQueryVariables>(OrgMrConfigDocument, options);
      }
export function useOrgMrConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgMrConfigQuery, OrgMrConfigQueryVariables>(OrgMrConfigDocument, options);
        }
// @ts-ignore
export function useOrgMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgMrConfigQuery, OrgMrConfigQueryVariables>;
export function useOrgMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgMrConfigQuery | undefined, OrgMrConfigQueryVariables>;
export function useOrgMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgMrConfigQuery, OrgMrConfigQueryVariables>(OrgMrConfigDocument, options);
        }
export type OrgMrConfigQueryHookResult = ReturnType<typeof useOrgMrConfigQuery>;
export type OrgMrConfigLazyQueryHookResult = ReturnType<typeof useOrgMrConfigLazyQuery>;
export type OrgMrConfigSuspenseQueryHookResult = ReturnType<typeof useOrgMrConfigSuspenseQuery>;
export type OrgMrConfigQueryResult = ApolloReactCommon.QueryResult<OrgMrConfigQuery, OrgMrConfigQueryVariables>;
export const EntityMrConfigDocument = gql`
    query EntityMRConfig($entityName: String!) {
  entity(name: $entityName) {
    id
    name
    modelRegistryMigrationConfig {
      ...ModelRegistryMigrationConfigFragment
    }
  }
}
    ${ModelRegistryMigrationConfigFragmentFragmentDoc}`;
export type EntityMrConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>, 'query'> & ({ variables: EntityMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityMrConfigComponent = (props: EntityMrConfigComponentProps) => (
      <ApolloReactComponents.Query<EntityMrConfigQuery, EntityMrConfigQueryVariables> query={EntityMrConfigDocument} {...props} />
    );
    
export type EntityMrConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityMrConfigQuery, EntityMrConfigQueryVariables>
    } & TChildProps;
export function withEntityMrConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityMrConfigQuery,
  EntityMrConfigQueryVariables,
  EntityMrConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityMrConfigQuery, EntityMrConfigQueryVariables, EntityMrConfigProps<TChildProps, TDataName>>(EntityMrConfigDocument, {
      alias: 'entityMrConfig',
      ...operationOptions
    });
};

/**
 * __useEntityMrConfigQuery__
 *
 * To run a query within a React component, call `useEntityMrConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityMrConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityMrConfigQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityMrConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables> & ({ variables: EntityMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityMrConfigQuery, EntityMrConfigQueryVariables>(EntityMrConfigDocument, options);
      }
export function useEntityMrConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityMrConfigQuery, EntityMrConfigQueryVariables>(EntityMrConfigDocument, options);
        }
// @ts-ignore
export function useEntityMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityMrConfigQuery, EntityMrConfigQueryVariables>;
export function useEntityMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityMrConfigQuery | undefined, EntityMrConfigQueryVariables>;
export function useEntityMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityMrConfigQuery, EntityMrConfigQueryVariables>(EntityMrConfigDocument, options);
        }
export type EntityMrConfigQueryHookResult = ReturnType<typeof useEntityMrConfigQuery>;
export type EntityMrConfigLazyQueryHookResult = ReturnType<typeof useEntityMrConfigLazyQuery>;
export type EntityMrConfigSuspenseQueryHookResult = ReturnType<typeof useEntityMrConfigSuspenseQuery>;
export type EntityMrConfigQueryResult = ApolloReactCommon.QueryResult<EntityMrConfigQuery, EntityMrConfigQueryVariables>;
export const OrgTeamsMrConfigDocument = gql`
    query OrgTeamsMRConfig($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    teams {
      id
      name
      modelRegistryMigrationConfig {
        ...ModelRegistryMigrationConfigFragment
      }
    }
  }
}
    ${ModelRegistryMigrationConfigFragmentFragmentDoc}`;
export type OrgTeamsMrConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>, 'query'> & ({ variables: OrgTeamsMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrgTeamsMrConfigComponent = (props: OrgTeamsMrConfigComponentProps) => (
      <ApolloReactComponents.Query<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables> query={OrgTeamsMrConfigDocument} {...props} />
    );
    
export type OrgTeamsMrConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>
    } & TChildProps;
export function withOrgTeamsMrConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrgTeamsMrConfigQuery,
  OrgTeamsMrConfigQueryVariables,
  OrgTeamsMrConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables, OrgTeamsMrConfigProps<TChildProps, TDataName>>(OrgTeamsMrConfigDocument, {
      alias: 'orgTeamsMrConfig',
      ...operationOptions
    });
};

/**
 * __useOrgTeamsMrConfigQuery__
 *
 * To run a query within a React component, call `useOrgTeamsMrConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgTeamsMrConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgTeamsMrConfigQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrgTeamsMrConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables> & ({ variables: OrgTeamsMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>(OrgTeamsMrConfigDocument, options);
      }
export function useOrgTeamsMrConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>(OrgTeamsMrConfigDocument, options);
        }
// @ts-ignore
export function useOrgTeamsMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>;
export function useOrgTeamsMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgTeamsMrConfigQuery | undefined, OrgTeamsMrConfigQueryVariables>;
export function useOrgTeamsMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>(OrgTeamsMrConfigDocument, options);
        }
export type OrgTeamsMrConfigQueryHookResult = ReturnType<typeof useOrgTeamsMrConfigQuery>;
export type OrgTeamsMrConfigLazyQueryHookResult = ReturnType<typeof useOrgTeamsMrConfigLazyQuery>;
export type OrgTeamsMrConfigSuspenseQueryHookResult = ReturnType<typeof useOrgTeamsMrConfigSuspenseQuery>;
export type OrgTeamsMrConfigQueryResult = ApolloReactCommon.QueryResult<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>;
export const FetchArtifactTypeNamesDocument = gql`
    query FetchArtifactTypeNames($orgName: String!, $first: Int, $after: String) {
  organization(name: $orgName) {
    id
    name
    orgEntity {
      id
      name
      artifactTypeNames(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node
          cursor
        }
      }
    }
  }
}
    `;
export type FetchArtifactTypeNamesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>, 'query'> & ({ variables: FetchArtifactTypeNamesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchArtifactTypeNamesComponent = (props: FetchArtifactTypeNamesComponentProps) => (
      <ApolloReactComponents.Query<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables> query={FetchArtifactTypeNamesDocument} {...props} />
    );
    
export type FetchArtifactTypeNamesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>
    } & TChildProps;
export function withFetchArtifactTypeNames<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchArtifactTypeNamesQuery,
  FetchArtifactTypeNamesQueryVariables,
  FetchArtifactTypeNamesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables, FetchArtifactTypeNamesProps<TChildProps, TDataName>>(FetchArtifactTypeNamesDocument, {
      alias: 'fetchArtifactTypeNames',
      ...operationOptions
    });
};

/**
 * __useFetchArtifactTypeNamesQuery__
 *
 * To run a query within a React component, call `useFetchArtifactTypeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactTypeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactTypeNamesQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchArtifactTypeNamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables> & ({ variables: FetchArtifactTypeNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>(FetchArtifactTypeNamesDocument, options);
      }
export function useFetchArtifactTypeNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>(FetchArtifactTypeNamesDocument, options);
        }
// @ts-ignore
export function useFetchArtifactTypeNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>;
export function useFetchArtifactTypeNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactTypeNamesQuery | undefined, FetchArtifactTypeNamesQueryVariables>;
export function useFetchArtifactTypeNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>(FetchArtifactTypeNamesDocument, options);
        }
export type FetchArtifactTypeNamesQueryHookResult = ReturnType<typeof useFetchArtifactTypeNamesQuery>;
export type FetchArtifactTypeNamesLazyQueryHookResult = ReturnType<typeof useFetchArtifactTypeNamesLazyQuery>;
export type FetchArtifactTypeNamesSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactTypeNamesSuspenseQuery>;
export type FetchArtifactTypeNamesQueryResult = ApolloReactCommon.QueryResult<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>;
export const RegistryOrganizationDocument = gql`
    query RegistryOrganization($orgName: String!) {
  organization(name: $orgName) {
    id
    members {
      ...OrganizationMemberFragment
    }
    teams {
      id
      name
      photoUrl
      memberCount
    }
    serviceAccounts {
      id
      name
      accountType
    }
    subscriptions {
      id
      plan {
        id
        name
        planType
      }
    }
  }
}
    ${OrganizationMemberFragmentFragmentDoc}`;
export type RegistryOrganizationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>, 'query'> & ({ variables: RegistryOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistryOrganizationComponent = (props: RegistryOrganizationComponentProps) => (
      <ApolloReactComponents.Query<RegistryOrganizationQuery, RegistryOrganizationQueryVariables> query={RegistryOrganizationDocument} {...props} />
    );
    
export type RegistryOrganizationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>
    } & TChildProps;
export function withRegistryOrganization<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegistryOrganizationQuery,
  RegistryOrganizationQueryVariables,
  RegistryOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegistryOrganizationQuery, RegistryOrganizationQueryVariables, RegistryOrganizationProps<TChildProps, TDataName>>(RegistryOrganizationDocument, {
      alias: 'registryOrganization',
      ...operationOptions
    });
};

/**
 * __useRegistryOrganizationQuery__
 *
 * To run a query within a React component, call `useRegistryOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryOrganizationQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useRegistryOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables> & ({ variables: RegistryOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>(RegistryOrganizationDocument, options);
      }
export function useRegistryOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>(RegistryOrganizationDocument, options);
        }
// @ts-ignore
export function useRegistryOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>;
export function useRegistryOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryOrganizationQuery | undefined, RegistryOrganizationQueryVariables>;
export function useRegistryOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>(RegistryOrganizationDocument, options);
        }
export type RegistryOrganizationQueryHookResult = ReturnType<typeof useRegistryOrganizationQuery>;
export type RegistryOrganizationLazyQueryHookResult = ReturnType<typeof useRegistryOrganizationLazyQuery>;
export type RegistryOrganizationSuspenseQueryHookResult = ReturnType<typeof useRegistryOrganizationSuspenseQuery>;
export type RegistryOrganizationQueryResult = ApolloReactCommon.QueryResult<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>;
export const OrganizationReadOnlyDocument = gql`
    query OrganizationReadOnly($orgName: String!) {
  organization(name: $orgName) {
    id
    orgEntity {
      id
      name
      readOnly
    }
  }
}
    `;
export type OrganizationReadOnlyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>, 'query'> & ({ variables: OrganizationReadOnlyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationReadOnlyComponent = (props: OrganizationReadOnlyComponentProps) => (
      <ApolloReactComponents.Query<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables> query={OrganizationReadOnlyDocument} {...props} />
    );
    
export type OrganizationReadOnlyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>
    } & TChildProps;
export function withOrganizationReadOnly<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationReadOnlyQuery,
  OrganizationReadOnlyQueryVariables,
  OrganizationReadOnlyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables, OrganizationReadOnlyProps<TChildProps, TDataName>>(OrganizationReadOnlyDocument, {
      alias: 'organizationReadOnly',
      ...operationOptions
    });
};

/**
 * __useOrganizationReadOnlyQuery__
 *
 * To run a query within a React component, call `useOrganizationReadOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationReadOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationReadOnlyQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationReadOnlyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables> & ({ variables: OrganizationReadOnlyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>(OrganizationReadOnlyDocument, options);
      }
export function useOrganizationReadOnlyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>(OrganizationReadOnlyDocument, options);
        }
// @ts-ignore
export function useOrganizationReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>;
export function useOrganizationReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationReadOnlyQuery | undefined, OrganizationReadOnlyQueryVariables>;
export function useOrganizationReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>(OrganizationReadOnlyDocument, options);
        }
export type OrganizationReadOnlyQueryHookResult = ReturnType<typeof useOrganizationReadOnlyQuery>;
export type OrganizationReadOnlyLazyQueryHookResult = ReturnType<typeof useOrganizationReadOnlyLazyQuery>;
export type OrganizationReadOnlySuspenseQueryHookResult = ReturnType<typeof useOrganizationReadOnlySuspenseQuery>;
export type OrganizationReadOnlyQueryResult = ApolloReactCommon.QueryResult<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>;
export const ProjectReadOnlyDocument = gql`
    query ProjectReadOnly($entityName: String!, $projectName: String!) {
  entity(name: $entityName) {
    id
    project(name: $projectName) {
      id
      readOnly
    }
  }
}
    `;
export type ProjectReadOnlyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>, 'query'> & ({ variables: ProjectReadOnlyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectReadOnlyComponent = (props: ProjectReadOnlyComponentProps) => (
      <ApolloReactComponents.Query<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables> query={ProjectReadOnlyDocument} {...props} />
    );
    
export type ProjectReadOnlyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>
    } & TChildProps;
export function withProjectReadOnly<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectReadOnlyQuery,
  ProjectReadOnlyQueryVariables,
  ProjectReadOnlyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables, ProjectReadOnlyProps<TChildProps, TDataName>>(ProjectReadOnlyDocument, {
      alias: 'projectReadOnly',
      ...operationOptions
    });
};

/**
 * __useProjectReadOnlyQuery__
 *
 * To run a query within a React component, call `useProjectReadOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReadOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReadOnlyQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectReadOnlyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables> & ({ variables: ProjectReadOnlyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>(ProjectReadOnlyDocument, options);
      }
export function useProjectReadOnlyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>(ProjectReadOnlyDocument, options);
        }
// @ts-ignore
export function useProjectReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>;
export function useProjectReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectReadOnlyQuery | undefined, ProjectReadOnlyQueryVariables>;
export function useProjectReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>(ProjectReadOnlyDocument, options);
        }
export type ProjectReadOnlyQueryHookResult = ReturnType<typeof useProjectReadOnlyQuery>;
export type ProjectReadOnlyLazyQueryHookResult = ReturnType<typeof useProjectReadOnlyLazyQuery>;
export type ProjectReadOnlySuspenseQueryHookResult = ReturnType<typeof useProjectReadOnlySuspenseQuery>;
export type ProjectReadOnlyQueryResult = ApolloReactCommon.QueryResult<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>;
export const FetchArtifactCollectionsPartialDocument = gql`
    query FetchArtifactCollectionsPartial($orgName: String!, $searchTerm: String, $cursor: String, $limit: Int!, $artifactsLimit: Int) {
  organization(name: $orgName) {
    id
    orgEntity {
      id
      name
      artifactCollectionsSearch(
        searchTerm: $searchTerm
        cursor: $cursor
        limit: $limit
        artifactsLimit: $artifactsLimit
      ) {
        ...registrySearchResultFragment
      }
    }
  }
}
    ${RegistrySearchResultFragmentFragmentDoc}`;
export type FetchArtifactCollectionsPartialComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>, 'query'> & ({ variables: FetchArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchArtifactCollectionsPartialComponent = (props: FetchArtifactCollectionsPartialComponentProps) => (
      <ApolloReactComponents.Query<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables> query={FetchArtifactCollectionsPartialDocument} {...props} />
    );
    
export type FetchArtifactCollectionsPartialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>
    } & TChildProps;
export function withFetchArtifactCollectionsPartial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchArtifactCollectionsPartialQuery,
  FetchArtifactCollectionsPartialQueryVariables,
  FetchArtifactCollectionsPartialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables, FetchArtifactCollectionsPartialProps<TChildProps, TDataName>>(FetchArtifactCollectionsPartialDocument, {
      alias: 'fetchArtifactCollectionsPartial',
      ...operationOptions
    });
};

/**
 * __useFetchArtifactCollectionsPartialQuery__
 *
 * To run a query within a React component, call `useFetchArtifactCollectionsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactCollectionsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactCollectionsPartialQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      searchTerm: // value for 'searchTerm'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      artifactsLimit: // value for 'artifactsLimit'
 *   },
 * });
 */
export function useFetchArtifactCollectionsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables> & ({ variables: FetchArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>(FetchArtifactCollectionsPartialDocument, options);
      }
export function useFetchArtifactCollectionsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>(FetchArtifactCollectionsPartialDocument, options);
        }
// @ts-ignore
export function useFetchArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>;
export function useFetchArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionsPartialQuery | undefined, FetchArtifactCollectionsPartialQueryVariables>;
export function useFetchArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>(FetchArtifactCollectionsPartialDocument, options);
        }
export type FetchArtifactCollectionsPartialQueryHookResult = ReturnType<typeof useFetchArtifactCollectionsPartialQuery>;
export type FetchArtifactCollectionsPartialLazyQueryHookResult = ReturnType<typeof useFetchArtifactCollectionsPartialLazyQuery>;
export type FetchArtifactCollectionsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactCollectionsPartialSuspenseQuery>;
export type FetchArtifactCollectionsPartialQueryResult = ApolloReactCommon.QueryResult<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>;
export const FetchArtifactMembershipsPartialDocument = gql`
    query FetchArtifactMembershipsPartial($collectionId: ID!, $limit: Int!, $after: String, $searchTerm: String) {
  artifactCollection(id: $collectionId) {
    id
    artifactMemberships(first: $limit, after: $after, searchTerm: $searchTerm) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...registrySearchArtifactMembershipsFragment
        }
      }
    }
  }
}
    ${RegistrySearchArtifactMembershipsFragmentFragmentDoc}`;
export type FetchArtifactMembershipsPartialComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>, 'query'> & ({ variables: FetchArtifactMembershipsPartialQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchArtifactMembershipsPartialComponent = (props: FetchArtifactMembershipsPartialComponentProps) => (
      <ApolloReactComponents.Query<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables> query={FetchArtifactMembershipsPartialDocument} {...props} />
    );
    
export type FetchArtifactMembershipsPartialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>
    } & TChildProps;
export function withFetchArtifactMembershipsPartial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchArtifactMembershipsPartialQuery,
  FetchArtifactMembershipsPartialQueryVariables,
  FetchArtifactMembershipsPartialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables, FetchArtifactMembershipsPartialProps<TChildProps, TDataName>>(FetchArtifactMembershipsPartialDocument, {
      alias: 'fetchArtifactMembershipsPartial',
      ...operationOptions
    });
};

/**
 * __useFetchArtifactMembershipsPartialQuery__
 *
 * To run a query within a React component, call `useFetchArtifactMembershipsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactMembershipsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactMembershipsPartialQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useFetchArtifactMembershipsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables> & ({ variables: FetchArtifactMembershipsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>(FetchArtifactMembershipsPartialDocument, options);
      }
export function useFetchArtifactMembershipsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>(FetchArtifactMembershipsPartialDocument, options);
        }
// @ts-ignore
export function useFetchArtifactMembershipsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>;
export function useFetchArtifactMembershipsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactMembershipsPartialQuery | undefined, FetchArtifactMembershipsPartialQueryVariables>;
export function useFetchArtifactMembershipsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>(FetchArtifactMembershipsPartialDocument, options);
        }
export type FetchArtifactMembershipsPartialQueryHookResult = ReturnType<typeof useFetchArtifactMembershipsPartialQuery>;
export type FetchArtifactMembershipsPartialLazyQueryHookResult = ReturnType<typeof useFetchArtifactMembershipsPartialLazyQuery>;
export type FetchArtifactMembershipsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactMembershipsPartialSuspenseQuery>;
export type FetchArtifactMembershipsPartialQueryResult = ApolloReactCommon.QueryResult<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>;
export const FetchArtifactCollectionSupplementalDocument = gql`
    query FetchArtifactCollectionSupplemental($collectionId: ID!) {
  artifactCollection(id: $collectionId) {
    id
    project {
      id
      name
    }
    artifacts {
      edges {
        node {
          id
          usedBy {
            edges {
              node {
                id
                user {
                  id
                  name
                }
              }
            }
          }
        }
      }
      totalCount
    }
  }
}
    `;
export type FetchArtifactCollectionSupplementalComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>, 'query'> & ({ variables: FetchArtifactCollectionSupplementalQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchArtifactCollectionSupplementalComponent = (props: FetchArtifactCollectionSupplementalComponentProps) => (
      <ApolloReactComponents.Query<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables> query={FetchArtifactCollectionSupplementalDocument} {...props} />
    );
    
export type FetchArtifactCollectionSupplementalProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>
    } & TChildProps;
export function withFetchArtifactCollectionSupplemental<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchArtifactCollectionSupplementalQuery,
  FetchArtifactCollectionSupplementalQueryVariables,
  FetchArtifactCollectionSupplementalProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables, FetchArtifactCollectionSupplementalProps<TChildProps, TDataName>>(FetchArtifactCollectionSupplementalDocument, {
      alias: 'fetchArtifactCollectionSupplemental',
      ...operationOptions
    });
};

/**
 * __useFetchArtifactCollectionSupplementalQuery__
 *
 * To run a query within a React component, call `useFetchArtifactCollectionSupplementalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactCollectionSupplementalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactCollectionSupplementalQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useFetchArtifactCollectionSupplementalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables> & ({ variables: FetchArtifactCollectionSupplementalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>(FetchArtifactCollectionSupplementalDocument, options);
      }
export function useFetchArtifactCollectionSupplementalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>(FetchArtifactCollectionSupplementalDocument, options);
        }
// @ts-ignore
export function useFetchArtifactCollectionSupplementalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>;
export function useFetchArtifactCollectionSupplementalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionSupplementalQuery | undefined, FetchArtifactCollectionSupplementalQueryVariables>;
export function useFetchArtifactCollectionSupplementalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>(FetchArtifactCollectionSupplementalDocument, options);
        }
export type FetchArtifactCollectionSupplementalQueryHookResult = ReturnType<typeof useFetchArtifactCollectionSupplementalQuery>;
export type FetchArtifactCollectionSupplementalLazyQueryHookResult = ReturnType<typeof useFetchArtifactCollectionSupplementalLazyQuery>;
export type FetchArtifactCollectionSupplementalSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactCollectionSupplementalSuspenseQuery>;
export type FetchArtifactCollectionSupplementalQueryResult = ApolloReactCommon.QueryResult<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>;
export const RegistryCollectionsDocument = gql`
    query RegistryCollections($organization: String!, $registryFilter: JSONString, $collectionFilter: JSONString, $collectionTypes: [ArtifactCollectionType!] = [PORTFOLIO], $cursor: String, $perPage: Int) {
  organization(name: $organization) {
    id
    orgEntity {
      id
      name
      artifactCollections(
        projectFilters: $registryFilter
        filters: $collectionFilter
        collectionTypes: $collectionTypes
        after: $cursor
        first: $perPage
      ) {
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
        edges {
          node {
            ...RegistryCollectionFragment
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${RegistryCollectionFragmentFragmentDoc}`;
export type RegistryCollectionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>, 'query'> & ({ variables: RegistryCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistryCollectionsComponent = (props: RegistryCollectionsComponentProps) => (
      <ApolloReactComponents.Query<RegistryCollectionsQuery, RegistryCollectionsQueryVariables> query={RegistryCollectionsDocument} {...props} />
    );
    
export type RegistryCollectionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>
    } & TChildProps;
export function withRegistryCollections<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegistryCollectionsQuery,
  RegistryCollectionsQueryVariables,
  RegistryCollectionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegistryCollectionsQuery, RegistryCollectionsQueryVariables, RegistryCollectionsProps<TChildProps, TDataName>>(RegistryCollectionsDocument, {
      alias: 'registryCollections',
      ...operationOptions
    });
};

/**
 * __useRegistryCollectionsQuery__
 *
 * To run a query within a React component, call `useRegistryCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryCollectionsQuery({
 *   variables: {
 *      organization: // value for 'organization'
 *      registryFilter: // value for 'registryFilter'
 *      collectionFilter: // value for 'collectionFilter'
 *      collectionTypes: // value for 'collectionTypes'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useRegistryCollectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables> & ({ variables: RegistryCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>(RegistryCollectionsDocument, options);
      }
export function useRegistryCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>(RegistryCollectionsDocument, options);
        }
// @ts-ignore
export function useRegistryCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>;
export function useRegistryCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsQuery | undefined, RegistryCollectionsQueryVariables>;
export function useRegistryCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>(RegistryCollectionsDocument, options);
        }
export type RegistryCollectionsQueryHookResult = ReturnType<typeof useRegistryCollectionsQuery>;
export type RegistryCollectionsLazyQueryHookResult = ReturnType<typeof useRegistryCollectionsLazyQuery>;
export type RegistryCollectionsSuspenseQueryHookResult = ReturnType<typeof useRegistryCollectionsSuspenseQuery>;
export type RegistryCollectionsQueryResult = ApolloReactCommon.QueryResult<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>;
export const RegistryCollectionsWithDetailsDocument = gql`
    query RegistryCollectionsWithDetails($organization: String!, $registryFilter: JSONString, $collectionFilter: JSONString, $collectionTypes: [ArtifactCollectionType!] = [PORTFOLIO], $cursor: String, $perPage: Int) {
  organization(name: $organization) {
    id
    orgEntity {
      id
      name
      artifactCollections(
        projectFilters: $registryFilter
        filters: $collectionFilter
        collectionTypes: $collectionTypes
        after: $cursor
        first: $perPage
      ) {
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
        edges {
          node {
            ...RegistryCollectionWithDetailsFragment
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${RegistryCollectionWithDetailsFragmentFragmentDoc}`;
export type RegistryCollectionsWithDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>, 'query'> & ({ variables: RegistryCollectionsWithDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistryCollectionsWithDetailsComponent = (props: RegistryCollectionsWithDetailsComponentProps) => (
      <ApolloReactComponents.Query<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables> query={RegistryCollectionsWithDetailsDocument} {...props} />
    );
    
export type RegistryCollectionsWithDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>
    } & TChildProps;
export function withRegistryCollectionsWithDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegistryCollectionsWithDetailsQuery,
  RegistryCollectionsWithDetailsQueryVariables,
  RegistryCollectionsWithDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables, RegistryCollectionsWithDetailsProps<TChildProps, TDataName>>(RegistryCollectionsWithDetailsDocument, {
      alias: 'registryCollectionsWithDetails',
      ...operationOptions
    });
};

/**
 * __useRegistryCollectionsWithDetailsQuery__
 *
 * To run a query within a React component, call `useRegistryCollectionsWithDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryCollectionsWithDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryCollectionsWithDetailsQuery({
 *   variables: {
 *      organization: // value for 'organization'
 *      registryFilter: // value for 'registryFilter'
 *      collectionFilter: // value for 'collectionFilter'
 *      collectionTypes: // value for 'collectionTypes'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useRegistryCollectionsWithDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables> & ({ variables: RegistryCollectionsWithDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>(RegistryCollectionsWithDetailsDocument, options);
      }
export function useRegistryCollectionsWithDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>(RegistryCollectionsWithDetailsDocument, options);
        }
// @ts-ignore
export function useRegistryCollectionsWithDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>;
export function useRegistryCollectionsWithDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsWithDetailsQuery | undefined, RegistryCollectionsWithDetailsQueryVariables>;
export function useRegistryCollectionsWithDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>(RegistryCollectionsWithDetailsDocument, options);
        }
export type RegistryCollectionsWithDetailsQueryHookResult = ReturnType<typeof useRegistryCollectionsWithDetailsQuery>;
export type RegistryCollectionsWithDetailsLazyQueryHookResult = ReturnType<typeof useRegistryCollectionsWithDetailsLazyQuery>;
export type RegistryCollectionsWithDetailsSuspenseQueryHookResult = ReturnType<typeof useRegistryCollectionsWithDetailsSuspenseQuery>;
export type RegistryCollectionsWithDetailsQueryResult = ApolloReactCommon.QueryResult<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>;
export const CreateRegistryMembersDocument = gql`
    mutation createRegistryMembers($userIds: [ID!], $teamIds: [ID!], $projectId: ID!) {
  createProjectMembers(
    input: {userIds: $userIds, teamIds: $teamIds, projectId: $projectId}
  ) {
    success
  }
}
    `;
export type CreateRegistryMembersMutationFn = ApolloReactCommon.MutationFunction<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>;
export type CreateRegistryMembersComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>, 'mutation'>;

    export const CreateRegistryMembersComponent = (props: CreateRegistryMembersComponentProps) => (
      <ApolloReactComponents.Mutation<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables> mutation={CreateRegistryMembersDocument} {...props} />
    );
    
export type CreateRegistryMembersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>
    } & TChildProps;
export function withCreateRegistryMembers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateRegistryMembersMutation,
  CreateRegistryMembersMutationVariables,
  CreateRegistryMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables, CreateRegistryMembersProps<TChildProps, TDataName>>(CreateRegistryMembersDocument, {
      alias: 'createRegistryMembers',
      ...operationOptions
    });
};

/**
 * __useCreateRegistryMembersMutation__
 *
 * To run a mutation, you first call `useCreateRegistryMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryMembersMutation, { data, loading, error }] = useCreateRegistryMembersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      teamIds: // value for 'teamIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateRegistryMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>(CreateRegistryMembersDocument, options);
      }
export type CreateRegistryMembersMutationHookResult = ReturnType<typeof useCreateRegistryMembersMutation>;
export type CreateRegistryMembersMutationResult = ApolloReactCommon.MutationResult<CreateRegistryMembersMutation>;
export type CreateRegistryMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>;
export const DeleteRegistryMembersDocument = gql`
    mutation deleteRegistryMembers($userIds: [ID!], $teamIds: [ID!], $projectId: ID!) {
  deleteProjectMembers(
    input: {userIds: $userIds, teamIds: $teamIds, projectId: $projectId}
  ) {
    success
  }
}
    `;
export type DeleteRegistryMembersMutationFn = ApolloReactCommon.MutationFunction<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>;
export type DeleteRegistryMembersComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>, 'mutation'>;

    export const DeleteRegistryMembersComponent = (props: DeleteRegistryMembersComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables> mutation={DeleteRegistryMembersDocument} {...props} />
    );
    
export type DeleteRegistryMembersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>
    } & TChildProps;
export function withDeleteRegistryMembers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteRegistryMembersMutation,
  DeleteRegistryMembersMutationVariables,
  DeleteRegistryMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables, DeleteRegistryMembersProps<TChildProps, TDataName>>(DeleteRegistryMembersDocument, {
      alias: 'deleteRegistryMembers',
      ...operationOptions
    });
};

/**
 * __useDeleteRegistryMembersMutation__
 *
 * To run a mutation, you first call `useDeleteRegistryMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistryMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistryMembersMutation, { data, loading, error }] = useDeleteRegistryMembersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      teamIds: // value for 'teamIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteRegistryMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>(DeleteRegistryMembersDocument, options);
      }
export type DeleteRegistryMembersMutationHookResult = ReturnType<typeof useDeleteRegistryMembersMutation>;
export type DeleteRegistryMembersMutationResult = ApolloReactCommon.MutationResult<DeleteRegistryMembersMutation>;
export type DeleteRegistryMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>;
export const UpdateUserRegistryRoleDocument = gql`
    mutation updateUserRegistryRole($userId: ID!, $projectId: ID!, $userProjectRole: String!, $clientMutationId: String) {
  updateProjectMember(
    input: {userId: $userId, projectId: $projectId, userProjectRole: $userProjectRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateUserRegistryRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>;
export type UpdateUserRegistryRoleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>, 'mutation'>;

    export const UpdateUserRegistryRoleComponent = (props: UpdateUserRegistryRoleComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables> mutation={UpdateUserRegistryRoleDocument} {...props} />
    );
    
export type UpdateUserRegistryRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>
    } & TChildProps;
export function withUpdateUserRegistryRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserRegistryRoleMutation,
  UpdateUserRegistryRoleMutationVariables,
  UpdateUserRegistryRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables, UpdateUserRegistryRoleProps<TChildProps, TDataName>>(UpdateUserRegistryRoleDocument, {
      alias: 'updateUserRegistryRole',
      ...operationOptions
    });
};

/**
 * __useUpdateUserRegistryRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRegistryRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRegistryRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRegistryRoleMutation, { data, loading, error }] = useUpdateUserRegistryRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *      userProjectRole: // value for 'userProjectRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateUserRegistryRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>(UpdateUserRegistryRoleDocument, options);
      }
export type UpdateUserRegistryRoleMutationHookResult = ReturnType<typeof useUpdateUserRegistryRoleMutation>;
export type UpdateUserRegistryRoleMutationResult = ApolloReactCommon.MutationResult<UpdateUserRegistryRoleMutation>;
export type UpdateUserRegistryRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>;
export const UpdateTeamRegistryRoleDocument = gql`
    mutation updateTeamRegistryRole($teamId: ID!, $projectId: ID!, $teamProjectRole: String!, $clientMutationId: String) {
  updateProjectTeamMember(
    input: {teamId: $teamId, projectId: $projectId, teamProjectRole: $teamProjectRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateTeamRegistryRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>;
export type UpdateTeamRegistryRoleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>, 'mutation'>;

    export const UpdateTeamRegistryRoleComponent = (props: UpdateTeamRegistryRoleComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables> mutation={UpdateTeamRegistryRoleDocument} {...props} />
    );
    
export type UpdateTeamRegistryRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>
    } & TChildProps;
export function withUpdateTeamRegistryRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateTeamRegistryRoleMutation,
  UpdateTeamRegistryRoleMutationVariables,
  UpdateTeamRegistryRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables, UpdateTeamRegistryRoleProps<TChildProps, TDataName>>(UpdateTeamRegistryRoleDocument, {
      alias: 'updateTeamRegistryRole',
      ...operationOptions
    });
};

/**
 * __useUpdateTeamRegistryRoleMutation__
 *
 * To run a mutation, you first call `useUpdateTeamRegistryRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamRegistryRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamRegistryRoleMutation, { data, loading, error }] = useUpdateTeamRegistryRoleMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      teamProjectRole: // value for 'teamProjectRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateTeamRegistryRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>(UpdateTeamRegistryRoleDocument, options);
      }
export type UpdateTeamRegistryRoleMutationHookResult = ReturnType<typeof useUpdateTeamRegistryRoleMutation>;
export type UpdateTeamRegistryRoleMutationResult = ApolloReactCommon.MutationResult<UpdateTeamRegistryRoleMutation>;
export type UpdateTeamRegistryRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>;
export const ArtifactMembershipsDocument = gql`
    query ArtifactMemberships($organization: String!, $registryFilter: JSONString, $collectionFilter: JSONString, $artifactFilter: JSONString, $cursor: String, $perPage: Int, $order: String) {
  organization(name: $organization) {
    id
    orgEntity {
      id
      name
      artifactMemberships(
        projectFilters: $registryFilter
        collectionFilters: $collectionFilter
        filters: $artifactFilter
        after: $cursor
        first: $perPage
        order: $order
      ) {
        pageInfo {
          ...PageInfoFragment
        }
        edges {
          node {
            ...ArtifactMembershipFragment
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${ArtifactMembershipFragmentFragmentDoc}`;
export type ArtifactMembershipsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>, 'query'> & ({ variables: ArtifactMembershipsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactMembershipsComponent = (props: ArtifactMembershipsComponentProps) => (
      <ApolloReactComponents.Query<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables> query={ArtifactMembershipsDocument} {...props} />
    );
    
export type ArtifactMembershipsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>
    } & TChildProps;
export function withArtifactMemberships<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactMembershipsQuery,
  ArtifactMembershipsQueryVariables,
  ArtifactMembershipsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables, ArtifactMembershipsProps<TChildProps, TDataName>>(ArtifactMembershipsDocument, {
      alias: 'artifactMemberships',
      ...operationOptions
    });
};

/**
 * __useArtifactMembershipsQuery__
 *
 * To run a query within a React component, call `useArtifactMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactMembershipsQuery({
 *   variables: {
 *      organization: // value for 'organization'
 *      registryFilter: // value for 'registryFilter'
 *      collectionFilter: // value for 'collectionFilter'
 *      artifactFilter: // value for 'artifactFilter'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useArtifactMembershipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables> & ({ variables: ArtifactMembershipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>(ArtifactMembershipsDocument, options);
      }
export function useArtifactMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>(ArtifactMembershipsDocument, options);
        }
// @ts-ignore
export function useArtifactMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>;
export function useArtifactMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipsQuery | undefined, ArtifactMembershipsQueryVariables>;
export function useArtifactMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>(ArtifactMembershipsDocument, options);
        }
export type ArtifactMembershipsQueryHookResult = ReturnType<typeof useArtifactMembershipsQuery>;
export type ArtifactMembershipsLazyQueryHookResult = ReturnType<typeof useArtifactMembershipsLazyQuery>;
export type ArtifactMembershipsSuspenseQueryHookResult = ReturnType<typeof useArtifactMembershipsSuspenseQuery>;
export type ArtifactMembershipsQueryResult = ApolloReactCommon.QueryResult<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>;
export const RegistryProjectArtifactTypesDocument = gql`
    query RegistryProjectArtifactTypes($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactTypes(includeAll: true) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;
export type RegistryProjectArtifactTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>, 'query'> & ({ variables: RegistryProjectArtifactTypesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistryProjectArtifactTypesComponent = (props: RegistryProjectArtifactTypesComponentProps) => (
      <ApolloReactComponents.Query<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables> query={RegistryProjectArtifactTypesDocument} {...props} />
    );
    
export type RegistryProjectArtifactTypesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>
    } & TChildProps;
export function withRegistryProjectArtifactTypes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegistryProjectArtifactTypesQuery,
  RegistryProjectArtifactTypesQueryVariables,
  RegistryProjectArtifactTypesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables, RegistryProjectArtifactTypesProps<TChildProps, TDataName>>(RegistryProjectArtifactTypesDocument, {
      alias: 'registryProjectArtifactTypes',
      ...operationOptions
    });
};

/**
 * __useRegistryProjectArtifactTypesQuery__
 *
 * To run a query within a React component, call `useRegistryProjectArtifactTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectArtifactTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectArtifactTypesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRegistryProjectArtifactTypesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables> & ({ variables: RegistryProjectArtifactTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>(RegistryProjectArtifactTypesDocument, options);
      }
export function useRegistryProjectArtifactTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>(RegistryProjectArtifactTypesDocument, options);
        }
// @ts-ignore
export function useRegistryProjectArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>;
export function useRegistryProjectArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectArtifactTypesQuery | undefined, RegistryProjectArtifactTypesQueryVariables>;
export function useRegistryProjectArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>(RegistryProjectArtifactTypesDocument, options);
        }
export type RegistryProjectArtifactTypesQueryHookResult = ReturnType<typeof useRegistryProjectArtifactTypesQuery>;
export type RegistryProjectArtifactTypesLazyQueryHookResult = ReturnType<typeof useRegistryProjectArtifactTypesLazyQuery>;
export type RegistryProjectArtifactTypesSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectArtifactTypesSuspenseQuery>;
export type RegistryProjectArtifactTypesQueryResult = ApolloReactCommon.QueryResult<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>;
export const RegistryProjectMembersDocument = gql`
    query RegistryProjectMembers($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    user {
      id
      name
      username
      photoUrl
      email
      accountType
    }
    members {
      id
      username
      name
      photoUrl
      email
      accountType
      role {
        ID
        name
      }
      projectRoleIsInherited
    }
    teamMembers {
      role {
        ID
        name
      }
      team {
        id
        name
        photoUrl
        memberCount
        members {
          id
          name
          photoUrl
          accountType
        }
      }
    }
  }
}
    `;
export type RegistryProjectMembersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>, 'query'> & ({ variables: RegistryProjectMembersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistryProjectMembersComponent = (props: RegistryProjectMembersComponentProps) => (
      <ApolloReactComponents.Query<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables> query={RegistryProjectMembersDocument} {...props} />
    );
    
export type RegistryProjectMembersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>
    } & TChildProps;
export function withRegistryProjectMembers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegistryProjectMembersQuery,
  RegistryProjectMembersQueryVariables,
  RegistryProjectMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables, RegistryProjectMembersProps<TChildProps, TDataName>>(RegistryProjectMembersDocument, {
      alias: 'registryProjectMembers',
      ...operationOptions
    });
};

/**
 * __useRegistryProjectMembersQuery__
 *
 * To run a query within a React component, call `useRegistryProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectMembersQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRegistryProjectMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables> & ({ variables: RegistryProjectMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>(RegistryProjectMembersDocument, options);
      }
export function useRegistryProjectMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>(RegistryProjectMembersDocument, options);
        }
// @ts-ignore
export function useRegistryProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>;
export function useRegistryProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectMembersQuery | undefined, RegistryProjectMembersQueryVariables>;
export function useRegistryProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>(RegistryProjectMembersDocument, options);
        }
export type RegistryProjectMembersQueryHookResult = ReturnType<typeof useRegistryProjectMembersQuery>;
export type RegistryProjectMembersLazyQueryHookResult = ReturnType<typeof useRegistryProjectMembersLazyQuery>;
export type RegistryProjectMembersSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectMembersSuspenseQuery>;
export type RegistryProjectMembersQueryResult = ApolloReactCommon.QueryResult<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>;
export const RegistryProjectMemberDocument = gql`
    query RegistryProjectMember($entityName: String!, $projectName: String!, $memberID: ID!) {
  project(entityName: $entityName, name: $projectName) {
    id
    member(id: $memberID) {
      id
      role {
        ID
        name
      }
      projectRoleIsInherited
    }
    teamMembers {
      role {
        ID
        name
      }
      team {
        id
        member(id: $memberID) {
          id
        }
      }
    }
  }
}
    `;
export type RegistryProjectMemberComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>, 'query'> & ({ variables: RegistryProjectMemberQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistryProjectMemberComponent = (props: RegistryProjectMemberComponentProps) => (
      <ApolloReactComponents.Query<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables> query={RegistryProjectMemberDocument} {...props} />
    );
    
export type RegistryProjectMemberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>
    } & TChildProps;
export function withRegistryProjectMember<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegistryProjectMemberQuery,
  RegistryProjectMemberQueryVariables,
  RegistryProjectMemberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables, RegistryProjectMemberProps<TChildProps, TDataName>>(RegistryProjectMemberDocument, {
      alias: 'registryProjectMember',
      ...operationOptions
    });
};

/**
 * __useRegistryProjectMemberQuery__
 *
 * To run a query within a React component, call `useRegistryProjectMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectMemberQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      memberID: // value for 'memberID'
 *   },
 * });
 */
export function useRegistryProjectMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables> & ({ variables: RegistryProjectMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>(RegistryProjectMemberDocument, options);
      }
export function useRegistryProjectMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>(RegistryProjectMemberDocument, options);
        }
// @ts-ignore
export function useRegistryProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>;
export function useRegistryProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectMemberQuery | undefined, RegistryProjectMemberQueryVariables>;
export function useRegistryProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>(RegistryProjectMemberDocument, options);
        }
export type RegistryProjectMemberQueryHookResult = ReturnType<typeof useRegistryProjectMemberQuery>;
export type RegistryProjectMemberLazyQueryHookResult = ReturnType<typeof useRegistryProjectMemberLazyQuery>;
export type RegistryProjectMemberSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectMemberSuspenseQuery>;
export type RegistryProjectMemberQueryResult = ApolloReactCommon.QueryResult<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>;
export const BatchRegistryViewerMembershipDocument = gql`
    query BatchRegistryViewerMembership($entityName: String!, $viewerID: ID!, $projectIDs: [ID!]!) {
  projects(entityName: $entityName, projectIDs: $projectIDs) {
    edges {
      node {
        id
        member(id: $viewerID) {
          id
          name
        }
        teamMembers {
          team {
            id
            member(id: $viewerID) {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export type BatchRegistryViewerMembershipComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>, 'query'> & ({ variables: BatchRegistryViewerMembershipQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BatchRegistryViewerMembershipComponent = (props: BatchRegistryViewerMembershipComponentProps) => (
      <ApolloReactComponents.Query<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables> query={BatchRegistryViewerMembershipDocument} {...props} />
    );
    
export type BatchRegistryViewerMembershipProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>
    } & TChildProps;
export function withBatchRegistryViewerMembership<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BatchRegistryViewerMembershipQuery,
  BatchRegistryViewerMembershipQueryVariables,
  BatchRegistryViewerMembershipProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables, BatchRegistryViewerMembershipProps<TChildProps, TDataName>>(BatchRegistryViewerMembershipDocument, {
      alias: 'batchRegistryViewerMembership',
      ...operationOptions
    });
};

/**
 * __useBatchRegistryViewerMembershipQuery__
 *
 * To run a query within a React component, call `useBatchRegistryViewerMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchRegistryViewerMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchRegistryViewerMembershipQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      viewerID: // value for 'viewerID'
 *      projectIDs: // value for 'projectIDs'
 *   },
 * });
 */
export function useBatchRegistryViewerMembershipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables> & ({ variables: BatchRegistryViewerMembershipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>(BatchRegistryViewerMembershipDocument, options);
      }
export function useBatchRegistryViewerMembershipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>(BatchRegistryViewerMembershipDocument, options);
        }
// @ts-ignore
export function useBatchRegistryViewerMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>;
export function useBatchRegistryViewerMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BatchRegistryViewerMembershipQuery | undefined, BatchRegistryViewerMembershipQueryVariables>;
export function useBatchRegistryViewerMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>(BatchRegistryViewerMembershipDocument, options);
        }
export type BatchRegistryViewerMembershipQueryHookResult = ReturnType<typeof useBatchRegistryViewerMembershipQuery>;
export type BatchRegistryViewerMembershipLazyQueryHookResult = ReturnType<typeof useBatchRegistryViewerMembershipLazyQuery>;
export type BatchRegistryViewerMembershipSuspenseQueryHookResult = ReturnType<typeof useBatchRegistryViewerMembershipSuspenseQuery>;
export type BatchRegistryViewerMembershipQueryResult = ApolloReactCommon.QueryResult<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>;
export const FetchRegistryProjectsPartialDocument = gql`
    query FetchRegistryProjectsPartial($orgName: String!, $pattern: String, $after: String, $filters: JSONString, $limit: Int) {
  organization(name: $orgName) {
    id
    registries(pattern: $pattern, filters: $filters, after: $after, first: $limit) {
      ...RegistryProjectsSearchFragment
    }
  }
}
    ${RegistryProjectsSearchFragmentFragmentDoc}`;
export type FetchRegistryProjectsPartialComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>, 'query'> & ({ variables: FetchRegistryProjectsPartialQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRegistryProjectsPartialComponent = (props: FetchRegistryProjectsPartialComponentProps) => (
      <ApolloReactComponents.Query<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables> query={FetchRegistryProjectsPartialDocument} {...props} />
    );
    
export type FetchRegistryProjectsPartialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>
    } & TChildProps;
export function withFetchRegistryProjectsPartial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRegistryProjectsPartialQuery,
  FetchRegistryProjectsPartialQueryVariables,
  FetchRegistryProjectsPartialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables, FetchRegistryProjectsPartialProps<TChildProps, TDataName>>(FetchRegistryProjectsPartialDocument, {
      alias: 'fetchRegistryProjectsPartial',
      ...operationOptions
    });
};

/**
 * __useFetchRegistryProjectsPartialQuery__
 *
 * To run a query within a React component, call `useFetchRegistryProjectsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRegistryProjectsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRegistryProjectsPartialQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      pattern: // value for 'pattern'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchRegistryProjectsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables> & ({ variables: FetchRegistryProjectsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>(FetchRegistryProjectsPartialDocument, options);
      }
export function useFetchRegistryProjectsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>(FetchRegistryProjectsPartialDocument, options);
        }
// @ts-ignore
export function useFetchRegistryProjectsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>;
export function useFetchRegistryProjectsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRegistryProjectsPartialQuery | undefined, FetchRegistryProjectsPartialQueryVariables>;
export function useFetchRegistryProjectsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>(FetchRegistryProjectsPartialDocument, options);
        }
export type FetchRegistryProjectsPartialQueryHookResult = ReturnType<typeof useFetchRegistryProjectsPartialQuery>;
export type FetchRegistryProjectsPartialLazyQueryHookResult = ReturnType<typeof useFetchRegistryProjectsPartialLazyQuery>;
export type FetchRegistryProjectsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchRegistryProjectsPartialSuspenseQuery>;
export type FetchRegistryProjectsPartialQueryResult = ApolloReactCommon.QueryResult<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>;
export const LegacyRegistryProjectsDocument = gql`
    query LegacyRegistryProjects($entityName: String!) {
  projects(pattern: "", entityName: $entityName) {
    edges {
      node {
        id
        ...ProjectFragment
      }
    }
  }
}
    ${ProjectFragmentFragmentDoc}`;
export type LegacyRegistryProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>, 'query'> & ({ variables: LegacyRegistryProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LegacyRegistryProjectsComponent = (props: LegacyRegistryProjectsComponentProps) => (
      <ApolloReactComponents.Query<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables> query={LegacyRegistryProjectsDocument} {...props} />
    );
    
export type LegacyRegistryProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>
    } & TChildProps;
export function withLegacyRegistryProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LegacyRegistryProjectsQuery,
  LegacyRegistryProjectsQueryVariables,
  LegacyRegistryProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables, LegacyRegistryProjectsProps<TChildProps, TDataName>>(LegacyRegistryProjectsDocument, {
      alias: 'legacyRegistryProjects',
      ...operationOptions
    });
};

/**
 * __useLegacyRegistryProjectsQuery__
 *
 * To run a query within a React component, call `useLegacyRegistryProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyRegistryProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyRegistryProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useLegacyRegistryProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables> & ({ variables: LegacyRegistryProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>(LegacyRegistryProjectsDocument, options);
      }
export function useLegacyRegistryProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>(LegacyRegistryProjectsDocument, options);
        }
// @ts-ignore
export function useLegacyRegistryProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>;
export function useLegacyRegistryProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LegacyRegistryProjectsQuery | undefined, LegacyRegistryProjectsQueryVariables>;
export function useLegacyRegistryProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>(LegacyRegistryProjectsDocument, options);
        }
export type LegacyRegistryProjectsQueryHookResult = ReturnType<typeof useLegacyRegistryProjectsQuery>;
export type LegacyRegistryProjectsLazyQueryHookResult = ReturnType<typeof useLegacyRegistryProjectsLazyQuery>;
export type LegacyRegistryProjectsSuspenseQueryHookResult = ReturnType<typeof useLegacyRegistryProjectsSuspenseQuery>;
export type LegacyRegistryProjectsQueryResult = ApolloReactCommon.QueryResult<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>;
export const RegistryProjectsWithTypeDocument = gql`
    query RegistryProjectsWithType($orgName: String!, $artifactTypeName: String!) {
  organization(name: $orgName) {
    id
    registries(pattern: "wandb-registry-") {
      edges {
        node {
          id
          name
          artifactType(name: $artifactTypeName) {
            id
            name
          }
          allowAllArtifactTypesInRegistry
          entityName
        }
      }
    }
  }
}
    `;
export type RegistryProjectsWithTypeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>, 'query'> & ({ variables: RegistryProjectsWithTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistryProjectsWithTypeComponent = (props: RegistryProjectsWithTypeComponentProps) => (
      <ApolloReactComponents.Query<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables> query={RegistryProjectsWithTypeDocument} {...props} />
    );
    
export type RegistryProjectsWithTypeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>
    } & TChildProps;
export function withRegistryProjectsWithType<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegistryProjectsWithTypeQuery,
  RegistryProjectsWithTypeQueryVariables,
  RegistryProjectsWithTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables, RegistryProjectsWithTypeProps<TChildProps, TDataName>>(RegistryProjectsWithTypeDocument, {
      alias: 'registryProjectsWithType',
      ...operationOptions
    });
};

/**
 * __useRegistryProjectsWithTypeQuery__
 *
 * To run a query within a React component, call `useRegistryProjectsWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectsWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectsWithTypeQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *   },
 * });
 */
export function useRegistryProjectsWithTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables> & ({ variables: RegistryProjectsWithTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>(RegistryProjectsWithTypeDocument, options);
      }
export function useRegistryProjectsWithTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>(RegistryProjectsWithTypeDocument, options);
        }
// @ts-ignore
export function useRegistryProjectsWithTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>;
export function useRegistryProjectsWithTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectsWithTypeQuery | undefined, RegistryProjectsWithTypeQueryVariables>;
export function useRegistryProjectsWithTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>(RegistryProjectsWithTypeDocument, options);
        }
export type RegistryProjectsWithTypeQueryHookResult = ReturnType<typeof useRegistryProjectsWithTypeQuery>;
export type RegistryProjectsWithTypeLazyQueryHookResult = ReturnType<typeof useRegistryProjectsWithTypeLazyQuery>;
export type RegistryProjectsWithTypeSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectsWithTypeSuspenseQuery>;
export type RegistryProjectsWithTypeQueryResult = ApolloReactCommon.QueryResult<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>;
export const UpsertRegistryProjectDocument = gql`
    mutation upsertRegistryProject($description: String, $entityName: String, $id: String, $name: String, $access: String, $owner: ID, $allowAllArtifactTypesInRegistry: Boolean, $artifactTypes: [ArtifactTypeInput!], $icon: ProjectIconInput) {
  upsertModel(
    input: {description: $description, entityName: $entityName, id: $id, name: $name, access: $access, owner: $owner, allowAllArtifactTypesInRegistry: $allowAllArtifactTypesInRegistry, artifactTypes: $artifactTypes, icon: $icon}
  ) {
    project {
      id
      name
      entityName
      description
      access
      user {
        id
      }
      allowAllArtifactTypesInRegistry
      icon {
        name
        color
      }
    }
    inserted
  }
}
    `;
export type UpsertRegistryProjectMutationFn = ApolloReactCommon.MutationFunction<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>;
export type UpsertRegistryProjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>, 'mutation'>;

    export const UpsertRegistryProjectComponent = (props: UpsertRegistryProjectComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables> mutation={UpsertRegistryProjectDocument} {...props} />
    );
    
export type UpsertRegistryProjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>
    } & TChildProps;
export function withUpsertRegistryProject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertRegistryProjectMutation,
  UpsertRegistryProjectMutationVariables,
  UpsertRegistryProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables, UpsertRegistryProjectProps<TChildProps, TDataName>>(UpsertRegistryProjectDocument, {
      alias: 'upsertRegistryProject',
      ...operationOptions
    });
};

/**
 * __useUpsertRegistryProjectMutation__
 *
 * To run a mutation, you first call `useUpsertRegistryProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRegistryProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRegistryProjectMutation, { data, loading, error }] = useUpsertRegistryProjectMutation({
 *   variables: {
 *      description: // value for 'description'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      access: // value for 'access'
 *      owner: // value for 'owner'
 *      allowAllArtifactTypesInRegistry: // value for 'allowAllArtifactTypesInRegistry'
 *      artifactTypes: // value for 'artifactTypes'
 *      icon: // value for 'icon'
 *   },
 * });
 */
export function useUpsertRegistryProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>(UpsertRegistryProjectDocument, options);
      }
export type UpsertRegistryProjectMutationHookResult = ReturnType<typeof useUpsertRegistryProjectMutation>;
export type UpsertRegistryProjectMutationResult = ApolloReactCommon.MutationResult<UpsertRegistryProjectMutation>;
export type UpsertRegistryProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>;
export const RegistryProjectDocument = gql`
    query RegistryProject($orgName: String!, $projectName: String!) {
  organization(name: $orgName) {
    id
    orgEntity {
      id
      name
      project(name: $projectName) {
        id
        ...ProjectFragment
      }
    }
  }
}
    ${ProjectFragmentFragmentDoc}`;
export type RegistryProjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegistryProjectQuery, RegistryProjectQueryVariables>, 'query'> & ({ variables: RegistryProjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistryProjectComponent = (props: RegistryProjectComponentProps) => (
      <ApolloReactComponents.Query<RegistryProjectQuery, RegistryProjectQueryVariables> query={RegistryProjectDocument} {...props} />
    );
    
export type RegistryProjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegistryProjectQuery, RegistryProjectQueryVariables>
    } & TChildProps;
export function withRegistryProject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegistryProjectQuery,
  RegistryProjectQueryVariables,
  RegistryProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegistryProjectQuery, RegistryProjectQueryVariables, RegistryProjectProps<TChildProps, TDataName>>(RegistryProjectDocument, {
      alias: 'registryProject',
      ...operationOptions
    });
};

/**
 * __useRegistryProjectQuery__
 *
 * To run a query within a React component, call `useRegistryProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRegistryProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables> & ({ variables: RegistryProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectQuery, RegistryProjectQueryVariables>(RegistryProjectDocument, options);
      }
export function useRegistryProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectQuery, RegistryProjectQueryVariables>(RegistryProjectDocument, options);
        }
// @ts-ignore
export function useRegistryProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectQuery, RegistryProjectQueryVariables>;
export function useRegistryProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectQuery | undefined, RegistryProjectQueryVariables>;
export function useRegistryProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectQuery, RegistryProjectQueryVariables>(RegistryProjectDocument, options);
        }
export type RegistryProjectQueryHookResult = ReturnType<typeof useRegistryProjectQuery>;
export type RegistryProjectLazyQueryHookResult = ReturnType<typeof useRegistryProjectLazyQuery>;
export type RegistryProjectSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectSuspenseQuery>;
export type RegistryProjectQueryResult = ApolloReactCommon.QueryResult<RegistryProjectQuery, RegistryProjectQueryVariables>;
export const StarredRegistriesDocument = gql`
    query StarredRegistries($organizationId: ID) {
  viewer {
    id
    starredRegistries(first: 30, organizationID: $organizationId) {
      edges {
        node {
          id
          ...ProjectFragment
        }
      }
    }
  }
}
    ${ProjectFragmentFragmentDoc}`;
export type StarredRegistriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>, 'query'>;

    export const StarredRegistriesComponent = (props: StarredRegistriesComponentProps) => (
      <ApolloReactComponents.Query<StarredRegistriesQuery, StarredRegistriesQueryVariables> query={StarredRegistriesDocument} {...props} />
    );
    
export type StarredRegistriesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StarredRegistriesQuery, StarredRegistriesQueryVariables>
    } & TChildProps;
export function withStarredRegistries<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StarredRegistriesQuery,
  StarredRegistriesQueryVariables,
  StarredRegistriesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StarredRegistriesQuery, StarredRegistriesQueryVariables, StarredRegistriesProps<TChildProps, TDataName>>(StarredRegistriesDocument, {
      alias: 'starredRegistries',
      ...operationOptions
    });
};

/**
 * __useStarredRegistriesQuery__
 *
 * To run a query within a React component, call `useStarredRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStarredRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStarredRegistriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStarredRegistriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StarredRegistriesQuery, StarredRegistriesQueryVariables>(StarredRegistriesDocument, options);
      }
export function useStarredRegistriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StarredRegistriesQuery, StarredRegistriesQueryVariables>(StarredRegistriesDocument, options);
        }
// @ts-ignore
export function useStarredRegistriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StarredRegistriesQuery, StarredRegistriesQueryVariables>;
export function useStarredRegistriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StarredRegistriesQuery | undefined, StarredRegistriesQueryVariables>;
export function useStarredRegistriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StarredRegistriesQuery, StarredRegistriesQueryVariables>(StarredRegistriesDocument, options);
        }
export type StarredRegistriesQueryHookResult = ReturnType<typeof useStarredRegistriesQuery>;
export type StarredRegistriesLazyQueryHookResult = ReturnType<typeof useStarredRegistriesLazyQuery>;
export type StarredRegistriesSuspenseQueryHookResult = ReturnType<typeof useStarredRegistriesSuspenseQuery>;
export type StarredRegistriesQueryResult = ApolloReactCommon.QueryResult<StarredRegistriesQuery, StarredRegistriesQueryVariables>;
export const AddProjectProtectedAliasesDocument = gql`
    mutation AddProjectProtectedAliases($entityName: String!, $projectName: String!, $aliases: [String!]!) {
  addProjectProtectedAliases(
    input: {entityName: $entityName, projectName: $projectName, aliases: $aliases}
  ) {
    aliases
  }
}
    `;
export type AddProjectProtectedAliasesMutationFn = ApolloReactCommon.MutationFunction<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>;
export type AddProjectProtectedAliasesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>, 'mutation'>;

    export const AddProjectProtectedAliasesComponent = (props: AddProjectProtectedAliasesComponentProps) => (
      <ApolloReactComponents.Mutation<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables> mutation={AddProjectProtectedAliasesDocument} {...props} />
    );
    
export type AddProjectProtectedAliasesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>
    } & TChildProps;
export function withAddProjectProtectedAliases<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddProjectProtectedAliasesMutation,
  AddProjectProtectedAliasesMutationVariables,
  AddProjectProtectedAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables, AddProjectProtectedAliasesProps<TChildProps, TDataName>>(AddProjectProtectedAliasesDocument, {
      alias: 'addProjectProtectedAliases',
      ...operationOptions
    });
};

/**
 * __useAddProjectProtectedAliasesMutation__
 *
 * To run a mutation, you first call `useAddProjectProtectedAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectProtectedAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectProtectedAliasesMutation, { data, loading, error }] = useAddProjectProtectedAliasesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      aliases: // value for 'aliases'
 *   },
 * });
 */
export function useAddProjectProtectedAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>(AddProjectProtectedAliasesDocument, options);
      }
export type AddProjectProtectedAliasesMutationHookResult = ReturnType<typeof useAddProjectProtectedAliasesMutation>;
export type AddProjectProtectedAliasesMutationResult = ApolloReactCommon.MutationResult<AddProjectProtectedAliasesMutation>;
export type AddProjectProtectedAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>;
export const RemoveProjectProtectedAliasesDocument = gql`
    mutation RemoveProjectProtectedAliases($entityName: String!, $projectName: String!, $aliases: [String!]!) {
  removeProjectProtectedAliases(
    input: {entityName: $entityName, projectName: $projectName, aliases: $aliases}
  ) {
    aliases
  }
}
    `;
export type RemoveProjectProtectedAliasesMutationFn = ApolloReactCommon.MutationFunction<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>;
export type RemoveProjectProtectedAliasesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>, 'mutation'>;

    export const RemoveProjectProtectedAliasesComponent = (props: RemoveProjectProtectedAliasesComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables> mutation={RemoveProjectProtectedAliasesDocument} {...props} />
    );
    
export type RemoveProjectProtectedAliasesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>
    } & TChildProps;
export function withRemoveProjectProtectedAliases<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveProjectProtectedAliasesMutation,
  RemoveProjectProtectedAliasesMutationVariables,
  RemoveProjectProtectedAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables, RemoveProjectProtectedAliasesProps<TChildProps, TDataName>>(RemoveProjectProtectedAliasesDocument, {
      alias: 'removeProjectProtectedAliases',
      ...operationOptions
    });
};

/**
 * __useRemoveProjectProtectedAliasesMutation__
 *
 * To run a mutation, you first call `useRemoveProjectProtectedAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectProtectedAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectProtectedAliasesMutation, { data, loading, error }] = useRemoveProjectProtectedAliasesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      aliases: // value for 'aliases'
 *   },
 * });
 */
export function useRemoveProjectProtectedAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>(RemoveProjectProtectedAliasesDocument, options);
      }
export type RemoveProjectProtectedAliasesMutationHookResult = ReturnType<typeof useRemoveProjectProtectedAliasesMutation>;
export type RemoveProjectProtectedAliasesMutationResult = ApolloReactCommon.MutationResult<RemoveProjectProtectedAliasesMutation>;
export type RemoveProjectProtectedAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>;
export const ProjectProtectedAliasesDocument = gql`
    query ProjectProtectedAliases($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    protectedArtifactAliases {
      alias
    }
  }
}
    `;
export type ProjectProtectedAliasesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>, 'query'> & ({ variables: ProjectProtectedAliasesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectProtectedAliasesComponent = (props: ProjectProtectedAliasesComponentProps) => (
      <ApolloReactComponents.Query<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables> query={ProjectProtectedAliasesDocument} {...props} />
    );
    
export type ProjectProtectedAliasesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>
    } & TChildProps;
export function withProjectProtectedAliases<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectProtectedAliasesQuery,
  ProjectProtectedAliasesQueryVariables,
  ProjectProtectedAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables, ProjectProtectedAliasesProps<TChildProps, TDataName>>(ProjectProtectedAliasesDocument, {
      alias: 'projectProtectedAliases',
      ...operationOptions
    });
};

/**
 * __useProjectProtectedAliasesQuery__
 *
 * To run a query within a React component, call `useProjectProtectedAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProtectedAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectProtectedAliasesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectProtectedAliasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables> & ({ variables: ProjectProtectedAliasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>(ProjectProtectedAliasesDocument, options);
      }
export function useProjectProtectedAliasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>(ProjectProtectedAliasesDocument, options);
        }
// @ts-ignore
export function useProjectProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>;
export function useProjectProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectProtectedAliasesQuery | undefined, ProjectProtectedAliasesQueryVariables>;
export function useProjectProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>(ProjectProtectedAliasesDocument, options);
        }
export type ProjectProtectedAliasesQueryHookResult = ReturnType<typeof useProjectProtectedAliasesQuery>;
export type ProjectProtectedAliasesLazyQueryHookResult = ReturnType<typeof useProjectProtectedAliasesLazyQuery>;
export type ProjectProtectedAliasesSuspenseQueryHookResult = ReturnType<typeof useProjectProtectedAliasesSuspenseQuery>;
export type ProjectProtectedAliasesQueryResult = ApolloReactCommon.QueryResult<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>;
export const ArtifactMembershipsWithAliasCountDocument = gql`
    query ArtifactMembershipsWithAliasCount($entityName: String!, $projectName: String!, $alias: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactMembershipsWithAliasCount(alias: $alias)
  }
}
    `;
export type ArtifactMembershipsWithAliasCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>, 'query'> & ({ variables: ArtifactMembershipsWithAliasCountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactMembershipsWithAliasCountComponent = (props: ArtifactMembershipsWithAliasCountComponentProps) => (
      <ApolloReactComponents.Query<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables> query={ArtifactMembershipsWithAliasCountDocument} {...props} />
    );
    
export type ArtifactMembershipsWithAliasCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>
    } & TChildProps;
export function withArtifactMembershipsWithAliasCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactMembershipsWithAliasCountQuery,
  ArtifactMembershipsWithAliasCountQueryVariables,
  ArtifactMembershipsWithAliasCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables, ArtifactMembershipsWithAliasCountProps<TChildProps, TDataName>>(ArtifactMembershipsWithAliasCountDocument, {
      alias: 'artifactMembershipsWithAliasCount',
      ...operationOptions
    });
};

/**
 * __useArtifactMembershipsWithAliasCountQuery__
 *
 * To run a query within a React component, call `useArtifactMembershipsWithAliasCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactMembershipsWithAliasCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactMembershipsWithAliasCountQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useArtifactMembershipsWithAliasCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables> & ({ variables: ArtifactMembershipsWithAliasCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>(ArtifactMembershipsWithAliasCountDocument, options);
      }
export function useArtifactMembershipsWithAliasCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>(ArtifactMembershipsWithAliasCountDocument, options);
        }
// @ts-ignore
export function useArtifactMembershipsWithAliasCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>;
export function useArtifactMembershipsWithAliasCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipsWithAliasCountQuery | undefined, ArtifactMembershipsWithAliasCountQueryVariables>;
export function useArtifactMembershipsWithAliasCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>(ArtifactMembershipsWithAliasCountDocument, options);
        }
export type ArtifactMembershipsWithAliasCountQueryHookResult = ReturnType<typeof useArtifactMembershipsWithAliasCountQuery>;
export type ArtifactMembershipsWithAliasCountLazyQueryHookResult = ReturnType<typeof useArtifactMembershipsWithAliasCountLazyQuery>;
export type ArtifactMembershipsWithAliasCountSuspenseQueryHookResult = ReturnType<typeof useArtifactMembershipsWithAliasCountSuspenseQuery>;
export type ArtifactMembershipsWithAliasCountQueryResult = ApolloReactCommon.QueryResult<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>;
export const FetchRegistryArtifactCollectionsPartialDocument = gql`
    query FetchRegistryArtifactCollectionsPartial($entityName: String!, $projectName: String!, $searchTerm: String, $cursor: String, $limit: Int!, $artifactsLimit: Int) {
  project(entityName: $entityName, name: $projectName) {
    id
    artifactCollectionsSearch(
      searchTerm: $searchTerm
      cursor: $cursor
      limit: $limit
      artifactsLimit: $artifactsLimit
      collectionTypes: PORTFOLIO
    ) {
      ...registrySearchResultFragment
    }
  }
}
    ${RegistrySearchResultFragmentFragmentDoc}`;
export type FetchRegistryArtifactCollectionsPartialComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>, 'query'> & ({ variables: FetchRegistryArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRegistryArtifactCollectionsPartialComponent = (props: FetchRegistryArtifactCollectionsPartialComponentProps) => (
      <ApolloReactComponents.Query<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables> query={FetchRegistryArtifactCollectionsPartialDocument} {...props} />
    );
    
export type FetchRegistryArtifactCollectionsPartialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>
    } & TChildProps;
export function withFetchRegistryArtifactCollectionsPartial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRegistryArtifactCollectionsPartialQuery,
  FetchRegistryArtifactCollectionsPartialQueryVariables,
  FetchRegistryArtifactCollectionsPartialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables, FetchRegistryArtifactCollectionsPartialProps<TChildProps, TDataName>>(FetchRegistryArtifactCollectionsPartialDocument, {
      alias: 'fetchRegistryArtifactCollectionsPartial',
      ...operationOptions
    });
};

/**
 * __useFetchRegistryArtifactCollectionsPartialQuery__
 *
 * To run a query within a React component, call `useFetchRegistryArtifactCollectionsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRegistryArtifactCollectionsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRegistryArtifactCollectionsPartialQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      searchTerm: // value for 'searchTerm'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      artifactsLimit: // value for 'artifactsLimit'
 *   },
 * });
 */
export function useFetchRegistryArtifactCollectionsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables> & ({ variables: FetchRegistryArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>(FetchRegistryArtifactCollectionsPartialDocument, options);
      }
export function useFetchRegistryArtifactCollectionsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>(FetchRegistryArtifactCollectionsPartialDocument, options);
        }
// @ts-ignore
export function useFetchRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>;
export function useFetchRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRegistryArtifactCollectionsPartialQuery | undefined, FetchRegistryArtifactCollectionsPartialQueryVariables>;
export function useFetchRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>(FetchRegistryArtifactCollectionsPartialDocument, options);
        }
export type FetchRegistryArtifactCollectionsPartialQueryHookResult = ReturnType<typeof useFetchRegistryArtifactCollectionsPartialQuery>;
export type FetchRegistryArtifactCollectionsPartialLazyQueryHookResult = ReturnType<typeof useFetchRegistryArtifactCollectionsPartialLazyQuery>;
export type FetchRegistryArtifactCollectionsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchRegistryArtifactCollectionsPartialSuspenseQuery>;
export type FetchRegistryArtifactCollectionsPartialQueryResult = ApolloReactCommon.QueryResult<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>;
export const FetchEntityModelRegistryArtifactCollectionsPartialDocument = gql`
    query FetchEntityModelRegistryArtifactCollectionsPartial($entityName: String!, $searchTerm: String, $cursor: String, $limit: Int!, $artifactsLimit: Int) {
  entity(name: $entityName) {
    id
    name
    artifactCollectionsSearch(
      searchTerm: $searchTerm
      cursor: $cursor
      limit: $limit
      artifactsLimit: $artifactsLimit
      collectionTypes: PORTFOLIO
    ) {
      ...registrySearchResultFragment
    }
  }
}
    ${RegistrySearchResultFragmentFragmentDoc}`;
export type FetchEntityModelRegistryArtifactCollectionsPartialComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>, 'query'> & ({ variables: FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchEntityModelRegistryArtifactCollectionsPartialComponent = (props: FetchEntityModelRegistryArtifactCollectionsPartialComponentProps) => (
      <ApolloReactComponents.Query<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables> query={FetchEntityModelRegistryArtifactCollectionsPartialDocument} {...props} />
    );
    
export type FetchEntityModelRegistryArtifactCollectionsPartialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>
    } & TChildProps;
export function withFetchEntityModelRegistryArtifactCollectionsPartial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchEntityModelRegistryArtifactCollectionsPartialQuery,
  FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables,
  FetchEntityModelRegistryArtifactCollectionsPartialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables, FetchEntityModelRegistryArtifactCollectionsPartialProps<TChildProps, TDataName>>(FetchEntityModelRegistryArtifactCollectionsPartialDocument, {
      alias: 'fetchEntityModelRegistryArtifactCollectionsPartial',
      ...operationOptions
    });
};

/**
 * __useFetchEntityModelRegistryArtifactCollectionsPartialQuery__
 *
 * To run a query within a React component, call `useFetchEntityModelRegistryArtifactCollectionsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEntityModelRegistryArtifactCollectionsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEntityModelRegistryArtifactCollectionsPartialQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      searchTerm: // value for 'searchTerm'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      artifactsLimit: // value for 'artifactsLimit'
 *   },
 * });
 */
export function useFetchEntityModelRegistryArtifactCollectionsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables> & ({ variables: FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>(FetchEntityModelRegistryArtifactCollectionsPartialDocument, options);
      }
export function useFetchEntityModelRegistryArtifactCollectionsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>(FetchEntityModelRegistryArtifactCollectionsPartialDocument, options);
        }
// @ts-ignore
export function useFetchEntityModelRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>;
export function useFetchEntityModelRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityModelRegistryArtifactCollectionsPartialQuery | undefined, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>;
export function useFetchEntityModelRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>(FetchEntityModelRegistryArtifactCollectionsPartialDocument, options);
        }
export type FetchEntityModelRegistryArtifactCollectionsPartialQueryHookResult = ReturnType<typeof useFetchEntityModelRegistryArtifactCollectionsPartialQuery>;
export type FetchEntityModelRegistryArtifactCollectionsPartialLazyQueryHookResult = ReturnType<typeof useFetchEntityModelRegistryArtifactCollectionsPartialLazyQuery>;
export type FetchEntityModelRegistryArtifactCollectionsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchEntityModelRegistryArtifactCollectionsPartialSuspenseQuery>;
export type FetchEntityModelRegistryArtifactCollectionsPartialQueryResult = ApolloReactCommon.QueryResult<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>;
export const StarRegistryDocument = gql`
    mutation starRegistry($entityName: String!, $registryName: String!, $clientMutationId: String) {
  starRegistry(
    input: {entityName: $entityName, registryName: $registryName, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export type StarRegistryMutationFn = ApolloReactCommon.MutationFunction<StarRegistryMutation, StarRegistryMutationVariables>;
export type StarRegistryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StarRegistryMutation, StarRegistryMutationVariables>, 'mutation'>;

    export const StarRegistryComponent = (props: StarRegistryComponentProps) => (
      <ApolloReactComponents.Mutation<StarRegistryMutation, StarRegistryMutationVariables> mutation={StarRegistryDocument} {...props} />
    );
    
export type StarRegistryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<StarRegistryMutation, StarRegistryMutationVariables>
    } & TChildProps;
export function withStarRegistry<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StarRegistryMutation,
  StarRegistryMutationVariables,
  StarRegistryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, StarRegistryMutation, StarRegistryMutationVariables, StarRegistryProps<TChildProps, TDataName>>(StarRegistryDocument, {
      alias: 'starRegistry',
      ...operationOptions
    });
};

/**
 * __useStarRegistryMutation__
 *
 * To run a mutation, you first call `useStarRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starRegistryMutation, { data, loading, error }] = useStarRegistryMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      registryName: // value for 'registryName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useStarRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StarRegistryMutation, StarRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StarRegistryMutation, StarRegistryMutationVariables>(StarRegistryDocument, options);
      }
export type StarRegistryMutationHookResult = ReturnType<typeof useStarRegistryMutation>;
export type StarRegistryMutationResult = ApolloReactCommon.MutationResult<StarRegistryMutation>;
export type StarRegistryMutationOptions = ApolloReactCommon.BaseMutationOptions<StarRegistryMutation, StarRegistryMutationVariables>;
export const UnstarRegistryDocument = gql`
    mutation unstarRegistry($entityName: String!, $registryName: String!, $clientMutationId: String) {
  unstarRegistry(
    input: {entityName: $entityName, registryName: $registryName, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export type UnstarRegistryMutationFn = ApolloReactCommon.MutationFunction<UnstarRegistryMutation, UnstarRegistryMutationVariables>;
export type UnstarRegistryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnstarRegistryMutation, UnstarRegistryMutationVariables>, 'mutation'>;

    export const UnstarRegistryComponent = (props: UnstarRegistryComponentProps) => (
      <ApolloReactComponents.Mutation<UnstarRegistryMutation, UnstarRegistryMutationVariables> mutation={UnstarRegistryDocument} {...props} />
    );
    
export type UnstarRegistryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnstarRegistryMutation, UnstarRegistryMutationVariables>
    } & TChildProps;
export function withUnstarRegistry<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnstarRegistryMutation,
  UnstarRegistryMutationVariables,
  UnstarRegistryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnstarRegistryMutation, UnstarRegistryMutationVariables, UnstarRegistryProps<TChildProps, TDataName>>(UnstarRegistryDocument, {
      alias: 'unstarRegistry',
      ...operationOptions
    });
};

/**
 * __useUnstarRegistryMutation__
 *
 * To run a mutation, you first call `useUnstarRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarRegistryMutation, { data, loading, error }] = useUnstarRegistryMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      registryName: // value for 'registryName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUnstarRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnstarRegistryMutation, UnstarRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnstarRegistryMutation, UnstarRegistryMutationVariables>(UnstarRegistryDocument, options);
      }
export type UnstarRegistryMutationHookResult = ReturnType<typeof useUnstarRegistryMutation>;
export type UnstarRegistryMutationResult = ApolloReactCommon.MutationResult<UnstarRegistryMutation>;
export type UnstarRegistryMutationOptions = ApolloReactCommon.BaseMutationOptions<UnstarRegistryMutation, UnstarRegistryMutationVariables>;
export const LinkArtifactDocument = gql`
    mutation LinkArtifact($artifactID: ID, $artifactPortfolioID: ID, $aliases: [ArtifactAliasInput!]) {
  linkArtifact(
    input: {artifactID: $artifactID, artifactPortfolioID: $artifactPortfolioID, aliases: $aliases}
  ) {
    artifactCollectionID
    artifactID
    createdAt
    versionIndex
    clientMutationId
  }
}
    `;
export type LinkArtifactMutationFn = ApolloReactCommon.MutationFunction<LinkArtifactMutation, LinkArtifactMutationVariables>;
export type LinkArtifactComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LinkArtifactMutation, LinkArtifactMutationVariables>, 'mutation'>;

    export const LinkArtifactComponent = (props: LinkArtifactComponentProps) => (
      <ApolloReactComponents.Mutation<LinkArtifactMutation, LinkArtifactMutationVariables> mutation={LinkArtifactDocument} {...props} />
    );
    
export type LinkArtifactProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<LinkArtifactMutation, LinkArtifactMutationVariables>
    } & TChildProps;
export function withLinkArtifact<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LinkArtifactMutation,
  LinkArtifactMutationVariables,
  LinkArtifactProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LinkArtifactMutation, LinkArtifactMutationVariables, LinkArtifactProps<TChildProps, TDataName>>(LinkArtifactDocument, {
      alias: 'linkArtifact',
      ...operationOptions
    });
};

/**
 * __useLinkArtifactMutation__
 *
 * To run a mutation, you first call `useLinkArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkArtifactMutation, { data, loading, error }] = useLinkArtifactMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *      aliases: // value for 'aliases'
 *   },
 * });
 */
export function useLinkArtifactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkArtifactMutation, LinkArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkArtifactMutation, LinkArtifactMutationVariables>(LinkArtifactDocument, options);
      }
export type LinkArtifactMutationHookResult = ReturnType<typeof useLinkArtifactMutation>;
export type LinkArtifactMutationResult = ApolloReactCommon.MutationResult<LinkArtifactMutation>;
export type LinkArtifactMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkArtifactMutation, LinkArtifactMutationVariables>;
export const CreateAndLinkWeaveAssetDocument = gql`
    mutation CreateAndLinkWeaveAsset($ref: String!, $entityName: String, $projectName: String, $artifactPortfolioID: ID, $artifactPortfolioName: String, $aliases: [ArtifactAliasInput!]) {
  createAndLinkWeaveAsset(
    input: {ref: $ref, entityName: $entityName, projectName: $projectName, artifactPortfolioID: $artifactPortfolioID, artifactPortfolioName: $artifactPortfolioName, aliases: $aliases}
  ) {
    artifactCollectionID
    artifactID
    createdAt
    versionIndex
    clientMutationId
  }
}
    `;
export type CreateAndLinkWeaveAssetMutationFn = ApolloReactCommon.MutationFunction<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>;
export type CreateAndLinkWeaveAssetComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>, 'mutation'>;

    export const CreateAndLinkWeaveAssetComponent = (props: CreateAndLinkWeaveAssetComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables> mutation={CreateAndLinkWeaveAssetDocument} {...props} />
    );
    
export type CreateAndLinkWeaveAssetProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>
    } & TChildProps;
export function withCreateAndLinkWeaveAsset<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAndLinkWeaveAssetMutation,
  CreateAndLinkWeaveAssetMutationVariables,
  CreateAndLinkWeaveAssetProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables, CreateAndLinkWeaveAssetProps<TChildProps, TDataName>>(CreateAndLinkWeaveAssetDocument, {
      alias: 'createAndLinkWeaveAsset',
      ...operationOptions
    });
};

/**
 * __useCreateAndLinkWeaveAssetMutation__
 *
 * To run a mutation, you first call `useCreateAndLinkWeaveAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndLinkWeaveAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndLinkWeaveAssetMutation, { data, loading, error }] = useCreateAndLinkWeaveAssetMutation({
 *   variables: {
 *      ref: // value for 'ref'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *      artifactPortfolioName: // value for 'artifactPortfolioName'
 *      aliases: // value for 'aliases'
 *   },
 * });
 */
export function useCreateAndLinkWeaveAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>(CreateAndLinkWeaveAssetDocument, options);
      }
export type CreateAndLinkWeaveAssetMutationHookResult = ReturnType<typeof useCreateAndLinkWeaveAssetMutation>;
export type CreateAndLinkWeaveAssetMutationResult = ApolloReactCommon.MutationResult<CreateAndLinkWeaveAssetMutation>;
export type CreateAndLinkWeaveAssetMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>;
export const ImportPanelMenuProjectsDocument = gql`
    query ImportPanelMenuProjects($userName: String!, $selectedEntityName: String, $projectSearchQuery: String) {
  entity(name: $selectedEntityName) {
    id
    ...ImportPanelMenuEntityFragment
  }
  user(userName: $userName) {
    id
    teams {
      edges {
        node {
          id
          ...ImportPanelMenuEntityFragment
        }
      }
    }
  }
}
    ${ImportPanelMenuEntityFragmentFragmentDoc}`;
export type ImportPanelMenuProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>, 'query'> & ({ variables: ImportPanelMenuProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ImportPanelMenuProjectsComponent = (props: ImportPanelMenuProjectsComponentProps) => (
      <ApolloReactComponents.Query<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables> query={ImportPanelMenuProjectsDocument} {...props} />
    );
    
export type ImportPanelMenuProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>
    } & TChildProps;
export function withImportPanelMenuProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ImportPanelMenuProjectsQuery,
  ImportPanelMenuProjectsQueryVariables,
  ImportPanelMenuProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables, ImportPanelMenuProjectsProps<TChildProps, TDataName>>(ImportPanelMenuProjectsDocument, {
      alias: 'importPanelMenuProjects',
      ...operationOptions
    });
};

/**
 * __useImportPanelMenuProjectsQuery__
 *
 * To run a query within a React component, call `useImportPanelMenuProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPanelMenuProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPanelMenuProjectsQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      selectedEntityName: // value for 'selectedEntityName'
 *      projectSearchQuery: // value for 'projectSearchQuery'
 *   },
 * });
 */
export function useImportPanelMenuProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables> & ({ variables: ImportPanelMenuProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>(ImportPanelMenuProjectsDocument, options);
      }
export function useImportPanelMenuProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>(ImportPanelMenuProjectsDocument, options);
        }
// @ts-ignore
export function useImportPanelMenuProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>;
export function useImportPanelMenuProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuProjectsQuery | undefined, ImportPanelMenuProjectsQueryVariables>;
export function useImportPanelMenuProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>(ImportPanelMenuProjectsDocument, options);
        }
export type ImportPanelMenuProjectsQueryHookResult = ReturnType<typeof useImportPanelMenuProjectsQuery>;
export type ImportPanelMenuProjectsLazyQueryHookResult = ReturnType<typeof useImportPanelMenuProjectsLazyQuery>;
export type ImportPanelMenuProjectsSuspenseQueryHookResult = ReturnType<typeof useImportPanelMenuProjectsSuspenseQuery>;
export type ImportPanelMenuProjectsQueryResult = ApolloReactCommon.QueryResult<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>;
export const ImportPanelMenuViewsDocument = gql`
    query ImportPanelMenuViews($entityName: String, $projectName: String, $userName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    allViews(viewType: "project-view", userName: $userName) {
      edges {
        node {
          id
          ...ImportPanelProjectViewsFragment
        }
      }
    }
  }
}
    ${ImportPanelProjectViewsFragmentFragmentDoc}`;
export type ImportPanelMenuViewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>, 'query'>;

    export const ImportPanelMenuViewsComponent = (props: ImportPanelMenuViewsComponentProps) => (
      <ApolloReactComponents.Query<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables> query={ImportPanelMenuViewsDocument} {...props} />
    );
    
export type ImportPanelMenuViewsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>
    } & TChildProps;
export function withImportPanelMenuViews<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ImportPanelMenuViewsQuery,
  ImportPanelMenuViewsQueryVariables,
  ImportPanelMenuViewsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables, ImportPanelMenuViewsProps<TChildProps, TDataName>>(ImportPanelMenuViewsDocument, {
      alias: 'importPanelMenuViews',
      ...operationOptions
    });
};

/**
 * __useImportPanelMenuViewsQuery__
 *
 * To run a query within a React component, call `useImportPanelMenuViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPanelMenuViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPanelMenuViewsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useImportPanelMenuViewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>(ImportPanelMenuViewsDocument, options);
      }
export function useImportPanelMenuViewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>(ImportPanelMenuViewsDocument, options);
        }
// @ts-ignore
export function useImportPanelMenuViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>;
export function useImportPanelMenuViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuViewsQuery | undefined, ImportPanelMenuViewsQueryVariables>;
export function useImportPanelMenuViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>(ImportPanelMenuViewsDocument, options);
        }
export type ImportPanelMenuViewsQueryHookResult = ReturnType<typeof useImportPanelMenuViewsQuery>;
export type ImportPanelMenuViewsLazyQueryHookResult = ReturnType<typeof useImportPanelMenuViewsLazyQuery>;
export type ImportPanelMenuViewsSuspenseQueryHookResult = ReturnType<typeof useImportPanelMenuViewsSuspenseQuery>;
export type ImportPanelMenuViewsQueryResult = ApolloReactCommon.QueryResult<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>;
export const ImportPanelMenuViewSpecDocument = gql`
    query ImportPanelMenuViewSpec($viewId: ID!) {
  view(id: $viewId) {
    id
    spec
  }
}
    `;
export type ImportPanelMenuViewSpecComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>, 'query'> & ({ variables: ImportPanelMenuViewSpecQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ImportPanelMenuViewSpecComponent = (props: ImportPanelMenuViewSpecComponentProps) => (
      <ApolloReactComponents.Query<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables> query={ImportPanelMenuViewSpecDocument} {...props} />
    );
    
export type ImportPanelMenuViewSpecProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>
    } & TChildProps;
export function withImportPanelMenuViewSpec<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ImportPanelMenuViewSpecQuery,
  ImportPanelMenuViewSpecQueryVariables,
  ImportPanelMenuViewSpecProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables, ImportPanelMenuViewSpecProps<TChildProps, TDataName>>(ImportPanelMenuViewSpecDocument, {
      alias: 'importPanelMenuViewSpec',
      ...operationOptions
    });
};

/**
 * __useImportPanelMenuViewSpecQuery__
 *
 * To run a query within a React component, call `useImportPanelMenuViewSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPanelMenuViewSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPanelMenuViewSpecQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useImportPanelMenuViewSpecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables> & ({ variables: ImportPanelMenuViewSpecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>(ImportPanelMenuViewSpecDocument, options);
      }
export function useImportPanelMenuViewSpecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>(ImportPanelMenuViewSpecDocument, options);
        }
// @ts-ignore
export function useImportPanelMenuViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>;
export function useImportPanelMenuViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuViewSpecQuery | undefined, ImportPanelMenuViewSpecQueryVariables>;
export function useImportPanelMenuViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>(ImportPanelMenuViewSpecDocument, options);
        }
export type ImportPanelMenuViewSpecQueryHookResult = ReturnType<typeof useImportPanelMenuViewSpecQuery>;
export type ImportPanelMenuViewSpecLazyQueryHookResult = ReturnType<typeof useImportPanelMenuViewSpecLazyQuery>;
export type ImportPanelMenuViewSpecSuspenseQueryHookResult = ReturnType<typeof useImportPanelMenuViewSpecSuspenseQuery>;
export type ImportPanelMenuViewSpecQueryResult = ApolloReactCommon.QueryResult<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>;
export const RunDetailsDocument = gql`
    query RunDetails($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    entityName
    name
    entity {
      id
      claimingEntity {
        id
        name
      }
    }
    access
    readOnly
    run(name: $runName) {
      id
      historyMaterializationTask {
        id
        state
        progress
        updatedAt
      }
      inputArtifacts {
        totalCount
      }
      outputArtifacts {
        totalCount
      }
      servicesAvailable {
        tensorboard
      }
      sweep {
        id
        name
      }
      group
      displayName
      name
      summaryMetrics
      config
      createdAt
    }
  }
}
    `;
export type RunDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunDetailsQuery, RunDetailsQueryVariables>, 'query'> & ({ variables: RunDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunDetailsComponent = (props: RunDetailsComponentProps) => (
      <ApolloReactComponents.Query<RunDetailsQuery, RunDetailsQueryVariables> query={RunDetailsDocument} {...props} />
    );
    
export type RunDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunDetailsQuery, RunDetailsQueryVariables>
    } & TChildProps;
export function withRunDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunDetailsQuery,
  RunDetailsQueryVariables,
  RunDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunDetailsQuery, RunDetailsQueryVariables, RunDetailsProps<TChildProps, TDataName>>(RunDetailsDocument, {
      alias: 'runDetails',
      ...operationOptions
    });
};

/**
 * __useRunDetailsQuery__
 *
 * To run a query within a React component, call `useRunDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunDetailsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables> & ({ variables: RunDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunDetailsQuery, RunDetailsQueryVariables>(RunDetailsDocument, options);
      }
export function useRunDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunDetailsQuery, RunDetailsQueryVariables>(RunDetailsDocument, options);
        }
// @ts-ignore
export function useRunDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunDetailsQuery, RunDetailsQueryVariables>;
export function useRunDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunDetailsQuery | undefined, RunDetailsQueryVariables>;
export function useRunDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunDetailsQuery, RunDetailsQueryVariables>(RunDetailsDocument, options);
        }
export type RunDetailsQueryHookResult = ReturnType<typeof useRunDetailsQuery>;
export type RunDetailsLazyQueryHookResult = ReturnType<typeof useRunDetailsLazyQuery>;
export type RunDetailsSuspenseQueryHookResult = ReturnType<typeof useRunDetailsSuspenseQuery>;
export type RunDetailsQueryResult = ApolloReactCommon.QueryResult<RunDetailsQuery, RunDetailsQueryVariables>;
export const RunsDetailsUserDocument = gql`
    query RunsDetailsUser($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    user {
      id
      username
      apiKey
      accountType
    }
  }
}
    `;
export type RunsDetailsUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>, 'query'> & ({ variables: RunsDetailsUserQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsDetailsUserComponent = (props: RunsDetailsUserComponentProps) => (
      <ApolloReactComponents.Query<RunsDetailsUserQuery, RunsDetailsUserQueryVariables> query={RunsDetailsUserDocument} {...props} />
    );
    
export type RunsDetailsUserProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>
    } & TChildProps;
export function withRunsDetailsUser<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsDetailsUserQuery,
  RunsDetailsUserQueryVariables,
  RunsDetailsUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsDetailsUserQuery, RunsDetailsUserQueryVariables, RunsDetailsUserProps<TChildProps, TDataName>>(RunsDetailsUserDocument, {
      alias: 'runsDetailsUser',
      ...operationOptions
    });
};

/**
 * __useRunsDetailsUserQuery__
 *
 * To run a query within a React component, call `useRunsDetailsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsDetailsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsDetailsUserQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRunsDetailsUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables> & ({ variables: RunsDetailsUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>(RunsDetailsUserDocument, options);
      }
export function useRunsDetailsUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>(RunsDetailsUserDocument, options);
        }
// @ts-ignore
export function useRunsDetailsUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>;
export function useRunsDetailsUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsDetailsUserQuery | undefined, RunsDetailsUserQueryVariables>;
export function useRunsDetailsUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>(RunsDetailsUserDocument, options);
        }
export type RunsDetailsUserQueryHookResult = ReturnType<typeof useRunsDetailsUserQuery>;
export type RunsDetailsUserLazyQueryHookResult = ReturnType<typeof useRunsDetailsUserLazyQuery>;
export type RunsDetailsUserSuspenseQueryHookResult = ReturnType<typeof useRunsDetailsUserSuspenseQuery>;
export type RunsDetailsUserQueryResult = ApolloReactCommon.QueryResult<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>;
export const RunPageLogsDocument = gql`
    query RunPageLogs($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      group
      sweep {
        id
      }
      state
      historyKeys(format: PLAINTEXT)
      createdAt
      logLineCount
      outputLogFile: files(first: 1, names: ["output.log"]) {
        edges {
          node {
            id
            sizeBytes
            url
          }
        }
      }
    }
  }
}
    `;
export type RunPageLogsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunPageLogsQuery, RunPageLogsQueryVariables>, 'query'> & ({ variables: RunPageLogsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunPageLogsComponent = (props: RunPageLogsComponentProps) => (
      <ApolloReactComponents.Query<RunPageLogsQuery, RunPageLogsQueryVariables> query={RunPageLogsDocument} {...props} />
    );
    
export type RunPageLogsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunPageLogsQuery, RunPageLogsQueryVariables>
    } & TChildProps;
export function withRunPageLogs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunPageLogsQuery,
  RunPageLogsQueryVariables,
  RunPageLogsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunPageLogsQuery, RunPageLogsQueryVariables, RunPageLogsProps<TChildProps, TDataName>>(RunPageLogsDocument, {
      alias: 'runPageLogs',
      ...operationOptions
    });
};

/**
 * __useRunPageLogsQuery__
 *
 * To run a query within a React component, call `useRunPageLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunPageLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunPageLogsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunPageLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables> & ({ variables: RunPageLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunPageLogsQuery, RunPageLogsQueryVariables>(RunPageLogsDocument, options);
      }
export function useRunPageLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunPageLogsQuery, RunPageLogsQueryVariables>(RunPageLogsDocument, options);
        }
// @ts-ignore
export function useRunPageLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunPageLogsQuery, RunPageLogsQueryVariables>;
export function useRunPageLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunPageLogsQuery | undefined, RunPageLogsQueryVariables>;
export function useRunPageLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunPageLogsQuery, RunPageLogsQueryVariables>(RunPageLogsDocument, options);
        }
export type RunPageLogsQueryHookResult = ReturnType<typeof useRunPageLogsQuery>;
export type RunPageLogsLazyQueryHookResult = ReturnType<typeof useRunPageLogsLazyQuery>;
export type RunPageLogsSuspenseQueryHookResult = ReturnType<typeof useRunPageLogsSuspenseQuery>;
export type RunPageLogsQueryResult = ApolloReactCommon.QueryResult<RunPageLogsQuery, RunPageLogsQueryVariables>;
export const AllRunGroupsDocument = gql`
    query AllRunGroups($projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(groupKeys: ["group"]) {
      edges {
        node {
          id
          name
          group
        }
      }
    }
  }
}
    `;
export type AllRunGroupsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>, 'query'> & ({ variables: AllRunGroupsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AllRunGroupsComponent = (props: AllRunGroupsComponentProps) => (
      <ApolloReactComponents.Query<AllRunGroupsQuery, AllRunGroupsQueryVariables> query={AllRunGroupsDocument} {...props} />
    );
    
export type AllRunGroupsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllRunGroupsQuery, AllRunGroupsQueryVariables>
    } & TChildProps;
export function withAllRunGroups<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllRunGroupsQuery,
  AllRunGroupsQueryVariables,
  AllRunGroupsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllRunGroupsQuery, AllRunGroupsQueryVariables, AllRunGroupsProps<TChildProps, TDataName>>(AllRunGroupsDocument, {
      alias: 'allRunGroups',
      ...operationOptions
    });
};

/**
 * __useAllRunGroupsQuery__
 *
 * To run a query within a React component, call `useAllRunGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRunGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRunGroupsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useAllRunGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables> & ({ variables: AllRunGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllRunGroupsQuery, AllRunGroupsQueryVariables>(AllRunGroupsDocument, options);
      }
export function useAllRunGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllRunGroupsQuery, AllRunGroupsQueryVariables>(AllRunGroupsDocument, options);
        }
// @ts-ignore
export function useAllRunGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllRunGroupsQuery, AllRunGroupsQueryVariables>;
export function useAllRunGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllRunGroupsQuery | undefined, AllRunGroupsQueryVariables>;
export function useAllRunGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllRunGroupsQuery, AllRunGroupsQueryVariables>(AllRunGroupsDocument, options);
        }
export type AllRunGroupsQueryHookResult = ReturnType<typeof useAllRunGroupsQuery>;
export type AllRunGroupsLazyQueryHookResult = ReturnType<typeof useAllRunGroupsLazyQuery>;
export type AllRunGroupsSuspenseQueryHookResult = ReturnType<typeof useAllRunGroupsSuspenseQuery>;
export type AllRunGroupsQueryResult = ApolloReactCommon.QueryResult<AllRunGroupsQuery, AllRunGroupsQueryVariables>;
export const GetRunsForMoveGroupsDocument = gql`
    query GetRunsForMoveGroups($projectName: String!, $entityName: String!, $filters: JSONString!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters) {
      edges {
        node {
          id
          user {
            id
            username
          }
          name
          displayName
          group
        }
      }
    }
  }
}
    `;
export type GetRunsForMoveGroupsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>, 'query'> & ({ variables: GetRunsForMoveGroupsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRunsForMoveGroupsComponent = (props: GetRunsForMoveGroupsComponentProps) => (
      <ApolloReactComponents.Query<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables> query={GetRunsForMoveGroupsDocument} {...props} />
    );
    
export type GetRunsForMoveGroupsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>
    } & TChildProps;
export function withGetRunsForMoveGroups<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRunsForMoveGroupsQuery,
  GetRunsForMoveGroupsQueryVariables,
  GetRunsForMoveGroupsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables, GetRunsForMoveGroupsProps<TChildProps, TDataName>>(GetRunsForMoveGroupsDocument, {
      alias: 'getRunsForMoveGroups',
      ...operationOptions
    });
};

/**
 * __useGetRunsForMoveGroupsQuery__
 *
 * To run a query within a React component, call `useGetRunsForMoveGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunsForMoveGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunsForMoveGroupsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetRunsForMoveGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables> & ({ variables: GetRunsForMoveGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>(GetRunsForMoveGroupsDocument, options);
      }
export function useGetRunsForMoveGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>(GetRunsForMoveGroupsDocument, options);
        }
// @ts-ignore
export function useGetRunsForMoveGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>;
export function useGetRunsForMoveGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRunsForMoveGroupsQuery | undefined, GetRunsForMoveGroupsQueryVariables>;
export function useGetRunsForMoveGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>(GetRunsForMoveGroupsDocument, options);
        }
export type GetRunsForMoveGroupsQueryHookResult = ReturnType<typeof useGetRunsForMoveGroupsQuery>;
export type GetRunsForMoveGroupsLazyQueryHookResult = ReturnType<typeof useGetRunsForMoveGroupsLazyQuery>;
export type GetRunsForMoveGroupsSuspenseQueryHookResult = ReturnType<typeof useGetRunsForMoveGroupsSuspenseQuery>;
export type GetRunsForMoveGroupsQueryResult = ApolloReactCommon.QueryResult<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>;
export const MoveRunToGroupDocument = gql`
    mutation MoveRunToGroup($entityName: String!, $groupName: String!, $projectName: String!, $runId: String!) {
  upsertBucket(
    input: {entityName: $entityName, groupName: $groupName, id: $runId, modelName: $projectName}
  ) {
    bucket {
      id
      group
    }
  }
}
    `;
export type MoveRunToGroupMutationFn = ApolloReactCommon.MutationFunction<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>;
export type MoveRunToGroupComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>, 'mutation'>;

    export const MoveRunToGroupComponent = (props: MoveRunToGroupComponentProps) => (
      <ApolloReactComponents.Mutation<MoveRunToGroupMutation, MoveRunToGroupMutationVariables> mutation={MoveRunToGroupDocument} {...props} />
    );
    
export type MoveRunToGroupProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>
    } & TChildProps;
export function withMoveRunToGroup<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MoveRunToGroupMutation,
  MoveRunToGroupMutationVariables,
  MoveRunToGroupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MoveRunToGroupMutation, MoveRunToGroupMutationVariables, MoveRunToGroupProps<TChildProps, TDataName>>(MoveRunToGroupDocument, {
      alias: 'moveRunToGroup',
      ...operationOptions
    });
};

/**
 * __useMoveRunToGroupMutation__
 *
 * To run a mutation, you first call `useMoveRunToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveRunToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveRunToGroupMutation, { data, loading, error }] = useMoveRunToGroupMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      groupName: // value for 'groupName'
 *      projectName: // value for 'projectName'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useMoveRunToGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>(MoveRunToGroupDocument, options);
      }
export type MoveRunToGroupMutationHookResult = ReturnType<typeof useMoveRunToGroupMutation>;
export type MoveRunToGroupMutationResult = ApolloReactCommon.MutationResult<MoveRunToGroupMutation>;
export type MoveRunToGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>;
export const RunValueSuggestionsPaginatedDocument = gql`
    query RunValueSuggestionsPaginated($projectName: String!, $entityName: String, $keyPath: String!, $filters: JSONString, $valuePattern: String, $before: String, $after: String, $first: Int, $last: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    runFieldValues(
      keyPath: $keyPath
      filters: $filters
      valuePattern: $valuePattern
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          value
        }
      }
    }
  }
}
    `;
export type RunValueSuggestionsPaginatedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>, 'query'> & ({ variables: RunValueSuggestionsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunValueSuggestionsPaginatedComponent = (props: RunValueSuggestionsPaginatedComponentProps) => (
      <ApolloReactComponents.Query<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables> query={RunValueSuggestionsPaginatedDocument} {...props} />
    );
    
export type RunValueSuggestionsPaginatedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>
    } & TChildProps;
export function withRunValueSuggestionsPaginated<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunValueSuggestionsPaginatedQuery,
  RunValueSuggestionsPaginatedQueryVariables,
  RunValueSuggestionsPaginatedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables, RunValueSuggestionsPaginatedProps<TChildProps, TDataName>>(RunValueSuggestionsPaginatedDocument, {
      alias: 'runValueSuggestionsPaginated',
      ...operationOptions
    });
};

/**
 * __useRunValueSuggestionsPaginatedQuery__
 *
 * To run a query within a React component, call `useRunValueSuggestionsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunValueSuggestionsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunValueSuggestionsPaginatedQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      keyPath: // value for 'keyPath'
 *      filters: // value for 'filters'
 *      valuePattern: // value for 'valuePattern'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useRunValueSuggestionsPaginatedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables> & ({ variables: RunValueSuggestionsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>(RunValueSuggestionsPaginatedDocument, options);
      }
export function useRunValueSuggestionsPaginatedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>(RunValueSuggestionsPaginatedDocument, options);
        }
// @ts-ignore
export function useRunValueSuggestionsPaginatedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>;
export function useRunValueSuggestionsPaginatedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunValueSuggestionsPaginatedQuery | undefined, RunValueSuggestionsPaginatedQueryVariables>;
export function useRunValueSuggestionsPaginatedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>(RunValueSuggestionsPaginatedDocument, options);
        }
export type RunValueSuggestionsPaginatedQueryHookResult = ReturnType<typeof useRunValueSuggestionsPaginatedQuery>;
export type RunValueSuggestionsPaginatedLazyQueryHookResult = ReturnType<typeof useRunValueSuggestionsPaginatedLazyQuery>;
export type RunValueSuggestionsPaginatedSuspenseQueryHookResult = ReturnType<typeof useRunValueSuggestionsPaginatedSuspenseQuery>;
export type RunValueSuggestionsPaginatedQueryResult = ApolloReactCommon.QueryResult<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>;
export const AccountSelectorContextProviderEntityDocument = gql`
    query AccountSelectorContextProviderEntity($teamName: String!) {
  entity(name: $teamName) {
    id
    isTeam
    organization {
      id
      name
    }
    members {
      id
    }
  }
}
    `;
export type AccountSelectorContextProviderEntityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>, 'query'> & ({ variables: AccountSelectorContextProviderEntityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountSelectorContextProviderEntityComponent = (props: AccountSelectorContextProviderEntityComponentProps) => (
      <ApolloReactComponents.Query<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables> query={AccountSelectorContextProviderEntityDocument} {...props} />
    );
    
export type AccountSelectorContextProviderEntityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>
    } & TChildProps;
export function withAccountSelectorContextProviderEntity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountSelectorContextProviderEntityQuery,
  AccountSelectorContextProviderEntityQueryVariables,
  AccountSelectorContextProviderEntityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables, AccountSelectorContextProviderEntityProps<TChildProps, TDataName>>(AccountSelectorContextProviderEntityDocument, {
      alias: 'accountSelectorContextProviderEntity',
      ...operationOptions
    });
};

/**
 * __useAccountSelectorContextProviderEntityQuery__
 *
 * To run a query within a React component, call `useAccountSelectorContextProviderEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSelectorContextProviderEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSelectorContextProviderEntityQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useAccountSelectorContextProviderEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables> & ({ variables: AccountSelectorContextProviderEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>(AccountSelectorContextProviderEntityDocument, options);
      }
export function useAccountSelectorContextProviderEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>(AccountSelectorContextProviderEntityDocument, options);
        }
// @ts-ignore
export function useAccountSelectorContextProviderEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>;
export function useAccountSelectorContextProviderEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSelectorContextProviderEntityQuery | undefined, AccountSelectorContextProviderEntityQueryVariables>;
export function useAccountSelectorContextProviderEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>(AccountSelectorContextProviderEntityDocument, options);
        }
export type AccountSelectorContextProviderEntityQueryHookResult = ReturnType<typeof useAccountSelectorContextProviderEntityQuery>;
export type AccountSelectorContextProviderEntityLazyQueryHookResult = ReturnType<typeof useAccountSelectorContextProviderEntityLazyQuery>;
export type AccountSelectorContextProviderEntitySuspenseQueryHookResult = ReturnType<typeof useAccountSelectorContextProviderEntitySuspenseQuery>;
export type AccountSelectorContextProviderEntityQueryResult = ApolloReactCommon.QueryResult<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>;
export const ProfileMenuOrgRoleInfoDocument = gql`
    query ProfileMenuOrgRoleInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    members {
      id
      role
      username
    }
  }
}
    `;
export type ProfileMenuOrgRoleInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>, 'query'> & ({ variables: ProfileMenuOrgRoleInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProfileMenuOrgRoleInfoComponent = (props: ProfileMenuOrgRoleInfoComponentProps) => (
      <ApolloReactComponents.Query<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables> query={ProfileMenuOrgRoleInfoDocument} {...props} />
    );
    
export type ProfileMenuOrgRoleInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>
    } & TChildProps;
export function withProfileMenuOrgRoleInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProfileMenuOrgRoleInfoQuery,
  ProfileMenuOrgRoleInfoQueryVariables,
  ProfileMenuOrgRoleInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables, ProfileMenuOrgRoleInfoProps<TChildProps, TDataName>>(ProfileMenuOrgRoleInfoDocument, {
      alias: 'profileMenuOrgRoleInfo',
      ...operationOptions
    });
};

/**
 * __useProfileMenuOrgRoleInfoQuery__
 *
 * To run a query within a React component, call `useProfileMenuOrgRoleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileMenuOrgRoleInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileMenuOrgRoleInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useProfileMenuOrgRoleInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables> & ({ variables: ProfileMenuOrgRoleInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>(ProfileMenuOrgRoleInfoDocument, options);
      }
export function useProfileMenuOrgRoleInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>(ProfileMenuOrgRoleInfoDocument, options);
        }
// @ts-ignore
export function useProfileMenuOrgRoleInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>;
export function useProfileMenuOrgRoleInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileMenuOrgRoleInfoQuery | undefined, ProfileMenuOrgRoleInfoQueryVariables>;
export function useProfileMenuOrgRoleInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>(ProfileMenuOrgRoleInfoDocument, options);
        }
export type ProfileMenuOrgRoleInfoQueryHookResult = ReturnType<typeof useProfileMenuOrgRoleInfoQuery>;
export type ProfileMenuOrgRoleInfoLazyQueryHookResult = ReturnType<typeof useProfileMenuOrgRoleInfoLazyQuery>;
export type ProfileMenuOrgRoleInfoSuspenseQueryHookResult = ReturnType<typeof useProfileMenuOrgRoleInfoSuspenseQuery>;
export type ProfileMenuOrgRoleInfoQueryResult = ApolloReactCommon.QueryResult<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>;
export const QuickAddMetricSearchDocument = gql`
    query QuickAddMetricSearch($projectName: String!, $entityName: String!, $filters: JSONString, $runLimit: Int = 100, $runOrder: String, $keysPageSize: Int = 100, $cursor: String, $metricNamePattern: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters, first: $runLimit, order: $runOrder) {
      metricSearch(
        pageSize: $keysPageSize
        cursor: $cursor
        metricNamePattern: $metricNamePattern
      ) {
        results {
          key
          types
          column
        }
        cursor
        hasMore
      }
    }
  }
}
    `;
export type QuickAddMetricSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>, 'query'> & ({ variables: QuickAddMetricSearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const QuickAddMetricSearchComponent = (props: QuickAddMetricSearchComponentProps) => (
      <ApolloReactComponents.Query<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables> query={QuickAddMetricSearchDocument} {...props} />
    );
    
export type QuickAddMetricSearchProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>
    } & TChildProps;
export function withQuickAddMetricSearch<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QuickAddMetricSearchQuery,
  QuickAddMetricSearchQueryVariables,
  QuickAddMetricSearchProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables, QuickAddMetricSearchProps<TChildProps, TDataName>>(QuickAddMetricSearchDocument, {
      alias: 'quickAddMetricSearch',
      ...operationOptions
    });
};

/**
 * __useQuickAddMetricSearchQuery__
 *
 * To run a query within a React component, call `useQuickAddMetricSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickAddMetricSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickAddMetricSearchQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      runLimit: // value for 'runLimit'
 *      runOrder: // value for 'runOrder'
 *      keysPageSize: // value for 'keysPageSize'
 *      cursor: // value for 'cursor'
 *      metricNamePattern: // value for 'metricNamePattern'
 *   },
 * });
 */
export function useQuickAddMetricSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables> & ({ variables: QuickAddMetricSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>(QuickAddMetricSearchDocument, options);
      }
export function useQuickAddMetricSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>(QuickAddMetricSearchDocument, options);
        }
// @ts-ignore
export function useQuickAddMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>;
export function useQuickAddMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QuickAddMetricSearchQuery | undefined, QuickAddMetricSearchQueryVariables>;
export function useQuickAddMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>(QuickAddMetricSearchDocument, options);
        }
export type QuickAddMetricSearchQueryHookResult = ReturnType<typeof useQuickAddMetricSearchQuery>;
export type QuickAddMetricSearchLazyQueryHookResult = ReturnType<typeof useQuickAddMetricSearchLazyQuery>;
export type QuickAddMetricSearchSuspenseQueryHookResult = ReturnType<typeof useQuickAddMetricSearchSuspenseQuery>;
export type QuickAddMetricSearchQueryResult = ApolloReactCommon.QueryResult<QuickAddMetricSearchQuery, QuickAddMetricSearchQueryVariables>;
export const ConfigValuesAggregationQueryDocument = gql`
    query ConfigValuesAggregationQuery($entityName: String!, $filters: JSONString!, $limit: Int!, $order: String!, $projectName: String!, $configKey: String!, $configType: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: $limit, order: $order, filters: $filters) {
      configValues(configKey: $configKey, configType: $configType)
      configValuesNumberAggregation(configKey: $configKey)
      __typename
    }
    __typename
  }
}
    `;
export type ConfigValuesAggregationQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>, 'query'> & ({ variables: ConfigValuesAggregationQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConfigValuesAggregationQueryComponent = (props: ConfigValuesAggregationQueryComponentProps) => (
      <ApolloReactComponents.Query<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables> query={ConfigValuesAggregationQueryDocument} {...props} />
    );
    
export type ConfigValuesAggregationQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>
    } & TChildProps;
export function withConfigValuesAggregationQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ConfigValuesAggregationQueryQuery,
  ConfigValuesAggregationQueryQueryVariables,
  ConfigValuesAggregationQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables, ConfigValuesAggregationQueryProps<TChildProps, TDataName>>(ConfigValuesAggregationQueryDocument, {
      alias: 'configValuesAggregationQuery',
      ...operationOptions
    });
};

/**
 * __useConfigValuesAggregationQueryQuery__
 *
 * To run a query within a React component, call `useConfigValuesAggregationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigValuesAggregationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigValuesAggregationQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      configKey: // value for 'configKey'
 *      configType: // value for 'configType'
 *   },
 * });
 */
export function useConfigValuesAggregationQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables> & ({ variables: ConfigValuesAggregationQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>(ConfigValuesAggregationQueryDocument, options);
      }
export function useConfigValuesAggregationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>(ConfigValuesAggregationQueryDocument, options);
        }
// @ts-ignore
export function useConfigValuesAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>;
export function useConfigValuesAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigValuesAggregationQueryQuery | undefined, ConfigValuesAggregationQueryQueryVariables>;
export function useConfigValuesAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>(ConfigValuesAggregationQueryDocument, options);
        }
export type ConfigValuesAggregationQueryQueryHookResult = ReturnType<typeof useConfigValuesAggregationQueryQuery>;
export type ConfigValuesAggregationQueryLazyQueryHookResult = ReturnType<typeof useConfigValuesAggregationQueryLazyQuery>;
export type ConfigValuesAggregationQuerySuspenseQueryHookResult = ReturnType<typeof useConfigValuesAggregationQuerySuspenseQuery>;
export type ConfigValuesAggregationQueryQueryResult = ApolloReactCommon.QueryResult<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>;
export const ConfigValuesCategoriesQueryDocument = gql`
    query ConfigValuesCategoriesQuery($entityName: String!, $filters: JSONString!, $limit: Int!, $order: String!, $projectName: String!, $configKey: String!, $configType: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: $limit, order: $order, filters: $filters) {
      configValues(configKey: $configKey, configType: $configType)
      configValuesCategories(configKey: $configKey, limit: $limit)
      __typename
    }
    __typename
  }
}
    `;
export type ConfigValuesCategoriesQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>, 'query'> & ({ variables: ConfigValuesCategoriesQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConfigValuesCategoriesQueryComponent = (props: ConfigValuesCategoriesQueryComponentProps) => (
      <ApolloReactComponents.Query<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables> query={ConfigValuesCategoriesQueryDocument} {...props} />
    );
    
export type ConfigValuesCategoriesQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>
    } & TChildProps;
export function withConfigValuesCategoriesQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ConfigValuesCategoriesQueryQuery,
  ConfigValuesCategoriesQueryQueryVariables,
  ConfigValuesCategoriesQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables, ConfigValuesCategoriesQueryProps<TChildProps, TDataName>>(ConfigValuesCategoriesQueryDocument, {
      alias: 'configValuesCategoriesQuery',
      ...operationOptions
    });
};

/**
 * __useConfigValuesCategoriesQueryQuery__
 *
 * To run a query within a React component, call `useConfigValuesCategoriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigValuesCategoriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigValuesCategoriesQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      configKey: // value for 'configKey'
 *      configType: // value for 'configType'
 *   },
 * });
 */
export function useConfigValuesCategoriesQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables> & ({ variables: ConfigValuesCategoriesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>(ConfigValuesCategoriesQueryDocument, options);
      }
export function useConfigValuesCategoriesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>(ConfigValuesCategoriesQueryDocument, options);
        }
// @ts-ignore
export function useConfigValuesCategoriesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>;
export function useConfigValuesCategoriesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigValuesCategoriesQueryQuery | undefined, ConfigValuesCategoriesQueryQueryVariables>;
export function useConfigValuesCategoriesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>(ConfigValuesCategoriesQueryDocument, options);
        }
export type ConfigValuesCategoriesQueryQueryHookResult = ReturnType<typeof useConfigValuesCategoriesQueryQuery>;
export type ConfigValuesCategoriesQueryLazyQueryHookResult = ReturnType<typeof useConfigValuesCategoriesQueryLazyQuery>;
export type ConfigValuesCategoriesQuerySuspenseQueryHookResult = ReturnType<typeof useConfigValuesCategoriesQuerySuspenseQuery>;
export type ConfigValuesCategoriesQueryQueryResult = ApolloReactCommon.QueryResult<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>;
export const MetricStatisticsAggregationQueryDocument = gql`
    query MetricStatisticsAggregationQuery($entityName: String!, $filters: JSONString!, $limit: Int!, $order: String!, $projectName: String!, $metricName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: $limit, order: $order, filters: $filters) {
      metricStatisticsAggregation(metricName: $metricName)
      __typename
    }
    __typename
  }
}
    `;
export type MetricStatisticsAggregationQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>, 'query'> & ({ variables: MetricStatisticsAggregationQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MetricStatisticsAggregationQueryComponent = (props: MetricStatisticsAggregationQueryComponentProps) => (
      <ApolloReactComponents.Query<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables> query={MetricStatisticsAggregationQueryDocument} {...props} />
    );
    
export type MetricStatisticsAggregationQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>
    } & TChildProps;
export function withMetricStatisticsAggregationQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MetricStatisticsAggregationQueryQuery,
  MetricStatisticsAggregationQueryQueryVariables,
  MetricStatisticsAggregationQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables, MetricStatisticsAggregationQueryProps<TChildProps, TDataName>>(MetricStatisticsAggregationQueryDocument, {
      alias: 'metricStatisticsAggregationQuery',
      ...operationOptions
    });
};

/**
 * __useMetricStatisticsAggregationQueryQuery__
 *
 * To run a query within a React component, call `useMetricStatisticsAggregationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricStatisticsAggregationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricStatisticsAggregationQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      metricName: // value for 'metricName'
 *   },
 * });
 */
export function useMetricStatisticsAggregationQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables> & ({ variables: MetricStatisticsAggregationQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>(MetricStatisticsAggregationQueryDocument, options);
      }
export function useMetricStatisticsAggregationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>(MetricStatisticsAggregationQueryDocument, options);
        }
// @ts-ignore
export function useMetricStatisticsAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>;
export function useMetricStatisticsAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricStatisticsAggregationQueryQuery | undefined, MetricStatisticsAggregationQueryQueryVariables>;
export function useMetricStatisticsAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>(MetricStatisticsAggregationQueryDocument, options);
        }
export type MetricStatisticsAggregationQueryQueryHookResult = ReturnType<typeof useMetricStatisticsAggregationQueryQuery>;
export type MetricStatisticsAggregationQueryLazyQueryHookResult = ReturnType<typeof useMetricStatisticsAggregationQueryLazyQuery>;
export type MetricStatisticsAggregationQuerySuspenseQueryHookResult = ReturnType<typeof useMetricStatisticsAggregationQuerySuspenseQuery>;
export type MetricStatisticsAggregationQueryQueryResult = ApolloReactCommon.QueryResult<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>;
export const MetricStatisticsQueryDocument = gql`
    query MetricStatisticsQuery($entityName: String!, $filters: JSONString!, $limit: Int!, $order: String!, $projectName: String!, $metricName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: $limit, order: $order, filters: $filters) {
      metricStatistics(metricName: $metricName)
      __typename
    }
    __typename
  }
}
    `;
export type MetricStatisticsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>, 'query'> & ({ variables: MetricStatisticsQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MetricStatisticsQueryComponent = (props: MetricStatisticsQueryComponentProps) => (
      <ApolloReactComponents.Query<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables> query={MetricStatisticsQueryDocument} {...props} />
    );
    
export type MetricStatisticsQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>
    } & TChildProps;
export function withMetricStatisticsQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MetricStatisticsQueryQuery,
  MetricStatisticsQueryQueryVariables,
  MetricStatisticsQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables, MetricStatisticsQueryProps<TChildProps, TDataName>>(MetricStatisticsQueryDocument, {
      alias: 'metricStatisticsQuery',
      ...operationOptions
    });
};

/**
 * __useMetricStatisticsQueryQuery__
 *
 * To run a query within a React component, call `useMetricStatisticsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricStatisticsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricStatisticsQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      metricName: // value for 'metricName'
 *   },
 * });
 */
export function useMetricStatisticsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables> & ({ variables: MetricStatisticsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>(MetricStatisticsQueryDocument, options);
      }
export function useMetricStatisticsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>(MetricStatisticsQueryDocument, options);
        }
// @ts-ignore
export function useMetricStatisticsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>;
export function useMetricStatisticsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricStatisticsQueryQuery | undefined, MetricStatisticsQueryQueryVariables>;
export function useMetricStatisticsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>(MetricStatisticsQueryDocument, options);
        }
export type MetricStatisticsQueryQueryHookResult = ReturnType<typeof useMetricStatisticsQueryQuery>;
export type MetricStatisticsQueryLazyQueryHookResult = ReturnType<typeof useMetricStatisticsQueryLazyQuery>;
export type MetricStatisticsQuerySuspenseQueryHookResult = ReturnType<typeof useMetricStatisticsQuerySuspenseQuery>;
export type MetricStatisticsQueryQueryResult = ApolloReactCommon.QueryResult<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>;
export const CreateSemanticLegendDocument = gql`
    mutation CreateSemanticLegend($id: ID!, $metricName: String!, $yValue: String!, $customColors: [String], $bucketUpperBounds: [Float!]!, $excludedRunColor: String!) {
  createSemanticLegend(
    input: {viewID: $id, metricName: $metricName, yValue: $yValue, customColors: $customColors, bucketUpperBounds: $bucketUpperBounds, excludedRunColor: $excludedRunColor}
  ) {
    success
  }
}
    `;
export type CreateSemanticLegendMutationFn = ApolloReactCommon.MutationFunction<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>;
export type CreateSemanticLegendComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>, 'mutation'>;

    export const CreateSemanticLegendComponent = (props: CreateSemanticLegendComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables> mutation={CreateSemanticLegendDocument} {...props} />
    );
    
export type CreateSemanticLegendProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>
    } & TChildProps;
export function withCreateSemanticLegend<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSemanticLegendMutation,
  CreateSemanticLegendMutationVariables,
  CreateSemanticLegendProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables, CreateSemanticLegendProps<TChildProps, TDataName>>(CreateSemanticLegendDocument, {
      alias: 'createSemanticLegend',
      ...operationOptions
    });
};

/**
 * __useCreateSemanticLegendMutation__
 *
 * To run a mutation, you first call `useCreateSemanticLegendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSemanticLegendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSemanticLegendMutation, { data, loading, error }] = useCreateSemanticLegendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metricName: // value for 'metricName'
 *      yValue: // value for 'yValue'
 *      customColors: // value for 'customColors'
 *      bucketUpperBounds: // value for 'bucketUpperBounds'
 *      excludedRunColor: // value for 'excludedRunColor'
 *   },
 * });
 */
export function useCreateSemanticLegendMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>(CreateSemanticLegendDocument, options);
      }
export type CreateSemanticLegendMutationHookResult = ReturnType<typeof useCreateSemanticLegendMutation>;
export type CreateSemanticLegendMutationResult = ApolloReactCommon.MutationResult<CreateSemanticLegendMutation>;
export type CreateSemanticLegendMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>;
export const UpdateSemanticLegendDocument = gql`
    mutation UpdateSemanticLegend($id: ID!, $currentMetric: String!, $metricName: String, $yValue: String, $customColors: [String], $bucketUpperBounds: [Float!], $excludedRunColor: String) {
  updateSemanticLegend(
    input: {viewID: $id, currentMetric: $currentMetric, metricName: $metricName, yValue: $yValue, customColors: $customColors, bucketUpperBounds: $bucketUpperBounds, excludedRunColor: $excludedRunColor}
  ) {
    success
  }
}
    `;
export type UpdateSemanticLegendMutationFn = ApolloReactCommon.MutationFunction<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>;
export type UpdateSemanticLegendComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>, 'mutation'>;

    export const UpdateSemanticLegendComponent = (props: UpdateSemanticLegendComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables> mutation={UpdateSemanticLegendDocument} {...props} />
    );
    
export type UpdateSemanticLegendProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>
    } & TChildProps;
export function withUpdateSemanticLegend<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSemanticLegendMutation,
  UpdateSemanticLegendMutationVariables,
  UpdateSemanticLegendProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables, UpdateSemanticLegendProps<TChildProps, TDataName>>(UpdateSemanticLegendDocument, {
      alias: 'updateSemanticLegend',
      ...operationOptions
    });
};

/**
 * __useUpdateSemanticLegendMutation__
 *
 * To run a mutation, you first call `useUpdateSemanticLegendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSemanticLegendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSemanticLegendMutation, { data, loading, error }] = useUpdateSemanticLegendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentMetric: // value for 'currentMetric'
 *      metricName: // value for 'metricName'
 *      yValue: // value for 'yValue'
 *      customColors: // value for 'customColors'
 *      bucketUpperBounds: // value for 'bucketUpperBounds'
 *      excludedRunColor: // value for 'excludedRunColor'
 *   },
 * });
 */
export function useUpdateSemanticLegendMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>(UpdateSemanticLegendDocument, options);
      }
export type UpdateSemanticLegendMutationHookResult = ReturnType<typeof useUpdateSemanticLegendMutation>;
export type UpdateSemanticLegendMutationResult = ApolloReactCommon.MutationResult<UpdateSemanticLegendMutation>;
export type UpdateSemanticLegendMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>;
export const SemanticLegendsQueryDocument = gql`
    query SemanticLegendsQuery($id: ID!) {
  view(id: $id) {
    id
    semanticLegend {
      currentMetric
      semanticLegendsByMetric {
        metricName
        yValue
        customColors {
          bucketNumber
          colorHex
        }
        bucketUpperBounds
        excludedRunColor
        lastUpdatedAt
      }
    }
  }
}
    `;
export type SemanticLegendsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>, 'query'> & ({ variables: SemanticLegendsQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SemanticLegendsQueryComponent = (props: SemanticLegendsQueryComponentProps) => (
      <ApolloReactComponents.Query<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables> query={SemanticLegendsQueryDocument} {...props} />
    );
    
export type SemanticLegendsQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>
    } & TChildProps;
export function withSemanticLegendsQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SemanticLegendsQueryQuery,
  SemanticLegendsQueryQueryVariables,
  SemanticLegendsQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables, SemanticLegendsQueryProps<TChildProps, TDataName>>(SemanticLegendsQueryDocument, {
      alias: 'semanticLegendsQuery',
      ...operationOptions
    });
};

/**
 * __useSemanticLegendsQueryQuery__
 *
 * To run a query within a React component, call `useSemanticLegendsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSemanticLegendsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSemanticLegendsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSemanticLegendsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables> & ({ variables: SemanticLegendsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>(SemanticLegendsQueryDocument, options);
      }
export function useSemanticLegendsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>(SemanticLegendsQueryDocument, options);
        }
// @ts-ignore
export function useSemanticLegendsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>;
export function useSemanticLegendsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SemanticLegendsQueryQuery | undefined, SemanticLegendsQueryQueryVariables>;
export function useSemanticLegendsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>(SemanticLegendsQueryDocument, options);
        }
export type SemanticLegendsQueryQueryHookResult = ReturnType<typeof useSemanticLegendsQueryQuery>;
export type SemanticLegendsQueryLazyQueryHookResult = ReturnType<typeof useSemanticLegendsQueryLazyQuery>;
export type SemanticLegendsQuerySuspenseQueryHookResult = ReturnType<typeof useSemanticLegendsQuerySuspenseQuery>;
export type SemanticLegendsQueryQueryResult = ApolloReactCommon.QueryResult<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>;
export const CreateSemanticLegendWithCategoricalConfigDocument = gql`
    mutation CreateSemanticLegendWithCategoricalConfig($id: ID!, $metricName: String!, $yValue: String!, $customColors: [String], $bucketUpperBounds: [Float!]!, $excludedRunColor: String!, $categories: [String]) {
  createSemanticLegend(
    input: {viewID: $id, metricName: $metricName, yValue: $yValue, customColors: $customColors, bucketUpperBounds: $bucketUpperBounds, excludedRunColor: $excludedRunColor, categories: $categories}
  ) {
    success
  }
}
    `;
export type CreateSemanticLegendWithCategoricalConfigMutationFn = ApolloReactCommon.MutationFunction<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>;
export type CreateSemanticLegendWithCategoricalConfigComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>, 'mutation'>;

    export const CreateSemanticLegendWithCategoricalConfigComponent = (props: CreateSemanticLegendWithCategoricalConfigComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables> mutation={CreateSemanticLegendWithCategoricalConfigDocument} {...props} />
    );
    
export type CreateSemanticLegendWithCategoricalConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>
    } & TChildProps;
export function withCreateSemanticLegendWithCategoricalConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSemanticLegendWithCategoricalConfigMutation,
  CreateSemanticLegendWithCategoricalConfigMutationVariables,
  CreateSemanticLegendWithCategoricalConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables, CreateSemanticLegendWithCategoricalConfigProps<TChildProps, TDataName>>(CreateSemanticLegendWithCategoricalConfigDocument, {
      alias: 'createSemanticLegendWithCategoricalConfig',
      ...operationOptions
    });
};

/**
 * __useCreateSemanticLegendWithCategoricalConfigMutation__
 *
 * To run a mutation, you first call `useCreateSemanticLegendWithCategoricalConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSemanticLegendWithCategoricalConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSemanticLegendWithCategoricalConfigMutation, { data, loading, error }] = useCreateSemanticLegendWithCategoricalConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metricName: // value for 'metricName'
 *      yValue: // value for 'yValue'
 *      customColors: // value for 'customColors'
 *      bucketUpperBounds: // value for 'bucketUpperBounds'
 *      excludedRunColor: // value for 'excludedRunColor'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useCreateSemanticLegendWithCategoricalConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>(CreateSemanticLegendWithCategoricalConfigDocument, options);
      }
export type CreateSemanticLegendWithCategoricalConfigMutationHookResult = ReturnType<typeof useCreateSemanticLegendWithCategoricalConfigMutation>;
export type CreateSemanticLegendWithCategoricalConfigMutationResult = ApolloReactCommon.MutationResult<CreateSemanticLegendWithCategoricalConfigMutation>;
export type CreateSemanticLegendWithCategoricalConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>;
export const UpdateSemanticLegendWithCategoricalConfigDocument = gql`
    mutation UpdateSemanticLegendWithCategoricalConfig($id: ID!, $currentMetric: String!, $metricName: String, $yValue: String, $customColors: [String], $bucketUpperBounds: [Float!], $excludedRunColor: String, $categories: [String]) {
  updateSemanticLegend(
    input: {viewID: $id, currentMetric: $currentMetric, metricName: $metricName, yValue: $yValue, customColors: $customColors, bucketUpperBounds: $bucketUpperBounds, excludedRunColor: $excludedRunColor, categories: $categories}
  ) {
    success
  }
}
    `;
export type UpdateSemanticLegendWithCategoricalConfigMutationFn = ApolloReactCommon.MutationFunction<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>;
export type UpdateSemanticLegendWithCategoricalConfigComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>, 'mutation'>;

    export const UpdateSemanticLegendWithCategoricalConfigComponent = (props: UpdateSemanticLegendWithCategoricalConfigComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables> mutation={UpdateSemanticLegendWithCategoricalConfigDocument} {...props} />
    );
    
export type UpdateSemanticLegendWithCategoricalConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>
    } & TChildProps;
export function withUpdateSemanticLegendWithCategoricalConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSemanticLegendWithCategoricalConfigMutation,
  UpdateSemanticLegendWithCategoricalConfigMutationVariables,
  UpdateSemanticLegendWithCategoricalConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables, UpdateSemanticLegendWithCategoricalConfigProps<TChildProps, TDataName>>(UpdateSemanticLegendWithCategoricalConfigDocument, {
      alias: 'updateSemanticLegendWithCategoricalConfig',
      ...operationOptions
    });
};

/**
 * __useUpdateSemanticLegendWithCategoricalConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSemanticLegendWithCategoricalConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSemanticLegendWithCategoricalConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSemanticLegendWithCategoricalConfigMutation, { data, loading, error }] = useUpdateSemanticLegendWithCategoricalConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentMetric: // value for 'currentMetric'
 *      metricName: // value for 'metricName'
 *      yValue: // value for 'yValue'
 *      customColors: // value for 'customColors'
 *      bucketUpperBounds: // value for 'bucketUpperBounds'
 *      excludedRunColor: // value for 'excludedRunColor'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useUpdateSemanticLegendWithCategoricalConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>(UpdateSemanticLegendWithCategoricalConfigDocument, options);
      }
export type UpdateSemanticLegendWithCategoricalConfigMutationHookResult = ReturnType<typeof useUpdateSemanticLegendWithCategoricalConfigMutation>;
export type UpdateSemanticLegendWithCategoricalConfigMutationResult = ApolloReactCommon.MutationResult<UpdateSemanticLegendWithCategoricalConfigMutation>;
export type UpdateSemanticLegendWithCategoricalConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>;
export const SemanticLegendsQueryWithCategoricalConfigDocument = gql`
    query SemanticLegendsQueryWithCategoricalConfig($id: ID!) {
  view(id: $id) {
    id
    semanticLegend {
      currentMetric
      semanticLegendsByMetric {
        metricName
        yValue
        customColors {
          bucketNumber
          colorHex
        }
        bucketUpperBounds
        excludedRunColor
        lastUpdatedAt
        categories
      }
    }
  }
}
    `;
export type SemanticLegendsQueryWithCategoricalConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>, 'query'> & ({ variables: SemanticLegendsQueryWithCategoricalConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SemanticLegendsQueryWithCategoricalConfigComponent = (props: SemanticLegendsQueryWithCategoricalConfigComponentProps) => (
      <ApolloReactComponents.Query<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables> query={SemanticLegendsQueryWithCategoricalConfigDocument} {...props} />
    );
    
export type SemanticLegendsQueryWithCategoricalConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>
    } & TChildProps;
export function withSemanticLegendsQueryWithCategoricalConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SemanticLegendsQueryWithCategoricalConfigQuery,
  SemanticLegendsQueryWithCategoricalConfigQueryVariables,
  SemanticLegendsQueryWithCategoricalConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables, SemanticLegendsQueryWithCategoricalConfigProps<TChildProps, TDataName>>(SemanticLegendsQueryWithCategoricalConfigDocument, {
      alias: 'semanticLegendsQueryWithCategoricalConfig',
      ...operationOptions
    });
};

/**
 * __useSemanticLegendsQueryWithCategoricalConfigQuery__
 *
 * To run a query within a React component, call `useSemanticLegendsQueryWithCategoricalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSemanticLegendsQueryWithCategoricalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSemanticLegendsQueryWithCategoricalConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSemanticLegendsQueryWithCategoricalConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables> & ({ variables: SemanticLegendsQueryWithCategoricalConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>(SemanticLegendsQueryWithCategoricalConfigDocument, options);
      }
export function useSemanticLegendsQueryWithCategoricalConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>(SemanticLegendsQueryWithCategoricalConfigDocument, options);
        }
// @ts-ignore
export function useSemanticLegendsQueryWithCategoricalConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>;
export function useSemanticLegendsQueryWithCategoricalConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SemanticLegendsQueryWithCategoricalConfigQuery | undefined, SemanticLegendsQueryWithCategoricalConfigQueryVariables>;
export function useSemanticLegendsQueryWithCategoricalConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>(SemanticLegendsQueryWithCategoricalConfigDocument, options);
        }
export type SemanticLegendsQueryWithCategoricalConfigQueryHookResult = ReturnType<typeof useSemanticLegendsQueryWithCategoricalConfigQuery>;
export type SemanticLegendsQueryWithCategoricalConfigLazyQueryHookResult = ReturnType<typeof useSemanticLegendsQueryWithCategoricalConfigLazyQuery>;
export type SemanticLegendsQueryWithCategoricalConfigSuspenseQueryHookResult = ReturnType<typeof useSemanticLegendsQueryWithCategoricalConfigSuspenseQuery>;
export type SemanticLegendsQueryWithCategoricalConfigQueryResult = ApolloReactCommon.QueryResult<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>;
export const UpsertWorkspaceTemplateDocument = gql`
    mutation UpsertWorkspaceTemplate($entityId: ID!, $linePlotTemplateId: ID, $linePlotSettings: JSONString, $workspaceLayoutTemplateId: ID, $workspaceLayoutSettings: JSONString) {
  upsertWorkspaceTemplate(
    input: {entityId: $entityId, linePlotTemplateId: $linePlotTemplateId, linePlotSettings: $linePlotSettings, workspaceLayoutTemplateId: $workspaceLayoutTemplateId, workspaceLayoutSettings: $workspaceLayoutSettings}
  ) {
    linePlotTemplateId
    workspaceLayoutTemplateId
  }
}
    `;
export type UpsertWorkspaceTemplateMutationFn = ApolloReactCommon.MutationFunction<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>;
export type UpsertWorkspaceTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>, 'mutation'>;

    export const UpsertWorkspaceTemplateComponent = (props: UpsertWorkspaceTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables> mutation={UpsertWorkspaceTemplateDocument} {...props} />
    );
    
export type UpsertWorkspaceTemplateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>
    } & TChildProps;
export function withUpsertWorkspaceTemplate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertWorkspaceTemplateMutation,
  UpsertWorkspaceTemplateMutationVariables,
  UpsertWorkspaceTemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables, UpsertWorkspaceTemplateProps<TChildProps, TDataName>>(UpsertWorkspaceTemplateDocument, {
      alias: 'upsertWorkspaceTemplate',
      ...operationOptions
    });
};

/**
 * __useUpsertWorkspaceTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertWorkspaceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWorkspaceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWorkspaceTemplateMutation, { data, loading, error }] = useUpsertWorkspaceTemplateMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      linePlotTemplateId: // value for 'linePlotTemplateId'
 *      linePlotSettings: // value for 'linePlotSettings'
 *      workspaceLayoutTemplateId: // value for 'workspaceLayoutTemplateId'
 *      workspaceLayoutSettings: // value for 'workspaceLayoutSettings'
 *   },
 * });
 */
export function useUpsertWorkspaceTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>(UpsertWorkspaceTemplateDocument, options);
      }
export type UpsertWorkspaceTemplateMutationHookResult = ReturnType<typeof useUpsertWorkspaceTemplateMutation>;
export type UpsertWorkspaceTemplateMutationResult = ApolloReactCommon.MutationResult<UpsertWorkspaceTemplateMutation>;
export type UpsertWorkspaceTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>;
export const DeleteWorkspaceTemplateDocument = gql`
    mutation DeleteWorkspaceTemplate($linePlotTemplateId: ID, $workspaceLayoutTemplateId: ID) {
  deleteWorkspaceTemplate(
    input: {linePlotTemplateId: $linePlotTemplateId, workspaceLayoutTemplateId: $workspaceLayoutTemplateId}
  ) {
    success
  }
}
    `;
export type DeleteWorkspaceTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>;
export type DeleteWorkspaceTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>, 'mutation'>;

    export const DeleteWorkspaceTemplateComponent = (props: DeleteWorkspaceTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables> mutation={DeleteWorkspaceTemplateDocument} {...props} />
    );
    
export type DeleteWorkspaceTemplateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>
    } & TChildProps;
export function withDeleteWorkspaceTemplate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteWorkspaceTemplateMutation,
  DeleteWorkspaceTemplateMutationVariables,
  DeleteWorkspaceTemplateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables, DeleteWorkspaceTemplateProps<TChildProps, TDataName>>(DeleteWorkspaceTemplateDocument, {
      alias: 'deleteWorkspaceTemplate',
      ...operationOptions
    });
};

/**
 * __useDeleteWorkspaceTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceTemplateMutation, { data, loading, error }] = useDeleteWorkspaceTemplateMutation({
 *   variables: {
 *      linePlotTemplateId: // value for 'linePlotTemplateId'
 *      workspaceLayoutTemplateId: // value for 'workspaceLayoutTemplateId'
 *   },
 * });
 */
export function useDeleteWorkspaceTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>(DeleteWorkspaceTemplateDocument, options);
      }
export type DeleteWorkspaceTemplateMutationHookResult = ReturnType<typeof useDeleteWorkspaceTemplateMutation>;
export type DeleteWorkspaceTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteWorkspaceTemplateMutation>;
export type DeleteWorkspaceTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>;
export const WorkspaceTemplatesDocument = gql`
    query WorkspaceTemplates($entityId: ID!, $userId: ID) {
  workspaceTemplates(entityId: $entityId, userId: $userId) {
    id
    createdAt
    createdBy {
      id
      name
      email
      username
    }
    updatedAt
    settings
    settingsVersion
    type
  }
}
    `;
export type WorkspaceTemplatesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>, 'query'> & ({ variables: WorkspaceTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WorkspaceTemplatesComponent = (props: WorkspaceTemplatesComponentProps) => (
      <ApolloReactComponents.Query<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables> query={WorkspaceTemplatesDocument} {...props} />
    );
    
export type WorkspaceTemplatesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>
    } & TChildProps;
export function withWorkspaceTemplates<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  WorkspaceTemplatesQuery,
  WorkspaceTemplatesQueryVariables,
  WorkspaceTemplatesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables, WorkspaceTemplatesProps<TChildProps, TDataName>>(WorkspaceTemplatesDocument, {
      alias: 'workspaceTemplates',
      ...operationOptions
    });
};

/**
 * __useWorkspaceTemplatesQuery__
 *
 * To run a query within a React component, call `useWorkspaceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceTemplatesQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWorkspaceTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables> & ({ variables: WorkspaceTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>(WorkspaceTemplatesDocument, options);
      }
export function useWorkspaceTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>(WorkspaceTemplatesDocument, options);
        }
// @ts-ignore
export function useWorkspaceTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>;
export function useWorkspaceTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceTemplatesQuery | undefined, WorkspaceTemplatesQueryVariables>;
export function useWorkspaceTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>(WorkspaceTemplatesDocument, options);
        }
export type WorkspaceTemplatesQueryHookResult = ReturnType<typeof useWorkspaceTemplatesQuery>;
export type WorkspaceTemplatesLazyQueryHookResult = ReturnType<typeof useWorkspaceTemplatesLazyQuery>;
export type WorkspaceTemplatesSuspenseQueryHookResult = ReturnType<typeof useWorkspaceTemplatesSuspenseQuery>;
export type WorkspaceTemplatesQueryResult = ApolloReactCommon.QueryResult<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>;
export const TeamsForInvitesDocument = gql`
    query teamsForInvites {
  organization {
    id
    teams {
      id
      name
      memberCount
    }
  }
}
    `;
export type TeamsForInvitesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>, 'query'>;

    export const TeamsForInvitesComponent = (props: TeamsForInvitesComponentProps) => (
      <ApolloReactComponents.Query<TeamsForInvitesQuery, TeamsForInvitesQueryVariables> query={TeamsForInvitesDocument} {...props} />
    );
    
export type TeamsForInvitesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>
    } & TChildProps;
export function withTeamsForInvites<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamsForInvitesQuery,
  TeamsForInvitesQueryVariables,
  TeamsForInvitesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamsForInvitesQuery, TeamsForInvitesQueryVariables, TeamsForInvitesProps<TChildProps, TDataName>>(TeamsForInvitesDocument, {
      alias: 'teamsForInvites',
      ...operationOptions
    });
};

/**
 * __useTeamsForInvitesQuery__
 *
 * To run a query within a React component, call `useTeamsForInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsForInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsForInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamsForInvitesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>(TeamsForInvitesDocument, options);
      }
export function useTeamsForInvitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>(TeamsForInvitesDocument, options);
        }
// @ts-ignore
export function useTeamsForInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>;
export function useTeamsForInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsForInvitesQuery | undefined, TeamsForInvitesQueryVariables>;
export function useTeamsForInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>(TeamsForInvitesDocument, options);
        }
export type TeamsForInvitesQueryHookResult = ReturnType<typeof useTeamsForInvitesQuery>;
export type TeamsForInvitesLazyQueryHookResult = ReturnType<typeof useTeamsForInvitesLazyQuery>;
export type TeamsForInvitesSuspenseQueryHookResult = ReturnType<typeof useTeamsForInvitesSuspenseQuery>;
export type TeamsForInvitesQueryResult = ApolloReactCommon.QueryResult<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation updateSubscription($entityName: String!, $teamsEnabled: Boolean, $privateProjects: Boolean, $gpuEnabled: DateTime, $hubPreset: String, $repo: String, $disk: String, $redisEnabled: Boolean, $dockerEnabled: Boolean, $image: String) {
  updateSubscription(
    input: {entityName: $entityName, teamsEnabled: $teamsEnabled, privateProjects: $privateProjects, gpuEnabled: $gpuEnabled, hubPreset: $hubPreset, hubSettings: {repo: $repo, disk: $disk, redisEnabled: $redisEnabled, dockerEnabled: $dockerEnabled, image: $image}}
  ) {
    entity {
      id
      name
      available
      photoUrl
      limits
    }
  }
}
    `;
export type UpdateSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export type UpdateSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>, 'mutation'>;

    export const UpdateSubscriptionComponent = (props: UpdateSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables> mutation={UpdateSubscriptionDocument} {...props} />
    );
    
export type UpdateSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>
    } & TChildProps;
export function withUpdateSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables,
  UpdateSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables, UpdateSubscriptionProps<TChildProps, TDataName>>(UpdateSubscriptionDocument, {
      alias: 'updateSubscription',
      ...operationOptions
    });
};

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      teamsEnabled: // value for 'teamsEnabled'
 *      privateProjects: // value for 'privateProjects'
 *      gpuEnabled: // value for 'gpuEnabled'
 *      hubPreset: // value for 'hubPreset'
 *      repo: // value for 'repo'
 *      disk: // value for 'disk'
 *      redisEnabled: // value for 'redisEnabled'
 *      dockerEnabled: // value for 'dockerEnabled'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const UpdateEntityPhotoDocument = gql`
    mutation updateEntityPhoto($entityName: String!, $photoUrl: String) {
  updateEntity(input: {entity: $entityName, photoUrl: $photoUrl}) {
    entity {
      id
      name
      available
      photoUrl
      limits
    }
  }
}
    `;
export type UpdateEntityPhotoMutationFn = ApolloReactCommon.MutationFunction<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>;
export type UpdateEntityPhotoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>, 'mutation'>;

    export const UpdateEntityPhotoComponent = (props: UpdateEntityPhotoComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables> mutation={UpdateEntityPhotoDocument} {...props} />
    );
    
export type UpdateEntityPhotoProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>
    } & TChildProps;
export function withUpdateEntityPhoto<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEntityPhotoMutation,
  UpdateEntityPhotoMutationVariables,
  UpdateEntityPhotoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables, UpdateEntityPhotoProps<TChildProps, TDataName>>(UpdateEntityPhotoDocument, {
      alias: 'updateEntityPhoto',
      ...operationOptions
    });
};

/**
 * __useUpdateEntityPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateEntityPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityPhotoMutation, { data, loading, error }] = useUpdateEntityPhotoMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      photoUrl: // value for 'photoUrl'
 *   },
 * });
 */
export function useUpdateEntityPhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>(UpdateEntityPhotoDocument, options);
      }
export type UpdateEntityPhotoMutationHookResult = ReturnType<typeof useUpdateEntityPhotoMutation>;
export type UpdateEntityPhotoMutationResult = ApolloReactCommon.MutationResult<UpdateEntityPhotoMutation>;
export type UpdateEntityPhotoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>;
export const TeamQueryDocument = gql`
    query TeamQuery($name: String) {
  entity(name: $name) {
    id
    name
    available
    photoUrl
    limits
    settings {
      openToMatchingOrgEmailDomainUsers
    }
  }
}
    `;
export type TeamQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamQueryQuery, TeamQueryQueryVariables>, 'query'>;

    export const TeamQueryComponent = (props: TeamQueryComponentProps) => (
      <ApolloReactComponents.Query<TeamQueryQuery, TeamQueryQueryVariables> query={TeamQueryDocument} {...props} />
    );
    
export type TeamQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamQueryQuery, TeamQueryQueryVariables>
    } & TChildProps;
export function withTeamQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamQueryQuery,
  TeamQueryQueryVariables,
  TeamQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamQueryQuery, TeamQueryQueryVariables, TeamQueryProps<TChildProps, TDataName>>(TeamQueryDocument, {
      alias: 'teamQuery',
      ...operationOptions
    });
};

/**
 * __useTeamQueryQuery__
 *
 * To run a query within a React component, call `useTeamQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQueryQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTeamQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamQueryQuery, TeamQueryQueryVariables>(TeamQueryDocument, options);
      }
export function useTeamQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamQueryQuery, TeamQueryQueryVariables>(TeamQueryDocument, options);
        }
// @ts-ignore
export function useTeamQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamQueryQuery, TeamQueryQueryVariables>;
export function useTeamQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamQueryQuery | undefined, TeamQueryQueryVariables>;
export function useTeamQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamQueryQuery, TeamQueryQueryVariables>(TeamQueryDocument, options);
        }
export type TeamQueryQueryHookResult = ReturnType<typeof useTeamQueryQuery>;
export type TeamQueryLazyQueryHookResult = ReturnType<typeof useTeamQueryLazyQuery>;
export type TeamQuerySuspenseQueryHookResult = ReturnType<typeof useTeamQuerySuspenseQuery>;
export type TeamQueryQueryResult = ApolloReactCommon.QueryResult<TeamQueryQuery, TeamQueryQueryVariables>;
export const UserQueryDocument = gql`
    query UserQuery($userName: String!) {
  user(userName: $userName) {
    id
  }
}
    `;
export type UserQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserQueryQuery, UserQueryQueryVariables>, 'query'> & ({ variables: UserQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserQueryComponent = (props: UserQueryComponentProps) => (
      <ApolloReactComponents.Query<UserQueryQuery, UserQueryQueryVariables> query={UserQueryDocument} {...props} />
    );
    
export type UserQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserQueryQuery, UserQueryQueryVariables>
    } & TChildProps;
export function withUserQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserQueryQuery,
  UserQueryQueryVariables,
  UserQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserQueryQuery, UserQueryQueryVariables, UserQueryProps<TChildProps, TDataName>>(UserQueryDocument, {
      alias: 'userQuery',
      ...operationOptions
    });
};

/**
 * __useUserQueryQuery__
 *
 * To run a query within a React component, call `useUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQueryQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useUserQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQueryQuery, UserQueryQueryVariables> & ({ variables: UserQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQueryQuery, UserQueryQueryVariables>(UserQueryDocument, options);
      }
export function useUserQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQueryQuery, UserQueryQueryVariables>(UserQueryDocument, options);
        }
// @ts-ignore
export function useUserQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserQueryQuery, UserQueryQueryVariables>;
export function useUserQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserQueryQuery | undefined, UserQueryQueryVariables>;
export function useUserQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserQueryQuery, UserQueryQueryVariables>(UserQueryDocument, options);
        }
export type UserQueryQueryHookResult = ReturnType<typeof useUserQueryQuery>;
export type UserQueryLazyQueryHookResult = ReturnType<typeof useUserQueryLazyQuery>;
export type UserQuerySuspenseQueryHookResult = ReturnType<typeof useUserQuerySuspenseQuery>;
export type UserQueryQueryResult = ApolloReactCommon.QueryResult<UserQueryQuery, UserQueryQueryVariables>;
export const AllEntitiesDocument = gql`
    query allEntities($first: Int = 2000) {
  entities(first: $first) {
    edges {
      node {
        id
        createdAt
        name
        memberCount
        isTeam
        members {
          admin
          pending
          username
          email
          name
          id
        }
      }
    }
  }
}
    `;
export type AllEntitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllEntitiesQuery, AllEntitiesQueryVariables>, 'query'>;

    export const AllEntitiesComponent = (props: AllEntitiesComponentProps) => (
      <ApolloReactComponents.Query<AllEntitiesQuery, AllEntitiesQueryVariables> query={AllEntitiesDocument} {...props} />
    );
    
export type AllEntitiesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllEntitiesQuery, AllEntitiesQueryVariables>
    } & TChildProps;
export function withAllEntities<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllEntitiesQuery,
  AllEntitiesQueryVariables,
  AllEntitiesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllEntitiesQuery, AllEntitiesQueryVariables, AllEntitiesProps<TChildProps, TDataName>>(AllEntitiesDocument, {
      alias: 'allEntities',
      ...operationOptions
    });
};

/**
 * __useAllEntitiesQuery__
 *
 * To run a query within a React component, call `useAllEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEntitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllEntitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllEntitiesQuery, AllEntitiesQueryVariables>(AllEntitiesDocument, options);
      }
export function useAllEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllEntitiesQuery, AllEntitiesQueryVariables>(AllEntitiesDocument, options);
        }
// @ts-ignore
export function useAllEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllEntitiesQuery, AllEntitiesQueryVariables>;
export function useAllEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllEntitiesQuery | undefined, AllEntitiesQueryVariables>;
export function useAllEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllEntitiesQuery, AllEntitiesQueryVariables>(AllEntitiesDocument, options);
        }
export type AllEntitiesQueryHookResult = ReturnType<typeof useAllEntitiesQuery>;
export type AllEntitiesLazyQueryHookResult = ReturnType<typeof useAllEntitiesLazyQuery>;
export type AllEntitiesSuspenseQueryHookResult = ReturnType<typeof useAllEntitiesSuspenseQuery>;
export type AllEntitiesQueryResult = ApolloReactCommon.QueryResult<AllEntitiesQuery, AllEntitiesQueryVariables>;
export const UpdateEntityAdminDocument = gql`
    mutation UpdateEntityAdmin($entityName: String!, $isPaid: Boolean, $rateLimits: RateLimitsInput) {
  updateEntity(
    input: {entity: $entityName, isPaid: $isPaid, rateLimits: $rateLimits}
  ) {
    entity {
      id
      isPaid
      rateLimits {
        graphql
        sdkGraphql
        filestreamCount
        filestreamPerRunCount
        filestreamSize
        runUpdateCount
        sdkGraphqlQuerySeconds
      }
    }
  }
}
    `;
export type UpdateEntityAdminMutationFn = ApolloReactCommon.MutationFunction<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>;
export type UpdateEntityAdminComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>, 'mutation'>;

    export const UpdateEntityAdminComponent = (props: UpdateEntityAdminComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables> mutation={UpdateEntityAdminDocument} {...props} />
    );
    
export type UpdateEntityAdminProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>
    } & TChildProps;
export function withUpdateEntityAdmin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEntityAdminMutation,
  UpdateEntityAdminMutationVariables,
  UpdateEntityAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables, UpdateEntityAdminProps<TChildProps, TDataName>>(UpdateEntityAdminDocument, {
      alias: 'updateEntityAdmin',
      ...operationOptions
    });
};

/**
 * __useUpdateEntityAdminMutation__
 *
 * To run a mutation, you first call `useUpdateEntityAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityAdminMutation, { data, loading, error }] = useUpdateEntityAdminMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      isPaid: // value for 'isPaid'
 *      rateLimits: // value for 'rateLimits'
 *   },
 * });
 */
export function useUpdateEntityAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>(UpdateEntityAdminDocument, options);
      }
export type UpdateEntityAdminMutationHookResult = ReturnType<typeof useUpdateEntityAdminMutation>;
export type UpdateEntityAdminMutationResult = ApolloReactCommon.MutationResult<UpdateEntityAdminMutation>;
export type UpdateEntityAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>;
export const UpdateProjectAdminDocument = gql`
    mutation UpdateProjectAdmin($id: String!, $rateLimits: RateLimitsInput) {
  upsertModel(input: {id: $id, rateLimits: $rateLimits}) {
    project {
      id
      rateLimits {
        filestreamCount
        filestreamPerRunCount
        filestreamSize
        runUpdateCount
        sdkGraphqlQuerySeconds
      }
    }
  }
}
    `;
export type UpdateProjectAdminMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>;
export type UpdateProjectAdminComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>, 'mutation'>;

    export const UpdateProjectAdminComponent = (props: UpdateProjectAdminComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables> mutation={UpdateProjectAdminDocument} {...props} />
    );
    
export type UpdateProjectAdminProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>
    } & TChildProps;
export function withUpdateProjectAdmin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProjectAdminMutation,
  UpdateProjectAdminMutationVariables,
  UpdateProjectAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables, UpdateProjectAdminProps<TChildProps, TDataName>>(UpdateProjectAdminDocument, {
      alias: 'updateProjectAdmin',
      ...operationOptions
    });
};

/**
 * __useUpdateProjectAdminMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAdminMutation, { data, loading, error }] = useUpdateProjectAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rateLimits: // value for 'rateLimits'
 *   },
 * });
 */
export function useUpdateProjectAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>(UpdateProjectAdminDocument, options);
      }
export type UpdateProjectAdminMutationHookResult = ReturnType<typeof useUpdateProjectAdminMutation>;
export type UpdateProjectAdminMutationResult = ApolloReactCommon.MutationResult<UpdateProjectAdminMutation>;
export type UpdateProjectAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>;
export const ProjectRateLimitsDocument = gql`
    query ProjectRateLimits($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    rateLimits {
      filestreamCount
      filestreamPerRunCount
      filestreamSize
      runUpdateCount
      sdkGraphqlQuerySeconds
    }
  }
}
    `;
export type ProjectRateLimitsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>, 'query'> & ({ variables: ProjectRateLimitsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectRateLimitsComponent = (props: ProjectRateLimitsComponentProps) => (
      <ApolloReactComponents.Query<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables> query={ProjectRateLimitsDocument} {...props} />
    );
    
export type ProjectRateLimitsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>
    } & TChildProps;
export function withProjectRateLimits<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectRateLimitsQuery,
  ProjectRateLimitsQueryVariables,
  ProjectRateLimitsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables, ProjectRateLimitsProps<TChildProps, TDataName>>(ProjectRateLimitsDocument, {
      alias: 'projectRateLimits',
      ...operationOptions
    });
};

/**
 * __useProjectRateLimitsQuery__
 *
 * To run a query within a React component, call `useProjectRateLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRateLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRateLimitsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectRateLimitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables> & ({ variables: ProjectRateLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>(ProjectRateLimitsDocument, options);
      }
export function useProjectRateLimitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>(ProjectRateLimitsDocument, options);
        }
// @ts-ignore
export function useProjectRateLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>;
export function useProjectRateLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRateLimitsQuery | undefined, ProjectRateLimitsQueryVariables>;
export function useProjectRateLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>(ProjectRateLimitsDocument, options);
        }
export type ProjectRateLimitsQueryHookResult = ReturnType<typeof useProjectRateLimitsQuery>;
export type ProjectRateLimitsLazyQueryHookResult = ReturnType<typeof useProjectRateLimitsLazyQuery>;
export type ProjectRateLimitsSuspenseQueryHookResult = ReturnType<typeof useProjectRateLimitsSuspenseQuery>;
export type ProjectRateLimitsQueryResult = ApolloReactCommon.QueryResult<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>;
export const TriggerParquetExportDocument = gql`
    mutation triggerParquetExport($runId: ID!) {
  triggerParquetExport(input: {runId: $runId}) {
    task {
      id
    }
  }
}
    `;
export type TriggerParquetExportMutationFn = ApolloReactCommon.MutationFunction<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>;
export type TriggerParquetExportComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>, 'mutation'>;

    export const TriggerParquetExportComponent = (props: TriggerParquetExportComponentProps) => (
      <ApolloReactComponents.Mutation<TriggerParquetExportMutation, TriggerParquetExportMutationVariables> mutation={TriggerParquetExportDocument} {...props} />
    );
    
export type TriggerParquetExportProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>
    } & TChildProps;
export function withTriggerParquetExport<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TriggerParquetExportMutation,
  TriggerParquetExportMutationVariables,
  TriggerParquetExportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, TriggerParquetExportMutation, TriggerParquetExportMutationVariables, TriggerParquetExportProps<TChildProps, TDataName>>(TriggerParquetExportDocument, {
      alias: 'triggerParquetExport',
      ...operationOptions
    });
};

/**
 * __useTriggerParquetExportMutation__
 *
 * To run a mutation, you first call `useTriggerParquetExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerParquetExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerParquetExportMutation, { data, loading, error }] = useTriggerParquetExportMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useTriggerParquetExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>(TriggerParquetExportDocument, options);
      }
export type TriggerParquetExportMutationHookResult = ReturnType<typeof useTriggerParquetExportMutation>;
export type TriggerParquetExportMutationResult = ApolloReactCommon.MutationResult<TriggerParquetExportMutation>;
export type TriggerParquetExportMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>;
export const TriggerRecomputeKeysInfoDocument = gql`
    mutation triggerRecomputeKeysInfo($runId: ID!) {
  triggerRecomputeKeysInfo(input: {runId: $runId}) {
    task {
      id
    }
  }
}
    `;
export type TriggerRecomputeKeysInfoMutationFn = ApolloReactCommon.MutationFunction<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>;
export type TriggerRecomputeKeysInfoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>, 'mutation'>;

    export const TriggerRecomputeKeysInfoComponent = (props: TriggerRecomputeKeysInfoComponentProps) => (
      <ApolloReactComponents.Mutation<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables> mutation={TriggerRecomputeKeysInfoDocument} {...props} />
    );
    
export type TriggerRecomputeKeysInfoProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>
    } & TChildProps;
export function withTriggerRecomputeKeysInfo<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TriggerRecomputeKeysInfoMutation,
  TriggerRecomputeKeysInfoMutationVariables,
  TriggerRecomputeKeysInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables, TriggerRecomputeKeysInfoProps<TChildProps, TDataName>>(TriggerRecomputeKeysInfoDocument, {
      alias: 'triggerRecomputeKeysInfo',
      ...operationOptions
    });
};

/**
 * __useTriggerRecomputeKeysInfoMutation__
 *
 * To run a mutation, you first call `useTriggerRecomputeKeysInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerRecomputeKeysInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerRecomputeKeysInfoMutation, { data, loading, error }] = useTriggerRecomputeKeysInfoMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useTriggerRecomputeKeysInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>(TriggerRecomputeKeysInfoDocument, options);
      }
export type TriggerRecomputeKeysInfoMutationHookResult = ReturnType<typeof useTriggerRecomputeKeysInfoMutation>;
export type TriggerRecomputeKeysInfoMutationResult = ApolloReactCommon.MutationResult<TriggerRecomputeKeysInfoMutation>;
export type TriggerRecomputeKeysInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>;
export const TriggerEventsExportDocument = gql`
    mutation triggerEventsExport($runId: ID!) {
  triggerEventsExport(input: {runId: $runId}) {
    task {
      id
    }
  }
}
    `;
export type TriggerEventsExportMutationFn = ApolloReactCommon.MutationFunction<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>;
export type TriggerEventsExportComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>, 'mutation'>;

    export const TriggerEventsExportComponent = (props: TriggerEventsExportComponentProps) => (
      <ApolloReactComponents.Mutation<TriggerEventsExportMutation, TriggerEventsExportMutationVariables> mutation={TriggerEventsExportDocument} {...props} />
    );
    
export type TriggerEventsExportProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>
    } & TChildProps;
export function withTriggerEventsExport<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TriggerEventsExportMutation,
  TriggerEventsExportMutationVariables,
  TriggerEventsExportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, TriggerEventsExportMutation, TriggerEventsExportMutationVariables, TriggerEventsExportProps<TChildProps, TDataName>>(TriggerEventsExportDocument, {
      alias: 'triggerEventsExport',
      ...operationOptions
    });
};

/**
 * __useTriggerEventsExportMutation__
 *
 * To run a mutation, you first call `useTriggerEventsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerEventsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerEventsExportMutation, { data, loading, error }] = useTriggerEventsExportMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useTriggerEventsExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>(TriggerEventsExportDocument, options);
      }
export type TriggerEventsExportMutationHookResult = ReturnType<typeof useTriggerEventsExportMutation>;
export type TriggerEventsExportMutationResult = ApolloReactCommon.MutationResult<TriggerEventsExportMutation>;
export type TriggerEventsExportMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>;
export const TriggerFlatRunsMigratorDocument = gql`
    mutation triggerFlatRunsMigrator($entityName: String, $organizationName: String) {
  triggerFlatRunsMigrator(
    input: {entityName: $entityName, organizationName: $organizationName}
  ) {
    glueTaskName
  }
}
    `;
export type TriggerFlatRunsMigratorMutationFn = ApolloReactCommon.MutationFunction<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>;
export type TriggerFlatRunsMigratorComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>, 'mutation'>;

    export const TriggerFlatRunsMigratorComponent = (props: TriggerFlatRunsMigratorComponentProps) => (
      <ApolloReactComponents.Mutation<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables> mutation={TriggerFlatRunsMigratorDocument} {...props} />
    );
    
export type TriggerFlatRunsMigratorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>
    } & TChildProps;
export function withTriggerFlatRunsMigrator<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TriggerFlatRunsMigratorMutation,
  TriggerFlatRunsMigratorMutationVariables,
  TriggerFlatRunsMigratorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables, TriggerFlatRunsMigratorProps<TChildProps, TDataName>>(TriggerFlatRunsMigratorDocument, {
      alias: 'triggerFlatRunsMigrator',
      ...operationOptions
    });
};

/**
 * __useTriggerFlatRunsMigratorMutation__
 *
 * To run a mutation, you first call `useTriggerFlatRunsMigratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerFlatRunsMigratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerFlatRunsMigratorMutation, { data, loading, error }] = useTriggerFlatRunsMigratorMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      organizationName: // value for 'organizationName'
 *   },
 * });
 */
export function useTriggerFlatRunsMigratorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>(TriggerFlatRunsMigratorDocument, options);
      }
export type TriggerFlatRunsMigratorMutationHookResult = ReturnType<typeof useTriggerFlatRunsMigratorMutation>;
export type TriggerFlatRunsMigratorMutationResult = ApolloReactCommon.MutationResult<TriggerFlatRunsMigratorMutation>;
export type TriggerFlatRunsMigratorMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>;
export const CreateFinishedRunAlertDocument = gql`
    mutation CreateFinishedRunAlert($entityName: String!) {
  createFinishedRunAlert(input: {entityName: $entityName}) {
    alert {
      id
      condition {
        __typename
        ... on FinishedRunCondition {
          success
        }
      }
      subscriptions {
        id
      }
    }
  }
}
    `;
export type CreateFinishedRunAlertMutationFn = ApolloReactCommon.MutationFunction<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>;
export type CreateFinishedRunAlertComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>, 'mutation'>;

    export const CreateFinishedRunAlertComponent = (props: CreateFinishedRunAlertComponentProps) => (
      <ApolloReactComponents.Mutation<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables> mutation={CreateFinishedRunAlertDocument} {...props} />
    );
    
export type CreateFinishedRunAlertProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>
    } & TChildProps;
export function withCreateFinishedRunAlert<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateFinishedRunAlertMutation,
  CreateFinishedRunAlertMutationVariables,
  CreateFinishedRunAlertProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables, CreateFinishedRunAlertProps<TChildProps, TDataName>>(CreateFinishedRunAlertDocument, {
      alias: 'createFinishedRunAlert',
      ...operationOptions
    });
};

/**
 * __useCreateFinishedRunAlertMutation__
 *
 * To run a mutation, you first call `useCreateFinishedRunAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinishedRunAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinishedRunAlertMutation, { data, loading, error }] = useCreateFinishedRunAlertMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCreateFinishedRunAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>(CreateFinishedRunAlertDocument, options);
      }
export type CreateFinishedRunAlertMutationHookResult = ReturnType<typeof useCreateFinishedRunAlertMutation>;
export type CreateFinishedRunAlertMutationResult = ApolloReactCommon.MutationResult<CreateFinishedRunAlertMutation>;
export type CreateFinishedRunAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>;
export const CreateStoppedRunAlertDocument = gql`
    mutation CreateStoppedRunAlert($entityName: String!, $minimumRunDuration: Duration!) {
  createStoppedRunAlert(
    input: {entityName: $entityName, minimumRunDuration: $minimumRunDuration}
  ) {
    alert {
      id
      condition {
        __typename
        ... on StoppedRunCondition {
          minimumRunDuration
        }
      }
      subscriptions {
        id
      }
    }
  }
}
    `;
export type CreateStoppedRunAlertMutationFn = ApolloReactCommon.MutationFunction<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>;
export type CreateStoppedRunAlertComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>, 'mutation'>;

    export const CreateStoppedRunAlertComponent = (props: CreateStoppedRunAlertComponentProps) => (
      <ApolloReactComponents.Mutation<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables> mutation={CreateStoppedRunAlertDocument} {...props} />
    );
    
export type CreateStoppedRunAlertProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>
    } & TChildProps;
export function withCreateStoppedRunAlert<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateStoppedRunAlertMutation,
  CreateStoppedRunAlertMutationVariables,
  CreateStoppedRunAlertProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables, CreateStoppedRunAlertProps<TChildProps, TDataName>>(CreateStoppedRunAlertDocument, {
      alias: 'createStoppedRunAlert',
      ...operationOptions
    });
};

/**
 * __useCreateStoppedRunAlertMutation__
 *
 * To run a mutation, you first call `useCreateStoppedRunAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoppedRunAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoppedRunAlertMutation, { data, loading, error }] = useCreateStoppedRunAlertMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      minimumRunDuration: // value for 'minimumRunDuration'
 *   },
 * });
 */
export function useCreateStoppedRunAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>(CreateStoppedRunAlertDocument, options);
      }
export type CreateStoppedRunAlertMutationHookResult = ReturnType<typeof useCreateStoppedRunAlertMutation>;
export type CreateStoppedRunAlertMutationResult = ApolloReactCommon.MutationResult<CreateStoppedRunAlertMutation>;
export type CreateStoppedRunAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>;
export const UpdateStoppedRunAlertDocument = gql`
    mutation UpdateStoppedRunAlert($id: ID!, $minimumRunDuration: Duration) {
  updateStoppedRunAlert(input: {id: $id, minimumRunDuration: $minimumRunDuration}) {
    alert {
      id
      condition {
        __typename
        ... on StoppedRunCondition {
          minimumRunDuration
        }
      }
      subscriptions {
        id
      }
    }
  }
}
    `;
export type UpdateStoppedRunAlertMutationFn = ApolloReactCommon.MutationFunction<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>;
export type UpdateStoppedRunAlertComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>, 'mutation'>;

    export const UpdateStoppedRunAlertComponent = (props: UpdateStoppedRunAlertComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables> mutation={UpdateStoppedRunAlertDocument} {...props} />
    );
    
export type UpdateStoppedRunAlertProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>
    } & TChildProps;
export function withUpdateStoppedRunAlert<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateStoppedRunAlertMutation,
  UpdateStoppedRunAlertMutationVariables,
  UpdateStoppedRunAlertProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables, UpdateStoppedRunAlertProps<TChildProps, TDataName>>(UpdateStoppedRunAlertDocument, {
      alias: 'updateStoppedRunAlert',
      ...operationOptions
    });
};

/**
 * __useUpdateStoppedRunAlertMutation__
 *
 * To run a mutation, you first call `useUpdateStoppedRunAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoppedRunAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoppedRunAlertMutation, { data, loading, error }] = useUpdateStoppedRunAlertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      minimumRunDuration: // value for 'minimumRunDuration'
 *   },
 * });
 */
export function useUpdateStoppedRunAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>(UpdateStoppedRunAlertDocument, options);
      }
export type UpdateStoppedRunAlertMutationHookResult = ReturnType<typeof useUpdateStoppedRunAlertMutation>;
export type UpdateStoppedRunAlertMutationResult = ApolloReactCommon.MutationResult<UpdateStoppedRunAlertMutation>;
export type UpdateStoppedRunAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>;
export const CreateScriptableRunAlertDocument = gql`
    mutation CreateScriptableRunAlert($entityName: String!) {
  createScriptableRunAlert(input: {entityName: $entityName}) {
    alert {
      id
      condition {
        __typename
        ... on ScriptableRunCondition {
          success
        }
      }
      subscriptions {
        id
      }
    }
  }
}
    `;
export type CreateScriptableRunAlertMutationFn = ApolloReactCommon.MutationFunction<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>;
export type CreateScriptableRunAlertComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>, 'mutation'>;

    export const CreateScriptableRunAlertComponent = (props: CreateScriptableRunAlertComponentProps) => (
      <ApolloReactComponents.Mutation<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables> mutation={CreateScriptableRunAlertDocument} {...props} />
    );
    
export type CreateScriptableRunAlertProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>
    } & TChildProps;
export function withCreateScriptableRunAlert<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateScriptableRunAlertMutation,
  CreateScriptableRunAlertMutationVariables,
  CreateScriptableRunAlertProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables, CreateScriptableRunAlertProps<TChildProps, TDataName>>(CreateScriptableRunAlertDocument, {
      alias: 'createScriptableRunAlert',
      ...operationOptions
    });
};

/**
 * __useCreateScriptableRunAlertMutation__
 *
 * To run a mutation, you first call `useCreateScriptableRunAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScriptableRunAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScriptableRunAlertMutation, { data, loading, error }] = useCreateScriptableRunAlertMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCreateScriptableRunAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>(CreateScriptableRunAlertDocument, options);
      }
export type CreateScriptableRunAlertMutationHookResult = ReturnType<typeof useCreateScriptableRunAlertMutation>;
export type CreateScriptableRunAlertMutationResult = ApolloReactCommon.MutationResult<CreateScriptableRunAlertMutation>;
export type CreateScriptableRunAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>;
export const DeleteAlertDocument = gql`
    mutation DeleteAlert($id: ID!) {
  deleteAlert(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteAlertMutationFn = ApolloReactCommon.MutationFunction<DeleteAlertMutation, DeleteAlertMutationVariables>;
export type DeleteAlertComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteAlertMutation, DeleteAlertMutationVariables>, 'mutation'>;

    export const DeleteAlertComponent = (props: DeleteAlertComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteAlertMutation, DeleteAlertMutationVariables> mutation={DeleteAlertDocument} {...props} />
    );
    
export type DeleteAlertProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteAlertMutation, DeleteAlertMutationVariables>
    } & TChildProps;
export function withDeleteAlert<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteAlertMutation,
  DeleteAlertMutationVariables,
  DeleteAlertProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteAlertMutation, DeleteAlertMutationVariables, DeleteAlertProps<TChildProps, TDataName>>(DeleteAlertDocument, {
      alias: 'deleteAlert',
      ...operationOptions
    });
};

/**
 * __useDeleteAlertMutation__
 *
 * To run a mutation, you first call `useDeleteAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertMutation, { data, loading, error }] = useDeleteAlertMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAlertMutation, DeleteAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAlertMutation, DeleteAlertMutationVariables>(DeleteAlertDocument, options);
      }
export type DeleteAlertMutationHookResult = ReturnType<typeof useDeleteAlertMutation>;
export type DeleteAlertMutationResult = ApolloReactCommon.MutationResult<DeleteAlertMutation>;
export type DeleteAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAlertMutation, DeleteAlertMutationVariables>;
export const CreateSlackChannelSubscriptionDocument = gql`
    mutation CreateSlackChannelSubscription($alertID: ID!, $integrationID: ID!) {
  createSlackChannelSubscription(
    input: {alertID: $alertID, integrationID: $integrationID}
  ) {
    subscription {
      id
    }
  }
}
    `;
export type CreateSlackChannelSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>;
export type CreateSlackChannelSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>, 'mutation'>;

    export const CreateSlackChannelSubscriptionComponent = (props: CreateSlackChannelSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables> mutation={CreateSlackChannelSubscriptionDocument} {...props} />
    );
    
export type CreateSlackChannelSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateSlackChannelSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSlackChannelSubscriptionMutation,
  CreateSlackChannelSubscriptionMutationVariables,
  CreateSlackChannelSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables, CreateSlackChannelSubscriptionProps<TChildProps, TDataName>>(CreateSlackChannelSubscriptionDocument, {
      alias: 'createSlackChannelSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateSlackChannelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSlackChannelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackChannelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackChannelSubscriptionMutation, { data, loading, error }] = useCreateSlackChannelSubscriptionMutation({
 *   variables: {
 *      alertID: // value for 'alertID'
 *      integrationID: // value for 'integrationID'
 *   },
 * });
 */
export function useCreateSlackChannelSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>(CreateSlackChannelSubscriptionDocument, options);
      }
export type CreateSlackChannelSubscriptionMutationHookResult = ReturnType<typeof useCreateSlackChannelSubscriptionMutation>;
export type CreateSlackChannelSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateSlackChannelSubscriptionMutation>;
export type CreateSlackChannelSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>;
export const CreateEmailSubscriptionDocument = gql`
    mutation CreateEmailSubscription($alertID: ID!) {
  createEmailSubscription(input: {alertID: $alertID}) {
    subscription {
      id
    }
  }
}
    `;
export type CreateEmailSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>;
export type CreateEmailSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>, 'mutation'>;

    export const CreateEmailSubscriptionComponent = (props: CreateEmailSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables> mutation={CreateEmailSubscriptionDocument} {...props} />
    );
    
export type CreateEmailSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateEmailSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateEmailSubscriptionMutation,
  CreateEmailSubscriptionMutationVariables,
  CreateEmailSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables, CreateEmailSubscriptionProps<TChildProps, TDataName>>(CreateEmailSubscriptionDocument, {
      alias: 'createEmailSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateEmailSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateEmailSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailSubscriptionMutation, { data, loading, error }] = useCreateEmailSubscriptionMutation({
 *   variables: {
 *      alertID: // value for 'alertID'
 *   },
 * });
 */
export function useCreateEmailSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>(CreateEmailSubscriptionDocument, options);
      }
export type CreateEmailSubscriptionMutationHookResult = ReturnType<typeof useCreateEmailSubscriptionMutation>;
export type CreateEmailSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateEmailSubscriptionMutation>;
export type CreateEmailSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>;
export const CreateViewCommentsAlertSubscriptionDocument = gql`
    mutation CreateViewCommentsAlertSubscription($viewID: ID!) {
  createViewCommentsAlertSubscription(input: {viewID: $viewID}) {
    subscription {
      id
    }
  }
}
    `;
export type CreateViewCommentsAlertSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>;
export type CreateViewCommentsAlertSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>, 'mutation'>;

    export const CreateViewCommentsAlertSubscriptionComponent = (props: CreateViewCommentsAlertSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables> mutation={CreateViewCommentsAlertSubscriptionDocument} {...props} />
    );
    
export type CreateViewCommentsAlertSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateViewCommentsAlertSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateViewCommentsAlertSubscriptionMutation,
  CreateViewCommentsAlertSubscriptionMutationVariables,
  CreateViewCommentsAlertSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables, CreateViewCommentsAlertSubscriptionProps<TChildProps, TDataName>>(CreateViewCommentsAlertSubscriptionDocument, {
      alias: 'createViewCommentsAlertSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateViewCommentsAlertSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateViewCommentsAlertSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViewCommentsAlertSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViewCommentsAlertSubscriptionMutation, { data, loading, error }] = useCreateViewCommentsAlertSubscriptionMutation({
 *   variables: {
 *      viewID: // value for 'viewID'
 *   },
 * });
 */
export function useCreateViewCommentsAlertSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>(CreateViewCommentsAlertSubscriptionDocument, options);
      }
export type CreateViewCommentsAlertSubscriptionMutationHookResult = ReturnType<typeof useCreateViewCommentsAlertSubscriptionMutation>;
export type CreateViewCommentsAlertSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateViewCommentsAlertSubscriptionMutation>;
export type CreateViewCommentsAlertSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>;
export const DeleteAlertSubscriptionDocument = gql`
    mutation DeleteAlertSubscription($id: ID!) {
  deleteAlertSubscription(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteAlertSubscriptionMutationFn = ApolloReactCommon.MutationFunction<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>;
export type DeleteAlertSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>, 'mutation'>;

    export const DeleteAlertSubscriptionComponent = (props: DeleteAlertSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables> mutation={DeleteAlertSubscriptionDocument} {...props} />
    );
    
export type DeleteAlertSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>
    } & TChildProps;
export function withDeleteAlertSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteAlertSubscriptionMutation,
  DeleteAlertSubscriptionMutationVariables,
  DeleteAlertSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables, DeleteAlertSubscriptionProps<TChildProps, TDataName>>(DeleteAlertSubscriptionDocument, {
      alias: 'deleteAlertSubscription',
      ...operationOptions
    });
};

/**
 * __useDeleteAlertSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteAlertSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertSubscriptionMutation, { data, loading, error }] = useDeleteAlertSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlertSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>(DeleteAlertSubscriptionDocument, options);
      }
export type DeleteAlertSubscriptionMutationHookResult = ReturnType<typeof useDeleteAlertSubscriptionMutation>;
export type DeleteAlertSubscriptionMutationResult = ApolloReactCommon.MutationResult<DeleteAlertSubscriptionMutation>;
export type DeleteAlertSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>;
export const BenchmarkProjectDocument = gql`
    query BenchmarkProject($name: String!, $entityName: String) {
  project(name: $name, entityName: $entityName) {
    id
    access
    name
    description
    readOnly
    entityName
    views
    gitHubSubmissionRepo
    acceptedBenchmarkRuns: benchmarkRuns(state: "ACCEPTED") {
      ...benchmarkRunsFragment
    }
    rejectedBenchmarkRuns: benchmarkRuns(state: "REJECTED") {
      ...benchmarkRunsFragment
    }
    submittedBenchmarkRuns: benchmarkRuns(state: "SUBMITTED") {
      ...benchmarkRunsFragment
    }
    entity {
      id
      name
      photoUrl
      defaultAccess
      readOnlyAdmin
      privateOnly
      isTeam
    }
  }
}
    ${BenchmarkRunsFragmentFragmentDoc}`;
export type BenchmarkProjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>, 'query'> & ({ variables: BenchmarkProjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BenchmarkProjectComponent = (props: BenchmarkProjectComponentProps) => (
      <ApolloReactComponents.Query<BenchmarkProjectQuery, BenchmarkProjectQueryVariables> query={BenchmarkProjectDocument} {...props} />
    );
    
export type BenchmarkProjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>
    } & TChildProps;
export function withBenchmarkProject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BenchmarkProjectQuery,
  BenchmarkProjectQueryVariables,
  BenchmarkProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BenchmarkProjectQuery, BenchmarkProjectQueryVariables, BenchmarkProjectProps<TChildProps, TDataName>>(BenchmarkProjectDocument, {
      alias: 'benchmarkProject',
      ...operationOptions
    });
};

/**
 * __useBenchmarkProjectQuery__
 *
 * To run a query within a React component, call `useBenchmarkProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenchmarkProjectQuery({
 *   variables: {
 *      name: // value for 'name'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useBenchmarkProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BenchmarkProjectQuery, BenchmarkProjectQueryVariables> & ({ variables: BenchmarkProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>(BenchmarkProjectDocument, options);
      }
export function useBenchmarkProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>(BenchmarkProjectDocument, options);
        }
// @ts-ignore
export function useBenchmarkProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>;
export function useBenchmarkProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BenchmarkProjectQuery | undefined, BenchmarkProjectQueryVariables>;
export function useBenchmarkProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>(BenchmarkProjectDocument, options);
        }
export type BenchmarkProjectQueryHookResult = ReturnType<typeof useBenchmarkProjectQuery>;
export type BenchmarkProjectLazyQueryHookResult = ReturnType<typeof useBenchmarkProjectLazyQuery>;
export type BenchmarkProjectSuspenseQueryHookResult = ReturnType<typeof useBenchmarkProjectSuspenseQuery>;
export type BenchmarkProjectQueryResult = ApolloReactCommon.QueryResult<BenchmarkProjectQuery, BenchmarkProjectQueryVariables>;
export const SubmitBenchmarkRunDocument = gql`
    mutation SubmitBenchmarkRun($id: ID!, $isCodeHidden: Boolean, $benchmarkEntityName: String, $benchmarkName: String) {
  submitBenchmarkRun(
    input: {id: $id, isCodeHidden: $isCodeHidden, benchmarkEntityName: $benchmarkEntityName, benchmarkName: $benchmarkName}
  ) {
    benchmarkRun {
      id
      results
    }
  }
}
    `;
export type SubmitBenchmarkRunMutationFn = ApolloReactCommon.MutationFunction<SubmitBenchmarkRunMutation, SubmitBenchmarkRunMutationVariables>;
export type SubmitBenchmarkRunComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitBenchmarkRunMutation, SubmitBenchmarkRunMutationVariables>, 'mutation'>;

    export const SubmitBenchmarkRunComponent = (props: SubmitBenchmarkRunComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitBenchmarkRunMutation, SubmitBenchmarkRunMutationVariables> mutation={SubmitBenchmarkRunDocument} {...props} />
    );
    
export type SubmitBenchmarkRunProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SubmitBenchmarkRunMutation, SubmitBenchmarkRunMutationVariables>
    } & TChildProps;
export function withSubmitBenchmarkRun<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubmitBenchmarkRunMutation,
  SubmitBenchmarkRunMutationVariables,
  SubmitBenchmarkRunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SubmitBenchmarkRunMutation, SubmitBenchmarkRunMutationVariables, SubmitBenchmarkRunProps<TChildProps, TDataName>>(SubmitBenchmarkRunDocument, {
      alias: 'submitBenchmarkRun',
      ...operationOptions
    });
};

/**
 * __useSubmitBenchmarkRunMutation__
 *
 * To run a mutation, you first call `useSubmitBenchmarkRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBenchmarkRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBenchmarkRunMutation, { data, loading, error }] = useSubmitBenchmarkRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isCodeHidden: // value for 'isCodeHidden'
 *      benchmarkEntityName: // value for 'benchmarkEntityName'
 *      benchmarkName: // value for 'benchmarkName'
 *   },
 * });
 */
export function useSubmitBenchmarkRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitBenchmarkRunMutation, SubmitBenchmarkRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitBenchmarkRunMutation, SubmitBenchmarkRunMutationVariables>(SubmitBenchmarkRunDocument, options);
      }
export type SubmitBenchmarkRunMutationHookResult = ReturnType<typeof useSubmitBenchmarkRunMutation>;
export type SubmitBenchmarkRunMutationResult = ApolloReactCommon.MutationResult<SubmitBenchmarkRunMutation>;
export type SubmitBenchmarkRunMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitBenchmarkRunMutation, SubmitBenchmarkRunMutationVariables>;
export const PublishBenchmarkRunDocument = gql`
    mutation PublishBenchmarkRun($id: ID!, $isCodeHidden: Boolean, $benchmarkEntityName: String, $benchmarkName: String) {
  publishBenchmarkRun(
    input: {id: $id, isCodeHidden: $isCodeHidden, benchmarkEntityName: $benchmarkEntityName, benchmarkName: $benchmarkName}
  ) {
    benchmarkRun {
      id
      gitHubSubmissionPR
    }
  }
}
    `;
export type PublishBenchmarkRunMutationFn = ApolloReactCommon.MutationFunction<PublishBenchmarkRunMutation, PublishBenchmarkRunMutationVariables>;
export type PublishBenchmarkRunComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PublishBenchmarkRunMutation, PublishBenchmarkRunMutationVariables>, 'mutation'>;

    export const PublishBenchmarkRunComponent = (props: PublishBenchmarkRunComponentProps) => (
      <ApolloReactComponents.Mutation<PublishBenchmarkRunMutation, PublishBenchmarkRunMutationVariables> mutation={PublishBenchmarkRunDocument} {...props} />
    );
    
export type PublishBenchmarkRunProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<PublishBenchmarkRunMutation, PublishBenchmarkRunMutationVariables>
    } & TChildProps;
export function withPublishBenchmarkRun<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PublishBenchmarkRunMutation,
  PublishBenchmarkRunMutationVariables,
  PublishBenchmarkRunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, PublishBenchmarkRunMutation, PublishBenchmarkRunMutationVariables, PublishBenchmarkRunProps<TChildProps, TDataName>>(PublishBenchmarkRunDocument, {
      alias: 'publishBenchmarkRun',
      ...operationOptions
    });
};

/**
 * __usePublishBenchmarkRunMutation__
 *
 * To run a mutation, you first call `usePublishBenchmarkRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishBenchmarkRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishBenchmarkRunMutation, { data, loading, error }] = usePublishBenchmarkRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isCodeHidden: // value for 'isCodeHidden'
 *      benchmarkEntityName: // value for 'benchmarkEntityName'
 *      benchmarkName: // value for 'benchmarkName'
 *   },
 * });
 */
export function usePublishBenchmarkRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishBenchmarkRunMutation, PublishBenchmarkRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishBenchmarkRunMutation, PublishBenchmarkRunMutationVariables>(PublishBenchmarkRunDocument, options);
      }
export type PublishBenchmarkRunMutationHookResult = ReturnType<typeof usePublishBenchmarkRunMutation>;
export type PublishBenchmarkRunMutationResult = ApolloReactCommon.MutationResult<PublishBenchmarkRunMutation>;
export type PublishBenchmarkRunMutationOptions = ApolloReactCommon.BaseMutationOptions<PublishBenchmarkRunMutation, PublishBenchmarkRunMutationVariables>;
export const UpdateBenchmarkRunDocument = gql`
    mutation UpdateBenchmarkRun($id: ID!, $state: String, $details: JSONString) {
  updateBenchmarkRun(input: {id: $id, state: $state, details: $details}) {
    benchmarkRun {
      id
      state
      details
    }
  }
}
    `;
export type UpdateBenchmarkRunMutationFn = ApolloReactCommon.MutationFunction<UpdateBenchmarkRunMutation, UpdateBenchmarkRunMutationVariables>;
export type UpdateBenchmarkRunComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateBenchmarkRunMutation, UpdateBenchmarkRunMutationVariables>, 'mutation'>;

    export const UpdateBenchmarkRunComponent = (props: UpdateBenchmarkRunComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateBenchmarkRunMutation, UpdateBenchmarkRunMutationVariables> mutation={UpdateBenchmarkRunDocument} {...props} />
    );
    
export type UpdateBenchmarkRunProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateBenchmarkRunMutation, UpdateBenchmarkRunMutationVariables>
    } & TChildProps;
export function withUpdateBenchmarkRun<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateBenchmarkRunMutation,
  UpdateBenchmarkRunMutationVariables,
  UpdateBenchmarkRunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateBenchmarkRunMutation, UpdateBenchmarkRunMutationVariables, UpdateBenchmarkRunProps<TChildProps, TDataName>>(UpdateBenchmarkRunDocument, {
      alias: 'updateBenchmarkRun',
      ...operationOptions
    });
};

/**
 * __useUpdateBenchmarkRunMutation__
 *
 * To run a mutation, you first call `useUpdateBenchmarkRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBenchmarkRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBenchmarkRunMutation, { data, loading, error }] = useUpdateBenchmarkRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateBenchmarkRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBenchmarkRunMutation, UpdateBenchmarkRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBenchmarkRunMutation, UpdateBenchmarkRunMutationVariables>(UpdateBenchmarkRunDocument, options);
      }
export type UpdateBenchmarkRunMutationHookResult = ReturnType<typeof useUpdateBenchmarkRunMutation>;
export type UpdateBenchmarkRunMutationResult = ApolloReactCommon.MutationResult<UpdateBenchmarkRunMutation>;
export type UpdateBenchmarkRunMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBenchmarkRunMutation, UpdateBenchmarkRunMutationVariables>;
export const CreateReportsPromptDocument = gql`
    query CreateReportsPrompt($entityName: String, $last: Int) {
  viewer(entityName: $entityName) {
    id
    runs(last: $last, order: "-updated_at") {
      edges {
        node {
          id
          createdAt
          project {
            id
            name
            entityName
          }
          updatedAt
        }
      }
    }
  }
}
    `;
export type CreateReportsPromptComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>, 'query'>;

    export const CreateReportsPromptComponent = (props: CreateReportsPromptComponentProps) => (
      <ApolloReactComponents.Query<CreateReportsPromptQuery, CreateReportsPromptQueryVariables> query={CreateReportsPromptDocument} {...props} />
    );
    
export type CreateReportsPromptProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>
    } & TChildProps;
export function withCreateReportsPrompt<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateReportsPromptQuery,
  CreateReportsPromptQueryVariables,
  CreateReportsPromptProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CreateReportsPromptQuery, CreateReportsPromptQueryVariables, CreateReportsPromptProps<TChildProps, TDataName>>(CreateReportsPromptDocument, {
      alias: 'createReportsPrompt',
      ...operationOptions
    });
};

/**
 * __useCreateReportsPromptQuery__
 *
 * To run a query within a React component, call `useCreateReportsPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateReportsPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateReportsPromptQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCreateReportsPromptQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>(CreateReportsPromptDocument, options);
      }
export function useCreateReportsPromptLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>(CreateReportsPromptDocument, options);
        }
// @ts-ignore
export function useCreateReportsPromptSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>;
export function useCreateReportsPromptSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateReportsPromptQuery | undefined, CreateReportsPromptQueryVariables>;
export function useCreateReportsPromptSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>(CreateReportsPromptDocument, options);
        }
export type CreateReportsPromptQueryHookResult = ReturnType<typeof useCreateReportsPromptQuery>;
export type CreateReportsPromptLazyQueryHookResult = ReturnType<typeof useCreateReportsPromptLazyQuery>;
export type CreateReportsPromptSuspenseQueryHookResult = ReturnType<typeof useCreateReportsPromptSuspenseQuery>;
export type CreateReportsPromptQueryResult = ApolloReactCommon.QueryResult<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>;
export const CreateCustomChartDocument = gql`
    mutation CreateCustomChart($entity: String!, $name: String!, $displayName: String!, $type: String!, $access: String!, $spec: JSONString!) {
  createCustomChart(
    input: {entity: $entity, name: $name, displayName: $displayName, type: $type, access: $access, spec: $spec}
  ) {
    chart {
      id
      ...CustomChartFragment
    }
  }
}
    ${CustomChartFragmentFragmentDoc}`;
export type CreateCustomChartMutationFn = ApolloReactCommon.MutationFunction<CreateCustomChartMutation, CreateCustomChartMutationVariables>;
export type CreateCustomChartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCustomChartMutation, CreateCustomChartMutationVariables>, 'mutation'>;

    export const CreateCustomChartComponent = (props: CreateCustomChartComponentProps) => (
      <ApolloReactComponents.Mutation<CreateCustomChartMutation, CreateCustomChartMutationVariables> mutation={CreateCustomChartDocument} {...props} />
    );
    
export type CreateCustomChartProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateCustomChartMutation, CreateCustomChartMutationVariables>
    } & TChildProps;
export function withCreateCustomChart<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCustomChartMutation,
  CreateCustomChartMutationVariables,
  CreateCustomChartProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCustomChartMutation, CreateCustomChartMutationVariables, CreateCustomChartProps<TChildProps, TDataName>>(CreateCustomChartDocument, {
      alias: 'createCustomChart',
      ...operationOptions
    });
};

/**
 * __useCreateCustomChartMutation__
 *
 * To run a mutation, you first call `useCreateCustomChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomChartMutation, { data, loading, error }] = useCreateCustomChartMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      type: // value for 'type'
 *      access: // value for 'access'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useCreateCustomChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomChartMutation, CreateCustomChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomChartMutation, CreateCustomChartMutationVariables>(CreateCustomChartDocument, options);
      }
export type CreateCustomChartMutationHookResult = ReturnType<typeof useCreateCustomChartMutation>;
export type CreateCustomChartMutationResult = ApolloReactCommon.MutationResult<CreateCustomChartMutation>;
export type CreateCustomChartMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomChartMutation, CreateCustomChartMutationVariables>;
export const UpdateCustomChartDocument = gql`
    mutation UpdateCustomChart($entity: String!, $name: String!, $displayName: String, $type: String, $access: String, $spec: JSONString) {
  updateCustomChart(
    input: {entity: $entity, name: $name, displayName: $displayName, type: $type, access: $access, spec: $spec}
  ) {
    chart {
      id
      ...CustomChartFragment
    }
  }
}
    ${CustomChartFragmentFragmentDoc}`;
export type UpdateCustomChartMutationFn = ApolloReactCommon.MutationFunction<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>;
export type UpdateCustomChartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>, 'mutation'>;

    export const UpdateCustomChartComponent = (props: UpdateCustomChartComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCustomChartMutation, UpdateCustomChartMutationVariables> mutation={UpdateCustomChartDocument} {...props} />
    );
    
export type UpdateCustomChartProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>
    } & TChildProps;
export function withUpdateCustomChart<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCustomChartMutation,
  UpdateCustomChartMutationVariables,
  UpdateCustomChartProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCustomChartMutation, UpdateCustomChartMutationVariables, UpdateCustomChartProps<TChildProps, TDataName>>(UpdateCustomChartDocument, {
      alias: 'updateCustomChart',
      ...operationOptions
    });
};

/**
 * __useUpdateCustomChartMutation__
 *
 * To run a mutation, you first call `useUpdateCustomChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomChartMutation, { data, loading, error }] = useUpdateCustomChartMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      type: // value for 'type'
 *      access: // value for 'access'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useUpdateCustomChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>(UpdateCustomChartDocument, options);
      }
export type UpdateCustomChartMutationHookResult = ReturnType<typeof useUpdateCustomChartMutation>;
export type UpdateCustomChartMutationResult = ApolloReactCommon.MutationResult<UpdateCustomChartMutation>;
export type UpdateCustomChartMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>;
export const DeleteCustomChartDocument = gql`
    mutation DeleteCustomChart($entity: String!, $name: String!) {
  deleteCustomChart(input: {entity: $entity, name: $name}) {
    success
  }
}
    `;
export type DeleteCustomChartMutationFn = ApolloReactCommon.MutationFunction<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>;
export type DeleteCustomChartComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>, 'mutation'>;

    export const DeleteCustomChartComponent = (props: DeleteCustomChartComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteCustomChartMutation, DeleteCustomChartMutationVariables> mutation={DeleteCustomChartDocument} {...props} />
    );
    
export type DeleteCustomChartProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>
    } & TChildProps;
export function withDeleteCustomChart<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteCustomChartMutation,
  DeleteCustomChartMutationVariables,
  DeleteCustomChartProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteCustomChartMutation, DeleteCustomChartMutationVariables, DeleteCustomChartProps<TChildProps, TDataName>>(DeleteCustomChartDocument, {
      alias: 'deleteCustomChart',
      ...operationOptions
    });
};

/**
 * __useDeleteCustomChartMutation__
 *
 * To run a mutation, you first call `useDeleteCustomChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomChartMutation, { data, loading, error }] = useDeleteCustomChartMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteCustomChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>(DeleteCustomChartDocument, options);
      }
export type DeleteCustomChartMutationHookResult = ReturnType<typeof useDeleteCustomChartMutation>;
export type DeleteCustomChartMutationResult = ApolloReactCommon.MutationResult<DeleteCustomChartMutation>;
export type DeleteCustomChartMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>;
export const CustomChartsDocument = gql`
    query CustomCharts($entity: String!) {
  customCharts(type: "vega2", entity: $entity) {
    edges {
      node {
        id
        ...CustomChartFragment
      }
    }
  }
}
    ${CustomChartFragmentFragmentDoc}`;
export type CustomChartsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CustomChartsQuery, CustomChartsQueryVariables>, 'query'> & ({ variables: CustomChartsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CustomChartsComponent = (props: CustomChartsComponentProps) => (
      <ApolloReactComponents.Query<CustomChartsQuery, CustomChartsQueryVariables> query={CustomChartsDocument} {...props} />
    );
    
export type CustomChartsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CustomChartsQuery, CustomChartsQueryVariables>
    } & TChildProps;
export function withCustomCharts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CustomChartsQuery,
  CustomChartsQueryVariables,
  CustomChartsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CustomChartsQuery, CustomChartsQueryVariables, CustomChartsProps<TChildProps, TDataName>>(CustomChartsDocument, {
      alias: 'customCharts',
      ...operationOptions
    });
};

/**
 * __useCustomChartsQuery__
 *
 * To run a query within a React component, call `useCustomChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomChartsQuery({
 *   variables: {
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useCustomChartsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables> & ({ variables: CustomChartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomChartsQuery, CustomChartsQueryVariables>(CustomChartsDocument, options);
      }
export function useCustomChartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomChartsQuery, CustomChartsQueryVariables>(CustomChartsDocument, options);
        }
// @ts-ignore
export function useCustomChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomChartsQuery, CustomChartsQueryVariables>;
export function useCustomChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomChartsQuery | undefined, CustomChartsQueryVariables>;
export function useCustomChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomChartsQuery, CustomChartsQueryVariables>(CustomChartsDocument, options);
        }
export type CustomChartsQueryHookResult = ReturnType<typeof useCustomChartsQuery>;
export type CustomChartsLazyQueryHookResult = ReturnType<typeof useCustomChartsLazyQuery>;
export type CustomChartsSuspenseQueryHookResult = ReturnType<typeof useCustomChartsSuspenseQuery>;
export type CustomChartsQueryResult = ApolloReactCommon.QueryResult<CustomChartsQuery, CustomChartsQueryVariables>;
export const CustomChartDocument = gql`
    query CustomChart($id: ID!) {
  customChart(id: $id) {
    id
    ...CustomChartFragment
  }
}
    ${CustomChartFragmentFragmentDoc}`;
export type CustomChartComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CustomChartQuery, CustomChartQueryVariables>, 'query'> & ({ variables: CustomChartQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CustomChartComponent = (props: CustomChartComponentProps) => (
      <ApolloReactComponents.Query<CustomChartQuery, CustomChartQueryVariables> query={CustomChartDocument} {...props} />
    );
    
export type CustomChartProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CustomChartQuery, CustomChartQueryVariables>
    } & TChildProps;
export function withCustomChart<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CustomChartQuery,
  CustomChartQueryVariables,
  CustomChartProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CustomChartQuery, CustomChartQueryVariables, CustomChartProps<TChildProps, TDataName>>(CustomChartDocument, {
      alias: 'customChart',
      ...operationOptions
    });
};

/**
 * __useCustomChartQuery__
 *
 * To run a query within a React component, call `useCustomChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomChartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomChartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomChartQuery, CustomChartQueryVariables> & ({ variables: CustomChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomChartQuery, CustomChartQueryVariables>(CustomChartDocument, options);
      }
export function useCustomChartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomChartQuery, CustomChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomChartQuery, CustomChartQueryVariables>(CustomChartDocument, options);
        }
// @ts-ignore
export function useCustomChartSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CustomChartQuery, CustomChartQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomChartQuery, CustomChartQueryVariables>;
export function useCustomChartSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomChartQuery, CustomChartQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomChartQuery | undefined, CustomChartQueryVariables>;
export function useCustomChartSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomChartQuery, CustomChartQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomChartQuery, CustomChartQueryVariables>(CustomChartDocument, options);
        }
export type CustomChartQueryHookResult = ReturnType<typeof useCustomChartQuery>;
export type CustomChartLazyQueryHookResult = ReturnType<typeof useCustomChartLazyQuery>;
export type CustomChartSuspenseQueryHookResult = ReturnType<typeof useCustomChartSuspenseQuery>;
export type CustomChartQueryResult = ApolloReactCommon.QueryResult<CustomChartQuery, CustomChartQueryVariables>;
export const CreateCustomerSubscriptionDocument = gql`
    mutation createCustomerSubscription($planId: ID!, $newOrganizationName: String!, $paymentMethod: String!, $quantity: Int!, $trial: Boolean!, $clientMutationId: String) {
  createCustomerSubscription(
    input: {planId: $planId, newOrganizationName: $newOrganizationName, paymentMethod: $paymentMethod, quantity: $quantity, trial: $trial, clientMutationId: $clientMutationId}
  ) {
    subscription
    organizationId
    clientMutationId
  }
}
    `;
export type CreateCustomerSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>;
export type CreateCustomerSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>, 'mutation'>;

    export const CreateCustomerSubscriptionComponent = (props: CreateCustomerSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables> mutation={CreateCustomerSubscriptionDocument} {...props} />
    );
    
export type CreateCustomerSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateCustomerSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCustomerSubscriptionMutation,
  CreateCustomerSubscriptionMutationVariables,
  CreateCustomerSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables, CreateCustomerSubscriptionProps<TChildProps, TDataName>>(CreateCustomerSubscriptionDocument, {
      alias: 'createCustomerSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSubscriptionMutation, { data, loading, error }] = useCreateCustomerSubscriptionMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      newOrganizationName: // value for 'newOrganizationName'
 *      paymentMethod: // value for 'paymentMethod'
 *      quantity: // value for 'quantity'
 *      trial: // value for 'trial'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateCustomerSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>(CreateCustomerSubscriptionDocument, options);
      }
export type CreateCustomerSubscriptionMutationHookResult = ReturnType<typeof useCreateCustomerSubscriptionMutation>;
export type CreateCustomerSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateCustomerSubscriptionMutation>;
export type CreateCustomerSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>;
export const CreateAcademicOrReverseTrialDocument = gql`
    mutation createAcademicOrReverseTrial($newOrganizationName: String!, $newTeamName: String!, $isAcademic: Boolean!, $clientMutationId: String) {
  createAcademicOrReverseTrial(
    input: {newOrganizationName: $newOrganizationName, newTeamName: $newTeamName, isAcademic: $isAcademic, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
    orgID
  }
}
    `;
export type CreateAcademicOrReverseTrialMutationFn = ApolloReactCommon.MutationFunction<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>;
export type CreateAcademicOrReverseTrialComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>, 'mutation'>;

    export const CreateAcademicOrReverseTrialComponent = (props: CreateAcademicOrReverseTrialComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables> mutation={CreateAcademicOrReverseTrialDocument} {...props} />
    );
    
export type CreateAcademicOrReverseTrialProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>
    } & TChildProps;
export function withCreateAcademicOrReverseTrial<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAcademicOrReverseTrialMutation,
  CreateAcademicOrReverseTrialMutationVariables,
  CreateAcademicOrReverseTrialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables, CreateAcademicOrReverseTrialProps<TChildProps, TDataName>>(CreateAcademicOrReverseTrialDocument, {
      alias: 'createAcademicOrReverseTrial',
      ...operationOptions
    });
};

/**
 * __useCreateAcademicOrReverseTrialMutation__
 *
 * To run a mutation, you first call `useCreateAcademicOrReverseTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAcademicOrReverseTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAcademicOrReverseTrialMutation, { data, loading, error }] = useCreateAcademicOrReverseTrialMutation({
 *   variables: {
 *      newOrganizationName: // value for 'newOrganizationName'
 *      newTeamName: // value for 'newTeamName'
 *      isAcademic: // value for 'isAcademic'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateAcademicOrReverseTrialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>(CreateAcademicOrReverseTrialDocument, options);
      }
export type CreateAcademicOrReverseTrialMutationHookResult = ReturnType<typeof useCreateAcademicOrReverseTrialMutation>;
export type CreateAcademicOrReverseTrialMutationResult = ApolloReactCommon.MutationResult<CreateAcademicOrReverseTrialMutation>;
export type CreateAcademicOrReverseTrialMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>;
export const CreateCustomerTrialDocument = gql`
    mutation createCustomerTrial($planId: ID!, $userName: String!, $newOrganizationName: String!, $quantity: Int!, $trialDays: Int!, $clientMutationId: String) {
  createCustomerTrial(
    input: {planId: $planId, userName: $userName, newOrganizationName: $newOrganizationName, quantity: $quantity, trialDays: $trialDays, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateCustomerTrialMutationFn = ApolloReactCommon.MutationFunction<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>;
export type CreateCustomerTrialComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>, 'mutation'>;

    export const CreateCustomerTrialComponent = (props: CreateCustomerTrialComponentProps) => (
      <ApolloReactComponents.Mutation<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables> mutation={CreateCustomerTrialDocument} {...props} />
    );
    
export type CreateCustomerTrialProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>
    } & TChildProps;
export function withCreateCustomerTrial<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCustomerTrialMutation,
  CreateCustomerTrialMutationVariables,
  CreateCustomerTrialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables, CreateCustomerTrialProps<TChildProps, TDataName>>(CreateCustomerTrialDocument, {
      alias: 'createCustomerTrial',
      ...operationOptions
    });
};

/**
 * __useCreateCustomerTrialMutation__
 *
 * To run a mutation, you first call `useCreateCustomerTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerTrialMutation, { data, loading, error }] = useCreateCustomerTrialMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      userName: // value for 'userName'
 *      newOrganizationName: // value for 'newOrganizationName'
 *      quantity: // value for 'quantity'
 *      trialDays: // value for 'trialDays'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateCustomerTrialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>(CreateCustomerTrialDocument, options);
      }
export type CreateCustomerTrialMutationHookResult = ReturnType<typeof useCreateCustomerTrialMutation>;
export type CreateCustomerTrialMutationResult = ApolloReactCommon.MutationResult<CreateCustomerTrialMutation>;
export type CreateCustomerTrialMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>;
export const CancelCustomerSubscriptionDocument = gql`
    mutation cancelCustomerSubscription($organizationId: ID!, $clientMutationId: String) {
  cancelCustomerSubscription(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type CancelCustomerSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>;
export type CancelCustomerSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>, 'mutation'>;

    export const CancelCustomerSubscriptionComponent = (props: CancelCustomerSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables> mutation={CancelCustomerSubscriptionDocument} {...props} />
    );
    
export type CancelCustomerSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>
    } & TChildProps;
export function withCancelCustomerSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CancelCustomerSubscriptionMutation,
  CancelCustomerSubscriptionMutationVariables,
  CancelCustomerSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables, CancelCustomerSubscriptionProps<TChildProps, TDataName>>(CancelCustomerSubscriptionDocument, {
      alias: 'cancelCustomerSubscription',
      ...operationOptions
    });
};

/**
 * __useCancelCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCustomerSubscriptionMutation, { data, loading, error }] = useCancelCustomerSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCancelCustomerSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>(CancelCustomerSubscriptionDocument, options);
      }
export type CancelCustomerSubscriptionMutationHookResult = ReturnType<typeof useCancelCustomerSubscriptionMutation>;
export type CancelCustomerSubscriptionMutationResult = ApolloReactCommon.MutationResult<CancelCustomerSubscriptionMutation>;
export type CancelCustomerSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>;
export const UpdateCustomerPaymentMethodDocument = gql`
    mutation updateCustomerPaymentMethod($organizationId: ID!, $paymentMethod: String!, $clientMutationId: String) {
  updateCustomerPaymentMethod(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateCustomerPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>;
export type UpdateCustomerPaymentMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>, 'mutation'>;

    export const UpdateCustomerPaymentMethodComponent = (props: UpdateCustomerPaymentMethodComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables> mutation={UpdateCustomerPaymentMethodDocument} {...props} />
    );
    
export type UpdateCustomerPaymentMethodProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>
    } & TChildProps;
export function withUpdateCustomerPaymentMethod<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCustomerPaymentMethodMutation,
  UpdateCustomerPaymentMethodMutationVariables,
  UpdateCustomerPaymentMethodProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables, UpdateCustomerPaymentMethodProps<TChildProps, TDataName>>(UpdateCustomerPaymentMethodDocument, {
      alias: 'updateCustomerPaymentMethod',
      ...operationOptions
    });
};

/**
 * __useUpdateCustomerPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerPaymentMethodMutation, { data, loading, error }] = useUpdateCustomerPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateCustomerPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>(UpdateCustomerPaymentMethodDocument, options);
      }
export type UpdateCustomerPaymentMethodMutationHookResult = ReturnType<typeof useUpdateCustomerPaymentMethodMutation>;
export type UpdateCustomerPaymentMethodMutationResult = ApolloReactCommon.MutationResult<UpdateCustomerPaymentMethodMutation>;
export type UpdateCustomerPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>;
export const AttachCustomerPaymentMethodDocument = gql`
    mutation attachCustomerPaymentMethod($organizationId: ID!, $paymentMethod: String!, $clientMutationId: String) {
  attachCustomerPaymentMethod(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type AttachCustomerPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>;
export type AttachCustomerPaymentMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>, 'mutation'>;

    export const AttachCustomerPaymentMethodComponent = (props: AttachCustomerPaymentMethodComponentProps) => (
      <ApolloReactComponents.Mutation<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables> mutation={AttachCustomerPaymentMethodDocument} {...props} />
    );
    
export type AttachCustomerPaymentMethodProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>
    } & TChildProps;
export function withAttachCustomerPaymentMethod<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AttachCustomerPaymentMethodMutation,
  AttachCustomerPaymentMethodMutationVariables,
  AttachCustomerPaymentMethodProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables, AttachCustomerPaymentMethodProps<TChildProps, TDataName>>(AttachCustomerPaymentMethodDocument, {
      alias: 'attachCustomerPaymentMethod',
      ...operationOptions
    });
};

/**
 * __useAttachCustomerPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAttachCustomerPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachCustomerPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachCustomerPaymentMethodMutation, { data, loading, error }] = useAttachCustomerPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useAttachCustomerPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>(AttachCustomerPaymentMethodDocument, options);
      }
export type AttachCustomerPaymentMethodMutationHookResult = ReturnType<typeof useAttachCustomerPaymentMethodMutation>;
export type AttachCustomerPaymentMethodMutationResult = ApolloReactCommon.MutationResult<AttachCustomerPaymentMethodMutation>;
export type AttachCustomerPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>;
export const UpdateCustomerDefaultPaymentMethodDocument = gql`
    mutation updateCustomerDefaultPaymentMethod($organizationId: ID!, $paymentMethod: String!, $clientMutationId: String) {
  updateCustomerDefaultPaymentMethod(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateCustomerDefaultPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>;
export type UpdateCustomerDefaultPaymentMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>, 'mutation'>;

    export const UpdateCustomerDefaultPaymentMethodComponent = (props: UpdateCustomerDefaultPaymentMethodComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables> mutation={UpdateCustomerDefaultPaymentMethodDocument} {...props} />
    );
    
export type UpdateCustomerDefaultPaymentMethodProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>
    } & TChildProps;
export function withUpdateCustomerDefaultPaymentMethod<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCustomerDefaultPaymentMethodMutation,
  UpdateCustomerDefaultPaymentMethodMutationVariables,
  UpdateCustomerDefaultPaymentMethodProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables, UpdateCustomerDefaultPaymentMethodProps<TChildProps, TDataName>>(UpdateCustomerDefaultPaymentMethodDocument, {
      alias: 'updateCustomerDefaultPaymentMethod',
      ...operationOptions
    });
};

/**
 * __useUpdateCustomerDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerDefaultPaymentMethodMutation, { data, loading, error }] = useUpdateCustomerDefaultPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateCustomerDefaultPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>(UpdateCustomerDefaultPaymentMethodDocument, options);
      }
export type UpdateCustomerDefaultPaymentMethodMutationHookResult = ReturnType<typeof useUpdateCustomerDefaultPaymentMethodMutation>;
export type UpdateCustomerDefaultPaymentMethodMutationResult = ApolloReactCommon.MutationResult<UpdateCustomerDefaultPaymentMethodMutation>;
export type UpdateCustomerDefaultPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>;
export const DetachCustomerPaymentMethodDocument = gql`
    mutation detachCustomerPaymentMethod($organizationId: ID!, $paymentMethod: String!, $clientMutationId: String) {
  detachCustomerPaymentMethod(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type DetachCustomerPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>;
export type DetachCustomerPaymentMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>, 'mutation'>;

    export const DetachCustomerPaymentMethodComponent = (props: DetachCustomerPaymentMethodComponentProps) => (
      <ApolloReactComponents.Mutation<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables> mutation={DetachCustomerPaymentMethodDocument} {...props} />
    );
    
export type DetachCustomerPaymentMethodProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>
    } & TChildProps;
export function withDetachCustomerPaymentMethod<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DetachCustomerPaymentMethodMutation,
  DetachCustomerPaymentMethodMutationVariables,
  DetachCustomerPaymentMethodProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables, DetachCustomerPaymentMethodProps<TChildProps, TDataName>>(DetachCustomerPaymentMethodDocument, {
      alias: 'detachCustomerPaymentMethod',
      ...operationOptions
    });
};

/**
 * __useDetachCustomerPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDetachCustomerPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachCustomerPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachCustomerPaymentMethodMutation, { data, loading, error }] = useDetachCustomerPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useDetachCustomerPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>(DetachCustomerPaymentMethodDocument, options);
      }
export type DetachCustomerPaymentMethodMutationHookResult = ReturnType<typeof useDetachCustomerPaymentMethodMutation>;
export type DetachCustomerPaymentMethodMutationResult = ApolloReactCommon.MutationResult<DetachCustomerPaymentMethodMutation>;
export type DetachCustomerPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>;
export const RetryStripeOpenInvoicesByOrganizationDocument = gql`
    mutation retryStripeOpenInvoicesByOrganization($organizationId: ID!) {
  retryStripeOpenInvoicesByOrganization(input: {organizationId: $organizationId}) {
    success
    clientMutationId
  }
}
    `;
export type RetryStripeOpenInvoicesByOrganizationMutationFn = ApolloReactCommon.MutationFunction<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>;
export type RetryStripeOpenInvoicesByOrganizationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>, 'mutation'>;

    export const RetryStripeOpenInvoicesByOrganizationComponent = (props: RetryStripeOpenInvoicesByOrganizationComponentProps) => (
      <ApolloReactComponents.Mutation<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables> mutation={RetryStripeOpenInvoicesByOrganizationDocument} {...props} />
    );
    
export type RetryStripeOpenInvoicesByOrganizationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>
    } & TChildProps;
export function withRetryStripeOpenInvoicesByOrganization<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RetryStripeOpenInvoicesByOrganizationMutation,
  RetryStripeOpenInvoicesByOrganizationMutationVariables,
  RetryStripeOpenInvoicesByOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables, RetryStripeOpenInvoicesByOrganizationProps<TChildProps, TDataName>>(RetryStripeOpenInvoicesByOrganizationDocument, {
      alias: 'retryStripeOpenInvoicesByOrganization',
      ...operationOptions
    });
};

/**
 * __useRetryStripeOpenInvoicesByOrganizationMutation__
 *
 * To run a mutation, you first call `useRetryStripeOpenInvoicesByOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryStripeOpenInvoicesByOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryStripeOpenInvoicesByOrganizationMutation, { data, loading, error }] = useRetryStripeOpenInvoicesByOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRetryStripeOpenInvoicesByOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>(RetryStripeOpenInvoicesByOrganizationDocument, options);
      }
export type RetryStripeOpenInvoicesByOrganizationMutationHookResult = ReturnType<typeof useRetryStripeOpenInvoicesByOrganizationMutation>;
export type RetryStripeOpenInvoicesByOrganizationMutationResult = ApolloReactCommon.MutationResult<RetryStripeOpenInvoicesByOrganizationMutation>;
export type RetryStripeOpenInvoicesByOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>;
export const CustomerSubscriptionInfoDocument = gql`
    query CustomerSubscriptionInfo {
  viewer {
    id
    organizations {
      id
      name
      orgType
      usedSeats
      stripeBillingInfo {
        status
        cancelAtPeriodEnd
        currentPeriodEnd
        invoiceLink
        paymentMethod {
          id
          type
          cardType
          endingIn
        }
      }
      billingUser {
        id
        username
      }
      subscriptions {
        id
        plan {
          id
          name
          displayName
          unitPrice
          billingInterval
          planType
        }
        privileges
        seats
        expiresAt
        subscriptionType
        status
        billingPeriodStart
        billingPeriodEnd
      }
      teams {
        id
        name
        storageBytes
        referenceBytes
        computeHours
      }
      members {
        orgID
        id
        username
        name
        photoUrl
        admin
        teams {
          edges {
            node {
              id
              name
            }
          }
        }
        role
      }
      pendingInvites {
        id
        email
      }
    }
  }
}
    `;
export type CustomerSubscriptionInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>, 'query'>;

    export const CustomerSubscriptionInfoComponent = (props: CustomerSubscriptionInfoComponentProps) => (
      <ApolloReactComponents.Query<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables> query={CustomerSubscriptionInfoDocument} {...props} />
    );
    
export type CustomerSubscriptionInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>
    } & TChildProps;
export function withCustomerSubscriptionInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CustomerSubscriptionInfoQuery,
  CustomerSubscriptionInfoQueryVariables,
  CustomerSubscriptionInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables, CustomerSubscriptionInfoProps<TChildProps, TDataName>>(CustomerSubscriptionInfoDocument, {
      alias: 'customerSubscriptionInfo',
      ...operationOptions
    });
};

/**
 * __useCustomerSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useCustomerSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSubscriptionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerSubscriptionInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>(CustomerSubscriptionInfoDocument, options);
      }
export function useCustomerSubscriptionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>(CustomerSubscriptionInfoDocument, options);
        }
// @ts-ignore
export function useCustomerSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>;
export function useCustomerSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomerSubscriptionInfoQuery | undefined, CustomerSubscriptionInfoQueryVariables>;
export function useCustomerSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>(CustomerSubscriptionInfoDocument, options);
        }
export type CustomerSubscriptionInfoQueryHookResult = ReturnType<typeof useCustomerSubscriptionInfoQuery>;
export type CustomerSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useCustomerSubscriptionInfoLazyQuery>;
export type CustomerSubscriptionInfoSuspenseQueryHookResult = ReturnType<typeof useCustomerSubscriptionInfoSuspenseQuery>;
export type CustomerSubscriptionInfoQueryResult = ApolloReactCommon.QueryResult<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>;
export const OrganizationSubscriptionInfoDocument = gql`
    query OrganizationSubscriptionInfo($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    orgType
    flags
    usedSeats
    usedViewOnlySeats
    createdAt
    seatAvailability {
      seats
      viewOnlySeats
    }
    stripeBillingInfo {
      status
      cancelAtPeriodEnd
      currentPeriodEnd
      invoiceLink
      paymentMethod {
        id
        type
        cardType
        endingIn
      }
      paymentMetadata {
        shouldUpgradeToTeams
      }
    }
    stripePaymentMethods {
      stripePaymentMethodID
      type
      isDefault
      isFailed
      card {
        last4
        brand
      }
    }
    stripeInvoices {
      number
      created
      total
      status
      currency
      hostedInvoiceURL
      invoicePDF
      subscription {
        status
        organizationSubscriptions {
          id
          plan {
            id
            displayName
          }
        }
      }
    }
    billingUser {
      id
      username
      name
      email
      photoUrl
    }
    stripeCustomerId
    teams {
      id
      name
      memberCount
      photoUrl
    }
    subscriptions {
      id
      plan {
        id
        name
        unitPrice
        billingInterval
        planType
        maxSeats
        displayName
        defaultPrivileges
        stripePrice {
          amount
        }
      }
      privileges
      seats
      expiresAt
      subscriptionType
      status
      nextPlans {
        id
        name
        displayName
        billingInterval
        defaultPrivileges
        stripePrice {
          amount
        }
      }
      availableSeatsToPurchase
      isAutomaticUpgrade
      thresholdCrossedAt
      upgradedAt
      billingPeriodStart
      billingPeriodEnd
    }
    members {
      orgID
      id
      username
      name
      photoUrl
      admin
      email
      user {
        id
        loggedInAt
      }
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
      role
      modelsSeat
      weaveRole
    }
    pendingInvites {
      id
      email
      entity {
        id
        name
      }
      role
      createdAt
    }
  }
}
    `;
export type OrganizationSubscriptionInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>, 'query'> & ({ variables: OrganizationSubscriptionInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationSubscriptionInfoComponent = (props: OrganizationSubscriptionInfoComponentProps) => (
      <ApolloReactComponents.Query<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables> query={OrganizationSubscriptionInfoDocument} {...props} />
    );
    
export type OrganizationSubscriptionInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>
    } & TChildProps;
export function withOrganizationSubscriptionInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationSubscriptionInfoQuery,
  OrganizationSubscriptionInfoQueryVariables,
  OrganizationSubscriptionInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables, OrganizationSubscriptionInfoProps<TChildProps, TDataName>>(OrganizationSubscriptionInfoDocument, {
      alias: 'organizationSubscriptionInfo',
      ...operationOptions
    });
};

/**
 * __useOrganizationSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSubscriptionInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables> & ({ variables: OrganizationSubscriptionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>(OrganizationSubscriptionInfoDocument, options);
      }
export function useOrganizationSubscriptionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>(OrganizationSubscriptionInfoDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>;
export function useOrganizationSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionInfoQuery | undefined, OrganizationSubscriptionInfoQueryVariables>;
export function useOrganizationSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>(OrganizationSubscriptionInfoDocument, options);
        }
export type OrganizationSubscriptionInfoQueryHookResult = ReturnType<typeof useOrganizationSubscriptionInfoQuery>;
export type OrganizationSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionInfoLazyQuery>;
export type OrganizationSubscriptionInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionInfoSuspenseQuery>;
export type OrganizationSubscriptionInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>;
export const UpgradeCustomerSubscriptionDocument = gql`
    mutation upgradeCustomerSubscription($planID: ID!, $organizationID: ID!, $paymentMethod: String!, $quantity: Int!, $clientMutationId: String) {
  upgradeCustomerSubscription(
    input: {planID: $planID, organizationID: $organizationID, paymentMethod: $paymentMethod, quantity: $quantity, clientMutationId: $clientMutationId}
  ) {
    subscription
    organizationID
    clientMutationId
  }
}
    `;
export type UpgradeCustomerSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>;
export type UpgradeCustomerSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>, 'mutation'>;

    export const UpgradeCustomerSubscriptionComponent = (props: UpgradeCustomerSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables> mutation={UpgradeCustomerSubscriptionDocument} {...props} />
    );
    
export type UpgradeCustomerSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>
    } & TChildProps;
export function withUpgradeCustomerSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpgradeCustomerSubscriptionMutation,
  UpgradeCustomerSubscriptionMutationVariables,
  UpgradeCustomerSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables, UpgradeCustomerSubscriptionProps<TChildProps, TDataName>>(UpgradeCustomerSubscriptionDocument, {
      alias: 'upgradeCustomerSubscription',
      ...operationOptions
    });
};

/**
 * __useUpgradeCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeCustomerSubscriptionMutation, { data, loading, error }] = useUpgradeCustomerSubscriptionMutation({
 *   variables: {
 *      planID: // value for 'planID'
 *      organizationID: // value for 'organizationID'
 *      paymentMethod: // value for 'paymentMethod'
 *      quantity: // value for 'quantity'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpgradeCustomerSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>(UpgradeCustomerSubscriptionDocument, options);
      }
export type UpgradeCustomerSubscriptionMutationHookResult = ReturnType<typeof useUpgradeCustomerSubscriptionMutation>;
export type UpgradeCustomerSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpgradeCustomerSubscriptionMutation>;
export type UpgradeCustomerSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>;
export const UpgradeCustomerToProPlanDocument = gql`
    mutation upgradeCustomerToProPlan($planID: ID!, $organizationID: ID!, $paymentMethod: String!, $modelsSeats: Int!, $weaveIngestionTier: WeaveIngestionLimitInMb!, $monthly: Boolean, $clientMutationId: String) {
  upgradeCustomerToProPlan(
    input: {planID: $planID, organizationID: $organizationID, paymentMethod: $paymentMethod, modelsSeats: $modelsSeats, weaveIngestionTier: $weaveIngestionTier, monthly: $monthly, clientMutationId: $clientMutationId}
  ) {
    subscriptionUsage
    subscriptionCommit
    organizationID
    clientMutationId
  }
}
    `;
export type UpgradeCustomerToProPlanMutationFn = ApolloReactCommon.MutationFunction<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>;
export type UpgradeCustomerToProPlanComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>, 'mutation'>;

    export const UpgradeCustomerToProPlanComponent = (props: UpgradeCustomerToProPlanComponentProps) => (
      <ApolloReactComponents.Mutation<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables> mutation={UpgradeCustomerToProPlanDocument} {...props} />
    );
    
export type UpgradeCustomerToProPlanProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>
    } & TChildProps;
export function withUpgradeCustomerToProPlan<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpgradeCustomerToProPlanMutation,
  UpgradeCustomerToProPlanMutationVariables,
  UpgradeCustomerToProPlanProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables, UpgradeCustomerToProPlanProps<TChildProps, TDataName>>(UpgradeCustomerToProPlanDocument, {
      alias: 'upgradeCustomerToProPlan',
      ...operationOptions
    });
};

/**
 * __useUpgradeCustomerToProPlanMutation__
 *
 * To run a mutation, you first call `useUpgradeCustomerToProPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeCustomerToProPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeCustomerToProPlanMutation, { data, loading, error }] = useUpgradeCustomerToProPlanMutation({
 *   variables: {
 *      planID: // value for 'planID'
 *      organizationID: // value for 'organizationID'
 *      paymentMethod: // value for 'paymentMethod'
 *      modelsSeats: // value for 'modelsSeats'
 *      weaveIngestionTier: // value for 'weaveIngestionTier'
 *      monthly: // value for 'monthly'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpgradeCustomerToProPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>(UpgradeCustomerToProPlanDocument, options);
      }
export type UpgradeCustomerToProPlanMutationHookResult = ReturnType<typeof useUpgradeCustomerToProPlanMutation>;
export type UpgradeCustomerToProPlanMutationResult = ApolloReactCommon.MutationResult<UpgradeCustomerToProPlanMutation>;
export type UpgradeCustomerToProPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>;
export const CreateHourOverageSubscriptionDocument = gql`
    mutation createHourOverageSubscription($organizationId: ID!, $clientMutationId: String) {
  createHourOverageSubscription(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateHourOverageSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>;
export type CreateHourOverageSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>, 'mutation'>;

    export const CreateHourOverageSubscriptionComponent = (props: CreateHourOverageSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables> mutation={CreateHourOverageSubscriptionDocument} {...props} />
    );
    
export type CreateHourOverageSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateHourOverageSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateHourOverageSubscriptionMutation,
  CreateHourOverageSubscriptionMutationVariables,
  CreateHourOverageSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables, CreateHourOverageSubscriptionProps<TChildProps, TDataName>>(CreateHourOverageSubscriptionDocument, {
      alias: 'createHourOverageSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateHourOverageSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateHourOverageSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHourOverageSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHourOverageSubscriptionMutation, { data, loading, error }] = useCreateHourOverageSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateHourOverageSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>(CreateHourOverageSubscriptionDocument, options);
      }
export type CreateHourOverageSubscriptionMutationHookResult = ReturnType<typeof useCreateHourOverageSubscriptionMutation>;
export type CreateHourOverageSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateHourOverageSubscriptionMutation>;
export type CreateHourOverageSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>;
export const UpgradeTrialSubscriptionDocument = gql`
    mutation upgradeTrialSubscription($organizationID: ID!, $planID: ID!) {
  upgradeTrialSubscription(
    input: {organizationID: $organizationID, planID: $planID}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpgradeTrialSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>;
export type UpgradeTrialSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>, 'mutation'>;

    export const UpgradeTrialSubscriptionComponent = (props: UpgradeTrialSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables> mutation={UpgradeTrialSubscriptionDocument} {...props} />
    );
    
export type UpgradeTrialSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>
    } & TChildProps;
export function withUpgradeTrialSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpgradeTrialSubscriptionMutation,
  UpgradeTrialSubscriptionMutationVariables,
  UpgradeTrialSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables, UpgradeTrialSubscriptionProps<TChildProps, TDataName>>(UpgradeTrialSubscriptionDocument, {
      alias: 'upgradeTrialSubscription',
      ...operationOptions
    });
};

/**
 * __useUpgradeTrialSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeTrialSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeTrialSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeTrialSubscriptionMutation, { data, loading, error }] = useUpgradeTrialSubscriptionMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      planID: // value for 'planID'
 *   },
 * });
 */
export function useUpgradeTrialSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>(UpgradeTrialSubscriptionDocument, options);
      }
export type UpgradeTrialSubscriptionMutationHookResult = ReturnType<typeof useUpgradeTrialSubscriptionMutation>;
export type UpgradeTrialSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpgradeTrialSubscriptionMutation>;
export type UpgradeTrialSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>;
export const BenchmarkDiscussionThreadsDocument = gql`
    query BenchmarkDiscussionThreads($benchmarkEntityName: String!, $benchmarkProjectName: String!) {
  project(entityName: $benchmarkEntityName, name: $benchmarkProjectName) {
    id
    benchmarkDiscussionThreads {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          createdAt
          updatedAt
          title
          body
          upvotes
          poster {
            id
            photoUrl
            name
          }
          comments {
            totalCount
          }
        }
      }
    }
  }
}
    `;
export type BenchmarkDiscussionThreadsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>, 'query'> & ({ variables: BenchmarkDiscussionThreadsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BenchmarkDiscussionThreadsComponent = (props: BenchmarkDiscussionThreadsComponentProps) => (
      <ApolloReactComponents.Query<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables> query={BenchmarkDiscussionThreadsDocument} {...props} />
    );
    
export type BenchmarkDiscussionThreadsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>
    } & TChildProps;
export function withBenchmarkDiscussionThreads<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BenchmarkDiscussionThreadsQuery,
  BenchmarkDiscussionThreadsQueryVariables,
  BenchmarkDiscussionThreadsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables, BenchmarkDiscussionThreadsProps<TChildProps, TDataName>>(BenchmarkDiscussionThreadsDocument, {
      alias: 'benchmarkDiscussionThreads',
      ...operationOptions
    });
};

/**
 * __useBenchmarkDiscussionThreadsQuery__
 *
 * To run a query within a React component, call `useBenchmarkDiscussionThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkDiscussionThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenchmarkDiscussionThreadsQuery({
 *   variables: {
 *      benchmarkEntityName: // value for 'benchmarkEntityName'
 *      benchmarkProjectName: // value for 'benchmarkProjectName'
 *   },
 * });
 */
export function useBenchmarkDiscussionThreadsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables> & ({ variables: BenchmarkDiscussionThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>(BenchmarkDiscussionThreadsDocument, options);
      }
export function useBenchmarkDiscussionThreadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>(BenchmarkDiscussionThreadsDocument, options);
        }
// @ts-ignore
export function useBenchmarkDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>;
export function useBenchmarkDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BenchmarkDiscussionThreadsQuery | undefined, BenchmarkDiscussionThreadsQueryVariables>;
export function useBenchmarkDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>(BenchmarkDiscussionThreadsDocument, options);
        }
export type BenchmarkDiscussionThreadsQueryHookResult = ReturnType<typeof useBenchmarkDiscussionThreadsQuery>;
export type BenchmarkDiscussionThreadsLazyQueryHookResult = ReturnType<typeof useBenchmarkDiscussionThreadsLazyQuery>;
export type BenchmarkDiscussionThreadsSuspenseQueryHookResult = ReturnType<typeof useBenchmarkDiscussionThreadsSuspenseQuery>;
export type BenchmarkDiscussionThreadsQueryResult = ApolloReactCommon.QueryResult<BenchmarkDiscussionThreadsQuery, BenchmarkDiscussionThreadsQueryVariables>;
export const CreateBenchmarkDiscussionThreadDocument = gql`
    mutation CreateBenchmarkDiscussionThread($benchmarkEntityName: String!, $benchmarkProjectName: String!, $title: String!, $body: String!) {
  createBenchmarkDiscussionThread(
    input: {benchmarkEntityName: $benchmarkEntityName, benchmarkProjectName: $benchmarkProjectName, title: $title, body: $body}
  ) {
    discussionThread {
      id
      createdAt
      updatedAt
      title
      body
      upvotes
      poster {
        id
        photoUrl
        name
      }
    }
  }
}
    `;
export type CreateBenchmarkDiscussionThreadMutationFn = ApolloReactCommon.MutationFunction<CreateBenchmarkDiscussionThreadMutation, CreateBenchmarkDiscussionThreadMutationVariables>;
export type CreateBenchmarkDiscussionThreadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateBenchmarkDiscussionThreadMutation, CreateBenchmarkDiscussionThreadMutationVariables>, 'mutation'>;

    export const CreateBenchmarkDiscussionThreadComponent = (props: CreateBenchmarkDiscussionThreadComponentProps) => (
      <ApolloReactComponents.Mutation<CreateBenchmarkDiscussionThreadMutation, CreateBenchmarkDiscussionThreadMutationVariables> mutation={CreateBenchmarkDiscussionThreadDocument} {...props} />
    );
    
export type CreateBenchmarkDiscussionThreadProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateBenchmarkDiscussionThreadMutation, CreateBenchmarkDiscussionThreadMutationVariables>
    } & TChildProps;
export function withCreateBenchmarkDiscussionThread<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateBenchmarkDiscussionThreadMutation,
  CreateBenchmarkDiscussionThreadMutationVariables,
  CreateBenchmarkDiscussionThreadProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateBenchmarkDiscussionThreadMutation, CreateBenchmarkDiscussionThreadMutationVariables, CreateBenchmarkDiscussionThreadProps<TChildProps, TDataName>>(CreateBenchmarkDiscussionThreadDocument, {
      alias: 'createBenchmarkDiscussionThread',
      ...operationOptions
    });
};

/**
 * __useCreateBenchmarkDiscussionThreadMutation__
 *
 * To run a mutation, you first call `useCreateBenchmarkDiscussionThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBenchmarkDiscussionThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBenchmarkDiscussionThreadMutation, { data, loading, error }] = useCreateBenchmarkDiscussionThreadMutation({
 *   variables: {
 *      benchmarkEntityName: // value for 'benchmarkEntityName'
 *      benchmarkProjectName: // value for 'benchmarkProjectName'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateBenchmarkDiscussionThreadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBenchmarkDiscussionThreadMutation, CreateBenchmarkDiscussionThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBenchmarkDiscussionThreadMutation, CreateBenchmarkDiscussionThreadMutationVariables>(CreateBenchmarkDiscussionThreadDocument, options);
      }
export type CreateBenchmarkDiscussionThreadMutationHookResult = ReturnType<typeof useCreateBenchmarkDiscussionThreadMutation>;
export type CreateBenchmarkDiscussionThreadMutationResult = ApolloReactCommon.MutationResult<CreateBenchmarkDiscussionThreadMutation>;
export type CreateBenchmarkDiscussionThreadMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBenchmarkDiscussionThreadMutation, CreateBenchmarkDiscussionThreadMutationVariables>;
export const UpdateDiscussionThreadDocument = gql`
    mutation UpdateDiscussionThread($discussionThreadID: ID!, $body: String!) {
  updateDiscussionThread(
    input: {discussionThreadID: $discussionThreadID, body: $body}
  ) {
    discussionThread {
      id
      createdAt
      updatedAt
      title
      body
      upvotes
      poster {
        id
        photoUrl
        name
      }
    }
  }
}
    `;
export type UpdateDiscussionThreadMutationFn = ApolloReactCommon.MutationFunction<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>;
export type UpdateDiscussionThreadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>, 'mutation'>;

    export const UpdateDiscussionThreadComponent = (props: UpdateDiscussionThreadComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables> mutation={UpdateDiscussionThreadDocument} {...props} />
    );
    
export type UpdateDiscussionThreadProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>
    } & TChildProps;
export function withUpdateDiscussionThread<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDiscussionThreadMutation,
  UpdateDiscussionThreadMutationVariables,
  UpdateDiscussionThreadProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables, UpdateDiscussionThreadProps<TChildProps, TDataName>>(UpdateDiscussionThreadDocument, {
      alias: 'updateDiscussionThread',
      ...operationOptions
    });
};

/**
 * __useUpdateDiscussionThreadMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionThreadMutation, { data, loading, error }] = useUpdateDiscussionThreadMutation({
 *   variables: {
 *      discussionThreadID: // value for 'discussionThreadID'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateDiscussionThreadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>(UpdateDiscussionThreadDocument, options);
      }
export type UpdateDiscussionThreadMutationHookResult = ReturnType<typeof useUpdateDiscussionThreadMutation>;
export type UpdateDiscussionThreadMutationResult = ApolloReactCommon.MutationResult<UpdateDiscussionThreadMutation>;
export type UpdateDiscussionThreadMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>;
export const CreateBenchmarkDiscussionCommentDocument = gql`
    mutation CreateBenchmarkDiscussionComment($discussionThreadID: ID!, $parentCommentID: ID, $body: String!) {
  createBenchmarkDiscussionComment(
    input: {discussionThreadID: $discussionThreadID, parentCommentID: $parentCommentID, body: $body}
  ) {
    discussionComment {
      id
      createdAt
      updatedAt
      deletedAt
      body
      isParent
      poster {
        id
        photoUrl
        name
      }
    }
  }
}
    `;
export type CreateBenchmarkDiscussionCommentMutationFn = ApolloReactCommon.MutationFunction<CreateBenchmarkDiscussionCommentMutation, CreateBenchmarkDiscussionCommentMutationVariables>;
export type CreateBenchmarkDiscussionCommentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateBenchmarkDiscussionCommentMutation, CreateBenchmarkDiscussionCommentMutationVariables>, 'mutation'>;

    export const CreateBenchmarkDiscussionCommentComponent = (props: CreateBenchmarkDiscussionCommentComponentProps) => (
      <ApolloReactComponents.Mutation<CreateBenchmarkDiscussionCommentMutation, CreateBenchmarkDiscussionCommentMutationVariables> mutation={CreateBenchmarkDiscussionCommentDocument} {...props} />
    );
    
export type CreateBenchmarkDiscussionCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateBenchmarkDiscussionCommentMutation, CreateBenchmarkDiscussionCommentMutationVariables>
    } & TChildProps;
export function withCreateBenchmarkDiscussionComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateBenchmarkDiscussionCommentMutation,
  CreateBenchmarkDiscussionCommentMutationVariables,
  CreateBenchmarkDiscussionCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateBenchmarkDiscussionCommentMutation, CreateBenchmarkDiscussionCommentMutationVariables, CreateBenchmarkDiscussionCommentProps<TChildProps, TDataName>>(CreateBenchmarkDiscussionCommentDocument, {
      alias: 'createBenchmarkDiscussionComment',
      ...operationOptions
    });
};

/**
 * __useCreateBenchmarkDiscussionCommentMutation__
 *
 * To run a mutation, you first call `useCreateBenchmarkDiscussionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBenchmarkDiscussionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBenchmarkDiscussionCommentMutation, { data, loading, error }] = useCreateBenchmarkDiscussionCommentMutation({
 *   variables: {
 *      discussionThreadID: // value for 'discussionThreadID'
 *      parentCommentID: // value for 'parentCommentID'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateBenchmarkDiscussionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBenchmarkDiscussionCommentMutation, CreateBenchmarkDiscussionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBenchmarkDiscussionCommentMutation, CreateBenchmarkDiscussionCommentMutationVariables>(CreateBenchmarkDiscussionCommentDocument, options);
      }
export type CreateBenchmarkDiscussionCommentMutationHookResult = ReturnType<typeof useCreateBenchmarkDiscussionCommentMutation>;
export type CreateBenchmarkDiscussionCommentMutationResult = ApolloReactCommon.MutationResult<CreateBenchmarkDiscussionCommentMutation>;
export type CreateBenchmarkDiscussionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBenchmarkDiscussionCommentMutation, CreateBenchmarkDiscussionCommentMutationVariables>;
export const UpdateDiscussionCommentDocument = gql`
    mutation UpdateDiscussionComment($viewID: ID, $discussionCommentID: ID!, $body: String!, $inlineCommentDetails: JSONString) {
  updateDiscussionComment(
    input: {viewID: $viewID, discussionCommentID: $discussionCommentID, body: $body, inlineCommentDetails: $inlineCommentDetails}
  ) {
    discussionComment {
      id
      createdAt
      updatedAt
      deletedAt
      body
      isParent
      poster {
        id
        photoUrl
        name
        username
      }
    }
  }
}
    `;
export type UpdateDiscussionCommentMutationFn = ApolloReactCommon.MutationFunction<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>;
export type UpdateDiscussionCommentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>, 'mutation'>;

    export const UpdateDiscussionCommentComponent = (props: UpdateDiscussionCommentComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables> mutation={UpdateDiscussionCommentDocument} {...props} />
    );
    
export type UpdateDiscussionCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>
    } & TChildProps;
export function withUpdateDiscussionComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDiscussionCommentMutation,
  UpdateDiscussionCommentMutationVariables,
  UpdateDiscussionCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables, UpdateDiscussionCommentProps<TChildProps, TDataName>>(UpdateDiscussionCommentDocument, {
      alias: 'updateDiscussionComment',
      ...operationOptions
    });
};

/**
 * __useUpdateDiscussionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionCommentMutation, { data, loading, error }] = useUpdateDiscussionCommentMutation({
 *   variables: {
 *      viewID: // value for 'viewID'
 *      discussionCommentID: // value for 'discussionCommentID'
 *      body: // value for 'body'
 *      inlineCommentDetails: // value for 'inlineCommentDetails'
 *   },
 * });
 */
export function useUpdateDiscussionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>(UpdateDiscussionCommentDocument, options);
      }
export type UpdateDiscussionCommentMutationHookResult = ReturnType<typeof useUpdateDiscussionCommentMutation>;
export type UpdateDiscussionCommentMutationResult = ApolloReactCommon.MutationResult<UpdateDiscussionCommentMutation>;
export type UpdateDiscussionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>;
export const DeleteDiscussionCommentDocument = gql`
    mutation DeleteDiscussionComment($id: ID!, $deleteThread: Boolean) {
  deleteDiscussionComment(input: {id: $id, deleteThread: $deleteThread}) {
    success
  }
}
    `;
export type DeleteDiscussionCommentMutationFn = ApolloReactCommon.MutationFunction<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>;
export type DeleteDiscussionCommentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>, 'mutation'>;

    export const DeleteDiscussionCommentComponent = (props: DeleteDiscussionCommentComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables> mutation={DeleteDiscussionCommentDocument} {...props} />
    );
    
export type DeleteDiscussionCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>
    } & TChildProps;
export function withDeleteDiscussionComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteDiscussionCommentMutation,
  DeleteDiscussionCommentMutationVariables,
  DeleteDiscussionCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables, DeleteDiscussionCommentProps<TChildProps, TDataName>>(DeleteDiscussionCommentDocument, {
      alias: 'deleteDiscussionComment',
      ...operationOptions
    });
};

/**
 * __useDeleteDiscussionCommentMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionCommentMutation, { data, loading, error }] = useDeleteDiscussionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteThread: // value for 'deleteThread'
 *   },
 * });
 */
export function useDeleteDiscussionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>(DeleteDiscussionCommentDocument, options);
      }
export type DeleteDiscussionCommentMutationHookResult = ReturnType<typeof useDeleteDiscussionCommentMutation>;
export type DeleteDiscussionCommentMutationResult = ApolloReactCommon.MutationResult<DeleteDiscussionCommentMutation>;
export type DeleteDiscussionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>;
export const ViewDiscussionThreadsDocument = gql`
    query ViewDiscussionThreads($viewID: ID!) {
  view(id: $viewID) {
    id
    discussionThreads {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          createdAt
          updatedAt
          title
          body
          upvotes
          poster {
            id
            photoUrl
            name
            username
          }
          comments {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                id
                createdAt
                updatedAt
                body
                poster {
                  id
                  photoUrl
                  name
                  username
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ViewDiscussionThreadsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>, 'query'> & ({ variables: ViewDiscussionThreadsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewDiscussionThreadsComponent = (props: ViewDiscussionThreadsComponentProps) => (
      <ApolloReactComponents.Query<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables> query={ViewDiscussionThreadsDocument} {...props} />
    );
    
export type ViewDiscussionThreadsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>
    } & TChildProps;
export function withViewDiscussionThreads<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewDiscussionThreadsQuery,
  ViewDiscussionThreadsQueryVariables,
  ViewDiscussionThreadsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables, ViewDiscussionThreadsProps<TChildProps, TDataName>>(ViewDiscussionThreadsDocument, {
      alias: 'viewDiscussionThreads',
      ...operationOptions
    });
};

/**
 * __useViewDiscussionThreadsQuery__
 *
 * To run a query within a React component, call `useViewDiscussionThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewDiscussionThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewDiscussionThreadsQuery({
 *   variables: {
 *      viewID: // value for 'viewID'
 *   },
 * });
 */
export function useViewDiscussionThreadsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables> & ({ variables: ViewDiscussionThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>(ViewDiscussionThreadsDocument, options);
      }
export function useViewDiscussionThreadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>(ViewDiscussionThreadsDocument, options);
        }
// @ts-ignore
export function useViewDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>;
export function useViewDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewDiscussionThreadsQuery | undefined, ViewDiscussionThreadsQueryVariables>;
export function useViewDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>(ViewDiscussionThreadsDocument, options);
        }
export type ViewDiscussionThreadsQueryHookResult = ReturnType<typeof useViewDiscussionThreadsQuery>;
export type ViewDiscussionThreadsLazyQueryHookResult = ReturnType<typeof useViewDiscussionThreadsLazyQuery>;
export type ViewDiscussionThreadsSuspenseQueryHookResult = ReturnType<typeof useViewDiscussionThreadsSuspenseQuery>;
export type ViewDiscussionThreadsQueryResult = ApolloReactCommon.QueryResult<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>;
export const CreateViewDiscussionCommentDocument = gql`
    mutation CreateViewDiscussionComment($viewID: ID!, $discussionThreadID: ID, $body: String!, $notifyAllSubscribers: Boolean, $inlineCommentDetails: JSONString) {
  createViewDiscussionComment(
    input: {viewID: $viewID, discussionThreadID: $discussionThreadID, body: $body, notifyAllSubscribers: $notifyAllSubscribers, inlineCommentDetails: $inlineCommentDetails}
  ) {
    discussionThread {
      id
      createdAt
      updatedAt
      title
      body
      upvotes
      poster {
        id
        photoUrl
        name
        username
      }
    }
    discussionComment {
      id
      createdAt
      updatedAt
      body
      poster {
        id
        photoUrl
        name
        username
      }
    }
    alertSubscription {
      id
    }
  }
}
    `;
export type CreateViewDiscussionCommentMutationFn = ApolloReactCommon.MutationFunction<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>;
export type CreateViewDiscussionCommentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>, 'mutation'>;

    export const CreateViewDiscussionCommentComponent = (props: CreateViewDiscussionCommentComponentProps) => (
      <ApolloReactComponents.Mutation<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables> mutation={CreateViewDiscussionCommentDocument} {...props} />
    );
    
export type CreateViewDiscussionCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>
    } & TChildProps;
export function withCreateViewDiscussionComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateViewDiscussionCommentMutation,
  CreateViewDiscussionCommentMutationVariables,
  CreateViewDiscussionCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables, CreateViewDiscussionCommentProps<TChildProps, TDataName>>(CreateViewDiscussionCommentDocument, {
      alias: 'createViewDiscussionComment',
      ...operationOptions
    });
};

/**
 * __useCreateViewDiscussionCommentMutation__
 *
 * To run a mutation, you first call `useCreateViewDiscussionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViewDiscussionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViewDiscussionCommentMutation, { data, loading, error }] = useCreateViewDiscussionCommentMutation({
 *   variables: {
 *      viewID: // value for 'viewID'
 *      discussionThreadID: // value for 'discussionThreadID'
 *      body: // value for 'body'
 *      notifyAllSubscribers: // value for 'notifyAllSubscribers'
 *      inlineCommentDetails: // value for 'inlineCommentDetails'
 *   },
 * });
 */
export function useCreateViewDiscussionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>(CreateViewDiscussionCommentDocument, options);
      }
export type CreateViewDiscussionCommentMutationHookResult = ReturnType<typeof useCreateViewDiscussionCommentMutation>;
export type CreateViewDiscussionCommentMutationResult = ApolloReactCommon.MutationResult<CreateViewDiscussionCommentMutation>;
export type CreateViewDiscussionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>;
export const DismissedBannerDocument = gql`
    query DismissedBanner($id: ID!) {
  dismissedBanner(id: $id) {
    id
    dismissedAt
  }
}
    `;
export type DismissedBannerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DismissedBannerQuery, DismissedBannerQueryVariables>, 'query'> & ({ variables: DismissedBannerQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DismissedBannerComponent = (props: DismissedBannerComponentProps) => (
      <ApolloReactComponents.Query<DismissedBannerQuery, DismissedBannerQueryVariables> query={DismissedBannerDocument} {...props} />
    );
    
export type DismissedBannerProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<DismissedBannerQuery, DismissedBannerQueryVariables>
    } & TChildProps;
export function withDismissedBanner<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DismissedBannerQuery,
  DismissedBannerQueryVariables,
  DismissedBannerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, DismissedBannerQuery, DismissedBannerQueryVariables, DismissedBannerProps<TChildProps, TDataName>>(DismissedBannerDocument, {
      alias: 'dismissedBanner',
      ...operationOptions
    });
};

/**
 * __useDismissedBannerQuery__
 *
 * To run a query within a React component, call `useDismissedBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDismissedBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDismissedBannerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissedBannerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables> & ({ variables: DismissedBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DismissedBannerQuery, DismissedBannerQueryVariables>(DismissedBannerDocument, options);
      }
export function useDismissedBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DismissedBannerQuery, DismissedBannerQueryVariables>(DismissedBannerDocument, options);
        }
// @ts-ignore
export function useDismissedBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DismissedBannerQuery, DismissedBannerQueryVariables>;
export function useDismissedBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DismissedBannerQuery | undefined, DismissedBannerQueryVariables>;
export function useDismissedBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DismissedBannerQuery, DismissedBannerQueryVariables>(DismissedBannerDocument, options);
        }
export type DismissedBannerQueryHookResult = ReturnType<typeof useDismissedBannerQuery>;
export type DismissedBannerLazyQueryHookResult = ReturnType<typeof useDismissedBannerLazyQuery>;
export type DismissedBannerSuspenseQueryHookResult = ReturnType<typeof useDismissedBannerSuspenseQuery>;
export type DismissedBannerQueryResult = ApolloReactCommon.QueryResult<DismissedBannerQuery, DismissedBannerQueryVariables>;
export const SetDismissedBannerDocument = gql`
    mutation SetDismissedBanner($id: ID!) {
  setDismissedBanner(input: {bannerID: $id}) {
    success
  }
}
    `;
export type SetDismissedBannerMutationFn = ApolloReactCommon.MutationFunction<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>;
export type SetDismissedBannerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>, 'mutation'>;

    export const SetDismissedBannerComponent = (props: SetDismissedBannerComponentProps) => (
      <ApolloReactComponents.Mutation<SetDismissedBannerMutation, SetDismissedBannerMutationVariables> mutation={SetDismissedBannerDocument} {...props} />
    );
    
export type SetDismissedBannerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>
    } & TChildProps;
export function withSetDismissedBanner<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetDismissedBannerMutation,
  SetDismissedBannerMutationVariables,
  SetDismissedBannerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SetDismissedBannerMutation, SetDismissedBannerMutationVariables, SetDismissedBannerProps<TChildProps, TDataName>>(SetDismissedBannerDocument, {
      alias: 'setDismissedBanner',
      ...operationOptions
    });
};

/**
 * __useSetDismissedBannerMutation__
 *
 * To run a mutation, you first call `useSetDismissedBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDismissedBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDismissedBannerMutation, { data, loading, error }] = useSetDismissedBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDismissedBannerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>(SetDismissedBannerDocument, options);
      }
export type SetDismissedBannerMutationHookResult = ReturnType<typeof useSetDismissedBannerMutation>;
export type SetDismissedBannerMutationResult = ApolloReactCommon.MutationResult<SetDismissedBannerMutation>;
export type SetDismissedBannerMutationOptions = ApolloReactCommon.BaseMutationOptions<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation resendEmailVerification($email: String!, $clientMutationId: String) {
  resendEmailVerification(
    input: {email: $email, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type ResendEmailVerificationMutationFn = ApolloReactCommon.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export type ResendEmailVerificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>, 'mutation'>;

    export const ResendEmailVerificationComponent = (props: ResendEmailVerificationComponentProps) => (
      <ApolloReactComponents.Mutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables> mutation={ResendEmailVerificationDocument} {...props} />
    );
    
export type ResendEmailVerificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>
    } & TChildProps;
export function withResendEmailVerification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResendEmailVerificationMutation,
  ResendEmailVerificationMutationVariables,
  ResendEmailVerificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables, ResendEmailVerificationProps<TChildProps, TDataName>>(ResendEmailVerificationDocument, {
      alias: 'resendEmailVerification',
      ...operationOptions
    });
};

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = ApolloReactCommon.MutationResult<ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const SelectedAccountEntityOrgDocument = gql`
    query SelectedAccountEntityOrg($id: ID!) {
  organization(id: $id) {
    id
    orgEntity {
      id
      name
    }
  }
}
    `;
export type SelectedAccountEntityOrgComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>, 'query'> & ({ variables: SelectedAccountEntityOrgQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SelectedAccountEntityOrgComponent = (props: SelectedAccountEntityOrgComponentProps) => (
      <ApolloReactComponents.Query<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables> query={SelectedAccountEntityOrgDocument} {...props} />
    );
    
export type SelectedAccountEntityOrgProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>
    } & TChildProps;
export function withSelectedAccountEntityOrg<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SelectedAccountEntityOrgQuery,
  SelectedAccountEntityOrgQueryVariables,
  SelectedAccountEntityOrgProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables, SelectedAccountEntityOrgProps<TChildProps, TDataName>>(SelectedAccountEntityOrgDocument, {
      alias: 'selectedAccountEntityOrg',
      ...operationOptions
    });
};

/**
 * __useSelectedAccountEntityOrgQuery__
 *
 * To run a query within a React component, call `useSelectedAccountEntityOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedAccountEntityOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedAccountEntityOrgQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectedAccountEntityOrgQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables> & ({ variables: SelectedAccountEntityOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>(SelectedAccountEntityOrgDocument, options);
      }
export function useSelectedAccountEntityOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>(SelectedAccountEntityOrgDocument, options);
        }
// @ts-ignore
export function useSelectedAccountEntityOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>;
export function useSelectedAccountEntityOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedAccountEntityOrgQuery | undefined, SelectedAccountEntityOrgQueryVariables>;
export function useSelectedAccountEntityOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>(SelectedAccountEntityOrgDocument, options);
        }
export type SelectedAccountEntityOrgQueryHookResult = ReturnType<typeof useSelectedAccountEntityOrgQuery>;
export type SelectedAccountEntityOrgLazyQueryHookResult = ReturnType<typeof useSelectedAccountEntityOrgLazyQuery>;
export type SelectedAccountEntityOrgSuspenseQueryHookResult = ReturnType<typeof useSelectedAccountEntityOrgSuspenseQuery>;
export type SelectedAccountEntityOrgQueryResult = ApolloReactCommon.QueryResult<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>;
export const EntityPageDocument = gql`
    query EntityPage($entityName: String!) {
  entity(name: $entityName) {
    id
    isTeam
    entityType
    available
    claimingEntity {
      id
      name
    }
    members {
      id
      name
      username
      email
      photoUrl
      pending
      accountType
      role
    }
    name
  }
}
    `;
export type EntityPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityPageQuery, EntityPageQueryVariables>, 'query'> & ({ variables: EntityPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityPageComponent = (props: EntityPageComponentProps) => (
      <ApolloReactComponents.Query<EntityPageQuery, EntityPageQueryVariables> query={EntityPageDocument} {...props} />
    );
    
export type EntityPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityPageQuery, EntityPageQueryVariables>
    } & TChildProps;
export function withEntityPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityPageQuery,
  EntityPageQueryVariables,
  EntityPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityPageQuery, EntityPageQueryVariables, EntityPageProps<TChildProps, TDataName>>(EntityPageDocument, {
      alias: 'entityPage',
      ...operationOptions
    });
};

/**
 * __useEntityPageQuery__
 *
 * To run a query within a React component, call `useEntityPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPageQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityPageQuery, EntityPageQueryVariables> & ({ variables: EntityPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityPageQuery, EntityPageQueryVariables>(EntityPageDocument, options);
      }
export function useEntityPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityPageQuery, EntityPageQueryVariables>(EntityPageDocument, options);
        }
// @ts-ignore
export function useEntityPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPageQuery, EntityPageQueryVariables>;
export function useEntityPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPageQuery | undefined, EntityPageQueryVariables>;
export function useEntityPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityPageQuery, EntityPageQueryVariables>(EntityPageDocument, options);
        }
export type EntityPageQueryHookResult = ReturnType<typeof useEntityPageQuery>;
export type EntityPageLazyQueryHookResult = ReturnType<typeof useEntityPageLazyQuery>;
export type EntityPageSuspenseQueryHookResult = ReturnType<typeof useEntityPageSuspenseQuery>;
export type EntityPageQueryResult = ApolloReactCommon.QueryResult<EntityPageQuery, EntityPageQueryVariables>;
export const EntityTypeDocument = gql`
    query EntityType($entityName: String!) {
  entity(name: $entityName) {
    id
    entityType
  }
}
    `;
export type EntityTypeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityTypeQuery, EntityTypeQueryVariables>, 'query'> & ({ variables: EntityTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityTypeComponent = (props: EntityTypeComponentProps) => (
      <ApolloReactComponents.Query<EntityTypeQuery, EntityTypeQueryVariables> query={EntityTypeDocument} {...props} />
    );
    
export type EntityTypeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityTypeQuery, EntityTypeQueryVariables>
    } & TChildProps;
export function withEntityType<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityTypeQuery,
  EntityTypeQueryVariables,
  EntityTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityTypeQuery, EntityTypeQueryVariables, EntityTypeProps<TChildProps, TDataName>>(EntityTypeDocument, {
      alias: 'entityType',
      ...operationOptions
    });
};

/**
 * __useEntityTypeQuery__
 *
 * To run a query within a React component, call `useEntityTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityTypeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables> & ({ variables: EntityTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityTypeQuery, EntityTypeQueryVariables>(EntityTypeDocument, options);
      }
export function useEntityTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityTypeQuery, EntityTypeQueryVariables>(EntityTypeDocument, options);
        }
// @ts-ignore
export function useEntityTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityTypeQuery, EntityTypeQueryVariables>;
export function useEntityTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityTypeQuery | undefined, EntityTypeQueryVariables>;
export function useEntityTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityTypeQuery, EntityTypeQueryVariables>(EntityTypeDocument, options);
        }
export type EntityTypeQueryHookResult = ReturnType<typeof useEntityTypeQuery>;
export type EntityTypeLazyQueryHookResult = ReturnType<typeof useEntityTypeLazyQuery>;
export type EntityTypeSuspenseQueryHookResult = ReturnType<typeof useEntityTypeSuspenseQuery>;
export type EntityTypeQueryResult = ApolloReactCommon.QueryResult<EntityTypeQuery, EntityTypeQueryVariables>;
export const EntityPageUserStatsDocument = gql`
    query EntityPageUserStats($entityName: String!, $userStatsStartDate: DateTime!) {
  entity(name: $entityName) {
    id
    userStats(from: $userStatsStartDate, first: 10) {
      edges {
        node {
          id
          user {
            id
            name
            username
            photoUrl
            accountType
          }
          runCount
        }
      }
    }
  }
}
    `;
export type EntityPageUserStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>, 'query'> & ({ variables: EntityPageUserStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityPageUserStatsComponent = (props: EntityPageUserStatsComponentProps) => (
      <ApolloReactComponents.Query<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables> query={EntityPageUserStatsDocument} {...props} />
    );
    
export type EntityPageUserStatsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>
    } & TChildProps;
export function withEntityPageUserStats<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityPageUserStatsQuery,
  EntityPageUserStatsQueryVariables,
  EntityPageUserStatsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables, EntityPageUserStatsProps<TChildProps, TDataName>>(EntityPageUserStatsDocument, {
      alias: 'entityPageUserStats',
      ...operationOptions
    });
};

/**
 * __useEntityPageUserStatsQuery__
 *
 * To run a query within a React component, call `useEntityPageUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPageUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPageUserStatsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      userStatsStartDate: // value for 'userStatsStartDate'
 *   },
 * });
 */
export function useEntityPageUserStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables> & ({ variables: EntityPageUserStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>(EntityPageUserStatsDocument, options);
      }
export function useEntityPageUserStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>(EntityPageUserStatsDocument, options);
        }
// @ts-ignore
export function useEntityPageUserStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>;
export function useEntityPageUserStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPageUserStatsQuery | undefined, EntityPageUserStatsQueryVariables>;
export function useEntityPageUserStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>(EntityPageUserStatsDocument, options);
        }
export type EntityPageUserStatsQueryHookResult = ReturnType<typeof useEntityPageUserStatsQuery>;
export type EntityPageUserStatsLazyQueryHookResult = ReturnType<typeof useEntityPageUserStatsLazyQuery>;
export type EntityPageUserStatsSuspenseQueryHookResult = ReturnType<typeof useEntityPageUserStatsSuspenseQuery>;
export type EntityPageUserStatsQueryResult = ApolloReactCommon.QueryResult<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>;
export const EntityRunsDocument = gql`
    query EntityRuns($entityName: String!) {
  entity(name: $entityName) {
    id
    latestRuns {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
  }
}
    ${RunsTableFragmentFragmentDoc}`;
export type EntityRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityRunsQuery, EntityRunsQueryVariables>, 'query'> & ({ variables: EntityRunsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityRunsComponent = (props: EntityRunsComponentProps) => (
      <ApolloReactComponents.Query<EntityRunsQuery, EntityRunsQueryVariables> query={EntityRunsDocument} {...props} />
    );
    
export type EntityRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityRunsQuery, EntityRunsQueryVariables>
    } & TChildProps;
export function withEntityRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityRunsQuery,
  EntityRunsQueryVariables,
  EntityRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityRunsQuery, EntityRunsQueryVariables, EntityRunsProps<TChildProps, TDataName>>(EntityRunsDocument, {
      alias: 'entityRuns',
      ...operationOptions
    });
};

/**
 * __useEntityRunsQuery__
 *
 * To run a query within a React component, call `useEntityRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRunsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables> & ({ variables: EntityRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityRunsQuery, EntityRunsQueryVariables>(EntityRunsDocument, options);
      }
export function useEntityRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityRunsQuery, EntityRunsQueryVariables>(EntityRunsDocument, options);
        }
// @ts-ignore
export function useEntityRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityRunsQuery, EntityRunsQueryVariables>;
export function useEntityRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityRunsQuery | undefined, EntityRunsQueryVariables>;
export function useEntityRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityRunsQuery, EntityRunsQueryVariables>(EntityRunsDocument, options);
        }
export type EntityRunsQueryHookResult = ReturnType<typeof useEntityRunsQuery>;
export type EntityRunsLazyQueryHookResult = ReturnType<typeof useEntityRunsLazyQuery>;
export type EntityRunsSuspenseQueryHookResult = ReturnType<typeof useEntityRunsSuspenseQuery>;
export type EntityRunsQueryResult = ApolloReactCommon.QueryResult<EntityRunsQuery, EntityRunsQueryVariables>;
export const EntitySettingsDocument = gql`
    query EntitySettings($name: String!) {
  entity(name: $name) {
    id
    settings {
      defaultCloudRegion {
        id
        provider
        region
      }
      openToMatchingOrgEmailDomainUsers
      entityProfileEnabled
      hideActivityCalendar
      membersCanInvite
      disableMagicLinkSharing
      disableMembersEditArtifactTTL
      hidden
    }
  }
}
    `;
export type EntitySettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntitySettingsQuery, EntitySettingsQueryVariables>, 'query'> & ({ variables: EntitySettingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntitySettingsComponent = (props: EntitySettingsComponentProps) => (
      <ApolloReactComponents.Query<EntitySettingsQuery, EntitySettingsQueryVariables> query={EntitySettingsDocument} {...props} />
    );
    
export type EntitySettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntitySettingsQuery, EntitySettingsQueryVariables>
    } & TChildProps;
export function withEntitySettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntitySettingsQuery,
  EntitySettingsQueryVariables,
  EntitySettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntitySettingsQuery, EntitySettingsQueryVariables, EntitySettingsProps<TChildProps, TDataName>>(EntitySettingsDocument, {
      alias: 'entitySettings',
      ...operationOptions
    });
};

/**
 * __useEntitySettingsQuery__
 *
 * To run a query within a React component, call `useEntitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySettingsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntitySettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables> & ({ variables: EntitySettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntitySettingsQuery, EntitySettingsQueryVariables>(EntitySettingsDocument, options);
      }
export function useEntitySettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntitySettingsQuery, EntitySettingsQueryVariables>(EntitySettingsDocument, options);
        }
// @ts-ignore
export function useEntitySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntitySettingsQuery, EntitySettingsQueryVariables>;
export function useEntitySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntitySettingsQuery | undefined, EntitySettingsQueryVariables>;
export function useEntitySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntitySettingsQuery, EntitySettingsQueryVariables>(EntitySettingsDocument, options);
        }
export type EntitySettingsQueryHookResult = ReturnType<typeof useEntitySettingsQuery>;
export type EntitySettingsLazyQueryHookResult = ReturnType<typeof useEntitySettingsLazyQuery>;
export type EntitySettingsSuspenseQueryHookResult = ReturnType<typeof useEntitySettingsSuspenseQuery>;
export type EntitySettingsQueryResult = ApolloReactCommon.QueryResult<EntitySettingsQuery, EntitySettingsQueryVariables>;
export const EntityStorageDocument = gql`
    query EntityStorage($entityName: String, $enableReferenceTracking: Boolean) {
  entity(name: $entityName) {
    id
    storageBytes
    referenceBytes
    computeHours
    storage: storageTree(enableReferenceTracking: $enableReferenceTracking) {
      id
      size
    }
  }
}
    `;
export type EntityStorageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityStorageQuery, EntityStorageQueryVariables>, 'query'>;

    export const EntityStorageComponent = (props: EntityStorageComponentProps) => (
      <ApolloReactComponents.Query<EntityStorageQuery, EntityStorageQueryVariables> query={EntityStorageDocument} {...props} />
    );
    
export type EntityStorageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityStorageQuery, EntityStorageQueryVariables>
    } & TChildProps;
export function withEntityStorage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityStorageQuery,
  EntityStorageQueryVariables,
  EntityStorageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityStorageQuery, EntityStorageQueryVariables, EntityStorageProps<TChildProps, TDataName>>(EntityStorageDocument, {
      alias: 'entityStorage',
      ...operationOptions
    });
};

/**
 * __useEntityStorageQuery__
 *
 * To run a query within a React component, call `useEntityStorageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityStorageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityStorageQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      enableReferenceTracking: // value for 'enableReferenceTracking'
 *   },
 * });
 */
export function useEntityStorageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityStorageQuery, EntityStorageQueryVariables>(EntityStorageDocument, options);
      }
export function useEntityStorageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityStorageQuery, EntityStorageQueryVariables>(EntityStorageDocument, options);
        }
// @ts-ignore
export function useEntityStorageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageQuery, EntityStorageQueryVariables>;
export function useEntityStorageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageQuery | undefined, EntityStorageQueryVariables>;
export function useEntityStorageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityStorageQuery, EntityStorageQueryVariables>(EntityStorageDocument, options);
        }
export type EntityStorageQueryHookResult = ReturnType<typeof useEntityStorageQuery>;
export type EntityStorageLazyQueryHookResult = ReturnType<typeof useEntityStorageLazyQuery>;
export type EntityStorageSuspenseQueryHookResult = ReturnType<typeof useEntityStorageSuspenseQuery>;
export type EntityStorageQueryResult = ApolloReactCommon.QueryResult<EntityStorageQuery, EntityStorageQueryVariables>;
export const CachedEntityStorageInfoDocument = gql`
    query CachedEntityStorageInfo($entityName: String) {
  entity(name: $entityName) {
    id
    storageBytes(cached: true)
  }
}
    `;
export type CachedEntityStorageInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>, 'query'>;

    export const CachedEntityStorageInfoComponent = (props: CachedEntityStorageInfoComponentProps) => (
      <ApolloReactComponents.Query<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables> query={CachedEntityStorageInfoDocument} {...props} />
    );
    
export type CachedEntityStorageInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>
    } & TChildProps;
export function withCachedEntityStorageInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CachedEntityStorageInfoQuery,
  CachedEntityStorageInfoQueryVariables,
  CachedEntityStorageInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables, CachedEntityStorageInfoProps<TChildProps, TDataName>>(CachedEntityStorageInfoDocument, {
      alias: 'cachedEntityStorageInfo',
      ...operationOptions
    });
};

/**
 * __useCachedEntityStorageInfoQuery__
 *
 * To run a query within a React component, call `useCachedEntityStorageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCachedEntityStorageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCachedEntityStorageInfoQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCachedEntityStorageInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>(CachedEntityStorageInfoDocument, options);
      }
export function useCachedEntityStorageInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>(CachedEntityStorageInfoDocument, options);
        }
// @ts-ignore
export function useCachedEntityStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>;
export function useCachedEntityStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CachedEntityStorageInfoQuery | undefined, CachedEntityStorageInfoQueryVariables>;
export function useCachedEntityStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>(CachedEntityStorageInfoDocument, options);
        }
export type CachedEntityStorageInfoQueryHookResult = ReturnType<typeof useCachedEntityStorageInfoQuery>;
export type CachedEntityStorageInfoLazyQueryHookResult = ReturnType<typeof useCachedEntityStorageInfoLazyQuery>;
export type CachedEntityStorageInfoSuspenseQueryHookResult = ReturnType<typeof useCachedEntityStorageInfoSuspenseQuery>;
export type CachedEntityStorageInfoQueryResult = ApolloReactCommon.QueryResult<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>;
export const ArtifactCollectionStorageTreeDocument = gql`
    query ArtifactCollectionStorageTree($entityName: String!, $enableReferenceTracking: Boolean!, $artifactCollectionID: ID!) {
  entity(name: $entityName) {
    id
    artifactCollectionStorageTree(
      artifactCollectionID: $artifactCollectionID
      enableReferenceTracking: $enableReferenceTracking
    ) {
      edges {
        node {
          id
          name
          size
          artifactID
        }
      }
    }
  }
}
    `;
export type ArtifactCollectionStorageTreeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>, 'query'> & ({ variables: ArtifactCollectionStorageTreeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCollectionStorageTreeComponent = (props: ArtifactCollectionStorageTreeComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables> query={ArtifactCollectionStorageTreeDocument} {...props} />
    );
    
export type ArtifactCollectionStorageTreeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>
    } & TChildProps;
export function withArtifactCollectionStorageTree<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCollectionStorageTreeQuery,
  ArtifactCollectionStorageTreeQueryVariables,
  ArtifactCollectionStorageTreeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables, ArtifactCollectionStorageTreeProps<TChildProps, TDataName>>(ArtifactCollectionStorageTreeDocument, {
      alias: 'artifactCollectionStorageTree',
      ...operationOptions
    });
};

/**
 * __useArtifactCollectionStorageTreeQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionStorageTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionStorageTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionStorageTreeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      enableReferenceTracking: // value for 'enableReferenceTracking'
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactCollectionStorageTreeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables> & ({ variables: ArtifactCollectionStorageTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>(ArtifactCollectionStorageTreeDocument, options);
      }
export function useArtifactCollectionStorageTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>(ArtifactCollectionStorageTreeDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>;
export function useArtifactCollectionStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionStorageTreeQuery | undefined, ArtifactCollectionStorageTreeQueryVariables>;
export function useArtifactCollectionStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>(ArtifactCollectionStorageTreeDocument, options);
        }
export type ArtifactCollectionStorageTreeQueryHookResult = ReturnType<typeof useArtifactCollectionStorageTreeQuery>;
export type ArtifactCollectionStorageTreeLazyQueryHookResult = ReturnType<typeof useArtifactCollectionStorageTreeLazyQuery>;
export type ArtifactCollectionStorageTreeSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionStorageTreeSuspenseQuery>;
export type ArtifactCollectionStorageTreeQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>;
export const EntityStorageTreeDocument = gql`
    query EntityStorageTree($entityName: String!, $enableReferenceTracking: Boolean!, $query: String, $cached: Boolean) {
  entity(name: $entityName) {
    id
    storageTree(enableReferenceTracking: $enableReferenceTracking, cached: $cached) {
      id
      name
      size
      lastUpdatedAt
      projects(query: $query) {
        totalSize
        edges {
          node {
            id
            name
            size
            projectID
            runs @skip(if: $enableReferenceTracking) {
              totalSize
              edges {
                node {
                  id
                  ...RunNode
                }
              }
            }
            artifactSequences {
              totalSize
              edges {
                node {
                  id
                  ...ArtifactNode
                }
              }
            }
            artifactTypes {
              id
              name
              size
            }
          }
        }
      }
    }
  }
}
    ${RunNodeFragmentDoc}
${ArtifactNodeFragmentDoc}`;
export type EntityStorageTreeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>, 'query'> & ({ variables: EntityStorageTreeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityStorageTreeComponent = (props: EntityStorageTreeComponentProps) => (
      <ApolloReactComponents.Query<EntityStorageTreeQuery, EntityStorageTreeQueryVariables> query={EntityStorageTreeDocument} {...props} />
    );
    
export type EntityStorageTreeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>
    } & TChildProps;
export function withEntityStorageTree<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityStorageTreeQuery,
  EntityStorageTreeQueryVariables,
  EntityStorageTreeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityStorageTreeQuery, EntityStorageTreeQueryVariables, EntityStorageTreeProps<TChildProps, TDataName>>(EntityStorageTreeDocument, {
      alias: 'entityStorageTree',
      ...operationOptions
    });
};

/**
 * __useEntityStorageTreeQuery__
 *
 * To run a query within a React component, call `useEntityStorageTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityStorageTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityStorageTreeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      enableReferenceTracking: // value for 'enableReferenceTracking'
 *      query: // value for 'query'
 *      cached: // value for 'cached'
 *   },
 * });
 */
export function useEntityStorageTreeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables> & ({ variables: EntityStorageTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>(EntityStorageTreeDocument, options);
      }
export function useEntityStorageTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>(EntityStorageTreeDocument, options);
        }
// @ts-ignore
export function useEntityStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>;
export function useEntityStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageTreeQuery | undefined, EntityStorageTreeQueryVariables>;
export function useEntityStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>(EntityStorageTreeDocument, options);
        }
export type EntityStorageTreeQueryHookResult = ReturnType<typeof useEntityStorageTreeQuery>;
export type EntityStorageTreeLazyQueryHookResult = ReturnType<typeof useEntityStorageTreeLazyQuery>;
export type EntityStorageTreeSuspenseQueryHookResult = ReturnType<typeof useEntityStorageTreeSuspenseQuery>;
export type EntityStorageTreeQueryResult = ApolloReactCommon.QueryResult<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>;
export const UserEmailsDocument = gql`
    query UserEmails {
  viewer {
    id
    ...GetEmails_User
  }
}
    ${GetEmails_UserFragmentDoc}`;
export type UserEmailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserEmailsQuery, UserEmailsQueryVariables>, 'query'>;

    export const UserEmailsComponent = (props: UserEmailsComponentProps) => (
      <ApolloReactComponents.Query<UserEmailsQuery, UserEmailsQueryVariables> query={UserEmailsDocument} {...props} />
    );
    
export type UserEmailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserEmailsQuery, UserEmailsQueryVariables>
    } & TChildProps;
export function withUserEmails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserEmailsQuery,
  UserEmailsQueryVariables,
  UserEmailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserEmailsQuery, UserEmailsQueryVariables, UserEmailsProps<TChildProps, TDataName>>(UserEmailsDocument, {
      alias: 'userEmails',
      ...operationOptions
    });
};

/**
 * __useUserEmailsQuery__
 *
 * To run a query within a React component, call `useUserEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEmailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEmailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
      }
export function useUserEmailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
        }
// @ts-ignore
export function useUserEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEmailsQuery, UserEmailsQueryVariables>;
export function useUserEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEmailsQuery | undefined, UserEmailsQueryVariables>;
export function useUserEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
        }
export type UserEmailsQueryHookResult = ReturnType<typeof useUserEmailsQuery>;
export type UserEmailsLazyQueryHookResult = ReturnType<typeof useUserEmailsLazyQuery>;
export type UserEmailsSuspenseQueryHookResult = ReturnType<typeof useUserEmailsSuspenseQuery>;
export type UserEmailsQueryResult = ApolloReactCommon.QueryResult<UserEmailsQuery, UserEmailsQueryVariables>;
export const GlueTasksDocument = gql`
    query GlueTasks {
  glueManager {
    taskTypes
    registeredTasks {
      edges {
        node {
          id
          name
          taskType
          arguments
          checkpoint
          lastRunAt
          status
          strategyType
          strategyMetadata
        }
      }
    }
  }
}
    `;
export type GlueTasksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GlueTasksQuery, GlueTasksQueryVariables>, 'query'>;

    export const GlueTasksComponent = (props: GlueTasksComponentProps) => (
      <ApolloReactComponents.Query<GlueTasksQuery, GlueTasksQueryVariables> query={GlueTasksDocument} {...props} />
    );
    
export type GlueTasksProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GlueTasksQuery, GlueTasksQueryVariables>
    } & TChildProps;
export function withGlueTasks<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GlueTasksQuery,
  GlueTasksQueryVariables,
  GlueTasksProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GlueTasksQuery, GlueTasksQueryVariables, GlueTasksProps<TChildProps, TDataName>>(GlueTasksDocument, {
      alias: 'glueTasks',
      ...operationOptions
    });
};

/**
 * __useGlueTasksQuery__
 *
 * To run a query within a React component, call `useGlueTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlueTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlueTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlueTasksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlueTasksQuery, GlueTasksQueryVariables>(GlueTasksDocument, options);
      }
export function useGlueTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlueTasksQuery, GlueTasksQueryVariables>(GlueTasksDocument, options);
        }
// @ts-ignore
export function useGlueTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueTasksQuery, GlueTasksQueryVariables>;
export function useGlueTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueTasksQuery | undefined, GlueTasksQueryVariables>;
export function useGlueTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlueTasksQuery, GlueTasksQueryVariables>(GlueTasksDocument, options);
        }
export type GlueTasksQueryHookResult = ReturnType<typeof useGlueTasksQuery>;
export type GlueTasksLazyQueryHookResult = ReturnType<typeof useGlueTasksLazyQuery>;
export type GlueTasksSuspenseQueryHookResult = ReturnType<typeof useGlueTasksSuspenseQuery>;
export type GlueTasksQueryResult = ApolloReactCommon.QueryResult<GlueTasksQuery, GlueTasksQueryVariables>;
export const GlueTaskConfigDocument = gql`
    query GlueTaskConfig($taskType: String!) {
  glueManager {
    taskConfig(taskType: $taskType) {
      defaultArguments
    }
  }
}
    `;
export type GlueTaskConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>, 'query'> & ({ variables: GlueTaskConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GlueTaskConfigComponent = (props: GlueTaskConfigComponentProps) => (
      <ApolloReactComponents.Query<GlueTaskConfigQuery, GlueTaskConfigQueryVariables> query={GlueTaskConfigDocument} {...props} />
    );
    
export type GlueTaskConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>
    } & TChildProps;
export function withGlueTaskConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GlueTaskConfigQuery,
  GlueTaskConfigQueryVariables,
  GlueTaskConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GlueTaskConfigQuery, GlueTaskConfigQueryVariables, GlueTaskConfigProps<TChildProps, TDataName>>(GlueTaskConfigDocument, {
      alias: 'glueTaskConfig',
      ...operationOptions
    });
};

/**
 * __useGlueTaskConfigQuery__
 *
 * To run a query within a React component, call `useGlueTaskConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlueTaskConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlueTaskConfigQuery({
 *   variables: {
 *      taskType: // value for 'taskType'
 *   },
 * });
 */
export function useGlueTaskConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables> & ({ variables: GlueTaskConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>(GlueTaskConfigDocument, options);
      }
export function useGlueTaskConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>(GlueTaskConfigDocument, options);
        }
// @ts-ignore
export function useGlueTaskConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>;
export function useGlueTaskConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueTaskConfigQuery | undefined, GlueTaskConfigQueryVariables>;
export function useGlueTaskConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>(GlueTaskConfigDocument, options);
        }
export type GlueTaskConfigQueryHookResult = ReturnType<typeof useGlueTaskConfigQuery>;
export type GlueTaskConfigLazyQueryHookResult = ReturnType<typeof useGlueTaskConfigLazyQuery>;
export type GlueTaskConfigSuspenseQueryHookResult = ReturnType<typeof useGlueTaskConfigSuspenseQuery>;
export type GlueTaskConfigQueryResult = ApolloReactCommon.QueryResult<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>;
export const GlueRunsDocument = gql`
    query GlueRuns($taskID: ID!) {
  glueRuns(taskID: $taskID) {
    edges {
      node {
        id
        runAt
        runtimeMS
        arguments
        errors
        retries
        succeeded
      }
    }
  }
}
    `;
export type GlueRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GlueRunsQuery, GlueRunsQueryVariables>, 'query'> & ({ variables: GlueRunsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GlueRunsComponent = (props: GlueRunsComponentProps) => (
      <ApolloReactComponents.Query<GlueRunsQuery, GlueRunsQueryVariables> query={GlueRunsDocument} {...props} />
    );
    
export type GlueRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GlueRunsQuery, GlueRunsQueryVariables>
    } & TChildProps;
export function withGlueRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GlueRunsQuery,
  GlueRunsQueryVariables,
  GlueRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GlueRunsQuery, GlueRunsQueryVariables, GlueRunsProps<TChildProps, TDataName>>(GlueRunsDocument, {
      alias: 'glueRuns',
      ...operationOptions
    });
};

/**
 * __useGlueRunsQuery__
 *
 * To run a query within a React component, call `useGlueRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlueRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlueRunsQuery({
 *   variables: {
 *      taskID: // value for 'taskID'
 *   },
 * });
 */
export function useGlueRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables> & ({ variables: GlueRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlueRunsQuery, GlueRunsQueryVariables>(GlueRunsDocument, options);
      }
export function useGlueRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlueRunsQuery, GlueRunsQueryVariables>(GlueRunsDocument, options);
        }
// @ts-ignore
export function useGlueRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueRunsQuery, GlueRunsQueryVariables>;
export function useGlueRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueRunsQuery | undefined, GlueRunsQueryVariables>;
export function useGlueRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlueRunsQuery, GlueRunsQueryVariables>(GlueRunsDocument, options);
        }
export type GlueRunsQueryHookResult = ReturnType<typeof useGlueRunsQuery>;
export type GlueRunsLazyQueryHookResult = ReturnType<typeof useGlueRunsLazyQuery>;
export type GlueRunsSuspenseQueryHookResult = ReturnType<typeof useGlueRunsSuspenseQuery>;
export type GlueRunsQueryResult = ApolloReactCommon.QueryResult<GlueRunsQuery, GlueRunsQueryVariables>;
export const CreateGlueTaskDocument = gql`
    mutation CreateGlueTask($name: String!, $taskType: String!, $arguments: JSONString!, $status: String!, $strategyType: String!, $strategyMetadata: String!, $clientMutationId: String) {
  createGlueTask(
    input: {name: $name, taskType: $taskType, arguments: $arguments, status: $status, strategyType: $strategyType, strategyMetadata: $strategyMetadata, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type CreateGlueTaskMutationFn = ApolloReactCommon.MutationFunction<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>;
export type CreateGlueTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>, 'mutation'>;

    export const CreateGlueTaskComponent = (props: CreateGlueTaskComponentProps) => (
      <ApolloReactComponents.Mutation<CreateGlueTaskMutation, CreateGlueTaskMutationVariables> mutation={CreateGlueTaskDocument} {...props} />
    );
    
export type CreateGlueTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>
    } & TChildProps;
export function withCreateGlueTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateGlueTaskMutation,
  CreateGlueTaskMutationVariables,
  CreateGlueTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateGlueTaskMutation, CreateGlueTaskMutationVariables, CreateGlueTaskProps<TChildProps, TDataName>>(CreateGlueTaskDocument, {
      alias: 'createGlueTask',
      ...operationOptions
    });
};

/**
 * __useCreateGlueTaskMutation__
 *
 * To run a mutation, you first call `useCreateGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlueTaskMutation, { data, loading, error }] = useCreateGlueTaskMutation({
 *   variables: {
 *      name: // value for 'name'
 *      taskType: // value for 'taskType'
 *      arguments: // value for 'arguments'
 *      status: // value for 'status'
 *      strategyType: // value for 'strategyType'
 *      strategyMetadata: // value for 'strategyMetadata'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>(CreateGlueTaskDocument, options);
      }
export type CreateGlueTaskMutationHookResult = ReturnType<typeof useCreateGlueTaskMutation>;
export type CreateGlueTaskMutationResult = ApolloReactCommon.MutationResult<CreateGlueTaskMutation>;
export type CreateGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>;
export const UpdateGlueTaskDocument = gql`
    mutation UpdateGlueTask($id: ID!, $name: String, $arguments: JSONString, $checkpoint: JSONString, $strategyType: String, $strategyMetadata: String, $status: String) {
  updateGlueTask(
    input: {id: $id, name: $name, arguments: $arguments, checkpoint: $checkpoint, strategyType: $strategyType, strategyMetadata: $strategyMetadata, status: $status}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateGlueTaskMutationFn = ApolloReactCommon.MutationFunction<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>;
export type UpdateGlueTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>, 'mutation'>;

    export const UpdateGlueTaskComponent = (props: UpdateGlueTaskComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables> mutation={UpdateGlueTaskDocument} {...props} />
    );
    
export type UpdateGlueTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>
    } & TChildProps;
export function withUpdateGlueTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateGlueTaskMutation,
  UpdateGlueTaskMutationVariables,
  UpdateGlueTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables, UpdateGlueTaskProps<TChildProps, TDataName>>(UpdateGlueTaskDocument, {
      alias: 'updateGlueTask',
      ...operationOptions
    });
};

/**
 * __useUpdateGlueTaskMutation__
 *
 * To run a mutation, you first call `useUpdateGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlueTaskMutation, { data, loading, error }] = useUpdateGlueTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      arguments: // value for 'arguments'
 *      checkpoint: // value for 'checkpoint'
 *      strategyType: // value for 'strategyType'
 *      strategyMetadata: // value for 'strategyMetadata'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>(UpdateGlueTaskDocument, options);
      }
export type UpdateGlueTaskMutationHookResult = ReturnType<typeof useUpdateGlueTaskMutation>;
export type UpdateGlueTaskMutationResult = ApolloReactCommon.MutationResult<UpdateGlueTaskMutation>;
export type UpdateGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>;
export const EnableGlueTaskDocument = gql`
    mutation EnableGlueTask($id: ID!) {
  enableGlueTask(input: {id: $id}) {
    success
    clientMutationId
  }
}
    `;
export type EnableGlueTaskMutationFn = ApolloReactCommon.MutationFunction<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>;
export type EnableGlueTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>, 'mutation'>;

    export const EnableGlueTaskComponent = (props: EnableGlueTaskComponentProps) => (
      <ApolloReactComponents.Mutation<EnableGlueTaskMutation, EnableGlueTaskMutationVariables> mutation={EnableGlueTaskDocument} {...props} />
    );
    
export type EnableGlueTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>
    } & TChildProps;
export function withEnableGlueTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EnableGlueTaskMutation,
  EnableGlueTaskMutationVariables,
  EnableGlueTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EnableGlueTaskMutation, EnableGlueTaskMutationVariables, EnableGlueTaskProps<TChildProps, TDataName>>(EnableGlueTaskDocument, {
      alias: 'enableGlueTask',
      ...operationOptions
    });
};

/**
 * __useEnableGlueTaskMutation__
 *
 * To run a mutation, you first call `useEnableGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableGlueTaskMutation, { data, loading, error }] = useEnableGlueTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>(EnableGlueTaskDocument, options);
      }
export type EnableGlueTaskMutationHookResult = ReturnType<typeof useEnableGlueTaskMutation>;
export type EnableGlueTaskMutationResult = ApolloReactCommon.MutationResult<EnableGlueTaskMutation>;
export type EnableGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>;
export const DisableGlueTaskDocument = gql`
    mutation DisableGlueTask($id: ID!) {
  disableGlueTask(input: {id: $id}) {
    success
    clientMutationId
  }
}
    `;
export type DisableGlueTaskMutationFn = ApolloReactCommon.MutationFunction<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>;
export type DisableGlueTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>, 'mutation'>;

    export const DisableGlueTaskComponent = (props: DisableGlueTaskComponentProps) => (
      <ApolloReactComponents.Mutation<DisableGlueTaskMutation, DisableGlueTaskMutationVariables> mutation={DisableGlueTaskDocument} {...props} />
    );
    
export type DisableGlueTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>
    } & TChildProps;
export function withDisableGlueTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DisableGlueTaskMutation,
  DisableGlueTaskMutationVariables,
  DisableGlueTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DisableGlueTaskMutation, DisableGlueTaskMutationVariables, DisableGlueTaskProps<TChildProps, TDataName>>(DisableGlueTaskDocument, {
      alias: 'disableGlueTask',
      ...operationOptions
    });
};

/**
 * __useDisableGlueTaskMutation__
 *
 * To run a mutation, you first call `useDisableGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableGlueTaskMutation, { data, loading, error }] = useDisableGlueTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>(DisableGlueTaskDocument, options);
      }
export type DisableGlueTaskMutationHookResult = ReturnType<typeof useDisableGlueTaskMutation>;
export type DisableGlueTaskMutationResult = ApolloReactCommon.MutationResult<DisableGlueTaskMutation>;
export type DisableGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>;
export const DeleteGlueTaskDocument = gql`
    mutation DeleteGlueTask($id: ID!) {
  deleteGlueTask(input: {id: $id}) {
    success
    clientMutationId
  }
}
    `;
export type DeleteGlueTaskMutationFn = ApolloReactCommon.MutationFunction<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>;
export type DeleteGlueTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>, 'mutation'>;

    export const DeleteGlueTaskComponent = (props: DeleteGlueTaskComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables> mutation={DeleteGlueTaskDocument} {...props} />
    );
    
export type DeleteGlueTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>
    } & TChildProps;
export function withDeleteGlueTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteGlueTaskMutation,
  DeleteGlueTaskMutationVariables,
  DeleteGlueTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables, DeleteGlueTaskProps<TChildProps, TDataName>>(DeleteGlueTaskDocument, {
      alias: 'deleteGlueTask',
      ...operationOptions
    });
};

/**
 * __useDeleteGlueTaskMutation__
 *
 * To run a mutation, you first call `useDeleteGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlueTaskMutation, { data, loading, error }] = useDeleteGlueTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>(DeleteGlueTaskDocument, options);
      }
export type DeleteGlueTaskMutationHookResult = ReturnType<typeof useDeleteGlueTaskMutation>;
export type DeleteGlueTaskMutationResult = ApolloReactCommon.MutationResult<DeleteGlueTaskMutation>;
export type DeleteGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>;
export const HomePageViewerDetailsDocument = gql`
    query HomePageViewerDetails($entityName: String) {
  viewer(entityName: $entityName) {
    id
    username
    name
    photoUrl
    organizations {
      id
      name
    }
    defaultEntity {
      id
      name
    }
    teams(first: 100) {
      edges {
        node {
          id
          name
          photoUrl
        }
      }
    }
  }
}
    `;
export type HomePageViewerDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>, 'query'>;

    export const HomePageViewerDetailsComponent = (props: HomePageViewerDetailsComponentProps) => (
      <ApolloReactComponents.Query<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables> query={HomePageViewerDetailsDocument} {...props} />
    );
    
export type HomePageViewerDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>
    } & TChildProps;
export function withHomePageViewerDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HomePageViewerDetailsQuery,
  HomePageViewerDetailsQueryVariables,
  HomePageViewerDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables, HomePageViewerDetailsProps<TChildProps, TDataName>>(HomePageViewerDetailsDocument, {
      alias: 'homePageViewerDetails',
      ...operationOptions
    });
};

/**
 * __useHomePageViewerDetailsQuery__
 *
 * To run a query within a React component, call `useHomePageViewerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageViewerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageViewerDetailsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useHomePageViewerDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>(HomePageViewerDetailsDocument, options);
      }
export function useHomePageViewerDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>(HomePageViewerDetailsDocument, options);
        }
// @ts-ignore
export function useHomePageViewerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>;
export function useHomePageViewerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageViewerDetailsQuery | undefined, HomePageViewerDetailsQueryVariables>;
export function useHomePageViewerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>(HomePageViewerDetailsDocument, options);
        }
export type HomePageViewerDetailsQueryHookResult = ReturnType<typeof useHomePageViewerDetailsQuery>;
export type HomePageViewerDetailsLazyQueryHookResult = ReturnType<typeof useHomePageViewerDetailsLazyQuery>;
export type HomePageViewerDetailsSuspenseQueryHookResult = ReturnType<typeof useHomePageViewerDetailsSuspenseQuery>;
export type HomePageViewerDetailsQueryResult = ApolloReactCommon.QueryResult<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>;
export const HomePageViewerProjectsDocument = gql`
    query HomePageViewerProjects($entityName: String!, $first: Int = 20, $pattern: String) {
  projects(
    entityName: $entityName
    first: $first
    pattern: $pattern
    order: "-created_at"
  ) {
    edges {
      node {
        id
        name
        entityName
        access
        createdAt
      }
    }
  }
}
    `;
export type HomePageViewerProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>, 'query'> & ({ variables: HomePageViewerProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HomePageViewerProjectsComponent = (props: HomePageViewerProjectsComponentProps) => (
      <ApolloReactComponents.Query<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables> query={HomePageViewerProjectsDocument} {...props} />
    );
    
export type HomePageViewerProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>
    } & TChildProps;
export function withHomePageViewerProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HomePageViewerProjectsQuery,
  HomePageViewerProjectsQueryVariables,
  HomePageViewerProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables, HomePageViewerProjectsProps<TChildProps, TDataName>>(HomePageViewerProjectsDocument, {
      alias: 'homePageViewerProjects',
      ...operationOptions
    });
};

/**
 * __useHomePageViewerProjectsQuery__
 *
 * To run a query within a React component, call `useHomePageViewerProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageViewerProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageViewerProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useHomePageViewerProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables> & ({ variables: HomePageViewerProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>(HomePageViewerProjectsDocument, options);
      }
export function useHomePageViewerProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>(HomePageViewerProjectsDocument, options);
        }
// @ts-ignore
export function useHomePageViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>;
export function useHomePageViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageViewerProjectsQuery | undefined, HomePageViewerProjectsQueryVariables>;
export function useHomePageViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>(HomePageViewerProjectsDocument, options);
        }
export type HomePageViewerProjectsQueryHookResult = ReturnType<typeof useHomePageViewerProjectsQuery>;
export type HomePageViewerProjectsLazyQueryHookResult = ReturnType<typeof useHomePageViewerProjectsLazyQuery>;
export type HomePageViewerProjectsSuspenseQueryHookResult = ReturnType<typeof useHomePageViewerProjectsSuspenseQuery>;
export type HomePageViewerProjectsQueryResult = ApolloReactCommon.QueryResult<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>;
export const ViewerReportsDocument = gql`
    query ViewerReports($entityName: String) {
  viewer(entityName: $entityName) {
    id
    views(viewType: "runs", first: 100) {
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;
export type ViewerReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerReportsQuery, ViewerReportsQueryVariables>, 'query'>;

    export const ViewerReportsComponent = (props: ViewerReportsComponentProps) => (
      <ApolloReactComponents.Query<ViewerReportsQuery, ViewerReportsQueryVariables> query={ViewerReportsDocument} {...props} />
    );
    
export type ViewerReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerReportsQuery, ViewerReportsQueryVariables>
    } & TChildProps;
export function withViewerReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerReportsQuery,
  ViewerReportsQueryVariables,
  ViewerReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerReportsQuery, ViewerReportsQueryVariables, ViewerReportsProps<TChildProps, TDataName>>(ViewerReportsDocument, {
      alias: 'viewerReports',
      ...operationOptions
    });
};

/**
 * __useViewerReportsQuery__
 *
 * To run a query within a React component, call `useViewerReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerReportsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useViewerReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerReportsQuery, ViewerReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerReportsQuery, ViewerReportsQueryVariables>(ViewerReportsDocument, options);
      }
export function useViewerReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerReportsQuery, ViewerReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerReportsQuery, ViewerReportsQueryVariables>(ViewerReportsDocument, options);
        }
// @ts-ignore
export function useViewerReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerReportsQuery, ViewerReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerReportsQuery, ViewerReportsQueryVariables>;
export function useViewerReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerReportsQuery, ViewerReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerReportsQuery | undefined, ViewerReportsQueryVariables>;
export function useViewerReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerReportsQuery, ViewerReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerReportsQuery, ViewerReportsQueryVariables>(ViewerReportsDocument, options);
        }
export type ViewerReportsQueryHookResult = ReturnType<typeof useViewerReportsQuery>;
export type ViewerReportsLazyQueryHookResult = ReturnType<typeof useViewerReportsLazyQuery>;
export type ViewerReportsSuspenseQueryHookResult = ReturnType<typeof useViewerReportsSuspenseQuery>;
export type ViewerReportsQueryResult = ApolloReactCommon.QueryResult<ViewerReportsQuery, ViewerReportsQueryVariables>;
export const ViewerRunsDocument = gql`
    query ViewerRuns($entityName: String, $first: Int = 100) {
  viewer(entityName: $entityName) {
    id
    runs(first: $first) {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
  }
}
    ${RunsTableFragmentFragmentDoc}`;
export type ViewerRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerRunsQuery, ViewerRunsQueryVariables>, 'query'>;

    export const ViewerRunsComponent = (props: ViewerRunsComponentProps) => (
      <ApolloReactComponents.Query<ViewerRunsQuery, ViewerRunsQueryVariables> query={ViewerRunsDocument} {...props} />
    );
    
export type ViewerRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerRunsQuery, ViewerRunsQueryVariables>
    } & TChildProps;
export function withViewerRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerRunsQuery,
  ViewerRunsQueryVariables,
  ViewerRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerRunsQuery, ViewerRunsQueryVariables, ViewerRunsProps<TChildProps, TDataName>>(ViewerRunsDocument, {
      alias: 'viewerRuns',
      ...operationOptions
    });
};

/**
 * __useViewerRunsQuery__
 *
 * To run a query within a React component, call `useViewerRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerRunsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useViewerRunsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerRunsQuery, ViewerRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerRunsQuery, ViewerRunsQueryVariables>(ViewerRunsDocument, options);
      }
export function useViewerRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerRunsQuery, ViewerRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerRunsQuery, ViewerRunsQueryVariables>(ViewerRunsDocument, options);
        }
// @ts-ignore
export function useViewerRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerRunsQuery, ViewerRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerRunsQuery, ViewerRunsQueryVariables>;
export function useViewerRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerRunsQuery, ViewerRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerRunsQuery | undefined, ViewerRunsQueryVariables>;
export function useViewerRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerRunsQuery, ViewerRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerRunsQuery, ViewerRunsQueryVariables>(ViewerRunsDocument, options);
        }
export type ViewerRunsQueryHookResult = ReturnType<typeof useViewerRunsQuery>;
export type ViewerRunsLazyQueryHookResult = ReturnType<typeof useViewerRunsLazyQuery>;
export type ViewerRunsSuspenseQueryHookResult = ReturnType<typeof useViewerRunsSuspenseQuery>;
export type ViewerRunsQueryResult = ApolloReactCommon.QueryResult<ViewerRunsQuery, ViewerRunsQueryVariables>;
export const EntityProjectsDocument = gql`
    query EntityProjects($entityName: String!, $first: Int = 20) {
  entity(name: $entityName) {
    id
    projects(first: $first) {
      edges {
        node {
          id
          ...AccountProjectFragment
        }
      }
    }
  }
}
    ${AccountProjectFragmentFragmentDoc}`;
export type EntityProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityProjectsQuery, EntityProjectsQueryVariables>, 'query'> & ({ variables: EntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityProjectsComponent = (props: EntityProjectsComponentProps) => (
      <ApolloReactComponents.Query<EntityProjectsQuery, EntityProjectsQueryVariables> query={EntityProjectsDocument} {...props} />
    );
    
export type EntityProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityProjectsQuery, EntityProjectsQueryVariables>
    } & TChildProps;
export function withEntityProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityProjectsQuery,
  EntityProjectsQueryVariables,
  EntityProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityProjectsQuery, EntityProjectsQueryVariables, EntityProjectsProps<TChildProps, TDataName>>(EntityProjectsDocument, {
      alias: 'entityProjects',
      ...operationOptions
    });
};

/**
 * __useEntityProjectsQuery__
 *
 * To run a query within a React component, call `useEntityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useEntityProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables> & ({ variables: EntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityProjectsQuery, EntityProjectsQueryVariables>(EntityProjectsDocument, options);
      }
export function useEntityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityProjectsQuery, EntityProjectsQueryVariables>(EntityProjectsDocument, options);
        }
// @ts-ignore
export function useEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProjectsQuery, EntityProjectsQueryVariables>;
export function useEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProjectsQuery | undefined, EntityProjectsQueryVariables>;
export function useEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityProjectsQuery, EntityProjectsQueryVariables>(EntityProjectsDocument, options);
        }
export type EntityProjectsQueryHookResult = ReturnType<typeof useEntityProjectsQuery>;
export type EntityProjectsLazyQueryHookResult = ReturnType<typeof useEntityProjectsLazyQuery>;
export type EntityProjectsSuspenseQueryHookResult = ReturnType<typeof useEntityProjectsSuspenseQuery>;
export type EntityProjectsQueryResult = ApolloReactCommon.QueryResult<EntityProjectsQuery, EntityProjectsQueryVariables>;
export const EntityReportsDocument = gql`
    query EntityReports($entityName: String!) {
  entity(name: $entityName) {
    id
    views(first: 100) {
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;
export type EntityReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityReportsQuery, EntityReportsQueryVariables>, 'query'> & ({ variables: EntityReportsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityReportsComponent = (props: EntityReportsComponentProps) => (
      <ApolloReactComponents.Query<EntityReportsQuery, EntityReportsQueryVariables> query={EntityReportsDocument} {...props} />
    );
    
export type EntityReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityReportsQuery, EntityReportsQueryVariables>
    } & TChildProps;
export function withEntityReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityReportsQuery,
  EntityReportsQueryVariables,
  EntityReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityReportsQuery, EntityReportsQueryVariables, EntityReportsProps<TChildProps, TDataName>>(EntityReportsDocument, {
      alias: 'entityReports',
      ...operationOptions
    });
};

/**
 * __useEntityReportsQuery__
 *
 * To run a query within a React component, call `useEntityReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityReportsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables> & ({ variables: EntityReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityReportsQuery, EntityReportsQueryVariables>(EntityReportsDocument, options);
      }
export function useEntityReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityReportsQuery, EntityReportsQueryVariables>(EntityReportsDocument, options);
        }
// @ts-ignore
export function useEntityReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityReportsQuery, EntityReportsQueryVariables>;
export function useEntityReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityReportsQuery | undefined, EntityReportsQueryVariables>;
export function useEntityReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityReportsQuery, EntityReportsQueryVariables>(EntityReportsDocument, options);
        }
export type EntityReportsQueryHookResult = ReturnType<typeof useEntityReportsQuery>;
export type EntityReportsLazyQueryHookResult = ReturnType<typeof useEntityReportsLazyQuery>;
export type EntityReportsSuspenseQueryHookResult = ReturnType<typeof useEntityReportsSuspenseQuery>;
export type EntityReportsQueryResult = ApolloReactCommon.QueryResult<EntityReportsQuery, EntityReportsQueryVariables>;
export const OrganizationReportsDocument = gql`
    query OrganizationReports($orgID: ID!, $userID: ID) {
  organization(id: $orgID) {
    id
    views(first: 100, userID: $userID) {
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;
export type OrganizationReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>, 'query'> & ({ variables: OrganizationReportsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationReportsComponent = (props: OrganizationReportsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationReportsQuery, OrganizationReportsQueryVariables> query={OrganizationReportsDocument} {...props} />
    );
    
export type OrganizationReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationReportsQuery, OrganizationReportsQueryVariables>
    } & TChildProps;
export function withOrganizationReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationReportsQuery,
  OrganizationReportsQueryVariables,
  OrganizationReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationReportsQuery, OrganizationReportsQueryVariables, OrganizationReportsProps<TChildProps, TDataName>>(OrganizationReportsDocument, {
      alias: 'organizationReports',
      ...operationOptions
    });
};

/**
 * __useOrganizationReportsQuery__
 *
 * To run a query within a React component, call `useOrganizationReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationReportsQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useOrganizationReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables> & ({ variables: OrganizationReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationReportsQuery, OrganizationReportsQueryVariables>(OrganizationReportsDocument, options);
      }
export function useOrganizationReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationReportsQuery, OrganizationReportsQueryVariables>(OrganizationReportsDocument, options);
        }
// @ts-ignore
export function useOrganizationReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationReportsQuery, OrganizationReportsQueryVariables>;
export function useOrganizationReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationReportsQuery | undefined, OrganizationReportsQueryVariables>;
export function useOrganizationReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationReportsQuery, OrganizationReportsQueryVariables>(OrganizationReportsDocument, options);
        }
export type OrganizationReportsQueryHookResult = ReturnType<typeof useOrganizationReportsQuery>;
export type OrganizationReportsLazyQueryHookResult = ReturnType<typeof useOrganizationReportsLazyQuery>;
export type OrganizationReportsSuspenseQueryHookResult = ReturnType<typeof useOrganizationReportsSuspenseQuery>;
export type OrganizationReportsQueryResult = ApolloReactCommon.QueryResult<OrganizationReportsQuery, OrganizationReportsQueryVariables>;
export const AccountTeamsDocument = gql`
    query AccountTeams {
  viewer {
    id
    name
    username
    teams {
      edges {
        node {
          id
          isTeam
          organizationId
          name
          defaultAccess
          privateOnly
          members {
            id
            name
            username
            memberRole {
              name
            }
            email
            pending
            photoUrl
            accountType
            role
          }
        }
      }
    }
  }
}
    `;
export type AccountTeamsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountTeamsQuery, AccountTeamsQueryVariables>, 'query'>;

    export const AccountTeamsComponent = (props: AccountTeamsComponentProps) => (
      <ApolloReactComponents.Query<AccountTeamsQuery, AccountTeamsQueryVariables> query={AccountTeamsDocument} {...props} />
    );
    
export type AccountTeamsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountTeamsQuery, AccountTeamsQueryVariables>
    } & TChildProps;
export function withAccountTeams<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountTeamsQuery,
  AccountTeamsQueryVariables,
  AccountTeamsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountTeamsQuery, AccountTeamsQueryVariables, AccountTeamsProps<TChildProps, TDataName>>(AccountTeamsDocument, {
      alias: 'accountTeams',
      ...operationOptions
    });
};

/**
 * __useAccountTeamsQuery__
 *
 * To run a query within a React component, call `useAccountTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountTeamsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountTeamsQuery, AccountTeamsQueryVariables>(AccountTeamsDocument, options);
      }
export function useAccountTeamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountTeamsQuery, AccountTeamsQueryVariables>(AccountTeamsDocument, options);
        }
// @ts-ignore
export function useAccountTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountTeamsQuery, AccountTeamsQueryVariables>;
export function useAccountTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountTeamsQuery | undefined, AccountTeamsQueryVariables>;
export function useAccountTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountTeamsQuery, AccountTeamsQueryVariables>(AccountTeamsDocument, options);
        }
export type AccountTeamsQueryHookResult = ReturnType<typeof useAccountTeamsQuery>;
export type AccountTeamsLazyQueryHookResult = ReturnType<typeof useAccountTeamsLazyQuery>;
export type AccountTeamsSuspenseQueryHookResult = ReturnType<typeof useAccountTeamsSuspenseQuery>;
export type AccountTeamsQueryResult = ApolloReactCommon.QueryResult<AccountTeamsQuery, AccountTeamsQueryVariables>;
export const CreateSlackIntegrationDocument = gql`
    mutation CreateSlackIntegration($code: String!, $entityName: String!, $redirectURI: String!) {
  createSlackIntegration(
    input: {code: $code, entityName: $entityName, redirectURI: $redirectURI}
  ) {
    integration {
      id
    }
  }
}
    `;
export type CreateSlackIntegrationMutationFn = ApolloReactCommon.MutationFunction<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>;
export type CreateSlackIntegrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>, 'mutation'>;

    export const CreateSlackIntegrationComponent = (props: CreateSlackIntegrationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables> mutation={CreateSlackIntegrationDocument} {...props} />
    );
    
export type CreateSlackIntegrationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>
    } & TChildProps;
export function withCreateSlackIntegration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSlackIntegrationMutation,
  CreateSlackIntegrationMutationVariables,
  CreateSlackIntegrationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables, CreateSlackIntegrationProps<TChildProps, TDataName>>(CreateSlackIntegrationDocument, {
      alias: 'createSlackIntegration',
      ...operationOptions
    });
};

/**
 * __useCreateSlackIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateSlackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackIntegrationMutation, { data, loading, error }] = useCreateSlackIntegrationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      entityName: // value for 'entityName'
 *      redirectURI: // value for 'redirectURI'
 *   },
 * });
 */
export function useCreateSlackIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>(CreateSlackIntegrationDocument, options);
      }
export type CreateSlackIntegrationMutationHookResult = ReturnType<typeof useCreateSlackIntegrationMutation>;
export type CreateSlackIntegrationMutationResult = ApolloReactCommon.MutationResult<CreateSlackIntegrationMutation>;
export type CreateSlackIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>;
export const CreateGenericWebhookIntegrationDocument = gql`
    mutation CreateGenericWebhookIntegration($entityName: String!, $webhookName: String!, $urlEndpoint: String!, $accessTokenRef: String, $secretRef: String) {
  createGenericWebhookIntegration(
    input: {entityName: $entityName, name: $webhookName, urlEndpoint: $urlEndpoint, accessTokenRef: $accessTokenRef, secretRef: $secretRef}
  ) {
    integration {
      __typename
      ... on GenericWebhookIntegration {
        id
        urlEndpoint
        name
      }
    }
  }
}
    `;
export type CreateGenericWebhookIntegrationMutationFn = ApolloReactCommon.MutationFunction<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>;
export type CreateGenericWebhookIntegrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>, 'mutation'>;

    export const CreateGenericWebhookIntegrationComponent = (props: CreateGenericWebhookIntegrationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables> mutation={CreateGenericWebhookIntegrationDocument} {...props} />
    );
    
export type CreateGenericWebhookIntegrationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>
    } & TChildProps;
export function withCreateGenericWebhookIntegration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateGenericWebhookIntegrationMutation,
  CreateGenericWebhookIntegrationMutationVariables,
  CreateGenericWebhookIntegrationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables, CreateGenericWebhookIntegrationProps<TChildProps, TDataName>>(CreateGenericWebhookIntegrationDocument, {
      alias: 'createGenericWebhookIntegration',
      ...operationOptions
    });
};

/**
 * __useCreateGenericWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateGenericWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericWebhookIntegrationMutation, { data, loading, error }] = useCreateGenericWebhookIntegrationMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      webhookName: // value for 'webhookName'
 *      urlEndpoint: // value for 'urlEndpoint'
 *      accessTokenRef: // value for 'accessTokenRef'
 *      secretRef: // value for 'secretRef'
 *   },
 * });
 */
export function useCreateGenericWebhookIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>(CreateGenericWebhookIntegrationDocument, options);
      }
export type CreateGenericWebhookIntegrationMutationHookResult = ReturnType<typeof useCreateGenericWebhookIntegrationMutation>;
export type CreateGenericWebhookIntegrationMutationResult = ApolloReactCommon.MutationResult<CreateGenericWebhookIntegrationMutation>;
export type CreateGenericWebhookIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>;
export const UpdateGenericWebhookIntegrationDocument = gql`
    mutation UpdateGenericWebhookIntegration($integrationID: ID!, $webhookName: String, $urlEndpoint: String, $accessTokenRef: String, $secretRef: String) {
  updateGenericWebhookIntegration(
    input: {id: $integrationID, name: $webhookName, urlEndpoint: $urlEndpoint, accessTokenRef: $accessTokenRef, secretRef: $secretRef}
  ) {
    integration {
      __typename
      ... on GenericWebhookIntegration {
        id
        urlEndpoint
        name
      }
    }
  }
}
    `;
export type UpdateGenericWebhookIntegrationMutationFn = ApolloReactCommon.MutationFunction<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>;
export type UpdateGenericWebhookIntegrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>, 'mutation'>;

    export const UpdateGenericWebhookIntegrationComponent = (props: UpdateGenericWebhookIntegrationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables> mutation={UpdateGenericWebhookIntegrationDocument} {...props} />
    );
    
export type UpdateGenericWebhookIntegrationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>
    } & TChildProps;
export function withUpdateGenericWebhookIntegration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateGenericWebhookIntegrationMutation,
  UpdateGenericWebhookIntegrationMutationVariables,
  UpdateGenericWebhookIntegrationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables, UpdateGenericWebhookIntegrationProps<TChildProps, TDataName>>(UpdateGenericWebhookIntegrationDocument, {
      alias: 'updateGenericWebhookIntegration',
      ...operationOptions
    });
};

/**
 * __useUpdateGenericWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateGenericWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericWebhookIntegrationMutation, { data, loading, error }] = useUpdateGenericWebhookIntegrationMutation({
 *   variables: {
 *      integrationID: // value for 'integrationID'
 *      webhookName: // value for 'webhookName'
 *      urlEndpoint: // value for 'urlEndpoint'
 *      accessTokenRef: // value for 'accessTokenRef'
 *      secretRef: // value for 'secretRef'
 *   },
 * });
 */
export function useUpdateGenericWebhookIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>(UpdateGenericWebhookIntegrationDocument, options);
      }
export type UpdateGenericWebhookIntegrationMutationHookResult = ReturnType<typeof useUpdateGenericWebhookIntegrationMutation>;
export type UpdateGenericWebhookIntegrationMutationResult = ApolloReactCommon.MutationResult<UpdateGenericWebhookIntegrationMutation>;
export type UpdateGenericWebhookIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>;
export const TestGenericWebhookIntegrationDocument = gql`
    mutation TestGenericWebhookIntegration($entityName: String!, $urlEndpoint: String!, $accessTokenRef: String, $secretRef: String, $requestPayload: JSONString) {
  testGenericWebhookIntegration(
    input: {entityName: $entityName, urlEndpoint: $urlEndpoint, accessTokenRef: $accessTokenRef, secretRef: $secretRef, requestPayload: $requestPayload}
  ) {
    ok
    response
  }
}
    `;
export type TestGenericWebhookIntegrationMutationFn = ApolloReactCommon.MutationFunction<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>;
export type TestGenericWebhookIntegrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>, 'mutation'>;

    export const TestGenericWebhookIntegrationComponent = (props: TestGenericWebhookIntegrationComponentProps) => (
      <ApolloReactComponents.Mutation<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables> mutation={TestGenericWebhookIntegrationDocument} {...props} />
    );
    
export type TestGenericWebhookIntegrationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>
    } & TChildProps;
export function withTestGenericWebhookIntegration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TestGenericWebhookIntegrationMutation,
  TestGenericWebhookIntegrationMutationVariables,
  TestGenericWebhookIntegrationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables, TestGenericWebhookIntegrationProps<TChildProps, TDataName>>(TestGenericWebhookIntegrationDocument, {
      alias: 'testGenericWebhookIntegration',
      ...operationOptions
    });
};

/**
 * __useTestGenericWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useTestGenericWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestGenericWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testGenericWebhookIntegrationMutation, { data, loading, error }] = useTestGenericWebhookIntegrationMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      urlEndpoint: // value for 'urlEndpoint'
 *      accessTokenRef: // value for 'accessTokenRef'
 *      secretRef: // value for 'secretRef'
 *      requestPayload: // value for 'requestPayload'
 *   },
 * });
 */
export function useTestGenericWebhookIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>(TestGenericWebhookIntegrationDocument, options);
      }
export type TestGenericWebhookIntegrationMutationHookResult = ReturnType<typeof useTestGenericWebhookIntegrationMutation>;
export type TestGenericWebhookIntegrationMutationResult = ApolloReactCommon.MutationResult<TestGenericWebhookIntegrationMutation>;
export type TestGenericWebhookIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>;
export const DeleteIntegrationDocument = gql`
    mutation DeleteIntegration($id: ID!) {
  deleteIntegration(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteIntegrationMutationFn = ApolloReactCommon.MutationFunction<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;
export type DeleteIntegrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>, 'mutation'>;

    export const DeleteIntegrationComponent = (props: DeleteIntegrationComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteIntegrationMutation, DeleteIntegrationMutationVariables> mutation={DeleteIntegrationDocument} {...props} />
    );
    
export type DeleteIntegrationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>
    } & TChildProps;
export function withDeleteIntegration<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteIntegrationMutation,
  DeleteIntegrationMutationVariables,
  DeleteIntegrationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteIntegrationMutation, DeleteIntegrationMutationVariables, DeleteIntegrationProps<TChildProps, TDataName>>(DeleteIntegrationDocument, {
      alias: 'deleteIntegration',
      ...operationOptions
    });
};

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationMutation, { data, loading, error }] = useDeleteIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>(DeleteIntegrationDocument, options);
      }
export type DeleteIntegrationMutationHookResult = ReturnType<typeof useDeleteIntegrationMutation>;
export type DeleteIntegrationMutationResult = ApolloReactCommon.MutationResult<DeleteIntegrationMutation>;
export type DeleteIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;
export const FetchLaunchAgentsFromProjectDocument = gql`
    query fetchLaunchAgentsFromProject($entityName: String!, $projectName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    launchAgents {
      id
      name
      createdAt
      agentStatus
      stopPolling
      runQueues
      hostname
      agentConfig
      version
    }
  }
}
    `;
export type FetchLaunchAgentsFromProjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>, 'query'> & ({ variables: FetchLaunchAgentsFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchLaunchAgentsFromProjectComponent = (props: FetchLaunchAgentsFromProjectComponentProps) => (
      <ApolloReactComponents.Query<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables> query={FetchLaunchAgentsFromProjectDocument} {...props} />
    );
    
export type FetchLaunchAgentsFromProjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>
    } & TChildProps;
export function withFetchLaunchAgentsFromProject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchLaunchAgentsFromProjectQuery,
  FetchLaunchAgentsFromProjectQueryVariables,
  FetchLaunchAgentsFromProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables, FetchLaunchAgentsFromProjectProps<TChildProps, TDataName>>(FetchLaunchAgentsFromProjectDocument, {
      alias: 'fetchLaunchAgentsFromProject',
      ...operationOptions
    });
};

/**
 * __useFetchLaunchAgentsFromProjectQuery__
 *
 * To run a query within a React component, call `useFetchLaunchAgentsFromProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLaunchAgentsFromProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLaunchAgentsFromProjectQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchLaunchAgentsFromProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables> & ({ variables: FetchLaunchAgentsFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>(FetchLaunchAgentsFromProjectDocument, options);
      }
export function useFetchLaunchAgentsFromProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>(FetchLaunchAgentsFromProjectDocument, options);
        }
// @ts-ignore
export function useFetchLaunchAgentsFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>;
export function useFetchLaunchAgentsFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchLaunchAgentsFromProjectQuery | undefined, FetchLaunchAgentsFromProjectQueryVariables>;
export function useFetchLaunchAgentsFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>(FetchLaunchAgentsFromProjectDocument, options);
        }
export type FetchLaunchAgentsFromProjectQueryHookResult = ReturnType<typeof useFetchLaunchAgentsFromProjectQuery>;
export type FetchLaunchAgentsFromProjectLazyQueryHookResult = ReturnType<typeof useFetchLaunchAgentsFromProjectLazyQuery>;
export type FetchLaunchAgentsFromProjectSuspenseQueryHookResult = ReturnType<typeof useFetchLaunchAgentsFromProjectSuspenseQuery>;
export type FetchLaunchAgentsFromProjectQueryResult = ApolloReactCommon.QueryResult<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>;
export const StopLaunchAgentDocument = gql`
    mutation stopLaunchAgent($agentId: ID!, $stopPolling: Boolean) {
  updateLaunchAgent(input: {launchAgentId: $agentId, stopPolling: $stopPolling}) {
    success
  }
}
    `;
export type StopLaunchAgentMutationFn = ApolloReactCommon.MutationFunction<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>;
export type StopLaunchAgentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>, 'mutation'>;

    export const StopLaunchAgentComponent = (props: StopLaunchAgentComponentProps) => (
      <ApolloReactComponents.Mutation<StopLaunchAgentMutation, StopLaunchAgentMutationVariables> mutation={StopLaunchAgentDocument} {...props} />
    );
    
export type StopLaunchAgentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>
    } & TChildProps;
export function withStopLaunchAgent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StopLaunchAgentMutation,
  StopLaunchAgentMutationVariables,
  StopLaunchAgentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, StopLaunchAgentMutation, StopLaunchAgentMutationVariables, StopLaunchAgentProps<TChildProps, TDataName>>(StopLaunchAgentDocument, {
      alias: 'stopLaunchAgent',
      ...operationOptions
    });
};

/**
 * __useStopLaunchAgentMutation__
 *
 * To run a mutation, you first call `useStopLaunchAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopLaunchAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopLaunchAgentMutation, { data, loading, error }] = useStopLaunchAgentMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      stopPolling: // value for 'stopPolling'
 *   },
 * });
 */
export function useStopLaunchAgentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>(StopLaunchAgentDocument, options);
      }
export type StopLaunchAgentMutationHookResult = ReturnType<typeof useStopLaunchAgentMutation>;
export type StopLaunchAgentMutationResult = ApolloReactCommon.MutationResult<StopLaunchAgentMutation>;
export type StopLaunchAgentMutationOptions = ApolloReactCommon.BaseMutationOptions<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>;
export const DeleteLaunchAgentsDocument = gql`
    mutation deleteLaunchAgents($agentIds: [ID!]!) {
  deleteLaunchAgents(input: {launchAgentIds: $agentIds}) {
    success
  }
}
    `;
export type DeleteLaunchAgentsMutationFn = ApolloReactCommon.MutationFunction<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>;
export type DeleteLaunchAgentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>, 'mutation'>;

    export const DeleteLaunchAgentsComponent = (props: DeleteLaunchAgentsComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables> mutation={DeleteLaunchAgentsDocument} {...props} />
    );
    
export type DeleteLaunchAgentsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>
    } & TChildProps;
export function withDeleteLaunchAgents<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteLaunchAgentsMutation,
  DeleteLaunchAgentsMutationVariables,
  DeleteLaunchAgentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables, DeleteLaunchAgentsProps<TChildProps, TDataName>>(DeleteLaunchAgentsDocument, {
      alias: 'deleteLaunchAgents',
      ...operationOptions
    });
};

/**
 * __useDeleteLaunchAgentsMutation__
 *
 * To run a mutation, you first call `useDeleteLaunchAgentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLaunchAgentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLaunchAgentsMutation, { data, loading, error }] = useDeleteLaunchAgentsMutation({
 *   variables: {
 *      agentIds: // value for 'agentIds'
 *   },
 * });
 */
export function useDeleteLaunchAgentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>(DeleteLaunchAgentsDocument, options);
      }
export type DeleteLaunchAgentsMutationHookResult = ReturnType<typeof useDeleteLaunchAgentsMutation>;
export type DeleteLaunchAgentsMutationResult = ApolloReactCommon.MutationResult<DeleteLaunchAgentsMutation>;
export type DeleteLaunchAgentsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>;
export const HasLocalLicenseDocument = gql`
    query HasLocalLicense {
  serverInfo {
    hasLocalLicense
  }
}
    `;
export type HasLocalLicenseComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>, 'query'>;

    export const HasLocalLicenseComponent = (props: HasLocalLicenseComponentProps) => (
      <ApolloReactComponents.Query<HasLocalLicenseQuery, HasLocalLicenseQueryVariables> query={HasLocalLicenseDocument} {...props} />
    );
    
export type HasLocalLicenseProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>
    } & TChildProps;
export function withHasLocalLicense<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HasLocalLicenseQuery,
  HasLocalLicenseQueryVariables,
  HasLocalLicenseProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HasLocalLicenseQuery, HasLocalLicenseQueryVariables, HasLocalLicenseProps<TChildProps, TDataName>>(HasLocalLicenseDocument, {
      alias: 'hasLocalLicense',
      ...operationOptions
    });
};

/**
 * __useHasLocalLicenseQuery__
 *
 * To run a query within a React component, call `useHasLocalLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasLocalLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasLocalLicenseQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasLocalLicenseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>(HasLocalLicenseDocument, options);
      }
export function useHasLocalLicenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>(HasLocalLicenseDocument, options);
        }
// @ts-ignore
export function useHasLocalLicenseSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>;
export function useHasLocalLicenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HasLocalLicenseQuery | undefined, HasLocalLicenseQueryVariables>;
export function useHasLocalLicenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>(HasLocalLicenseDocument, options);
        }
export type HasLocalLicenseQueryHookResult = ReturnType<typeof useHasLocalLicenseQuery>;
export type HasLocalLicenseLazyQueryHookResult = ReturnType<typeof useHasLocalLicenseLazyQuery>;
export type HasLocalLicenseSuspenseQueryHookResult = ReturnType<typeof useHasLocalLicenseSuspenseQuery>;
export type HasLocalLicenseQueryResult = ApolloReactCommon.QueryResult<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>;
export const LatestLocalVersionInfoDocument = gql`
    query latestLocalVersionInfo {
  serverInfo {
    latestLocalVersionInfo {
      outOfDate
      latestVersionString
      versionOnThisInstanceString
    }
  }
}
    `;
export type LatestLocalVersionInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>, 'query'>;

    export const LatestLocalVersionInfoComponent = (props: LatestLocalVersionInfoComponentProps) => (
      <ApolloReactComponents.Query<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables> query={LatestLocalVersionInfoDocument} {...props} />
    );
    
export type LatestLocalVersionInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>
    } & TChildProps;
export function withLatestLocalVersionInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LatestLocalVersionInfoQuery,
  LatestLocalVersionInfoQueryVariables,
  LatestLocalVersionInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables, LatestLocalVersionInfoProps<TChildProps, TDataName>>(LatestLocalVersionInfoDocument, {
      alias: 'latestLocalVersionInfo',
      ...operationOptions
    });
};

/**
 * __useLatestLocalVersionInfoQuery__
 *
 * To run a query within a React component, call `useLatestLocalVersionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestLocalVersionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestLocalVersionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestLocalVersionInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>(LatestLocalVersionInfoDocument, options);
      }
export function useLatestLocalVersionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>(LatestLocalVersionInfoDocument, options);
        }
// @ts-ignore
export function useLatestLocalVersionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>;
export function useLatestLocalVersionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LatestLocalVersionInfoQuery | undefined, LatestLocalVersionInfoQueryVariables>;
export function useLatestLocalVersionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>(LatestLocalVersionInfoDocument, options);
        }
export type LatestLocalVersionInfoQueryHookResult = ReturnType<typeof useLatestLocalVersionInfoQuery>;
export type LatestLocalVersionInfoLazyQueryHookResult = ReturnType<typeof useLatestLocalVersionInfoLazyQuery>;
export type LatestLocalVersionInfoSuspenseQueryHookResult = ReturnType<typeof useLatestLocalVersionInfoSuspenseQuery>;
export type LatestLocalVersionInfoQueryResult = ApolloReactCommon.QueryResult<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>;
export const AvailableFilesQueryDocument = gql`
    query AvailableFilesQuery($projectName: String!, $entityName: String!, $runName: String!, $filenames: [String!]!, $includeDirectUrl: Boolean!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      files(names: $filenames) {
        edges {
          node {
            id
            name
            directUrl @include(if: $includeDirectUrl)
            url(upload: false)
            md5
            sizeBytes
          }
        }
      }
    }
  }
}
    `;
export type AvailableFilesQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>, 'query'> & ({ variables: AvailableFilesQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AvailableFilesQueryComponent = (props: AvailableFilesQueryComponentProps) => (
      <ApolloReactComponents.Query<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables> query={AvailableFilesQueryDocument} {...props} />
    );
    
export type AvailableFilesQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>
    } & TChildProps;
export function withAvailableFilesQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AvailableFilesQueryQuery,
  AvailableFilesQueryQueryVariables,
  AvailableFilesQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables, AvailableFilesQueryProps<TChildProps, TDataName>>(AvailableFilesQueryDocument, {
      alias: 'availableFilesQuery',
      ...operationOptions
    });
};

/**
 * __useAvailableFilesQueryQuery__
 *
 * To run a query within a React component, call `useAvailableFilesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableFilesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableFilesQueryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      filenames: // value for 'filenames'
 *      includeDirectUrl: // value for 'includeDirectUrl'
 *   },
 * });
 */
export function useAvailableFilesQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables> & ({ variables: AvailableFilesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>(AvailableFilesQueryDocument, options);
      }
export function useAvailableFilesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>(AvailableFilesQueryDocument, options);
        }
// @ts-ignore
export function useAvailableFilesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>;
export function useAvailableFilesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableFilesQueryQuery | undefined, AvailableFilesQueryQueryVariables>;
export function useAvailableFilesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>(AvailableFilesQueryDocument, options);
        }
export type AvailableFilesQueryQueryHookResult = ReturnType<typeof useAvailableFilesQueryQuery>;
export type AvailableFilesQueryLazyQueryHookResult = ReturnType<typeof useAvailableFilesQueryLazyQuery>;
export type AvailableFilesQuerySuspenseQueryHookResult = ReturnType<typeof useAvailableFilesQuerySuspenseQuery>;
export type AvailableFilesQueryQueryResult = ApolloReactCommon.QueryResult<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>;
export const DirectUrlQueryDocument = gql`
    query DirectUrlQuery($projectName: String!, $entityName: String!, $runName: String!, $filenames: [String!]!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      files(names: $filenames) {
        edges {
          node {
            id
            name
            directUrl
            url(upload: false)
            thumbnails {
              size
              directUrl
              originalImageWidth
              originalImageHeight
            }
            hlsSrc
          }
        }
      }
    }
  }
}
    `;
export type DirectUrlQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>, 'query'> & ({ variables: DirectUrlQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DirectUrlQueryComponent = (props: DirectUrlQueryComponentProps) => (
      <ApolloReactComponents.Query<DirectUrlQueryQuery, DirectUrlQueryQueryVariables> query={DirectUrlQueryDocument} {...props} />
    );
    
export type DirectUrlQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>
    } & TChildProps;
export function withDirectUrlQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DirectUrlQueryQuery,
  DirectUrlQueryQueryVariables,
  DirectUrlQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, DirectUrlQueryQuery, DirectUrlQueryQueryVariables, DirectUrlQueryProps<TChildProps, TDataName>>(DirectUrlQueryDocument, {
      alias: 'directUrlQuery',
      ...operationOptions
    });
};

/**
 * __useDirectUrlQueryQuery__
 *
 * To run a query within a React component, call `useDirectUrlQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectUrlQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectUrlQueryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      filenames: // value for 'filenames'
 *   },
 * });
 */
export function useDirectUrlQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables> & ({ variables: DirectUrlQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>(DirectUrlQueryDocument, options);
      }
export function useDirectUrlQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>(DirectUrlQueryDocument, options);
        }
// @ts-ignore
export function useDirectUrlQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>;
export function useDirectUrlQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DirectUrlQueryQuery | undefined, DirectUrlQueryQueryVariables>;
export function useDirectUrlQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>(DirectUrlQueryDocument, options);
        }
export type DirectUrlQueryQueryHookResult = ReturnType<typeof useDirectUrlQueryQuery>;
export type DirectUrlQueryLazyQueryHookResult = ReturnType<typeof useDirectUrlQueryLazyQuery>;
export type DirectUrlQuerySuspenseQueryHookResult = ReturnType<typeof useDirectUrlQuerySuspenseQuery>;
export type DirectUrlQueryQueryResult = ApolloReactCommon.QueryResult<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>;
export const ArtifactCodeFileQueryDocument = gql`
    query ArtifactCodeFileQuery($projectName: String!, $entityName: String!, $runName: String!, $filenames: [String!]!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      outputArtifacts {
        edges {
          node {
            id
            files(names: $filenames) {
              edges {
                node {
                  id
                  name
                  url(upload: false)
                  directUrl
                  sizeBytes
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ArtifactCodeFileQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>, 'query'> & ({ variables: ArtifactCodeFileQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCodeFileQueryComponent = (props: ArtifactCodeFileQueryComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables> query={ArtifactCodeFileQueryDocument} {...props} />
    );
    
export type ArtifactCodeFileQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>
    } & TChildProps;
export function withArtifactCodeFileQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCodeFileQueryQuery,
  ArtifactCodeFileQueryQueryVariables,
  ArtifactCodeFileQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables, ArtifactCodeFileQueryProps<TChildProps, TDataName>>(ArtifactCodeFileQueryDocument, {
      alias: 'artifactCodeFileQuery',
      ...operationOptions
    });
};

/**
 * __useArtifactCodeFileQueryQuery__
 *
 * To run a query within a React component, call `useArtifactCodeFileQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCodeFileQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCodeFileQueryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      filenames: // value for 'filenames'
 *   },
 * });
 */
export function useArtifactCodeFileQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables> & ({ variables: ArtifactCodeFileQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>(ArtifactCodeFileQueryDocument, options);
      }
export function useArtifactCodeFileQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>(ArtifactCodeFileQueryDocument, options);
        }
// @ts-ignore
export function useArtifactCodeFileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>;
export function useArtifactCodeFileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCodeFileQueryQuery | undefined, ArtifactCodeFileQueryQueryVariables>;
export function useArtifactCodeFileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>(ArtifactCodeFileQueryDocument, options);
        }
export type ArtifactCodeFileQueryQueryHookResult = ReturnType<typeof useArtifactCodeFileQueryQuery>;
export type ArtifactCodeFileQueryLazyQueryHookResult = ReturnType<typeof useArtifactCodeFileQueryLazyQuery>;
export type ArtifactCodeFileQuerySuspenseQueryHookResult = ReturnType<typeof useArtifactCodeFileQuerySuspenseQuery>;
export type ArtifactCodeFileQueryQueryResult = ApolloReactCommon.QueryResult<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>;
export const AddWorkflowsAdminDocument = gql`
    mutation AddWorkflowsAdmin($entityName: String!, $username: String, $userID: ID, $adminType: WorkflowsAdminType!) {
  addWorkflowsAdmin(
    input: {entityName: $entityName, username: $username, userID: $userID, adminType: $adminType}
  ) {
    success
  }
}
    `;
export type AddWorkflowsAdminMutationFn = ApolloReactCommon.MutationFunction<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>;
export type AddWorkflowsAdminComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>, 'mutation'>;

    export const AddWorkflowsAdminComponent = (props: AddWorkflowsAdminComponentProps) => (
      <ApolloReactComponents.Mutation<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables> mutation={AddWorkflowsAdminDocument} {...props} />
    );
    
export type AddWorkflowsAdminProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>
    } & TChildProps;
export function withAddWorkflowsAdmin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddWorkflowsAdminMutation,
  AddWorkflowsAdminMutationVariables,
  AddWorkflowsAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables, AddWorkflowsAdminProps<TChildProps, TDataName>>(AddWorkflowsAdminDocument, {
      alias: 'addWorkflowsAdmin',
      ...operationOptions
    });
};

/**
 * __useAddWorkflowsAdminMutation__
 *
 * To run a mutation, you first call `useAddWorkflowsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkflowsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkflowsAdminMutation, { data, loading, error }] = useAddWorkflowsAdminMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      username: // value for 'username'
 *      userID: // value for 'userID'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useAddWorkflowsAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>(AddWorkflowsAdminDocument, options);
      }
export type AddWorkflowsAdminMutationHookResult = ReturnType<typeof useAddWorkflowsAdminMutation>;
export type AddWorkflowsAdminMutationResult = ApolloReactCommon.MutationResult<AddWorkflowsAdminMutation>;
export type AddWorkflowsAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>;
export const DeleteWorkflowsAdminDocument = gql`
    mutation DeleteWorkflowsAdmin($entityName: String!, $username: String, $userID: ID, $adminType: WorkflowsAdminType!) {
  deleteWorkflowsAdmin(
    input: {entityName: $entityName, username: $username, userID: $userID, adminType: $adminType}
  ) {
    success
  }
}
    `;
export type DeleteWorkflowsAdminMutationFn = ApolloReactCommon.MutationFunction<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>;
export type DeleteWorkflowsAdminComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>, 'mutation'>;

    export const DeleteWorkflowsAdminComponent = (props: DeleteWorkflowsAdminComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables> mutation={DeleteWorkflowsAdminDocument} {...props} />
    );
    
export type DeleteWorkflowsAdminProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>
    } & TChildProps;
export function withDeleteWorkflowsAdmin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteWorkflowsAdminMutation,
  DeleteWorkflowsAdminMutationVariables,
  DeleteWorkflowsAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables, DeleteWorkflowsAdminProps<TChildProps, TDataName>>(DeleteWorkflowsAdminDocument, {
      alias: 'deleteWorkflowsAdmin',
      ...operationOptions
    });
};

/**
 * __useDeleteWorkflowsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowsAdminMutation, { data, loading, error }] = useDeleteWorkflowsAdminMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      username: // value for 'username'
 *      userID: // value for 'userID'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useDeleteWorkflowsAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>(DeleteWorkflowsAdminDocument, options);
      }
export type DeleteWorkflowsAdminMutationHookResult = ReturnType<typeof useDeleteWorkflowsAdminMutation>;
export type DeleteWorkflowsAdminMutationResult = ApolloReactCommon.MutationResult<DeleteWorkflowsAdminMutation>;
export type DeleteWorkflowsAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>;
export const AddProtectedAliasesDocument = gql`
    mutation AddProtectedAliases($entityName: String!, $aliases: [String!]!, $adminType: WorkflowsAdminType!) {
  addProtectedAliases(
    input: {entityName: $entityName, aliases: $aliases, adminType: $adminType}
  ) {
    aliases
  }
}
    `;
export type AddProtectedAliasesMutationFn = ApolloReactCommon.MutationFunction<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>;
export type AddProtectedAliasesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>, 'mutation'>;

    export const AddProtectedAliasesComponent = (props: AddProtectedAliasesComponentProps) => (
      <ApolloReactComponents.Mutation<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables> mutation={AddProtectedAliasesDocument} {...props} />
    );
    
export type AddProtectedAliasesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>
    } & TChildProps;
export function withAddProtectedAliases<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddProtectedAliasesMutation,
  AddProtectedAliasesMutationVariables,
  AddProtectedAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables, AddProtectedAliasesProps<TChildProps, TDataName>>(AddProtectedAliasesDocument, {
      alias: 'addProtectedAliases',
      ...operationOptions
    });
};

/**
 * __useAddProtectedAliasesMutation__
 *
 * To run a mutation, you first call `useAddProtectedAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProtectedAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProtectedAliasesMutation, { data, loading, error }] = useAddProtectedAliasesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      aliases: // value for 'aliases'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useAddProtectedAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>(AddProtectedAliasesDocument, options);
      }
export type AddProtectedAliasesMutationHookResult = ReturnType<typeof useAddProtectedAliasesMutation>;
export type AddProtectedAliasesMutationResult = ApolloReactCommon.MutationResult<AddProtectedAliasesMutation>;
export type AddProtectedAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>;
export const RemoveProtectedAliasesDocument = gql`
    mutation RemoveProtectedAliases($entityName: String!, $aliases: [String!]!, $adminType: WorkflowsAdminType!) {
  removeProtectedAliases(
    input: {entityName: $entityName, aliases: $aliases, adminType: $adminType}
  ) {
    aliases
  }
}
    `;
export type RemoveProtectedAliasesMutationFn = ApolloReactCommon.MutationFunction<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>;
export type RemoveProtectedAliasesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>, 'mutation'>;

    export const RemoveProtectedAliasesComponent = (props: RemoveProtectedAliasesComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables> mutation={RemoveProtectedAliasesDocument} {...props} />
    );
    
export type RemoveProtectedAliasesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>
    } & TChildProps;
export function withRemoveProtectedAliases<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveProtectedAliasesMutation,
  RemoveProtectedAliasesMutationVariables,
  RemoveProtectedAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables, RemoveProtectedAliasesProps<TChildProps, TDataName>>(RemoveProtectedAliasesDocument, {
      alias: 'removeProtectedAliases',
      ...operationOptions
    });
};

/**
 * __useRemoveProtectedAliasesMutation__
 *
 * To run a mutation, you first call `useRemoveProtectedAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProtectedAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProtectedAliasesMutation, { data, loading, error }] = useRemoveProtectedAliasesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      aliases: // value for 'aliases'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useRemoveProtectedAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>(RemoveProtectedAliasesDocument, options);
      }
export type RemoveProtectedAliasesMutationHookResult = ReturnType<typeof useRemoveProtectedAliasesMutation>;
export type RemoveProtectedAliasesMutationResult = ApolloReactCommon.MutationResult<RemoveProtectedAliasesMutation>;
export type RemoveProtectedAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>;
export const EntityProtectedAliasesDocument = gql`
    query EntityProtectedAliases($entityName: String!, $workflowsAdminType: WorkflowsAdminType!) {
  entity(name: $entityName) {
    id
    workflowsAdmins(adminType: $workflowsAdminType) {
      id
      username
      name
      email
    }
    protectedAliases(adminType: $workflowsAdminType)
  }
}
    `;
export type EntityProtectedAliasesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>, 'query'> & ({ variables: EntityProtectedAliasesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityProtectedAliasesComponent = (props: EntityProtectedAliasesComponentProps) => (
      <ApolloReactComponents.Query<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables> query={EntityProtectedAliasesDocument} {...props} />
    );
    
export type EntityProtectedAliasesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>
    } & TChildProps;
export function withEntityProtectedAliases<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityProtectedAliasesQuery,
  EntityProtectedAliasesQueryVariables,
  EntityProtectedAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables, EntityProtectedAliasesProps<TChildProps, TDataName>>(EntityProtectedAliasesDocument, {
      alias: 'entityProtectedAliases',
      ...operationOptions
    });
};

/**
 * __useEntityProtectedAliasesQuery__
 *
 * To run a query within a React component, call `useEntityProtectedAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityProtectedAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityProtectedAliasesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      workflowsAdminType: // value for 'workflowsAdminType'
 *   },
 * });
 */
export function useEntityProtectedAliasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables> & ({ variables: EntityProtectedAliasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>(EntityProtectedAliasesDocument, options);
      }
export function useEntityProtectedAliasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>(EntityProtectedAliasesDocument, options);
        }
// @ts-ignore
export function useEntityProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>;
export function useEntityProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProtectedAliasesQuery | undefined, EntityProtectedAliasesQueryVariables>;
export function useEntityProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>(EntityProtectedAliasesDocument, options);
        }
export type EntityProtectedAliasesQueryHookResult = ReturnType<typeof useEntityProtectedAliasesQuery>;
export type EntityProtectedAliasesLazyQueryHookResult = ReturnType<typeof useEntityProtectedAliasesLazyQuery>;
export type EntityProtectedAliasesSuspenseQueryHookResult = ReturnType<typeof useEntityProtectedAliasesSuspenseQuery>;
export type EntityProtectedAliasesQueryResult = ApolloReactCommon.QueryResult<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>;
export const ModelDocument = gql`
    query Model($name: String!, $logCursor: String, $fileCursor: String, $fileLimit: Int = 10, $fileNames: [String] = [], $entityName: String, $bucketName: String!, $upload: Boolean, $detailed: Boolean!, $includeFiles: Boolean = false) {
  project(name: $name, entityName: $entityName) {
    id
    readOnly
    name
    entityName
    description
    createdAt
    bucketCount
    access
    summaryMetrics
    run(name: $bucketName) {
      id
      name
      __typename
      ...SelectRunFragment
      ...BasicRunFragment
      ...DetailedRunFragment @include(if: $detailed)
      ...RunFilesFragment @include(if: $includeFiles)
    }
    views
  }
  viewer {
    id
    email
    photoUrl
    admin
    defaultFramework
  }
}
    ${SelectRunFragmentFragmentDoc}
${BasicRunFragmentFragmentDoc}
${DetailedRunFragmentFragmentDoc}
${RunFilesFragmentFragmentDoc}`;
export type ModelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ModelQuery, ModelQueryVariables>, 'query'> & ({ variables: ModelQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ModelComponent = (props: ModelComponentProps) => (
      <ApolloReactComponents.Query<ModelQuery, ModelQueryVariables> query={ModelDocument} {...props} />
    );
    
export type ModelProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ModelQuery, ModelQueryVariables>
    } & TChildProps;
export function withModel<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ModelQuery,
  ModelQueryVariables,
  ModelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ModelQuery, ModelQueryVariables, ModelProps<TChildProps, TDataName>>(ModelDocument, {
      alias: 'model',
      ...operationOptions
    });
};

/**
 * __useModelQuery__
 *
 * To run a query within a React component, call `useModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelQuery({
 *   variables: {
 *      name: // value for 'name'
 *      logCursor: // value for 'logCursor'
 *      fileCursor: // value for 'fileCursor'
 *      fileLimit: // value for 'fileLimit'
 *      fileNames: // value for 'fileNames'
 *      entityName: // value for 'entityName'
 *      bucketName: // value for 'bucketName'
 *      upload: // value for 'upload'
 *      detailed: // value for 'detailed'
 *      includeFiles: // value for 'includeFiles'
 *   },
 * });
 */
export function useModelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModelQuery, ModelQueryVariables> & ({ variables: ModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
      }
export function useModelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
// @ts-ignore
export function useModelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ModelQuery, ModelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ModelQuery, ModelQueryVariables>;
export function useModelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModelQuery, ModelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ModelQuery | undefined, ModelQueryVariables>;
export function useModelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
export type ModelQueryHookResult = ReturnType<typeof useModelQuery>;
export type ModelLazyQueryHookResult = ReturnType<typeof useModelLazyQuery>;
export type ModelSuspenseQueryHookResult = ReturnType<typeof useModelSuspenseQuery>;
export type ModelQueryResult = ApolloReactCommon.QueryResult<ModelQuery, ModelQueryVariables>;
export const UpsertModelDocument = gql`
    mutation upsertModel($description: String, $entityName: String, $id: String, $name: String, $framework: String, $access: String, $views: JSONString, $owner: ID) {
  upsertModel(
    input: {description: $description, entityName: $entityName, id: $id, name: $name, framework: $framework, access: $access, views: $views, owner: $owner}
  ) {
    project {
      id
      name
      entityName
      description
      access
      views
      user {
        id
      }
    }
    model {
      id
      name
      entityName
      description
      access
      views
      user {
        id
      }
    }
    inserted
  }
}
    `;
export type UpsertModelMutationFn = ApolloReactCommon.MutationFunction<UpsertModelMutation, UpsertModelMutationVariables>;
export type UpsertModelComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertModelMutation, UpsertModelMutationVariables>, 'mutation'>;

    export const UpsertModelComponent = (props: UpsertModelComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertModelMutation, UpsertModelMutationVariables> mutation={UpsertModelDocument} {...props} />
    );
    
export type UpsertModelProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertModelMutation, UpsertModelMutationVariables>
    } & TChildProps;
export function withUpsertModel<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertModelMutation,
  UpsertModelMutationVariables,
  UpsertModelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertModelMutation, UpsertModelMutationVariables, UpsertModelProps<TChildProps, TDataName>>(UpsertModelDocument, {
      alias: 'upsertModel',
      ...operationOptions
    });
};

/**
 * __useUpsertModelMutation__
 *
 * To run a mutation, you first call `useUpsertModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertModelMutation, { data, loading, error }] = useUpsertModelMutation({
 *   variables: {
 *      description: // value for 'description'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      framework: // value for 'framework'
 *      access: // value for 'access'
 *      views: // value for 'views'
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useUpsertModelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertModelMutation, UpsertModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertModelMutation, UpsertModelMutationVariables>(UpsertModelDocument, options);
      }
export type UpsertModelMutationHookResult = ReturnType<typeof useUpsertModelMutation>;
export type UpsertModelMutationResult = ApolloReactCommon.MutationResult<UpsertModelMutation>;
export type UpsertModelMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertModelMutation, UpsertModelMutationVariables>;
export const RenameProjectDocument = gql`
    mutation renameProject($entityName: String!, $oldProjectName: String!, $newProjectName: String!) {
  renameProject(
    input: {entityName: $entityName, oldProjectName: $oldProjectName, newProjectName: $newProjectName}
  ) {
    project {
      id
      name
      entityName
      description
      access
      views
    }
    model {
      id
      name
      entityName
      description
      access
      views
    }
    inserted
  }
}
    `;
export type RenameProjectMutationFn = ApolloReactCommon.MutationFunction<RenameProjectMutation, RenameProjectMutationVariables>;
export type RenameProjectComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RenameProjectMutation, RenameProjectMutationVariables>, 'mutation'>;

    export const RenameProjectComponent = (props: RenameProjectComponentProps) => (
      <ApolloReactComponents.Mutation<RenameProjectMutation, RenameProjectMutationVariables> mutation={RenameProjectDocument} {...props} />
    );
    
export type RenameProjectProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RenameProjectMutation, RenameProjectMutationVariables>
    } & TChildProps;
export function withRenameProject<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RenameProjectMutation,
  RenameProjectMutationVariables,
  RenameProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RenameProjectMutation, RenameProjectMutationVariables, RenameProjectProps<TChildProps, TDataName>>(RenameProjectDocument, {
      alias: 'renameProject',
      ...operationOptions
    });
};

/**
 * __useRenameProjectMutation__
 *
 * To run a mutation, you first call `useRenameProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameProjectMutation, { data, loading, error }] = useRenameProjectMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      oldProjectName: // value for 'oldProjectName'
 *      newProjectName: // value for 'newProjectName'
 *   },
 * });
 */
export function useRenameProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenameProjectMutation, RenameProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenameProjectMutation, RenameProjectMutationVariables>(RenameProjectDocument, options);
      }
export type RenameProjectMutationHookResult = ReturnType<typeof useRenameProjectMutation>;
export type RenameProjectMutationResult = ApolloReactCommon.MutationResult<RenameProjectMutation>;
export type RenameProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<RenameProjectMutation, RenameProjectMutationVariables>;
export const DeleteModelDocument = gql`
    mutation deleteModel($id: String!) {
  deleteModel(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteModelMutationFn = ApolloReactCommon.MutationFunction<DeleteModelMutation, DeleteModelMutationVariables>;
export type DeleteModelComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteModelMutation, DeleteModelMutationVariables>, 'mutation'>;

    export const DeleteModelComponent = (props: DeleteModelComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteModelMutation, DeleteModelMutationVariables> mutation={DeleteModelDocument} {...props} />
    );
    
export type DeleteModelProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteModelMutation, DeleteModelMutationVariables>
    } & TChildProps;
export function withDeleteModel<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteModelMutation,
  DeleteModelMutationVariables,
  DeleteModelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteModelMutation, DeleteModelMutationVariables, DeleteModelProps<TChildProps, TDataName>>(DeleteModelDocument, {
      alias: 'deleteModel',
      ...operationOptions
    });
};

/**
 * __useDeleteModelMutation__
 *
 * To run a mutation, you first call `useDeleteModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModelMutation, { data, loading, error }] = useDeleteModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteModelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteModelMutation, DeleteModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteModelMutation, DeleteModelMutationVariables>(DeleteModelDocument, options);
      }
export type DeleteModelMutationHookResult = ReturnType<typeof useDeleteModelMutation>;
export type DeleteModelMutationResult = ApolloReactCommon.MutationResult<DeleteModelMutation>;
export type DeleteModelMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteModelMutation, DeleteModelMutationVariables>;
export const ModelsDocument = gql`
    query Models($cursor: String, $entityName: String, $order: String, $first: Int = 500, $anonymous: Boolean = false) {
  projects(
    first: $first
    after: $cursor
    entityName: $entityName
    order: $order
    anonymous: $anonymous
  ) {
    edges {
      node {
        id
        name
        entityName
        description
        totalRuns
        totalUsers
        lastActive
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  viewer {
    id
    email
    photoUrl
  }
}
    `;
export type ModelsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ModelsQuery, ModelsQueryVariables>, 'query'>;

    export const ModelsComponent = (props: ModelsComponentProps) => (
      <ApolloReactComponents.Query<ModelsQuery, ModelsQueryVariables> query={ModelsDocument} {...props} />
    );
    
export type ModelsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ModelsQuery, ModelsQueryVariables>
    } & TChildProps;
export function withModels<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ModelsQuery,
  ModelsQueryVariables,
  ModelsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ModelsQuery, ModelsQueryVariables, ModelsProps<TChildProps, TDataName>>(ModelsDocument, {
      alias: 'models',
      ...operationOptions
    });
};

/**
 * __useModelsQuery__
 *
 * To run a query within a React component, call `useModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      entityName: // value for 'entityName'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      anonymous: // value for 'anonymous'
 *   },
 * });
 */
export function useModelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModelsQuery, ModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModelsQuery, ModelsQueryVariables>(ModelsDocument, options);
      }
export function useModelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModelsQuery, ModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModelsQuery, ModelsQueryVariables>(ModelsDocument, options);
        }
// @ts-ignore
export function useModelsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ModelsQuery, ModelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ModelsQuery, ModelsQueryVariables>;
export function useModelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModelsQuery, ModelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ModelsQuery | undefined, ModelsQueryVariables>;
export function useModelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModelsQuery, ModelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModelsQuery, ModelsQueryVariables>(ModelsDocument, options);
        }
export type ModelsQueryHookResult = ReturnType<typeof useModelsQuery>;
export type ModelsLazyQueryHookResult = ReturnType<typeof useModelsLazyQuery>;
export type ModelsSuspenseQueryHookResult = ReturnType<typeof useModelsSuspenseQuery>;
export type ModelsQueryResult = ApolloReactCommon.QueryResult<ModelsQuery, ModelsQueryVariables>;
export const NumPendingInvitesDocument = gql`
    query NumPendingInvites {
  numPendingInvites
}
    `;
export type NumPendingInvitesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>, 'query'>;

    export const NumPendingInvitesComponent = (props: NumPendingInvitesComponentProps) => (
      <ApolloReactComponents.Query<NumPendingInvitesQuery, NumPendingInvitesQueryVariables> query={NumPendingInvitesDocument} {...props} />
    );
    
export type NumPendingInvitesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>
    } & TChildProps;
export function withNumPendingInvites<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NumPendingInvitesQuery,
  NumPendingInvitesQueryVariables,
  NumPendingInvitesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NumPendingInvitesQuery, NumPendingInvitesQueryVariables, NumPendingInvitesProps<TChildProps, TDataName>>(NumPendingInvitesDocument, {
      alias: 'numPendingInvites',
      ...operationOptions
    });
};

/**
 * __useNumPendingInvitesQuery__
 *
 * To run a query within a React component, call `useNumPendingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumPendingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumPendingInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNumPendingInvitesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>(NumPendingInvitesDocument, options);
      }
export function useNumPendingInvitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>(NumPendingInvitesDocument, options);
        }
// @ts-ignore
export function useNumPendingInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>;
export function useNumPendingInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NumPendingInvitesQuery | undefined, NumPendingInvitesQueryVariables>;
export function useNumPendingInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>(NumPendingInvitesDocument, options);
        }
export type NumPendingInvitesQueryHookResult = ReturnType<typeof useNumPendingInvitesQuery>;
export type NumPendingInvitesLazyQueryHookResult = ReturnType<typeof useNumPendingInvitesLazyQuery>;
export type NumPendingInvitesSuspenseQueryHookResult = ReturnType<typeof useNumPendingInvitesSuspenseQuery>;
export type NumPendingInvitesQueryResult = ApolloReactCommon.QueryResult<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>;
export const CreateOAuthProviderDocument = gql`
    mutation createOAuthProvider($organizationId: ID!, $issuerUrl: String!) {
  createOAuthProvider(
    input: {issuerUrl: $issuerUrl, organizationId: $organizationId}
  ) {
    success
  }
}
    `;
export type CreateOAuthProviderMutationFn = ApolloReactCommon.MutationFunction<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>;
export type CreateOAuthProviderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>, 'mutation'>;

    export const CreateOAuthProviderComponent = (props: CreateOAuthProviderComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables> mutation={CreateOAuthProviderDocument} {...props} />
    );
    
export type CreateOAuthProviderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>
    } & TChildProps;
export function withCreateOAuthProvider<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOAuthProviderMutation,
  CreateOAuthProviderMutationVariables,
  CreateOAuthProviderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables, CreateOAuthProviderProps<TChildProps, TDataName>>(CreateOAuthProviderDocument, {
      alias: 'createOAuthProvider',
      ...operationOptions
    });
};

/**
 * __useCreateOAuthProviderMutation__
 *
 * To run a mutation, you first call `useCreateOAuthProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthProviderMutation, { data, loading, error }] = useCreateOAuthProviderMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      issuerUrl: // value for 'issuerUrl'
 *   },
 * });
 */
export function useCreateOAuthProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>(CreateOAuthProviderDocument, options);
      }
export type CreateOAuthProviderMutationHookResult = ReturnType<typeof useCreateOAuthProviderMutation>;
export type CreateOAuthProviderMutationResult = ApolloReactCommon.MutationResult<CreateOAuthProviderMutation>;
export type CreateOAuthProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>;
export const OauthProvidersDocument = gql`
    query oauthProviders($organizationName: String!) {
  organization(name: $organizationName) {
    id
    OAuthProviders {
      id
      issuerUrl
    }
  }
}
    `;
export type OauthProvidersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OauthProvidersQuery, OauthProvidersQueryVariables>, 'query'> & ({ variables: OauthProvidersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OauthProvidersComponent = (props: OauthProvidersComponentProps) => (
      <ApolloReactComponents.Query<OauthProvidersQuery, OauthProvidersQueryVariables> query={OauthProvidersDocument} {...props} />
    );
    
export type OauthProvidersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OauthProvidersQuery, OauthProvidersQueryVariables>
    } & TChildProps;
export function withOauthProviders<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OauthProvidersQuery,
  OauthProvidersQueryVariables,
  OauthProvidersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OauthProvidersQuery, OauthProvidersQueryVariables, OauthProvidersProps<TChildProps, TDataName>>(OauthProvidersDocument, {
      alias: 'oauthProviders',
      ...operationOptions
    });
};

/**
 * __useOauthProvidersQuery__
 *
 * To run a query within a React component, call `useOauthProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOauthProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOauthProvidersQuery({
 *   variables: {
 *      organizationName: // value for 'organizationName'
 *   },
 * });
 */
export function useOauthProvidersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables> & ({ variables: OauthProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OauthProvidersQuery, OauthProvidersQueryVariables>(OauthProvidersDocument, options);
      }
export function useOauthProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OauthProvidersQuery, OauthProvidersQueryVariables>(OauthProvidersDocument, options);
        }
// @ts-ignore
export function useOauthProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OauthProvidersQuery, OauthProvidersQueryVariables>;
export function useOauthProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OauthProvidersQuery | undefined, OauthProvidersQueryVariables>;
export function useOauthProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OauthProvidersQuery, OauthProvidersQueryVariables>(OauthProvidersDocument, options);
        }
export type OauthProvidersQueryHookResult = ReturnType<typeof useOauthProvidersQuery>;
export type OauthProvidersLazyQueryHookResult = ReturnType<typeof useOauthProvidersLazyQuery>;
export type OauthProvidersSuspenseQueryHookResult = ReturnType<typeof useOauthProvidersSuspenseQuery>;
export type OauthProvidersQueryResult = ApolloReactCommon.QueryResult<OauthProvidersQuery, OauthProvidersQueryVariables>;
export const DeleteOAuthProviderDocument = gql`
    mutation deleteOAuthProvider($providerId: ID!) {
  deleteOAuthProvider(input: {providerId: $providerId}) {
    success
  }
}
    `;
export type DeleteOAuthProviderMutationFn = ApolloReactCommon.MutationFunction<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>;
export type DeleteOAuthProviderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>, 'mutation'>;

    export const DeleteOAuthProviderComponent = (props: DeleteOAuthProviderComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables> mutation={DeleteOAuthProviderDocument} {...props} />
    );
    
export type DeleteOAuthProviderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>
    } & TChildProps;
export function withDeleteOAuthProvider<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteOAuthProviderMutation,
  DeleteOAuthProviderMutationVariables,
  DeleteOAuthProviderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables, DeleteOAuthProviderProps<TChildProps, TDataName>>(DeleteOAuthProviderDocument, {
      alias: 'deleteOAuthProvider',
      ...operationOptions
    });
};

/**
 * __useDeleteOAuthProviderMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthProviderMutation, { data, loading, error }] = useDeleteOAuthProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useDeleteOAuthProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>(DeleteOAuthProviderDocument, options);
      }
export type DeleteOAuthProviderMutationHookResult = ReturnType<typeof useDeleteOAuthProviderMutation>;
export type DeleteOAuthProviderMutationResult = ApolloReactCommon.MutationResult<DeleteOAuthProviderMutation>;
export type DeleteOAuthProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>;
export const OauthClientsDocument = gql`
    query oauthClients($entityName: String!) {
  entity(name: $entityName) {
    id
    members {
      id
      role
      OAuthClients {
        id
        subject
      }
    }
  }
}
    `;
export type OauthClientsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OauthClientsQuery, OauthClientsQueryVariables>, 'query'> & ({ variables: OauthClientsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OauthClientsComponent = (props: OauthClientsComponentProps) => (
      <ApolloReactComponents.Query<OauthClientsQuery, OauthClientsQueryVariables> query={OauthClientsDocument} {...props} />
    );
    
export type OauthClientsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OauthClientsQuery, OauthClientsQueryVariables>
    } & TChildProps;
export function withOauthClients<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OauthClientsQuery,
  OauthClientsQueryVariables,
  OauthClientsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OauthClientsQuery, OauthClientsQueryVariables, OauthClientsProps<TChildProps, TDataName>>(OauthClientsDocument, {
      alias: 'oauthClients',
      ...operationOptions
    });
};

/**
 * __useOauthClientsQuery__
 *
 * To run a query within a React component, call `useOauthClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOauthClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOauthClientsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useOauthClientsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables> & ({ variables: OauthClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OauthClientsQuery, OauthClientsQueryVariables>(OauthClientsDocument, options);
      }
export function useOauthClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OauthClientsQuery, OauthClientsQueryVariables>(OauthClientsDocument, options);
        }
// @ts-ignore
export function useOauthClientsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OauthClientsQuery, OauthClientsQueryVariables>;
export function useOauthClientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OauthClientsQuery | undefined, OauthClientsQueryVariables>;
export function useOauthClientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OauthClientsQuery, OauthClientsQueryVariables>(OauthClientsDocument, options);
        }
export type OauthClientsQueryHookResult = ReturnType<typeof useOauthClientsQuery>;
export type OauthClientsLazyQueryHookResult = ReturnType<typeof useOauthClientsLazyQuery>;
export type OauthClientsSuspenseQueryHookResult = ReturnType<typeof useOauthClientsSuspenseQuery>;
export type OauthClientsQueryResult = ApolloReactCommon.QueryResult<OauthClientsQuery, OauthClientsQueryVariables>;
export const CreateOAuthClientDocument = gql`
    mutation createOAuthClient($providerId: ID!, $name: String!, $subject: String!, $entityName: String!) {
  createClient(
    input: {providerId: $providerId, entityName: $entityName, name: $name, subject: $subject}
  ) {
    success
  }
}
    `;
export type CreateOAuthClientMutationFn = ApolloReactCommon.MutationFunction<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>;
export type CreateOAuthClientComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>, 'mutation'>;

    export const CreateOAuthClientComponent = (props: CreateOAuthClientComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOAuthClientMutation, CreateOAuthClientMutationVariables> mutation={CreateOAuthClientDocument} {...props} />
    );
    
export type CreateOAuthClientProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>
    } & TChildProps;
export function withCreateOAuthClient<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOAuthClientMutation,
  CreateOAuthClientMutationVariables,
  CreateOAuthClientProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOAuthClientMutation, CreateOAuthClientMutationVariables, CreateOAuthClientProps<TChildProps, TDataName>>(CreateOAuthClientDocument, {
      alias: 'createOAuthClient',
      ...operationOptions
    });
};

/**
 * __useCreateOAuthClientMutation__
 *
 * To run a mutation, you first call `useCreateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthClientMutation, { data, loading, error }] = useCreateOAuthClientMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      name: // value for 'name'
 *      subject: // value for 'subject'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCreateOAuthClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>(CreateOAuthClientDocument, options);
      }
export type CreateOAuthClientMutationHookResult = ReturnType<typeof useCreateOAuthClientMutation>;
export type CreateOAuthClientMutationResult = ApolloReactCommon.MutationResult<CreateOAuthClientMutation>;
export type CreateOAuthClientMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>;
export const DeleteOAuthClientDocument = gql`
    mutation deleteOAuthClient($clientId: String!, $entityName: String!) {
  revokeClient(input: {clientId: $clientId, entityName: $entityName}) {
    success
  }
}
    `;
export type DeleteOAuthClientMutationFn = ApolloReactCommon.MutationFunction<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;
export type DeleteOAuthClientComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>, 'mutation'>;

    export const DeleteOAuthClientComponent = (props: DeleteOAuthClientComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables> mutation={DeleteOAuthClientDocument} {...props} />
    );
    
export type DeleteOAuthClientProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>
    } & TChildProps;
export function withDeleteOAuthClient<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteOAuthClientMutation,
  DeleteOAuthClientMutationVariables,
  DeleteOAuthClientProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables, DeleteOAuthClientProps<TChildProps, TDataName>>(DeleteOAuthClientDocument, {
      alias: 'deleteOAuthClient',
      ...operationOptions
    });
};

/**
 * __useDeleteOAuthClientMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthClientMutation, { data, loading, error }] = useDeleteOAuthClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useDeleteOAuthClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>(DeleteOAuthClientDocument, options);
      }
export type DeleteOAuthClientMutationHookResult = ReturnType<typeof useDeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationResult = ApolloReactCommon.MutationResult<DeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;
export const ActivityTimelineDocument = gql`
    query ActivityTimeline($startDate: DateTime, $endDate: DateTime, $orgName: String) {
  organization(name: $orgName) {
    id
    firstActivity
    activity: activity(start: $startDate, end: $endDate) {
      numActiveUsers
      startAt
      endAt
    }
  }
}
    `;
export type ActivityTimelineComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>, 'query'>;

    export const ActivityTimelineComponent = (props: ActivityTimelineComponentProps) => (
      <ApolloReactComponents.Query<ActivityTimelineQuery, ActivityTimelineQueryVariables> query={ActivityTimelineDocument} {...props} />
    );
    
export type ActivityTimelineProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ActivityTimelineQuery, ActivityTimelineQueryVariables>
    } & TChildProps;
export function withActivityTimeline<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ActivityTimelineQuery,
  ActivityTimelineQueryVariables,
  ActivityTimelineProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ActivityTimelineQuery, ActivityTimelineQueryVariables, ActivityTimelineProps<TChildProps, TDataName>>(ActivityTimelineDocument, {
      alias: 'activityTimeline',
      ...operationOptions
    });
};

/**
 * __useActivityTimelineQuery__
 *
 * To run a query within a React component, call `useActivityTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTimelineQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useActivityTimelineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityTimelineQuery, ActivityTimelineQueryVariables>(ActivityTimelineDocument, options);
      }
export function useActivityTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityTimelineQuery, ActivityTimelineQueryVariables>(ActivityTimelineDocument, options);
        }
// @ts-ignore
export function useActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivityTimelineQuery, ActivityTimelineQueryVariables>;
export function useActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivityTimelineQuery | undefined, ActivityTimelineQueryVariables>;
export function useActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActivityTimelineQuery, ActivityTimelineQueryVariables>(ActivityTimelineDocument, options);
        }
export type ActivityTimelineQueryHookResult = ReturnType<typeof useActivityTimelineQuery>;
export type ActivityTimelineLazyQueryHookResult = ReturnType<typeof useActivityTimelineLazyQuery>;
export type ActivityTimelineSuspenseQueryHookResult = ReturnType<typeof useActivityTimelineSuspenseQuery>;
export type ActivityTimelineQueryResult = ApolloReactCommon.QueryResult<ActivityTimelineQuery, ActivityTimelineQueryVariables>;
export const OrgFlagsDocument = gql`
    query OrgFlags($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    flags
  }
}
    `;
export type OrgFlagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrgFlagsQuery, OrgFlagsQueryVariables>, 'query'> & ({ variables: OrgFlagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrgFlagsComponent = (props: OrgFlagsComponentProps) => (
      <ApolloReactComponents.Query<OrgFlagsQuery, OrgFlagsQueryVariables> query={OrgFlagsDocument} {...props} />
    );
    
export type OrgFlagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrgFlagsQuery, OrgFlagsQueryVariables>
    } & TChildProps;
export function withOrgFlags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrgFlagsQuery,
  OrgFlagsQueryVariables,
  OrgFlagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrgFlagsQuery, OrgFlagsQueryVariables, OrgFlagsProps<TChildProps, TDataName>>(OrgFlagsDocument, {
      alias: 'orgFlags',
      ...operationOptions
    });
};

/**
 * __useOrgFlagsQuery__
 *
 * To run a query within a React component, call `useOrgFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgFlagsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrgFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables> & ({ variables: OrgFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgFlagsQuery, OrgFlagsQueryVariables>(OrgFlagsDocument, options);
      }
export function useOrgFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgFlagsQuery, OrgFlagsQueryVariables>(OrgFlagsDocument, options);
        }
// @ts-ignore
export function useOrgFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgFlagsQuery, OrgFlagsQueryVariables>;
export function useOrgFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgFlagsQuery | undefined, OrgFlagsQueryVariables>;
export function useOrgFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgFlagsQuery, OrgFlagsQueryVariables>(OrgFlagsDocument, options);
        }
export type OrgFlagsQueryHookResult = ReturnType<typeof useOrgFlagsQuery>;
export type OrgFlagsLazyQueryHookResult = ReturnType<typeof useOrgFlagsLazyQuery>;
export type OrgFlagsSuspenseQueryHookResult = ReturnType<typeof useOrgFlagsSuspenseQuery>;
export type OrgFlagsQueryResult = ApolloReactCommon.QueryResult<OrgFlagsQuery, OrgFlagsQueryVariables>;
export const OrgDashboardEnablementDocument = gql`
    query OrgDashboardEnablement {
  organization {
    id
    name
    activity {
      numActiveUsers
    }
  }
}
    `;
export type OrgDashboardEnablementComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>, 'query'>;

    export const OrgDashboardEnablementComponent = (props: OrgDashboardEnablementComponentProps) => (
      <ApolloReactComponents.Query<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables> query={OrgDashboardEnablementDocument} {...props} />
    );
    
export type OrgDashboardEnablementProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>
    } & TChildProps;
export function withOrgDashboardEnablement<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrgDashboardEnablementQuery,
  OrgDashboardEnablementQueryVariables,
  OrgDashboardEnablementProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables, OrgDashboardEnablementProps<TChildProps, TDataName>>(OrgDashboardEnablementDocument, {
      alias: 'orgDashboardEnablement',
      ...operationOptions
    });
};

/**
 * __useOrgDashboardEnablementQuery__
 *
 * To run a query within a React component, call `useOrgDashboardEnablementQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgDashboardEnablementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgDashboardEnablementQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgDashboardEnablementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>(OrgDashboardEnablementDocument, options);
      }
export function useOrgDashboardEnablementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>(OrgDashboardEnablementDocument, options);
        }
// @ts-ignore
export function useOrgDashboardEnablementSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>;
export function useOrgDashboardEnablementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgDashboardEnablementQuery | undefined, OrgDashboardEnablementQueryVariables>;
export function useOrgDashboardEnablementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>(OrgDashboardEnablementDocument, options);
        }
export type OrgDashboardEnablementQueryHookResult = ReturnType<typeof useOrgDashboardEnablementQuery>;
export type OrgDashboardEnablementLazyQueryHookResult = ReturnType<typeof useOrgDashboardEnablementLazyQuery>;
export type OrgDashboardEnablementSuspenseQueryHookResult = ReturnType<typeof useOrgDashboardEnablementSuspenseQuery>;
export type OrgDashboardEnablementQueryResult = ApolloReactCommon.QueryResult<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>;
export const OrgDashboardContextDocument = gql`
    query OrgDashboardContext($orgName: String) {
  organization(name: $orgName) {
    id
    name
    members {
      orgID
      id
      role
      username
      modelsSeat
      weaveRole
      user {
        id
        ...UserRoleFragment
        teams {
          edges {
            node {
              id
              name
            }
          }
        }
        activity {
          lastActiveAt
          startAt
          endAt
          daysActive
          numReports
          numRuns
        }
      }
    }
    activeUsersForRange {
      last30Days
      last3Months
      last6Months
      last12Months
      allTime
    }
  }
}
    ${UserRoleFragmentFragmentDoc}`;
export type OrgDashboardContextComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>, 'query'>;

    export const OrgDashboardContextComponent = (props: OrgDashboardContextComponentProps) => (
      <ApolloReactComponents.Query<OrgDashboardContextQuery, OrgDashboardContextQueryVariables> query={OrgDashboardContextDocument} {...props} />
    );
    
export type OrgDashboardContextProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>
    } & TChildProps;
export function withOrgDashboardContext<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrgDashboardContextQuery,
  OrgDashboardContextQueryVariables,
  OrgDashboardContextProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrgDashboardContextQuery, OrgDashboardContextQueryVariables, OrgDashboardContextProps<TChildProps, TDataName>>(OrgDashboardContextDocument, {
      alias: 'orgDashboardContext',
      ...operationOptions
    });
};

/**
 * __useOrgDashboardContextQuery__
 *
 * To run a query within a React component, call `useOrgDashboardContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgDashboardContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgDashboardContextQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrgDashboardContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>(OrgDashboardContextDocument, options);
      }
export function useOrgDashboardContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>(OrgDashboardContextDocument, options);
        }
// @ts-ignore
export function useOrgDashboardContextSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>;
export function useOrgDashboardContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgDashboardContextQuery | undefined, OrgDashboardContextQueryVariables>;
export function useOrgDashboardContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>(OrgDashboardContextDocument, options);
        }
export type OrgDashboardContextQueryHookResult = ReturnType<typeof useOrgDashboardContextQuery>;
export type OrgDashboardContextLazyQueryHookResult = ReturnType<typeof useOrgDashboardContextLazyQuery>;
export type OrgDashboardContextSuspenseQueryHookResult = ReturnType<typeof useOrgDashboardContextSuspenseQuery>;
export type OrgDashboardContextQueryResult = ApolloReactCommon.QueryResult<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>;
export const OrgActivityTimelineDocument = gql`
    query OrgActivityTimeline($startDate: DateTime, $endDate: DateTime) {
  organization {
    id
    activity: activity(start: $startDate, end: $endDate) {
      numActiveUsers
      startAt
      endAt
    }
  }
}
    `;
export type OrgActivityTimelineComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>, 'query'>;

    export const OrgActivityTimelineComponent = (props: OrgActivityTimelineComponentProps) => (
      <ApolloReactComponents.Query<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables> query={OrgActivityTimelineDocument} {...props} />
    );
    
export type OrgActivityTimelineProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>
    } & TChildProps;
export function withOrgActivityTimeline<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrgActivityTimelineQuery,
  OrgActivityTimelineQueryVariables,
  OrgActivityTimelineProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables, OrgActivityTimelineProps<TChildProps, TDataName>>(OrgActivityTimelineDocument, {
      alias: 'orgActivityTimeline',
      ...operationOptions
    });
};

/**
 * __useOrgActivityTimelineQuery__
 *
 * To run a query within a React component, call `useOrgActivityTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgActivityTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgActivityTimelineQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useOrgActivityTimelineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>(OrgActivityTimelineDocument, options);
      }
export function useOrgActivityTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>(OrgActivityTimelineDocument, options);
        }
// @ts-ignore
export function useOrgActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>;
export function useOrgActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgActivityTimelineQuery | undefined, OrgActivityTimelineQueryVariables>;
export function useOrgActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>(OrgActivityTimelineDocument, options);
        }
export type OrgActivityTimelineQueryHookResult = ReturnType<typeof useOrgActivityTimelineQuery>;
export type OrgActivityTimelineLazyQueryHookResult = ReturnType<typeof useOrgActivityTimelineLazyQuery>;
export type OrgActivityTimelineSuspenseQueryHookResult = ReturnType<typeof useOrgActivityTimelineSuspenseQuery>;
export type OrgActivityTimelineQueryResult = ApolloReactCommon.QueryResult<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>;
export const OrgSeatsDocument = gql`
    query OrgSeats {
  organization {
    id
    seatAvailability {
      seats
      viewOnlySeats
      expiresAt
    }
  }
}
    `;
export type OrgSeatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrgSeatsQuery, OrgSeatsQueryVariables>, 'query'>;

    export const OrgSeatsComponent = (props: OrgSeatsComponentProps) => (
      <ApolloReactComponents.Query<OrgSeatsQuery, OrgSeatsQueryVariables> query={OrgSeatsDocument} {...props} />
    );
    
export type OrgSeatsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrgSeatsQuery, OrgSeatsQueryVariables>
    } & TChildProps;
export function withOrgSeats<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrgSeatsQuery,
  OrgSeatsQueryVariables,
  OrgSeatsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrgSeatsQuery, OrgSeatsQueryVariables, OrgSeatsProps<TChildProps, TDataName>>(OrgSeatsDocument, {
      alias: 'orgSeats',
      ...operationOptions
    });
};

/**
 * __useOrgSeatsQuery__
 *
 * To run a query within a React component, call `useOrgSeatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgSeatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgSeatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgSeatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgSeatsQuery, OrgSeatsQueryVariables>(OrgSeatsDocument, options);
      }
export function useOrgSeatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgSeatsQuery, OrgSeatsQueryVariables>(OrgSeatsDocument, options);
        }
// @ts-ignore
export function useOrgSeatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgSeatsQuery, OrgSeatsQueryVariables>;
export function useOrgSeatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgSeatsQuery | undefined, OrgSeatsQueryVariables>;
export function useOrgSeatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgSeatsQuery, OrgSeatsQueryVariables>(OrgSeatsDocument, options);
        }
export type OrgSeatsQueryHookResult = ReturnType<typeof useOrgSeatsQuery>;
export type OrgSeatsLazyQueryHookResult = ReturnType<typeof useOrgSeatsLazyQuery>;
export type OrgSeatsSuspenseQueryHookResult = ReturnType<typeof useOrgSeatsSuspenseQuery>;
export type OrgSeatsQueryResult = ApolloReactCommon.QueryResult<OrgSeatsQuery, OrgSeatsQueryVariables>;
export const UserActivityTableDocument = gql`
    query UserActivityTable {
  organization {
    id
    name
    members {
      orgID
      id
      role
      modelsSeat
      weaveRole
      user {
        id
        name
        photoUrl
        createdAt
        accountType
        ...UserRoleFragment
        activity {
          lastActiveAt
          daysActive
          numReports
          numRuns
        }
        teams {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${UserRoleFragmentFragmentDoc}`;
export type UserActivityTableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserActivityTableQuery, UserActivityTableQueryVariables>, 'query'>;

    export const UserActivityTableComponent = (props: UserActivityTableComponentProps) => (
      <ApolloReactComponents.Query<UserActivityTableQuery, UserActivityTableQueryVariables> query={UserActivityTableDocument} {...props} />
    );
    
export type UserActivityTableProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserActivityTableQuery, UserActivityTableQueryVariables>
    } & TChildProps;
export function withUserActivityTable<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserActivityTableQuery,
  UserActivityTableQueryVariables,
  UserActivityTableProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserActivityTableQuery, UserActivityTableQueryVariables, UserActivityTableProps<TChildProps, TDataName>>(UserActivityTableDocument, {
      alias: 'userActivityTable',
      ...operationOptions
    });
};

/**
 * __useUserActivityTableQuery__
 *
 * To run a query within a React component, call `useUserActivityTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActivityTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserActivityTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserActivityTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserActivityTableQuery, UserActivityTableQueryVariables>(UserActivityTableDocument, options);
      }
export function useUserActivityTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserActivityTableQuery, UserActivityTableQueryVariables>(UserActivityTableDocument, options);
        }
// @ts-ignore
export function useUserActivityTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserActivityTableQuery, UserActivityTableQueryVariables>;
export function useUserActivityTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserActivityTableQuery | undefined, UserActivityTableQueryVariables>;
export function useUserActivityTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserActivityTableQuery, UserActivityTableQueryVariables>(UserActivityTableDocument, options);
        }
export type UserActivityTableQueryHookResult = ReturnType<typeof useUserActivityTableQuery>;
export type UserActivityTableLazyQueryHookResult = ReturnType<typeof useUserActivityTableLazyQuery>;
export type UserActivityTableSuspenseQueryHookResult = ReturnType<typeof useUserActivityTableSuspenseQuery>;
export type UserActivityTableQueryResult = ApolloReactCommon.QueryResult<UserActivityTableQuery, UserActivityTableQueryVariables>;
export const AddUserToOrganizationDocument = gql`
    mutation addUserToOrganization($userName: String!, $teams: [String!], $organizationId: ID!, $clientMutationId: String, $userOrgRole: String!) {
  addUserToOrganization(
    input: {userName: $userName, teams: $teams, organizationId: $organizationId, clientMutationId: $clientMutationId, userOrgRole: $userOrgRole}
  ) {
    success
    clientMutationId
  }
}
    `;
export type AddUserToOrganizationMutationFn = ApolloReactCommon.MutationFunction<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;
export type AddUserToOrganizationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>, 'mutation'>;

    export const AddUserToOrganizationComponent = (props: AddUserToOrganizationComponentProps) => (
      <ApolloReactComponents.Mutation<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables> mutation={AddUserToOrganizationDocument} {...props} />
    );
    
export type AddUserToOrganizationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>
    } & TChildProps;
export function withAddUserToOrganization<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddUserToOrganizationMutation,
  AddUserToOrganizationMutationVariables,
  AddUserToOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables, AddUserToOrganizationProps<TChildProps, TDataName>>(AddUserToOrganizationDocument, {
      alias: 'addUserToOrganization',
      ...operationOptions
    });
};

/**
 * __useAddUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToOrganizationMutation, { data, loading, error }] = useAddUserToOrganizationMutation({
 *   variables: {
 *      userName: // value for 'userName'
 *      teams: // value for 'teams'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *      userOrgRole: // value for 'userOrgRole'
 *   },
 * });
 */
export function useAddUserToOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>(AddUserToOrganizationDocument, options);
      }
export type AddUserToOrganizationMutationHookResult = ReturnType<typeof useAddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationResult = ApolloReactCommon.MutationResult<AddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;
export const RemoveUserFromOrganizationDocument = gql`
    mutation removeUserFromOrganization($userName: String!, $organizationId: ID!, $clientMutationId: String) {
  removeUserFromOrganization(
    input: {userName: $userName, organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type RemoveUserFromOrganizationMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;
export type RemoveUserFromOrganizationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>, 'mutation'>;

    export const RemoveUserFromOrganizationComponent = (props: RemoveUserFromOrganizationComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables> mutation={RemoveUserFromOrganizationDocument} {...props} />
    );
    
export type RemoveUserFromOrganizationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>
    } & TChildProps;
export function withRemoveUserFromOrganization<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveUserFromOrganizationMutation,
  RemoveUserFromOrganizationMutationVariables,
  RemoveUserFromOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables, RemoveUserFromOrganizationProps<TChildProps, TDataName>>(RemoveUserFromOrganizationDocument, {
      alias: 'removeUserFromOrganization',
      ...operationOptions
    });
};

/**
 * __useRemoveUserFromOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganizationMutation, { data, loading, error }] = useRemoveUserFromOrganizationMutation({
 *   variables: {
 *      userName: // value for 'userName'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRemoveUserFromOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>(RemoveUserFromOrganizationDocument, options);
      }
export type RemoveUserFromOrganizationMutationHookResult = ReturnType<typeof useRemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;
export const RemoveUserFromOrganizationByIdDocument = gql`
    mutation removeUserFromOrganizationById($userId: ID!, $organizationId: ID!, $clientMutationId: String) {
  removeUserFromOrganizationById(
    input: {userId: $userId, organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type RemoveUserFromOrganizationByIdMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>;
export type RemoveUserFromOrganizationByIdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>, 'mutation'>;

    export const RemoveUserFromOrganizationByIdComponent = (props: RemoveUserFromOrganizationByIdComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables> mutation={RemoveUserFromOrganizationByIdDocument} {...props} />
    );
    
export type RemoveUserFromOrganizationByIdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>
    } & TChildProps;
export function withRemoveUserFromOrganizationById<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveUserFromOrganizationByIdMutation,
  RemoveUserFromOrganizationByIdMutationVariables,
  RemoveUserFromOrganizationByIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables, RemoveUserFromOrganizationByIdProps<TChildProps, TDataName>>(RemoveUserFromOrganizationByIdDocument, {
      alias: 'removeUserFromOrganizationById',
      ...operationOptions
    });
};

/**
 * __useRemoveUserFromOrganizationByIdMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganizationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganizationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganizationByIdMutation, { data, loading, error }] = useRemoveUserFromOrganizationByIdMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRemoveUserFromOrganizationByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>(RemoveUserFromOrganizationByIdDocument, options);
      }
export type RemoveUserFromOrganizationByIdMutationHookResult = ReturnType<typeof useRemoveUserFromOrganizationByIdMutation>;
export type RemoveUserFromOrganizationByIdMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromOrganizationByIdMutation>;
export type RemoveUserFromOrganizationByIdMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($organizationID: ID!, $flags: JSONString, $name: String) {
  updateOrganization(
    input: {organizationID: $organizationID, flags: $flags, name: $name}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export type UpdateOrganizationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>, 'mutation'>;

    export const UpdateOrganizationComponent = (props: UpdateOrganizationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables> mutation={UpdateOrganizationDocument} {...props} />
    );
    
export type UpdateOrganizationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>
    } & TChildProps;
export function withUpdateOrganization<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables,
  UpdateOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrganizationMutation, UpdateOrganizationMutationVariables, UpdateOrganizationProps<TChildProps, TDataName>>(UpdateOrganizationDocument, {
      alias: 'updateOrganization',
      ...operationOptions
    });
};

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      flags: // value for 'flags'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($organizationId: ID!, $clientMutationId: String) {
  deleteOrganization(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type DeleteOrganizationMutationFn = ApolloReactCommon.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export type DeleteOrganizationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>, 'mutation'>;

    export const DeleteOrganizationComponent = (props: DeleteOrganizationComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables> mutation={DeleteOrganizationDocument} {...props} />
    );
    
export type DeleteOrganizationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>
    } & TChildProps;
export function withDeleteOrganization<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteOrganizationMutation,
  DeleteOrganizationMutationVariables,
  DeleteOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteOrganizationMutation, DeleteOrganizationMutationVariables, DeleteOrganizationProps<TChildProps, TDataName>>(DeleteOrganizationDocument, {
      alias: 'deleteOrganization',
      ...operationOptions
    });
};

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = ApolloReactCommon.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const UpdateOrganizationUserV2Document = gql`
    mutation UpdateOrganizationUserV2($userName: String!, $organizationId: ID!, $userOrgRole: String!, $clientMutationId: String) {
  updateOrganizationUserV2(
    input: {userName: $userName, organizationId: $organizationId, userOrgRole: $userOrgRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationUserV2MutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>;
export type UpdateOrganizationUserV2ComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>, 'mutation'>;

    export const UpdateOrganizationUserV2Component = (props: UpdateOrganizationUserV2ComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables> mutation={UpdateOrganizationUserV2Document} {...props} />
    );
    
export type UpdateOrganizationUserV2Props<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>
    } & TChildProps;
export function withUpdateOrganizationUserV2<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrganizationUserV2Mutation,
  UpdateOrganizationUserV2MutationVariables,
  UpdateOrganizationUserV2Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables, UpdateOrganizationUserV2Props<TChildProps, TDataName>>(UpdateOrganizationUserV2Document, {
      alias: 'updateOrganizationUserV2',
      ...operationOptions
    });
};

/**
 * __useUpdateOrganizationUserV2Mutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserV2Mutation, { data, loading, error }] = useUpdateOrganizationUserV2Mutation({
 *   variables: {
 *      userName: // value for 'userName'
 *      organizationId: // value for 'organizationId'
 *      userOrgRole: // value for 'userOrgRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationUserV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>(UpdateOrganizationUserV2Document, options);
      }
export type UpdateOrganizationUserV2MutationHookResult = ReturnType<typeof useUpdateOrganizationUserV2Mutation>;
export type UpdateOrganizationUserV2MutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationUserV2Mutation>;
export type UpdateOrganizationUserV2MutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>;
export const MakeOrgMembersNoAccessModelsSeatDocument = gql`
    mutation makeOrgMembersNoAccessModelsSeat($organizationId: ID!, $clientMutationId: String) {
  makeOrgMembersNoAccessModelsSeat(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type MakeOrgMembersNoAccessModelsSeatMutationFn = ApolloReactCommon.MutationFunction<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>;
export type MakeOrgMembersNoAccessModelsSeatComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>, 'mutation'>;

    export const MakeOrgMembersNoAccessModelsSeatComponent = (props: MakeOrgMembersNoAccessModelsSeatComponentProps) => (
      <ApolloReactComponents.Mutation<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables> mutation={MakeOrgMembersNoAccessModelsSeatDocument} {...props} />
    );
    
export type MakeOrgMembersNoAccessModelsSeatProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>
    } & TChildProps;
export function withMakeOrgMembersNoAccessModelsSeat<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MakeOrgMembersNoAccessModelsSeatMutation,
  MakeOrgMembersNoAccessModelsSeatMutationVariables,
  MakeOrgMembersNoAccessModelsSeatProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables, MakeOrgMembersNoAccessModelsSeatProps<TChildProps, TDataName>>(MakeOrgMembersNoAccessModelsSeatDocument, {
      alias: 'makeOrgMembersNoAccessModelsSeat',
      ...operationOptions
    });
};

/**
 * __useMakeOrgMembersNoAccessModelsSeatMutation__
 *
 * To run a mutation, you first call `useMakeOrgMembersNoAccessModelsSeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeOrgMembersNoAccessModelsSeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeOrgMembersNoAccessModelsSeatMutation, { data, loading, error }] = useMakeOrgMembersNoAccessModelsSeatMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useMakeOrgMembersNoAccessModelsSeatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>(MakeOrgMembersNoAccessModelsSeatDocument, options);
      }
export type MakeOrgMembersNoAccessModelsSeatMutationHookResult = ReturnType<typeof useMakeOrgMembersNoAccessModelsSeatMutation>;
export type MakeOrgMembersNoAccessModelsSeatMutationResult = ApolloReactCommon.MutationResult<MakeOrgMembersNoAccessModelsSeatMutation>;
export type MakeOrgMembersNoAccessModelsSeatMutationOptions = ApolloReactCommon.BaseMutationOptions<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>;
export const UpdateModelsSeatDocument = gql`
    mutation updateModelsSeat($userID: ID!, $organizationId: ID!, $modelsSeat: String!, $clientMutationId: String) {
  updateModelsSeat(
    input: {organizationId: $organizationId, userId: $userID, modelsSeat: $modelsSeat, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateModelsSeatMutationFn = ApolloReactCommon.MutationFunction<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>;
export type UpdateModelsSeatComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>, 'mutation'>;

    export const UpdateModelsSeatComponent = (props: UpdateModelsSeatComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables> mutation={UpdateModelsSeatDocument} {...props} />
    );
    
export type UpdateModelsSeatProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>
    } & TChildProps;
export function withUpdateModelsSeat<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateModelsSeatMutation,
  UpdateModelsSeatMutationVariables,
  UpdateModelsSeatProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables, UpdateModelsSeatProps<TChildProps, TDataName>>(UpdateModelsSeatDocument, {
      alias: 'updateModelsSeat',
      ...operationOptions
    });
};

/**
 * __useUpdateModelsSeatMutation__
 *
 * To run a mutation, you first call `useUpdateModelsSeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelsSeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelsSeatMutation, { data, loading, error }] = useUpdateModelsSeatMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      organizationId: // value for 'organizationId'
 *      modelsSeat: // value for 'modelsSeat'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateModelsSeatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>(UpdateModelsSeatDocument, options);
      }
export type UpdateModelsSeatMutationHookResult = ReturnType<typeof useUpdateModelsSeatMutation>;
export type UpdateModelsSeatMutationResult = ApolloReactCommon.MutationResult<UpdateModelsSeatMutation>;
export type UpdateModelsSeatMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>;
export const UpdateWeaveRoleDocument = gql`
    mutation updateWeaveRole($userID: ID!, $organizationId: ID!, $weaveRole: String!, $clientMutationId: String) {
  updateWeaveRole(
    input: {organizationId: $organizationId, userId: $userID, weaveRole: $weaveRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateWeaveRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>;
export type UpdateWeaveRoleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>, 'mutation'>;

    export const UpdateWeaveRoleComponent = (props: UpdateWeaveRoleComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables> mutation={UpdateWeaveRoleDocument} {...props} />
    );
    
export type UpdateWeaveRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>
    } & TChildProps;
export function withUpdateWeaveRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateWeaveRoleMutation,
  UpdateWeaveRoleMutationVariables,
  UpdateWeaveRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables, UpdateWeaveRoleProps<TChildProps, TDataName>>(UpdateWeaveRoleDocument, {
      alias: 'updateWeaveRole',
      ...operationOptions
    });
};

/**
 * __useUpdateWeaveRoleMutation__
 *
 * To run a mutation, you first call `useUpdateWeaveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeaveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeaveRoleMutation, { data, loading, error }] = useUpdateWeaveRoleMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      organizationId: // value for 'organizationId'
 *      weaveRole: // value for 'weaveRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateWeaveRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>(UpdateWeaveRoleDocument, options);
      }
export type UpdateWeaveRoleMutationHookResult = ReturnType<typeof useUpdateWeaveRoleMutation>;
export type UpdateWeaveRoleMutationResult = ApolloReactCommon.MutationResult<UpdateWeaveRoleMutation>;
export type UpdateWeaveRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>;
export const UpdateOrganizationBillingUserDocument = gql`
    mutation updateOrganizationBillingUser($organizationId: ID!, $newBillingUser: ID!, $clientMutationId: String) {
  updateOrganizationBillingUser(
    input: {organizationId: $organizationId, newBillingUser: $newBillingUser, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationBillingUserMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>;
export type UpdateOrganizationBillingUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>, 'mutation'>;

    export const UpdateOrganizationBillingUserComponent = (props: UpdateOrganizationBillingUserComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables> mutation={UpdateOrganizationBillingUserDocument} {...props} />
    );
    
export type UpdateOrganizationBillingUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>
    } & TChildProps;
export function withUpdateOrganizationBillingUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrganizationBillingUserMutation,
  UpdateOrganizationBillingUserMutationVariables,
  UpdateOrganizationBillingUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables, UpdateOrganizationBillingUserProps<TChildProps, TDataName>>(UpdateOrganizationBillingUserDocument, {
      alias: 'updateOrganizationBillingUser',
      ...operationOptions
    });
};

/**
 * __useUpdateOrganizationBillingUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationBillingUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationBillingUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationBillingUserMutation, { data, loading, error }] = useUpdateOrganizationBillingUserMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      newBillingUser: // value for 'newBillingUser'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationBillingUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>(UpdateOrganizationBillingUserDocument, options);
      }
export type UpdateOrganizationBillingUserMutationHookResult = ReturnType<typeof useUpdateOrganizationBillingUserMutation>;
export type UpdateOrganizationBillingUserMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationBillingUserMutation>;
export type UpdateOrganizationBillingUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>;
export const UpgradeProCustomerDocument = gql`
    mutation upgradeProCustomer($organizationID: ID!, $weaveIngestionTier: WeaveIngestionLimitInMb!, $modelsSeats: Int!, $monthly: Boolean, $clientMutationId: String) {
  upgradeProCustomer(
    input: {organizationID: $organizationID, weaveIngestionTier: $weaveIngestionTier, modelsSeats: $modelsSeats, monthly: $monthly, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpgradeProCustomerMutationFn = ApolloReactCommon.MutationFunction<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>;
export type UpgradeProCustomerComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>, 'mutation'>;

    export const UpgradeProCustomerComponent = (props: UpgradeProCustomerComponentProps) => (
      <ApolloReactComponents.Mutation<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables> mutation={UpgradeProCustomerDocument} {...props} />
    );
    
export type UpgradeProCustomerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>
    } & TChildProps;
export function withUpgradeProCustomer<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpgradeProCustomerMutation,
  UpgradeProCustomerMutationVariables,
  UpgradeProCustomerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables, UpgradeProCustomerProps<TChildProps, TDataName>>(UpgradeProCustomerDocument, {
      alias: 'upgradeProCustomer',
      ...operationOptions
    });
};

/**
 * __useUpgradeProCustomerMutation__
 *
 * To run a mutation, you first call `useUpgradeProCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeProCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeProCustomerMutation, { data, loading, error }] = useUpgradeProCustomerMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      weaveIngestionTier: // value for 'weaveIngestionTier'
 *      modelsSeats: // value for 'modelsSeats'
 *      monthly: // value for 'monthly'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpgradeProCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>(UpgradeProCustomerDocument, options);
      }
export type UpgradeProCustomerMutationHookResult = ReturnType<typeof useUpgradeProCustomerMutation>;
export type UpgradeProCustomerMutationResult = ApolloReactCommon.MutationResult<UpgradeProCustomerMutation>;
export type UpgradeProCustomerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>;
export const UpdateOrganizationSubscriptionDocument = gql`
    mutation updateOrganizationSubscription($organizationSubscriptionID: ID!, $createStripeSubscription: Boolean!, $planID: ID, $seats: Int, $privileges: JSONString, $type: OrganizationSubscriptionType, $status: OrganizationSubscriptionStatus, $stripeSubscriptionId: String, $expiresAt: DateTime) {
  updateOrganizationSubscription(
    input: {organizationSubscriptionID: $organizationSubscriptionID, planID: $planID, seats: $seats, privileges: $privileges, type: $type, status: $status, stripeSubscriptionId: $stripeSubscriptionId, expiresAt: $expiresAt, createStripeSubscription: $createStripeSubscription}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>;
export type UpdateOrganizationSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>, 'mutation'>;

    export const UpdateOrganizationSubscriptionComponent = (props: UpdateOrganizationSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables> mutation={UpdateOrganizationSubscriptionDocument} {...props} />
    );
    
export type UpdateOrganizationSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>
    } & TChildProps;
export function withUpdateOrganizationSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrganizationSubscriptionMutation,
  UpdateOrganizationSubscriptionMutationVariables,
  UpdateOrganizationSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables, UpdateOrganizationSubscriptionProps<TChildProps, TDataName>>(UpdateOrganizationSubscriptionDocument, {
      alias: 'updateOrganizationSubscription',
      ...operationOptions
    });
};

/**
 * __useUpdateOrganizationSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSubscriptionMutation, { data, loading, error }] = useUpdateOrganizationSubscriptionMutation({
 *   variables: {
 *      organizationSubscriptionID: // value for 'organizationSubscriptionID'
 *      createStripeSubscription: // value for 'createStripeSubscription'
 *      planID: // value for 'planID'
 *      seats: // value for 'seats'
 *      privileges: // value for 'privileges'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      stripeSubscriptionId: // value for 'stripeSubscriptionId'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useUpdateOrganizationSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>(UpdateOrganizationSubscriptionDocument, options);
      }
export type UpdateOrganizationSubscriptionMutationHookResult = ReturnType<typeof useUpdateOrganizationSubscriptionMutation>;
export type UpdateOrganizationSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationSubscriptionMutation>;
export type UpdateOrganizationSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>;
export const DeleteOrganizationSubscriptionDocument = gql`
    mutation deleteOrganizationSubscription($subscriptionID: ID!) {
  deleteOrganizationSubscription(input: {subscriptionID: $subscriptionID}) {
    success
    clientMutationId
  }
}
    `;
export type DeleteOrganizationSubscriptionMutationFn = ApolloReactCommon.MutationFunction<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>;
export type DeleteOrganizationSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>, 'mutation'>;

    export const DeleteOrganizationSubscriptionComponent = (props: DeleteOrganizationSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables> mutation={DeleteOrganizationSubscriptionDocument} {...props} />
    );
    
export type DeleteOrganizationSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>
    } & TChildProps;
export function withDeleteOrganizationSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteOrganizationSubscriptionMutation,
  DeleteOrganizationSubscriptionMutationVariables,
  DeleteOrganizationSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables, DeleteOrganizationSubscriptionProps<TChildProps, TDataName>>(DeleteOrganizationSubscriptionDocument, {
      alias: 'deleteOrganizationSubscription',
      ...operationOptions
    });
};

/**
 * __useDeleteOrganizationSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationSubscriptionMutation, { data, loading, error }] = useDeleteOrganizationSubscriptionMutation({
 *   variables: {
 *      subscriptionID: // value for 'subscriptionID'
 *   },
 * });
 */
export function useDeleteOrganizationSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>(DeleteOrganizationSubscriptionDocument, options);
      }
export type DeleteOrganizationSubscriptionMutationHookResult = ReturnType<typeof useDeleteOrganizationSubscriptionMutation>;
export type DeleteOrganizationSubscriptionMutationResult = ApolloReactCommon.MutationResult<DeleteOrganizationSubscriptionMutation>;
export type DeleteOrganizationSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>;
export const LinkTeamToOrganizationDocument = gql`
    mutation linkTeamToOrganization($entityName: String!, $organizationID: ID!, $clientMutationId: String) {
  linkTeamToOrganization(
    input: {entityName: $entityName, organizationID: $organizationID, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type LinkTeamToOrganizationMutationFn = ApolloReactCommon.MutationFunction<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>;
export type LinkTeamToOrganizationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>, 'mutation'>;

    export const LinkTeamToOrganizationComponent = (props: LinkTeamToOrganizationComponentProps) => (
      <ApolloReactComponents.Mutation<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables> mutation={LinkTeamToOrganizationDocument} {...props} />
    );
    
export type LinkTeamToOrganizationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>
    } & TChildProps;
export function withLinkTeamToOrganization<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LinkTeamToOrganizationMutation,
  LinkTeamToOrganizationMutationVariables,
  LinkTeamToOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables, LinkTeamToOrganizationProps<TChildProps, TDataName>>(LinkTeamToOrganizationDocument, {
      alias: 'linkTeamToOrganization',
      ...operationOptions
    });
};

/**
 * __useLinkTeamToOrganizationMutation__
 *
 * To run a mutation, you first call `useLinkTeamToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTeamToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTeamToOrganizationMutation, { data, loading, error }] = useLinkTeamToOrganizationMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      organizationID: // value for 'organizationID'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useLinkTeamToOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>(LinkTeamToOrganizationDocument, options);
      }
export type LinkTeamToOrganizationMutationHookResult = ReturnType<typeof useLinkTeamToOrganizationMutation>;
export type LinkTeamToOrganizationMutationResult = ApolloReactCommon.MutationResult<LinkTeamToOrganizationMutation>;
export type LinkTeamToOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>;
export const WeaveSavingsCalculatorDocument = gql`
    query weaveSavingsCalculator($organizationID: ID!) {
  weaveSavingsCalculator(organizationID: $organizationID) {
    recommendationString
    totalPossibleSavings
    recommendedWeaveTier
  }
}
    `;
export type WeaveSavingsCalculatorComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>, 'query'> & ({ variables: WeaveSavingsCalculatorQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WeaveSavingsCalculatorComponent = (props: WeaveSavingsCalculatorComponentProps) => (
      <ApolloReactComponents.Query<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables> query={WeaveSavingsCalculatorDocument} {...props} />
    );
    
export type WeaveSavingsCalculatorProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>
    } & TChildProps;
export function withWeaveSavingsCalculator<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  WeaveSavingsCalculatorQuery,
  WeaveSavingsCalculatorQueryVariables,
  WeaveSavingsCalculatorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables, WeaveSavingsCalculatorProps<TChildProps, TDataName>>(WeaveSavingsCalculatorDocument, {
      alias: 'weaveSavingsCalculator',
      ...operationOptions
    });
};

/**
 * __useWeaveSavingsCalculatorQuery__
 *
 * To run a query within a React component, call `useWeaveSavingsCalculatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeaveSavingsCalculatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeaveSavingsCalculatorQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useWeaveSavingsCalculatorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables> & ({ variables: WeaveSavingsCalculatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>(WeaveSavingsCalculatorDocument, options);
      }
export function useWeaveSavingsCalculatorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>(WeaveSavingsCalculatorDocument, options);
        }
// @ts-ignore
export function useWeaveSavingsCalculatorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>;
export function useWeaveSavingsCalculatorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveSavingsCalculatorQuery | undefined, WeaveSavingsCalculatorQueryVariables>;
export function useWeaveSavingsCalculatorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>(WeaveSavingsCalculatorDocument, options);
        }
export type WeaveSavingsCalculatorQueryHookResult = ReturnType<typeof useWeaveSavingsCalculatorQuery>;
export type WeaveSavingsCalculatorLazyQueryHookResult = ReturnType<typeof useWeaveSavingsCalculatorLazyQuery>;
export type WeaveSavingsCalculatorSuspenseQueryHookResult = ReturnType<typeof useWeaveSavingsCalculatorSuspenseQuery>;
export type WeaveSavingsCalculatorQueryResult = ApolloReactCommon.QueryResult<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>;
export const CheckoutPreviewDocument = gql`
    query checkoutPreview($organizationID: ID!, $weaveIngestionTier: WeaveIngestionLimitInMb!, $numberOfModelsSeat: Int!, $couponID: String, $isMonthly: Boolean) {
  checkoutPreview(
    organizationID: $organizationID
    weaveIngestionTier: $weaveIngestionTier
    numberOfModelsSeat: $numberOfModelsSeat
    couponID: $couponID
    isMonthly: $isMonthly
  ) {
    total
    renewalDate
    lineItems {
      description
      amount
      product
      position
      discountAmount
      subLineItems {
        description
        amount
        proration
      }
    }
  }
}
    `;
export type CheckoutPreviewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>, 'query'> & ({ variables: CheckoutPreviewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CheckoutPreviewComponent = (props: CheckoutPreviewComponentProps) => (
      <ApolloReactComponents.Query<CheckoutPreviewQuery, CheckoutPreviewQueryVariables> query={CheckoutPreviewDocument} {...props} />
    );
    
export type CheckoutPreviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>
    } & TChildProps;
export function withCheckoutPreview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CheckoutPreviewQuery,
  CheckoutPreviewQueryVariables,
  CheckoutPreviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CheckoutPreviewQuery, CheckoutPreviewQueryVariables, CheckoutPreviewProps<TChildProps, TDataName>>(CheckoutPreviewDocument, {
      alias: 'checkoutPreview',
      ...operationOptions
    });
};

/**
 * __useCheckoutPreviewQuery__
 *
 * To run a query within a React component, call `useCheckoutPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPreviewQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      weaveIngestionTier: // value for 'weaveIngestionTier'
 *      numberOfModelsSeat: // value for 'numberOfModelsSeat'
 *      couponID: // value for 'couponID'
 *      isMonthly: // value for 'isMonthly'
 *   },
 * });
 */
export function useCheckoutPreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables> & ({ variables: CheckoutPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
      }
export function useCheckoutPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
        }
// @ts-ignore
export function useCheckoutPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>;
export function useCheckoutPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutPreviewQuery | undefined, CheckoutPreviewQueryVariables>;
export function useCheckoutPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
        }
export type CheckoutPreviewQueryHookResult = ReturnType<typeof useCheckoutPreviewQuery>;
export type CheckoutPreviewLazyQueryHookResult = ReturnType<typeof useCheckoutPreviewLazyQuery>;
export type CheckoutPreviewSuspenseQueryHookResult = ReturnType<typeof useCheckoutPreviewSuspenseQuery>;
export type CheckoutPreviewQueryResult = ApolloReactCommon.QueryResult<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>;
export const AllOrganizationsDocument = gql`
    query allOrganizations($first: Int, $cursor: String, $queryOrg: String, $querySubId: String, $queryUser: String, $queryTeam: String, $emailDomain: String) {
  organizations(
    first: $first
    after: $cursor
    queryOrg: $queryOrg
    querySubId: $querySubId
    queryUser: $queryUser
    queryTeam: $queryTeam
    emailDomain: $emailDomain
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        orgType
        flags
        billingUser {
          id
          username
          email
        }
        teams {
          id
          name
        }
        usedSeats
        usedViewOnlySeats
        stripeBillingInfo {
          stripeSubscriptionId
          status
          currentPeriodEnd
          cancelAtPeriodEnd
          paymentMethod {
            id
            cardType
            endingIn
          }
        }
        members {
          orgID
          id
          admin
          name
          username
          photoUrl
          teams {
            edges {
              node {
                id
                name
              }
            }
          }
          role
          modelsSeat
          weaveRole
        }
        subscriptions {
          plan {
            id
            name
            planType
            displayName
          }
          seats
          id
          subscriptionType
          stripeSubscriptionId
          status
          expiresAt
          privileges
        }
      }
    }
  }
}
    `;
export type AllOrganizationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>, 'query'>;

    export const AllOrganizationsComponent = (props: AllOrganizationsComponentProps) => (
      <ApolloReactComponents.Query<AllOrganizationsQuery, AllOrganizationsQueryVariables> query={AllOrganizationsDocument} {...props} />
    );
    
export type AllOrganizationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllOrganizationsQuery, AllOrganizationsQueryVariables>
    } & TChildProps;
export function withAllOrganizations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllOrganizationsQuery,
  AllOrganizationsQueryVariables,
  AllOrganizationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllOrganizationsQuery, AllOrganizationsQueryVariables, AllOrganizationsProps<TChildProps, TDataName>>(AllOrganizationsDocument, {
      alias: 'allOrganizations',
      ...operationOptions
    });
};

/**
 * __useAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrganizationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      queryOrg: // value for 'queryOrg'
 *      querySubId: // value for 'querySubId'
 *      queryUser: // value for 'queryUser'
 *      queryTeam: // value for 'queryTeam'
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useAllOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllOrganizationsQuery, AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
      }
export function useAllOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllOrganizationsQuery, AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
        }
// @ts-ignore
export function useAllOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllOrganizationsQuery, AllOrganizationsQueryVariables>;
export function useAllOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllOrganizationsQuery | undefined, AllOrganizationsQueryVariables>;
export function useAllOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllOrganizationsQuery, AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
        }
export type AllOrganizationsQueryHookResult = ReturnType<typeof useAllOrganizationsQuery>;
export type AllOrganizationsLazyQueryHookResult = ReturnType<typeof useAllOrganizationsLazyQuery>;
export type AllOrganizationsSuspenseQueryHookResult = ReturnType<typeof useAllOrganizationsSuspenseQuery>;
export type AllOrganizationsQueryResult = ApolloReactCommon.QueryResult<AllOrganizationsQuery, AllOrganizationsQueryVariables>;
export const OrganizationSubscriptionsDocument = gql`
    query OrganizationSubscriptions {
  viewer {
    id
    organizations {
      id
      createdAt
      name
      billingUser {
        id
        username
        email
      }
      flags
      usedSeats
      subscriptions {
        id
        subscriptionType
        status
        expiresAt
        privileges
        plan {
          id
          name
          planType
          billingInterval
        }
        seats
        isAutomaticUpgrade
        createdAt
        thresholdCrossedAt
        upgradedAt
        billingPeriodStart
        billingPeriodEnd
        expansionPacks {
          edges {
            node {
              id
              secondsLimit
              secondsRemaining
              expiresAt
            }
          }
        }
      }
      teams {
        id
        name
        computeHours
        oldComputeHours: computeHours(minDaysOld: 14)
      }
      members {
        orgID
        id
        username
        role
      }
      pendingInvites {
        id
      }
    }
  }
}
    `;
export type OrganizationSubscriptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>, 'query'>;

    export const OrganizationSubscriptionsComponent = (props: OrganizationSubscriptionsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables> query={OrganizationSubscriptionsDocument} {...props} />
    );
    
export type OrganizationSubscriptionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>
    } & TChildProps;
export function withOrganizationSubscriptions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationSubscriptionsQuery,
  OrganizationSubscriptionsQueryVariables,
  OrganizationSubscriptionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables, OrganizationSubscriptionsProps<TChildProps, TDataName>>(OrganizationSubscriptionsDocument, {
      alias: 'organizationSubscriptions',
      ...operationOptions
    });
};

/**
 * __useOrganizationSubscriptionsQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>(OrganizationSubscriptionsDocument, options);
      }
export function useOrganizationSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>(OrganizationSubscriptionsDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>;
export function useOrganizationSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsQuery | undefined, OrganizationSubscriptionsQueryVariables>;
export function useOrganizationSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>(OrganizationSubscriptionsDocument, options);
        }
export type OrganizationSubscriptionsQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsQuery>;
export type OrganizationSubscriptionsLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsLazyQuery>;
export type OrganizationSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsSuspenseQuery>;
export type OrganizationSubscriptionsQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>;
export const OrganizationStorageInfoDocument = gql`
    query OrganizationStorageInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    teams {
      id
      storageBytes(cached: true)
      referenceBytes(cached: true)
    }
  }
}
    `;
export type OrganizationStorageInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>, 'query'> & ({ variables: OrganizationStorageInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationStorageInfoComponent = (props: OrganizationStorageInfoComponentProps) => (
      <ApolloReactComponents.Query<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables> query={OrganizationStorageInfoDocument} {...props} />
    );
    
export type OrganizationStorageInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>
    } & TChildProps;
export function withOrganizationStorageInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationStorageInfoQuery,
  OrganizationStorageInfoQueryVariables,
  OrganizationStorageInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables, OrganizationStorageInfoProps<TChildProps, TDataName>>(OrganizationStorageInfoDocument, {
      alias: 'organizationStorageInfo',
      ...operationOptions
    });
};

/**
 * __useOrganizationStorageInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationStorageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStorageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStorageInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useOrganizationStorageInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables> & ({ variables: OrganizationStorageInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>(OrganizationStorageInfoDocument, options);
      }
export function useOrganizationStorageInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>(OrganizationStorageInfoDocument, options);
        }
// @ts-ignore
export function useOrganizationStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>;
export function useOrganizationStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationStorageInfoQuery | undefined, OrganizationStorageInfoQueryVariables>;
export function useOrganizationStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>(OrganizationStorageInfoDocument, options);
        }
export type OrganizationStorageInfoQueryHookResult = ReturnType<typeof useOrganizationStorageInfoQuery>;
export type OrganizationStorageInfoLazyQueryHookResult = ReturnType<typeof useOrganizationStorageInfoLazyQuery>;
export type OrganizationStorageInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationStorageInfoSuspenseQuery>;
export type OrganizationStorageInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>;
export const OrganizationSubscriptionsBasicInfoDocument = gql`
    query OrganizationSubscriptionsBasicInfo {
  viewer {
    id
    username
    organizations {
      id
      ...OrganizationSubscriptionBasicInfo
    }
  }
}
    ${OrganizationSubscriptionBasicInfoFragmentDoc}`;
export type OrganizationSubscriptionsBasicInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>, 'query'>;

    export const OrganizationSubscriptionsBasicInfoComponent = (props: OrganizationSubscriptionsBasicInfoComponentProps) => (
      <ApolloReactComponents.Query<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables> query={OrganizationSubscriptionsBasicInfoDocument} {...props} />
    );
    
export type OrganizationSubscriptionsBasicInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>
    } & TChildProps;
export function withOrganizationSubscriptionsBasicInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationSubscriptionsBasicInfoQuery,
  OrganizationSubscriptionsBasicInfoQueryVariables,
  OrganizationSubscriptionsBasicInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables, OrganizationSubscriptionsBasicInfoProps<TChildProps, TDataName>>(OrganizationSubscriptionsBasicInfoDocument, {
      alias: 'organizationSubscriptionsBasicInfo',
      ...operationOptions
    });
};

/**
 * __useOrganizationSubscriptionsBasicInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionsBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionsBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionsBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSubscriptionsBasicInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>(OrganizationSubscriptionsBasicInfoDocument, options);
      }
export function useOrganizationSubscriptionsBasicInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>(OrganizationSubscriptionsBasicInfoDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>;
export function useOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsBasicInfoQuery | undefined, OrganizationSubscriptionsBasicInfoQueryVariables>;
export function useOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>(OrganizationSubscriptionsBasicInfoDocument, options);
        }
export type OrganizationSubscriptionsBasicInfoQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicInfoQuery>;
export type OrganizationSubscriptionsBasicInfoLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicInfoLazyQuery>;
export type OrganizationSubscriptionsBasicInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicInfoSuspenseQuery>;
export type OrganizationSubscriptionsBasicInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>;
export const OrganizationSubscriptionBasicInfoByNameDocument = gql`
    query OrganizationSubscriptionBasicInfoByName($name: String!) {
  organization(name: $name) {
    id
    ...OrganizationSubscriptionBasicInfo
  }
}
    ${OrganizationSubscriptionBasicInfoFragmentDoc}`;
export type OrganizationSubscriptionBasicInfoByNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>, 'query'> & ({ variables: OrganizationSubscriptionBasicInfoByNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationSubscriptionBasicInfoByNameComponent = (props: OrganizationSubscriptionBasicInfoByNameComponentProps) => (
      <ApolloReactComponents.Query<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables> query={OrganizationSubscriptionBasicInfoByNameDocument} {...props} />
    );
    
export type OrganizationSubscriptionBasicInfoByNameProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>
    } & TChildProps;
export function withOrganizationSubscriptionBasicInfoByName<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationSubscriptionBasicInfoByNameQuery,
  OrganizationSubscriptionBasicInfoByNameQueryVariables,
  OrganizationSubscriptionBasicInfoByNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables, OrganizationSubscriptionBasicInfoByNameProps<TChildProps, TDataName>>(OrganizationSubscriptionBasicInfoByNameDocument, {
      alias: 'organizationSubscriptionBasicInfoByName',
      ...operationOptions
    });
};

/**
 * __useOrganizationSubscriptionBasicInfoByNameQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionBasicInfoByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionBasicInfoByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionBasicInfoByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOrganizationSubscriptionBasicInfoByNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables> & ({ variables: OrganizationSubscriptionBasicInfoByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>(OrganizationSubscriptionBasicInfoByNameDocument, options);
      }
export function useOrganizationSubscriptionBasicInfoByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>(OrganizationSubscriptionBasicInfoByNameDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionBasicInfoByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>;
export function useOrganizationSubscriptionBasicInfoByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionBasicInfoByNameQuery | undefined, OrganizationSubscriptionBasicInfoByNameQueryVariables>;
export function useOrganizationSubscriptionBasicInfoByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>(OrganizationSubscriptionBasicInfoByNameDocument, options);
        }
export type OrganizationSubscriptionBasicInfoByNameQueryHookResult = ReturnType<typeof useOrganizationSubscriptionBasicInfoByNameQuery>;
export type OrganizationSubscriptionBasicInfoByNameLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionBasicInfoByNameLazyQuery>;
export type OrganizationSubscriptionBasicInfoByNameSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionBasicInfoByNameSuspenseQuery>;
export type OrganizationSubscriptionBasicInfoByNameQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>;
export const OrganizationSubscriptionsBasicDetailsDocument = gql`
    query OrganizationSubscriptionsBasicDetails($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    subscriptions {
      id
      subscriptionType
      billingPeriodStart
      billingPeriodEnd
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;
export type OrganizationSubscriptionsBasicDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>, 'query'> & ({ variables: OrganizationSubscriptionsBasicDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationSubscriptionsBasicDetailsComponent = (props: OrganizationSubscriptionsBasicDetailsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables> query={OrganizationSubscriptionsBasicDetailsDocument} {...props} />
    );
    
export type OrganizationSubscriptionsBasicDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>
    } & TChildProps;
export function withOrganizationSubscriptionsBasicDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationSubscriptionsBasicDetailsQuery,
  OrganizationSubscriptionsBasicDetailsQueryVariables,
  OrganizationSubscriptionsBasicDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables, OrganizationSubscriptionsBasicDetailsProps<TChildProps, TDataName>>(OrganizationSubscriptionsBasicDetailsDocument, {
      alias: 'organizationSubscriptionsBasicDetails',
      ...operationOptions
    });
};

/**
 * __useOrganizationSubscriptionsBasicDetailsQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionsBasicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionsBasicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionsBasicDetailsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSubscriptionsBasicDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables> & ({ variables: OrganizationSubscriptionsBasicDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>(OrganizationSubscriptionsBasicDetailsDocument, options);
      }
export function useOrganizationSubscriptionsBasicDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>(OrganizationSubscriptionsBasicDetailsDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionsBasicDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>;
export function useOrganizationSubscriptionsBasicDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsBasicDetailsQuery | undefined, OrganizationSubscriptionsBasicDetailsQueryVariables>;
export function useOrganizationSubscriptionsBasicDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>(OrganizationSubscriptionsBasicDetailsDocument, options);
        }
export type OrganizationSubscriptionsBasicDetailsQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicDetailsQuery>;
export type OrganizationSubscriptionsBasicDetailsLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicDetailsLazyQuery>;
export type OrganizationSubscriptionsBasicDetailsSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicDetailsSuspenseQuery>;
export type OrganizationSubscriptionsBasicDetailsQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>;
export const UpdateOrganizationSubscriptionSeatsDocument = gql`
    mutation updateOrganizationSubscriptionSeats($organizationID: ID!, $seats: Int!, $clientMutationId: String) {
  updateOrganizationSubscriptionSeats(
    input: {organizationID: $organizationID, seats: $seats, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationSubscriptionSeatsMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>;
export type UpdateOrganizationSubscriptionSeatsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>, 'mutation'>;

    export const UpdateOrganizationSubscriptionSeatsComponent = (props: UpdateOrganizationSubscriptionSeatsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables> mutation={UpdateOrganizationSubscriptionSeatsDocument} {...props} />
    );
    
export type UpdateOrganizationSubscriptionSeatsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>
    } & TChildProps;
export function withUpdateOrganizationSubscriptionSeats<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrganizationSubscriptionSeatsMutation,
  UpdateOrganizationSubscriptionSeatsMutationVariables,
  UpdateOrganizationSubscriptionSeatsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables, UpdateOrganizationSubscriptionSeatsProps<TChildProps, TDataName>>(UpdateOrganizationSubscriptionSeatsDocument, {
      alias: 'updateOrganizationSubscriptionSeats',
      ...operationOptions
    });
};

/**
 * __useUpdateOrganizationSubscriptionSeatsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSubscriptionSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSubscriptionSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSubscriptionSeatsMutation, { data, loading, error }] = useUpdateOrganizationSubscriptionSeatsMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      seats: // value for 'seats'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationSubscriptionSeatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>(UpdateOrganizationSubscriptionSeatsDocument, options);
      }
export type UpdateOrganizationSubscriptionSeatsMutationHookResult = ReturnType<typeof useUpdateOrganizationSubscriptionSeatsMutation>;
export type UpdateOrganizationSubscriptionSeatsMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationSubscriptionSeatsMutation>;
export type UpdateOrganizationSubscriptionSeatsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>;
export const SendRequestOrgEmailDomainVerificationDocument = gql`
    mutation sendRequestOrgEmailDomainVerification($organizationID: ID!, $clientMutationId: String) {
  sendRequestOrgEmailDomainVerification(
    input: {organizationID: $organizationID, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type SendRequestOrgEmailDomainVerificationMutationFn = ApolloReactCommon.MutationFunction<SendRequestOrgEmailDomainVerificationMutation, SendRequestOrgEmailDomainVerificationMutationVariables>;
export type SendRequestOrgEmailDomainVerificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SendRequestOrgEmailDomainVerificationMutation, SendRequestOrgEmailDomainVerificationMutationVariables>, 'mutation'>;

    export const SendRequestOrgEmailDomainVerificationComponent = (props: SendRequestOrgEmailDomainVerificationComponentProps) => (
      <ApolloReactComponents.Mutation<SendRequestOrgEmailDomainVerificationMutation, SendRequestOrgEmailDomainVerificationMutationVariables> mutation={SendRequestOrgEmailDomainVerificationDocument} {...props} />
    );
    
export type SendRequestOrgEmailDomainVerificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SendRequestOrgEmailDomainVerificationMutation, SendRequestOrgEmailDomainVerificationMutationVariables>
    } & TChildProps;
export function withSendRequestOrgEmailDomainVerification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SendRequestOrgEmailDomainVerificationMutation,
  SendRequestOrgEmailDomainVerificationMutationVariables,
  SendRequestOrgEmailDomainVerificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SendRequestOrgEmailDomainVerificationMutation, SendRequestOrgEmailDomainVerificationMutationVariables, SendRequestOrgEmailDomainVerificationProps<TChildProps, TDataName>>(SendRequestOrgEmailDomainVerificationDocument, {
      alias: 'sendRequestOrgEmailDomainVerification',
      ...operationOptions
    });
};

/**
 * __useSendRequestOrgEmailDomainVerificationMutation__
 *
 * To run a mutation, you first call `useSendRequestOrgEmailDomainVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRequestOrgEmailDomainVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRequestOrgEmailDomainVerificationMutation, { data, loading, error }] = useSendRequestOrgEmailDomainVerificationMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useSendRequestOrgEmailDomainVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendRequestOrgEmailDomainVerificationMutation, SendRequestOrgEmailDomainVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendRequestOrgEmailDomainVerificationMutation, SendRequestOrgEmailDomainVerificationMutationVariables>(SendRequestOrgEmailDomainVerificationDocument, options);
      }
export type SendRequestOrgEmailDomainVerificationMutationHookResult = ReturnType<typeof useSendRequestOrgEmailDomainVerificationMutation>;
export type SendRequestOrgEmailDomainVerificationMutationResult = ApolloReactCommon.MutationResult<SendRequestOrgEmailDomainVerificationMutation>;
export type SendRequestOrgEmailDomainVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendRequestOrgEmailDomainVerificationMutation, SendRequestOrgEmailDomainVerificationMutationVariables>;
export const OrganizationRunsDocument = gql`
    query OrganizationRuns($orgID: ID!, $userID: ID!) {
  organization(id: $orgID) {
    id
    latestRuns(userID: $userID) {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
  }
}
    ${RunsTableFragmentFragmentDoc}`;
export type OrganizationRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>, 'query'> & ({ variables: OrganizationRunsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationRunsComponent = (props: OrganizationRunsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationRunsQuery, OrganizationRunsQueryVariables> query={OrganizationRunsDocument} {...props} />
    );
    
export type OrganizationRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationRunsQuery, OrganizationRunsQueryVariables>
    } & TChildProps;
export function withOrganizationRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationRunsQuery,
  OrganizationRunsQueryVariables,
  OrganizationRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationRunsQuery, OrganizationRunsQueryVariables, OrganizationRunsProps<TChildProps, TDataName>>(OrganizationRunsDocument, {
      alias: 'organizationRuns',
      ...operationOptions
    });
};

/**
 * __useOrganizationRunsQuery__
 *
 * To run a query within a React component, call `useOrganizationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRunsQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useOrganizationRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables> & ({ variables: OrganizationRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRunsQuery, OrganizationRunsQueryVariables>(OrganizationRunsDocument, options);
      }
export function useOrganizationRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRunsQuery, OrganizationRunsQueryVariables>(OrganizationRunsDocument, options);
        }
// @ts-ignore
export function useOrganizationRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRunsQuery, OrganizationRunsQueryVariables>;
export function useOrganizationRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRunsQuery | undefined, OrganizationRunsQueryVariables>;
export function useOrganizationRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRunsQuery, OrganizationRunsQueryVariables>(OrganizationRunsDocument, options);
        }
export type OrganizationRunsQueryHookResult = ReturnType<typeof useOrganizationRunsQuery>;
export type OrganizationRunsLazyQueryHookResult = ReturnType<typeof useOrganizationRunsLazyQuery>;
export type OrganizationRunsSuspenseQueryHookResult = ReturnType<typeof useOrganizationRunsSuspenseQuery>;
export type OrganizationRunsQueryResult = ApolloReactCommon.QueryResult<OrganizationRunsQuery, OrganizationRunsQueryVariables>;
export const OrganizationServiceAccountsDocument = gql`
    query OrganizationServiceAccounts($orgName: String!) {
  organization(name: $orgName) {
    id
    serviceAccounts {
      id
      name
      createdAt
      apiKey
      apiKeyCount
      accountType
      defaultEntity {
        name
        id
      }
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type OrganizationServiceAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>, 'query'> & ({ variables: OrganizationServiceAccountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationServiceAccountsComponent = (props: OrganizationServiceAccountsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables> query={OrganizationServiceAccountsDocument} {...props} />
    );
    
export type OrganizationServiceAccountsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>
    } & TChildProps;
export function withOrganizationServiceAccounts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationServiceAccountsQuery,
  OrganizationServiceAccountsQueryVariables,
  OrganizationServiceAccountsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables, OrganizationServiceAccountsProps<TChildProps, TDataName>>(OrganizationServiceAccountsDocument, {
      alias: 'organizationServiceAccounts',
      ...operationOptions
    });
};

/**
 * __useOrganizationServiceAccountsQuery__
 *
 * To run a query within a React component, call `useOrganizationServiceAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationServiceAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationServiceAccountsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationServiceAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables> & ({ variables: OrganizationServiceAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>(OrganizationServiceAccountsDocument, options);
      }
export function useOrganizationServiceAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>(OrganizationServiceAccountsDocument, options);
        }
// @ts-ignore
export function useOrganizationServiceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>;
export function useOrganizationServiceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationServiceAccountsQuery | undefined, OrganizationServiceAccountsQueryVariables>;
export function useOrganizationServiceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>(OrganizationServiceAccountsDocument, options);
        }
export type OrganizationServiceAccountsQueryHookResult = ReturnType<typeof useOrganizationServiceAccountsQuery>;
export type OrganizationServiceAccountsLazyQueryHookResult = ReturnType<typeof useOrganizationServiceAccountsLazyQuery>;
export type OrganizationServiceAccountsSuspenseQueryHookResult = ReturnType<typeof useOrganizationServiceAccountsSuspenseQuery>;
export type OrganizationServiceAccountsQueryResult = ApolloReactCommon.QueryResult<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>;
export const OrganizationProjectsDocument = gql`
    query OrganizationProjects($orgID: ID!, $userID: ID, $first: Int = 20) {
  organization(id: $orgID) {
    id
    projects(userID: $userID, first: $first, order: "-created_at") {
      edges {
        node {
          id
          ...AccountProjectFragment
        }
      }
    }
  }
}
    ${AccountProjectFragmentFragmentDoc}`;
export type OrganizationProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>, 'query'> & ({ variables: OrganizationProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationProjectsComponent = (props: OrganizationProjectsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationProjectsQuery, OrganizationProjectsQueryVariables> query={OrganizationProjectsDocument} {...props} />
    );
    
export type OrganizationProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>
    } & TChildProps;
export function withOrganizationProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationProjectsQuery,
  OrganizationProjectsQueryVariables,
  OrganizationProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationProjectsQuery, OrganizationProjectsQueryVariables, OrganizationProjectsProps<TChildProps, TDataName>>(OrganizationProjectsDocument, {
      alias: 'organizationProjects',
      ...operationOptions
    });
};

/**
 * __useOrganizationProjectsQuery__
 *
 * To run a query within a React component, call `useOrganizationProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationProjectsQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      userID: // value for 'userID'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useOrganizationProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables> & ({ variables: OrganizationProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>(OrganizationProjectsDocument, options);
      }
export function useOrganizationProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>(OrganizationProjectsDocument, options);
        }
// @ts-ignore
export function useOrganizationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>;
export function useOrganizationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationProjectsQuery | undefined, OrganizationProjectsQueryVariables>;
export function useOrganizationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>(OrganizationProjectsDocument, options);
        }
export type OrganizationProjectsQueryHookResult = ReturnType<typeof useOrganizationProjectsQuery>;
export type OrganizationProjectsLazyQueryHookResult = ReturnType<typeof useOrganizationProjectsLazyQuery>;
export type OrganizationProjectsSuspenseQueryHookResult = ReturnType<typeof useOrganizationProjectsSuspenseQuery>;
export type OrganizationProjectsQueryResult = ApolloReactCommon.QueryResult<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>;
export const ViewerOrganizationFeatureFlagsDocument = gql`
    query viewerOrganizationFeatureFlags($rampIDType: RampIDType!) {
  viewer {
    id
    organizations {
      id
      name
      featureFlags(rampIDType: $rampIDType) {
        rampKey
        isEnabled
      }
    }
  }
}
    `;
export type ViewerOrganizationFeatureFlagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>, 'query'> & ({ variables: ViewerOrganizationFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewerOrganizationFeatureFlagsComponent = (props: ViewerOrganizationFeatureFlagsComponentProps) => (
      <ApolloReactComponents.Query<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables> query={ViewerOrganizationFeatureFlagsDocument} {...props} />
    );
    
export type ViewerOrganizationFeatureFlagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>
    } & TChildProps;
export function withViewerOrganizationFeatureFlags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerOrganizationFeatureFlagsQuery,
  ViewerOrganizationFeatureFlagsQueryVariables,
  ViewerOrganizationFeatureFlagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables, ViewerOrganizationFeatureFlagsProps<TChildProps, TDataName>>(ViewerOrganizationFeatureFlagsDocument, {
      alias: 'viewerOrganizationFeatureFlags',
      ...operationOptions
    });
};

/**
 * __useViewerOrganizationFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useViewerOrganizationFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerOrganizationFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerOrganizationFeatureFlagsQuery({
 *   variables: {
 *      rampIDType: // value for 'rampIDType'
 *   },
 * });
 */
export function useViewerOrganizationFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables> & ({ variables: ViewerOrganizationFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>(ViewerOrganizationFeatureFlagsDocument, options);
      }
export function useViewerOrganizationFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>(ViewerOrganizationFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useViewerOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>;
export function useViewerOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerOrganizationFeatureFlagsQuery | undefined, ViewerOrganizationFeatureFlagsQueryVariables>;
export function useViewerOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>(ViewerOrganizationFeatureFlagsDocument, options);
        }
export type ViewerOrganizationFeatureFlagsQueryHookResult = ReturnType<typeof useViewerOrganizationFeatureFlagsQuery>;
export type ViewerOrganizationFeatureFlagsLazyQueryHookResult = ReturnType<typeof useViewerOrganizationFeatureFlagsLazyQuery>;
export type ViewerOrganizationFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useViewerOrganizationFeatureFlagsSuspenseQuery>;
export type ViewerOrganizationFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>;
export const OrganizationFeatureFlagsDocument = gql`
    query organizationFeatureFlags($orgName: String, $rampIDType: RampIDType!) {
  organization(name: $orgName) {
    id
    orgType
    featureFlags(rampIDType: $rampIDType) {
      rampKey
      isEnabled
    }
  }
}
    `;
export type OrganizationFeatureFlagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>, 'query'> & ({ variables: OrganizationFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationFeatureFlagsComponent = (props: OrganizationFeatureFlagsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables> query={OrganizationFeatureFlagsDocument} {...props} />
    );
    
export type OrganizationFeatureFlagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>
    } & TChildProps;
export function withOrganizationFeatureFlags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationFeatureFlagsQuery,
  OrganizationFeatureFlagsQueryVariables,
  OrganizationFeatureFlagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables, OrganizationFeatureFlagsProps<TChildProps, TDataName>>(OrganizationFeatureFlagsDocument, {
      alias: 'organizationFeatureFlags',
      ...operationOptions
    });
};

/**
 * __useOrganizationFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useOrganizationFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFeatureFlagsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      rampIDType: // value for 'rampIDType'
 *   },
 * });
 */
export function useOrganizationFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables> & ({ variables: OrganizationFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>(OrganizationFeatureFlagsDocument, options);
      }
export function useOrganizationFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>(OrganizationFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>;
export function useOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationFeatureFlagsQuery | undefined, OrganizationFeatureFlagsQueryVariables>;
export function useOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>(OrganizationFeatureFlagsDocument, options);
        }
export type OrganizationFeatureFlagsQueryHookResult = ReturnType<typeof useOrganizationFeatureFlagsQuery>;
export type OrganizationFeatureFlagsLazyQueryHookResult = ReturnType<typeof useOrganizationFeatureFlagsLazyQuery>;
export type OrganizationFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useOrganizationFeatureFlagsSuspenseQuery>;
export type OrganizationFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>;
export const UpdateOrganizationPrivacySettingsDocument = gql`
    mutation updateOrganizationPrivacySettings($organizationId: ID!, $hidden: Boolean, $privateOnly: Boolean, $onlyAdminsCanInvite: Boolean, $disableMagicLinkSharing: Boolean, $restrictMatchingOrgEmailDomainUsers: Boolean, $codeSavingDisabled: Boolean, $clientMutationId: String) {
  updateOrganizationPrivacySettings(
    input: {organizationId: $organizationId, hidden: $hidden, privateOnly: $privateOnly, onlyAdminsCanInvite: $onlyAdminsCanInvite, disableMagicLinkSharing: $disableMagicLinkSharing, restrictMatchingOrgEmailDomainUsers: $restrictMatchingOrgEmailDomainUsers, codeSavingDisabled: $codeSavingDisabled, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationPrivacySettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>;
export type UpdateOrganizationPrivacySettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>, 'mutation'>;

    export const UpdateOrganizationPrivacySettingsComponent = (props: UpdateOrganizationPrivacySettingsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables> mutation={UpdateOrganizationPrivacySettingsDocument} {...props} />
    );
    
export type UpdateOrganizationPrivacySettingsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>
    } & TChildProps;
export function withUpdateOrganizationPrivacySettings<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateOrganizationPrivacySettingsMutation,
  UpdateOrganizationPrivacySettingsMutationVariables,
  UpdateOrganizationPrivacySettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables, UpdateOrganizationPrivacySettingsProps<TChildProps, TDataName>>(UpdateOrganizationPrivacySettingsDocument, {
      alias: 'updateOrganizationPrivacySettings',
      ...operationOptions
    });
};

/**
 * __useUpdateOrganizationPrivacySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPrivacySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPrivacySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPrivacySettingsMutation, { data, loading, error }] = useUpdateOrganizationPrivacySettingsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      hidden: // value for 'hidden'
 *      privateOnly: // value for 'privateOnly'
 *      onlyAdminsCanInvite: // value for 'onlyAdminsCanInvite'
 *      disableMagicLinkSharing: // value for 'disableMagicLinkSharing'
 *      restrictMatchingOrgEmailDomainUsers: // value for 'restrictMatchingOrgEmailDomainUsers'
 *      codeSavingDisabled: // value for 'codeSavingDisabled'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationPrivacySettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>(UpdateOrganizationPrivacySettingsDocument, options);
      }
export type UpdateOrganizationPrivacySettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationPrivacySettingsMutation>;
export type UpdateOrganizationPrivacySettingsMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationPrivacySettingsMutation>;
export type UpdateOrganizationPrivacySettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>;
export const OrganizationMemberRoleDocument = gql`
    query OrganizationMemberRole($orgID: ID!, $username: String) {
  organization(id: $orgID) {
    id
    member(username: $username) {
      id
      role
    }
  }
}
    `;
export type OrganizationMemberRoleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>, 'query'> & ({ variables: OrganizationMemberRoleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationMemberRoleComponent = (props: OrganizationMemberRoleComponentProps) => (
      <ApolloReactComponents.Query<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables> query={OrganizationMemberRoleDocument} {...props} />
    );
    
export type OrganizationMemberRoleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>
    } & TChildProps;
export function withOrganizationMemberRole<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationMemberRoleQuery,
  OrganizationMemberRoleQueryVariables,
  OrganizationMemberRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables, OrganizationMemberRoleProps<TChildProps, TDataName>>(OrganizationMemberRoleDocument, {
      alias: 'organizationMemberRole',
      ...operationOptions
    });
};

/**
 * __useOrganizationMemberRoleQuery__
 *
 * To run a query within a React component, call `useOrganizationMemberRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMemberRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMemberRoleQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useOrganizationMemberRoleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables> & ({ variables: OrganizationMemberRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>(OrganizationMemberRoleDocument, options);
      }
export function useOrganizationMemberRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>(OrganizationMemberRoleDocument, options);
        }
// @ts-ignore
export function useOrganizationMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>;
export function useOrganizationMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberRoleQuery | undefined, OrganizationMemberRoleQueryVariables>;
export function useOrganizationMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>(OrganizationMemberRoleDocument, options);
        }
export type OrganizationMemberRoleQueryHookResult = ReturnType<typeof useOrganizationMemberRoleQuery>;
export type OrganizationMemberRoleLazyQueryHookResult = ReturnType<typeof useOrganizationMemberRoleLazyQuery>;
export type OrganizationMemberRoleSuspenseQueryHookResult = ReturnType<typeof useOrganizationMemberRoleSuspenseQuery>;
export type OrganizationMemberRoleQueryResult = ApolloReactCommon.QueryResult<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>;
export const OrganizationMemberModelsSeatDocument = gql`
    query OrganizationMemberModelsSeat($orgName: String, $username: String) {
  organization(name: $orgName) {
    id
    member(username: $username) {
      id
      role
      modelsSeat
    }
  }
}
    `;
export type OrganizationMemberModelsSeatComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>, 'query'>;

    export const OrganizationMemberModelsSeatComponent = (props: OrganizationMemberModelsSeatComponentProps) => (
      <ApolloReactComponents.Query<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables> query={OrganizationMemberModelsSeatDocument} {...props} />
    );
    
export type OrganizationMemberModelsSeatProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>
    } & TChildProps;
export function withOrganizationMemberModelsSeat<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationMemberModelsSeatQuery,
  OrganizationMemberModelsSeatQueryVariables,
  OrganizationMemberModelsSeatProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables, OrganizationMemberModelsSeatProps<TChildProps, TDataName>>(OrganizationMemberModelsSeatDocument, {
      alias: 'organizationMemberModelsSeat',
      ...operationOptions
    });
};

/**
 * __useOrganizationMemberModelsSeatQuery__
 *
 * To run a query within a React component, call `useOrganizationMemberModelsSeatQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMemberModelsSeatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMemberModelsSeatQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useOrganizationMemberModelsSeatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>(OrganizationMemberModelsSeatDocument, options);
      }
export function useOrganizationMemberModelsSeatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>(OrganizationMemberModelsSeatDocument, options);
        }
// @ts-ignore
export function useOrganizationMemberModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>;
export function useOrganizationMemberModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberModelsSeatQuery | undefined, OrganizationMemberModelsSeatQueryVariables>;
export function useOrganizationMemberModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>(OrganizationMemberModelsSeatDocument, options);
        }
export type OrganizationMemberModelsSeatQueryHookResult = ReturnType<typeof useOrganizationMemberModelsSeatQuery>;
export type OrganizationMemberModelsSeatLazyQueryHookResult = ReturnType<typeof useOrganizationMemberModelsSeatLazyQuery>;
export type OrganizationMemberModelsSeatSuspenseQueryHookResult = ReturnType<typeof useOrganizationMemberModelsSeatSuspenseQuery>;
export type OrganizationMemberModelsSeatQueryResult = ApolloReactCommon.QueryResult<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>;
export const OrganizationMemberWeaveRoleDocument = gql`
    query OrganizationMemberWeaveRole($orgName: String, $username: String) {
  organization(name: $orgName) {
    id
    member(username: $username) {
      id
      weaveRole
    }
  }
}
    `;
export type OrganizationMemberWeaveRoleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>, 'query'>;

    export const OrganizationMemberWeaveRoleComponent = (props: OrganizationMemberWeaveRoleComponentProps) => (
      <ApolloReactComponents.Query<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables> query={OrganizationMemberWeaveRoleDocument} {...props} />
    );
    
export type OrganizationMemberWeaveRoleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>
    } & TChildProps;
export function withOrganizationMemberWeaveRole<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationMemberWeaveRoleQuery,
  OrganizationMemberWeaveRoleQueryVariables,
  OrganizationMemberWeaveRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables, OrganizationMemberWeaveRoleProps<TChildProps, TDataName>>(OrganizationMemberWeaveRoleDocument, {
      alias: 'organizationMemberWeaveRole',
      ...operationOptions
    });
};

/**
 * __useOrganizationMemberWeaveRoleQuery__
 *
 * To run a query within a React component, call `useOrganizationMemberWeaveRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMemberWeaveRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMemberWeaveRoleQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useOrganizationMemberWeaveRoleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>(OrganizationMemberWeaveRoleDocument, options);
      }
export function useOrganizationMemberWeaveRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>(OrganizationMemberWeaveRoleDocument, options);
        }
// @ts-ignore
export function useOrganizationMemberWeaveRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>;
export function useOrganizationMemberWeaveRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberWeaveRoleQuery | undefined, OrganizationMemberWeaveRoleQueryVariables>;
export function useOrganizationMemberWeaveRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>(OrganizationMemberWeaveRoleDocument, options);
        }
export type OrganizationMemberWeaveRoleQueryHookResult = ReturnType<typeof useOrganizationMemberWeaveRoleQuery>;
export type OrganizationMemberWeaveRoleLazyQueryHookResult = ReturnType<typeof useOrganizationMemberWeaveRoleLazyQuery>;
export type OrganizationMemberWeaveRoleSuspenseQueryHookResult = ReturnType<typeof useOrganizationMemberWeaveRoleSuspenseQuery>;
export type OrganizationMemberWeaveRoleQueryResult = ApolloReactCommon.QueryResult<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>;
export const OrganizationMembersDocument = gql`
    query OrganizationMembers($orgName: String!) {
  organization(name: $orgName) {
    id
    members {
      id
      name
      username
      email
      photoUrl
      user {
        id
        accountType
      }
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type OrganizationMembersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>, 'query'> & ({ variables: OrganizationMembersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationMembersComponent = (props: OrganizationMembersComponentProps) => (
      <ApolloReactComponents.Query<OrganizationMembersQuery, OrganizationMembersQueryVariables> query={OrganizationMembersDocument} {...props} />
    );
    
export type OrganizationMembersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationMembersQuery, OrganizationMembersQueryVariables>
    } & TChildProps;
export function withOrganizationMembers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationMembersQuery,
  OrganizationMembersQueryVariables,
  OrganizationMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationMembersQuery, OrganizationMembersQueryVariables, OrganizationMembersProps<TChildProps, TDataName>>(OrganizationMembersDocument, {
      alias: 'organizationMembers',
      ...operationOptions
    });
};

/**
 * __useOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMembersQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables> & ({ variables: OrganizationMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMembersQuery, OrganizationMembersQueryVariables>(OrganizationMembersDocument, options);
      }
export function useOrganizationMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMembersQuery, OrganizationMembersQueryVariables>(OrganizationMembersDocument, options);
        }
// @ts-ignore
export function useOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMembersQuery, OrganizationMembersQueryVariables>;
export function useOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMembersQuery | undefined, OrganizationMembersQueryVariables>;
export function useOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMembersQuery, OrganizationMembersQueryVariables>(OrganizationMembersDocument, options);
        }
export type OrganizationMembersQueryHookResult = ReturnType<typeof useOrganizationMembersQuery>;
export type OrganizationMembersLazyQueryHookResult = ReturnType<typeof useOrganizationMembersLazyQuery>;
export type OrganizationMembersSuspenseQueryHookResult = ReturnType<typeof useOrganizationMembersSuspenseQuery>;
export type OrganizationMembersQueryResult = ApolloReactCommon.QueryResult<OrganizationMembersQuery, OrganizationMembersQueryVariables>;
export const OrganizationApiKeysDocument = gql`
    query OrganizationApiKeys($orgName: String!, $first: Int, $after: String) {
  organization(name: $orgName) {
    id
    apiKeysConnection(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      edges {
        node {
          id
          apiKeyId
          description
          createdAt
          expiresAt
          lastUsedAt
          user {
            id
            name
            accountType
            username
          }
        }
      }
    }
  }
}
    `;
export type OrganizationApiKeysComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>, 'query'> & ({ variables: OrganizationApiKeysQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationApiKeysComponent = (props: OrganizationApiKeysComponentProps) => (
      <ApolloReactComponents.Query<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables> query={OrganizationApiKeysDocument} {...props} />
    );
    
export type OrganizationApiKeysProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>
    } & TChildProps;
export function withOrganizationApiKeys<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationApiKeysQuery,
  OrganizationApiKeysQueryVariables,
  OrganizationApiKeysProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables, OrganizationApiKeysProps<TChildProps, TDataName>>(OrganizationApiKeysDocument, {
      alias: 'organizationApiKeys',
      ...operationOptions
    });
};

/**
 * __useOrganizationApiKeysQuery__
 *
 * To run a query within a React component, call `useOrganizationApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationApiKeysQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useOrganizationApiKeysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables> & ({ variables: OrganizationApiKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>(OrganizationApiKeysDocument, options);
      }
export function useOrganizationApiKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>(OrganizationApiKeysDocument, options);
        }
// @ts-ignore
export function useOrganizationApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>;
export function useOrganizationApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationApiKeysQuery | undefined, OrganizationApiKeysQueryVariables>;
export function useOrganizationApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>(OrganizationApiKeysDocument, options);
        }
export type OrganizationApiKeysQueryHookResult = ReturnType<typeof useOrganizationApiKeysQuery>;
export type OrganizationApiKeysLazyQueryHookResult = ReturnType<typeof useOrganizationApiKeysLazyQuery>;
export type OrganizationApiKeysSuspenseQueryHookResult = ReturnType<typeof useOrganizationApiKeysSuspenseQuery>;
export type OrganizationApiKeysQueryResult = ApolloReactCommon.QueryResult<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>;
export const FetchPreviewableLinkDocument = gql`
    query FetchPreviewableLink($resourceID: ID!, $resourceType: PreviewableLinkResourceType!) {
  previewableLink(resourceID: $resourceID, resourceType: $resourceType) {
    id
    URL
    createdAt
    updatedAt
    resourceID
    resourceType
    __typename
  }
}
    `;
export type FetchPreviewableLinkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>, 'query'> & ({ variables: FetchPreviewableLinkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchPreviewableLinkComponent = (props: FetchPreviewableLinkComponentProps) => (
      <ApolloReactComponents.Query<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables> query={FetchPreviewableLinkDocument} {...props} />
    );
    
export type FetchPreviewableLinkProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>
    } & TChildProps;
export function withFetchPreviewableLink<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchPreviewableLinkQuery,
  FetchPreviewableLinkQueryVariables,
  FetchPreviewableLinkProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables, FetchPreviewableLinkProps<TChildProps, TDataName>>(FetchPreviewableLinkDocument, {
      alias: 'fetchPreviewableLink',
      ...operationOptions
    });
};

/**
 * __useFetchPreviewableLinkQuery__
 *
 * To run a query within a React component, call `useFetchPreviewableLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPreviewableLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPreviewableLinkQuery({
 *   variables: {
 *      resourceID: // value for 'resourceID'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useFetchPreviewableLinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables> & ({ variables: FetchPreviewableLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>(FetchPreviewableLinkDocument, options);
      }
export function useFetchPreviewableLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>(FetchPreviewableLinkDocument, options);
        }
// @ts-ignore
export function useFetchPreviewableLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>;
export function useFetchPreviewableLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchPreviewableLinkQuery | undefined, FetchPreviewableLinkQueryVariables>;
export function useFetchPreviewableLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>(FetchPreviewableLinkDocument, options);
        }
export type FetchPreviewableLinkQueryHookResult = ReturnType<typeof useFetchPreviewableLinkQuery>;
export type FetchPreviewableLinkLazyQueryHookResult = ReturnType<typeof useFetchPreviewableLinkLazyQuery>;
export type FetchPreviewableLinkSuspenseQueryHookResult = ReturnType<typeof useFetchPreviewableLinkSuspenseQuery>;
export type FetchPreviewableLinkQueryResult = ApolloReactCommon.QueryResult<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>;
export const ProfilePageDocument = gql`
    query ProfilePage($username: String!) {
  user(userName: $username) {
    id
    name
    username
    email
    photoUrl
    userInfo
    hideTeamsFromPublic
    accountType
    defaultEntity {
      id
      name
    }
    views(viewType: "runs", first: 10000) {
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
    starredViews(first: 500) {
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
    teams(first: 100) {
      edges {
        node {
          id
          name
          photoUrl
          isTeam
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;
export type ProfilePageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfilePageQuery, ProfilePageQueryVariables>, 'query'> & ({ variables: ProfilePageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProfilePageComponent = (props: ProfilePageComponentProps) => (
      <ApolloReactComponents.Query<ProfilePageQuery, ProfilePageQueryVariables> query={ProfilePageDocument} {...props} />
    );
    
export type ProfilePageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProfilePageQuery, ProfilePageQueryVariables>
    } & TChildProps;
export function withProfilePage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProfilePageQuery,
  ProfilePageQueryVariables,
  ProfilePageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProfilePageQuery, ProfilePageQueryVariables, ProfilePageProps<TChildProps, TDataName>>(ProfilePageDocument, {
      alias: 'profilePage',
      ...operationOptions
    });
};

/**
 * __useProfilePageQuery__
 *
 * To run a query within a React component, call `useProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfilePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables> & ({ variables: ProfilePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePageQuery, ProfilePageQueryVariables>(ProfilePageDocument, options);
      }
export function useProfilePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePageQuery, ProfilePageQueryVariables>(ProfilePageDocument, options);
        }
// @ts-ignore
export function useProfilePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageQuery, ProfilePageQueryVariables>;
export function useProfilePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageQuery | undefined, ProfilePageQueryVariables>;
export function useProfilePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePageQuery, ProfilePageQueryVariables>(ProfilePageDocument, options);
        }
export type ProfilePageQueryHookResult = ReturnType<typeof useProfilePageQuery>;
export type ProfilePageLazyQueryHookResult = ReturnType<typeof useProfilePageLazyQuery>;
export type ProfilePageSuspenseQueryHookResult = ReturnType<typeof useProfilePageSuspenseQuery>;
export type ProfilePageQueryResult = ApolloReactCommon.QueryResult<ProfilePageQuery, ProfilePageQueryVariables>;
export const ProfileUserCheckDocument = gql`
    query ProfileUserCheck($username: String!) {
  user(userName: $username) {
    id
    name
    username
  }
}
    `;
export type ProfileUserCheckComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>, 'query'> & ({ variables: ProfileUserCheckQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProfileUserCheckComponent = (props: ProfileUserCheckComponentProps) => (
      <ApolloReactComponents.Query<ProfileUserCheckQuery, ProfileUserCheckQueryVariables> query={ProfileUserCheckDocument} {...props} />
    );
    
export type ProfileUserCheckProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>
    } & TChildProps;
export function withProfileUserCheck<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProfileUserCheckQuery,
  ProfileUserCheckQueryVariables,
  ProfileUserCheckProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProfileUserCheckQuery, ProfileUserCheckQueryVariables, ProfileUserCheckProps<TChildProps, TDataName>>(ProfileUserCheckDocument, {
      alias: 'profileUserCheck',
      ...operationOptions
    });
};

/**
 * __useProfileUserCheckQuery__
 *
 * To run a query within a React component, call `useProfileUserCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileUserCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileUserCheckQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfileUserCheckQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables> & ({ variables: ProfileUserCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>(ProfileUserCheckDocument, options);
      }
export function useProfileUserCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>(ProfileUserCheckDocument, options);
        }
// @ts-ignore
export function useProfileUserCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>;
export function useProfileUserCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileUserCheckQuery | undefined, ProfileUserCheckQueryVariables>;
export function useProfileUserCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>(ProfileUserCheckDocument, options);
        }
export type ProfileUserCheckQueryHookResult = ReturnType<typeof useProfileUserCheckQuery>;
export type ProfileUserCheckLazyQueryHookResult = ReturnType<typeof useProfileUserCheckLazyQuery>;
export type ProfileUserCheckSuspenseQueryHookResult = ReturnType<typeof useProfileUserCheckSuspenseQuery>;
export type ProfileUserCheckQueryResult = ApolloReactCommon.QueryResult<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>;
export const ProfilePageProjectsDocument = gql`
    query ProfilePageProjects($username: String!) {
  user(userName: $username) {
    id
    projects(first: 100) {
      edges {
        node {
          id
          name
          entityName
          access
          description
          totalRuns
          lastActive
          runCount
          user {
            id
            username
          }
        }
      }
    }
  }
}
    `;
export type ProfilePageProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>, 'query'> & ({ variables: ProfilePageProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProfilePageProjectsComponent = (props: ProfilePageProjectsComponentProps) => (
      <ApolloReactComponents.Query<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables> query={ProfilePageProjectsDocument} {...props} />
    );
    
export type ProfilePageProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>
    } & TChildProps;
export function withProfilePageProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProfilePageProjectsQuery,
  ProfilePageProjectsQueryVariables,
  ProfilePageProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables, ProfilePageProjectsProps<TChildProps, TDataName>>(ProfilePageProjectsDocument, {
      alias: 'profilePageProjects',
      ...operationOptions
    });
};

/**
 * __useProfilePageProjectsQuery__
 *
 * To run a query within a React component, call `useProfilePageProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageProjectsQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfilePageProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables> & ({ variables: ProfilePageProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>(ProfilePageProjectsDocument, options);
      }
export function useProfilePageProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>(ProfilePageProjectsDocument, options);
        }
// @ts-ignore
export function useProfilePageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>;
export function useProfilePageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageProjectsQuery | undefined, ProfilePageProjectsQueryVariables>;
export function useProfilePageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>(ProfilePageProjectsDocument, options);
        }
export type ProfilePageProjectsQueryHookResult = ReturnType<typeof useProfilePageProjectsQuery>;
export type ProfilePageProjectsLazyQueryHookResult = ReturnType<typeof useProfilePageProjectsLazyQuery>;
export type ProfilePageProjectsSuspenseQueryHookResult = ReturnType<typeof useProfilePageProjectsSuspenseQuery>;
export type ProfilePageProjectsQueryResult = ApolloReactCommon.QueryResult<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>;
export const UserRunsActivityDocument = gql`
    query UserRunsActivity($username: String!, $dailyRunCountLimit: Int!) {
  user(userName: $username) {
    id
    dailyRunCount(limit: $dailyRunCountLimit)
  }
}
    `;
export type UserRunsActivityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>, 'query'> & ({ variables: UserRunsActivityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserRunsActivityComponent = (props: UserRunsActivityComponentProps) => (
      <ApolloReactComponents.Query<UserRunsActivityQuery, UserRunsActivityQueryVariables> query={UserRunsActivityDocument} {...props} />
    );
    
export type UserRunsActivityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserRunsActivityQuery, UserRunsActivityQueryVariables>
    } & TChildProps;
export function withUserRunsActivity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserRunsActivityQuery,
  UserRunsActivityQueryVariables,
  UserRunsActivityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserRunsActivityQuery, UserRunsActivityQueryVariables, UserRunsActivityProps<TChildProps, TDataName>>(UserRunsActivityDocument, {
      alias: 'userRunsActivity',
      ...operationOptions
    });
};

/**
 * __useUserRunsActivityQuery__
 *
 * To run a query within a React component, call `useUserRunsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRunsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRunsActivityQuery({
 *   variables: {
 *      username: // value for 'username'
 *      dailyRunCountLimit: // value for 'dailyRunCountLimit'
 *   },
 * });
 */
export function useUserRunsActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables> & ({ variables: UserRunsActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserRunsActivityQuery, UserRunsActivityQueryVariables>(UserRunsActivityDocument, options);
      }
export function useUserRunsActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserRunsActivityQuery, UserRunsActivityQueryVariables>(UserRunsActivityDocument, options);
        }
// @ts-ignore
export function useUserRunsActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserRunsActivityQuery, UserRunsActivityQueryVariables>;
export function useUserRunsActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserRunsActivityQuery | undefined, UserRunsActivityQueryVariables>;
export function useUserRunsActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserRunsActivityQuery, UserRunsActivityQueryVariables>(UserRunsActivityDocument, options);
        }
export type UserRunsActivityQueryHookResult = ReturnType<typeof useUserRunsActivityQuery>;
export type UserRunsActivityLazyQueryHookResult = ReturnType<typeof useUserRunsActivityLazyQuery>;
export type UserRunsActivitySuspenseQueryHookResult = ReturnType<typeof useUserRunsActivitySuspenseQuery>;
export type UserRunsActivityQueryResult = ApolloReactCommon.QueryResult<UserRunsActivityQuery, UserRunsActivityQueryVariables>;
export const UserRunsDocument = gql`
    query UserRuns($username: String!, $pattern: String, $first: Int = 100) {
  user(userName: $username) {
    id
    runs(first: $first, pattern: $pattern) {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
  }
}
    ${RunsTableFragmentFragmentDoc}`;
export type UserRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserRunsQuery, UserRunsQueryVariables>, 'query'> & ({ variables: UserRunsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserRunsComponent = (props: UserRunsComponentProps) => (
      <ApolloReactComponents.Query<UserRunsQuery, UserRunsQueryVariables> query={UserRunsDocument} {...props} />
    );
    
export type UserRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserRunsQuery, UserRunsQueryVariables>
    } & TChildProps;
export function withUserRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserRunsQuery,
  UserRunsQueryVariables,
  UserRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserRunsQuery, UserRunsQueryVariables, UserRunsProps<TChildProps, TDataName>>(UserRunsDocument, {
      alias: 'userRuns',
      ...operationOptions
    });
};

/**
 * __useUserRunsQuery__
 *
 * To run a query within a React component, call `useUserRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRunsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      pattern: // value for 'pattern'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUserRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserRunsQuery, UserRunsQueryVariables> & ({ variables: UserRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserRunsQuery, UserRunsQueryVariables>(UserRunsDocument, options);
      }
export function useUserRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserRunsQuery, UserRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserRunsQuery, UserRunsQueryVariables>(UserRunsDocument, options);
        }
// @ts-ignore
export function useUserRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserRunsQuery, UserRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserRunsQuery, UserRunsQueryVariables>;
export function useUserRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserRunsQuery, UserRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserRunsQuery | undefined, UserRunsQueryVariables>;
export function useUserRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserRunsQuery, UserRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserRunsQuery, UserRunsQueryVariables>(UserRunsDocument, options);
        }
export type UserRunsQueryHookResult = ReturnType<typeof useUserRunsQuery>;
export type UserRunsLazyQueryHookResult = ReturnType<typeof useUserRunsLazyQuery>;
export type UserRunsSuspenseQueryHookResult = ReturnType<typeof useUserRunsSuspenseQuery>;
export type UserRunsQueryResult = ApolloReactCommon.QueryResult<UserRunsQuery, UserRunsQueryVariables>;
export const ProjectNameFromInternalIdDocument = gql`
    query ProjectNameFromInternalId($internalId: ID!) {
  project(internalId: $internalId) {
    id
    entityName
    name
  }
}
    `;
export type ProjectNameFromInternalIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>, 'query'> & ({ variables: ProjectNameFromInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectNameFromInternalIdComponent = (props: ProjectNameFromInternalIdComponentProps) => (
      <ApolloReactComponents.Query<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables> query={ProjectNameFromInternalIdDocument} {...props} />
    );
    
export type ProjectNameFromInternalIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>
    } & TChildProps;
export function withProjectNameFromInternalId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectNameFromInternalIdQuery,
  ProjectNameFromInternalIdQueryVariables,
  ProjectNameFromInternalIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables, ProjectNameFromInternalIdProps<TChildProps, TDataName>>(ProjectNameFromInternalIdDocument, {
      alias: 'projectNameFromInternalId',
      ...operationOptions
    });
};

/**
 * __useProjectNameFromInternalIdQuery__
 *
 * To run a query within a React component, call `useProjectNameFromInternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNameFromInternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectNameFromInternalIdQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *   },
 * });
 */
export function useProjectNameFromInternalIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables> & ({ variables: ProjectNameFromInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>(ProjectNameFromInternalIdDocument, options);
      }
export function useProjectNameFromInternalIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>(ProjectNameFromInternalIdDocument, options);
        }
// @ts-ignore
export function useProjectNameFromInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>;
export function useProjectNameFromInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectNameFromInternalIdQuery | undefined, ProjectNameFromInternalIdQueryVariables>;
export function useProjectNameFromInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>(ProjectNameFromInternalIdDocument, options);
        }
export type ProjectNameFromInternalIdQueryHookResult = ReturnType<typeof useProjectNameFromInternalIdQuery>;
export type ProjectNameFromInternalIdLazyQueryHookResult = ReturnType<typeof useProjectNameFromInternalIdLazyQuery>;
export type ProjectNameFromInternalIdSuspenseQueryHookResult = ReturnType<typeof useProjectNameFromInternalIdSuspenseQuery>;
export type ProjectNameFromInternalIdQueryResult = ApolloReactCommon.QueryResult<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>;
export const ProjectInternalIdFromNameDocument = gql`
    query ProjectInternalIdFromName($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    internalId
  }
}
    `;
export type ProjectInternalIdFromNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>, 'query'> & ({ variables: ProjectInternalIdFromNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectInternalIdFromNameComponent = (props: ProjectInternalIdFromNameComponentProps) => (
      <ApolloReactComponents.Query<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables> query={ProjectInternalIdFromNameDocument} {...props} />
    );
    
export type ProjectInternalIdFromNameProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>
    } & TChildProps;
export function withProjectInternalIdFromName<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectInternalIdFromNameQuery,
  ProjectInternalIdFromNameQueryVariables,
  ProjectInternalIdFromNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables, ProjectInternalIdFromNameProps<TChildProps, TDataName>>(ProjectInternalIdFromNameDocument, {
      alias: 'projectInternalIdFromName',
      ...operationOptions
    });
};

/**
 * __useProjectInternalIdFromNameQuery__
 *
 * To run a query within a React component, call `useProjectInternalIdFromNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInternalIdFromNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInternalIdFromNameQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectInternalIdFromNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables> & ({ variables: ProjectInternalIdFromNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>(ProjectInternalIdFromNameDocument, options);
      }
export function useProjectInternalIdFromNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>(ProjectInternalIdFromNameDocument, options);
        }
// @ts-ignore
export function useProjectInternalIdFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>;
export function useProjectInternalIdFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectInternalIdFromNameQuery | undefined, ProjectInternalIdFromNameQueryVariables>;
export function useProjectInternalIdFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>(ProjectInternalIdFromNameDocument, options);
        }
export type ProjectInternalIdFromNameQueryHookResult = ReturnType<typeof useProjectInternalIdFromNameQuery>;
export type ProjectInternalIdFromNameLazyQueryHookResult = ReturnType<typeof useProjectInternalIdFromNameLazyQuery>;
export type ProjectInternalIdFromNameSuspenseQueryHookResult = ReturnType<typeof useProjectInternalIdFromNameSuspenseQuery>;
export type ProjectInternalIdFromNameQueryResult = ApolloReactCommon.QueryResult<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>;
export const ProjectInfosFromInternalIdsDocument = gql`
    query ProjectInfosFromInternalIds($internalIds: [ID!]!) {
  projects(internalIDs: $internalIds) {
    edges {
      node {
        id
        internalId
        name
        entityName
      }
    }
  }
}
    `;
export type ProjectInfosFromInternalIdsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>, 'query'> & ({ variables: ProjectInfosFromInternalIdsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectInfosFromInternalIdsComponent = (props: ProjectInfosFromInternalIdsComponentProps) => (
      <ApolloReactComponents.Query<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables> query={ProjectInfosFromInternalIdsDocument} {...props} />
    );
    
export type ProjectInfosFromInternalIdsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>
    } & TChildProps;
export function withProjectInfosFromInternalIds<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectInfosFromInternalIdsQuery,
  ProjectInfosFromInternalIdsQueryVariables,
  ProjectInfosFromInternalIdsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables, ProjectInfosFromInternalIdsProps<TChildProps, TDataName>>(ProjectInfosFromInternalIdsDocument, {
      alias: 'projectInfosFromInternalIds',
      ...operationOptions
    });
};

/**
 * __useProjectInfosFromInternalIdsQuery__
 *
 * To run a query within a React component, call `useProjectInfosFromInternalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInfosFromInternalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInfosFromInternalIdsQuery({
 *   variables: {
 *      internalIds: // value for 'internalIds'
 *   },
 * });
 */
export function useProjectInfosFromInternalIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables> & ({ variables: ProjectInfosFromInternalIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>(ProjectInfosFromInternalIdsDocument, options);
      }
export function useProjectInfosFromInternalIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>(ProjectInfosFromInternalIdsDocument, options);
        }
// @ts-ignore
export function useProjectInfosFromInternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>;
export function useProjectInfosFromInternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectInfosFromInternalIdsQuery | undefined, ProjectInfosFromInternalIdsQueryVariables>;
export function useProjectInfosFromInternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>(ProjectInfosFromInternalIdsDocument, options);
        }
export type ProjectInfosFromInternalIdsQueryHookResult = ReturnType<typeof useProjectInfosFromInternalIdsQuery>;
export type ProjectInfosFromInternalIdsLazyQueryHookResult = ReturnType<typeof useProjectInfosFromInternalIdsLazyQuery>;
export type ProjectInfosFromInternalIdsSuspenseQueryHookResult = ReturnType<typeof useProjectInfosFromInternalIdsSuspenseQuery>;
export type ProjectInfosFromInternalIdsQueryResult = ApolloReactCommon.QueryResult<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>;
export const AllProjectNamesDocument = gql`
    query AllProjectNames($entityName: String!, $first: Int = 500, $order: String = "name") {
  projects(first: $first, entityName: $entityName, order: $order) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export type AllProjectNamesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>, 'query'> & ({ variables: AllProjectNamesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AllProjectNamesComponent = (props: AllProjectNamesComponentProps) => (
      <ApolloReactComponents.Query<AllProjectNamesQuery, AllProjectNamesQueryVariables> query={AllProjectNamesDocument} {...props} />
    );
    
export type AllProjectNamesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllProjectNamesQuery, AllProjectNamesQueryVariables>
    } & TChildProps;
export function withAllProjectNames<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllProjectNamesQuery,
  AllProjectNamesQueryVariables,
  AllProjectNamesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllProjectNamesQuery, AllProjectNamesQueryVariables, AllProjectNamesProps<TChildProps, TDataName>>(AllProjectNamesDocument, {
      alias: 'allProjectNames',
      ...operationOptions
    });
};

/**
 * __useAllProjectNamesQuery__
 *
 * To run a query within a React component, call `useAllProjectNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProjectNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProjectNamesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAllProjectNamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables> & ({ variables: AllProjectNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllProjectNamesQuery, AllProjectNamesQueryVariables>(AllProjectNamesDocument, options);
      }
export function useAllProjectNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllProjectNamesQuery, AllProjectNamesQueryVariables>(AllProjectNamesDocument, options);
        }
// @ts-ignore
export function useAllProjectNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllProjectNamesQuery, AllProjectNamesQueryVariables>;
export function useAllProjectNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllProjectNamesQuery | undefined, AllProjectNamesQueryVariables>;
export function useAllProjectNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllProjectNamesQuery, AllProjectNamesQueryVariables>(AllProjectNamesDocument, options);
        }
export type AllProjectNamesQueryHookResult = ReturnType<typeof useAllProjectNamesQuery>;
export type AllProjectNamesLazyQueryHookResult = ReturnType<typeof useAllProjectNamesLazyQuery>;
export type AllProjectNamesSuspenseQueryHookResult = ReturnType<typeof useAllProjectNamesSuspenseQuery>;
export type AllProjectNamesQueryResult = ApolloReactCommon.QueryResult<AllProjectNamesQuery, AllProjectNamesQueryVariables>;
export const AllProjectNamesWithPatternDocument = gql`
    query AllProjectNamesWithPattern($entityName: String!, $first: Int = 500, $order: String = "name", $pattern: String) {
  projects(
    first: $first
    entityName: $entityName
    order: $order
    pattern: $pattern
  ) {
    edges {
      node {
        id
        name
        entityName
      }
    }
  }
}
    `;
export type AllProjectNamesWithPatternComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>, 'query'> & ({ variables: AllProjectNamesWithPatternQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AllProjectNamesWithPatternComponent = (props: AllProjectNamesWithPatternComponentProps) => (
      <ApolloReactComponents.Query<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables> query={AllProjectNamesWithPatternDocument} {...props} />
    );
    
export type AllProjectNamesWithPatternProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>
    } & TChildProps;
export function withAllProjectNamesWithPattern<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllProjectNamesWithPatternQuery,
  AllProjectNamesWithPatternQueryVariables,
  AllProjectNamesWithPatternProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables, AllProjectNamesWithPatternProps<TChildProps, TDataName>>(AllProjectNamesWithPatternDocument, {
      alias: 'allProjectNamesWithPattern',
      ...operationOptions
    });
};

/**
 * __useAllProjectNamesWithPatternQuery__
 *
 * To run a query within a React component, call `useAllProjectNamesWithPatternQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProjectNamesWithPatternQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProjectNamesWithPatternQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useAllProjectNamesWithPatternQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables> & ({ variables: AllProjectNamesWithPatternQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>(AllProjectNamesWithPatternDocument, options);
      }
export function useAllProjectNamesWithPatternLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>(AllProjectNamesWithPatternDocument, options);
        }
// @ts-ignore
export function useAllProjectNamesWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>;
export function useAllProjectNamesWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllProjectNamesWithPatternQuery | undefined, AllProjectNamesWithPatternQueryVariables>;
export function useAllProjectNamesWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>(AllProjectNamesWithPatternDocument, options);
        }
export type AllProjectNamesWithPatternQueryHookResult = ReturnType<typeof useAllProjectNamesWithPatternQuery>;
export type AllProjectNamesWithPatternLazyQueryHookResult = ReturnType<typeof useAllProjectNamesWithPatternLazyQuery>;
export type AllProjectNamesWithPatternSuspenseQueryHookResult = ReturnType<typeof useAllProjectNamesWithPatternSuspenseQuery>;
export type AllProjectNamesWithPatternQueryResult = ApolloReactCommon.QueryResult<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>;
export const MoveProjectsDocument = gql`
    mutation moveProjects($projectNames: [String!], $sourceEntityName: String!, $destinationEntityName: String!, $ownerUsername: String!, $notes: String, $clientMutationId: String) {
  moveProjects(
    input: {projectNames: $projectNames, sourceEntityName: $sourceEntityName, destinationEntityName: $destinationEntityName, ownerUsername: $ownerUsername, notes: $notes, clientMutationId: $clientMutationId}
  ) {
    tasks {
      id
      type
      state
      progress
      name
    }
  }
}
    `;
export type MoveProjectsMutationFn = ApolloReactCommon.MutationFunction<MoveProjectsMutation, MoveProjectsMutationVariables>;
export type MoveProjectsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MoveProjectsMutation, MoveProjectsMutationVariables>, 'mutation'>;

    export const MoveProjectsComponent = (props: MoveProjectsComponentProps) => (
      <ApolloReactComponents.Mutation<MoveProjectsMutation, MoveProjectsMutationVariables> mutation={MoveProjectsDocument} {...props} />
    );
    
export type MoveProjectsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MoveProjectsMutation, MoveProjectsMutationVariables>
    } & TChildProps;
export function withMoveProjects<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MoveProjectsMutation,
  MoveProjectsMutationVariables,
  MoveProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MoveProjectsMutation, MoveProjectsMutationVariables, MoveProjectsProps<TChildProps, TDataName>>(MoveProjectsDocument, {
      alias: 'moveProjects',
      ...operationOptions
    });
};

/**
 * __useMoveProjectsMutation__
 *
 * To run a mutation, you first call `useMoveProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveProjectsMutation, { data, loading, error }] = useMoveProjectsMutation({
 *   variables: {
 *      projectNames: // value for 'projectNames'
 *      sourceEntityName: // value for 'sourceEntityName'
 *      destinationEntityName: // value for 'destinationEntityName'
 *      ownerUsername: // value for 'ownerUsername'
 *      notes: // value for 'notes'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useMoveProjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveProjectsMutation, MoveProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveProjectsMutation, MoveProjectsMutationVariables>(MoveProjectsDocument, options);
      }
export type MoveProjectsMutationHookResult = ReturnType<typeof useMoveProjectsMutation>;
export type MoveProjectsMutationResult = ApolloReactCommon.MutationResult<MoveProjectsMutation>;
export type MoveProjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveProjectsMutation, MoveProjectsMutationVariables>;
export const CloneProjectsDocument = gql`
    mutation cloneProjects($projectNames: [String!], $sourceEntityName: String!, $destinationEntityName: String!, $ownerUsername: String!, $notes: String, $clientMutationId: String) {
  cloneProjects(
    input: {projectNames: $projectNames, sourceEntityName: $sourceEntityName, destinationEntityName: $destinationEntityName, ownerUsername: $ownerUsername, notes: $notes, clientMutationId: $clientMutationId}
  ) {
    tasks {
      id
      type
      state
      progress
      name
    }
  }
}
    `;
export type CloneProjectsMutationFn = ApolloReactCommon.MutationFunction<CloneProjectsMutation, CloneProjectsMutationVariables>;
export type CloneProjectsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CloneProjectsMutation, CloneProjectsMutationVariables>, 'mutation'>;

    export const CloneProjectsComponent = (props: CloneProjectsComponentProps) => (
      <ApolloReactComponents.Mutation<CloneProjectsMutation, CloneProjectsMutationVariables> mutation={CloneProjectsDocument} {...props} />
    );
    
export type CloneProjectsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CloneProjectsMutation, CloneProjectsMutationVariables>
    } & TChildProps;
export function withCloneProjects<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CloneProjectsMutation,
  CloneProjectsMutationVariables,
  CloneProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CloneProjectsMutation, CloneProjectsMutationVariables, CloneProjectsProps<TChildProps, TDataName>>(CloneProjectsDocument, {
      alias: 'cloneProjects',
      ...operationOptions
    });
};

/**
 * __useCloneProjectsMutation__
 *
 * To run a mutation, you first call `useCloneProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProjectsMutation, { data, loading, error }] = useCloneProjectsMutation({
 *   variables: {
 *      projectNames: // value for 'projectNames'
 *      sourceEntityName: // value for 'sourceEntityName'
 *      destinationEntityName: // value for 'destinationEntityName'
 *      ownerUsername: // value for 'ownerUsername'
 *      notes: // value for 'notes'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCloneProjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneProjectsMutation, CloneProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloneProjectsMutation, CloneProjectsMutationVariables>(CloneProjectsDocument, options);
      }
export type CloneProjectsMutationHookResult = ReturnType<typeof useCloneProjectsMutation>;
export type CloneProjectsMutationResult = ApolloReactCommon.MutationResult<CloneProjectsMutation>;
export type CloneProjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneProjectsMutation, CloneProjectsMutationVariables>;
export const MoveHistoryForRunDocument = gql`
    mutation moveHistoryForRun($sourceEntityName: String!, $sourceProjectName: String!, $runName: String!, $destinationEntityName: String!, $destinationProjectName: String!, $clientMutationId: String) {
  moveHistoryForRun(
    input: {sourceEntityName: $sourceEntityName, sourceProjectName: $sourceProjectName, runName: $runName, destinationEntityName: $destinationEntityName, destinationProjectName: $destinationProjectName, clientMutationId: $clientMutationId}
  ) {
    task {
      id
      type
      state
      progress
      name
    }
  }
}
    `;
export type MoveHistoryForRunMutationFn = ApolloReactCommon.MutationFunction<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>;
export type MoveHistoryForRunComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>, 'mutation'>;

    export const MoveHistoryForRunComponent = (props: MoveHistoryForRunComponentProps) => (
      <ApolloReactComponents.Mutation<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables> mutation={MoveHistoryForRunDocument} {...props} />
    );
    
export type MoveHistoryForRunProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>
    } & TChildProps;
export function withMoveHistoryForRun<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MoveHistoryForRunMutation,
  MoveHistoryForRunMutationVariables,
  MoveHistoryForRunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables, MoveHistoryForRunProps<TChildProps, TDataName>>(MoveHistoryForRunDocument, {
      alias: 'moveHistoryForRun',
      ...operationOptions
    });
};

/**
 * __useMoveHistoryForRunMutation__
 *
 * To run a mutation, you first call `useMoveHistoryForRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveHistoryForRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveHistoryForRunMutation, { data, loading, error }] = useMoveHistoryForRunMutation({
 *   variables: {
 *      sourceEntityName: // value for 'sourceEntityName'
 *      sourceProjectName: // value for 'sourceProjectName'
 *      runName: // value for 'runName'
 *      destinationEntityName: // value for 'destinationEntityName'
 *      destinationProjectName: // value for 'destinationProjectName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useMoveHistoryForRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>(MoveHistoryForRunDocument, options);
      }
export type MoveHistoryForRunMutationHookResult = ReturnType<typeof useMoveHistoryForRunMutation>;
export type MoveHistoryForRunMutationResult = ApolloReactCommon.MutationResult<MoveHistoryForRunMutation>;
export type MoveHistoryForRunMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>;
export const ProjectMembersDocument = gql`
    query ProjectMembers($projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    members {
      ...ProjectMemberFields
    }
  }
}
    ${ProjectMemberFieldsFragmentDoc}`;
export type ProjectMembersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectMembersQuery, ProjectMembersQueryVariables>, 'query'> & ({ variables: ProjectMembersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectMembersComponent = (props: ProjectMembersComponentProps) => (
      <ApolloReactComponents.Query<ProjectMembersQuery, ProjectMembersQueryVariables> query={ProjectMembersDocument} {...props} />
    );
    
export type ProjectMembersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectMembersQuery, ProjectMembersQueryVariables>
    } & TChildProps;
export function withProjectMembers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectMembersQuery,
  ProjectMembersQueryVariables,
  ProjectMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectMembersQuery, ProjectMembersQueryVariables, ProjectMembersProps<TChildProps, TDataName>>(ProjectMembersDocument, {
      alias: 'projectMembers',
      ...operationOptions
    });
};

/**
 * __useProjectMembersQuery__
 *
 * To run a query within a React component, call `useProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembersQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables> & ({ variables: ProjectMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, options);
      }
export function useProjectMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, options);
        }
// @ts-ignore
export function useProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMembersQuery, ProjectMembersQueryVariables>;
export function useProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMembersQuery | undefined, ProjectMembersQueryVariables>;
export function useProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, options);
        }
export type ProjectMembersQueryHookResult = ReturnType<typeof useProjectMembersQuery>;
export type ProjectMembersLazyQueryHookResult = ReturnType<typeof useProjectMembersLazyQuery>;
export type ProjectMembersSuspenseQueryHookResult = ReturnType<typeof useProjectMembersSuspenseQuery>;
export type ProjectMembersQueryResult = ApolloReactCommon.QueryResult<ProjectMembersQuery, ProjectMembersQueryVariables>;
export const ProjectMemberDocument = gql`
    query ProjectMember($projectName: String!, $entityName: String!, $memberId: ID!) {
  project(name: $projectName, entityName: $entityName) {
    id
    member(id: $memberId) {
      ...ProjectMemberFields
    }
  }
}
    ${ProjectMemberFieldsFragmentDoc}`;
export type ProjectMemberComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectMemberQuery, ProjectMemberQueryVariables>, 'query'> & ({ variables: ProjectMemberQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectMemberComponent = (props: ProjectMemberComponentProps) => (
      <ApolloReactComponents.Query<ProjectMemberQuery, ProjectMemberQueryVariables> query={ProjectMemberDocument} {...props} />
    );
    
export type ProjectMemberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectMemberQuery, ProjectMemberQueryVariables>
    } & TChildProps;
export function withProjectMember<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectMemberQuery,
  ProjectMemberQueryVariables,
  ProjectMemberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectMemberQuery, ProjectMemberQueryVariables, ProjectMemberProps<TChildProps, TDataName>>(ProjectMemberDocument, {
      alias: 'projectMember',
      ...operationOptions
    });
};

/**
 * __useProjectMemberQuery__
 *
 * To run a query within a React component, call `useProjectMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMemberQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useProjectMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables> & ({ variables: ProjectMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectMemberQuery, ProjectMemberQueryVariables>(ProjectMemberDocument, options);
      }
export function useProjectMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectMemberQuery, ProjectMemberQueryVariables>(ProjectMemberDocument, options);
        }
// @ts-ignore
export function useProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMemberQuery, ProjectMemberQueryVariables>;
export function useProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMemberQuery | undefined, ProjectMemberQueryVariables>;
export function useProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectMemberQuery, ProjectMemberQueryVariables>(ProjectMemberDocument, options);
        }
export type ProjectMemberQueryHookResult = ReturnType<typeof useProjectMemberQuery>;
export type ProjectMemberLazyQueryHookResult = ReturnType<typeof useProjectMemberLazyQuery>;
export type ProjectMemberSuspenseQueryHookResult = ReturnType<typeof useProjectMemberSuspenseQuery>;
export type ProjectMemberQueryResult = ApolloReactCommon.QueryResult<ProjectMemberQuery, ProjectMemberQueryVariables>;
export const CreateProjectMembersDocument = gql`
    mutation createProjectMembers($userIds: [ID!]!, $projectId: ID!) {
  createProjectMembers(input: {userIds: $userIds, projectId: $projectId}) {
    success
  }
}
    `;
export type CreateProjectMembersMutationFn = ApolloReactCommon.MutationFunction<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>;
export type CreateProjectMembersComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>, 'mutation'>;

    export const CreateProjectMembersComponent = (props: CreateProjectMembersComponentProps) => (
      <ApolloReactComponents.Mutation<CreateProjectMembersMutation, CreateProjectMembersMutationVariables> mutation={CreateProjectMembersDocument} {...props} />
    );
    
export type CreateProjectMembersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>
    } & TChildProps;
export function withCreateProjectMembers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateProjectMembersMutation,
  CreateProjectMembersMutationVariables,
  CreateProjectMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateProjectMembersMutation, CreateProjectMembersMutationVariables, CreateProjectMembersProps<TChildProps, TDataName>>(CreateProjectMembersDocument, {
      alias: 'createProjectMembers',
      ...operationOptions
    });
};

/**
 * __useCreateProjectMembersMutation__
 *
 * To run a mutation, you first call `useCreateProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMembersMutation, { data, loading, error }] = useCreateProjectMembersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateProjectMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>(CreateProjectMembersDocument, options);
      }
export type CreateProjectMembersMutationHookResult = ReturnType<typeof useCreateProjectMembersMutation>;
export type CreateProjectMembersMutationResult = ApolloReactCommon.MutationResult<CreateProjectMembersMutation>;
export type CreateProjectMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>;
export const DeleteProjectMembersDocument = gql`
    mutation deleteProjectMembers($userIds: [ID!]!, $projectId: ID!) {
  deleteProjectMembers(input: {userIds: $userIds, projectId: $projectId}) {
    success
  }
}
    `;
export type DeleteProjectMembersMutationFn = ApolloReactCommon.MutationFunction<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>;
export type DeleteProjectMembersComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>, 'mutation'>;

    export const DeleteProjectMembersComponent = (props: DeleteProjectMembersComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables> mutation={DeleteProjectMembersDocument} {...props} />
    );
    
export type DeleteProjectMembersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>
    } & TChildProps;
export function withDeleteProjectMembers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteProjectMembersMutation,
  DeleteProjectMembersMutationVariables,
  DeleteProjectMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables, DeleteProjectMembersProps<TChildProps, TDataName>>(DeleteProjectMembersDocument, {
      alias: 'deleteProjectMembers',
      ...operationOptions
    });
};

/**
 * __useDeleteProjectMembersMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMembersMutation, { data, loading, error }] = useDeleteProjectMembersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>(DeleteProjectMembersDocument, options);
      }
export type DeleteProjectMembersMutationHookResult = ReturnType<typeof useDeleteProjectMembersMutation>;
export type DeleteProjectMembersMutationResult = ApolloReactCommon.MutationResult<DeleteProjectMembersMutation>;
export type DeleteProjectMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>;
export const ProjectMembersEntityMembersDocument = gql`
    query ProjectMembersEntityMembers($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    members {
      id
      role {
        ID
        name
      }
    }
    entity {
      id
      members {
        id
        admin
        pending
        email
        username
        name
        photoUrl
        accountType
        memberRole {
          ID
          name
          permissions {
            name
            groupName
            displayName
          }
        }
      }
    }
  }
}
    `;
export type ProjectMembersEntityMembersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>, 'query'> & ({ variables: ProjectMembersEntityMembersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectMembersEntityMembersComponent = (props: ProjectMembersEntityMembersComponentProps) => (
      <ApolloReactComponents.Query<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables> query={ProjectMembersEntityMembersDocument} {...props} />
    );
    
export type ProjectMembersEntityMembersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>
    } & TChildProps;
export function withProjectMembersEntityMembers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectMembersEntityMembersQuery,
  ProjectMembersEntityMembersQueryVariables,
  ProjectMembersEntityMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables, ProjectMembersEntityMembersProps<TChildProps, TDataName>>(ProjectMembersEntityMembersDocument, {
      alias: 'projectMembersEntityMembers',
      ...operationOptions
    });
};

/**
 * __useProjectMembersEntityMembersQuery__
 *
 * To run a query within a React component, call `useProjectMembersEntityMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersEntityMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembersEntityMembersQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectMembersEntityMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables> & ({ variables: ProjectMembersEntityMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>(ProjectMembersEntityMembersDocument, options);
      }
export function useProjectMembersEntityMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>(ProjectMembersEntityMembersDocument, options);
        }
// @ts-ignore
export function useProjectMembersEntityMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>;
export function useProjectMembersEntityMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMembersEntityMembersQuery | undefined, ProjectMembersEntityMembersQueryVariables>;
export function useProjectMembersEntityMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>(ProjectMembersEntityMembersDocument, options);
        }
export type ProjectMembersEntityMembersQueryHookResult = ReturnType<typeof useProjectMembersEntityMembersQuery>;
export type ProjectMembersEntityMembersLazyQueryHookResult = ReturnType<typeof useProjectMembersEntityMembersLazyQuery>;
export type ProjectMembersEntityMembersSuspenseQueryHookResult = ReturnType<typeof useProjectMembersEntityMembersSuspenseQuery>;
export type ProjectMembersEntityMembersQueryResult = ApolloReactCommon.QueryResult<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>;
export const RampSettingsDocument = gql`
    query RampSettings {
  rampManager {
    settings {
      edges {
        name
        group
        description
        rampType
        rampIDType
        stores {
          name
          thresholds {
            checkId
            displayCheckID
            threshold
          }
        }
      }
    }
  }
}
    `;
export type RampSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RampSettingsQuery, RampSettingsQueryVariables>, 'query'>;

    export const RampSettingsComponent = (props: RampSettingsComponentProps) => (
      <ApolloReactComponents.Query<RampSettingsQuery, RampSettingsQueryVariables> query={RampSettingsDocument} {...props} />
    );
    
export type RampSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RampSettingsQuery, RampSettingsQueryVariables>
    } & TChildProps;
export function withRampSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RampSettingsQuery,
  RampSettingsQueryVariables,
  RampSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RampSettingsQuery, RampSettingsQueryVariables, RampSettingsProps<TChildProps, TDataName>>(RampSettingsDocument, {
      alias: 'rampSettings',
      ...operationOptions
    });
};

/**
 * __useRampSettingsQuery__
 *
 * To run a query within a React component, call `useRampSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RampSettingsQuery, RampSettingsQueryVariables>(RampSettingsDocument, options);
      }
export function useRampSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RampSettingsQuery, RampSettingsQueryVariables>(RampSettingsDocument, options);
        }
// @ts-ignore
export function useRampSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RampSettingsQuery, RampSettingsQueryVariables>;
export function useRampSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RampSettingsQuery | undefined, RampSettingsQueryVariables>;
export function useRampSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RampSettingsQuery, RampSettingsQueryVariables>(RampSettingsDocument, options);
        }
export type RampSettingsQueryHookResult = ReturnType<typeof useRampSettingsQuery>;
export type RampSettingsLazyQueryHookResult = ReturnType<typeof useRampSettingsLazyQuery>;
export type RampSettingsSuspenseQueryHookResult = ReturnType<typeof useRampSettingsSuspenseQuery>;
export type RampSettingsQueryResult = ApolloReactCommon.QueryResult<RampSettingsQuery, RampSettingsQueryVariables>;
export const IdIsRampedForSettingDocument = gql`
    query IDIsRampedForSetting($setting: String!, $id: String!) {
  rampManager {
    setting(name: $setting) {
      idIsRamped(id: $id)
    }
  }
}
    `;
export type IdIsRampedForSettingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>, 'query'> & ({ variables: IdIsRampedForSettingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IdIsRampedForSettingComponent = (props: IdIsRampedForSettingComponentProps) => (
      <ApolloReactComponents.Query<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables> query={IdIsRampedForSettingDocument} {...props} />
    );
    
export type IdIsRampedForSettingProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>
    } & TChildProps;
export function withIdIsRampedForSetting<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IdIsRampedForSettingQuery,
  IdIsRampedForSettingQueryVariables,
  IdIsRampedForSettingProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables, IdIsRampedForSettingProps<TChildProps, TDataName>>(IdIsRampedForSettingDocument, {
      alias: 'idIsRampedForSetting',
      ...operationOptions
    });
};

/**
 * __useIdIsRampedForSettingQuery__
 *
 * To run a query within a React component, call `useIdIsRampedForSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdIsRampedForSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdIsRampedForSettingQuery({
 *   variables: {
 *      setting: // value for 'setting'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIdIsRampedForSettingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables> & ({ variables: IdIsRampedForSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>(IdIsRampedForSettingDocument, options);
      }
export function useIdIsRampedForSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>(IdIsRampedForSettingDocument, options);
        }
// @ts-ignore
export function useIdIsRampedForSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>;
export function useIdIsRampedForSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IdIsRampedForSettingQuery | undefined, IdIsRampedForSettingQueryVariables>;
export function useIdIsRampedForSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>(IdIsRampedForSettingDocument, options);
        }
export type IdIsRampedForSettingQueryHookResult = ReturnType<typeof useIdIsRampedForSettingQuery>;
export type IdIsRampedForSettingLazyQueryHookResult = ReturnType<typeof useIdIsRampedForSettingLazyQuery>;
export type IdIsRampedForSettingSuspenseQueryHookResult = ReturnType<typeof useIdIsRampedForSettingSuspenseQuery>;
export type IdIsRampedForSettingQueryResult = ApolloReactCommon.QueryResult<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>;
export const UpdateRampThresholdDocument = gql`
    mutation updateRampThreshold($store: String!, $setting: String!, $checkId: String!, $threshold: Float!, $clientMutationId: String) {
  updateRampThreshold(
    input: {store: $store, setting: $setting, checkId: $checkId, threshold: $threshold, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateRampThresholdMutationFn = ApolloReactCommon.MutationFunction<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>;
export type UpdateRampThresholdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>, 'mutation'>;

    export const UpdateRampThresholdComponent = (props: UpdateRampThresholdComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables> mutation={UpdateRampThresholdDocument} {...props} />
    );
    
export type UpdateRampThresholdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>
    } & TChildProps;
export function withUpdateRampThreshold<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateRampThresholdMutation,
  UpdateRampThresholdMutationVariables,
  UpdateRampThresholdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables, UpdateRampThresholdProps<TChildProps, TDataName>>(UpdateRampThresholdDocument, {
      alias: 'updateRampThreshold',
      ...operationOptions
    });
};

/**
 * __useUpdateRampThresholdMutation__
 *
 * To run a mutation, you first call `useUpdateRampThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRampThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRampThresholdMutation, { data, loading, error }] = useUpdateRampThresholdMutation({
 *   variables: {
 *      store: // value for 'store'
 *      setting: // value for 'setting'
 *      checkId: // value for 'checkId'
 *      threshold: // value for 'threshold'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateRampThresholdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>(UpdateRampThresholdDocument, options);
      }
export type UpdateRampThresholdMutationHookResult = ReturnType<typeof useUpdateRampThresholdMutation>;
export type UpdateRampThresholdMutationResult = ApolloReactCommon.MutationResult<UpdateRampThresholdMutation>;
export type UpdateRampThresholdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>;
export const FetchRepoDisplayNameByIdDocument = gql`
    query FetchRepoDisplayNameByID($id: ID!) {
  repo(id: $id) {
    id
    displayName
  }
}
    `;
export type FetchRepoDisplayNameByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>, 'query'> & ({ variables: FetchRepoDisplayNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRepoDisplayNameByIdComponent = (props: FetchRepoDisplayNameByIdComponentProps) => (
      <ApolloReactComponents.Query<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables> query={FetchRepoDisplayNameByIdDocument} {...props} />
    );
    
export type FetchRepoDisplayNameByIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>
    } & TChildProps;
export function withFetchRepoDisplayNameById<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRepoDisplayNameByIdQuery,
  FetchRepoDisplayNameByIdQueryVariables,
  FetchRepoDisplayNameByIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables, FetchRepoDisplayNameByIdProps<TChildProps, TDataName>>(FetchRepoDisplayNameByIdDocument, {
      alias: 'fetchRepoDisplayNameById',
      ...operationOptions
    });
};

/**
 * __useFetchRepoDisplayNameByIdQuery__
 *
 * To run a query within a React component, call `useFetchRepoDisplayNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRepoDisplayNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRepoDisplayNameByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchRepoDisplayNameByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables> & ({ variables: FetchRepoDisplayNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>(FetchRepoDisplayNameByIdDocument, options);
      }
export function useFetchRepoDisplayNameByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>(FetchRepoDisplayNameByIdDocument, options);
        }
// @ts-ignore
export function useFetchRepoDisplayNameByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>;
export function useFetchRepoDisplayNameByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRepoDisplayNameByIdQuery | undefined, FetchRepoDisplayNameByIdQueryVariables>;
export function useFetchRepoDisplayNameByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>(FetchRepoDisplayNameByIdDocument, options);
        }
export type FetchRepoDisplayNameByIdQueryHookResult = ReturnType<typeof useFetchRepoDisplayNameByIdQuery>;
export type FetchRepoDisplayNameByIdLazyQueryHookResult = ReturnType<typeof useFetchRepoDisplayNameByIdLazyQuery>;
export type FetchRepoDisplayNameByIdSuspenseQueryHookResult = ReturnType<typeof useFetchRepoDisplayNameByIdSuspenseQuery>;
export type FetchRepoDisplayNameByIdQueryResult = ApolloReactCommon.QueryResult<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>;
export const ReportSearchDocument = gql`
    query ReportSearch($query: String!) {
  reportSearch(query: $query) {
    edges {
      node {
        entityName
        displayName
        id
        projectName
      }
    }
  }
}
    `;
export type ReportSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReportSearchQuery, ReportSearchQueryVariables>, 'query'> & ({ variables: ReportSearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReportSearchComponent = (props: ReportSearchComponentProps) => (
      <ApolloReactComponents.Query<ReportSearchQuery, ReportSearchQueryVariables> query={ReportSearchDocument} {...props} />
    );
    
export type ReportSearchProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ReportSearchQuery, ReportSearchQueryVariables>
    } & TChildProps;
export function withReportSearch<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReportSearchQuery,
  ReportSearchQueryVariables,
  ReportSearchProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ReportSearchQuery, ReportSearchQueryVariables, ReportSearchProps<TChildProps, TDataName>>(ReportSearchDocument, {
      alias: 'reportSearch',
      ...operationOptions
    });
};

/**
 * __useReportSearchQuery__
 *
 * To run a query within a React component, call `useReportSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useReportSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables> & ({ variables: ReportSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReportSearchQuery, ReportSearchQueryVariables>(ReportSearchDocument, options);
      }
export function useReportSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReportSearchQuery, ReportSearchQueryVariables>(ReportSearchDocument, options);
        }
// @ts-ignore
export function useReportSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportSearchQuery, ReportSearchQueryVariables>;
export function useReportSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportSearchQuery | undefined, ReportSearchQueryVariables>;
export function useReportSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReportSearchQuery, ReportSearchQueryVariables>(ReportSearchDocument, options);
        }
export type ReportSearchQueryHookResult = ReturnType<typeof useReportSearchQuery>;
export type ReportSearchLazyQueryHookResult = ReturnType<typeof useReportSearchLazyQuery>;
export type ReportSearchSuspenseQueryHookResult = ReturnType<typeof useReportSearchSuspenseQuery>;
export type ReportSearchQueryResult = ApolloReactCommon.QueryResult<ReportSearchQuery, ReportSearchQueryVariables>;
export const OrganizationRolesDocument = gql`
    query OrganizationRoles($orgName: String!) {
  organization(name: $orgName) {
    id
    roles {
      ID
      name
      description
      inheritedFrom {
        name
      }
    }
  }
}
    `;
export type OrganizationRolesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>, 'query'> & ({ variables: OrganizationRolesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationRolesComponent = (props: OrganizationRolesComponentProps) => (
      <ApolloReactComponents.Query<OrganizationRolesQuery, OrganizationRolesQueryVariables> query={OrganizationRolesDocument} {...props} />
    );
    
export type OrganizationRolesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationRolesQuery, OrganizationRolesQueryVariables>
    } & TChildProps;
export function withOrganizationRoles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationRolesQuery,
  OrganizationRolesQueryVariables,
  OrganizationRolesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationRolesQuery, OrganizationRolesQueryVariables, OrganizationRolesProps<TChildProps, TDataName>>(OrganizationRolesDocument, {
      alias: 'organizationRoles',
      ...operationOptions
    });
};

/**
 * __useOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRolesQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables> & ({ variables: OrganizationRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRolesQuery, OrganizationRolesQueryVariables>(OrganizationRolesDocument, options);
      }
export function useOrganizationRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRolesQuery, OrganizationRolesQueryVariables>(OrganizationRolesDocument, options);
        }
// @ts-ignore
export function useOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRolesQuery, OrganizationRolesQueryVariables>;
export function useOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRolesQuery | undefined, OrganizationRolesQueryVariables>;
export function useOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRolesQuery, OrganizationRolesQueryVariables>(OrganizationRolesDocument, options);
        }
export type OrganizationRolesQueryHookResult = ReturnType<typeof useOrganizationRolesQuery>;
export type OrganizationRolesLazyQueryHookResult = ReturnType<typeof useOrganizationRolesLazyQuery>;
export type OrganizationRolesSuspenseQueryHookResult = ReturnType<typeof useOrganizationRolesSuspenseQuery>;
export type OrganizationRolesQueryResult = ApolloReactCommon.QueryResult<OrganizationRolesQuery, OrganizationRolesQueryVariables>;
export const OrganizationRolePermissionsDocument = gql`
    query OrganizationRolePermissions($orgName: String!) {
  organization(name: $orgName) {
    id
    roles {
      ID
      name
      description
      inheritedFrom {
        ID
        name
      }
      permissions {
        name
        displayName
        groupName
      }
    }
  }
}
    `;
export type OrganizationRolePermissionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>, 'query'> & ({ variables: OrganizationRolePermissionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationRolePermissionsComponent = (props: OrganizationRolePermissionsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables> query={OrganizationRolePermissionsDocument} {...props} />
    );
    
export type OrganizationRolePermissionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>
    } & TChildProps;
export function withOrganizationRolePermissions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationRolePermissionsQuery,
  OrganizationRolePermissionsQueryVariables,
  OrganizationRolePermissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables, OrganizationRolePermissionsProps<TChildProps, TDataName>>(OrganizationRolePermissionsDocument, {
      alias: 'organizationRolePermissions',
      ...operationOptions
    });
};

/**
 * __useOrganizationRolePermissionsQuery__
 *
 * To run a query within a React component, call `useOrganizationRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRolePermissionsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationRolePermissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables> & ({ variables: OrganizationRolePermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>(OrganizationRolePermissionsDocument, options);
      }
export function useOrganizationRolePermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>(OrganizationRolePermissionsDocument, options);
        }
// @ts-ignore
export function useOrganizationRolePermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>;
export function useOrganizationRolePermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRolePermissionsQuery | undefined, OrganizationRolePermissionsQueryVariables>;
export function useOrganizationRolePermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>(OrganizationRolePermissionsDocument, options);
        }
export type OrganizationRolePermissionsQueryHookResult = ReturnType<typeof useOrganizationRolePermissionsQuery>;
export type OrganizationRolePermissionsLazyQueryHookResult = ReturnType<typeof useOrganizationRolePermissionsLazyQuery>;
export type OrganizationRolePermissionsSuspenseQueryHookResult = ReturnType<typeof useOrganizationRolePermissionsSuspenseQuery>;
export type OrganizationRolePermissionsQueryResult = ApolloReactCommon.QueryResult<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>;
export const CreateRoleDocument = gql`
    mutation createRole($name: String!, $description: String, $inheritedFrom: String!, $permissions: [String!]!, $organizationID: ID!) {
  createRole(
    input: {name: $name, description: $description, inheritedFrom: $inheritedFrom, permissions: $permissions, organizationID: $organizationID}
  ) {
    success
  }
}
    `;
export type CreateRoleMutationFn = ApolloReactCommon.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;
export type CreateRoleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateRoleMutation, CreateRoleMutationVariables>, 'mutation'>;

    export const CreateRoleComponent = (props: CreateRoleComponentProps) => (
      <ApolloReactComponents.Mutation<CreateRoleMutation, CreateRoleMutationVariables> mutation={CreateRoleDocument} {...props} />
    );
    
export type CreateRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>
    } & TChildProps;
export function withCreateRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateRoleMutation,
  CreateRoleMutationVariables,
  CreateRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateRoleMutation, CreateRoleMutationVariables, CreateRoleProps<TChildProps, TDataName>>(CreateRoleDocument, {
      alias: 'createRole',
      ...operationOptions
    });
};

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      inheritedFrom: // value for 'inheritedFrom'
 *      permissions: // value for 'permissions'
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = ApolloReactCommon.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation updateRole($roleID: ID!, $name: String, $description: String, $inheritedFrom: String) {
  updateRole(
    input: {roleID: $roleID, name: $name, description: $description, inheritedFrom: $inheritedFrom}
  ) {
    success
  }
}
    `;
export type UpdateRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;
export type UpdateRoleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateRoleMutation, UpdateRoleMutationVariables>, 'mutation'>;

    export const UpdateRoleComponent = (props: UpdateRoleComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateRoleMutation, UpdateRoleMutationVariables> mutation={UpdateRoleDocument} {...props} />
    );
    
export type UpdateRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>
    } & TChildProps;
export function withUpdateRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateRoleMutation,
  UpdateRoleMutationVariables,
  UpdateRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateRoleMutation, UpdateRoleMutationVariables, UpdateRoleProps<TChildProps, TDataName>>(UpdateRoleDocument, {
      alias: 'updateRole',
      ...operationOptions
    });
};

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      inheritedFrom: // value for 'inheritedFrom'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = ApolloReactCommon.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($roleID: ID!) {
  deleteRole(input: {roleID: $roleID}) {
    success
  }
}
    `;
export type DeleteRoleMutationFn = ApolloReactCommon.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;
export type DeleteRoleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteRoleMutation, DeleteRoleMutationVariables>, 'mutation'>;

    export const DeleteRoleComponent = (props: DeleteRoleComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteRoleMutation, DeleteRoleMutationVariables> mutation={DeleteRoleDocument} {...props} />
    );
    
export type DeleteRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>
    } & TChildProps;
export function withDeleteRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteRoleMutation,
  DeleteRoleMutationVariables,
  DeleteRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteRoleMutation, DeleteRoleMutationVariables, DeleteRoleProps<TChildProps, TDataName>>(DeleteRoleDocument, {
      alias: 'deleteRole',
      ...operationOptions
    });
};

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = ApolloReactCommon.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const AddRolePermissionsDocument = gql`
    mutation addRolePermissions($roleID: ID!, $permissions: [String!]!) {
  addRolePermissions(input: {roleID: $roleID, permissions: $permissions}) {
    success
  }
}
    `;
export type AddRolePermissionsMutationFn = ApolloReactCommon.MutationFunction<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>;
export type AddRolePermissionsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>, 'mutation'>;

    export const AddRolePermissionsComponent = (props: AddRolePermissionsComponentProps) => (
      <ApolloReactComponents.Mutation<AddRolePermissionsMutation, AddRolePermissionsMutationVariables> mutation={AddRolePermissionsDocument} {...props} />
    );
    
export type AddRolePermissionsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>
    } & TChildProps;
export function withAddRolePermissions<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddRolePermissionsMutation,
  AddRolePermissionsMutationVariables,
  AddRolePermissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddRolePermissionsMutation, AddRolePermissionsMutationVariables, AddRolePermissionsProps<TChildProps, TDataName>>(AddRolePermissionsDocument, {
      alias: 'addRolePermissions',
      ...operationOptions
    });
};

/**
 * __useAddRolePermissionsMutation__
 *
 * To run a mutation, you first call `useAddRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRolePermissionsMutation, { data, loading, error }] = useAddRolePermissionsMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useAddRolePermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>(AddRolePermissionsDocument, options);
      }
export type AddRolePermissionsMutationHookResult = ReturnType<typeof useAddRolePermissionsMutation>;
export type AddRolePermissionsMutationResult = ApolloReactCommon.MutationResult<AddRolePermissionsMutation>;
export type AddRolePermissionsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>;
export const DeleteRolePermissionsDocument = gql`
    mutation deleteRolePermissions($roleID: ID!, $permissions: [String!]!) {
  deleteRolePermissions(input: {roleID: $roleID, permissions: $permissions}) {
    success
  }
}
    `;
export type DeleteRolePermissionsMutationFn = ApolloReactCommon.MutationFunction<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>;
export type DeleteRolePermissionsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>, 'mutation'>;

    export const DeleteRolePermissionsComponent = (props: DeleteRolePermissionsComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables> mutation={DeleteRolePermissionsDocument} {...props} />
    );
    
export type DeleteRolePermissionsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>
    } & TChildProps;
export function withDeleteRolePermissions<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteRolePermissionsMutation,
  DeleteRolePermissionsMutationVariables,
  DeleteRolePermissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables, DeleteRolePermissionsProps<TChildProps, TDataName>>(DeleteRolePermissionsDocument, {
      alias: 'deleteRolePermissions',
      ...operationOptions
    });
};

/**
 * __useDeleteRolePermissionsMutation__
 *
 * To run a mutation, you first call `useDeleteRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRolePermissionsMutation, { data, loading, error }] = useDeleteRolePermissionsMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useDeleteRolePermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>(DeleteRolePermissionsDocument, options);
      }
export type DeleteRolePermissionsMutationHookResult = ReturnType<typeof useDeleteRolePermissionsMutation>;
export type DeleteRolePermissionsMutationResult = ApolloReactCommon.MutationResult<DeleteRolePermissionsMutation>;
export type DeleteRolePermissionsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>;
export const EntityMemberRoleDocument = gql`
    query EntityMemberRole($entityName: String!, $memberId: ID!) {
  entity(name: $entityName) {
    id
    member(id: $memberId) {
      id
      role
      memberRole {
        ID
        name
        inheritedFrom {
          permissions {
            name
            groupName
            displayName
          }
        }
        permissions {
          name
          groupName
          displayName
        }
      }
    }
  }
}
    `;
export type EntityMemberRoleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>, 'query'> & ({ variables: EntityMemberRoleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityMemberRoleComponent = (props: EntityMemberRoleComponentProps) => (
      <ApolloReactComponents.Query<EntityMemberRoleQuery, EntityMemberRoleQueryVariables> query={EntityMemberRoleDocument} {...props} />
    );
    
export type EntityMemberRoleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>
    } & TChildProps;
export function withEntityMemberRole<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityMemberRoleQuery,
  EntityMemberRoleQueryVariables,
  EntityMemberRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityMemberRoleQuery, EntityMemberRoleQueryVariables, EntityMemberRoleProps<TChildProps, TDataName>>(EntityMemberRoleDocument, {
      alias: 'entityMemberRole',
      ...operationOptions
    });
};

/**
 * __useEntityMemberRoleQuery__
 *
 * To run a query within a React component, call `useEntityMemberRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityMemberRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityMemberRoleQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useEntityMemberRoleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables> & ({ variables: EntityMemberRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>(EntityMemberRoleDocument, options);
      }
export function useEntityMemberRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>(EntityMemberRoleDocument, options);
        }
// @ts-ignore
export function useEntityMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>;
export function useEntityMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityMemberRoleQuery | undefined, EntityMemberRoleQueryVariables>;
export function useEntityMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>(EntityMemberRoleDocument, options);
        }
export type EntityMemberRoleQueryHookResult = ReturnType<typeof useEntityMemberRoleQuery>;
export type EntityMemberRoleLazyQueryHookResult = ReturnType<typeof useEntityMemberRoleLazyQuery>;
export type EntityMemberRoleSuspenseQueryHookResult = ReturnType<typeof useEntityMemberRoleSuspenseQuery>;
export type EntityMemberRoleQueryResult = ApolloReactCommon.QueryResult<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>;
export const RunDocument = gql`
    query Run($projectName: String!, $entityName: String, $runName: String!, $enableArtifactCounts: Boolean = false) {
  project(name: $projectName, entityName: $entityName) {
    id
    internalId
    name
    readOnly
    createdAt
    access
    views
    entityName
    tags {
      id
      name
      colorIndex
    }
    isBenchmark
    linkedBenchmark {
      id
      entityName
      name
      gitHubSubmissionRepo
      views
    }
    run(name: $runName) {
      id
      name
      displayName
      notes
      config
      summaryMetrics
      historyKeys(format: PLAINTEXT)
      github
      fileCount
      createdAt
      heartbeatAt
      computeSeconds
      commit
      jobType
      group
      tags: tagColors {
        id
        name
        colorIndex
      }
      host
      state
      stopped
      sweep {
        id
        name
        displayName
      }
      runInfo {
        program
        args
        os
        python
        colab
        executable
        codeSaved
        cpuCount
        cpuCountLogical
        gpuCount
        gpu
        git {
          remote
          commit
        }
      }
      diffPatchFile: files(first: 1, names: ["diff.patch"]) {
        edges {
          node {
            id
            name
            md5
            sizeBytes
          }
        }
      }
      ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
      logLineCount
      outputLogFile: files(first: 1, names: ["output.log"]) {
        edges {
          node {
            id
            name
            md5
            sizeBytes
            directUrl
            url(upload: false)
          }
        }
      }
      benchmarkRun {
        id
        benchmark {
          id
          name
          entityName
          readOnly
          views
        }
        details
        results
        gitHubSubmissionPR
        run {
          id
          name
          github
          user {
            id
            username
          }
          summaryMetrics
        }
        originalProject {
          id
          name
          entityName
        }
        originalRun {
          id
          name
        }
        isCodeHidden
        state
      }
      user {
        id
        username
        name
        photoUrl
        accountType
      }
      servicesAvailable {
        tensorboard
      }
      branchPoint {
        run {
          id
          name
          project {
            id
            name
            entity {
              id
              name
            }
          }
        }
        step
      }
      internalID
    }
    entity {
      id
      name
      defaultAccess
      readOnlyAdmin
      privateOnly
      isTeam
      user {
        id
        username
        accountType
      }
      claimingEntity {
        id
        name
      }
      codeSavingEnabled
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}`;
export type RunComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunQuery, RunQueryVariables>, 'query'> & ({ variables: RunQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunComponent = (props: RunComponentProps) => (
      <ApolloReactComponents.Query<RunQuery, RunQueryVariables> query={RunDocument} {...props} />
    );
    
export type RunProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunQuery, RunQueryVariables>
    } & TChildProps;
export function withRun<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunQuery,
  RunQueryVariables,
  RunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunQuery, RunQueryVariables, RunProps<TChildProps, TDataName>>(RunDocument, {
      alias: 'run',
      ...operationOptions
    });
};

/**
 * __useRunQuery__
 *
 * To run a query within a React component, call `useRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *   },
 * });
 */
export function useRunQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunQuery, RunQueryVariables> & ({ variables: RunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunQuery, RunQueryVariables>(RunDocument, options);
      }
export function useRunLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunQuery, RunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunQuery, RunQueryVariables>(RunDocument, options);
        }
// @ts-ignore
export function useRunSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunQuery, RunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunQuery, RunQueryVariables>;
export function useRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunQuery, RunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunQuery | undefined, RunQueryVariables>;
export function useRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunQuery, RunQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunQuery, RunQueryVariables>(RunDocument, options);
        }
export type RunQueryHookResult = ReturnType<typeof useRunQuery>;
export type RunLazyQueryHookResult = ReturnType<typeof useRunLazyQuery>;
export type RunSuspenseQueryHookResult = ReturnType<typeof useRunSuspenseQuery>;
export type RunQueryResult = ApolloReactCommon.QueryResult<RunQuery, RunQueryVariables>;
export const CreateRunQueueDocument = gql`
    mutation createRunQueue($entityName: String!, $projectName: String!, $queueName: String!, $access: RunQueueAccessType!, $defaultResourceConfigID: ID, $prioritizationMode: RunQueuePrioritizationMode!) {
  createRunQueue(
    input: {entityName: $entityName, projectName: $projectName, queueName: $queueName, access: $access, defaultResourceConfigID: $defaultResourceConfigID, prioritizationMode: $prioritizationMode}
  ) {
    success
    queueID
  }
}
    `;
export type CreateRunQueueMutationFn = ApolloReactCommon.MutationFunction<CreateRunQueueMutation, CreateRunQueueMutationVariables>;
export type CreateRunQueueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateRunQueueMutation, CreateRunQueueMutationVariables>, 'mutation'>;

    export const CreateRunQueueComponent = (props: CreateRunQueueComponentProps) => (
      <ApolloReactComponents.Mutation<CreateRunQueueMutation, CreateRunQueueMutationVariables> mutation={CreateRunQueueDocument} {...props} />
    );
    
export type CreateRunQueueProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateRunQueueMutation, CreateRunQueueMutationVariables>
    } & TChildProps;
export function withCreateRunQueue<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateRunQueueMutation,
  CreateRunQueueMutationVariables,
  CreateRunQueueProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateRunQueueMutation, CreateRunQueueMutationVariables, CreateRunQueueProps<TChildProps, TDataName>>(CreateRunQueueDocument, {
      alias: 'createRunQueue',
      ...operationOptions
    });
};

/**
 * __useCreateRunQueueMutation__
 *
 * To run a mutation, you first call `useCreateRunQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRunQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRunQueueMutation, { data, loading, error }] = useCreateRunQueueMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      queueName: // value for 'queueName'
 *      access: // value for 'access'
 *      defaultResourceConfigID: // value for 'defaultResourceConfigID'
 *      prioritizationMode: // value for 'prioritizationMode'
 *   },
 * });
 */
export function useCreateRunQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRunQueueMutation, CreateRunQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRunQueueMutation, CreateRunQueueMutationVariables>(CreateRunQueueDocument, options);
      }
export type CreateRunQueueMutationHookResult = ReturnType<typeof useCreateRunQueueMutation>;
export type CreateRunQueueMutationResult = ApolloReactCommon.MutationResult<CreateRunQueueMutation>;
export type CreateRunQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRunQueueMutation, CreateRunQueueMutationVariables>;
export const UpdateRunQueueDocument = gql`
    mutation updateRunQueue($queueID: ID!, $defaultResourceConfigID: ID, $externalLinks: JSONString) {
  updateRunQueue(
    input: {queueID: $queueID, defaultResourceConfigID: $defaultResourceConfigID, externalLinks: $externalLinks}
  ) {
    success
  }
}
    `;
export type UpdateRunQueueMutationFn = ApolloReactCommon.MutationFunction<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>;
export type UpdateRunQueueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>, 'mutation'>;

    export const UpdateRunQueueComponent = (props: UpdateRunQueueComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateRunQueueMutation, UpdateRunQueueMutationVariables> mutation={UpdateRunQueueDocument} {...props} />
    );
    
export type UpdateRunQueueProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>
    } & TChildProps;
export function withUpdateRunQueue<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateRunQueueMutation,
  UpdateRunQueueMutationVariables,
  UpdateRunQueueProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateRunQueueMutation, UpdateRunQueueMutationVariables, UpdateRunQueueProps<TChildProps, TDataName>>(UpdateRunQueueDocument, {
      alias: 'updateRunQueue',
      ...operationOptions
    });
};

/**
 * __useUpdateRunQueueMutation__
 *
 * To run a mutation, you first call `useUpdateRunQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRunQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRunQueueMutation, { data, loading, error }] = useUpdateRunQueueMutation({
 *   variables: {
 *      queueID: // value for 'queueID'
 *      defaultResourceConfigID: // value for 'defaultResourceConfigID'
 *      externalLinks: // value for 'externalLinks'
 *   },
 * });
 */
export function useUpdateRunQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>(UpdateRunQueueDocument, options);
      }
export type UpdateRunQueueMutationHookResult = ReturnType<typeof useUpdateRunQueueMutation>;
export type UpdateRunQueueMutationResult = ApolloReactCommon.MutationResult<UpdateRunQueueMutation>;
export type UpdateRunQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>;
export const EnableRunQueuePrioritizationDocument = gql`
    mutation enableRunQueuePrioritization($queueID: ID!) {
  updateRunQueue(input: {queueID: $queueID, prioritizationMode: V0}) {
    success
  }
}
    `;
export type EnableRunQueuePrioritizationMutationFn = ApolloReactCommon.MutationFunction<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>;
export type EnableRunQueuePrioritizationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>, 'mutation'>;

    export const EnableRunQueuePrioritizationComponent = (props: EnableRunQueuePrioritizationComponentProps) => (
      <ApolloReactComponents.Mutation<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables> mutation={EnableRunQueuePrioritizationDocument} {...props} />
    );
    
export type EnableRunQueuePrioritizationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>
    } & TChildProps;
export function withEnableRunQueuePrioritization<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EnableRunQueuePrioritizationMutation,
  EnableRunQueuePrioritizationMutationVariables,
  EnableRunQueuePrioritizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables, EnableRunQueuePrioritizationProps<TChildProps, TDataName>>(EnableRunQueuePrioritizationDocument, {
      alias: 'enableRunQueuePrioritization',
      ...operationOptions
    });
};

/**
 * __useEnableRunQueuePrioritizationMutation__
 *
 * To run a mutation, you first call `useEnableRunQueuePrioritizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableRunQueuePrioritizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableRunQueuePrioritizationMutation, { data, loading, error }] = useEnableRunQueuePrioritizationMutation({
 *   variables: {
 *      queueID: // value for 'queueID'
 *   },
 * });
 */
export function useEnableRunQueuePrioritizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>(EnableRunQueuePrioritizationDocument, options);
      }
export type EnableRunQueuePrioritizationMutationHookResult = ReturnType<typeof useEnableRunQueuePrioritizationMutation>;
export type EnableRunQueuePrioritizationMutationResult = ApolloReactCommon.MutationResult<EnableRunQueuePrioritizationMutation>;
export type EnableRunQueuePrioritizationMutationOptions = ApolloReactCommon.BaseMutationOptions<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>;
export const DeleteRunQueuesDocument = gql`
    mutation deleteRunQueues($queueIDs: [ID!]!) {
  deleteRunQueues(input: {queueIDs: $queueIDs}) {
    success
  }
}
    `;
export type DeleteRunQueuesMutationFn = ApolloReactCommon.MutationFunction<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>;
export type DeleteRunQueuesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>, 'mutation'>;

    export const DeleteRunQueuesComponent = (props: DeleteRunQueuesComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables> mutation={DeleteRunQueuesDocument} {...props} />
    );
    
export type DeleteRunQueuesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>
    } & TChildProps;
export function withDeleteRunQueues<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteRunQueuesMutation,
  DeleteRunQueuesMutationVariables,
  DeleteRunQueuesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables, DeleteRunQueuesProps<TChildProps, TDataName>>(DeleteRunQueuesDocument, {
      alias: 'deleteRunQueues',
      ...operationOptions
    });
};

/**
 * __useDeleteRunQueuesMutation__
 *
 * To run a mutation, you first call `useDeleteRunQueuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRunQueuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRunQueuesMutation, { data, loading, error }] = useDeleteRunQueuesMutation({
 *   variables: {
 *      queueIDs: // value for 'queueIDs'
 *   },
 * });
 */
export function useDeleteRunQueuesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>(DeleteRunQueuesDocument, options);
      }
export type DeleteRunQueuesMutationHookResult = ReturnType<typeof useDeleteRunQueuesMutation>;
export type DeleteRunQueuesMutationResult = ApolloReactCommon.MutationResult<DeleteRunQueuesMutation>;
export type DeleteRunQueuesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>;
export const PushToRunQueueDocument = gql`
    mutation pushToRunQueue($queueID: ID!, $runSpec: JSONString!, $priority: Int, $templateVariableValues: JSONString) {
  pushToRunQueue(
    input: {queueID: $queueID, runSpec: $runSpec, priority: $priority, templateVariableValues: $templateVariableValues}
  ) {
    runQueueItemId
  }
}
    `;
export type PushToRunQueueMutationFn = ApolloReactCommon.MutationFunction<PushToRunQueueMutation, PushToRunQueueMutationVariables>;
export type PushToRunQueueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PushToRunQueueMutation, PushToRunQueueMutationVariables>, 'mutation'>;

    export const PushToRunQueueComponent = (props: PushToRunQueueComponentProps) => (
      <ApolloReactComponents.Mutation<PushToRunQueueMutation, PushToRunQueueMutationVariables> mutation={PushToRunQueueDocument} {...props} />
    );
    
export type PushToRunQueueProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<PushToRunQueueMutation, PushToRunQueueMutationVariables>
    } & TChildProps;
export function withPushToRunQueue<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PushToRunQueueMutation,
  PushToRunQueueMutationVariables,
  PushToRunQueueProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, PushToRunQueueMutation, PushToRunQueueMutationVariables, PushToRunQueueProps<TChildProps, TDataName>>(PushToRunQueueDocument, {
      alias: 'pushToRunQueue',
      ...operationOptions
    });
};

/**
 * __usePushToRunQueueMutation__
 *
 * To run a mutation, you first call `usePushToRunQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToRunQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToRunQueueMutation, { data, loading, error }] = usePushToRunQueueMutation({
 *   variables: {
 *      queueID: // value for 'queueID'
 *      runSpec: // value for 'runSpec'
 *      priority: // value for 'priority'
 *      templateVariableValues: // value for 'templateVariableValues'
 *   },
 * });
 */
export function usePushToRunQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PushToRunQueueMutation, PushToRunQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PushToRunQueueMutation, PushToRunQueueMutationVariables>(PushToRunQueueDocument, options);
      }
export type PushToRunQueueMutationHookResult = ReturnType<typeof usePushToRunQueueMutation>;
export type PushToRunQueueMutationResult = ApolloReactCommon.MutationResult<PushToRunQueueMutation>;
export type PushToRunQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<PushToRunQueueMutation, PushToRunQueueMutationVariables>;
export const DeleteFromRunQueueDocument = gql`
    mutation deleteFromRunQueue($queueID: ID!, $runQueueItemId: ID!) {
  deleteFromRunQueue(input: {queueID: $queueID, runQueueItemId: $runQueueItemId}) {
    success
  }
}
    `;
export type DeleteFromRunQueueMutationFn = ApolloReactCommon.MutationFunction<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>;
export type DeleteFromRunQueueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>, 'mutation'>;

    export const DeleteFromRunQueueComponent = (props: DeleteFromRunQueueComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables> mutation={DeleteFromRunQueueDocument} {...props} />
    );
    
export type DeleteFromRunQueueProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>
    } & TChildProps;
export function withDeleteFromRunQueue<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteFromRunQueueMutation,
  DeleteFromRunQueueMutationVariables,
  DeleteFromRunQueueProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables, DeleteFromRunQueueProps<TChildProps, TDataName>>(DeleteFromRunQueueDocument, {
      alias: 'deleteFromRunQueue',
      ...operationOptions
    });
};

/**
 * __useDeleteFromRunQueueMutation__
 *
 * To run a mutation, you first call `useDeleteFromRunQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromRunQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromRunQueueMutation, { data, loading, error }] = useDeleteFromRunQueueMutation({
 *   variables: {
 *      queueID: // value for 'queueID'
 *      runQueueItemId: // value for 'runQueueItemId'
 *   },
 * });
 */
export function useDeleteFromRunQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>(DeleteFromRunQueueDocument, options);
      }
export type DeleteFromRunQueueMutationHookResult = ReturnType<typeof useDeleteFromRunQueueMutation>;
export type DeleteFromRunQueueMutationResult = ApolloReactCommon.MutationResult<DeleteFromRunQueueMutation>;
export type DeleteFromRunQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>;
export const FetchRunQueuesFromProjectDocument = gql`
    query fetchRunQueuesFromProject($entityName: String!, $projectName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runQueues {
      id
      createdAt
      createdBy
      access
      updatedAt
      name
      defaultResourceConfigID
      executorInfo
      runQueueItems {
        edges {
          node {
            id
            ...RunQueueItemFragment
          }
        }
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;
export type FetchRunQueuesFromProjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>, 'query'> & ({ variables: FetchRunQueuesFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRunQueuesFromProjectComponent = (props: FetchRunQueuesFromProjectComponentProps) => (
      <ApolloReactComponents.Query<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables> query={FetchRunQueuesFromProjectDocument} {...props} />
    );
    
export type FetchRunQueuesFromProjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>
    } & TChildProps;
export function withFetchRunQueuesFromProject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRunQueuesFromProjectQuery,
  FetchRunQueuesFromProjectQueryVariables,
  FetchRunQueuesFromProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables, FetchRunQueuesFromProjectProps<TChildProps, TDataName>>(FetchRunQueuesFromProjectDocument, {
      alias: 'fetchRunQueuesFromProject',
      ...operationOptions
    });
};

/**
 * __useFetchRunQueuesFromProjectQuery__
 *
 * To run a query within a React component, call `useFetchRunQueuesFromProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunQueuesFromProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunQueuesFromProjectQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchRunQueuesFromProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables> & ({ variables: FetchRunQueuesFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>(FetchRunQueuesFromProjectDocument, options);
      }
export function useFetchRunQueuesFromProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>(FetchRunQueuesFromProjectDocument, options);
        }
// @ts-ignore
export function useFetchRunQueuesFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>;
export function useFetchRunQueuesFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueuesFromProjectQuery | undefined, FetchRunQueuesFromProjectQueryVariables>;
export function useFetchRunQueuesFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>(FetchRunQueuesFromProjectDocument, options);
        }
export type FetchRunQueuesFromProjectQueryHookResult = ReturnType<typeof useFetchRunQueuesFromProjectQuery>;
export type FetchRunQueuesFromProjectLazyQueryHookResult = ReturnType<typeof useFetchRunQueuesFromProjectLazyQuery>;
export type FetchRunQueuesFromProjectSuspenseQueryHookResult = ReturnType<typeof useFetchRunQueuesFromProjectSuspenseQuery>;
export type FetchRunQueuesFromProjectQueryResult = ApolloReactCommon.QueryResult<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>;
export const FetchRunQueueByNameDocument = gql`
    query FetchRunQueueByName($entityName: String!, $projectName: String!, $runQueueName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runQueue(name: $runQueueName) {
      id
      createdAt
      createdBy
      access
      updatedAt
      name
      defaultResourceConfigID
      executorInfo
      runQueueItems {
        edges {
          node {
            id
            ...RunQueueItemFragment
          }
        }
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;
export type FetchRunQueueByNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>, 'query'> & ({ variables: FetchRunQueueByNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRunQueueByNameComponent = (props: FetchRunQueueByNameComponentProps) => (
      <ApolloReactComponents.Query<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables> query={FetchRunQueueByNameDocument} {...props} />
    );
    
export type FetchRunQueueByNameProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>
    } & TChildProps;
export function withFetchRunQueueByName<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRunQueueByNameQuery,
  FetchRunQueueByNameQueryVariables,
  FetchRunQueueByNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables, FetchRunQueueByNameProps<TChildProps, TDataName>>(FetchRunQueueByNameDocument, {
      alias: 'fetchRunQueueByName',
      ...operationOptions
    });
};

/**
 * __useFetchRunQueueByNameQuery__
 *
 * To run a query within a React component, call `useFetchRunQueueByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunQueueByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunQueueByNameQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runQueueName: // value for 'runQueueName'
 *   },
 * });
 */
export function useFetchRunQueueByNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables> & ({ variables: FetchRunQueueByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>(FetchRunQueueByNameDocument, options);
      }
export function useFetchRunQueueByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>(FetchRunQueueByNameDocument, options);
        }
// @ts-ignore
export function useFetchRunQueueByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>;
export function useFetchRunQueueByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueueByNameQuery | undefined, FetchRunQueueByNameQueryVariables>;
export function useFetchRunQueueByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>(FetchRunQueueByNameDocument, options);
        }
export type FetchRunQueueByNameQueryHookResult = ReturnType<typeof useFetchRunQueueByNameQuery>;
export type FetchRunQueueByNameLazyQueryHookResult = ReturnType<typeof useFetchRunQueueByNameLazyQuery>;
export type FetchRunQueueByNameSuspenseQueryHookResult = ReturnType<typeof useFetchRunQueueByNameSuspenseQuery>;
export type FetchRunQueueByNameQueryResult = ApolloReactCommon.QueryResult<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>;
export const FetchRunQueueItemFromProjectDocument = gql`
    query FetchRunQueueItemFromProject($entityName: String!, $projectName: String!, $runQueueName: String!, $runQueueItemID: ID!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runQueue(name: $runQueueName) {
      id
      runQueueItem(id: $runQueueItemID) {
        id
        ...RunQueueItemFragment
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;
export type FetchRunQueueItemFromProjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>, 'query'> & ({ variables: FetchRunQueueItemFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRunQueueItemFromProjectComponent = (props: FetchRunQueueItemFromProjectComponentProps) => (
      <ApolloReactComponents.Query<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables> query={FetchRunQueueItemFromProjectDocument} {...props} />
    );
    
export type FetchRunQueueItemFromProjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>
    } & TChildProps;
export function withFetchRunQueueItemFromProject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRunQueueItemFromProjectQuery,
  FetchRunQueueItemFromProjectQueryVariables,
  FetchRunQueueItemFromProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables, FetchRunQueueItemFromProjectProps<TChildProps, TDataName>>(FetchRunQueueItemFromProjectDocument, {
      alias: 'fetchRunQueueItemFromProject',
      ...operationOptions
    });
};

/**
 * __useFetchRunQueueItemFromProjectQuery__
 *
 * To run a query within a React component, call `useFetchRunQueueItemFromProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunQueueItemFromProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunQueueItemFromProjectQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runQueueName: // value for 'runQueueName'
 *      runQueueItemID: // value for 'runQueueItemID'
 *   },
 * });
 */
export function useFetchRunQueueItemFromProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables> & ({ variables: FetchRunQueueItemFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>(FetchRunQueueItemFromProjectDocument, options);
      }
export function useFetchRunQueueItemFromProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>(FetchRunQueueItemFromProjectDocument, options);
        }
// @ts-ignore
export function useFetchRunQueueItemFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>;
export function useFetchRunQueueItemFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueueItemFromProjectQuery | undefined, FetchRunQueueItemFromProjectQueryVariables>;
export function useFetchRunQueueItemFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>(FetchRunQueueItemFromProjectDocument, options);
        }
export type FetchRunQueueItemFromProjectQueryHookResult = ReturnType<typeof useFetchRunQueueItemFromProjectQuery>;
export type FetchRunQueueItemFromProjectLazyQueryHookResult = ReturnType<typeof useFetchRunQueueItemFromProjectLazyQuery>;
export type FetchRunQueueItemFromProjectSuspenseQueryHookResult = ReturnType<typeof useFetchRunQueueItemFromProjectSuspenseQuery>;
export type FetchRunQueueItemFromProjectQueryResult = ApolloReactCommon.QueryResult<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>;
export const TeamInfoDocument = gql`
    query TeamInfo($entityName: String!) {
  entity(name: $entityName) {
    id
    members {
      id
      username
      name
      admin
    }
  }
}
    `;
export type TeamInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamInfoQuery, TeamInfoQueryVariables>, 'query'> & ({ variables: TeamInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamInfoComponent = (props: TeamInfoComponentProps) => (
      <ApolloReactComponents.Query<TeamInfoQuery, TeamInfoQueryVariables> query={TeamInfoDocument} {...props} />
    );
    
export type TeamInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamInfoQuery, TeamInfoQueryVariables>
    } & TChildProps;
export function withTeamInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamInfoQuery,
  TeamInfoQueryVariables,
  TeamInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamInfoQuery, TeamInfoQueryVariables, TeamInfoProps<TChildProps, TDataName>>(TeamInfoDocument, {
      alias: 'teamInfo',
      ...operationOptions
    });
};

/**
 * __useTeamInfoQuery__
 *
 * To run a query within a React component, call `useTeamInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamInfoQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables> & ({ variables: TeamInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamInfoQuery, TeamInfoQueryVariables>(TeamInfoDocument, options);
      }
export function useTeamInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamInfoQuery, TeamInfoQueryVariables>(TeamInfoDocument, options);
        }
// @ts-ignore
export function useTeamInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamInfoQuery, TeamInfoQueryVariables>;
export function useTeamInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamInfoQuery | undefined, TeamInfoQueryVariables>;
export function useTeamInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamInfoQuery, TeamInfoQueryVariables>(TeamInfoDocument, options);
        }
export type TeamInfoQueryHookResult = ReturnType<typeof useTeamInfoQuery>;
export type TeamInfoLazyQueryHookResult = ReturnType<typeof useTeamInfoLazyQuery>;
export type TeamInfoSuspenseQueryHookResult = ReturnType<typeof useTeamInfoSuspenseQuery>;
export type TeamInfoQueryResult = ApolloReactCommon.QueryResult<TeamInfoQuery, TeamInfoQueryVariables>;
export const RunDisplayNameDocument = gql`
    query RunDisplayName($entityName: String!, $projectName: String!, $runName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      displayName
    }
  }
}
    `;
export type RunDisplayNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>, 'query'> & ({ variables: RunDisplayNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunDisplayNameComponent = (props: RunDisplayNameComponentProps) => (
      <ApolloReactComponents.Query<RunDisplayNameQuery, RunDisplayNameQueryVariables> query={RunDisplayNameDocument} {...props} />
    );
    
export type RunDisplayNameProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunDisplayNameQuery, RunDisplayNameQueryVariables>
    } & TChildProps;
export function withRunDisplayName<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunDisplayNameQuery,
  RunDisplayNameQueryVariables,
  RunDisplayNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunDisplayNameQuery, RunDisplayNameQueryVariables, RunDisplayNameProps<TChildProps, TDataName>>(RunDisplayNameDocument, {
      alias: 'runDisplayName',
      ...operationOptions
    });
};

/**
 * __useRunDisplayNameQuery__
 *
 * To run a query within a React component, call `useRunDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunDisplayNameQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunDisplayNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables> & ({ variables: RunDisplayNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunDisplayNameQuery, RunDisplayNameQueryVariables>(RunDisplayNameDocument, options);
      }
export function useRunDisplayNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunDisplayNameQuery, RunDisplayNameQueryVariables>(RunDisplayNameDocument, options);
        }
// @ts-ignore
export function useRunDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunDisplayNameQuery, RunDisplayNameQueryVariables>;
export function useRunDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunDisplayNameQuery | undefined, RunDisplayNameQueryVariables>;
export function useRunDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunDisplayNameQuery, RunDisplayNameQueryVariables>(RunDisplayNameDocument, options);
        }
export type RunDisplayNameQueryHookResult = ReturnType<typeof useRunDisplayNameQuery>;
export type RunDisplayNameLazyQueryHookResult = ReturnType<typeof useRunDisplayNameLazyQuery>;
export type RunDisplayNameSuspenseQueryHookResult = ReturnType<typeof useRunDisplayNameSuspenseQuery>;
export type RunDisplayNameQueryResult = ApolloReactCommon.QueryResult<RunDisplayNameQuery, RunDisplayNameQueryVariables>;
export const RunsStateDocument = gql`
    query RunsState($projectName: String!, $entityName: String, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters) {
      edges {
        node {
          id
          name
          displayName
          state
        }
      }
    }
  }
}
    `;
export type RunsStateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsStateQuery, RunsStateQueryVariables>, 'query'> & ({ variables: RunsStateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsStateComponent = (props: RunsStateComponentProps) => (
      <ApolloReactComponents.Query<RunsStateQuery, RunsStateQueryVariables> query={RunsStateDocument} {...props} />
    );
    
export type RunsStateProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsStateQuery, RunsStateQueryVariables>
    } & TChildProps;
export function withRunsState<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsStateQuery,
  RunsStateQueryVariables,
  RunsStateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsStateQuery, RunsStateQueryVariables, RunsStateProps<TChildProps, TDataName>>(RunsStateDocument, {
      alias: 'runsState',
      ...operationOptions
    });
};

/**
 * __useRunsStateQuery__
 *
 * To run a query within a React component, call `useRunsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunsStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateQuery, RunsStateQueryVariables> & ({ variables: RunsStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateQuery, RunsStateQueryVariables>(RunsStateDocument, options);
      }
export function useRunsStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateQuery, RunsStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateQuery, RunsStateQueryVariables>(RunsStateDocument, options);
        }
// @ts-ignore
export function useRunsStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQuery, RunsStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQuery, RunsStateQueryVariables>;
export function useRunsStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQuery, RunsStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQuery | undefined, RunsStateQueryVariables>;
export function useRunsStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQuery, RunsStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateQuery, RunsStateQueryVariables>(RunsStateDocument, options);
        }
export type RunsStateQueryHookResult = ReturnType<typeof useRunsStateQuery>;
export type RunsStateLazyQueryHookResult = ReturnType<typeof useRunsStateLazyQuery>;
export type RunsStateSuspenseQueryHookResult = ReturnType<typeof useRunsStateSuspenseQuery>;
export type RunsStateQueryResult = ApolloReactCommon.QueryResult<RunsStateQuery, RunsStateQueryVariables>;
export const RunTensorboardDocument = gql`
    query RunTensorboard($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      servicesAvailable {
        tensorboard
      }
    }
  }
}
    `;
export type RunTensorboardComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunTensorboardQuery, RunTensorboardQueryVariables>, 'query'> & ({ variables: RunTensorboardQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunTensorboardComponent = (props: RunTensorboardComponentProps) => (
      <ApolloReactComponents.Query<RunTensorboardQuery, RunTensorboardQueryVariables> query={RunTensorboardDocument} {...props} />
    );
    
export type RunTensorboardProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunTensorboardQuery, RunTensorboardQueryVariables>
    } & TChildProps;
export function withRunTensorboard<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunTensorboardQuery,
  RunTensorboardQueryVariables,
  RunTensorboardProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunTensorboardQuery, RunTensorboardQueryVariables, RunTensorboardProps<TChildProps, TDataName>>(RunTensorboardDocument, {
      alias: 'runTensorboard',
      ...operationOptions
    });
};

/**
 * __useRunTensorboardQuery__
 *
 * To run a query within a React component, call `useRunTensorboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunTensorboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunTensorboardQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunTensorboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables> & ({ variables: RunTensorboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunTensorboardQuery, RunTensorboardQueryVariables>(RunTensorboardDocument, options);
      }
export function useRunTensorboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunTensorboardQuery, RunTensorboardQueryVariables>(RunTensorboardDocument, options);
        }
// @ts-ignore
export function useRunTensorboardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunTensorboardQuery, RunTensorboardQueryVariables>;
export function useRunTensorboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunTensorboardQuery | undefined, RunTensorboardQueryVariables>;
export function useRunTensorboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunTensorboardQuery, RunTensorboardQueryVariables>(RunTensorboardDocument, options);
        }
export type RunTensorboardQueryHookResult = ReturnType<typeof useRunTensorboardQuery>;
export type RunTensorboardLazyQueryHookResult = ReturnType<typeof useRunTensorboardLazyQuery>;
export type RunTensorboardSuspenseQueryHookResult = ReturnType<typeof useRunTensorboardSuspenseQuery>;
export type RunTensorboardQueryResult = ApolloReactCommon.QueryResult<RunTensorboardQuery, RunTensorboardQueryVariables>;
export const RunsModelDocument = gql`
    query RunsModel($cursor: String, $name: String!, $entityName: String, $jobKey: String, $order: String, $filters: JSONString, $limit: Int = 1000, $bucketIds: [String], $requestSubscribe: Boolean!, $selectEnable: Boolean = true, $basicEnable: Boolean = true, $history: Boolean = false, $historyKeyInfo: Boolean = false, $historySamples: Int = 750, $sampledHistory: Boolean = false, $fields: [String], $historyFields: [String], $sampledHistorySpecs: [JSONString!]!, $groupKeys: [String], $groupLevel: Int) {
  project(name: $name, entityName: $entityName) {
    id
    name
    createdAt
    entityName
    description
    summaryMetrics
    views
    requestSubscribe @include(if: $requestSubscribe)
    runCount(filters: $filters)
    runs(
      first: $limit
      after: $cursor
      jobKey: $jobKey
      order: $order
      names: $bucketIds
      filters: $filters
      fields: $fields
      historyFields: $historyFields
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      edges {
        node {
          id
          name
          displayName
          __typename
          ...SelectRunFragment @include(if: $selectEnable)
          ...BasicRunFragment @include(if: $basicEnable)
          ...HistoryRunFragment @include(if: $history)
          ...SampledHistoryRunFragment @include(if: $sampledHistory)
          historyKeys(format: PLAINTEXT) @include(if: $historyKeyInfo)
        }
      }
      pageInfo {
        startCursor
        hasPreviousPage
        endCursor
        hasNextPage
      }
    }
  }
  viewer {
    id
    email
    photoUrl
    admin
  }
  serverInfo {
    pollingOK
  }
}
    ${SelectRunFragmentFragmentDoc}
${BasicRunFragmentFragmentDoc}
${HistoryRunFragmentFragmentDoc}
${SampledHistoryRunFragmentFragmentDoc}`;
export type RunsModelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsModelQuery, RunsModelQueryVariables>, 'query'> & ({ variables: RunsModelQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsModelComponent = (props: RunsModelComponentProps) => (
      <ApolloReactComponents.Query<RunsModelQuery, RunsModelQueryVariables> query={RunsModelDocument} {...props} />
    );
    
export type RunsModelProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsModelQuery, RunsModelQueryVariables>
    } & TChildProps;
export function withRunsModel<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsModelQuery,
  RunsModelQueryVariables,
  RunsModelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsModelQuery, RunsModelQueryVariables, RunsModelProps<TChildProps, TDataName>>(RunsModelDocument, {
      alias: 'runsModel',
      ...operationOptions
    });
};

/**
 * __useRunsModelQuery__
 *
 * To run a query within a React component, call `useRunsModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsModelQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      name: // value for 'name'
 *      entityName: // value for 'entityName'
 *      jobKey: // value for 'jobKey'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      bucketIds: // value for 'bucketIds'
 *      requestSubscribe: // value for 'requestSubscribe'
 *      selectEnable: // value for 'selectEnable'
 *      basicEnable: // value for 'basicEnable'
 *      history: // value for 'history'
 *      historyKeyInfo: // value for 'historyKeyInfo'
 *      historySamples: // value for 'historySamples'
 *      sampledHistory: // value for 'sampledHistory'
 *      fields: // value for 'fields'
 *      historyFields: // value for 'historyFields'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *   },
 * });
 */
export function useRunsModelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsModelQuery, RunsModelQueryVariables> & ({ variables: RunsModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsModelQuery, RunsModelQueryVariables>(RunsModelDocument, options);
      }
export function useRunsModelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsModelQuery, RunsModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsModelQuery, RunsModelQueryVariables>(RunsModelDocument, options);
        }
// @ts-ignore
export function useRunsModelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsModelQuery, RunsModelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsModelQuery, RunsModelQueryVariables>;
export function useRunsModelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsModelQuery, RunsModelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsModelQuery | undefined, RunsModelQueryVariables>;
export function useRunsModelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsModelQuery, RunsModelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsModelQuery, RunsModelQueryVariables>(RunsModelDocument, options);
        }
export type RunsModelQueryHookResult = ReturnType<typeof useRunsModelQuery>;
export type RunsModelLazyQueryHookResult = ReturnType<typeof useRunsModelLazyQuery>;
export type RunsModelSuspenseQueryHookResult = ReturnType<typeof useRunsModelSuspenseQuery>;
export type RunsModelQueryResult = ApolloReactCommon.QueryResult<RunsModelQuery, RunsModelQueryVariables>;
export const UpsertRunDocument = gql`
    mutation upsertRun($id: String, $displayName: String, $notes: String, $tags: [String!]) {
  upsertBucket(
    input: {id: $id, displayName: $displayName, notes: $notes, tags: $tags}
  ) {
    bucket {
      id
      name
      displayName
      notes
      tags: tagColors {
        id
        name
        colorIndex
      }
      project {
        id
        tags {
          id
          name
          colorIndex
        }
      }
    }
    inserted
  }
}
    `;
export type UpsertRunMutationFn = ApolloReactCommon.MutationFunction<UpsertRunMutation, UpsertRunMutationVariables>;
export type UpsertRunComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertRunMutation, UpsertRunMutationVariables>, 'mutation'>;

    export const UpsertRunComponent = (props: UpsertRunComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertRunMutation, UpsertRunMutationVariables> mutation={UpsertRunDocument} {...props} />
    );
    
export type UpsertRunProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertRunMutation, UpsertRunMutationVariables>
    } & TChildProps;
export function withUpsertRun<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertRunMutation,
  UpsertRunMutationVariables,
  UpsertRunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertRunMutation, UpsertRunMutationVariables, UpsertRunProps<TChildProps, TDataName>>(UpsertRunDocument, {
      alias: 'upsertRun',
      ...operationOptions
    });
};

/**
 * __useUpsertRunMutation__
 *
 * To run a mutation, you first call `useUpsertRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRunMutation, { data, loading, error }] = useUpsertRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      notes: // value for 'notes'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpsertRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertRunMutation, UpsertRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertRunMutation, UpsertRunMutationVariables>(UpsertRunDocument, options);
      }
export type UpsertRunMutationHookResult = ReturnType<typeof useUpsertRunMutation>;
export type UpsertRunMutationResult = ApolloReactCommon.MutationResult<UpsertRunMutation>;
export type UpsertRunMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertRunMutation, UpsertRunMutationVariables>;
export const UpsertRunGroupDocument = gql`
    mutation upsertRunGroup($entityName: String!, $projectName: String!, $name: String!, $newName: String, $notes: String, $tags: [String!]) {
  upsertRunGroup(
    input: {projectName: $projectName, entityName: $entityName, name: $name, notes: $notes, newName: $newName, tags: $tags}
  ) {
    group {
      id
      name
      notes
      tags {
        id
        name
        colorIndex
      }
      project {
        id
        tags {
          id
          name
          colorIndex
        }
      }
    }
  }
}
    `;
export type UpsertRunGroupMutationFn = ApolloReactCommon.MutationFunction<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>;
export type UpsertRunGroupComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>, 'mutation'>;

    export const UpsertRunGroupComponent = (props: UpsertRunGroupComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertRunGroupMutation, UpsertRunGroupMutationVariables> mutation={UpsertRunGroupDocument} {...props} />
    );
    
export type UpsertRunGroupProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>
    } & TChildProps;
export function withUpsertRunGroup<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertRunGroupMutation,
  UpsertRunGroupMutationVariables,
  UpsertRunGroupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertRunGroupMutation, UpsertRunGroupMutationVariables, UpsertRunGroupProps<TChildProps, TDataName>>(UpsertRunGroupDocument, {
      alias: 'upsertRunGroup',
      ...operationOptions
    });
};

/**
 * __useUpsertRunGroupMutation__
 *
 * To run a mutation, you first call `useUpsertRunGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRunGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRunGroupMutation, { data, loading, error }] = useUpsertRunGroupMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      name: // value for 'name'
 *      newName: // value for 'newName'
 *      notes: // value for 'notes'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpsertRunGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>(UpsertRunGroupDocument, options);
      }
export type UpsertRunGroupMutationHookResult = ReturnType<typeof useUpsertRunGroupMutation>;
export type UpsertRunGroupMutationResult = ApolloReactCommon.MutationResult<UpsertRunGroupMutation>;
export type UpsertRunGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>;
export const ModifyRunsDocument = gql`
    mutation modifyRuns($filters: JSONString, $entityName: String, $projectName: String, $addTags: [String], $removeTags: [String]) {
  modifyRuns(
    input: {filters: $filters, entityName: $entityName, projectName: $projectName, addTags: $addTags, removeTags: $removeTags}
  ) {
    runsSQL {
      id
      name
      __typename
      ...SelectRunFragment
      ...BasicRunFragment
      user {
        id
        username
        photoUrl
      }
    }
  }
}
    ${SelectRunFragmentFragmentDoc}
${BasicRunFragmentFragmentDoc}`;
export type ModifyRunsMutationFn = ApolloReactCommon.MutationFunction<ModifyRunsMutation, ModifyRunsMutationVariables>;
export type ModifyRunsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ModifyRunsMutation, ModifyRunsMutationVariables>, 'mutation'>;

    export const ModifyRunsComponent = (props: ModifyRunsComponentProps) => (
      <ApolloReactComponents.Mutation<ModifyRunsMutation, ModifyRunsMutationVariables> mutation={ModifyRunsDocument} {...props} />
    );
    
export type ModifyRunsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ModifyRunsMutation, ModifyRunsMutationVariables>
    } & TChildProps;
export function withModifyRuns<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ModifyRunsMutation,
  ModifyRunsMutationVariables,
  ModifyRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ModifyRunsMutation, ModifyRunsMutationVariables, ModifyRunsProps<TChildProps, TDataName>>(ModifyRunsDocument, {
      alias: 'modifyRuns',
      ...operationOptions
    });
};

/**
 * __useModifyRunsMutation__
 *
 * To run a mutation, you first call `useModifyRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyRunsMutation, { data, loading, error }] = useModifyRunsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      addTags: // value for 'addTags'
 *      removeTags: // value for 'removeTags'
 *   },
 * });
 */
export function useModifyRunsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyRunsMutation, ModifyRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyRunsMutation, ModifyRunsMutationVariables>(ModifyRunsDocument, options);
      }
export type ModifyRunsMutationHookResult = ReturnType<typeof useModifyRunsMutation>;
export type ModifyRunsMutationResult = ApolloReactCommon.MutationResult<ModifyRunsMutation>;
export type ModifyRunsMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyRunsMutation, ModifyRunsMutationVariables>;
export const MoveRunsDocument = gql`
    mutation moveRuns($filters: JSONString!, $sourceEntityName: String!, $sourceProjectName: String!, $destinationEntityName: String!, $destinationProjectName: String!) {
  moveRuns(
    input: {filters: $filters, sourceEntityName: $sourceEntityName, sourceProjectName: $sourceProjectName, destinationEntityName: $destinationEntityName, destinationProjectName: $destinationProjectName}
  ) {
    task {
      id
    }
  }
}
    `;
export type MoveRunsMutationFn = ApolloReactCommon.MutationFunction<MoveRunsMutation, MoveRunsMutationVariables>;
export type MoveRunsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MoveRunsMutation, MoveRunsMutationVariables>, 'mutation'>;

    export const MoveRunsComponent = (props: MoveRunsComponentProps) => (
      <ApolloReactComponents.Mutation<MoveRunsMutation, MoveRunsMutationVariables> mutation={MoveRunsDocument} {...props} />
    );
    
export type MoveRunsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MoveRunsMutation, MoveRunsMutationVariables>
    } & TChildProps;
export function withMoveRuns<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MoveRunsMutation,
  MoveRunsMutationVariables,
  MoveRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MoveRunsMutation, MoveRunsMutationVariables, MoveRunsProps<TChildProps, TDataName>>(MoveRunsDocument, {
      alias: 'moveRuns',
      ...operationOptions
    });
};

/**
 * __useMoveRunsMutation__
 *
 * To run a mutation, you first call `useMoveRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveRunsMutation, { data, loading, error }] = useMoveRunsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      sourceEntityName: // value for 'sourceEntityName'
 *      sourceProjectName: // value for 'sourceProjectName'
 *      destinationEntityName: // value for 'destinationEntityName'
 *      destinationProjectName: // value for 'destinationProjectName'
 *   },
 * });
 */
export function useMoveRunsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveRunsMutation, MoveRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveRunsMutation, MoveRunsMutationVariables>(MoveRunsDocument, options);
      }
export type MoveRunsMutationHookResult = ReturnType<typeof useMoveRunsMutation>;
export type MoveRunsMutationResult = ApolloReactCommon.MutationResult<MoveRunsMutation>;
export type MoveRunsMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveRunsMutation, MoveRunsMutationVariables>;
export const DeleteRunsDocument = gql`
    mutation deleteRuns($filters: JSONString!, $entityName: String!, $projectName: String!, $deleteArtifacts: Boolean!) {
  deleteRuns(
    input: {filters: $filters, entityName: $entityName, projectName: $projectName, deleteArtifacts: $deleteArtifacts}
  ) {
    clientMutationId
    errors
  }
}
    `;
export type DeleteRunsMutationFn = ApolloReactCommon.MutationFunction<DeleteRunsMutation, DeleteRunsMutationVariables>;
export type DeleteRunsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteRunsMutation, DeleteRunsMutationVariables>, 'mutation'>;

    export const DeleteRunsComponent = (props: DeleteRunsComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteRunsMutation, DeleteRunsMutationVariables> mutation={DeleteRunsDocument} {...props} />
    );
    
export type DeleteRunsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteRunsMutation, DeleteRunsMutationVariables>
    } & TChildProps;
export function withDeleteRuns<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteRunsMutation,
  DeleteRunsMutationVariables,
  DeleteRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteRunsMutation, DeleteRunsMutationVariables, DeleteRunsProps<TChildProps, TDataName>>(DeleteRunsDocument, {
      alias: 'deleteRuns',
      ...operationOptions
    });
};

/**
 * __useDeleteRunsMutation__
 *
 * To run a mutation, you first call `useDeleteRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRunsMutation, { data, loading, error }] = useDeleteRunsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      deleteArtifacts: // value for 'deleteArtifacts'
 *   },
 * });
 */
export function useDeleteRunsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRunsMutation, DeleteRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRunsMutation, DeleteRunsMutationVariables>(DeleteRunsDocument, options);
      }
export type DeleteRunsMutationHookResult = ReturnType<typeof useDeleteRunsMutation>;
export type DeleteRunsMutationResult = ApolloReactCommon.MutationResult<DeleteRunsMutation>;
export type DeleteRunsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRunsMutation, DeleteRunsMutationVariables>;
export const UndeleteRunsDocument = gql`
    mutation undeleteRuns($filters: JSONString!, $entityName: String!, $projectName: String!) {
  undeleteRuns(
    input: {filters: $filters, entityName: $entityName, projectName: $projectName}
  ) {
    clientMutationId
  }
}
    `;
export type UndeleteRunsMutationFn = ApolloReactCommon.MutationFunction<UndeleteRunsMutation, UndeleteRunsMutationVariables>;
export type UndeleteRunsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UndeleteRunsMutation, UndeleteRunsMutationVariables>, 'mutation'>;

    export const UndeleteRunsComponent = (props: UndeleteRunsComponentProps) => (
      <ApolloReactComponents.Mutation<UndeleteRunsMutation, UndeleteRunsMutationVariables> mutation={UndeleteRunsDocument} {...props} />
    );
    
export type UndeleteRunsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UndeleteRunsMutation, UndeleteRunsMutationVariables>
    } & TChildProps;
export function withUndeleteRuns<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UndeleteRunsMutation,
  UndeleteRunsMutationVariables,
  UndeleteRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UndeleteRunsMutation, UndeleteRunsMutationVariables, UndeleteRunsProps<TChildProps, TDataName>>(UndeleteRunsDocument, {
      alias: 'undeleteRuns',
      ...operationOptions
    });
};

/**
 * __useUndeleteRunsMutation__
 *
 * To run a mutation, you first call `useUndeleteRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteRunsMutation, { data, loading, error }] = useUndeleteRunsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useUndeleteRunsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndeleteRunsMutation, UndeleteRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UndeleteRunsMutation, UndeleteRunsMutationVariables>(UndeleteRunsDocument, options);
      }
export type UndeleteRunsMutationHookResult = ReturnType<typeof useUndeleteRunsMutation>;
export type UndeleteRunsMutationResult = ApolloReactCommon.MutationResult<UndeleteRunsMutation>;
export type UndeleteRunsMutationOptions = ApolloReactCommon.BaseMutationOptions<UndeleteRunsMutation, UndeleteRunsMutationVariables>;
export const DeleteRunDocument = gql`
    mutation deleteRun($id: ID!, $deleteArtifacts: Boolean = false) {
  deleteRun(input: {id: $id, deleteArtifacts: $deleteArtifacts}) {
    clientMutationId
  }
}
    `;
export type DeleteRunMutationFn = ApolloReactCommon.MutationFunction<DeleteRunMutation, DeleteRunMutationVariables>;
export type DeleteRunComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteRunMutation, DeleteRunMutationVariables>, 'mutation'>;

    export const DeleteRunComponent = (props: DeleteRunComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteRunMutation, DeleteRunMutationVariables> mutation={DeleteRunDocument} {...props} />
    );
    
export type DeleteRunProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteRunMutation, DeleteRunMutationVariables>
    } & TChildProps;
export function withDeleteRun<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteRunMutation,
  DeleteRunMutationVariables,
  DeleteRunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteRunMutation, DeleteRunMutationVariables, DeleteRunProps<TChildProps, TDataName>>(DeleteRunDocument, {
      alias: 'deleteRun',
      ...operationOptions
    });
};

/**
 * __useDeleteRunMutation__
 *
 * To run a mutation, you first call `useDeleteRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRunMutation, { data, loading, error }] = useDeleteRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteArtifacts: // value for 'deleteArtifacts'
 *   },
 * });
 */
export function useDeleteRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRunMutation, DeleteRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRunMutation, DeleteRunMutationVariables>(DeleteRunDocument, options);
      }
export type DeleteRunMutationHookResult = ReturnType<typeof useDeleteRunMutation>;
export type DeleteRunMutationResult = ApolloReactCommon.MutationResult<DeleteRunMutation>;
export type DeleteRunMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRunMutation, DeleteRunMutationVariables>;
export const StopRunDocument = gql`
    mutation stopRun($id: ID!) {
  stopRun(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type StopRunMutationFn = ApolloReactCommon.MutationFunction<StopRunMutation, StopRunMutationVariables>;
export type StopRunComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StopRunMutation, StopRunMutationVariables>, 'mutation'>;

    export const StopRunComponent = (props: StopRunComponentProps) => (
      <ApolloReactComponents.Mutation<StopRunMutation, StopRunMutationVariables> mutation={StopRunDocument} {...props} />
    );
    
export type StopRunProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<StopRunMutation, StopRunMutationVariables>
    } & TChildProps;
export function withStopRun<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StopRunMutation,
  StopRunMutationVariables,
  StopRunProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, StopRunMutation, StopRunMutationVariables, StopRunProps<TChildProps, TDataName>>(StopRunDocument, {
      alias: 'stopRun',
      ...operationOptions
    });
};

/**
 * __useStopRunMutation__
 *
 * To run a mutation, you first call `useStopRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRunMutation, { data, loading, error }] = useStopRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopRunMutation, StopRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopRunMutation, StopRunMutationVariables>(StopRunDocument, options);
      }
export type StopRunMutationHookResult = ReturnType<typeof useStopRunMutation>;
export type StopRunMutationResult = ApolloReactCommon.MutationResult<StopRunMutation>;
export type StopRunMutationOptions = ApolloReactCommon.BaseMutationOptions<StopRunMutation, StopRunMutationVariables>;
export const RunStopDocument = gql`
    mutation runStop($id: ID!) {
  stopRun(input: {id: $id}) {
    success
  }
}
    `;
export type RunStopMutationFn = ApolloReactCommon.MutationFunction<RunStopMutation, RunStopMutationVariables>;
export type RunStopComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RunStopMutation, RunStopMutationVariables>, 'mutation'>;

    export const RunStopComponent = (props: RunStopComponentProps) => (
      <ApolloReactComponents.Mutation<RunStopMutation, RunStopMutationVariables> mutation={RunStopDocument} {...props} />
    );
    
export type RunStopProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RunStopMutation, RunStopMutationVariables>
    } & TChildProps;
export function withRunStop<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunStopMutation,
  RunStopMutationVariables,
  RunStopProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RunStopMutation, RunStopMutationVariables, RunStopProps<TChildProps, TDataName>>(RunStopDocument, {
      alias: 'runStop',
      ...operationOptions
    });
};

/**
 * __useRunStopMutation__
 *
 * To run a mutation, you first call `useRunStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runStopMutation, { data, loading, error }] = useRunStopMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRunStopMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RunStopMutation, RunStopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RunStopMutation, RunStopMutationVariables>(RunStopDocument, options);
      }
export type RunStopMutationHookResult = ReturnType<typeof useRunStopMutation>;
export type RunStopMutationResult = ApolloReactCommon.MutationResult<RunStopMutation>;
export type RunStopMutationOptions = ApolloReactCommon.BaseMutationOptions<RunStopMutation, RunStopMutationVariables>;
export const DeleteFilesDocument = gql`
    mutation deleteFiles($ids: [ID!]!, $projectId: Int!) {
  deleteFiles(input: {files: $ids, projectId: $projectId}) {
    clientMutationId
    success
  }
}
    `;
export type DeleteFilesMutationFn = ApolloReactCommon.MutationFunction<DeleteFilesMutation, DeleteFilesMutationVariables>;
export type DeleteFilesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteFilesMutation, DeleteFilesMutationVariables>, 'mutation'>;

    export const DeleteFilesComponent = (props: DeleteFilesComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteFilesMutation, DeleteFilesMutationVariables> mutation={DeleteFilesDocument} {...props} />
    );
    
export type DeleteFilesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteFilesMutation, DeleteFilesMutationVariables>
    } & TChildProps;
export function withDeleteFiles<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteFilesMutation,
  DeleteFilesMutationVariables,
  DeleteFilesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteFilesMutation, DeleteFilesMutationVariables, DeleteFilesProps<TChildProps, TDataName>>(DeleteFilesDocument, {
      alias: 'deleteFiles',
      ...operationOptions
    });
};

/**
 * __useDeleteFilesMutation__
 *
 * To run a mutation, you first call `useDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesMutation, { data, loading, error }] = useDeleteFilesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteFilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFilesMutation, DeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFilesMutation, DeleteFilesMutationVariables>(DeleteFilesDocument, options);
      }
export type DeleteFilesMutationHookResult = ReturnType<typeof useDeleteFilesMutation>;
export type DeleteFilesMutationResult = ApolloReactCommon.MutationResult<DeleteFilesMutation>;
export type DeleteFilesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFilesMutation, DeleteFilesMutationVariables>;
export const DeleteFilesByRunAndFolderDocument = gql`
    mutation deleteFilesByRunAndFolder($runName: String!, $projectId: Int!, $folders: [String!]!) {
  deleteFilesByRunAndFolder(
    input: {runName: $runName, projectId: $projectId, folders: $folders}
  ) {
    clientMutationId
    success
  }
}
    `;
export type DeleteFilesByRunAndFolderMutationFn = ApolloReactCommon.MutationFunction<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>;
export type DeleteFilesByRunAndFolderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>, 'mutation'>;

    export const DeleteFilesByRunAndFolderComponent = (props: DeleteFilesByRunAndFolderComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables> mutation={DeleteFilesByRunAndFolderDocument} {...props} />
    );
    
export type DeleteFilesByRunAndFolderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>
    } & TChildProps;
export function withDeleteFilesByRunAndFolder<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteFilesByRunAndFolderMutation,
  DeleteFilesByRunAndFolderMutationVariables,
  DeleteFilesByRunAndFolderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables, DeleteFilesByRunAndFolderProps<TChildProps, TDataName>>(DeleteFilesByRunAndFolderDocument, {
      alias: 'deleteFilesByRunAndFolder',
      ...operationOptions
    });
};

/**
 * __useDeleteFilesByRunAndFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFilesByRunAndFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesByRunAndFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesByRunAndFolderMutation, { data, loading, error }] = useDeleteFilesByRunAndFolderMutation({
 *   variables: {
 *      runName: // value for 'runName'
 *      projectId: // value for 'projectId'
 *      folders: // value for 'folders'
 *   },
 * });
 */
export function useDeleteFilesByRunAndFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>(DeleteFilesByRunAndFolderDocument, options);
      }
export type DeleteFilesByRunAndFolderMutationHookResult = ReturnType<typeof useDeleteFilesByRunAndFolderMutation>;
export type DeleteFilesByRunAndFolderMutationResult = ApolloReactCommon.MutationResult<DeleteFilesByRunAndFolderMutation>;
export type DeleteFilesByRunAndFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>;
export const RunHasProtectedOutputArtifactDocument = gql`
    query runHasProtectedOutputArtifact($runName: String!, $projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      hasProtectedOutputArtifact
    }
  }
}
    `;
export type RunHasProtectedOutputArtifactComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>, 'query'> & ({ variables: RunHasProtectedOutputArtifactQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunHasProtectedOutputArtifactComponent = (props: RunHasProtectedOutputArtifactComponentProps) => (
      <ApolloReactComponents.Query<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables> query={RunHasProtectedOutputArtifactDocument} {...props} />
    );
    
export type RunHasProtectedOutputArtifactProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>
    } & TChildProps;
export function withRunHasProtectedOutputArtifact<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunHasProtectedOutputArtifactQuery,
  RunHasProtectedOutputArtifactQueryVariables,
  RunHasProtectedOutputArtifactProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables, RunHasProtectedOutputArtifactProps<TChildProps, TDataName>>(RunHasProtectedOutputArtifactDocument, {
      alias: 'runHasProtectedOutputArtifact',
      ...operationOptions
    });
};

/**
 * __useRunHasProtectedOutputArtifactQuery__
 *
 * To run a query within a React component, call `useRunHasProtectedOutputArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunHasProtectedOutputArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunHasProtectedOutputArtifactQuery({
 *   variables: {
 *      runName: // value for 'runName'
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRunHasProtectedOutputArtifactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables> & ({ variables: RunHasProtectedOutputArtifactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>(RunHasProtectedOutputArtifactDocument, options);
      }
export function useRunHasProtectedOutputArtifactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>(RunHasProtectedOutputArtifactDocument, options);
        }
// @ts-ignore
export function useRunHasProtectedOutputArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>;
export function useRunHasProtectedOutputArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunHasProtectedOutputArtifactQuery | undefined, RunHasProtectedOutputArtifactQueryVariables>;
export function useRunHasProtectedOutputArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>(RunHasProtectedOutputArtifactDocument, options);
        }
export type RunHasProtectedOutputArtifactQueryHookResult = ReturnType<typeof useRunHasProtectedOutputArtifactQuery>;
export type RunHasProtectedOutputArtifactLazyQueryHookResult = ReturnType<typeof useRunHasProtectedOutputArtifactLazyQuery>;
export type RunHasProtectedOutputArtifactSuspenseQueryHookResult = ReturnType<typeof useRunHasProtectedOutputArtifactSuspenseQuery>;
export type RunHasProtectedOutputArtifactQueryResult = ApolloReactCommon.QueryResult<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>;
export const RunsHaveProtectedOutputArtifactsDocument = gql`
    query runsHaveProtectedOutputArtifacts($filters: JSONString!, $projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runsHaveProtectedOutputArtifacts(filters: $filters)
  }
}
    `;
export type RunsHaveProtectedOutputArtifactsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>, 'query'> & ({ variables: RunsHaveProtectedOutputArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsHaveProtectedOutputArtifactsComponent = (props: RunsHaveProtectedOutputArtifactsComponentProps) => (
      <ApolloReactComponents.Query<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables> query={RunsHaveProtectedOutputArtifactsDocument} {...props} />
    );
    
export type RunsHaveProtectedOutputArtifactsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>
    } & TChildProps;
export function withRunsHaveProtectedOutputArtifacts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsHaveProtectedOutputArtifactsQuery,
  RunsHaveProtectedOutputArtifactsQueryVariables,
  RunsHaveProtectedOutputArtifactsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables, RunsHaveProtectedOutputArtifactsProps<TChildProps, TDataName>>(RunsHaveProtectedOutputArtifactsDocument, {
      alias: 'runsHaveProtectedOutputArtifacts',
      ...operationOptions
    });
};

/**
 * __useRunsHaveProtectedOutputArtifactsQuery__
 *
 * To run a query within a React component, call `useRunsHaveProtectedOutputArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsHaveProtectedOutputArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsHaveProtectedOutputArtifactsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRunsHaveProtectedOutputArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables> & ({ variables: RunsHaveProtectedOutputArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>(RunsHaveProtectedOutputArtifactsDocument, options);
      }
export function useRunsHaveProtectedOutputArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>(RunsHaveProtectedOutputArtifactsDocument, options);
        }
// @ts-ignore
export function useRunsHaveProtectedOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>;
export function useRunsHaveProtectedOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsHaveProtectedOutputArtifactsQuery | undefined, RunsHaveProtectedOutputArtifactsQueryVariables>;
export function useRunsHaveProtectedOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>(RunsHaveProtectedOutputArtifactsDocument, options);
        }
export type RunsHaveProtectedOutputArtifactsQueryHookResult = ReturnType<typeof useRunsHaveProtectedOutputArtifactsQuery>;
export type RunsHaveProtectedOutputArtifactsLazyQueryHookResult = ReturnType<typeof useRunsHaveProtectedOutputArtifactsLazyQuery>;
export type RunsHaveProtectedOutputArtifactsSuspenseQueryHookResult = ReturnType<typeof useRunsHaveProtectedOutputArtifactsSuspenseQuery>;
export type RunsHaveProtectedOutputArtifactsQueryResult = ApolloReactCommon.QueryResult<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>;
export const InsertSecretDocument = gql`
    mutation insertSecret($entityName: String!, $secretName: String!, $secretValue: String!) {
  insertSecret(
    input: {entityName: $entityName, secretName: $secretName, secretValue: $secretValue}
  ) {
    success
  }
}
    `;
export type InsertSecretMutationFn = ApolloReactCommon.MutationFunction<InsertSecretMutation, InsertSecretMutationVariables>;
export type InsertSecretComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertSecretMutation, InsertSecretMutationVariables>, 'mutation'>;

    export const InsertSecretComponent = (props: InsertSecretComponentProps) => (
      <ApolloReactComponents.Mutation<InsertSecretMutation, InsertSecretMutationVariables> mutation={InsertSecretDocument} {...props} />
    );
    
export type InsertSecretProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertSecretMutation, InsertSecretMutationVariables>
    } & TChildProps;
export function withInsertSecret<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertSecretMutation,
  InsertSecretMutationVariables,
  InsertSecretProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertSecretMutation, InsertSecretMutationVariables, InsertSecretProps<TChildProps, TDataName>>(InsertSecretDocument, {
      alias: 'insertSecret',
      ...operationOptions
    });
};

/**
 * __useInsertSecretMutation__
 *
 * To run a mutation, you first call `useInsertSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSecretMutation, { data, loading, error }] = useInsertSecretMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      secretName: // value for 'secretName'
 *      secretValue: // value for 'secretValue'
 *   },
 * });
 */
export function useInsertSecretMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertSecretMutation, InsertSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertSecretMutation, InsertSecretMutationVariables>(InsertSecretDocument, options);
      }
export type InsertSecretMutationHookResult = ReturnType<typeof useInsertSecretMutation>;
export type InsertSecretMutationResult = ApolloReactCommon.MutationResult<InsertSecretMutation>;
export type InsertSecretMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertSecretMutation, InsertSecretMutationVariables>;
export const DeleteSecretDocument = gql`
    mutation deleteSecret($entityName: String!, $secretName: String!) {
  deleteSecret(input: {entityName: $entityName, secretName: $secretName}) {
    success
  }
}
    `;
export type DeleteSecretMutationFn = ApolloReactCommon.MutationFunction<DeleteSecretMutation, DeleteSecretMutationVariables>;
export type DeleteSecretComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteSecretMutation, DeleteSecretMutationVariables>, 'mutation'>;

    export const DeleteSecretComponent = (props: DeleteSecretComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteSecretMutation, DeleteSecretMutationVariables> mutation={DeleteSecretDocument} {...props} />
    );
    
export type DeleteSecretProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteSecretMutation, DeleteSecretMutationVariables>
    } & TChildProps;
export function withDeleteSecret<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteSecretMutation,
  DeleteSecretMutationVariables,
  DeleteSecretProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteSecretMutation, DeleteSecretMutationVariables, DeleteSecretProps<TChildProps, TDataName>>(DeleteSecretDocument, {
      alias: 'deleteSecret',
      ...operationOptions
    });
};

/**
 * __useDeleteSecretMutation__
 *
 * To run a mutation, you first call `useDeleteSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSecretMutation, { data, loading, error }] = useDeleteSecretMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      secretName: // value for 'secretName'
 *   },
 * });
 */
export function useDeleteSecretMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSecretMutation, DeleteSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSecretMutation, DeleteSecretMutationVariables>(DeleteSecretDocument, options);
      }
export type DeleteSecretMutationHookResult = ReturnType<typeof useDeleteSecretMutation>;
export type DeleteSecretMutationResult = ApolloReactCommon.MutationResult<DeleteSecretMutation>;
export type DeleteSecretMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSecretMutation, DeleteSecretMutationVariables>;
export const SecretsDocument = gql`
    query secrets($entityName: String!) {
  entity(name: $entityName) {
    id
    secrets {
      entityId
      name
      createdAt
    }
  }
}
    `;
export type SecretsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SecretsQuery, SecretsQueryVariables>, 'query'> & ({ variables: SecretsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SecretsComponent = (props: SecretsComponentProps) => (
      <ApolloReactComponents.Query<SecretsQuery, SecretsQueryVariables> query={SecretsDocument} {...props} />
    );
    
export type SecretsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SecretsQuery, SecretsQueryVariables>
    } & TChildProps;
export function withSecrets<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SecretsQuery,
  SecretsQueryVariables,
  SecretsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SecretsQuery, SecretsQueryVariables, SecretsProps<TChildProps, TDataName>>(SecretsDocument, {
      alias: 'secrets',
      ...operationOptions
    });
};

/**
 * __useSecretsQuery__
 *
 * To run a query within a React component, call `useSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecretsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useSecretsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SecretsQuery, SecretsQueryVariables> & ({ variables: SecretsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SecretsQuery, SecretsQueryVariables>(SecretsDocument, options);
      }
export function useSecretsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SecretsQuery, SecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SecretsQuery, SecretsQueryVariables>(SecretsDocument, options);
        }
// @ts-ignore
export function useSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SecretsQuery, SecretsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SecretsQuery, SecretsQueryVariables>;
export function useSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SecretsQuery, SecretsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SecretsQuery | undefined, SecretsQueryVariables>;
export function useSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SecretsQuery, SecretsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SecretsQuery, SecretsQueryVariables>(SecretsDocument, options);
        }
export type SecretsQueryHookResult = ReturnType<typeof useSecretsQuery>;
export type SecretsLazyQueryHookResult = ReturnType<typeof useSecretsLazyQuery>;
export type SecretsSuspenseQueryHookResult = ReturnType<typeof useSecretsSuspenseQuery>;
export type SecretsQueryResult = ApolloReactCommon.QueryResult<SecretsQuery, SecretsQueryVariables>;
export const ServerInfoDocument = gql`
    query ServerInfo {
  serverInfo {
    availableCloudRegions {
      id
      provider
      region
    }
    isGoogleIap
    slackClientID
  }
}
    `;
export type ServerInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ServerInfoQuery, ServerInfoQueryVariables>, 'query'>;

    export const ServerInfoComponent = (props: ServerInfoComponentProps) => (
      <ApolloReactComponents.Query<ServerInfoQuery, ServerInfoQueryVariables> query={ServerInfoDocument} {...props} />
    );
    
export type ServerInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ServerInfoQuery, ServerInfoQueryVariables>
    } & TChildProps;
export function withServerInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ServerInfoQuery,
  ServerInfoQueryVariables,
  ServerInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ServerInfoQuery, ServerInfoQueryVariables, ServerInfoProps<TChildProps, TDataName>>(ServerInfoDocument, {
      alias: 'serverInfo',
      ...operationOptions
    });
};

/**
 * __useServerInfoQuery__
 *
 * To run a query within a React component, call `useServerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServerInfoQuery, ServerInfoQueryVariables>(ServerInfoDocument, options);
      }
export function useServerInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServerInfoQuery, ServerInfoQueryVariables>(ServerInfoDocument, options);
        }
// @ts-ignore
export function useServerInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerInfoQuery, ServerInfoQueryVariables>;
export function useServerInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerInfoQuery | undefined, ServerInfoQueryVariables>;
export function useServerInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServerInfoQuery, ServerInfoQueryVariables>(ServerInfoDocument, options);
        }
export type ServerInfoQueryHookResult = ReturnType<typeof useServerInfoQuery>;
export type ServerInfoLazyQueryHookResult = ReturnType<typeof useServerInfoLazyQuery>;
export type ServerInfoSuspenseQueryHookResult = ReturnType<typeof useServerInfoSuspenseQuery>;
export type ServerInfoQueryResult = ApolloReactCommon.QueryResult<ServerInfoQuery, ServerInfoQueryVariables>;
export const LicenseExpirationUiDocument = gql`
    query LicenseExpirationUI {
  serverInfo {
    licenseExpirationUI {
      bannerTotalDays
      bannerDaysRemaining
      renewUrl
    }
  }
}
    `;
export type LicenseExpirationUiComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>, 'query'>;

    export const LicenseExpirationUiComponent = (props: LicenseExpirationUiComponentProps) => (
      <ApolloReactComponents.Query<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables> query={LicenseExpirationUiDocument} {...props} />
    );
    
export type LicenseExpirationUiProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>
    } & TChildProps;
export function withLicenseExpirationUi<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LicenseExpirationUiQuery,
  LicenseExpirationUiQueryVariables,
  LicenseExpirationUiProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables, LicenseExpirationUiProps<TChildProps, TDataName>>(LicenseExpirationUiDocument, {
      alias: 'licenseExpirationUi',
      ...operationOptions
    });
};

/**
 * __useLicenseExpirationUiQuery__
 *
 * To run a query within a React component, call `useLicenseExpirationUiQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseExpirationUiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseExpirationUiQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicenseExpirationUiQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>(LicenseExpirationUiDocument, options);
      }
export function useLicenseExpirationUiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>(LicenseExpirationUiDocument, options);
        }
// @ts-ignore
export function useLicenseExpirationUiSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>;
export function useLicenseExpirationUiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LicenseExpirationUiQuery | undefined, LicenseExpirationUiQueryVariables>;
export function useLicenseExpirationUiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>(LicenseExpirationUiDocument, options);
        }
export type LicenseExpirationUiQueryHookResult = ReturnType<typeof useLicenseExpirationUiQuery>;
export type LicenseExpirationUiLazyQueryHookResult = ReturnType<typeof useLicenseExpirationUiLazyQuery>;
export type LicenseExpirationUiSuspenseQueryHookResult = ReturnType<typeof useLicenseExpirationUiSuspenseQuery>;
export type LicenseExpirationUiQueryResult = ApolloReactCommon.QueryResult<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>;
export const UserLimitReachedDocument = gql`
    query UserLimitReached {
  serverInfo {
    userLimitReached
    viewOnlyUserLimitReached
    licenseFlags
  }
}
    `;
export type UserLimitReachedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>, 'query'>;

    export const UserLimitReachedComponent = (props: UserLimitReachedComponentProps) => (
      <ApolloReactComponents.Query<UserLimitReachedQuery, UserLimitReachedQueryVariables> query={UserLimitReachedDocument} {...props} />
    );
    
export type UserLimitReachedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserLimitReachedQuery, UserLimitReachedQueryVariables>
    } & TChildProps;
export function withUserLimitReached<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserLimitReachedQuery,
  UserLimitReachedQueryVariables,
  UserLimitReachedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserLimitReachedQuery, UserLimitReachedQueryVariables, UserLimitReachedProps<TChildProps, TDataName>>(UserLimitReachedDocument, {
      alias: 'userLimitReached',
      ...operationOptions
    });
};

/**
 * __useUserLimitReachedQuery__
 *
 * To run a query within a React component, call `useUserLimitReachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLimitReachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLimitReachedQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserLimitReachedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserLimitReachedQuery, UserLimitReachedQueryVariables>(UserLimitReachedDocument, options);
      }
export function useUserLimitReachedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserLimitReachedQuery, UserLimitReachedQueryVariables>(UserLimitReachedDocument, options);
        }
// @ts-ignore
export function useUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserLimitReachedQuery, UserLimitReachedQueryVariables>;
export function useUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserLimitReachedQuery | undefined, UserLimitReachedQueryVariables>;
export function useUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserLimitReachedQuery, UserLimitReachedQueryVariables>(UserLimitReachedDocument, options);
        }
export type UserLimitReachedQueryHookResult = ReturnType<typeof useUserLimitReachedQuery>;
export type UserLimitReachedLazyQueryHookResult = ReturnType<typeof useUserLimitReachedLazyQuery>;
export type UserLimitReachedSuspenseQueryHookResult = ReturnType<typeof useUserLimitReachedSuspenseQuery>;
export type UserLimitReachedQueryResult = ApolloReactCommon.QueryResult<UserLimitReachedQuery, UserLimitReachedQueryVariables>;
export const ViewOnlyUserLimitReachedDocument = gql`
    query ViewOnlyUserLimitReached {
  serverInfo {
    viewOnlyUserLimitReached
  }
}
    `;
export type ViewOnlyUserLimitReachedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>, 'query'>;

    export const ViewOnlyUserLimitReachedComponent = (props: ViewOnlyUserLimitReachedComponentProps) => (
      <ApolloReactComponents.Query<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables> query={ViewOnlyUserLimitReachedDocument} {...props} />
    );
    
export type ViewOnlyUserLimitReachedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>
    } & TChildProps;
export function withViewOnlyUserLimitReached<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewOnlyUserLimitReachedQuery,
  ViewOnlyUserLimitReachedQueryVariables,
  ViewOnlyUserLimitReachedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables, ViewOnlyUserLimitReachedProps<TChildProps, TDataName>>(ViewOnlyUserLimitReachedDocument, {
      alias: 'viewOnlyUserLimitReached',
      ...operationOptions
    });
};

/**
 * __useViewOnlyUserLimitReachedQuery__
 *
 * To run a query within a React component, call `useViewOnlyUserLimitReachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewOnlyUserLimitReachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewOnlyUserLimitReachedQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewOnlyUserLimitReachedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>(ViewOnlyUserLimitReachedDocument, options);
      }
export function useViewOnlyUserLimitReachedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>(ViewOnlyUserLimitReachedDocument, options);
        }
// @ts-ignore
export function useViewOnlyUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>;
export function useViewOnlyUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewOnlyUserLimitReachedQuery | undefined, ViewOnlyUserLimitReachedQueryVariables>;
export function useViewOnlyUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>(ViewOnlyUserLimitReachedDocument, options);
        }
export type ViewOnlyUserLimitReachedQueryHookResult = ReturnType<typeof useViewOnlyUserLimitReachedQuery>;
export type ViewOnlyUserLimitReachedLazyQueryHookResult = ReturnType<typeof useViewOnlyUserLimitReachedLazyQuery>;
export type ViewOnlyUserLimitReachedSuspenseQueryHookResult = ReturnType<typeof useViewOnlyUserLimitReachedSuspenseQuery>;
export type ViewOnlyUserLimitReachedQueryResult = ApolloReactCommon.QueryResult<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>;
export const RegisteredModelLimitReachedDocument = gql`
    query RegisteredModelLimitReached($entityName: String!) {
  serverInfo {
    registeredModelLimitReached(entityName: $entityName)
  }
}
    `;
export type RegisteredModelLimitReachedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>, 'query'> & ({ variables: RegisteredModelLimitReachedQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegisteredModelLimitReachedComponent = (props: RegisteredModelLimitReachedComponentProps) => (
      <ApolloReactComponents.Query<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables> query={RegisteredModelLimitReachedDocument} {...props} />
    );
    
export type RegisteredModelLimitReachedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>
    } & TChildProps;
export function withRegisteredModelLimitReached<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegisteredModelLimitReachedQuery,
  RegisteredModelLimitReachedQueryVariables,
  RegisteredModelLimitReachedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables, RegisteredModelLimitReachedProps<TChildProps, TDataName>>(RegisteredModelLimitReachedDocument, {
      alias: 'registeredModelLimitReached',
      ...operationOptions
    });
};

/**
 * __useRegisteredModelLimitReachedQuery__
 *
 * To run a query within a React component, call `useRegisteredModelLimitReachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredModelLimitReachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredModelLimitReachedQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRegisteredModelLimitReachedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables> & ({ variables: RegisteredModelLimitReachedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>(RegisteredModelLimitReachedDocument, options);
      }
export function useRegisteredModelLimitReachedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>(RegisteredModelLimitReachedDocument, options);
        }
// @ts-ignore
export function useRegisteredModelLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>;
export function useRegisteredModelLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegisteredModelLimitReachedQuery | undefined, RegisteredModelLimitReachedQueryVariables>;
export function useRegisteredModelLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>(RegisteredModelLimitReachedDocument, options);
        }
export type RegisteredModelLimitReachedQueryHookResult = ReturnType<typeof useRegisteredModelLimitReachedQuery>;
export type RegisteredModelLimitReachedLazyQueryHookResult = ReturnType<typeof useRegisteredModelLimitReachedLazyQuery>;
export type RegisteredModelLimitReachedSuspenseQueryHookResult = ReturnType<typeof useRegisteredModelLimitReachedSuspenseQuery>;
export type RegisteredModelLimitReachedQueryResult = ApolloReactCommon.QueryResult<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>;
export const ActionHistoryLimitDocument = gql`
    query ActionHistoryLimit($entityName: String, $artifactCollectionID: ID) {
  serverInfo {
    actionHistoryLimit(
      entityName: $entityName
      artifactCollectionID: $artifactCollectionID
    )
  }
}
    `;
export type ActionHistoryLimitComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>, 'query'>;

    export const ActionHistoryLimitComponent = (props: ActionHistoryLimitComponentProps) => (
      <ApolloReactComponents.Query<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables> query={ActionHistoryLimitDocument} {...props} />
    );
    
export type ActionHistoryLimitProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>
    } & TChildProps;
export function withActionHistoryLimit<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ActionHistoryLimitQuery,
  ActionHistoryLimitQueryVariables,
  ActionHistoryLimitProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables, ActionHistoryLimitProps<TChildProps, TDataName>>(ActionHistoryLimitDocument, {
      alias: 'actionHistoryLimit',
      ...operationOptions
    });
};

/**
 * __useActionHistoryLimitQuery__
 *
 * To run a query within a React component, call `useActionHistoryLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionHistoryLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionHistoryLimitQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useActionHistoryLimitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>(ActionHistoryLimitDocument, options);
      }
export function useActionHistoryLimitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>(ActionHistoryLimitDocument, options);
        }
// @ts-ignore
export function useActionHistoryLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>;
export function useActionHistoryLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActionHistoryLimitQuery | undefined, ActionHistoryLimitQueryVariables>;
export function useActionHistoryLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>(ActionHistoryLimitDocument, options);
        }
export type ActionHistoryLimitQueryHookResult = ReturnType<typeof useActionHistoryLimitQuery>;
export type ActionHistoryLimitLazyQueryHookResult = ReturnType<typeof useActionHistoryLimitLazyQuery>;
export type ActionHistoryLimitSuspenseQueryHookResult = ReturnType<typeof useActionHistoryLimitSuspenseQuery>;
export type ActionHistoryLimitQueryResult = ApolloReactCommon.QueryResult<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>;
export const FrontendHostDocument = gql`
    query FrontendHost {
  serverInfo {
    frontendHost
  }
}
    `;
export type FrontendHostComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FrontendHostQuery, FrontendHostQueryVariables>, 'query'>;

    export const FrontendHostComponent = (props: FrontendHostComponentProps) => (
      <ApolloReactComponents.Query<FrontendHostQuery, FrontendHostQueryVariables> query={FrontendHostDocument} {...props} />
    );
    
export type FrontendHostProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FrontendHostQuery, FrontendHostQueryVariables>
    } & TChildProps;
export function withFrontendHost<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FrontendHostQuery,
  FrontendHostQueryVariables,
  FrontendHostProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FrontendHostQuery, FrontendHostQueryVariables, FrontendHostProps<TChildProps, TDataName>>(FrontendHostDocument, {
      alias: 'frontendHost',
      ...operationOptions
    });
};

/**
 * __useFrontendHostQuery__
 *
 * To run a query within a React component, call `useFrontendHostQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontendHostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontendHostQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrontendHostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FrontendHostQuery, FrontendHostQueryVariables>(FrontendHostDocument, options);
      }
export function useFrontendHostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FrontendHostQuery, FrontendHostQueryVariables>(FrontendHostDocument, options);
        }
// @ts-ignore
export function useFrontendHostSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FrontendHostQuery, FrontendHostQueryVariables>;
export function useFrontendHostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FrontendHostQuery | undefined, FrontendHostQueryVariables>;
export function useFrontendHostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FrontendHostQuery, FrontendHostQueryVariables>(FrontendHostDocument, options);
        }
export type FrontendHostQueryHookResult = ReturnType<typeof useFrontendHostQuery>;
export type FrontendHostLazyQueryHookResult = ReturnType<typeof useFrontendHostLazyQuery>;
export type FrontendHostSuspenseQueryHookResult = ReturnType<typeof useFrontendHostSuspenseQuery>;
export type FrontendHostQueryResult = ApolloReactCommon.QueryResult<FrontendHostQuery, FrontendHostQueryVariables>;
export const DeploymentIdDocument = gql`
    query DeploymentID {
  serverInfo {
    deploymentId
  }
}
    `;
export type DeploymentIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DeploymentIdQuery, DeploymentIdQueryVariables>, 'query'>;

    export const DeploymentIdComponent = (props: DeploymentIdComponentProps) => (
      <ApolloReactComponents.Query<DeploymentIdQuery, DeploymentIdQueryVariables> query={DeploymentIdDocument} {...props} />
    );
    
export type DeploymentIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<DeploymentIdQuery, DeploymentIdQueryVariables>
    } & TChildProps;
export function withDeploymentId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeploymentIdQuery,
  DeploymentIdQueryVariables,
  DeploymentIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, DeploymentIdQuery, DeploymentIdQueryVariables, DeploymentIdProps<TChildProps, TDataName>>(DeploymentIdDocument, {
      alias: 'deploymentId',
      ...operationOptions
    });
};

/**
 * __useDeploymentIdQuery__
 *
 * To run a query within a React component, call `useDeploymentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeploymentIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeploymentIdQuery, DeploymentIdQueryVariables>(DeploymentIdDocument, options);
      }
export function useDeploymentIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeploymentIdQuery, DeploymentIdQueryVariables>(DeploymentIdDocument, options);
        }
// @ts-ignore
export function useDeploymentIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeploymentIdQuery, DeploymentIdQueryVariables>;
export function useDeploymentIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeploymentIdQuery | undefined, DeploymentIdQueryVariables>;
export function useDeploymentIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeploymentIdQuery, DeploymentIdQueryVariables>(DeploymentIdDocument, options);
        }
export type DeploymentIdQueryHookResult = ReturnType<typeof useDeploymentIdQuery>;
export type DeploymentIdLazyQueryHookResult = ReturnType<typeof useDeploymentIdLazyQuery>;
export type DeploymentIdSuspenseQueryHookResult = ReturnType<typeof useDeploymentIdSuspenseQuery>;
export type DeploymentIdQueryResult = ApolloReactCommon.QueryResult<DeploymentIdQuery, DeploymentIdQueryVariables>;
export const SecureStorageConnectorEnabledDocument = gql`
    query SecureStorageConnectorEnabled {
  serverInfo {
    secureStorageConnectorEnabled
  }
}
    `;
export type SecureStorageConnectorEnabledComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>, 'query'>;

    export const SecureStorageConnectorEnabledComponent = (props: SecureStorageConnectorEnabledComponentProps) => (
      <ApolloReactComponents.Query<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables> query={SecureStorageConnectorEnabledDocument} {...props} />
    );
    
export type SecureStorageConnectorEnabledProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>
    } & TChildProps;
export function withSecureStorageConnectorEnabled<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SecureStorageConnectorEnabledQuery,
  SecureStorageConnectorEnabledQueryVariables,
  SecureStorageConnectorEnabledProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables, SecureStorageConnectorEnabledProps<TChildProps, TDataName>>(SecureStorageConnectorEnabledDocument, {
      alias: 'secureStorageConnectorEnabled',
      ...operationOptions
    });
};

/**
 * __useSecureStorageConnectorEnabledQuery__
 *
 * To run a query within a React component, call `useSecureStorageConnectorEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureStorageConnectorEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureStorageConnectorEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useSecureStorageConnectorEnabledQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>(SecureStorageConnectorEnabledDocument, options);
      }
export function useSecureStorageConnectorEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>(SecureStorageConnectorEnabledDocument, options);
        }
// @ts-ignore
export function useSecureStorageConnectorEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>;
export function useSecureStorageConnectorEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SecureStorageConnectorEnabledQuery | undefined, SecureStorageConnectorEnabledQueryVariables>;
export function useSecureStorageConnectorEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>(SecureStorageConnectorEnabledDocument, options);
        }
export type SecureStorageConnectorEnabledQueryHookResult = ReturnType<typeof useSecureStorageConnectorEnabledQuery>;
export type SecureStorageConnectorEnabledLazyQueryHookResult = ReturnType<typeof useSecureStorageConnectorEnabledLazyQuery>;
export type SecureStorageConnectorEnabledSuspenseQueryHookResult = ReturnType<typeof useSecureStorageConnectorEnabledSuspenseQuery>;
export type SecureStorageConnectorEnabledQueryResult = ApolloReactCommon.QueryResult<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>;
export const AvailableBucketProvidersDocument = gql`
    query AvailableBucketProviders {
  serverInfo {
    availableBucketProviders
  }
}
    `;
export type AvailableBucketProvidersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>, 'query'>;

    export const AvailableBucketProvidersComponent = (props: AvailableBucketProvidersComponentProps) => (
      <ApolloReactComponents.Query<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables> query={AvailableBucketProvidersDocument} {...props} />
    );
    
export type AvailableBucketProvidersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>
    } & TChildProps;
export function withAvailableBucketProviders<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AvailableBucketProvidersQuery,
  AvailableBucketProvidersQueryVariables,
  AvailableBucketProvidersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables, AvailableBucketProvidersProps<TChildProps, TDataName>>(AvailableBucketProvidersDocument, {
      alias: 'availableBucketProviders',
      ...operationOptions
    });
};

/**
 * __useAvailableBucketProvidersQuery__
 *
 * To run a query within a React component, call `useAvailableBucketProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableBucketProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableBucketProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableBucketProvidersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>(AvailableBucketProvidersDocument, options);
      }
export function useAvailableBucketProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>(AvailableBucketProvidersDocument, options);
        }
// @ts-ignore
export function useAvailableBucketProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>;
export function useAvailableBucketProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableBucketProvidersQuery | undefined, AvailableBucketProvidersQueryVariables>;
export function useAvailableBucketProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>(AvailableBucketProvidersDocument, options);
        }
export type AvailableBucketProvidersQueryHookResult = ReturnType<typeof useAvailableBucketProvidersQuery>;
export type AvailableBucketProvidersLazyQueryHookResult = ReturnType<typeof useAvailableBucketProvidersLazyQuery>;
export type AvailableBucketProvidersSuspenseQueryHookResult = ReturnType<typeof useAvailableBucketProvidersSuspenseQuery>;
export type AvailableBucketProvidersQueryResult = ApolloReactCommon.QueryResult<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>;
export const DataRetentionDurationDocument = gql`
    query DataRetentionDuration {
  serverInfo {
    dataRetentionDuration
  }
}
    `;
export type DataRetentionDurationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>, 'query'>;

    export const DataRetentionDurationComponent = (props: DataRetentionDurationComponentProps) => (
      <ApolloReactComponents.Query<DataRetentionDurationQuery, DataRetentionDurationQueryVariables> query={DataRetentionDurationDocument} {...props} />
    );
    
export type DataRetentionDurationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>
    } & TChildProps;
export function withDataRetentionDuration<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DataRetentionDurationQuery,
  DataRetentionDurationQueryVariables,
  DataRetentionDurationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, DataRetentionDurationQuery, DataRetentionDurationQueryVariables, DataRetentionDurationProps<TChildProps, TDataName>>(DataRetentionDurationDocument, {
      alias: 'dataRetentionDuration',
      ...operationOptions
    });
};

/**
 * __useDataRetentionDurationQuery__
 *
 * To run a query within a React component, call `useDataRetentionDurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataRetentionDurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataRetentionDurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataRetentionDurationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>(DataRetentionDurationDocument, options);
      }
export function useDataRetentionDurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>(DataRetentionDurationDocument, options);
        }
// @ts-ignore
export function useDataRetentionDurationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>;
export function useDataRetentionDurationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataRetentionDurationQuery | undefined, DataRetentionDurationQueryVariables>;
export function useDataRetentionDurationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>(DataRetentionDurationDocument, options);
        }
export type DataRetentionDurationQueryHookResult = ReturnType<typeof useDataRetentionDurationQuery>;
export type DataRetentionDurationLazyQueryHookResult = ReturnType<typeof useDataRetentionDurationLazyQuery>;
export type DataRetentionDurationSuspenseQueryHookResult = ReturnType<typeof useDataRetentionDurationSuspenseQuery>;
export type DataRetentionDurationQueryResult = ApolloReactCommon.QueryResult<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>;
export const FailedPaymentBannersDocument = gql`
    query FailedPaymentBanners($id: ID!) {
  failedPaymentBanners(id: $id) {
    userID
    orgsWithFailedPayments {
      id
      orgId
      orgName
      isBillingUser
      billingEmail
      daysUntilCancellation
      isCollectionMethodACH
    }
  }
}
    `;
export type FailedPaymentBannersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>, 'query'> & ({ variables: FailedPaymentBannersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FailedPaymentBannersComponent = (props: FailedPaymentBannersComponentProps) => (
      <ApolloReactComponents.Query<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables> query={FailedPaymentBannersDocument} {...props} />
    );
    
export type FailedPaymentBannersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>
    } & TChildProps;
export function withFailedPaymentBanners<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FailedPaymentBannersQuery,
  FailedPaymentBannersQueryVariables,
  FailedPaymentBannersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables, FailedPaymentBannersProps<TChildProps, TDataName>>(FailedPaymentBannersDocument, {
      alias: 'failedPaymentBanners',
      ...operationOptions
    });
};

/**
 * __useFailedPaymentBannersQuery__
 *
 * To run a query within a React component, call `useFailedPaymentBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedPaymentBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedPaymentBannersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFailedPaymentBannersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables> & ({ variables: FailedPaymentBannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>(FailedPaymentBannersDocument, options);
      }
export function useFailedPaymentBannersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>(FailedPaymentBannersDocument, options);
        }
// @ts-ignore
export function useFailedPaymentBannersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>;
export function useFailedPaymentBannersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FailedPaymentBannersQuery | undefined, FailedPaymentBannersQueryVariables>;
export function useFailedPaymentBannersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>(FailedPaymentBannersDocument, options);
        }
export type FailedPaymentBannersQueryHookResult = ReturnType<typeof useFailedPaymentBannersQuery>;
export type FailedPaymentBannersLazyQueryHookResult = ReturnType<typeof useFailedPaymentBannersLazyQuery>;
export type FailedPaymentBannersSuspenseQueryHookResult = ReturnType<typeof useFailedPaymentBannersSuspenseQuery>;
export type FailedPaymentBannersQueryResult = ApolloReactCommon.QueryResult<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>;
export const StarredProjectsDocument = gql`
    query StarredProjects($organizationId: ID) {
  viewer {
    id
    starredProjects(first: 30, organizationID: $organizationId) {
      edges {
        node {
          id
          ...AccountProjectFragment
        }
      }
    }
  }
}
    ${AccountProjectFragmentFragmentDoc}`;
export type StarredProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StarredProjectsQuery, StarredProjectsQueryVariables>, 'query'>;

    export const StarredProjectsComponent = (props: StarredProjectsComponentProps) => (
      <ApolloReactComponents.Query<StarredProjectsQuery, StarredProjectsQueryVariables> query={StarredProjectsDocument} {...props} />
    );
    
export type StarredProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StarredProjectsQuery, StarredProjectsQueryVariables>
    } & TChildProps;
export function withStarredProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StarredProjectsQuery,
  StarredProjectsQueryVariables,
  StarredProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StarredProjectsQuery, StarredProjectsQueryVariables, StarredProjectsProps<TChildProps, TDataName>>(StarredProjectsDocument, {
      alias: 'starredProjects',
      ...operationOptions
    });
};

/**
 * __useStarredProjectsQuery__
 *
 * To run a query within a React component, call `useStarredProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStarredProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStarredProjectsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStarredProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StarredProjectsQuery, StarredProjectsQueryVariables>(StarredProjectsDocument, options);
      }
export function useStarredProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StarredProjectsQuery, StarredProjectsQueryVariables>(StarredProjectsDocument, options);
        }
// @ts-ignore
export function useStarredProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StarredProjectsQuery, StarredProjectsQueryVariables>;
export function useStarredProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StarredProjectsQuery | undefined, StarredProjectsQueryVariables>;
export function useStarredProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StarredProjectsQuery, StarredProjectsQueryVariables>(StarredProjectsDocument, options);
        }
export type StarredProjectsQueryHookResult = ReturnType<typeof useStarredProjectsQuery>;
export type StarredProjectsLazyQueryHookResult = ReturnType<typeof useStarredProjectsLazyQuery>;
export type StarredProjectsSuspenseQueryHookResult = ReturnType<typeof useStarredProjectsSuspenseQuery>;
export type StarredProjectsQueryResult = ApolloReactCommon.QueryResult<StarredProjectsQuery, StarredProjectsQueryVariables>;
export const CreateStorageSubscriptionDocument = gql`
    mutation createStorageSubscription($organizationId: ID, $paymentMethod: String, $clientMutationId: String) {
  createStorageSubscription(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateStorageSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>;
export type CreateStorageSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>, 'mutation'>;

    export const CreateStorageSubscriptionComponent = (props: CreateStorageSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables> mutation={CreateStorageSubscriptionDocument} {...props} />
    );
    
export type CreateStorageSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateStorageSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateStorageSubscriptionMutation,
  CreateStorageSubscriptionMutationVariables,
  CreateStorageSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables, CreateStorageSubscriptionProps<TChildProps, TDataName>>(CreateStorageSubscriptionDocument, {
      alias: 'createStorageSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateStorageSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateStorageSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStorageSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStorageSubscriptionMutation, { data, loading, error }] = useCreateStorageSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateStorageSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>(CreateStorageSubscriptionDocument, options);
      }
export type CreateStorageSubscriptionMutationHookResult = ReturnType<typeof useCreateStorageSubscriptionMutation>;
export type CreateStorageSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateStorageSubscriptionMutation>;
export type CreateStorageSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>;
export const CreateInferenceSubscriptionDocument = gql`
    mutation createInferenceSubscription($organizationId: ID, $paymentMethod: String, $clientMutationId: String) {
  createInferenceSubscription(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateInferenceSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>;
export type CreateInferenceSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>, 'mutation'>;

    export const CreateInferenceSubscriptionComponent = (props: CreateInferenceSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables> mutation={CreateInferenceSubscriptionDocument} {...props} />
    );
    
export type CreateInferenceSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateInferenceSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateInferenceSubscriptionMutation,
  CreateInferenceSubscriptionMutationVariables,
  CreateInferenceSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables, CreateInferenceSubscriptionProps<TChildProps, TDataName>>(CreateInferenceSubscriptionDocument, {
      alias: 'createInferenceSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateInferenceSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateInferenceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInferenceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInferenceSubscriptionMutation, { data, loading, error }] = useCreateInferenceSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateInferenceSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>(CreateInferenceSubscriptionDocument, options);
      }
export type CreateInferenceSubscriptionMutationHookResult = ReturnType<typeof useCreateInferenceSubscriptionMutation>;
export type CreateInferenceSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateInferenceSubscriptionMutation>;
export type CreateInferenceSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>;
export const SubscriptionPlansDocument = gql`
    query SubscriptionPlans {
  plans {
    id
    name
    displayName
    stripePlanId
    maxSeats
    defaultPrivileges
    planType
    planVisibility
    unitPrice
    billingInterval
  }
}
    `;
export type SubscriptionPlansComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>, 'query'>;

    export const SubscriptionPlansComponent = (props: SubscriptionPlansComponentProps) => (
      <ApolloReactComponents.Query<SubscriptionPlansQuery, SubscriptionPlansQueryVariables> query={SubscriptionPlansDocument} {...props} />
    );
    
export type SubscriptionPlansProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>
    } & TChildProps;
export function withSubscriptionPlans<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubscriptionPlansQuery,
  SubscriptionPlansQueryVariables,
  SubscriptionPlansProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SubscriptionPlansQuery, SubscriptionPlansQueryVariables, SubscriptionPlansProps<TChildProps, TDataName>>(SubscriptionPlansDocument, {
      alias: 'subscriptionPlans',
      ...operationOptions
    });
};

/**
 * __useSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionPlansQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
      }
export function useSubscriptionPlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
        }
// @ts-ignore
export function useSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>;
export function useSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SubscriptionPlansQuery | undefined, SubscriptionPlansQueryVariables>;
export function useSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
        }
export type SubscriptionPlansQueryHookResult = ReturnType<typeof useSubscriptionPlansQuery>;
export type SubscriptionPlansLazyQueryHookResult = ReturnType<typeof useSubscriptionPlansLazyQuery>;
export type SubscriptionPlansSuspenseQueryHookResult = ReturnType<typeof useSubscriptionPlansSuspenseQuery>;
export type SubscriptionPlansQueryResult = ApolloReactCommon.QueryResult<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>;
export const UpsertSweepDocument = gql`
    mutation upsertSweep($id: ID, $description: String, $state: String, $displayName: String, $config: String, $entityName: String, $projectName: String, $priorRunsFilters: JSONString, $launchScheduler: JSONString) {
  upsertSweep(
    input: {id: $id, description: $description, state: $state, displayName: $displayName, config: $config, entityName: $entityName, projectName: $projectName, priorRunsFilters: $priorRunsFilters, launchScheduler: $launchScheduler}
  ) {
    sweep {
      id
      name
      displayName
      description
      state
    }
    inserted
    insertedPriorRuns
  }
}
    `;
export type UpsertSweepMutationFn = ApolloReactCommon.MutationFunction<UpsertSweepMutation, UpsertSweepMutationVariables>;
export type UpsertSweepComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertSweepMutation, UpsertSweepMutationVariables>, 'mutation'>;

    export const UpsertSweepComponent = (props: UpsertSweepComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertSweepMutation, UpsertSweepMutationVariables> mutation={UpsertSweepDocument} {...props} />
    );
    
export type UpsertSweepProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertSweepMutation, UpsertSweepMutationVariables>
    } & TChildProps;
export function withUpsertSweep<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertSweepMutation,
  UpsertSweepMutationVariables,
  UpsertSweepProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertSweepMutation, UpsertSweepMutationVariables, UpsertSweepProps<TChildProps, TDataName>>(UpsertSweepDocument, {
      alias: 'upsertSweep',
      ...operationOptions
    });
};

/**
 * __useUpsertSweepMutation__
 *
 * To run a mutation, you first call `useUpsertSweepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSweepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSweepMutation, { data, loading, error }] = useUpsertSweepMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      state: // value for 'state'
 *      displayName: // value for 'displayName'
 *      config: // value for 'config'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      priorRunsFilters: // value for 'priorRunsFilters'
 *      launchScheduler: // value for 'launchScheduler'
 *   },
 * });
 */
export function useUpsertSweepMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertSweepMutation, UpsertSweepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertSweepMutation, UpsertSweepMutationVariables>(UpsertSweepDocument, options);
      }
export type UpsertSweepMutationHookResult = ReturnType<typeof useUpsertSweepMutation>;
export type UpsertSweepMutationResult = ApolloReactCommon.MutationResult<UpsertSweepMutation>;
export type UpsertSweepMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertSweepMutation, UpsertSweepMutationVariables>;
export const DeleteSweepsDocument = gql`
    mutation deleteSweeps($ids: [ID!]!, $deleteRuns: Boolean!) {
  deleteSweeps(input: {ids: $ids, deleteRuns: $deleteRuns}) {
    affectedAgents
    affectedRuns
  }
}
    `;
export type DeleteSweepsMutationFn = ApolloReactCommon.MutationFunction<DeleteSweepsMutation, DeleteSweepsMutationVariables>;
export type DeleteSweepsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteSweepsMutation, DeleteSweepsMutationVariables>, 'mutation'>;

    export const DeleteSweepsComponent = (props: DeleteSweepsComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteSweepsMutation, DeleteSweepsMutationVariables> mutation={DeleteSweepsDocument} {...props} />
    );
    
export type DeleteSweepsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteSweepsMutation, DeleteSweepsMutationVariables>
    } & TChildProps;
export function withDeleteSweeps<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteSweepsMutation,
  DeleteSweepsMutationVariables,
  DeleteSweepsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteSweepsMutation, DeleteSweepsMutationVariables, DeleteSweepsProps<TChildProps, TDataName>>(DeleteSweepsDocument, {
      alias: 'deleteSweeps',
      ...operationOptions
    });
};

/**
 * __useDeleteSweepsMutation__
 *
 * To run a mutation, you first call `useDeleteSweepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSweepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSweepsMutation, { data, loading, error }] = useDeleteSweepsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      deleteRuns: // value for 'deleteRuns'
 *   },
 * });
 */
export function useDeleteSweepsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSweepsMutation, DeleteSweepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSweepsMutation, DeleteSweepsMutationVariables>(DeleteSweepsDocument, options);
      }
export type DeleteSweepsMutationHookResult = ReturnType<typeof useDeleteSweepsMutation>;
export type DeleteSweepsMutationResult = ApolloReactCommon.MutationResult<DeleteSweepsMutation>;
export type DeleteSweepsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSweepsMutation, DeleteSweepsMutationVariables>;
export const GetTaskDocument = gql`
    query GetTask($id: ID!) {
  task(id: $id) {
    id
    name
    __typename
    state
    progress
    createdAt
    updatedAt
    type
    result
  }
}
    `;
export type GetTaskComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTaskQuery, GetTaskQueryVariables>, 'query'> & ({ variables: GetTaskQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetTaskComponent = (props: GetTaskComponentProps) => (
      <ApolloReactComponents.Query<GetTaskQuery, GetTaskQueryVariables> query={GetTaskDocument} {...props} />
    );
    
export type GetTaskProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTaskQuery, GetTaskQueryVariables>
    } & TChildProps;
export function withGetTask<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTaskQuery,
  GetTaskQueryVariables,
  GetTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTaskQuery, GetTaskQueryVariables, GetTaskProps<TChildProps, TDataName>>(GetTaskDocument, {
      alias: 'getTask',
      ...operationOptions
    });
};

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables> & ({ variables: GetTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
// @ts-ignore
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTaskQuery, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTaskQuery | undefined, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = ApolloReactCommon.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const EntityIsTeamDocument = gql`
    query EntityIsTeam($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
  }
}
    `;
export type EntityIsTeamComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>, 'query'>;

    export const EntityIsTeamComponent = (props: EntityIsTeamComponentProps) => (
      <ApolloReactComponents.Query<EntityIsTeamQuery, EntityIsTeamQueryVariables> query={EntityIsTeamDocument} {...props} />
    );
    
export type EntityIsTeamProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityIsTeamQuery, EntityIsTeamQueryVariables>
    } & TChildProps;
export function withEntityIsTeam<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityIsTeamQuery,
  EntityIsTeamQueryVariables,
  EntityIsTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityIsTeamQuery, EntityIsTeamQueryVariables, EntityIsTeamProps<TChildProps, TDataName>>(EntityIsTeamDocument, {
      alias: 'entityIsTeam',
      ...operationOptions
    });
};

/**
 * __useEntityIsTeamQuery__
 *
 * To run a query within a React component, call `useEntityIsTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityIsTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityIsTeamQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityIsTeamQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityIsTeamQuery, EntityIsTeamQueryVariables>(EntityIsTeamDocument, options);
      }
export function useEntityIsTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityIsTeamQuery, EntityIsTeamQueryVariables>(EntityIsTeamDocument, options);
        }
// @ts-ignore
export function useEntityIsTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityIsTeamQuery, EntityIsTeamQueryVariables>;
export function useEntityIsTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityIsTeamQuery | undefined, EntityIsTeamQueryVariables>;
export function useEntityIsTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityIsTeamQuery, EntityIsTeamQueryVariables>(EntityIsTeamDocument, options);
        }
export type EntityIsTeamQueryHookResult = ReturnType<typeof useEntityIsTeamQuery>;
export type EntityIsTeamLazyQueryHookResult = ReturnType<typeof useEntityIsTeamLazyQuery>;
export type EntityIsTeamSuspenseQueryHookResult = ReturnType<typeof useEntityIsTeamSuspenseQuery>;
export type EntityIsTeamQueryResult = ApolloReactCommon.QueryResult<EntityIsTeamQuery, EntityIsTeamQueryVariables>;
export const BasicTeamOrganizationDocument = gql`
    query BasicTeamOrganization($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
    available
    organization {
      id
      name
    }
  }
}
    `;
export type BasicTeamOrganizationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>, 'query'>;

    export const BasicTeamOrganizationComponent = (props: BasicTeamOrganizationComponentProps) => (
      <ApolloReactComponents.Query<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables> query={BasicTeamOrganizationDocument} {...props} />
    );
    
export type BasicTeamOrganizationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>
    } & TChildProps;
export function withBasicTeamOrganization<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BasicTeamOrganizationQuery,
  BasicTeamOrganizationQueryVariables,
  BasicTeamOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables, BasicTeamOrganizationProps<TChildProps, TDataName>>(BasicTeamOrganizationDocument, {
      alias: 'basicTeamOrganization',
      ...operationOptions
    });
};

/**
 * __useBasicTeamOrganizationQuery__
 *
 * To run a query within a React component, call `useBasicTeamOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicTeamOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicTeamOrganizationQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useBasicTeamOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>(BasicTeamOrganizationDocument, options);
      }
export function useBasicTeamOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>(BasicTeamOrganizationDocument, options);
        }
// @ts-ignore
export function useBasicTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>;
export function useBasicTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BasicTeamOrganizationQuery | undefined, BasicTeamOrganizationQueryVariables>;
export function useBasicTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>(BasicTeamOrganizationDocument, options);
        }
export type BasicTeamOrganizationQueryHookResult = ReturnType<typeof useBasicTeamOrganizationQuery>;
export type BasicTeamOrganizationLazyQueryHookResult = ReturnType<typeof useBasicTeamOrganizationLazyQuery>;
export type BasicTeamOrganizationSuspenseQueryHookResult = ReturnType<typeof useBasicTeamOrganizationSuspenseQuery>;
export type BasicTeamOrganizationQueryResult = ApolloReactCommon.QueryResult<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>;
export const TeamOrganizationDocument = gql`
    query TeamOrganization($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
    computeHours
    settings {
      openToMatchingOrgEmailDomainUsers
      membersCanInvite
      disableMagicLinkSharing
    }
    organization {
      id
      name
      flags
      usedSeats
      orgType
      roles {
        ID
        name
        description
        inheritedFrom {
          name
        }
      }
      members {
        orgID
        id
        username
        role
        modelsSeat
        weaveRole
      }
      seatAvailability {
        seats
        viewOnlySeats
      }
      subscriptions {
        id
        plan {
          id
          name
          planType
          unitPrice
          billingInterval
          defaultPrivileges
          maxSeats
        }
        privileges
        subscriptionType
        billingPeriodStart
        billingPeriodEnd
        availableSeatsToPurchase
        seats
      }
    }
  }
}
    `;
export type TeamOrganizationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>, 'query'>;

    export const TeamOrganizationComponent = (props: TeamOrganizationComponentProps) => (
      <ApolloReactComponents.Query<TeamOrganizationQuery, TeamOrganizationQueryVariables> query={TeamOrganizationDocument} {...props} />
    );
    
export type TeamOrganizationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamOrganizationQuery, TeamOrganizationQueryVariables>
    } & TChildProps;
export function withTeamOrganization<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamOrganizationQuery,
  TeamOrganizationQueryVariables,
  TeamOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamOrganizationQuery, TeamOrganizationQueryVariables, TeamOrganizationProps<TChildProps, TDataName>>(TeamOrganizationDocument, {
      alias: 'teamOrganization',
      ...operationOptions
    });
};

/**
 * __useTeamOrganizationQuery__
 *
 * To run a query within a React component, call `useTeamOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrganizationQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamOrganizationQuery, TeamOrganizationQueryVariables>(TeamOrganizationDocument, options);
      }
export function useTeamOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamOrganizationQuery, TeamOrganizationQueryVariables>(TeamOrganizationDocument, options);
        }
// @ts-ignore
export function useTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationQuery, TeamOrganizationQueryVariables>;
export function useTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationQuery | undefined, TeamOrganizationQueryVariables>;
export function useTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamOrganizationQuery, TeamOrganizationQueryVariables>(TeamOrganizationDocument, options);
        }
export type TeamOrganizationQueryHookResult = ReturnType<typeof useTeamOrganizationQuery>;
export type TeamOrganizationLazyQueryHookResult = ReturnType<typeof useTeamOrganizationLazyQuery>;
export type TeamOrganizationSuspenseQueryHookResult = ReturnType<typeof useTeamOrganizationSuspenseQuery>;
export type TeamOrganizationQueryResult = ApolloReactCommon.QueryResult<TeamOrganizationQuery, TeamOrganizationQueryVariables>;
export const TeamOrganizationRolesDocument = gql`
    query TeamOrganizationRoles($entityName: String) {
  entity(name: $entityName) {
    id
    settings {
      membersCanInvite
    }
    members {
      id
      username
      role
    }
    organization {
      id
      seatAvailability {
        viewOnlySeats
      }
      roles {
        ID
        name
        description
        inheritedFrom {
          name
        }
      }
      members {
        id
        username
        role
      }
    }
  }
}
    `;
export type TeamOrganizationRolesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>, 'query'>;

    export const TeamOrganizationRolesComponent = (props: TeamOrganizationRolesComponentProps) => (
      <ApolloReactComponents.Query<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables> query={TeamOrganizationRolesDocument} {...props} />
    );
    
export type TeamOrganizationRolesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>
    } & TChildProps;
export function withTeamOrganizationRoles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamOrganizationRolesQuery,
  TeamOrganizationRolesQueryVariables,
  TeamOrganizationRolesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables, TeamOrganizationRolesProps<TChildProps, TDataName>>(TeamOrganizationRolesDocument, {
      alias: 'teamOrganizationRoles',
      ...operationOptions
    });
};

/**
 * __useTeamOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useTeamOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrganizationRolesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamOrganizationRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>(TeamOrganizationRolesDocument, options);
      }
export function useTeamOrganizationRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>(TeamOrganizationRolesDocument, options);
        }
// @ts-ignore
export function useTeamOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>;
export function useTeamOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationRolesQuery | undefined, TeamOrganizationRolesQueryVariables>;
export function useTeamOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>(TeamOrganizationRolesDocument, options);
        }
export type TeamOrganizationRolesQueryHookResult = ReturnType<typeof useTeamOrganizationRolesQuery>;
export type TeamOrganizationRolesLazyQueryHookResult = ReturnType<typeof useTeamOrganizationRolesLazyQuery>;
export type TeamOrganizationRolesSuspenseQueryHookResult = ReturnType<typeof useTeamOrganizationRolesSuspenseQuery>;
export type TeamOrganizationRolesQueryResult = ApolloReactCommon.QueryResult<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>;
export const TeamOrganizationMembersDocument = gql`
    query TeamOrganizationMembers($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
    organizationId
  }
}
    `;
export type TeamOrganizationMembersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>, 'query'>;

    export const TeamOrganizationMembersComponent = (props: TeamOrganizationMembersComponentProps) => (
      <ApolloReactComponents.Query<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables> query={TeamOrganizationMembersDocument} {...props} />
    );
    
export type TeamOrganizationMembersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>
    } & TChildProps;
export function withTeamOrganizationMembers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamOrganizationMembersQuery,
  TeamOrganizationMembersQueryVariables,
  TeamOrganizationMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables, TeamOrganizationMembersProps<TChildProps, TDataName>>(TeamOrganizationMembersDocument, {
      alias: 'teamOrganizationMembers',
      ...operationOptions
    });
};

/**
 * __useTeamOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useTeamOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrganizationMembersQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamOrganizationMembersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>(TeamOrganizationMembersDocument, options);
      }
export function useTeamOrganizationMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>(TeamOrganizationMembersDocument, options);
        }
// @ts-ignore
export function useTeamOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>;
export function useTeamOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationMembersQuery | undefined, TeamOrganizationMembersQueryVariables>;
export function useTeamOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>(TeamOrganizationMembersDocument, options);
        }
export type TeamOrganizationMembersQueryHookResult = ReturnType<typeof useTeamOrganizationMembersQuery>;
export type TeamOrganizationMembersLazyQueryHookResult = ReturnType<typeof useTeamOrganizationMembersLazyQuery>;
export type TeamOrganizationMembersSuspenseQueryHookResult = ReturnType<typeof useTeamOrganizationMembersSuspenseQuery>;
export type TeamOrganizationMembersQueryResult = ApolloReactCommon.QueryResult<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>;
export const TeamPageProjectsTwoDocument = gql`
    query TeamPageProjectsTwo($entityName: String!, $first: Int = 10) {
  entity(name: $entityName) {
    id
    organizationId
    projects(order: "-created_at", first: $first) {
      edges {
        node {
          id
          name
          entityName
          description
          totalRuns
          lastActive
        }
      }
    }
  }
}
    `;
export type TeamPageProjectsTwoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>, 'query'> & ({ variables: TeamPageProjectsTwoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamPageProjectsTwoComponent = (props: TeamPageProjectsTwoComponentProps) => (
      <ApolloReactComponents.Query<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables> query={TeamPageProjectsTwoDocument} {...props} />
    );
    
export type TeamPageProjectsTwoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>
    } & TChildProps;
export function withTeamPageProjectsTwo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamPageProjectsTwoQuery,
  TeamPageProjectsTwoQueryVariables,
  TeamPageProjectsTwoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables, TeamPageProjectsTwoProps<TChildProps, TDataName>>(TeamPageProjectsTwoDocument, {
      alias: 'teamPageProjectsTwo',
      ...operationOptions
    });
};

/**
 * __useTeamPageProjectsTwoQuery__
 *
 * To run a query within a React component, call `useTeamPageProjectsTwoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageProjectsTwoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageProjectsTwoQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useTeamPageProjectsTwoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables> & ({ variables: TeamPageProjectsTwoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>(TeamPageProjectsTwoDocument, options);
      }
export function useTeamPageProjectsTwoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>(TeamPageProjectsTwoDocument, options);
        }
// @ts-ignore
export function useTeamPageProjectsTwoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>;
export function useTeamPageProjectsTwoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageProjectsTwoQuery | undefined, TeamPageProjectsTwoQueryVariables>;
export function useTeamPageProjectsTwoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>(TeamPageProjectsTwoDocument, options);
        }
export type TeamPageProjectsTwoQueryHookResult = ReturnType<typeof useTeamPageProjectsTwoQuery>;
export type TeamPageProjectsTwoLazyQueryHookResult = ReturnType<typeof useTeamPageProjectsTwoLazyQuery>;
export type TeamPageProjectsTwoSuspenseQueryHookResult = ReturnType<typeof useTeamPageProjectsTwoSuspenseQuery>;
export type TeamPageProjectsTwoQueryResult = ApolloReactCommon.QueryResult<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>;
export const TeamPageProjectsDocument = gql`
    query TeamPageProjects($entityName: String!) {
  entity(name: $entityName) {
    id
    organizationId
    projects(order: "-created_at", first: 100) {
      edges {
        node {
          id
          name
          entityName
          access
          allViews(viewType: "runs", first: 10000) {
            edges {
              node {
                id
                ...ReportsTableFragment
              }
            }
          }
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;
export type TeamPageProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>, 'query'> & ({ variables: TeamPageProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamPageProjectsComponent = (props: TeamPageProjectsComponentProps) => (
      <ApolloReactComponents.Query<TeamPageProjectsQuery, TeamPageProjectsQueryVariables> query={TeamPageProjectsDocument} {...props} />
    );
    
export type TeamPageProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>
    } & TChildProps;
export function withTeamPageProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamPageProjectsQuery,
  TeamPageProjectsQueryVariables,
  TeamPageProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamPageProjectsQuery, TeamPageProjectsQueryVariables, TeamPageProjectsProps<TChildProps, TDataName>>(TeamPageProjectsDocument, {
      alias: 'teamPageProjects',
      ...operationOptions
    });
};

/**
 * __useTeamPageProjectsQuery__
 *
 * To run a query within a React component, call `useTeamPageProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamPageProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables> & ({ variables: TeamPageProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>(TeamPageProjectsDocument, options);
      }
export function useTeamPageProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>(TeamPageProjectsDocument, options);
        }
// @ts-ignore
export function useTeamPageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>;
export function useTeamPageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageProjectsQuery | undefined, TeamPageProjectsQueryVariables>;
export function useTeamPageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>(TeamPageProjectsDocument, options);
        }
export type TeamPageProjectsQueryHookResult = ReturnType<typeof useTeamPageProjectsQuery>;
export type TeamPageProjectsLazyQueryHookResult = ReturnType<typeof useTeamPageProjectsLazyQuery>;
export type TeamPageProjectsSuspenseQueryHookResult = ReturnType<typeof useTeamPageProjectsSuspenseQuery>;
export type TeamPageProjectsQueryResult = ApolloReactCommon.QueryResult<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>;
export const FetchTeamProfilePageProjectsByIDsDocument = gql`
    query FetchTeamProfilePageProjectsByIDs($entityName: String!, $projectIDs: [ID!]!) {
  projects(entityName: $entityName, projectIDs: $projectIDs) {
    edges {
      node {
        id
        name
        entityName
        access
        lastActive
        runCount
        user {
          id
          username
        }
      }
    }
  }
}
    `;
export type FetchTeamProfilePageProjectsByIDsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>, 'query'> & ({ variables: FetchTeamProfilePageProjectsByIDsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchTeamProfilePageProjectsByIDsComponent = (props: FetchTeamProfilePageProjectsByIDsComponentProps) => (
      <ApolloReactComponents.Query<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables> query={FetchTeamProfilePageProjectsByIDsDocument} {...props} />
    );
    
export type FetchTeamProfilePageProjectsByIDsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>
    } & TChildProps;
export function withFetchTeamProfilePageProjectsByIDs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchTeamProfilePageProjectsByIDsQuery,
  FetchTeamProfilePageProjectsByIDsQueryVariables,
  FetchTeamProfilePageProjectsByIDsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables, FetchTeamProfilePageProjectsByIDsProps<TChildProps, TDataName>>(FetchTeamProfilePageProjectsByIDsDocument, {
      alias: 'fetchTeamProfilePageProjectsByIDs',
      ...operationOptions
    });
};

/**
 * __useFetchTeamProfilePageProjectsByIDsQuery__
 *
 * To run a query within a React component, call `useFetchTeamProfilePageProjectsByIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTeamProfilePageProjectsByIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTeamProfilePageProjectsByIDsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectIDs: // value for 'projectIDs'
 *   },
 * });
 */
export function useFetchTeamProfilePageProjectsByIDsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables> & ({ variables: FetchTeamProfilePageProjectsByIDsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>(FetchTeamProfilePageProjectsByIDsDocument, options);
      }
export function useFetchTeamProfilePageProjectsByIDsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>(FetchTeamProfilePageProjectsByIDsDocument, options);
        }
// @ts-ignore
export function useFetchTeamProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>;
export function useFetchTeamProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchTeamProfilePageProjectsByIDsQuery | undefined, FetchTeamProfilePageProjectsByIDsQueryVariables>;
export function useFetchTeamProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>(FetchTeamProfilePageProjectsByIDsDocument, options);
        }
export type FetchTeamProfilePageProjectsByIDsQueryHookResult = ReturnType<typeof useFetchTeamProfilePageProjectsByIDsQuery>;
export type FetchTeamProfilePageProjectsByIDsLazyQueryHookResult = ReturnType<typeof useFetchTeamProfilePageProjectsByIDsLazyQuery>;
export type FetchTeamProfilePageProjectsByIDsSuspenseQueryHookResult = ReturnType<typeof useFetchTeamProfilePageProjectsByIDsSuspenseQuery>;
export type FetchTeamProfilePageProjectsByIDsQueryResult = ApolloReactCommon.QueryResult<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>;
export const TeamPageDocument = gql`
    query TeamPage($entityName: String!, $workflowsAdminType: WorkflowsAdminType!) {
  entity(name: $entityName) {
    available
    claimingEntity {
      id
      name
    }
    id
    isTeam
    members {
      id
      admin
      pending
      email
      username
      name
      photoUrl
      accountType
      apiKey
      apiKeyCount
      role
      memberRole {
        ID
        name
      }
      serviceAccountAuthMethod
    }
    memberCount
    name
    organizationId
    invites {
      edges {
        node {
          id
          email
          fromUser {
            id
            username
          }
        }
      }
    }
    photoUrl
    projects(first: 1) {
      edges {
        node {
          id
        }
      }
    }
    projectCount
    readOnly
    workflowsAdmins(adminType: $workflowsAdminType) {
      id
      username
      name
      email
    }
    publicQueueLaunchAgents {
      id
      username
      name
      email
    }
    protectedAliases(adminType: $workflowsAdminType)
  }
}
    `;
export type TeamPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamPageQuery, TeamPageQueryVariables>, 'query'> & ({ variables: TeamPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamPageComponent = (props: TeamPageComponentProps) => (
      <ApolloReactComponents.Query<TeamPageQuery, TeamPageQueryVariables> query={TeamPageDocument} {...props} />
    );
    
export type TeamPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamPageQuery, TeamPageQueryVariables>
    } & TChildProps;
export function withTeamPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamPageQuery,
  TeamPageQueryVariables,
  TeamPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamPageQuery, TeamPageQueryVariables, TeamPageProps<TChildProps, TDataName>>(TeamPageDocument, {
      alias: 'teamPage',
      ...operationOptions
    });
};

/**
 * __useTeamPageQuery__
 *
 * To run a query within a React component, call `useTeamPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      workflowsAdminType: // value for 'workflowsAdminType'
 *   },
 * });
 */
export function useTeamPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageQuery, TeamPageQueryVariables> & ({ variables: TeamPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
      }
export function useTeamPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
        }
// @ts-ignore
export function useTeamPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageQuery, TeamPageQueryVariables>;
export function useTeamPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageQuery | undefined, TeamPageQueryVariables>;
export function useTeamPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
        }
export type TeamPageQueryHookResult = ReturnType<typeof useTeamPageQuery>;
export type TeamPageLazyQueryHookResult = ReturnType<typeof useTeamPageLazyQuery>;
export type TeamPageSuspenseQueryHookResult = ReturnType<typeof useTeamPageSuspenseQuery>;
export type TeamPageQueryResult = ApolloReactCommon.QueryResult<TeamPageQuery, TeamPageQueryVariables>;
export const AvailableTeamDocument = gql`
    query availableTeam($teamName: String!) {
  entity(name: $teamName) {
    id
    available
  }
}
    `;
export type AvailableTeamComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AvailableTeamQuery, AvailableTeamQueryVariables>, 'query'> & ({ variables: AvailableTeamQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AvailableTeamComponent = (props: AvailableTeamComponentProps) => (
      <ApolloReactComponents.Query<AvailableTeamQuery, AvailableTeamQueryVariables> query={AvailableTeamDocument} {...props} />
    );
    
export type AvailableTeamProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AvailableTeamQuery, AvailableTeamQueryVariables>
    } & TChildProps;
export function withAvailableTeam<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AvailableTeamQuery,
  AvailableTeamQueryVariables,
  AvailableTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AvailableTeamQuery, AvailableTeamQueryVariables, AvailableTeamProps<TChildProps, TDataName>>(AvailableTeamDocument, {
      alias: 'availableTeam',
      ...operationOptions
    });
};

/**
 * __useAvailableTeamQuery__
 *
 * To run a query within a React component, call `useAvailableTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTeamQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useAvailableTeamQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables> & ({ variables: AvailableTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableTeamQuery, AvailableTeamQueryVariables>(AvailableTeamDocument, options);
      }
export function useAvailableTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableTeamQuery, AvailableTeamQueryVariables>(AvailableTeamDocument, options);
        }
// @ts-ignore
export function useAvailableTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableTeamQuery, AvailableTeamQueryVariables>;
export function useAvailableTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableTeamQuery | undefined, AvailableTeamQueryVariables>;
export function useAvailableTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableTeamQuery, AvailableTeamQueryVariables>(AvailableTeamDocument, options);
        }
export type AvailableTeamQueryHookResult = ReturnType<typeof useAvailableTeamQuery>;
export type AvailableTeamLazyQueryHookResult = ReturnType<typeof useAvailableTeamLazyQuery>;
export type AvailableTeamSuspenseQueryHookResult = ReturnType<typeof useAvailableTeamSuspenseQuery>;
export type AvailableTeamQueryResult = ApolloReactCommon.QueryResult<AvailableTeamQuery, AvailableTeamQueryVariables>;
export const AvailableOrgDocument = gql`
    query availableOrg($name: String!) {
  organization(name: $name) {
    id
    available
  }
}
    `;
export type AvailableOrgComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AvailableOrgQuery, AvailableOrgQueryVariables>, 'query'> & ({ variables: AvailableOrgQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AvailableOrgComponent = (props: AvailableOrgComponentProps) => (
      <ApolloReactComponents.Query<AvailableOrgQuery, AvailableOrgQueryVariables> query={AvailableOrgDocument} {...props} />
    );
    
export type AvailableOrgProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AvailableOrgQuery, AvailableOrgQueryVariables>
    } & TChildProps;
export function withAvailableOrg<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AvailableOrgQuery,
  AvailableOrgQueryVariables,
  AvailableOrgProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AvailableOrgQuery, AvailableOrgQueryVariables, AvailableOrgProps<TChildProps, TDataName>>(AvailableOrgDocument, {
      alias: 'availableOrg',
      ...operationOptions
    });
};

/**
 * __useAvailableOrgQuery__
 *
 * To run a query within a React component, call `useAvailableOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableOrgQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAvailableOrgQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables> & ({ variables: AvailableOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableOrgQuery, AvailableOrgQueryVariables>(AvailableOrgDocument, options);
      }
export function useAvailableOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableOrgQuery, AvailableOrgQueryVariables>(AvailableOrgDocument, options);
        }
// @ts-ignore
export function useAvailableOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableOrgQuery, AvailableOrgQueryVariables>;
export function useAvailableOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableOrgQuery | undefined, AvailableOrgQueryVariables>;
export function useAvailableOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableOrgQuery, AvailableOrgQueryVariables>(AvailableOrgDocument, options);
        }
export type AvailableOrgQueryHookResult = ReturnType<typeof useAvailableOrgQuery>;
export type AvailableOrgLazyQueryHookResult = ReturnType<typeof useAvailableOrgLazyQuery>;
export type AvailableOrgSuspenseQueryHookResult = ReturnType<typeof useAvailableOrgSuspenseQuery>;
export type AvailableOrgQueryResult = ApolloReactCommon.QueryResult<AvailableOrgQuery, AvailableOrgQueryVariables>;
export const OrganizationStorageBucketInfosDocument = gql`
    query organizationStorageBucketInfos($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    teams {
      id
      settings {
        storageBucketInfo {
          ID
          provider
          name
          kmsKeyID
          awsExternalID
          path
        }
      }
    }
  }
}
    `;
export type OrganizationStorageBucketInfosComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>, 'query'> & ({ variables: OrganizationStorageBucketInfosQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationStorageBucketInfosComponent = (props: OrganizationStorageBucketInfosComponentProps) => (
      <ApolloReactComponents.Query<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables> query={OrganizationStorageBucketInfosDocument} {...props} />
    );
    
export type OrganizationStorageBucketInfosProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>
    } & TChildProps;
export function withOrganizationStorageBucketInfos<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationStorageBucketInfosQuery,
  OrganizationStorageBucketInfosQueryVariables,
  OrganizationStorageBucketInfosProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables, OrganizationStorageBucketInfosProps<TChildProps, TDataName>>(OrganizationStorageBucketInfosDocument, {
      alias: 'organizationStorageBucketInfos',
      ...operationOptions
    });
};

/**
 * __useOrganizationStorageBucketInfosQuery__
 *
 * To run a query within a React component, call `useOrganizationStorageBucketInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStorageBucketInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStorageBucketInfosQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationStorageBucketInfosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables> & ({ variables: OrganizationStorageBucketInfosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>(OrganizationStorageBucketInfosDocument, options);
      }
export function useOrganizationStorageBucketInfosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>(OrganizationStorageBucketInfosDocument, options);
        }
// @ts-ignore
export function useOrganizationStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>;
export function useOrganizationStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationStorageBucketInfosQuery | undefined, OrganizationStorageBucketInfosQueryVariables>;
export function useOrganizationStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>(OrganizationStorageBucketInfosDocument, options);
        }
export type OrganizationStorageBucketInfosQueryHookResult = ReturnType<typeof useOrganizationStorageBucketInfosQuery>;
export type OrganizationStorageBucketInfosLazyQueryHookResult = ReturnType<typeof useOrganizationStorageBucketInfosLazyQuery>;
export type OrganizationStorageBucketInfosSuspenseQueryHookResult = ReturnType<typeof useOrganizationStorageBucketInfosSuspenseQuery>;
export type OrganizationStorageBucketInfosQueryResult = ApolloReactCommon.QueryResult<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>;
export const StorageBucketInfosDocument = gql`
    query storageBucketInfos {
  entities {
    edges {
      node {
        id
        settings {
          storageBucketInfo {
            ID
            provider
            name
            kmsKeyID
            awsExternalID
            path
          }
        }
      }
    }
  }
}
    `;
export type StorageBucketInfosComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>, 'query'>;

    export const StorageBucketInfosComponent = (props: StorageBucketInfosComponentProps) => (
      <ApolloReactComponents.Query<StorageBucketInfosQuery, StorageBucketInfosQueryVariables> query={StorageBucketInfosDocument} {...props} />
    );
    
export type StorageBucketInfosProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>
    } & TChildProps;
export function withStorageBucketInfos<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StorageBucketInfosQuery,
  StorageBucketInfosQueryVariables,
  StorageBucketInfosProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StorageBucketInfosQuery, StorageBucketInfosQueryVariables, StorageBucketInfosProps<TChildProps, TDataName>>(StorageBucketInfosDocument, {
      alias: 'storageBucketInfos',
      ...operationOptions
    });
};

/**
 * __useStorageBucketInfosQuery__
 *
 * To run a query within a React component, call `useStorageBucketInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageBucketInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageBucketInfosQuery({
 *   variables: {
 *   },
 * });
 */
export function useStorageBucketInfosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>(StorageBucketInfosDocument, options);
      }
export function useStorageBucketInfosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>(StorageBucketInfosDocument, options);
        }
// @ts-ignore
export function useStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>;
export function useStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StorageBucketInfosQuery | undefined, StorageBucketInfosQueryVariables>;
export function useStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>(StorageBucketInfosDocument, options);
        }
export type StorageBucketInfosQueryHookResult = ReturnType<typeof useStorageBucketInfosQuery>;
export type StorageBucketInfosLazyQueryHookResult = ReturnType<typeof useStorageBucketInfosLazyQuery>;
export type StorageBucketInfosSuspenseQueryHookResult = ReturnType<typeof useStorageBucketInfosSuspenseQuery>;
export type StorageBucketInfosQueryResult = ApolloReactCommon.QueryResult<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($teamName: String!, $organizationId: String, $teamAdminUserName: String, $storageBucketInfo: StorageBucketInfoInput) {
  createTeam(
    input: {teamName: $teamName, organizationId: $organizationId, teamAdminUserName: $teamAdminUserName, storageBucketInfo: $storageBucketInfo}
  ) {
    entity {
      id
      name
      available
      photoUrl
      limits
    }
  }
}
    `;
export type CreateTeamMutationFn = ApolloReactCommon.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;
export type CreateTeamComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateTeamMutation, CreateTeamMutationVariables>, 'mutation'>;

    export const CreateTeamComponent = (props: CreateTeamComponentProps) => (
      <ApolloReactComponents.Mutation<CreateTeamMutation, CreateTeamMutationVariables> mutation={CreateTeamDocument} {...props} />
    );
    
export type CreateTeamProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>
    } & TChildProps;
export function withCreateTeam<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateTeamMutation,
  CreateTeamMutationVariables,
  CreateTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateTeamMutation, CreateTeamMutationVariables, CreateTeamProps<TChildProps, TDataName>>(CreateTeamDocument, {
      alias: 'createTeam',
      ...operationOptions
    });
};

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      teamName: // value for 'teamName'
 *      organizationId: // value for 'organizationId'
 *      teamAdminUserName: // value for 'teamAdminUserName'
 *      storageBucketInfo: // value for 'storageBucketInfo'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = ApolloReactCommon.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const TestBucketStoreConnectionDocument = gql`
    mutation testBucketStoreConnection($input: StorageBucketInfoInput!) {
  testBucketStoreConnection(input: $input) {
    message
    severity
  }
}
    `;
export type TestBucketStoreConnectionMutationFn = ApolloReactCommon.MutationFunction<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>;
export type TestBucketStoreConnectionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>, 'mutation'>;

    export const TestBucketStoreConnectionComponent = (props: TestBucketStoreConnectionComponentProps) => (
      <ApolloReactComponents.Mutation<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables> mutation={TestBucketStoreConnectionDocument} {...props} />
    );
    
export type TestBucketStoreConnectionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>
    } & TChildProps;
export function withTestBucketStoreConnection<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TestBucketStoreConnectionMutation,
  TestBucketStoreConnectionMutationVariables,
  TestBucketStoreConnectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables, TestBucketStoreConnectionProps<TChildProps, TDataName>>(TestBucketStoreConnectionDocument, {
      alias: 'testBucketStoreConnection',
      ...operationOptions
    });
};

/**
 * __useTestBucketStoreConnectionMutation__
 *
 * To run a mutation, you first call `useTestBucketStoreConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestBucketStoreConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testBucketStoreConnectionMutation, { data, loading, error }] = useTestBucketStoreConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestBucketStoreConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>(TestBucketStoreConnectionDocument, options);
      }
export type TestBucketStoreConnectionMutationHookResult = ReturnType<typeof useTestBucketStoreConnectionMutation>;
export type TestBucketStoreConnectionMutationResult = ApolloReactCommon.MutationResult<TestBucketStoreConnectionMutation>;
export type TestBucketStoreConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($teamName: String!) {
  deleteTeam(input: {teamName: $teamName}) {
    success
  }
}
    `;
export type DeleteTeamMutationFn = ApolloReactCommon.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;
export type DeleteTeamComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteTeamMutation, DeleteTeamMutationVariables>, 'mutation'>;

    export const DeleteTeamComponent = (props: DeleteTeamComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteTeamMutation, DeleteTeamMutationVariables> mutation={DeleteTeamDocument} {...props} />
    );
    
export type DeleteTeamProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>
    } & TChildProps;
export function withDeleteTeam<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteTeamMutation,
  DeleteTeamMutationVariables,
  DeleteTeamProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteTeamMutation, DeleteTeamMutationVariables, DeleteTeamProps<TChildProps, TDataName>>(DeleteTeamDocument, {
      alias: 'deleteTeam',
      ...operationOptions
    });
};

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = ApolloReactCommon.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const EntityFeatureFlagsDocument = gql`
    query entityFeatureFlags($teamName: String, $rampIDType: RampIDType!) {
  entity(name: $teamName) {
    id
    featureFlags(rampIDType: $rampIDType) {
      rampKey
      isEnabled
    }
  }
}
    `;
export type EntityFeatureFlagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>, 'query'> & ({ variables: EntityFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityFeatureFlagsComponent = (props: EntityFeatureFlagsComponentProps) => (
      <ApolloReactComponents.Query<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables> query={EntityFeatureFlagsDocument} {...props} />
    );
    
export type EntityFeatureFlagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>
    } & TChildProps;
export function withEntityFeatureFlags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityFeatureFlagsQuery,
  EntityFeatureFlagsQueryVariables,
  EntityFeatureFlagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables, EntityFeatureFlagsProps<TChildProps, TDataName>>(EntityFeatureFlagsDocument, {
      alias: 'entityFeatureFlags',
      ...operationOptions
    });
};

/**
 * __useEntityFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useEntityFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityFeatureFlagsQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *      rampIDType: // value for 'rampIDType'
 *   },
 * });
 */
export function useEntityFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables> & ({ variables: EntityFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>(EntityFeatureFlagsDocument, options);
      }
export function useEntityFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>(EntityFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useEntityFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>;
export function useEntityFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityFeatureFlagsQuery | undefined, EntityFeatureFlagsQueryVariables>;
export function useEntityFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>(EntityFeatureFlagsDocument, options);
        }
export type EntityFeatureFlagsQueryHookResult = ReturnType<typeof useEntityFeatureFlagsQuery>;
export type EntityFeatureFlagsLazyQueryHookResult = ReturnType<typeof useEntityFeatureFlagsLazyQuery>;
export type EntityFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useEntityFeatureFlagsSuspenseQuery>;
export type EntityFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>;
export const OrganizationTeamsDocument = gql`
    query organizationTeams($orgName: String!) {
  organization(name: $orgName) {
    id
    teams {
      id
      name
      memberCount
      computeHours
    }
    subscriptions {
      id
      privileges
    }
    members {
      orgID
      id
      username
      role
      user {
        id
        name
        accountType
        ...UserRoleFragment
        teams {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${UserRoleFragmentFragmentDoc}`;
export type OrganizationTeamsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>, 'query'> & ({ variables: OrganizationTeamsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationTeamsComponent = (props: OrganizationTeamsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationTeamsQuery, OrganizationTeamsQueryVariables> query={OrganizationTeamsDocument} {...props} />
    );
    
export type OrganizationTeamsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>
    } & TChildProps;
export function withOrganizationTeams<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationTeamsQuery,
  OrganizationTeamsQueryVariables,
  OrganizationTeamsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationTeamsQuery, OrganizationTeamsQueryVariables, OrganizationTeamsProps<TChildProps, TDataName>>(OrganizationTeamsDocument, {
      alias: 'organizationTeams',
      ...operationOptions
    });
};

/**
 * __useOrganizationTeamsQuery__
 *
 * To run a query within a React component, call `useOrganizationTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTeamsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationTeamsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables> & ({ variables: OrganizationTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
      }
export function useOrganizationTeamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
        }
// @ts-ignore
export function useOrganizationTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>;
export function useOrganizationTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsQuery | undefined, OrganizationTeamsQueryVariables>;
export function useOrganizationTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
        }
export type OrganizationTeamsQueryHookResult = ReturnType<typeof useOrganizationTeamsQuery>;
export type OrganizationTeamsLazyQueryHookResult = ReturnType<typeof useOrganizationTeamsLazyQuery>;
export type OrganizationTeamsSuspenseQueryHookResult = ReturnType<typeof useOrganizationTeamsSuspenseQuery>;
export type OrganizationTeamsQueryResult = ApolloReactCommon.QueryResult<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>;
export const EntityOrganizationDocument = gql`
    query entityOrganization($teamName: String!) {
  entity(name: $teamName) {
    id
    organization {
      id
      name
    }
  }
}
    `;
export type EntityOrganizationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>, 'query'> & ({ variables: EntityOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityOrganizationComponent = (props: EntityOrganizationComponentProps) => (
      <ApolloReactComponents.Query<EntityOrganizationQuery, EntityOrganizationQueryVariables> query={EntityOrganizationDocument} {...props} />
    );
    
export type EntityOrganizationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityOrganizationQuery, EntityOrganizationQueryVariables>
    } & TChildProps;
export function withEntityOrganization<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityOrganizationQuery,
  EntityOrganizationQueryVariables,
  EntityOrganizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityOrganizationQuery, EntityOrganizationQueryVariables, EntityOrganizationProps<TChildProps, TDataName>>(EntityOrganizationDocument, {
      alias: 'entityOrganization',
      ...operationOptions
    });
};

/**
 * __useEntityOrganizationQuery__
 *
 * To run a query within a React component, call `useEntityOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityOrganizationQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useEntityOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables> & ({ variables: EntityOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityOrganizationQuery, EntityOrganizationQueryVariables>(EntityOrganizationDocument, options);
      }
export function useEntityOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityOrganizationQuery, EntityOrganizationQueryVariables>(EntityOrganizationDocument, options);
        }
// @ts-ignore
export function useEntityOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityOrganizationQuery, EntityOrganizationQueryVariables>;
export function useEntityOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityOrganizationQuery | undefined, EntityOrganizationQueryVariables>;
export function useEntityOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityOrganizationQuery, EntityOrganizationQueryVariables>(EntityOrganizationDocument, options);
        }
export type EntityOrganizationQueryHookResult = ReturnType<typeof useEntityOrganizationQuery>;
export type EntityOrganizationLazyQueryHookResult = ReturnType<typeof useEntityOrganizationLazyQuery>;
export type EntityOrganizationSuspenseQueryHookResult = ReturnType<typeof useEntityOrganizationSuspenseQuery>;
export type EntityOrganizationQueryResult = ApolloReactCommon.QueryResult<EntityOrganizationQuery, EntityOrganizationQueryVariables>;
export const UserContextDocument = gql`
    query UserContext {
  viewer {
    id
    views(viewType: "userContext") {
      edges {
        node {
          id
          spec
        }
      }
    }
  }
}
    `;
export type UserContextComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserContextQuery, UserContextQueryVariables>, 'query'>;

    export const UserContextComponent = (props: UserContextComponentProps) => (
      <ApolloReactComponents.Query<UserContextQuery, UserContextQueryVariables> query={UserContextDocument} {...props} />
    );
    
export type UserContextProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserContextQuery, UserContextQueryVariables>
    } & TChildProps;
export function withUserContext<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserContextQuery,
  UserContextQueryVariables,
  UserContextProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserContextQuery, UserContextQueryVariables, UserContextProps<TChildProps, TDataName>>(UserContextDocument, {
      alias: 'userContext',
      ...operationOptions
    });
};

/**
 * __useUserContextQuery__
 *
 * To run a query within a React component, call `useUserContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserContextQuery, UserContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserContextQuery, UserContextQueryVariables>(UserContextDocument, options);
      }
export function useUserContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserContextQuery, UserContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserContextQuery, UserContextQueryVariables>(UserContextDocument, options);
        }
// @ts-ignore
export function useUserContextSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserContextQuery, UserContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserContextQuery, UserContextQueryVariables>;
export function useUserContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserContextQuery, UserContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserContextQuery | undefined, UserContextQueryVariables>;
export function useUserContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserContextQuery, UserContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserContextQuery, UserContextQueryVariables>(UserContextDocument, options);
        }
export type UserContextQueryHookResult = ReturnType<typeof useUserContextQuery>;
export type UserContextLazyQueryHookResult = ReturnType<typeof useUserContextLazyQuery>;
export type UserContextSuspenseQueryHookResult = ReturnType<typeof useUserContextSuspenseQuery>;
export type UserContextQueryResult = ApolloReactCommon.QueryResult<UserContextQuery, UserContextQueryVariables>;
export const ViewerUserInfoDocument = gql`
    query ViewerUserInfo {
  viewer {
    id
    userInfo
  }
}
    `;
export type ViewerUserInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>, 'query'>;

    export const ViewerUserInfoComponent = (props: ViewerUserInfoComponentProps) => (
      <ApolloReactComponents.Query<ViewerUserInfoQuery, ViewerUserInfoQueryVariables> query={ViewerUserInfoDocument} {...props} />
    );
    
export type ViewerUserInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>
    } & TChildProps;
export function withViewerUserInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerUserInfoQuery,
  ViewerUserInfoQueryVariables,
  ViewerUserInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerUserInfoQuery, ViewerUserInfoQueryVariables, ViewerUserInfoProps<TChildProps, TDataName>>(ViewerUserInfoDocument, {
      alias: 'viewerUserInfo',
      ...operationOptions
    });
};

/**
 * __useViewerUserInfoQuery__
 *
 * To run a query within a React component, call `useViewerUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerUserInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>(ViewerUserInfoDocument, options);
      }
export function useViewerUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>(ViewerUserInfoDocument, options);
        }
// @ts-ignore
export function useViewerUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>;
export function useViewerUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerUserInfoQuery | undefined, ViewerUserInfoQueryVariables>;
export function useViewerUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>(ViewerUserInfoDocument, options);
        }
export type ViewerUserInfoQueryHookResult = ReturnType<typeof useViewerUserInfoQuery>;
export type ViewerUserInfoLazyQueryHookResult = ReturnType<typeof useViewerUserInfoLazyQuery>;
export type ViewerUserInfoSuspenseQueryHookResult = ReturnType<typeof useViewerUserInfoSuspenseQuery>;
export type ViewerUserInfoQueryResult = ApolloReactCommon.QueryResult<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>;
export const UserOrganizationsDocument = gql`
    query UserOrganizations($emailDomain: String) {
  viewer {
    id
    organizations: organizations {
      id
      name
      orgType
      members {
        id
        admin
      }
      teams {
        id
        name
      }
      subscriptions {
        id
        subscriptionType
        privileges
        plan {
          id
          name
          planType
          displayName
        }
      }
    }
    openMatchingOrganizations: organizations(emailDomain: $emailDomain) {
      id
      name
      orgType
      flags
      members {
        orgID
        id
        admin
      }
      subscriptions {
        id
        status
      }
      teams {
        id
        name
        memberCount
        settings {
          openToMatchingOrgEmailDomainUsers
        }
      }
    }
  }
}
    `;
export type UserOrganizationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>, 'query'>;

    export const UserOrganizationsComponent = (props: UserOrganizationsComponentProps) => (
      <ApolloReactComponents.Query<UserOrganizationsQuery, UserOrganizationsQueryVariables> query={UserOrganizationsDocument} {...props} />
    );
    
export type UserOrganizationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserOrganizationsQuery, UserOrganizationsQueryVariables>
    } & TChildProps;
export function withUserOrganizations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserOrganizationsQuery,
  UserOrganizationsQueryVariables,
  UserOrganizationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserOrganizationsQuery, UserOrganizationsQueryVariables, UserOrganizationsProps<TChildProps, TDataName>>(UserOrganizationsDocument, {
      alias: 'userOrganizations',
      ...operationOptions
    });
};

/**
 * __useUserOrganizationsQuery__
 *
 * To run a query within a React component, call `useUserOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOrganizationsQuery({
 *   variables: {
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useUserOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
      }
export function useUserOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
        }
// @ts-ignore
export function useUserOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserOrganizationsQuery, UserOrganizationsQueryVariables>;
export function useUserOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserOrganizationsQuery | undefined, UserOrganizationsQueryVariables>;
export function useUserOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
        }
export type UserOrganizationsQueryHookResult = ReturnType<typeof useUserOrganizationsQuery>;
export type UserOrganizationsLazyQueryHookResult = ReturnType<typeof useUserOrganizationsLazyQuery>;
export type UserOrganizationsSuspenseQueryHookResult = ReturnType<typeof useUserOrganizationsSuspenseQuery>;
export type UserOrganizationsQueryResult = ApolloReactCommon.QueryResult<UserOrganizationsQuery, UserOrganizationsQueryVariables>;
export const EntityStorageBytesDocument = gql`
    query EntityStorageBytes($name: String!) {
  entity(name: $name) {
    id
    storageBytes
  }
}
    `;
export type EntityStorageBytesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>, 'query'> & ({ variables: EntityStorageBytesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityStorageBytesComponent = (props: EntityStorageBytesComponentProps) => (
      <ApolloReactComponents.Query<EntityStorageBytesQuery, EntityStorageBytesQueryVariables> query={EntityStorageBytesDocument} {...props} />
    );
    
export type EntityStorageBytesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>
    } & TChildProps;
export function withEntityStorageBytes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityStorageBytesQuery,
  EntityStorageBytesQueryVariables,
  EntityStorageBytesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityStorageBytesQuery, EntityStorageBytesQueryVariables, EntityStorageBytesProps<TChildProps, TDataName>>(EntityStorageBytesDocument, {
      alias: 'entityStorageBytes',
      ...operationOptions
    });
};

/**
 * __useEntityStorageBytesQuery__
 *
 * To run a query within a React component, call `useEntityStorageBytesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityStorageBytesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityStorageBytesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntityStorageBytesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables> & ({ variables: EntityStorageBytesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>(EntityStorageBytesDocument, options);
      }
export function useEntityStorageBytesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>(EntityStorageBytesDocument, options);
        }
// @ts-ignore
export function useEntityStorageBytesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>;
export function useEntityStorageBytesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageBytesQuery | undefined, EntityStorageBytesQueryVariables>;
export function useEntityStorageBytesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>(EntityStorageBytesDocument, options);
        }
export type EntityStorageBytesQueryHookResult = ReturnType<typeof useEntityStorageBytesQuery>;
export type EntityStorageBytesLazyQueryHookResult = ReturnType<typeof useEntityStorageBytesLazyQuery>;
export type EntityStorageBytesSuspenseQueryHookResult = ReturnType<typeof useEntityStorageBytesSuspenseQuery>;
export type EntityStorageBytesQueryResult = ApolloReactCommon.QueryResult<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>;
export const EntityDocument = gql`
    query Entity($name: String!) {
  entity(name: $name) {
    id
    name
    available
    photoUrl
    readOnly
    readOnlyAdmin
    isTeam
    privateOnly
    codeSavingEnabled
    artifactTTLDurationSeconds
    settings {
      hidden
      openToMatchingOrgEmailDomainUsers
      membersCanInvite
      disableMagicLinkSharing
      defaultCloudRegion {
        id
        provider
        region
      }
      storageBucketInfo {
        provider
        name
        kmsKeyID
        awsExternalID
        path
      }
      disableMembersEditArtifactTTL
    }
    defaultAccess
    isPaid
    rateLimits {
      graphql
      sdkGraphql
      filestreamCount
      filestreamPerRunCount
      filestreamSize
      runUpdateCount
      sdkGraphqlQuerySeconds
    }
    members {
      id
      admin
      role
      pending
      email
      username
      name
      photoUrl
      accountType
      apiKey
    }
    defaultAlerts {
      id
      condition {
        __typename
        ... on FinishedRunCondition {
          success
        }
        ... on StoppedRunCondition {
          minimumRunDuration
        }
      }
      subscriptions {
        __typename
        ... on EmailSubscription {
          id
        }
        ... on SlackChannelSubscription {
          id
        }
      }
    }
    integrations {
      edges {
        node {
          id
          __typename
          ... on SlackIntegration {
            teamName
            channelName
          }
          ... on GenericWebhookIntegration {
            id
            urlEndpoint
            name
            accessTokenRef
            secretRef
            createdAt
          }
        }
      }
    }
    computeHours
    organization {
      id
      name
      orgType
      billingUser {
        id
        username
      }
      subscriptions {
        id
        plan {
          id
          name
          planType
        }
        privileges
        seats
        expiresAt
        subscriptionType
        status
      }
      members {
        orgID
        id
        username
        name
        photoUrl
        admin
        role
      }
      pendingInvites {
        id
        email
      }
    }
    invites {
      edges {
        node {
          id
          createdAt
          name
          toUser {
            id
            email
            username
          }
        }
      }
    }
  }
  user(userName: $name) {
    id
    username
    accountType
  }
}
    `;
export type EntityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityQuery, EntityQueryVariables>, 'query'> & ({ variables: EntityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityComponent = (props: EntityComponentProps) => (
      <ApolloReactComponents.Query<EntityQuery, EntityQueryVariables> query={EntityDocument} {...props} />
    );
    
export type EntityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityQuery, EntityQueryVariables>
    } & TChildProps;
export function withEntity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityQuery,
  EntityQueryVariables,
  EntityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityQuery, EntityQueryVariables, EntityProps<TChildProps, TDataName>>(EntityDocument, {
      alias: 'entity',
      ...operationOptions
    });
};

/**
 * __useEntityQuery__
 *
 * To run a query within a React component, call `useEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityQuery, EntityQueryVariables> & ({ variables: EntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
      }
export function useEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityQuery, EntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
        }
// @ts-ignore
export function useEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQuery, EntityQueryVariables>;
export function useEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQuery | undefined, EntityQueryVariables>;
export function useEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
        }
export type EntityQueryHookResult = ReturnType<typeof useEntityQuery>;
export type EntityLazyQueryHookResult = ReturnType<typeof useEntityLazyQuery>;
export type EntitySuspenseQueryHookResult = ReturnType<typeof useEntitySuspenseQuery>;
export type EntityQueryResult = ApolloReactCommon.QueryResult<EntityQuery, EntityQueryVariables>;
export const EntityIntegrationsDocument = gql`
    query EntityIntegrations($name: String!) {
  entity(name: $name) {
    id
    name
    integrations {
      edges {
        node {
          id
          __typename
          ... on SlackIntegration {
            teamName
            channelName
          }
          ... on GenericWebhookIntegration {
            id
            urlEndpoint
            name
            accessTokenRef
            secretRef
            createdAt
          }
        }
      }
    }
  }
}
    `;
export type EntityIntegrationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>, 'query'> & ({ variables: EntityIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityIntegrationsComponent = (props: EntityIntegrationsComponentProps) => (
      <ApolloReactComponents.Query<EntityIntegrationsQuery, EntityIntegrationsQueryVariables> query={EntityIntegrationsDocument} {...props} />
    );
    
export type EntityIntegrationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>
    } & TChildProps;
export function withEntityIntegrations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityIntegrationsQuery,
  EntityIntegrationsQueryVariables,
  EntityIntegrationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityIntegrationsQuery, EntityIntegrationsQueryVariables, EntityIntegrationsProps<TChildProps, TDataName>>(EntityIntegrationsDocument, {
      alias: 'entityIntegrations',
      ...operationOptions
    });
};

/**
 * __useEntityIntegrationsQuery__
 *
 * To run a query within a React component, call `useEntityIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityIntegrationsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntityIntegrationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables> & ({ variables: EntityIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>(EntityIntegrationsDocument, options);
      }
export function useEntityIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>(EntityIntegrationsDocument, options);
        }
// @ts-ignore
export function useEntityIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>;
export function useEntityIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityIntegrationsQuery | undefined, EntityIntegrationsQueryVariables>;
export function useEntityIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>(EntityIntegrationsDocument, options);
        }
export type EntityIntegrationsQueryHookResult = ReturnType<typeof useEntityIntegrationsQuery>;
export type EntityIntegrationsLazyQueryHookResult = ReturnType<typeof useEntityIntegrationsLazyQuery>;
export type EntityIntegrationsSuspenseQueryHookResult = ReturnType<typeof useEntityIntegrationsSuspenseQuery>;
export type EntityIntegrationsQueryResult = ApolloReactCommon.QueryResult<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($query: String, $queryEmail: String, $ids: [ID!], $usernames: [String!]) {
  users(query: $query, queryEmail: $queryEmail, ids: $ids, usernames: $usernames) {
    edges {
      node {
        emails {
          ...EmailBasic
        }
        id
        name
        loggedInAt
        userInfo
        ...UserRoleFragment
      }
    }
  }
}
    ${EmailBasicFragmentDoc}
${UserRoleFragmentFragmentDoc}`;
export type SearchUsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchUsersQuery, SearchUsersQueryVariables>, 'query'>;

    export const SearchUsersComponent = (props: SearchUsersComponentProps) => (
      <ApolloReactComponents.Query<SearchUsersQuery, SearchUsersQueryVariables> query={SearchUsersDocument} {...props} />
    );
    
export type SearchUsersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchUsersQuery, SearchUsersQueryVariables>
    } & TChildProps;
export function withSearchUsers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchUsersQuery,
  SearchUsersQueryVariables,
  SearchUsersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchUsersQuery, SearchUsersQueryVariables, SearchUsersProps<TChildProps, TDataName>>(SearchUsersDocument, {
      alias: 'searchUsers',
      ...operationOptions
    });
};

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      queryEmail: // value for 'queryEmail'
 *      ids: // value for 'ids'
 *      usernames: // value for 'usernames'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
// @ts-ignore
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersQuery | undefined, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = ApolloReactCommon.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const FindUsersDocument = gql`
    query FindUsers($query: String!, $limit: Int!) {
  users(query: $query, first: $limit) {
    edges {
      node {
        id
        ...UserFragment
      }
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export type FindUsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FindUsersQuery, FindUsersQueryVariables>, 'query'> & ({ variables: FindUsersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FindUsersComponent = (props: FindUsersComponentProps) => (
      <ApolloReactComponents.Query<FindUsersQuery, FindUsersQueryVariables> query={FindUsersDocument} {...props} />
    );
    
export type FindUsersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FindUsersQuery, FindUsersQueryVariables>
    } & TChildProps;
export function withFindUsers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FindUsersQuery,
  FindUsersQueryVariables,
  FindUsersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FindUsersQuery, FindUsersQueryVariables, FindUsersProps<TChildProps, TDataName>>(FindUsersDocument, {
      alias: 'findUsers',
      ...operationOptions
    });
};

/**
 * __useFindUsersQuery__
 *
 * To run a query within a React component, call `useFindUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindUsersQuery, FindUsersQueryVariables> & ({ variables: FindUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
      }
export function useFindUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
        }
// @ts-ignore
export function useFindUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FindUsersQuery, FindUsersQueryVariables>;
export function useFindUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FindUsersQuery | undefined, FindUsersQueryVariables>;
export function useFindUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
        }
export type FindUsersQueryHookResult = ReturnType<typeof useFindUsersQuery>;
export type FindUsersLazyQueryHookResult = ReturnType<typeof useFindUsersLazyQuery>;
export type FindUsersSuspenseQueryHookResult = ReturnType<typeof useFindUsersSuspenseQuery>;
export type FindUsersQueryResult = ApolloReactCommon.QueryResult<FindUsersQuery, FindUsersQueryVariables>;
export const FindUsersByUsernameDocument = gql`
    query FindUsersByUsername($usernames: [String!]!, $limit: Int!) {
  users(usernames: $usernames, first: $limit) {
    edges {
      node {
        id
        ...UserFragment
      }
    }
  }
}
    ${UserFragmentFragmentDoc}`;
export type FindUsersByUsernameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>, 'query'> & ({ variables: FindUsersByUsernameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FindUsersByUsernameComponent = (props: FindUsersByUsernameComponentProps) => (
      <ApolloReactComponents.Query<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables> query={FindUsersByUsernameDocument} {...props} />
    );
    
export type FindUsersByUsernameProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>
    } & TChildProps;
export function withFindUsersByUsername<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FindUsersByUsernameQuery,
  FindUsersByUsernameQueryVariables,
  FindUsersByUsernameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables, FindUsersByUsernameProps<TChildProps, TDataName>>(FindUsersByUsernameDocument, {
      alias: 'findUsersByUsername',
      ...operationOptions
    });
};

/**
 * __useFindUsersByUsernameQuery__
 *
 * To run a query within a React component, call `useFindUsersByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersByUsernameQuery({
 *   variables: {
 *      usernames: // value for 'usernames'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindUsersByUsernameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables> & ({ variables: FindUsersByUsernameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>(FindUsersByUsernameDocument, options);
      }
export function useFindUsersByUsernameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>(FindUsersByUsernameDocument, options);
        }
// @ts-ignore
export function useFindUsersByUsernameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>;
export function useFindUsersByUsernameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FindUsersByUsernameQuery | undefined, FindUsersByUsernameQueryVariables>;
export function useFindUsersByUsernameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>(FindUsersByUsernameDocument, options);
        }
export type FindUsersByUsernameQueryHookResult = ReturnType<typeof useFindUsersByUsernameQuery>;
export type FindUsersByUsernameLazyQueryHookResult = ReturnType<typeof useFindUsersByUsernameLazyQuery>;
export type FindUsersByUsernameSuspenseQueryHookResult = ReturnType<typeof useFindUsersByUsernameSuspenseQuery>;
export type FindUsersByUsernameQueryResult = ApolloReactCommon.QueryResult<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($id: ID!, $role: String!) {
  updateUserRole(input: {id: $id, accountType: $role}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
      accountType
    }
  }
}
    `;
export type UpdateUserRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export type UpdateUserRoleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>, 'mutation'>;

    export const UpdateUserRoleComponent = (props: UpdateUserRoleComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables> mutation={UpdateUserRoleDocument} {...props} />
    );
    
export type UpdateUserRoleProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>
    } & TChildProps;
export function withUpdateUserRole<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserRoleMutation,
  UpdateUserRoleMutationVariables,
  UpdateUserRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserRoleMutation, UpdateUserRoleMutationVariables, UpdateUserRoleProps<TChildProps, TDataName>>(UpdateUserRoleDocument, {
      alias: 'updateUserRole',
      ...operationOptions
    });
};

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = ApolloReactCommon.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const UpdateUserRoleV2Document = gql`
    mutation UpdateUserRoleV2($id: ID!, $role: String!) {
  updateUserRoleV2(input: {id: $id, accountType: $role}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
      accountType
    }
  }
}
    `;
export type UpdateUserRoleV2MutationFn = ApolloReactCommon.MutationFunction<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>;
export type UpdateUserRoleV2ComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>, 'mutation'>;

    export const UpdateUserRoleV2Component = (props: UpdateUserRoleV2ComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables> mutation={UpdateUserRoleV2Document} {...props} />
    );
    
export type UpdateUserRoleV2Props<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>
    } & TChildProps;
export function withUpdateUserRoleV2<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserRoleV2Mutation,
  UpdateUserRoleV2MutationVariables,
  UpdateUserRoleV2Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables, UpdateUserRoleV2Props<TChildProps, TDataName>>(UpdateUserRoleV2Document, {
      alias: 'updateUserRoleV2',
      ...operationOptions
    });
};

/**
 * __useUpdateUserRoleV2Mutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleV2Mutation, { data, loading, error }] = useUpdateUserRoleV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserRoleV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>(UpdateUserRoleV2Document, options);
      }
export type UpdateUserRoleV2MutationHookResult = ReturnType<typeof useUpdateUserRoleV2Mutation>;
export type UpdateUserRoleV2MutationResult = ApolloReactCommon.MutationResult<UpdateUserRoleV2Mutation>;
export type UpdateUserRoleV2MutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>;
export const SetUserAdminDocument = gql`
    mutation SetUserAdmin($id: ID!, $admin: Boolean!) {
  updateUser(input: {id: $id, admin: $admin}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
    }
  }
}
    `;
export type SetUserAdminMutationFn = ApolloReactCommon.MutationFunction<SetUserAdminMutation, SetUserAdminMutationVariables>;
export type SetUserAdminComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SetUserAdminMutation, SetUserAdminMutationVariables>, 'mutation'>;

    export const SetUserAdminComponent = (props: SetUserAdminComponentProps) => (
      <ApolloReactComponents.Mutation<SetUserAdminMutation, SetUserAdminMutationVariables> mutation={SetUserAdminDocument} {...props} />
    );
    
export type SetUserAdminProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SetUserAdminMutation, SetUserAdminMutationVariables>
    } & TChildProps;
export function withSetUserAdmin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetUserAdminMutation,
  SetUserAdminMutationVariables,
  SetUserAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SetUserAdminMutation, SetUserAdminMutationVariables, SetUserAdminProps<TChildProps, TDataName>>(SetUserAdminDocument, {
      alias: 'setUserAdmin',
      ...operationOptions
    });
};

/**
 * __useSetUserAdminMutation__
 *
 * To run a mutation, you first call `useSetUserAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserAdminMutation, { data, loading, error }] = useSetUserAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      admin: // value for 'admin'
 *   },
 * });
 */
export function useSetUserAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserAdminMutation, SetUserAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserAdminMutation, SetUserAdminMutationVariables>(SetUserAdminDocument, options);
      }
export type SetUserAdminMutationHookResult = ReturnType<typeof useSetUserAdminMutation>;
export type SetUserAdminMutationResult = ApolloReactCommon.MutationResult<SetUserAdminMutation>;
export type SetUserAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<SetUserAdminMutation, SetUserAdminMutationVariables>;
export const PurgeUserDocument = gql`
    mutation PurgeUser($username: String!, $email: String!) {
  purgeUser(input: {username: $username, email: $email}) {
    user {
      id
      deletedAt
    }
  }
}
    `;
export type PurgeUserMutationFn = ApolloReactCommon.MutationFunction<PurgeUserMutation, PurgeUserMutationVariables>;
export type PurgeUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PurgeUserMutation, PurgeUserMutationVariables>, 'mutation'>;

    export const PurgeUserComponent = (props: PurgeUserComponentProps) => (
      <ApolloReactComponents.Mutation<PurgeUserMutation, PurgeUserMutationVariables> mutation={PurgeUserDocument} {...props} />
    );
    
export type PurgeUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<PurgeUserMutation, PurgeUserMutationVariables>
    } & TChildProps;
export function withPurgeUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PurgeUserMutation,
  PurgeUserMutationVariables,
  PurgeUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, PurgeUserMutation, PurgeUserMutationVariables, PurgeUserProps<TChildProps, TDataName>>(PurgeUserDocument, {
      alias: 'purgeUser',
      ...operationOptions
    });
};

/**
 * __usePurgeUserMutation__
 *
 * To run a mutation, you first call `usePurgeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurgeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purgeUserMutation, { data, loading, error }] = usePurgeUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePurgeUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PurgeUserMutation, PurgeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PurgeUserMutation, PurgeUserMutationVariables>(PurgeUserDocument, options);
      }
export type PurgeUserMutationHookResult = ReturnType<typeof usePurgeUserMutation>;
export type PurgeUserMutationResult = ApolloReactCommon.MutationResult<PurgeUserMutation>;
export type PurgeUserMutationOptions = ApolloReactCommon.BaseMutationOptions<PurgeUserMutation, PurgeUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(input: {id: $id}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
    }
  }
}
    `;
export type DeleteUserMutationFn = ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;
export type DeleteUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteUserMutation, DeleteUserMutationVariables>, 'mutation'>;

    export const DeleteUserComponent = (props: DeleteUserComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteUserMutation, DeleteUserMutationVariables> mutation={DeleteUserDocument} {...props} />
    );
    
export type DeleteUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>
    } & TChildProps;
export function withDeleteUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteUserMutation,
  DeleteUserMutationVariables,
  DeleteUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteUserMutation, DeleteUserMutationVariables, DeleteUserProps<TChildProps, TDataName>>(DeleteUserDocument, {
      alias: 'deleteUser',
      ...operationOptions
    });
};

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UndeleteUserDocument = gql`
    mutation UndeleteUser($id: ID!) {
  undeleteUser(input: {id: $id}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
    }
  }
}
    `;
export type UndeleteUserMutationFn = ApolloReactCommon.MutationFunction<UndeleteUserMutation, UndeleteUserMutationVariables>;
export type UndeleteUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UndeleteUserMutation, UndeleteUserMutationVariables>, 'mutation'>;

    export const UndeleteUserComponent = (props: UndeleteUserComponentProps) => (
      <ApolloReactComponents.Mutation<UndeleteUserMutation, UndeleteUserMutationVariables> mutation={UndeleteUserDocument} {...props} />
    );
    
export type UndeleteUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UndeleteUserMutation, UndeleteUserMutationVariables>
    } & TChildProps;
export function withUndeleteUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UndeleteUserMutation,
  UndeleteUserMutationVariables,
  UndeleteUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UndeleteUserMutation, UndeleteUserMutationVariables, UndeleteUserProps<TChildProps, TDataName>>(UndeleteUserDocument, {
      alias: 'undeleteUser',
      ...operationOptions
    });
};

/**
 * __useUndeleteUserMutation__
 *
 * To run a mutation, you first call `useUndeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteUserMutation, { data, loading, error }] = useUndeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndeleteUserMutation, UndeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UndeleteUserMutation, UndeleteUserMutationVariables>(UndeleteUserDocument, options);
      }
export type UndeleteUserMutationHookResult = ReturnType<typeof useUndeleteUserMutation>;
export type UndeleteUserMutationResult = ApolloReactCommon.MutationResult<UndeleteUserMutation>;
export type UndeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UndeleteUserMutation, UndeleteUserMutationVariables>;
export const CreateInviteDocument = gql`
    mutation CreateInvite($entityName: String!, $email: String, $username: String, $admin: Boolean, $role: String, $modelSeat: String) {
  createInvite(
    input: {entityName: $entityName, email: $email, username: $username, admin: $admin, role: $role, modelSeat: $modelSeat}
  ) {
    invite {
      id
      name
      email
      createdAt
      toUser {
        id
        name
      }
    }
    success
    remainingSeats
    remainingViewOnlySeats
  }
}
    `;
export type CreateInviteMutationFn = ApolloReactCommon.MutationFunction<CreateInviteMutation, CreateInviteMutationVariables>;
export type CreateInviteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateInviteMutation, CreateInviteMutationVariables>, 'mutation'>;

    export const CreateInviteComponent = (props: CreateInviteComponentProps) => (
      <ApolloReactComponents.Mutation<CreateInviteMutation, CreateInviteMutationVariables> mutation={CreateInviteDocument} {...props} />
    );
    
export type CreateInviteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateInviteMutation, CreateInviteMutationVariables>
    } & TChildProps;
export function withCreateInvite<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateInviteMutation,
  CreateInviteMutationVariables,
  CreateInviteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateInviteMutation, CreateInviteMutationVariables, CreateInviteProps<TChildProps, TDataName>>(CreateInviteDocument, {
      alias: 'createInvite',
      ...operationOptions
    });
};

/**
 * __useCreateInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteMutation, { data, loading, error }] = useCreateInviteMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      admin: // value for 'admin'
 *      role: // value for 'role'
 *      modelSeat: // value for 'modelSeat'
 *   },
 * });
 */
export function useCreateInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInviteMutation, CreateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInviteMutation, CreateInviteMutationVariables>(CreateInviteDocument, options);
      }
export type CreateInviteMutationHookResult = ReturnType<typeof useCreateInviteMutation>;
export type CreateInviteMutationResult = ApolloReactCommon.MutationResult<CreateInviteMutation>;
export type CreateInviteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInviteMutation, CreateInviteMutationVariables>;
export const DeleteInviteDocument = gql`
    mutation DeleteInvite($id: String, $entityName: String) {
  deleteInvite(input: {id: $id, entityName: $entityName}) {
    success
  }
}
    `;
export type DeleteInviteMutationFn = ApolloReactCommon.MutationFunction<DeleteInviteMutation, DeleteInviteMutationVariables>;
export type DeleteInviteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteInviteMutation, DeleteInviteMutationVariables>, 'mutation'>;

    export const DeleteInviteComponent = (props: DeleteInviteComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteInviteMutation, DeleteInviteMutationVariables> mutation={DeleteInviteDocument} {...props} />
    );
    
export type DeleteInviteProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteInviteMutation, DeleteInviteMutationVariables>
    } & TChildProps;
export function withDeleteInvite<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteInviteMutation,
  DeleteInviteMutationVariables,
  DeleteInviteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteInviteMutation, DeleteInviteMutationVariables, DeleteInviteProps<TChildProps, TDataName>>(DeleteInviteDocument, {
      alias: 'deleteInvite',
      ...operationOptions
    });
};

/**
 * __useDeleteInviteMutation__
 *
 * To run a mutation, you first call `useDeleteInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInviteMutation, { data, loading, error }] = useDeleteInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useDeleteInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInviteMutation, DeleteInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteInviteMutation, DeleteInviteMutationVariables>(DeleteInviteDocument, options);
      }
export type DeleteInviteMutationHookResult = ReturnType<typeof useDeleteInviteMutation>;
export type DeleteInviteMutationResult = ApolloReactCommon.MutationResult<DeleteInviteMutation>;
export type DeleteInviteMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteInviteMutation, DeleteInviteMutationVariables>;
export const UpdateMemberDocument = gql`
    mutation UpdateMember($entityName: String!, $user: ID!, $role: String!) {
  updateMember(input: {entityName: $entityName, user: $user, role: $role}) {
    member {
      id
      role
    }
  }
}
    `;
export type UpdateMemberMutationFn = ApolloReactCommon.MutationFunction<UpdateMemberMutation, UpdateMemberMutationVariables>;
export type UpdateMemberComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMemberMutation, UpdateMemberMutationVariables>, 'mutation'>;

    export const UpdateMemberComponent = (props: UpdateMemberComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMemberMutation, UpdateMemberMutationVariables> mutation={UpdateMemberDocument} {...props} />
    );
    
export type UpdateMemberProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateMemberMutation, UpdateMemberMutationVariables>
    } & TChildProps;
export function withUpdateMember<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateMemberMutation,
  UpdateMemberMutationVariables,
  UpdateMemberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateMemberMutation, UpdateMemberMutationVariables, UpdateMemberProps<TChildProps, TDataName>>(UpdateMemberDocument, {
      alias: 'updateMember',
      ...operationOptions
    });
};

/**
 * __useUpdateMemberMutation__
 *
 * To run a mutation, you first call `useUpdateMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberMutation, { data, loading, error }] = useUpdateMemberMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      user: // value for 'user'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMemberMutation, UpdateMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMemberMutation, UpdateMemberMutationVariables>(UpdateMemberDocument, options);
      }
export type UpdateMemberMutationHookResult = ReturnType<typeof useUpdateMemberMutation>;
export type UpdateMemberMutationResult = ApolloReactCommon.MutationResult<UpdateMemberMutation>;
export type UpdateMemberMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMemberMutation, UpdateMemberMutationVariables>;
export const CreateServiceAccountDocument = gql`
    mutation CreateServiceAccount($entityName: String!, $description: String!, $organizationId: ID) {
  createServiceAccount(
    input: {description: $description, entityName: $entityName, organizationId: $organizationId}
  ) {
    user {
      id
      name
      apiKeys {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type CreateServiceAccountMutationFn = ApolloReactCommon.MutationFunction<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>;
export type CreateServiceAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>, 'mutation'>;

    export const CreateServiceAccountComponent = (props: CreateServiceAccountComponentProps) => (
      <ApolloReactComponents.Mutation<CreateServiceAccountMutation, CreateServiceAccountMutationVariables> mutation={CreateServiceAccountDocument} {...props} />
    );
    
export type CreateServiceAccountProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>
    } & TChildProps;
export function withCreateServiceAccount<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateServiceAccountMutation,
  CreateServiceAccountMutationVariables,
  CreateServiceAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateServiceAccountMutation, CreateServiceAccountMutationVariables, CreateServiceAccountProps<TChildProps, TDataName>>(CreateServiceAccountDocument, {
      alias: 'createServiceAccount',
      ...operationOptions
    });
};

/**
 * __useCreateServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAccountMutation, { data, loading, error }] = useCreateServiceAccountMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      description: // value for 'description'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateServiceAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>(CreateServiceAccountDocument, options);
      }
export type CreateServiceAccountMutationHookResult = ReturnType<typeof useCreateServiceAccountMutation>;
export type CreateServiceAccountMutationResult = ApolloReactCommon.MutationResult<CreateServiceAccountMutation>;
export type CreateServiceAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>;
export const CreateOrgServiceAccountDocument = gql`
    mutation CreateOrgServiceAccount($description: String!, $defaultEntityId: ID!, $organizationId: ID!) {
  createOrgServiceAccount(
    input: {description: $description, defaultEntityId: $defaultEntityId, organizationId: $organizationId}
  ) {
    user {
      id
      name
      apiKeys {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type CreateOrgServiceAccountMutationFn = ApolloReactCommon.MutationFunction<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>;
export type CreateOrgServiceAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>, 'mutation'>;

    export const CreateOrgServiceAccountComponent = (props: CreateOrgServiceAccountComponentProps) => (
      <ApolloReactComponents.Mutation<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables> mutation={CreateOrgServiceAccountDocument} {...props} />
    );
    
export type CreateOrgServiceAccountProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>
    } & TChildProps;
export function withCreateOrgServiceAccount<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateOrgServiceAccountMutation,
  CreateOrgServiceAccountMutationVariables,
  CreateOrgServiceAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables, CreateOrgServiceAccountProps<TChildProps, TDataName>>(CreateOrgServiceAccountDocument, {
      alias: 'createOrgServiceAccount',
      ...operationOptions
    });
};

/**
 * __useCreateOrgServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateOrgServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgServiceAccountMutation, { data, loading, error }] = useCreateOrgServiceAccountMutation({
 *   variables: {
 *      description: // value for 'description'
 *      defaultEntityId: // value for 'defaultEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateOrgServiceAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>(CreateOrgServiceAccountDocument, options);
      }
export type CreateOrgServiceAccountMutationHookResult = ReturnType<typeof useCreateOrgServiceAccountMutation>;
export type CreateOrgServiceAccountMutationResult = ApolloReactCommon.MutationResult<CreateOrgServiceAccountMutation>;
export type CreateOrgServiceAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>;
export const DeleteServiceAccountDocument = gql`
    mutation DeleteServiceAccount($id: ID!) {
  deleteServiceAccount(input: {id: $id}) {
    user {
      id
    }
  }
}
    `;
export type DeleteServiceAccountMutationFn = ApolloReactCommon.MutationFunction<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>;
export type DeleteServiceAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>, 'mutation'>;

    export const DeleteServiceAccountComponent = (props: DeleteServiceAccountComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables> mutation={DeleteServiceAccountDocument} {...props} />
    );
    
export type DeleteServiceAccountProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>
    } & TChildProps;
export function withDeleteServiceAccount<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteServiceAccountMutation,
  DeleteServiceAccountMutationVariables,
  DeleteServiceAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables, DeleteServiceAccountProps<TChildProps, TDataName>>(DeleteServiceAccountDocument, {
      alias: 'deleteServiceAccount',
      ...operationOptions
    });
};

/**
 * __useDeleteServiceAccountMutation__
 *
 * To run a mutation, you first call `useDeleteServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceAccountMutation, { data, loading, error }] = useDeleteServiceAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>(DeleteServiceAccountDocument, options);
      }
export type DeleteServiceAccountMutationHookResult = ReturnType<typeof useDeleteServiceAccountMutation>;
export type DeleteServiceAccountMutationResult = ApolloReactCommon.MutationResult<DeleteServiceAccountMutation>;
export type DeleteServiceAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>;
export const CreateEntityDocument = gql`
    mutation CreateEntity($name: String!, $invited: String, $framework: String) {
  createEntity(
    input: {name: $name, defaultFramework: $framework, invited: $invited}
  ) {
    entity {
      id
      name
      photoUrl
      invitedTeam
      projects(first: 100) {
        edges {
          node {
            id
            name
            entityName
          }
        }
      }
    }
    apiKey {
      id
      name
    }
  }
}
    `;
export type CreateEntityMutationFn = ApolloReactCommon.MutationFunction<CreateEntityMutation, CreateEntityMutationVariables>;
export type CreateEntityComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateEntityMutation, CreateEntityMutationVariables>, 'mutation'>;

    export const CreateEntityComponent = (props: CreateEntityComponentProps) => (
      <ApolloReactComponents.Mutation<CreateEntityMutation, CreateEntityMutationVariables> mutation={CreateEntityDocument} {...props} />
    );
    
export type CreateEntityProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateEntityMutation, CreateEntityMutationVariables>
    } & TChildProps;
export function withCreateEntity<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateEntityMutation,
  CreateEntityMutationVariables,
  CreateEntityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateEntityMutation, CreateEntityMutationVariables, CreateEntityProps<TChildProps, TDataName>>(CreateEntityDocument, {
      alias: 'createEntity',
      ...operationOptions
    });
};

/**
 * __useCreateEntityMutation__
 *
 * To run a mutation, you first call `useCreateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMutation, { data, loading, error }] = useCreateEntityMutation({
 *   variables: {
 *      name: // value for 'name'
 *      invited: // value for 'invited'
 *      framework: // value for 'framework'
 *   },
 * });
 */
export function useCreateEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEntityMutation, CreateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEntityMutation, CreateEntityMutationVariables>(CreateEntityDocument, options);
      }
export type CreateEntityMutationHookResult = ReturnType<typeof useCreateEntityMutation>;
export type CreateEntityMutationResult = ApolloReactCommon.MutationResult<CreateEntityMutation>;
export type CreateEntityMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEntityMutation, CreateEntityMutationVariables>;
export const CreateUserFromAdminDocument = gql`
    mutation CreateUserFromAdmin($email: String!, $admin: Boolean, $accountType: String, $organizationID: ID) {
  createUser(
    input: {email: $email, admin: $admin, accountType: $accountType, organizationID: $organizationID}
  ) {
    user {
      id
      name
      username
      email
      admin
    }
  }
}
    `;
export type CreateUserFromAdminMutationFn = ApolloReactCommon.MutationFunction<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>;
export type CreateUserFromAdminComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>, 'mutation'>;

    export const CreateUserFromAdminComponent = (props: CreateUserFromAdminComponentProps) => (
      <ApolloReactComponents.Mutation<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables> mutation={CreateUserFromAdminDocument} {...props} />
    );
    
export type CreateUserFromAdminProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>
    } & TChildProps;
export function withCreateUserFromAdmin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateUserFromAdminMutation,
  CreateUserFromAdminMutationVariables,
  CreateUserFromAdminProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables, CreateUserFromAdminProps<TChildProps, TDataName>>(CreateUserFromAdminDocument, {
      alias: 'createUserFromAdmin',
      ...operationOptions
    });
};

/**
 * __useCreateUserFromAdminMutation__
 *
 * To run a mutation, you first call `useCreateUserFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFromAdminMutation, { data, loading, error }] = useCreateUserFromAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      admin: // value for 'admin'
 *      accountType: // value for 'accountType'
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useCreateUserFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>(CreateUserFromAdminDocument, options);
      }
export type CreateUserFromAdminMutationHookResult = ReturnType<typeof useCreateUserFromAdminMutation>;
export type CreateUserFromAdminMutationResult = ApolloReactCommon.MutationResult<CreateUserFromAdminMutation>;
export type CreateUserFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>;
export const CreateEntityOnboardingFlowDocument = gql`
    mutation CreateEntityOnboardingFlow($name: String!) {
  createEntity(input: {name: $name}) {
    entity {
      id
    }
  }
}
    `;
export type CreateEntityOnboardingFlowMutationFn = ApolloReactCommon.MutationFunction<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>;
export type CreateEntityOnboardingFlowComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>, 'mutation'>;

    export const CreateEntityOnboardingFlowComponent = (props: CreateEntityOnboardingFlowComponentProps) => (
      <ApolloReactComponents.Mutation<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables> mutation={CreateEntityOnboardingFlowDocument} {...props} />
    );
    
export type CreateEntityOnboardingFlowProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>
    } & TChildProps;
export function withCreateEntityOnboardingFlow<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateEntityOnboardingFlowMutation,
  CreateEntityOnboardingFlowMutationVariables,
  CreateEntityOnboardingFlowProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables, CreateEntityOnboardingFlowProps<TChildProps, TDataName>>(CreateEntityOnboardingFlowDocument, {
      alias: 'createEntityOnboardingFlow',
      ...operationOptions
    });
};

/**
 * __useCreateEntityOnboardingFlowMutation__
 *
 * To run a mutation, you first call `useCreateEntityOnboardingFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityOnboardingFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityOnboardingFlowMutation, { data, loading, error }] = useCreateEntityOnboardingFlowMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateEntityOnboardingFlowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>(CreateEntityOnboardingFlowDocument, options);
      }
export type CreateEntityOnboardingFlowMutationHookResult = ReturnType<typeof useCreateEntityOnboardingFlowMutation>;
export type CreateEntityOnboardingFlowMutationResult = ApolloReactCommon.MutationResult<CreateEntityOnboardingFlowMutation>;
export type CreateEntityOnboardingFlowMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>;
export const CheckAvailabilityDocument = gql`
    query CheckAvailability($name: String) {
  entity(name: $name) {
    id
    available
  }
}
    `;
export type CheckAvailabilityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>, 'query'>;

    export const CheckAvailabilityComponent = (props: CheckAvailabilityComponentProps) => (
      <ApolloReactComponents.Query<CheckAvailabilityQuery, CheckAvailabilityQueryVariables> query={CheckAvailabilityDocument} {...props} />
    );
    
export type CheckAvailabilityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>
    } & TChildProps;
export function withCheckAvailability<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CheckAvailabilityQuery,
  CheckAvailabilityQueryVariables,
  CheckAvailabilityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CheckAvailabilityQuery, CheckAvailabilityQueryVariables, CheckAvailabilityProps<TChildProps, TDataName>>(CheckAvailabilityDocument, {
      alias: 'checkAvailability',
      ...operationOptions
    });
};

/**
 * __useCheckAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAvailabilityQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCheckAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>(CheckAvailabilityDocument, options);
      }
export function useCheckAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>(CheckAvailabilityDocument, options);
        }
// @ts-ignore
export function useCheckAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>;
export function useCheckAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckAvailabilityQuery | undefined, CheckAvailabilityQueryVariables>;
export function useCheckAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>(CheckAvailabilityDocument, options);
        }
export type CheckAvailabilityQueryHookResult = ReturnType<typeof useCheckAvailabilityQuery>;
export type CheckAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckAvailabilityLazyQuery>;
export type CheckAvailabilitySuspenseQueryHookResult = ReturnType<typeof useCheckAvailabilitySuspenseQuery>;
export type CheckAvailabilityQueryResult = ApolloReactCommon.QueryResult<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($defaultEntity: String, $defaultFramework: String, $photoUrl: String, $code: String, $settingsVisited: Boolean, $galleryVisited: Boolean, $onboardingHidden: Boolean, $hideTeamsFromPublic: Boolean) {
  updateUser(
    input: {defaultEntity: $defaultEntity, defaultFramework: $defaultFramework, photoUrl: $photoUrl, code: $code, settingsVisited: $settingsVisited, galleryVisited: $galleryVisited, onboardingHidden: $onboardingHidden, hideTeamsFromPublic: $hideTeamsFromPublic}
  ) {
    user {
      id
      flags
      entity
      hideTeamsFromPublic
      teams {
        edges {
          node {
            id
            name
            isTeam
          }
        }
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;
export type UpdateUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserMutation, UpdateUserMutationVariables>, 'mutation'>;

    export const UpdateUserComponent = (props: UpdateUserComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserMutation, UpdateUserMutationVariables> mutation={UpdateUserDocument} {...props} />
    );
    
export type UpdateUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>
    } & TChildProps;
export function withUpdateUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserMutation,
  UpdateUserMutationVariables,
  UpdateUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserMutation, UpdateUserMutationVariables, UpdateUserProps<TChildProps, TDataName>>(UpdateUserDocument, {
      alias: 'updateUser',
      ...operationOptions
    });
};

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      defaultEntity: // value for 'defaultEntity'
 *      defaultFramework: // value for 'defaultFramework'
 *      photoUrl: // value for 'photoUrl'
 *      code: // value for 'code'
 *      settingsVisited: // value for 'settingsVisited'
 *      galleryVisited: // value for 'galleryVisited'
 *      onboardingHidden: // value for 'onboardingHidden'
 *      hideTeamsFromPublic: // value for 'hideTeamsFromPublic'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserInfoDocument = gql`
    mutation UpdateUserInfo($id: ID, $name: String, $photoUrl: String, $userInfo: JSONString, $defaultEntity: String, $primaryEmail: String, $password: String) {
  updateUser(
    input: {id: $id, name: $name, userInfo: $userInfo, defaultEntity: $defaultEntity, photoUrl: $photoUrl, primaryEmail: $primaryEmail, password: $password}
  ) {
    user {
      id
      name
      userInfo
      photoUrl
      entity
      teams {
        edges {
          node {
            id
            name
            isTeam
          }
        }
      }
    }
  }
}
    `;
export type UpdateUserInfoMutationFn = ApolloReactCommon.MutationFunction<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;
export type UpdateUserInfoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>, 'mutation'>;

    export const UpdateUserInfoComponent = (props: UpdateUserInfoComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserInfoMutation, UpdateUserInfoMutationVariables> mutation={UpdateUserInfoDocument} {...props} />
    );
    
export type UpdateUserInfoProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>
    } & TChildProps;
export function withUpdateUserInfo<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserInfoMutation,
  UpdateUserInfoMutationVariables,
  UpdateUserInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserInfoMutation, UpdateUserInfoMutationVariables, UpdateUserInfoProps<TChildProps, TDataName>>(UpdateUserInfoDocument, {
      alias: 'updateUserInfo',
      ...operationOptions
    });
};

/**
 * __useUpdateUserInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInfoMutation, { data, loading, error }] = useUpdateUserInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      photoUrl: // value for 'photoUrl'
 *      userInfo: // value for 'userInfo'
 *      defaultEntity: // value for 'defaultEntity'
 *      primaryEmail: // value for 'primaryEmail'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdateUserInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>(UpdateUserInfoDocument, options);
      }
export type UpdateUserInfoMutationHookResult = ReturnType<typeof useUpdateUserInfoMutation>;
export type UpdateUserInfoMutationResult = ApolloReactCommon.MutationResult<UpdateUserInfoMutation>;
export type UpdateUserInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;
export const UpdateUserEmailDocument = gql`
    mutation UpdateUserEmail($id: ID!, $type: EmailType) {
  updateUserEmail(input: {id: $id, type: $type}) {
    success
    email {
      id
      emailAddress
    }
  }
}
    `;
export type UpdateUserEmailMutationFn = ApolloReactCommon.MutationFunction<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;
export type UpdateUserEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>, 'mutation'>;

    export const UpdateUserEmailComponent = (props: UpdateUserEmailComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserEmailMutation, UpdateUserEmailMutationVariables> mutation={UpdateUserEmailDocument} {...props} />
    );
    
export type UpdateUserEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>
    } & TChildProps;
export function withUpdateUserEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserEmailMutation,
  UpdateUserEmailMutationVariables,
  UpdateUserEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserEmailMutation, UpdateUserEmailMutationVariables, UpdateUserEmailProps<TChildProps, TDataName>>(UpdateUserEmailDocument, {
      alias: 'updateUserEmail',
      ...operationOptions
    });
};

/**
 * __useUpdateUserEmailMutation__
 *
 * To run a mutation, you first call `useUpdateUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEmailMutation, { data, loading, error }] = useUpdateUserEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateUserEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>(UpdateUserEmailDocument, options);
      }
export type UpdateUserEmailMutationHookResult = ReturnType<typeof useUpdateUserEmailMutation>;
export type UpdateUserEmailMutationResult = ApolloReactCommon.MutationResult<UpdateUserEmailMutation>;
export type UpdateUserEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;
export const DeleteUserEmailDocument = gql`
    mutation DeleteUserEmail($id: ID!) {
  deleteUserEmail(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteUserEmailMutationFn = ApolloReactCommon.MutationFunction<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>;
export type DeleteUserEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>, 'mutation'>;

    export const DeleteUserEmailComponent = (props: DeleteUserEmailComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteUserEmailMutation, DeleteUserEmailMutationVariables> mutation={DeleteUserEmailDocument} {...props} />
    );
    
export type DeleteUserEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>
    } & TChildProps;
export function withDeleteUserEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteUserEmailMutation,
  DeleteUserEmailMutationVariables,
  DeleteUserEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteUserEmailMutation, DeleteUserEmailMutationVariables, DeleteUserEmailProps<TChildProps, TDataName>>(DeleteUserEmailDocument, {
      alias: 'deleteUserEmail',
      ...operationOptions
    });
};

/**
 * __useDeleteUserEmailMutation__
 *
 * To run a mutation, you first call `useDeleteUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserEmailMutation, { data, loading, error }] = useDeleteUserEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>(DeleteUserEmailDocument, options);
      }
export type DeleteUserEmailMutationHookResult = ReturnType<typeof useDeleteUserEmailMutation>;
export type DeleteUserEmailMutationResult = ApolloReactCommon.MutationResult<DeleteUserEmailMutation>;
export type DeleteUserEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>;
export const GenerateApiKeyDocument = gql`
    mutation GenerateApiKey($description: String) {
  generateApiKey(input: {description: $description}) {
    apiKey {
      id
      name
      description
      apiKeyId
      createdAt
      expiresAt
      user {
        id
        name
      }
    }
    secretApiKey
  }
}
    `;
export type GenerateApiKeyMutationFn = ApolloReactCommon.MutationFunction<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;
export type GenerateApiKeyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>, 'mutation'>;

    export const GenerateApiKeyComponent = (props: GenerateApiKeyComponentProps) => (
      <ApolloReactComponents.Mutation<GenerateApiKeyMutation, GenerateApiKeyMutationVariables> mutation={GenerateApiKeyDocument} {...props} />
    );
    
export type GenerateApiKeyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>
    } & TChildProps;
export function withGenerateApiKey<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GenerateApiKeyMutation,
  GenerateApiKeyMutationVariables,
  GenerateApiKeyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, GenerateApiKeyMutation, GenerateApiKeyMutationVariables, GenerateApiKeyProps<TChildProps, TDataName>>(GenerateApiKeyDocument, {
      alias: 'generateApiKey',
      ...operationOptions
    });
};

/**
 * __useGenerateApiKeyMutation__
 *
 * To run a mutation, you first call `useGenerateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateApiKeyMutation, { data, loading, error }] = useGenerateApiKeyMutation({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGenerateApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>(GenerateApiKeyDocument, options);
      }
export type GenerateApiKeyMutationHookResult = ReturnType<typeof useGenerateApiKeyMutation>;
export type GenerateApiKeyMutationResult = ApolloReactCommon.MutationResult<GenerateApiKeyMutation>;
export type GenerateApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation DeleteApiKey($id: String!) {
  deleteApiKey(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteApiKeyMutationFn = ApolloReactCommon.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export type DeleteApiKeyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>, 'mutation'>;

    export const DeleteApiKeyComponent = (props: DeleteApiKeyComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables> mutation={DeleteApiKeyDocument} {...props} />
    );
    
export type DeleteApiKeyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>
    } & TChildProps;
export function withDeleteApiKey<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteApiKeyMutation,
  DeleteApiKeyMutationVariables,
  DeleteApiKeyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteApiKeyMutation, DeleteApiKeyMutationVariables, DeleteApiKeyProps<TChildProps, TDataName>>(DeleteApiKeyDocument, {
      alias: 'deleteApiKey',
      ...operationOptions
    });
};

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = ApolloReactCommon.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const CreateServiceAccountApiKeyDocument = gql`
    mutation CreateServiceAccountApiKey($serviceAccountId: ID!, $description: String) {
  createServiceAccountApiKey(
    input: {serviceAccountId: $serviceAccountId, description: $description}
  ) {
    apiKey {
      id
      name
      description
      apiKeyId
      createdAt
      expiresAt
      user {
        id
        name
      }
    }
    secretApiKey
    success
  }
}
    `;
export type CreateServiceAccountApiKeyMutationFn = ApolloReactCommon.MutationFunction<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>;
export type CreateServiceAccountApiKeyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>, 'mutation'>;

    export const CreateServiceAccountApiKeyComponent = (props: CreateServiceAccountApiKeyComponentProps) => (
      <ApolloReactComponents.Mutation<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables> mutation={CreateServiceAccountApiKeyDocument} {...props} />
    );
    
export type CreateServiceAccountApiKeyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>
    } & TChildProps;
export function withCreateServiceAccountApiKey<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateServiceAccountApiKeyMutation,
  CreateServiceAccountApiKeyMutationVariables,
  CreateServiceAccountApiKeyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables, CreateServiceAccountApiKeyProps<TChildProps, TDataName>>(CreateServiceAccountApiKeyDocument, {
      alias: 'createServiceAccountApiKey',
      ...operationOptions
    });
};

/**
 * __useCreateServiceAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateServiceAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAccountApiKeyMutation, { data, loading, error }] = useCreateServiceAccountApiKeyMutation({
 *   variables: {
 *      serviceAccountId: // value for 'serviceAccountId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateServiceAccountApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>(CreateServiceAccountApiKeyDocument, options);
      }
export type CreateServiceAccountApiKeyMutationHookResult = ReturnType<typeof useCreateServiceAccountApiKeyMutation>;
export type CreateServiceAccountApiKeyMutationResult = ApolloReactCommon.MutationResult<CreateServiceAccountApiKeyMutation>;
export type CreateServiceAccountApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>;
export const DeleteServiceAccountApiKeyDocument = gql`
    mutation DeleteServiceAccountApiKey($apiKeyId: String!, $serviceAccountId: ID!) {
  deleteServiceAccountApiKey(
    input: {apiKeyId: $apiKeyId, serviceAccountId: $serviceAccountId}
  ) {
    success
  }
}
    `;
export type DeleteServiceAccountApiKeyMutationFn = ApolloReactCommon.MutationFunction<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>;
export type DeleteServiceAccountApiKeyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>, 'mutation'>;

    export const DeleteServiceAccountApiKeyComponent = (props: DeleteServiceAccountApiKeyComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables> mutation={DeleteServiceAccountApiKeyDocument} {...props} />
    );
    
export type DeleteServiceAccountApiKeyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>
    } & TChildProps;
export function withDeleteServiceAccountApiKey<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteServiceAccountApiKeyMutation,
  DeleteServiceAccountApiKeyMutationVariables,
  DeleteServiceAccountApiKeyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables, DeleteServiceAccountApiKeyProps<TChildProps, TDataName>>(DeleteServiceAccountApiKeyDocument, {
      alias: 'deleteServiceAccountApiKey',
      ...operationOptions
    });
};

/**
 * __useDeleteServiceAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteServiceAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceAccountApiKeyMutation, { data, loading, error }] = useDeleteServiceAccountApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *      serviceAccountId: // value for 'serviceAccountId'
 *   },
 * });
 */
export function useDeleteServiceAccountApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>(DeleteServiceAccountApiKeyDocument, options);
      }
export type DeleteServiceAccountApiKeyMutationHookResult = ReturnType<typeof useDeleteServiceAccountApiKeyMutation>;
export type DeleteServiceAccountApiKeyMutationResult = ApolloReactCommon.MutationResult<DeleteServiceAccountApiKeyMutation>;
export type DeleteServiceAccountApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>;
export const UpdateServiceAccountApiKeyDocument = gql`
    mutation UpdateServiceAccountApiKey($apiKeyId: String!, $serviceAccountId: ID!, $description: String!) {
  updateServiceAccountApiKey(
    input: {apiKeyId: $apiKeyId, serviceAccountId: $serviceAccountId, description: $description}
  ) {
    success
    apiKey {
      id
      description
    }
  }
}
    `;
export type UpdateServiceAccountApiKeyMutationFn = ApolloReactCommon.MutationFunction<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>;
export type UpdateServiceAccountApiKeyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>, 'mutation'>;

    export const UpdateServiceAccountApiKeyComponent = (props: UpdateServiceAccountApiKeyComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables> mutation={UpdateServiceAccountApiKeyDocument} {...props} />
    );
    
export type UpdateServiceAccountApiKeyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>
    } & TChildProps;
export function withUpdateServiceAccountApiKey<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateServiceAccountApiKeyMutation,
  UpdateServiceAccountApiKeyMutationVariables,
  UpdateServiceAccountApiKeyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables, UpdateServiceAccountApiKeyProps<TChildProps, TDataName>>(UpdateServiceAccountApiKeyDocument, {
      alias: 'updateServiceAccountApiKey',
      ...operationOptions
    });
};

/**
 * __useUpdateServiceAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateServiceAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceAccountApiKeyMutation, { data, loading, error }] = useUpdateServiceAccountApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *      serviceAccountId: // value for 'serviceAccountId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateServiceAccountApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>(UpdateServiceAccountApiKeyDocument, options);
      }
export type UpdateServiceAccountApiKeyMutationHookResult = ReturnType<typeof useUpdateServiceAccountApiKeyMutation>;
export type UpdateServiceAccountApiKeyMutationResult = ApolloReactCommon.MutationResult<UpdateServiceAccountApiKeyMutation>;
export type UpdateServiceAccountApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>;
export const UpdateApiKeyDocument = gql`
    mutation UpdateApiKey($apiKeyId: String!, $description: String!) {
  updateApiKey(input: {id: $apiKeyId, description: $description}) {
    success
    apiKey {
      id
      description
    }
  }
}
    `;
export type UpdateApiKeyMutationFn = ApolloReactCommon.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export type UpdateApiKeyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>, 'mutation'>;

    export const UpdateApiKeyComponent = (props: UpdateApiKeyComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables> mutation={UpdateApiKeyDocument} {...props} />
    );
    
export type UpdateApiKeyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>
    } & TChildProps;
export function withUpdateApiKey<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateApiKeyMutation,
  UpdateApiKeyMutationVariables,
  UpdateApiKeyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateApiKeyMutation, UpdateApiKeyMutationVariables, UpdateApiKeyProps<TChildProps, TDataName>>(UpdateApiKeyDocument, {
      alias: 'updateApiKey',
      ...operationOptions
    });
};

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = ApolloReactCommon.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const OrganizationTeamsWithViewerRoleDocument = gql`
    query OrganizationTeamsWithViewerRole($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    teams {
      id
      name
      members {
        id
        username
        role
        memberRole {
          ID
          name
          permissions {
            name
            groupName
            displayName
          }
        }
      }
    }
  }
  viewer {
    id
    username
  }
}
    `;
export type OrganizationTeamsWithViewerRoleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>, 'query'> & ({ variables: OrganizationTeamsWithViewerRoleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationTeamsWithViewerRoleComponent = (props: OrganizationTeamsWithViewerRoleComponentProps) => (
      <ApolloReactComponents.Query<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables> query={OrganizationTeamsWithViewerRoleDocument} {...props} />
    );
    
export type OrganizationTeamsWithViewerRoleProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>
    } & TChildProps;
export function withOrganizationTeamsWithViewerRole<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationTeamsWithViewerRoleQuery,
  OrganizationTeamsWithViewerRoleQueryVariables,
  OrganizationTeamsWithViewerRoleProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables, OrganizationTeamsWithViewerRoleProps<TChildProps, TDataName>>(OrganizationTeamsWithViewerRoleDocument, {
      alias: 'organizationTeamsWithViewerRole',
      ...operationOptions
    });
};

/**
 * __useOrganizationTeamsWithViewerRoleQuery__
 *
 * To run a query within a React component, call `useOrganizationTeamsWithViewerRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTeamsWithViewerRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTeamsWithViewerRoleQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationTeamsWithViewerRoleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables> & ({ variables: OrganizationTeamsWithViewerRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>(OrganizationTeamsWithViewerRoleDocument, options);
      }
export function useOrganizationTeamsWithViewerRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>(OrganizationTeamsWithViewerRoleDocument, options);
        }
// @ts-ignore
export function useOrganizationTeamsWithViewerRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>;
export function useOrganizationTeamsWithViewerRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsWithViewerRoleQuery | undefined, OrganizationTeamsWithViewerRoleQueryVariables>;
export function useOrganizationTeamsWithViewerRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>(OrganizationTeamsWithViewerRoleDocument, options);
        }
export type OrganizationTeamsWithViewerRoleQueryHookResult = ReturnType<typeof useOrganizationTeamsWithViewerRoleQuery>;
export type OrganizationTeamsWithViewerRoleLazyQueryHookResult = ReturnType<typeof useOrganizationTeamsWithViewerRoleLazyQuery>;
export type OrganizationTeamsWithViewerRoleSuspenseQueryHookResult = ReturnType<typeof useOrganizationTeamsWithViewerRoleSuspenseQuery>;
export type OrganizationTeamsWithViewerRoleQueryResult = ApolloReactCommon.QueryResult<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>;
export const UpdateEntityDocument = gql`
    mutation UpdateEntity($entityName: String!, $defaultAccess: String, $privateOnly: Boolean, $codeSavingEnabled: Boolean, $settings: EntitySettingsInput) {
  updateEntity(
    input: {entity: $entityName, defaultAccess: $defaultAccess, privateOnly: $privateOnly, codeSavingEnabled: $codeSavingEnabled, settings: $settings}
  ) {
    entity {
      id
      defaultAccess
      privateOnly
      limits
      settings {
        hidden
        defaultCloudRegion {
          id
          provider
          region
        }
      }
    }
  }
}
    `;
export type UpdateEntityMutationFn = ApolloReactCommon.MutationFunction<UpdateEntityMutation, UpdateEntityMutationVariables>;
export type UpdateEntityComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEntityMutation, UpdateEntityMutationVariables>, 'mutation'>;

    export const UpdateEntityComponent = (props: UpdateEntityComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateEntityMutation, UpdateEntityMutationVariables> mutation={UpdateEntityDocument} {...props} />
    );
    
export type UpdateEntityProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEntityMutation, UpdateEntityMutationVariables>
    } & TChildProps;
export function withUpdateEntity<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEntityMutation,
  UpdateEntityMutationVariables,
  UpdateEntityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEntityMutation, UpdateEntityMutationVariables, UpdateEntityProps<TChildProps, TDataName>>(UpdateEntityDocument, {
      alias: 'updateEntity',
      ...operationOptions
    });
};

/**
 * __useUpdateEntityMutation__
 *
 * To run a mutation, you first call `useUpdateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityMutation, { data, loading, error }] = useUpdateEntityMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      defaultAccess: // value for 'defaultAccess'
 *      privateOnly: // value for 'privateOnly'
 *      codeSavingEnabled: // value for 'codeSavingEnabled'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEntityMutation, UpdateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEntityMutation, UpdateEntityMutationVariables>(UpdateEntityDocument, options);
      }
export type UpdateEntityMutationHookResult = ReturnType<typeof useUpdateEntityMutation>;
export type UpdateEntityMutationResult = ApolloReactCommon.MutationResult<UpdateEntityMutation>;
export type UpdateEntityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEntityMutation, UpdateEntityMutationVariables>;
export const ClaimAnonymousEntityDocument = gql`
    mutation ClaimAnonymousEntity($anonymousApiKey: String!) {
  claimAnonymousEntity(input: {anonymousApiKey: $anonymousApiKey}) {
    task {
      id
      type
      state
      progress
      name
    }
  }
}
    `;
export type ClaimAnonymousEntityMutationFn = ApolloReactCommon.MutationFunction<ClaimAnonymousEntityMutation, ClaimAnonymousEntityMutationVariables>;
export type ClaimAnonymousEntityComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ClaimAnonymousEntityMutation, ClaimAnonymousEntityMutationVariables>, 'mutation'>;

    export const ClaimAnonymousEntityComponent = (props: ClaimAnonymousEntityComponentProps) => (
      <ApolloReactComponents.Mutation<ClaimAnonymousEntityMutation, ClaimAnonymousEntityMutationVariables> mutation={ClaimAnonymousEntityDocument} {...props} />
    );
    
export type ClaimAnonymousEntityProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ClaimAnonymousEntityMutation, ClaimAnonymousEntityMutationVariables>
    } & TChildProps;
export function withClaimAnonymousEntity<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClaimAnonymousEntityMutation,
  ClaimAnonymousEntityMutationVariables,
  ClaimAnonymousEntityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ClaimAnonymousEntityMutation, ClaimAnonymousEntityMutationVariables, ClaimAnonymousEntityProps<TChildProps, TDataName>>(ClaimAnonymousEntityDocument, {
      alias: 'claimAnonymousEntity',
      ...operationOptions
    });
};

/**
 * __useClaimAnonymousEntityMutation__
 *
 * To run a mutation, you first call `useClaimAnonymousEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimAnonymousEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimAnonymousEntityMutation, { data, loading, error }] = useClaimAnonymousEntityMutation({
 *   variables: {
 *      anonymousApiKey: // value for 'anonymousApiKey'
 *   },
 * });
 */
export function useClaimAnonymousEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClaimAnonymousEntityMutation, ClaimAnonymousEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClaimAnonymousEntityMutation, ClaimAnonymousEntityMutationVariables>(ClaimAnonymousEntityDocument, options);
      }
export type ClaimAnonymousEntityMutationHookResult = ReturnType<typeof useClaimAnonymousEntityMutation>;
export type ClaimAnonymousEntityMutationResult = ApolloReactCommon.MutationResult<ClaimAnonymousEntityMutation>;
export type ClaimAnonymousEntityMutationOptions = ApolloReactCommon.BaseMutationOptions<ClaimAnonymousEntityMutation, ClaimAnonymousEntityMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  resetPassword(input: {email: $email}) {
    success
  }
}
    `;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;
export type ResetPasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResetPasswordMutation, ResetPasswordMutationVariables>, 'mutation'>;

    export const ResetPasswordComponent = (props: ResetPasswordComponentProps) => (
      <ApolloReactComponents.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> mutation={ResetPasswordDocument} {...props} />
    );
    
export type ResetPasswordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>
    } & TChildProps;
export function withResetPassword<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
  ResetPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResetPasswordMutation, ResetPasswordMutationVariables, ResetPasswordProps<TChildProps, TDataName>>(ResetPasswordDocument, {
      alias: 'resetPassword',
      ...operationOptions
    });
};

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ViewerAllProjectsWithPatternDocument = gql`
    query ViewerAllProjectsWithPattern($pattern: String, $limit: Int = 500) {
  viewer {
    id
    entity
    projects(first: $limit, pattern: $pattern) {
      edges {
        node {
          id
          name
          entityName
        }
      }
    }
  }
}
    `;
export type ViewerAllProjectsWithPatternComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>, 'query'>;

    export const ViewerAllProjectsWithPatternComponent = (props: ViewerAllProjectsWithPatternComponentProps) => (
      <ApolloReactComponents.Query<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables> query={ViewerAllProjectsWithPatternDocument} {...props} />
    );
    
export type ViewerAllProjectsWithPatternProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>
    } & TChildProps;
export function withViewerAllProjectsWithPattern<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerAllProjectsWithPatternQuery,
  ViewerAllProjectsWithPatternQueryVariables,
  ViewerAllProjectsWithPatternProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables, ViewerAllProjectsWithPatternProps<TChildProps, TDataName>>(ViewerAllProjectsWithPatternDocument, {
      alias: 'viewerAllProjectsWithPattern',
      ...operationOptions
    });
};

/**
 * __useViewerAllProjectsWithPatternQuery__
 *
 * To run a query within a React component, call `useViewerAllProjectsWithPatternQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerAllProjectsWithPatternQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerAllProjectsWithPatternQuery({
 *   variables: {
 *      pattern: // value for 'pattern'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useViewerAllProjectsWithPatternQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>(ViewerAllProjectsWithPatternDocument, options);
      }
export function useViewerAllProjectsWithPatternLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>(ViewerAllProjectsWithPatternDocument, options);
        }
// @ts-ignore
export function useViewerAllProjectsWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>;
export function useViewerAllProjectsWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerAllProjectsWithPatternQuery | undefined, ViewerAllProjectsWithPatternQueryVariables>;
export function useViewerAllProjectsWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>(ViewerAllProjectsWithPatternDocument, options);
        }
export type ViewerAllProjectsWithPatternQueryHookResult = ReturnType<typeof useViewerAllProjectsWithPatternQuery>;
export type ViewerAllProjectsWithPatternLazyQueryHookResult = ReturnType<typeof useViewerAllProjectsWithPatternLazyQuery>;
export type ViewerAllProjectsWithPatternSuspenseQueryHookResult = ReturnType<typeof useViewerAllProjectsWithPatternSuspenseQuery>;
export type ViewerAllProjectsWithPatternQueryResult = ApolloReactCommon.QueryResult<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>;
export const ViewerDocument = gql`
    query Viewer($includeStorage: Boolean = false) {
  viewer {
    id
    analyticsId
    admin
    email
    entity
    defaultFramework
    photoUrl
    flags
    code
    username
    createdAt
    name
    accountType
    userInfo
    hideTeamsFromPublic
    limits
    signupRequired
    personalEntityDisabled
    instanceAdminTeamAccessDisabled
    teams(first: 100) {
      edges {
        node {
          id
          name
          photoUrl
          defaultAccess
          readOnlyAdmin
          privateOnly
          isTeam
          organizationId
        }
      }
    }
    organizations {
      id
      name
      orgType
      subscriptions {
        id
        subscriptionType
      }
    }
    defaultEntity {
      id
      name
    }
    userEntity {
      id
      name
      defaultAccess
      codeSavingEnabled
      storageBytes @include(if: $includeStorage)
      settings {
        defaultCloudRegion {
          id
          provider
          region
        }
      }
      isTeam
      defaultAlerts {
        id
        condition {
          __typename
          ... on FinishedRunCondition {
            success
          }
          ... on StoppedRunCondition {
            minimumRunDuration
          }
        }
        subscriptions {
          __typename
          ... on EmailSubscription {
            id
          }
          ... on SlackChannelSubscription {
            id
          }
        }
      }
      integrations {
        edges {
          node {
            id
            __typename
            ... on SlackIntegration {
              teamName
              channelName
            }
          }
        }
      }
      claimedEntities {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type ViewerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerQuery, ViewerQueryVariables>, 'query'>;

    export const ViewerComponent = (props: ViewerComponentProps) => (
      <ApolloReactComponents.Query<ViewerQuery, ViewerQueryVariables> query={ViewerDocument} {...props} />
    );
    
export type ViewerProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerQuery, ViewerQueryVariables>
    } & TChildProps;
export function withViewer<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerQuery,
  ViewerQueryVariables,
  ViewerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerQuery, ViewerQueryVariables, ViewerProps<TChildProps, TDataName>>(ViewerDocument, {
      alias: 'viewer',
      ...operationOptions
    });
};

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *      includeStorage: // value for 'includeStorage'
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
// @ts-ignore
export function useViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerQuery, ViewerQueryVariables>;
export function useViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerQuery | undefined, ViewerQueryVariables>;
export function useViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerSuspenseQueryHookResult = ReturnType<typeof useViewerSuspenseQuery>;
export type ViewerQueryResult = ApolloReactCommon.QueryResult<ViewerQuery, ViewerQueryVariables>;
export const ViewerPhotoUrlDocument = gql`
    query ViewerPhotoURL {
  viewer {
    id
    photoUrl
  }
}
    `;
export type ViewerPhotoUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>, 'query'>;

    export const ViewerPhotoUrlComponent = (props: ViewerPhotoUrlComponentProps) => (
      <ApolloReactComponents.Query<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables> query={ViewerPhotoUrlDocument} {...props} />
    );
    
export type ViewerPhotoUrlProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>
    } & TChildProps;
export function withViewerPhotoUrl<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerPhotoUrlQuery,
  ViewerPhotoUrlQueryVariables,
  ViewerPhotoUrlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables, ViewerPhotoUrlProps<TChildProps, TDataName>>(ViewerPhotoUrlDocument, {
      alias: 'viewerPhotoUrl',
      ...operationOptions
    });
};

/**
 * __useViewerPhotoUrlQuery__
 *
 * To run a query within a React component, call `useViewerPhotoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerPhotoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerPhotoUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerPhotoUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>(ViewerPhotoUrlDocument, options);
      }
export function useViewerPhotoUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>(ViewerPhotoUrlDocument, options);
        }
// @ts-ignore
export function useViewerPhotoUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>;
export function useViewerPhotoUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerPhotoUrlQuery | undefined, ViewerPhotoUrlQueryVariables>;
export function useViewerPhotoUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>(ViewerPhotoUrlDocument, options);
        }
export type ViewerPhotoUrlQueryHookResult = ReturnType<typeof useViewerPhotoUrlQuery>;
export type ViewerPhotoUrlLazyQueryHookResult = ReturnType<typeof useViewerPhotoUrlLazyQuery>;
export type ViewerPhotoUrlSuspenseQueryHookResult = ReturnType<typeof useViewerPhotoUrlSuspenseQuery>;
export type ViewerPhotoUrlQueryResult = ApolloReactCommon.QueryResult<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>;
export const ViewerProjectsDocument = gql`
    query ViewerProjects($entityName: String, $name: String) {
  viewer {
    id
    entity
    photoUrl
    username
    createdAt
    linkedProjects: projects(
      first: 100
      linkedBenchmark: {EntityName: $entityName, Name: $name}
    ) {
      edges {
        node {
          id
          name
          entityName
          runs(order: "createdAt", first: 50) {
            edges {
              node {
                id
                name
                notes
                summaryMetrics
                project {
                  id
                  entityName
                  name
                }
                displayName
                createdAt
                benchmarkRun {
                  id
                  results
                  originalRun {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
    projects(first: 100) {
      edges {
        node {
          id
          name
          entityName
        }
      }
    }
  }
}
    `;
export type ViewerProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerProjectsQuery, ViewerProjectsQueryVariables>, 'query'>;

    export const ViewerProjectsComponent = (props: ViewerProjectsComponentProps) => (
      <ApolloReactComponents.Query<ViewerProjectsQuery, ViewerProjectsQueryVariables> query={ViewerProjectsDocument} {...props} />
    );
    
export type ViewerProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerProjectsQuery, ViewerProjectsQueryVariables>
    } & TChildProps;
export function withViewerProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerProjectsQuery,
  ViewerProjectsQueryVariables,
  ViewerProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerProjectsQuery, ViewerProjectsQueryVariables, ViewerProjectsProps<TChildProps, TDataName>>(ViewerProjectsDocument, {
      alias: 'viewerProjects',
      ...operationOptions
    });
};

/**
 * __useViewerProjectsQuery__
 *
 * To run a query within a React component, call `useViewerProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useViewerProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerProjectsQuery, ViewerProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerProjectsQuery, ViewerProjectsQueryVariables>(ViewerProjectsDocument, options);
      }
export function useViewerProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerProjectsQuery, ViewerProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerProjectsQuery, ViewerProjectsQueryVariables>(ViewerProjectsDocument, options);
        }
// @ts-ignore
export function useViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerProjectsQuery, ViewerProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerProjectsQuery, ViewerProjectsQueryVariables>;
export function useViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerProjectsQuery, ViewerProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerProjectsQuery | undefined, ViewerProjectsQueryVariables>;
export function useViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerProjectsQuery, ViewerProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerProjectsQuery, ViewerProjectsQueryVariables>(ViewerProjectsDocument, options);
        }
export type ViewerProjectsQueryHookResult = ReturnType<typeof useViewerProjectsQuery>;
export type ViewerProjectsLazyQueryHookResult = ReturnType<typeof useViewerProjectsLazyQuery>;
export type ViewerProjectsSuspenseQueryHookResult = ReturnType<typeof useViewerProjectsSuspenseQuery>;
export type ViewerProjectsQueryResult = ApolloReactCommon.QueryResult<ViewerProjectsQuery, ViewerProjectsQueryVariables>;
export const ViewerFeatureFlagsDocument = gql`
    query viewerFeatureFlags($rampIDType: RampIDType!) {
  viewer {
    id
    featureFlags(rampIDType: $rampIDType) {
      rampKey
      isEnabled
    }
  }
}
    `;
export type ViewerFeatureFlagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>, 'query'> & ({ variables: ViewerFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewerFeatureFlagsComponent = (props: ViewerFeatureFlagsComponentProps) => (
      <ApolloReactComponents.Query<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables> query={ViewerFeatureFlagsDocument} {...props} />
    );
    
export type ViewerFeatureFlagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>
    } & TChildProps;
export function withViewerFeatureFlags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerFeatureFlagsQuery,
  ViewerFeatureFlagsQueryVariables,
  ViewerFeatureFlagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables, ViewerFeatureFlagsProps<TChildProps, TDataName>>(ViewerFeatureFlagsDocument, {
      alias: 'viewerFeatureFlags',
      ...operationOptions
    });
};

/**
 * __useViewerFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useViewerFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerFeatureFlagsQuery({
 *   variables: {
 *      rampIDType: // value for 'rampIDType'
 *   },
 * });
 */
export function useViewerFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables> & ({ variables: ViewerFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>(ViewerFeatureFlagsDocument, options);
      }
export function useViewerFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>(ViewerFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useViewerFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>;
export function useViewerFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerFeatureFlagsQuery | undefined, ViewerFeatureFlagsQueryVariables>;
export function useViewerFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>(ViewerFeatureFlagsDocument, options);
        }
export type ViewerFeatureFlagsQueryHookResult = ReturnType<typeof useViewerFeatureFlagsQuery>;
export type ViewerFeatureFlagsLazyQueryHookResult = ReturnType<typeof useViewerFeatureFlagsLazyQuery>;
export type ViewerFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useViewerFeatureFlagsSuspenseQuery>;
export type ViewerFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>;
export const UpsertViewDocument = gql`
    mutation upsertView($id: ID, $entityName: String, $projectName: String, $type: String, $name: String, $description: String, $spec: String!, $specIsGzipped: Boolean) {
  upsertView(
    input: {id: $id, entityName: $entityName, projectName: $projectName, name: $name, description: $description, type: $type, spec: $spec, specIsGzipped: $specIsGzipped}
  ) {
    view {
      id
      ...ViewFragment
    }
    inserted
  }
}
    ${ViewFragmentFragmentDoc}`;
export type UpsertViewMutationFn = ApolloReactCommon.MutationFunction<UpsertViewMutation, UpsertViewMutationVariables>;
export type UpsertViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertViewMutation, UpsertViewMutationVariables>, 'mutation'>;

    export const UpsertViewComponent = (props: UpsertViewComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertViewMutation, UpsertViewMutationVariables> mutation={UpsertViewDocument} {...props} />
    );
    
export type UpsertViewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertViewMutation, UpsertViewMutationVariables>
    } & TChildProps;
export function withUpsertView<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertViewMutation,
  UpsertViewMutationVariables,
  UpsertViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertViewMutation, UpsertViewMutationVariables, UpsertViewProps<TChildProps, TDataName>>(UpsertViewDocument, {
      alias: 'upsertView',
      ...operationOptions
    });
};

/**
 * __useUpsertViewMutation__
 *
 * To run a mutation, you first call `useUpsertViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertViewMutation, { data, loading, error }] = useUpsertViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      spec: // value for 'spec'
 *      specIsGzipped: // value for 'specIsGzipped'
 *   },
 * });
 */
export function useUpsertViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertViewMutation, UpsertViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertViewMutation, UpsertViewMutationVariables>(UpsertViewDocument, options);
      }
export type UpsertViewMutationHookResult = ReturnType<typeof useUpsertViewMutation>;
export type UpsertViewMutationResult = ApolloReactCommon.MutationResult<UpsertViewMutation>;
export type UpsertViewMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertViewMutation, UpsertViewMutationVariables>;
export const DeleteViewDocument = gql`
    mutation deleteView($id: ID) {
  deleteView(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteViewMutationFn = ApolloReactCommon.MutationFunction<DeleteViewMutation, DeleteViewMutationVariables>;
export type DeleteViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteViewMutation, DeleteViewMutationVariables>, 'mutation'>;

    export const DeleteViewComponent = (props: DeleteViewComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteViewMutation, DeleteViewMutationVariables> mutation={DeleteViewDocument} {...props} />
    );
    
export type DeleteViewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteViewMutation, DeleteViewMutationVariables>
    } & TChildProps;
export function withDeleteView<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteViewMutation,
  DeleteViewMutationVariables,
  DeleteViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteViewMutation, DeleteViewMutationVariables, DeleteViewProps<TChildProps, TDataName>>(DeleteViewDocument, {
      alias: 'deleteView',
      ...operationOptions
    });
};

/**
 * __useDeleteViewMutation__
 *
 * To run a mutation, you first call `useDeleteViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewMutation, { data, loading, error }] = useDeleteViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteViewMutation, DeleteViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteViewMutation, DeleteViewMutationVariables>(DeleteViewDocument, options);
      }
export type DeleteViewMutationHookResult = ReturnType<typeof useDeleteViewMutation>;
export type DeleteViewMutationResult = ApolloReactCommon.MutationResult<DeleteViewMutation>;
export type DeleteViewMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteViewMutation, DeleteViewMutationVariables>;
export const CreateSharedViewDocument = gql`
    mutation createSharedView($entityName: String!, $name: String!, $type: String!, $description: String, $spec: String!) {
  upsertSharedView(
    input: {entityName: $entityName, name: $name, type: $type, description: $description, spec: $spec}
  ) {
    view {
      id
      ...ViewFragment
    }
  }
}
    ${ViewFragmentFragmentDoc}`;
export type CreateSharedViewMutationFn = ApolloReactCommon.MutationFunction<CreateSharedViewMutation, CreateSharedViewMutationVariables>;
export type CreateSharedViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSharedViewMutation, CreateSharedViewMutationVariables>, 'mutation'>;

    export const CreateSharedViewComponent = (props: CreateSharedViewComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSharedViewMutation, CreateSharedViewMutationVariables> mutation={CreateSharedViewDocument} {...props} />
    );
    
export type CreateSharedViewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateSharedViewMutation, CreateSharedViewMutationVariables>
    } & TChildProps;
export function withCreateSharedView<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSharedViewMutation,
  CreateSharedViewMutationVariables,
  CreateSharedViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSharedViewMutation, CreateSharedViewMutationVariables, CreateSharedViewProps<TChildProps, TDataName>>(CreateSharedViewDocument, {
      alias: 'createSharedView',
      ...operationOptions
    });
};

/**
 * __useCreateSharedViewMutation__
 *
 * To run a mutation, you first call `useCreateSharedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharedViewMutation, { data, loading, error }] = useCreateSharedViewMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      description: // value for 'description'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useCreateSharedViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSharedViewMutation, CreateSharedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSharedViewMutation, CreateSharedViewMutationVariables>(CreateSharedViewDocument, options);
      }
export type CreateSharedViewMutationHookResult = ReturnType<typeof useCreateSharedViewMutation>;
export type CreateSharedViewMutationResult = ApolloReactCommon.MutationResult<CreateSharedViewMutation>;
export type CreateSharedViewMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSharedViewMutation, CreateSharedViewMutationVariables>;
export const ViewParentDocument = gql`
    query viewParent($id: ID!) {
  viewParent(id: $id) {
    id
    displayName
  }
}
    `;
export type ViewParentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewParentQuery, ViewParentQueryVariables>, 'query'> & ({ variables: ViewParentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewParentComponent = (props: ViewParentComponentProps) => (
      <ApolloReactComponents.Query<ViewParentQuery, ViewParentQueryVariables> query={ViewParentDocument} {...props} />
    );
    
export type ViewParentProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewParentQuery, ViewParentQueryVariables>
    } & TChildProps;
export function withViewParent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewParentQuery,
  ViewParentQueryVariables,
  ViewParentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewParentQuery, ViewParentQueryVariables, ViewParentProps<TChildProps, TDataName>>(ViewParentDocument, {
      alias: 'viewParent',
      ...operationOptions
    });
};

/**
 * __useViewParentQuery__
 *
 * To run a query within a React component, call `useViewParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewParentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewParentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewParentQuery, ViewParentQueryVariables> & ({ variables: ViewParentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewParentQuery, ViewParentQueryVariables>(ViewParentDocument, options);
      }
export function useViewParentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewParentQuery, ViewParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewParentQuery, ViewParentQueryVariables>(ViewParentDocument, options);
        }
// @ts-ignore
export function useViewParentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewParentQuery, ViewParentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewParentQuery, ViewParentQueryVariables>;
export function useViewParentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewParentQuery, ViewParentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewParentQuery | undefined, ViewParentQueryVariables>;
export function useViewParentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewParentQuery, ViewParentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewParentQuery, ViewParentQueryVariables>(ViewParentDocument, options);
        }
export type ViewParentQueryHookResult = ReturnType<typeof useViewParentQuery>;
export type ViewParentLazyQueryHookResult = ReturnType<typeof useViewParentLazyQuery>;
export type ViewParentSuspenseQueryHookResult = ReturnType<typeof useViewParentSuspenseQuery>;
export type ViewParentQueryResult = ApolloReactCommon.QueryResult<ViewParentQuery, ViewParentQueryVariables>;
export const ViewChildrenDocument = gql`
    query viewChildren($id: ID!) {
  view(id: $id) {
    id
    children {
      edges {
        node {
          id
          displayName
          user {
            id
          }
        }
      }
    }
  }
}
    `;
export type ViewChildrenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewChildrenQuery, ViewChildrenQueryVariables>, 'query'> & ({ variables: ViewChildrenQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewChildrenComponent = (props: ViewChildrenComponentProps) => (
      <ApolloReactComponents.Query<ViewChildrenQuery, ViewChildrenQueryVariables> query={ViewChildrenDocument} {...props} />
    );
    
export type ViewChildrenProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewChildrenQuery, ViewChildrenQueryVariables>
    } & TChildProps;
export function withViewChildren<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewChildrenQuery,
  ViewChildrenQueryVariables,
  ViewChildrenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewChildrenQuery, ViewChildrenQueryVariables, ViewChildrenProps<TChildProps, TDataName>>(ViewChildrenDocument, {
      alias: 'viewChildren',
      ...operationOptions
    });
};

/**
 * __useViewChildrenQuery__
 *
 * To run a query within a React component, call `useViewChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewChildrenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewChildrenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables> & ({ variables: ViewChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewChildrenQuery, ViewChildrenQueryVariables>(ViewChildrenDocument, options);
      }
export function useViewChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewChildrenQuery, ViewChildrenQueryVariables>(ViewChildrenDocument, options);
        }
// @ts-ignore
export function useViewChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewChildrenQuery, ViewChildrenQueryVariables>;
export function useViewChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewChildrenQuery | undefined, ViewChildrenQueryVariables>;
export function useViewChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewChildrenQuery, ViewChildrenQueryVariables>(ViewChildrenDocument, options);
        }
export type ViewChildrenQueryHookResult = ReturnType<typeof useViewChildrenQuery>;
export type ViewChildrenLazyQueryHookResult = ReturnType<typeof useViewChildrenLazyQuery>;
export type ViewChildrenSuspenseQueryHookResult = ReturnType<typeof useViewChildrenSuspenseQuery>;
export type ViewChildrenQueryResult = ApolloReactCommon.QueryResult<ViewChildrenQuery, ViewChildrenQueryVariables>;
export const AcademicApplicationOrgInfoDocument = gql`
    query AcademicApplicationOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    subscriptions {
      id
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;
export type AcademicApplicationOrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>, 'query'> & ({ variables: AcademicApplicationOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AcademicApplicationOrgInfoComponent = (props: AcademicApplicationOrgInfoComponentProps) => (
      <ApolloReactComponents.Query<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables> query={AcademicApplicationOrgInfoDocument} {...props} />
    );
    
export type AcademicApplicationOrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>
    } & TChildProps;
export function withAcademicApplicationOrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcademicApplicationOrgInfoQuery,
  AcademicApplicationOrgInfoQueryVariables,
  AcademicApplicationOrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables, AcademicApplicationOrgInfoProps<TChildProps, TDataName>>(AcademicApplicationOrgInfoDocument, {
      alias: 'academicApplicationOrgInfo',
      ...operationOptions
    });
};

/**
 * __useAcademicApplicationOrgInfoQuery__
 *
 * To run a query within a React component, call `useAcademicApplicationOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicApplicationOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicApplicationOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useAcademicApplicationOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables> & ({ variables: AcademicApplicationOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>(AcademicApplicationOrgInfoDocument, options);
      }
export function useAcademicApplicationOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>(AcademicApplicationOrgInfoDocument, options);
        }
// @ts-ignore
export function useAcademicApplicationOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>;
export function useAcademicApplicationOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AcademicApplicationOrgInfoQuery | undefined, AcademicApplicationOrgInfoQueryVariables>;
export function useAcademicApplicationOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>(AcademicApplicationOrgInfoDocument, options);
        }
export type AcademicApplicationOrgInfoQueryHookResult = ReturnType<typeof useAcademicApplicationOrgInfoQuery>;
export type AcademicApplicationOrgInfoLazyQueryHookResult = ReturnType<typeof useAcademicApplicationOrgInfoLazyQuery>;
export type AcademicApplicationOrgInfoSuspenseQueryHookResult = ReturnType<typeof useAcademicApplicationOrgInfoSuspenseQuery>;
export type AcademicApplicationOrgInfoQueryResult = ApolloReactCommon.QueryResult<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>;
export const UpsertLinkedBenchmarkDocument = gql`
    mutation upsertLinkedBenchmark($description: String, $entityName: String, $id: String, $name: String, $framework: String, $access: String, $views: JSONString, $linkedBenchmark: ID) {
  upsertModel(
    input: {description: $description, entityName: $entityName, id: $id, name: $name, framework: $framework, access: $access, views: $views, linkedBenchmark: $linkedBenchmark}
  ) {
    project {
      id
      name
      entityName
      description
      access
      views
      isBenchmark
      linkedBenchmark {
        id
        name
      }
    }
    inserted
  }
}
    `;
export type UpsertLinkedBenchmarkMutationFn = ApolloReactCommon.MutationFunction<UpsertLinkedBenchmarkMutation, UpsertLinkedBenchmarkMutationVariables>;
export type UpsertLinkedBenchmarkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertLinkedBenchmarkMutation, UpsertLinkedBenchmarkMutationVariables>, 'mutation'>;

    export const UpsertLinkedBenchmarkComponent = (props: UpsertLinkedBenchmarkComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertLinkedBenchmarkMutation, UpsertLinkedBenchmarkMutationVariables> mutation={UpsertLinkedBenchmarkDocument} {...props} />
    );
    
export type UpsertLinkedBenchmarkProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertLinkedBenchmarkMutation, UpsertLinkedBenchmarkMutationVariables>
    } & TChildProps;
export function withUpsertLinkedBenchmark<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertLinkedBenchmarkMutation,
  UpsertLinkedBenchmarkMutationVariables,
  UpsertLinkedBenchmarkProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertLinkedBenchmarkMutation, UpsertLinkedBenchmarkMutationVariables, UpsertLinkedBenchmarkProps<TChildProps, TDataName>>(UpsertLinkedBenchmarkDocument, {
      alias: 'upsertLinkedBenchmark',
      ...operationOptions
    });
};

/**
 * __useUpsertLinkedBenchmarkMutation__
 *
 * To run a mutation, you first call `useUpsertLinkedBenchmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLinkedBenchmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLinkedBenchmarkMutation, { data, loading, error }] = useUpsertLinkedBenchmarkMutation({
 *   variables: {
 *      description: // value for 'description'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      framework: // value for 'framework'
 *      access: // value for 'access'
 *      views: // value for 'views'
 *      linkedBenchmark: // value for 'linkedBenchmark'
 *   },
 * });
 */
export function useUpsertLinkedBenchmarkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertLinkedBenchmarkMutation, UpsertLinkedBenchmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertLinkedBenchmarkMutation, UpsertLinkedBenchmarkMutationVariables>(UpsertLinkedBenchmarkDocument, options);
      }
export type UpsertLinkedBenchmarkMutationHookResult = ReturnType<typeof useUpsertLinkedBenchmarkMutation>;
export type UpsertLinkedBenchmarkMutationResult = ApolloReactCommon.MutationResult<UpsertLinkedBenchmarkMutation>;
export type UpsertLinkedBenchmarkMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertLinkedBenchmarkMutation, UpsertLinkedBenchmarkMutationVariables>;
export const MostActiveMembersDocument = gql`
    query MostActiveMembers($organizationId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  organization(id: $organizationId) {
    id
    members {
      id
      name
      username
      photoUrl
      daysActive(start: $startDate, end: $endDate)
      lastActiveAt
    }
  }
}
    `;
export type MostActiveMembersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>, 'query'> & ({ variables: MostActiveMembersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MostActiveMembersComponent = (props: MostActiveMembersComponentProps) => (
      <ApolloReactComponents.Query<MostActiveMembersQuery, MostActiveMembersQueryVariables> query={MostActiveMembersDocument} {...props} />
    );
    
export type MostActiveMembersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MostActiveMembersQuery, MostActiveMembersQueryVariables>
    } & TChildProps;
export function withMostActiveMembers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MostActiveMembersQuery,
  MostActiveMembersQueryVariables,
  MostActiveMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MostActiveMembersQuery, MostActiveMembersQueryVariables, MostActiveMembersProps<TChildProps, TDataName>>(MostActiveMembersDocument, {
      alias: 'mostActiveMembers',
      ...operationOptions
    });
};

/**
 * __useMostActiveMembersQuery__
 *
 * To run a query within a React component, call `useMostActiveMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostActiveMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostActiveMembersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useMostActiveMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables> & ({ variables: MostActiveMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MostActiveMembersQuery, MostActiveMembersQueryVariables>(MostActiveMembersDocument, options);
      }
export function useMostActiveMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MostActiveMembersQuery, MostActiveMembersQueryVariables>(MostActiveMembersDocument, options);
        }
// @ts-ignore
export function useMostActiveMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MostActiveMembersQuery, MostActiveMembersQueryVariables>;
export function useMostActiveMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MostActiveMembersQuery | undefined, MostActiveMembersQueryVariables>;
export function useMostActiveMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MostActiveMembersQuery, MostActiveMembersQueryVariables>(MostActiveMembersDocument, options);
        }
export type MostActiveMembersQueryHookResult = ReturnType<typeof useMostActiveMembersQuery>;
export type MostActiveMembersLazyQueryHookResult = ReturnType<typeof useMostActiveMembersLazyQuery>;
export type MostActiveMembersSuspenseQueryHookResult = ReturnType<typeof useMostActiveMembersSuspenseQuery>;
export type MostActiveMembersQueryResult = ApolloReactCommon.QueryResult<MostActiveMembersQuery, MostActiveMembersQueryVariables>;
export const OrganizationMemberActivityDocument = gql`
    query OrganizationMemberActivity($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    members {
      id
      lastActiveAt
    }
    activeUsersForRange {
      last7Days
      last30Days
      last90Days
      last6Months
      last12Months
    }
  }
}
    `;
export type OrganizationMemberActivityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>, 'query'> & ({ variables: OrganizationMemberActivityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationMemberActivityComponent = (props: OrganizationMemberActivityComponentProps) => (
      <ApolloReactComponents.Query<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables> query={OrganizationMemberActivityDocument} {...props} />
    );
    
export type OrganizationMemberActivityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>
    } & TChildProps;
export function withOrganizationMemberActivity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationMemberActivityQuery,
  OrganizationMemberActivityQueryVariables,
  OrganizationMemberActivityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables, OrganizationMemberActivityProps<TChildProps, TDataName>>(OrganizationMemberActivityDocument, {
      alias: 'organizationMemberActivity',
      ...operationOptions
    });
};

/**
 * __useOrganizationMemberActivityQuery__
 *
 * To run a query within a React component, call `useOrganizationMemberActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMemberActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMemberActivityQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationMemberActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables> & ({ variables: OrganizationMemberActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>(OrganizationMemberActivityDocument, options);
      }
export function useOrganizationMemberActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>(OrganizationMemberActivityDocument, options);
        }
// @ts-ignore
export function useOrganizationMemberActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>;
export function useOrganizationMemberActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberActivityQuery | undefined, OrganizationMemberActivityQueryVariables>;
export function useOrganizationMemberActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>(OrganizationMemberActivityDocument, options);
        }
export type OrganizationMemberActivityQueryHookResult = ReturnType<typeof useOrganizationMemberActivityQuery>;
export type OrganizationMemberActivityLazyQueryHookResult = ReturnType<typeof useOrganizationMemberActivityLazyQuery>;
export type OrganizationMemberActivitySuspenseQueryHookResult = ReturnType<typeof useOrganizationMemberActivitySuspenseQuery>;
export type OrganizationMemberActivityQueryResult = ApolloReactCommon.QueryResult<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>;
export const CreateAlertThresholdDocument = gql`
    mutation CreateAlertThreshold($input: CreateAlertThresholdInput!) {
  createAlertThreshold(input: $input) {
    success
    alertThreshold {
      id
      type
      value
      emailSent
      isEnabled
      product
    }
  }
}
    `;
export type CreateAlertThresholdMutationFn = ApolloReactCommon.MutationFunction<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>;
export type CreateAlertThresholdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>, 'mutation'>;

    export const CreateAlertThresholdComponent = (props: CreateAlertThresholdComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables> mutation={CreateAlertThresholdDocument} {...props} />
    );
    
export type CreateAlertThresholdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>
    } & TChildProps;
export function withCreateAlertThreshold<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAlertThresholdMutation,
  CreateAlertThresholdMutationVariables,
  CreateAlertThresholdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables, CreateAlertThresholdProps<TChildProps, TDataName>>(CreateAlertThresholdDocument, {
      alias: 'createAlertThreshold',
      ...operationOptions
    });
};

/**
 * __useCreateAlertThresholdMutation__
 *
 * To run a mutation, you first call `useCreateAlertThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertThresholdMutation, { data, loading, error }] = useCreateAlertThresholdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlertThresholdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>(CreateAlertThresholdDocument, options);
      }
export type CreateAlertThresholdMutationHookResult = ReturnType<typeof useCreateAlertThresholdMutation>;
export type CreateAlertThresholdMutationResult = ApolloReactCommon.MutationResult<CreateAlertThresholdMutation>;
export type CreateAlertThresholdMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>;
export const DeleteAlertThresholdDocument = gql`
    mutation DeleteAlertThreshold($input: DeleteAlertThresholdInput!) {
  deleteAlertThreshold(input: $input) {
    success
  }
}
    `;
export type DeleteAlertThresholdMutationFn = ApolloReactCommon.MutationFunction<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>;
export type DeleteAlertThresholdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>, 'mutation'>;

    export const DeleteAlertThresholdComponent = (props: DeleteAlertThresholdComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables> mutation={DeleteAlertThresholdDocument} {...props} />
    );
    
export type DeleteAlertThresholdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>
    } & TChildProps;
export function withDeleteAlertThreshold<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteAlertThresholdMutation,
  DeleteAlertThresholdMutationVariables,
  DeleteAlertThresholdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables, DeleteAlertThresholdProps<TChildProps, TDataName>>(DeleteAlertThresholdDocument, {
      alias: 'deleteAlertThreshold',
      ...operationOptions
    });
};

/**
 * __useDeleteAlertThresholdMutation__
 *
 * To run a mutation, you first call `useDeleteAlertThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertThresholdMutation, { data, loading, error }] = useDeleteAlertThresholdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAlertThresholdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>(DeleteAlertThresholdDocument, options);
      }
export type DeleteAlertThresholdMutationHookResult = ReturnType<typeof useDeleteAlertThresholdMutation>;
export type DeleteAlertThresholdMutationResult = ApolloReactCommon.MutationResult<DeleteAlertThresholdMutation>;
export type DeleteAlertThresholdMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>;
export const UpdateAlertThresholdDocument = gql`
    mutation UpdateAlertThreshold($input: UpdateAlertThresholdInput!) {
  updateAlertThreshold(input: $input) {
    success
    alertThreshold {
      id
      isEnabled
    }
  }
}
    `;
export type UpdateAlertThresholdMutationFn = ApolloReactCommon.MutationFunction<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>;
export type UpdateAlertThresholdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>, 'mutation'>;

    export const UpdateAlertThresholdComponent = (props: UpdateAlertThresholdComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables> mutation={UpdateAlertThresholdDocument} {...props} />
    );
    
export type UpdateAlertThresholdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>
    } & TChildProps;
export function withUpdateAlertThreshold<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAlertThresholdMutation,
  UpdateAlertThresholdMutationVariables,
  UpdateAlertThresholdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables, UpdateAlertThresholdProps<TChildProps, TDataName>>(UpdateAlertThresholdDocument, {
      alias: 'updateAlertThreshold',
      ...operationOptions
    });
};

/**
 * __useUpdateAlertThresholdMutation__
 *
 * To run a mutation, you first call `useUpdateAlertThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertThresholdMutation, { data, loading, error }] = useUpdateAlertThresholdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlertThresholdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>(UpdateAlertThresholdDocument, options);
      }
export type UpdateAlertThresholdMutationHookResult = ReturnType<typeof useUpdateAlertThresholdMutation>;
export type UpdateAlertThresholdMutationResult = ApolloReactCommon.MutationResult<UpdateAlertThresholdMutation>;
export type UpdateAlertThresholdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>;
export const AlertsTabOrgInfoDocument = gql`
    query AlertsTabOrgInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    alertThresholds {
      id
      type
      value
      emailSent
      isEnabled
      product
    }
  }
}
    `;
export type AlertsTabOrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>, 'query'> & ({ variables: AlertsTabOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AlertsTabOrgInfoComponent = (props: AlertsTabOrgInfoComponentProps) => (
      <ApolloReactComponents.Query<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables> query={AlertsTabOrgInfoDocument} {...props} />
    );
    
export type AlertsTabOrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>
    } & TChildProps;
export function withAlertsTabOrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AlertsTabOrgInfoQuery,
  AlertsTabOrgInfoQueryVariables,
  AlertsTabOrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables, AlertsTabOrgInfoProps<TChildProps, TDataName>>(AlertsTabOrgInfoDocument, {
      alias: 'alertsTabOrgInfo',
      ...operationOptions
    });
};

/**
 * __useAlertsTabOrgInfoQuery__
 *
 * To run a query within a React component, call `useAlertsTabOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsTabOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsTabOrgInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useAlertsTabOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables> & ({ variables: AlertsTabOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>(AlertsTabOrgInfoDocument, options);
      }
export function useAlertsTabOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>(AlertsTabOrgInfoDocument, options);
        }
// @ts-ignore
export function useAlertsTabOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>;
export function useAlertsTabOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AlertsTabOrgInfoQuery | undefined, AlertsTabOrgInfoQueryVariables>;
export function useAlertsTabOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>(AlertsTabOrgInfoDocument, options);
        }
export type AlertsTabOrgInfoQueryHookResult = ReturnType<typeof useAlertsTabOrgInfoQuery>;
export type AlertsTabOrgInfoLazyQueryHookResult = ReturnType<typeof useAlertsTabOrgInfoLazyQuery>;
export type AlertsTabOrgInfoSuspenseQueryHookResult = ReturnType<typeof useAlertsTabOrgInfoSuspenseQuery>;
export type AlertsTabOrgInfoQueryResult = ApolloReactCommon.QueryResult<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>;
export const CurrentBillingPeriodUsageSectionOrgInfoDocument = gql`
    query CurrentBillingPeriodUsageSectionOrgInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    createdAt
    usedSeats
    teams {
      id
      name
    }
    subscriptions {
      id
      billingPeriodStart
      billingPeriodEnd
      subscriptionType
      seats
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;
export type CurrentBillingPeriodUsageSectionOrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>, 'query'> & ({ variables: CurrentBillingPeriodUsageSectionOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CurrentBillingPeriodUsageSectionOrgInfoComponent = (props: CurrentBillingPeriodUsageSectionOrgInfoComponentProps) => (
      <ApolloReactComponents.Query<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables> query={CurrentBillingPeriodUsageSectionOrgInfoDocument} {...props} />
    );
    
export type CurrentBillingPeriodUsageSectionOrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>
    } & TChildProps;
export function withCurrentBillingPeriodUsageSectionOrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentBillingPeriodUsageSectionOrgInfoQuery,
  CurrentBillingPeriodUsageSectionOrgInfoQueryVariables,
  CurrentBillingPeriodUsageSectionOrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables, CurrentBillingPeriodUsageSectionOrgInfoProps<TChildProps, TDataName>>(CurrentBillingPeriodUsageSectionOrgInfoDocument, {
      alias: 'currentBillingPeriodUsageSectionOrgInfo',
      ...operationOptions
    });
};

/**
 * __useCurrentBillingPeriodUsageSectionOrgInfoQuery__
 *
 * To run a query within a React component, call `useCurrentBillingPeriodUsageSectionOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBillingPeriodUsageSectionOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBillingPeriodUsageSectionOrgInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useCurrentBillingPeriodUsageSectionOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables> & ({ variables: CurrentBillingPeriodUsageSectionOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>(CurrentBillingPeriodUsageSectionOrgInfoDocument, options);
      }
export function useCurrentBillingPeriodUsageSectionOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>(CurrentBillingPeriodUsageSectionOrgInfoDocument, options);
        }
// @ts-ignore
export function useCurrentBillingPeriodUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>;
export function useCurrentBillingPeriodUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentBillingPeriodUsageSectionOrgInfoQuery | undefined, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>;
export function useCurrentBillingPeriodUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>(CurrentBillingPeriodUsageSectionOrgInfoDocument, options);
        }
export type CurrentBillingPeriodUsageSectionOrgInfoQueryHookResult = ReturnType<typeof useCurrentBillingPeriodUsageSectionOrgInfoQuery>;
export type CurrentBillingPeriodUsageSectionOrgInfoLazyQueryHookResult = ReturnType<typeof useCurrentBillingPeriodUsageSectionOrgInfoLazyQuery>;
export type CurrentBillingPeriodUsageSectionOrgInfoSuspenseQueryHookResult = ReturnType<typeof useCurrentBillingPeriodUsageSectionOrgInfoSuspenseQuery>;
export type CurrentBillingPeriodUsageSectionOrgInfoQueryResult = ApolloReactCommon.QueryResult<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>;
export const EnterpriseBillingPeriodOrgInfoDocument = gql`
    query EnterpriseBillingPeriodOrgInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    weaveEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
    }
  }
}
    `;
export type EnterpriseBillingPeriodOrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>, 'query'> & ({ variables: EnterpriseBillingPeriodOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EnterpriseBillingPeriodOrgInfoComponent = (props: EnterpriseBillingPeriodOrgInfoComponentProps) => (
      <ApolloReactComponents.Query<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables> query={EnterpriseBillingPeriodOrgInfoDocument} {...props} />
    );
    
export type EnterpriseBillingPeriodOrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>
    } & TChildProps;
export function withEnterpriseBillingPeriodOrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EnterpriseBillingPeriodOrgInfoQuery,
  EnterpriseBillingPeriodOrgInfoQueryVariables,
  EnterpriseBillingPeriodOrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables, EnterpriseBillingPeriodOrgInfoProps<TChildProps, TDataName>>(EnterpriseBillingPeriodOrgInfoDocument, {
      alias: 'enterpriseBillingPeriodOrgInfo',
      ...operationOptions
    });
};

/**
 * __useEnterpriseBillingPeriodOrgInfoQuery__
 *
 * To run a query within a React component, call `useEnterpriseBillingPeriodOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseBillingPeriodOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseBillingPeriodOrgInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useEnterpriseBillingPeriodOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables> & ({ variables: EnterpriseBillingPeriodOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>(EnterpriseBillingPeriodOrgInfoDocument, options);
      }
export function useEnterpriseBillingPeriodOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>(EnterpriseBillingPeriodOrgInfoDocument, options);
        }
// @ts-ignore
export function useEnterpriseBillingPeriodOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>;
export function useEnterpriseBillingPeriodOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnterpriseBillingPeriodOrgInfoQuery | undefined, EnterpriseBillingPeriodOrgInfoQueryVariables>;
export function useEnterpriseBillingPeriodOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>(EnterpriseBillingPeriodOrgInfoDocument, options);
        }
export type EnterpriseBillingPeriodOrgInfoQueryHookResult = ReturnType<typeof useEnterpriseBillingPeriodOrgInfoQuery>;
export type EnterpriseBillingPeriodOrgInfoLazyQueryHookResult = ReturnType<typeof useEnterpriseBillingPeriodOrgInfoLazyQuery>;
export type EnterpriseBillingPeriodOrgInfoSuspenseQueryHookResult = ReturnType<typeof useEnterpriseBillingPeriodOrgInfoSuspenseQuery>;
export type EnterpriseBillingPeriodOrgInfoQueryResult = ApolloReactCommon.QueryResult<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>;
export const UsageTotalInfoDocument = gql`
    query UsageTotalInfo($orgName: String!, $usageType: UsageType!, $intervalMarkers: [DateTime!]!) {
  organization(name: $orgName) {
    id
    createdAt
    usageTotal(usageType: $usageType, intervalMarkers: $intervalMarkers)
  }
}
    `;
export type UsageTotalInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>, 'query'> & ({ variables: UsageTotalInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UsageTotalInfoComponent = (props: UsageTotalInfoComponentProps) => (
      <ApolloReactComponents.Query<UsageTotalInfoQuery, UsageTotalInfoQueryVariables> query={UsageTotalInfoDocument} {...props} />
    );
    
export type UsageTotalInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>
    } & TChildProps;
export function withUsageTotalInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UsageTotalInfoQuery,
  UsageTotalInfoQueryVariables,
  UsageTotalInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UsageTotalInfoQuery, UsageTotalInfoQueryVariables, UsageTotalInfoProps<TChildProps, TDataName>>(UsageTotalInfoDocument, {
      alias: 'usageTotalInfo',
      ...operationOptions
    });
};

/**
 * __useUsageTotalInfoQuery__
 *
 * To run a query within a React component, call `useUsageTotalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageTotalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageTotalInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      usageType: // value for 'usageType'
 *      intervalMarkers: // value for 'intervalMarkers'
 *   },
 * });
 */
export function useUsageTotalInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables> & ({ variables: UsageTotalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>(UsageTotalInfoDocument, options);
      }
export function useUsageTotalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>(UsageTotalInfoDocument, options);
        }
// @ts-ignore
export function useUsageTotalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>;
export function useUsageTotalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsageTotalInfoQuery | undefined, UsageTotalInfoQueryVariables>;
export function useUsageTotalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>(UsageTotalInfoDocument, options);
        }
export type UsageTotalInfoQueryHookResult = ReturnType<typeof useUsageTotalInfoQuery>;
export type UsageTotalInfoLazyQueryHookResult = ReturnType<typeof useUsageTotalInfoLazyQuery>;
export type UsageTotalInfoSuspenseQueryHookResult = ReturnType<typeof useUsageTotalInfoSuspenseQuery>;
export type UsageTotalInfoQueryResult = ApolloReactCommon.QueryResult<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>;
export const CurrentPlanPageOrgInfoDocument = gql`
    query CurrentPlanPageOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    usedSeats
    createdAt
    subscriptions {
      id
      status
      seats
      plan {
        id
        planType
        name
      }
    }
    teams {
      id
      name
    }
    stripeBillingInfo {
      currentPeriodEnd
    }
  }
}
    `;
export type CurrentPlanPageOrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>, 'query'> & ({ variables: CurrentPlanPageOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CurrentPlanPageOrgInfoComponent = (props: CurrentPlanPageOrgInfoComponentProps) => (
      <ApolloReactComponents.Query<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables> query={CurrentPlanPageOrgInfoDocument} {...props} />
    );
    
export type CurrentPlanPageOrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>
    } & TChildProps;
export function withCurrentPlanPageOrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentPlanPageOrgInfoQuery,
  CurrentPlanPageOrgInfoQueryVariables,
  CurrentPlanPageOrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables, CurrentPlanPageOrgInfoProps<TChildProps, TDataName>>(CurrentPlanPageOrgInfoDocument, {
      alias: 'currentPlanPageOrgInfo',
      ...operationOptions
    });
};

/**
 * __useCurrentPlanPageOrgInfoQuery__
 *
 * To run a query within a React component, call `useCurrentPlanPageOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPlanPageOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPlanPageOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useCurrentPlanPageOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables> & ({ variables: CurrentPlanPageOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>(CurrentPlanPageOrgInfoDocument, options);
      }
export function useCurrentPlanPageOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>(CurrentPlanPageOrgInfoDocument, options);
        }
// @ts-ignore
export function useCurrentPlanPageOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>;
export function useCurrentPlanPageOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentPlanPageOrgInfoQuery | undefined, CurrentPlanPageOrgInfoQueryVariables>;
export function useCurrentPlanPageOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>(CurrentPlanPageOrgInfoDocument, options);
        }
export type CurrentPlanPageOrgInfoQueryHookResult = ReturnType<typeof useCurrentPlanPageOrgInfoQuery>;
export type CurrentPlanPageOrgInfoLazyQueryHookResult = ReturnType<typeof useCurrentPlanPageOrgInfoLazyQuery>;
export type CurrentPlanPageOrgInfoSuspenseQueryHookResult = ReturnType<typeof useCurrentPlanPageOrgInfoSuspenseQuery>;
export type CurrentPlanPageOrgInfoQueryResult = ApolloReactCommon.QueryResult<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>;
export const PrimaryPlanCardV3OrgInfoDocument = gql`
    query PrimaryPlanCardV3OrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    usedSeats
    createdAt
    teams {
      id
      name
      computeHours
    }
    subscriptions {
      id
      expiresAt
      seats
      billingPeriodStart
      billingPeriodEnd
      subscriptionType
      status
      discount {
        start
        end
        coupon {
          id
          amountOff
          percentOff
          duration
          currency
          name
        }
      }
      plan {
        id
        displayName
        planType
        name
        stripePrice {
          amount
        }
        billingInterval
        unitPrice
      }
    }
  }
}
    `;
export type PrimaryPlanCardV3OrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>, 'query'> & ({ variables: PrimaryPlanCardV3OrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PrimaryPlanCardV3OrgInfoComponent = (props: PrimaryPlanCardV3OrgInfoComponentProps) => (
      <ApolloReactComponents.Query<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables> query={PrimaryPlanCardV3OrgInfoDocument} {...props} />
    );
    
export type PrimaryPlanCardV3OrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>
    } & TChildProps;
export function withPrimaryPlanCardV3OrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PrimaryPlanCardV3OrgInfoQuery,
  PrimaryPlanCardV3OrgInfoQueryVariables,
  PrimaryPlanCardV3OrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables, PrimaryPlanCardV3OrgInfoProps<TChildProps, TDataName>>(PrimaryPlanCardV3OrgInfoDocument, {
      alias: 'primaryPlanCardV3OrgInfo',
      ...operationOptions
    });
};

/**
 * __usePrimaryPlanCardV3OrgInfoQuery__
 *
 * To run a query within a React component, call `usePrimaryPlanCardV3OrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimaryPlanCardV3OrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimaryPlanCardV3OrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function usePrimaryPlanCardV3OrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables> & ({ variables: PrimaryPlanCardV3OrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>(PrimaryPlanCardV3OrgInfoDocument, options);
      }
export function usePrimaryPlanCardV3OrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>(PrimaryPlanCardV3OrgInfoDocument, options);
        }
// @ts-ignore
export function usePrimaryPlanCardV3OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>;
export function usePrimaryPlanCardV3OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PrimaryPlanCardV3OrgInfoQuery | undefined, PrimaryPlanCardV3OrgInfoQueryVariables>;
export function usePrimaryPlanCardV3OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>(PrimaryPlanCardV3OrgInfoDocument, options);
        }
export type PrimaryPlanCardV3OrgInfoQueryHookResult = ReturnType<typeof usePrimaryPlanCardV3OrgInfoQuery>;
export type PrimaryPlanCardV3OrgInfoLazyQueryHookResult = ReturnType<typeof usePrimaryPlanCardV3OrgInfoLazyQuery>;
export type PrimaryPlanCardV3OrgInfoSuspenseQueryHookResult = ReturnType<typeof usePrimaryPlanCardV3OrgInfoSuspenseQuery>;
export type PrimaryPlanCardV3OrgInfoQueryResult = ApolloReactCommon.QueryResult<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>;
export const StoragePlanCardV2OrgInfoDocument = gql`
    query StoragePlanCardV2OrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    createdAt
    teams {
      id
      storageBytes
      referenceBytes
    }
    subscriptions {
      id
      plan {
        id
        name
        planType
      }
      billingPeriodStart
      billingPeriodEnd
      subscriptionType
    }
  }
}
    `;
export type StoragePlanCardV2OrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>, 'query'> & ({ variables: StoragePlanCardV2OrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StoragePlanCardV2OrgInfoComponent = (props: StoragePlanCardV2OrgInfoComponentProps) => (
      <ApolloReactComponents.Query<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables> query={StoragePlanCardV2OrgInfoDocument} {...props} />
    );
    
export type StoragePlanCardV2OrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>
    } & TChildProps;
export function withStoragePlanCardV2OrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StoragePlanCardV2OrgInfoQuery,
  StoragePlanCardV2OrgInfoQueryVariables,
  StoragePlanCardV2OrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables, StoragePlanCardV2OrgInfoProps<TChildProps, TDataName>>(StoragePlanCardV2OrgInfoDocument, {
      alias: 'storagePlanCardV2OrgInfo',
      ...operationOptions
    });
};

/**
 * __useStoragePlanCardV2OrgInfoQuery__
 *
 * To run a query within a React component, call `useStoragePlanCardV2OrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoragePlanCardV2OrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoragePlanCardV2OrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useStoragePlanCardV2OrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables> & ({ variables: StoragePlanCardV2OrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>(StoragePlanCardV2OrgInfoDocument, options);
      }
export function useStoragePlanCardV2OrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>(StoragePlanCardV2OrgInfoDocument, options);
        }
// @ts-ignore
export function useStoragePlanCardV2OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>;
export function useStoragePlanCardV2OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StoragePlanCardV2OrgInfoQuery | undefined, StoragePlanCardV2OrgInfoQueryVariables>;
export function useStoragePlanCardV2OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>(StoragePlanCardV2OrgInfoDocument, options);
        }
export type StoragePlanCardV2OrgInfoQueryHookResult = ReturnType<typeof useStoragePlanCardV2OrgInfoQuery>;
export type StoragePlanCardV2OrgInfoLazyQueryHookResult = ReturnType<typeof useStoragePlanCardV2OrgInfoLazyQuery>;
export type StoragePlanCardV2OrgInfoSuspenseQueryHookResult = ReturnType<typeof useStoragePlanCardV2OrgInfoSuspenseQuery>;
export type StoragePlanCardV2OrgInfoQueryResult = ApolloReactCommon.QueryResult<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>;
export const ServerCurrentBillingPeriodUsageSectionDocument = gql`
    query ServerCurrentBillingPeriodUsageSection {
  serverInfo {
    weaveLimits {
      weaveLimitBytes
      weaveOverageCostCents
      weaveOverageUnit
    }
    contractStartDate
  }
}
    `;
export type ServerCurrentBillingPeriodUsageSectionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>, 'query'>;

    export const ServerCurrentBillingPeriodUsageSectionComponent = (props: ServerCurrentBillingPeriodUsageSectionComponentProps) => (
      <ApolloReactComponents.Query<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables> query={ServerCurrentBillingPeriodUsageSectionDocument} {...props} />
    );
    
export type ServerCurrentBillingPeriodUsageSectionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>
    } & TChildProps;
export function withServerCurrentBillingPeriodUsageSection<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ServerCurrentBillingPeriodUsageSectionQuery,
  ServerCurrentBillingPeriodUsageSectionQueryVariables,
  ServerCurrentBillingPeriodUsageSectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables, ServerCurrentBillingPeriodUsageSectionProps<TChildProps, TDataName>>(ServerCurrentBillingPeriodUsageSectionDocument, {
      alias: 'serverCurrentBillingPeriodUsageSection',
      ...operationOptions
    });
};

/**
 * __useServerCurrentBillingPeriodUsageSectionQuery__
 *
 * To run a query within a React component, call `useServerCurrentBillingPeriodUsageSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerCurrentBillingPeriodUsageSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerCurrentBillingPeriodUsageSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerCurrentBillingPeriodUsageSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>(ServerCurrentBillingPeriodUsageSectionDocument, options);
      }
export function useServerCurrentBillingPeriodUsageSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>(ServerCurrentBillingPeriodUsageSectionDocument, options);
        }
// @ts-ignore
export function useServerCurrentBillingPeriodUsageSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>;
export function useServerCurrentBillingPeriodUsageSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerCurrentBillingPeriodUsageSectionQuery | undefined, ServerCurrentBillingPeriodUsageSectionQueryVariables>;
export function useServerCurrentBillingPeriodUsageSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>(ServerCurrentBillingPeriodUsageSectionDocument, options);
        }
export type ServerCurrentBillingPeriodUsageSectionQueryHookResult = ReturnType<typeof useServerCurrentBillingPeriodUsageSectionQuery>;
export type ServerCurrentBillingPeriodUsageSectionLazyQueryHookResult = ReturnType<typeof useServerCurrentBillingPeriodUsageSectionLazyQuery>;
export type ServerCurrentBillingPeriodUsageSectionSuspenseQueryHookResult = ReturnType<typeof useServerCurrentBillingPeriodUsageSectionSuspenseQuery>;
export type ServerCurrentBillingPeriodUsageSectionQueryResult = ApolloReactCommon.QueryResult<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>;
export const TotalUsageSectionOrgInfoDocument = gql`
    query TotalUsageSectionOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    usedSeats
    subscriptions {
      id
      privileges
      seats
      subscriptionType
      billingPeriodEnd
      plan {
        id
        name
        planType
      }
    }
    teams {
      id
      computeHours
      storageBytes
      referenceBytes
    }
  }
}
    `;
export type TotalUsageSectionOrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>, 'query'> & ({ variables: TotalUsageSectionOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TotalUsageSectionOrgInfoComponent = (props: TotalUsageSectionOrgInfoComponentProps) => (
      <ApolloReactComponents.Query<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables> query={TotalUsageSectionOrgInfoDocument} {...props} />
    );
    
export type TotalUsageSectionOrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>
    } & TChildProps;
export function withTotalUsageSectionOrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TotalUsageSectionOrgInfoQuery,
  TotalUsageSectionOrgInfoQueryVariables,
  TotalUsageSectionOrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables, TotalUsageSectionOrgInfoProps<TChildProps, TDataName>>(TotalUsageSectionOrgInfoDocument, {
      alias: 'totalUsageSectionOrgInfo',
      ...operationOptions
    });
};

/**
 * __useTotalUsageSectionOrgInfoQuery__
 *
 * To run a query within a React component, call `useTotalUsageSectionOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalUsageSectionOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalUsageSectionOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useTotalUsageSectionOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables> & ({ variables: TotalUsageSectionOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>(TotalUsageSectionOrgInfoDocument, options);
      }
export function useTotalUsageSectionOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>(TotalUsageSectionOrgInfoDocument, options);
        }
// @ts-ignore
export function useTotalUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>;
export function useTotalUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TotalUsageSectionOrgInfoQuery | undefined, TotalUsageSectionOrgInfoQueryVariables>;
export function useTotalUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>(TotalUsageSectionOrgInfoDocument, options);
        }
export type TotalUsageSectionOrgInfoQueryHookResult = ReturnType<typeof useTotalUsageSectionOrgInfoQuery>;
export type TotalUsageSectionOrgInfoLazyQueryHookResult = ReturnType<typeof useTotalUsageSectionOrgInfoLazyQuery>;
export type TotalUsageSectionOrgInfoSuspenseQueryHookResult = ReturnType<typeof useTotalUsageSectionOrgInfoSuspenseQuery>;
export type TotalUsageSectionOrgInfoQueryResult = ApolloReactCommon.QueryResult<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>;
export const StorageTableDocument = gql`
    query StorageTable($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    teams {
      id
      name
      storageBytes
      storageTree {
        id
      }
      projects {
        edges {
          node {
            id
            storageBytes
          }
        }
      }
    }
  }
}
    `;
export type StorageTableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StorageTableQuery, StorageTableQueryVariables>, 'query'> & ({ variables: StorageTableQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StorageTableComponent = (props: StorageTableComponentProps) => (
      <ApolloReactComponents.Query<StorageTableQuery, StorageTableQueryVariables> query={StorageTableDocument} {...props} />
    );
    
export type StorageTableProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StorageTableQuery, StorageTableQueryVariables>
    } & TChildProps;
export function withStorageTable<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StorageTableQuery,
  StorageTableQueryVariables,
  StorageTableProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StorageTableQuery, StorageTableQueryVariables, StorageTableProps<TChildProps, TDataName>>(StorageTableDocument, {
      alias: 'storageTable',
      ...operationOptions
    });
};

/**
 * __useStorageTableQuery__
 *
 * To run a query within a React component, call `useStorageTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageTableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStorageTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StorageTableQuery, StorageTableQueryVariables> & ({ variables: StorageTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorageTableQuery, StorageTableQueryVariables>(StorageTableDocument, options);
      }
export function useStorageTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorageTableQuery, StorageTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorageTableQuery, StorageTableQueryVariables>(StorageTableDocument, options);
        }
// @ts-ignore
export function useStorageTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StorageTableQuery, StorageTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StorageTableQuery, StorageTableQueryVariables>;
export function useStorageTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StorageTableQuery, StorageTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StorageTableQuery | undefined, StorageTableQueryVariables>;
export function useStorageTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StorageTableQuery, StorageTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StorageTableQuery, StorageTableQueryVariables>(StorageTableDocument, options);
        }
export type StorageTableQueryHookResult = ReturnType<typeof useStorageTableQuery>;
export type StorageTableLazyQueryHookResult = ReturnType<typeof useStorageTableLazyQuery>;
export type StorageTableSuspenseQueryHookResult = ReturnType<typeof useStorageTableSuspenseQuery>;
export type StorageTableQueryResult = ApolloReactCommon.QueryResult<StorageTableQuery, StorageTableQueryVariables>;
export const DefaultEntityForDomainCaptureDropdownDocument = gql`
    query DefaultEntityForDomainCaptureDropdown($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    flags
    teams {
      id
      name
      settings {
        openToMatchingOrgEmailDomainUsers
      }
    }
  }
}
    `;
export type DefaultEntityForDomainCaptureDropdownComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>, 'query'> & ({ variables: DefaultEntityForDomainCaptureDropdownQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DefaultEntityForDomainCaptureDropdownComponent = (props: DefaultEntityForDomainCaptureDropdownComponentProps) => (
      <ApolloReactComponents.Query<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables> query={DefaultEntityForDomainCaptureDropdownDocument} {...props} />
    );
    
export type DefaultEntityForDomainCaptureDropdownProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>
    } & TChildProps;
export function withDefaultEntityForDomainCaptureDropdown<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DefaultEntityForDomainCaptureDropdownQuery,
  DefaultEntityForDomainCaptureDropdownQueryVariables,
  DefaultEntityForDomainCaptureDropdownProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables, DefaultEntityForDomainCaptureDropdownProps<TChildProps, TDataName>>(DefaultEntityForDomainCaptureDropdownDocument, {
      alias: 'defaultEntityForDomainCaptureDropdown',
      ...operationOptions
    });
};

/**
 * __useDefaultEntityForDomainCaptureDropdownQuery__
 *
 * To run a query within a React component, call `useDefaultEntityForDomainCaptureDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultEntityForDomainCaptureDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultEntityForDomainCaptureDropdownQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDefaultEntityForDomainCaptureDropdownQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables> & ({ variables: DefaultEntityForDomainCaptureDropdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>(DefaultEntityForDomainCaptureDropdownDocument, options);
      }
export function useDefaultEntityForDomainCaptureDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>(DefaultEntityForDomainCaptureDropdownDocument, options);
        }
// @ts-ignore
export function useDefaultEntityForDomainCaptureDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>;
export function useDefaultEntityForDomainCaptureDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefaultEntityForDomainCaptureDropdownQuery | undefined, DefaultEntityForDomainCaptureDropdownQueryVariables>;
export function useDefaultEntityForDomainCaptureDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>(DefaultEntityForDomainCaptureDropdownDocument, options);
        }
export type DefaultEntityForDomainCaptureDropdownQueryHookResult = ReturnType<typeof useDefaultEntityForDomainCaptureDropdownQuery>;
export type DefaultEntityForDomainCaptureDropdownLazyQueryHookResult = ReturnType<typeof useDefaultEntityForDomainCaptureDropdownLazyQuery>;
export type DefaultEntityForDomainCaptureDropdownSuspenseQueryHookResult = ReturnType<typeof useDefaultEntityForDomainCaptureDropdownSuspenseQuery>;
export type DefaultEntityForDomainCaptureDropdownQueryResult = ApolloReactCommon.QueryResult<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>;
export const OrganizationDefaultModelsSeatDocument = gql`
    query OrganizationDefaultModelsSeat($orgName: String!) {
  organization(name: $orgName) {
    id
    flags
    subscriptions {
      id
      privileges
      plan {
        id
        planType
      }
    }
  }
}
    `;
export type OrganizationDefaultModelsSeatComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>, 'query'> & ({ variables: OrganizationDefaultModelsSeatQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationDefaultModelsSeatComponent = (props: OrganizationDefaultModelsSeatComponentProps) => (
      <ApolloReactComponents.Query<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables> query={OrganizationDefaultModelsSeatDocument} {...props} />
    );
    
export type OrganizationDefaultModelsSeatProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>
    } & TChildProps;
export function withOrganizationDefaultModelsSeat<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationDefaultModelsSeatQuery,
  OrganizationDefaultModelsSeatQueryVariables,
  OrganizationDefaultModelsSeatProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables, OrganizationDefaultModelsSeatProps<TChildProps, TDataName>>(OrganizationDefaultModelsSeatDocument, {
      alias: 'organizationDefaultModelsSeat',
      ...operationOptions
    });
};

/**
 * __useOrganizationDefaultModelsSeatQuery__
 *
 * To run a query within a React component, call `useOrganizationDefaultModelsSeatQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDefaultModelsSeatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDefaultModelsSeatQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationDefaultModelsSeatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables> & ({ variables: OrganizationDefaultModelsSeatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>(OrganizationDefaultModelsSeatDocument, options);
      }
export function useOrganizationDefaultModelsSeatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>(OrganizationDefaultModelsSeatDocument, options);
        }
// @ts-ignore
export function useOrganizationDefaultModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>;
export function useOrganizationDefaultModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDefaultModelsSeatQuery | undefined, OrganizationDefaultModelsSeatQueryVariables>;
export function useOrganizationDefaultModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>(OrganizationDefaultModelsSeatDocument, options);
        }
export type OrganizationDefaultModelsSeatQueryHookResult = ReturnType<typeof useOrganizationDefaultModelsSeatQuery>;
export type OrganizationDefaultModelsSeatLazyQueryHookResult = ReturnType<typeof useOrganizationDefaultModelsSeatLazyQuery>;
export type OrganizationDefaultModelsSeatSuspenseQueryHookResult = ReturnType<typeof useOrganizationDefaultModelsSeatSuspenseQuery>;
export type OrganizationDefaultModelsSeatQueryResult = ApolloReactCommon.QueryResult<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>;
export const OrganizationDomainCaptureSettingDocument = gql`
    query OrganizationDomainCaptureSetting($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    flags
    teams {
      id
      settings {
        openToMatchingOrgEmailDomainUsers
      }
    }
  }
}
    `;
export type OrganizationDomainCaptureSettingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>, 'query'> & ({ variables: OrganizationDomainCaptureSettingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationDomainCaptureSettingComponent = (props: OrganizationDomainCaptureSettingComponentProps) => (
      <ApolloReactComponents.Query<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables> query={OrganizationDomainCaptureSettingDocument} {...props} />
    );
    
export type OrganizationDomainCaptureSettingProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>
    } & TChildProps;
export function withOrganizationDomainCaptureSetting<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationDomainCaptureSettingQuery,
  OrganizationDomainCaptureSettingQueryVariables,
  OrganizationDomainCaptureSettingProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables, OrganizationDomainCaptureSettingProps<TChildProps, TDataName>>(OrganizationDomainCaptureSettingDocument, {
      alias: 'organizationDomainCaptureSetting',
      ...operationOptions
    });
};

/**
 * __useOrganizationDomainCaptureSettingQuery__
 *
 * To run a query within a React component, call `useOrganizationDomainCaptureSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDomainCaptureSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDomainCaptureSettingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationDomainCaptureSettingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables> & ({ variables: OrganizationDomainCaptureSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>(OrganizationDomainCaptureSettingDocument, options);
      }
export function useOrganizationDomainCaptureSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>(OrganizationDomainCaptureSettingDocument, options);
        }
// @ts-ignore
export function useOrganizationDomainCaptureSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>;
export function useOrganizationDomainCaptureSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDomainCaptureSettingQuery | undefined, OrganizationDomainCaptureSettingQueryVariables>;
export function useOrganizationDomainCaptureSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>(OrganizationDomainCaptureSettingDocument, options);
        }
export type OrganizationDomainCaptureSettingQueryHookResult = ReturnType<typeof useOrganizationDomainCaptureSettingQuery>;
export type OrganizationDomainCaptureSettingLazyQueryHookResult = ReturnType<typeof useOrganizationDomainCaptureSettingLazyQuery>;
export type OrganizationDomainCaptureSettingSuspenseQueryHookResult = ReturnType<typeof useOrganizationDomainCaptureSettingSuspenseQuery>;
export type OrganizationDomainCaptureSettingQueryResult = ApolloReactCommon.QueryResult<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>;
export const ViewerDomainClaimBlockingReasonDocument = gql`
    query ViewerDomainClaimBlockingReason($orgID: ID!) {
  viewer {
    id
    domainClaimBlockingReason(orgId: $orgID)
  }
}
    `;
export type ViewerDomainClaimBlockingReasonComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>, 'query'> & ({ variables: ViewerDomainClaimBlockingReasonQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewerDomainClaimBlockingReasonComponent = (props: ViewerDomainClaimBlockingReasonComponentProps) => (
      <ApolloReactComponents.Query<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables> query={ViewerDomainClaimBlockingReasonDocument} {...props} />
    );
    
export type ViewerDomainClaimBlockingReasonProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>
    } & TChildProps;
export function withViewerDomainClaimBlockingReason<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerDomainClaimBlockingReasonQuery,
  ViewerDomainClaimBlockingReasonQueryVariables,
  ViewerDomainClaimBlockingReasonProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables, ViewerDomainClaimBlockingReasonProps<TChildProps, TDataName>>(ViewerDomainClaimBlockingReasonDocument, {
      alias: 'viewerDomainClaimBlockingReason',
      ...operationOptions
    });
};

/**
 * __useViewerDomainClaimBlockingReasonQuery__
 *
 * To run a query within a React component, call `useViewerDomainClaimBlockingReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerDomainClaimBlockingReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerDomainClaimBlockingReasonQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *   },
 * });
 */
export function useViewerDomainClaimBlockingReasonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables> & ({ variables: ViewerDomainClaimBlockingReasonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>(ViewerDomainClaimBlockingReasonDocument, options);
      }
export function useViewerDomainClaimBlockingReasonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>(ViewerDomainClaimBlockingReasonDocument, options);
        }
// @ts-ignore
export function useViewerDomainClaimBlockingReasonSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>;
export function useViewerDomainClaimBlockingReasonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDomainClaimBlockingReasonQuery | undefined, ViewerDomainClaimBlockingReasonQueryVariables>;
export function useViewerDomainClaimBlockingReasonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>(ViewerDomainClaimBlockingReasonDocument, options);
        }
export type ViewerDomainClaimBlockingReasonQueryHookResult = ReturnType<typeof useViewerDomainClaimBlockingReasonQuery>;
export type ViewerDomainClaimBlockingReasonLazyQueryHookResult = ReturnType<typeof useViewerDomainClaimBlockingReasonLazyQuery>;
export type ViewerDomainClaimBlockingReasonSuspenseQueryHookResult = ReturnType<typeof useViewerDomainClaimBlockingReasonSuspenseQuery>;
export type ViewerDomainClaimBlockingReasonQueryResult = ApolloReactCommon.QueryResult<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>;
export const OrganizationTeamsWithDomainCaptureEnabledDocument = gql`
    query OrganizationTeamsWithDomainCaptureEnabled($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    flags
    teams {
      id
      name
      settings {
        openToMatchingOrgEmailDomainUsers
      }
      memberCount
    }
  }
}
    `;
export type OrganizationTeamsWithDomainCaptureEnabledComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>, 'query'> & ({ variables: OrganizationTeamsWithDomainCaptureEnabledQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationTeamsWithDomainCaptureEnabledComponent = (props: OrganizationTeamsWithDomainCaptureEnabledComponentProps) => (
      <ApolloReactComponents.Query<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables> query={OrganizationTeamsWithDomainCaptureEnabledDocument} {...props} />
    );
    
export type OrganizationTeamsWithDomainCaptureEnabledProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>
    } & TChildProps;
export function withOrganizationTeamsWithDomainCaptureEnabled<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationTeamsWithDomainCaptureEnabledQuery,
  OrganizationTeamsWithDomainCaptureEnabledQueryVariables,
  OrganizationTeamsWithDomainCaptureEnabledProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables, OrganizationTeamsWithDomainCaptureEnabledProps<TChildProps, TDataName>>(OrganizationTeamsWithDomainCaptureEnabledDocument, {
      alias: 'organizationTeamsWithDomainCaptureEnabled',
      ...operationOptions
    });
};

/**
 * __useOrganizationTeamsWithDomainCaptureEnabledQuery__
 *
 * To run a query within a React component, call `useOrganizationTeamsWithDomainCaptureEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTeamsWithDomainCaptureEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTeamsWithDomainCaptureEnabledQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationTeamsWithDomainCaptureEnabledQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables> & ({ variables: OrganizationTeamsWithDomainCaptureEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>(OrganizationTeamsWithDomainCaptureEnabledDocument, options);
      }
export function useOrganizationTeamsWithDomainCaptureEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>(OrganizationTeamsWithDomainCaptureEnabledDocument, options);
        }
// @ts-ignore
export function useOrganizationTeamsWithDomainCaptureEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>;
export function useOrganizationTeamsWithDomainCaptureEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsWithDomainCaptureEnabledQuery | undefined, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>;
export function useOrganizationTeamsWithDomainCaptureEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>(OrganizationTeamsWithDomainCaptureEnabledDocument, options);
        }
export type OrganizationTeamsWithDomainCaptureEnabledQueryHookResult = ReturnType<typeof useOrganizationTeamsWithDomainCaptureEnabledQuery>;
export type OrganizationTeamsWithDomainCaptureEnabledLazyQueryHookResult = ReturnType<typeof useOrganizationTeamsWithDomainCaptureEnabledLazyQuery>;
export type OrganizationTeamsWithDomainCaptureEnabledSuspenseQueryHookResult = ReturnType<typeof useOrganizationTeamsWithDomainCaptureEnabledSuspenseQuery>;
export type OrganizationTeamsWithDomainCaptureEnabledQueryResult = ApolloReactCommon.QueryResult<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>;
export const EditOrgMembersModalDocument = gql`
    query EditOrgMembersModal($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    flags
    teams {
      id
      name
      settings {
        openToMatchingOrgEmailDomainUsers
      }
    }
    seatAvailability {
      seats
    }
    pendingInvites {
      id
      email
    }
    billingUser {
      id
      username
    }
    subscriptions {
      id
      seats
      plan {
        id
        unitPrice
        planType
        billingInterval
      }
    }
    members {
      id
      username
      role
      modelsSeat
      name
      user {
        id
        loggedInAt
      }
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type EditOrgMembersModalComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>, 'query'> & ({ variables: EditOrgMembersModalQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EditOrgMembersModalComponent = (props: EditOrgMembersModalComponentProps) => (
      <ApolloReactComponents.Query<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables> query={EditOrgMembersModalDocument} {...props} />
    );
    
export type EditOrgMembersModalProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>
    } & TChildProps;
export function withEditOrgMembersModal<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditOrgMembersModalQuery,
  EditOrgMembersModalQueryVariables,
  EditOrgMembersModalProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables, EditOrgMembersModalProps<TChildProps, TDataName>>(EditOrgMembersModalDocument, {
      alias: 'editOrgMembersModal',
      ...operationOptions
    });
};

/**
 * __useEditOrgMembersModalQuery__
 *
 * To run a query within a React component, call `useEditOrgMembersModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOrgMembersModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOrgMembersModalQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useEditOrgMembersModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables> & ({ variables: EditOrgMembersModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>(EditOrgMembersModalDocument, options);
      }
export function useEditOrgMembersModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>(EditOrgMembersModalDocument, options);
        }
// @ts-ignore
export function useEditOrgMembersModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>;
export function useEditOrgMembersModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditOrgMembersModalQuery | undefined, EditOrgMembersModalQueryVariables>;
export function useEditOrgMembersModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>(EditOrgMembersModalDocument, options);
        }
export type EditOrgMembersModalQueryHookResult = ReturnType<typeof useEditOrgMembersModalQuery>;
export type EditOrgMembersModalLazyQueryHookResult = ReturnType<typeof useEditOrgMembersModalLazyQuery>;
export type EditOrgMembersModalSuspenseQueryHookResult = ReturnType<typeof useEditOrgMembersModalSuspenseQuery>;
export type EditOrgMembersModalQueryResult = ApolloReactCommon.QueryResult<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>;
export const IsEmailDomainClaimedAndShouldRedirectToSsoDocument = gql`
    query IsEmailDomainClaimedAndShouldRedirectToSSO {
  viewer {
    id
    isEmailDomainClaimedAndShouldRedirectToSSO
  }
}
    `;
export type IsEmailDomainClaimedAndShouldRedirectToSsoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>, 'query'>;

    export const IsEmailDomainClaimedAndShouldRedirectToSsoComponent = (props: IsEmailDomainClaimedAndShouldRedirectToSsoComponentProps) => (
      <ApolloReactComponents.Query<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables> query={IsEmailDomainClaimedAndShouldRedirectToSsoDocument} {...props} />
    );
    
export type IsEmailDomainClaimedAndShouldRedirectToSsoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>
    } & TChildProps;
export function withIsEmailDomainClaimedAndShouldRedirectToSso<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IsEmailDomainClaimedAndShouldRedirectToSsoQuery,
  IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables,
  IsEmailDomainClaimedAndShouldRedirectToSsoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables, IsEmailDomainClaimedAndShouldRedirectToSsoProps<TChildProps, TDataName>>(IsEmailDomainClaimedAndShouldRedirectToSsoDocument, {
      alias: 'isEmailDomainClaimedAndShouldRedirectToSso',
      ...operationOptions
    });
};

/**
 * __useIsEmailDomainClaimedAndShouldRedirectToSsoQuery__
 *
 * To run a query within a React component, call `useIsEmailDomainClaimedAndShouldRedirectToSsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEmailDomainClaimedAndShouldRedirectToSsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsEmailDomainClaimedAndShouldRedirectToSsoQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsEmailDomainClaimedAndShouldRedirectToSsoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>(IsEmailDomainClaimedAndShouldRedirectToSsoDocument, options);
      }
export function useIsEmailDomainClaimedAndShouldRedirectToSsoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>(IsEmailDomainClaimedAndShouldRedirectToSsoDocument, options);
        }
// @ts-ignore
export function useIsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>;
export function useIsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IsEmailDomainClaimedAndShouldRedirectToSsoQuery | undefined, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>;
export function useIsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>(IsEmailDomainClaimedAndShouldRedirectToSsoDocument, options);
        }
export type IsEmailDomainClaimedAndShouldRedirectToSsoQueryHookResult = ReturnType<typeof useIsEmailDomainClaimedAndShouldRedirectToSsoQuery>;
export type IsEmailDomainClaimedAndShouldRedirectToSsoLazyQueryHookResult = ReturnType<typeof useIsEmailDomainClaimedAndShouldRedirectToSsoLazyQuery>;
export type IsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQueryHookResult = ReturnType<typeof useIsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQuery>;
export type IsEmailDomainClaimedAndShouldRedirectToSsoQueryResult = ApolloReactCommon.QueryResult<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>;
export const TeamPageShowcasedProjectsDocument = gql`
    query TeamPageShowcasedProjects($entityName: String!, $pattern: String, $first: Int = 20, $order: String = "-created_at") {
  projects(
    first: $first
    entityName: $entityName
    pattern: $pattern
    order: $order
  ) {
    edges {
      node {
        id
        name
        entityName
        description
        lastActive
        runCount
        access
        user {
          id
          username
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export type TeamPageShowcasedProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>, 'query'> & ({ variables: TeamPageShowcasedProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamPageShowcasedProjectsComponent = (props: TeamPageShowcasedProjectsComponentProps) => (
      <ApolloReactComponents.Query<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables> query={TeamPageShowcasedProjectsDocument} {...props} />
    );
    
export type TeamPageShowcasedProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>
    } & TChildProps;
export function withTeamPageShowcasedProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamPageShowcasedProjectsQuery,
  TeamPageShowcasedProjectsQueryVariables,
  TeamPageShowcasedProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables, TeamPageShowcasedProjectsProps<TChildProps, TDataName>>(TeamPageShowcasedProjectsDocument, {
      alias: 'teamPageShowcasedProjects',
      ...operationOptions
    });
};

/**
 * __useTeamPageShowcasedProjectsQuery__
 *
 * To run a query within a React component, call `useTeamPageShowcasedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageShowcasedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageShowcasedProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeamPageShowcasedProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables> & ({ variables: TeamPageShowcasedProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>(TeamPageShowcasedProjectsDocument, options);
      }
export function useTeamPageShowcasedProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>(TeamPageShowcasedProjectsDocument, options);
        }
// @ts-ignore
export function useTeamPageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>;
export function useTeamPageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageShowcasedProjectsQuery | undefined, TeamPageShowcasedProjectsQueryVariables>;
export function useTeamPageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>(TeamPageShowcasedProjectsDocument, options);
        }
export type TeamPageShowcasedProjectsQueryHookResult = ReturnType<typeof useTeamPageShowcasedProjectsQuery>;
export type TeamPageShowcasedProjectsLazyQueryHookResult = ReturnType<typeof useTeamPageShowcasedProjectsLazyQuery>;
export type TeamPageShowcasedProjectsSuspenseQueryHookResult = ReturnType<typeof useTeamPageShowcasedProjectsSuspenseQuery>;
export type TeamPageShowcasedProjectsQueryResult = ApolloReactCommon.QueryResult<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>;
export const ProfilePageShowcasedProjectsDocument = gql`
    query ProfilePageShowcasedProjects($username: String!, $pattern: String, $first: Int = 20, $order: String = "-created_at") {
  user(userName: $username) {
    id
    projects(first: $first, pattern: $pattern, order: $order) {
      edges {
        node {
          id
          name
          entityName
          access
          description
          totalRuns
          lastActive
          runCount
          user {
            id
            username
          }
        }
      }
    }
  }
}
    `;
export type ProfilePageShowcasedProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>, 'query'> & ({ variables: ProfilePageShowcasedProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProfilePageShowcasedProjectsComponent = (props: ProfilePageShowcasedProjectsComponentProps) => (
      <ApolloReactComponents.Query<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables> query={ProfilePageShowcasedProjectsDocument} {...props} />
    );
    
export type ProfilePageShowcasedProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>
    } & TChildProps;
export function withProfilePageShowcasedProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProfilePageShowcasedProjectsQuery,
  ProfilePageShowcasedProjectsQueryVariables,
  ProfilePageShowcasedProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables, ProfilePageShowcasedProjectsProps<TChildProps, TDataName>>(ProfilePageShowcasedProjectsDocument, {
      alias: 'profilePageShowcasedProjects',
      ...operationOptions
    });
};

/**
 * __useProfilePageShowcasedProjectsQuery__
 *
 * To run a query within a React component, call `useProfilePageShowcasedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageShowcasedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageShowcasedProjectsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      pattern: // value for 'pattern'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useProfilePageShowcasedProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables> & ({ variables: ProfilePageShowcasedProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>(ProfilePageShowcasedProjectsDocument, options);
      }
export function useProfilePageShowcasedProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>(ProfilePageShowcasedProjectsDocument, options);
        }
// @ts-ignore
export function useProfilePageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>;
export function useProfilePageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageShowcasedProjectsQuery | undefined, ProfilePageShowcasedProjectsQueryVariables>;
export function useProfilePageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>(ProfilePageShowcasedProjectsDocument, options);
        }
export type ProfilePageShowcasedProjectsQueryHookResult = ReturnType<typeof useProfilePageShowcasedProjectsQuery>;
export type ProfilePageShowcasedProjectsLazyQueryHookResult = ReturnType<typeof useProfilePageShowcasedProjectsLazyQuery>;
export type ProfilePageShowcasedProjectsSuspenseQueryHookResult = ReturnType<typeof useProfilePageShowcasedProjectsSuspenseQuery>;
export type ProfilePageShowcasedProjectsQueryResult = ApolloReactCommon.QueryResult<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>;
export const SimpleTestQueryDocument = gql`
    query SimpleTestQuery {
  serverInfo {
    pollingOK
  }
}
    `;
export type SimpleTestQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>, 'query'>;

    export const SimpleTestQueryComponent = (props: SimpleTestQueryComponentProps) => (
      <ApolloReactComponents.Query<SimpleTestQueryQuery, SimpleTestQueryQueryVariables> query={SimpleTestQueryDocument} {...props} />
    );
    
export type SimpleTestQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>
    } & TChildProps;
export function withSimpleTestQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SimpleTestQueryQuery,
  SimpleTestQueryQueryVariables,
  SimpleTestQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SimpleTestQueryQuery, SimpleTestQueryQueryVariables, SimpleTestQueryProps<TChildProps, TDataName>>(SimpleTestQueryDocument, {
      alias: 'simpleTestQuery',
      ...operationOptions
    });
};

/**
 * __useSimpleTestQueryQuery__
 *
 * To run a query within a React component, call `useSimpleTestQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleTestQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleTestQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSimpleTestQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>(SimpleTestQueryDocument, options);
      }
export function useSimpleTestQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>(SimpleTestQueryDocument, options);
        }
// @ts-ignore
export function useSimpleTestQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>;
export function useSimpleTestQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SimpleTestQueryQuery | undefined, SimpleTestQueryQueryVariables>;
export function useSimpleTestQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>(SimpleTestQueryDocument, options);
        }
export type SimpleTestQueryQueryHookResult = ReturnType<typeof useSimpleTestQueryQuery>;
export type SimpleTestQueryLazyQueryHookResult = ReturnType<typeof useSimpleTestQueryLazyQuery>;
export type SimpleTestQuerySuspenseQueryHookResult = ReturnType<typeof useSimpleTestQuerySuspenseQuery>;
export type SimpleTestQueryQueryResult = ApolloReactCommon.QueryResult<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>;
export const HistoricUsageOrganizationInfoDocument = gql`
    query HistoricUsageOrganizationInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    members {
      id
      username
      role
    }
  }
}
    `;
export type HistoricUsageOrganizationInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>, 'query'> & ({ variables: HistoricUsageOrganizationInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HistoricUsageOrganizationInfoComponent = (props: HistoricUsageOrganizationInfoComponentProps) => (
      <ApolloReactComponents.Query<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables> query={HistoricUsageOrganizationInfoDocument} {...props} />
    );
    
export type HistoricUsageOrganizationInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>
    } & TChildProps;
export function withHistoricUsageOrganizationInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HistoricUsageOrganizationInfoQuery,
  HistoricUsageOrganizationInfoQueryVariables,
  HistoricUsageOrganizationInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables, HistoricUsageOrganizationInfoProps<TChildProps, TDataName>>(HistoricUsageOrganizationInfoDocument, {
      alias: 'historicUsageOrganizationInfo',
      ...operationOptions
    });
};

/**
 * __useHistoricUsageOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useHistoricUsageOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricUsageOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricUsageOrganizationInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useHistoricUsageOrganizationInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables> & ({ variables: HistoricUsageOrganizationInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>(HistoricUsageOrganizationInfoDocument, options);
      }
export function useHistoricUsageOrganizationInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>(HistoricUsageOrganizationInfoDocument, options);
        }
// @ts-ignore
export function useHistoricUsageOrganizationInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>;
export function useHistoricUsageOrganizationInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoricUsageOrganizationInfoQuery | undefined, HistoricUsageOrganizationInfoQueryVariables>;
export function useHistoricUsageOrganizationInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>(HistoricUsageOrganizationInfoDocument, options);
        }
export type HistoricUsageOrganizationInfoQueryHookResult = ReturnType<typeof useHistoricUsageOrganizationInfoQuery>;
export type HistoricUsageOrganizationInfoLazyQueryHookResult = ReturnType<typeof useHistoricUsageOrganizationInfoLazyQuery>;
export type HistoricUsageOrganizationInfoSuspenseQueryHookResult = ReturnType<typeof useHistoricUsageOrganizationInfoSuspenseQuery>;
export type HistoricUsageOrganizationInfoQueryResult = ApolloReactCommon.QueryResult<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>;
export const UsageTabInfoDocument = gql`
    query UsageTabInfo($orgName: String!, $usageType: UsageType!, $intervalMarkers: [DateTime!]!) {
  organization(name: $orgName) {
    id
    createdAt
    usage(usageType: $usageType, intervalMarkers: $intervalMarkers) {
      start
      end
      value
      projectName
      entityName
      ... on InferenceCostUsageAggregation {
        endpointName
        inputCount
        outputCount
        inputCost
        outputCost
      }
      ... on TrainingCostUsageAggregation {
        gpuModelID
        gpuDurationMs
      }
    }
  }
}
    `;
export type UsageTabInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>, 'query'> & ({ variables: UsageTabInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UsageTabInfoComponent = (props: UsageTabInfoComponentProps) => (
      <ApolloReactComponents.Query<UsageTabInfoQuery, UsageTabInfoQueryVariables> query={UsageTabInfoDocument} {...props} />
    );
    
export type UsageTabInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UsageTabInfoQuery, UsageTabInfoQueryVariables>
    } & TChildProps;
export function withUsageTabInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UsageTabInfoQuery,
  UsageTabInfoQueryVariables,
  UsageTabInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UsageTabInfoQuery, UsageTabInfoQueryVariables, UsageTabInfoProps<TChildProps, TDataName>>(UsageTabInfoDocument, {
      alias: 'usageTabInfo',
      ...operationOptions
    });
};

/**
 * __useUsageTabInfoQuery__
 *
 * To run a query within a React component, call `useUsageTabInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageTabInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageTabInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      usageType: // value for 'usageType'
 *      intervalMarkers: // value for 'intervalMarkers'
 *   },
 * });
 */
export function useUsageTabInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables> & ({ variables: UsageTabInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsageTabInfoQuery, UsageTabInfoQueryVariables>(UsageTabInfoDocument, options);
      }
export function useUsageTabInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsageTabInfoQuery, UsageTabInfoQueryVariables>(UsageTabInfoDocument, options);
        }
// @ts-ignore
export function useUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsageTabInfoQuery, UsageTabInfoQueryVariables>;
export function useUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsageTabInfoQuery | undefined, UsageTabInfoQueryVariables>;
export function useUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsageTabInfoQuery, UsageTabInfoQueryVariables>(UsageTabInfoDocument, options);
        }
export type UsageTabInfoQueryHookResult = ReturnType<typeof useUsageTabInfoQuery>;
export type UsageTabInfoLazyQueryHookResult = ReturnType<typeof useUsageTabInfoLazyQuery>;
export type UsageTabInfoSuspenseQueryHookResult = ReturnType<typeof useUsageTabInfoSuspenseQuery>;
export type UsageTabInfoQueryResult = ApolloReactCommon.QueryResult<UsageTabInfoQuery, UsageTabInfoQueryVariables>;
export const GlobalUsageTabInfoDocument = gql`
    query GlobalUsageTabInfo($usageType: UsageType!, $intervalMarkers: [DateTime!]!) {
  usage(usageType: $usageType, intervalMarkers: $intervalMarkers) {
    start
    end
    value
    projectName
    entityName
    ... on InferenceCostUsageAggregation {
      endpointName
      inputCount
      outputCount
      inputCost
      outputCost
    }
    ... on TrainingCostUsageAggregation {
      gpuModelID
      gpuDurationMs
    }
  }
}
    `;
export type GlobalUsageTabInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>, 'query'> & ({ variables: GlobalUsageTabInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GlobalUsageTabInfoComponent = (props: GlobalUsageTabInfoComponentProps) => (
      <ApolloReactComponents.Query<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables> query={GlobalUsageTabInfoDocument} {...props} />
    );
    
export type GlobalUsageTabInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>
    } & TChildProps;
export function withGlobalUsageTabInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GlobalUsageTabInfoQuery,
  GlobalUsageTabInfoQueryVariables,
  GlobalUsageTabInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables, GlobalUsageTabInfoProps<TChildProps, TDataName>>(GlobalUsageTabInfoDocument, {
      alias: 'globalUsageTabInfo',
      ...operationOptions
    });
};

/**
 * __useGlobalUsageTabInfoQuery__
 *
 * To run a query within a React component, call `useGlobalUsageTabInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalUsageTabInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalUsageTabInfoQuery({
 *   variables: {
 *      usageType: // value for 'usageType'
 *      intervalMarkers: // value for 'intervalMarkers'
 *   },
 * });
 */
export function useGlobalUsageTabInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables> & ({ variables: GlobalUsageTabInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>(GlobalUsageTabInfoDocument, options);
      }
export function useGlobalUsageTabInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>(GlobalUsageTabInfoDocument, options);
        }
// @ts-ignore
export function useGlobalUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>;
export function useGlobalUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalUsageTabInfoQuery | undefined, GlobalUsageTabInfoQueryVariables>;
export function useGlobalUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>(GlobalUsageTabInfoDocument, options);
        }
export type GlobalUsageTabInfoQueryHookResult = ReturnType<typeof useGlobalUsageTabInfoQuery>;
export type GlobalUsageTabInfoLazyQueryHookResult = ReturnType<typeof useGlobalUsageTabInfoLazyQuery>;
export type GlobalUsageTabInfoSuspenseQueryHookResult = ReturnType<typeof useGlobalUsageTabInfoSuspenseQuery>;
export type GlobalUsageTabInfoQueryResult = ApolloReactCommon.QueryResult<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>;
export const WeaveUsageInfoDocument = gql`
    query WeaveUsageInfo($orgName: String!, $usageType: UsageType!, $intervalMarkers: [DateTime!]!) {
  organization(name: $orgName) {
    id
    createdAt
    usageTotal(usageType: $usageType, intervalMarkers: $intervalMarkers)
  }
}
    `;
export type WeaveUsageInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>, 'query'> & ({ variables: WeaveUsageInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WeaveUsageInfoComponent = (props: WeaveUsageInfoComponentProps) => (
      <ApolloReactComponents.Query<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables> query={WeaveUsageInfoDocument} {...props} />
    );
    
export type WeaveUsageInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>
    } & TChildProps;
export function withWeaveUsageInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  WeaveUsageInfoQuery,
  WeaveUsageInfoQueryVariables,
  WeaveUsageInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables, WeaveUsageInfoProps<TChildProps, TDataName>>(WeaveUsageInfoDocument, {
      alias: 'weaveUsageInfo',
      ...operationOptions
    });
};

/**
 * __useWeaveUsageInfoQuery__
 *
 * To run a query within a React component, call `useWeaveUsageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeaveUsageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeaveUsageInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      usageType: // value for 'usageType'
 *      intervalMarkers: // value for 'intervalMarkers'
 *   },
 * });
 */
export function useWeaveUsageInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables> & ({ variables: WeaveUsageInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>(WeaveUsageInfoDocument, options);
      }
export function useWeaveUsageInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>(WeaveUsageInfoDocument, options);
        }
// @ts-ignore
export function useWeaveUsageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>;
export function useWeaveUsageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveUsageInfoQuery | undefined, WeaveUsageInfoQueryVariables>;
export function useWeaveUsageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>(WeaveUsageInfoDocument, options);
        }
export type WeaveUsageInfoQueryHookResult = ReturnType<typeof useWeaveUsageInfoQuery>;
export type WeaveUsageInfoLazyQueryHookResult = ReturnType<typeof useWeaveUsageInfoLazyQuery>;
export type WeaveUsageInfoSuspenseQueryHookResult = ReturnType<typeof useWeaveUsageInfoSuspenseQuery>;
export type WeaveUsageInfoQueryResult = ApolloReactCommon.QueryResult<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>;
export const TrialCardAccountExpirationDocument = gql`
    query TrialCardAccountExpiration($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    subscriptions {
      id
      expiresAt
      status
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;
export type TrialCardAccountExpirationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>, 'query'> & ({ variables: TrialCardAccountExpirationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TrialCardAccountExpirationComponent = (props: TrialCardAccountExpirationComponentProps) => (
      <ApolloReactComponents.Query<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables> query={TrialCardAccountExpirationDocument} {...props} />
    );
    
export type TrialCardAccountExpirationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>
    } & TChildProps;
export function withTrialCardAccountExpiration<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TrialCardAccountExpirationQuery,
  TrialCardAccountExpirationQueryVariables,
  TrialCardAccountExpirationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables, TrialCardAccountExpirationProps<TChildProps, TDataName>>(TrialCardAccountExpirationDocument, {
      alias: 'trialCardAccountExpiration',
      ...operationOptions
    });
};

/**
 * __useTrialCardAccountExpirationQuery__
 *
 * To run a query within a React component, call `useTrialCardAccountExpirationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialCardAccountExpirationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialCardAccountExpirationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useTrialCardAccountExpirationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables> & ({ variables: TrialCardAccountExpirationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>(TrialCardAccountExpirationDocument, options);
      }
export function useTrialCardAccountExpirationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>(TrialCardAccountExpirationDocument, options);
        }
// @ts-ignore
export function useTrialCardAccountExpirationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>;
export function useTrialCardAccountExpirationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialCardAccountExpirationQuery | undefined, TrialCardAccountExpirationQueryVariables>;
export function useTrialCardAccountExpirationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>(TrialCardAccountExpirationDocument, options);
        }
export type TrialCardAccountExpirationQueryHookResult = ReturnType<typeof useTrialCardAccountExpirationQuery>;
export type TrialCardAccountExpirationLazyQueryHookResult = ReturnType<typeof useTrialCardAccountExpirationLazyQuery>;
export type TrialCardAccountExpirationSuspenseQueryHookResult = ReturnType<typeof useTrialCardAccountExpirationSuspenseQuery>;
export type TrialCardAccountExpirationQueryResult = ApolloReactCommon.QueryResult<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>;
export const UpsertBenchmarkDocument = gql`
    mutation upsertBenchmark($description: String, $entityName: String!, $id: String, $name: String!, $access: String, $views: JSONString) {
  upsertModel(
    input: {description: $description, entityName: $entityName, id: $id, name: $name, access: $access, views: $views, isBenchmark: true}
  ) {
    project {
      id
      name
      entityName
      description
      access
      views
      isBenchmark
    }
    inserted
  }
}
    `;
export type UpsertBenchmarkMutationFn = ApolloReactCommon.MutationFunction<UpsertBenchmarkMutation, UpsertBenchmarkMutationVariables>;
export type UpsertBenchmarkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertBenchmarkMutation, UpsertBenchmarkMutationVariables>, 'mutation'>;

    export const UpsertBenchmarkComponent = (props: UpsertBenchmarkComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertBenchmarkMutation, UpsertBenchmarkMutationVariables> mutation={UpsertBenchmarkDocument} {...props} />
    );
    
export type UpsertBenchmarkProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertBenchmarkMutation, UpsertBenchmarkMutationVariables>
    } & TChildProps;
export function withUpsertBenchmark<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertBenchmarkMutation,
  UpsertBenchmarkMutationVariables,
  UpsertBenchmarkProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertBenchmarkMutation, UpsertBenchmarkMutationVariables, UpsertBenchmarkProps<TChildProps, TDataName>>(UpsertBenchmarkDocument, {
      alias: 'upsertBenchmark',
      ...operationOptions
    });
};

/**
 * __useUpsertBenchmarkMutation__
 *
 * To run a mutation, you first call `useUpsertBenchmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBenchmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBenchmarkMutation, { data, loading, error }] = useUpsertBenchmarkMutation({
 *   variables: {
 *      description: // value for 'description'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      access: // value for 'access'
 *      views: // value for 'views'
 *   },
 * });
 */
export function useUpsertBenchmarkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertBenchmarkMutation, UpsertBenchmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertBenchmarkMutation, UpsertBenchmarkMutationVariables>(UpsertBenchmarkDocument, options);
      }
export type UpsertBenchmarkMutationHookResult = ReturnType<typeof useUpsertBenchmarkMutation>;
export type UpsertBenchmarkMutationResult = ApolloReactCommon.MutationResult<UpsertBenchmarkMutation>;
export type UpsertBenchmarkMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertBenchmarkMutation, UpsertBenchmarkMutationVariables>;
export const PredefinedRoleOrgInfoDocument = gql`
    query PredefinedRoleOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    subscriptions {
      id
      subscriptionType
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;
export type PredefinedRoleOrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>, 'query'> & ({ variables: PredefinedRoleOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PredefinedRoleOrgInfoComponent = (props: PredefinedRoleOrgInfoComponentProps) => (
      <ApolloReactComponents.Query<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables> query={PredefinedRoleOrgInfoDocument} {...props} />
    );
    
export type PredefinedRoleOrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>
    } & TChildProps;
export function withPredefinedRoleOrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PredefinedRoleOrgInfoQuery,
  PredefinedRoleOrgInfoQueryVariables,
  PredefinedRoleOrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables, PredefinedRoleOrgInfoProps<TChildProps, TDataName>>(PredefinedRoleOrgInfoDocument, {
      alias: 'predefinedRoleOrgInfo',
      ...operationOptions
    });
};

/**
 * __usePredefinedRoleOrgInfoQuery__
 *
 * To run a query within a React component, call `usePredefinedRoleOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredefinedRoleOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredefinedRoleOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function usePredefinedRoleOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables> & ({ variables: PredefinedRoleOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>(PredefinedRoleOrgInfoDocument, options);
      }
export function usePredefinedRoleOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>(PredefinedRoleOrgInfoDocument, options);
        }
// @ts-ignore
export function usePredefinedRoleOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>;
export function usePredefinedRoleOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PredefinedRoleOrgInfoQuery | undefined, PredefinedRoleOrgInfoQueryVariables>;
export function usePredefinedRoleOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>(PredefinedRoleOrgInfoDocument, options);
        }
export type PredefinedRoleOrgInfoQueryHookResult = ReturnType<typeof usePredefinedRoleOrgInfoQuery>;
export type PredefinedRoleOrgInfoLazyQueryHookResult = ReturnType<typeof usePredefinedRoleOrgInfoLazyQuery>;
export type PredefinedRoleOrgInfoSuspenseQueryHookResult = ReturnType<typeof usePredefinedRoleOrgInfoSuspenseQuery>;
export type PredefinedRoleOrgInfoQueryResult = ApolloReactCommon.QueryResult<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>;
export const OrganizationFlagsDocument = gql`
    query OrganizationFlags($orgName: String!) {
  organization(name: $orgName) {
    id
    flags
  }
}
    `;
export type OrganizationFlagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>, 'query'> & ({ variables: OrganizationFlagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationFlagsComponent = (props: OrganizationFlagsComponentProps) => (
      <ApolloReactComponents.Query<OrganizationFlagsQuery, OrganizationFlagsQueryVariables> query={OrganizationFlagsDocument} {...props} />
    );
    
export type OrganizationFlagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>
    } & TChildProps;
export function withOrganizationFlags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationFlagsQuery,
  OrganizationFlagsQueryVariables,
  OrganizationFlagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationFlagsQuery, OrganizationFlagsQueryVariables, OrganizationFlagsProps<TChildProps, TDataName>>(OrganizationFlagsDocument, {
      alias: 'organizationFlags',
      ...operationOptions
    });
};

/**
 * __useOrganizationFlagsQuery__
 *
 * To run a query within a React component, call `useOrganizationFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFlagsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables> & ({ variables: OrganizationFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>(OrganizationFlagsDocument, options);
      }
export function useOrganizationFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>(OrganizationFlagsDocument, options);
        }
// @ts-ignore
export function useOrganizationFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>;
export function useOrganizationFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationFlagsQuery | undefined, OrganizationFlagsQueryVariables>;
export function useOrganizationFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>(OrganizationFlagsDocument, options);
        }
export type OrganizationFlagsQueryHookResult = ReturnType<typeof useOrganizationFlagsQuery>;
export type OrganizationFlagsLazyQueryHookResult = ReturnType<typeof useOrganizationFlagsLazyQuery>;
export type OrganizationFlagsSuspenseQueryHookResult = ReturnType<typeof useOrganizationFlagsSuspenseQuery>;
export type OrganizationFlagsQueryResult = ApolloReactCommon.QueryResult<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>;
export const FetchProfilePageProjectsByIDsDocument = gql`
    query FetchProfilePageProjectsByIDs($entityName: String!, $projectIDs: [ID!]!) {
  projects(entityName: $entityName, projectIDs: $projectIDs) {
    edges {
      node {
        id
        name
        entityName
        access
        lastActive
        runCount
        user {
          id
          username
        }
      }
    }
  }
}
    `;
export type FetchProfilePageProjectsByIDsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>, 'query'> & ({ variables: FetchProfilePageProjectsByIDsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProfilePageProjectsByIDsComponent = (props: FetchProfilePageProjectsByIDsComponentProps) => (
      <ApolloReactComponents.Query<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables> query={FetchProfilePageProjectsByIDsDocument} {...props} />
    );
    
export type FetchProfilePageProjectsByIDsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>
    } & TChildProps;
export function withFetchProfilePageProjectsByIDs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProfilePageProjectsByIDsQuery,
  FetchProfilePageProjectsByIDsQueryVariables,
  FetchProfilePageProjectsByIDsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables, FetchProfilePageProjectsByIDsProps<TChildProps, TDataName>>(FetchProfilePageProjectsByIDsDocument, {
      alias: 'fetchProfilePageProjectsByIDs',
      ...operationOptions
    });
};

/**
 * __useFetchProfilePageProjectsByIDsQuery__
 *
 * To run a query within a React component, call `useFetchProfilePageProjectsByIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProfilePageProjectsByIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProfilePageProjectsByIDsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectIDs: // value for 'projectIDs'
 *   },
 * });
 */
export function useFetchProfilePageProjectsByIDsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables> & ({ variables: FetchProfilePageProjectsByIDsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>(FetchProfilePageProjectsByIDsDocument, options);
      }
export function useFetchProfilePageProjectsByIDsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>(FetchProfilePageProjectsByIDsDocument, options);
        }
// @ts-ignore
export function useFetchProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>;
export function useFetchProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProfilePageProjectsByIDsQuery | undefined, FetchProfilePageProjectsByIDsQueryVariables>;
export function useFetchProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>(FetchProfilePageProjectsByIDsDocument, options);
        }
export type FetchProfilePageProjectsByIDsQueryHookResult = ReturnType<typeof useFetchProfilePageProjectsByIDsQuery>;
export type FetchProfilePageProjectsByIDsLazyQueryHookResult = ReturnType<typeof useFetchProfilePageProjectsByIDsLazyQuery>;
export type FetchProfilePageProjectsByIDsSuspenseQueryHookResult = ReturnType<typeof useFetchProfilePageProjectsByIDsSuspenseQuery>;
export type FetchProfilePageProjectsByIDsQueryResult = ApolloReactCommon.QueryResult<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>;
export const RunOverflowMenuDocument = gql`
    query RunOverflowMenu($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    entityName
    name
    readOnly
    run(name: $runName) {
      id
      state
      displayName
      name
      inputArtifacts {
        totalCount
      }
      runInfo {
        git {
          remote
          commit
        }
      }
      commit
      github
      diffPatchFile: files(first: 1, names: ["diff.patch"]) {
        edges {
          node {
            id
            sizeBytes
          }
        }
      }
    }
  }
}
    `;
export type RunOverflowMenuComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>, 'query'> & ({ variables: RunOverflowMenuQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunOverflowMenuComponent = (props: RunOverflowMenuComponentProps) => (
      <ApolloReactComponents.Query<RunOverflowMenuQuery, RunOverflowMenuQueryVariables> query={RunOverflowMenuDocument} {...props} />
    );
    
export type RunOverflowMenuProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>
    } & TChildProps;
export function withRunOverflowMenu<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunOverflowMenuQuery,
  RunOverflowMenuQueryVariables,
  RunOverflowMenuProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunOverflowMenuQuery, RunOverflowMenuQueryVariables, RunOverflowMenuProps<TChildProps, TDataName>>(RunOverflowMenuDocument, {
      alias: 'runOverflowMenu',
      ...operationOptions
    });
};

/**
 * __useRunOverflowMenuQuery__
 *
 * To run a query within a React component, call `useRunOverflowMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunOverflowMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunOverflowMenuQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunOverflowMenuQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables> & ({ variables: RunOverflowMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>(RunOverflowMenuDocument, options);
      }
export function useRunOverflowMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>(RunOverflowMenuDocument, options);
        }
// @ts-ignore
export function useRunOverflowMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>;
export function useRunOverflowMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverflowMenuQuery | undefined, RunOverflowMenuQueryVariables>;
export function useRunOverflowMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>(RunOverflowMenuDocument, options);
        }
export type RunOverflowMenuQueryHookResult = ReturnType<typeof useRunOverflowMenuQuery>;
export type RunOverflowMenuLazyQueryHookResult = ReturnType<typeof useRunOverflowMenuLazyQuery>;
export type RunOverflowMenuSuspenseQueryHookResult = ReturnType<typeof useRunOverflowMenuSuspenseQuery>;
export type RunOverflowMenuQueryResult = ApolloReactCommon.QueryResult<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>;
export const RunOverviewDocument = gql`
    query RunOverview($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    internalId
    name
    readOnly
    entityName
    entity {
      id
      isTeam
    }
    tags {
      id
      name
      colorIndex
    }
    isBenchmark
    linkedBenchmark {
      id
      entityName
      name
    }
    run(name: $runName) {
      id
      state
      stopped
      heartbeatAt
      computeSeconds
      name
      displayName
      notes
      config
      inputArtifacts {
        totalCount
      }
      createdAt
      jobType
      group
      tags: tagColors {
        id
        name
        colorIndex
      }
      host
      sweep {
        id
        name
        displayName
      }
      runInfo {
        program
        args
        os
        python
        colab
        executable
        cpuCount
        cpuCountLogical
        gpuCount
        gpu
        git {
          remote
          commit
        }
      }
      benchmarkRun {
        id
        benchmark {
          id
          name
          entityName
          readOnly
          views
        }
        details
        results
        gitHubSubmissionPR
        run {
          id
          summaryMetrics
        }
        originalProject {
          id
          name
          entityName
        }
        originalRun {
          id
          name
        }
        state
      }
      user {
        id
        username
        name
        photoUrl
        accountType
      }
      branchPoint {
        run {
          id
          name
          project {
            id
            name
            entity {
              id
              name
            }
          }
        }
        step
      }
      internalID
    }
  }
}
    `;
export type RunOverviewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunOverviewQuery, RunOverviewQueryVariables>, 'query'> & ({ variables: RunOverviewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunOverviewComponent = (props: RunOverviewComponentProps) => (
      <ApolloReactComponents.Query<RunOverviewQuery, RunOverviewQueryVariables> query={RunOverviewDocument} {...props} />
    );
    
export type RunOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunOverviewQuery, RunOverviewQueryVariables>
    } & TChildProps;
export function withRunOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunOverviewQuery,
  RunOverviewQueryVariables,
  RunOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunOverviewQuery, RunOverviewQueryVariables, RunOverviewProps<TChildProps, TDataName>>(RunOverviewDocument, {
      alias: 'runOverview',
      ...operationOptions
    });
};

/**
 * __useRunOverviewQuery__
 *
 * To run a query within a React component, call `useRunOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunOverviewQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables> & ({ variables: RunOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunOverviewQuery, RunOverviewQueryVariables>(RunOverviewDocument, options);
      }
export function useRunOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunOverviewQuery, RunOverviewQueryVariables>(RunOverviewDocument, options);
        }
// @ts-ignore
export function useRunOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewQuery, RunOverviewQueryVariables>;
export function useRunOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewQuery | undefined, RunOverviewQueryVariables>;
export function useRunOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunOverviewQuery, RunOverviewQueryVariables>(RunOverviewDocument, options);
        }
export type RunOverviewQueryHookResult = ReturnType<typeof useRunOverviewQuery>;
export type RunOverviewLazyQueryHookResult = ReturnType<typeof useRunOverviewLazyQuery>;
export type RunOverviewSuspenseQueryHookResult = ReturnType<typeof useRunOverviewSuspenseQuery>;
export type RunOverviewQueryResult = ApolloReactCommon.QueryResult<RunOverviewQuery, RunOverviewQueryVariables>;
export const RunPageHeaderDocument = gql`
    query RunPageHeader($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      name
      tags: tagColors {
        id
        name
      }
      notes
      displayName
    }
  }
}
    `;
export type RunPageHeaderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>, 'query'> & ({ variables: RunPageHeaderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunPageHeaderComponent = (props: RunPageHeaderComponentProps) => (
      <ApolloReactComponents.Query<RunPageHeaderQuery, RunPageHeaderQueryVariables> query={RunPageHeaderDocument} {...props} />
    );
    
export type RunPageHeaderProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunPageHeaderQuery, RunPageHeaderQueryVariables>
    } & TChildProps;
export function withRunPageHeader<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunPageHeaderQuery,
  RunPageHeaderQueryVariables,
  RunPageHeaderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunPageHeaderQuery, RunPageHeaderQueryVariables, RunPageHeaderProps<TChildProps, TDataName>>(RunPageHeaderDocument, {
      alias: 'runPageHeader',
      ...operationOptions
    });
};

/**
 * __useRunPageHeaderQuery__
 *
 * To run a query within a React component, call `useRunPageHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunPageHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunPageHeaderQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunPageHeaderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables> & ({ variables: RunPageHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunPageHeaderQuery, RunPageHeaderQueryVariables>(RunPageHeaderDocument, options);
      }
export function useRunPageHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunPageHeaderQuery, RunPageHeaderQueryVariables>(RunPageHeaderDocument, options);
        }
// @ts-ignore
export function useRunPageHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunPageHeaderQuery, RunPageHeaderQueryVariables>;
export function useRunPageHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunPageHeaderQuery | undefined, RunPageHeaderQueryVariables>;
export function useRunPageHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunPageHeaderQuery, RunPageHeaderQueryVariables>(RunPageHeaderDocument, options);
        }
export type RunPageHeaderQueryHookResult = ReturnType<typeof useRunPageHeaderQuery>;
export type RunPageHeaderLazyQueryHookResult = ReturnType<typeof useRunPageHeaderLazyQuery>;
export type RunPageHeaderSuspenseQueryHookResult = ReturnType<typeof useRunPageHeaderSuspenseQuery>;
export type RunPageHeaderQueryResult = ApolloReactCommon.QueryResult<RunPageHeaderQuery, RunPageHeaderQueryVariables>;
export const StartupProgramDocument = gql`
    query StartupProgram($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    flags
    subscriptions {
      id
      subscriptionType
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;
export type StartupProgramComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StartupProgramQuery, StartupProgramQueryVariables>, 'query'> & ({ variables: StartupProgramQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StartupProgramComponent = (props: StartupProgramComponentProps) => (
      <ApolloReactComponents.Query<StartupProgramQuery, StartupProgramQueryVariables> query={StartupProgramDocument} {...props} />
    );
    
export type StartupProgramProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StartupProgramQuery, StartupProgramQueryVariables>
    } & TChildProps;
export function withStartupProgram<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StartupProgramQuery,
  StartupProgramQueryVariables,
  StartupProgramProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StartupProgramQuery, StartupProgramQueryVariables, StartupProgramProps<TChildProps, TDataName>>(StartupProgramDocument, {
      alias: 'startupProgram',
      ...operationOptions
    });
};

/**
 * __useStartupProgramQuery__
 *
 * To run a query within a React component, call `useStartupProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartupProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartupProgramQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useStartupProgramQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables> & ({ variables: StartupProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StartupProgramQuery, StartupProgramQueryVariables>(StartupProgramDocument, options);
      }
export function useStartupProgramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StartupProgramQuery, StartupProgramQueryVariables>(StartupProgramDocument, options);
        }
// @ts-ignore
export function useStartupProgramSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StartupProgramQuery, StartupProgramQueryVariables>;
export function useStartupProgramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StartupProgramQuery | undefined, StartupProgramQueryVariables>;
export function useStartupProgramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StartupProgramQuery, StartupProgramQueryVariables>(StartupProgramDocument, options);
        }
export type StartupProgramQueryHookResult = ReturnType<typeof useStartupProgramQuery>;
export type StartupProgramLazyQueryHookResult = ReturnType<typeof useStartupProgramLazyQuery>;
export type StartupProgramSuspenseQueryHookResult = ReturnType<typeof useStartupProgramSuspenseQuery>;
export type StartupProgramQueryResult = ApolloReactCommon.QueryResult<StartupProgramQuery, StartupProgramQueryVariables>;
export const StartupProgramCouponInfoDocument = gql`
    query StartupProgramCouponInfo($couponID: String!) {
  coupon(id: $couponID) {
    id
  }
}
    `;
export type StartupProgramCouponInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>, 'query'> & ({ variables: StartupProgramCouponInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StartupProgramCouponInfoComponent = (props: StartupProgramCouponInfoComponentProps) => (
      <ApolloReactComponents.Query<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables> query={StartupProgramCouponInfoDocument} {...props} />
    );
    
export type StartupProgramCouponInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>
    } & TChildProps;
export function withStartupProgramCouponInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StartupProgramCouponInfoQuery,
  StartupProgramCouponInfoQueryVariables,
  StartupProgramCouponInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables, StartupProgramCouponInfoProps<TChildProps, TDataName>>(StartupProgramCouponInfoDocument, {
      alias: 'startupProgramCouponInfo',
      ...operationOptions
    });
};

/**
 * __useStartupProgramCouponInfoQuery__
 *
 * To run a query within a React component, call `useStartupProgramCouponInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartupProgramCouponInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartupProgramCouponInfoQuery({
 *   variables: {
 *      couponID: // value for 'couponID'
 *   },
 * });
 */
export function useStartupProgramCouponInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables> & ({ variables: StartupProgramCouponInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>(StartupProgramCouponInfoDocument, options);
      }
export function useStartupProgramCouponInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>(StartupProgramCouponInfoDocument, options);
        }
// @ts-ignore
export function useStartupProgramCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>;
export function useStartupProgramCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StartupProgramCouponInfoQuery | undefined, StartupProgramCouponInfoQueryVariables>;
export function useStartupProgramCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>(StartupProgramCouponInfoDocument, options);
        }
export type StartupProgramCouponInfoQueryHookResult = ReturnType<typeof useStartupProgramCouponInfoQuery>;
export type StartupProgramCouponInfoLazyQueryHookResult = ReturnType<typeof useStartupProgramCouponInfoLazyQuery>;
export type StartupProgramCouponInfoSuspenseQueryHookResult = ReturnType<typeof useStartupProgramCouponInfoSuspenseQuery>;
export type StartupProgramCouponInfoQueryResult = ApolloReactCommon.QueryResult<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>;
export const TrialEndOrgInfoDocument = gql`
    query TrialEndOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    usedSeats
    flags
    teams {
      id
      name
    }
    subscriptions {
      id
      expiresAt
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;
export type TrialEndOrgInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>, 'query'> & ({ variables: TrialEndOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TrialEndOrgInfoComponent = (props: TrialEndOrgInfoComponentProps) => (
      <ApolloReactComponents.Query<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables> query={TrialEndOrgInfoDocument} {...props} />
    );
    
export type TrialEndOrgInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>
    } & TChildProps;
export function withTrialEndOrgInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TrialEndOrgInfoQuery,
  TrialEndOrgInfoQueryVariables,
  TrialEndOrgInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables, TrialEndOrgInfoProps<TChildProps, TDataName>>(TrialEndOrgInfoDocument, {
      alias: 'trialEndOrgInfo',
      ...operationOptions
    });
};

/**
 * __useTrialEndOrgInfoQuery__
 *
 * To run a query within a React component, call `useTrialEndOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialEndOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialEndOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useTrialEndOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables> & ({ variables: TrialEndOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>(TrialEndOrgInfoDocument, options);
      }
export function useTrialEndOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>(TrialEndOrgInfoDocument, options);
        }
// @ts-ignore
export function useTrialEndOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>;
export function useTrialEndOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialEndOrgInfoQuery | undefined, TrialEndOrgInfoQueryVariables>;
export function useTrialEndOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>(TrialEndOrgInfoDocument, options);
        }
export type TrialEndOrgInfoQueryHookResult = ReturnType<typeof useTrialEndOrgInfoQuery>;
export type TrialEndOrgInfoLazyQueryHookResult = ReturnType<typeof useTrialEndOrgInfoLazyQuery>;
export type TrialEndOrgInfoSuspenseQueryHookResult = ReturnType<typeof useTrialEndOrgInfoSuspenseQuery>;
export type TrialEndOrgInfoQueryResult = ApolloReactCommon.QueryResult<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>;
export const TrialEndCouponInfoDocument = gql`
    query TrialEndCouponInfo($couponID: String!) {
  coupon(id: $couponID) {
    id
    amountOff
    percentOff
    duration
    currency
    name
    durationInMonths
  }
}
    `;
export type TrialEndCouponInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>, 'query'> & ({ variables: TrialEndCouponInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TrialEndCouponInfoComponent = (props: TrialEndCouponInfoComponentProps) => (
      <ApolloReactComponents.Query<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables> query={TrialEndCouponInfoDocument} {...props} />
    );
    
export type TrialEndCouponInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>
    } & TChildProps;
export function withTrialEndCouponInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TrialEndCouponInfoQuery,
  TrialEndCouponInfoQueryVariables,
  TrialEndCouponInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables, TrialEndCouponInfoProps<TChildProps, TDataName>>(TrialEndCouponInfoDocument, {
      alias: 'trialEndCouponInfo',
      ...operationOptions
    });
};

/**
 * __useTrialEndCouponInfoQuery__
 *
 * To run a query within a React component, call `useTrialEndCouponInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialEndCouponInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialEndCouponInfoQuery({
 *   variables: {
 *      couponID: // value for 'couponID'
 *   },
 * });
 */
export function useTrialEndCouponInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables> & ({ variables: TrialEndCouponInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>(TrialEndCouponInfoDocument, options);
      }
export function useTrialEndCouponInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>(TrialEndCouponInfoDocument, options);
        }
// @ts-ignore
export function useTrialEndCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>;
export function useTrialEndCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialEndCouponInfoQuery | undefined, TrialEndCouponInfoQueryVariables>;
export function useTrialEndCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>(TrialEndCouponInfoDocument, options);
        }
export type TrialEndCouponInfoQueryHookResult = ReturnType<typeof useTrialEndCouponInfoQuery>;
export type TrialEndCouponInfoLazyQueryHookResult = ReturnType<typeof useTrialEndCouponInfoLazyQuery>;
export type TrialEndCouponInfoSuspenseQueryHookResult = ReturnType<typeof useTrialEndCouponInfoSuspenseQuery>;
export type TrialEndCouponInfoQueryResult = ApolloReactCommon.QueryResult<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>;
export const CreateAccessTokenDocument = gql`
    mutation createAccessToken($projects: [ProjectSpecifier!]!, $viewId: ID!, $email: String, $username: String, $clientMutationId: String, $previewURL: String) {
  createAccessToken(
    input: {projects: $projects, viewId: $viewId, email: $email, username: $username, clientMutationId: $clientMutationId, previewURL: $previewURL}
  ) {
    accessToken {
      id
      token
      view {
        id
      }
      type
      emails
      createdBy {
        id
        username
        email
        name
      }
      createdAt
      lastAccessedAt
      revokedAt
      projects {
        id
        name
        entityName
      }
    }
    toNewUser
    recipientAlreadyOnTeam
    clientMutationId
  }
}
    `;
export type CreateAccessTokenMutationFn = ApolloReactCommon.MutationFunction<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>;
export type CreateAccessTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>, 'mutation'>;

    export const CreateAccessTokenComponent = (props: CreateAccessTokenComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAccessTokenMutation, CreateAccessTokenMutationVariables> mutation={CreateAccessTokenDocument} {...props} />
    );
    
export type CreateAccessTokenProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>
    } & TChildProps;
export function withCreateAccessToken<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAccessTokenMutation,
  CreateAccessTokenMutationVariables,
  CreateAccessTokenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAccessTokenMutation, CreateAccessTokenMutationVariables, CreateAccessTokenProps<TChildProps, TDataName>>(CreateAccessTokenDocument, {
      alias: 'createAccessToken',
      ...operationOptions
    });
};

/**
 * __useCreateAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessTokenMutation, { data, loading, error }] = useCreateAccessTokenMutation({
 *   variables: {
 *      projects: // value for 'projects'
 *      viewId: // value for 'viewId'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      clientMutationId: // value for 'clientMutationId'
 *      previewURL: // value for 'previewURL'
 *   },
 * });
 */
export function useCreateAccessTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>(CreateAccessTokenDocument, options);
      }
export type CreateAccessTokenMutationHookResult = ReturnType<typeof useCreateAccessTokenMutation>;
export type CreateAccessTokenMutationResult = ApolloReactCommon.MutationResult<CreateAccessTokenMutation>;
export type CreateAccessTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>;
export const RevokeAccessTokenDocument = gql`
    mutation revokeAccessToken($token: String!, $clientMutationId: String) {
  revokeAccessToken(input: {token: $token, clientMutationId: $clientMutationId}) {
    success
    clientMutationId
  }
}
    `;
export type RevokeAccessTokenMutationFn = ApolloReactCommon.MutationFunction<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>;
export type RevokeAccessTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>, 'mutation'>;

    export const RevokeAccessTokenComponent = (props: RevokeAccessTokenComponentProps) => (
      <ApolloReactComponents.Mutation<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables> mutation={RevokeAccessTokenDocument} {...props} />
    );
    
export type RevokeAccessTokenProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>
    } & TChildProps;
export function withRevokeAccessToken<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RevokeAccessTokenMutation,
  RevokeAccessTokenMutationVariables,
  RevokeAccessTokenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables, RevokeAccessTokenProps<TChildProps, TDataName>>(RevokeAccessTokenDocument, {
      alias: 'revokeAccessToken',
      ...operationOptions
    });
};

/**
 * __useRevokeAccessTokenMutation__
 *
 * To run a mutation, you first call `useRevokeAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAccessTokenMutation, { data, loading, error }] = useRevokeAccessTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRevokeAccessTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>(RevokeAccessTokenDocument, options);
      }
export type RevokeAccessTokenMutationHookResult = ReturnType<typeof useRevokeAccessTokenMutation>;
export type RevokeAccessTokenMutationResult = ApolloReactCommon.MutationResult<RevokeAccessTokenMutation>;
export type RevokeAccessTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>;
export const UpdateAccessTokenProjectsDocument = gql`
    mutation updateAccessTokenProjects($token: String!, $projects: [ProjectSpecifier!]!, $clientMutationId: String) {
  updateAccessTokenProjects(
    input: {token: $token, projects: $projects, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateAccessTokenProjectsMutationFn = ApolloReactCommon.MutationFunction<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>;
export type UpdateAccessTokenProjectsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>, 'mutation'>;

    export const UpdateAccessTokenProjectsComponent = (props: UpdateAccessTokenProjectsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables> mutation={UpdateAccessTokenProjectsDocument} {...props} />
    );
    
export type UpdateAccessTokenProjectsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>
    } & TChildProps;
export function withUpdateAccessTokenProjects<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAccessTokenProjectsMutation,
  UpdateAccessTokenProjectsMutationVariables,
  UpdateAccessTokenProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables, UpdateAccessTokenProjectsProps<TChildProps, TDataName>>(UpdateAccessTokenProjectsDocument, {
      alias: 'updateAccessTokenProjects',
      ...operationOptions
    });
};

/**
 * __useUpdateAccessTokenProjectsMutation__
 *
 * To run a mutation, you first call `useUpdateAccessTokenProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessTokenProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessTokenProjectsMutation, { data, loading, error }] = useUpdateAccessTokenProjectsMutation({
 *   variables: {
 *      token: // value for 'token'
 *      projects: // value for 'projects'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateAccessTokenProjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>(UpdateAccessTokenProjectsDocument, options);
      }
export type UpdateAccessTokenProjectsMutationHookResult = ReturnType<typeof useUpdateAccessTokenProjectsMutation>;
export type UpdateAccessTokenProjectsMutationResult = ApolloReactCommon.MutationResult<UpdateAccessTokenProjectsMutation>;
export type UpdateAccessTokenProjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>;
export const UpdateAccessTokenDocument = gql`
    mutation updateAccessToken($token: String!, $email: String, $username: String, $clientMutationId: String, $previewURL: String) {
  updateAccessToken(
    input: {token: $token, email: $email, username: $username, clientMutationId: $clientMutationId, previewURL: $previewURL}
  ) {
    accessToken {
      id
      token
      view {
        id
      }
      type
      emails
      createdBy {
        id
        username
        email
        name
      }
      createdAt
      lastAccessedAt
      revokedAt
      projects {
        id
        name
        entityName
      }
    }
    toNewUser
    recipientAlreadyOnTeam
    clientMutationId
  }
}
    `;
export type UpdateAccessTokenMutationFn = ApolloReactCommon.MutationFunction<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>;
export type UpdateAccessTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>, 'mutation'>;

    export const UpdateAccessTokenComponent = (props: UpdateAccessTokenComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables> mutation={UpdateAccessTokenDocument} {...props} />
    );
    
export type UpdateAccessTokenProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>
    } & TChildProps;
export function withUpdateAccessToken<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateAccessTokenMutation,
  UpdateAccessTokenMutationVariables,
  UpdateAccessTokenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables, UpdateAccessTokenProps<TChildProps, TDataName>>(UpdateAccessTokenDocument, {
      alias: 'updateAccessToken',
      ...operationOptions
    });
};

/**
 * __useUpdateAccessTokenMutation__
 *
 * To run a mutation, you first call `useUpdateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessTokenMutation, { data, loading, error }] = useUpdateAccessTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      clientMutationId: // value for 'clientMutationId'
 *      previewURL: // value for 'previewURL'
 *   },
 * });
 */
export function useUpdateAccessTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>(UpdateAccessTokenDocument, options);
      }
export type UpdateAccessTokenMutationHookResult = ReturnType<typeof useUpdateAccessTokenMutation>;
export type UpdateAccessTokenMutationResult = ApolloReactCommon.MutationResult<UpdateAccessTokenMutation>;
export type UpdateAccessTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>;
export const RevokeAccessTokenEmailDocument = gql`
    mutation revokeAccessTokenEmail($token: String!, $email: String!, $clientMutationId: String) {
  revokeAccessTokenEmail(
    input: {token: $token, email: $email, clientMutationId: $clientMutationId}
  ) {
    accessToken {
      id
      token
      view {
        id
      }
      type
      emails
    }
    clientMutationId
  }
}
    `;
export type RevokeAccessTokenEmailMutationFn = ApolloReactCommon.MutationFunction<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>;
export type RevokeAccessTokenEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>, 'mutation'>;

    export const RevokeAccessTokenEmailComponent = (props: RevokeAccessTokenEmailComponentProps) => (
      <ApolloReactComponents.Mutation<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables> mutation={RevokeAccessTokenEmailDocument} {...props} />
    );
    
export type RevokeAccessTokenEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>
    } & TChildProps;
export function withRevokeAccessTokenEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RevokeAccessTokenEmailMutation,
  RevokeAccessTokenEmailMutationVariables,
  RevokeAccessTokenEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables, RevokeAccessTokenEmailProps<TChildProps, TDataName>>(RevokeAccessTokenEmailDocument, {
      alias: 'revokeAccessTokenEmail',
      ...operationOptions
    });
};

/**
 * __useRevokeAccessTokenEmailMutation__
 *
 * To run a mutation, you first call `useRevokeAccessTokenEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAccessTokenEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAccessTokenEmailMutation, { data, loading, error }] = useRevokeAccessTokenEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRevokeAccessTokenEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>(RevokeAccessTokenEmailDocument, options);
      }
export type RevokeAccessTokenEmailMutationHookResult = ReturnType<typeof useRevokeAccessTokenEmailMutation>;
export type RevokeAccessTokenEmailMutationResult = ApolloReactCommon.MutationResult<RevokeAccessTokenEmailMutation>;
export type RevokeAccessTokenEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>;
export const ArtifactCollectionAliasActionHistoryDocument = gql`
    query ArtifactCollectionAliasActionHistory($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactCollectionName: String!, $actionCursor: String, $actionFirst: Int, $alias: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifactCollection(name: $artifactCollectionName) {
        id
        aliases {
          edges {
            node {
              id
              alias
            }
          }
        }
        isModelRegistryMigratedArtifactCollection
        aliasActionHistory(after: $actionCursor, first: $actionFirst, alias: $alias) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              createdAt
              alias
              actionType
              targetArtifact {
                id
                versionIndex
                artifactSequence {
                  id
                  name
                  project {
                    id
                    name
                  }
                }
              }
              sourceArtifact {
                id
                versionIndex
                artifactSequence {
                  id
                  name
                  project {
                    id
                    name
                  }
                }
              }
              user {
                id
                username
                photoUrl
                name
                accountType
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ArtifactCollectionAliasActionHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>, 'query'> & ({ variables: ArtifactCollectionAliasActionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCollectionAliasActionHistoryComponent = (props: ArtifactCollectionAliasActionHistoryComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables> query={ArtifactCollectionAliasActionHistoryDocument} {...props} />
    );
    
export type ArtifactCollectionAliasActionHistoryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>
    } & TChildProps;
export function withArtifactCollectionAliasActionHistory<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCollectionAliasActionHistoryQuery,
  ArtifactCollectionAliasActionHistoryQueryVariables,
  ArtifactCollectionAliasActionHistoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables, ArtifactCollectionAliasActionHistoryProps<TChildProps, TDataName>>(ArtifactCollectionAliasActionHistoryDocument, {
      alias: 'artifactCollectionAliasActionHistory',
      ...operationOptions
    });
};

/**
 * __useArtifactCollectionAliasActionHistoryQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionAliasActionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionAliasActionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionAliasActionHistoryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      actionCursor: // value for 'actionCursor'
 *      actionFirst: // value for 'actionFirst'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useArtifactCollectionAliasActionHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables> & ({ variables: ArtifactCollectionAliasActionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>(ArtifactCollectionAliasActionHistoryDocument, options);
      }
export function useArtifactCollectionAliasActionHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>(ArtifactCollectionAliasActionHistoryDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionAliasActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>;
export function useArtifactCollectionAliasActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionAliasActionHistoryQuery | undefined, ArtifactCollectionAliasActionHistoryQueryVariables>;
export function useArtifactCollectionAliasActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>(ArtifactCollectionAliasActionHistoryDocument, options);
        }
export type ArtifactCollectionAliasActionHistoryQueryHookResult = ReturnType<typeof useArtifactCollectionAliasActionHistoryQuery>;
export type ArtifactCollectionAliasActionHistoryLazyQueryHookResult = ReturnType<typeof useArtifactCollectionAliasActionHistoryLazyQuery>;
export type ArtifactCollectionAliasActionHistorySuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionAliasActionHistorySuspenseQuery>;
export type ArtifactCollectionAliasActionHistoryQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>;
export const ArtifactCollectionActionHistoryDocument = gql`
    query ArtifactCollectionActionHistory($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactCollectionName: String!, $actionCursor: String, $actionFirst: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifactCollection(name: $artifactCollectionName) {
        id
        aliases {
          edges {
            node {
              id
              alias
            }
          }
        }
        artifactCollectionActions(after: $actionCursor, first: $actionFirst) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              id
              createdAt
              actionType
              user {
                id
                username
                name
                accountType
              }
              artifact {
                id
                versionIndex
                artifactSequence {
                  id
                  name
                  project {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ArtifactCollectionActionHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>, 'query'> & ({ variables: ArtifactCollectionActionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCollectionActionHistoryComponent = (props: ArtifactCollectionActionHistoryComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables> query={ArtifactCollectionActionHistoryDocument} {...props} />
    );
    
export type ArtifactCollectionActionHistoryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>
    } & TChildProps;
export function withArtifactCollectionActionHistory<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCollectionActionHistoryQuery,
  ArtifactCollectionActionHistoryQueryVariables,
  ArtifactCollectionActionHistoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables, ArtifactCollectionActionHistoryProps<TChildProps, TDataName>>(ArtifactCollectionActionHistoryDocument, {
      alias: 'artifactCollectionActionHistory',
      ...operationOptions
    });
};

/**
 * __useArtifactCollectionActionHistoryQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionActionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionActionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionActionHistoryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      actionCursor: // value for 'actionCursor'
 *      actionFirst: // value for 'actionFirst'
 *   },
 * });
 */
export function useArtifactCollectionActionHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables> & ({ variables: ArtifactCollectionActionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>(ArtifactCollectionActionHistoryDocument, options);
      }
export function useArtifactCollectionActionHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>(ArtifactCollectionActionHistoryDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>;
export function useArtifactCollectionActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionActionHistoryQuery | undefined, ArtifactCollectionActionHistoryQueryVariables>;
export function useArtifactCollectionActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>(ArtifactCollectionActionHistoryDocument, options);
        }
export type ArtifactCollectionActionHistoryQueryHookResult = ReturnType<typeof useArtifactCollectionActionHistoryQuery>;
export type ArtifactCollectionActionHistoryLazyQueryHookResult = ReturnType<typeof useArtifactCollectionActionHistoryLazyQuery>;
export type ArtifactCollectionActionHistorySuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionActionHistorySuspenseQuery>;
export type ArtifactCollectionActionHistoryQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>;
export const ArtifactCollectionDocument = gql`
    query ArtifactCollection($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactCollectionName: String!, $artifactCursor: String, $artifactFirst: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      name
      description
      artifactCollection(name: $artifactCollectionName) {
        __typename
        id
        name
        description
        artifacts {
          totalCount
        }
        artifactMemberships(after: $artifactCursor, first: $artifactFirst) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              id
              createdAt
              commitHash
              versionIndex
              artifact {
                id
                digest
                state
                createdAt
              }
              aliases {
                id
                artifactCollection {
                  id
                  name
                }
                alias
              }
            }
          }
        }
        aliases {
          edges {
            node {
              id
              alias
              artifact {
                id
                versionIndex
              }
            }
          }
        }
        tags {
          edges {
            node {
              id
              name
              tagCategoryName
              attributes
            }
          }
        }
      }
    }
  }
}
    `;
export type ArtifactCollectionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>, 'query'> & ({ variables: ArtifactCollectionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCollectionComponent = (props: ArtifactCollectionComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCollectionQuery, ArtifactCollectionQueryVariables> query={ArtifactCollectionDocument} {...props} />
    );
    
export type ArtifactCollectionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>
    } & TChildProps;
export function withArtifactCollection<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCollectionQuery,
  ArtifactCollectionQueryVariables,
  ArtifactCollectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCollectionQuery, ArtifactCollectionQueryVariables, ArtifactCollectionProps<TChildProps, TDataName>>(ArtifactCollectionDocument, {
      alias: 'artifactCollection',
      ...operationOptions
    });
};

/**
 * __useArtifactCollectionQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      artifactCursor: // value for 'artifactCursor'
 *      artifactFirst: // value for 'artifactFirst'
 *   },
 * });
 */
export function useArtifactCollectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables> & ({ variables: ArtifactCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>(ArtifactCollectionDocument, options);
      }
export function useArtifactCollectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>(ArtifactCollectionDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>;
export function useArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionQuery | undefined, ArtifactCollectionQueryVariables>;
export function useArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>(ArtifactCollectionDocument, options);
        }
export type ArtifactCollectionQueryHookResult = ReturnType<typeof useArtifactCollectionQuery>;
export type ArtifactCollectionLazyQueryHookResult = ReturnType<typeof useArtifactCollectionLazyQuery>;
export type ArtifactCollectionSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionSuspenseQuery>;
export type ArtifactCollectionQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>;
export const EntityPortfoliosDocument = gql`
    query EntityPortfolios($entityName: String!, $artifactTypeName: String!) {
  entity(name: $entityName) {
    id
    name
    projects {
      edges {
        node {
          id
          name
          artifactType(name: $artifactTypeName) {
            id
            name
            artifactCollections(collectionTypes: [PORTFOLIO]) {
              edges {
                node {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type EntityPortfoliosComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>, 'query'> & ({ variables: EntityPortfoliosQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityPortfoliosComponent = (props: EntityPortfoliosComponentProps) => (
      <ApolloReactComponents.Query<EntityPortfoliosQuery, EntityPortfoliosQueryVariables> query={EntityPortfoliosDocument} {...props} />
    );
    
export type EntityPortfoliosProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>
    } & TChildProps;
export function withEntityPortfolios<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityPortfoliosQuery,
  EntityPortfoliosQueryVariables,
  EntityPortfoliosProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityPortfoliosQuery, EntityPortfoliosQueryVariables, EntityPortfoliosProps<TChildProps, TDataName>>(EntityPortfoliosDocument, {
      alias: 'entityPortfolios',
      ...operationOptions
    });
};

/**
 * __useEntityPortfoliosQuery__
 *
 * To run a query within a React component, call `useEntityPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPortfoliosQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *   },
 * });
 */
export function useEntityPortfoliosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables> & ({ variables: EntityPortfoliosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>(EntityPortfoliosDocument, options);
      }
export function useEntityPortfoliosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>(EntityPortfoliosDocument, options);
        }
// @ts-ignore
export function useEntityPortfoliosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>;
export function useEntityPortfoliosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPortfoliosQuery | undefined, EntityPortfoliosQueryVariables>;
export function useEntityPortfoliosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>(EntityPortfoliosDocument, options);
        }
export type EntityPortfoliosQueryHookResult = ReturnType<typeof useEntityPortfoliosQuery>;
export type EntityPortfoliosLazyQueryHookResult = ReturnType<typeof useEntityPortfoliosLazyQuery>;
export type EntityPortfoliosSuspenseQueryHookResult = ReturnType<typeof useEntityPortfoliosSuspenseQuery>;
export type EntityPortfoliosQueryResult = ApolloReactCommon.QueryResult<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>;
export const ArtifactCollectionNameFromIdDocument = gql`
    query ArtifactCollectionNameFromID($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    __typename
    ... on ArtifactSequence {
      id
      name
      project {
        id
        name
      }
    }
    ... on ArtifactPortfolio {
      id
      name
      project {
        id
        name
      }
    }
  }
}
    `;
export type ArtifactCollectionNameFromIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>, 'query'> & ({ variables: ArtifactCollectionNameFromIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCollectionNameFromIdComponent = (props: ArtifactCollectionNameFromIdComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables> query={ArtifactCollectionNameFromIdDocument} {...props} />
    );
    
export type ArtifactCollectionNameFromIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>
    } & TChildProps;
export function withArtifactCollectionNameFromId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCollectionNameFromIdQuery,
  ArtifactCollectionNameFromIdQueryVariables,
  ArtifactCollectionNameFromIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables, ArtifactCollectionNameFromIdProps<TChildProps, TDataName>>(ArtifactCollectionNameFromIdDocument, {
      alias: 'artifactCollectionNameFromId',
      ...operationOptions
    });
};

/**
 * __useArtifactCollectionNameFromIdQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionNameFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionNameFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionNameFromIdQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactCollectionNameFromIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables> & ({ variables: ArtifactCollectionNameFromIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>(ArtifactCollectionNameFromIdDocument, options);
      }
export function useArtifactCollectionNameFromIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>(ArtifactCollectionNameFromIdDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionNameFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>;
export function useArtifactCollectionNameFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionNameFromIdQuery | undefined, ArtifactCollectionNameFromIdQueryVariables>;
export function useArtifactCollectionNameFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>(ArtifactCollectionNameFromIdDocument, options);
        }
export type ArtifactCollectionNameFromIdQueryHookResult = ReturnType<typeof useArtifactCollectionNameFromIdQuery>;
export type ArtifactCollectionNameFromIdLazyQueryHookResult = ReturnType<typeof useArtifactCollectionNameFromIdLazyQuery>;
export type ArtifactCollectionNameFromIdSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionNameFromIdSuspenseQuery>;
export type ArtifactCollectionNameFromIdQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>;
export const ArtifactFilesDocument = gql`
    query ArtifactFiles($artifactID: ID!, $artifactFileNames: [String!]!) {
  artifact(id: $artifactID) {
    id
    createdAt
    files(names: $artifactFileNames) {
      edges {
        node {
          id
          name
          displayName
          digest
          url
          directUrl
          isReference
          sizeBytes
          updatedAt
        }
      }
    }
  }
}
    `;
export type ArtifactFilesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>, 'query'> & ({ variables: ArtifactFilesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactFilesComponent = (props: ArtifactFilesComponentProps) => (
      <ApolloReactComponents.Query<ArtifactFilesQuery, ArtifactFilesQueryVariables> query={ArtifactFilesDocument} {...props} />
    );
    
export type ArtifactFilesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactFilesQuery, ArtifactFilesQueryVariables>
    } & TChildProps;
export function withArtifactFiles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactFilesQuery,
  ArtifactFilesQueryVariables,
  ArtifactFilesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactFilesQuery, ArtifactFilesQueryVariables, ArtifactFilesProps<TChildProps, TDataName>>(ArtifactFilesDocument, {
      alias: 'artifactFiles',
      ...operationOptions
    });
};

/**
 * __useArtifactFilesQuery__
 *
 * To run a query within a React component, call `useArtifactFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactFilesQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      artifactFileNames: // value for 'artifactFileNames'
 *   },
 * });
 */
export function useArtifactFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables> & ({ variables: ArtifactFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactFilesQuery, ArtifactFilesQueryVariables>(ArtifactFilesDocument, options);
      }
export function useArtifactFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactFilesQuery, ArtifactFilesQueryVariables>(ArtifactFilesDocument, options);
        }
// @ts-ignore
export function useArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactFilesQuery, ArtifactFilesQueryVariables>;
export function useArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactFilesQuery | undefined, ArtifactFilesQueryVariables>;
export function useArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactFilesQuery, ArtifactFilesQueryVariables>(ArtifactFilesDocument, options);
        }
export type ArtifactFilesQueryHookResult = ReturnType<typeof useArtifactFilesQuery>;
export type ArtifactFilesLazyQueryHookResult = ReturnType<typeof useArtifactFilesLazyQuery>;
export type ArtifactFilesSuspenseQueryHookResult = ReturnType<typeof useArtifactFilesSuspenseQuery>;
export type ArtifactFilesQueryResult = ApolloReactCommon.QueryResult<ArtifactFilesQuery, ArtifactFilesQueryVariables>;
export const ArtifactIdDocument = gql`
    query ArtifactID($projectName: String!, $entityName: String!, $artifactTypeName: String!, $artifactID: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifact(name: $artifactID) {
        id
      }
    }
  }
}
    `;
export type ArtifactIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactIdQuery, ArtifactIdQueryVariables>, 'query'> & ({ variables: ArtifactIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactIdComponent = (props: ArtifactIdComponentProps) => (
      <ApolloReactComponents.Query<ArtifactIdQuery, ArtifactIdQueryVariables> query={ArtifactIdDocument} {...props} />
    );
    
export type ArtifactIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactIdQuery, ArtifactIdQueryVariables>
    } & TChildProps;
export function withArtifactId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactIdQuery,
  ArtifactIdQueryVariables,
  ArtifactIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactIdQuery, ArtifactIdQueryVariables, ArtifactIdProps<TChildProps, TDataName>>(ArtifactIdDocument, {
      alias: 'artifactId',
      ...operationOptions
    });
};

/**
 * __useArtifactIdQuery__
 *
 * To run a query within a React component, call `useArtifactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactIdQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables> & ({ variables: ArtifactIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactIdQuery, ArtifactIdQueryVariables>(ArtifactIdDocument, options);
      }
export function useArtifactIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactIdQuery, ArtifactIdQueryVariables>(ArtifactIdDocument, options);
        }
// @ts-ignore
export function useArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactIdQuery, ArtifactIdQueryVariables>;
export function useArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactIdQuery | undefined, ArtifactIdQueryVariables>;
export function useArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactIdQuery, ArtifactIdQueryVariables>(ArtifactIdDocument, options);
        }
export type ArtifactIdQueryHookResult = ReturnType<typeof useArtifactIdQuery>;
export type ArtifactIdLazyQueryHookResult = ReturnType<typeof useArtifactIdLazyQuery>;
export type ArtifactIdSuspenseQueryHookResult = ReturnType<typeof useArtifactIdSuspenseQuery>;
export type ArtifactIdQueryResult = ApolloReactCommon.QueryResult<ArtifactIdQuery, ArtifactIdQueryVariables>;
export const ArtifactPathInfoDocument = gql`
    query ArtifactPathInfo($artifactId: ID!) {
  artifact(id: $artifactId) {
    id
    createdAt
    commitHash
    versionIndex
    artifactSequence {
      id
      name
    }
    artifactType {
      id
      name
      project {
        id
        name
        entityName
      }
    }
  }
}
    `;
export type ArtifactPathInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>, 'query'> & ({ variables: ArtifactPathInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactPathInfoComponent = (props: ArtifactPathInfoComponentProps) => (
      <ApolloReactComponents.Query<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables> query={ArtifactPathInfoDocument} {...props} />
    );
    
export type ArtifactPathInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>
    } & TChildProps;
export function withArtifactPathInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactPathInfoQuery,
  ArtifactPathInfoQueryVariables,
  ArtifactPathInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables, ArtifactPathInfoProps<TChildProps, TDataName>>(ArtifactPathInfoDocument, {
      alias: 'artifactPathInfo',
      ...operationOptions
    });
};

/**
 * __useArtifactPathInfoQuery__
 *
 * To run a query within a React component, call `useArtifactPathInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactPathInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactPathInfoQuery({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useArtifactPathInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables> & ({ variables: ArtifactPathInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>(ArtifactPathInfoDocument, options);
      }
export function useArtifactPathInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>(ArtifactPathInfoDocument, options);
        }
// @ts-ignore
export function useArtifactPathInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>;
export function useArtifactPathInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathInfoQuery | undefined, ArtifactPathInfoQueryVariables>;
export function useArtifactPathInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>(ArtifactPathInfoDocument, options);
        }
export type ArtifactPathInfoQueryHookResult = ReturnType<typeof useArtifactPathInfoQuery>;
export type ArtifactPathInfoLazyQueryHookResult = ReturnType<typeof useArtifactPathInfoLazyQuery>;
export type ArtifactPathInfoSuspenseQueryHookResult = ReturnType<typeof useArtifactPathInfoSuspenseQuery>;
export type ArtifactPathInfoQueryResult = ApolloReactCommon.QueryResult<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>;
export const ArtifactManifestDocument = gql`
    query ArtifactManifest($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactID: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifact(name: $artifactID) {
        id
        createdAt
        currentManifest {
          id
          file {
            id
            directUrl
          }
        }
      }
    }
  }
  serverInfo {
    defaultCloudRegion {
      id
    }
  }
}
    `;
export type ArtifactManifestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>, 'query'> & ({ variables: ArtifactManifestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactManifestComponent = (props: ArtifactManifestComponentProps) => (
      <ApolloReactComponents.Query<ArtifactManifestQuery, ArtifactManifestQueryVariables> query={ArtifactManifestDocument} {...props} />
    );
    
export type ArtifactManifestProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactManifestQuery, ArtifactManifestQueryVariables>
    } & TChildProps;
export function withArtifactManifest<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactManifestQuery,
  ArtifactManifestQueryVariables,
  ArtifactManifestProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactManifestQuery, ArtifactManifestQueryVariables, ArtifactManifestProps<TChildProps, TDataName>>(ArtifactManifestDocument, {
      alias: 'artifactManifest',
      ...operationOptions
    });
};

/**
 * __useArtifactManifestQuery__
 *
 * To run a query within a React component, call `useArtifactManifestQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactManifestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactManifestQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactManifestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables> & ({ variables: ArtifactManifestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactManifestQuery, ArtifactManifestQueryVariables>(ArtifactManifestDocument, options);
      }
export function useArtifactManifestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactManifestQuery, ArtifactManifestQueryVariables>(ArtifactManifestDocument, options);
        }
// @ts-ignore
export function useArtifactManifestSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestQuery, ArtifactManifestQueryVariables>;
export function useArtifactManifestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestQuery | undefined, ArtifactManifestQueryVariables>;
export function useArtifactManifestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactManifestQuery, ArtifactManifestQueryVariables>(ArtifactManifestDocument, options);
        }
export type ArtifactManifestQueryHookResult = ReturnType<typeof useArtifactManifestQuery>;
export type ArtifactManifestLazyQueryHookResult = ReturnType<typeof useArtifactManifestLazyQuery>;
export type ArtifactManifestSuspenseQueryHookResult = ReturnType<typeof useArtifactManifestSuspenseQuery>;
export type ArtifactManifestQueryResult = ApolloReactCommon.QueryResult<ArtifactManifestQuery, ArtifactManifestQueryVariables>;
export const ArtifactManifestFromIdDocument = gql`
    query ArtifactManifestFromID($artifactId: ID!) {
  artifact(id: $artifactId) {
    id
    createdAt
    artifactSequence {
      id
      name
      project {
        id
        name
        entityName
      }
    }
    artifactType {
      id
      name
    }
    currentManifest {
      id
      file {
        id
        directUrl
      }
    }
  }
  serverInfo {
    defaultCloudRegion {
      id
    }
  }
}
    `;
export type ArtifactManifestFromIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>, 'query'> & ({ variables: ArtifactManifestFromIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactManifestFromIdComponent = (props: ArtifactManifestFromIdComponentProps) => (
      <ApolloReactComponents.Query<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables> query={ArtifactManifestFromIdDocument} {...props} />
    );
    
export type ArtifactManifestFromIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>
    } & TChildProps;
export function withArtifactManifestFromId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactManifestFromIdQuery,
  ArtifactManifestFromIdQueryVariables,
  ArtifactManifestFromIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables, ArtifactManifestFromIdProps<TChildProps, TDataName>>(ArtifactManifestFromIdDocument, {
      alias: 'artifactManifestFromId',
      ...operationOptions
    });
};

/**
 * __useArtifactManifestFromIdQuery__
 *
 * To run a query within a React component, call `useArtifactManifestFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactManifestFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactManifestFromIdQuery({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useArtifactManifestFromIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables> & ({ variables: ArtifactManifestFromIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>(ArtifactManifestFromIdDocument, options);
      }
export function useArtifactManifestFromIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>(ArtifactManifestFromIdDocument, options);
        }
// @ts-ignore
export function useArtifactManifestFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>;
export function useArtifactManifestFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestFromIdQuery | undefined, ArtifactManifestFromIdQueryVariables>;
export function useArtifactManifestFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>(ArtifactManifestFromIdDocument, options);
        }
export type ArtifactManifestFromIdQueryHookResult = ReturnType<typeof useArtifactManifestFromIdQuery>;
export type ArtifactManifestFromIdLazyQueryHookResult = ReturnType<typeof useArtifactManifestFromIdLazyQuery>;
export type ArtifactManifestFromIdSuspenseQueryHookResult = ReturnType<typeof useArtifactManifestFromIdSuspenseQuery>;
export type ArtifactManifestFromIdQueryResult = ApolloReactCommon.QueryResult<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>;
export const ResolveLatestSequenceAliasToArtifactIdDocument = gql`
    query ResolveLatestSequenceAliasToArtifactId($sequenceId: ID!) {
  artifactSequence(id: $sequenceId) {
    id
    latestArtifact {
      id
    }
  }
}
    `;
export type ResolveLatestSequenceAliasToArtifactIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>, 'query'> & ({ variables: ResolveLatestSequenceAliasToArtifactIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ResolveLatestSequenceAliasToArtifactIdComponent = (props: ResolveLatestSequenceAliasToArtifactIdComponentProps) => (
      <ApolloReactComponents.Query<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables> query={ResolveLatestSequenceAliasToArtifactIdDocument} {...props} />
    );
    
export type ResolveLatestSequenceAliasToArtifactIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>
    } & TChildProps;
export function withResolveLatestSequenceAliasToArtifactId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResolveLatestSequenceAliasToArtifactIdQuery,
  ResolveLatestSequenceAliasToArtifactIdQueryVariables,
  ResolveLatestSequenceAliasToArtifactIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables, ResolveLatestSequenceAliasToArtifactIdProps<TChildProps, TDataName>>(ResolveLatestSequenceAliasToArtifactIdDocument, {
      alias: 'resolveLatestSequenceAliasToArtifactId',
      ...operationOptions
    });
};

/**
 * __useResolveLatestSequenceAliasToArtifactIdQuery__
 *
 * To run a query within a React component, call `useResolveLatestSequenceAliasToArtifactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveLatestSequenceAliasToArtifactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveLatestSequenceAliasToArtifactIdQuery({
 *   variables: {
 *      sequenceId: // value for 'sequenceId'
 *   },
 * });
 */
export function useResolveLatestSequenceAliasToArtifactIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables> & ({ variables: ResolveLatestSequenceAliasToArtifactIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>(ResolveLatestSequenceAliasToArtifactIdDocument, options);
      }
export function useResolveLatestSequenceAliasToArtifactIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>(ResolveLatestSequenceAliasToArtifactIdDocument, options);
        }
// @ts-ignore
export function useResolveLatestSequenceAliasToArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>;
export function useResolveLatestSequenceAliasToArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResolveLatestSequenceAliasToArtifactIdQuery | undefined, ResolveLatestSequenceAliasToArtifactIdQueryVariables>;
export function useResolveLatestSequenceAliasToArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>(ResolveLatestSequenceAliasToArtifactIdDocument, options);
        }
export type ResolveLatestSequenceAliasToArtifactIdQueryHookResult = ReturnType<typeof useResolveLatestSequenceAliasToArtifactIdQuery>;
export type ResolveLatestSequenceAliasToArtifactIdLazyQueryHookResult = ReturnType<typeof useResolveLatestSequenceAliasToArtifactIdLazyQuery>;
export type ResolveLatestSequenceAliasToArtifactIdSuspenseQueryHookResult = ReturnType<typeof useResolveLatestSequenceAliasToArtifactIdSuspenseQuery>;
export type ResolveLatestSequenceAliasToArtifactIdQueryResult = ApolloReactCommon.QueryResult<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>;
export const ArtifactCommitHashDocument = gql`
    query ArtifactCommitHash($id: ID!, $artifactCollectionName: String!) {
  artifact(id: $id) {
    id
    commitHash(artifactCollectionName: $artifactCollectionName)
  }
}
    `;
export type ArtifactCommitHashComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>, 'query'> & ({ variables: ArtifactCommitHashQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactCommitHashComponent = (props: ArtifactCommitHashComponentProps) => (
      <ApolloReactComponents.Query<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables> query={ArtifactCommitHashDocument} {...props} />
    );
    
export type ArtifactCommitHashProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>
    } & TChildProps;
export function withArtifactCommitHash<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactCommitHashQuery,
  ArtifactCommitHashQueryVariables,
  ArtifactCommitHashProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables, ArtifactCommitHashProps<TChildProps, TDataName>>(ArtifactCommitHashDocument, {
      alias: 'artifactCommitHash',
      ...operationOptions
    });
};

/**
 * __useArtifactCommitHashQuery__
 *
 * To run a query within a React component, call `useArtifactCommitHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCommitHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCommitHashQuery({
 *   variables: {
 *      id: // value for 'id'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *   },
 * });
 */
export function useArtifactCommitHashQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables> & ({ variables: ArtifactCommitHashQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>(ArtifactCommitHashDocument, options);
      }
export function useArtifactCommitHashLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>(ArtifactCommitHashDocument, options);
        }
// @ts-ignore
export function useArtifactCommitHashSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>;
export function useArtifactCommitHashSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCommitHashQuery | undefined, ArtifactCommitHashQueryVariables>;
export function useArtifactCommitHashSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>(ArtifactCommitHashDocument, options);
        }
export type ArtifactCommitHashQueryHookResult = ReturnType<typeof useArtifactCommitHashQuery>;
export type ArtifactCommitHashLazyQueryHookResult = ReturnType<typeof useArtifactCommitHashLazyQuery>;
export type ArtifactCommitHashSuspenseQueryHookResult = ReturnType<typeof useArtifactCommitHashSuspenseQuery>;
export type ArtifactCommitHashQueryResult = ApolloReactCommon.QueryResult<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>;
export const ArtifactManifestFromMembershipDocument = gql`
    query ArtifactManifestFromMembership($projectName: String!, $entityName: String!, $artifactName: String!, $versionIndex: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactCollection(name: $artifactName) {
      id
      artifactMembership(aliasName: $versionIndex) {
        id
        artifact {
          id
          createdAt
          currentManifest {
            id
            file {
              id
              directUrl
            }
          }
        }
      }
    }
  }
  serverInfo {
    defaultCloudRegion {
      id
    }
  }
}
    `;
export type ArtifactManifestFromMembershipComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>, 'query'> & ({ variables: ArtifactManifestFromMembershipQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactManifestFromMembershipComponent = (props: ArtifactManifestFromMembershipComponentProps) => (
      <ApolloReactComponents.Query<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables> query={ArtifactManifestFromMembershipDocument} {...props} />
    );
    
export type ArtifactManifestFromMembershipProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>
    } & TChildProps;
export function withArtifactManifestFromMembership<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactManifestFromMembershipQuery,
  ArtifactManifestFromMembershipQueryVariables,
  ArtifactManifestFromMembershipProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables, ArtifactManifestFromMembershipProps<TChildProps, TDataName>>(ArtifactManifestFromMembershipDocument, {
      alias: 'artifactManifestFromMembership',
      ...operationOptions
    });
};

/**
 * __useArtifactManifestFromMembershipQuery__
 *
 * To run a query within a React component, call `useArtifactManifestFromMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactManifestFromMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactManifestFromMembershipQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactName: // value for 'artifactName'
 *      versionIndex: // value for 'versionIndex'
 *   },
 * });
 */
export function useArtifactManifestFromMembershipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables> & ({ variables: ArtifactManifestFromMembershipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>(ArtifactManifestFromMembershipDocument, options);
      }
export function useArtifactManifestFromMembershipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>(ArtifactManifestFromMembershipDocument, options);
        }
// @ts-ignore
export function useArtifactManifestFromMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>;
export function useArtifactManifestFromMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestFromMembershipQuery | undefined, ArtifactManifestFromMembershipQueryVariables>;
export function useArtifactManifestFromMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>(ArtifactManifestFromMembershipDocument, options);
        }
export type ArtifactManifestFromMembershipQueryHookResult = ReturnType<typeof useArtifactManifestFromMembershipQuery>;
export type ArtifactManifestFromMembershipLazyQueryHookResult = ReturnType<typeof useArtifactManifestFromMembershipLazyQuery>;
export type ArtifactManifestFromMembershipSuspenseQueryHookResult = ReturnType<typeof useArtifactManifestFromMembershipSuspenseQuery>;
export type ArtifactManifestFromMembershipQueryResult = ApolloReactCommon.QueryResult<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>;
export const CreateArtifactTypesDocument = gql`
    mutation CreateArtifactTypes($entityName: String!, $projectName: String!, $artifactTypes: [ArtifactTypeInput!]!) {
  createArtifactTypes(
    input: {entityName: $entityName, projectName: $projectName, artifactTypes: $artifactTypes}
  ) {
    artifactTypes {
      id
      name
    }
  }
}
    `;
export type CreateArtifactTypesMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>;
export type CreateArtifactTypesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>, 'mutation'>;

    export const CreateArtifactTypesComponent = (props: CreateArtifactTypesComponentProps) => (
      <ApolloReactComponents.Mutation<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables> mutation={CreateArtifactTypesDocument} {...props} />
    );
    
export type CreateArtifactTypesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>
    } & TChildProps;
export function withCreateArtifactTypes<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateArtifactTypesMutation,
  CreateArtifactTypesMutationVariables,
  CreateArtifactTypesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables, CreateArtifactTypesProps<TChildProps, TDataName>>(CreateArtifactTypesDocument, {
      alias: 'createArtifactTypes',
      ...operationOptions
    });
};

/**
 * __useCreateArtifactTypesMutation__
 *
 * To run a mutation, you first call `useCreateArtifactTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactTypesMutation, { data, loading, error }] = useCreateArtifactTypesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactTypes: // value for 'artifactTypes'
 *   },
 * });
 */
export function useCreateArtifactTypesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>(CreateArtifactTypesDocument, options);
      }
export type CreateArtifactTypesMutationHookResult = ReturnType<typeof useCreateArtifactTypesMutation>;
export type CreateArtifactTypesMutationResult = ApolloReactCommon.MutationResult<CreateArtifactTypesMutation>;
export type CreateArtifactTypesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>;
export const UpdateArtifactDocument = gql`
    mutation UpdateArtifact($artifactID: ID!, $description: String, $aliases: [ArtifactAliasInput!], $labels: JSONString, $metadata: JSONString, $ttlDurationSeconds: Int64) {
  updateArtifact(
    input: {artifactID: $artifactID, description: $description, aliases: $aliases, labels: $labels, metadata: $metadata, ttlDurationSeconds: $ttlDurationSeconds}
  ) {
    artifact {
      id
      digest
      description
      aliases {
        id
        artifactCollectionName
        alias
      }
      labels
      ttlDurationSeconds
    }
  }
}
    `;
export type UpdateArtifactMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactMutation, UpdateArtifactMutationVariables>;
export type UpdateArtifactComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateArtifactMutation, UpdateArtifactMutationVariables>, 'mutation'>;

    export const UpdateArtifactComponent = (props: UpdateArtifactComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateArtifactMutation, UpdateArtifactMutationVariables> mutation={UpdateArtifactDocument} {...props} />
    );
    
export type UpdateArtifactProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateArtifactMutation, UpdateArtifactMutationVariables>
    } & TChildProps;
export function withUpdateArtifact<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateArtifactMutation,
  UpdateArtifactMutationVariables,
  UpdateArtifactProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateArtifactMutation, UpdateArtifactMutationVariables, UpdateArtifactProps<TChildProps, TDataName>>(UpdateArtifactDocument, {
      alias: 'updateArtifact',
      ...operationOptions
    });
};

/**
 * __useUpdateArtifactMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactMutation, { data, loading, error }] = useUpdateArtifactMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      description: // value for 'description'
 *      aliases: // value for 'aliases'
 *      labels: // value for 'labels'
 *      metadata: // value for 'metadata'
 *      ttlDurationSeconds: // value for 'ttlDurationSeconds'
 *   },
 * });
 */
export function useUpdateArtifactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactMutation, UpdateArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactMutation, UpdateArtifactMutationVariables>(UpdateArtifactDocument, options);
      }
export type UpdateArtifactMutationHookResult = ReturnType<typeof useUpdateArtifactMutation>;
export type UpdateArtifactMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactMutation>;
export type UpdateArtifactMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactMutation, UpdateArtifactMutationVariables>;
export const DeleteArtifactDocument = gql`
    mutation DeleteArtifact($artifactID: ID!, $deleteAliases: Boolean = false) {
  deleteArtifact(input: {artifactID: $artifactID, deleteAliases: $deleteAliases}) {
    artifact {
      id
      state
    }
  }
}
    `;
export type DeleteArtifactMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactMutation, DeleteArtifactMutationVariables>;
export type DeleteArtifactComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteArtifactMutation, DeleteArtifactMutationVariables>, 'mutation'>;

    export const DeleteArtifactComponent = (props: DeleteArtifactComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteArtifactMutation, DeleteArtifactMutationVariables> mutation={DeleteArtifactDocument} {...props} />
    );
    
export type DeleteArtifactProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteArtifactMutation, DeleteArtifactMutationVariables>
    } & TChildProps;
export function withDeleteArtifact<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteArtifactMutation,
  DeleteArtifactMutationVariables,
  DeleteArtifactProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteArtifactMutation, DeleteArtifactMutationVariables, DeleteArtifactProps<TChildProps, TDataName>>(DeleteArtifactDocument, {
      alias: 'deleteArtifact',
      ...operationOptions
    });
};

/**
 * __useDeleteArtifactMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactMutation, { data, loading, error }] = useDeleteArtifactMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      deleteAliases: // value for 'deleteAliases'
 *   },
 * });
 */
export function useDeleteArtifactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactMutation, DeleteArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactMutation, DeleteArtifactMutationVariables>(DeleteArtifactDocument, options);
      }
export type DeleteArtifactMutationHookResult = ReturnType<typeof useDeleteArtifactMutation>;
export type DeleteArtifactMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactMutation>;
export type DeleteArtifactMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactMutation, DeleteArtifactMutationVariables>;
export const DeleteArtifactSequenceDocument = gql`
    mutation DeleteArtifactSequence($artifactSequenceID: ID!) {
  deleteArtifactSequence(input: {artifactSequenceID: $artifactSequenceID}) {
    artifactCollection {
      id
      state
    }
  }
}
    `;
export type DeleteArtifactSequenceMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>;
export type DeleteArtifactSequenceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>, 'mutation'>;

    export const DeleteArtifactSequenceComponent = (props: DeleteArtifactSequenceComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables> mutation={DeleteArtifactSequenceDocument} {...props} />
    );
    
export type DeleteArtifactSequenceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>
    } & TChildProps;
export function withDeleteArtifactSequence<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteArtifactSequenceMutation,
  DeleteArtifactSequenceMutationVariables,
  DeleteArtifactSequenceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables, DeleteArtifactSequenceProps<TChildProps, TDataName>>(DeleteArtifactSequenceDocument, {
      alias: 'deleteArtifactSequence',
      ...operationOptions
    });
};

/**
 * __useDeleteArtifactSequenceMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactSequenceMutation, { data, loading, error }] = useDeleteArtifactSequenceMutation({
 *   variables: {
 *      artifactSequenceID: // value for 'artifactSequenceID'
 *   },
 * });
 */
export function useDeleteArtifactSequenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>(DeleteArtifactSequenceDocument, options);
      }
export type DeleteArtifactSequenceMutationHookResult = ReturnType<typeof useDeleteArtifactSequenceMutation>;
export type DeleteArtifactSequenceMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactSequenceMutation>;
export type DeleteArtifactSequenceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>;
export const UpdateArtifactTypeDocument = gql`
    mutation UpdateArtifactType($artifactTypeID: ID!, $description: String) {
  updateArtifactType(
    input: {artifactTypeID: $artifactTypeID, description: $description}
  ) {
    artifactType {
      id
      description
    }
  }
}
    `;
export type UpdateArtifactTypeMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>;
export type UpdateArtifactTypeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>, 'mutation'>;

    export const UpdateArtifactTypeComponent = (props: UpdateArtifactTypeComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables> mutation={UpdateArtifactTypeDocument} {...props} />
    );
    
export type UpdateArtifactTypeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>
    } & TChildProps;
export function withUpdateArtifactType<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateArtifactTypeMutation,
  UpdateArtifactTypeMutationVariables,
  UpdateArtifactTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables, UpdateArtifactTypeProps<TChildProps, TDataName>>(UpdateArtifactTypeDocument, {
      alias: 'updateArtifactType',
      ...operationOptions
    });
};

/**
 * __useUpdateArtifactTypeMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactTypeMutation, { data, loading, error }] = useUpdateArtifactTypeMutation({
 *   variables: {
 *      artifactTypeID: // value for 'artifactTypeID'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateArtifactTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>(UpdateArtifactTypeDocument, options);
      }
export type UpdateArtifactTypeMutationHookResult = ReturnType<typeof useUpdateArtifactTypeMutation>;
export type UpdateArtifactTypeMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactTypeMutation>;
export type UpdateArtifactTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>;
export const UpdateArtifactPortfolioDocument = gql`
    mutation UpdateArtifactPortfolio($artifactPortfolioID: ID!, $name: String, $description: String) {
  updateArtifactPortfolio(
    input: {artifactPortfolioID: $artifactPortfolioID, name: $name, description: $description}
  ) {
    artifactCollection {
      id
      name
      description
    }
  }
}
    `;
export type UpdateArtifactPortfolioMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>;
export type UpdateArtifactPortfolioComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>, 'mutation'>;

    export const UpdateArtifactPortfolioComponent = (props: UpdateArtifactPortfolioComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables> mutation={UpdateArtifactPortfolioDocument} {...props} />
    );
    
export type UpdateArtifactPortfolioProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>
    } & TChildProps;
export function withUpdateArtifactPortfolio<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateArtifactPortfolioMutation,
  UpdateArtifactPortfolioMutationVariables,
  UpdateArtifactPortfolioProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables, UpdateArtifactPortfolioProps<TChildProps, TDataName>>(UpdateArtifactPortfolioDocument, {
      alias: 'updateArtifactPortfolio',
      ...operationOptions
    });
};

/**
 * __useUpdateArtifactPortfolioMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactPortfolioMutation, { data, loading, error }] = useUpdateArtifactPortfolioMutation({
 *   variables: {
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateArtifactPortfolioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>(UpdateArtifactPortfolioDocument, options);
      }
export type UpdateArtifactPortfolioMutationHookResult = ReturnType<typeof useUpdateArtifactPortfolioMutation>;
export type UpdateArtifactPortfolioMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactPortfolioMutation>;
export type UpdateArtifactPortfolioMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>;
export const UpdateArtifactCollectionDocument = gql`
    mutation UpdateArtifactCollection($artifactSequenceID: ID!, $name: String, $description: String) {
  updateArtifactSequence(
    input: {artifactSequenceID: $artifactSequenceID, name: $name, description: $description}
  ) {
    artifactCollection {
      id
      name
      description
    }
  }
}
    `;
export type UpdateArtifactCollectionMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>;
export type UpdateArtifactCollectionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>, 'mutation'>;

    export const UpdateArtifactCollectionComponent = (props: UpdateArtifactCollectionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables> mutation={UpdateArtifactCollectionDocument} {...props} />
    );
    
export type UpdateArtifactCollectionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>
    } & TChildProps;
export function withUpdateArtifactCollection<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateArtifactCollectionMutation,
  UpdateArtifactCollectionMutationVariables,
  UpdateArtifactCollectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables, UpdateArtifactCollectionProps<TChildProps, TDataName>>(UpdateArtifactCollectionDocument, {
      alias: 'updateArtifactCollection',
      ...operationOptions
    });
};

/**
 * __useUpdateArtifactCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactCollectionMutation, { data, loading, error }] = useUpdateArtifactCollectionMutation({
 *   variables: {
 *      artifactSequenceID: // value for 'artifactSequenceID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateArtifactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>(UpdateArtifactCollectionDocument, options);
      }
export type UpdateArtifactCollectionMutationHookResult = ReturnType<typeof useUpdateArtifactCollectionMutation>;
export type UpdateArtifactCollectionMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactCollectionMutation>;
export type UpdateArtifactCollectionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>;
export const MoveArtifactCollectionDocument = gql`
    mutation MoveArtifactCollection($artifactSequenceID: ID!, $destinationArtifactTypeName: String!) {
  moveArtifactSequence(
    input: {artifactSequenceID: $artifactSequenceID, destinationArtifactTypeName: $destinationArtifactTypeName}
  ) {
    artifactCollection {
      id
      name
      description
    }
  }
}
    `;
export type MoveArtifactCollectionMutationFn = ApolloReactCommon.MutationFunction<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>;
export type MoveArtifactCollectionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>, 'mutation'>;

    export const MoveArtifactCollectionComponent = (props: MoveArtifactCollectionComponentProps) => (
      <ApolloReactComponents.Mutation<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables> mutation={MoveArtifactCollectionDocument} {...props} />
    );
    
export type MoveArtifactCollectionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>
    } & TChildProps;
export function withMoveArtifactCollection<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MoveArtifactCollectionMutation,
  MoveArtifactCollectionMutationVariables,
  MoveArtifactCollectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables, MoveArtifactCollectionProps<TChildProps, TDataName>>(MoveArtifactCollectionDocument, {
      alias: 'moveArtifactCollection',
      ...operationOptions
    });
};

/**
 * __useMoveArtifactCollectionMutation__
 *
 * To run a mutation, you first call `useMoveArtifactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveArtifactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveArtifactCollectionMutation, { data, loading, error }] = useMoveArtifactCollectionMutation({
 *   variables: {
 *      artifactSequenceID: // value for 'artifactSequenceID'
 *      destinationArtifactTypeName: // value for 'destinationArtifactTypeName'
 *   },
 * });
 */
export function useMoveArtifactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>(MoveArtifactCollectionDocument, options);
      }
export type MoveArtifactCollectionMutationHookResult = ReturnType<typeof useMoveArtifactCollectionMutation>;
export type MoveArtifactCollectionMutationResult = ApolloReactCommon.MutationResult<MoveArtifactCollectionMutation>;
export type MoveArtifactCollectionMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>;
export const DeleteArtifactCollectionDocument = gql`
    mutation DeleteArtifactCollection($artifactSequenceID: ID!) {
  deleteArtifactSequence(input: {artifactSequenceID: $artifactSequenceID}) {
    artifactCollection {
      id
    }
  }
}
    `;
export type DeleteArtifactCollectionMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>;
export type DeleteArtifactCollectionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>, 'mutation'>;

    export const DeleteArtifactCollectionComponent = (props: DeleteArtifactCollectionComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables> mutation={DeleteArtifactCollectionDocument} {...props} />
    );
    
export type DeleteArtifactCollectionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>
    } & TChildProps;
export function withDeleteArtifactCollection<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteArtifactCollectionMutation,
  DeleteArtifactCollectionMutationVariables,
  DeleteArtifactCollectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables, DeleteArtifactCollectionProps<TChildProps, TDataName>>(DeleteArtifactCollectionDocument, {
      alias: 'deleteArtifactCollection',
      ...operationOptions
    });
};

/**
 * __useDeleteArtifactCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactCollectionMutation, { data, loading, error }] = useDeleteArtifactCollectionMutation({
 *   variables: {
 *      artifactSequenceID: // value for 'artifactSequenceID'
 *   },
 * });
 */
export function useDeleteArtifactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>(DeleteArtifactCollectionDocument, options);
      }
export type DeleteArtifactCollectionMutationHookResult = ReturnType<typeof useDeleteArtifactCollectionMutation>;
export type DeleteArtifactCollectionMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactCollectionMutation>;
export type DeleteArtifactCollectionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>;
export const DeleteArtifactPortfolioDocument = gql`
    mutation DeleteArtifactPortfolio($artifactPortfolioID: ID!) {
  deleteArtifactPortfolio(input: {artifactPortfolioID: $artifactPortfolioID}) {
    artifactCollection {
      id
    }
  }
}
    `;
export type DeleteArtifactPortfolioMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>;
export type DeleteArtifactPortfolioComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>, 'mutation'>;

    export const DeleteArtifactPortfolioComponent = (props: DeleteArtifactPortfolioComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables> mutation={DeleteArtifactPortfolioDocument} {...props} />
    );
    
export type DeleteArtifactPortfolioProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>
    } & TChildProps;
export function withDeleteArtifactPortfolio<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteArtifactPortfolioMutation,
  DeleteArtifactPortfolioMutationVariables,
  DeleteArtifactPortfolioProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables, DeleteArtifactPortfolioProps<TChildProps, TDataName>>(DeleteArtifactPortfolioDocument, {
      alias: 'deleteArtifactPortfolio',
      ...operationOptions
    });
};

/**
 * __useDeleteArtifactPortfolioMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactPortfolioMutation, { data, loading, error }] = useDeleteArtifactPortfolioMutation({
 *   variables: {
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *   },
 * });
 */
export function useDeleteArtifactPortfolioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>(DeleteArtifactPortfolioDocument, options);
      }
export type DeleteArtifactPortfolioMutationHookResult = ReturnType<typeof useDeleteArtifactPortfolioMutation>;
export type DeleteArtifactPortfolioMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactPortfolioMutation>;
export type DeleteArtifactPortfolioMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>;
export const CreateArtifactFilesDocument = gql`
    mutation CreateArtifactFiles($artifactFiles: [CreateArtifactFileSpecInput!]!, $layout: ArtifactStorageLayout = V1) {
  createArtifactFiles(
    input: {artifactFiles: $artifactFiles, storageLayout: $layout}
  ) {
    files {
      edges {
        node {
          id
          name
          displayName
          uploadUrl: url(upload: true)
          directUrl
          isReference
          sizeBytes
          updatedAt
        }
      }
    }
  }
}
    `;
export type CreateArtifactFilesMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>;
export type CreateArtifactFilesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>, 'mutation'>;

    export const CreateArtifactFilesComponent = (props: CreateArtifactFilesComponentProps) => (
      <ApolloReactComponents.Mutation<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables> mutation={CreateArtifactFilesDocument} {...props} />
    );
    
export type CreateArtifactFilesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>
    } & TChildProps;
export function withCreateArtifactFiles<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateArtifactFilesMutation,
  CreateArtifactFilesMutationVariables,
  CreateArtifactFilesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables, CreateArtifactFilesProps<TChildProps, TDataName>>(CreateArtifactFilesDocument, {
      alias: 'createArtifactFiles',
      ...operationOptions
    });
};

/**
 * __useCreateArtifactFilesMutation__
 *
 * To run a mutation, you first call `useCreateArtifactFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactFilesMutation, { data, loading, error }] = useCreateArtifactFilesMutation({
 *   variables: {
 *      artifactFiles: // value for 'artifactFiles'
 *      layout: // value for 'layout'
 *   },
 * });
 */
export function useCreateArtifactFilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>(CreateArtifactFilesDocument, options);
      }
export type CreateArtifactFilesMutationHookResult = ReturnType<typeof useCreateArtifactFilesMutation>;
export type CreateArtifactFilesMutationResult = ApolloReactCommon.MutationResult<CreateArtifactFilesMutation>;
export type CreateArtifactFilesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>;
export const CreateArtifactPortfolioDocument = gql`
    mutation CreateArtifactPortfolio($entityName: String!, $projectName: String!, $artifactTypeID: ID!, $name: String!, $description: String, $clientMutationId: String) {
  createArtifactPortfolio(
    input: {entityName: $entityName, projectName: $projectName, artifactTypeID: $artifactTypeID, name: $name, description: $description, clientMutationId: $clientMutationId}
  ) {
    artifactCollection {
      id
      name
    }
  }
}
    `;
export type CreateArtifactPortfolioMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>;
export type CreateArtifactPortfolioComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>, 'mutation'>;

    export const CreateArtifactPortfolioComponent = (props: CreateArtifactPortfolioComponentProps) => (
      <ApolloReactComponents.Mutation<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables> mutation={CreateArtifactPortfolioDocument} {...props} />
    );
    
export type CreateArtifactPortfolioProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>
    } & TChildProps;
export function withCreateArtifactPortfolio<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateArtifactPortfolioMutation,
  CreateArtifactPortfolioMutationVariables,
  CreateArtifactPortfolioProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables, CreateArtifactPortfolioProps<TChildProps, TDataName>>(CreateArtifactPortfolioDocument, {
      alias: 'createArtifactPortfolio',
      ...operationOptions
    });
};

/**
 * __useCreateArtifactPortfolioMutation__
 *
 * To run a mutation, you first call `useCreateArtifactPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactPortfolioMutation, { data, loading, error }] = useCreateArtifactPortfolioMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactTypeID: // value for 'artifactTypeID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateArtifactPortfolioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>(CreateArtifactPortfolioDocument, options);
      }
export type CreateArtifactPortfolioMutationHookResult = ReturnType<typeof useCreateArtifactPortfolioMutation>;
export type CreateArtifactPortfolioMutationResult = ApolloReactCommon.MutationResult<CreateArtifactPortfolioMutation>;
export type CreateArtifactPortfolioMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>;
export const CreateArtifactSequenceDocument = gql`
    mutation CreateArtifactSequence($entityName: String!, $projectName: String!, $artifactTypeID: ID!, $name: String!, $description: String, $clientMutationId: String) {
  createArtifactSequence(
    input: {entityName: $entityName, projectName: $projectName, artifactTypeID: $artifactTypeID, name: $name, description: $description, clientMutationId: $clientMutationId}
  ) {
    artifactCollection {
      id
      name
    }
  }
}
    `;
export type CreateArtifactSequenceMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>;
export type CreateArtifactSequenceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>, 'mutation'>;

    export const CreateArtifactSequenceComponent = (props: CreateArtifactSequenceComponentProps) => (
      <ApolloReactComponents.Mutation<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables> mutation={CreateArtifactSequenceDocument} {...props} />
    );
    
export type CreateArtifactSequenceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>
    } & TChildProps;
export function withCreateArtifactSequence<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateArtifactSequenceMutation,
  CreateArtifactSequenceMutationVariables,
  CreateArtifactSequenceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables, CreateArtifactSequenceProps<TChildProps, TDataName>>(CreateArtifactSequenceDocument, {
      alias: 'createArtifactSequence',
      ...operationOptions
    });
};

/**
 * __useCreateArtifactSequenceMutation__
 *
 * To run a mutation, you first call `useCreateArtifactSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactSequenceMutation, { data, loading, error }] = useCreateArtifactSequenceMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactTypeID: // value for 'artifactTypeID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateArtifactSequenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>(CreateArtifactSequenceDocument, options);
      }
export type CreateArtifactSequenceMutationHookResult = ReturnType<typeof useCreateArtifactSequenceMutation>;
export type CreateArtifactSequenceMutationResult = ApolloReactCommon.MutationResult<CreateArtifactSequenceMutation>;
export type CreateArtifactSequenceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>;
export const UnlinkArtifactDocument = gql`
    mutation UnlinkArtifact($artifactID: ID!, $artifactPortfolioID: ID!) {
  unlinkArtifact(
    input: {artifactID: $artifactID, artifactPortfolioID: $artifactPortfolioID}
  ) {
    artifactID
    success
    clientMutationId
  }
}
    `;
export type UnlinkArtifactMutationFn = ApolloReactCommon.MutationFunction<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>;
export type UnlinkArtifactComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>, 'mutation'>;

    export const UnlinkArtifactComponent = (props: UnlinkArtifactComponentProps) => (
      <ApolloReactComponents.Mutation<UnlinkArtifactMutation, UnlinkArtifactMutationVariables> mutation={UnlinkArtifactDocument} {...props} />
    );
    
export type UnlinkArtifactProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>
    } & TChildProps;
export function withUnlinkArtifact<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnlinkArtifactMutation,
  UnlinkArtifactMutationVariables,
  UnlinkArtifactProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnlinkArtifactMutation, UnlinkArtifactMutationVariables, UnlinkArtifactProps<TChildProps, TDataName>>(UnlinkArtifactDocument, {
      alias: 'unlinkArtifact',
      ...operationOptions
    });
};

/**
 * __useUnlinkArtifactMutation__
 *
 * To run a mutation, you first call `useUnlinkArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkArtifactMutation, { data, loading, error }] = useUnlinkArtifactMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *   },
 * });
 */
export function useUnlinkArtifactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>(UnlinkArtifactDocument, options);
      }
export type UnlinkArtifactMutationHookResult = ReturnType<typeof useUnlinkArtifactMutation>;
export type UnlinkArtifactMutationResult = ApolloReactCommon.MutationResult<UnlinkArtifactMutation>;
export type UnlinkArtifactMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>;
export const AddAliasesDocument = gql`
    mutation AddAliases($artifactID: ID!, $aliases: [ArtifactCollectionAliasInput!]!, $clientMutationId: String) {
  addAliases(
    input: {artifactID: $artifactID, aliases: $aliases, clientMutationId: $clientMutationId}
  ) {
    success
  }
}
    `;
export type AddAliasesMutationFn = ApolloReactCommon.MutationFunction<AddAliasesMutation, AddAliasesMutationVariables>;
export type AddAliasesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddAliasesMutation, AddAliasesMutationVariables>, 'mutation'>;

    export const AddAliasesComponent = (props: AddAliasesComponentProps) => (
      <ApolloReactComponents.Mutation<AddAliasesMutation, AddAliasesMutationVariables> mutation={AddAliasesDocument} {...props} />
    );
    
export type AddAliasesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddAliasesMutation, AddAliasesMutationVariables>
    } & TChildProps;
export function withAddAliases<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddAliasesMutation,
  AddAliasesMutationVariables,
  AddAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddAliasesMutation, AddAliasesMutationVariables, AddAliasesProps<TChildProps, TDataName>>(AddAliasesDocument, {
      alias: 'addAliases',
      ...operationOptions
    });
};

/**
 * __useAddAliasesMutation__
 *
 * To run a mutation, you first call `useAddAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAliasesMutation, { data, loading, error }] = useAddAliasesMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      aliases: // value for 'aliases'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useAddAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAliasesMutation, AddAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddAliasesMutation, AddAliasesMutationVariables>(AddAliasesDocument, options);
      }
export type AddAliasesMutationHookResult = ReturnType<typeof useAddAliasesMutation>;
export type AddAliasesMutationResult = ApolloReactCommon.MutationResult<AddAliasesMutation>;
export type AddAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAliasesMutation, AddAliasesMutationVariables>;
export const DeleteAliasesDocument = gql`
    mutation DeleteAliases($artifactID: ID!, $aliases: [ArtifactCollectionAliasInput!]!, $clientMutationId: String) {
  deleteAliases(
    input: {artifactID: $artifactID, aliases: $aliases, clientMutationId: $clientMutationId}
  ) {
    success
  }
}
    `;
export type DeleteAliasesMutationFn = ApolloReactCommon.MutationFunction<DeleteAliasesMutation, DeleteAliasesMutationVariables>;
export type DeleteAliasesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteAliasesMutation, DeleteAliasesMutationVariables>, 'mutation'>;

    export const DeleteAliasesComponent = (props: DeleteAliasesComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteAliasesMutation, DeleteAliasesMutationVariables> mutation={DeleteAliasesDocument} {...props} />
    );
    
export type DeleteAliasesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteAliasesMutation, DeleteAliasesMutationVariables>
    } & TChildProps;
export function withDeleteAliases<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteAliasesMutation,
  DeleteAliasesMutationVariables,
  DeleteAliasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteAliasesMutation, DeleteAliasesMutationVariables, DeleteAliasesProps<TChildProps, TDataName>>(DeleteAliasesDocument, {
      alias: 'deleteAliases',
      ...operationOptions
    });
};

/**
 * __useDeleteAliasesMutation__
 *
 * To run a mutation, you first call `useDeleteAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAliasesMutation, { data, loading, error }] = useDeleteAliasesMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      aliases: // value for 'aliases'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useDeleteAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAliasesMutation, DeleteAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAliasesMutation, DeleteAliasesMutationVariables>(DeleteAliasesDocument, options);
      }
export type DeleteAliasesMutationHookResult = ReturnType<typeof useDeleteAliasesMutation>;
export type DeleteAliasesMutationResult = ApolloReactCommon.MutationResult<DeleteAliasesMutation>;
export type DeleteAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAliasesMutation, DeleteAliasesMutationVariables>;
export const UpdateArtifactEntityTtlDocument = gql`
    mutation UpdateArtifactEntityTTL($entityName: String!, $ttlDurationSeconds: Int64!) {
  updateArtifactEntityTTL(
    input: {entityName: $entityName, ttlDurationSeconds: $ttlDurationSeconds}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateArtifactEntityTtlMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>;
export type UpdateArtifactEntityTtlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>, 'mutation'>;

    export const UpdateArtifactEntityTtlComponent = (props: UpdateArtifactEntityTtlComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables> mutation={UpdateArtifactEntityTtlDocument} {...props} />
    );
    
export type UpdateArtifactEntityTtlProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>
    } & TChildProps;
export function withUpdateArtifactEntityTtl<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateArtifactEntityTtlMutation,
  UpdateArtifactEntityTtlMutationVariables,
  UpdateArtifactEntityTtlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables, UpdateArtifactEntityTtlProps<TChildProps, TDataName>>(UpdateArtifactEntityTtlDocument, {
      alias: 'updateArtifactEntityTtl',
      ...operationOptions
    });
};

/**
 * __useUpdateArtifactEntityTtlMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactEntityTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactEntityTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactEntityTtlMutation, { data, loading, error }] = useUpdateArtifactEntityTtlMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      ttlDurationSeconds: // value for 'ttlDurationSeconds'
 *   },
 * });
 */
export function useUpdateArtifactEntityTtlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>(UpdateArtifactEntityTtlDocument, options);
      }
export type UpdateArtifactEntityTtlMutationHookResult = ReturnType<typeof useUpdateArtifactEntityTtlMutation>;
export type UpdateArtifactEntityTtlMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactEntityTtlMutation>;
export type UpdateArtifactEntityTtlMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>;
export const DeleteArtifactEntityTtlDocument = gql`
    mutation DeleteArtifactEntityTTL($entityName: String!) {
  deleteArtifactEntityTTL(input: {entityName: $entityName}) {
    clientMutationId
  }
}
    `;
export type DeleteArtifactEntityTtlMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>;
export type DeleteArtifactEntityTtlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>, 'mutation'>;

    export const DeleteArtifactEntityTtlComponent = (props: DeleteArtifactEntityTtlComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables> mutation={DeleteArtifactEntityTtlDocument} {...props} />
    );
    
export type DeleteArtifactEntityTtlProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>
    } & TChildProps;
export function withDeleteArtifactEntityTtl<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteArtifactEntityTtlMutation,
  DeleteArtifactEntityTtlMutationVariables,
  DeleteArtifactEntityTtlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables, DeleteArtifactEntityTtlProps<TChildProps, TDataName>>(DeleteArtifactEntityTtlDocument, {
      alias: 'deleteArtifactEntityTtl',
      ...operationOptions
    });
};

/**
 * __useDeleteArtifactEntityTtlMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactEntityTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactEntityTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactEntityTtlMutation, { data, loading, error }] = useDeleteArtifactEntityTtlMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useDeleteArtifactEntityTtlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>(DeleteArtifactEntityTtlDocument, options);
      }
export type DeleteArtifactEntityTtlMutationHookResult = ReturnType<typeof useDeleteArtifactEntityTtlMutation>;
export type DeleteArtifactEntityTtlMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactEntityTtlMutation>;
export type DeleteArtifactEntityTtlMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>;
export const ArtifactRedirectDocument = gql`
    query ArtifactRedirect($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactCollectionName: String!, $membershipIdentifier: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactTypes {
      edges {
        node {
          id
          name
          artifactCollections(first: 1) {
            edges {
              node {
                id
                name
                artifactMemberships(first: 1) {
                  edges {
                    node {
                      id
                      versionIndex
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    artifactType(name: $artifactTypeName) {
      id
      name
      artifactCollections(first: 1) {
        edges {
          node {
            id
            name
            artifactMemberships(first: 1) {
              edges {
                node {
                  id
                  versionIndex
                }
              }
            }
          }
        }
      }
      artifactCollection(name: $artifactCollectionName) {
        id
        name
        artifactMemberships(first: 1) {
          edges {
            node {
              id
              versionIndex
            }
          }
        }
        artifactMembership(aliasName: $membershipIdentifier) {
          id
          versionIndex
        }
      }
    }
  }
}
    `;
export type ArtifactRedirectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>, 'query'> & ({ variables: ArtifactRedirectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactRedirectComponent = (props: ArtifactRedirectComponentProps) => (
      <ApolloReactComponents.Query<ArtifactRedirectQuery, ArtifactRedirectQueryVariables> query={ArtifactRedirectDocument} {...props} />
    );
    
export type ArtifactRedirectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>
    } & TChildProps;
export function withArtifactRedirect<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactRedirectQuery,
  ArtifactRedirectQueryVariables,
  ArtifactRedirectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactRedirectQuery, ArtifactRedirectQueryVariables, ArtifactRedirectProps<TChildProps, TDataName>>(ArtifactRedirectDocument, {
      alias: 'artifactRedirect',
      ...operationOptions
    });
};

/**
 * __useArtifactRedirectQuery__
 *
 * To run a query within a React component, call `useArtifactRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactRedirectQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *   },
 * });
 */
export function useArtifactRedirectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables> & ({ variables: ArtifactRedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>(ArtifactRedirectDocument, options);
      }
export function useArtifactRedirectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>(ArtifactRedirectDocument, options);
        }
// @ts-ignore
export function useArtifactRedirectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>;
export function useArtifactRedirectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactRedirectQuery | undefined, ArtifactRedirectQueryVariables>;
export function useArtifactRedirectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>(ArtifactRedirectDocument, options);
        }
export type ArtifactRedirectQueryHookResult = ReturnType<typeof useArtifactRedirectQuery>;
export type ArtifactRedirectLazyQueryHookResult = ReturnType<typeof useArtifactRedirectLazyQuery>;
export type ArtifactRedirectSuspenseQueryHookResult = ReturnType<typeof useArtifactRedirectSuspenseQuery>;
export type ArtifactRedirectQueryResult = ApolloReactCommon.QueryResult<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>;
export const ArtifactTypeDocument = gql`
    query ArtifactType($projectName: String!, $entityName: String!, $artifactTypeName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      name
      description
      artifactSequences(order: "-createdAt") {
        edges {
          node {
            id
            name
            description
            createdAt
            artifacts {
              totalCount
            }
          }
        }
      }
    }
  }
}
    `;
export type ArtifactTypeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>, 'query'> & ({ variables: ArtifactTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactTypeComponent = (props: ArtifactTypeComponentProps) => (
      <ApolloReactComponents.Query<ArtifactTypeQuery, ArtifactTypeQueryVariables> query={ArtifactTypeDocument} {...props} />
    );
    
export type ArtifactTypeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactTypeQuery, ArtifactTypeQueryVariables>
    } & TChildProps;
export function withArtifactType<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactTypeQuery,
  ArtifactTypeQueryVariables,
  ArtifactTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactTypeQuery, ArtifactTypeQueryVariables, ArtifactTypeProps<TChildProps, TDataName>>(ArtifactTypeDocument, {
      alias: 'artifactType',
      ...operationOptions
    });
};

/**
 * __useArtifactTypeQuery__
 *
 * To run a query within a React component, call `useArtifactTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactTypeQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *   },
 * });
 */
export function useArtifactTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables> & ({ variables: ArtifactTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactTypeQuery, ArtifactTypeQueryVariables>(ArtifactTypeDocument, options);
      }
export function useArtifactTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactTypeQuery, ArtifactTypeQueryVariables>(ArtifactTypeDocument, options);
        }
// @ts-ignore
export function useArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTypeQuery, ArtifactTypeQueryVariables>;
export function useArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTypeQuery | undefined, ArtifactTypeQueryVariables>;
export function useArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactTypeQuery, ArtifactTypeQueryVariables>(ArtifactTypeDocument, options);
        }
export type ArtifactTypeQueryHookResult = ReturnType<typeof useArtifactTypeQuery>;
export type ArtifactTypeLazyQueryHookResult = ReturnType<typeof useArtifactTypeLazyQuery>;
export type ArtifactTypeSuspenseQueryHookResult = ReturnType<typeof useArtifactTypeSuspenseQuery>;
export type ArtifactTypeQueryResult = ApolloReactCommon.QueryResult<ArtifactTypeQuery, ArtifactTypeQueryVariables>;
export const ArtifactTypesDocument = gql`
    query ArtifactTypes($entityName: String, $projectName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactTypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;
export type ArtifactTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>, 'query'>;

    export const ArtifactTypesComponent = (props: ArtifactTypesComponentProps) => (
      <ApolloReactComponents.Query<ArtifactTypesQuery, ArtifactTypesQueryVariables> query={ArtifactTypesDocument} {...props} />
    );
    
export type ArtifactTypesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactTypesQuery, ArtifactTypesQueryVariables>
    } & TChildProps;
export function withArtifactTypes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactTypesQuery,
  ArtifactTypesQueryVariables,
  ArtifactTypesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactTypesQuery, ArtifactTypesQueryVariables, ArtifactTypesProps<TChildProps, TDataName>>(ArtifactTypesDocument, {
      alias: 'artifactTypes',
      ...operationOptions
    });
};

/**
 * __useArtifactTypesQuery__
 *
 * To run a query within a React component, call `useArtifactTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactTypesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useArtifactTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactTypesQuery, ArtifactTypesQueryVariables>(ArtifactTypesDocument, options);
      }
export function useArtifactTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactTypesQuery, ArtifactTypesQueryVariables>(ArtifactTypesDocument, options);
        }
// @ts-ignore
export function useArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTypesQuery, ArtifactTypesQueryVariables>;
export function useArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTypesQuery | undefined, ArtifactTypesQueryVariables>;
export function useArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactTypesQuery, ArtifactTypesQueryVariables>(ArtifactTypesDocument, options);
        }
export type ArtifactTypesQueryHookResult = ReturnType<typeof useArtifactTypesQuery>;
export type ArtifactTypesLazyQueryHookResult = ReturnType<typeof useArtifactTypesLazyQuery>;
export type ArtifactTypesSuspenseQueryHookResult = ReturnType<typeof useArtifactTypesSuspenseQuery>;
export type ArtifactTypesQueryResult = ApolloReactCommon.QueryResult<ArtifactTypesQuery, ArtifactTypesQueryVariables>;
export const ViewerDefaultResourceConfigsDocument = gql`
    query ViewerDefaultResourceConfigs {
  viewer {
    id
    teams {
      edges {
        node {
          id
          defaultResourceConfigs {
            edges {
              node {
                id
                createdAt
                updatedAt
                scope {
                  __typename
                  Type
                  ID
                }
                resource
                config
                templateVariables {
                  name
                  description
                  schema
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ViewerDefaultResourceConfigsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>, 'query'>;

    export const ViewerDefaultResourceConfigsComponent = (props: ViewerDefaultResourceConfigsComponentProps) => (
      <ApolloReactComponents.Query<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables> query={ViewerDefaultResourceConfigsDocument} {...props} />
    );
    
export type ViewerDefaultResourceConfigsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>
    } & TChildProps;
export function withViewerDefaultResourceConfigs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerDefaultResourceConfigsQuery,
  ViewerDefaultResourceConfigsQueryVariables,
  ViewerDefaultResourceConfigsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables, ViewerDefaultResourceConfigsProps<TChildProps, TDataName>>(ViewerDefaultResourceConfigsDocument, {
      alias: 'viewerDefaultResourceConfigs',
      ...operationOptions
    });
};

/**
 * __useViewerDefaultResourceConfigsQuery__
 *
 * To run a query within a React component, call `useViewerDefaultResourceConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerDefaultResourceConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerDefaultResourceConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerDefaultResourceConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>(ViewerDefaultResourceConfigsDocument, options);
      }
export function useViewerDefaultResourceConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>(ViewerDefaultResourceConfigsDocument, options);
        }
// @ts-ignore
export function useViewerDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>;
export function useViewerDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDefaultResourceConfigsQuery | undefined, ViewerDefaultResourceConfigsQueryVariables>;
export function useViewerDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>(ViewerDefaultResourceConfigsDocument, options);
        }
export type ViewerDefaultResourceConfigsQueryHookResult = ReturnType<typeof useViewerDefaultResourceConfigsQuery>;
export type ViewerDefaultResourceConfigsLazyQueryHookResult = ReturnType<typeof useViewerDefaultResourceConfigsLazyQuery>;
export type ViewerDefaultResourceConfigsSuspenseQueryHookResult = ReturnType<typeof useViewerDefaultResourceConfigsSuspenseQuery>;
export type ViewerDefaultResourceConfigsQueryResult = ApolloReactCommon.QueryResult<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>;
export const EntityDefaultResourceConfigsDocument = gql`
    query EntityDefaultResourceConfigs($entityName: String!) {
  entity(name: $entityName) {
    id
    defaultResourceConfigs {
      edges {
        node {
          id
          createdAt
          updatedAt
          scope {
            __typename
            Type
            ID
          }
          resource
          config
          templateVariables {
            name
            description
            schema
          }
        }
      }
    }
  }
}
    `;
export type EntityDefaultResourceConfigsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>, 'query'> & ({ variables: EntityDefaultResourceConfigsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityDefaultResourceConfigsComponent = (props: EntityDefaultResourceConfigsComponentProps) => (
      <ApolloReactComponents.Query<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables> query={EntityDefaultResourceConfigsDocument} {...props} />
    );
    
export type EntityDefaultResourceConfigsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>
    } & TChildProps;
export function withEntityDefaultResourceConfigs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityDefaultResourceConfigsQuery,
  EntityDefaultResourceConfigsQueryVariables,
  EntityDefaultResourceConfigsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables, EntityDefaultResourceConfigsProps<TChildProps, TDataName>>(EntityDefaultResourceConfigsDocument, {
      alias: 'entityDefaultResourceConfigs',
      ...operationOptions
    });
};

/**
 * __useEntityDefaultResourceConfigsQuery__
 *
 * To run a query within a React component, call `useEntityDefaultResourceConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDefaultResourceConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDefaultResourceConfigsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityDefaultResourceConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables> & ({ variables: EntityDefaultResourceConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>(EntityDefaultResourceConfigsDocument, options);
      }
export function useEntityDefaultResourceConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>(EntityDefaultResourceConfigsDocument, options);
        }
// @ts-ignore
export function useEntityDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>;
export function useEntityDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDefaultResourceConfigsQuery | undefined, EntityDefaultResourceConfigsQueryVariables>;
export function useEntityDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>(EntityDefaultResourceConfigsDocument, options);
        }
export type EntityDefaultResourceConfigsQueryHookResult = ReturnType<typeof useEntityDefaultResourceConfigsQuery>;
export type EntityDefaultResourceConfigsLazyQueryHookResult = ReturnType<typeof useEntityDefaultResourceConfigsLazyQuery>;
export type EntityDefaultResourceConfigsSuspenseQueryHookResult = ReturnType<typeof useEntityDefaultResourceConfigsSuspenseQuery>;
export type EntityDefaultResourceConfigsQueryResult = ApolloReactCommon.QueryResult<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>;
export const ProjectDefaultResourceConfigsDocument = gql`
    query ProjectDefaultResourceConfigs($projectName: String!) {
  project(name: $projectName) {
    id
    defaultResourceConfigs {
      edges {
        node {
          id
          createdAt
          updatedAt
          scope {
            Type
            ID
          }
          resource
          config
          templateVariables {
            name
            description
            schema
          }
        }
      }
    }
  }
}
    `;
export type ProjectDefaultResourceConfigsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>, 'query'> & ({ variables: ProjectDefaultResourceConfigsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectDefaultResourceConfigsComponent = (props: ProjectDefaultResourceConfigsComponentProps) => (
      <ApolloReactComponents.Query<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables> query={ProjectDefaultResourceConfigsDocument} {...props} />
    );
    
export type ProjectDefaultResourceConfigsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>
    } & TChildProps;
export function withProjectDefaultResourceConfigs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectDefaultResourceConfigsQuery,
  ProjectDefaultResourceConfigsQueryVariables,
  ProjectDefaultResourceConfigsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables, ProjectDefaultResourceConfigsProps<TChildProps, TDataName>>(ProjectDefaultResourceConfigsDocument, {
      alias: 'projectDefaultResourceConfigs',
      ...operationOptions
    });
};

/**
 * __useProjectDefaultResourceConfigsQuery__
 *
 * To run a query within a React component, call `useProjectDefaultResourceConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDefaultResourceConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDefaultResourceConfigsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectDefaultResourceConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables> & ({ variables: ProjectDefaultResourceConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>(ProjectDefaultResourceConfigsDocument, options);
      }
export function useProjectDefaultResourceConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>(ProjectDefaultResourceConfigsDocument, options);
        }
// @ts-ignore
export function useProjectDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>;
export function useProjectDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectDefaultResourceConfigsQuery | undefined, ProjectDefaultResourceConfigsQueryVariables>;
export function useProjectDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>(ProjectDefaultResourceConfigsDocument, options);
        }
export type ProjectDefaultResourceConfigsQueryHookResult = ReturnType<typeof useProjectDefaultResourceConfigsQuery>;
export type ProjectDefaultResourceConfigsLazyQueryHookResult = ReturnType<typeof useProjectDefaultResourceConfigsLazyQuery>;
export type ProjectDefaultResourceConfigsSuspenseQueryHookResult = ReturnType<typeof useProjectDefaultResourceConfigsSuspenseQuery>;
export type ProjectDefaultResourceConfigsQueryResult = ApolloReactCommon.QueryResult<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>;
export const CreateDefaultResourceConfigDocument = gql`
    mutation CreateDefaultResourceConfig($entityName: String!, $projectName: String, $resource: String!, $config: JSONString!, $templateVariables: JSONString!) {
  createDefaultResourceConfig(
    input: {entityName: $entityName, projectName: $projectName, resource: $resource, config: $config, templateVariables: $templateVariables}
  ) {
    defaultResourceConfigID
    schemaValidationErrors
    success
  }
}
    `;
export type CreateDefaultResourceConfigMutationFn = ApolloReactCommon.MutationFunction<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>;
export type CreateDefaultResourceConfigComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>, 'mutation'>;

    export const CreateDefaultResourceConfigComponent = (props: CreateDefaultResourceConfigComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables> mutation={CreateDefaultResourceConfigDocument} {...props} />
    );
    
export type CreateDefaultResourceConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>
    } & TChildProps;
export function withCreateDefaultResourceConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDefaultResourceConfigMutation,
  CreateDefaultResourceConfigMutationVariables,
  CreateDefaultResourceConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables, CreateDefaultResourceConfigProps<TChildProps, TDataName>>(CreateDefaultResourceConfigDocument, {
      alias: 'createDefaultResourceConfig',
      ...operationOptions
    });
};

/**
 * __useCreateDefaultResourceConfigMutation__
 *
 * To run a mutation, you first call `useCreateDefaultResourceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefaultResourceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefaultResourceConfigMutation, { data, loading, error }] = useCreateDefaultResourceConfigMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      resource: // value for 'resource'
 *      config: // value for 'config'
 *      templateVariables: // value for 'templateVariables'
 *   },
 * });
 */
export function useCreateDefaultResourceConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>(CreateDefaultResourceConfigDocument, options);
      }
export type CreateDefaultResourceConfigMutationHookResult = ReturnType<typeof useCreateDefaultResourceConfigMutation>;
export type CreateDefaultResourceConfigMutationResult = ApolloReactCommon.MutationResult<CreateDefaultResourceConfigMutation>;
export type CreateDefaultResourceConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>;
export const DeleteDefaultResourceConfigDocument = gql`
    mutation DeleteDefaultResourceConfig($defaultResourceConfigIDs: [ID!]!) {
  deleteDefaultResourceConfigs(
    input: {defaultResourceConfigIDs: $defaultResourceConfigIDs}
  ) {
    numAffected
    success
  }
}
    `;
export type DeleteDefaultResourceConfigMutationFn = ApolloReactCommon.MutationFunction<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>;
export type DeleteDefaultResourceConfigComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>, 'mutation'>;

    export const DeleteDefaultResourceConfigComponent = (props: DeleteDefaultResourceConfigComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables> mutation={DeleteDefaultResourceConfigDocument} {...props} />
    );
    
export type DeleteDefaultResourceConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>
    } & TChildProps;
export function withDeleteDefaultResourceConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteDefaultResourceConfigMutation,
  DeleteDefaultResourceConfigMutationVariables,
  DeleteDefaultResourceConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables, DeleteDefaultResourceConfigProps<TChildProps, TDataName>>(DeleteDefaultResourceConfigDocument, {
      alias: 'deleteDefaultResourceConfig',
      ...operationOptions
    });
};

/**
 * __useDeleteDefaultResourceConfigMutation__
 *
 * To run a mutation, you first call `useDeleteDefaultResourceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDefaultResourceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDefaultResourceConfigMutation, { data, loading, error }] = useDeleteDefaultResourceConfigMutation({
 *   variables: {
 *      defaultResourceConfigIDs: // value for 'defaultResourceConfigIDs'
 *   },
 * });
 */
export function useDeleteDefaultResourceConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>(DeleteDefaultResourceConfigDocument, options);
      }
export type DeleteDefaultResourceConfigMutationHookResult = ReturnType<typeof useDeleteDefaultResourceConfigMutation>;
export type DeleteDefaultResourceConfigMutationResult = ApolloReactCommon.MutationResult<DeleteDefaultResourceConfigMutation>;
export type DeleteDefaultResourceConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>;
export const UpdateDefaultResourceConfigDocument = gql`
    mutation UpdateDefaultResourceConfig($defaultResourceConfigID: ID!, $resource: String, $config: JSONString!, $entityName: String, $projectName: String, $templateVariables: JSONString!) {
  updateDefaultResourceConfig(
    input: {defaultResourceConfigID: $defaultResourceConfigID, resource: $resource, config: $config, entityName: $entityName, projectName: $projectName, templateVariables: $templateVariables}
  ) {
    schemaValidationErrors
    success
  }
}
    `;
export type UpdateDefaultResourceConfigMutationFn = ApolloReactCommon.MutationFunction<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>;
export type UpdateDefaultResourceConfigComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>, 'mutation'>;

    export const UpdateDefaultResourceConfigComponent = (props: UpdateDefaultResourceConfigComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables> mutation={UpdateDefaultResourceConfigDocument} {...props} />
    );
    
export type UpdateDefaultResourceConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>
    } & TChildProps;
export function withUpdateDefaultResourceConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateDefaultResourceConfigMutation,
  UpdateDefaultResourceConfigMutationVariables,
  UpdateDefaultResourceConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables, UpdateDefaultResourceConfigProps<TChildProps, TDataName>>(UpdateDefaultResourceConfigDocument, {
      alias: 'updateDefaultResourceConfig',
      ...operationOptions
    });
};

/**
 * __useUpdateDefaultResourceConfigMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultResourceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultResourceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultResourceConfigMutation, { data, loading, error }] = useUpdateDefaultResourceConfigMutation({
 *   variables: {
 *      defaultResourceConfigID: // value for 'defaultResourceConfigID'
 *      resource: // value for 'resource'
 *      config: // value for 'config'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      templateVariables: // value for 'templateVariables'
 *   },
 * });
 */
export function useUpdateDefaultResourceConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>(UpdateDefaultResourceConfigDocument, options);
      }
export type UpdateDefaultResourceConfigMutationHookResult = ReturnType<typeof useUpdateDefaultResourceConfigMutation>;
export type UpdateDefaultResourceConfigMutationResult = ApolloReactCommon.MutationResult<UpdateDefaultResourceConfigMutation>;
export type UpdateDefaultResourceConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>;
export const DefaultResourceConfigDocument = gql`
    query DefaultResourceConfig($entityName: String!, $defaultResourceConfigID: ID!) {
  entity(name: $entityName) {
    id
    defaultResourceConfig(id: $defaultResourceConfigID) {
      id
      config
      resource
      templateVariables {
        name
        description
        schema
      }
    }
  }
}
    `;
export type DefaultResourceConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>, 'query'> & ({ variables: DefaultResourceConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DefaultResourceConfigComponent = (props: DefaultResourceConfigComponentProps) => (
      <ApolloReactComponents.Query<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables> query={DefaultResourceConfigDocument} {...props} />
    );
    
export type DefaultResourceConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>
    } & TChildProps;
export function withDefaultResourceConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DefaultResourceConfigQuery,
  DefaultResourceConfigQueryVariables,
  DefaultResourceConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables, DefaultResourceConfigProps<TChildProps, TDataName>>(DefaultResourceConfigDocument, {
      alias: 'defaultResourceConfig',
      ...operationOptions
    });
};

/**
 * __useDefaultResourceConfigQuery__
 *
 * To run a query within a React component, call `useDefaultResourceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultResourceConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultResourceConfigQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      defaultResourceConfigID: // value for 'defaultResourceConfigID'
 *   },
 * });
 */
export function useDefaultResourceConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables> & ({ variables: DefaultResourceConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>(DefaultResourceConfigDocument, options);
      }
export function useDefaultResourceConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>(DefaultResourceConfigDocument, options);
        }
// @ts-ignore
export function useDefaultResourceConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>;
export function useDefaultResourceConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefaultResourceConfigQuery | undefined, DefaultResourceConfigQueryVariables>;
export function useDefaultResourceConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>(DefaultResourceConfigDocument, options);
        }
export type DefaultResourceConfigQueryHookResult = ReturnType<typeof useDefaultResourceConfigQuery>;
export type DefaultResourceConfigLazyQueryHookResult = ReturnType<typeof useDefaultResourceConfigLazyQuery>;
export type DefaultResourceConfigSuspenseQueryHookResult = ReturnType<typeof useDefaultResourceConfigSuspenseQuery>;
export type DefaultResourceConfigQueryResult = ApolloReactCommon.QueryResult<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>;
export const EntityArtifactsDocument = gql`
    query EntityArtifacts($entityName: String!) {
  entity(name: $entityName) {
    id
    projects {
      edges {
        node {
          id
          name
          artifactTypes {
            edges {
              node {
                id
                name
                artifactSequences(order: "-createdAt") {
                  edges {
                    node {
                      id
                      name
                      createdAt
                      artifacts(first: 100) {
                        edges {
                          node {
                            id
                            versionIndex
                            aliases {
                              id
                              alias
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type EntityArtifactsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>, 'query'> & ({ variables: EntityArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityArtifactsComponent = (props: EntityArtifactsComponentProps) => (
      <ApolloReactComponents.Query<EntityArtifactsQuery, EntityArtifactsQueryVariables> query={EntityArtifactsDocument} {...props} />
    );
    
export type EntityArtifactsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityArtifactsQuery, EntityArtifactsQueryVariables>
    } & TChildProps;
export function withEntityArtifacts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityArtifactsQuery,
  EntityArtifactsQueryVariables,
  EntityArtifactsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityArtifactsQuery, EntityArtifactsQueryVariables, EntityArtifactsProps<TChildProps, TDataName>>(EntityArtifactsDocument, {
      alias: 'entityArtifacts',
      ...operationOptions
    });
};

/**
 * __useEntityArtifactsQuery__
 *
 * To run a query within a React component, call `useEntityArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityArtifactsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables> & ({ variables: EntityArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityArtifactsQuery, EntityArtifactsQueryVariables>(EntityArtifactsDocument, options);
      }
export function useEntityArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityArtifactsQuery, EntityArtifactsQueryVariables>(EntityArtifactsDocument, options);
        }
// @ts-ignore
export function useEntityArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityArtifactsQuery, EntityArtifactsQueryVariables>;
export function useEntityArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityArtifactsQuery | undefined, EntityArtifactsQueryVariables>;
export function useEntityArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityArtifactsQuery, EntityArtifactsQueryVariables>(EntityArtifactsDocument, options);
        }
export type EntityArtifactsQueryHookResult = ReturnType<typeof useEntityArtifactsQuery>;
export type EntityArtifactsLazyQueryHookResult = ReturnType<typeof useEntityArtifactsLazyQuery>;
export type EntityArtifactsSuspenseQueryHookResult = ReturnType<typeof useEntityArtifactsSuspenseQuery>;
export type EntityArtifactsQueryResult = ApolloReactCommon.QueryResult<EntityArtifactsQuery, EntityArtifactsQueryVariables>;
export const PaidEntityDocument = gql`
    query PaidEntity($entityName: String!) {
  entity(name: $entityName) {
    id
    name
    isPaid
  }
}
    `;
export type PaidEntityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaidEntityQuery, PaidEntityQueryVariables>, 'query'> & ({ variables: PaidEntityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PaidEntityComponent = (props: PaidEntityComponentProps) => (
      <ApolloReactComponents.Query<PaidEntityQuery, PaidEntityQueryVariables> query={PaidEntityDocument} {...props} />
    );
    
export type PaidEntityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PaidEntityQuery, PaidEntityQueryVariables>
    } & TChildProps;
export function withPaidEntity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PaidEntityQuery,
  PaidEntityQueryVariables,
  PaidEntityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PaidEntityQuery, PaidEntityQueryVariables, PaidEntityProps<TChildProps, TDataName>>(PaidEntityDocument, {
      alias: 'paidEntity',
      ...operationOptions
    });
};

/**
 * __usePaidEntityQuery__
 *
 * To run a query within a React component, call `usePaidEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaidEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaidEntityQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function usePaidEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables> & ({ variables: PaidEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaidEntityQuery, PaidEntityQueryVariables>(PaidEntityDocument, options);
      }
export function usePaidEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaidEntityQuery, PaidEntityQueryVariables>(PaidEntityDocument, options);
        }
// @ts-ignore
export function usePaidEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaidEntityQuery, PaidEntityQueryVariables>;
export function usePaidEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaidEntityQuery | undefined, PaidEntityQueryVariables>;
export function usePaidEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaidEntityQuery, PaidEntityQueryVariables>(PaidEntityDocument, options);
        }
export type PaidEntityQueryHookResult = ReturnType<typeof usePaidEntityQuery>;
export type PaidEntityLazyQueryHookResult = ReturnType<typeof usePaidEntityLazyQuery>;
export type PaidEntitySuspenseQueryHookResult = ReturnType<typeof usePaidEntitySuspenseQuery>;
export type PaidEntityQueryResult = ApolloReactCommon.QueryResult<PaidEntityQuery, PaidEntityQueryVariables>;
export const EntityProfileDocument = gql`
    query EntityProfile($entityName: String!) {
  entity(name: $entityName) {
    id
    profileView {
      id
      spec
      updatedAt
      updatedBy {
        id
        username
      }
    }
  }
}
    `;
export type EntityProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityProfileQuery, EntityProfileQueryVariables>, 'query'> & ({ variables: EntityProfileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityProfileComponent = (props: EntityProfileComponentProps) => (
      <ApolloReactComponents.Query<EntityProfileQuery, EntityProfileQueryVariables> query={EntityProfileDocument} {...props} />
    );
    
export type EntityProfileProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityProfileQuery, EntityProfileQueryVariables>
    } & TChildProps;
export function withEntityProfile<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityProfileQuery,
  EntityProfileQueryVariables,
  EntityProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityProfileQuery, EntityProfileQueryVariables, EntityProfileProps<TChildProps, TDataName>>(EntityProfileDocument, {
      alias: 'entityProfile',
      ...operationOptions
    });
};

/**
 * __useEntityProfileQuery__
 *
 * To run a query within a React component, call `useEntityProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityProfileQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables> & ({ variables: EntityProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityProfileQuery, EntityProfileQueryVariables>(EntityProfileDocument, options);
      }
export function useEntityProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityProfileQuery, EntityProfileQueryVariables>(EntityProfileDocument, options);
        }
// @ts-ignore
export function useEntityProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProfileQuery, EntityProfileQueryVariables>;
export function useEntityProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProfileQuery | undefined, EntityProfileQueryVariables>;
export function useEntityProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityProfileQuery, EntityProfileQueryVariables>(EntityProfileDocument, options);
        }
export type EntityProfileQueryHookResult = ReturnType<typeof useEntityProfileQuery>;
export type EntityProfileLazyQueryHookResult = ReturnType<typeof useEntityProfileLazyQuery>;
export type EntityProfileSuspenseQueryHookResult = ReturnType<typeof useEntityProfileSuspenseQuery>;
export type EntityProfileQueryResult = ApolloReactCommon.QueryResult<EntityProfileQuery, EntityProfileQueryVariables>;
export const EntityProjectsReportsDocument = gql`
    query EntityProjectsReports($entityName: String!, $pattern: String, $first: Int = 100) {
  entity(name: $entityName) {
    id
    projects(order: "-created_at", first: $first, pattern: $pattern) {
      edges {
        node {
          id
          name
          entityName
          reports: allViews(viewType: "runs") {
            edges {
              node {
                id
                ...ViewFragmentMetadata
              }
            }
          }
        }
      }
    }
  }
}
    ${ViewFragmentMetadataFragmentDoc}`;
export type EntityProjectsReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>, 'query'> & ({ variables: EntityProjectsReportsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityProjectsReportsComponent = (props: EntityProjectsReportsComponentProps) => (
      <ApolloReactComponents.Query<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables> query={EntityProjectsReportsDocument} {...props} />
    );
    
export type EntityProjectsReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>
    } & TChildProps;
export function withEntityProjectsReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityProjectsReportsQuery,
  EntityProjectsReportsQueryVariables,
  EntityProjectsReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables, EntityProjectsReportsProps<TChildProps, TDataName>>(EntityProjectsReportsDocument, {
      alias: 'entityProjectsReports',
      ...operationOptions
    });
};

/**
 * __useEntityProjectsReportsQuery__
 *
 * To run a query within a React component, call `useEntityProjectsReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityProjectsReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityProjectsReportsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useEntityProjectsReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables> & ({ variables: EntityProjectsReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>(EntityProjectsReportsDocument, options);
      }
export function useEntityProjectsReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>(EntityProjectsReportsDocument, options);
        }
// @ts-ignore
export function useEntityProjectsReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>;
export function useEntityProjectsReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProjectsReportsQuery | undefined, EntityProjectsReportsQueryVariables>;
export function useEntityProjectsReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>(EntityProjectsReportsDocument, options);
        }
export type EntityProjectsReportsQueryHookResult = ReturnType<typeof useEntityProjectsReportsQuery>;
export type EntityProjectsReportsLazyQueryHookResult = ReturnType<typeof useEntityProjectsReportsLazyQuery>;
export type EntityProjectsReportsSuspenseQueryHookResult = ReturnType<typeof useEntityProjectsReportsSuspenseQuery>;
export type EntityProjectsReportsQueryResult = ApolloReactCommon.QueryResult<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>;
export const ProjectReportsDocument = gql`
    query ProjectReports($entityName: String, $projectName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
    reports: allViews(viewType: "runs") {
      edges {
        node {
          id
          ...ViewFragmentMetadata
        }
      }
    }
  }
}
    ${ViewFragmentMetadataFragmentDoc}`;
export type ProjectReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectReportsQuery, ProjectReportsQueryVariables>, 'query'>;

    export const ProjectReportsComponent = (props: ProjectReportsComponentProps) => (
      <ApolloReactComponents.Query<ProjectReportsQuery, ProjectReportsQueryVariables> query={ProjectReportsDocument} {...props} />
    );
    
export type ProjectReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectReportsQuery, ProjectReportsQueryVariables>
    } & TChildProps;
export function withProjectReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectReportsQuery,
  ProjectReportsQueryVariables,
  ProjectReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectReportsQuery, ProjectReportsQueryVariables, ProjectReportsProps<TChildProps, TDataName>>(ProjectReportsDocument, {
      alias: 'projectReports',
      ...operationOptions
    });
};

/**
 * __useProjectReportsQuery__
 *
 * To run a query within a React component, call `useProjectReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReportsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectReportsQuery, ProjectReportsQueryVariables>(ProjectReportsDocument, options);
      }
export function useProjectReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectReportsQuery, ProjectReportsQueryVariables>(ProjectReportsDocument, options);
        }
// @ts-ignore
export function useProjectReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectReportsQuery, ProjectReportsQueryVariables>;
export function useProjectReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectReportsQuery | undefined, ProjectReportsQueryVariables>;
export function useProjectReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectReportsQuery, ProjectReportsQueryVariables>(ProjectReportsDocument, options);
        }
export type ProjectReportsQueryHookResult = ReturnType<typeof useProjectReportsQuery>;
export type ProjectReportsLazyQueryHookResult = ReturnType<typeof useProjectReportsLazyQuery>;
export type ProjectReportsSuspenseQueryHookResult = ReturnType<typeof useProjectReportsSuspenseQuery>;
export type ProjectReportsQueryResult = ApolloReactCommon.QueryResult<ProjectReportsQuery, ProjectReportsQueryVariables>;
export const EntityTagsDocument = gql`
    query EntityTags($entityName: String!) {
  entity(name: $entityName) {
    id
    tagCategories {
      id
      name
      tags {
        edges {
          node {
            id
            name
            tagCategoryName
            attributes
          }
        }
      }
    }
  }
}
    `;
export type EntityTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityTagsQuery, EntityTagsQueryVariables>, 'query'> & ({ variables: EntityTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityTagsComponent = (props: EntityTagsComponentProps) => (
      <ApolloReactComponents.Query<EntityTagsQuery, EntityTagsQueryVariables> query={EntityTagsDocument} {...props} />
    );
    
export type EntityTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityTagsQuery, EntityTagsQueryVariables>
    } & TChildProps;
export function withEntityTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityTagsQuery,
  EntityTagsQueryVariables,
  EntityTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityTagsQuery, EntityTagsQueryVariables, EntityTagsProps<TChildProps, TDataName>>(EntityTagsDocument, {
      alias: 'entityTags',
      ...operationOptions
    });
};

/**
 * __useEntityTagsQuery__
 *
 * To run a query within a React component, call `useEntityTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityTagsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables> & ({ variables: EntityTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityTagsQuery, EntityTagsQueryVariables>(EntityTagsDocument, options);
      }
export function useEntityTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityTagsQuery, EntityTagsQueryVariables>(EntityTagsDocument, options);
        }
// @ts-ignore
export function useEntityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityTagsQuery, EntityTagsQueryVariables>;
export function useEntityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityTagsQuery | undefined, EntityTagsQueryVariables>;
export function useEntityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityTagsQuery, EntityTagsQueryVariables>(EntityTagsDocument, options);
        }
export type EntityTagsQueryHookResult = ReturnType<typeof useEntityTagsQuery>;
export type EntityTagsLazyQueryHookResult = ReturnType<typeof useEntityTagsLazyQuery>;
export type EntityTagsSuspenseQueryHookResult = ReturnType<typeof useEntityTagsSuspenseQuery>;
export type EntityTagsQueryResult = ApolloReactCommon.QueryResult<EntityTagsQuery, EntityTagsQueryVariables>;
export const GalleryDocument = gql`
    query Gallery {
  singletonView(type: "fullyConnected") {
    id
    spec
  }
}
    `;
export type GalleryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GalleryQuery, GalleryQueryVariables>, 'query'>;

    export const GalleryComponent = (props: GalleryComponentProps) => (
      <ApolloReactComponents.Query<GalleryQuery, GalleryQueryVariables> query={GalleryDocument} {...props} />
    );
    
export type GalleryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GalleryQuery, GalleryQueryVariables>
    } & TChildProps;
export function withGallery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GalleryQuery,
  GalleryQueryVariables,
  GalleryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GalleryQuery, GalleryQueryVariables, GalleryProps<TChildProps, TDataName>>(GalleryDocument, {
      alias: 'gallery',
      ...operationOptions
    });
};

/**
 * __useGalleryQuery__
 *
 * To run a query within a React component, call `useGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGalleryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GalleryQuery, GalleryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GalleryQuery, GalleryQueryVariables>(GalleryDocument, options);
      }
export function useGalleryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GalleryQuery, GalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GalleryQuery, GalleryQueryVariables>(GalleryDocument, options);
        }
// @ts-ignore
export function useGallerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GalleryQuery, GalleryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GalleryQuery, GalleryQueryVariables>;
export function useGallerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GalleryQuery, GalleryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GalleryQuery | undefined, GalleryQueryVariables>;
export function useGallerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GalleryQuery, GalleryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GalleryQuery, GalleryQueryVariables>(GalleryDocument, options);
        }
export type GalleryQueryHookResult = ReturnType<typeof useGalleryQuery>;
export type GalleryLazyQueryHookResult = ReturnType<typeof useGalleryLazyQuery>;
export type GallerySuspenseQueryHookResult = ReturnType<typeof useGallerySuspenseQuery>;
export type GalleryQueryResult = ApolloReactCommon.QueryResult<GalleryQuery, GalleryQueryVariables>;
export const UpdateGalleryDocument = gql`
    mutation UpdateGallery($id: ID, $spec: String!) {
  upsertView(input: {id: $id, spec: $spec, name: "", type: "fullyConnected"}) {
    view {
      id
      updatedAt
      createdAt
      spec
    }
    inserted
  }
}
    `;
export type UpdateGalleryMutationFn = ApolloReactCommon.MutationFunction<UpdateGalleryMutation, UpdateGalleryMutationVariables>;
export type UpdateGalleryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>, 'mutation'>;

    export const UpdateGalleryComponent = (props: UpdateGalleryComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateGalleryMutation, UpdateGalleryMutationVariables> mutation={UpdateGalleryDocument} {...props} />
    );
    
export type UpdateGalleryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateGalleryMutation, UpdateGalleryMutationVariables>
    } & TChildProps;
export function withUpdateGallery<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateGalleryMutation,
  UpdateGalleryMutationVariables,
  UpdateGalleryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateGalleryMutation, UpdateGalleryMutationVariables, UpdateGalleryProps<TChildProps, TDataName>>(UpdateGalleryDocument, {
      alias: 'updateGallery',
      ...operationOptions
    });
};

/**
 * __useUpdateGalleryMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryMutation, { data, loading, error }] = useUpdateGalleryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useUpdateGalleryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGalleryMutation, UpdateGalleryMutationVariables>(UpdateGalleryDocument, options);
      }
export type UpdateGalleryMutationHookResult = ReturnType<typeof useUpdateGalleryMutation>;
export type UpdateGalleryMutationResult = ApolloReactCommon.MutationResult<UpdateGalleryMutation>;
export type UpdateGalleryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>;
export const FeaturedReportsMetadataDocument = gql`
    query FeaturedReportsMetadata($ids: [ID!]!, $recentStarCountFrom: DateTime) {
  views(ids: $ids) {
    edges {
      node {
        id
        createdAt
        updatedAt
        entityName
        project {
          id
          entityName
          name
          access
        }
        displayName
        description
        viewCount
        starCount
        recentStarCount: starCount(from: $recentStarCountFrom)
        starred
      }
    }
  }
}
    `;
export type FeaturedReportsMetadataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>, 'query'> & ({ variables: FeaturedReportsMetadataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FeaturedReportsMetadataComponent = (props: FeaturedReportsMetadataComponentProps) => (
      <ApolloReactComponents.Query<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables> query={FeaturedReportsMetadataDocument} {...props} />
    );
    
export type FeaturedReportsMetadataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>
    } & TChildProps;
export function withFeaturedReportsMetadata<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FeaturedReportsMetadataQuery,
  FeaturedReportsMetadataQueryVariables,
  FeaturedReportsMetadataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables, FeaturedReportsMetadataProps<TChildProps, TDataName>>(FeaturedReportsMetadataDocument, {
      alias: 'featuredReportsMetadata',
      ...operationOptions
    });
};

/**
 * __useFeaturedReportsMetadataQuery__
 *
 * To run a query within a React component, call `useFeaturedReportsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedReportsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedReportsMetadataQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      recentStarCountFrom: // value for 'recentStarCountFrom'
 *   },
 * });
 */
export function useFeaturedReportsMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables> & ({ variables: FeaturedReportsMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>(FeaturedReportsMetadataDocument, options);
      }
export function useFeaturedReportsMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>(FeaturedReportsMetadataDocument, options);
        }
// @ts-ignore
export function useFeaturedReportsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>;
export function useFeaturedReportsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeaturedReportsMetadataQuery | undefined, FeaturedReportsMetadataQueryVariables>;
export function useFeaturedReportsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>(FeaturedReportsMetadataDocument, options);
        }
export type FeaturedReportsMetadataQueryHookResult = ReturnType<typeof useFeaturedReportsMetadataQuery>;
export type FeaturedReportsMetadataLazyQueryHookResult = ReturnType<typeof useFeaturedReportsMetadataLazyQuery>;
export type FeaturedReportsMetadataSuspenseQueryHookResult = ReturnType<typeof useFeaturedReportsMetadataSuspenseQuery>;
export type FeaturedReportsMetadataQueryResult = ApolloReactCommon.QueryResult<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>;
export const FeaturedReportsAuthorsDocument = gql`
    query FeaturedReportsAuthors($usernames: [String!]!) {
  users(usernames: $usernames) {
    edges {
      node {
        id
        name
        username
        photoUrl
        userInfo
      }
    }
  }
}
    `;
export type FeaturedReportsAuthorsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>, 'query'> & ({ variables: FeaturedReportsAuthorsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FeaturedReportsAuthorsComponent = (props: FeaturedReportsAuthorsComponentProps) => (
      <ApolloReactComponents.Query<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables> query={FeaturedReportsAuthorsDocument} {...props} />
    );
    
export type FeaturedReportsAuthorsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>
    } & TChildProps;
export function withFeaturedReportsAuthors<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FeaturedReportsAuthorsQuery,
  FeaturedReportsAuthorsQueryVariables,
  FeaturedReportsAuthorsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables, FeaturedReportsAuthorsProps<TChildProps, TDataName>>(FeaturedReportsAuthorsDocument, {
      alias: 'featuredReportsAuthors',
      ...operationOptions
    });
};

/**
 * __useFeaturedReportsAuthorsQuery__
 *
 * To run a query within a React component, call `useFeaturedReportsAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedReportsAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedReportsAuthorsQuery({
 *   variables: {
 *      usernames: // value for 'usernames'
 *   },
 * });
 */
export function useFeaturedReportsAuthorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables> & ({ variables: FeaturedReportsAuthorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>(FeaturedReportsAuthorsDocument, options);
      }
export function useFeaturedReportsAuthorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>(FeaturedReportsAuthorsDocument, options);
        }
// @ts-ignore
export function useFeaturedReportsAuthorsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>;
export function useFeaturedReportsAuthorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeaturedReportsAuthorsQuery | undefined, FeaturedReportsAuthorsQueryVariables>;
export function useFeaturedReportsAuthorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>(FeaturedReportsAuthorsDocument, options);
        }
export type FeaturedReportsAuthorsQueryHookResult = ReturnType<typeof useFeaturedReportsAuthorsQuery>;
export type FeaturedReportsAuthorsLazyQueryHookResult = ReturnType<typeof useFeaturedReportsAuthorsLazyQuery>;
export type FeaturedReportsAuthorsSuspenseQueryHookResult = ReturnType<typeof useFeaturedReportsAuthorsSuspenseQuery>;
export type FeaturedReportsAuthorsQueryResult = ApolloReactCommon.QueryResult<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>;
export const InsertGalleryDiscussionDocument = gql`
    mutation InsertGalleryDiscussion($spec: String!, $reportID: ID!, $sendEmail: Boolean) {
  insertGalleryDiscussion(
    input: {spec: $spec, reportID: $reportID, sendEmail: $sendEmail}
  ) {
    success
  }
}
    `;
export type InsertGalleryDiscussionMutationFn = ApolloReactCommon.MutationFunction<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>;
export type InsertGalleryDiscussionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>, 'mutation'>;

    export const InsertGalleryDiscussionComponent = (props: InsertGalleryDiscussionComponentProps) => (
      <ApolloReactComponents.Mutation<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables> mutation={InsertGalleryDiscussionDocument} {...props} />
    );
    
export type InsertGalleryDiscussionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>
    } & TChildProps;
export function withInsertGalleryDiscussion<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsertGalleryDiscussionMutation,
  InsertGalleryDiscussionMutationVariables,
  InsertGalleryDiscussionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables, InsertGalleryDiscussionProps<TChildProps, TDataName>>(InsertGalleryDiscussionDocument, {
      alias: 'insertGalleryDiscussion',
      ...operationOptions
    });
};

/**
 * __useInsertGalleryDiscussionMutation__
 *
 * To run a mutation, you first call `useInsertGalleryDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGalleryDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGalleryDiscussionMutation, { data, loading, error }] = useInsertGalleryDiscussionMutation({
 *   variables: {
 *      spec: // value for 'spec'
 *      reportID: // value for 'reportID'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useInsertGalleryDiscussionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>(InsertGalleryDiscussionDocument, options);
      }
export type InsertGalleryDiscussionMutationHookResult = ReturnType<typeof useInsertGalleryDiscussionMutation>;
export type InsertGalleryDiscussionMutationResult = ApolloReactCommon.MutationResult<InsertGalleryDiscussionMutation>;
export type InsertGalleryDiscussionMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>;
export const SubmitFcNewsDocument = gql`
    mutation SubmitFCNews($name: String!, $email: String!, $url: String!, $details: String) {
  submitFCNews(input: {name: $name, email: $email, url: $url, details: $details}) {
    success
  }
}
    `;
export type SubmitFcNewsMutationFn = ApolloReactCommon.MutationFunction<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>;
export type SubmitFcNewsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>, 'mutation'>;

    export const SubmitFcNewsComponent = (props: SubmitFcNewsComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitFcNewsMutation, SubmitFcNewsMutationVariables> mutation={SubmitFcNewsDocument} {...props} />
    );
    
export type SubmitFcNewsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>
    } & TChildProps;
export function withSubmitFcNews<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubmitFcNewsMutation,
  SubmitFcNewsMutationVariables,
  SubmitFcNewsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SubmitFcNewsMutation, SubmitFcNewsMutationVariables, SubmitFcNewsProps<TChildProps, TDataName>>(SubmitFcNewsDocument, {
      alias: 'submitFcNews',
      ...operationOptions
    });
};

/**
 * __useSubmitFcNewsMutation__
 *
 * To run a mutation, you first call `useSubmitFcNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFcNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFcNewsMutation, { data, loading, error }] = useSubmitFcNewsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      url: // value for 'url'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useSubmitFcNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>(SubmitFcNewsDocument, options);
      }
export type SubmitFcNewsMutationHookResult = ReturnType<typeof useSubmitFcNewsMutation>;
export type SubmitFcNewsMutationResult = ApolloReactCommon.MutationResult<SubmitFcNewsMutation>;
export type SubmitFcNewsMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>;
export const GalleryTagSectionsDocument = gql`
    query GalleryTagSections {
  galleryTagSections
}
    `;
export type GalleryTagSectionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>, 'query'>;

    export const GalleryTagSectionsComponent = (props: GalleryTagSectionsComponentProps) => (
      <ApolloReactComponents.Query<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables> query={GalleryTagSectionsDocument} {...props} />
    );
    
export type GalleryTagSectionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>
    } & TChildProps;
export function withGalleryTagSections<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GalleryTagSectionsQuery,
  GalleryTagSectionsQueryVariables,
  GalleryTagSectionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables, GalleryTagSectionsProps<TChildProps, TDataName>>(GalleryTagSectionsDocument, {
      alias: 'galleryTagSections',
      ...operationOptions
    });
};

/**
 * __useGalleryTagSectionsQuery__
 *
 * To run a query within a React component, call `useGalleryTagSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryTagSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryTagSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGalleryTagSectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>(GalleryTagSectionsDocument, options);
      }
export function useGalleryTagSectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>(GalleryTagSectionsDocument, options);
        }
// @ts-ignore
export function useGalleryTagSectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>;
export function useGalleryTagSectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GalleryTagSectionsQuery | undefined, GalleryTagSectionsQueryVariables>;
export function useGalleryTagSectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>(GalleryTagSectionsDocument, options);
        }
export type GalleryTagSectionsQueryHookResult = ReturnType<typeof useGalleryTagSectionsQuery>;
export type GalleryTagSectionsLazyQueryHookResult = ReturnType<typeof useGalleryTagSectionsLazyQuery>;
export type GalleryTagSectionsSuspenseQueryHookResult = ReturnType<typeof useGalleryTagSectionsSuspenseQuery>;
export type GalleryTagSectionsQueryResult = ApolloReactCommon.QueryResult<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>;
export const ProjectAccessDocument = gql`
    query ProjectAccess($name: String, $entityName: String) {
  project(name: $name, entityName: $entityName) {
    id
    access
  }
}
    `;
export type ProjectAccessComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectAccessQuery, ProjectAccessQueryVariables>, 'query'>;

    export const ProjectAccessComponent = (props: ProjectAccessComponentProps) => (
      <ApolloReactComponents.Query<ProjectAccessQuery, ProjectAccessQueryVariables> query={ProjectAccessDocument} {...props} />
    );
    
export type ProjectAccessProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectAccessQuery, ProjectAccessQueryVariables>
    } & TChildProps;
export function withProjectAccess<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectAccessQuery,
  ProjectAccessQueryVariables,
  ProjectAccessProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectAccessQuery, ProjectAccessQueryVariables, ProjectAccessProps<TChildProps, TDataName>>(ProjectAccessDocument, {
      alias: 'projectAccess',
      ...operationOptions
    });
};

/**
 * __useProjectAccessQuery__
 *
 * To run a query within a React component, call `useProjectAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAccessQuery({
 *   variables: {
 *      name: // value for 'name'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectAccessQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectAccessQuery, ProjectAccessQueryVariables>(ProjectAccessDocument, options);
      }
export function useProjectAccessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectAccessQuery, ProjectAccessQueryVariables>(ProjectAccessDocument, options);
        }
// @ts-ignore
export function useProjectAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectAccessQuery, ProjectAccessQueryVariables>;
export function useProjectAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectAccessQuery | undefined, ProjectAccessQueryVariables>;
export function useProjectAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectAccessQuery, ProjectAccessQueryVariables>(ProjectAccessDocument, options);
        }
export type ProjectAccessQueryHookResult = ReturnType<typeof useProjectAccessQuery>;
export type ProjectAccessLazyQueryHookResult = ReturnType<typeof useProjectAccessLazyQuery>;
export type ProjectAccessSuspenseQueryHookResult = ReturnType<typeof useProjectAccessSuspenseQuery>;
export type ProjectAccessQueryResult = ApolloReactCommon.QueryResult<ProjectAccessQuery, ProjectAccessQueryVariables>;
export const NewsletterSubscriptionDocument = gql`
    query NewsletterSubscription($userName: String!) {
  user(userName: $userName) {
    id
    newsletterSubscription {
      id
    }
  }
}
    `;
export type NewsletterSubscriptionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>, 'query'> & ({ variables: NewsletterSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NewsletterSubscriptionComponent = (props: NewsletterSubscriptionComponentProps) => (
      <ApolloReactComponents.Query<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables> query={NewsletterSubscriptionDocument} {...props} />
    );
    
export type NewsletterSubscriptionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>
    } & TChildProps;
export function withNewsletterSubscription<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NewsletterSubscriptionQuery,
  NewsletterSubscriptionQueryVariables,
  NewsletterSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables, NewsletterSubscriptionProps<TChildProps, TDataName>>(NewsletterSubscriptionDocument, {
      alias: 'newsletterSubscription',
      ...operationOptions
    });
};

/**
 * __useNewsletterSubscriptionQuery__
 *
 * To run a query within a React component, call `useNewsletterSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterSubscriptionQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useNewsletterSubscriptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables> & ({ variables: NewsletterSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
      }
export function useNewsletterSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
        }
// @ts-ignore
export function useNewsletterSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>;
export function useNewsletterSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NewsletterSubscriptionQuery | undefined, NewsletterSubscriptionQueryVariables>;
export function useNewsletterSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
        }
export type NewsletterSubscriptionQueryHookResult = ReturnType<typeof useNewsletterSubscriptionQuery>;
export type NewsletterSubscriptionLazyQueryHookResult = ReturnType<typeof useNewsletterSubscriptionLazyQuery>;
export type NewsletterSubscriptionSuspenseQueryHookResult = ReturnType<typeof useNewsletterSubscriptionSuspenseQuery>;
export type NewsletterSubscriptionQueryResult = ApolloReactCommon.QueryResult<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>;
export const CreateNewsletterSubscriptionDocument = gql`
    mutation CreateNewsletterSubscription($email: String) {
  createNewsletterSubscription(input: {email: $email}) {
    newsletterSubscription {
      id
    }
  }
}
    `;
export type CreateNewsletterSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>;
export type CreateNewsletterSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>, 'mutation'>;

    export const CreateNewsletterSubscriptionComponent = (props: CreateNewsletterSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables> mutation={CreateNewsletterSubscriptionDocument} {...props} />
    );
    
export type CreateNewsletterSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>
    } & TChildProps;
export function withCreateNewsletterSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateNewsletterSubscriptionMutation,
  CreateNewsletterSubscriptionMutationVariables,
  CreateNewsletterSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables, CreateNewsletterSubscriptionProps<TChildProps, TDataName>>(CreateNewsletterSubscriptionDocument, {
      alias: 'createNewsletterSubscription',
      ...operationOptions
    });
};

/**
 * __useCreateNewsletterSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateNewsletterSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsletterSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsletterSubscriptionMutation, { data, loading, error }] = useCreateNewsletterSubscriptionMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateNewsletterSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>(CreateNewsletterSubscriptionDocument, options);
      }
export type CreateNewsletterSubscriptionMutationHookResult = ReturnType<typeof useCreateNewsletterSubscriptionMutation>;
export type CreateNewsletterSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateNewsletterSubscriptionMutation>;
export type CreateNewsletterSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>;
export const AllNewsletterSubscriptionsDocument = gql`
    query AllNewsletterSubscriptions($first: Int = 10000) {
  newsletterSubscriptions(first: $first) {
    edges {
      node {
        id
        user {
          id
          username
          email
        }
        email
        createdAt
      }
    }
  }
}
    `;
export type AllNewsletterSubscriptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>, 'query'>;

    export const AllNewsletterSubscriptionsComponent = (props: AllNewsletterSubscriptionsComponentProps) => (
      <ApolloReactComponents.Query<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables> query={AllNewsletterSubscriptionsDocument} {...props} />
    );
    
export type AllNewsletterSubscriptionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>
    } & TChildProps;
export function withAllNewsletterSubscriptions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllNewsletterSubscriptionsQuery,
  AllNewsletterSubscriptionsQueryVariables,
  AllNewsletterSubscriptionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables, AllNewsletterSubscriptionsProps<TChildProps, TDataName>>(AllNewsletterSubscriptionsDocument, {
      alias: 'allNewsletterSubscriptions',
      ...operationOptions
    });
};

/**
 * __useAllNewsletterSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAllNewsletterSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNewsletterSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNewsletterSubscriptionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllNewsletterSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>(AllNewsletterSubscriptionsDocument, options);
      }
export function useAllNewsletterSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>(AllNewsletterSubscriptionsDocument, options);
        }
// @ts-ignore
export function useAllNewsletterSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>;
export function useAllNewsletterSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllNewsletterSubscriptionsQuery | undefined, AllNewsletterSubscriptionsQueryVariables>;
export function useAllNewsletterSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>(AllNewsletterSubscriptionsDocument, options);
        }
export type AllNewsletterSubscriptionsQueryHookResult = ReturnType<typeof useAllNewsletterSubscriptionsQuery>;
export type AllNewsletterSubscriptionsLazyQueryHookResult = ReturnType<typeof useAllNewsletterSubscriptionsLazyQuery>;
export type AllNewsletterSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useAllNewsletterSubscriptionsSuspenseQuery>;
export type AllNewsletterSubscriptionsQueryResult = ApolloReactCommon.QueryResult<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>;
export const ViewPreviewUrlDocument = gql`
    query ViewPreviewUrl($id: ID!) {
  view(id: $id) {
    id
    previewUrl
  }
}
    `;
export type ViewPreviewUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>, 'query'> & ({ variables: ViewPreviewUrlQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewPreviewUrlComponent = (props: ViewPreviewUrlComponentProps) => (
      <ApolloReactComponents.Query<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables> query={ViewPreviewUrlDocument} {...props} />
    );
    
export type ViewPreviewUrlProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>
    } & TChildProps;
export function withViewPreviewUrl<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewPreviewUrlQuery,
  ViewPreviewUrlQueryVariables,
  ViewPreviewUrlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables, ViewPreviewUrlProps<TChildProps, TDataName>>(ViewPreviewUrlDocument, {
      alias: 'viewPreviewUrl',
      ...operationOptions
    });
};

/**
 * __useViewPreviewUrlQuery__
 *
 * To run a query within a React component, call `useViewPreviewUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewPreviewUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewPreviewUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewPreviewUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables> & ({ variables: ViewPreviewUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>(ViewPreviewUrlDocument, options);
      }
export function useViewPreviewUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>(ViewPreviewUrlDocument, options);
        }
// @ts-ignore
export function useViewPreviewUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>;
export function useViewPreviewUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewPreviewUrlQuery | undefined, ViewPreviewUrlQueryVariables>;
export function useViewPreviewUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>(ViewPreviewUrlDocument, options);
        }
export type ViewPreviewUrlQueryHookResult = ReturnType<typeof useViewPreviewUrlQuery>;
export type ViewPreviewUrlLazyQueryHookResult = ReturnType<typeof useViewPreviewUrlLazyQuery>;
export type ViewPreviewUrlSuspenseQueryHookResult = ReturnType<typeof useViewPreviewUrlSuspenseQuery>;
export type ViewPreviewUrlQueryResult = ApolloReactCommon.QueryResult<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>;
export const GroupPageDocument = gql`
    query GroupPage($projectName: String!, $entityName: String, $groupName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runGroup(name: $groupName) {
      id
      name
      notes
      tags {
        id
        name
        colorIndex
      }
    }
  }
}
    `;
export type GroupPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupPageQuery, GroupPageQueryVariables>, 'query'> & ({ variables: GroupPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupPageComponent = (props: GroupPageComponentProps) => (
      <ApolloReactComponents.Query<GroupPageQuery, GroupPageQueryVariables> query={GroupPageDocument} {...props} />
    );
    
export type GroupPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GroupPageQuery, GroupPageQueryVariables>
    } & TChildProps;
export function withGroupPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GroupPageQuery,
  GroupPageQueryVariables,
  GroupPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GroupPageQuery, GroupPageQueryVariables, GroupPageProps<TChildProps, TDataName>>(GroupPageDocument, {
      alias: 'groupPage',
      ...operationOptions
    });
};

/**
 * __useGroupPageQuery__
 *
 * To run a query within a React component, call `useGroupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      groupName: // value for 'groupName'
 *   },
 * });
 */
export function useGroupPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupPageQuery, GroupPageQueryVariables> & ({ variables: GroupPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupPageQuery, GroupPageQueryVariables>(GroupPageDocument, options);
      }
export function useGroupPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupPageQuery, GroupPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupPageQuery, GroupPageQueryVariables>(GroupPageDocument, options);
        }
// @ts-ignore
export function useGroupPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupPageQuery, GroupPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupPageQuery, GroupPageQueryVariables>;
export function useGroupPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupPageQuery, GroupPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupPageQuery | undefined, GroupPageQueryVariables>;
export function useGroupPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupPageQuery, GroupPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupPageQuery, GroupPageQueryVariables>(GroupPageDocument, options);
        }
export type GroupPageQueryHookResult = ReturnType<typeof useGroupPageQuery>;
export type GroupPageLazyQueryHookResult = ReturnType<typeof useGroupPageLazyQuery>;
export type GroupPageSuspenseQueryHookResult = ReturnType<typeof useGroupPageSuspenseQuery>;
export type GroupPageQueryResult = ApolloReactCommon.QueryResult<GroupPageQuery, GroupPageQueryVariables>;
export const HistoryKeysDocument = gql`
    query HistoryKeys($projectName: String!, $entityName: String!, $filters: JSONString, $limit: Int = 100, $order: String) {
  project(name: $projectName, entityName: $entityName) {
    ...HistoryKeysFields
    runs(filters: $filters, first: $limit, order: $order) {
      historyKeys(format: PLAINTEXT)
    }
  }
}
    ${HistoryKeysFieldsFragmentDoc}`;
export type HistoryKeysComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HistoryKeysQuery, HistoryKeysQueryVariables>, 'query'> & ({ variables: HistoryKeysQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HistoryKeysComponent = (props: HistoryKeysComponentProps) => (
      <ApolloReactComponents.Query<HistoryKeysQuery, HistoryKeysQueryVariables> query={HistoryKeysDocument} {...props} />
    );
    
export type HistoryKeysProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HistoryKeysQuery, HistoryKeysQueryVariables>
    } & TChildProps;
export function withHistoryKeys<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HistoryKeysQuery,
  HistoryKeysQueryVariables,
  HistoryKeysProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HistoryKeysQuery, HistoryKeysQueryVariables, HistoryKeysProps<TChildProps, TDataName>>(HistoryKeysDocument, {
      alias: 'historyKeys',
      ...operationOptions
    });
};

/**
 * __useHistoryKeysQuery__
 *
 * To run a query within a React component, call `useHistoryKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryKeysQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHistoryKeysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables> & ({ variables: HistoryKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HistoryKeysQuery, HistoryKeysQueryVariables>(HistoryKeysDocument, options);
      }
export function useHistoryKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HistoryKeysQuery, HistoryKeysQueryVariables>(HistoryKeysDocument, options);
        }
// @ts-ignore
export function useHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysQuery, HistoryKeysQueryVariables>;
export function useHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysQuery | undefined, HistoryKeysQueryVariables>;
export function useHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HistoryKeysQuery, HistoryKeysQueryVariables>(HistoryKeysDocument, options);
        }
export type HistoryKeysQueryHookResult = ReturnType<typeof useHistoryKeysQuery>;
export type HistoryKeysLazyQueryHookResult = ReturnType<typeof useHistoryKeysLazyQuery>;
export type HistoryKeysSuspenseQueryHookResult = ReturnType<typeof useHistoryKeysSuspenseQuery>;
export type HistoryKeysQueryResult = ApolloReactCommon.QueryResult<HistoryKeysQuery, HistoryKeysQueryVariables>;
export const HistoryKeysWithHashDocument = gql`
    query HistoryKeysWithHash($projectName: String!, $entityName: String!, $filters: JSONString, $limit: Int = 100, $order: String) {
  project(name: $projectName, entityName: $entityName) {
    ...HistoryKeysFields
    runs(filters: $filters, first: $limit, order: $order) {
      historyKeys(format: PLAINTEXT, includeHash: true)
    }
  }
}
    ${HistoryKeysFieldsFragmentDoc}`;
export type HistoryKeysWithHashComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>, 'query'> & ({ variables: HistoryKeysWithHashQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HistoryKeysWithHashComponent = (props: HistoryKeysWithHashComponentProps) => (
      <ApolloReactComponents.Query<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables> query={HistoryKeysWithHashDocument} {...props} />
    );
    
export type HistoryKeysWithHashProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>
    } & TChildProps;
export function withHistoryKeysWithHash<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HistoryKeysWithHashQuery,
  HistoryKeysWithHashQueryVariables,
  HistoryKeysWithHashProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables, HistoryKeysWithHashProps<TChildProps, TDataName>>(HistoryKeysWithHashDocument, {
      alias: 'historyKeysWithHash',
      ...operationOptions
    });
};

/**
 * __useHistoryKeysWithHashQuery__
 *
 * To run a query within a React component, call `useHistoryKeysWithHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryKeysWithHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryKeysWithHashQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHistoryKeysWithHashQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables> & ({ variables: HistoryKeysWithHashQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>(HistoryKeysWithHashDocument, options);
      }
export function useHistoryKeysWithHashLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>(HistoryKeysWithHashDocument, options);
        }
// @ts-ignore
export function useHistoryKeysWithHashSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>;
export function useHistoryKeysWithHashSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysWithHashQuery | undefined, HistoryKeysWithHashQueryVariables>;
export function useHistoryKeysWithHashSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>(HistoryKeysWithHashDocument, options);
        }
export type HistoryKeysWithHashQueryHookResult = ReturnType<typeof useHistoryKeysWithHashQuery>;
export type HistoryKeysWithHashLazyQueryHookResult = ReturnType<typeof useHistoryKeysWithHashLazyQuery>;
export type HistoryKeysWithHashSuspenseQueryHookResult = ReturnType<typeof useHistoryKeysWithHashSuspenseQuery>;
export type HistoryKeysWithHashQueryResult = ApolloReactCommon.QueryResult<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>;
export const HistoryKeysByProjectIdDocument = gql`
    query HistoryKeysByProjectId($internalId: ID!, $filters: JSONString, $limit: Int = 100, $order: String) {
  project(internalId: $internalId) {
    id
    runs(filters: $filters, first: $limit, order: $order) {
      historyKeys(format: BITMAP)
      edges {
        node {
          id
          wandbConfig(keys: ["viz", "visualize"])
        }
      }
    }
  }
}
    `;
export type HistoryKeysByProjectIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>, 'query'> & ({ variables: HistoryKeysByProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HistoryKeysByProjectIdComponent = (props: HistoryKeysByProjectIdComponentProps) => (
      <ApolloReactComponents.Query<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables> query={HistoryKeysByProjectIdDocument} {...props} />
    );
    
export type HistoryKeysByProjectIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>
    } & TChildProps;
export function withHistoryKeysByProjectId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HistoryKeysByProjectIdQuery,
  HistoryKeysByProjectIdQueryVariables,
  HistoryKeysByProjectIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables, HistoryKeysByProjectIdProps<TChildProps, TDataName>>(HistoryKeysByProjectIdDocument, {
      alias: 'historyKeysByProjectId',
      ...operationOptions
    });
};

/**
 * __useHistoryKeysByProjectIdQuery__
 *
 * To run a query within a React component, call `useHistoryKeysByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryKeysByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryKeysByProjectIdQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHistoryKeysByProjectIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables> & ({ variables: HistoryKeysByProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>(HistoryKeysByProjectIdDocument, options);
      }
export function useHistoryKeysByProjectIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>(HistoryKeysByProjectIdDocument, options);
        }
// @ts-ignore
export function useHistoryKeysByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>;
export function useHistoryKeysByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysByProjectIdQuery | undefined, HistoryKeysByProjectIdQueryVariables>;
export function useHistoryKeysByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>(HistoryKeysByProjectIdDocument, options);
        }
export type HistoryKeysByProjectIdQueryHookResult = ReturnType<typeof useHistoryKeysByProjectIdQuery>;
export type HistoryKeysByProjectIdLazyQueryHookResult = ReturnType<typeof useHistoryKeysByProjectIdLazyQuery>;
export type HistoryKeysByProjectIdSuspenseQueryHookResult = ReturnType<typeof useHistoryKeysByProjectIdSuspenseQuery>;
export type HistoryKeysByProjectIdQueryResult = ApolloReactCommon.QueryResult<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>;
export const InviteDocument = gql`
    query Invite($key: String!) {
  invite(key: $key) {
    id
    toUser {
      id
      username
    }
  }
}
    `;
export type InviteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InviteQuery, InviteQueryVariables>, 'query'> & ({ variables: InviteQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InviteComponent = (props: InviteComponentProps) => (
      <ApolloReactComponents.Query<InviteQuery, InviteQueryVariables> query={InviteDocument} {...props} />
    );
    
export type InviteProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InviteQuery, InviteQueryVariables>
    } & TChildProps;
export function withInvite<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InviteQuery,
  InviteQueryVariables,
  InviteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InviteQuery, InviteQueryVariables, InviteProps<TChildProps, TDataName>>(InviteDocument, {
      alias: 'invite',
      ...operationOptions
    });
};

/**
 * __useInviteQuery__
 *
 * To run a query within a React component, call `useInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useInviteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InviteQuery, InviteQueryVariables> & ({ variables: InviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
      }
export function useInviteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
// @ts-ignore
export function useInviteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InviteQuery, InviteQueryVariables>;
export function useInviteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InviteQuery | undefined, InviteQueryVariables>;
export function useInviteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
export type InviteQueryHookResult = ReturnType<typeof useInviteQuery>;
export type InviteLazyQueryHookResult = ReturnType<typeof useInviteLazyQuery>;
export type InviteSuspenseQueryHookResult = ReturnType<typeof useInviteSuspenseQuery>;
export type InviteQueryResult = ApolloReactCommon.QueryResult<InviteQuery, InviteQueryVariables>;
export const FetchEntityJobsDocument = gql`
    query FetchEntityJobs($entityName: String!, $pattern: String) {
  entity(name: $entityName) {
    id
    name
    projects(first: 100, pattern: $pattern) {
      edges {
        node {
          id
          name
          artifactType(name: "job") {
            id
            artifactCollections {
              edges {
                node {
                  id
                  name
                  description
                  artifacts {
                    edges {
                      node {
                        id
                        description
                        labels
                        versionIndex
                        aliases {
                          id
                          alias
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type FetchEntityJobsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>, 'query'> & ({ variables: FetchEntityJobsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchEntityJobsComponent = (props: FetchEntityJobsComponentProps) => (
      <ApolloReactComponents.Query<FetchEntityJobsQuery, FetchEntityJobsQueryVariables> query={FetchEntityJobsDocument} {...props} />
    );
    
export type FetchEntityJobsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>
    } & TChildProps;
export function withFetchEntityJobs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchEntityJobsQuery,
  FetchEntityJobsQueryVariables,
  FetchEntityJobsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchEntityJobsQuery, FetchEntityJobsQueryVariables, FetchEntityJobsProps<TChildProps, TDataName>>(FetchEntityJobsDocument, {
      alias: 'fetchEntityJobs',
      ...operationOptions
    });
};

/**
 * __useFetchEntityJobsQuery__
 *
 * To run a query within a React component, call `useFetchEntityJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEntityJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEntityJobsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useFetchEntityJobsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables> & ({ variables: FetchEntityJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>(FetchEntityJobsDocument, options);
      }
export function useFetchEntityJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>(FetchEntityJobsDocument, options);
        }
// @ts-ignore
export function useFetchEntityJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>;
export function useFetchEntityJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityJobsQuery | undefined, FetchEntityJobsQueryVariables>;
export function useFetchEntityJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>(FetchEntityJobsDocument, options);
        }
export type FetchEntityJobsQueryHookResult = ReturnType<typeof useFetchEntityJobsQuery>;
export type FetchEntityJobsLazyQueryHookResult = ReturnType<typeof useFetchEntityJobsLazyQuery>;
export type FetchEntityJobsSuspenseQueryHookResult = ReturnType<typeof useFetchEntityJobsSuspenseQuery>;
export type FetchEntityJobsQueryResult = ApolloReactCommon.QueryResult<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>;
export const FetchProjectJobsPartialDocument = gql`
    query FetchProjectJobsPartial($entityName: String!, $projectName: String!, $limit: Int!, $after: String, $filters: JSONString) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    internalId
    artifactType(name: "job") {
      id
      artifactCollections(first: $limit, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...JobInfo
          }
        }
      }
    }
  }
}
    ${JobInfoFragmentDoc}`;
export type FetchProjectJobsPartialComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>, 'query'> & ({ variables: FetchProjectJobsPartialQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectJobsPartialComponent = (props: FetchProjectJobsPartialComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables> query={FetchProjectJobsPartialDocument} {...props} />
    );
    
export type FetchProjectJobsPartialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>
    } & TChildProps;
export function withFetchProjectJobsPartial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectJobsPartialQuery,
  FetchProjectJobsPartialQueryVariables,
  FetchProjectJobsPartialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables, FetchProjectJobsPartialProps<TChildProps, TDataName>>(FetchProjectJobsPartialDocument, {
      alias: 'fetchProjectJobsPartial',
      ...operationOptions
    });
};

/**
 * __useFetchProjectJobsPartialQuery__
 *
 * To run a query within a React component, call `useFetchProjectJobsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectJobsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectJobsPartialQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchProjectJobsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables> & ({ variables: FetchProjectJobsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>(FetchProjectJobsPartialDocument, options);
      }
export function useFetchProjectJobsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>(FetchProjectJobsPartialDocument, options);
        }
// @ts-ignore
export function useFetchProjectJobsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>;
export function useFetchProjectJobsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsPartialQuery | undefined, FetchProjectJobsPartialQueryVariables>;
export function useFetchProjectJobsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>(FetchProjectJobsPartialDocument, options);
        }
export type FetchProjectJobsPartialQueryHookResult = ReturnType<typeof useFetchProjectJobsPartialQuery>;
export type FetchProjectJobsPartialLazyQueryHookResult = ReturnType<typeof useFetchProjectJobsPartialLazyQuery>;
export type FetchProjectJobsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchProjectJobsPartialSuspenseQuery>;
export type FetchProjectJobsPartialQueryResult = ApolloReactCommon.QueryResult<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>;
export const FetchProjectInternalIdDocument = gql`
    query FetchProjectInternalId($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    internalId
  }
}
    `;
export type FetchProjectInternalIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>, 'query'> & ({ variables: FetchProjectInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectInternalIdComponent = (props: FetchProjectInternalIdComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables> query={FetchProjectInternalIdDocument} {...props} />
    );
    
export type FetchProjectInternalIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>
    } & TChildProps;
export function withFetchProjectInternalId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectInternalIdQuery,
  FetchProjectInternalIdQueryVariables,
  FetchProjectInternalIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables, FetchProjectInternalIdProps<TChildProps, TDataName>>(FetchProjectInternalIdDocument, {
      alias: 'fetchProjectInternalId',
      ...operationOptions
    });
};

/**
 * __useFetchProjectInternalIdQuery__
 *
 * To run a query within a React component, call `useFetchProjectInternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectInternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectInternalIdQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchProjectInternalIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables> & ({ variables: FetchProjectInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>(FetchProjectInternalIdDocument, options);
      }
export function useFetchProjectInternalIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>(FetchProjectInternalIdDocument, options);
        }
// @ts-ignore
export function useFetchProjectInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>;
export function useFetchProjectInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectInternalIdQuery | undefined, FetchProjectInternalIdQueryVariables>;
export function useFetchProjectInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>(FetchProjectInternalIdDocument, options);
        }
export type FetchProjectInternalIdQueryHookResult = ReturnType<typeof useFetchProjectInternalIdQuery>;
export type FetchProjectInternalIdLazyQueryHookResult = ReturnType<typeof useFetchProjectInternalIdLazyQuery>;
export type FetchProjectInternalIdSuspenseQueryHookResult = ReturnType<typeof useFetchProjectInternalIdSuspenseQuery>;
export type FetchProjectInternalIdQueryResult = ApolloReactCommon.QueryResult<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>;
export const FetchProjectJobsDocument = gql`
    query FetchProjectJobs($entityName: String!, $projectName: String!, $filters: JSONString) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactType(name: "job") {
      id
      artifactCollections {
        edges {
          node {
            ...JobInfo
          }
        }
      }
    }
  }
}
    ${JobInfoFragmentDoc}`;
export type FetchProjectJobsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>, 'query'> & ({ variables: FetchProjectJobsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectJobsComponent = (props: FetchProjectJobsComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectJobsQuery, FetchProjectJobsQueryVariables> query={FetchProjectJobsDocument} {...props} />
    );
    
export type FetchProjectJobsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>
    } & TChildProps;
export function withFetchProjectJobs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectJobsQuery,
  FetchProjectJobsQueryVariables,
  FetchProjectJobsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectJobsQuery, FetchProjectJobsQueryVariables, FetchProjectJobsProps<TChildProps, TDataName>>(FetchProjectJobsDocument, {
      alias: 'fetchProjectJobs',
      ...operationOptions
    });
};

/**
 * __useFetchProjectJobsQuery__
 *
 * To run a query within a React component, call `useFetchProjectJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectJobsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchProjectJobsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables> & ({ variables: FetchProjectJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>(FetchProjectJobsDocument, options);
      }
export function useFetchProjectJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>(FetchProjectJobsDocument, options);
        }
// @ts-ignore
export function useFetchProjectJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>;
export function useFetchProjectJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsQuery | undefined, FetchProjectJobsQueryVariables>;
export function useFetchProjectJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>(FetchProjectJobsDocument, options);
        }
export type FetchProjectJobsQueryHookResult = ReturnType<typeof useFetchProjectJobsQuery>;
export type FetchProjectJobsLazyQueryHookResult = ReturnType<typeof useFetchProjectJobsLazyQuery>;
export type FetchProjectJobsSuspenseQueryHookResult = ReturnType<typeof useFetchProjectJobsSuspenseQuery>;
export type FetchProjectJobsQueryResult = ApolloReactCommon.QueryResult<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>;
export const FetchRecentlyUsedJobsDocument = gql`
    query FetchRecentlyUsedJobs($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    runs(first: 100) {
      edges {
        node {
          id
          createdAt
          job {
            id
            artifactSequence {
              id
              name
              state
              project {
                id
                name
                entityName
              }
              description
              createdAt
            }
          }
        }
      }
    }
  }
}
    `;
export type FetchRecentlyUsedJobsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>, 'query'> & ({ variables: FetchRecentlyUsedJobsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRecentlyUsedJobsComponent = (props: FetchRecentlyUsedJobsComponentProps) => (
      <ApolloReactComponents.Query<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables> query={FetchRecentlyUsedJobsDocument} {...props} />
    );
    
export type FetchRecentlyUsedJobsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>
    } & TChildProps;
export function withFetchRecentlyUsedJobs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRecentlyUsedJobsQuery,
  FetchRecentlyUsedJobsQueryVariables,
  FetchRecentlyUsedJobsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables, FetchRecentlyUsedJobsProps<TChildProps, TDataName>>(FetchRecentlyUsedJobsDocument, {
      alias: 'fetchRecentlyUsedJobs',
      ...operationOptions
    });
};

/**
 * __useFetchRecentlyUsedJobsQuery__
 *
 * To run a query within a React component, call `useFetchRecentlyUsedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecentlyUsedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecentlyUsedJobsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchRecentlyUsedJobsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables> & ({ variables: FetchRecentlyUsedJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>(FetchRecentlyUsedJobsDocument, options);
      }
export function useFetchRecentlyUsedJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>(FetchRecentlyUsedJobsDocument, options);
        }
// @ts-ignore
export function useFetchRecentlyUsedJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>;
export function useFetchRecentlyUsedJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRecentlyUsedJobsQuery | undefined, FetchRecentlyUsedJobsQueryVariables>;
export function useFetchRecentlyUsedJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>(FetchRecentlyUsedJobsDocument, options);
        }
export type FetchRecentlyUsedJobsQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobsQuery>;
export type FetchRecentlyUsedJobsLazyQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobsLazyQuery>;
export type FetchRecentlyUsedJobsSuspenseQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobsSuspenseQuery>;
export type FetchRecentlyUsedJobsQueryResult = ApolloReactCommon.QueryResult<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>;
export const FetchJobVersionsDocument = gql`
    query FetchJobVersions($entityName: String!, $projectName: String!, $jobName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    artifactCollection(name: $jobName) {
      id
      description
      artifacts {
        edges {
          node {
            id
            createdAt
            createdBy {
              __typename
              ... on User {
                id
                name
                username
                photoUrl
              }
              ... on Run {
                id
                name
                displayName
                defaultColorIndex
              }
            }
            aliases {
              id
              alias
            }
          }
        }
      }
    }
  }
}
    `;
export type FetchJobVersionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>, 'query'> & ({ variables: FetchJobVersionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchJobVersionsComponent = (props: FetchJobVersionsComponentProps) => (
      <ApolloReactComponents.Query<FetchJobVersionsQuery, FetchJobVersionsQueryVariables> query={FetchJobVersionsDocument} {...props} />
    );
    
export type FetchJobVersionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>
    } & TChildProps;
export function withFetchJobVersions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchJobVersionsQuery,
  FetchJobVersionsQueryVariables,
  FetchJobVersionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchJobVersionsQuery, FetchJobVersionsQueryVariables, FetchJobVersionsProps<TChildProps, TDataName>>(FetchJobVersionsDocument, {
      alias: 'fetchJobVersions',
      ...operationOptions
    });
};

/**
 * __useFetchJobVersionsQuery__
 *
 * To run a query within a React component, call `useFetchJobVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobVersionsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      jobName: // value for 'jobName'
 *   },
 * });
 */
export function useFetchJobVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables> & ({ variables: FetchJobVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>(FetchJobVersionsDocument, options);
      }
export function useFetchJobVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>(FetchJobVersionsDocument, options);
        }
// @ts-ignore
export function useFetchJobVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>;
export function useFetchJobVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobVersionsQuery | undefined, FetchJobVersionsQueryVariables>;
export function useFetchJobVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>(FetchJobVersionsDocument, options);
        }
export type FetchJobVersionsQueryHookResult = ReturnType<typeof useFetchJobVersionsQuery>;
export type FetchJobVersionsLazyQueryHookResult = ReturnType<typeof useFetchJobVersionsLazyQuery>;
export type FetchJobVersionsSuspenseQueryHookResult = ReturnType<typeof useFetchJobVersionsSuspenseQuery>;
export type FetchJobVersionsQueryResult = ApolloReactCommon.QueryResult<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>;
export const FetchRecentlyUsedJobDetailDocument = gql`
    query FetchRecentlyUsedJobDetail($entityName: String!, $projectName: String!, $limit: Int!, $after: String, $filters: JSONString, $artifactCollectionFilters: JSONString) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    internalId
    entityName
    artifactType(name: "job") {
      id
      artifactCollections(
        first: $limit
        after: $after
        filters: $artifactCollectionFilters
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            project {
              id
              name
              entityName
            }
            ...JobInfo
          }
        }
      }
    }
  }
}
    ${JobInfoFragmentDoc}`;
export type FetchRecentlyUsedJobDetailComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>, 'query'> & ({ variables: FetchRecentlyUsedJobDetailQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRecentlyUsedJobDetailComponent = (props: FetchRecentlyUsedJobDetailComponentProps) => (
      <ApolloReactComponents.Query<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables> query={FetchRecentlyUsedJobDetailDocument} {...props} />
    );
    
export type FetchRecentlyUsedJobDetailProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>
    } & TChildProps;
export function withFetchRecentlyUsedJobDetail<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRecentlyUsedJobDetailQuery,
  FetchRecentlyUsedJobDetailQueryVariables,
  FetchRecentlyUsedJobDetailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables, FetchRecentlyUsedJobDetailProps<TChildProps, TDataName>>(FetchRecentlyUsedJobDetailDocument, {
      alias: 'fetchRecentlyUsedJobDetail',
      ...operationOptions
    });
};

/**
 * __useFetchRecentlyUsedJobDetailQuery__
 *
 * To run a query within a React component, call `useFetchRecentlyUsedJobDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecentlyUsedJobDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecentlyUsedJobDetailQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      artifactCollectionFilters: // value for 'artifactCollectionFilters'
 *   },
 * });
 */
export function useFetchRecentlyUsedJobDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables> & ({ variables: FetchRecentlyUsedJobDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>(FetchRecentlyUsedJobDetailDocument, options);
      }
export function useFetchRecentlyUsedJobDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>(FetchRecentlyUsedJobDetailDocument, options);
        }
// @ts-ignore
export function useFetchRecentlyUsedJobDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>;
export function useFetchRecentlyUsedJobDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRecentlyUsedJobDetailQuery | undefined, FetchRecentlyUsedJobDetailQueryVariables>;
export function useFetchRecentlyUsedJobDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>(FetchRecentlyUsedJobDetailDocument, options);
        }
export type FetchRecentlyUsedJobDetailQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobDetailQuery>;
export type FetchRecentlyUsedJobDetailLazyQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobDetailLazyQuery>;
export type FetchRecentlyUsedJobDetailSuspenseQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobDetailSuspenseQuery>;
export type FetchRecentlyUsedJobDetailQueryResult = ApolloReactCommon.QueryResult<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>;
export const FetchJobDocument = gql`
    query FetchJob($jobId: ID!) {
  artifactCollection(id: $jobId) {
    id
    name
  }
}
    `;
export type FetchJobComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchJobQuery, FetchJobQueryVariables>, 'query'> & ({ variables: FetchJobQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchJobComponent = (props: FetchJobComponentProps) => (
      <ApolloReactComponents.Query<FetchJobQuery, FetchJobQueryVariables> query={FetchJobDocument} {...props} />
    );
    
export type FetchJobProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchJobQuery, FetchJobQueryVariables>
    } & TChildProps;
export function withFetchJob<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchJobQuery,
  FetchJobQueryVariables,
  FetchJobProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchJobQuery, FetchJobQueryVariables, FetchJobProps<TChildProps, TDataName>>(FetchJobDocument, {
      alias: 'fetchJob',
      ...operationOptions
    });
};

/**
 * __useFetchJobQuery__
 *
 * To run a query within a React component, call `useFetchJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useFetchJobQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchJobQuery, FetchJobQueryVariables> & ({ variables: FetchJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchJobQuery, FetchJobQueryVariables>(FetchJobDocument, options);
      }
export function useFetchJobLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchJobQuery, FetchJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchJobQuery, FetchJobQueryVariables>(FetchJobDocument, options);
        }
// @ts-ignore
export function useFetchJobSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchJobQuery, FetchJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobQuery, FetchJobQueryVariables>;
export function useFetchJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobQuery, FetchJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobQuery | undefined, FetchJobQueryVariables>;
export function useFetchJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobQuery, FetchJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchJobQuery, FetchJobQueryVariables>(FetchJobDocument, options);
        }
export type FetchJobQueryHookResult = ReturnType<typeof useFetchJobQuery>;
export type FetchJobLazyQueryHookResult = ReturnType<typeof useFetchJobLazyQuery>;
export type FetchJobSuspenseQueryHookResult = ReturnType<typeof useFetchJobSuspenseQuery>;
export type FetchJobQueryResult = ApolloReactCommon.QueryResult<FetchJobQuery, FetchJobQueryVariables>;
export const FetchJobDetailsDocument = gql`
    query FetchJobDetails($jobId: ID!, $usedByFilters: JSONString, $usedByFirst: Int) {
  artifactCollection(id: $jobId) {
    id
    name
    description
    createdAt
    project {
      id
      access
      name
      entity {
        id
        name
      }
    }
    artifacts {
      edges {
        node {
          id
          description
          labels
          versionIndex
          aliases {
            id
            alias
          }
          createdAt
          createdBy {
            __typename
            ... on User {
              id
              name
              username
              photoUrl
            }
            ... on Run {
              id
              name
              displayName
              defaultColorIndex
            }
          }
          usedBy(filters: $usedByFilters, first: $usedByFirst) {
            totalCount
            edges {
              node {
                id
                name
                displayName
                state
                stopped
                createdAt
                user {
                  id
                  name
                  username
                  photoUrl
                }
                config
                project {
                  id
                  name
                  entity {
                    id
                    name
                  }
                }
                defaultColorIndex
                runInfo {
                  args
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type FetchJobDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>, 'query'> & ({ variables: FetchJobDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchJobDetailsComponent = (props: FetchJobDetailsComponentProps) => (
      <ApolloReactComponents.Query<FetchJobDetailsQuery, FetchJobDetailsQueryVariables> query={FetchJobDetailsDocument} {...props} />
    );
    
export type FetchJobDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>
    } & TChildProps;
export function withFetchJobDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchJobDetailsQuery,
  FetchJobDetailsQueryVariables,
  FetchJobDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchJobDetailsQuery, FetchJobDetailsQueryVariables, FetchJobDetailsProps<TChildProps, TDataName>>(FetchJobDetailsDocument, {
      alias: 'fetchJobDetails',
      ...operationOptions
    });
};

/**
 * __useFetchJobDetailsQuery__
 *
 * To run a query within a React component, call `useFetchJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobDetailsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      usedByFilters: // value for 'usedByFilters'
 *      usedByFirst: // value for 'usedByFirst'
 *   },
 * });
 */
export function useFetchJobDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables> & ({ variables: FetchJobDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>(FetchJobDetailsDocument, options);
      }
export function useFetchJobDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>(FetchJobDetailsDocument, options);
        }
// @ts-ignore
export function useFetchJobDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>;
export function useFetchJobDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobDetailsQuery | undefined, FetchJobDetailsQueryVariables>;
export function useFetchJobDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>(FetchJobDetailsDocument, options);
        }
export type FetchJobDetailsQueryHookResult = ReturnType<typeof useFetchJobDetailsQuery>;
export type FetchJobDetailsLazyQueryHookResult = ReturnType<typeof useFetchJobDetailsLazyQuery>;
export type FetchJobDetailsSuspenseQueryHookResult = ReturnType<typeof useFetchJobDetailsSuspenseQuery>;
export type FetchJobDetailsQueryResult = ApolloReactCommon.QueryResult<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>;
export const FetchProjectRunsDocument = gql`
    query FetchProjectRuns($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    runs {
      edges {
        node {
          id
          name
          displayName
          runInfo {
            git {
              remote
              commit
            }
          }
        }
      }
    }
  }
}
    `;
export type FetchProjectRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>, 'query'> & ({ variables: FetchProjectRunsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectRunsComponent = (props: FetchProjectRunsComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectRunsQuery, FetchProjectRunsQueryVariables> query={FetchProjectRunsDocument} {...props} />
    );
    
export type FetchProjectRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>
    } & TChildProps;
export function withFetchProjectRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectRunsQuery,
  FetchProjectRunsQueryVariables,
  FetchProjectRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectRunsQuery, FetchProjectRunsQueryVariables, FetchProjectRunsProps<TChildProps, TDataName>>(FetchProjectRunsDocument, {
      alias: 'fetchProjectRuns',
      ...operationOptions
    });
};

/**
 * __useFetchProjectRunsQuery__
 *
 * To run a query within a React component, call `useFetchProjectRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectRunsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchProjectRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables> & ({ variables: FetchProjectRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>(FetchProjectRunsDocument, options);
      }
export function useFetchProjectRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>(FetchProjectRunsDocument, options);
        }
// @ts-ignore
export function useFetchProjectRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>;
export function useFetchProjectRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectRunsQuery | undefined, FetchProjectRunsQueryVariables>;
export function useFetchProjectRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>(FetchProjectRunsDocument, options);
        }
export type FetchProjectRunsQueryHookResult = ReturnType<typeof useFetchProjectRunsQuery>;
export type FetchProjectRunsLazyQueryHookResult = ReturnType<typeof useFetchProjectRunsLazyQuery>;
export type FetchProjectRunsSuspenseQueryHookResult = ReturnType<typeof useFetchProjectRunsSuspenseQuery>;
export type FetchProjectRunsQueryResult = ApolloReactCommon.QueryResult<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>;
export const FetchProjectLaunchQueuesDocument = gql`
    query FetchProjectLaunchQueues($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    entity {
      id
      isTeam
      name
    }
    runQueues {
      id
      name
      access
      defaultResourceConfigID
      prioritizationMode
    }
  }
}
    `;
export type FetchProjectLaunchQueuesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>, 'query'> & ({ variables: FetchProjectLaunchQueuesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectLaunchQueuesComponent = (props: FetchProjectLaunchQueuesComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables> query={FetchProjectLaunchQueuesDocument} {...props} />
    );
    
export type FetchProjectLaunchQueuesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>
    } & TChildProps;
export function withFetchProjectLaunchQueues<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectLaunchQueuesQuery,
  FetchProjectLaunchQueuesQueryVariables,
  FetchProjectLaunchQueuesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables, FetchProjectLaunchQueuesProps<TChildProps, TDataName>>(FetchProjectLaunchQueuesDocument, {
      alias: 'fetchProjectLaunchQueues',
      ...operationOptions
    });
};

/**
 * __useFetchProjectLaunchQueuesQuery__
 *
 * To run a query within a React component, call `useFetchProjectLaunchQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectLaunchQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectLaunchQueuesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchProjectLaunchQueuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables> & ({ variables: FetchProjectLaunchQueuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>(FetchProjectLaunchQueuesDocument, options);
      }
export function useFetchProjectLaunchQueuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>(FetchProjectLaunchQueuesDocument, options);
        }
// @ts-ignore
export function useFetchProjectLaunchQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>;
export function useFetchProjectLaunchQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectLaunchQueuesQuery | undefined, FetchProjectLaunchQueuesQueryVariables>;
export function useFetchProjectLaunchQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>(FetchProjectLaunchQueuesDocument, options);
        }
export type FetchProjectLaunchQueuesQueryHookResult = ReturnType<typeof useFetchProjectLaunchQueuesQuery>;
export type FetchProjectLaunchQueuesLazyQueryHookResult = ReturnType<typeof useFetchProjectLaunchQueuesLazyQuery>;
export type FetchProjectLaunchQueuesSuspenseQueryHookResult = ReturnType<typeof useFetchProjectLaunchQueuesSuspenseQuery>;
export type FetchProjectLaunchQueuesQueryResult = ApolloReactCommon.QueryResult<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>;
export const FetchEntityProjectsDocument = gql`
    query FetchEntityProjects($entityName: String!) {
  entity(name: $entityName) {
    id
    projects(first: 100, order: "-createdAt") {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;
export type FetchEntityProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>, 'query'> & ({ variables: FetchEntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchEntityProjectsComponent = (props: FetchEntityProjectsComponentProps) => (
      <ApolloReactComponents.Query<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables> query={FetchEntityProjectsDocument} {...props} />
    );
    
export type FetchEntityProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>
    } & TChildProps;
export function withFetchEntityProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchEntityProjectsQuery,
  FetchEntityProjectsQueryVariables,
  FetchEntityProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables, FetchEntityProjectsProps<TChildProps, TDataName>>(FetchEntityProjectsDocument, {
      alias: 'fetchEntityProjects',
      ...operationOptions
    });
};

/**
 * __useFetchEntityProjectsQuery__
 *
 * To run a query within a React component, call `useFetchEntityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEntityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEntityProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useFetchEntityProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables> & ({ variables: FetchEntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>(FetchEntityProjectsDocument, options);
      }
export function useFetchEntityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>(FetchEntityProjectsDocument, options);
        }
// @ts-ignore
export function useFetchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>;
export function useFetchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityProjectsQuery | undefined, FetchEntityProjectsQueryVariables>;
export function useFetchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>(FetchEntityProjectsDocument, options);
        }
export type FetchEntityProjectsQueryHookResult = ReturnType<typeof useFetchEntityProjectsQuery>;
export type FetchEntityProjectsLazyQueryHookResult = ReturnType<typeof useFetchEntityProjectsLazyQuery>;
export type FetchEntityProjectsSuspenseQueryHookResult = ReturnType<typeof useFetchEntityProjectsSuspenseQuery>;
export type FetchEntityProjectsQueryResult = ApolloReactCommon.QueryResult<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>;
export const EntityPhotoDocument = gql`
    query EntityPhoto($entityName: String!) {
  entity(name: $entityName) {
    id
    photoUrl
  }
}
    `;
export type EntityPhotoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityPhotoQuery, EntityPhotoQueryVariables>, 'query'> & ({ variables: EntityPhotoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityPhotoComponent = (props: EntityPhotoComponentProps) => (
      <ApolloReactComponents.Query<EntityPhotoQuery, EntityPhotoQueryVariables> query={EntityPhotoDocument} {...props} />
    );
    
export type EntityPhotoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityPhotoQuery, EntityPhotoQueryVariables>
    } & TChildProps;
export function withEntityPhoto<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityPhotoQuery,
  EntityPhotoQueryVariables,
  EntityPhotoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityPhotoQuery, EntityPhotoQueryVariables, EntityPhotoProps<TChildProps, TDataName>>(EntityPhotoDocument, {
      alias: 'entityPhoto',
      ...operationOptions
    });
};

/**
 * __useEntityPhotoQuery__
 *
 * To run a query within a React component, call `useEntityPhotoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPhotoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPhotoQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityPhotoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables> & ({ variables: EntityPhotoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityPhotoQuery, EntityPhotoQueryVariables>(EntityPhotoDocument, options);
      }
export function useEntityPhotoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityPhotoQuery, EntityPhotoQueryVariables>(EntityPhotoDocument, options);
        }
// @ts-ignore
export function useEntityPhotoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPhotoQuery, EntityPhotoQueryVariables>;
export function useEntityPhotoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPhotoQuery | undefined, EntityPhotoQueryVariables>;
export function useEntityPhotoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityPhotoQuery, EntityPhotoQueryVariables>(EntityPhotoDocument, options);
        }
export type EntityPhotoQueryHookResult = ReturnType<typeof useEntityPhotoQuery>;
export type EntityPhotoLazyQueryHookResult = ReturnType<typeof useEntityPhotoLazyQuery>;
export type EntityPhotoSuspenseQueryHookResult = ReturnType<typeof useEntityPhotoSuspenseQuery>;
export type EntityPhotoQueryResult = ApolloReactCommon.QueryResult<EntityPhotoQuery, EntityPhotoQueryVariables>;
export const UserEntitiesDocument = gql`
    query UserEntities {
  viewer {
    id
    teams {
      edges {
        node {
          id
          name
          photoUrl
          members {
            id
            username
            role
          }
        }
      }
    }
  }
}
    `;
export type UserEntitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserEntitiesQuery, UserEntitiesQueryVariables>, 'query'>;

    export const UserEntitiesComponent = (props: UserEntitiesComponentProps) => (
      <ApolloReactComponents.Query<UserEntitiesQuery, UserEntitiesQueryVariables> query={UserEntitiesDocument} {...props} />
    );
    
export type UserEntitiesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserEntitiesQuery, UserEntitiesQueryVariables>
    } & TChildProps;
export function withUserEntities<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserEntitiesQuery,
  UserEntitiesQueryVariables,
  UserEntitiesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserEntitiesQuery, UserEntitiesQueryVariables, UserEntitiesProps<TChildProps, TDataName>>(UserEntitiesDocument, {
      alias: 'userEntities',
      ...operationOptions
    });
};

/**
 * __useUserEntitiesQuery__
 *
 * To run a query within a React component, call `useUserEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEntitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserEntitiesQuery, UserEntitiesQueryVariables>(UserEntitiesDocument, options);
      }
export function useUserEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserEntitiesQuery, UserEntitiesQueryVariables>(UserEntitiesDocument, options);
        }
// @ts-ignore
export function useUserEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEntitiesQuery, UserEntitiesQueryVariables>;
export function useUserEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEntitiesQuery | undefined, UserEntitiesQueryVariables>;
export function useUserEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserEntitiesQuery, UserEntitiesQueryVariables>(UserEntitiesDocument, options);
        }
export type UserEntitiesQueryHookResult = ReturnType<typeof useUserEntitiesQuery>;
export type UserEntitiesLazyQueryHookResult = ReturnType<typeof useUserEntitiesLazyQuery>;
export type UserEntitiesSuspenseQueryHookResult = ReturnType<typeof useUserEntitiesSuspenseQuery>;
export type UserEntitiesQueryResult = ApolloReactCommon.QueryResult<UserEntitiesQuery, UserEntitiesQueryVariables>;
export const ViewerDestinationProjectsDocument = gql`
    query ViewerDestinationProjects {
  viewer {
    id
    teams {
      edges {
        node {
          id
          name
          projects {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ViewerDestinationProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>, 'query'>;

    export const ViewerDestinationProjectsComponent = (props: ViewerDestinationProjectsComponentProps) => (
      <ApolloReactComponents.Query<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables> query={ViewerDestinationProjectsDocument} {...props} />
    );
    
export type ViewerDestinationProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>
    } & TChildProps;
export function withViewerDestinationProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerDestinationProjectsQuery,
  ViewerDestinationProjectsQueryVariables,
  ViewerDestinationProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables, ViewerDestinationProjectsProps<TChildProps, TDataName>>(ViewerDestinationProjectsDocument, {
      alias: 'viewerDestinationProjects',
      ...operationOptions
    });
};

/**
 * __useViewerDestinationProjectsQuery__
 *
 * To run a query within a React component, call `useViewerDestinationProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerDestinationProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerDestinationProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerDestinationProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>(ViewerDestinationProjectsDocument, options);
      }
export function useViewerDestinationProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>(ViewerDestinationProjectsDocument, options);
        }
// @ts-ignore
export function useViewerDestinationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>;
export function useViewerDestinationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDestinationProjectsQuery | undefined, ViewerDestinationProjectsQueryVariables>;
export function useViewerDestinationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>(ViewerDestinationProjectsDocument, options);
        }
export type ViewerDestinationProjectsQueryHookResult = ReturnType<typeof useViewerDestinationProjectsQuery>;
export type ViewerDestinationProjectsLazyQueryHookResult = ReturnType<typeof useViewerDestinationProjectsLazyQuery>;
export type ViewerDestinationProjectsSuspenseQueryHookResult = ReturnType<typeof useViewerDestinationProjectsSuspenseQuery>;
export type ViewerDestinationProjectsQueryResult = ApolloReactCommon.QueryResult<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>;
export const QueueNamesDocument = gql`
    query QueueNames($entityName: String) {
  project(name: "model-registry", entityName: $entityName) {
    id
    runQueues {
      id
      name
    }
  }
}
    `;
export type QueueNamesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QueueNamesQuery, QueueNamesQueryVariables>, 'query'>;

    export const QueueNamesComponent = (props: QueueNamesComponentProps) => (
      <ApolloReactComponents.Query<QueueNamesQuery, QueueNamesQueryVariables> query={QueueNamesDocument} {...props} />
    );
    
export type QueueNamesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<QueueNamesQuery, QueueNamesQueryVariables>
    } & TChildProps;
export function withQueueNames<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QueueNamesQuery,
  QueueNamesQueryVariables,
  QueueNamesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, QueueNamesQuery, QueueNamesQueryVariables, QueueNamesProps<TChildProps, TDataName>>(QueueNamesDocument, {
      alias: 'queueNames',
      ...operationOptions
    });
};

/**
 * __useQueueNamesQuery__
 *
 * To run a query within a React component, call `useQueueNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueNamesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useQueueNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QueueNamesQuery, QueueNamesQueryVariables>(QueueNamesDocument, options);
      }
export function useQueueNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QueueNamesQuery, QueueNamesQueryVariables>(QueueNamesDocument, options);
        }
// @ts-ignore
export function useQueueNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueNamesQuery, QueueNamesQueryVariables>;
export function useQueueNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueNamesQuery | undefined, QueueNamesQueryVariables>;
export function useQueueNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QueueNamesQuery, QueueNamesQueryVariables>(QueueNamesDocument, options);
        }
export type QueueNamesQueryHookResult = ReturnType<typeof useQueueNamesQuery>;
export type QueueNamesLazyQueryHookResult = ReturnType<typeof useQueueNamesLazyQuery>;
export type QueueNamesSuspenseQueryHookResult = ReturnType<typeof useQueueNamesSuspenseQuery>;
export type QueueNamesQueryResult = ApolloReactCommon.QueryResult<QueueNamesQuery, QueueNamesQueryVariables>;
export const AllQueuesDocument = gql`
    query AllQueues {
  viewer {
    id
    entity
    teams {
      edges {
        node {
          id
          name
          organizationId
          launchProject {
            id
            name
            launchAgents {
              id
              name
              createdAt
              heartbeatAt
              agentStatus
              stopPolling
              runQueues
              hostname
            }
            runQueues {
              id
              createdAt
              createdBy
              updatedAt
              name
              access
              prioritizationMode
              executorInfo
              externalLinks
              defaultResourceConfig {
                id
                ...DefaultResourceConfigFragment
              }
              runQueueItems(first: 500) {
                edges {
                  node {
                    id
                    ...RunQueueItemFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DefaultResourceConfigFragmentFragmentDoc}
${RunQueueItemFragmentFragmentDoc}`;
export type AllQueuesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllQueuesQuery, AllQueuesQueryVariables>, 'query'>;

    export const AllQueuesComponent = (props: AllQueuesComponentProps) => (
      <ApolloReactComponents.Query<AllQueuesQuery, AllQueuesQueryVariables> query={AllQueuesDocument} {...props} />
    );
    
export type AllQueuesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllQueuesQuery, AllQueuesQueryVariables>
    } & TChildProps;
export function withAllQueues<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllQueuesQuery,
  AllQueuesQueryVariables,
  AllQueuesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllQueuesQuery, AllQueuesQueryVariables, AllQueuesProps<TChildProps, TDataName>>(AllQueuesDocument, {
      alias: 'allQueues',
      ...operationOptions
    });
};

/**
 * __useAllQueuesQuery__
 *
 * To run a query within a React component, call `useAllQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllQueuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllQueuesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllQueuesQuery, AllQueuesQueryVariables>(AllQueuesDocument, options);
      }
export function useAllQueuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllQueuesQuery, AllQueuesQueryVariables>(AllQueuesDocument, options);
        }
// @ts-ignore
export function useAllQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllQueuesQuery, AllQueuesQueryVariables>;
export function useAllQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllQueuesQuery | undefined, AllQueuesQueryVariables>;
export function useAllQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllQueuesQuery, AllQueuesQueryVariables>(AllQueuesDocument, options);
        }
export type AllQueuesQueryHookResult = ReturnType<typeof useAllQueuesQuery>;
export type AllQueuesLazyQueryHookResult = ReturnType<typeof useAllQueuesLazyQuery>;
export type AllQueuesSuspenseQueryHookResult = ReturnType<typeof useAllQueuesSuspenseQuery>;
export type AllQueuesQueryResult = ApolloReactCommon.QueryResult<AllQueuesQuery, AllQueuesQueryVariables>;
export const PublicQueueDocument = gql`
    query PublicQueue($entityName: String, $publicQueueName: String) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
      runQueue(name: $publicQueueName) {
        id
        createdAt
        createdBy
        updatedAt
        name
        access
        prioritizationMode
        executorInfo
        externalLinks
        defaultResourceConfig {
          id
          ...DefaultResourceConfigFragment
        }
        runQueueItems(first: 500) {
          edges {
            node {
              id
              ...RunQueueItemFragment
              error {
                message
                stage
                filePaths
              }
              warnings {
                message
                stage
                filePaths
              }
            }
          }
        }
      }
    }
  }
}
    ${DefaultResourceConfigFragmentFragmentDoc}
${RunQueueItemFragmentFragmentDoc}`;
export type PublicQueueComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PublicQueueQuery, PublicQueueQueryVariables>, 'query'>;

    export const PublicQueueComponent = (props: PublicQueueComponentProps) => (
      <ApolloReactComponents.Query<PublicQueueQuery, PublicQueueQueryVariables> query={PublicQueueDocument} {...props} />
    );
    
export type PublicQueueProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PublicQueueQuery, PublicQueueQueryVariables>
    } & TChildProps;
export function withPublicQueue<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PublicQueueQuery,
  PublicQueueQueryVariables,
  PublicQueueProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PublicQueueQuery, PublicQueueQueryVariables, PublicQueueProps<TChildProps, TDataName>>(PublicQueueDocument, {
      alias: 'publicQueue',
      ...operationOptions
    });
};

/**
 * __usePublicQueueQuery__
 *
 * To run a query within a React component, call `usePublicQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicQueueQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      publicQueueName: // value for 'publicQueueName'
 *   },
 * });
 */
export function usePublicQueueQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublicQueueQuery, PublicQueueQueryVariables>(PublicQueueDocument, options);
      }
export function usePublicQueueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublicQueueQuery, PublicQueueQueryVariables>(PublicQueueDocument, options);
        }
// @ts-ignore
export function usePublicQueueSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicQueueQuery, PublicQueueQueryVariables>;
export function usePublicQueueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicQueueQuery | undefined, PublicQueueQueryVariables>;
export function usePublicQueueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublicQueueQuery, PublicQueueQueryVariables>(PublicQueueDocument, options);
        }
export type PublicQueueQueryHookResult = ReturnType<typeof usePublicQueueQuery>;
export type PublicQueueLazyQueryHookResult = ReturnType<typeof usePublicQueueLazyQuery>;
export type PublicQueueSuspenseQueryHookResult = ReturnType<typeof usePublicQueueSuspenseQuery>;
export type PublicQueueQueryResult = ApolloReactCommon.QueryResult<PublicQueueQuery, PublicQueueQueryVariables>;
export const QueueByIdLiteDocument = gql`
    query QueueByIDLite($entityName: String!, $queueId: ID!) {
  project(name: "model-registry", entityName: $entityName) {
    id
    name
    launchAgents {
      id
      name
      createdAt
      heartbeatAt
      agentStatus
      stopPolling
      runQueues
      hostname
    }
    runQueue(id: $queueId) {
      id
      createdAt
      name
      defaultResourceConfig {
        id
        createdAt
        resource
        config
        templateVariables {
          name
          description
          schema
        }
      }
      prioritizationMode
      executorInfo
      externalLinks
      runQueueItems(first: 500) {
        edges {
          node {
            id
            ...RunQueueItemFragment
          }
        }
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;
export type QueueByIdLiteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>, 'query'> & ({ variables: QueueByIdLiteQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const QueueByIdLiteComponent = (props: QueueByIdLiteComponentProps) => (
      <ApolloReactComponents.Query<QueueByIdLiteQuery, QueueByIdLiteQueryVariables> query={QueueByIdLiteDocument} {...props} />
    );
    
export type QueueByIdLiteProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>
    } & TChildProps;
export function withQueueByIdLite<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QueueByIdLiteQuery,
  QueueByIdLiteQueryVariables,
  QueueByIdLiteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, QueueByIdLiteQuery, QueueByIdLiteQueryVariables, QueueByIdLiteProps<TChildProps, TDataName>>(QueueByIdLiteDocument, {
      alias: 'queueByIdLite',
      ...operationOptions
    });
};

/**
 * __useQueueByIdLiteQuery__
 *
 * To run a query within a React component, call `useQueueByIdLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueByIdLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueByIdLiteQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useQueueByIdLiteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables> & ({ variables: QueueByIdLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>(QueueByIdLiteDocument, options);
      }
export function useQueueByIdLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>(QueueByIdLiteDocument, options);
        }
// @ts-ignore
export function useQueueByIdLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>;
export function useQueueByIdLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueByIdLiteQuery | undefined, QueueByIdLiteQueryVariables>;
export function useQueueByIdLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>(QueueByIdLiteDocument, options);
        }
export type QueueByIdLiteQueryHookResult = ReturnType<typeof useQueueByIdLiteQuery>;
export type QueueByIdLiteLazyQueryHookResult = ReturnType<typeof useQueueByIdLiteLazyQuery>;
export type QueueByIdLiteSuspenseQueryHookResult = ReturnType<typeof useQueueByIdLiteSuspenseQuery>;
export type QueueByIdLiteQueryResult = ApolloReactCommon.QueryResult<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>;
export const PublicQueueLiteDocument = gql`
    query PublicQueueLite($entityName: String, $publicQueueName: String) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
      runQueue(name: $publicQueueName) {
        id
        createdAt
        createdBy
        updatedAt
        name
        access
        prioritizationMode
        executorInfo
        externalLinks
        defaultResourceConfig {
          id
          ...DefaultResourceConfigFragment
        }
        runQueueItems(first: 500) {
          edges {
            node {
              id
              ...RunQueueItemFragment
            }
          }
        }
      }
    }
  }
}
    ${DefaultResourceConfigFragmentFragmentDoc}
${RunQueueItemFragmentFragmentDoc}`;
export type PublicQueueLiteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>, 'query'>;

    export const PublicQueueLiteComponent = (props: PublicQueueLiteComponentProps) => (
      <ApolloReactComponents.Query<PublicQueueLiteQuery, PublicQueueLiteQueryVariables> query={PublicQueueLiteDocument} {...props} />
    );
    
export type PublicQueueLiteProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>
    } & TChildProps;
export function withPublicQueueLite<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PublicQueueLiteQuery,
  PublicQueueLiteQueryVariables,
  PublicQueueLiteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PublicQueueLiteQuery, PublicQueueLiteQueryVariables, PublicQueueLiteProps<TChildProps, TDataName>>(PublicQueueLiteDocument, {
      alias: 'publicQueueLite',
      ...operationOptions
    });
};

/**
 * __usePublicQueueLiteQuery__
 *
 * To run a query within a React component, call `usePublicQueueLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicQueueLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicQueueLiteQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      publicQueueName: // value for 'publicQueueName'
 *   },
 * });
 */
export function usePublicQueueLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>(PublicQueueLiteDocument, options);
      }
export function usePublicQueueLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>(PublicQueueLiteDocument, options);
        }
// @ts-ignore
export function usePublicQueueLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>;
export function usePublicQueueLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicQueueLiteQuery | undefined, PublicQueueLiteQueryVariables>;
export function usePublicQueueLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>(PublicQueueLiteDocument, options);
        }
export type PublicQueueLiteQueryHookResult = ReturnType<typeof usePublicQueueLiteQuery>;
export type PublicQueueLiteLazyQueryHookResult = ReturnType<typeof usePublicQueueLiteLazyQuery>;
export type PublicQueueLiteSuspenseQueryHookResult = ReturnType<typeof usePublicQueueLiteSuspenseQuery>;
export type PublicQueueLiteQueryResult = ApolloReactCommon.QueryResult<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>;
export const EntityQueuesLiteDocument = gql`
    query EntityQueuesLite($entityName: String) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
      runQueues {
        id
        createdAt
        createdBy
        updatedAt
        name
        access
        defaultResourceConfig {
          id
          createdAt
          updatedAt
          scope {
            __typename
            Type
            ID
          }
          resource
          config
          templateVariables {
            name
            description
            schema
          }
        }
        prioritizationMode
        executorInfo
        externalLinks
      }
    }
  }
}
    `;
export type EntityQueuesLiteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>, 'query'>;

    export const EntityQueuesLiteComponent = (props: EntityQueuesLiteComponentProps) => (
      <ApolloReactComponents.Query<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables> query={EntityQueuesLiteDocument} {...props} />
    );
    
export type EntityQueuesLiteProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>
    } & TChildProps;
export function withEntityQueuesLite<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityQueuesLiteQuery,
  EntityQueuesLiteQueryVariables,
  EntityQueuesLiteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables, EntityQueuesLiteProps<TChildProps, TDataName>>(EntityQueuesLiteDocument, {
      alias: 'entityQueuesLite',
      ...operationOptions
    });
};

/**
 * __useEntityQueuesLiteQuery__
 *
 * To run a query within a React component, call `useEntityQueuesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQueuesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQueuesLiteQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityQueuesLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>(EntityQueuesLiteDocument, options);
      }
export function useEntityQueuesLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>(EntityQueuesLiteDocument, options);
        }
// @ts-ignore
export function useEntityQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>;
export function useEntityQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQueuesLiteQuery | undefined, EntityQueuesLiteQueryVariables>;
export function useEntityQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>(EntityQueuesLiteDocument, options);
        }
export type EntityQueuesLiteQueryHookResult = ReturnType<typeof useEntityQueuesLiteQuery>;
export type EntityQueuesLiteLazyQueryHookResult = ReturnType<typeof useEntityQueuesLiteLazyQuery>;
export type EntityQueuesLiteSuspenseQueryHookResult = ReturnType<typeof useEntityQueuesLiteSuspenseQuery>;
export type EntityQueuesLiteQueryResult = ApolloReactCommon.QueryResult<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>;
export const EntityQueueByQueueNameLiteDocument = gql`
    query EntityQueueByQueueNameLite($entityName: String, $queueName: String) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
      runQueue(name: $queueName) {
        id
        createdAt
        createdBy
        updatedAt
        name
        access
        defaultResourceConfig {
          id
          createdAt
          updatedAt
          scope {
            __typename
            Type
            ID
          }
          resource
          config
          templateVariables {
            name
            description
            schema
          }
        }
        prioritizationMode
        executorInfo
        externalLinks
      }
    }
  }
}
    `;
export type EntityQueueByQueueNameLiteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>, 'query'>;

    export const EntityQueueByQueueNameLiteComponent = (props: EntityQueueByQueueNameLiteComponentProps) => (
      <ApolloReactComponents.Query<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables> query={EntityQueueByQueueNameLiteDocument} {...props} />
    );
    
export type EntityQueueByQueueNameLiteProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>
    } & TChildProps;
export function withEntityQueueByQueueNameLite<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityQueueByQueueNameLiteQuery,
  EntityQueueByQueueNameLiteQueryVariables,
  EntityQueueByQueueNameLiteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables, EntityQueueByQueueNameLiteProps<TChildProps, TDataName>>(EntityQueueByQueueNameLiteDocument, {
      alias: 'entityQueueByQueueNameLite',
      ...operationOptions
    });
};

/**
 * __useEntityQueueByQueueNameLiteQuery__
 *
 * To run a query within a React component, call `useEntityQueueByQueueNameLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQueueByQueueNameLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQueueByQueueNameLiteQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      queueName: // value for 'queueName'
 *   },
 * });
 */
export function useEntityQueueByQueueNameLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>(EntityQueueByQueueNameLiteDocument, options);
      }
export function useEntityQueueByQueueNameLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>(EntityQueueByQueueNameLiteDocument, options);
        }
// @ts-ignore
export function useEntityQueueByQueueNameLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>;
export function useEntityQueueByQueueNameLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQueueByQueueNameLiteQuery | undefined, EntityQueueByQueueNameLiteQueryVariables>;
export function useEntityQueueByQueueNameLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>(EntityQueueByQueueNameLiteDocument, options);
        }
export type EntityQueueByQueueNameLiteQueryHookResult = ReturnType<typeof useEntityQueueByQueueNameLiteQuery>;
export type EntityQueueByQueueNameLiteLazyQueryHookResult = ReturnType<typeof useEntityQueueByQueueNameLiteLazyQuery>;
export type EntityQueueByQueueNameLiteSuspenseQueryHookResult = ReturnType<typeof useEntityQueueByQueueNameLiteSuspenseQuery>;
export type EntityQueueByQueueNameLiteQueryResult = ApolloReactCommon.QueryResult<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>;
export const AllQueuesLiteDocument = gql`
    query AllQueuesLite {
  viewer {
    id
    entity
    teams {
      edges {
        node {
          id
          name
          organizationId
          launchProject {
            id
            name
            launchAgents {
              id
              name
              createdAt
              heartbeatAt
              agentStatus
              stopPolling
              runQueues
              hostname
            }
            runQueues {
              id
              createdAt
              createdBy
              updatedAt
              name
              access
              prioritizationMode
              executorInfo
              externalLinks
              defaultResourceConfig {
                id
                createdAt
                updatedAt
                scope {
                  __typename
                  Type
                  ID
                }
                resource
                config
                templateVariables {
                  name
                  description
                  schema
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type AllQueuesLiteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>, 'query'>;

    export const AllQueuesLiteComponent = (props: AllQueuesLiteComponentProps) => (
      <ApolloReactComponents.Query<AllQueuesLiteQuery, AllQueuesLiteQueryVariables> query={AllQueuesLiteDocument} {...props} />
    );
    
export type AllQueuesLiteProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>
    } & TChildProps;
export function withAllQueuesLite<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllQueuesLiteQuery,
  AllQueuesLiteQueryVariables,
  AllQueuesLiteProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllQueuesLiteQuery, AllQueuesLiteQueryVariables, AllQueuesLiteProps<TChildProps, TDataName>>(AllQueuesLiteDocument, {
      alias: 'allQueuesLite',
      ...operationOptions
    });
};

/**
 * __useAllQueuesLiteQuery__
 *
 * To run a query within a React component, call `useAllQueuesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllQueuesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllQueuesLiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllQueuesLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>(AllQueuesLiteDocument, options);
      }
export function useAllQueuesLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>(AllQueuesLiteDocument, options);
        }
// @ts-ignore
export function useAllQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>;
export function useAllQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllQueuesLiteQuery | undefined, AllQueuesLiteQueryVariables>;
export function useAllQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>(AllQueuesLiteDocument, options);
        }
export type AllQueuesLiteQueryHookResult = ReturnType<typeof useAllQueuesLiteQuery>;
export type AllQueuesLiteLazyQueryHookResult = ReturnType<typeof useAllQueuesLiteLazyQuery>;
export type AllQueuesLiteSuspenseQueryHookResult = ReturnType<typeof useAllQueuesLiteSuspenseQuery>;
export type AllQueuesLiteQueryResult = ApolloReactCommon.QueryResult<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>;
export const RunsInformationDocument = gql`
    query RunsInformation($projectName: String!, $entityName: String, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters) {
      edges {
        node {
          id
          name
          displayName
          state
          createdAt
          heartbeatAt
        }
      }
    }
  }
}
    `;
export type RunsInformationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsInformationQuery, RunsInformationQueryVariables>, 'query'> & ({ variables: RunsInformationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsInformationComponent = (props: RunsInformationComponentProps) => (
      <ApolloReactComponents.Query<RunsInformationQuery, RunsInformationQueryVariables> query={RunsInformationDocument} {...props} />
    );
    
export type RunsInformationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsInformationQuery, RunsInformationQueryVariables>
    } & TChildProps;
export function withRunsInformation<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsInformationQuery,
  RunsInformationQueryVariables,
  RunsInformationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsInformationQuery, RunsInformationQueryVariables, RunsInformationProps<TChildProps, TDataName>>(RunsInformationDocument, {
      alias: 'runsInformation',
      ...operationOptions
    });
};

/**
 * __useRunsInformationQuery__
 *
 * To run a query within a React component, call `useRunsInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsInformationQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunsInformationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables> & ({ variables: RunsInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsInformationQuery, RunsInformationQueryVariables>(RunsInformationDocument, options);
      }
export function useRunsInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsInformationQuery, RunsInformationQueryVariables>(RunsInformationDocument, options);
        }
// @ts-ignore
export function useRunsInformationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsInformationQuery, RunsInformationQueryVariables>;
export function useRunsInformationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsInformationQuery | undefined, RunsInformationQueryVariables>;
export function useRunsInformationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsInformationQuery, RunsInformationQueryVariables>(RunsInformationDocument, options);
        }
export type RunsInformationQueryHookResult = ReturnType<typeof useRunsInformationQuery>;
export type RunsInformationLazyQueryHookResult = ReturnType<typeof useRunsInformationLazyQuery>;
export type RunsInformationSuspenseQueryHookResult = ReturnType<typeof useRunsInformationSuspenseQuery>;
export type RunsInformationQueryResult = ApolloReactCommon.QueryResult<RunsInformationQuery, RunsInformationQueryVariables>;
export const FetchCodeArtifactFilesDocument = gql`
    query FetchCodeArtifactFiles($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    files {
      edges {
        node {
          id
          name
          displayName
          mimetype
          sizeBytes
          url
        }
      }
    }
  }
}
    `;
export type FetchCodeArtifactFilesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>, 'query'> & ({ variables: FetchCodeArtifactFilesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchCodeArtifactFilesComponent = (props: FetchCodeArtifactFilesComponentProps) => (
      <ApolloReactComponents.Query<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables> query={FetchCodeArtifactFilesDocument} {...props} />
    );
    
export type FetchCodeArtifactFilesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>
    } & TChildProps;
export function withFetchCodeArtifactFiles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchCodeArtifactFilesQuery,
  FetchCodeArtifactFilesQueryVariables,
  FetchCodeArtifactFilesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables, FetchCodeArtifactFilesProps<TChildProps, TDataName>>(FetchCodeArtifactFilesDocument, {
      alias: 'fetchCodeArtifactFiles',
      ...operationOptions
    });
};

/**
 * __useFetchCodeArtifactFilesQuery__
 *
 * To run a query within a React component, call `useFetchCodeArtifactFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCodeArtifactFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCodeArtifactFilesQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useFetchCodeArtifactFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables> & ({ variables: FetchCodeArtifactFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>(FetchCodeArtifactFilesDocument, options);
      }
export function useFetchCodeArtifactFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>(FetchCodeArtifactFilesDocument, options);
        }
// @ts-ignore
export function useFetchCodeArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>;
export function useFetchCodeArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchCodeArtifactFilesQuery | undefined, FetchCodeArtifactFilesQueryVariables>;
export function useFetchCodeArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>(FetchCodeArtifactFilesDocument, options);
        }
export type FetchCodeArtifactFilesQueryHookResult = ReturnType<typeof useFetchCodeArtifactFilesQuery>;
export type FetchCodeArtifactFilesLazyQueryHookResult = ReturnType<typeof useFetchCodeArtifactFilesLazyQuery>;
export type FetchCodeArtifactFilesSuspenseQueryHookResult = ReturnType<typeof useFetchCodeArtifactFilesSuspenseQuery>;
export type FetchCodeArtifactFilesQueryResult = ApolloReactCommon.QueryResult<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>;
export const FetchAgentDetailsDocument = gql`
    query FetchAgentDetails($agentId: ID!) {
  launchAgent(id: $agentId) {
    id
    name
    createdAt
    updatedAt
    heartbeatAt
    runQueues
    hostname
    agentStatus
    stopPolling
    agentConfig
    version
  }
}
    `;
export type FetchAgentDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>, 'query'> & ({ variables: FetchAgentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchAgentDetailsComponent = (props: FetchAgentDetailsComponentProps) => (
      <ApolloReactComponents.Query<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables> query={FetchAgentDetailsDocument} {...props} />
    );
    
export type FetchAgentDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>
    } & TChildProps;
export function withFetchAgentDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchAgentDetailsQuery,
  FetchAgentDetailsQueryVariables,
  FetchAgentDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables, FetchAgentDetailsProps<TChildProps, TDataName>>(FetchAgentDetailsDocument, {
      alias: 'fetchAgentDetails',
      ...operationOptions
    });
};

/**
 * __useFetchAgentDetailsQuery__
 *
 * To run a query within a React component, call `useFetchAgentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAgentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAgentDetailsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useFetchAgentDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables> & ({ variables: FetchAgentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>(FetchAgentDetailsDocument, options);
      }
export function useFetchAgentDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>(FetchAgentDetailsDocument, options);
        }
// @ts-ignore
export function useFetchAgentDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>;
export function useFetchAgentDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchAgentDetailsQuery | undefined, FetchAgentDetailsQueryVariables>;
export function useFetchAgentDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>(FetchAgentDetailsDocument, options);
        }
export type FetchAgentDetailsQueryHookResult = ReturnType<typeof useFetchAgentDetailsQuery>;
export type FetchAgentDetailsLazyQueryHookResult = ReturnType<typeof useFetchAgentDetailsLazyQuery>;
export type FetchAgentDetailsSuspenseQueryHookResult = ReturnType<typeof useFetchAgentDetailsSuspenseQuery>;
export type FetchAgentDetailsQueryResult = ApolloReactCommon.QueryResult<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>;
export const EntityAgentsDocument = gql`
    query EntityAgents($entityName: String!) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
    }
  }
}
    `;
export type EntityAgentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityAgentsQuery, EntityAgentsQueryVariables>, 'query'> & ({ variables: EntityAgentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityAgentsComponent = (props: EntityAgentsComponentProps) => (
      <ApolloReactComponents.Query<EntityAgentsQuery, EntityAgentsQueryVariables> query={EntityAgentsDocument} {...props} />
    );
    
export type EntityAgentsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityAgentsQuery, EntityAgentsQueryVariables>
    } & TChildProps;
export function withEntityAgents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityAgentsQuery,
  EntityAgentsQueryVariables,
  EntityAgentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityAgentsQuery, EntityAgentsQueryVariables, EntityAgentsProps<TChildProps, TDataName>>(EntityAgentsDocument, {
      alias: 'entityAgents',
      ...operationOptions
    });
};

/**
 * __useEntityAgentsQuery__
 *
 * To run a query within a React component, call `useEntityAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityAgentsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityAgentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables> & ({ variables: EntityAgentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityAgentsQuery, EntityAgentsQueryVariables>(EntityAgentsDocument, options);
      }
export function useEntityAgentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityAgentsQuery, EntityAgentsQueryVariables>(EntityAgentsDocument, options);
        }
// @ts-ignore
export function useEntityAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityAgentsQuery, EntityAgentsQueryVariables>;
export function useEntityAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityAgentsQuery | undefined, EntityAgentsQueryVariables>;
export function useEntityAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityAgentsQuery, EntityAgentsQueryVariables>(EntityAgentsDocument, options);
        }
export type EntityAgentsQueryHookResult = ReturnType<typeof useEntityAgentsQuery>;
export type EntityAgentsLazyQueryHookResult = ReturnType<typeof useEntityAgentsLazyQuery>;
export type EntityAgentsSuspenseQueryHookResult = ReturnType<typeof useEntityAgentsSuspenseQuery>;
export type EntityAgentsQueryResult = ApolloReactCommon.QueryResult<EntityAgentsQuery, EntityAgentsQueryVariables>;
export const FetchRunOutputLogDocument = gql`
    query FetchRunOutputLog($entityName: String!, $projectName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      logLineCount
      outputLogFile: files(first: 1, names: ["output.log"]) {
        edges {
          node {
            id
            name
            md5
            sizeBytes
            directUrl
            url(upload: false)
          }
        }
      }
    }
  }
}
    `;
export type FetchRunOutputLogComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>, 'query'> & ({ variables: FetchRunOutputLogQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRunOutputLogComponent = (props: FetchRunOutputLogComponentProps) => (
      <ApolloReactComponents.Query<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables> query={FetchRunOutputLogDocument} {...props} />
    );
    
export type FetchRunOutputLogProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>
    } & TChildProps;
export function withFetchRunOutputLog<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRunOutputLogQuery,
  FetchRunOutputLogQueryVariables,
  FetchRunOutputLogProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables, FetchRunOutputLogProps<TChildProps, TDataName>>(FetchRunOutputLogDocument, {
      alias: 'fetchRunOutputLog',
      ...operationOptions
    });
};

/**
 * __useFetchRunOutputLogQuery__
 *
 * To run a query within a React component, call `useFetchRunOutputLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunOutputLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunOutputLogQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useFetchRunOutputLogQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables> & ({ variables: FetchRunOutputLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>(FetchRunOutputLogDocument, options);
      }
export function useFetchRunOutputLogLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>(FetchRunOutputLogDocument, options);
        }
// @ts-ignore
export function useFetchRunOutputLogSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>;
export function useFetchRunOutputLogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunOutputLogQuery | undefined, FetchRunOutputLogQueryVariables>;
export function useFetchRunOutputLogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>(FetchRunOutputLogDocument, options);
        }
export type FetchRunOutputLogQueryHookResult = ReturnType<typeof useFetchRunOutputLogQuery>;
export type FetchRunOutputLogLazyQueryHookResult = ReturnType<typeof useFetchRunOutputLogLazyQuery>;
export type FetchRunOutputLogSuspenseQueryHookResult = ReturnType<typeof useFetchRunOutputLogSuspenseQuery>;
export type FetchRunOutputLogQueryResult = ApolloReactCommon.QueryResult<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>;
export const QueueByIdDocument = gql`
    query QueueByID($entityName: String!, $queueId: ID!, $first: Int, $after: String) {
  project(name: "model-registry", entityName: $entityName) {
    id
    name
    launchAgents {
      id
      name
      createdAt
      heartbeatAt
      agentStatus
      stopPolling
      runQueues
      hostname
    }
    runQueue(id: $queueId) {
      id
      createdAt
      name
      defaultResourceConfig {
        id
        createdAt
        resource
        config
        templateVariables {
          name
          description
          schema
        }
      }
      prioritizationMode
      executorInfo
      externalLinks
      runQueueItems(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            ...RunQueueItemFragment
            error {
              message
              stage
              filePaths
            }
            warnings {
              message
              stage
              filePaths
            }
          }
        }
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;
export type QueueByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QueueByIdQuery, QueueByIdQueryVariables>, 'query'> & ({ variables: QueueByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const QueueByIdComponent = (props: QueueByIdComponentProps) => (
      <ApolloReactComponents.Query<QueueByIdQuery, QueueByIdQueryVariables> query={QueueByIdDocument} {...props} />
    );
    
export type QueueByIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<QueueByIdQuery, QueueByIdQueryVariables>
    } & TChildProps;
export function withQueueById<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  QueueByIdQuery,
  QueueByIdQueryVariables,
  QueueByIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, QueueByIdQuery, QueueByIdQueryVariables, QueueByIdProps<TChildProps, TDataName>>(QueueByIdDocument, {
      alias: 'queueById',
      ...operationOptions
    });
};

/**
 * __useQueueByIdQuery__
 *
 * To run a query within a React component, call `useQueueByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueByIdQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      queueId: // value for 'queueId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useQueueByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables> & ({ variables: QueueByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QueueByIdQuery, QueueByIdQueryVariables>(QueueByIdDocument, options);
      }
export function useQueueByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QueueByIdQuery, QueueByIdQueryVariables>(QueueByIdDocument, options);
        }
// @ts-ignore
export function useQueueByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueByIdQuery, QueueByIdQueryVariables>;
export function useQueueByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueByIdQuery | undefined, QueueByIdQueryVariables>;
export function useQueueByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QueueByIdQuery, QueueByIdQueryVariables>(QueueByIdDocument, options);
        }
export type QueueByIdQueryHookResult = ReturnType<typeof useQueueByIdQuery>;
export type QueueByIdLazyQueryHookResult = ReturnType<typeof useQueueByIdLazyQuery>;
export type QueueByIdSuspenseQueryHookResult = ReturnType<typeof useQueueByIdSuspenseQuery>;
export type QueueByIdQueryResult = ApolloReactCommon.QueryResult<QueueByIdQuery, QueueByIdQueryVariables>;
export const RunJobDocument = gql`
    query RunJob($entityName: String!, $projectName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      job {
        id
        artifactSequence {
          id
          name
        }
        versionIndex
      }
    }
  }
}
    `;
export type RunJobComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunJobQuery, RunJobQueryVariables>, 'query'> & ({ variables: RunJobQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunJobComponent = (props: RunJobComponentProps) => (
      <ApolloReactComponents.Query<RunJobQuery, RunJobQueryVariables> query={RunJobDocument} {...props} />
    );
    
export type RunJobProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunJobQuery, RunJobQueryVariables>
    } & TChildProps;
export function withRunJob<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunJobQuery,
  RunJobQueryVariables,
  RunJobProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunJobQuery, RunJobQueryVariables, RunJobProps<TChildProps, TDataName>>(RunJobDocument, {
      alias: 'runJob',
      ...operationOptions
    });
};

/**
 * __useRunJobQuery__
 *
 * To run a query within a React component, call `useRunJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunJobQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunJobQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunJobQuery, RunJobQueryVariables> & ({ variables: RunJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunJobQuery, RunJobQueryVariables>(RunJobDocument, options);
      }
export function useRunJobLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunJobQuery, RunJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunJobQuery, RunJobQueryVariables>(RunJobDocument, options);
        }
// @ts-ignore
export function useRunJobSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunJobQuery, RunJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunJobQuery, RunJobQueryVariables>;
export function useRunJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunJobQuery, RunJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunJobQuery | undefined, RunJobQueryVariables>;
export function useRunJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunJobQuery, RunJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunJobQuery, RunJobQueryVariables>(RunJobDocument, options);
        }
export type RunJobQueryHookResult = ReturnType<typeof useRunJobQuery>;
export type RunJobLazyQueryHookResult = ReturnType<typeof useRunJobLazyQuery>;
export type RunJobSuspenseQueryHookResult = ReturnType<typeof useRunJobSuspenseQuery>;
export type RunJobQueryResult = ApolloReactCommon.QueryResult<RunJobQuery, RunJobQueryVariables>;
export const RunFilesAndFolderWithDirectUrLsDocument = gql`
    query RunFilesAndFolderWithDirectURLs($projectName: String!, $entityName: String, $runName: String!, $maxNumFiles: Int!, $pattern: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    run(name: $runName) {
      id
      name
      projectId
      files(first: $maxNumFiles, pattern: $pattern) {
        edges {
          node {
            id
            name
            directUrl
            sizeBytes
            updatedAt
            artifact {
              id
              digest
            }
          }
        }
      }
    }
  }
}
    `;
export type RunFilesAndFolderWithDirectUrLsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>, 'query'> & ({ variables: RunFilesAndFolderWithDirectUrLsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunFilesAndFolderWithDirectUrLsComponent = (props: RunFilesAndFolderWithDirectUrLsComponentProps) => (
      <ApolloReactComponents.Query<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables> query={RunFilesAndFolderWithDirectUrLsDocument} {...props} />
    );
    
export type RunFilesAndFolderWithDirectUrLsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>
    } & TChildProps;
export function withRunFilesAndFolderWithDirectUrLs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunFilesAndFolderWithDirectUrLsQuery,
  RunFilesAndFolderWithDirectUrLsQueryVariables,
  RunFilesAndFolderWithDirectUrLsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables, RunFilesAndFolderWithDirectUrLsProps<TChildProps, TDataName>>(RunFilesAndFolderWithDirectUrLsDocument, {
      alias: 'runFilesAndFolderWithDirectUrLs',
      ...operationOptions
    });
};

/**
 * __useRunFilesAndFolderWithDirectUrLsQuery__
 *
 * To run a query within a React component, call `useRunFilesAndFolderWithDirectUrLsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunFilesAndFolderWithDirectUrLsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunFilesAndFolderWithDirectUrLsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      maxNumFiles: // value for 'maxNumFiles'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useRunFilesAndFolderWithDirectUrLsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables> & ({ variables: RunFilesAndFolderWithDirectUrLsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>(RunFilesAndFolderWithDirectUrLsDocument, options);
      }
export function useRunFilesAndFolderWithDirectUrLsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>(RunFilesAndFolderWithDirectUrLsDocument, options);
        }
// @ts-ignore
export function useRunFilesAndFolderWithDirectUrLsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>;
export function useRunFilesAndFolderWithDirectUrLsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesAndFolderWithDirectUrLsQuery | undefined, RunFilesAndFolderWithDirectUrLsQueryVariables>;
export function useRunFilesAndFolderWithDirectUrLsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>(RunFilesAndFolderWithDirectUrLsDocument, options);
        }
export type RunFilesAndFolderWithDirectUrLsQueryHookResult = ReturnType<typeof useRunFilesAndFolderWithDirectUrLsQuery>;
export type RunFilesAndFolderWithDirectUrLsLazyQueryHookResult = ReturnType<typeof useRunFilesAndFolderWithDirectUrLsLazyQuery>;
export type RunFilesAndFolderWithDirectUrLsSuspenseQueryHookResult = ReturnType<typeof useRunFilesAndFolderWithDirectUrLsSuspenseQuery>;
export type RunFilesAndFolderWithDirectUrLsQueryResult = ApolloReactCommon.QueryResult<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>;
export const AccountUsingLaunchDocument = gql`
    query AccountUsingLaunch($name: String!) {
  organization(name: $name) {
    id
    isLaunchActive
  }
}
    `;
export type AccountUsingLaunchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>, 'query'> & ({ variables: AccountUsingLaunchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountUsingLaunchComponent = (props: AccountUsingLaunchComponentProps) => (
      <ApolloReactComponents.Query<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables> query={AccountUsingLaunchDocument} {...props} />
    );
    
export type AccountUsingLaunchProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>
    } & TChildProps;
export function withAccountUsingLaunch<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountUsingLaunchQuery,
  AccountUsingLaunchQueryVariables,
  AccountUsingLaunchProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables, AccountUsingLaunchProps<TChildProps, TDataName>>(AccountUsingLaunchDocument, {
      alias: 'accountUsingLaunch',
      ...operationOptions
    });
};

/**
 * __useAccountUsingLaunchQuery__
 *
 * To run a query within a React component, call `useAccountUsingLaunchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUsingLaunchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUsingLaunchQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccountUsingLaunchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables> & ({ variables: AccountUsingLaunchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>(AccountUsingLaunchDocument, options);
      }
export function useAccountUsingLaunchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>(AccountUsingLaunchDocument, options);
        }
// @ts-ignore
export function useAccountUsingLaunchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>;
export function useAccountUsingLaunchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountUsingLaunchQuery | undefined, AccountUsingLaunchQueryVariables>;
export function useAccountUsingLaunchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>(AccountUsingLaunchDocument, options);
        }
export type AccountUsingLaunchQueryHookResult = ReturnType<typeof useAccountUsingLaunchQuery>;
export type AccountUsingLaunchLazyQueryHookResult = ReturnType<typeof useAccountUsingLaunchLazyQuery>;
export type AccountUsingLaunchSuspenseQueryHookResult = ReturnType<typeof useAccountUsingLaunchSuspenseQuery>;
export type AccountUsingLaunchQueryResult = ApolloReactCommon.QueryResult<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>;
export const ArtifactPathEntityProjectsDocument = gql`
    query ArtifactPathEntityProjects($entityName: String!, $pattern: String) {
  entity(name: $entityName) {
    id
    name
    projects(first: 500, pattern: $pattern) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;
export type ArtifactPathEntityProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>, 'query'> & ({ variables: ArtifactPathEntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactPathEntityProjectsComponent = (props: ArtifactPathEntityProjectsComponentProps) => (
      <ApolloReactComponents.Query<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables> query={ArtifactPathEntityProjectsDocument} {...props} />
    );
    
export type ArtifactPathEntityProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>
    } & TChildProps;
export function withArtifactPathEntityProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactPathEntityProjectsQuery,
  ArtifactPathEntityProjectsQueryVariables,
  ArtifactPathEntityProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables, ArtifactPathEntityProjectsProps<TChildProps, TDataName>>(ArtifactPathEntityProjectsDocument, {
      alias: 'artifactPathEntityProjects',
      ...operationOptions
    });
};

/**
 * __useArtifactPathEntityProjectsQuery__
 *
 * To run a query within a React component, call `useArtifactPathEntityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactPathEntityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactPathEntityProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useArtifactPathEntityProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables> & ({ variables: ArtifactPathEntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>(ArtifactPathEntityProjectsDocument, options);
      }
export function useArtifactPathEntityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>(ArtifactPathEntityProjectsDocument, options);
        }
// @ts-ignore
export function useArtifactPathEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>;
export function useArtifactPathEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathEntityProjectsQuery | undefined, ArtifactPathEntityProjectsQueryVariables>;
export function useArtifactPathEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>(ArtifactPathEntityProjectsDocument, options);
        }
export type ArtifactPathEntityProjectsQueryHookResult = ReturnType<typeof useArtifactPathEntityProjectsQuery>;
export type ArtifactPathEntityProjectsLazyQueryHookResult = ReturnType<typeof useArtifactPathEntityProjectsLazyQuery>;
export type ArtifactPathEntityProjectsSuspenseQueryHookResult = ReturnType<typeof useArtifactPathEntityProjectsSuspenseQuery>;
export type ArtifactPathEntityProjectsQueryResult = ApolloReactCommon.QueryResult<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>;
export const ArtifactPathSearchArtifactsDocument = gql`
    query ArtifactPathSearchArtifacts($entityName: String!, $projectName: String!, $limit: Int!, $searchTerm: String, $artifactsLimit: Int) {
  entity(name: $entityName) {
    id
    project(name: $projectName) {
      id
      artifactCollectionsSearch(
        limit: $limit
        searchTerm: $searchTerm
        artifactsLimit: $artifactsLimit
      ) {
        edges {
          node {
            id
            name
            artifacts {
              edges {
                node {
                  id
                  versionIndex
                  aliases {
                    id
                    alias
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ArtifactPathSearchArtifactsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>, 'query'> & ({ variables: ArtifactPathSearchArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArtifactPathSearchArtifactsComponent = (props: ArtifactPathSearchArtifactsComponentProps) => (
      <ApolloReactComponents.Query<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables> query={ArtifactPathSearchArtifactsDocument} {...props} />
    );
    
export type ArtifactPathSearchArtifactsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>
    } & TChildProps;
export function withArtifactPathSearchArtifacts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ArtifactPathSearchArtifactsQuery,
  ArtifactPathSearchArtifactsQueryVariables,
  ArtifactPathSearchArtifactsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables, ArtifactPathSearchArtifactsProps<TChildProps, TDataName>>(ArtifactPathSearchArtifactsDocument, {
      alias: 'artifactPathSearchArtifacts',
      ...operationOptions
    });
};

/**
 * __useArtifactPathSearchArtifactsQuery__
 *
 * To run a query within a React component, call `useArtifactPathSearchArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactPathSearchArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactPathSearchArtifactsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      limit: // value for 'limit'
 *      searchTerm: // value for 'searchTerm'
 *      artifactsLimit: // value for 'artifactsLimit'
 *   },
 * });
 */
export function useArtifactPathSearchArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables> & ({ variables: ArtifactPathSearchArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>(ArtifactPathSearchArtifactsDocument, options);
      }
export function useArtifactPathSearchArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>(ArtifactPathSearchArtifactsDocument, options);
        }
// @ts-ignore
export function useArtifactPathSearchArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>;
export function useArtifactPathSearchArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathSearchArtifactsQuery | undefined, ArtifactPathSearchArtifactsQueryVariables>;
export function useArtifactPathSearchArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>(ArtifactPathSearchArtifactsDocument, options);
        }
export type ArtifactPathSearchArtifactsQueryHookResult = ReturnType<typeof useArtifactPathSearchArtifactsQuery>;
export type ArtifactPathSearchArtifactsLazyQueryHookResult = ReturnType<typeof useArtifactPathSearchArtifactsLazyQuery>;
export type ArtifactPathSearchArtifactsSuspenseQueryHookResult = ReturnType<typeof useArtifactPathSearchArtifactsSuspenseQuery>;
export type ArtifactPathSearchArtifactsQueryResult = ApolloReactCommon.QueryResult<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>;
export const AddPublicQueueLaunchAgentTeamConfigDocument = gql`
    mutation AddPublicQueueLaunchAgentTeamConfig($input: AddPublicQueueLaunchAgentTeamConfigInput!) {
  addPublicQueueLaunchAgentTeamConfig(input: $input) {
    success
    clientMutationID
  }
}
    `;
export type AddPublicQueueLaunchAgentTeamConfigMutationFn = ApolloReactCommon.MutationFunction<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>;
export type AddPublicQueueLaunchAgentTeamConfigComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>, 'mutation'>;

    export const AddPublicQueueLaunchAgentTeamConfigComponent = (props: AddPublicQueueLaunchAgentTeamConfigComponentProps) => (
      <ApolloReactComponents.Mutation<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables> mutation={AddPublicQueueLaunchAgentTeamConfigDocument} {...props} />
    );
    
export type AddPublicQueueLaunchAgentTeamConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>
    } & TChildProps;
export function withAddPublicQueueLaunchAgentTeamConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddPublicQueueLaunchAgentTeamConfigMutation,
  AddPublicQueueLaunchAgentTeamConfigMutationVariables,
  AddPublicQueueLaunchAgentTeamConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables, AddPublicQueueLaunchAgentTeamConfigProps<TChildProps, TDataName>>(AddPublicQueueLaunchAgentTeamConfigDocument, {
      alias: 'addPublicQueueLaunchAgentTeamConfig',
      ...operationOptions
    });
};

/**
 * __useAddPublicQueueLaunchAgentTeamConfigMutation__
 *
 * To run a mutation, you first call `useAddPublicQueueLaunchAgentTeamConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPublicQueueLaunchAgentTeamConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPublicQueueLaunchAgentTeamConfigMutation, { data, loading, error }] = useAddPublicQueueLaunchAgentTeamConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPublicQueueLaunchAgentTeamConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>(AddPublicQueueLaunchAgentTeamConfigDocument, options);
      }
export type AddPublicQueueLaunchAgentTeamConfigMutationHookResult = ReturnType<typeof useAddPublicQueueLaunchAgentTeamConfigMutation>;
export type AddPublicQueueLaunchAgentTeamConfigMutationResult = ApolloReactCommon.MutationResult<AddPublicQueueLaunchAgentTeamConfigMutation>;
export type AddPublicQueueLaunchAgentTeamConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>;
export const DeletePublicQueueLaunchAgentTeamConfigDocument = gql`
    mutation DeletePublicQueueLaunchAgentTeamConfig($input: DeletePublicQueueLaunchAgentTeamConfigInput!) {
  deletePublicQueueLaunchAgentTeamConfig(input: $input) {
    success
    clientMutationID
  }
}
    `;
export type DeletePublicQueueLaunchAgentTeamConfigMutationFn = ApolloReactCommon.MutationFunction<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>;
export type DeletePublicQueueLaunchAgentTeamConfigComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>, 'mutation'>;

    export const DeletePublicQueueLaunchAgentTeamConfigComponent = (props: DeletePublicQueueLaunchAgentTeamConfigComponentProps) => (
      <ApolloReactComponents.Mutation<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables> mutation={DeletePublicQueueLaunchAgentTeamConfigDocument} {...props} />
    );
    
export type DeletePublicQueueLaunchAgentTeamConfigProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>
    } & TChildProps;
export function withDeletePublicQueueLaunchAgentTeamConfig<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeletePublicQueueLaunchAgentTeamConfigMutation,
  DeletePublicQueueLaunchAgentTeamConfigMutationVariables,
  DeletePublicQueueLaunchAgentTeamConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables, DeletePublicQueueLaunchAgentTeamConfigProps<TChildProps, TDataName>>(DeletePublicQueueLaunchAgentTeamConfigDocument, {
      alias: 'deletePublicQueueLaunchAgentTeamConfig',
      ...operationOptions
    });
};

/**
 * __useDeletePublicQueueLaunchAgentTeamConfigMutation__
 *
 * To run a mutation, you first call `useDeletePublicQueueLaunchAgentTeamConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePublicQueueLaunchAgentTeamConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePublicQueueLaunchAgentTeamConfigMutation, { data, loading, error }] = useDeletePublicQueueLaunchAgentTeamConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePublicQueueLaunchAgentTeamConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>(DeletePublicQueueLaunchAgentTeamConfigDocument, options);
      }
export type DeletePublicQueueLaunchAgentTeamConfigMutationHookResult = ReturnType<typeof useDeletePublicQueueLaunchAgentTeamConfigMutation>;
export type DeletePublicQueueLaunchAgentTeamConfigMutationResult = ApolloReactCommon.MutationResult<DeletePublicQueueLaunchAgentTeamConfigMutation>;
export type DeletePublicQueueLaunchAgentTeamConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>;
export const ViewerTeamsProjectsDocument = gql`
    query ViewerTeamsProjects($pattern: String) {
  viewer {
    id
    teams {
      edges {
        node {
          id
          name
          projects(first: 100, pattern: $pattern) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ViewerTeamsProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>, 'query'>;

    export const ViewerTeamsProjectsComponent = (props: ViewerTeamsProjectsComponentProps) => (
      <ApolloReactComponents.Query<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables> query={ViewerTeamsProjectsDocument} {...props} />
    );
    
export type ViewerTeamsProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>
    } & TChildProps;
export function withViewerTeamsProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerTeamsProjectsQuery,
  ViewerTeamsProjectsQueryVariables,
  ViewerTeamsProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables, ViewerTeamsProjectsProps<TChildProps, TDataName>>(ViewerTeamsProjectsDocument, {
      alias: 'viewerTeamsProjects',
      ...operationOptions
    });
};

/**
 * __useViewerTeamsProjectsQuery__
 *
 * To run a query within a React component, call `useViewerTeamsProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerTeamsProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerTeamsProjectsQuery({
 *   variables: {
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useViewerTeamsProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>(ViewerTeamsProjectsDocument, options);
      }
export function useViewerTeamsProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>(ViewerTeamsProjectsDocument, options);
        }
// @ts-ignore
export function useViewerTeamsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>;
export function useViewerTeamsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerTeamsProjectsQuery | undefined, ViewerTeamsProjectsQueryVariables>;
export function useViewerTeamsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>(ViewerTeamsProjectsDocument, options);
        }
export type ViewerTeamsProjectsQueryHookResult = ReturnType<typeof useViewerTeamsProjectsQuery>;
export type ViewerTeamsProjectsLazyQueryHookResult = ReturnType<typeof useViewerTeamsProjectsLazyQuery>;
export type ViewerTeamsProjectsSuspenseQueryHookResult = ReturnType<typeof useViewerTeamsProjectsSuspenseQuery>;
export type ViewerTeamsProjectsQueryResult = ApolloReactCommon.QueryResult<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>;
export const FetchProjectRunsForConfigDocument = gql`
    query FetchProjectRunsForConfig($entityName: String!, $projectName: String!, $first: Int) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    runs(first: $first, order: "-createdAt") {
      edges {
        node {
          id
          name
          displayName
          createdAt
          state
          defaultColorIndex
          config
          runInfo {
            args
          }
          user {
            id
            name
            username
            photoUrl
          }
          job {
            id
            description
            labels
            versionIndex
            aliases {
              id
              alias
            }
            artifactSequence {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export type FetchProjectRunsForConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>, 'query'> & ({ variables: FetchProjectRunsForConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchProjectRunsForConfigComponent = (props: FetchProjectRunsForConfigComponentProps) => (
      <ApolloReactComponents.Query<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables> query={FetchProjectRunsForConfigDocument} {...props} />
    );
    
export type FetchProjectRunsForConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>
    } & TChildProps;
export function withFetchProjectRunsForConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchProjectRunsForConfigQuery,
  FetchProjectRunsForConfigQueryVariables,
  FetchProjectRunsForConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables, FetchProjectRunsForConfigProps<TChildProps, TDataName>>(FetchProjectRunsForConfigDocument, {
      alias: 'fetchProjectRunsForConfig',
      ...operationOptions
    });
};

/**
 * __useFetchProjectRunsForConfigQuery__
 *
 * To run a query within a React component, call `useFetchProjectRunsForConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectRunsForConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectRunsForConfigQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFetchProjectRunsForConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables> & ({ variables: FetchProjectRunsForConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>(FetchProjectRunsForConfigDocument, options);
      }
export function useFetchProjectRunsForConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>(FetchProjectRunsForConfigDocument, options);
        }
// @ts-ignore
export function useFetchProjectRunsForConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>;
export function useFetchProjectRunsForConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectRunsForConfigQuery | undefined, FetchProjectRunsForConfigQueryVariables>;
export function useFetchProjectRunsForConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>(FetchProjectRunsForConfigDocument, options);
        }
export type FetchProjectRunsForConfigQueryHookResult = ReturnType<typeof useFetchProjectRunsForConfigQuery>;
export type FetchProjectRunsForConfigLazyQueryHookResult = ReturnType<typeof useFetchProjectRunsForConfigLazyQuery>;
export type FetchProjectRunsForConfigSuspenseQueryHookResult = ReturnType<typeof useFetchProjectRunsForConfigSuspenseQuery>;
export type FetchProjectRunsForConfigQueryResult = ApolloReactCommon.QueryResult<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>;
export const MessageOfTheDayDocument = gql`
    query MessageOfTheDay {
  serverInfo {
    messageOfTheDay
  }
}
    `;
export type MessageOfTheDayComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>, 'query'>;

    export const MessageOfTheDayComponent = (props: MessageOfTheDayComponentProps) => (
      <ApolloReactComponents.Query<MessageOfTheDayQuery, MessageOfTheDayQueryVariables> query={MessageOfTheDayDocument} {...props} />
    );
    
export type MessageOfTheDayProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>
    } & TChildProps;
export function withMessageOfTheDay<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MessageOfTheDayQuery,
  MessageOfTheDayQueryVariables,
  MessageOfTheDayProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MessageOfTheDayQuery, MessageOfTheDayQueryVariables, MessageOfTheDayProps<TChildProps, TDataName>>(MessageOfTheDayDocument, {
      alias: 'messageOfTheDay',
      ...operationOptions
    });
};

/**
 * __useMessageOfTheDayQuery__
 *
 * To run a query within a React component, call `useMessageOfTheDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageOfTheDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageOfTheDayQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessageOfTheDayQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>(MessageOfTheDayDocument, options);
      }
export function useMessageOfTheDayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>(MessageOfTheDayDocument, options);
        }
// @ts-ignore
export function useMessageOfTheDaySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>;
export function useMessageOfTheDaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MessageOfTheDayQuery | undefined, MessageOfTheDayQueryVariables>;
export function useMessageOfTheDaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>(MessageOfTheDayDocument, options);
        }
export type MessageOfTheDayQueryHookResult = ReturnType<typeof useMessageOfTheDayQuery>;
export type MessageOfTheDayLazyQueryHookResult = ReturnType<typeof useMessageOfTheDayLazyQuery>;
export type MessageOfTheDaySuspenseQueryHookResult = ReturnType<typeof useMessageOfTheDaySuspenseQuery>;
export type MessageOfTheDayQueryResult = ApolloReactCommon.QueryResult<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>;
export const MoveViewDocument = gql`
    mutation moveView($id: ID!, $entityName: String!, $projectName: String!, $clientMutationId: String) {
  moveView(
    input: {id: $id, entityName: $entityName, projectName: $projectName, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type MoveViewMutationFn = ApolloReactCommon.MutationFunction<MoveViewMutation, MoveViewMutationVariables>;
export type MoveViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MoveViewMutation, MoveViewMutationVariables>, 'mutation'>;

    export const MoveViewComponent = (props: MoveViewComponentProps) => (
      <ApolloReactComponents.Mutation<MoveViewMutation, MoveViewMutationVariables> mutation={MoveViewDocument} {...props} />
    );
    
export type MoveViewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MoveViewMutation, MoveViewMutationVariables>
    } & TChildProps;
export function withMoveView<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MoveViewMutation,
  MoveViewMutationVariables,
  MoveViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MoveViewMutation, MoveViewMutationVariables, MoveViewProps<TChildProps, TDataName>>(MoveViewDocument, {
      alias: 'moveView',
      ...operationOptions
    });
};

/**
 * __useMoveViewMutation__
 *
 * To run a mutation, you first call `useMoveViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveViewMutation, { data, loading, error }] = useMoveViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useMoveViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveViewMutation, MoveViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveViewMutation, MoveViewMutationVariables>(MoveViewDocument, options);
      }
export type MoveViewMutationHookResult = ReturnType<typeof useMoveViewMutation>;
export type MoveViewMutationResult = ApolloReactCommon.MutationResult<MoveViewMutation>;
export type MoveViewMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveViewMutation, MoveViewMutationVariables>;
export const MultiRunWorkspaceDocument = gql`
    query MultiRunWorkspace($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    readOnly
    isBenchmark
    linkedBenchmark {
      id
      entityName
      name
      gitHubSubmissionRepo
      views
    }
    runQueues {
      id
      name
      createdBy
      access
    }
  }
}
    `;
export type MultiRunWorkspaceComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>, 'query'> & ({ variables: MultiRunWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MultiRunWorkspaceComponent = (props: MultiRunWorkspaceComponentProps) => (
      <ApolloReactComponents.Query<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables> query={MultiRunWorkspaceDocument} {...props} />
    );
    
export type MultiRunWorkspaceProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>
    } & TChildProps;
export function withMultiRunWorkspace<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MultiRunWorkspaceQuery,
  MultiRunWorkspaceQueryVariables,
  MultiRunWorkspaceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables, MultiRunWorkspaceProps<TChildProps, TDataName>>(MultiRunWorkspaceDocument, {
      alias: 'multiRunWorkspace',
      ...operationOptions
    });
};

/**
 * __useMultiRunWorkspaceQuery__
 *
 * To run a query within a React component, call `useMultiRunWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiRunWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiRunWorkspaceQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useMultiRunWorkspaceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables> & ({ variables: MultiRunWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>(MultiRunWorkspaceDocument, options);
      }
export function useMultiRunWorkspaceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>(MultiRunWorkspaceDocument, options);
        }
// @ts-ignore
export function useMultiRunWorkspaceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>;
export function useMultiRunWorkspaceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MultiRunWorkspaceQuery | undefined, MultiRunWorkspaceQueryVariables>;
export function useMultiRunWorkspaceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>(MultiRunWorkspaceDocument, options);
        }
export type MultiRunWorkspaceQueryHookResult = ReturnType<typeof useMultiRunWorkspaceQuery>;
export type MultiRunWorkspaceLazyQueryHookResult = ReturnType<typeof useMultiRunWorkspaceLazyQuery>;
export type MultiRunWorkspaceSuspenseQueryHookResult = ReturnType<typeof useMultiRunWorkspaceSuspenseQuery>;
export type MultiRunWorkspaceQueryResult = ApolloReactCommon.QueryResult<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>;
export const NwEntityPermissionDocument = gql`
    query NwEntityPermission($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
    settings {
      hidden
    }
  }
}
    `;
export type NwEntityPermissionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>, 'query'>;

    export const NwEntityPermissionComponent = (props: NwEntityPermissionComponentProps) => (
      <ApolloReactComponents.Query<NwEntityPermissionQuery, NwEntityPermissionQueryVariables> query={NwEntityPermissionDocument} {...props} />
    );
    
export type NwEntityPermissionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>
    } & TChildProps;
export function withNwEntityPermission<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NwEntityPermissionQuery,
  NwEntityPermissionQueryVariables,
  NwEntityPermissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NwEntityPermissionQuery, NwEntityPermissionQueryVariables, NwEntityPermissionProps<TChildProps, TDataName>>(NwEntityPermissionDocument, {
      alias: 'nwEntityPermission',
      ...operationOptions
    });
};

/**
 * __useNwEntityPermissionQuery__
 *
 * To run a query within a React component, call `useNwEntityPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNwEntityPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNwEntityPermissionQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useNwEntityPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>(NwEntityPermissionDocument, options);
      }
export function useNwEntityPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>(NwEntityPermissionDocument, options);
        }
// @ts-ignore
export function useNwEntityPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>;
export function useNwEntityPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NwEntityPermissionQuery | undefined, NwEntityPermissionQueryVariables>;
export function useNwEntityPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>(NwEntityPermissionDocument, options);
        }
export type NwEntityPermissionQueryHookResult = ReturnType<typeof useNwEntityPermissionQuery>;
export type NwEntityPermissionLazyQueryHookResult = ReturnType<typeof useNwEntityPermissionLazyQuery>;
export type NwEntityPermissionSuspenseQueryHookResult = ReturnType<typeof useNwEntityPermissionSuspenseQuery>;
export type NwEntityPermissionQueryResult = ApolloReactCommon.QueryResult<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>;
export const NwProjectPermissionDocument = gql`
    query NwProjectPermission($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    user {
      id
      username
    }
    members {
      id
      username
    }
  }
}
    `;
export type NwProjectPermissionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>, 'query'> & ({ variables: NwProjectPermissionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NwProjectPermissionComponent = (props: NwProjectPermissionComponentProps) => (
      <ApolloReactComponents.Query<NwProjectPermissionQuery, NwProjectPermissionQueryVariables> query={NwProjectPermissionDocument} {...props} />
    );
    
export type NwProjectPermissionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>
    } & TChildProps;
export function withNwProjectPermission<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NwProjectPermissionQuery,
  NwProjectPermissionQueryVariables,
  NwProjectPermissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NwProjectPermissionQuery, NwProjectPermissionQueryVariables, NwProjectPermissionProps<TChildProps, TDataName>>(NwProjectPermissionDocument, {
      alias: 'nwProjectPermission',
      ...operationOptions
    });
};

/**
 * __useNwProjectPermissionQuery__
 *
 * To run a query within a React component, call `useNwProjectPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNwProjectPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNwProjectPermissionQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useNwProjectPermissionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables> & ({ variables: NwProjectPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>(NwProjectPermissionDocument, options);
      }
export function useNwProjectPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>(NwProjectPermissionDocument, options);
        }
// @ts-ignore
export function useNwProjectPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>;
export function useNwProjectPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NwProjectPermissionQuery | undefined, NwProjectPermissionQueryVariables>;
export function useNwProjectPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>(NwProjectPermissionDocument, options);
        }
export type NwProjectPermissionQueryHookResult = ReturnType<typeof useNwProjectPermissionQuery>;
export type NwProjectPermissionLazyQueryHookResult = ReturnType<typeof useNwProjectPermissionLazyQuery>;
export type NwProjectPermissionSuspenseQueryHookResult = ReturnType<typeof useNwProjectPermissionSuspenseQuery>;
export type NwProjectPermissionQueryResult = ApolloReactCommon.QueryResult<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>;
export const OrgAdminsDocument = gql`
    query OrgAdmins($orgName: String) {
  organization(name: $orgName) {
    id
    billingUser {
      id
      username
    }
    members {
      id
      user {
        id
        username
      }
      admin
    }
  }
}
    `;
export type OrgAdminsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrgAdminsQuery, OrgAdminsQueryVariables>, 'query'>;

    export const OrgAdminsComponent = (props: OrgAdminsComponentProps) => (
      <ApolloReactComponents.Query<OrgAdminsQuery, OrgAdminsQueryVariables> query={OrgAdminsDocument} {...props} />
    );
    
export type OrgAdminsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrgAdminsQuery, OrgAdminsQueryVariables>
    } & TChildProps;
export function withOrgAdmins<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrgAdminsQuery,
  OrgAdminsQueryVariables,
  OrgAdminsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrgAdminsQuery, OrgAdminsQueryVariables, OrgAdminsProps<TChildProps, TDataName>>(OrgAdminsDocument, {
      alias: 'orgAdmins',
      ...operationOptions
    });
};

/**
 * __useOrgAdminsQuery__
 *
 * To run a query within a React component, call `useOrgAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgAdminsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrgAdminsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgAdminsQuery, OrgAdminsQueryVariables>(OrgAdminsDocument, options);
      }
export function useOrgAdminsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgAdminsQuery, OrgAdminsQueryVariables>(OrgAdminsDocument, options);
        }
// @ts-ignore
export function useOrgAdminsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgAdminsQuery, OrgAdminsQueryVariables>;
export function useOrgAdminsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgAdminsQuery | undefined, OrgAdminsQueryVariables>;
export function useOrgAdminsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgAdminsQuery, OrgAdminsQueryVariables>(OrgAdminsDocument, options);
        }
export type OrgAdminsQueryHookResult = ReturnType<typeof useOrgAdminsQuery>;
export type OrgAdminsLazyQueryHookResult = ReturnType<typeof useOrgAdminsLazyQuery>;
export type OrgAdminsSuspenseQueryHookResult = ReturnType<typeof useOrgAdminsSuspenseQuery>;
export type OrgAdminsQueryResult = ApolloReactCommon.QueryResult<OrgAdminsQuery, OrgAdminsQueryVariables>;
export const ParameterImportanceDocument = gql`
    query ParameterImportance($projectName: String!, $entityName: String, $limit: Int!, $targetName: String!, $filters: JSONString, $parameters: [String!], $runParameters: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    parameterImportance(
      limit: $limit
      filters: $filters
      target: $targetName
      parameters: $parameters
      runParameters: $runParameters
    )
  }
}
    `;
export type ParameterImportanceComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>, 'query'> & ({ variables: ParameterImportanceQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ParameterImportanceComponent = (props: ParameterImportanceComponentProps) => (
      <ApolloReactComponents.Query<ParameterImportanceQuery, ParameterImportanceQueryVariables> query={ParameterImportanceDocument} {...props} />
    );
    
export type ParameterImportanceProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ParameterImportanceQuery, ParameterImportanceQueryVariables>
    } & TChildProps;
export function withParameterImportance<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ParameterImportanceQuery,
  ParameterImportanceQueryVariables,
  ParameterImportanceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ParameterImportanceQuery, ParameterImportanceQueryVariables, ParameterImportanceProps<TChildProps, TDataName>>(ParameterImportanceDocument, {
      alias: 'parameterImportance',
      ...operationOptions
    });
};

/**
 * __useParameterImportanceQuery__
 *
 * To run a query within a React component, call `useParameterImportanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useParameterImportanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParameterImportanceQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      limit: // value for 'limit'
 *      targetName: // value for 'targetName'
 *      filters: // value for 'filters'
 *      parameters: // value for 'parameters'
 *      runParameters: // value for 'runParameters'
 *   },
 * });
 */
export function useParameterImportanceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables> & ({ variables: ParameterImportanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ParameterImportanceQuery, ParameterImportanceQueryVariables>(ParameterImportanceDocument, options);
      }
export function useParameterImportanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ParameterImportanceQuery, ParameterImportanceQueryVariables>(ParameterImportanceDocument, options);
        }
// @ts-ignore
export function useParameterImportanceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ParameterImportanceQuery, ParameterImportanceQueryVariables>;
export function useParameterImportanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ParameterImportanceQuery | undefined, ParameterImportanceQueryVariables>;
export function useParameterImportanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ParameterImportanceQuery, ParameterImportanceQueryVariables>(ParameterImportanceDocument, options);
        }
export type ParameterImportanceQueryHookResult = ReturnType<typeof useParameterImportanceQuery>;
export type ParameterImportanceLazyQueryHookResult = ReturnType<typeof useParameterImportanceLazyQuery>;
export type ParameterImportanceSuspenseQueryHookResult = ReturnType<typeof useParameterImportanceSuspenseQuery>;
export type ParameterImportanceQueryResult = ApolloReactCommon.QueryResult<ParameterImportanceQuery, ParameterImportanceQueryVariables>;
export const ProjectArtifactCollectionsDocument = gql`
    query ProjectArtifactCollections($projectName: String!, $entityName: String!, $collectionTypes: [ArtifactCollectionType!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactTypes {
      edges {
        node {
          id
          name
          artifactCollections(order: "-createdAt", collectionTypes: $collectionTypes) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type ProjectArtifactCollectionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>, 'query'> & ({ variables: ProjectArtifactCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectArtifactCollectionsComponent = (props: ProjectArtifactCollectionsComponentProps) => (
      <ApolloReactComponents.Query<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables> query={ProjectArtifactCollectionsDocument} {...props} />
    );
    
export type ProjectArtifactCollectionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>
    } & TChildProps;
export function withProjectArtifactCollections<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectArtifactCollectionsQuery,
  ProjectArtifactCollectionsQueryVariables,
  ProjectArtifactCollectionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables, ProjectArtifactCollectionsProps<TChildProps, TDataName>>(ProjectArtifactCollectionsDocument, {
      alias: 'projectArtifactCollections',
      ...operationOptions
    });
};

/**
 * __useProjectArtifactCollectionsQuery__
 *
 * To run a query within a React component, call `useProjectArtifactCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectArtifactCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectArtifactCollectionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      collectionTypes: // value for 'collectionTypes'
 *   },
 * });
 */
export function useProjectArtifactCollectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables> & ({ variables: ProjectArtifactCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>(ProjectArtifactCollectionsDocument, options);
      }
export function useProjectArtifactCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>(ProjectArtifactCollectionsDocument, options);
        }
// @ts-ignore
export function useProjectArtifactCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>;
export function useProjectArtifactCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectArtifactCollectionsQuery | undefined, ProjectArtifactCollectionsQueryVariables>;
export function useProjectArtifactCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>(ProjectArtifactCollectionsDocument, options);
        }
export type ProjectArtifactCollectionsQueryHookResult = ReturnType<typeof useProjectArtifactCollectionsQuery>;
export type ProjectArtifactCollectionsLazyQueryHookResult = ReturnType<typeof useProjectArtifactCollectionsLazyQuery>;
export type ProjectArtifactCollectionsSuspenseQueryHookResult = ReturnType<typeof useProjectArtifactCollectionsSuspenseQuery>;
export type ProjectArtifactCollectionsQueryResult = ApolloReactCommon.QueryResult<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>;
export const ProjectArtifactsDocument = gql`
    query ProjectArtifacts($projectName: String!, $entityName: String!, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactTypes {
      edges {
        node {
          id
          name
          artifactCollections(order: "-createdAt", filters: $filters) {
            edges {
              node {
                id
                name
                updatedAt
              }
            }
            totalCount
          }
        }
      }
    }
  }
}
    `;
export type ProjectArtifactsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>, 'query'> & ({ variables: ProjectArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectArtifactsComponent = (props: ProjectArtifactsComponentProps) => (
      <ApolloReactComponents.Query<ProjectArtifactsQuery, ProjectArtifactsQueryVariables> query={ProjectArtifactsDocument} {...props} />
    );
    
export type ProjectArtifactsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>
    } & TChildProps;
export function withProjectArtifacts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectArtifactsQuery,
  ProjectArtifactsQueryVariables,
  ProjectArtifactsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectArtifactsQuery, ProjectArtifactsQueryVariables, ProjectArtifactsProps<TChildProps, TDataName>>(ProjectArtifactsDocument, {
      alias: 'projectArtifacts',
      ...operationOptions
    });
};

/**
 * __useProjectArtifactsQuery__
 *
 * To run a query within a React component, call `useProjectArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectArtifactsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectArtifactsQuery, ProjectArtifactsQueryVariables> & ({ variables: ProjectArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>(ProjectArtifactsDocument, options);
      }
export function useProjectArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>(ProjectArtifactsDocument, options);
        }
// @ts-ignore
export function useProjectArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>;
export function useProjectArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectArtifactsQuery | undefined, ProjectArtifactsQueryVariables>;
export function useProjectArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>(ProjectArtifactsDocument, options);
        }
export type ProjectArtifactsQueryHookResult = ReturnType<typeof useProjectArtifactsQuery>;
export type ProjectArtifactsLazyQueryHookResult = ReturnType<typeof useProjectArtifactsLazyQuery>;
export type ProjectArtifactsSuspenseQueryHookResult = ReturnType<typeof useProjectArtifactsSuspenseQuery>;
export type ProjectArtifactsQueryResult = ApolloReactCommon.QueryResult<ProjectArtifactsQuery, ProjectArtifactsQueryVariables>;
export const ProjectFieldsDocument = gql`
    query ProjectFields($projectName: String!, $entityName: String!, $types: [String!]!, $columns: [String!]!, $pattern: String, $count: Int!, $cursor: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    fields(
      types: $types
      columns: $columns
      pattern: $pattern
      first: $count
      after: $cursor
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          path
          type
        }
      }
    }
  }
}
    `;
export type ProjectFieldsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>, 'query'> & ({ variables: ProjectFieldsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectFieldsComponent = (props: ProjectFieldsComponentProps) => (
      <ApolloReactComponents.Query<ProjectFieldsQuery, ProjectFieldsQueryVariables> query={ProjectFieldsDocument} {...props} />
    );
    
export type ProjectFieldsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectFieldsQuery, ProjectFieldsQueryVariables>
    } & TChildProps;
export function withProjectFields<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectFieldsQuery,
  ProjectFieldsQueryVariables,
  ProjectFieldsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectFieldsQuery, ProjectFieldsQueryVariables, ProjectFieldsProps<TChildProps, TDataName>>(ProjectFieldsDocument, {
      alias: 'projectFields',
      ...operationOptions
    });
};

/**
 * __useProjectFieldsQuery__
 *
 * To run a query within a React component, call `useProjectFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFieldsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      types: // value for 'types'
 *      columns: // value for 'columns'
 *      pattern: // value for 'pattern'
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useProjectFieldsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables> & ({ variables: ProjectFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectFieldsQuery, ProjectFieldsQueryVariables>(ProjectFieldsDocument, options);
      }
export function useProjectFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectFieldsQuery, ProjectFieldsQueryVariables>(ProjectFieldsDocument, options);
        }
// @ts-ignore
export function useProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFieldsQuery, ProjectFieldsQueryVariables>;
export function useProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFieldsQuery | undefined, ProjectFieldsQueryVariables>;
export function useProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectFieldsQuery, ProjectFieldsQueryVariables>(ProjectFieldsDocument, options);
        }
export type ProjectFieldsQueryHookResult = ReturnType<typeof useProjectFieldsQuery>;
export type ProjectFieldsLazyQueryHookResult = ReturnType<typeof useProjectFieldsLazyQuery>;
export type ProjectFieldsSuspenseQueryHookResult = ReturnType<typeof useProjectFieldsSuspenseQuery>;
export type ProjectFieldsQueryResult = ApolloReactCommon.QueryResult<ProjectFieldsQuery, ProjectFieldsQueryVariables>;
export const ProjectPageDocument = gql`
    query ProjectPage($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
    lastActive
    access
    description
    readOnly
    totalRuns: runCount
    fromV2
    computeHours
    totalSweeps
    totalUsers
    isBenchmark
    views
    reports: allViews(viewType: "runs") {
      totalCount
    }
    user {
      id
      name
      username
      photoUrl
      accountType
    }
    linkedBenchmark {
      id
      entityName
      name
      gitHubSubmissionRepo
      views
    }
    entity {
      id
      name
      defaultAccess
      readOnlyAdmin
      privateOnly
      isTeam
      claimingEntity {
        id
        name
      }
      organization {
        id
        name
      }
    }
    ...WeaveflowCheckFragment
  }
}
    ${WeaveflowCheckFragmentFragmentDoc}`;
export type ProjectPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectPageQuery, ProjectPageQueryVariables>, 'query'> & ({ variables: ProjectPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectPageComponent = (props: ProjectPageComponentProps) => (
      <ApolloReactComponents.Query<ProjectPageQuery, ProjectPageQueryVariables> query={ProjectPageDocument} {...props} />
    );
    
export type ProjectPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectPageQuery, ProjectPageQueryVariables>
    } & TChildProps;
export function withProjectPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectPageQuery,
  ProjectPageQueryVariables,
  ProjectPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectPageQuery, ProjectPageQueryVariables, ProjectPageProps<TChildProps, TDataName>>(ProjectPageDocument, {
      alias: 'projectPage',
      ...operationOptions
    });
};

/**
 * __useProjectPageQuery__
 *
 * To run a query within a React component, call `useProjectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables> & ({ variables: ProjectPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectPageQuery, ProjectPageQueryVariables>(ProjectPageDocument, options);
      }
export function useProjectPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectPageQuery, ProjectPageQueryVariables>(ProjectPageDocument, options);
        }
// @ts-ignore
export function useProjectPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectPageQuery, ProjectPageQueryVariables>;
export function useProjectPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectPageQuery | undefined, ProjectPageQueryVariables>;
export function useProjectPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectPageQuery, ProjectPageQueryVariables>(ProjectPageDocument, options);
        }
export type ProjectPageQueryHookResult = ReturnType<typeof useProjectPageQuery>;
export type ProjectPageLazyQueryHookResult = ReturnType<typeof useProjectPageLazyQuery>;
export type ProjectPageSuspenseQueryHookResult = ReturnType<typeof useProjectPageSuspenseQuery>;
export type ProjectPageQueryResult = ApolloReactCommon.QueryResult<ProjectPageQuery, ProjectPageQueryVariables>;
export const ProjectTags2Document = gql`
    query ProjectTags2($projectName: String!, $entityName: String!, $pattern: String, $before: String, $after: String, $first: Int = 100, $last: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    runTags(
      pattern: $pattern
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          name
          id
        }
      }
    }
  }
}
    `;
export type ProjectTags2ComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectTags2Query, ProjectTags2QueryVariables>, 'query'> & ({ variables: ProjectTags2QueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectTags2Component = (props: ProjectTags2ComponentProps) => (
      <ApolloReactComponents.Query<ProjectTags2Query, ProjectTags2QueryVariables> query={ProjectTags2Document} {...props} />
    );
    
export type ProjectTags2Props<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectTags2Query, ProjectTags2QueryVariables>
    } & TChildProps;
export function withProjectTags2<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectTags2Query,
  ProjectTags2QueryVariables,
  ProjectTags2Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectTags2Query, ProjectTags2QueryVariables, ProjectTags2Props<TChildProps, TDataName>>(ProjectTags2Document, {
      alias: 'projectTags2',
      ...operationOptions
    });
};

/**
 * __useProjectTags2Query__
 *
 * To run a query within a React component, call `useProjectTags2Query` and pass it any options that fit your needs.
 * When your component renders, `useProjectTags2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTags2Query({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useProjectTags2Query(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables> & ({ variables: ProjectTags2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTags2Query, ProjectTags2QueryVariables>(ProjectTags2Document, options);
      }
export function useProjectTags2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTags2Query, ProjectTags2QueryVariables>(ProjectTags2Document, options);
        }
// @ts-ignore
export function useProjectTags2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTags2Query, ProjectTags2QueryVariables>;
export function useProjectTags2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTags2Query | undefined, ProjectTags2QueryVariables>;
export function useProjectTags2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTags2Query, ProjectTags2QueryVariables>(ProjectTags2Document, options);
        }
export type ProjectTags2QueryHookResult = ReturnType<typeof useProjectTags2Query>;
export type ProjectTags2LazyQueryHookResult = ReturnType<typeof useProjectTags2LazyQuery>;
export type ProjectTags2SuspenseQueryHookResult = ReturnType<typeof useProjectTags2SuspenseQuery>;
export type ProjectTags2QueryResult = ApolloReactCommon.QueryResult<ProjectTags2Query, ProjectTags2QueryVariables>;
export const ProjectTagsDocument = gql`
    query ProjectTags($projectName: String!, $entityName: String, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    tagCounts(filters: $filters) {
      name
      count
    }
  }
}
    `;
export type ProjectTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProjectTagsQuery, ProjectTagsQueryVariables>, 'query'> & ({ variables: ProjectTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProjectTagsComponent = (props: ProjectTagsComponentProps) => (
      <ApolloReactComponents.Query<ProjectTagsQuery, ProjectTagsQueryVariables> query={ProjectTagsDocument} {...props} />
    );
    
export type ProjectTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProjectTagsQuery, ProjectTagsQueryVariables>
    } & TChildProps;
export function withProjectTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProjectTagsQuery,
  ProjectTagsQueryVariables,
  ProjectTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProjectTagsQuery, ProjectTagsQueryVariables, ProjectTagsProps<TChildProps, TDataName>>(ProjectTagsDocument, {
      alias: 'projectTags',
      ...operationOptions
    });
};

/**
 * __useProjectTagsQuery__
 *
 * To run a query within a React component, call `useProjectTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTagsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables> & ({ variables: ProjectTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTagsQuery, ProjectTagsQueryVariables>(ProjectTagsDocument, options);
      }
export function useProjectTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTagsQuery, ProjectTagsQueryVariables>(ProjectTagsDocument, options);
        }
// @ts-ignore
export function useProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTagsQuery, ProjectTagsQueryVariables>;
export function useProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTagsQuery | undefined, ProjectTagsQueryVariables>;
export function useProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTagsQuery, ProjectTagsQueryVariables>(ProjectTagsDocument, options);
        }
export type ProjectTagsQueryHookResult = ReturnType<typeof useProjectTagsQuery>;
export type ProjectTagsLazyQueryHookResult = ReturnType<typeof useProjectTagsLazyQuery>;
export type ProjectTagsSuspenseQueryHookResult = ReturnType<typeof useProjectTagsSuspenseQuery>;
export type ProjectTagsQueryResult = ApolloReactCommon.QueryResult<ProjectTagsQuery, ProjectTagsQueryVariables>;
export const ReportPageDocument = gql`
    query ReportPage($projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    readOnly
    entity {
      id
      name
      defaultAccess
      readOnlyAdmin
      privateOnly
      isTeam
    }
  }
}
    `;
export type ReportPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReportPageQuery, ReportPageQueryVariables>, 'query'> & ({ variables: ReportPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReportPageComponent = (props: ReportPageComponentProps) => (
      <ApolloReactComponents.Query<ReportPageQuery, ReportPageQueryVariables> query={ReportPageDocument} {...props} />
    );
    
export type ReportPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ReportPageQuery, ReportPageQueryVariables>
    } & TChildProps;
export function withReportPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReportPageQuery,
  ReportPageQueryVariables,
  ReportPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ReportPageQuery, ReportPageQueryVariables, ReportPageProps<TChildProps, TDataName>>(ReportPageDocument, {
      alias: 'reportPage',
      ...operationOptions
    });
};

/**
 * __useReportPageQuery__
 *
 * To run a query within a React component, call `useReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useReportPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReportPageQuery, ReportPageQueryVariables> & ({ variables: ReportPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReportPageQuery, ReportPageQueryVariables>(ReportPageDocument, options);
      }
export function useReportPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReportPageQuery, ReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReportPageQuery, ReportPageQueryVariables>(ReportPageDocument, options);
        }
// @ts-ignore
export function useReportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReportPageQuery, ReportPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportPageQuery, ReportPageQueryVariables>;
export function useReportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportPageQuery, ReportPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportPageQuery | undefined, ReportPageQueryVariables>;
export function useReportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportPageQuery, ReportPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReportPageQuery, ReportPageQueryVariables>(ReportPageDocument, options);
        }
export type ReportPageQueryHookResult = ReturnType<typeof useReportPageQuery>;
export type ReportPageLazyQueryHookResult = ReturnType<typeof useReportPageLazyQuery>;
export type ReportPageSuspenseQueryHookResult = ReturnType<typeof useReportPageSuspenseQuery>;
export type ReportPageQueryResult = ApolloReactCommon.QueryResult<ReportPageQuery, ReportPageQueryVariables>;
export const ReportTableDocument = gql`
    query ReportTable($projectName: String!, $entityName: String, $draftsOffset: Int = 0, $draftsPageSize: Int = 100, $publishedOffset: Int = 0, $publishedPageSize: Int = 100) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    readOnly
    reportDrafts: allViews(
      viewType: "runs/draft"
      first: $draftsPageSize
      offset: $draftsOffset
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges {
        node {
          id
          ...ViewFragmentMetadata
        }
      }
    }
    reports: allViews(
      viewType: "runs"
      first: $publishedPageSize
      offset: $publishedOffset
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges {
        node {
          id
          ...ViewFragmentMetadata
        }
      }
    }
  }
}
    ${ViewFragmentMetadataFragmentDoc}`;
export type ReportTableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReportTableQuery, ReportTableQueryVariables>, 'query'> & ({ variables: ReportTableQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReportTableComponent = (props: ReportTableComponentProps) => (
      <ApolloReactComponents.Query<ReportTableQuery, ReportTableQueryVariables> query={ReportTableDocument} {...props} />
    );
    
export type ReportTableProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ReportTableQuery, ReportTableQueryVariables>
    } & TChildProps;
export function withReportTable<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReportTableQuery,
  ReportTableQueryVariables,
  ReportTableProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ReportTableQuery, ReportTableQueryVariables, ReportTableProps<TChildProps, TDataName>>(ReportTableDocument, {
      alias: 'reportTable',
      ...operationOptions
    });
};

/**
 * __useReportTableQuery__
 *
 * To run a query within a React component, call `useReportTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTableQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      draftsOffset: // value for 'draftsOffset'
 *      draftsPageSize: // value for 'draftsPageSize'
 *      publishedOffset: // value for 'publishedOffset'
 *      publishedPageSize: // value for 'publishedPageSize'
 *   },
 * });
 */
export function useReportTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReportTableQuery, ReportTableQueryVariables> & ({ variables: ReportTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReportTableQuery, ReportTableQueryVariables>(ReportTableDocument, options);
      }
export function useReportTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReportTableQuery, ReportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReportTableQuery, ReportTableQueryVariables>(ReportTableDocument, options);
        }
// @ts-ignore
export function useReportTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReportTableQuery, ReportTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportTableQuery, ReportTableQueryVariables>;
export function useReportTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportTableQuery, ReportTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportTableQuery | undefined, ReportTableQueryVariables>;
export function useReportTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportTableQuery, ReportTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReportTableQuery, ReportTableQueryVariables>(ReportTableDocument, options);
        }
export type ReportTableQueryHookResult = ReturnType<typeof useReportTableQuery>;
export type ReportTableLazyQueryHookResult = ReturnType<typeof useReportTableLazyQuery>;
export type ReportTableSuspenseQueryHookResult = ReturnType<typeof useReportTableSuspenseQuery>;
export type ReportTableQueryResult = ApolloReactCommon.QueryResult<ReportTableQuery, ReportTableQueryVariables>;
export const RunArtifactVersionsDocument = gql`
    query RunArtifactVersions($projectName: String!, $entityName: String!, $runName: String!, $pageSize: Int = 1000, $includeOutput: Boolean = false, $includeInput: Boolean = false, $after: String = "") {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      state
      outputArtifacts(first: $pageSize, after: $after) @include(if: $includeOutput) {
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
        edges {
          node {
            artifactType {
              id
              name
              project {
                id
                name
                entity {
                  id
                  name
                }
              }
            }
            id
            versionIndex
            artifactSequence {
              id
              name
            }
            usedBy {
              totalCount
            }
            isLinkedToGlobalRegistry
          }
        }
      }
      inputArtifacts(first: $pageSize, after: $after) @include(if: $includeInput) {
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
        edges {
          node {
            artifactType {
              id
              name
              project {
                id
                name
                entity {
                  id
                  name
                }
              }
            }
            id
            versionIndex
            artifactSequence {
              id
              name
              project {
                id
                name
                entity {
                  id
                  name
                }
              }
            }
            usedBy(first: 0) {
              totalCount
            }
          }
        }
      }
    }
  }
}
    `;
export type RunArtifactVersionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>, 'query'> & ({ variables: RunArtifactVersionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunArtifactVersionsComponent = (props: RunArtifactVersionsComponentProps) => (
      <ApolloReactComponents.Query<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables> query={RunArtifactVersionsDocument} {...props} />
    );
    
export type RunArtifactVersionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>
    } & TChildProps;
export function withRunArtifactVersions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunArtifactVersionsQuery,
  RunArtifactVersionsQueryVariables,
  RunArtifactVersionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables, RunArtifactVersionsProps<TChildProps, TDataName>>(RunArtifactVersionsDocument, {
      alias: 'runArtifactVersions',
      ...operationOptions
    });
};

/**
 * __useRunArtifactVersionsQuery__
 *
 * To run a query within a React component, call `useRunArtifactVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunArtifactVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunArtifactVersionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      pageSize: // value for 'pageSize'
 *      includeOutput: // value for 'includeOutput'
 *      includeInput: // value for 'includeInput'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRunArtifactVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables> & ({ variables: RunArtifactVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>(RunArtifactVersionsDocument, options);
      }
export function useRunArtifactVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>(RunArtifactVersionsDocument, options);
        }
// @ts-ignore
export function useRunArtifactVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>;
export function useRunArtifactVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunArtifactVersionsQuery | undefined, RunArtifactVersionsQueryVariables>;
export function useRunArtifactVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>(RunArtifactVersionsDocument, options);
        }
export type RunArtifactVersionsQueryHookResult = ReturnType<typeof useRunArtifactVersionsQuery>;
export type RunArtifactVersionsLazyQueryHookResult = ReturnType<typeof useRunArtifactVersionsLazyQuery>;
export type RunArtifactVersionsSuspenseQueryHookResult = ReturnType<typeof useRunArtifactVersionsSuspenseQuery>;
export type RunArtifactVersionsQueryResult = ApolloReactCommon.QueryResult<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>;
export const CodeFilesDocument = gql`
    query CodeFiles($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      codeArtifact {
        id
        commitHash
        artifactSequence {
          id
          name
        }
      }
      config
      group
      sweep {
        id
        name
      }
    }
  }
}
    `;
export type CodeFilesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CodeFilesQuery, CodeFilesQueryVariables>, 'query'> & ({ variables: CodeFilesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CodeFilesComponent = (props: CodeFilesComponentProps) => (
      <ApolloReactComponents.Query<CodeFilesQuery, CodeFilesQueryVariables> query={CodeFilesDocument} {...props} />
    );
    
export type CodeFilesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CodeFilesQuery, CodeFilesQueryVariables>
    } & TChildProps;
export function withCodeFiles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CodeFilesQuery,
  CodeFilesQueryVariables,
  CodeFilesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CodeFilesQuery, CodeFilesQueryVariables, CodeFilesProps<TChildProps, TDataName>>(CodeFilesDocument, {
      alias: 'codeFiles',
      ...operationOptions
    });
};

/**
 * __useCodeFilesQuery__
 *
 * To run a query within a React component, call `useCodeFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeFilesQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useCodeFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables> & ({ variables: CodeFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CodeFilesQuery, CodeFilesQueryVariables>(CodeFilesDocument, options);
      }
export function useCodeFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CodeFilesQuery, CodeFilesQueryVariables>(CodeFilesDocument, options);
        }
// @ts-ignore
export function useCodeFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CodeFilesQuery, CodeFilesQueryVariables>;
export function useCodeFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CodeFilesQuery | undefined, CodeFilesQueryVariables>;
export function useCodeFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CodeFilesQuery, CodeFilesQueryVariables>(CodeFilesDocument, options);
        }
export type CodeFilesQueryHookResult = ReturnType<typeof useCodeFilesQuery>;
export type CodeFilesLazyQueryHookResult = ReturnType<typeof useCodeFilesLazyQuery>;
export type CodeFilesSuspenseQueryHookResult = ReturnType<typeof useCodeFilesSuspenseQuery>;
export type CodeFilesQueryResult = ApolloReactCommon.QueryResult<CodeFilesQuery, CodeFilesQueryVariables>;
export const RunCodePollingDocument = gql`
    query RunCodePolling($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      state
      historyKeys(format: PLAINTEXT)
    }
  }
}
    `;
export type RunCodePollingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunCodePollingQuery, RunCodePollingQueryVariables>, 'query'> & ({ variables: RunCodePollingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunCodePollingComponent = (props: RunCodePollingComponentProps) => (
      <ApolloReactComponents.Query<RunCodePollingQuery, RunCodePollingQueryVariables> query={RunCodePollingDocument} {...props} />
    );
    
export type RunCodePollingProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunCodePollingQuery, RunCodePollingQueryVariables>
    } & TChildProps;
export function withRunCodePolling<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunCodePollingQuery,
  RunCodePollingQueryVariables,
  RunCodePollingProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunCodePollingQuery, RunCodePollingQueryVariables, RunCodePollingProps<TChildProps, TDataName>>(RunCodePollingDocument, {
      alias: 'runCodePolling',
      ...operationOptions
    });
};

/**
 * __useRunCodePollingQuery__
 *
 * To run a query within a React component, call `useRunCodePollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunCodePollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunCodePollingQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunCodePollingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables> & ({ variables: RunCodePollingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunCodePollingQuery, RunCodePollingQueryVariables>(RunCodePollingDocument, options);
      }
export function useRunCodePollingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunCodePollingQuery, RunCodePollingQueryVariables>(RunCodePollingDocument, options);
        }
// @ts-ignore
export function useRunCodePollingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunCodePollingQuery, RunCodePollingQueryVariables>;
export function useRunCodePollingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunCodePollingQuery | undefined, RunCodePollingQueryVariables>;
export function useRunCodePollingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunCodePollingQuery, RunCodePollingQueryVariables>(RunCodePollingDocument, options);
        }
export type RunCodePollingQueryHookResult = ReturnType<typeof useRunCodePollingQuery>;
export type RunCodePollingLazyQueryHookResult = ReturnType<typeof useRunCodePollingLazyQuery>;
export type RunCodePollingSuspenseQueryHookResult = ReturnType<typeof useRunCodePollingSuspenseQuery>;
export type RunCodePollingQueryResult = ApolloReactCommon.QueryResult<RunCodePollingQuery, RunCodePollingQueryVariables>;
export const RunsOutputArtifactsDocument = gql`
    query RunsOutputArtifacts($projectName: String!, $entityName: String!, $runNames: [String!]!, $filters: JSONString, $filenames: [String!]!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(names: $runNames) {
      edges {
        node {
          id
          name
          outputArtifacts(filters: $filters) {
            edges {
              node {
                id
                artifactType {
                  id
                  name
                }
                artifactSequenceMembership {
                  id
                  files(names: $filenames) {
                    edges {
                      node {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type RunsOutputArtifactsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>, 'query'> & ({ variables: RunsOutputArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsOutputArtifactsComponent = (props: RunsOutputArtifactsComponentProps) => (
      <ApolloReactComponents.Query<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables> query={RunsOutputArtifactsDocument} {...props} />
    );
    
export type RunsOutputArtifactsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>
    } & TChildProps;
export function withRunsOutputArtifacts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsOutputArtifactsQuery,
  RunsOutputArtifactsQueryVariables,
  RunsOutputArtifactsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables, RunsOutputArtifactsProps<TChildProps, TDataName>>(RunsOutputArtifactsDocument, {
      alias: 'runsOutputArtifacts',
      ...operationOptions
    });
};

/**
 * __useRunsOutputArtifactsQuery__
 *
 * To run a query within a React component, call `useRunsOutputArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsOutputArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsOutputArtifactsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runNames: // value for 'runNames'
 *      filters: // value for 'filters'
 *      filenames: // value for 'filenames'
 *   },
 * });
 */
export function useRunsOutputArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables> & ({ variables: RunsOutputArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>(RunsOutputArtifactsDocument, options);
      }
export function useRunsOutputArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>(RunsOutputArtifactsDocument, options);
        }
// @ts-ignore
export function useRunsOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>;
export function useRunsOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsOutputArtifactsQuery | undefined, RunsOutputArtifactsQueryVariables>;
export function useRunsOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>(RunsOutputArtifactsDocument, options);
        }
export type RunsOutputArtifactsQueryHookResult = ReturnType<typeof useRunsOutputArtifactsQuery>;
export type RunsOutputArtifactsLazyQueryHookResult = ReturnType<typeof useRunsOutputArtifactsLazyQuery>;
export type RunsOutputArtifactsSuspenseQueryHookResult = ReturnType<typeof useRunsOutputArtifactsSuspenseQuery>;
export type RunsOutputArtifactsQueryResult = ApolloReactCommon.QueryResult<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>;
export const RunByDisplayNameDocument = gql`
    query RunByDisplayName($entityName: String!, $projectName: String!, $filters: JSONString!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: 1, order: "-createdAt", filters: $filters) {
      edges {
        node {
          id
          name
          displayName
          createdAt
        }
      }
    }
  }
}
    `;
export type RunByDisplayNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>, 'query'> & ({ variables: RunByDisplayNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunByDisplayNameComponent = (props: RunByDisplayNameComponentProps) => (
      <ApolloReactComponents.Query<RunByDisplayNameQuery, RunByDisplayNameQueryVariables> query={RunByDisplayNameDocument} {...props} />
    );
    
export type RunByDisplayNameProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>
    } & TChildProps;
export function withRunByDisplayName<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunByDisplayNameQuery,
  RunByDisplayNameQueryVariables,
  RunByDisplayNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunByDisplayNameQuery, RunByDisplayNameQueryVariables, RunByDisplayNameProps<TChildProps, TDataName>>(RunByDisplayNameDocument, {
      alias: 'runByDisplayName',
      ...operationOptions
    });
};

/**
 * __useRunByDisplayNameQuery__
 *
 * To run a query within a React component, call `useRunByDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunByDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunByDisplayNameQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunByDisplayNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables> & ({ variables: RunByDisplayNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>(RunByDisplayNameDocument, options);
      }
export function useRunByDisplayNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>(RunByDisplayNameDocument, options);
        }
// @ts-ignore
export function useRunByDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>;
export function useRunByDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunByDisplayNameQuery | undefined, RunByDisplayNameQueryVariables>;
export function useRunByDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>(RunByDisplayNameDocument, options);
        }
export type RunByDisplayNameQueryHookResult = ReturnType<typeof useRunByDisplayNameQuery>;
export type RunByDisplayNameLazyQueryHookResult = ReturnType<typeof useRunByDisplayNameLazyQuery>;
export type RunByDisplayNameSuspenseQueryHookResult = ReturnType<typeof useRunByDisplayNameSuspenseQuery>;
export type RunByDisplayNameQueryResult = ApolloReactCommon.QueryResult<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>;
export const RunFilesDocument = gql`
    query RunFiles($projectName: String!, $entityName: String, $runName: String!, $maxNumFiles: Int!) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    run(name: $runName) {
      id
      name
      fileCount
      files(first: $maxNumFiles) {
        edges {
          node {
            id
            name
            url(upload: false)
            sizeBytes
            updatedAt
            artifact {
              id
              digest
            }
          }
        }
      }
    }
  }
}
    `;
export type RunFilesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunFilesQuery, RunFilesQueryVariables>, 'query'> & ({ variables: RunFilesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunFilesComponent = (props: RunFilesComponentProps) => (
      <ApolloReactComponents.Query<RunFilesQuery, RunFilesQueryVariables> query={RunFilesDocument} {...props} />
    );
    
export type RunFilesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunFilesQuery, RunFilesQueryVariables>
    } & TChildProps;
export function withRunFiles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunFilesQuery,
  RunFilesQueryVariables,
  RunFilesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunFilesQuery, RunFilesQueryVariables, RunFilesProps<TChildProps, TDataName>>(RunFilesDocument, {
      alias: 'runFiles',
      ...operationOptions
    });
};

/**
 * __useRunFilesQuery__
 *
 * To run a query within a React component, call `useRunFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunFilesQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      maxNumFiles: // value for 'maxNumFiles'
 *   },
 * });
 */
export function useRunFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunFilesQuery, RunFilesQueryVariables> & ({ variables: RunFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunFilesQuery, RunFilesQueryVariables>(RunFilesDocument, options);
      }
export function useRunFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunFilesQuery, RunFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunFilesQuery, RunFilesQueryVariables>(RunFilesDocument, options);
        }
// @ts-ignore
export function useRunFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunFilesQuery, RunFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesQuery, RunFilesQueryVariables>;
export function useRunFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesQuery, RunFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesQuery | undefined, RunFilesQueryVariables>;
export function useRunFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesQuery, RunFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunFilesQuery, RunFilesQueryVariables>(RunFilesDocument, options);
        }
export type RunFilesQueryHookResult = ReturnType<typeof useRunFilesQuery>;
export type RunFilesLazyQueryHookResult = ReturnType<typeof useRunFilesLazyQuery>;
export type RunFilesSuspenseQueryHookResult = ReturnType<typeof useRunFilesSuspenseQuery>;
export type RunFilesQueryResult = ApolloReactCommon.QueryResult<RunFilesQuery, RunFilesQueryVariables>;
export const RunFilesAndFoldersDocument = gql`
    query RunFilesAndFolders($projectName: String!, $entityName: String, $runName: String!, $maxNumFiles: Int!, $folderPath: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    run(name: $runName) {
      id
      name
      projectId
      files(first: $maxNumFiles, folderPath: $folderPath) {
        edges {
          node {
            id
            name
            url(upload: false)
            sizeBytes
            updatedAt
            artifact {
              id
              digest
            }
          }
        }
      }
      folders(folderPath: $folderPath) {
        folderList {
          name
          size
          numberOfFiles
        }
      }
    }
  }
}
    `;
export type RunFilesAndFoldersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>, 'query'> & ({ variables: RunFilesAndFoldersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunFilesAndFoldersComponent = (props: RunFilesAndFoldersComponentProps) => (
      <ApolloReactComponents.Query<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables> query={RunFilesAndFoldersDocument} {...props} />
    );
    
export type RunFilesAndFoldersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>
    } & TChildProps;
export function withRunFilesAndFolders<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunFilesAndFoldersQuery,
  RunFilesAndFoldersQueryVariables,
  RunFilesAndFoldersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables, RunFilesAndFoldersProps<TChildProps, TDataName>>(RunFilesAndFoldersDocument, {
      alias: 'runFilesAndFolders',
      ...operationOptions
    });
};

/**
 * __useRunFilesAndFoldersQuery__
 *
 * To run a query within a React component, call `useRunFilesAndFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunFilesAndFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunFilesAndFoldersQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      maxNumFiles: // value for 'maxNumFiles'
 *      folderPath: // value for 'folderPath'
 *   },
 * });
 */
export function useRunFilesAndFoldersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables> & ({ variables: RunFilesAndFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>(RunFilesAndFoldersDocument, options);
      }
export function useRunFilesAndFoldersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>(RunFilesAndFoldersDocument, options);
        }
// @ts-ignore
export function useRunFilesAndFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>;
export function useRunFilesAndFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesAndFoldersQuery | undefined, RunFilesAndFoldersQueryVariables>;
export function useRunFilesAndFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>(RunFilesAndFoldersDocument, options);
        }
export type RunFilesAndFoldersQueryHookResult = ReturnType<typeof useRunFilesAndFoldersQuery>;
export type RunFilesAndFoldersLazyQueryHookResult = ReturnType<typeof useRunFilesAndFoldersLazyQuery>;
export type RunFilesAndFoldersSuspenseQueryHookResult = ReturnType<typeof useRunFilesAndFoldersSuspenseQuery>;
export type RunFilesAndFoldersQueryResult = ApolloReactCommon.QueryResult<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>;
export const RunHistoryQueryDocument = gql`
    query RunHistoryQuery($entityName: String!, $projectName: String!, $runName: String!, $sampledHistorySpecs: [JSONString!]!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
    }
  }
}
    `;
export type RunHistoryQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>, 'query'> & ({ variables: RunHistoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunHistoryQueryComponent = (props: RunHistoryQueryComponentProps) => (
      <ApolloReactComponents.Query<RunHistoryQueryQuery, RunHistoryQueryQueryVariables> query={RunHistoryQueryDocument} {...props} />
    );
    
export type RunHistoryQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>
    } & TChildProps;
export function withRunHistoryQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunHistoryQueryQuery,
  RunHistoryQueryQueryVariables,
  RunHistoryQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunHistoryQueryQuery, RunHistoryQueryQueryVariables, RunHistoryQueryProps<TChildProps, TDataName>>(RunHistoryQueryDocument, {
      alias: 'runHistoryQuery',
      ...operationOptions
    });
};

/**
 * __useRunHistoryQueryQuery__
 *
 * To run a query within a React component, call `useRunHistoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunHistoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunHistoryQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *   },
 * });
 */
export function useRunHistoryQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables> & ({ variables: RunHistoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>(RunHistoryQueryDocument, options);
      }
export function useRunHistoryQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>(RunHistoryQueryDocument, options);
        }
// @ts-ignore
export function useRunHistoryQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>;
export function useRunHistoryQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunHistoryQueryQuery | undefined, RunHistoryQueryQueryVariables>;
export function useRunHistoryQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>(RunHistoryQueryDocument, options);
        }
export type RunHistoryQueryQueryHookResult = ReturnType<typeof useRunHistoryQueryQuery>;
export type RunHistoryQueryLazyQueryHookResult = ReturnType<typeof useRunHistoryQueryLazyQuery>;
export type RunHistoryQuerySuspenseQueryHookResult = ReturnType<typeof useRunHistoryQuerySuspenseQuery>;
export type RunHistoryQueryQueryResult = ApolloReactCommon.QueryResult<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>;
export const RunInfoAndConfigDocument = gql`
    query RunInfoAndConfig($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      runInfo {
        program
        args
        os
        python
        colab
        executable
        codeSaved
        cpuCount
        cpuCountLogical
        gpuCount
        gpu
        git {
          remote
          commit
        }
      }
      config
    }
  }
}
    `;
export type RunInfoAndConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>, 'query'> & ({ variables: RunInfoAndConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunInfoAndConfigComponent = (props: RunInfoAndConfigComponentProps) => (
      <ApolloReactComponents.Query<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables> query={RunInfoAndConfigDocument} {...props} />
    );
    
export type RunInfoAndConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>
    } & TChildProps;
export function withRunInfoAndConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunInfoAndConfigQuery,
  RunInfoAndConfigQueryVariables,
  RunInfoAndConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables, RunInfoAndConfigProps<TChildProps, TDataName>>(RunInfoAndConfigDocument, {
      alias: 'runInfoAndConfig',
      ...operationOptions
    });
};

/**
 * __useRunInfoAndConfigQuery__
 *
 * To run a query within a React component, call `useRunInfoAndConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunInfoAndConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunInfoAndConfigQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunInfoAndConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables> & ({ variables: RunInfoAndConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>(RunInfoAndConfigDocument, options);
      }
export function useRunInfoAndConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>(RunInfoAndConfigDocument, options);
        }
// @ts-ignore
export function useRunInfoAndConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>;
export function useRunInfoAndConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunInfoAndConfigQuery | undefined, RunInfoAndConfigQueryVariables>;
export function useRunInfoAndConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>(RunInfoAndConfigDocument, options);
        }
export type RunInfoAndConfigQueryHookResult = ReturnType<typeof useRunInfoAndConfigQuery>;
export type RunInfoAndConfigLazyQueryHookResult = ReturnType<typeof useRunInfoAndConfigLazyQuery>;
export type RunInfoAndConfigSuspenseQueryHookResult = ReturnType<typeof useRunInfoAndConfigSuspenseQuery>;
export type RunInfoAndConfigQueryResult = ApolloReactCommon.QueryResult<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>;
export const RunInfoDocument = gql`
    query RunInfo($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      runInfo {
        program
        args
        os
        python
        colab
        executable
        codeSaved
        cpuCount
        cpuCountLogical
        gpuCount
        gpu
        git {
          remote
          commit
        }
      }
    }
  }
}
    `;
export type RunInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunInfoQuery, RunInfoQueryVariables>, 'query'> & ({ variables: RunInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunInfoComponent = (props: RunInfoComponentProps) => (
      <ApolloReactComponents.Query<RunInfoQuery, RunInfoQueryVariables> query={RunInfoDocument} {...props} />
    );
    
export type RunInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunInfoQuery, RunInfoQueryVariables>
    } & TChildProps;
export function withRunInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunInfoQuery,
  RunInfoQueryVariables,
  RunInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunInfoQuery, RunInfoQueryVariables, RunInfoProps<TChildProps, TDataName>>(RunInfoDocument, {
      alias: 'runInfo',
      ...operationOptions
    });
};

/**
 * __useRunInfoQuery__
 *
 * To run a query within a React component, call `useRunInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunInfoQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunInfoQuery, RunInfoQueryVariables> & ({ variables: RunInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunInfoQuery, RunInfoQueryVariables>(RunInfoDocument, options);
      }
export function useRunInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunInfoQuery, RunInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunInfoQuery, RunInfoQueryVariables>(RunInfoDocument, options);
        }
// @ts-ignore
export function useRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunInfoQuery, RunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunInfoQuery, RunInfoQueryVariables>;
export function useRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunInfoQuery, RunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunInfoQuery | undefined, RunInfoQueryVariables>;
export function useRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunInfoQuery, RunInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunInfoQuery, RunInfoQueryVariables>(RunInfoDocument, options);
        }
export type RunInfoQueryHookResult = ReturnType<typeof useRunInfoQuery>;
export type RunInfoLazyQueryHookResult = ReturnType<typeof useRunInfoLazyQuery>;
export type RunInfoSuspenseQueryHookResult = ReturnType<typeof useRunInfoSuspenseQuery>;
export type RunInfoQueryResult = ApolloReactCommon.QueryResult<RunInfoQuery, RunInfoQueryVariables>;
export const RunKeysDocument = gql`
    query RunKeys($entityName: String!, $projectName: String!, $types: [String!] = ["number", "string", "boolean", "other"], $limit: Int = 1000) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    fields(
      types: $types
      columns: ["config", "summary_metrics", "system_metrics"]
      first: $limit
    ) {
      edges {
        node {
          path
        }
      }
    }
  }
}
    `;
export type RunKeysComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunKeysQuery, RunKeysQueryVariables>, 'query'> & ({ variables: RunKeysQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunKeysComponent = (props: RunKeysComponentProps) => (
      <ApolloReactComponents.Query<RunKeysQuery, RunKeysQueryVariables> query={RunKeysDocument} {...props} />
    );
    
export type RunKeysProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunKeysQuery, RunKeysQueryVariables>
    } & TChildProps;
export function withRunKeys<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunKeysQuery,
  RunKeysQueryVariables,
  RunKeysProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunKeysQuery, RunKeysQueryVariables, RunKeysProps<TChildProps, TDataName>>(RunKeysDocument, {
      alias: 'runKeys',
      ...operationOptions
    });
};

/**
 * __useRunKeysQuery__
 *
 * To run a query within a React component, call `useRunKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunKeysQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      types: // value for 'types'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRunKeysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunKeysQuery, RunKeysQueryVariables> & ({ variables: RunKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunKeysQuery, RunKeysQueryVariables>(RunKeysDocument, options);
      }
export function useRunKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunKeysQuery, RunKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunKeysQuery, RunKeysQueryVariables>(RunKeysDocument, options);
        }
// @ts-ignore
export function useRunKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunKeysQuery, RunKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunKeysQuery, RunKeysQueryVariables>;
export function useRunKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunKeysQuery, RunKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunKeysQuery | undefined, RunKeysQueryVariables>;
export function useRunKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunKeysQuery, RunKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunKeysQuery, RunKeysQueryVariables>(RunKeysDocument, options);
        }
export type RunKeysQueryHookResult = ReturnType<typeof useRunKeysQuery>;
export type RunKeysLazyQueryHookResult = ReturnType<typeof useRunKeysLazyQuery>;
export type RunKeysSuspenseQueryHookResult = ReturnType<typeof useRunKeysSuspenseQuery>;
export type RunKeysQueryResult = ApolloReactCommon.QueryResult<RunKeysQuery, RunKeysQueryVariables>;
export const RunSelectorDocument = gql`
    query RunSelector($projectInternalId: ID!) {
  project(internalId: $projectInternalId) {
    id
    runCount
    fields(
      types: ["number", "string", "boolean", "other"]
      columns: ["config", "summary_metrics", "system_metrics", "aggregations_min", "aggregations_max"]
      first: 2000
    ) {
      edges {
        node {
          path
        }
      }
    }
    entity {
      id
      settings {
        storageBucketInfo {
          ID
        }
      }
    }
  }
}
    `;
export type RunSelectorComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunSelectorQuery, RunSelectorQueryVariables>, 'query'> & ({ variables: RunSelectorQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunSelectorComponent = (props: RunSelectorComponentProps) => (
      <ApolloReactComponents.Query<RunSelectorQuery, RunSelectorQueryVariables> query={RunSelectorDocument} {...props} />
    );
    
export type RunSelectorProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunSelectorQuery, RunSelectorQueryVariables>
    } & TChildProps;
export function withRunSelector<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunSelectorQuery,
  RunSelectorQueryVariables,
  RunSelectorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunSelectorQuery, RunSelectorQueryVariables, RunSelectorProps<TChildProps, TDataName>>(RunSelectorDocument, {
      alias: 'runSelector',
      ...operationOptions
    });
};

/**
 * __useRunSelectorQuery__
 *
 * To run a query within a React component, call `useRunSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorQuery({
 *   variables: {
 *      projectInternalId: // value for 'projectInternalId'
 *   },
 * });
 */
export function useRunSelectorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables> & ({ variables: RunSelectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorQuery, RunSelectorQueryVariables>(RunSelectorDocument, options);
      }
export function useRunSelectorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorQuery, RunSelectorQueryVariables>(RunSelectorDocument, options);
        }
// @ts-ignore
export function useRunSelectorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorQuery, RunSelectorQueryVariables>;
export function useRunSelectorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorQuery | undefined, RunSelectorQueryVariables>;
export function useRunSelectorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorQuery, RunSelectorQueryVariables>(RunSelectorDocument, options);
        }
export type RunSelectorQueryHookResult = ReturnType<typeof useRunSelectorQuery>;
export type RunSelectorLazyQueryHookResult = ReturnType<typeof useRunSelectorLazyQuery>;
export type RunSelectorSuspenseQueryHookResult = ReturnType<typeof useRunSelectorSuspenseQuery>;
export type RunSelectorQueryResult = ApolloReactCommon.QueryResult<RunSelectorQuery, RunSelectorQueryVariables>;
export const RunSelectorRunsDocument = gql`
    query RunSelectorRuns($aggregationKeys: [String!], $configKeys: [String!], $currentRuns: [String!]!, $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $enableTags: Boolean = false, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunsFilter: JSONString!, $projectInternalId: ID!, $summaryKeys: [String!], $wandbKeys: [String!]) {
  project(internalId: $projectInternalId) {
    ...RunsSelectorRunsProjectFragment
  }
}
    ${RunsSelectorRunsProjectFragmentFragmentDoc}`;
export type RunSelectorRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>, 'query'> & ({ variables: RunSelectorRunsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunSelectorRunsComponent = (props: RunSelectorRunsComponentProps) => (
      <ApolloReactComponents.Query<RunSelectorRunsQuery, RunSelectorRunsQueryVariables> query={RunSelectorRunsDocument} {...props} />
    );
    
export type RunSelectorRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>
    } & TChildProps;
export function withRunSelectorRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunSelectorRunsQuery,
  RunSelectorRunsQueryVariables,
  RunSelectorRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunSelectorRunsQuery, RunSelectorRunsQueryVariables, RunSelectorRunsProps<TChildProps, TDataName>>(RunSelectorRunsDocument, {
      alias: 'runSelectorRuns',
      ...operationOptions
    });
};

/**
 * __useRunSelectorRunsQuery__
 *
 * To run a query within a React component, call `useRunSelectorRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorRunsQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      enableTags: // value for 'enableTags'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunsFilter: // value for 'pinnedRunsFilter'
 *      projectInternalId: // value for 'projectInternalId'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *   },
 * });
 */
export function useRunSelectorRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables> & ({ variables: RunSelectorRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>(RunSelectorRunsDocument, options);
      }
export function useRunSelectorRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>(RunSelectorRunsDocument, options);
        }
// @ts-ignore
export function useRunSelectorRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>;
export function useRunSelectorRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorRunsQuery | undefined, RunSelectorRunsQueryVariables>;
export function useRunSelectorRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>(RunSelectorRunsDocument, options);
        }
export type RunSelectorRunsQueryHookResult = ReturnType<typeof useRunSelectorRunsQuery>;
export type RunSelectorRunsLazyQueryHookResult = ReturnType<typeof useRunSelectorRunsLazyQuery>;
export type RunSelectorRunsSuspenseQueryHookResult = ReturnType<typeof useRunSelectorRunsSuspenseQuery>;
export type RunSelectorRunsQueryResult = ApolloReactCommon.QueryResult<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>;
export const RunSelectorCsvExportRunsDocument = gql`
    query RunSelectorCsvExportRuns($aggregationKeys: [String!], $configKeys: [String!], $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $enableTags: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $projectName: String!, $summaryKeys: [String!], $wandbKeys: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      edges {
        node {
          id
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          commit
          config(keys: $configKeys) @include(if: $enableConfig)
          createdAt
          displayName
          framework
          github
          group
          groupCounts
          heartbeatAt
          host
          jobType
          logLineCount
          name
          notes
          projectId
          readOnly
          runInfo {
            gpu
            gpuCount
          }
          shouldStop
          state
          stopped
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          sweep {
            id
            name
            displayName
          }
          tags @include(if: $enableTags)
          updatedAt
          user {
            id
            username
          }
          wandbConfig(keys: $wandbKeys)
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}`;
export type RunSelectorCsvExportRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>, 'query'> & ({ variables: RunSelectorCsvExportRunsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunSelectorCsvExportRunsComponent = (props: RunSelectorCsvExportRunsComponentProps) => (
      <ApolloReactComponents.Query<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables> query={RunSelectorCsvExportRunsDocument} {...props} />
    );
    
export type RunSelectorCsvExportRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>
    } & TChildProps;
export function withRunSelectorCsvExportRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunSelectorCsvExportRunsQuery,
  RunSelectorCsvExportRunsQueryVariables,
  RunSelectorCsvExportRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables, RunSelectorCsvExportRunsProps<TChildProps, TDataName>>(RunSelectorCsvExportRunsDocument, {
      alias: 'runSelectorCsvExportRuns',
      ...operationOptions
    });
};

/**
 * __useRunSelectorCsvExportRunsQuery__
 *
 * To run a query within a React component, call `useRunSelectorCsvExportRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorCsvExportRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorCsvExportRunsQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      enableTags: // value for 'enableTags'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *   },
 * });
 */
export function useRunSelectorCsvExportRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables> & ({ variables: RunSelectorCsvExportRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>(RunSelectorCsvExportRunsDocument, options);
      }
export function useRunSelectorCsvExportRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>(RunSelectorCsvExportRunsDocument, options);
        }
// @ts-ignore
export function useRunSelectorCsvExportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>;
export function useRunSelectorCsvExportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorCsvExportRunsQuery | undefined, RunSelectorCsvExportRunsQueryVariables>;
export function useRunSelectorCsvExportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>(RunSelectorCsvExportRunsDocument, options);
        }
export type RunSelectorCsvExportRunsQueryHookResult = ReturnType<typeof useRunSelectorCsvExportRunsQuery>;
export type RunSelectorCsvExportRunsLazyQueryHookResult = ReturnType<typeof useRunSelectorCsvExportRunsLazyQuery>;
export type RunSelectorCsvExportRunsSuspenseQueryHookResult = ReturnType<typeof useRunSelectorCsvExportRunsSuspenseQuery>;
export type RunSelectorCsvExportRunsQueryResult = ApolloReactCommon.QueryResult<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>;
export const RunSelectorAutoColsRunsDocument = gql`
    query RunSelectorAutoColsRuns($enableArtifactCounts: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $projectName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      edges {
        node {
          id
          aggregations
          commit
          config
          createdAt
          displayName
          framework
          github
          group
          groupCounts
          heartbeatAt
          host
          jobType
          logLineCount
          name
          notes
          projectId
          readOnly
          runInfo {
            gpu
            gpuCount
          }
          shouldStop
          state
          stopped
          summaryMetrics
          sweep {
            id
            name
            displayName
          }
          updatedAt
          user {
            id
            username
          }
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}`;
export type RunSelectorAutoColsRunsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>, 'query'> & ({ variables: RunSelectorAutoColsRunsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunSelectorAutoColsRunsComponent = (props: RunSelectorAutoColsRunsComponentProps) => (
      <ApolloReactComponents.Query<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables> query={RunSelectorAutoColsRunsDocument} {...props} />
    );
    
export type RunSelectorAutoColsRunsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>
    } & TChildProps;
export function withRunSelectorAutoColsRuns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunSelectorAutoColsRunsQuery,
  RunSelectorAutoColsRunsQueryVariables,
  RunSelectorAutoColsRunsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables, RunSelectorAutoColsRunsProps<TChildProps, TDataName>>(RunSelectorAutoColsRunsDocument, {
      alias: 'runSelectorAutoColsRuns',
      ...operationOptions
    });
};

/**
 * __useRunSelectorAutoColsRunsQuery__
 *
 * To run a query within a React component, call `useRunSelectorAutoColsRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorAutoColsRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorAutoColsRunsQuery({
 *   variables: {
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRunSelectorAutoColsRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables> & ({ variables: RunSelectorAutoColsRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>(RunSelectorAutoColsRunsDocument, options);
      }
export function useRunSelectorAutoColsRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>(RunSelectorAutoColsRunsDocument, options);
        }
// @ts-ignore
export function useRunSelectorAutoColsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>;
export function useRunSelectorAutoColsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorAutoColsRunsQuery | undefined, RunSelectorAutoColsRunsQueryVariables>;
export function useRunSelectorAutoColsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>(RunSelectorAutoColsRunsDocument, options);
        }
export type RunSelectorAutoColsRunsQueryHookResult = ReturnType<typeof useRunSelectorAutoColsRunsQuery>;
export type RunSelectorAutoColsRunsLazyQueryHookResult = ReturnType<typeof useRunSelectorAutoColsRunsLazyQuery>;
export type RunSelectorAutoColsRunsSuspenseQueryHookResult = ReturnType<typeof useRunSelectorAutoColsRunsSuspenseQuery>;
export type RunSelectorAutoColsRunsQueryResult = ApolloReactCommon.QueryResult<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>;
export const BulkEditorProjectTagsDocument = gql`
    query BulkEditorProjectTags($name: String!, $entityName: String, $tempFilters: JSONString) {
  project(name: $name, entityName: $entityName) {
    id
    tags {
      id
      name
      colorIndex
    }
    tagCounts(filters: $tempFilters) {
      name
      count
    }
  }
}
    `;
export type BulkEditorProjectTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>, 'query'> & ({ variables: BulkEditorProjectTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BulkEditorProjectTagsComponent = (props: BulkEditorProjectTagsComponentProps) => (
      <ApolloReactComponents.Query<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables> query={BulkEditorProjectTagsDocument} {...props} />
    );
    
export type BulkEditorProjectTagsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>
    } & TChildProps;
export function withBulkEditorProjectTags<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BulkEditorProjectTagsQuery,
  BulkEditorProjectTagsQueryVariables,
  BulkEditorProjectTagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables, BulkEditorProjectTagsProps<TChildProps, TDataName>>(BulkEditorProjectTagsDocument, {
      alias: 'bulkEditorProjectTags',
      ...operationOptions
    });
};

/**
 * __useBulkEditorProjectTagsQuery__
 *
 * To run a query within a React component, call `useBulkEditorProjectTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkEditorProjectTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkEditorProjectTagsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      entityName: // value for 'entityName'
 *      tempFilters: // value for 'tempFilters'
 *   },
 * });
 */
export function useBulkEditorProjectTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables> & ({ variables: BulkEditorProjectTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>(BulkEditorProjectTagsDocument, options);
      }
export function useBulkEditorProjectTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>(BulkEditorProjectTagsDocument, options);
        }
// @ts-ignore
export function useBulkEditorProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>;
export function useBulkEditorProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BulkEditorProjectTagsQuery | undefined, BulkEditorProjectTagsQueryVariables>;
export function useBulkEditorProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>(BulkEditorProjectTagsDocument, options);
        }
export type BulkEditorProjectTagsQueryHookResult = ReturnType<typeof useBulkEditorProjectTagsQuery>;
export type BulkEditorProjectTagsLazyQueryHookResult = ReturnType<typeof useBulkEditorProjectTagsLazyQuery>;
export type BulkEditorProjectTagsSuspenseQueryHookResult = ReturnType<typeof useBulkEditorProjectTagsSuspenseQuery>;
export type BulkEditorProjectTagsQueryResult = ApolloReactCommon.QueryResult<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>;
export const RunSetSummaryDocument = gql`
    query RunSetSummary($projectInternalId: ID!, $selections: JSONString!) {
  project(internalId: $projectInternalId) {
    id
    selectedCount: runCount(filters: $selections)
  }
}
    `;
export type RunSetSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>, 'query'> & ({ variables: RunSetSummaryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunSetSummaryComponent = (props: RunSetSummaryComponentProps) => (
      <ApolloReactComponents.Query<RunSetSummaryQuery, RunSetSummaryQueryVariables> query={RunSetSummaryDocument} {...props} />
    );
    
export type RunSetSummaryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunSetSummaryQuery, RunSetSummaryQueryVariables>
    } & TChildProps;
export function withRunSetSummary<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunSetSummaryQuery,
  RunSetSummaryQueryVariables,
  RunSetSummaryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunSetSummaryQuery, RunSetSummaryQueryVariables, RunSetSummaryProps<TChildProps, TDataName>>(RunSetSummaryDocument, {
      alias: 'runSetSummary',
      ...operationOptions
    });
};

/**
 * __useRunSetSummaryQuery__
 *
 * To run a query within a React component, call `useRunSetSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSetSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSetSummaryQuery({
 *   variables: {
 *      projectInternalId: // value for 'projectInternalId'
 *      selections: // value for 'selections'
 *   },
 * });
 */
export function useRunSetSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables> & ({ variables: RunSetSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSetSummaryQuery, RunSetSummaryQueryVariables>(RunSetSummaryDocument, options);
      }
export function useRunSetSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSetSummaryQuery, RunSetSummaryQueryVariables>(RunSetSummaryDocument, options);
        }
// @ts-ignore
export function useRunSetSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSetSummaryQuery, RunSetSummaryQueryVariables>;
export function useRunSetSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSetSummaryQuery | undefined, RunSetSummaryQueryVariables>;
export function useRunSetSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSetSummaryQuery, RunSetSummaryQueryVariables>(RunSetSummaryDocument, options);
        }
export type RunSetSummaryQueryHookResult = ReturnType<typeof useRunSetSummaryQuery>;
export type RunSetSummaryLazyQueryHookResult = ReturnType<typeof useRunSetSummaryLazyQuery>;
export type RunSetSummarySuspenseQueryHookResult = ReturnType<typeof useRunSetSummarySuspenseQuery>;
export type RunSetSummaryQueryResult = ApolloReactCommon.QueryResult<RunSetSummaryQuery, RunSetSummaryQueryVariables>;
export const RunValueSuggestionsDocument = gql`
    query RunValueSuggestions($projectName: String!, $entityName: String, $keyPath: String!, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    runKeySuggestions(keyPath: $keyPath, filters: $filters) {
      value
      displayValue
      count
    }
  }
}
    `;
export type RunValueSuggestionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>, 'query'> & ({ variables: RunValueSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunValueSuggestionsComponent = (props: RunValueSuggestionsComponentProps) => (
      <ApolloReactComponents.Query<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables> query={RunValueSuggestionsDocument} {...props} />
    );
    
export type RunValueSuggestionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>
    } & TChildProps;
export function withRunValueSuggestions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunValueSuggestionsQuery,
  RunValueSuggestionsQueryVariables,
  RunValueSuggestionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables, RunValueSuggestionsProps<TChildProps, TDataName>>(RunValueSuggestionsDocument, {
      alias: 'runValueSuggestions',
      ...operationOptions
    });
};

/**
 * __useRunValueSuggestionsQuery__
 *
 * To run a query within a React component, call `useRunValueSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunValueSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunValueSuggestionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      keyPath: // value for 'keyPath'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunValueSuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables> & ({ variables: RunValueSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>(RunValueSuggestionsDocument, options);
      }
export function useRunValueSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>(RunValueSuggestionsDocument, options);
        }
// @ts-ignore
export function useRunValueSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>;
export function useRunValueSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunValueSuggestionsQuery | undefined, RunValueSuggestionsQueryVariables>;
export function useRunValueSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>(RunValueSuggestionsDocument, options);
        }
export type RunValueSuggestionsQueryHookResult = ReturnType<typeof useRunValueSuggestionsQuery>;
export type RunValueSuggestionsLazyQueryHookResult = ReturnType<typeof useRunValueSuggestionsLazyQuery>;
export type RunValueSuggestionsSuspenseQueryHookResult = ReturnType<typeof useRunValueSuggestionsSuspenseQuery>;
export type RunValueSuggestionsQueryResult = ApolloReactCommon.QueryResult<RunValueSuggestionsQuery, RunValueSuggestionsQueryVariables>;
export const ViewSpecDocument = gql`
    query ViewSpec($id: ID!) {
  view(id: $id) {
    id
    type
    spec
  }
}
    `;
export type ViewSpecComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewSpecQuery, ViewSpecQueryVariables>, 'query'> & ({ variables: ViewSpecQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewSpecComponent = (props: ViewSpecComponentProps) => (
      <ApolloReactComponents.Query<ViewSpecQuery, ViewSpecQueryVariables> query={ViewSpecDocument} {...props} />
    );
    
export type ViewSpecProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewSpecQuery, ViewSpecQueryVariables>
    } & TChildProps;
export function withViewSpec<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewSpecQuery,
  ViewSpecQueryVariables,
  ViewSpecProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewSpecQuery, ViewSpecQueryVariables, ViewSpecProps<TChildProps, TDataName>>(ViewSpecDocument, {
      alias: 'viewSpec',
      ...operationOptions
    });
};

/**
 * __useViewSpecQuery__
 *
 * To run a query within a React component, call `useViewSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSpecQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewSpecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables> & ({ variables: ViewSpecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewSpecQuery, ViewSpecQueryVariables>(ViewSpecDocument, options);
      }
export function useViewSpecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewSpecQuery, ViewSpecQueryVariables>(ViewSpecDocument, options);
        }
// @ts-ignore
export function useViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewSpecQuery, ViewSpecQueryVariables>;
export function useViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewSpecQuery | undefined, ViewSpecQueryVariables>;
export function useViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewSpecQuery, ViewSpecQueryVariables>(ViewSpecDocument, options);
        }
export type ViewSpecQueryHookResult = ReturnType<typeof useViewSpecQuery>;
export type ViewSpecLazyQueryHookResult = ReturnType<typeof useViewSpecLazyQuery>;
export type ViewSpecSuspenseQueryHookResult = ReturnType<typeof useViewSpecSuspenseQuery>;
export type ViewSpecQueryResult = ApolloReactCommon.QueryResult<ViewSpecQuery, ViewSpecQueryVariables>;
export const SearchEntityProjectsDocument = gql`
    query SearchEntityProjects($entityName: String, $entityProjectsLimit: Int = 10000) {
  projects(entityName: $entityName, first: $entityProjectsLimit) {
    edges {
      node {
        id
        name
        entityName
        allViews(viewType: "runs", first: 1000) {
          edges {
            node {
              id
              displayName
              project {
                id
                name
                entityName
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type SearchEntityProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>, 'query'>;

    export const SearchEntityProjectsComponent = (props: SearchEntityProjectsComponentProps) => (
      <ApolloReactComponents.Query<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables> query={SearchEntityProjectsDocument} {...props} />
    );
    
export type SearchEntityProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>
    } & TChildProps;
export function withSearchEntityProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchEntityProjectsQuery,
  SearchEntityProjectsQueryVariables,
  SearchEntityProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables, SearchEntityProjectsProps<TChildProps, TDataName>>(SearchEntityProjectsDocument, {
      alias: 'searchEntityProjects',
      ...operationOptions
    });
};

/**
 * __useSearchEntityProjectsQuery__
 *
 * To run a query within a React component, call `useSearchEntityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEntityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEntityProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      entityProjectsLimit: // value for 'entityProjectsLimit'
 *   },
 * });
 */
export function useSearchEntityProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>(SearchEntityProjectsDocument, options);
      }
export function useSearchEntityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>(SearchEntityProjectsDocument, options);
        }
// @ts-ignore
export function useSearchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>;
export function useSearchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchEntityProjectsQuery | undefined, SearchEntityProjectsQueryVariables>;
export function useSearchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>(SearchEntityProjectsDocument, options);
        }
export type SearchEntityProjectsQueryHookResult = ReturnType<typeof useSearchEntityProjectsQuery>;
export type SearchEntityProjectsLazyQueryHookResult = ReturnType<typeof useSearchEntityProjectsLazyQuery>;
export type SearchEntityProjectsSuspenseQueryHookResult = ReturnType<typeof useSearchEntityProjectsSuspenseQuery>;
export type SearchEntityProjectsQueryResult = ApolloReactCommon.QueryResult<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>;
export const SearchViewerDocument = gql`
    query SearchViewer {
  viewer {
    id
    admin
    photoUrl
    username
    organizations {
      id
      name
      orgType
    }
    projects(first: 500) {
      edges {
        node {
          id
          name
          entityName
        }
      }
    }
    views(viewType: "runs", first: 10000) {
      edges {
        node {
          id
          displayName
          project {
            id
            name
            entityName
          }
        }
      }
    }
    teams(first: 500) {
      edges {
        node {
          id
          name
          photoUrl
          projects(first: 500) {
            edges {
              node {
                id
                name
                entityName
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type SearchViewerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchViewerQuery, SearchViewerQueryVariables>, 'query'>;

    export const SearchViewerComponent = (props: SearchViewerComponentProps) => (
      <ApolloReactComponents.Query<SearchViewerQuery, SearchViewerQueryVariables> query={SearchViewerDocument} {...props} />
    );
    
export type SearchViewerProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchViewerQuery, SearchViewerQueryVariables>
    } & TChildProps;
export function withSearchViewer<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchViewerQuery,
  SearchViewerQueryVariables,
  SearchViewerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchViewerQuery, SearchViewerQueryVariables, SearchViewerProps<TChildProps, TDataName>>(SearchViewerDocument, {
      alias: 'searchViewer',
      ...operationOptions
    });
};

/**
 * __useSearchViewerQuery__
 *
 * To run a query within a React component, call `useSearchViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchViewerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchViewerQuery, SearchViewerQueryVariables>(SearchViewerDocument, options);
      }
export function useSearchViewerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchViewerQuery, SearchViewerQueryVariables>(SearchViewerDocument, options);
        }
// @ts-ignore
export function useSearchViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchViewerQuery, SearchViewerQueryVariables>;
export function useSearchViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchViewerQuery | undefined, SearchViewerQueryVariables>;
export function useSearchViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchViewerQuery, SearchViewerQueryVariables>(SearchViewerDocument, options);
        }
export type SearchViewerQueryHookResult = ReturnType<typeof useSearchViewerQuery>;
export type SearchViewerLazyQueryHookResult = ReturnType<typeof useSearchViewerLazyQuery>;
export type SearchViewerSuspenseQueryHookResult = ReturnType<typeof useSearchViewerSuspenseQuery>;
export type SearchViewerQueryResult = ApolloReactCommon.QueryResult<SearchViewerQuery, SearchViewerQueryVariables>;
export const SearchNavQueryDocument = gql`
    query SearchNavQuery($entityName: String, $projectName: String, $runName: String!, $sweepName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    access
    readOnly
    isBenchmark
    entity {
      id
      name
      readOnlyAdmin
      defaultAccess
      privateOnly
      isTeam
    }
    user {
      id
    }
    run(name: $runName) {
      id
      displayName
      state
    }
    sweep(sweepName: $sweepName) {
      id
      name
      displayName
      config
    }
  }
}
    `;
export type SearchNavQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>, 'query'> & ({ variables: SearchNavQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchNavQueryComponent = (props: SearchNavQueryComponentProps) => (
      <ApolloReactComponents.Query<SearchNavQueryQuery, SearchNavQueryQueryVariables> query={SearchNavQueryDocument} {...props} />
    );
    
export type SearchNavQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchNavQueryQuery, SearchNavQueryQueryVariables>
    } & TChildProps;
export function withSearchNavQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchNavQueryQuery,
  SearchNavQueryQueryVariables,
  SearchNavQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchNavQueryQuery, SearchNavQueryQueryVariables, SearchNavQueryProps<TChildProps, TDataName>>(SearchNavQueryDocument, {
      alias: 'searchNavQuery',
      ...operationOptions
    });
};

/**
 * __useSearchNavQueryQuery__
 *
 * To run a query within a React component, call `useSearchNavQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNavQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNavQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      sweepName: // value for 'sweepName'
 *   },
 * });
 */
export function useSearchNavQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables> & ({ variables: SearchNavQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchNavQueryQuery, SearchNavQueryQueryVariables>(SearchNavQueryDocument, options);
      }
export function useSearchNavQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchNavQueryQuery, SearchNavQueryQueryVariables>(SearchNavQueryDocument, options);
        }
// @ts-ignore
export function useSearchNavQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchNavQueryQuery, SearchNavQueryQueryVariables>;
export function useSearchNavQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchNavQueryQuery | undefined, SearchNavQueryQueryVariables>;
export function useSearchNavQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchNavQueryQuery, SearchNavQueryQueryVariables>(SearchNavQueryDocument, options);
        }
export type SearchNavQueryQueryHookResult = ReturnType<typeof useSearchNavQueryQuery>;
export type SearchNavQueryLazyQueryHookResult = ReturnType<typeof useSearchNavQueryLazyQuery>;
export type SearchNavQuerySuspenseQueryHookResult = ReturnType<typeof useSearchNavQuerySuspenseQuery>;
export type SearchNavQueryQueryResult = ApolloReactCommon.QueryResult<SearchNavQueryQuery, SearchNavQueryQueryVariables>;
export const SelectedCountDocument = gql`
    query SelectedCount($projectInternalId: ID!, $filters: JSONString, $tempFilters: JSONString) {
  project(internalId: $projectInternalId) {
    id
    selectedCount: runCount(filters: $filters)
    tempSelectedCount: runCount(filters: $tempFilters)
    tempSelectedActiveCount: runActiveCount(filters: $tempFilters)
    tempOutputArtifactsCount: runOutputArtifactsCount(filters: $tempFilters)
  }
}
    `;
export type SelectedCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SelectedCountQuery, SelectedCountQueryVariables>, 'query'> & ({ variables: SelectedCountQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SelectedCountComponent = (props: SelectedCountComponentProps) => (
      <ApolloReactComponents.Query<SelectedCountQuery, SelectedCountQueryVariables> query={SelectedCountDocument} {...props} />
    );
    
export type SelectedCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SelectedCountQuery, SelectedCountQueryVariables>
    } & TChildProps;
export function withSelectedCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SelectedCountQuery,
  SelectedCountQueryVariables,
  SelectedCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SelectedCountQuery, SelectedCountQueryVariables, SelectedCountProps<TChildProps, TDataName>>(SelectedCountDocument, {
      alias: 'selectedCount',
      ...operationOptions
    });
};

/**
 * __useSelectedCountQuery__
 *
 * To run a query within a React component, call `useSelectedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedCountQuery({
 *   variables: {
 *      projectInternalId: // value for 'projectInternalId'
 *      filters: // value for 'filters'
 *      tempFilters: // value for 'tempFilters'
 *   },
 * });
 */
export function useSelectedCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables> & ({ variables: SelectedCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectedCountQuery, SelectedCountQueryVariables>(SelectedCountDocument, options);
      }
export function useSelectedCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectedCountQuery, SelectedCountQueryVariables>(SelectedCountDocument, options);
        }
// @ts-ignore
export function useSelectedCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedCountQuery, SelectedCountQueryVariables>;
export function useSelectedCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedCountQuery | undefined, SelectedCountQueryVariables>;
export function useSelectedCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectedCountQuery, SelectedCountQueryVariables>(SelectedCountDocument, options);
        }
export type SelectedCountQueryHookResult = ReturnType<typeof useSelectedCountQuery>;
export type SelectedCountLazyQueryHookResult = ReturnType<typeof useSelectedCountLazyQuery>;
export type SelectedCountSuspenseQueryHookResult = ReturnType<typeof useSelectedCountSuspenseQuery>;
export type SelectedCountQueryResult = ApolloReactCommon.QueryResult<SelectedCountQuery, SelectedCountQueryVariables>;
export const SingleFileDocument = gql`
    query SingleFile($projectName: String!, $entityName: String, $runName: String!, $fileName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      files(first: 1, names: [$fileName]) {
        edges {
          node {
            id
            name
            directUrl
            sizeBytes
            updatedAt
          }
        }
      }
    }
  }
}
    `;
export type SingleFileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SingleFileQuery, SingleFileQueryVariables>, 'query'> & ({ variables: SingleFileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SingleFileComponent = (props: SingleFileComponentProps) => (
      <ApolloReactComponents.Query<SingleFileQuery, SingleFileQueryVariables> query={SingleFileDocument} {...props} />
    );
    
export type SingleFileProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SingleFileQuery, SingleFileQueryVariables>
    } & TChildProps;
export function withSingleFile<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SingleFileQuery,
  SingleFileQueryVariables,
  SingleFileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SingleFileQuery, SingleFileQueryVariables, SingleFileProps<TChildProps, TDataName>>(SingleFileDocument, {
      alias: 'singleFile',
      ...operationOptions
    });
};

/**
 * __useSingleFileQuery__
 *
 * To run a query within a React component, call `useSingleFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleFileQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useSingleFileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SingleFileQuery, SingleFileQueryVariables> & ({ variables: SingleFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SingleFileQuery, SingleFileQueryVariables>(SingleFileDocument, options);
      }
export function useSingleFileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleFileQuery, SingleFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SingleFileQuery, SingleFileQueryVariables>(SingleFileDocument, options);
        }
// @ts-ignore
export function useSingleFileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SingleFileQuery, SingleFileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleFileQuery, SingleFileQueryVariables>;
export function useSingleFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleFileQuery, SingleFileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleFileQuery | undefined, SingleFileQueryVariables>;
export function useSingleFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleFileQuery, SingleFileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SingleFileQuery, SingleFileQueryVariables>(SingleFileDocument, options);
        }
export type SingleFileQueryHookResult = ReturnType<typeof useSingleFileQuery>;
export type SingleFileLazyQueryHookResult = ReturnType<typeof useSingleFileLazyQuery>;
export type SingleFileSuspenseQueryHookResult = ReturnType<typeof useSingleFileSuspenseQuery>;
export type SingleFileQueryResult = ApolloReactCommon.QueryResult<SingleFileQuery, SingleFileQueryVariables>;
export const SweepPageDocument = gql`
    query SweepPage($projectName: String!, $entityName: String!, $sweepName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    readOnly
    sweep(sweepName: $sweepName) {
      id
      name
      displayName
      runCount
      runCountExpected
      runTime
      method
      state
      description
      user {
        id
        username
        photoUrl
      }
      config
      createdAt
      heartbeatAt
      updatedAt
      controllerRunName
      priorRuns {
        edges {
          node {
            id
            name
          }
        }
      }
      agents {
        edges {
          node {
            id
            name
            state
            host
            persistent
            user {
              id
            }
            metrics
            createdAt
            heartbeatAt
            totalRuns
          }
        }
      }
      scheduler
    }
    entity {
      id
      name
      defaultAccess
      readOnlyAdmin
      privateOnly
      isTeam
    }
  }
}
    `;
export type SweepPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SweepPageQuery, SweepPageQueryVariables>, 'query'> & ({ variables: SweepPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SweepPageComponent = (props: SweepPageComponentProps) => (
      <ApolloReactComponents.Query<SweepPageQuery, SweepPageQueryVariables> query={SweepPageDocument} {...props} />
    );
    
export type SweepPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SweepPageQuery, SweepPageQueryVariables>
    } & TChildProps;
export function withSweepPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SweepPageQuery,
  SweepPageQueryVariables,
  SweepPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SweepPageQuery, SweepPageQueryVariables, SweepPageProps<TChildProps, TDataName>>(SweepPageDocument, {
      alias: 'sweepPage',
      ...operationOptions
    });
};

/**
 * __useSweepPageQuery__
 *
 * To run a query within a React component, call `useSweepPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSweepPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSweepPageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      sweepName: // value for 'sweepName'
 *   },
 * });
 */
export function useSweepPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SweepPageQuery, SweepPageQueryVariables> & ({ variables: SweepPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SweepPageQuery, SweepPageQueryVariables>(SweepPageDocument, options);
      }
export function useSweepPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SweepPageQuery, SweepPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SweepPageQuery, SweepPageQueryVariables>(SweepPageDocument, options);
        }
// @ts-ignore
export function useSweepPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SweepPageQuery, SweepPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepPageQuery, SweepPageQueryVariables>;
export function useSweepPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepPageQuery, SweepPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepPageQuery | undefined, SweepPageQueryVariables>;
export function useSweepPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepPageQuery, SweepPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SweepPageQuery, SweepPageQueryVariables>(SweepPageDocument, options);
        }
export type SweepPageQueryHookResult = ReturnType<typeof useSweepPageQuery>;
export type SweepPageLazyQueryHookResult = ReturnType<typeof useSweepPageLazyQuery>;
export type SweepPageSuspenseQueryHookResult = ReturnType<typeof useSweepPageSuspenseQuery>;
export type SweepPageQueryResult = ApolloReactCommon.QueryResult<SweepPageQuery, SweepPageQueryVariables>;
export const SweepsDocument = gql`
    query Sweeps($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    readOnly
    sweeps {
      edges {
        node {
          id
          name
          displayName
          state
          runCount
          runCountExpected
          runTime
          createdAt
          user {
            id
            username
            photoUrl
          }
          config
          scheduler
        }
      }
    }
  }
}
    `;
export type SweepsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SweepsQuery, SweepsQueryVariables>, 'query'> & ({ variables: SweepsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SweepsComponent = (props: SweepsComponentProps) => (
      <ApolloReactComponents.Query<SweepsQuery, SweepsQueryVariables> query={SweepsDocument} {...props} />
    );
    
export type SweepsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SweepsQuery, SweepsQueryVariables>
    } & TChildProps;
export function withSweeps<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SweepsQuery,
  SweepsQueryVariables,
  SweepsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SweepsQuery, SweepsQueryVariables, SweepsProps<TChildProps, TDataName>>(SweepsDocument, {
      alias: 'sweeps',
      ...operationOptions
    });
};

/**
 * __useSweepsQuery__
 *
 * To run a query within a React component, call `useSweepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSweepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSweepsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useSweepsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SweepsQuery, SweepsQueryVariables> & ({ variables: SweepsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SweepsQuery, SweepsQueryVariables>(SweepsDocument, options);
      }
export function useSweepsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SweepsQuery, SweepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SweepsQuery, SweepsQueryVariables>(SweepsDocument, options);
        }
// @ts-ignore
export function useSweepsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SweepsQuery, SweepsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepsQuery, SweepsQueryVariables>;
export function useSweepsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepsQuery, SweepsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepsQuery | undefined, SweepsQueryVariables>;
export function useSweepsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepsQuery, SweepsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SweepsQuery, SweepsQueryVariables>(SweepsDocument, options);
        }
export type SweepsQueryHookResult = ReturnType<typeof useSweepsQuery>;
export type SweepsLazyQueryHookResult = ReturnType<typeof useSweepsLazyQuery>;
export type SweepsSuspenseQueryHookResult = ReturnType<typeof useSweepsSuspenseQuery>;
export type SweepsQueryResult = ApolloReactCommon.QueryResult<SweepsQuery, SweepsQueryVariables>;
export const CreateArtifactCollectionTagAssignmentsDocument = gql`
    mutation CreateArtifactCollectionTagAssignments($entityName: String!, $projectName: String!, $artifactCollectionName: String!, $tags: [TagInput!]!) {
  createArtifactCollectionTagAssignments(
    input: {entityName: $entityName, projectName: $projectName, artifactCollectionName: $artifactCollectionName, tags: $tags}
  ) {
    tags {
      id
      name
      tagCategoryName
    }
  }
}
    `;
export type CreateArtifactCollectionTagAssignmentsMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>;
export type CreateArtifactCollectionTagAssignmentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>, 'mutation'>;

    export const CreateArtifactCollectionTagAssignmentsComponent = (props: CreateArtifactCollectionTagAssignmentsComponentProps) => (
      <ApolloReactComponents.Mutation<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables> mutation={CreateArtifactCollectionTagAssignmentsDocument} {...props} />
    );
    
export type CreateArtifactCollectionTagAssignmentsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>
    } & TChildProps;
export function withCreateArtifactCollectionTagAssignments<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateArtifactCollectionTagAssignmentsMutation,
  CreateArtifactCollectionTagAssignmentsMutationVariables,
  CreateArtifactCollectionTagAssignmentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables, CreateArtifactCollectionTagAssignmentsProps<TChildProps, TDataName>>(CreateArtifactCollectionTagAssignmentsDocument, {
      alias: 'createArtifactCollectionTagAssignments',
      ...operationOptions
    });
};

/**
 * __useCreateArtifactCollectionTagAssignmentsMutation__
 *
 * To run a mutation, you first call `useCreateArtifactCollectionTagAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactCollectionTagAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactCollectionTagAssignmentsMutation, { data, loading, error }] = useCreateArtifactCollectionTagAssignmentsMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateArtifactCollectionTagAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>(CreateArtifactCollectionTagAssignmentsDocument, options);
      }
export type CreateArtifactCollectionTagAssignmentsMutationHookResult = ReturnType<typeof useCreateArtifactCollectionTagAssignmentsMutation>;
export type CreateArtifactCollectionTagAssignmentsMutationResult = ApolloReactCommon.MutationResult<CreateArtifactCollectionTagAssignmentsMutation>;
export type CreateArtifactCollectionTagAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>;
export const DeleteArtifactCollectionTagAssignmentsDocument = gql`
    mutation DeleteArtifactCollectionTagAssignments($entityName: String!, $projectName: String!, $artifactCollectionName: String!, $tags: [TagInput!]!) {
  deleteArtifactCollectionTagAssignments(
    input: {entityName: $entityName, projectName: $projectName, artifactCollectionName: $artifactCollectionName, tags: $tags}
  ) {
    success
  }
}
    `;
export type DeleteArtifactCollectionTagAssignmentsMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>;
export type DeleteArtifactCollectionTagAssignmentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>, 'mutation'>;

    export const DeleteArtifactCollectionTagAssignmentsComponent = (props: DeleteArtifactCollectionTagAssignmentsComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables> mutation={DeleteArtifactCollectionTagAssignmentsDocument} {...props} />
    );
    
export type DeleteArtifactCollectionTagAssignmentsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>
    } & TChildProps;
export function withDeleteArtifactCollectionTagAssignments<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteArtifactCollectionTagAssignmentsMutation,
  DeleteArtifactCollectionTagAssignmentsMutationVariables,
  DeleteArtifactCollectionTagAssignmentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables, DeleteArtifactCollectionTagAssignmentsProps<TChildProps, TDataName>>(DeleteArtifactCollectionTagAssignmentsDocument, {
      alias: 'deleteArtifactCollectionTagAssignments',
      ...operationOptions
    });
};

/**
 * __useDeleteArtifactCollectionTagAssignmentsMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactCollectionTagAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactCollectionTagAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactCollectionTagAssignmentsMutation, { data, loading, error }] = useDeleteArtifactCollectionTagAssignmentsMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useDeleteArtifactCollectionTagAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>(DeleteArtifactCollectionTagAssignmentsDocument, options);
      }
export type DeleteArtifactCollectionTagAssignmentsMutationHookResult = ReturnType<typeof useDeleteArtifactCollectionTagAssignmentsMutation>;
export type DeleteArtifactCollectionTagAssignmentsMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactCollectionTagAssignmentsMutation>;
export type DeleteArtifactCollectionTagAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>;
export const CreateArtifactTagAssignmentsDocument = gql`
    mutation CreateArtifactTagAssignments($artifactID: ID!, $tags: [TagInput!]!) {
  createArtifactTagAssignments(input: {artifactID: $artifactID, tags: $tags}) {
    tags {
      id
      name
      tagCategoryName
    }
  }
}
    `;
export type CreateArtifactTagAssignmentsMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>;
export type CreateArtifactTagAssignmentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>, 'mutation'>;

    export const CreateArtifactTagAssignmentsComponent = (props: CreateArtifactTagAssignmentsComponentProps) => (
      <ApolloReactComponents.Mutation<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables> mutation={CreateArtifactTagAssignmentsDocument} {...props} />
    );
    
export type CreateArtifactTagAssignmentsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>
    } & TChildProps;
export function withCreateArtifactTagAssignments<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateArtifactTagAssignmentsMutation,
  CreateArtifactTagAssignmentsMutationVariables,
  CreateArtifactTagAssignmentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables, CreateArtifactTagAssignmentsProps<TChildProps, TDataName>>(CreateArtifactTagAssignmentsDocument, {
      alias: 'createArtifactTagAssignments',
      ...operationOptions
    });
};

/**
 * __useCreateArtifactTagAssignmentsMutation__
 *
 * To run a mutation, you first call `useCreateArtifactTagAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactTagAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactTagAssignmentsMutation, { data, loading, error }] = useCreateArtifactTagAssignmentsMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateArtifactTagAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>(CreateArtifactTagAssignmentsDocument, options);
      }
export type CreateArtifactTagAssignmentsMutationHookResult = ReturnType<typeof useCreateArtifactTagAssignmentsMutation>;
export type CreateArtifactTagAssignmentsMutationResult = ApolloReactCommon.MutationResult<CreateArtifactTagAssignmentsMutation>;
export type CreateArtifactTagAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>;
export const DeleteArtifactTagAssignmentsDocument = gql`
    mutation DeleteArtifactTagAssignments($artifactID: ID!, $tags: [TagInput!]!) {
  deleteArtifactTagAssignments(input: {artifactID: $artifactID, tags: $tags}) {
    success
  }
}
    `;
export type DeleteArtifactTagAssignmentsMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>;
export type DeleteArtifactTagAssignmentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>, 'mutation'>;

    export const DeleteArtifactTagAssignmentsComponent = (props: DeleteArtifactTagAssignmentsComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables> mutation={DeleteArtifactTagAssignmentsDocument} {...props} />
    );
    
export type DeleteArtifactTagAssignmentsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>
    } & TChildProps;
export function withDeleteArtifactTagAssignments<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteArtifactTagAssignmentsMutation,
  DeleteArtifactTagAssignmentsMutationVariables,
  DeleteArtifactTagAssignmentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables, DeleteArtifactTagAssignmentsProps<TChildProps, TDataName>>(DeleteArtifactTagAssignmentsDocument, {
      alias: 'deleteArtifactTagAssignments',
      ...operationOptions
    });
};

/**
 * __useDeleteArtifactTagAssignmentsMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactTagAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactTagAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactTagAssignmentsMutation, { data, loading, error }] = useDeleteArtifactTagAssignmentsMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useDeleteArtifactTagAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>(DeleteArtifactTagAssignmentsDocument, options);
      }
export type DeleteArtifactTagAssignmentsMutationHookResult = ReturnType<typeof useDeleteArtifactTagAssignmentsMutation>;
export type DeleteArtifactTagAssignmentsMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactTagAssignmentsMutation>;
export type DeleteArtifactTagAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>;
export const TeamMembersDocument = gql`
    query TeamMembers($entityName: String!) {
  entity(name: $entityName) {
    id
    members {
      ...TeamMemberFields
    }
  }
}
    ${TeamMemberFieldsFragmentDoc}`;
export type TeamMembersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamMembersQuery, TeamMembersQueryVariables>, 'query'> & ({ variables: TeamMembersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamMembersComponent = (props: TeamMembersComponentProps) => (
      <ApolloReactComponents.Query<TeamMembersQuery, TeamMembersQueryVariables> query={TeamMembersDocument} {...props} />
    );
    
export type TeamMembersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamMembersQuery, TeamMembersQueryVariables>
    } & TChildProps;
export function withTeamMembers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamMembersQuery,
  TeamMembersQueryVariables,
  TeamMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamMembersQuery, TeamMembersQueryVariables, TeamMembersProps<TChildProps, TDataName>>(TeamMembersDocument, {
      alias: 'teamMembers',
      ...operationOptions
    });
};

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables> & ({ variables: TeamMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
      }
export function useTeamMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
// @ts-ignore
export function useTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMembersQuery | undefined, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersSuspenseQueryHookResult = ReturnType<typeof useTeamMembersSuspenseQuery>;
export type TeamMembersQueryResult = ApolloReactCommon.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const TeamMemberDocument = gql`
    query TeamMember($entityName: String!, $memberId: ID!) {
  entity(name: $entityName) {
    id
    member(id: $memberId) {
      ...TeamMemberFields
      ...TeamMemberDetailedRole
    }
  }
}
    ${TeamMemberFieldsFragmentDoc}
${TeamMemberDetailedRoleFragmentDoc}`;
export type TeamMemberComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamMemberQuery, TeamMemberQueryVariables>, 'query'> & ({ variables: TeamMemberQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamMemberComponent = (props: TeamMemberComponentProps) => (
      <ApolloReactComponents.Query<TeamMemberQuery, TeamMemberQueryVariables> query={TeamMemberDocument} {...props} />
    );
    
export type TeamMemberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamMemberQuery, TeamMemberQueryVariables>
    } & TChildProps;
export function withTeamMember<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamMemberQuery,
  TeamMemberQueryVariables,
  TeamMemberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamMemberQuery, TeamMemberQueryVariables, TeamMemberProps<TChildProps, TDataName>>(TeamMemberDocument, {
      alias: 'teamMember',
      ...operationOptions
    });
};

/**
 * __useTeamMemberQuery__
 *
 * To run a query within a React component, call `useTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useTeamMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables> & ({ variables: TeamMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
      }
export function useTeamMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
        }
// @ts-ignore
export function useTeamMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMemberQuery, TeamMemberQueryVariables>;
export function useTeamMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMemberQuery | undefined, TeamMemberQueryVariables>;
export function useTeamMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
        }
export type TeamMemberQueryHookResult = ReturnType<typeof useTeamMemberQuery>;
export type TeamMemberLazyQueryHookResult = ReturnType<typeof useTeamMemberLazyQuery>;
export type TeamMemberSuspenseQueryHookResult = ReturnType<typeof useTeamMemberSuspenseQuery>;
export type TeamMemberQueryResult = ApolloReactCommon.QueryResult<TeamMemberQuery, TeamMemberQueryVariables>;
export const ContactUsForUserLedTrialDocument = gql`
    mutation contactUsForUserLedTrial($clientMutationId: String) {
  contactUsForUserLedTrial(input: {clientMutationId: $clientMutationId}) {
    clientMutationId
  }
}
    `;
export type ContactUsForUserLedTrialMutationFn = ApolloReactCommon.MutationFunction<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>;
export type ContactUsForUserLedTrialComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>, 'mutation'>;

    export const ContactUsForUserLedTrialComponent = (props: ContactUsForUserLedTrialComponentProps) => (
      <ApolloReactComponents.Mutation<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables> mutation={ContactUsForUserLedTrialDocument} {...props} />
    );
    
export type ContactUsForUserLedTrialProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>
    } & TChildProps;
export function withContactUsForUserLedTrial<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ContactUsForUserLedTrialMutation,
  ContactUsForUserLedTrialMutationVariables,
  ContactUsForUserLedTrialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables, ContactUsForUserLedTrialProps<TChildProps, TDataName>>(ContactUsForUserLedTrialDocument, {
      alias: 'contactUsForUserLedTrial',
      ...operationOptions
    });
};

/**
 * __useContactUsForUserLedTrialMutation__
 *
 * To run a mutation, you first call `useContactUsForUserLedTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactUsForUserLedTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactUsForUserLedTrialMutation, { data, loading, error }] = useContactUsForUserLedTrialMutation({
 *   variables: {
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useContactUsForUserLedTrialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>(ContactUsForUserLedTrialDocument, options);
      }
export type ContactUsForUserLedTrialMutationHookResult = ReturnType<typeof useContactUsForUserLedTrialMutation>;
export type ContactUsForUserLedTrialMutationResult = ApolloReactCommon.MutationResult<ContactUsForUserLedTrialMutation>;
export type ContactUsForUserLedTrialMutationOptions = ApolloReactCommon.BaseMutationOptions<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>;
export const ContactUsForComputeHoursDocument = gql`
    mutation contactUsForComputeHours($clientMutationId: String) {
  contactUsForComputeHours(input: {clientMutationId: $clientMutationId}) {
    clientMutationId
  }
}
    `;
export type ContactUsForComputeHoursMutationFn = ApolloReactCommon.MutationFunction<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>;
export type ContactUsForComputeHoursComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>, 'mutation'>;

    export const ContactUsForComputeHoursComponent = (props: ContactUsForComputeHoursComponentProps) => (
      <ApolloReactComponents.Mutation<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables> mutation={ContactUsForComputeHoursDocument} {...props} />
    );
    
export type ContactUsForComputeHoursProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>
    } & TChildProps;
export function withContactUsForComputeHours<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ContactUsForComputeHoursMutation,
  ContactUsForComputeHoursMutationVariables,
  ContactUsForComputeHoursProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables, ContactUsForComputeHoursProps<TChildProps, TDataName>>(ContactUsForComputeHoursDocument, {
      alias: 'contactUsForComputeHours',
      ...operationOptions
    });
};

/**
 * __useContactUsForComputeHoursMutation__
 *
 * To run a mutation, you first call `useContactUsForComputeHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactUsForComputeHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactUsForComputeHoursMutation, { data, loading, error }] = useContactUsForComputeHoursMutation({
 *   variables: {
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useContactUsForComputeHoursMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>(ContactUsForComputeHoursDocument, options);
      }
export type ContactUsForComputeHoursMutationHookResult = ReturnType<typeof useContactUsForComputeHoursMutation>;
export type ContactUsForComputeHoursMutationResult = ApolloReactCommon.MutationResult<ContactUsForComputeHoursMutation>;
export type ContactUsForComputeHoursMutationOptions = ApolloReactCommon.BaseMutationOptions<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>;
export const UserProfileDocument = gql`
    query UserProfile($userName: String!) {
  user(userName: $userName) {
    id
    profileView {
      id
      spec
      updatedAt
      updatedBy {
        id
        username
      }
    }
  }
}
    `;
export type UserProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserProfileQuery, UserProfileQueryVariables>, 'query'> & ({ variables: UserProfileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserProfileComponent = (props: UserProfileComponentProps) => (
      <ApolloReactComponents.Query<UserProfileQuery, UserProfileQueryVariables> query={UserProfileDocument} {...props} />
    );
    
export type UserProfileProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserProfileQuery, UserProfileQueryVariables>
    } & TChildProps;
export function withUserProfile<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserProfileQuery,
  UserProfileQueryVariables,
  UserProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserProfileQuery, UserProfileQueryVariables, UserProfileProps<TChildProps, TDataName>>(UserProfileDocument, {
      alias: 'userProfile',
      ...operationOptions
    });
};

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables> & ({ variables: UserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
// @ts-ignore
export function useUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProfileQuery, UserProfileQueryVariables>;
export function useUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProfileQuery | undefined, UserProfileQueryVariables>;
export function useUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileSuspenseQueryHookResult = ReturnType<typeof useUserProfileSuspenseQuery>;
export type UserProfileQueryResult = ApolloReactCommon.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserProjectsDocument = gql`
    query UserProjects($userName: String!, $includeReports: Boolean!, $first: Int = 10000, $pattern: String) {
  user(userName: $userName) {
    id
    teams {
      edges {
        node {
          id
          name
          projects(order: "-created_at", first: $first, pattern: $pattern) {
            edges {
              node {
                id
                name
                entityName
                reports: allViews(viewType: "runs") @include(if: $includeReports) {
                  edges {
                    node {
                      id
                      ...ViewFragmentMetadata
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ViewFragmentMetadataFragmentDoc}`;
export type UserProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserProjectsQuery, UserProjectsQueryVariables>, 'query'> & ({ variables: UserProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserProjectsComponent = (props: UserProjectsComponentProps) => (
      <ApolloReactComponents.Query<UserProjectsQuery, UserProjectsQueryVariables> query={UserProjectsDocument} {...props} />
    );
    
export type UserProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserProjectsQuery, UserProjectsQueryVariables>
    } & TChildProps;
export function withUserProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserProjectsQuery,
  UserProjectsQueryVariables,
  UserProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserProjectsQuery, UserProjectsQueryVariables, UserProjectsProps<TChildProps, TDataName>>(UserProjectsDocument, {
      alias: 'userProjects',
      ...operationOptions
    });
};

/**
 * __useUserProjectsQuery__
 *
 * To run a query within a React component, call `useUserProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectsQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      includeReports: // value for 'includeReports'
 *      first: // value for 'first'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useUserProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables> & ({ variables: UserProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProjectsQuery, UserProjectsQueryVariables>(UserProjectsDocument, options);
      }
export function useUserProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProjectsQuery, UserProjectsQueryVariables>(UserProjectsDocument, options);
        }
// @ts-ignore
export function useUserProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProjectsQuery, UserProjectsQueryVariables>;
export function useUserProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProjectsQuery | undefined, UserProjectsQueryVariables>;
export function useUserProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProjectsQuery, UserProjectsQueryVariables>(UserProjectsDocument, options);
        }
export type UserProjectsQueryHookResult = ReturnType<typeof useUserProjectsQuery>;
export type UserProjectsLazyQueryHookResult = ReturnType<typeof useUserProjectsLazyQuery>;
export type UserProjectsSuspenseQueryHookResult = ReturnType<typeof useUserProjectsSuspenseQuery>;
export type UserProjectsQueryResult = ApolloReactCommon.QueryResult<UserProjectsQuery, UserProjectsQueryVariables>;
export const AllTeamProjectsDocument = gql`
    query AllTeamProjects($entityName: String!, $first: Int = 10000) {
  projects(first: $first, entityName: $entityName) {
    edges {
      node {
        id
        name
        entityName
        totalRuns
        lastActive
        computeHours
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export type AllTeamProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>, 'query'> & ({ variables: AllTeamProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AllTeamProjectsComponent = (props: AllTeamProjectsComponentProps) => (
      <ApolloReactComponents.Query<AllTeamProjectsQuery, AllTeamProjectsQueryVariables> query={AllTeamProjectsDocument} {...props} />
    );
    
export type AllTeamProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>
    } & TChildProps;
export function withAllTeamProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllTeamProjectsQuery,
  AllTeamProjectsQueryVariables,
  AllTeamProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllTeamProjectsQuery, AllTeamProjectsQueryVariables, AllTeamProjectsProps<TChildProps, TDataName>>(AllTeamProjectsDocument, {
      alias: 'allTeamProjects',
      ...operationOptions
    });
};

/**
 * __useAllTeamProjectsQuery__
 *
 * To run a query within a React component, call `useAllTeamProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTeamProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTeamProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllTeamProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables> & ({ variables: AllTeamProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>(AllTeamProjectsDocument, options);
      }
export function useAllTeamProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>(AllTeamProjectsDocument, options);
        }
// @ts-ignore
export function useAllTeamProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>;
export function useAllTeamProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllTeamProjectsQuery | undefined, AllTeamProjectsQueryVariables>;
export function useAllTeamProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>(AllTeamProjectsDocument, options);
        }
export type AllTeamProjectsQueryHookResult = ReturnType<typeof useAllTeamProjectsQuery>;
export type AllTeamProjectsLazyQueryHookResult = ReturnType<typeof useAllTeamProjectsLazyQuery>;
export type AllTeamProjectsSuspenseQueryHookResult = ReturnType<typeof useAllTeamProjectsSuspenseQuery>;
export type AllTeamProjectsQueryResult = ApolloReactCommon.QueryResult<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>;
export const UserReportsDocument = gql`
    query UserReports {
  viewer {
    id
    username
    views(viewType: "runs") {
      edges {
        node {
          id
          createdAt
          updatedAt
          name
          displayName
          description
          previewUrl
          spec
          viewCount
          project {
            id
            name
            entityName
            access
          }
        }
      }
    }
  }
}
    `;
export type UserReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserReportsQuery, UserReportsQueryVariables>, 'query'>;

    export const UserReportsComponent = (props: UserReportsComponentProps) => (
      <ApolloReactComponents.Query<UserReportsQuery, UserReportsQueryVariables> query={UserReportsDocument} {...props} />
    );
    
export type UserReportsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserReportsQuery, UserReportsQueryVariables>
    } & TChildProps;
export function withUserReports<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserReportsQuery,
  UserReportsQueryVariables,
  UserReportsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserReportsQuery, UserReportsQueryVariables, UserReportsProps<TChildProps, TDataName>>(UserReportsDocument, {
      alias: 'userReports',
      ...operationOptions
    });
};

/**
 * __useUserReportsQuery__
 *
 * To run a query within a React component, call `useUserReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserReportsQuery, UserReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserReportsQuery, UserReportsQueryVariables>(UserReportsDocument, options);
      }
export function useUserReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserReportsQuery, UserReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserReportsQuery, UserReportsQueryVariables>(UserReportsDocument, options);
        }
// @ts-ignore
export function useUserReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserReportsQuery, UserReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserReportsQuery, UserReportsQueryVariables>;
export function useUserReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserReportsQuery, UserReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserReportsQuery | undefined, UserReportsQueryVariables>;
export function useUserReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserReportsQuery, UserReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserReportsQuery, UserReportsQueryVariables>(UserReportsDocument, options);
        }
export type UserReportsQueryHookResult = ReturnType<typeof useUserReportsQuery>;
export type UserReportsLazyQueryHookResult = ReturnType<typeof useUserReportsLazyQuery>;
export type UserReportsSuspenseQueryHookResult = ReturnType<typeof useUserReportsSuspenseQuery>;
export type UserReportsQueryResult = ApolloReactCommon.QueryResult<UserReportsQuery, UserReportsQueryVariables>;
export const Vega2PanelDocument = gql`
    query Vega2Panel($projectName: String!, $entityName: String, $id: ID!, $fetchSingle: Boolean!) {
  project(name: $projectName, entityName: $entityName) {
    id
    allViews(viewType: "vega2-panel") {
      edges {
        node {
          id
          ...ViewFragment
        }
      }
    }
  }
  view(id: $id, type: "vega2-panel") @include(if: $fetchSingle) {
    id
    ...ViewFragment
  }
}
    ${ViewFragmentFragmentDoc}`;
export type Vega2PanelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Vega2PanelQuery, Vega2PanelQueryVariables>, 'query'> & ({ variables: Vega2PanelQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const Vega2PanelComponent = (props: Vega2PanelComponentProps) => (
      <ApolloReactComponents.Query<Vega2PanelQuery, Vega2PanelQueryVariables> query={Vega2PanelDocument} {...props} />
    );
    
export type Vega2PanelProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<Vega2PanelQuery, Vega2PanelQueryVariables>
    } & TChildProps;
export function withVega2Panel<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  Vega2PanelQuery,
  Vega2PanelQueryVariables,
  Vega2PanelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, Vega2PanelQuery, Vega2PanelQueryVariables, Vega2PanelProps<TChildProps, TDataName>>(Vega2PanelDocument, {
      alias: 'vega2Panel',
      ...operationOptions
    });
};

/**
 * __useVega2PanelQuery__
 *
 * To run a query within a React component, call `useVega2PanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useVega2PanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVega2PanelQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      fetchSingle: // value for 'fetchSingle'
 *   },
 * });
 */
export function useVega2PanelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables> & ({ variables: Vega2PanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Vega2PanelQuery, Vega2PanelQueryVariables>(Vega2PanelDocument, options);
      }
export function useVega2PanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Vega2PanelQuery, Vega2PanelQueryVariables>(Vega2PanelDocument, options);
        }
// @ts-ignore
export function useVega2PanelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Vega2PanelQuery, Vega2PanelQueryVariables>;
export function useVega2PanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Vega2PanelQuery | undefined, Vega2PanelQueryVariables>;
export function useVega2PanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Vega2PanelQuery, Vega2PanelQueryVariables>(Vega2PanelDocument, options);
        }
export type Vega2PanelQueryHookResult = ReturnType<typeof useVega2PanelQuery>;
export type Vega2PanelLazyQueryHookResult = ReturnType<typeof useVega2PanelLazyQuery>;
export type Vega2PanelSuspenseQueryHookResult = ReturnType<typeof useVega2PanelSuspenseQuery>;
export type Vega2PanelQueryResult = ApolloReactCommon.QueryResult<Vega2PanelQuery, Vega2PanelQueryVariables>;
export const VegaPanelDocument = gql`
    query VegaPanel($projectName: String!, $entityName: String, $id: ID!, $fetchSingle: Boolean!) {
  project(name: $projectName, entityName: $entityName) {
    id
    allViews(viewType: "vega-panel") {
      edges {
        node {
          id
          ...ViewFragment
        }
      }
    }
  }
  view(id: $id, type: "vega-panel") @include(if: $fetchSingle) {
    id
    ...ViewFragment
  }
}
    ${ViewFragmentFragmentDoc}`;
export type VegaPanelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<VegaPanelQuery, VegaPanelQueryVariables>, 'query'> & ({ variables: VegaPanelQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const VegaPanelComponent = (props: VegaPanelComponentProps) => (
      <ApolloReactComponents.Query<VegaPanelQuery, VegaPanelQueryVariables> query={VegaPanelDocument} {...props} />
    );
    
export type VegaPanelProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<VegaPanelQuery, VegaPanelQueryVariables>
    } & TChildProps;
export function withVegaPanel<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  VegaPanelQuery,
  VegaPanelQueryVariables,
  VegaPanelProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, VegaPanelQuery, VegaPanelQueryVariables, VegaPanelProps<TChildProps, TDataName>>(VegaPanelDocument, {
      alias: 'vegaPanel',
      ...operationOptions
    });
};

/**
 * __useVegaPanelQuery__
 *
 * To run a query within a React component, call `useVegaPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useVegaPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVegaPanelQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      fetchSingle: // value for 'fetchSingle'
 *   },
 * });
 */
export function useVegaPanelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables> & ({ variables: VegaPanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VegaPanelQuery, VegaPanelQueryVariables>(VegaPanelDocument, options);
      }
export function useVegaPanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VegaPanelQuery, VegaPanelQueryVariables>(VegaPanelDocument, options);
        }
// @ts-ignore
export function useVegaPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VegaPanelQuery, VegaPanelQueryVariables>;
export function useVegaPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VegaPanelQuery | undefined, VegaPanelQueryVariables>;
export function useVegaPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VegaPanelQuery, VegaPanelQueryVariables>(VegaPanelDocument, options);
        }
export type VegaPanelQueryHookResult = ReturnType<typeof useVegaPanelQuery>;
export type VegaPanelLazyQueryHookResult = ReturnType<typeof useVegaPanelLazyQuery>;
export type VegaPanelSuspenseQueryHookResult = ReturnType<typeof useVegaPanelSuspenseQuery>;
export type VegaPanelQueryResult = ApolloReactCommon.QueryResult<VegaPanelQuery, VegaPanelQueryVariables>;
export const ViewerApiKeyDocument = gql`
    query ViewerApiKey {
  viewer {
    id
    apiKey
  }
}
    `;
export type ViewerApiKeyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>, 'query'>;

    export const ViewerApiKeyComponent = (props: ViewerApiKeyComponentProps) => (
      <ApolloReactComponents.Query<ViewerApiKeyQuery, ViewerApiKeyQueryVariables> query={ViewerApiKeyDocument} {...props} />
    );
    
export type ViewerApiKeyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>
    } & TChildProps;
export function withViewerApiKey<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerApiKeyQuery,
  ViewerApiKeyQueryVariables,
  ViewerApiKeyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerApiKeyQuery, ViewerApiKeyQueryVariables, ViewerApiKeyProps<TChildProps, TDataName>>(ViewerApiKeyDocument, {
      alias: 'viewerApiKey',
      ...operationOptions
    });
};

/**
 * __useViewerApiKeyQuery__
 *
 * To run a query within a React component, call `useViewerApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerApiKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerApiKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>(ViewerApiKeyDocument, options);
      }
export function useViewerApiKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>(ViewerApiKeyDocument, options);
        }
// @ts-ignore
export function useViewerApiKeySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>;
export function useViewerApiKeySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerApiKeyQuery | undefined, ViewerApiKeyQueryVariables>;
export function useViewerApiKeySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>(ViewerApiKeyDocument, options);
        }
export type ViewerApiKeyQueryHookResult = ReturnType<typeof useViewerApiKeyQuery>;
export type ViewerApiKeyLazyQueryHookResult = ReturnType<typeof useViewerApiKeyLazyQuery>;
export type ViewerApiKeySuspenseQueryHookResult = ReturnType<typeof useViewerApiKeySuspenseQuery>;
export type ViewerApiKeyQueryResult = ApolloReactCommon.QueryResult<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>;
export const ViewerApiKeysDocument = gql`
    query ViewerApiKeys {
  viewer {
    id
    apiKeys {
      edges {
        node {
          id
          name
          createdAt
          expiresAt
          description
          apiKeyId
        }
      }
    }
  }
}
    `;
export type ViewerApiKeysComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>, 'query'>;

    export const ViewerApiKeysComponent = (props: ViewerApiKeysComponentProps) => (
      <ApolloReactComponents.Query<ViewerApiKeysQuery, ViewerApiKeysQueryVariables> query={ViewerApiKeysDocument} {...props} />
    );
    
export type ViewerApiKeysProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>
    } & TChildProps;
export function withViewerApiKeys<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewerApiKeysQuery,
  ViewerApiKeysQueryVariables,
  ViewerApiKeysProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewerApiKeysQuery, ViewerApiKeysQueryVariables, ViewerApiKeysProps<TChildProps, TDataName>>(ViewerApiKeysDocument, {
      alias: 'viewerApiKeys',
      ...operationOptions
    });
};

/**
 * __useViewerApiKeysQuery__
 *
 * To run a query within a React component, call `useViewerApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerApiKeysQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>(ViewerApiKeysDocument, options);
      }
export function useViewerApiKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>(ViewerApiKeysDocument, options);
        }
// @ts-ignore
export function useViewerApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>;
export function useViewerApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerApiKeysQuery | undefined, ViewerApiKeysQueryVariables>;
export function useViewerApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>(ViewerApiKeysDocument, options);
        }
export type ViewerApiKeysQueryHookResult = ReturnType<typeof useViewerApiKeysQuery>;
export type ViewerApiKeysLazyQueryHookResult = ReturnType<typeof useViewerApiKeysLazyQuery>;
export type ViewerApiKeysSuspenseQueryHookResult = ReturnType<typeof useViewerApiKeysSuspenseQuery>;
export type ViewerApiKeysQueryResult = ApolloReactCommon.QueryResult<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>;
export const WandbConfigDocument = gql`
    query WandbConfig($projectName: String!, $entityName: String!, $filters: JSONString, $limit: Int = 100, $order: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters, first: $limit, order: $order) {
      edges {
        node {
          id
          wandbConfig
        }
      }
    }
  }
}
    `;
export type WandbConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WandbConfigQuery, WandbConfigQueryVariables>, 'query'> & ({ variables: WandbConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WandbConfigComponent = (props: WandbConfigComponentProps) => (
      <ApolloReactComponents.Query<WandbConfigQuery, WandbConfigQueryVariables> query={WandbConfigDocument} {...props} />
    );
    
export type WandbConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<WandbConfigQuery, WandbConfigQueryVariables>
    } & TChildProps;
export function withWandbConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  WandbConfigQuery,
  WandbConfigQueryVariables,
  WandbConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, WandbConfigQuery, WandbConfigQueryVariables, WandbConfigProps<TChildProps, TDataName>>(WandbConfigDocument, {
      alias: 'wandbConfig',
      ...operationOptions
    });
};

/**
 * __useWandbConfigQuery__
 *
 * To run a query within a React component, call `useWandbConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useWandbConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWandbConfigQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useWandbConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables> & ({ variables: WandbConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WandbConfigQuery, WandbConfigQueryVariables>(WandbConfigDocument, options);
      }
export function useWandbConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WandbConfigQuery, WandbConfigQueryVariables>(WandbConfigDocument, options);
        }
// @ts-ignore
export function useWandbConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WandbConfigQuery, WandbConfigQueryVariables>;
export function useWandbConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WandbConfigQuery | undefined, WandbConfigQueryVariables>;
export function useWandbConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WandbConfigQuery, WandbConfigQueryVariables>(WandbConfigDocument, options);
        }
export type WandbConfigQueryHookResult = ReturnType<typeof useWandbConfigQuery>;
export type WandbConfigLazyQueryHookResult = ReturnType<typeof useWandbConfigLazyQuery>;
export type WandbConfigSuspenseQueryHookResult = ReturnType<typeof useWandbConfigSuspenseQuery>;
export type WandbConfigQueryResult = ApolloReactCommon.QueryResult<WandbConfigQuery, WandbConfigQueryVariables>;
export const CoreweaveIdDocument = gql`
    query CoreweaveId($entity: String) {
  entity(name: $entity) {
    id
    organization {
      id
      coreWeaveOrganizationId
    }
  }
}
    `;
export type CoreweaveIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>, 'query'>;

    export const CoreweaveIdComponent = (props: CoreweaveIdComponentProps) => (
      <ApolloReactComponents.Query<CoreweaveIdQuery, CoreweaveIdQueryVariables> query={CoreweaveIdDocument} {...props} />
    );
    
export type CoreweaveIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CoreweaveIdQuery, CoreweaveIdQueryVariables>
    } & TChildProps;
export function withCoreweaveId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CoreweaveIdQuery,
  CoreweaveIdQueryVariables,
  CoreweaveIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CoreweaveIdQuery, CoreweaveIdQueryVariables, CoreweaveIdProps<TChildProps, TDataName>>(CoreweaveIdDocument, {
      alias: 'coreweaveId',
      ...operationOptions
    });
};

/**
 * __useCoreweaveIdQuery__
 *
 * To run a query within a React component, call `useCoreweaveIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoreweaveIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreweaveIdQuery({
 *   variables: {
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useCoreweaveIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CoreweaveIdQuery, CoreweaveIdQueryVariables>(CoreweaveIdDocument, options);
      }
export function useCoreweaveIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CoreweaveIdQuery, CoreweaveIdQueryVariables>(CoreweaveIdDocument, options);
        }
// @ts-ignore
export function useCoreweaveIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoreweaveIdQuery, CoreweaveIdQueryVariables>;
export function useCoreweaveIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoreweaveIdQuery | undefined, CoreweaveIdQueryVariables>;
export function useCoreweaveIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CoreweaveIdQuery, CoreweaveIdQueryVariables>(CoreweaveIdDocument, options);
        }
export type CoreweaveIdQueryHookResult = ReturnType<typeof useCoreweaveIdQuery>;
export type CoreweaveIdLazyQueryHookResult = ReturnType<typeof useCoreweaveIdLazyQuery>;
export type CoreweaveIdSuspenseQueryHookResult = ReturnType<typeof useCoreweaveIdSuspenseQuery>;
export type CoreweaveIdQueryResult = ApolloReactCommon.QueryResult<CoreweaveIdQuery, CoreweaveIdQueryVariables>;
export const CoreweaveIdByRunNameDocument = gql`
    query CoreweaveIdByRunName($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      runInfo {
        coreweave {
          orgId
          clusterName
          region
        }
      }
    }
  }
}
    `;
export type CoreweaveIdByRunNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>, 'query'> & ({ variables: CoreweaveIdByRunNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CoreweaveIdByRunNameComponent = (props: CoreweaveIdByRunNameComponentProps) => (
      <ApolloReactComponents.Query<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables> query={CoreweaveIdByRunNameDocument} {...props} />
    );
    
export type CoreweaveIdByRunNameProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>
    } & TChildProps;
export function withCoreweaveIdByRunName<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CoreweaveIdByRunNameQuery,
  CoreweaveIdByRunNameQueryVariables,
  CoreweaveIdByRunNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables, CoreweaveIdByRunNameProps<TChildProps, TDataName>>(CoreweaveIdByRunNameDocument, {
      alias: 'coreweaveIdByRunName',
      ...operationOptions
    });
};

/**
 * __useCoreweaveIdByRunNameQuery__
 *
 * To run a query within a React component, call `useCoreweaveIdByRunNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoreweaveIdByRunNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreweaveIdByRunNameQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useCoreweaveIdByRunNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables> & ({ variables: CoreweaveIdByRunNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>(CoreweaveIdByRunNameDocument, options);
      }
export function useCoreweaveIdByRunNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>(CoreweaveIdByRunNameDocument, options);
        }
// @ts-ignore
export function useCoreweaveIdByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>;
export function useCoreweaveIdByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoreweaveIdByRunNameQuery | undefined, CoreweaveIdByRunNameQueryVariables>;
export function useCoreweaveIdByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>(CoreweaveIdByRunNameDocument, options);
        }
export type CoreweaveIdByRunNameQueryHookResult = ReturnType<typeof useCoreweaveIdByRunNameQuery>;
export type CoreweaveIdByRunNameLazyQueryHookResult = ReturnType<typeof useCoreweaveIdByRunNameLazyQuery>;
export type CoreweaveIdByRunNameSuspenseQueryHookResult = ReturnType<typeof useCoreweaveIdByRunNameSuspenseQuery>;
export type CoreweaveIdByRunNameQueryResult = ApolloReactCommon.QueryResult<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>;
export const RunIssueQueryDocument = gql`
    query RunIssueQuery($entityName: String!, $projectName: String!, $runName: String!, $start: DateTime!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      nodeAlertsHistory(start: $start) {
        ...NodeAlertFragment
      }
    }
  }
}
    ${NodeAlertFragmentFragmentDoc}`;
export type RunIssueQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>, 'query'> & ({ variables: RunIssueQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunIssueQueryComponent = (props: RunIssueQueryComponentProps) => (
      <ApolloReactComponents.Query<RunIssueQueryQuery, RunIssueQueryQueryVariables> query={RunIssueQueryDocument} {...props} />
    );
    
export type RunIssueQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunIssueQueryQuery, RunIssueQueryQueryVariables>
    } & TChildProps;
export function withRunIssueQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunIssueQueryQuery,
  RunIssueQueryQueryVariables,
  RunIssueQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunIssueQueryQuery, RunIssueQueryQueryVariables, RunIssueQueryProps<TChildProps, TDataName>>(RunIssueQueryDocument, {
      alias: 'runIssueQuery',
      ...operationOptions
    });
};

/**
 * __useRunIssueQueryQuery__
 *
 * To run a query within a React component, call `useRunIssueQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunIssueQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunIssueQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useRunIssueQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables> & ({ variables: RunIssueQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunIssueQueryQuery, RunIssueQueryQueryVariables>(RunIssueQueryDocument, options);
      }
export function useRunIssueQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunIssueQueryQuery, RunIssueQueryQueryVariables>(RunIssueQueryDocument, options);
        }
// @ts-ignore
export function useRunIssueQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunIssueQueryQuery, RunIssueQueryQueryVariables>;
export function useRunIssueQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunIssueQueryQuery | undefined, RunIssueQueryQueryVariables>;
export function useRunIssueQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunIssueQueryQuery, RunIssueQueryQueryVariables>(RunIssueQueryDocument, options);
        }
export type RunIssueQueryQueryHookResult = ReturnType<typeof useRunIssueQueryQuery>;
export type RunIssueQueryLazyQueryHookResult = ReturnType<typeof useRunIssueQueryLazyQuery>;
export type RunIssueQuerySuspenseQueryHookResult = ReturnType<typeof useRunIssueQuerySuspenseQuery>;
export type RunIssueQueryQueryResult = ApolloReactCommon.QueryResult<RunIssueQueryQuery, RunIssueQueryQueryVariables>;
export const IssuesTimestampsByMetricQueryDocument = gql`
    query IssuesTimestampsByMetricQuery($entityName: String!, $projectName: String!, $runName: String!, $bucketedHistorySpecs: [JSONString!]!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      bucketedHistory(specs: $bucketedHistorySpecs, packVersion: 1)
    }
  }
}
    `;
export type IssuesTimestampsByMetricQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>, 'query'> & ({ variables: IssuesTimestampsByMetricQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IssuesTimestampsByMetricQueryComponent = (props: IssuesTimestampsByMetricQueryComponentProps) => (
      <ApolloReactComponents.Query<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables> query={IssuesTimestampsByMetricQueryDocument} {...props} />
    );
    
export type IssuesTimestampsByMetricQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>
    } & TChildProps;
export function withIssuesTimestampsByMetricQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IssuesTimestampsByMetricQueryQuery,
  IssuesTimestampsByMetricQueryQueryVariables,
  IssuesTimestampsByMetricQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables, IssuesTimestampsByMetricQueryProps<TChildProps, TDataName>>(IssuesTimestampsByMetricQueryDocument, {
      alias: 'issuesTimestampsByMetricQuery',
      ...operationOptions
    });
};

/**
 * __useIssuesTimestampsByMetricQueryQuery__
 *
 * To run a query within a React component, call `useIssuesTimestampsByMetricQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuesTimestampsByMetricQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuesTimestampsByMetricQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *   },
 * });
 */
export function useIssuesTimestampsByMetricQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables> & ({ variables: IssuesTimestampsByMetricQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>(IssuesTimestampsByMetricQueryDocument, options);
      }
export function useIssuesTimestampsByMetricQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>(IssuesTimestampsByMetricQueryDocument, options);
        }
// @ts-ignore
export function useIssuesTimestampsByMetricQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>;
export function useIssuesTimestampsByMetricQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IssuesTimestampsByMetricQueryQuery | undefined, IssuesTimestampsByMetricQueryQueryVariables>;
export function useIssuesTimestampsByMetricQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>(IssuesTimestampsByMetricQueryDocument, options);
        }
export type IssuesTimestampsByMetricQueryQueryHookResult = ReturnType<typeof useIssuesTimestampsByMetricQueryQuery>;
export type IssuesTimestampsByMetricQueryLazyQueryHookResult = ReturnType<typeof useIssuesTimestampsByMetricQueryLazyQuery>;
export type IssuesTimestampsByMetricQuerySuspenseQueryHookResult = ReturnType<typeof useIssuesTimestampsByMetricQuerySuspenseQuery>;
export type IssuesTimestampsByMetricQueryQueryResult = ApolloReactCommon.QueryResult<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>;
export const RunGrafanaDashboardQueryDocument = gql`
    query RunGrafanaDashboardQuery($entityName: String!, $projectName: String!, $runName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      coreweaveGrafanaDashboard
    }
  }
}
    `;
export type RunGrafanaDashboardQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>, 'query'> & ({ variables: RunGrafanaDashboardQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunGrafanaDashboardQueryComponent = (props: RunGrafanaDashboardQueryComponentProps) => (
      <ApolloReactComponents.Query<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables> query={RunGrafanaDashboardQueryDocument} {...props} />
    );
    
export type RunGrafanaDashboardQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>
    } & TChildProps;
export function withRunGrafanaDashboardQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunGrafanaDashboardQueryQuery,
  RunGrafanaDashboardQueryQueryVariables,
  RunGrafanaDashboardQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables, RunGrafanaDashboardQueryProps<TChildProps, TDataName>>(RunGrafanaDashboardQueryDocument, {
      alias: 'runGrafanaDashboardQuery',
      ...operationOptions
    });
};

/**
 * __useRunGrafanaDashboardQueryQuery__
 *
 * To run a query within a React component, call `useRunGrafanaDashboardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunGrafanaDashboardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunGrafanaDashboardQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunGrafanaDashboardQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables> & ({ variables: RunGrafanaDashboardQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>(RunGrafanaDashboardQueryDocument, options);
      }
export function useRunGrafanaDashboardQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>(RunGrafanaDashboardQueryDocument, options);
        }
// @ts-ignore
export function useRunGrafanaDashboardQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>;
export function useRunGrafanaDashboardQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunGrafanaDashboardQueryQuery | undefined, RunGrafanaDashboardQueryQueryVariables>;
export function useRunGrafanaDashboardQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>(RunGrafanaDashboardQueryDocument, options);
        }
export type RunGrafanaDashboardQueryQueryHookResult = ReturnType<typeof useRunGrafanaDashboardQueryQuery>;
export type RunGrafanaDashboardQueryLazyQueryHookResult = ReturnType<typeof useRunGrafanaDashboardQueryLazyQuery>;
export type RunGrafanaDashboardQuerySuspenseQueryHookResult = ReturnType<typeof useRunGrafanaDashboardQuerySuspenseQuery>;
export type RunGrafanaDashboardQueryQueryResult = ApolloReactCommon.QueryResult<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>;
export const ServerPollingOkDocument = gql`
    query ServerPollingOk {
  serverInfo {
    pollingOK
  }
}
    `;
export type ServerPollingOkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>, 'query'>;

    export const ServerPollingOkComponent = (props: ServerPollingOkComponentProps) => (
      <ApolloReactComponents.Query<ServerPollingOkQuery, ServerPollingOkQueryVariables> query={ServerPollingOkDocument} {...props} />
    );
    
export type ServerPollingOkProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ServerPollingOkQuery, ServerPollingOkQueryVariables>
    } & TChildProps;
export function withServerPollingOk<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ServerPollingOkQuery,
  ServerPollingOkQueryVariables,
  ServerPollingOkProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ServerPollingOkQuery, ServerPollingOkQueryVariables, ServerPollingOkProps<TChildProps, TDataName>>(ServerPollingOkDocument, {
      alias: 'serverPollingOk',
      ...operationOptions
    });
};

/**
 * __useServerPollingOkQuery__
 *
 * To run a query within a React component, call `useServerPollingOkQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerPollingOkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerPollingOkQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerPollingOkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServerPollingOkQuery, ServerPollingOkQueryVariables>(ServerPollingOkDocument, options);
      }
export function useServerPollingOkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServerPollingOkQuery, ServerPollingOkQueryVariables>(ServerPollingOkDocument, options);
        }
// @ts-ignore
export function useServerPollingOkSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerPollingOkQuery, ServerPollingOkQueryVariables>;
export function useServerPollingOkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerPollingOkQuery | undefined, ServerPollingOkQueryVariables>;
export function useServerPollingOkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServerPollingOkQuery, ServerPollingOkQueryVariables>(ServerPollingOkDocument, options);
        }
export type ServerPollingOkQueryHookResult = ReturnType<typeof useServerPollingOkQuery>;
export type ServerPollingOkLazyQueryHookResult = ReturnType<typeof useServerPollingOkLazyQuery>;
export type ServerPollingOkSuspenseQueryHookResult = ReturnType<typeof useServerPollingOkSuspenseQuery>;
export type ServerPollingOkQueryResult = ApolloReactCommon.QueryResult<ServerPollingOkQuery, ServerPollingOkQueryVariables>;
export const RunsStateQueryDocument = gql`
    query RunsStateQuery($aggregationKeys: [String!], $configKeys: [String!], $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableHistoryKeyInfo: Boolean = false, $enableSampledHistory: Boolean = false, $enableSummary: Boolean = false, $enableSystemMetrics: Boolean = true, $enableTags: Boolean = true, $enableWandb: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $projectName: String!, $sampledHistorySpecs: [JSONString!]!, $summaryKeys: [String!], $wandbKeys: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      edges {
        node {
          id
          name
          projectId
          displayName
          updatedAt
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
          ...RunStateBasicFragment @include(if: $enableBasic)
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          config(keys: $configKeys) @include(if: $enableConfig)
          historyKeys(format: PLAINTEXT) @include(if: $enableHistoryKeyInfo)
          sampledHistory(specs: $sampledHistorySpecs, packVersion: 1) @include(if: $enableSampledHistory)
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          systemMetrics @include(if: $enableSystemMetrics)
          tags: tagColors @include(if: $enableTags) {
            id
            name
            colorIndex
          }
          wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}
${RunStateBasicFragmentFragmentDoc}`;
export type RunsStateQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>, 'query'> & ({ variables: RunsStateQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsStateQueryComponent = (props: RunsStateQueryComponentProps) => (
      <ApolloReactComponents.Query<RunsStateQueryQuery, RunsStateQueryQueryVariables> query={RunsStateQueryDocument} {...props} />
    );
    
export type RunsStateQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsStateQueryQuery, RunsStateQueryQueryVariables>
    } & TChildProps;
export function withRunsStateQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsStateQueryQuery,
  RunsStateQueryQueryVariables,
  RunsStateQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsStateQueryQuery, RunsStateQueryQueryVariables, RunsStateQueryProps<TChildProps, TDataName>>(RunsStateQueryDocument, {
      alias: 'runsStateQuery',
      ...operationOptions
    });
};

/**
 * __useRunsStateQueryQuery__
 *
 * To run a query within a React component, call `useRunsStateQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateQueryQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableHistoryKeyInfo: // value for 'enableHistoryKeyInfo'
 *      enableSampledHistory: // value for 'enableSampledHistory'
 *      enableSummary: // value for 'enableSummary'
 *      enableSystemMetrics: // value for 'enableSystemMetrics'
 *      enableTags: // value for 'enableTags'
 *      enableWandb: // value for 'enableWandb'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *   },
 * });
 */
export function useRunsStateQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables> & ({ variables: RunsStateQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateQueryQuery, RunsStateQueryQueryVariables>(RunsStateQueryDocument, options);
      }
export function useRunsStateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateQueryQuery, RunsStateQueryQueryVariables>(RunsStateQueryDocument, options);
        }
// @ts-ignore
export function useRunsStateQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQueryQuery, RunsStateQueryQueryVariables>;
export function useRunsStateQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQueryQuery | undefined, RunsStateQueryQueryVariables>;
export function useRunsStateQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateQueryQuery, RunsStateQueryQueryVariables>(RunsStateQueryDocument, options);
        }
export type RunsStateQueryQueryHookResult = ReturnType<typeof useRunsStateQueryQuery>;
export type RunsStateQueryLazyQueryHookResult = ReturnType<typeof useRunsStateQueryLazyQuery>;
export type RunsStateQuerySuspenseQueryHookResult = ReturnType<typeof useRunsStateQuerySuspenseQuery>;
export type RunsStateQueryQueryResult = ApolloReactCommon.QueryResult<RunsStateQueryQuery, RunsStateQueryQueryVariables>;
export const RunsStateQueryWithProjectIdDocument = gql`
    query RunsStateQueryWithProjectId($aggregationKeys: [String!], $configKeys: [String!], $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableHistoryKeyInfo: Boolean = false, $enableSampledHistory: Boolean = false, $enableSummary: Boolean = false, $enableSystemMetrics: Boolean = true, $enableTags: Boolean = true, $enableWandb: Boolean = false, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $sampledHistorySpecs: [JSONString!]!, $summaryKeys: [String!], $wandbKeys: [String!], $internalId: ID!) {
  project(internalId: $internalId) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      edges {
        node {
          id
          name
          projectId
          displayName
          updatedAt
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
          ...RunStateBasicFragment @include(if: $enableBasic)
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          config(keys: $configKeys) @include(if: $enableConfig)
          historyKeys(format: BITMAP) @include(if: $enableHistoryKeyInfo)
          sampledHistory(specs: $sampledHistorySpecs, packVersion: 1) @include(if: $enableSampledHistory)
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          systemMetrics @include(if: $enableSystemMetrics)
          tags: tagColors @include(if: $enableTags) {
            id
            name
            colorIndex
          }
          wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}
${RunStateBasicFragmentFragmentDoc}`;
export type RunsStateQueryWithProjectIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>, 'query'> & ({ variables: RunsStateQueryWithProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsStateQueryWithProjectIdComponent = (props: RunsStateQueryWithProjectIdComponentProps) => (
      <ApolloReactComponents.Query<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables> query={RunsStateQueryWithProjectIdDocument} {...props} />
    );
    
export type RunsStateQueryWithProjectIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>
    } & TChildProps;
export function withRunsStateQueryWithProjectId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsStateQueryWithProjectIdQuery,
  RunsStateQueryWithProjectIdQueryVariables,
  RunsStateQueryWithProjectIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables, RunsStateQueryWithProjectIdProps<TChildProps, TDataName>>(RunsStateQueryWithProjectIdDocument, {
      alias: 'runsStateQueryWithProjectId',
      ...operationOptions
    });
};

/**
 * __useRunsStateQueryWithProjectIdQuery__
 *
 * To run a query within a React component, call `useRunsStateQueryWithProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateQueryWithProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateQueryWithProjectIdQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableHistoryKeyInfo: // value for 'enableHistoryKeyInfo'
 *      enableSampledHistory: // value for 'enableSampledHistory'
 *      enableSummary: // value for 'enableSummary'
 *      enableSystemMetrics: // value for 'enableSystemMetrics'
 *      enableTags: // value for 'enableTags'
 *      enableWandb: // value for 'enableWandb'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *      internalId: // value for 'internalId'
 *   },
 * });
 */
export function useRunsStateQueryWithProjectIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables> & ({ variables: RunsStateQueryWithProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>(RunsStateQueryWithProjectIdDocument, options);
      }
export function useRunsStateQueryWithProjectIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>(RunsStateQueryWithProjectIdDocument, options);
        }
// @ts-ignore
export function useRunsStateQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>;
export function useRunsStateQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQueryWithProjectIdQuery | undefined, RunsStateQueryWithProjectIdQueryVariables>;
export function useRunsStateQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>(RunsStateQueryWithProjectIdDocument, options);
        }
export type RunsStateQueryWithProjectIdQueryHookResult = ReturnType<typeof useRunsStateQueryWithProjectIdQuery>;
export type RunsStateQueryWithProjectIdLazyQueryHookResult = ReturnType<typeof useRunsStateQueryWithProjectIdLazyQuery>;
export type RunsStateQueryWithProjectIdSuspenseQueryHookResult = ReturnType<typeof useRunsStateQueryWithProjectIdSuspenseQuery>;
export type RunsStateQueryWithProjectIdQueryResult = ApolloReactCommon.QueryResult<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>;
export const RunsStateDeltaQueryDocument = gql`
    query RunsStateDeltaQuery($aggregationKeys: [String!], $configKeys: [String!], $currentRuns: [String!]!, $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableHistoryKeyInfo: Boolean = false, $enableSampledHistory: Boolean = false, $enableSummary: Boolean = false, $enableSystemMetrics: Boolean = true, $enableTags: Boolean = true, $enableWandb: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $projectName: String!, $sampledHistorySpecs: [JSONString!]!, $summaryKeys: [String!], $wandbKeys: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      delta(currentRuns: $currentRuns, lastUpdated: $lastUpdated) {
        index
        op
        run {
          id
          name
          projectId
          displayName
          updatedAt
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
          ...RunStateBasicFragment @include(if: $enableBasic)
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          config(keys: $configKeys) @include(if: $enableConfig)
          historyKeys(format: PLAINTEXT) @include(if: $enableHistoryKeyInfo)
          sampledHistory(specs: $sampledHistorySpecs, packVersion: 1) @include(if: $enableSampledHistory)
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          systemMetrics @include(if: $enableSystemMetrics)
          tags: tagColors @include(if: $enableTags) {
            id
            name
            colorIndex
          }
          wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}
${RunStateBasicFragmentFragmentDoc}`;
export type RunsStateDeltaQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>, 'query'> & ({ variables: RunsStateDeltaQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsStateDeltaQueryComponent = (props: RunsStateDeltaQueryComponentProps) => (
      <ApolloReactComponents.Query<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables> query={RunsStateDeltaQueryDocument} {...props} />
    );
    
export type RunsStateDeltaQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>
    } & TChildProps;
export function withRunsStateDeltaQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsStateDeltaQueryQuery,
  RunsStateDeltaQueryQueryVariables,
  RunsStateDeltaQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables, RunsStateDeltaQueryProps<TChildProps, TDataName>>(RunsStateDeltaQueryDocument, {
      alias: 'runsStateDeltaQuery',
      ...operationOptions
    });
};

/**
 * __useRunsStateDeltaQueryQuery__
 *
 * To run a query within a React component, call `useRunsStateDeltaQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateDeltaQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateDeltaQueryQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableHistoryKeyInfo: // value for 'enableHistoryKeyInfo'
 *      enableSampledHistory: // value for 'enableSampledHistory'
 *      enableSummary: // value for 'enableSummary'
 *      enableSystemMetrics: // value for 'enableSystemMetrics'
 *      enableTags: // value for 'enableTags'
 *      enableWandb: // value for 'enableWandb'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *   },
 * });
 */
export function useRunsStateDeltaQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables> & ({ variables: RunsStateDeltaQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>(RunsStateDeltaQueryDocument, options);
      }
export function useRunsStateDeltaQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>(RunsStateDeltaQueryDocument, options);
        }
// @ts-ignore
export function useRunsStateDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>;
export function useRunsStateDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateDeltaQueryQuery | undefined, RunsStateDeltaQueryQueryVariables>;
export function useRunsStateDeltaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>(RunsStateDeltaQueryDocument, options);
        }
export type RunsStateDeltaQueryQueryHookResult = ReturnType<typeof useRunsStateDeltaQueryQuery>;
export type RunsStateDeltaQueryLazyQueryHookResult = ReturnType<typeof useRunsStateDeltaQueryLazyQuery>;
export type RunsStateDeltaQuerySuspenseQueryHookResult = ReturnType<typeof useRunsStateDeltaQuerySuspenseQuery>;
export type RunsStateDeltaQueryQueryResult = ApolloReactCommon.QueryResult<RunsStateDeltaQueryQuery, RunsStateDeltaQueryQueryVariables>;
export const RunsStateDeltaQueryWithProjectIdDocument = gql`
    query RunsStateDeltaQueryWithProjectId($aggregationKeys: [String!], $configKeys: [String!], $currentRuns: [String!]!, $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableHistoryKeyInfo: Boolean = false, $enableSampledHistory: Boolean = false, $enableSummary: Boolean = false, $enableSystemMetrics: Boolean = true, $enableTags: Boolean = true, $enableWandb: Boolean = false, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $sampledHistorySpecs: [JSONString!]!, $summaryKeys: [String!], $wandbKeys: [String!], $internalId: ID!) {
  project(internalId: $internalId) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      delta(currentRuns: $currentRuns, lastUpdated: $lastUpdated) {
        index
        op
        run {
          id
          name
          projectId
          displayName
          updatedAt
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
          ...RunStateBasicFragment @include(if: $enableBasic)
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          config(keys: $configKeys) @include(if: $enableConfig)
          historyKeys(format: BITMAP) @include(if: $enableHistoryKeyInfo)
          sampledHistory(specs: $sampledHistorySpecs, packVersion: 1) @include(if: $enableSampledHistory)
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          systemMetrics @include(if: $enableSystemMetrics)
          tags: tagColors @include(if: $enableTags) {
            id
            name
            colorIndex
          }
          wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}
${RunStateBasicFragmentFragmentDoc}`;
export type RunsStateDeltaQueryWithProjectIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>, 'query'> & ({ variables: RunsStateDeltaQueryWithProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RunsStateDeltaQueryWithProjectIdComponent = (props: RunsStateDeltaQueryWithProjectIdComponentProps) => (
      <ApolloReactComponents.Query<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables> query={RunsStateDeltaQueryWithProjectIdDocument} {...props} />
    );
    
export type RunsStateDeltaQueryWithProjectIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>
    } & TChildProps;
export function withRunsStateDeltaQueryWithProjectId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RunsStateDeltaQueryWithProjectIdQuery,
  RunsStateDeltaQueryWithProjectIdQueryVariables,
  RunsStateDeltaQueryWithProjectIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables, RunsStateDeltaQueryWithProjectIdProps<TChildProps, TDataName>>(RunsStateDeltaQueryWithProjectIdDocument, {
      alias: 'runsStateDeltaQueryWithProjectId',
      ...operationOptions
    });
};

/**
 * __useRunsStateDeltaQueryWithProjectIdQuery__
 *
 * To run a query within a React component, call `useRunsStateDeltaQueryWithProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateDeltaQueryWithProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateDeltaQueryWithProjectIdQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableHistoryKeyInfo: // value for 'enableHistoryKeyInfo'
 *      enableSampledHistory: // value for 'enableSampledHistory'
 *      enableSummary: // value for 'enableSummary'
 *      enableSystemMetrics: // value for 'enableSystemMetrics'
 *      enableTags: // value for 'enableTags'
 *      enableWandb: // value for 'enableWandb'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *      internalId: // value for 'internalId'
 *   },
 * });
 */
export function useRunsStateDeltaQueryWithProjectIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables> & ({ variables: RunsStateDeltaQueryWithProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>(RunsStateDeltaQueryWithProjectIdDocument, options);
      }
export function useRunsStateDeltaQueryWithProjectIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>(RunsStateDeltaQueryWithProjectIdDocument, options);
        }
// @ts-ignore
export function useRunsStateDeltaQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>;
export function useRunsStateDeltaQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateDeltaQueryWithProjectIdQuery | undefined, RunsStateDeltaQueryWithProjectIdQueryVariables>;
export function useRunsStateDeltaQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>(RunsStateDeltaQueryWithProjectIdDocument, options);
        }
export type RunsStateDeltaQueryWithProjectIdQueryHookResult = ReturnType<typeof useRunsStateDeltaQueryWithProjectIdQuery>;
export type RunsStateDeltaQueryWithProjectIdLazyQueryHookResult = ReturnType<typeof useRunsStateDeltaQueryWithProjectIdLazyQuery>;
export type RunsStateDeltaQueryWithProjectIdSuspenseQueryHookResult = ReturnType<typeof useRunsStateDeltaQueryWithProjectIdSuspenseQuery>;
export type RunsStateDeltaQueryWithProjectIdQueryResult = ApolloReactCommon.QueryResult<RunsStateDeltaQueryWithProjectIdQuery, RunsStateDeltaQueryWithProjectIdQueryVariables>;
export const Views2MetadataDocument = gql`
    query Views2Metadata($entityName: String, $name: String, $viewType: String = "runs", $userName: String, $viewName: String) {
  project(name: $name, entityName: $entityName) {
    id
    allViews(viewType: $viewType, viewName: $viewName, userName: $userName) {
      edges {
        node {
          id
          ...ViewFragmentMetadata2
        }
      }
    }
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;
export type Views2MetadataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Views2MetadataQuery, Views2MetadataQueryVariables>, 'query'>;

    export const Views2MetadataComponent = (props: Views2MetadataComponentProps) => (
      <ApolloReactComponents.Query<Views2MetadataQuery, Views2MetadataQueryVariables> query={Views2MetadataDocument} {...props} />
    );
    
export type Views2MetadataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<Views2MetadataQuery, Views2MetadataQueryVariables>
    } & TChildProps;
export function withViews2Metadata<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  Views2MetadataQuery,
  Views2MetadataQueryVariables,
  Views2MetadataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, Views2MetadataQuery, Views2MetadataQueryVariables, Views2MetadataProps<TChildProps, TDataName>>(Views2MetadataDocument, {
      alias: 'views2Metadata',
      ...operationOptions
    });
};

/**
 * __useViews2MetadataQuery__
 *
 * To run a query within a React component, call `useViews2MetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useViews2MetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViews2MetadataQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *      viewType: // value for 'viewType'
 *      userName: // value for 'userName'
 *      viewName: // value for 'viewName'
 *   },
 * });
 */
export function useViews2MetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Views2MetadataQuery, Views2MetadataQueryVariables>(Views2MetadataDocument, options);
      }
export function useViews2MetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Views2MetadataQuery, Views2MetadataQueryVariables>(Views2MetadataDocument, options);
        }
// @ts-ignore
export function useViews2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2MetadataQuery, Views2MetadataQueryVariables>;
export function useViews2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2MetadataQuery | undefined, Views2MetadataQueryVariables>;
export function useViews2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Views2MetadataQuery, Views2MetadataQueryVariables>(Views2MetadataDocument, options);
        }
export type Views2MetadataQueryHookResult = ReturnType<typeof useViews2MetadataQuery>;
export type Views2MetadataLazyQueryHookResult = ReturnType<typeof useViews2MetadataLazyQuery>;
export type Views2MetadataSuspenseQueryHookResult = ReturnType<typeof useViews2MetadataSuspenseQuery>;
export type Views2MetadataQueryResult = ApolloReactCommon.QueryResult<Views2MetadataQuery, Views2MetadataQueryVariables>;
export const Views2ViewDocument = gql`
    query Views2View($id: ID!) {
  view(id: $id) {
    id
    ...ViewFragmentMetadata2
    spec
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;
export type Views2ViewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Views2ViewQuery, Views2ViewQueryVariables>, 'query'> & ({ variables: Views2ViewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const Views2ViewComponent = (props: Views2ViewComponentProps) => (
      <ApolloReactComponents.Query<Views2ViewQuery, Views2ViewQueryVariables> query={Views2ViewDocument} {...props} />
    );
    
export type Views2ViewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<Views2ViewQuery, Views2ViewQueryVariables>
    } & TChildProps;
export function withViews2View<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  Views2ViewQuery,
  Views2ViewQueryVariables,
  Views2ViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, Views2ViewQuery, Views2ViewQueryVariables, Views2ViewProps<TChildProps, TDataName>>(Views2ViewDocument, {
      alias: 'views2View',
      ...operationOptions
    });
};

/**
 * __useViews2ViewQuery__
 *
 * To run a query within a React component, call `useViews2ViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useViews2ViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViews2ViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViews2ViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables> & ({ variables: Views2ViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Views2ViewQuery, Views2ViewQueryVariables>(Views2ViewDocument, options);
      }
export function useViews2ViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Views2ViewQuery, Views2ViewQueryVariables>(Views2ViewDocument, options);
        }
// @ts-ignore
export function useViews2ViewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2ViewQuery, Views2ViewQueryVariables>;
export function useViews2ViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2ViewQuery | undefined, Views2ViewQueryVariables>;
export function useViews2ViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Views2ViewQuery, Views2ViewQueryVariables>(Views2ViewDocument, options);
        }
export type Views2ViewQueryHookResult = ReturnType<typeof useViews2ViewQuery>;
export type Views2ViewLazyQueryHookResult = ReturnType<typeof useViews2ViewLazyQuery>;
export type Views2ViewSuspenseQueryHookResult = ReturnType<typeof useViews2ViewSuspenseQuery>;
export type Views2ViewQueryResult = ApolloReactCommon.QueryResult<Views2ViewQuery, Views2ViewQueryVariables>;
export const Views2RawViewDocument = gql`
    query Views2RawView($id: ID!) {
  view(id: $id) {
    id
    ...ViewFragmentMetadata2
    specObject
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;
export type Views2RawViewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Views2RawViewQuery, Views2RawViewQueryVariables>, 'query'> & ({ variables: Views2RawViewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const Views2RawViewComponent = (props: Views2RawViewComponentProps) => (
      <ApolloReactComponents.Query<Views2RawViewQuery, Views2RawViewQueryVariables> query={Views2RawViewDocument} {...props} />
    );
    
export type Views2RawViewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<Views2RawViewQuery, Views2RawViewQueryVariables>
    } & TChildProps;
export function withViews2RawView<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  Views2RawViewQuery,
  Views2RawViewQueryVariables,
  Views2RawViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, Views2RawViewQuery, Views2RawViewQueryVariables, Views2RawViewProps<TChildProps, TDataName>>(Views2RawViewDocument, {
      alias: 'views2RawView',
      ...operationOptions
    });
};

/**
 * __useViews2RawViewQuery__
 *
 * To run a query within a React component, call `useViews2RawViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useViews2RawViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViews2RawViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViews2RawViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables> & ({ variables: Views2RawViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Views2RawViewQuery, Views2RawViewQueryVariables>(Views2RawViewDocument, options);
      }
export function useViews2RawViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Views2RawViewQuery, Views2RawViewQueryVariables>(Views2RawViewDocument, options);
        }
// @ts-ignore
export function useViews2RawViewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2RawViewQuery, Views2RawViewQueryVariables>;
export function useViews2RawViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2RawViewQuery | undefined, Views2RawViewQueryVariables>;
export function useViews2RawViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Views2RawViewQuery, Views2RawViewQueryVariables>(Views2RawViewDocument, options);
        }
export type Views2RawViewQueryHookResult = ReturnType<typeof useViews2RawViewQuery>;
export type Views2RawViewLazyQueryHookResult = ReturnType<typeof useViews2RawViewLazyQuery>;
export type Views2RawViewSuspenseQueryHookResult = ReturnType<typeof useViews2RawViewSuspenseQuery>;
export type Views2RawViewQueryResult = ApolloReactCommon.QueryResult<Views2RawViewQuery, Views2RawViewQueryVariables>;
export const ViewUpdatedAtDocument = gql`
    query ViewUpdatedAt($id: ID!) {
  view(id: $id) {
    id
    updatedAt
  }
}
    `;
export type ViewUpdatedAtComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>, 'query'> & ({ variables: ViewUpdatedAtQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewUpdatedAtComponent = (props: ViewUpdatedAtComponentProps) => (
      <ApolloReactComponents.Query<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables> query={ViewUpdatedAtDocument} {...props} />
    );
    
export type ViewUpdatedAtProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>
    } & TChildProps;
export function withViewUpdatedAt<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewUpdatedAtQuery,
  ViewUpdatedAtQueryVariables,
  ViewUpdatedAtProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables, ViewUpdatedAtProps<TChildProps, TDataName>>(ViewUpdatedAtDocument, {
      alias: 'viewUpdatedAt',
      ...operationOptions
    });
};

/**
 * __useViewUpdatedAtQuery__
 *
 * To run a query within a React component, call `useViewUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewUpdatedAtQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewUpdatedAtQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables> & ({ variables: ViewUpdatedAtQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>(ViewUpdatedAtDocument, options);
      }
export function useViewUpdatedAtLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>(ViewUpdatedAtDocument, options);
        }
// @ts-ignore
export function useViewUpdatedAtSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>;
export function useViewUpdatedAtSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewUpdatedAtQuery | undefined, ViewUpdatedAtQueryVariables>;
export function useViewUpdatedAtSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>(ViewUpdatedAtDocument, options);
        }
export type ViewUpdatedAtQueryHookResult = ReturnType<typeof useViewUpdatedAtQuery>;
export type ViewUpdatedAtLazyQueryHookResult = ReturnType<typeof useViewUpdatedAtLazyQuery>;
export type ViewUpdatedAtSuspenseQueryHookResult = ReturnType<typeof useViewUpdatedAtSuspenseQuery>;
export type ViewUpdatedAtQueryResult = ApolloReactCommon.QueryResult<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>;
export const NamedWorkspaceUpdateViewFieldsDocument = gql`
    query NamedWorkspaceUpdateViewFields($id: ID!) {
  view(id: $id) {
    id
    createdAt
    user {
      id
      name
      username
    }
    updatedAt
    updatedBy {
      id
      name
      username
    }
  }
}
    `;
export type NamedWorkspaceUpdateViewFieldsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>, 'query'> & ({ variables: NamedWorkspaceUpdateViewFieldsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NamedWorkspaceUpdateViewFieldsComponent = (props: NamedWorkspaceUpdateViewFieldsComponentProps) => (
      <ApolloReactComponents.Query<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables> query={NamedWorkspaceUpdateViewFieldsDocument} {...props} />
    );
    
export type NamedWorkspaceUpdateViewFieldsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>
    } & TChildProps;
export function withNamedWorkspaceUpdateViewFields<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NamedWorkspaceUpdateViewFieldsQuery,
  NamedWorkspaceUpdateViewFieldsQueryVariables,
  NamedWorkspaceUpdateViewFieldsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables, NamedWorkspaceUpdateViewFieldsProps<TChildProps, TDataName>>(NamedWorkspaceUpdateViewFieldsDocument, {
      alias: 'namedWorkspaceUpdateViewFields',
      ...operationOptions
    });
};

/**
 * __useNamedWorkspaceUpdateViewFieldsQuery__
 *
 * To run a query within a React component, call `useNamedWorkspaceUpdateViewFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNamedWorkspaceUpdateViewFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNamedWorkspaceUpdateViewFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNamedWorkspaceUpdateViewFieldsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables> & ({ variables: NamedWorkspaceUpdateViewFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>(NamedWorkspaceUpdateViewFieldsDocument, options);
      }
export function useNamedWorkspaceUpdateViewFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>(NamedWorkspaceUpdateViewFieldsDocument, options);
        }
// @ts-ignore
export function useNamedWorkspaceUpdateViewFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>;
export function useNamedWorkspaceUpdateViewFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NamedWorkspaceUpdateViewFieldsQuery | undefined, NamedWorkspaceUpdateViewFieldsQueryVariables>;
export function useNamedWorkspaceUpdateViewFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>(NamedWorkspaceUpdateViewFieldsDocument, options);
        }
export type NamedWorkspaceUpdateViewFieldsQueryHookResult = ReturnType<typeof useNamedWorkspaceUpdateViewFieldsQuery>;
export type NamedWorkspaceUpdateViewFieldsLazyQueryHookResult = ReturnType<typeof useNamedWorkspaceUpdateViewFieldsLazyQuery>;
export type NamedWorkspaceUpdateViewFieldsSuspenseQueryHookResult = ReturnType<typeof useNamedWorkspaceUpdateViewFieldsSuspenseQuery>;
export type NamedWorkspaceUpdateViewFieldsQueryResult = ApolloReactCommon.QueryResult<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>;
export const UpsertView2Document = gql`
    mutation UpsertView2($id: ID, $entityName: String, $projectName: String, $type: String, $name: String, $displayName: String, $description: String, $spec: String, $specIsGzipped: Boolean, $parentId: ID, $locked: Boolean, $previewUrl: String, $coverUrl: String, $showcasedAt: DateTime, $createdUsing: ViewSource) {
  upsertView(
    input: {id: $id, entityName: $entityName, projectName: $projectName, name: $name, displayName: $displayName, description: $description, type: $type, spec: $spec, specIsGzipped: $specIsGzipped, parentId: $parentId, locked: $locked, previewUrl: $previewUrl, coverUrl: $coverUrl, showcasedAt: $showcasedAt, createdUsing: $createdUsing}
  ) {
    view {
      id
      ...ViewFragmentMetadata2
    }
    inserted
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;
export type UpsertView2MutationFn = ApolloReactCommon.MutationFunction<UpsertView2Mutation, UpsertView2MutationVariables>;
export type UpsertView2ComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertView2Mutation, UpsertView2MutationVariables>, 'mutation'>;

    export const UpsertView2Component = (props: UpsertView2ComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertView2Mutation, UpsertView2MutationVariables> mutation={UpsertView2Document} {...props} />
    );
    
export type UpsertView2Props<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertView2Mutation, UpsertView2MutationVariables>
    } & TChildProps;
export function withUpsertView2<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertView2Mutation,
  UpsertView2MutationVariables,
  UpsertView2Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertView2Mutation, UpsertView2MutationVariables, UpsertView2Props<TChildProps, TDataName>>(UpsertView2Document, {
      alias: 'upsertView2',
      ...operationOptions
    });
};

/**
 * __useUpsertView2Mutation__
 *
 * To run a mutation, you first call `useUpsertView2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertView2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertView2Mutation, { data, loading, error }] = useUpsertView2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      spec: // value for 'spec'
 *      specIsGzipped: // value for 'specIsGzipped'
 *      parentId: // value for 'parentId'
 *      locked: // value for 'locked'
 *      previewUrl: // value for 'previewUrl'
 *      coverUrl: // value for 'coverUrl'
 *      showcasedAt: // value for 'showcasedAt'
 *      createdUsing: // value for 'createdUsing'
 *   },
 * });
 */
export function useUpsertView2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertView2Mutation, UpsertView2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertView2Mutation, UpsertView2MutationVariables>(UpsertView2Document, options);
      }
export type UpsertView2MutationHookResult = ReturnType<typeof useUpsertView2Mutation>;
export type UpsertView2MutationResult = ApolloReactCommon.MutationResult<UpsertView2Mutation>;
export type UpsertView2MutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertView2Mutation, UpsertView2MutationVariables>;
export const UpsertUserProfileViewDocument = gql`
    mutation UpsertUserProfileView($id: ID, $spec: String, $specIsGzipped: Boolean) {
  upsertUserProfileView(
    input: {id: $id, spec: $spec, specIsGzipped: $specIsGzipped}
  ) {
    view {
      id
      ...ViewFragmentMetadata2
      spec
    }
    inserted
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;
export type UpsertUserProfileViewMutationFn = ApolloReactCommon.MutationFunction<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>;
export type UpsertUserProfileViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>, 'mutation'>;

    export const UpsertUserProfileViewComponent = (props: UpsertUserProfileViewComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables> mutation={UpsertUserProfileViewDocument} {...props} />
    );
    
export type UpsertUserProfileViewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>
    } & TChildProps;
export function withUpsertUserProfileView<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertUserProfileViewMutation,
  UpsertUserProfileViewMutationVariables,
  UpsertUserProfileViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables, UpsertUserProfileViewProps<TChildProps, TDataName>>(UpsertUserProfileViewDocument, {
      alias: 'upsertUserProfileView',
      ...operationOptions
    });
};

/**
 * __useUpsertUserProfileViewMutation__
 *
 * To run a mutation, you first call `useUpsertUserProfileViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserProfileViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserProfileViewMutation, { data, loading, error }] = useUpsertUserProfileViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      spec: // value for 'spec'
 *      specIsGzipped: // value for 'specIsGzipped'
 *   },
 * });
 */
export function useUpsertUserProfileViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>(UpsertUserProfileViewDocument, options);
      }
export type UpsertUserProfileViewMutationHookResult = ReturnType<typeof useUpsertUserProfileViewMutation>;
export type UpsertUserProfileViewMutationResult = ApolloReactCommon.MutationResult<UpsertUserProfileViewMutation>;
export type UpsertUserProfileViewMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>;
export const DeleteView2Document = gql`
    mutation deleteView2($id: ID, $deleteDrafts: Boolean) {
  deleteView(input: {id: $id, deleteDrafts: $deleteDrafts}) {
    success
    pendingDrafts
  }
}
    `;
export type DeleteView2MutationFn = ApolloReactCommon.MutationFunction<DeleteView2Mutation, DeleteView2MutationVariables>;
export type DeleteView2ComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteView2Mutation, DeleteView2MutationVariables>, 'mutation'>;

    export const DeleteView2Component = (props: DeleteView2ComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteView2Mutation, DeleteView2MutationVariables> mutation={DeleteView2Document} {...props} />
    );
    
export type DeleteView2Props<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteView2Mutation, DeleteView2MutationVariables>
    } & TChildProps;
export function withDeleteView2<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteView2Mutation,
  DeleteView2MutationVariables,
  DeleteView2Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteView2Mutation, DeleteView2MutationVariables, DeleteView2Props<TChildProps, TDataName>>(DeleteView2Document, {
      alias: 'deleteView2',
      ...operationOptions
    });
};

/**
 * __useDeleteView2Mutation__
 *
 * To run a mutation, you first call `useDeleteView2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteView2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteView2Mutation, { data, loading, error }] = useDeleteView2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteDrafts: // value for 'deleteDrafts'
 *   },
 * });
 */
export function useDeleteView2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteView2Mutation, DeleteView2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteView2Mutation, DeleteView2MutationVariables>(DeleteView2Document, options);
      }
export type DeleteView2MutationHookResult = ReturnType<typeof useDeleteView2Mutation>;
export type DeleteView2MutationResult = ApolloReactCommon.MutationResult<DeleteView2Mutation>;
export type DeleteView2MutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteView2Mutation, DeleteView2MutationVariables>;
export const DeleteViewsDocument = gql`
    mutation deleteViews($ids: [ID!]!, $deleteDrafts: Boolean) {
  deleteViews(input: {ids: $ids, deleteDrafts: $deleteDrafts}) {
    success
    pendingDrafts
  }
}
    `;
export type DeleteViewsMutationFn = ApolloReactCommon.MutationFunction<DeleteViewsMutation, DeleteViewsMutationVariables>;
export type DeleteViewsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteViewsMutation, DeleteViewsMutationVariables>, 'mutation'>;

    export const DeleteViewsComponent = (props: DeleteViewsComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteViewsMutation, DeleteViewsMutationVariables> mutation={DeleteViewsDocument} {...props} />
    );
    
export type DeleteViewsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteViewsMutation, DeleteViewsMutationVariables>
    } & TChildProps;
export function withDeleteViews<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteViewsMutation,
  DeleteViewsMutationVariables,
  DeleteViewsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteViewsMutation, DeleteViewsMutationVariables, DeleteViewsProps<TChildProps, TDataName>>(DeleteViewsDocument, {
      alias: 'deleteViews',
      ...operationOptions
    });
};

/**
 * __useDeleteViewsMutation__
 *
 * To run a mutation, you first call `useDeleteViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewsMutation, { data, loading, error }] = useDeleteViewsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      deleteDrafts: // value for 'deleteDrafts'
 *   },
 * });
 */
export function useDeleteViewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteViewsMutation, DeleteViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteViewsMutation, DeleteViewsMutationVariables>(DeleteViewsDocument, options);
      }
export type DeleteViewsMutationHookResult = ReturnType<typeof useDeleteViewsMutation>;
export type DeleteViewsMutationResult = ApolloReactCommon.MutationResult<DeleteViewsMutation>;
export type DeleteViewsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteViewsMutation, DeleteViewsMutationVariables>;
export const StarViewDocument = gql`
    mutation starView($id: ID!) {
  starView(input: {id: $id}) {
    view {
      id
      starCount
      starred
    }
  }
}
    `;
export type StarViewMutationFn = ApolloReactCommon.MutationFunction<StarViewMutation, StarViewMutationVariables>;
export type StarViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StarViewMutation, StarViewMutationVariables>, 'mutation'>;

    export const StarViewComponent = (props: StarViewComponentProps) => (
      <ApolloReactComponents.Mutation<StarViewMutation, StarViewMutationVariables> mutation={StarViewDocument} {...props} />
    );
    
export type StarViewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<StarViewMutation, StarViewMutationVariables>
    } & TChildProps;
export function withStarView<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StarViewMutation,
  StarViewMutationVariables,
  StarViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, StarViewMutation, StarViewMutationVariables, StarViewProps<TChildProps, TDataName>>(StarViewDocument, {
      alias: 'starView',
      ...operationOptions
    });
};

/**
 * __useStarViewMutation__
 *
 * To run a mutation, you first call `useStarViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starViewMutation, { data, loading, error }] = useStarViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStarViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StarViewMutation, StarViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StarViewMutation, StarViewMutationVariables>(StarViewDocument, options);
      }
export type StarViewMutationHookResult = ReturnType<typeof useStarViewMutation>;
export type StarViewMutationResult = ApolloReactCommon.MutationResult<StarViewMutation>;
export type StarViewMutationOptions = ApolloReactCommon.BaseMutationOptions<StarViewMutation, StarViewMutationVariables>;
export const UnstarViewDocument = gql`
    mutation unstarView($id: ID!) {
  unstarView(input: {id: $id}) {
    view {
      id
      starCount
      starred
    }
  }
}
    `;
export type UnstarViewMutationFn = ApolloReactCommon.MutationFunction<UnstarViewMutation, UnstarViewMutationVariables>;
export type UnstarViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnstarViewMutation, UnstarViewMutationVariables>, 'mutation'>;

    export const UnstarViewComponent = (props: UnstarViewComponentProps) => (
      <ApolloReactComponents.Mutation<UnstarViewMutation, UnstarViewMutationVariables> mutation={UnstarViewDocument} {...props} />
    );
    
export type UnstarViewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnstarViewMutation, UnstarViewMutationVariables>
    } & TChildProps;
export function withUnstarView<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnstarViewMutation,
  UnstarViewMutationVariables,
  UnstarViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnstarViewMutation, UnstarViewMutationVariables, UnstarViewProps<TChildProps, TDataName>>(UnstarViewDocument, {
      alias: 'unstarView',
      ...operationOptions
    });
};

/**
 * __useUnstarViewMutation__
 *
 * To run a mutation, you first call `useUnstarViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarViewMutation, { data, loading, error }] = useUnstarViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnstarViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnstarViewMutation, UnstarViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnstarViewMutation, UnstarViewMutationVariables>(UnstarViewDocument, options);
      }
export type UnstarViewMutationHookResult = ReturnType<typeof useUnstarViewMutation>;
export type UnstarViewMutationResult = ApolloReactCommon.MutationResult<UnstarViewMutation>;
export type UnstarViewMutationOptions = ApolloReactCommon.BaseMutationOptions<UnstarViewMutation, UnstarViewMutationVariables>;
export const StargazersQueryDocument = gql`
    query StargazersQuery($viewID: ID!, $limit: Int, $cursor: String) {
  view(id: $viewID) {
    id
    stargazers(after: $cursor, first: $limit) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          username
          userInfo
          photoUrl
        }
      }
    }
  }
}
    `;
export type StargazersQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StargazersQueryQuery, StargazersQueryQueryVariables>, 'query'> & ({ variables: StargazersQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StargazersQueryComponent = (props: StargazersQueryComponentProps) => (
      <ApolloReactComponents.Query<StargazersQueryQuery, StargazersQueryQueryVariables> query={StargazersQueryDocument} {...props} />
    );
    
export type StargazersQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<StargazersQueryQuery, StargazersQueryQueryVariables>
    } & TChildProps;
export function withStargazersQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  StargazersQueryQuery,
  StargazersQueryQueryVariables,
  StargazersQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, StargazersQueryQuery, StargazersQueryQueryVariables, StargazersQueryProps<TChildProps, TDataName>>(StargazersQueryDocument, {
      alias: 'stargazersQuery',
      ...operationOptions
    });
};

/**
 * __useStargazersQueryQuery__
 *
 * To run a query within a React component, call `useStargazersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStargazersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStargazersQueryQuery({
 *   variables: {
 *      viewID: // value for 'viewID'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useStargazersQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables> & ({ variables: StargazersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StargazersQueryQuery, StargazersQueryQueryVariables>(StargazersQueryDocument, options);
      }
export function useStargazersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StargazersQueryQuery, StargazersQueryQueryVariables>(StargazersQueryDocument, options);
        }
// @ts-ignore
export function useStargazersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StargazersQueryQuery, StargazersQueryQueryVariables>;
export function useStargazersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StargazersQueryQuery | undefined, StargazersQueryQueryVariables>;
export function useStargazersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StargazersQueryQuery, StargazersQueryQueryVariables>(StargazersQueryDocument, options);
        }
export type StargazersQueryQueryHookResult = ReturnType<typeof useStargazersQueryQuery>;
export type StargazersQueryLazyQueryHookResult = ReturnType<typeof useStargazersQueryLazyQuery>;
export type StargazersQuerySuspenseQueryHookResult = ReturnType<typeof useStargazersQuerySuspenseQuery>;
export type StargazersQueryQueryResult = ApolloReactCommon.QueryResult<StargazersQueryQuery, StargazersQueryQueryVariables>;
export const PublicViewsDocument = gql`
    query PublicViews($limit: Int, $cursor: String) {
  publicViews(type: "runs", after: $cursor, first: $limit) {
    edges {
      node {
        id
        name
        description
        user {
          id
          username
          name
        }
      }
    }
  }
}
    `;
export type PublicViewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PublicViewsQuery, PublicViewsQueryVariables>, 'query'>;

    export const PublicViewsComponent = (props: PublicViewsComponentProps) => (
      <ApolloReactComponents.Query<PublicViewsQuery, PublicViewsQueryVariables> query={PublicViewsDocument} {...props} />
    );
    
export type PublicViewsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PublicViewsQuery, PublicViewsQueryVariables>
    } & TChildProps;
export function withPublicViews<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PublicViewsQuery,
  PublicViewsQueryVariables,
  PublicViewsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PublicViewsQuery, PublicViewsQueryVariables, PublicViewsProps<TChildProps, TDataName>>(PublicViewsDocument, {
      alias: 'publicViews',
      ...operationOptions
    });
};

/**
 * __usePublicViewsQuery__
 *
 * To run a query within a React component, call `usePublicViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicViewsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePublicViewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublicViewsQuery, PublicViewsQueryVariables>(PublicViewsDocument, options);
      }
export function usePublicViewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublicViewsQuery, PublicViewsQueryVariables>(PublicViewsDocument, options);
        }
// @ts-ignore
export function usePublicViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicViewsQuery, PublicViewsQueryVariables>;
export function usePublicViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicViewsQuery | undefined, PublicViewsQueryVariables>;
export function usePublicViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublicViewsQuery, PublicViewsQueryVariables>(PublicViewsDocument, options);
        }
export type PublicViewsQueryHookResult = ReturnType<typeof usePublicViewsQuery>;
export type PublicViewsLazyQueryHookResult = ReturnType<typeof usePublicViewsLazyQuery>;
export type PublicViewsSuspenseQueryHookResult = ReturnType<typeof usePublicViewsSuspenseQuery>;
export type PublicViewsQueryResult = ApolloReactCommon.QueryResult<PublicViewsQuery, PublicViewsQueryVariables>;
export const ViewDraftsDocument = gql`
    query viewDrafts($viewID: ID!) {
  view(id: $viewID) {
    id
    children {
      edges {
        node {
          id
          displayName
          user {
            id
          }
          entityName
          project {
            id
            name
            entityName
          }
        }
      }
    }
  }
}
    `;
export type ViewDraftsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewDraftsQuery, ViewDraftsQueryVariables>, 'query'> & ({ variables: ViewDraftsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewDraftsComponent = (props: ViewDraftsComponentProps) => (
      <ApolloReactComponents.Query<ViewDraftsQuery, ViewDraftsQueryVariables> query={ViewDraftsDocument} {...props} />
    );
    
export type ViewDraftsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewDraftsQuery, ViewDraftsQueryVariables>
    } & TChildProps;
export function withViewDrafts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewDraftsQuery,
  ViewDraftsQueryVariables,
  ViewDraftsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewDraftsQuery, ViewDraftsQueryVariables, ViewDraftsProps<TChildProps, TDataName>>(ViewDraftsDocument, {
      alias: 'viewDrafts',
      ...operationOptions
    });
};

/**
 * __useViewDraftsQuery__
 *
 * To run a query within a React component, call `useViewDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewDraftsQuery({
 *   variables: {
 *      viewID: // value for 'viewID'
 *   },
 * });
 */
export function useViewDraftsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables> & ({ variables: ViewDraftsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewDraftsQuery, ViewDraftsQueryVariables>(ViewDraftsDocument, options);
      }
export function useViewDraftsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewDraftsQuery, ViewDraftsQueryVariables>(ViewDraftsDocument, options);
        }
// @ts-ignore
export function useViewDraftsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewDraftsQuery, ViewDraftsQueryVariables>;
export function useViewDraftsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewDraftsQuery | undefined, ViewDraftsQueryVariables>;
export function useViewDraftsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewDraftsQuery, ViewDraftsQueryVariables>(ViewDraftsDocument, options);
        }
export type ViewDraftsQueryHookResult = ReturnType<typeof useViewDraftsQuery>;
export type ViewDraftsLazyQueryHookResult = ReturnType<typeof useViewDraftsLazyQuery>;
export type ViewDraftsSuspenseQueryHookResult = ReturnType<typeof useViewDraftsSuspenseQuery>;
export type ViewDraftsQueryResult = ApolloReactCommon.QueryResult<ViewDraftsQuery, ViewDraftsQueryVariables>;
export const ViewPermissionsDocument = gql`
    query viewPermissions($projectName: String!, $entityName: String!) {
  entity(name: $entityName) {
    id
    isTeam
    settings {
      disableMagicLinkSharing
      hidden
    }
  }
  project(name: $projectName, entityName: $entityName) {
    id
    access
  }
}
    `;
export type ViewPermissionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>, 'query'> & ({ variables: ViewPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewPermissionsComponent = (props: ViewPermissionsComponentProps) => (
      <ApolloReactComponents.Query<ViewPermissionsQuery, ViewPermissionsQueryVariables> query={ViewPermissionsDocument} {...props} />
    );
    
export type ViewPermissionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ViewPermissionsQuery, ViewPermissionsQueryVariables>
    } & TChildProps;
export function withViewPermissions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewPermissionsQuery,
  ViewPermissionsQueryVariables,
  ViewPermissionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ViewPermissionsQuery, ViewPermissionsQueryVariables, ViewPermissionsProps<TChildProps, TDataName>>(ViewPermissionsDocument, {
      alias: 'viewPermissions',
      ...operationOptions
    });
};

/**
 * __useViewPermissionsQuery__
 *
 * To run a query within a React component, call `useViewPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewPermissionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useViewPermissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables> & ({ variables: ViewPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewPermissionsQuery, ViewPermissionsQueryVariables>(ViewPermissionsDocument, options);
      }
export function useViewPermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewPermissionsQuery, ViewPermissionsQueryVariables>(ViewPermissionsDocument, options);
        }
// @ts-ignore
export function useViewPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewPermissionsQuery, ViewPermissionsQueryVariables>;
export function useViewPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewPermissionsQuery | undefined, ViewPermissionsQueryVariables>;
export function useViewPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewPermissionsQuery, ViewPermissionsQueryVariables>(ViewPermissionsDocument, options);
        }
export type ViewPermissionsQueryHookResult = ReturnType<typeof useViewPermissionsQuery>;
export type ViewPermissionsLazyQueryHookResult = ReturnType<typeof useViewPermissionsLazyQuery>;
export type ViewPermissionsSuspenseQueryHookResult = ReturnType<typeof useViewPermissionsSuspenseQuery>;
export type ViewPermissionsQueryResult = ApolloReactCommon.QueryResult<ViewPermissionsQuery, ViewPermissionsQueryVariables>;
export const ViewViewDocument = gql`
    mutation viewView($id: ID!) {
  viewView(input: {id: $id}) {
    success
  }
}
    `;
export type ViewViewMutationFn = ApolloReactCommon.MutationFunction<ViewViewMutation, ViewViewMutationVariables>;
export type ViewViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ViewViewMutation, ViewViewMutationVariables>, 'mutation'>;

    export const ViewViewComponent = (props: ViewViewComponentProps) => (
      <ApolloReactComponents.Mutation<ViewViewMutation, ViewViewMutationVariables> mutation={ViewViewDocument} {...props} />
    );
    
export type ViewViewProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ViewViewMutation, ViewViewMutationVariables>
    } & TChildProps;
export function withViewView<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ViewViewMutation,
  ViewViewMutationVariables,
  ViewViewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ViewViewMutation, ViewViewMutationVariables, ViewViewProps<TChildProps, TDataName>>(ViewViewDocument, {
      alias: 'viewView',
      ...operationOptions
    });
};

/**
 * __useViewViewMutation__
 *
 * To run a mutation, you first call `useViewViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewViewMutation, { data, loading, error }] = useViewViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ViewViewMutation, ViewViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ViewViewMutation, ViewViewMutationVariables>(ViewViewDocument, options);
      }
export type ViewViewMutationHookResult = ReturnType<typeof useViewViewMutation>;
export type ViewViewMutationResult = ApolloReactCommon.MutationResult<ViewViewMutation>;
export type ViewViewMutationOptions = ApolloReactCommon.BaseMutationOptions<ViewViewMutation, ViewViewMutationVariables>;
export const AccountPrivilegesDocument = gql`
    query AccountPrivileges($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    subscriptions {
      id
      privileges
      plan {
        id
        planType
      }
    }
  }
}
    `;
export type AccountPrivilegesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>, 'query'> & ({ variables: AccountPrivilegesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountPrivilegesComponent = (props: AccountPrivilegesComponentProps) => (
      <ApolloReactComponents.Query<AccountPrivilegesQuery, AccountPrivilegesQueryVariables> query={AccountPrivilegesDocument} {...props} />
    );
    
export type AccountPrivilegesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>
    } & TChildProps;
export function withAccountPrivileges<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountPrivilegesQuery,
  AccountPrivilegesQueryVariables,
  AccountPrivilegesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountPrivilegesQuery, AccountPrivilegesQueryVariables, AccountPrivilegesProps<TChildProps, TDataName>>(AccountPrivilegesDocument, {
      alias: 'accountPrivileges',
      ...operationOptions
    });
};

/**
 * __useAccountPrivilegesQuery__
 *
 * To run a query within a React component, call `useAccountPrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPrivilegesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAccountPrivilegesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables> & ({ variables: AccountPrivilegesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>(AccountPrivilegesDocument, options);
      }
export function useAccountPrivilegesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>(AccountPrivilegesDocument, options);
        }
// @ts-ignore
export function useAccountPrivilegesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>;
export function useAccountPrivilegesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountPrivilegesQuery | undefined, AccountPrivilegesQueryVariables>;
export function useAccountPrivilegesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>(AccountPrivilegesDocument, options);
        }
export type AccountPrivilegesQueryHookResult = ReturnType<typeof useAccountPrivilegesQuery>;
export type AccountPrivilegesLazyQueryHookResult = ReturnType<typeof useAccountPrivilegesLazyQuery>;
export type AccountPrivilegesSuspenseQueryHookResult = ReturnType<typeof useAccountPrivilegesSuspenseQuery>;
export type AccountPrivilegesQueryResult = ApolloReactCommon.QueryResult<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>;
export const AccountEnterpriseWeaveLimitsDocument = gql`
    query AccountEnterpriseWeaveLimits($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    weaveEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
      weaveLimit {
        weaveLimitBytes
        weaveOverageCostCents
        weaveOverageUnit
      }
    }
  }
}
    `;
export type AccountEnterpriseWeaveLimitsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>, 'query'> & ({ variables: AccountEnterpriseWeaveLimitsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountEnterpriseWeaveLimitsComponent = (props: AccountEnterpriseWeaveLimitsComponentProps) => (
      <ApolloReactComponents.Query<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables> query={AccountEnterpriseWeaveLimitsDocument} {...props} />
    );
    
export type AccountEnterpriseWeaveLimitsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>
    } & TChildProps;
export function withAccountEnterpriseWeaveLimits<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountEnterpriseWeaveLimitsQuery,
  AccountEnterpriseWeaveLimitsQueryVariables,
  AccountEnterpriseWeaveLimitsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables, AccountEnterpriseWeaveLimitsProps<TChildProps, TDataName>>(AccountEnterpriseWeaveLimitsDocument, {
      alias: 'accountEnterpriseWeaveLimits',
      ...operationOptions
    });
};

/**
 * __useAccountEnterpriseWeaveLimitsQuery__
 *
 * To run a query within a React component, call `useAccountEnterpriseWeaveLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountEnterpriseWeaveLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountEnterpriseWeaveLimitsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAccountEnterpriseWeaveLimitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables> & ({ variables: AccountEnterpriseWeaveLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>(AccountEnterpriseWeaveLimitsDocument, options);
      }
export function useAccountEnterpriseWeaveLimitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>(AccountEnterpriseWeaveLimitsDocument, options);
        }
// @ts-ignore
export function useAccountEnterpriseWeaveLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>;
export function useAccountEnterpriseWeaveLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountEnterpriseWeaveLimitsQuery | undefined, AccountEnterpriseWeaveLimitsQueryVariables>;
export function useAccountEnterpriseWeaveLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>(AccountEnterpriseWeaveLimitsDocument, options);
        }
export type AccountEnterpriseWeaveLimitsQueryHookResult = ReturnType<typeof useAccountEnterpriseWeaveLimitsQuery>;
export type AccountEnterpriseWeaveLimitsLazyQueryHookResult = ReturnType<typeof useAccountEnterpriseWeaveLimitsLazyQuery>;
export type AccountEnterpriseWeaveLimitsSuspenseQueryHookResult = ReturnType<typeof useAccountEnterpriseWeaveLimitsSuspenseQuery>;
export type AccountEnterpriseWeaveLimitsQueryResult = ApolloReactCommon.QueryResult<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>;
export const AccountSubscriptionPlansDocument = gql`
    query AccountSubscriptionPlans($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    subscriptions {
      id
      plan {
        id
        planType
        name
      }
    }
  }
}
    `;
export type AccountSubscriptionPlansComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>, 'query'> & ({ variables: AccountSubscriptionPlansQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AccountSubscriptionPlansComponent = (props: AccountSubscriptionPlansComponentProps) => (
      <ApolloReactComponents.Query<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables> query={AccountSubscriptionPlansDocument} {...props} />
    );
    
export type AccountSubscriptionPlansProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>
    } & TChildProps;
export function withAccountSubscriptionPlans<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AccountSubscriptionPlansQuery,
  AccountSubscriptionPlansQueryVariables,
  AccountSubscriptionPlansProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables, AccountSubscriptionPlansProps<TChildProps, TDataName>>(AccountSubscriptionPlansDocument, {
      alias: 'accountSubscriptionPlans',
      ...operationOptions
    });
};

/**
 * __useAccountSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useAccountSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscriptionPlansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAccountSubscriptionPlansQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables> & ({ variables: AccountSubscriptionPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>(AccountSubscriptionPlansDocument, options);
      }
export function useAccountSubscriptionPlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>(AccountSubscriptionPlansDocument, options);
        }
// @ts-ignore
export function useAccountSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>;
export function useAccountSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSubscriptionPlansQuery | undefined, AccountSubscriptionPlansQueryVariables>;
export function useAccountSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>(AccountSubscriptionPlansDocument, options);
        }
export type AccountSubscriptionPlansQueryHookResult = ReturnType<typeof useAccountSubscriptionPlansQuery>;
export type AccountSubscriptionPlansLazyQueryHookResult = ReturnType<typeof useAccountSubscriptionPlansLazyQuery>;
export type AccountSubscriptionPlansSuspenseQueryHookResult = ReturnType<typeof useAccountSubscriptionPlansSuspenseQuery>;
export type AccountSubscriptionPlansQueryResult = ApolloReactCommon.QueryResult<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>;
export const UserDynamicConfigDocument = gql`
    query userDynamicConfig($configId: String!) {
  viewer {
    id
    dynamicConfig(configId: $configId) {
      value
    }
  }
}
    `;
export type UserDynamicConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>, 'query'> & ({ variables: UserDynamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserDynamicConfigComponent = (props: UserDynamicConfigComponentProps) => (
      <ApolloReactComponents.Query<UserDynamicConfigQuery, UserDynamicConfigQueryVariables> query={UserDynamicConfigDocument} {...props} />
    );
    
export type UserDynamicConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>
    } & TChildProps;
export function withUserDynamicConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserDynamicConfigQuery,
  UserDynamicConfigQueryVariables,
  UserDynamicConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserDynamicConfigQuery, UserDynamicConfigQueryVariables, UserDynamicConfigProps<TChildProps, TDataName>>(UserDynamicConfigDocument, {
      alias: 'userDynamicConfig',
      ...operationOptions
    });
};

/**
 * __useUserDynamicConfigQuery__
 *
 * To run a query within a React component, call `useUserDynamicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDynamicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDynamicConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useUserDynamicConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables> & ({ variables: UserDynamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>(UserDynamicConfigDocument, options);
      }
export function useUserDynamicConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>(UserDynamicConfigDocument, options);
        }
// @ts-ignore
export function useUserDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>;
export function useUserDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserDynamicConfigQuery | undefined, UserDynamicConfigQueryVariables>;
export function useUserDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>(UserDynamicConfigDocument, options);
        }
export type UserDynamicConfigQueryHookResult = ReturnType<typeof useUserDynamicConfigQuery>;
export type UserDynamicConfigLazyQueryHookResult = ReturnType<typeof useUserDynamicConfigLazyQuery>;
export type UserDynamicConfigSuspenseQueryHookResult = ReturnType<typeof useUserDynamicConfigSuspenseQuery>;
export type UserDynamicConfigQueryResult = ApolloReactCommon.QueryResult<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>;
export const EntityDynamicConfigDocument = gql`
    query entityDynamicConfig($configId: String!, $entityName: String!) {
  entity(name: $entityName) {
    id
    dynamicConfig(configId: $configId) {
      value
    }
  }
}
    `;
export type EntityDynamicConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>, 'query'> & ({ variables: EntityDynamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EntityDynamicConfigComponent = (props: EntityDynamicConfigComponentProps) => (
      <ApolloReactComponents.Query<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables> query={EntityDynamicConfigDocument} {...props} />
    );
    
export type EntityDynamicConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>
    } & TChildProps;
export function withEntityDynamicConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EntityDynamicConfigQuery,
  EntityDynamicConfigQueryVariables,
  EntityDynamicConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables, EntityDynamicConfigProps<TChildProps, TDataName>>(EntityDynamicConfigDocument, {
      alias: 'entityDynamicConfig',
      ...operationOptions
    });
};

/**
 * __useEntityDynamicConfigQuery__
 *
 * To run a query within a React component, call `useEntityDynamicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDynamicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDynamicConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityDynamicConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables> & ({ variables: EntityDynamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>(EntityDynamicConfigDocument, options);
      }
export function useEntityDynamicConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>(EntityDynamicConfigDocument, options);
        }
// @ts-ignore
export function useEntityDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>;
export function useEntityDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDynamicConfigQuery | undefined, EntityDynamicConfigQueryVariables>;
export function useEntityDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>(EntityDynamicConfigDocument, options);
        }
export type EntityDynamicConfigQueryHookResult = ReturnType<typeof useEntityDynamicConfigQuery>;
export type EntityDynamicConfigLazyQueryHookResult = ReturnType<typeof useEntityDynamicConfigLazyQuery>;
export type EntityDynamicConfigSuspenseQueryHookResult = ReturnType<typeof useEntityDynamicConfigSuspenseQuery>;
export type EntityDynamicConfigQueryResult = ApolloReactCommon.QueryResult<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>;
export const OrganizationDyamicConfigDocument = gql`
    query organizationDyamicConfig($configId: String!, $orgName: String!) {
  organization(name: $orgName) {
    id
    orgType
    dynamicConfig(configId: $configId) {
      value
    }
  }
}
    `;
export type OrganizationDyamicConfigComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>, 'query'> & ({ variables: OrganizationDyamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationDyamicConfigComponent = (props: OrganizationDyamicConfigComponentProps) => (
      <ApolloReactComponents.Query<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables> query={OrganizationDyamicConfigDocument} {...props} />
    );
    
export type OrganizationDyamicConfigProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>
    } & TChildProps;
export function withOrganizationDyamicConfig<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationDyamicConfigQuery,
  OrganizationDyamicConfigQueryVariables,
  OrganizationDyamicConfigProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables, OrganizationDyamicConfigProps<TChildProps, TDataName>>(OrganizationDyamicConfigDocument, {
      alias: 'organizationDyamicConfig',
      ...operationOptions
    });
};

/**
 * __useOrganizationDyamicConfigQuery__
 *
 * To run a query within a React component, call `useOrganizationDyamicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDyamicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDyamicConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationDyamicConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables> & ({ variables: OrganizationDyamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>(OrganizationDyamicConfigDocument, options);
      }
export function useOrganizationDyamicConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>(OrganizationDyamicConfigDocument, options);
        }
// @ts-ignore
export function useOrganizationDyamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>;
export function useOrganizationDyamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDyamicConfigQuery | undefined, OrganizationDyamicConfigQueryVariables>;
export function useOrganizationDyamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>(OrganizationDyamicConfigDocument, options);
        }
export type OrganizationDyamicConfigQueryHookResult = ReturnType<typeof useOrganizationDyamicConfigQuery>;
export type OrganizationDyamicConfigLazyQueryHookResult = ReturnType<typeof useOrganizationDyamicConfigLazyQuery>;
export type OrganizationDyamicConfigSuspenseQueryHookResult = ReturnType<typeof useOrganizationDyamicConfigSuspenseQuery>;
export type OrganizationDyamicConfigQueryResult = ApolloReactCommon.QueryResult<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>;
export const TeamOrgDocument = gql`
    query TeamOrg($entityName: String!) {
  entity(name: $entityName) {
    id
    name
    organization {
      id
      name
    }
  }
}
    `;
export type TeamOrgComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TeamOrgQuery, TeamOrgQueryVariables>, 'query'> & ({ variables: TeamOrgQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamOrgComponent = (props: TeamOrgComponentProps) => (
      <ApolloReactComponents.Query<TeamOrgQuery, TeamOrgQueryVariables> query={TeamOrgDocument} {...props} />
    );
    
export type TeamOrgProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TeamOrgQuery, TeamOrgQueryVariables>
    } & TChildProps;
export function withTeamOrg<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TeamOrgQuery,
  TeamOrgQueryVariables,
  TeamOrgProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TeamOrgQuery, TeamOrgQueryVariables, TeamOrgProps<TChildProps, TDataName>>(TeamOrgDocument, {
      alias: 'teamOrg',
      ...operationOptions
    });
};

/**
 * __useTeamOrgQuery__
 *
 * To run a query within a React component, call `useTeamOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrgQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamOrgQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables> & ({ variables: TeamOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamOrgQuery, TeamOrgQueryVariables>(TeamOrgDocument, options);
      }
export function useTeamOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamOrgQuery, TeamOrgQueryVariables>(TeamOrgDocument, options);
        }
// @ts-ignore
export function useTeamOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrgQuery, TeamOrgQueryVariables>;
export function useTeamOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrgQuery | undefined, TeamOrgQueryVariables>;
export function useTeamOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamOrgQuery, TeamOrgQueryVariables>(TeamOrgDocument, options);
        }
export type TeamOrgQueryHookResult = ReturnType<typeof useTeamOrgQuery>;
export type TeamOrgLazyQueryHookResult = ReturnType<typeof useTeamOrgLazyQuery>;
export type TeamOrgSuspenseQueryHookResult = ReturnType<typeof useTeamOrgSuspenseQuery>;
export type TeamOrgQueryResult = ApolloReactCommon.QueryResult<TeamOrgQuery, TeamOrgQueryVariables>;
export const BillingPeriodSubscriptionsDocument = gql`
    query BillingPeriodSubscriptions($orgName: String!) {
  organization(name: $orgName) {
    id
    createdAt
    subscriptions {
      id
      billingPeriodStart
      billingPeriodEnd
      subscriptionType
      plan {
        id
        name
        planType
      }
    }
    inferenceEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
      inferenceLimit
    }
  }
}
    `;
export type BillingPeriodSubscriptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>, 'query'> & ({ variables: BillingPeriodSubscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BillingPeriodSubscriptionsComponent = (props: BillingPeriodSubscriptionsComponentProps) => (
      <ApolloReactComponents.Query<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables> query={BillingPeriodSubscriptionsDocument} {...props} />
    );
    
export type BillingPeriodSubscriptionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>
    } & TChildProps;
export function withBillingPeriodSubscriptions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BillingPeriodSubscriptionsQuery,
  BillingPeriodSubscriptionsQueryVariables,
  BillingPeriodSubscriptionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables, BillingPeriodSubscriptionsProps<TChildProps, TDataName>>(BillingPeriodSubscriptionsDocument, {
      alias: 'billingPeriodSubscriptions',
      ...operationOptions
    });
};

/**
 * __useBillingPeriodSubscriptionsQuery__
 *
 * To run a query within a React component, call `useBillingPeriodSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPeriodSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPeriodSubscriptionsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useBillingPeriodSubscriptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables> & ({ variables: BillingPeriodSubscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>(BillingPeriodSubscriptionsDocument, options);
      }
export function useBillingPeriodSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>(BillingPeriodSubscriptionsDocument, options);
        }
// @ts-ignore
export function useBillingPeriodSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>;
export function useBillingPeriodSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillingPeriodSubscriptionsQuery | undefined, BillingPeriodSubscriptionsQueryVariables>;
export function useBillingPeriodSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>(BillingPeriodSubscriptionsDocument, options);
        }
export type BillingPeriodSubscriptionsQueryHookResult = ReturnType<typeof useBillingPeriodSubscriptionsQuery>;
export type BillingPeriodSubscriptionsLazyQueryHookResult = ReturnType<typeof useBillingPeriodSubscriptionsLazyQuery>;
export type BillingPeriodSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useBillingPeriodSubscriptionsSuspenseQuery>;
export type BillingPeriodSubscriptionsQueryResult = ApolloReactCommon.QueryResult<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>;
export const OrganizationSubscriptionUpdateAdditionalInfoDocument = gql`
    query OrganizationSubscriptionUpdateAdditionalInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    weaveEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
    }
    inferenceEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
      inferenceLimit
    }
  }
}
    `;
export type OrganizationSubscriptionUpdateAdditionalInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>, 'query'> & ({ variables: OrganizationSubscriptionUpdateAdditionalInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationSubscriptionUpdateAdditionalInfoComponent = (props: OrganizationSubscriptionUpdateAdditionalInfoComponentProps) => (
      <ApolloReactComponents.Query<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables> query={OrganizationSubscriptionUpdateAdditionalInfoDocument} {...props} />
    );
    
export type OrganizationSubscriptionUpdateAdditionalInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>
    } & TChildProps;
export function withOrganizationSubscriptionUpdateAdditionalInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OrganizationSubscriptionUpdateAdditionalInfoQuery,
  OrganizationSubscriptionUpdateAdditionalInfoQueryVariables,
  OrganizationSubscriptionUpdateAdditionalInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables, OrganizationSubscriptionUpdateAdditionalInfoProps<TChildProps, TDataName>>(OrganizationSubscriptionUpdateAdditionalInfoDocument, {
      alias: 'organizationSubscriptionUpdateAdditionalInfo',
      ...operationOptions
    });
};

/**
 * __useOrganizationSubscriptionUpdateAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionUpdateAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionUpdateAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionUpdateAdditionalInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationSubscriptionUpdateAdditionalInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables> & ({ variables: OrganizationSubscriptionUpdateAdditionalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>(OrganizationSubscriptionUpdateAdditionalInfoDocument, options);
      }
export function useOrganizationSubscriptionUpdateAdditionalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>(OrganizationSubscriptionUpdateAdditionalInfoDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionUpdateAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>;
export function useOrganizationSubscriptionUpdateAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionUpdateAdditionalInfoQuery | undefined, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>;
export function useOrganizationSubscriptionUpdateAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>(OrganizationSubscriptionUpdateAdditionalInfoDocument, options);
        }
export type OrganizationSubscriptionUpdateAdditionalInfoQueryHookResult = ReturnType<typeof useOrganizationSubscriptionUpdateAdditionalInfoQuery>;
export type OrganizationSubscriptionUpdateAdditionalInfoLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionUpdateAdditionalInfoLazyQuery>;
export type OrganizationSubscriptionUpdateAdditionalInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionUpdateAdditionalInfoSuspenseQuery>;
export type OrganizationSubscriptionUpdateAdditionalInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>;